var Wv = function(r, e) {
  return Wv = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, n) {
    t.__proto__ = n;
  } || function(t, n) {
    for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
  }, Wv(r, e);
};
function pa(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  Wv(r, e);
  function t() {
    this.constructor = r;
  }
  r.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
}
var me = function() {
  return me = Object.assign || function(e) {
    for (var t, n = 1, i = arguments.length; n < i; n++) {
      t = arguments[n];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, me.apply(this, arguments);
};
function ns(r, e) {
  var t = {};
  for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}
function Ka(r, e, t, n) {
  function i(a) {
    return a instanceof t ? a : new t(function(s) {
      s(a);
    });
  }
  return new (t || (t = Promise))(function(a, s) {
    function o(c) {
      try {
        u(n.next(c));
      } catch (d) {
        s(d);
      }
    }
    function l(c) {
      try {
        u(n.throw(c));
      } catch (d) {
        s(d);
      }
    }
    function u(c) {
      c.done ? a(c.value) : i(c.value).then(o, l);
    }
    u((n = n.apply(r, e || [])).next());
  });
}
function Za(r, e) {
  var t = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, i, a, s = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return s.next = o(0), s.throw = o(1), s.return = o(2), typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function o(u) {
    return function(c) {
      return l([u, c]);
    };
  }
  function l(u) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; s && (s = 0, u[0] && (t = 0)), t; ) try {
      if (n = 1, i && (a = u[0] & 2 ? i.return : u[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, u[1])).done) return a;
      switch (i = 0, a && (u = [u[0] & 2, a.value]), u[0]) {
        case 0:
        case 1:
          a = u;
          break;
        case 4:
          return t.label++, { value: u[1], done: !1 };
        case 5:
          t.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (a = t.trys, !(a = a.length > 0 && a[a.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            t = 0;
            continue;
          }
          if (u[0] === 3 && (!a || u[1] > a[0] && u[1] < a[3])) {
            t.label = u[1];
            break;
          }
          if (u[0] === 6 && t.label < a[1]) {
            t.label = a[1], a = u;
            break;
          }
          if (a && t.label < a[2]) {
            t.label = a[2], t.ops.push(u);
            break;
          }
          a[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      u = e.call(r, t);
    } catch (c) {
      u = [6, c], i = 0;
    } finally {
      n = a = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function KW(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t) return t.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function ta(r, e, t) {
  if (t || arguments.length === 2) for (var n = 0, i = e.length, a; n < i; n++)
    (a || !(n in e)) && (a || (a = Array.prototype.slice.call(e, 0, n)), a[n] = e[n]);
  return r.concat(a || Array.prototype.slice.call(e));
}
var Mm = "Invariant Violation", _b = Object.setPrototypeOf, QI = _b === void 0 ? function(r, e) {
  return r.__proto__ = e, r;
} : _b, o2 = (
  /** @class */
  (function(r) {
    pa(e, r);
    function e(t) {
      t === void 0 && (t = Mm);
      var n = r.call(this, typeof t == "number" ? Mm + ": " + t + " (see https://github.com/apollographql/invariant-packages)" : t) || this;
      return n.framesToPop = 1, n.name = Mm, QI(n, e.prototype), n;
    }
    return e;
  })(Error)
);
function cl(r, e) {
  if (!r)
    throw new o2(e);
}
var l2 = ["debug", "log", "warn", "error", "silent"], YI = l2.indexOf("log");
function Ch(r) {
  return function() {
    if (l2.indexOf(r) >= YI) {
      var e = console[r] || console.log;
      return e.apply(console, arguments);
    }
  };
}
(function(r) {
  r.debug = Ch("debug"), r.log = Ch("log"), r.warn = Ch("warn"), r.error = Ch("error");
})(cl || (cl = {}));
var oA = "3.14.1";
function Ta(r) {
  try {
    return r();
  } catch {
  }
}
const qp = Ta(function() {
  return globalThis;
}) || Ta(function() {
  return window;
}) || Ta(function() {
  return self;
}) || Ta(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
Ta(function() {
  return Ta.constructor("return this")();
});
var Nb = /* @__PURE__ */ new Map();
function Qv(r) {
  var e = Nb.get(r) || 1;
  return Nb.set(r, e + 1), "".concat(r, ":").concat(e, ":").concat(Math.random().toString(36).slice(2));
}
function XI(r, e) {
  var t = Qv("stringifyForDisplay");
  return JSON.stringify(r, function(n, i) {
    return i === void 0 ? t : i;
  }, e).split(JSON.stringify(t)).join("<undefined>");
}
function Sh(r) {
  return function(e) {
    for (var t = [], n = 1; n < arguments.length; n++)
      t[n - 1] = arguments[n];
    if (typeof e == "number") {
      var i = e;
      e = lA(i), e || (e = uA(i, t), t = []);
    }
    r.apply(void 0, [e].concat(t));
  };
}
var Mr = Object.assign(function(e, t) {
  for (var n = [], i = 2; i < arguments.length; i++)
    n[i - 2] = arguments[i];
  e || cl(e, lA(t, n) || uA(t, n));
}, {
  debug: Sh(cl.debug),
  log: Sh(cl.log),
  warn: Sh(cl.warn),
  error: Sh(cl.error)
});
function Hi(r) {
  for (var e = [], t = 1; t < arguments.length; t++)
    e[t - 1] = arguments[t];
  return new o2(lA(r, e) || uA(r, e));
}
var Lb = /* @__PURE__ */ Symbol.for("ApolloErrorMessageHandler_" + oA);
function u2(r) {
  if (typeof r == "string")
    return r;
  try {
    return XI(r, 2).slice(0, 1e3);
  } catch {
    return "<non-serializable>";
  }
}
function lA(r, e) {
  if (e === void 0 && (e = []), !!r)
    return qp[Lb] && qp[Lb](r, e.map(u2));
}
function uA(r, e) {
  if (e === void 0 && (e = []), !!r)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: oA,
      message: r,
      args: e.map(u2)
    })));
}
function xp(r, e) {
  if (!!!r)
    throw new Error(e);
}
function JI(r) {
  return typeof r == "object" && r !== null;
}
function KI(r, e) {
  if (!!!r)
    throw new Error(
      "Unexpected invariant triggered."
    );
}
const ZI = /\r\n|[\n\r]/g;
function Yv(r, e) {
  let t = 0, n = 1;
  for (const i of r.body.matchAll(ZI)) {
    if (typeof i.index == "number" || KI(!1), i.index >= e)
      break;
    t = i.index + i[0].length, n += 1;
  }
  return {
    line: n,
    column: e + 1 - t
  };
}
function eD(r) {
  return c2(
    r.source,
    Yv(r.source, r.start)
  );
}
function c2(r, e) {
  const t = r.locationOffset.column - 1, n = "".padStart(t) + r.body, i = e.line - 1, a = r.locationOffset.line - 1, s = e.line + a, o = e.line === 1 ? t : 0, l = e.column + o, u = `${r.name}:${s}:${l}
`, c = n.split(/\r\n|[\n\r]/g), d = c[i];
  if (d.length > 120) {
    const f = Math.floor(l / 80), h = l % 80, g = [];
    for (let v = 0; v < d.length; v += 80)
      g.push(d.slice(v, v + 80));
    return u + Ub([
      [`${s} |`, g[0]],
      ...g.slice(1, f + 1).map((v) => ["|", v]),
      ["|", "^".padStart(h)],
      ["|", g[f + 1]]
    ]);
  }
  return u + Ub([
    // Lines specified like this: ["prefix", "string"],
    [`${s - 1} |`, c[i - 1]],
    [`${s} |`, d],
    ["|", "^".padStart(l)],
    [`${s + 1} |`, c[i + 1]]
  ]);
}
function Ub(r) {
  const e = r.filter(([n, i]) => i !== void 0), t = Math.max(...e.map(([n]) => n.length));
  return e.map(([n, i]) => n.padStart(t) + (i ? " " + i : "")).join(`
`);
}
function tD(r) {
  const e = r[0];
  return e == null || "kind" in e || "length" in e ? {
    nodes: e,
    source: r[1],
    positions: r[2],
    path: r[3],
    originalError: r[4],
    extensions: r[5]
  } : e;
}
class cA extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /** An array of GraphQL AST Nodes corresponding to this error. */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /** Original error that caused this GraphQLError, if one exists. */
  /** Extension fields to add to the formatted error. */
  /**
   * Creates a GraphQLError instance.
   * @param message - Human-readable error message.
   * @param options - Error metadata such as source locations, response path, original error, and extensions.
   * This positional-arguments constructor overload is deprecated. Use the
   * `GraphQLError(message, options)` overload instead.
   * @example
   * ```ts
   * // Create an error from AST nodes and response metadata.
   * import { parse } from 'graphql/language';
   * import { GraphQLError } from 'graphql/error';
   *
   * const document = parse('{ greeting }');
   * const fieldNode = document.definitions[0].selectionSet.selections[0];
   * const error = new GraphQLError('Cannot query this field.', {
   *   nodes: fieldNode,
   *   path: ['greeting'],
   *   extensions: { code: 'FORBIDDEN' },
   * });
   *
   * error.message; // => 'Cannot query this field.'
   * error.locations; // => [{ line: 1, column: 3 }]
   * error.path; // => ['greeting']
   * error.extensions; // => { code: 'FORBIDDEN' }
   * ```
   * @example
   * ```ts
   * // This variant derives locations from source positions and preserves the original error.
   * import { Source } from 'graphql/language';
   * import { GraphQLError } from 'graphql/error';
   *
   * const source = new Source('{ greeting }');
   * const originalError = new Error('Database unavailable.');
   * const error = new GraphQLError('Resolver failed.', {
   *   source,
   *   positions: [2],
   *   path: ['greeting'],
   *   originalError,
   * });
   *
   * error.locations; // => [{ line: 1, column: 3 }]
   * error.path; // => ['greeting']
   * error.originalError; // => originalError
   * ```
   */
  /**
   * Creates a GraphQLError instance using the legacy positional constructor.
   * This deprecated overload will be removed in v17. Prefer the
   * `GraphQLErrorOptions` object overload, which keeps optional error metadata
   * in a single options bag.
   * @param message - Human-readable error message.
   * @param nodes - AST node or nodes associated with this error.
   * @param source - Source document used to derive error locations.
   * @param positions - Character offsets in the source document associated with
   * this error.
   * @param path - Response path where this error occurred during execution.
   * @param originalError - Original error that caused this GraphQLError, if one
   * exists.
   * @param extensions - Extension fields to include in the formatted error.
   * @example
   * ```ts
   * import { Source } from 'graphql/language';
   * import { GraphQLError } from 'graphql/error';
   *
   * const source = new Source('{ greeting }');
   * const originalError = new Error('Database unavailable.');
   * const error = new GraphQLError(
   *   'Resolver failed.',
   *   undefined,
   *   source,
   *   [2],
   *   ['greeting'],
   *   originalError,
   *   { code: 'INTERNAL' },
   * );
   *
   * error.locations; // => [{ line: 1, column: 3 }]
   * error.path; // => ['greeting']
   * error.originalError; // => originalError
   * error.extensions; // => { code: 'INTERNAL' }
   * ```
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(e, ...t) {
    var n, i, a;
    const { nodes: s, source: o, positions: l, path: u, originalError: c, extensions: d } = tD(t);
    super(e), this.name = "GraphQLError", this.path = u ?? void 0, this.originalError = c ?? void 0, this.nodes = Vb(
      Array.isArray(s) ? s : s ? [s] : void 0
    );
    const f = Vb(
      (n = this.nodes) === null || n === void 0 ? void 0 : n.map((g) => g.loc).filter((g) => g != null)
    );
    this.source = o ?? (f == null || (i = f[0]) === null || i === void 0 ? void 0 : i.source), this.positions = l ?? f?.map((g) => g.start), this.locations = l && o ? l.map((g) => Yv(o, g)) : f?.map((g) => Yv(g.source, g.start));
    const h = JI(
      c?.extensions
    ) ? c?.extensions : void 0;
    this.extensions = (a = d ?? h) !== null && a !== void 0 ? a : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), c != null && c.stack ? Object.defineProperty(this, "stack", {
      value: c.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, cA) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  /**
   * Returns the value used by `Object.prototype.toString`.
   * @returns The built-in string tag for this object.
   */
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  /**
   * Returns this error as a human-readable message with source locations.
   * @returns The formatted error string.
   * @example
   * ```ts
   * import { Source } from 'graphql/language';
   * import { GraphQLError } from 'graphql/error';
   *
   * const error = new GraphQLError('Cannot query field "name".', {
   *   source: new Source('{ name }'),
   *   positions: [2],
   * });
   *
   * error.toString(); // => 'Cannot query field "name".\n\nGraphQL request:1:3\n1 | { name }\n  |   ^'
   * ```
   */
  toString() {
    let e = this.message;
    if (this.nodes)
      for (const t of this.nodes)
        t.loc && (e += `

` + eD(t.loc));
    else if (this.source && this.locations)
      for (const t of this.locations)
        e += `

` + c2(this.source, t);
    return e;
  }
  /**
   * Returns the JSON representation used when this object is serialized.
   * @returns The JSON-serializable representation.
   * @example
   * ```ts
   * import { GraphQLError } from 'graphql/error';
   *
   * const error = new GraphQLError('Resolver failed.', {
   *   path: ['viewer', 'name'],
   *   extensions: { code: 'INTERNAL' },
   * });
   *
   * error.toJSON(); // => { message: 'Resolver failed.', path: ['viewer', 'name'], extensions: { code: 'INTERNAL' } }
   * ```
   */
  toJSON() {
    const e = {
      message: this.message
    };
    return this.locations != null && (e.locations = this.locations), this.path != null && (e.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (e.extensions = this.extensions), e;
  }
}
function Vb(r) {
  return r === void 0 || r.length === 0 ? void 0 : r;
}
function oi(r, e, t) {
  return new cA(`Syntax Error: ${t}`, {
    source: r,
    positions: [e]
  });
}
class rD {
  /** The character offset at which this Node begins. */
  /** The character offset at which this Node ends. */
  /** The Token at which this Node begins. */
  /** The Token at which this Node ends. */
  /** The Source document the AST represents. */
  /**
   * Creates a Location instance.
   * @param startToken - The start token.
   * @param endToken - The end token.
   * @param source - Source document used to derive error locations.
   * @example
   * ```ts
   * import { Location, Source, Token, TokenKind } from 'graphql/language';
   *
   * const source = new Source('{ hello }');
   * const startToken = new Token(TokenKind.BRACE_L, 0, 1, 1, 1);
   * const endToken = new Token(TokenKind.BRACE_R, 8, 9, 1, 9);
   * const location = new Location(startToken, endToken, source);
   *
   * location.start; // => 0
   * location.end; // => 9
   * location.source.body; // => '{ hello }'
   * ```
   */
  constructor(e, t, n) {
    this.start = e.start, this.end = t.end, this.startToken = e, this.endToken = t, this.source = n;
  }
  /**
   * Returns the value used by `Object.prototype.toString`.
   * @returns The built-in string tag for this object.
   */
  get [Symbol.toStringTag]() {
    return "Location";
  }
  /**
   * Returns a JSON representation of this location.
   * @returns The JSON-serializable representation.
   * @example
   * ```ts
   * import { parse } from 'graphql/language';
   *
   * const document = parse('{ hello }');
   * const location = document.loc?.toJSON();
   *
   * location; // => { start: 0, end: 9 }
   * ```
   */
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
let f2 = class {
  /** The kind of Token. */
  /** The character offset at which this Node begins. */
  /** The character offset at which this Node ends. */
  /** The 1-indexed line number on which this Token appears. */
  /** The 1-indexed column number at which this Token begins. */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  /** Next token in the token stream, including ignored tokens. */
  /**
   * Creates a Token instance.
   * @param kind - Token kind produced by lexical analysis.
   * @param start - Character offset where this token begins.
   * @param end - Character offset where this token ends.
   * @param line - One-indexed line number where this token begins.
   * @param column - One-indexed column number where this token begins.
   * @param value - Interpreted value for non-punctuation tokens.
   * @example
   * ```ts
   * import { Token, TokenKind } from 'graphql/language';
   *
   * const token = new Token(TokenKind.NAME, 2, 7, 1, 3, 'hello');
   *
   * token.kind; // => TokenKind.NAME
   * token.value; // => 'hello'
   * token.toJSON(); // => { kind: 'Name', value: 'hello', line: 1, column: 3 }
   * ```
   */
  constructor(e, t, n, i, a, s) {
    this.kind = e, this.start = t, this.end = n, this.line = i, this.column = a, this.value = s, this.prev = null, this.next = null;
  }
  /**
   * Returns the value used by `Object.prototype.toString`.
   * @returns The built-in string tag for this object.
   */
  get [Symbol.toStringTag]() {
    return "Token";
  }
  /**
   * Returns a JSON representation of this token.
   * @returns The JSON-serializable representation.
   * @example
   * ```ts
   * import { Lexer, Source } from 'graphql/language';
   *
   * const lexer = new Lexer(new Source('{ hello }'));
   * const token = lexer.advance().toJSON();
   *
   * token; // => { kind: '{', value: undefined, line: 1, column: 1 }
   * ```
   */
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
};
const d2 = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "description",
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: [
    "description",
    "variable",
    "type",
    "defaultValue",
    "directives"
  ],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "description",
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: [
    "description",
    "name",
    "arguments",
    "directives",
    "locations"
  ],
  SchemaExtension: ["directives", "operationTypes"],
  DirectiveExtension: ["name", "directives"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"],
  TypeCoordinate: ["name"],
  MemberCoordinate: ["name", "memberName"],
  ArgumentCoordinate: ["name", "fieldName", "argumentName"],
  DirectiveCoordinate: ["name"],
  DirectiveArgumentCoordinate: ["name", "argumentName"]
}, nD = new Set(Object.keys(d2));
function zb(r) {
  const e = r?.kind;
  return typeof e == "string" && nD.has(e);
}
var Su;
(function(r) {
  r.QUERY = "query", r.MUTATION = "mutation", r.SUBSCRIPTION = "subscription";
})(Su || (Su = {}));
var Xv;
(function(r) {
  r.QUERY = "QUERY", r.MUTATION = "MUTATION", r.SUBSCRIPTION = "SUBSCRIPTION", r.FIELD = "FIELD", r.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", r.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", r.INLINE_FRAGMENT = "INLINE_FRAGMENT", r.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", r.SCHEMA = "SCHEMA", r.SCALAR = "SCALAR", r.OBJECT = "OBJECT", r.FIELD_DEFINITION = "FIELD_DEFINITION", r.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", r.INTERFACE = "INTERFACE", r.UNION = "UNION", r.ENUM = "ENUM", r.ENUM_VALUE = "ENUM_VALUE", r.INPUT_OBJECT = "INPUT_OBJECT", r.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION", r.DIRECTIVE_DEFINITION = "DIRECTIVE_DEFINITION";
})(Xv || (Xv = {}));
var et;
(function(r) {
  r.NAME = "Name", r.DOCUMENT = "Document", r.OPERATION_DEFINITION = "OperationDefinition", r.VARIABLE_DEFINITION = "VariableDefinition", r.SELECTION_SET = "SelectionSet", r.FIELD = "Field", r.ARGUMENT = "Argument", r.FRAGMENT_SPREAD = "FragmentSpread", r.INLINE_FRAGMENT = "InlineFragment", r.FRAGMENT_DEFINITION = "FragmentDefinition", r.VARIABLE = "Variable", r.INT = "IntValue", r.FLOAT = "FloatValue", r.STRING = "StringValue", r.BOOLEAN = "BooleanValue", r.NULL = "NullValue", r.ENUM = "EnumValue", r.LIST = "ListValue", r.OBJECT = "ObjectValue", r.OBJECT_FIELD = "ObjectField", r.DIRECTIVE = "Directive", r.NAMED_TYPE = "NamedType", r.LIST_TYPE = "ListType", r.NON_NULL_TYPE = "NonNullType", r.SCHEMA_DEFINITION = "SchemaDefinition", r.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", r.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", r.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", r.FIELD_DEFINITION = "FieldDefinition", r.INPUT_VALUE_DEFINITION = "InputValueDefinition", r.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", r.UNION_TYPE_DEFINITION = "UnionTypeDefinition", r.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", r.ENUM_VALUE_DEFINITION = "EnumValueDefinition", r.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", r.DIRECTIVE_DEFINITION = "DirectiveDefinition", r.SCHEMA_EXTENSION = "SchemaExtension", r.DIRECTIVE_EXTENSION = "DirectiveExtension", r.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", r.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", r.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", r.UNION_TYPE_EXTENSION = "UnionTypeExtension", r.ENUM_TYPE_EXTENSION = "EnumTypeExtension", r.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension", r.TYPE_COORDINATE = "TypeCoordinate", r.MEMBER_COORDINATE = "MemberCoordinate", r.ARGUMENT_COORDINATE = "ArgumentCoordinate", r.DIRECTIVE_COORDINATE = "DirectiveCoordinate", r.DIRECTIVE_ARGUMENT_COORDINATE = "DirectiveArgumentCoordinate";
})(et || (et = {}));
function Jv(r) {
  return r === 9 || r === 32;
}
function Zf(r) {
  return r >= 48 && r <= 57;
}
function h2(r) {
  return r >= 97 && r <= 122 || // A-Z
  r >= 65 && r <= 90;
}
function p2(r) {
  return h2(r) || r === 95;
}
function iD(r) {
  return h2(r) || Zf(r) || r === 95;
}
function aD(r) {
  var e;
  let t = Number.MAX_SAFE_INTEGER, n = null, i = -1;
  for (let s = 0; s < r.length; ++s) {
    var a;
    const o = r[s], l = sD(o);
    l !== o.length && (n = (a = n) !== null && a !== void 0 ? a : s, i = s, s !== 0 && l < t && (t = l));
  }
  return r.map((s, o) => o === 0 ? s : s.slice(t)).slice(
    (e = n) !== null && e !== void 0 ? e : 0,
    i + 1
  );
}
function sD(r) {
  let e = 0;
  for (; e < r.length && Jv(r.charCodeAt(e)); )
    ++e;
  return e;
}
function oD(r, e) {
  const t = r.replace(/"""/g, '\\"""'), n = t.split(/\r\n|[\n\r]/g), i = n.length === 1, a = n.length > 1 && n.slice(1).every((h) => h.length === 0 || Jv(h.charCodeAt(0))), s = t.endsWith('\\"""'), o = r.endsWith('"') && !s, l = r.endsWith("\\"), u = o || l, c = (
    // add leading and trailing new lines only if it improves readability
    !i || r.length > 70 || u || a || s
  );
  let d = "";
  const f = i && Jv(r.charCodeAt(0));
  return (c && !f || a) && (d += `
`), d += t, (c || u) && (d += `
`), '"""' + d + '"""';
}
var De;
(function(r) {
  r.SOF = "<SOF>", r.EOF = "<EOF>", r.BANG = "!", r.DOLLAR = "$", r.AMP = "&", r.PAREN_L = "(", r.PAREN_R = ")", r.DOT = ".", r.SPREAD = "...", r.COLON = ":", r.EQUALS = "=", r.AT = "@", r.BRACKET_L = "[", r.BRACKET_R = "]", r.BRACE_L = "{", r.PIPE = "|", r.BRACE_R = "}", r.NAME = "Name", r.INT = "Int", r.FLOAT = "Float", r.STRING = "String", r.BLOCK_STRING = "BlockString", r.COMMENT = "Comment";
})(De || (De = {}));
class lD {
  /** Source document used to derive error locations. */
  /** Most recent non-ignored token returned by the lexer. */
  /** Current non-ignored token at the lexer cursor. */
  /** The (1-indexed) line containing the current token. */
  /** Character offset where the current line starts. */
  /**
   * Creates a Lexer instance.
   * @param source - Source document used to derive error locations.
   * @example
   * ```ts
   * import { Lexer, Source, TokenKind } from 'graphql/language';
   *
   * const lexer = new Lexer(new Source('{ hello }'));
   *
   * lexer.token.kind; // => TokenKind.SOF
   * lexer.advance().kind; // => TokenKind.BRACE_L
   * lexer.advance().value; // => 'hello'
   * lexer.advance().kind; // => TokenKind.BRACE_R
   * ```
   */
  constructor(e) {
    const t = new f2(De.SOF, 0, 0, 0, 0);
    this.source = e, this.lastToken = t, this.token = t, this.line = 1, this.lineStart = 0;
  }
  /**
   * Returns the value used by `Object.prototype.toString`.
   * @returns The built-in string tag for this object.
   */
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   * @returns The next non-ignored token.
   * @example
   * ```ts
   * import { Lexer, Source } from 'graphql/language';
   *
   * const lexer = new Lexer(new Source('{ hello }'));
   * const token = lexer.advance();
   *
   * token.kind; // => '{'
   * lexer.token; // => token
   * ```
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   * @returns The next non-ignored token without advancing the lexer.
   * @example
   * ```ts
   * import { Lexer, Source } from 'graphql/language';
   *
   * const lexer = new Lexer(new Source('{ hello }'));
   * const token = lexer.lookahead();
   *
   * token.kind; // => '{'
   * lexer.token.kind; // => '<SOF>'
   * ```
   */
  lookahead() {
    let e = this.token;
    if (e.kind !== De.EOF)
      do
        if (e.next)
          e = e.next;
        else {
          const t = cD(this, e.end);
          e.next = t, t.prev = e, e = t;
        }
      while (e.kind === De.COMMENT);
    return e;
  }
}
function uD(r) {
  return r === De.BANG || r === De.DOLLAR || r === De.AMP || r === De.PAREN_L || r === De.PAREN_R || r === De.DOT || r === De.SPREAD || r === De.COLON || r === De.EQUALS || r === De.AT || r === De.BRACKET_L || r === De.BRACKET_R || r === De.BRACE_L || r === De.PIPE || r === De.BRACE_R;
}
function Ku(r) {
  return r >= 0 && r <= 55295 || r >= 57344 && r <= 1114111;
}
function yg(r, e) {
  return g2(r.charCodeAt(e)) && m2(r.charCodeAt(e + 1));
}
function g2(r) {
  return r >= 55296 && r <= 56319;
}
function m2(r) {
  return r >= 56320 && r <= 57343;
}
function Al(r, e) {
  const t = r.source.body.codePointAt(e);
  if (t === void 0)
    return De.EOF;
  if (t >= 32 && t <= 126) {
    const n = String.fromCodePoint(t);
    return n === '"' ? `'"'` : `"${n}"`;
  }
  return "U+" + t.toString(16).toUpperCase().padStart(4, "0");
}
function ri(r, e, t, n, i) {
  const a = r.line, s = 1 + t - r.lineStart;
  return new f2(e, t, n, a, s, i);
}
function cD(r, e) {
  const t = r.source.body, n = t.length;
  let i = e;
  for (; i < n; ) {
    const a = t.charCodeAt(i);
    switch (a) {
      // Ignored ::
      //   - UnicodeBOM
      //   - WhiteSpace
      //   - LineTerminator
      //   - Comment
      //   - Comma
      //
      // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
      //
      // WhiteSpace ::
      //   - "Horizontal Tab (U+0009)"
      //   - "Space (U+0020)"
      //
      // Comma :: ,
      case 65279:
      // <BOM>
      case 9:
      // \t
      case 32:
      // <space>
      case 44:
        ++i;
        continue;
      // LineTerminator ::
      //   - "New Line (U+000A)"
      //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
      //   - "Carriage Return (U+000D)" "New Line (U+000A)"
      case 10:
        ++i, ++r.line, r.lineStart = i;
        continue;
      case 13:
        t.charCodeAt(i + 1) === 10 ? i += 2 : ++i, ++r.line, r.lineStart = i;
        continue;
      // Comment
      case 35:
        return fD(r, i);
      // Token ::
      //   - Punctuator
      //   - Name
      //   - IntValue
      //   - FloatValue
      //   - StringValue
      //
      // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
      case 33:
        return ri(r, De.BANG, i, i + 1);
      case 36:
        return ri(r, De.DOLLAR, i, i + 1);
      case 38:
        return ri(r, De.AMP, i, i + 1);
      case 40:
        return ri(r, De.PAREN_L, i, i + 1);
      case 41:
        return ri(r, De.PAREN_R, i, i + 1);
      case 46:
        if (t.charCodeAt(i + 1) === 46 && t.charCodeAt(i + 2) === 46)
          return ri(r, De.SPREAD, i, i + 3);
        break;
      case 58:
        return ri(r, De.COLON, i, i + 1);
      case 61:
        return ri(r, De.EQUALS, i, i + 1);
      case 64:
        return ri(r, De.AT, i, i + 1);
      case 91:
        return ri(r, De.BRACKET_L, i, i + 1);
      case 93:
        return ri(r, De.BRACKET_R, i, i + 1);
      case 123:
        return ri(r, De.BRACE_L, i, i + 1);
      case 124:
        return ri(r, De.PIPE, i, i + 1);
      case 125:
        return ri(r, De.BRACE_R, i, i + 1);
      // StringValue
      case 34:
        return t.charCodeAt(i + 1) === 34 && t.charCodeAt(i + 2) === 34 ? vD(r, i) : hD(r, i);
    }
    if (Zf(a) || a === 45)
      return dD(r, i, a);
    if (p2(a))
      return yD(r, i);
    throw oi(
      r.source,
      i,
      a === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : Ku(a) || yg(t, i) ? `Unexpected character: ${Al(r, i)}.` : `Invalid character: ${Al(r, i)}.`
    );
  }
  return ri(r, De.EOF, n, n);
}
function fD(r, e) {
  const t = r.source.body, n = t.length;
  let i = e + 1;
  for (; i < n; ) {
    const a = t.charCodeAt(i);
    if (a === 10 || a === 13)
      break;
    if (Ku(a))
      ++i;
    else if (yg(t, i))
      i += 2;
    else
      break;
  }
  return ri(
    r,
    De.COMMENT,
    e,
    i,
    t.slice(e + 1, i)
  );
}
function dD(r, e, t) {
  const n = r.source.body;
  let i = e, a = t, s = !1;
  if (a === 45 && (a = n.charCodeAt(++i)), a === 48) {
    if (a = n.charCodeAt(++i), Zf(a))
      throw oi(
        r.source,
        i,
        `Invalid number, unexpected digit after 0: ${Al(
          r,
          i
        )}.`
      );
  } else
    i = _m(r, i, a), a = n.charCodeAt(i);
  if (a === 46 && (s = !0, a = n.charCodeAt(++i), i = _m(r, i, a), a = n.charCodeAt(i)), (a === 69 || a === 101) && (s = !0, a = n.charCodeAt(++i), (a === 43 || a === 45) && (a = n.charCodeAt(++i)), i = _m(r, i, a), a = n.charCodeAt(i)), a === 46 || p2(a))
    throw oi(
      r.source,
      i,
      `Invalid number, expected digit but got: ${Al(
        r,
        i
      )}.`
    );
  return ri(
    r,
    s ? De.FLOAT : De.INT,
    e,
    i,
    n.slice(e, i)
  );
}
function _m(r, e, t) {
  if (!Zf(t))
    throw oi(
      r.source,
      e,
      `Invalid number, expected digit but got: ${Al(
        r,
        e
      )}.`
    );
  const n = r.source.body;
  let i = e + 1;
  for (; Zf(n.charCodeAt(i)); )
    ++i;
  return i;
}
function hD(r, e) {
  const t = r.source.body, n = t.length;
  let i = e + 1, a = i, s = "";
  for (; i < n; ) {
    const o = t.charCodeAt(i);
    if (o === 34)
      return s += t.slice(a, i), ri(r, De.STRING, e, i + 1, s);
    if (o === 92) {
      s += t.slice(a, i);
      const l = t.charCodeAt(i + 1) === 117 ? t.charCodeAt(i + 2) === 123 ? pD(r, i) : gD(r, i) : mD(r, i);
      s += l.value, i += l.size, a = i;
      continue;
    }
    if (o === 10 || o === 13)
      break;
    if (Ku(o))
      ++i;
    else if (yg(t, i))
      i += 2;
    else
      throw oi(
        r.source,
        i,
        `Invalid character within String: ${Al(
          r,
          i
        )}.`
      );
  }
  throw oi(r.source, i, "Unterminated string.");
}
function pD(r, e) {
  const t = r.source.body;
  let n = 0, i = 3;
  for (; i < 12; ) {
    const a = t.charCodeAt(e + i++);
    if (a === 125) {
      if (i < 5 || !Ku(n))
        break;
      return {
        value: String.fromCodePoint(n),
        size: i
      };
    }
    if (n = n << 4 | kf(a), n < 0)
      break;
  }
  throw oi(
    r.source,
    e,
    `Invalid Unicode escape sequence: "${t.slice(
      e,
      e + i
    )}".`
  );
}
function gD(r, e) {
  const t = r.source.body, n = $b(t, e + 2);
  if (Ku(n))
    return {
      value: String.fromCodePoint(n),
      size: 6
    };
  if (g2(n) && t.charCodeAt(e + 6) === 92 && t.charCodeAt(e + 7) === 117) {
    const i = $b(t, e + 8);
    if (m2(i))
      return {
        value: String.fromCodePoint(n, i),
        size: 12
      };
  }
  throw oi(
    r.source,
    e,
    `Invalid Unicode escape sequence: "${t.slice(e, e + 6)}".`
  );
}
function $b(r, e) {
  return kf(r.charCodeAt(e)) << 12 | kf(r.charCodeAt(e + 1)) << 8 | kf(r.charCodeAt(e + 2)) << 4 | kf(r.charCodeAt(e + 3));
}
function kf(r) {
  return r >= 48 && r <= 57 ? r - 48 : r >= 65 && r <= 70 ? r - 55 : r >= 97 && r <= 102 ? r - 87 : -1;
}
function mD(r, e) {
  const t = r.source.body;
  switch (t.charCodeAt(e + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw oi(
    r.source,
    e,
    `Invalid character escape sequence: "${t.slice(
      e,
      e + 2
    )}".`
  );
}
function vD(r, e) {
  const t = r.source.body, n = t.length;
  let i = r.lineStart, a = e + 3, s = a, o = "";
  const l = [];
  for (; a < n; ) {
    const u = t.charCodeAt(a);
    if (u === 34 && t.charCodeAt(a + 1) === 34 && t.charCodeAt(a + 2) === 34) {
      o += t.slice(s, a), l.push(o);
      const c = ri(
        r,
        De.BLOCK_STRING,
        e,
        a + 3,
        // Return a string of the lines joined with U+000A.
        aD(l).join(`
`)
      );
      return r.line += l.length - 1, r.lineStart = i, c;
    }
    if (u === 92 && t.charCodeAt(a + 1) === 34 && t.charCodeAt(a + 2) === 34 && t.charCodeAt(a + 3) === 34) {
      o += t.slice(s, a), s = a + 1, a += 4;
      continue;
    }
    if (u === 10 || u === 13) {
      o += t.slice(s, a), l.push(o), u === 13 && t.charCodeAt(a + 1) === 10 ? a += 2 : ++a, o = "", s = a, i = a;
      continue;
    }
    if (Ku(u))
      ++a;
    else if (yg(t, a))
      a += 2;
    else
      throw oi(
        r.source,
        a,
        `Invalid character within String: ${Al(
          r,
          a
        )}.`
      );
  }
  throw oi(r.source, a, "Unterminated string.");
}
function yD(r, e) {
  const t = r.source.body, n = t.length;
  let i = e + 1;
  for (; i < n; ) {
    const a = t.charCodeAt(i);
    if (iD(a))
      ++i;
    else
      break;
  }
  return ri(
    r,
    De.NAME,
    e,
    i,
    t.slice(e, i)
  );
}
const AD = 10, v2 = 2;
function fA(r) {
  return Ag(r, []);
}
function Ag(r, e) {
  switch (typeof r) {
    case "string":
      return JSON.stringify(r);
    case "function":
      return r.name ? `[function ${r.name}]` : "[function]";
    case "object":
      return bD(r, e);
    default:
      return String(r);
  }
}
function bD(r, e) {
  if (r === null)
    return "null";
  if (e.includes(r))
    return "[Circular]";
  const t = [...e, r];
  if (wD(r)) {
    const n = r.toJSON();
    if (n !== r)
      return typeof n == "string" ? n : Ag(n, t);
  } else if (Array.isArray(r))
    return CD(r, t);
  return xD(r, t);
}
function wD(r) {
  return typeof r.toJSON == "function";
}
function xD(r, e) {
  const t = Object.entries(r);
  return t.length === 0 ? "{}" : e.length > v2 ? "[" + SD(r) + "]" : "{ " + t.map(
    ([i, a]) => i + ": " + Ag(a, e)
  ).join(", ") + " }";
}
function CD(r, e) {
  if (r.length === 0)
    return "[]";
  if (e.length > v2)
    return "[Array]";
  const t = Math.min(AD, r.length), n = r.length - t, i = [];
  for (let a = 0; a < t; ++a)
    i.push(Ag(r[a], e));
  return n === 1 ? i.push("... 1 more item") : n > 1 && i.push(`... ${n} more items`), "[" + i.join(", ") + "]";
}
function SD(r) {
  const e = Object.prototype.toString.call(r).replace(/^\[object /, "").replace(/]$/, "");
  if (e === "Object" && typeof r.constructor == "function") {
    const t = r.constructor.name;
    if (typeof t == "string" && t !== "")
      return t;
  }
  return e;
}
const ED = globalThis.process && // eslint-disable-next-line no-undef
process.env.NODE_ENV === "production", kD = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  ED ? function(e, t) {
    return e instanceof t;
  } : function(e, t) {
    if (e instanceof t)
      return !0;
    if (typeof e == "object" && e !== null) {
      var n;
      const i = t.prototype[Symbol.toStringTag], a = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in e ? e[Symbol.toStringTag] : (n = e.constructor) === null || n === void 0 ? void 0 : n.name
      );
      if (i === a) {
        const s = fA(e);
        throw new Error(`Cannot use ${i} "${s}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class y2 {
  /** The GraphQL source text. */
  /** Name used in diagnostics for this source, such as a file path or request name. */
  /** One-indexed line and column where this source begins. */
  /**
   * Creates a Source instance.
   * @param body - The GraphQL source text.
   * @param name - Name used in diagnostics for this source.
   * @param locationOffset - One-indexed line and column where this source begins.
   * @example
   * ```ts
   * import { Source } from 'graphql/language';
   *
   * const source = new Source(
   *   'type Query { greeting: String }',
   *   'schema.graphql',
   *   { line: 10, column: 1 },
   * );
   *
   * source.body; // => 'type Query { greeting: String }'
   * source.name; // => 'schema.graphql'
   * source.locationOffset; // => { line: 10, column: 1 }
   * ```
   */
  constructor(e, t = "GraphQL request", n = {
    line: 1,
    column: 1
  }) {
    typeof e == "string" || xp(!1, `Body must be a string. Received: ${fA(e)}.`), this.body = e, this.name = t, this.locationOffset = n, this.locationOffset.line > 0 || xp(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || xp(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  /**
   * Returns the value used by `Object.prototype.toString`.
   * @returns The built-in string tag for this object.
   */
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function TD(r) {
  return kD(r, y2);
}
function FD(r, e) {
  const t = new ID(r, e), n = t.parseDocument();
  return Object.defineProperty(n, "tokenCount", {
    enumerable: !1,
    value: t.tokenCount
  }), n;
}
let ID = class {
  constructor(e, t = {}) {
    const { lexer: n, ...i } = t;
    if (n)
      this._lexer = n;
    else {
      const a = TD(e) ? e : new y2(e);
      this._lexer = new lD(a);
    }
    this._options = i, this._tokenCounter = 0;
  }
  get tokenCount() {
    return this._tokenCounter;
  }
  /**
   * Converts a name lex token into a name parse node.
   *
   * @internal
   */
  parseName() {
    const e = this.expectToken(De.NAME);
    return this.node(e, {
      kind: et.NAME,
      value: e.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   *
   * @internal
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: et.DOCUMENT,
      definitions: this.many(
        De.SOF,
        this.parseDefinition,
        De.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   *
   * @internal
   */
  parseDefinition() {
    if (this.peek(De.BRACE_L))
      return this.parseOperationDefinition();
    const e = this.peekDescription(), t = e ? this._lexer.lookahead() : this._lexer.token;
    if (e && t.kind === De.BRACE_L)
      throw oi(
        this._lexer.source,
        this._lexer.token.start,
        "Unexpected description, descriptions are not supported on shorthand queries."
      );
    if (t.kind === De.NAME) {
      switch (t.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      switch (t.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
      }
      if (e)
        throw oi(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, only GraphQL definitions support descriptions."
        );
      if (t.value === "extend")
        return this.parseTypeSystemExtension();
    }
    throw this.unexpected(t);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   *
   * @internal
   */
  parseOperationDefinition() {
    const e = this._lexer.token;
    if (this.peek(De.BRACE_L))
      return this.node(e, {
        kind: et.OPERATION_DEFINITION,
        operation: Su.QUERY,
        description: void 0,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const t = this.parseDescription(), n = this.parseOperationType();
    let i;
    return this.peek(De.NAME) && (i = this.parseName()), this.node(e, {
      kind: et.OPERATION_DEFINITION,
      operation: n,
      description: t,
      name: i,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   *
   * @internal
   */
  parseOperationType() {
    const e = this.expectToken(De.NAME);
    switch (e.value) {
      case "query":
        return Su.QUERY;
      case "mutation":
        return Su.MUTATION;
      case "subscription":
        return Su.SUBSCRIPTION;
    }
    throw this.unexpected(e);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   *
   * @internal
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      De.PAREN_L,
      this.parseVariableDefinition,
      De.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   *
   * @internal
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: et.VARIABLE_DEFINITION,
      description: this.parseDescription(),
      variable: this.parseVariable(),
      type: (this.expectToken(De.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(De.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   *
   * @internal
   */
  parseVariable() {
    const e = this._lexer.token;
    return this.expectToken(De.DOLLAR), this.node(e, {
      kind: et.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   *
   * @internal
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: et.SELECTION_SET,
      selections: this.many(
        De.BRACE_L,
        this.parseSelection,
        De.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   *
   * @internal
   */
  parseSelection() {
    return this.peek(De.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   *
   * @internal
   */
  parseField() {
    const e = this._lexer.token, t = this.parseName();
    let n, i;
    return this.expectOptionalToken(De.COLON) ? (n = t, i = this.parseName()) : i = t, this.node(e, {
      kind: et.FIELD,
      alias: n,
      name: i,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(De.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   *
   * @internal
   */
  parseArguments(e) {
    const t = e ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(De.PAREN_L, t, De.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   *
   * @internal
   */
  parseArgument(e = !1) {
    const t = this._lexer.token, n = this.parseName();
    return this.expectToken(De.COLON), this.node(t, {
      kind: et.ARGUMENT,
      name: n,
      value: this.parseValueLiteral(e)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   *
   * @internal
   */
  parseFragment() {
    const e = this._lexer.token;
    this.expectToken(De.SPREAD);
    const t = this.expectOptionalKeyword("on");
    return !t && this.peek(De.NAME) ? this.node(e, {
      kind: et.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(e, {
      kind: et.INLINE_FRAGMENT,
      typeCondition: t ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   *
   * @internal
   */
  parseFragmentDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(e, {
      kind: et.FRAGMENT_DEFINITION,
      description: t,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(e, {
      kind: et.FRAGMENT_DEFINITION,
      description: t,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   *
   * @internal
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   *
   * @internal
   */
  parseValueLiteral(e) {
    const t = this._lexer.token;
    switch (t.kind) {
      case De.BRACKET_L:
        return this.parseList(e);
      case De.BRACE_L:
        return this.parseObject(e);
      case De.INT:
        return this.advanceLexer(), this.node(t, {
          kind: et.INT,
          value: t.value
        });
      case De.FLOAT:
        return this.advanceLexer(), this.node(t, {
          kind: et.FLOAT,
          value: t.value
        });
      case De.STRING:
      case De.BLOCK_STRING:
        return this.parseStringLiteral();
      case De.NAME:
        switch (this.advanceLexer(), t.value) {
          case "true":
            return this.node(t, {
              kind: et.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(t, {
              kind: et.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(t, {
              kind: et.NULL
            });
          default:
            return this.node(t, {
              kind: et.ENUM,
              value: t.value
            });
        }
      case De.DOLLAR:
        if (e)
          if (this.expectToken(De.DOLLAR), this._lexer.token.kind === De.NAME) {
            const n = this._lexer.token.value;
            throw oi(
              this._lexer.source,
              t.start,
              `Unexpected variable "$${n}" in constant value.`
            );
          } else
            throw this.unexpected(t);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const e = this._lexer.token;
    return this.advanceLexer(), this.node(e, {
      kind: et.STRING,
      value: e.value,
      block: e.kind === De.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   *
   * @internal
   */
  parseList(e) {
    const t = () => this.parseValueLiteral(e);
    return this.node(this._lexer.token, {
      kind: et.LIST,
      values: this.any(De.BRACKET_L, t, De.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   *
   * @internal
   */
  parseObject(e) {
    const t = () => this.parseObjectField(e);
    return this.node(this._lexer.token, {
      kind: et.OBJECT,
      fields: this.any(De.BRACE_L, t, De.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   *
   * @internal
   */
  parseObjectField(e) {
    const t = this._lexer.token, n = this.parseName();
    return this.expectToken(De.COLON), this.node(t, {
      kind: et.OBJECT_FIELD,
      name: n,
      value: this.parseValueLiteral(e)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   *
   * @internal
   */
  parseDirectives(e) {
    const t = [];
    for (; this.peek(De.AT); )
      t.push(this.parseDirective(e));
    return t;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   *
   * @internal
   */
  parseDirective(e) {
    const t = this._lexer.token;
    return this.expectToken(De.AT), this.node(t, {
      kind: et.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(e)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   *
   * @internal
   */
  parseTypeReference() {
    const e = this._lexer.token;
    let t;
    if (this.expectOptionalToken(De.BRACKET_L)) {
      const n = this.parseTypeReference();
      this.expectToken(De.BRACKET_R), t = this.node(e, {
        kind: et.LIST_TYPE,
        type: n
      });
    } else
      t = this.parseNamedType();
    return this.expectOptionalToken(De.BANG) ? this.node(e, {
      kind: et.NON_NULL_TYPE,
      type: t
    }) : t;
  }
  /**
   * NamedType : Name
   *
   * @internal
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: et.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(De.STRING) || this.peek(De.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   *
   * @internal
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   *
   * @internal
   */
  parseSchemaDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("schema");
    const n = this.parseConstDirectives(), i = this.many(
      De.BRACE_L,
      this.parseOperationTypeDefinition,
      De.BRACE_R
    );
    return this.node(e, {
      kind: et.SCHEMA_DEFINITION,
      description: t,
      directives: n,
      operationTypes: i
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   *
   * @internal
   */
  parseOperationTypeDefinition() {
    const e = this._lexer.token, t = this.parseOperationType();
    this.expectToken(De.COLON);
    const n = this.parseNamedType();
    return this.node(e, {
      kind: et.OPERATION_TYPE_DEFINITION,
      operation: t,
      type: n
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   *
   * @internal
   */
  parseScalarTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("scalar");
    const n = this.parseName(), i = this.parseConstDirectives();
    return this.node(e, {
      kind: et.SCALAR_TYPE_DEFINITION,
      description: t,
      name: n,
      directives: i
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   *
   * @internal
   */
  parseObjectTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("type");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), a = this.parseConstDirectives(), s = this.parseFieldsDefinition();
    return this.node(e, {
      kind: et.OBJECT_TYPE_DEFINITION,
      description: t,
      name: n,
      interfaces: i,
      directives: a,
      fields: s
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   *
   * @internal
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(De.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   *
   * @internal
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      De.BRACE_L,
      this.parseFieldDefinition,
      De.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   *
   * @internal
   */
  parseFieldDefinition() {
    const e = this._lexer.token, t = this.parseDescription(), n = this.parseName(), i = this.parseArgumentDefs();
    this.expectToken(De.COLON);
    const a = this.parseTypeReference(), s = this.parseConstDirectives();
    return this.node(e, {
      kind: et.FIELD_DEFINITION,
      description: t,
      name: n,
      arguments: i,
      type: a,
      directives: s
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   *
   * @internal
   */
  parseArgumentDefs() {
    return this.optionalMany(
      De.PAREN_L,
      this.parseInputValueDef,
      De.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   *
   * @internal
   */
  parseInputValueDef() {
    const e = this._lexer.token, t = this.parseDescription(), n = this.parseName();
    this.expectToken(De.COLON);
    const i = this.parseTypeReference();
    let a;
    this.expectOptionalToken(De.EQUALS) && (a = this.parseConstValueLiteral());
    const s = this.parseConstDirectives();
    return this.node(e, {
      kind: et.INPUT_VALUE_DEFINITION,
      description: t,
      name: n,
      type: i,
      defaultValue: a,
      directives: s
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   *
   * @internal
   */
  parseInterfaceTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("interface");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), a = this.parseConstDirectives(), s = this.parseFieldsDefinition();
    return this.node(e, {
      kind: et.INTERFACE_TYPE_DEFINITION,
      description: t,
      name: n,
      interfaces: i,
      directives: a,
      fields: s
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   *
   * @internal
   */
  parseUnionTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("union");
    const n = this.parseName(), i = this.parseConstDirectives(), a = this.parseUnionMemberTypes();
    return this.node(e, {
      kind: et.UNION_TYPE_DEFINITION,
      description: t,
      name: n,
      directives: i,
      types: a
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   *
   * @internal
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(De.EQUALS) ? this.delimitedMany(De.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   *
   * @internal
   */
  parseEnumTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("enum");
    const n = this.parseName(), i = this.parseConstDirectives(), a = this.parseEnumValuesDefinition();
    return this.node(e, {
      kind: et.ENUM_TYPE_DEFINITION,
      description: t,
      name: n,
      directives: i,
      values: a
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   *
   * @internal
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      De.BRACE_L,
      this.parseEnumValueDefinition,
      De.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * @internal
   */
  parseEnumValueDefinition() {
    const e = this._lexer.token, t = this.parseDescription(), n = this.parseEnumValueName(), i = this.parseConstDirectives();
    return this.node(e, {
      kind: et.ENUM_VALUE_DEFINITION,
      description: t,
      name: n,
      directives: i
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   *
   * @internal
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw oi(
        this._lexer.source,
        this._lexer.token.start,
        `${Eh(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   *
   * @internal
   */
  parseInputObjectTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("input");
    const n = this.parseName(), i = this.parseConstDirectives(), a = this.parseInputFieldsDefinition();
    return this.node(e, {
      kind: et.INPUT_OBJECT_TYPE_DEFINITION,
      description: t,
      name: n,
      directives: i,
      fields: a
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   *
   * @internal
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      De.BRACE_L,
      this.parseInputValueDef,
      De.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   *   - DirectiveDefinitionExtension
   *
   * @internal
   */
  parseTypeSystemExtension() {
    const e = this._lexer.lookahead();
    if (e.kind === De.NAME)
      switch (e.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
        case "directive":
          if (this._options.experimentalDirectivesOnDirectiveDefinitions)
            return this.parseDirectiveDefinitionExtension();
          break;
      }
    throw this.unexpected(e);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   *
   * @internal
   */
  parseSchemaExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const t = this.parseConstDirectives(), n = this.optionalMany(
      De.BRACE_L,
      this.parseOperationTypeDefinition,
      De.BRACE_R
    );
    if (t.length === 0 && n.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: et.SCHEMA_EXTENSION,
      directives: t,
      operationTypes: n
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   *
   * @internal
   */
  parseScalarTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const t = this.parseName(), n = this.parseConstDirectives();
    if (n.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: et.SCALAR_TYPE_EXTENSION,
      name: t,
      directives: n
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   *
   * @internal
   */
  parseObjectTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const t = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: et.OBJECT_TYPE_EXTENSION,
      name: t,
      interfaces: n,
      directives: i,
      fields: a
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   *
   * @internal
   */
  parseInterfaceTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const t = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: et.INTERFACE_TYPE_EXTENSION,
      name: t,
      interfaces: n,
      directives: i,
      fields: a
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   *
   * @internal
   */
  parseUnionTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const t = this.parseName(), n = this.parseConstDirectives(), i = this.parseUnionMemberTypes();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: et.UNION_TYPE_EXTENSION,
      name: t,
      directives: n,
      types: i
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   *
   * @internal
   */
  parseEnumTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const t = this.parseName(), n = this.parseConstDirectives(), i = this.parseEnumValuesDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: et.ENUM_TYPE_EXTENSION,
      name: t,
      directives: n,
      values: i
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   *
   * @internal
   */
  parseInputObjectTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const t = this.parseName(), n = this.parseConstDirectives(), i = this.parseInputFieldsDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: et.INPUT_OBJECT_TYPE_EXTENSION,
      name: t,
      directives: n,
      fields: i
    });
  }
  parseDirectiveDefinitionExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("directive"), this.expectToken(De.AT);
    const t = this.parseName(), n = this.parseConstDirectives();
    if (n.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: et.DIRECTIVE_EXTENSION,
      name: t,
      directives: n
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   *
   * @internal
   */
  parseDirectiveDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(De.AT);
    const n = this.parseName(), i = this.parseArgumentDefs(), a = this._options.experimentalDirectivesOnDirectiveDefinitions ? this.parseConstDirectives() : [], s = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const o = this.parseDirectiveLocations();
    return this.node(e, {
      kind: et.DIRECTIVE_DEFINITION,
      description: t,
      name: n,
      arguments: i,
      directives: a,
      repeatable: s,
      locations: o
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   *
   * @internal
   */
  parseDirectiveLocations() {
    return this.delimitedMany(De.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   *   `DIRECTIVE_DEFINITION`
   */
  parseDirectiveLocation() {
    const e = this._lexer.token, t = this.parseName();
    if (Object.prototype.hasOwnProperty.call(Xv, t.value))
      return t;
    throw this.unexpected(e);
  }
  // Schema Coordinates
  /**
   * SchemaCoordinate :
   *   - Name
   *   - Name . Name
   *   - Name . Name ( Name : )
   *   - \@ Name
   *   - \@ Name ( Name : )
   * @returns Parsed schema coordinate AST.
   * @example
   * ```ts
   * import { Parser, Source } from 'graphql/language';
   *
   * const typeCoordinate = new Parser(new Source('User.name')).parseSchemaCoordinate();
   * const directiveCoordinate = new Parser(new Source('@include(if:)')).parseSchemaCoordinate();
   *
   * typeCoordinate.name.value; // => 'User'
   * typeCoordinate.memberName?.value; // => 'name'
   * directiveCoordinate.name.value; // => 'deprecated'
   * directiveCoordinate.argumentName?.value; // => 'reason'
   * ```
   */
  parseSchemaCoordinate() {
    const e = this._lexer.token, t = this.expectOptionalToken(De.AT), n = this.parseName();
    let i;
    !t && this.expectOptionalToken(De.DOT) && (i = this.parseName());
    let a;
    return (t || i) && this.expectOptionalToken(De.PAREN_L) && (a = this.parseName(), this.expectToken(De.COLON), this.expectToken(De.PAREN_R)), t ? a ? this.node(e, {
      kind: et.DIRECTIVE_ARGUMENT_COORDINATE,
      name: n,
      argumentName: a
    }) : this.node(e, {
      kind: et.DIRECTIVE_COORDINATE,
      name: n
    }) : i ? a ? this.node(e, {
      kind: et.ARGUMENT_COORDINATE,
      name: n,
      fieldName: i,
      argumentName: a
    }) : this.node(e, {
      kind: et.MEMBER_COORDINATE,
      name: n,
      memberName: i
    }) : this.node(e, {
      kind: et.TYPE_COORDINATE,
      name: n
    });
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   *
   * @internal
   */
  node(e, t) {
    return this._options.noLocation !== !0 && (t.loc = new rD(
      e,
      this._lexer.lastToken,
      this._lexer.source
    )), t;
  }
  /**
   * Determines if the next token is of a given kind
   *
   * @internal
   */
  peek(e) {
    return this._lexer.token.kind === e;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   *
   * @internal
   */
  expectToken(e) {
    const t = this._lexer.token;
    if (t.kind === e)
      return this.advanceLexer(), t;
    throw oi(
      this._lexer.source,
      t.start,
      `Expected ${A2(e)}, found ${Eh(t)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   *
   * @internal
   */
  expectOptionalToken(e) {
    return this._lexer.token.kind === e ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   *
   * @internal
   */
  expectKeyword(e) {
    const t = this._lexer.token;
    if (t.kind === De.NAME && t.value === e)
      this.advanceLexer();
    else
      throw oi(
        this._lexer.source,
        t.start,
        `Expected "${e}", found ${Eh(t)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   *
   * @internal
   */
  expectOptionalKeyword(e) {
    const t = this._lexer.token;
    return t.kind === De.NAME && t.value === e ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   *
   * @internal
   */
  unexpected(e) {
    const t = e ?? this._lexer.token;
    return oi(
      this._lexer.source,
      t.start,
      `Unexpected ${Eh(t)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   *
   * @internal
   */
  any(e, t, n) {
    this.expectToken(e);
    const i = [];
    for (; !this.expectOptionalToken(n); )
      i.push(t.call(this));
    return i;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   *
   * @internal
   */
  optionalMany(e, t, n) {
    if (this.expectOptionalToken(e)) {
      const i = [];
      do
        i.push(t.call(this));
      while (!this.expectOptionalToken(n));
      return i;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   *
   * @internal
   */
  many(e, t, n) {
    this.expectToken(e);
    const i = [];
    do
      i.push(t.call(this));
    while (!this.expectOptionalToken(n));
    return i;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   *
   * @internal
   */
  delimitedMany(e, t) {
    this.expectOptionalToken(e);
    const n = [];
    do
      n.push(t.call(this));
    while (this.expectOptionalToken(e));
    return n;
  }
  advanceLexer() {
    const { maxTokens: e } = this._options, t = this._lexer.advance();
    if (t.kind !== De.EOF && (++this._tokenCounter, e !== void 0 && this._tokenCounter > e))
      throw oi(
        this._lexer.source,
        t.start,
        `Document contains more that ${e} tokens. Parsing aborted.`
      );
  }
};
function Eh(r) {
  const e = r.value;
  return A2(r.kind) + (e != null ? ` "${e}"` : "");
}
function A2(r) {
  return uD(r) ? `"${r}"` : r;
}
function DD(r) {
  return `"${r.replace(PD, RD)}"`;
}
const PD = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function RD(r) {
  return OD[r.charCodeAt(0)];
}
const OD = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], dA = Object.freeze({});
function Fa(r, e, t = d2) {
  const n = /* @__PURE__ */ new Map();
  for (const A of Object.values(et))
    n.set(A, BD(e, A));
  let i, a = Array.isArray(r), s = [r], o = -1, l = [], u = r, c, d;
  const f = [], h = [];
  do {
    o++;
    const A = o === s.length, x = A && l.length !== 0;
    if (A) {
      if (c = h.length === 0 ? void 0 : f[f.length - 1], u = d, d = h.pop(), x)
        if (a) {
          u = u.slice();
          let F = 0;
          for (const [S, R] of l) {
            const M = S - F;
            R === null ? (u.splice(M, 1), F++) : u[M] = R;
          }
        } else {
          u = { ...u };
          for (const [F, S] of l)
            u[F] = S;
        }
      o = i.index, s = i.keys, l = i.edits, a = i.inArray, i = i.prev;
    } else if (d) {
      if (c = a ? o : s[o], u = d[c], u == null)
        continue;
      f.push(c);
    }
    let k;
    if (!Array.isArray(u)) {
      var g, v;
      zb(u) || xp(!1, `Invalid AST Node: ${fA(u)}.`);
      const F = A ? (g = n.get(u.kind)) === null || g === void 0 ? void 0 : g.leave : (v = n.get(u.kind)) === null || v === void 0 ? void 0 : v.enter;
      if (k = F?.call(e, u, c, d, f, h), k === dA)
        break;
      if (k === !1) {
        if (!A) {
          f.pop();
          continue;
        }
      } else if (k !== void 0 && (l.push([c, k]), !A))
        if (zb(k))
          u = k;
        else {
          f.pop();
          continue;
        }
    }
    if (k === void 0 && x && l.push([c, u]), A)
      f.pop();
    else {
      var y;
      i = {
        inArray: a,
        index: o,
        keys: s,
        edits: l,
        prev: i
      }, a = Array.isArray(u), s = a ? u : (y = t[u.kind]) !== null && y !== void 0 ? y : [], o = -1, l = [], d && h.push(d), d = u;
    }
  } while (i !== void 0);
  return l.length !== 0 ? l[l.length - 1][1] : r;
}
function BD(r, e) {
  const t = r[e];
  return typeof t == "object" ? t : typeof t == "function" ? {
    enter: t,
    leave: void 0
  } : {
    enter: r.enter,
    leave: r.leave
  };
}
function MD(r) {
  return Fa(r, ND);
}
const _D = 80, ND = {
  Name: {
    leave: (r) => r.value
  },
  Variable: {
    leave: (r) => "$" + r.name
  },
  // Document
  Document: {
    leave: (r) => ot(r.definitions, `

`)
  },
  OperationDefinition: {
    leave(r) {
      const e = Nm(r.variableDefinitions) ? Zt(`(
`, ot(r.variableDefinitions, `
`), `
)`) : Zt("(", ot(r.variableDefinitions, ", "), ")"), t = Zt("", r.description, `
`) + ot(
        [
          r.operation,
          ot([r.name, e]),
          ot(r.directives, " ")
        ],
        " "
      );
      return (t === "query" ? "" : t + " ") + r.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: r, type: e, defaultValue: t, directives: n, description: i }) => Zt("", i, `
`) + r + ": " + e + Zt(" = ", t) + Zt(" ", ot(n, " "))
  },
  SelectionSet: {
    leave: ({ selections: r }) => Ca(r)
  },
  Field: {
    leave({ alias: r, name: e, arguments: t, directives: n, selectionSet: i }) {
      const a = Zt("", r, ": ") + e;
      let s = a + Zt("(", ot(t, ", "), ")");
      return s.length > _D && (s = a + Zt(`(
`, Cp(ot(t, `
`)), `
)`)), ot([s, ot(n, " "), i], " ");
    }
  },
  Argument: {
    leave: ({ name: r, value: e }) => r + ": " + e
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: r, directives: e }) => "..." + r + Zt(" ", ot(e, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: r, directives: e, selectionSet: t }) => ot(
      [
        "...",
        Zt("on ", r),
        ot(e, " "),
        t
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({
      name: r,
      typeCondition: e,
      variableDefinitions: t,
      directives: n,
      selectionSet: i,
      description: a
    }) => Zt("", a, `
`) + // Note: fragment variable definitions are experimental and may be changed
    // or removed in the future.
    `fragment ${r}${Zt("(", ot(t, ", "), ")")} on ${e} ${Zt("", ot(n, " "), " ")}` + i
  },
  // Value
  IntValue: {
    leave: ({ value: r }) => r
  },
  FloatValue: {
    leave: ({ value: r }) => r
  },
  StringValue: {
    leave: ({ value: r, block: e }) => e ? oD(r) : DD(r)
  },
  BooleanValue: {
    leave: ({ value: r }) => r ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: r }) => r
  },
  ListValue: {
    leave: ({ values: r }) => "[" + ot(r, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: r }) => "{" + ot(r, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: r, value: e }) => r + ": " + e
  },
  // Directive
  Directive: {
    leave: ({ name: r, arguments: e }) => "@" + r + Zt("(", ot(e, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: r }) => r
  },
  ListType: {
    leave: ({ type: r }) => "[" + r + "]"
  },
  NonNullType: {
    leave: ({ type: r }) => r + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: r, directives: e, operationTypes: t }) => Zt("", r, `
`) + ot(["schema", ot(e, " "), Ca(t)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: r, type: e }) => r + ": " + e
  },
  ScalarTypeDefinition: {
    leave: ({ description: r, name: e, directives: t }) => Zt("", r, `
`) + ot(["scalar", e, ot(t, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: r, name: e, interfaces: t, directives: n, fields: i }) => Zt("", r, `
`) + ot(
      [
        "type",
        e,
        Zt("implements ", ot(t, " & ")),
        ot(n, " "),
        Ca(i)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: r, name: e, arguments: t, type: n, directives: i }) => Zt("", r, `
`) + e + (Nm(t) ? Zt(`(
`, Cp(ot(t, `
`)), `
)`) : Zt("(", ot(t, ", "), ")")) + ": " + n + Zt(" ", ot(i, " "))
  },
  InputValueDefinition: {
    leave: ({ description: r, name: e, type: t, defaultValue: n, directives: i }) => Zt("", r, `
`) + ot(
      [e + ": " + t, Zt("= ", n), ot(i, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: r, name: e, interfaces: t, directives: n, fields: i }) => Zt("", r, `
`) + ot(
      [
        "interface",
        e,
        Zt("implements ", ot(t, " & ")),
        ot(n, " "),
        Ca(i)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: r, name: e, directives: t, types: n }) => Zt("", r, `
`) + ot(
      ["union", e, ot(t, " "), Zt("= ", ot(n, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: r, name: e, directives: t, values: n }) => Zt("", r, `
`) + ot(["enum", e, ot(t, " "), Ca(n)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: r, name: e, directives: t }) => Zt("", r, `
`) + ot([e, ot(t, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: r, name: e, directives: t, fields: n }) => Zt("", r, `
`) + ot(["input", e, ot(t, " "), Ca(n)], " ")
  },
  DirectiveDefinition: {
    leave: ({
      description: r,
      name: e,
      arguments: t,
      directives: n,
      repeatable: i,
      locations: a
    }) => Zt("", r, `
`) + "directive @" + e + (Nm(t) ? Zt(`(
`, Cp(ot(t, `
`)), `
)`) : Zt("(", ot(t, ", "), ")")) + Zt(" ", ot(n, " ")) + (i ? " repeatable" : "") + " on " + ot(a, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: r, operationTypes: e }) => ot(
      ["extend schema", ot(r, " "), Ca(e)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: r, directives: e }) => ot(["extend scalar", r, ot(e, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: r, interfaces: e, directives: t, fields: n }) => ot(
      [
        "extend type",
        r,
        Zt("implements ", ot(e, " & ")),
        ot(t, " "),
        Ca(n)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: r, interfaces: e, directives: t, fields: n }) => ot(
      [
        "extend interface",
        r,
        Zt("implements ", ot(e, " & ")),
        ot(t, " "),
        Ca(n)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: r, directives: e, types: t }) => ot(
      [
        "extend union",
        r,
        ot(e, " "),
        Zt("= ", ot(t, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: r, directives: e, values: t }) => ot(["extend enum", r, ot(e, " "), Ca(t)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: r, directives: e, fields: t }) => ot(["extend input", r, ot(e, " "), Ca(t)], " ")
  },
  DirectiveExtension: {
    leave: ({ name: r, directives: e }) => ot(["extend directive @" + r, ot(e, " ")], " ")
  },
  // Schema Coordinates
  TypeCoordinate: {
    leave: ({ name: r }) => r
  },
  MemberCoordinate: {
    leave: ({ name: r, memberName: e }) => ot([r, Zt(".", e)])
  },
  ArgumentCoordinate: {
    leave: ({ name: r, fieldName: e, argumentName: t }) => ot([r, Zt(".", e), Zt("(", t, ":)")])
  },
  DirectiveCoordinate: {
    leave: ({ name: r }) => ot(["@", r])
  },
  DirectiveArgumentCoordinate: {
    leave: ({ name: r, argumentName: e }) => ot(["@", r, Zt("(", e, ":)")])
  }
};
function ot(r, e = "") {
  var t;
  return (t = r?.filter((n) => n).join(e)) !== null && t !== void 0 ? t : "";
}
function Ca(r) {
  return Zt(`{
`, Cp(ot(r, `
`)), `
}`);
}
function Zt(r, e, t = "") {
  return e != null && e !== "" ? r + e + t : "";
}
function Cp(r) {
  return Zt("  ", r.replace(/\n/g, `
  `));
}
function Nm(r) {
  var e;
  return (e = r?.some((t) => t.includes(`
`))) !== null && e !== void 0 ? e : !1;
}
function Hb(r) {
  return r.kind === et.FIELD || r.kind === et.FRAGMENT_SPREAD || r.kind === et.INLINE_FRAGMENT;
}
function wd(r, e) {
  var t = r.directives;
  return !t || !t.length ? !0 : VD(t).every(function(n) {
    var i = n.directive, a = n.ifArgument, s = !1;
    return a.value.kind === "Variable" ? (s = e && e[a.value.name.value], Mr(s !== void 0, 105, i.name.value)) : s = a.value.value, i.name.value === "skip" ? !s : s;
  });
}
function ed(r, e, t) {
  var n = new Set(r), i = n.size;
  return Fa(e, {
    Directive: function(a) {
      if (n.delete(a.name.value) && (!t || !n.size))
        return dA;
    }
  }), t ? !n.size : n.size < i;
}
function LD(r) {
  return r && ed(["client", "export"], r, !0);
}
function UD(r) {
  var e = r.name.value;
  return e === "skip" || e === "include";
}
function VD(r) {
  var e = [];
  return r && r.length && r.forEach(function(t) {
    if (UD(t)) {
      var n = t.arguments, i = t.name.value;
      Mr(n && n.length === 1, 106, i);
      var a = n[0];
      Mr(a.name && a.name.value === "if", 107, i);
      var s = a.value;
      Mr(s && (s.kind === "Variable" || s.kind === "BooleanValue"), 108, i), e.push({ directive: t, ifArgument: a });
    }
  }), e;
}
function zD(r) {
  var e, t, n = (e = r.directives) === null || e === void 0 ? void 0 : e.find(function(a) {
    var s = a.name;
    return s.value === "unmask";
  });
  if (!n)
    return "mask";
  var i = (t = n.arguments) === null || t === void 0 ? void 0 : t.find(function(a) {
    var s = a.name;
    return s.value === "mode";
  });
  return i && "value" in i.value && i.value.value === "migrate" ? "migrate" : "unmask";
}
const $D = () => /* @__PURE__ */ Object.create(null), { forEach: HD, slice: jb } = Array.prototype, { hasOwnProperty: jD } = Object.prototype;
class Os {
  constructor(e = !0, t = $D) {
    this.weakness = e, this.makeData = t;
  }
  lookup() {
    return this.lookupArray(arguments);
  }
  lookupArray(e) {
    let t = this;
    return HD.call(e, (n) => t = t.getChildTrie(n)), jD.call(t, "data") ? t.data : t.data = this.makeData(jb.call(e));
  }
  peek() {
    return this.peekArray(arguments);
  }
  peekArray(e) {
    let t = this;
    for (let n = 0, i = e.length; t && n < i; ++n) {
      const a = t.mapFor(e[n], !1);
      t = a && a.get(e[n]);
    }
    return t && t.data;
  }
  remove() {
    return this.removeArray(arguments);
  }
  removeArray(e) {
    let t;
    if (e.length) {
      const n = e[0], i = this.mapFor(n, !1), a = i && i.get(n);
      a && (t = a.removeArray(jb.call(e, 1)), !a.data && !a.weak && !(a.strong && a.strong.size) && i.delete(n));
    } else
      t = this.data, delete this.data;
    return t;
  }
  getChildTrie(e) {
    const t = this.mapFor(e, !0);
    let n = t.get(e);
    return n || t.set(e, n = new Os(this.weakness, this.makeData)), n;
  }
  mapFor(e, t) {
    return this.weakness && GD(e) ? this.weak || (t ? this.weak = /* @__PURE__ */ new WeakMap() : void 0) : this.strong || (t ? this.strong = /* @__PURE__ */ new Map() : void 0);
  }
}
function GD(r) {
  switch (typeof r) {
    case "object":
      if (r === null)
        break;
    // Fall through to return true...
    case "function":
      return !0;
  }
  return !1;
}
var qD = Ta(function() {
  return navigator.product;
}) == "ReactNative", Cl = typeof WeakMap == "function" && !(qD && !global.HermesInternal), hA = typeof WeakSet == "function", b2 = typeof Symbol == "function" && typeof Symbol.for == "function", bg = b2 && Symbol.asyncIterator;
Ta(function() {
  return window.document.createElement;
});
Ta(function() {
  return navigator.userAgent.indexOf("jsdom") >= 0;
});
function li(r) {
  return r !== null && typeof r == "object";
}
function w2(r) {
  return r !== null && typeof r == "object" && (Object.getPrototypeOf(r) === Object.prototype || Object.getPrototypeOf(r) === null);
}
function WD(r, e) {
  var t = e, n = [];
  r.definitions.forEach(function(a) {
    if (a.kind === "OperationDefinition")
      throw Hi(
        112,
        a.operation,
        a.name ? " named '".concat(a.name.value, "'") : ""
      );
    a.kind === "FragmentDefinition" && n.push(a);
  }), typeof t > "u" && (Mr(n.length === 1, 113, n.length), t = n[0].name.value);
  var i = me(me({}, r), { definitions: ta([
    {
      kind: "OperationDefinition",
      // OperationTypeNode is an enum
      operation: "query",
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: t
            }
          }
        ]
      }
    }
  ], r.definitions, !0) });
  return i;
}
function Zu(r) {
  r === void 0 && (r = []);
  var e = {};
  return r.forEach(function(t) {
    e[t.name.value] = t;
  }), e;
}
function wg(r, e) {
  switch (r.kind) {
    case "InlineFragment":
      return r;
    case "FragmentSpread": {
      var t = r.name.value;
      if (typeof e == "function")
        return e(t);
      var n = e && e[t];
      return Mr(n, 114, t), n || null;
    }
    default:
      return null;
  }
}
function QD() {
}
class Kv {
  constructor(e = 1 / 0, t = QD) {
    this.max = e, this.dispose = t, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
  }
  has(e) {
    return this.map.has(e);
  }
  get(e) {
    const t = this.getNode(e);
    return t && t.value;
  }
  get size() {
    return this.map.size;
  }
  getNode(e) {
    const t = this.map.get(e);
    if (t && t !== this.newest) {
      const { older: n, newer: i } = t;
      i && (i.older = n), n && (n.newer = i), t.older = this.newest, t.older.newer = t, t.newer = null, this.newest = t, t === this.oldest && (this.oldest = i);
    }
    return t;
  }
  set(e, t) {
    let n = this.getNode(e);
    return n ? n.value = t : (n = {
      key: e,
      value: t,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.map.set(e, n), n.value);
  }
  clean() {
    for (; this.oldest && this.map.size > this.max; )
      this.delete(this.oldest.key);
  }
  delete(e) {
    const t = this.map.get(e);
    return t ? (t === this.newest && (this.newest = t.older), t === this.oldest && (this.oldest = t.newer), t.newer && (t.newer.older = t.older), t.older && (t.older.newer = t.newer), this.map.delete(e), this.dispose(t.value, e), !0) : !1;
  }
}
function Zv() {
}
const YD = Zv, XD = typeof WeakRef < "u" ? WeakRef : function(r) {
  return { deref: () => r };
}, JD = typeof WeakMap < "u" ? WeakMap : Map, KD = typeof FinalizationRegistry < "u" ? FinalizationRegistry : function() {
  return {
    register: Zv,
    unregister: Zv
  };
}, ZD = 10024;
class td {
  constructor(e = 1 / 0, t = YD) {
    this.max = e, this.dispose = t, this.map = new JD(), this.newest = null, this.oldest = null, this.unfinalizedNodes = /* @__PURE__ */ new Set(), this.finalizationScheduled = !1, this.size = 0, this.finalize = () => {
      const n = this.unfinalizedNodes.values();
      for (let i = 0; i < ZD; i++) {
        const a = n.next().value;
        if (!a)
          break;
        this.unfinalizedNodes.delete(a);
        const s = a.key;
        delete a.key, a.keyRef = new XD(s), this.registry.register(s, a, a);
      }
      this.unfinalizedNodes.size > 0 ? queueMicrotask(this.finalize) : this.finalizationScheduled = !1;
    }, this.registry = new KD(this.deleteNode.bind(this));
  }
  has(e) {
    return this.map.has(e);
  }
  get(e) {
    const t = this.getNode(e);
    return t && t.value;
  }
  getNode(e) {
    const t = this.map.get(e);
    if (t && t !== this.newest) {
      const { older: n, newer: i } = t;
      i && (i.older = n), n && (n.newer = i), t.older = this.newest, t.older.newer = t, t.newer = null, this.newest = t, t === this.oldest && (this.oldest = i);
    }
    return t;
  }
  set(e, t) {
    let n = this.getNode(e);
    return n ? n.value = t : (n = {
      key: e,
      value: t,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.scheduleFinalization(n), this.map.set(e, n), this.size++, n.value);
  }
  clean() {
    for (; this.oldest && this.size > this.max; )
      this.deleteNode(this.oldest);
  }
  deleteNode(e) {
    e === this.newest && (this.newest = e.older), e === this.oldest && (this.oldest = e.newer), e.newer && (e.newer.older = e.older), e.older && (e.older.newer = e.newer), this.size--;
    const t = e.key || e.keyRef && e.keyRef.deref();
    this.dispose(e.value, t), e.keyRef ? this.registry.unregister(e) : this.unfinalizedNodes.delete(e), t && this.map.delete(t);
  }
  delete(e) {
    const t = this.map.get(e);
    return t ? (this.deleteNode(t), !0) : !1;
  }
  scheduleFinalization(e) {
    this.unfinalizedNodes.add(e), this.finalizationScheduled || (this.finalizationScheduled = !0, queueMicrotask(this.finalize));
  }
}
var Lm = /* @__PURE__ */ new WeakSet();
function x2(r) {
  r.size <= (r.max || -1) || Lm.has(r) || (Lm.add(r), setTimeout(function() {
    r.clean(), Lm.delete(r);
  }, 100));
}
var C2 = function(r, e) {
  var t = new td(r, e);
  return t.set = function(n, i) {
    var a = td.prototype.set.call(this, n, i);
    return x2(this), a;
  }, t;
}, eP = function(r, e) {
  var t = new Kv(r, e);
  return t.set = function(n, i) {
    var a = Kv.prototype.set.call(this, n, i);
    return x2(this), a;
  }, t;
}, tP = /* @__PURE__ */ Symbol.for("apollo.cacheSize"), Rs = me({}, qp[tP]), fo = Object.assign(function(e) {
  return JSON.stringify(e, rP);
}, {
  reset: function() {
    Tf = new eP(
      Rs.canonicalStringify || 1e3
      /* defaultCacheSizes.canonicalStringify */
    );
  }
}), Tf;
fo.reset();
function rP(r, e) {
  if (e && typeof e == "object") {
    var t = Object.getPrototypeOf(e);
    if (t === Object.prototype || t === null) {
      var n = Object.keys(e);
      if (n.every(nP))
        return e;
      var i = JSON.stringify(n), a = Tf.get(i);
      if (!a) {
        n.sort();
        var s = JSON.stringify(n);
        a = Tf.get(s) || n, Tf.set(i, a), Tf.set(s, a);
      }
      var o = Object.create(t);
      return a.forEach(function(l) {
        o[l] = e[l];
      }), o;
    }
  }
  return e;
}
function nP(r, e, t) {
  return e === 0 || t[e - 1] <= r;
}
function Pu(r) {
  return { __ref: String(r) };
}
function Tn(r) {
  return !!(r && typeof r == "object" && typeof r.__ref == "string");
}
function iP(r) {
  return li(r) && r.kind === "Document" && Array.isArray(r.definitions);
}
function aP(r) {
  return r.kind === "StringValue";
}
function sP(r) {
  return r.kind === "BooleanValue";
}
function oP(r) {
  return r.kind === "IntValue";
}
function lP(r) {
  return r.kind === "FloatValue";
}
function uP(r) {
  return r.kind === "Variable";
}
function cP(r) {
  return r.kind === "ObjectValue";
}
function fP(r) {
  return r.kind === "ListValue";
}
function dP(r) {
  return r.kind === "EnumValue";
}
function hP(r) {
  return r.kind === "NullValue";
}
function Lu(r, e, t, n) {
  if (oP(t) || lP(t))
    r[e.value] = Number(t.value);
  else if (sP(t) || aP(t))
    r[e.value] = t.value;
  else if (cP(t)) {
    var i = {};
    t.fields.map(function(s) {
      return Lu(i, s.name, s.value, n);
    }), r[e.value] = i;
  } else if (uP(t)) {
    var a = (n || {})[t.name.value];
    r[e.value] = a;
  } else if (fP(t))
    r[e.value] = t.values.map(function(s) {
      var o = {};
      return Lu(o, e, s, n), o[e.value];
    });
  else if (dP(t))
    r[e.value] = t.value;
  else if (hP(t))
    r[e.value] = null;
  else
    throw Hi(123, e.value, t.kind);
}
function pP(r, e) {
  var t = null;
  r.directives && (t = {}, r.directives.forEach(function(i) {
    t[i.name.value] = {}, i.arguments && i.arguments.forEach(function(a) {
      var s = a.name, o = a.value;
      return Lu(t[i.name.value], s, o, e);
    });
  }));
  var n = null;
  return r.arguments && r.arguments.length && (n = {}, r.arguments.forEach(function(i) {
    var a = i.name, s = i.value;
    return Lu(n, a, s, e);
  })), S2(r.name.value, n, t);
}
var gP = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export",
  "nonreactive"
], Yc = fo, S2 = Object.assign(function(r, e, t) {
  if (e && t && t.connection && t.connection.key)
    if (t.connection.filter && t.connection.filter.length > 0) {
      var n = t.connection.filter ? t.connection.filter : [];
      n.sort();
      var i = {};
      return n.forEach(function(o) {
        i[o] = e[o];
      }), "".concat(t.connection.key, "(").concat(Yc(i), ")");
    } else
      return t.connection.key;
  var a = r;
  if (e) {
    var s = Yc(e);
    a += "(".concat(s, ")");
  }
  return t && Object.keys(t).forEach(function(o) {
    gP.indexOf(o) === -1 && (t[o] && Object.keys(t[o]).length ? a += "@".concat(o, "(").concat(Yc(t[o]), ")") : a += "@".concat(o));
  }), a;
}, {
  setStringify: function(r) {
    var e = Yc;
    return Yc = r, e;
  }
});
function xg(r, e) {
  if (r.arguments && r.arguments.length) {
    var t = {};
    return r.arguments.forEach(function(n) {
      var i = n.name, a = n.value;
      return Lu(t, i, a, e);
    }), t;
  }
  return null;
}
function mo(r) {
  return r.alias ? r.alias.value : r.name.value;
}
function ey(r, e, t) {
  for (var n, i = 0, a = e.selections; i < a.length; i++) {
    var s = a[i];
    if (vo(s)) {
      if (s.name.value === "__typename")
        return r[mo(s)];
    } else n ? n.push(s) : n = [s];
  }
  if (typeof r.__typename == "string")
    return r.__typename;
  if (n)
    for (var o = 0, l = n; o < l.length; o++) {
      var s = l[o], u = ey(r, wg(s, t).selectionSet, t);
      if (typeof u == "string")
        return u;
    }
}
function vo(r) {
  return r.kind === "Field";
}
function mP(r) {
  return r.kind === "InlineFragment";
}
function ec(r) {
  Mr(r && r.kind === "Document", 115);
  var e = r.definitions.filter(function(t) {
    return t.kind !== "FragmentDefinition";
  }).map(function(t) {
    if (t.kind !== "OperationDefinition")
      throw Hi(116, t.kind);
    return t;
  });
  return Mr(e.length <= 1, 117, e.length), r;
}
function tc(r) {
  return ec(r), r.definitions.filter(function(e) {
    return e.kind === "OperationDefinition";
  })[0];
}
function Sp(r) {
  return r.definitions.filter(function(e) {
    return e.kind === "OperationDefinition" && !!e.name;
  }).map(function(e) {
    return e.name.value;
  })[0] || null;
}
function rc(r) {
  return r.definitions.filter(function(e) {
    return e.kind === "FragmentDefinition";
  });
}
function vP(r) {
  var e = tc(r);
  return Mr(e && e.operation === "query", 118), e;
}
function yP(r) {
  Mr(r.kind === "Document", 119), Mr(r.definitions.length <= 1, 120);
  var e = r.definitions[0];
  return Mr(e.kind === "FragmentDefinition", 121), e;
}
function xd(r) {
  ec(r);
  for (var e, t = 0, n = r.definitions; t < n.length; t++) {
    var i = n[t];
    if (i.kind === "OperationDefinition") {
      var a = i.operation;
      if (a === "query" || a === "mutation" || a === "subscription")
        return i;
    }
    i.kind === "FragmentDefinition" && !e && (e = i);
  }
  if (e)
    return e;
  throw Hi(122);
}
function pA(r) {
  var e = /* @__PURE__ */ Object.create(null), t = r && r.variableDefinitions;
  return t && t.length && t.forEach(function(n) {
    n.defaultValue && Lu(e, n.variable.name, n.defaultValue);
  }), e;
}
let xi = null;
const Gb = {};
let AP = 1;
const bP = () => class {
  constructor() {
    this.id = [
      "slot",
      AP++,
      Date.now(),
      Math.random().toString(36).slice(2)
    ].join(":");
  }
  hasValue() {
    for (let e = xi; e; e = e.parent)
      if (this.id in e.slots) {
        const t = e.slots[this.id];
        if (t === Gb)
          break;
        return e !== xi && (xi.slots[this.id] = t), !0;
      }
    return xi && (xi.slots[this.id] = Gb), !1;
  }
  getValue() {
    if (this.hasValue())
      return xi.slots[this.id];
  }
  withValue(e, t, n, i) {
    const a = {
      __proto__: null,
      [this.id]: e
    }, s = xi;
    xi = { parent: s, slots: a };
    try {
      return t.apply(i, n);
    } finally {
      xi = s;
    }
  }
  // Capture the current context and wrap a callback function so that it
  // reestablishes the captured context when called.
  static bind(e) {
    const t = xi;
    return function() {
      const n = xi;
      try {
        return xi = t, e.apply(this, arguments);
      } finally {
        xi = n;
      }
    };
  }
  // Immediately run a callback function without any captured context.
  static noContext(e, t, n) {
    if (xi) {
      const i = xi;
      try {
        return xi = null, e.apply(n, t);
      } finally {
        xi = i;
      }
    } else
      return e.apply(n, t);
  }
};
function qb(r) {
  try {
    return r();
  } catch {
  }
}
const Um = "@wry/context:Slot", wP = (
  // Prefer globalThis when available.
  // https://github.com/benjamn/wryware/issues/347
  qb(() => globalThis) || // Fall back to global, which works in Node.js and may be converted by some
  // bundlers to the appropriate identifier (window, self, ...) depending on the
  // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
  qb(() => global) || // Otherwise, use a dummy host that's local to this module. We used to fall
  // back to using the Array constructor as a namespace, but that was flagged in
  // https://github.com/benjamn/wryware/issues/347, and can be avoided.
  /* @__PURE__ */ Object.create(null)
), Wb = wP, nc = Wb[Um] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[Um] || (function(r) {
  try {
    Object.defineProperty(Wb, Um, {
      value: r,
      enumerable: !1,
      writable: !1,
      // When it was possible for globalHost to be the Array constructor (a
      // legacy Slot dedup strategy), it was important for the property to be
      // configurable:true so it could be deleted. That does not seem to be as
      // important when globalHost is the global object, but I don't want to
      // cause similar problems again, and configurable:true seems safest.
      // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
      configurable: !0
    });
  } finally {
    return r;
  }
})(bP()), { bind: rQ, noContext: nQ } = nc, Cg = new nc(), { hasOwnProperty: xP } = Object.prototype, gA = Array.from || function(r) {
  const e = [];
  return r.forEach((t) => e.push(t)), e;
};
function mA(r) {
  const { unsubscribe: e } = r;
  typeof e == "function" && (r.unsubscribe = void 0, e());
}
const rd = [], CP = 100;
function Uu(r, e) {
  if (!r)
    throw new Error(e || "assertion failure");
}
function E2(r, e) {
  const t = r.length;
  return (
    // Unknown values are not equal to each other.
    t > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    t === e.length && // The underlying value or exception must be the same.
    r[t - 1] === e[t - 1]
  );
}
function k2(r) {
  switch (r.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return r[0];
    case 2:
      throw r[1];
  }
}
function T2(r) {
  return r.slice(0);
}
class Sg {
  constructor(e) {
    this.fn = e, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++Sg.count;
  }
  peek() {
    if (this.value.length === 1 && !yo(this))
      return Qb(this), this.value[0];
  }
  // This is the most important method of the Entry API, because it
  // determines whether the cached this.value can be returned immediately,
  // or must be recomputed. The overall performance of the caching system
  // depends on the truth of the following observations: (1) this.dirty is
  // usually false, (2) this.dirtyChildren is usually null/empty, and thus
  // (3) valueGet(this.value) is usually returned without recomputation.
  recompute(e) {
    return Uu(!this.recomputing, "already recomputing"), Qb(this), yo(this) ? SP(this, e) : k2(this.value);
  }
  setDirty() {
    this.dirty || (this.dirty = !0, F2(this), mA(this));
  }
  dispose() {
    this.setDirty(), O2(this), vA(this, (e, t) => {
      e.setDirty(), B2(e, this);
    });
  }
  forget() {
    this.dispose();
  }
  dependOn(e) {
    e.add(this), this.deps || (this.deps = rd.pop() || /* @__PURE__ */ new Set()), this.deps.add(e);
  }
  forgetDeps() {
    this.deps && (gA(this.deps).forEach((e) => e.delete(this)), this.deps.clear(), rd.push(this.deps), this.deps = null);
  }
}
Sg.count = 0;
function Qb(r) {
  const e = Cg.getValue();
  if (e)
    return r.parents.add(e), e.childValues.has(r) || e.childValues.set(r, []), yo(r) ? D2(e, r) : P2(e, r), e;
}
function SP(r, e) {
  return O2(r), Cg.withValue(r, EP, [r, e]), TP(r, e) && kP(r), k2(r.value);
}
function EP(r, e) {
  r.recomputing = !0;
  const { normalizeResult: t } = r;
  let n;
  t && r.value.length === 1 && (n = T2(r.value)), r.value.length = 0;
  try {
    if (r.value[0] = r.fn.apply(null, e), t && n && !E2(n, r.value))
      try {
        r.value[0] = t(r.value[0], n[0]);
      } catch {
      }
  } catch (i) {
    r.value[1] = i;
  }
  r.recomputing = !1;
}
function yo(r) {
  return r.dirty || !!(r.dirtyChildren && r.dirtyChildren.size);
}
function kP(r) {
  r.dirty = !1, !yo(r) && I2(r);
}
function F2(r) {
  vA(r, D2);
}
function I2(r) {
  vA(r, P2);
}
function vA(r, e) {
  const t = r.parents.size;
  if (t) {
    const n = gA(r.parents);
    for (let i = 0; i < t; ++i)
      e(n[i], r);
  }
}
function D2(r, e) {
  Uu(r.childValues.has(e)), Uu(yo(e));
  const t = !yo(r);
  if (!r.dirtyChildren)
    r.dirtyChildren = rd.pop() || /* @__PURE__ */ new Set();
  else if (r.dirtyChildren.has(e))
    return;
  r.dirtyChildren.add(e), t && F2(r);
}
function P2(r, e) {
  Uu(r.childValues.has(e)), Uu(!yo(e));
  const t = r.childValues.get(e);
  t.length === 0 ? r.childValues.set(e, T2(e.value)) : E2(t, e.value) || r.setDirty(), R2(r, e), !yo(r) && I2(r);
}
function R2(r, e) {
  const t = r.dirtyChildren;
  t && (t.delete(e), t.size === 0 && (rd.length < CP && rd.push(t), r.dirtyChildren = null));
}
function O2(r) {
  r.childValues.size > 0 && r.childValues.forEach((e, t) => {
    B2(r, t);
  }), r.forgetDeps(), Uu(r.dirtyChildren === null);
}
function B2(r, e) {
  e.parents.delete(r), r.childValues.delete(e), R2(r, e);
}
function TP(r, e) {
  if (typeof r.subscribe == "function")
    try {
      mA(r), r.unsubscribe = r.subscribe.apply(null, e);
    } catch {
      return r.setDirty(), !1;
    }
  return !0;
}
const FP = {
  setDirty: !0,
  dispose: !0,
  forget: !0
  // Fully remove parent Entry from LRU cache and computation graph
};
function M2(r) {
  const e = /* @__PURE__ */ new Map();
  function t(n) {
    const i = Cg.getValue();
    if (i) {
      let a = e.get(n);
      a || e.set(n, a = /* @__PURE__ */ new Set()), i.dependOn(a);
    }
  }
  return t.dirty = function(i, a) {
    const s = e.get(i);
    if (s) {
      const o = a && xP.call(FP, a) ? a : "setDirty";
      gA(s).forEach((l) => l[o]()), e.delete(i), mA(s);
    }
  }, t;
}
let Yb;
function IP(...r) {
  return (Yb || (Yb = new Os(typeof WeakMap == "function"))).lookupArray(r);
}
const Vm = /* @__PURE__ */ new Set();
function Vu(r, { max: e = Math.pow(2, 16), keyArgs: t, makeCacheKey: n = IP, normalizeResult: i, subscribe: a, cache: s = Kv } = /* @__PURE__ */ Object.create(null)) {
  const o = typeof s == "function" ? new s(e, (f) => f.dispose()) : s, l = function() {
    const f = n.apply(null, t ? t.apply(null, arguments) : arguments);
    if (f === void 0)
      return r.apply(null, arguments);
    let h = o.get(f);
    h || (o.set(f, h = new Sg(r)), h.normalizeResult = i, h.subscribe = a, h.forget = () => o.delete(f));
    const g = h.recompute(Array.prototype.slice.call(arguments));
    return o.set(f, h), Vm.add(o), Cg.hasValue() || (Vm.forEach((v) => v.clean()), Vm.clear()), g;
  };
  Object.defineProperty(l, "size", {
    get: () => o.size,
    configurable: !1,
    enumerable: !1
  }), Object.freeze(l.options = {
    max: e,
    keyArgs: t,
    makeCacheKey: n,
    normalizeResult: i,
    subscribe: a,
    cache: o
  });
  function u(f) {
    const h = f && o.get(f);
    h && h.setDirty();
  }
  l.dirtyKey = u, l.dirty = function() {
    u(n.apply(null, arguments));
  };
  function c(f) {
    const h = f && o.get(f);
    if (h)
      return h.peek();
  }
  l.peekKey = c, l.peek = function() {
    return c(n.apply(null, arguments));
  };
  function d(f) {
    return f ? o.delete(f) : !1;
  }
  return l.forgetKey = d, l.forget = function() {
    return d(n.apply(null, arguments));
  }, l.makeCacheKey = n, l.getKey = t ? function() {
    return n.apply(null, t.apply(null, arguments));
  } : n, Object.freeze(l);
}
function DP(r) {
  return r;
}
var _2 = (
  /** @class */
  (function() {
    function r(e, t) {
      t === void 0 && (t = /* @__PURE__ */ Object.create(null)), this.resultCache = hA ? /* @__PURE__ */ new WeakSet() : /* @__PURE__ */ new Set(), this.transform = e, t.getCacheKey && (this.getCacheKey = t.getCacheKey), this.cached = t.cache !== !1, this.resetCache();
    }
    return r.prototype.getCacheKey = function(e) {
      return [e];
    }, r.identity = function() {
      return new r(DP, { cache: !1 });
    }, r.split = function(e, t, n) {
      return n === void 0 && (n = r.identity()), Object.assign(new r(
        function(i) {
          var a = e(i) ? t : n;
          return a.transformDocument(i);
        },
        // Reasonably assume both `left` and `right` transforms handle their own caching
        { cache: !1 }
      ), { left: t, right: n });
    }, r.prototype.resetCache = function() {
      var e = this;
      if (this.cached) {
        var t = new Os(Cl);
        this.performWork = Vu(r.prototype.performWork.bind(this), {
          makeCacheKey: function(n) {
            var i = e.getCacheKey(n);
            if (i)
              return Mr(Array.isArray(i), 104), t.lookupArray(i);
          },
          max: Rs["documentTransform.cache"],
          cache: td
        });
      }
    }, r.prototype.performWork = function(e) {
      return ec(e), this.transform(e);
    }, r.prototype.transformDocument = function(e) {
      if (this.resultCache.has(e))
        return e;
      var t = this.performWork(e);
      return this.resultCache.add(t), t;
    }, r.prototype.concat = function(e) {
      var t = this;
      return Object.assign(new r(
        function(n) {
          return e.transformDocument(t.transformDocument(n));
        },
        // Reasonably assume both transforms handle their own caching
        { cache: !1 }
      ), {
        left: this,
        right: e
      });
    }, r;
  })()
), zm, hl = Object.assign(function(r) {
  var e = zm.get(r);
  return e || (e = MD(r), zm.set(r, e)), e;
}, {
  reset: function() {
    zm = new C2(
      Rs.print || 2e3
      /* defaultCacheSizes.print */
    );
  }
});
hl.reset();
var ni = Array.isArray;
function as(r) {
  return Array.isArray(r) && r.length > 0;
}
var Xb = {
  kind: et.FIELD,
  name: {
    kind: et.NAME,
    value: "__typename"
  }
};
function N2(r, e) {
  return !r || r.selectionSet.selections.every(function(t) {
    return t.kind === et.FRAGMENT_SPREAD && N2(e[t.name.value], e);
  });
}
function PP(r) {
  return N2(tc(r) || yP(r), Zu(rc(r))) ? null : r;
}
function RP(r) {
  var e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  return r.forEach(function(n) {
    n && (n.name ? e.set(n.name, n) : n.test && t.set(n.test, n));
  }), function(n) {
    var i = e.get(n.name.value);
    return !i && t.size && t.forEach(function(a, s) {
      s(n) && (i = a);
    }), i;
  };
}
function Jb(r) {
  var e = /* @__PURE__ */ new Map();
  return function(n) {
    n === void 0 && (n = r);
    var i = e.get(n);
    return i || e.set(n, i = {
      // Variable and fragment spread names used directly within this
      // operation or fragment definition, as identified by key. These sets
      // will be populated during the first traversal of the document in
      // removeDirectivesFromDocument below.
      variables: /* @__PURE__ */ new Set(),
      fragmentSpreads: /* @__PURE__ */ new Set()
    }), i;
  };
}
function L2(r, e) {
  ec(e);
  for (var t = Jb(""), n = Jb(""), i = function(A) {
    for (var x = 0, k = void 0; x < A.length && (k = A[x]); ++x)
      if (!ni(k)) {
        if (k.kind === et.OPERATION_DEFINITION)
          return t(k.name && k.name.value);
        if (k.kind === et.FRAGMENT_DEFINITION)
          return n(k.name.value);
      }
    return null;
  }, a = 0, s = e.definitions.length - 1; s >= 0; --s)
    e.definitions[s].kind === et.OPERATION_DEFINITION && ++a;
  var o = RP(r), l = function(A) {
    return as(A) && A.map(o).some(function(x) {
      return x && x.remove;
    });
  }, u = /* @__PURE__ */ new Map(), c = !1, d = {
    enter: function(A) {
      if (l(A.directives))
        return c = !0, null;
    }
  }, f = Fa(e, {
    // These two AST node types share the same implementation, defined above.
    Field: d,
    InlineFragment: d,
    VariableDefinition: {
      enter: function() {
        return !1;
      }
    },
    Variable: {
      enter: function(A, x, k, F, S) {
        var R = i(S);
        R && R.variables.add(A.name.value);
      }
    },
    FragmentSpread: {
      enter: function(A, x, k, F, S) {
        if (l(A.directives))
          return c = !0, null;
        var R = i(S);
        R && R.fragmentSpreads.add(A.name.value);
      }
    },
    FragmentDefinition: {
      enter: function(A, x, k, F) {
        u.set(JSON.stringify(F), A);
      },
      leave: function(A, x, k, F) {
        var S = u.get(JSON.stringify(F));
        if (A === S)
          return A;
        if (
          // This logic applies only if the document contains one or more
          // operations, since removing all fragments from a document containing
          // only fragments makes the document useless.
          a > 0 && A.selectionSet.selections.every(function(R) {
            return R.kind === et.FIELD && R.name.value === "__typename";
          })
        )
          return n(A.name.value).removed = !0, c = !0, null;
      }
    },
    Directive: {
      leave: function(A) {
        if (o(A))
          return c = !0, null;
      }
    }
  });
  if (!c)
    return e;
  var h = function(A) {
    return A.transitiveVars || (A.transitiveVars = new Set(A.variables), A.removed || A.fragmentSpreads.forEach(function(x) {
      h(n(x)).transitiveVars.forEach(function(k) {
        A.transitiveVars.add(k);
      });
    })), A;
  }, g = /* @__PURE__ */ new Set();
  f.definitions.forEach(function(A) {
    A.kind === et.OPERATION_DEFINITION ? h(t(A.name && A.name.value)).fragmentSpreads.forEach(function(x) {
      g.add(x);
    }) : A.kind === et.FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
    // definitions count as usages of their own fragment names. This heuristic
    // prevents accidentally removing all fragment definitions from the
    // document just because it contains no operations that use the fragments.
    a === 0 && !n(A.name.value).removed && g.add(A.name.value);
  }), g.forEach(function(A) {
    h(n(A)).fragmentSpreads.forEach(function(x) {
      g.add(x);
    });
  });
  var v = function(A) {
    return !!// A fragment definition will be removed if there are no spreads that refer
    // to it, or the fragment was explicitly removed because it had no fields
    // other than __typename.
    (!g.has(A) || n(A).removed);
  }, y = {
    enter: function(A) {
      if (v(A.name.value))
        return null;
    }
  };
  return PP(Fa(f, {
    // If the fragment is going to be removed, then leaving any dangling
    // FragmentSpread nodes with the same name would be a mistake.
    FragmentSpread: y,
    // This is where the fragment definition is actually removed.
    FragmentDefinition: y,
    OperationDefinition: {
      leave: function(A) {
        if (A.variableDefinitions) {
          var x = h(
            // If an operation is anonymous, we use the empty string as its key.
            t(A.name && A.name.value)
          ).transitiveVars;
          if (x.size < A.variableDefinitions.length)
            return me(me({}, A), { variableDefinitions: A.variableDefinitions.filter(function(k) {
              return x.has(k.variable.name.value);
            }) });
        }
      }
    }
  }));
}
var U2 = Object.assign(function(r) {
  return Fa(r, {
    SelectionSet: {
      enter: function(e, t, n) {
        if (!(n && n.kind === et.OPERATION_DEFINITION)) {
          var i = e.selections;
          if (i) {
            var a = i.some(function(o) {
              return vo(o) && (o.name.value === "__typename" || o.name.value.lastIndexOf("__", 0) === 0);
            });
            if (!a) {
              var s = n;
              if (!(vo(s) && s.directives && s.directives.some(function(o) {
                return o.name.value === "export";
              })))
                return me(me({}, e), { selections: ta(ta([], i, !0), [Xb], !1) });
            }
          }
        }
      }
    }
  });
}, {
  added: function(r) {
    return r === Xb;
  }
});
function OP(r) {
  var e = xd(r), t = e.operation;
  if (t === "query")
    return r;
  var n = Fa(r, {
    OperationDefinition: {
      enter: function(i) {
        return me(me({}, i), { operation: "query" });
      }
    }
  });
  return n;
}
function V2(r) {
  ec(r);
  var e = L2([
    {
      test: function(t) {
        return t.name.value === "client";
      },
      remove: !0
    }
  ], r);
  return e;
}
function BP(r) {
  return ec(r), Fa(r, {
    FragmentSpread: function(e) {
      var t;
      if (!(!((t = e.directives) === null || t === void 0) && t.some(function(n) {
        return n.name.value === "unmask";
      })))
        return me(me({}, e), { directives: ta(ta([], e.directives || [], !0), [
          {
            kind: et.DIRECTIVE,
            name: { kind: et.NAME, value: "nonreactive" }
          }
        ], !1) });
    }
  });
}
var MP = Object.prototype.hasOwnProperty;
function Kb() {
  for (var r = [], e = 0; e < arguments.length; e++)
    r[e] = arguments[e];
  return Eg(r);
}
function Eg(r) {
  var e = r[0] || {}, t = r.length;
  if (t > 1)
    for (var n = new Ao(), i = 1; i < t; ++i)
      e = n.merge(e, r[i]);
  return e;
}
var _P = function(r, e, t) {
  return this.merge(r[t], e[t]);
}, Ao = (
  /** @class */
  (function() {
    function r(e) {
      e === void 0 && (e = _P), this.reconciler = e, this.isObject = li, this.pastCopies = /* @__PURE__ */ new Set();
    }
    return r.prototype.merge = function(e, t) {
      for (var n = this, i = [], a = 2; a < arguments.length; a++)
        i[a - 2] = arguments[a];
      return li(t) && li(e) ? (Object.keys(t).forEach(function(s) {
        if (MP.call(e, s)) {
          var o = e[s];
          if (t[s] !== o) {
            var l = n.reconciler.apply(n, ta([
              e,
              t,
              s
            ], i, !1));
            l !== o && (e = n.shallowCopyForMerge(e), e[s] = l);
          }
        } else
          e = n.shallowCopyForMerge(e), e[s] = t[s];
      }), e) : t;
    }, r.prototype.shallowCopyForMerge = function(e) {
      return li(e) && (this.pastCopies.has(e) || (Array.isArray(e) ? e = e.slice(0) : e = me({ __proto__: Object.getPrototypeOf(e) }, e), this.pastCopies.add(e))), e;
    }, r;
  })()
);
function NP(r, e) {
  var t = typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (t) return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = LP(r)) || e) {
    t && (r = t);
    var n = 0;
    return function() {
      return n >= r.length ? { done: !0 } : { done: !1, value: r[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function LP(r, e) {
  if (r) {
    if (typeof r == "string") return Zb(r, e);
    var t = Object.prototype.toString.call(r).slice(8, -1);
    if (t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set") return Array.from(r);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Zb(r, e);
  }
}
function Zb(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, n = new Array(e); t < e; t++)
    n[t] = r[t];
  return n;
}
function ew(r, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, n.key, n);
  }
}
function yA(r, e, t) {
  return e && ew(r.prototype, e), t && ew(r, t), Object.defineProperty(r, "prototype", { writable: !1 }), r;
}
var AA = function() {
  return typeof Symbol == "function";
}, bA = function(r) {
  return AA() && !!Symbol[r];
}, wA = function(r) {
  return bA(r) ? Symbol[r] : "@@" + r;
};
AA() && !bA("observable") && (Symbol.observable = /* @__PURE__ */ Symbol("observable"));
var UP = wA("iterator"), ty = wA("observable"), z2 = wA("species");
function Wp(r, e) {
  var t = r[e];
  if (t != null) {
    if (typeof t != "function") throw new TypeError(t + " is not a function");
    return t;
  }
}
function Xc(r) {
  var e = r.constructor;
  return e !== void 0 && (e = e[z2], e === null && (e = void 0)), e !== void 0 ? e : nn;
}
function VP(r) {
  return r instanceof nn;
}
function zu(r) {
  zu.log ? zu.log(r) : setTimeout(function() {
    throw r;
  });
}
function Ep(r) {
  Promise.resolve().then(function() {
    try {
      r();
    } catch (e) {
      zu(e);
    }
  });
}
function $2(r) {
  var e = r._cleanup;
  if (e !== void 0 && (r._cleanup = void 0, !!e))
    try {
      if (typeof e == "function")
        e();
      else {
        var t = Wp(e, "unsubscribe");
        t && t.call(e);
      }
    } catch (n) {
      zu(n);
    }
}
function ry(r) {
  r._observer = void 0, r._queue = void 0, r._state = "closed";
}
function zP(r) {
  var e = r._queue;
  if (e) {
    r._queue = void 0, r._state = "ready";
    for (var t = 0; t < e.length && (H2(r, e[t].type, e[t].value), r._state !== "closed"); ++t)
      ;
  }
}
function H2(r, e, t) {
  r._state = "running";
  var n = r._observer;
  try {
    var i = Wp(n, e);
    switch (e) {
      case "next":
        i && i.call(n, t);
        break;
      case "error":
        if (ry(r), i) i.call(n, t);
        else throw t;
        break;
      case "complete":
        ry(r), i && i.call(n);
        break;
    }
  } catch (a) {
    zu(a);
  }
  r._state === "closed" ? $2(r) : r._state === "running" && (r._state = "ready");
}
function $m(r, e, t) {
  if (r._state !== "closed") {
    if (r._state === "buffering") {
      r._queue.push({
        type: e,
        value: t
      });
      return;
    }
    if (r._state !== "ready") {
      r._state = "buffering", r._queue = [{
        type: e,
        value: t
      }], Ep(function() {
        return zP(r);
      });
      return;
    }
    H2(r, e, t);
  }
}
var $P = /* @__PURE__ */ (function() {
  function r(t, n) {
    this._cleanup = void 0, this._observer = t, this._queue = void 0, this._state = "initializing";
    var i = new HP(this);
    try {
      this._cleanup = n.call(void 0, i);
    } catch (a) {
      i.error(a);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var e = r.prototype;
  return e.unsubscribe = function() {
    this._state !== "closed" && (ry(this), $2(this));
  }, yA(r, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), r;
})(), HP = /* @__PURE__ */ (function() {
  function r(t) {
    this._subscription = t;
  }
  var e = r.prototype;
  return e.next = function(n) {
    $m(this._subscription, "next", n);
  }, e.error = function(n) {
    $m(this._subscription, "error", n);
  }, e.complete = function() {
    $m(this._subscription, "complete");
  }, yA(r, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), r;
})(), nn = /* @__PURE__ */ (function() {
  function r(t) {
    if (!(this instanceof r)) throw new TypeError("Observable cannot be called as a function");
    if (typeof t != "function") throw new TypeError("Observable initializer must be a function");
    this._subscriber = t;
  }
  var e = r.prototype;
  return e.subscribe = function(n) {
    return (typeof n != "object" || n === null) && (n = {
      next: n,
      error: arguments[1],
      complete: arguments[2]
    }), new $P(n, this._subscriber);
  }, e.forEach = function(n) {
    var i = this;
    return new Promise(function(a, s) {
      if (typeof n != "function") {
        s(new TypeError(n + " is not a function"));
        return;
      }
      function o() {
        l.unsubscribe(), a();
      }
      var l = i.subscribe({
        next: function(u) {
          try {
            n(u, o);
          } catch (c) {
            s(c), l.unsubscribe();
          }
        },
        error: s,
        complete: a
      });
    });
  }, e.map = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var a = Xc(this);
    return new a(function(s) {
      return i.subscribe({
        next: function(o) {
          try {
            o = n(o);
          } catch (l) {
            return s.error(l);
          }
          s.next(o);
        },
        error: function(o) {
          s.error(o);
        },
        complete: function() {
          s.complete();
        }
      });
    });
  }, e.filter = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var a = Xc(this);
    return new a(function(s) {
      return i.subscribe({
        next: function(o) {
          try {
            if (!n(o)) return;
          } catch (l) {
            return s.error(l);
          }
          s.next(o);
        },
        error: function(o) {
          s.error(o);
        },
        complete: function() {
          s.complete();
        }
      });
    });
  }, e.reduce = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var a = Xc(this), s = arguments.length > 1, o = !1, l = arguments[1], u = l;
    return new a(function(c) {
      return i.subscribe({
        next: function(d) {
          var f = !o;
          if (o = !0, !f || s)
            try {
              u = n(u, d);
            } catch (h) {
              return c.error(h);
            }
          else
            u = d;
        },
        error: function(d) {
          c.error(d);
        },
        complete: function() {
          if (!o && !s) return c.error(new TypeError("Cannot reduce an empty sequence"));
          c.next(u), c.complete();
        }
      });
    });
  }, e.concat = function() {
    for (var n = this, i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    var o = Xc(this);
    return new o(function(l) {
      var u, c = 0;
      function d(f) {
        u = f.subscribe({
          next: function(h) {
            l.next(h);
          },
          error: function(h) {
            l.error(h);
          },
          complete: function() {
            c === a.length ? (u = void 0, l.complete()) : d(o.from(a[c++]));
          }
        });
      }
      return d(n), function() {
        u && (u.unsubscribe(), u = void 0);
      };
    });
  }, e.flatMap = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var a = Xc(this);
    return new a(function(s) {
      var o = [], l = i.subscribe({
        next: function(c) {
          if (n)
            try {
              c = n(c);
            } catch (f) {
              return s.error(f);
            }
          var d = a.from(c).subscribe({
            next: function(f) {
              s.next(f);
            },
            error: function(f) {
              s.error(f);
            },
            complete: function() {
              var f = o.indexOf(d);
              f >= 0 && o.splice(f, 1), u();
            }
          });
          o.push(d);
        },
        error: function(c) {
          s.error(c);
        },
        complete: function() {
          u();
        }
      });
      function u() {
        l.closed && o.length === 0 && s.complete();
      }
      return function() {
        o.forEach(function(c) {
          return c.unsubscribe();
        }), l.unsubscribe();
      };
    });
  }, e[ty] = function() {
    return this;
  }, r.from = function(n) {
    var i = typeof this == "function" ? this : r;
    if (n == null) throw new TypeError(n + " is not an object");
    var a = Wp(n, ty);
    if (a) {
      var s = a.call(n);
      if (Object(s) !== s) throw new TypeError(s + " is not an object");
      return VP(s) && s.constructor === i ? s : new i(function(o) {
        return s.subscribe(o);
      });
    }
    if (bA("iterator") && (a = Wp(n, UP), a))
      return new i(function(o) {
        Ep(function() {
          if (!o.closed) {
            for (var l = NP(a.call(n)), u; !(u = l()).done; ) {
              var c = u.value;
              if (o.next(c), o.closed) return;
            }
            o.complete();
          }
        });
      });
    if (Array.isArray(n))
      return new i(function(o) {
        Ep(function() {
          if (!o.closed) {
            for (var l = 0; l < n.length; ++l)
              if (o.next(n[l]), o.closed) return;
            o.complete();
          }
        });
      });
    throw new TypeError(n + " is not observable");
  }, r.of = function() {
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    var s = typeof this == "function" ? this : r;
    return new s(function(o) {
      Ep(function() {
        if (!o.closed) {
          for (var l = 0; l < i.length; ++l)
            if (o.next(i[l]), o.closed) return;
          o.complete();
        }
      });
    });
  }, yA(r, null, [{
    key: z2,
    get: function() {
      return this;
    }
  }]), r;
})();
AA() && Object.defineProperty(nn, /* @__PURE__ */ Symbol("extensions"), {
  value: {
    symbol: ty,
    hostReportError: zu
  },
  configurable: !0
});
function jP(r) {
  var e, t = r.Symbol;
  if (typeof t == "function")
    if (t.observable)
      e = t.observable;
    else {
      typeof t.for == "function" ? e = t.for("https://github.com/benlesh/symbol-observable") : e = t("https://github.com/benlesh/symbol-observable");
      try {
        t.observable = e;
      } catch {
      }
    }
  else
    e = "@@observable";
  return e;
}
var wu;
typeof self < "u" ? wu = self : typeof window < "u" ? wu = window : typeof global < "u" ? wu = global : typeof module < "u" ? wu = module : wu = Function("return this")();
jP(wu);
var tw = nn.prototype, rw = "@@observable";
tw[rw] || (tw[rw] = function() {
  return this;
});
function GP(r) {
  return r.catch(function() {
  }), r;
}
var qP = Object.prototype.toString;
function WP(r) {
  return ny(r);
}
function ny(r, e) {
  switch (qP.call(r)) {
    case "[object Array]": {
      if (e = e || /* @__PURE__ */ new Map(), e.has(r))
        return e.get(r);
      var t = r.slice(0);
      return e.set(r, t), t.forEach(function(i, a) {
        t[a] = ny(i, e);
      }), t;
    }
    case "[object Object]": {
      if (e = e || /* @__PURE__ */ new Map(), e.has(r))
        return e.get(r);
      var n = Object.create(Object.getPrototypeOf(r));
      return e.set(r, n), Object.keys(r).forEach(function(i) {
        n[i] = ny(r[i], e);
      }), n;
    }
    default:
      return r;
  }
}
function Uf(r, e, t) {
  var n = [];
  r.forEach(function(i) {
    return i[e] && n.push(i);
  }), n.forEach(function(i) {
    return i[e](t);
  });
}
function Hm(r, e, t) {
  return new nn(function(n) {
    var i = {
      // Normally we would initialize promiseQueue to Promise.resolve(), but
      // in this case, for backwards compatibility, we need to be careful to
      // invoke the first callback synchronously.
      then: function(l) {
        return new Promise(function(u) {
          return u(l());
        });
      }
    };
    function a(l, u) {
      return function(c) {
        if (l) {
          var d = function() {
            return n.closed ? (
              /* will be swallowed */
              0
            ) : l(c);
          };
          i = i.then(d, d).then(function(f) {
            return n.next(f);
          }, function(f) {
            return n.error(f);
          });
        } else
          n[u](c);
      };
    }
    var s = {
      next: a(e, "next"),
      error: a(t, "error"),
      complete: function() {
        i.then(function() {
          return n.complete();
        });
      }
    }, o = r.subscribe(s);
    return function() {
      return o.unsubscribe();
    };
  });
}
function j2(r) {
  function e(t) {
    Object.defineProperty(r, t, { value: nn });
  }
  return b2 && Symbol.species && e(Symbol.species), e("@@species"), r;
}
function nw(r) {
  return r && typeof r.then == "function";
}
var xu = (
  /** @class */
  (function(r) {
    pa(e, r);
    function e(t) {
      var n = r.call(this, function(i) {
        return n.addObserver(i), function() {
          return n.removeObserver(i);
        };
      }) || this;
      return n.observers = /* @__PURE__ */ new Set(), n.promise = new Promise(function(i, a) {
        n.resolve = i, n.reject = a;
      }), n.handlers = {
        next: function(i) {
          n.sub !== null && (n.latest = ["next", i], n.notify("next", i), Uf(n.observers, "next", i));
        },
        error: function(i) {
          var a = n.sub;
          a !== null && (a && setTimeout(function() {
            return a.unsubscribe();
          }), n.sub = null, n.latest = ["error", i], n.reject(i), n.notify("error", i), Uf(n.observers, "error", i));
        },
        complete: function() {
          var i = n, a = i.sub, s = i.sources, o = s === void 0 ? [] : s;
          if (a !== null) {
            var l = o.shift();
            l ? nw(l) ? l.then(function(u) {
              return n.sub = u.subscribe(n.handlers);
            }, n.handlers.error) : n.sub = l.subscribe(n.handlers) : (a && setTimeout(function() {
              return a.unsubscribe();
            }), n.sub = null, n.latest && n.latest[0] === "next" ? n.resolve(n.latest[1]) : n.resolve(), n.notify("complete"), Uf(n.observers, "complete"));
          }
        }
      }, n.nextResultListeners = /* @__PURE__ */ new Set(), n.cancel = function(i) {
        n.reject(i), n.sources = [], n.handlers.error(i);
      }, n.promise.catch(function(i) {
      }), typeof t == "function" && (t = [new nn(t)]), nw(t) ? t.then(function(i) {
        return n.start(i);
      }, n.handlers.error) : n.start(t), n;
    }
    return e.prototype.start = function(t) {
      this.sub === void 0 && (this.sources = Array.from(t), this.handlers.complete());
    }, e.prototype.deliverLastMessage = function(t) {
      if (this.latest) {
        var n = this.latest[0], i = t[n];
        i && i.call(t, this.latest[1]), this.sub === null && n === "next" && t.complete && t.complete();
      }
    }, e.prototype.addObserver = function(t) {
      this.observers.has(t) || (this.deliverLastMessage(t), this.observers.add(t));
    }, e.prototype.removeObserver = function(t) {
      this.observers.delete(t) && this.observers.size < 1 && this.handlers.complete();
    }, e.prototype.notify = function(t, n) {
      var i = this.nextResultListeners;
      i.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), i.forEach(function(a) {
        return a(t, n);
      }));
    }, e.prototype.beforeNext = function(t) {
      var n = !1;
      this.nextResultListeners.add(function(i, a) {
        n || (n = !0, t(i, a));
      });
    }, e;
  })(nn)
);
j2(xu);
function Ru(r) {
  return "incremental" in r;
}
function QP(r) {
  return "hasNext" in r && "data" in r;
}
function YP(r) {
  return Ru(r) || QP(r);
}
function XP(r) {
  return li(r) && "payload" in r;
}
function G2(r, e) {
  var t = r, n = new Ao();
  return Ru(e) && as(e.incremental) && e.incremental.forEach(function(i) {
    for (var a = i.data, s = i.path, o = s.length - 1; o >= 0; --o) {
      var l = s[o], u = !isNaN(+l), c = u ? [] : {};
      c[l] = a, a = c;
    }
    t = n.merge(t, a);
  }), t;
}
function kp(r) {
  var e = iy(r);
  return as(e);
}
function iy(r) {
  var e = as(r.errors) ? r.errors.slice(0) : [];
  return Ru(r) && as(r.incremental) && r.incremental.forEach(function(t) {
    t.errors && e.push.apply(e, t.errors);
  }), e;
}
function $u() {
  for (var r = [], e = 0; e < arguments.length; e++)
    r[e] = arguments[e];
  var t = /* @__PURE__ */ Object.create(null);
  return r.forEach(function(n) {
    n && Object.keys(n).forEach(function(i) {
      var a = n[i];
      a !== void 0 && (t[i] = a);
    });
  }), t;
}
function jm(r, e) {
  return $u(r, e, e.variables && {
    variables: $u(me(me({}, r && r.variables), e.variables))
  });
}
function JP(r, e) {
  return ay(r, e);
}
function ay(r, e, t) {
  if (t === void 0 && (t = /* @__PURE__ */ new Map()), t.has(r))
    return t.get(r);
  var n = !1;
  if (Array.isArray(r)) {
    var i = [];
    if (t.set(r, i), r.forEach(function(s, o) {
      var l = ay(s, e, t);
      n || (n = l !== s), i[o] = l;
    }), n)
      return i;
  } else if (w2(r)) {
    var a = Object.create(Object.getPrototypeOf(r));
    if (t.set(r, a), Object.keys(r).forEach(function(s) {
      if (s === e) {
        n = !0;
        return;
      }
      var o = ay(r[s], e, t);
      n || (n = o !== r[s]), a[s] = o;
    }), n)
      return a;
  }
  return r;
}
function xA(r) {
  return JP(r, "__typename");
}
var Gm, iw = /* @__PURE__ */ Symbol.for("apollo.deprecations.slot"), aw = qp, sw = (Gm = aw[iw]) !== null && Gm !== void 0 ? Gm : aw[iw] = new nc();
function Di(r) {
  for (var e = [], t = 1; t < arguments.length; t++)
    e[t - 1] = arguments[t];
  return sw.withValue.apply(sw, ta([Array.isArray(r) ? r : [r]], e, !1));
}
function qm(r) {
  return new nn(function(e) {
    e.error(r);
  });
}
var q2 = function(r, e, t) {
  var n = new Error(t);
  throw n.name = "ServerError", n.response = r, n.statusCode = r.status, n.result = e, n;
};
function KP(r) {
  for (var e = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], t = 0, n = Object.keys(r); t < n.length; t++) {
    var i = n[t];
    if (e.indexOf(i) < 0)
      throw Hi(58, i);
  }
  return r;
}
function ZP(r, e) {
  var t = me({}, r), n = function(a) {
    typeof a == "function" ? t = me(me({}, t), a(t)) : t = me(me({}, t), a);
  }, i = function() {
    return me({}, t);
  };
  return Object.defineProperty(e, "setContext", {
    enumerable: !1,
    value: n
  }), Object.defineProperty(e, "getContext", {
    enumerable: !1,
    value: i
  }), e;
}
function eR(r) {
  var e = {
    variables: r.variables || {},
    extensions: r.extensions || {},
    operationName: r.operationName,
    query: r.query
  };
  return e.operationName || (e.operationName = typeof e.query != "string" ? Sp(e.query) || void 0 : ""), e;
}
function tR(r, e) {
  var t = me({}, r), n = new Set(Object.keys(r));
  return Fa(e, {
    Variable: function(i, a, s) {
      s && s.kind !== "VariableDefinition" && n.delete(i.name.value);
    }
  }), n.forEach(function(i) {
    delete t[i];
  }), t;
}
function ow(r, e) {
  return e ? e(r) : nn.of();
}
function Jc(r) {
  return typeof r == "function" ? new Oa(r) : r;
}
function kh(r) {
  return r.request.length <= 1;
}
var Oa = (
  /** @class */
  (function() {
    function r(e) {
      e && (this.request = e);
    }
    return r.empty = function() {
      return new r(function() {
        return nn.of();
      });
    }, r.from = function(e) {
      return e.length === 0 ? r.empty() : e.map(Jc).reduce(function(t, n) {
        return t.concat(n);
      });
    }, r.split = function(e, t, n) {
      var i = Jc(t), a = Jc(n || new r(ow)), s;
      return kh(i) && kh(a) ? s = new r(function(o) {
        return e(o) ? i.request(o) || nn.of() : a.request(o) || nn.of();
      }) : s = new r(function(o, l) {
        return e(o) ? i.request(o, l) || nn.of() : a.request(o, l) || nn.of();
      }), Object.assign(s, { left: i, right: a });
    }, r.execute = function(e, t) {
      return e.request(ZP(t.context, eR(KP(t)))) || nn.of();
    }, r.concat = function(e, t) {
      var n = Jc(e);
      if (kh(n))
        return n;
      var i = Jc(t), a;
      return kh(i) ? a = new r(function(s) {
        return n.request(s, function(o) {
          return i.request(o) || nn.of();
        }) || nn.of();
      }) : a = new r(function(s, o) {
        return n.request(s, function(l) {
          return i.request(l, o) || nn.of();
        }) || nn.of();
      }), Object.assign(a, { left: n, right: i });
    }, r.prototype.split = function(e, t, n) {
      return this.concat(r.split(e, t, n || new r(ow)));
    }, r.prototype.concat = function(e) {
      return r.concat(this, e);
    }, r.prototype.request = function(e, t) {
      throw Hi(48);
    }, r.prototype.onError = function(e, t) {
      if (t && t.error)
        return t.error(e), !1;
      throw e;
    }, r.prototype.setOnError = function(e) {
      return this.onError = e, this;
    }, r;
  })()
), rR = Oa.from, sy = Oa.execute;
function nR(r) {
  var e, t = r[Symbol.asyncIterator]();
  return e = {
    next: function() {
      return t.next();
    }
  }, e[Symbol.asyncIterator] = function() {
    return this;
  }, e;
}
function iR(r) {
  var e = null, t = null, n = !1, i = [], a = [];
  function s(d) {
    if (!t) {
      if (a.length) {
        var f = a.shift();
        if (Array.isArray(f) && f[0])
          return f[0]({ value: d, done: !1 });
      }
      i.push(d);
    }
  }
  function o(d) {
    t = d;
    var f = a.slice();
    f.forEach(function(h) {
      h[1](d);
    }), !e || e();
  }
  function l() {
    n = !0;
    var d = a.slice();
    d.forEach(function(f) {
      f[0]({ value: void 0, done: !0 });
    }), !e || e();
  }
  e = function() {
    e = null, r.removeListener("data", s), r.removeListener("error", o), r.removeListener("end", l), r.removeListener("finish", l), r.removeListener("close", l);
  }, r.on("data", s), r.on("error", o), r.on("end", l), r.on("finish", l), r.on("close", l);
  function u() {
    return new Promise(function(d, f) {
      if (t)
        return f(t);
      if (i.length)
        return d({ value: i.shift(), done: !1 });
      if (n)
        return d({ value: void 0, done: !0 });
      a.push([d, f]);
    });
  }
  var c = {
    next: function() {
      return u();
    }
  };
  return bg && (c[Symbol.asyncIterator] = function() {
    return this;
  }), c;
}
function aR(r) {
  var e = !1, t = {
    next: function() {
      return e ? Promise.resolve({
        value: void 0,
        done: !0
      }) : (e = !0, new Promise(function(n, i) {
        r.then(function(a) {
          n({ value: a, done: !1 });
        }).catch(i);
      }));
    }
  };
  return bg && (t[Symbol.asyncIterator] = function() {
    return this;
  }), t;
}
function lw(r) {
  var e = {
    next: function() {
      return r.read();
    }
  };
  return bg && (e[Symbol.asyncIterator] = function() {
    return this;
  }), e;
}
function sR(r) {
  return !!r.body;
}
function oR(r) {
  return !!r.getReader;
}
function lR(r) {
  return !!(bg && r[Symbol.asyncIterator]);
}
function uR(r) {
  return !!r.stream;
}
function cR(r) {
  return !!r.arrayBuffer;
}
function fR(r) {
  return !!r.pipe;
}
function dR(r) {
  var e = r;
  if (sR(r) && (e = r.body), lR(e))
    return nR(e);
  if (oR(e))
    return lw(e.getReader());
  if (uR(e))
    return lw(e.stream().getReader());
  if (cR(e))
    return aR(e.arrayBuffer());
  if (fR(e))
    return iR(e);
  throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
var Cd = /* @__PURE__ */ Symbol();
function CA(r) {
  return r.extensions ? Array.isArray(r.extensions[Cd]) : !1;
}
function W2(r) {
  return r.hasOwnProperty("graphQLErrors");
}
var hR = function(r) {
  var e = ta(ta(ta([], r.graphQLErrors, !0), r.clientErrors, !0), r.protocolErrors, !0);
  return r.networkError && e.push(r.networkError), e.map(function(t) {
    return li(t) && t.message || "Error message not found.";
  }).join(`
`);
}, ro = (
  /** @class */
  (function(r) {
    pa(e, r);
    function e(t) {
      var n = t.graphQLErrors, i = t.protocolErrors, a = t.clientErrors, s = t.networkError, o = t.errorMessage, l = t.extraInfo, u = r.call(this, o) || this;
      return u.name = "ApolloError", u.graphQLErrors = n || [], u.protocolErrors = i || [], u.clientErrors = a || [], u.networkError = s || null, u.message = o || hR(u), u.extraInfo = l, u.cause = ta(ta(ta([
        s
      ], n || [], !0), i || [], !0), a || [], !0).find(function(c) {
        return !!c;
      }) || null, u.__proto__ = e.prototype, u;
    }
    return e;
  })(Error)
), uw = Object.prototype.hasOwnProperty;
function pR(r, e) {
  return Ka(this, void 0, void 0, function() {
    var t, n, i, a, s, o, l, u, c, d, f, h, g, v, y, A, x, k, F, S, R, M, j, G;
    return Za(this, function(ie) {
      switch (ie.label) {
        case 0:
          if (TextDecoder === void 0)
            throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          t = new TextDecoder("utf-8"), n = (G = r.headers) === null || G === void 0 ? void 0 : G.get("content-type"), i = "boundary=", a = n?.includes(i) ? n?.substring(n?.indexOf(i) + i.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", s = `\r
--`.concat(a), o = "", l = dR(r), u = !0, ie.label = 1;
        case 1:
          return u ? [4, l.next()] : [3, 3];
        case 2:
          for (c = ie.sent(), d = c.value, f = c.done, h = typeof d == "string" ? d : t.decode(d), g = o.length - s.length + 1, u = !f, o += h, v = o.indexOf(s, g); v > -1; ) {
            if (y = void 0, M = [
              o.slice(0, v),
              o.slice(v + s.length)
            ], y = M[0], o = M[1], A = y.indexOf(`\r
\r
`), x = gR(y.slice(0, A)), k = x["content-type"], k && k.toLowerCase().indexOf("application/json") === -1)
              throw new Error("Unsupported patch content type: application/json is required.");
            if (F = y.slice(A), F) {
              if (S = Q2(r, F), Object.keys(S).length > 1 || "data" in S || "incremental" in S || "errors" in S || "payload" in S)
                if (XP(S)) {
                  if (R = {}, "payload" in S) {
                    if (Object.keys(S).length === 1 && S.payload === null)
                      return [
                        2
                        /*return*/
                      ];
                    R = me({}, S.payload);
                  }
                  "errors" in S && (R = me(me({}, R), { extensions: me(me({}, "extensions" in R ? R.extensions : null), (j = {}, j[Cd] = S.errors, j)) })), e(R);
                } else
                  e(S);
              else if (
                // If the chunk contains only a "hasNext: false", we can call
                // observer.complete() immediately.
                Object.keys(S).length === 1 && "hasNext" in S && !S.hasNext
              )
                return [
                  2
                  /*return*/
                ];
            }
            v = o.indexOf(s);
          }
          return [3, 1];
        case 3:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function gR(r) {
  var e = {};
  return r.split(`
`).forEach(function(t) {
    var n = t.indexOf(":");
    if (n > -1) {
      var i = t.slice(0, n).trim().toLowerCase(), a = t.slice(n + 1).trim();
      e[i] = a;
    }
  }), e;
}
function Q2(r, e) {
  if (r.status >= 300) {
    var t = function() {
      try {
        return JSON.parse(e);
      } catch {
        return e;
      }
    };
    q2(r, t(), "Response not successful: Received status code ".concat(r.status));
  }
  try {
    return JSON.parse(e);
  } catch (i) {
    var n = i;
    throw n.name = "ServerParseError", n.response = r, n.statusCode = r.status, n.bodyText = e, n;
  }
}
function mR(r, e) {
  r.result && r.result.errors && r.result.data && e.next(r.result), e.error(r);
}
function vR(r) {
  return function(e) {
    return e.text().then(function(t) {
      return Q2(e, t);
    }).then(function(t) {
      return !Array.isArray(t) && !uw.call(t, "data") && !uw.call(t, "errors") && q2(e, t, "Server response was missing for query '".concat(Array.isArray(r) ? r.map(function(n) {
        return n.operationName;
      }) : r.operationName, "'.")), t;
    });
  };
}
var oy = function(r, e) {
  var t;
  try {
    t = JSON.stringify(r);
  } catch (i) {
    var n = Hi(54, e, i.message);
    throw n.parseError = i, n;
  }
  return t;
}, yR = {
  includeQuery: !0,
  includeExtensions: !1,
  preserveHeaderCase: !1
}, AR = {
  // headers are case insensitive (https://stackoverflow.com/a/5259004)
  accept: "*/*",
  // The content-type header describes the type of the body of the request, and
  // so it typically only is sent with requests that actually have bodies. One
  // could imagine that Apollo Client would remove this header when constructing
  // a GET request (which has no body), but we historically have not done that.
  // This means that browsers will preflight all Apollo Client requests (even
  // GET requests). Apollo Server's CSRF prevention feature (introduced in
  // AS3.7) takes advantage of this fact and does not block requests with this
  // header. If you want to drop this header from GET requests, then you should
  // probably replace it with a `apollo-require-preflight` header, or servers
  // with CSRF prevention enabled might block your GET request. See
  // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
  // for more details.
  "content-type": "application/json"
}, bR = {
  method: "POST"
}, wR = {
  http: yR,
  headers: AR,
  options: bR
}, xR = function(r, e) {
  return e(r);
};
function CR(r, e) {
  for (var t = [], n = 2; n < arguments.length; n++)
    t[n - 2] = arguments[n];
  var i = {}, a = {};
  t.forEach(function(d) {
    i = me(me(me({}, i), d.options), { headers: me(me({}, i.headers), d.headers) }), d.credentials && (i.credentials = d.credentials), a = me(me({}, a), d.http);
  }), i.headers && (i.headers = SR(i.headers, a.preserveHeaderCase));
  var s = r.operationName, o = r.extensions, l = r.variables, u = r.query, c = { operationName: s, variables: l };
  return a.includeExtensions && (c.extensions = o), a.includeQuery && (c.query = e(u, hl)), {
    options: i,
    body: c
  };
}
function SR(r, e) {
  if (!e) {
    var t = {};
    return Object.keys(Object(r)).forEach(function(a) {
      t[a.toLowerCase()] = r[a];
    }), t;
  }
  var n = {};
  Object.keys(Object(r)).forEach(function(a) {
    n[a.toLowerCase()] = {
      originalName: a,
      value: r[a]
    };
  });
  var i = {};
  return Object.keys(n).forEach(function(a) {
    i[n[a].originalName] = n[a].value;
  }), i;
}
var ER = function(r, e) {
  var t = r.getContext(), n = t.uri;
  return n || (typeof e == "function" ? e(r) : e || "/graphql");
};
function kR(r, e) {
  var t = [], n = function(d, f) {
    t.push("".concat(d, "=").concat(encodeURIComponent(f)));
  };
  if ("query" in e && n("query", e.query), e.operationName && n("operationName", e.operationName), e.variables) {
    var i = void 0;
    try {
      i = oy(e.variables, "Variables map");
    } catch (d) {
      return { parseError: d };
    }
    n("variables", i);
  }
  if (e.extensions) {
    var a = void 0;
    try {
      a = oy(e.extensions, "Extensions map");
    } catch (d) {
      return { parseError: d };
    }
    n("extensions", a);
  }
  var s = "", o = r, l = r.indexOf("#");
  l !== -1 && (s = r.substr(l), o = r.substr(0, l));
  var u = o.indexOf("?") === -1 ? "?" : "&", c = o + u + t.join("&") + s;
  return { newURI: c };
}
var TR = Ta(function() {
  return fetch;
}), Y2 = function(r) {
  r === void 0 && (r = {});
  var e = r.uri, t = e === void 0 ? "/graphql" : e, n = r.fetch, i = r.print, a = i === void 0 ? xR : i, s = r.includeExtensions, o = r.preserveHeaderCase, l = r.useGETForQueries, u = r.includeUnusedVariables, c = u === void 0 ? !1 : u, d = ns(r, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]), f = {
    http: { includeExtensions: s, preserveHeaderCase: o },
    options: d.fetchOptions,
    credentials: d.credentials,
    headers: d.headers
  };
  return new Oa(function(h) {
    var g = ER(h, t), v = h.getContext(), y = {};
    if (v.clientAwareness) {
      var A = v.clientAwareness, x = A.name, k = A.version;
      x && (y["apollographql-client-name"] = x), k && (y["apollographql-client-version"] = k);
    }
    var F = me(me({}, y), v.headers), S = {
      http: v.http,
      options: v.fetchOptions,
      credentials: v.credentials,
      headers: F
    };
    if (ed(["client"], h.query)) {
      var R = V2(h.query);
      if (!R)
        return qm(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
      h.query = R;
    }
    var M = CR(h, a, wR, f, S), j = M.options, G = M.body;
    G.variables && !c && (G.variables = tR(G.variables, h.query));
    var ie;
    !j.signal && typeof AbortController < "u" && (ie = new AbortController(), j.signal = ie.signal);
    var q = function(Re) {
      return Re.kind === "OperationDefinition" && Re.operation === "mutation";
    }, Y = function(Re) {
      return Re.kind === "OperationDefinition" && Re.operation === "subscription";
    }, J = Y(xd(h.query)), se = ed(["defer"], h.query);
    if (l && !h.query.definitions.some(q) && (j.method = "GET"), se || J) {
      j.headers = j.headers || {};
      var oe = "multipart/mixed;";
      J ? oe += "boundary=graphql;subscriptionSpec=1.0,application/json" : se && (oe += "deferSpec=20220824,application/json"), j.headers.accept = oe;
    }
    if (j.method === "GET") {
      var he = kR(g, G), ye = he.newURI, Ue = he.parseError;
      if (Ue)
        return qm(Ue);
      g = ye;
    } else
      try {
        j.body = oy(G, "Payload");
      } catch (Re) {
        return qm(Re);
      }
    return new nn(function(Re) {
      var Oe = n || Ta(function() {
        return fetch;
      }) || TR, ee = Re.next.bind(Re);
      return Oe(g, j).then(function(re) {
        var de;
        h.setContext({ response: re });
        var Be = (de = re.headers) === null || de === void 0 ? void 0 : de.get("content-type");
        return Be !== null && /^multipart\/mixed/i.test(Be) ? pR(re, ee) : vR(h)(re).then(ee);
      }).then(function() {
        ie = void 0, Re.complete();
      }).catch(function(re) {
        ie = void 0, mR(re, Re);
      }), function() {
        ie && ie.abort();
      };
    });
  });
}, FR = (
  /** @class */
  (function(r) {
    pa(e, r);
    function e(t) {
      t === void 0 && (t = {});
      var n = r.call(this, Y2(t).request) || this;
      return n.options = t, n;
    }
    return e;
  })(Oa)
);
const { toString: cw, hasOwnProperty: IR } = Object.prototype, fw = Function.prototype.toString, ly = /* @__PURE__ */ new Map();
function Dn(r, e) {
  try {
    return uy(r, e);
  } finally {
    ly.clear();
  }
}
function uy(r, e) {
  if (r === e)
    return !0;
  const t = cw.call(r), n = cw.call(e);
  if (t !== n)
    return !1;
  switch (t) {
    case "[object Array]":
      if (r.length !== e.length)
        return !1;
    // Fall through to object case...
    case "[object Object]": {
      if (hw(r, e))
        return !0;
      const i = dw(r), a = dw(e), s = i.length;
      if (s !== a.length)
        return !1;
      for (let o = 0; o < s; ++o)
        if (!IR.call(e, i[o]))
          return !1;
      for (let o = 0; o < s; ++o) {
        const l = i[o];
        if (!uy(r[l], e[l]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return r.name === e.name && r.message === e.message;
    case "[object Number]":
      if (r !== r)
        return e !== e;
    // Fall through to shared +a === +b case...
    case "[object Boolean]":
    case "[object Date]":
      return +r == +e;
    case "[object RegExp]":
    case "[object String]":
      return r == `${e}`;
    case "[object Map]":
    case "[object Set]": {
      if (r.size !== e.size)
        return !1;
      if (hw(r, e))
        return !0;
      const i = r.entries(), a = t === "[object Map]";
      for (; ; ) {
        const s = i.next();
        if (s.done)
          break;
        const [o, l] = s.value;
        if (!e.has(o) || a && !uy(l, e.get(o)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    // Buffer, in Node.js.
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      r = new Uint8Array(r), e = new Uint8Array(e);
    // Fall through...
    case "[object DataView]": {
      let i = r.byteLength;
      if (i === e.byteLength)
        for (; i-- && r[i] === e[i]; )
          ;
      return i === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      const i = fw.call(r);
      return i !== fw.call(e) ? !1 : !RR(i, PR);
    }
  }
  return !1;
}
function dw(r) {
  return Object.keys(r).filter(DR, r);
}
function DR(r) {
  return this[r] !== void 0;
}
const PR = "{ [native code] }";
function RR(r, e) {
  const t = r.length - e.length;
  return t >= 0 && r.indexOf(e, t) === t;
}
function hw(r, e) {
  let t = ly.get(r);
  if (t) {
    if (t.has(e))
      return !0;
  } else
    ly.set(r, t = /* @__PURE__ */ new Set());
  return t.add(e), !1;
}
function X2(r, e, t, n) {
  var i = e.data, a = ns(e, ["data"]), s = t.data, o = ns(t, ["data"]);
  return Dn(a, o) && Tp(xd(r).selectionSet, i, s, {
    fragmentMap: Zu(rc(r)),
    variables: n
  });
}
function Tp(r, e, t, n) {
  if (e === t)
    return !0;
  var i = /* @__PURE__ */ new Set();
  return r.selections.every(function(a) {
    if (i.has(a) || (i.add(a), !wd(a, n.variables)) || pw(a))
      return !0;
    if (vo(a)) {
      var s = mo(a), o = e && e[s], l = t && t[s], u = a.selectionSet;
      if (!u)
        return Dn(o, l);
      var c = Array.isArray(o), d = Array.isArray(l);
      if (c !== d)
        return !1;
      if (c && d) {
        var f = o.length;
        if (l.length !== f)
          return !1;
        for (var h = 0; h < f; ++h)
          if (!Tp(u, o[h], l[h], n))
            return !1;
        return !0;
      }
      return Tp(u, o, l, n);
    } else {
      var g = wg(a, n.fragmentMap);
      if (g)
        return pw(g) ? !0 : Tp(
          g.selectionSet,
          // Notice that we reuse the same aResult and bResult values here,
          // since the fragment ...spread does not specify a field name, but
          // consists of multiple fields (within the fragment's selection set)
          // that should be applied to the current result value(s).
          e,
          t,
          n
        );
    }
  });
}
function pw(r) {
  return !!r.directives && r.directives.some(OR);
}
function OR(r) {
  return r.name.value === "nonreactive";
}
var J2 = Cl ? WeakMap : Map, K2 = hA ? WeakSet : Set, Z2 = new nc();
function ek(r, e, t) {
  return Z2.withValue(!0, function() {
    var n = Ff(r, e, t, !1);
    return n;
  });
}
function BR(r, e) {
  if (e.has(r))
    return e.get(r);
  var t = Array.isArray(r) ? [] : /* @__PURE__ */ Object.create(null);
  return e.set(r, t), t;
}
function Ff(r, e, t, n, i) {
  var a = t.knownChanged, s = BR(r, t.mutableTargets);
  if (Array.isArray(r)) {
    for (var o = 0, l = Array.from(r.entries()); o < l.length; o++) {
      var u = l[o], c = u[0], d = u[1];
      if (d === null) {
        s[c] = null;
        continue;
      }
      var f = Ff(d, e, t, n);
      a.has(f) && a.add(s), s[c] = f;
    }
    return a.has(s) ? s : r;
  }
  for (var h = 0, g = e.selections; h < g.length; h++) {
    var v = g[h], y = void 0;
    if (n && a.add(s), v.kind === et.FIELD) {
      var A = mo(v), x = v.selectionSet;
      if (y = s[A] || r[A], y === void 0)
        continue;
      if (x && y !== null) {
        var f = Ff(r[A], x, t, n);
        a.has(f) && (y = f);
      }
      s[A] = y;
    }
    if (v.kind === et.INLINE_FRAGMENT && (!v.typeCondition || t.cache.fragmentMatches(v, r.__typename)) && (y = Ff(r, v.selectionSet, t, n)), v.kind === et.FRAGMENT_SPREAD) {
      var k = v.name.value, F = t.fragmentMap[k] || (t.fragmentMap[k] = t.cache.lookupFragment(k));
      Mr(F, 59, k);
      var S = zD(v);
      S !== "mask" && (y = Ff(r, F.selectionSet, t, S === "migrate"));
    }
    a.has(y) && a.add(s);
  }
  return "__typename" in r && !("__typename" in s) && (s.__typename = r.__typename), Object.keys(s).length !== Object.keys(r).length && a.add(s), a.has(s) ? s : r;
}
function tk(r, e, t, n) {
  if (!t.fragmentMatches)
    return r;
  var i = e.definitions.filter(function(s) {
    return s.kind === et.FRAGMENT_DEFINITION;
  });
  typeof n > "u" && (Mr(i.length === 1, 61, i.length), n = i[0].name.value);
  var a = i.find(function(s) {
    return s.name.value === n;
  });
  return Mr(!!a, 62, n), r == null || Dn(r, {}) ? r : ek(r, a.selectionSet, {
    operationName: a.name.value,
    fragmentMap: Zu(rc(e)),
    cache: t,
    mutableTargets: new J2(),
    knownChanged: new K2()
  });
}
function MR(r, e, t) {
  var n;
  if (!t.fragmentMatches)
    return r;
  var i = tc(e);
  return Mr(i, 63), r == null ? r : ek(r, i.selectionSet, {
    operationType: i.operation,
    operationName: (n = i.name) === null || n === void 0 ? void 0 : n.value,
    fragmentMap: Zu(rc(e)),
    cache: t,
    mutableTargets: new J2(),
    knownChanged: new K2()
  });
}
var _R = (
  /** @class */
  (function() {
    function r() {
      this.assumeImmutableResults = !1, this.getFragmentDoc = Vu(WD, {
        max: Rs["cache.fragmentQueryDocuments"] || 1e3,
        cache: td
      });
    }
    return r.prototype.lookupFragment = function(e) {
      return null;
    }, r.prototype.batch = function(e) {
      var t = this, n = typeof e.optimistic == "string" ? e.optimistic : e.optimistic === !1 ? null : void 0, i;
      return this.performTransaction(function() {
        return i = e.update(t);
      }, n), i;
    }, r.prototype.recordOptimisticTransaction = function(e, t) {
      this.performTransaction(e, t);
    }, r.prototype.transformDocument = function(e) {
      return e;
    }, r.prototype.transformForLink = function(e) {
      return e;
    }, r.prototype.identify = function(e) {
    }, r.prototype.gc = function() {
      return [];
    }, r.prototype.modify = function(e) {
      return !1;
    }, r.prototype.readQuery = function(e, t) {
      var n = this;
      return t === void 0 && (t = !!e.optimistic), Di("canonizeResults", function() {
        return n.read(me(me({}, e), { rootId: e.id || "ROOT_QUERY", optimistic: t }));
      });
    }, r.prototype.watchFragment = function(e) {
      var t = this, n = e.fragment, i = e.fragmentName, a = e.from, s = e.optimistic, o = s === void 0 ? !0 : s, l = ns(e, ["fragment", "fragmentName", "from", "optimistic"]), u = this.getFragmentDoc(n, i), c = typeof a > "u" || typeof a == "string" ? a : this.identify(a), d = !!e[/* @__PURE__ */ Symbol.for("apollo.dataMasking")], f = me(me({}, l), { returnPartialData: !0, id: c, query: u, optimistic: o }), h;
      return new nn(function(g) {
        return t.watch(me(me({}, f), { immediate: !0, callback: function(v) {
          var y = d ? tk(v.result, n, t, i) : v.result;
          if (
            // Always ensure we deliver the first result
            !(h && X2(
              u,
              { data: h.result },
              { data: y },
              // TODO: Fix the type on WatchFragmentOptions so that TVars
              // extends OperationVariables
              e.variables
            ))
          ) {
            var A = {
              data: y,
              complete: !!v.complete
            };
            v.missing && (A.missing = Eg(v.missing.map(function(x) {
              return x.missing;
            }))), h = me(me({}, v), { result: y }), g.next(A);
          }
        } }));
      });
    }, r.prototype.readFragment = function(e, t) {
      var n = this;
      return t === void 0 && (t = !!e.optimistic), Di("canonizeResults", function() {
        return n.read(me(me({}, e), { query: n.getFragmentDoc(e.fragment, e.fragmentName), rootId: e.id, optimistic: t }));
      });
    }, r.prototype.writeQuery = function(e) {
      var t = e.id, n = e.data, i = ns(e, ["id", "data"]);
      return this.write(Object.assign(i, {
        dataId: t || "ROOT_QUERY",
        result: n
      }));
    }, r.prototype.writeFragment = function(e) {
      var t = e.id, n = e.data, i = e.fragment, a = e.fragmentName, s = ns(e, ["id", "data", "fragment", "fragmentName"]);
      return this.write(Object.assign(s, {
        query: this.getFragmentDoc(i, a),
        dataId: t,
        result: n
      }));
    }, r.prototype.updateQuery = function(e, t) {
      return this.batch({
        update: function(n) {
          var i = Di("canonizeResults", function() {
            return n.readQuery(e);
          }), a = t(i);
          return a == null ? i : (n.writeQuery(me(me({}, e), { data: a })), a);
        }
      });
    }, r.prototype.updateFragment = function(e, t) {
      return this.batch({
        update: function(n) {
          var i = Di("canonizeResults", function() {
            return n.readFragment(e);
          }), a = t(i);
          return a == null ? i : (n.writeFragment(me(me({}, e), { data: a })), a);
        }
      });
    }, r;
  })()
), rk = (
  /** @class */
  (function(r) {
    pa(e, r);
    function e(t, n, i, a) {
      var s, o = r.call(this, t) || this;
      if (o.message = t, o.path = n, o.query = i, o.variables = a, Array.isArray(o.path)) {
        o.missing = o.message;
        for (var l = o.path.length - 1; l >= 0; --l)
          o.missing = (s = {}, s[o.path[l]] = o.missing, s);
      } else
        o.missing = o.path;
      return o.__proto__ = e.prototype, o;
    }
    return e;
  })(Error)
), gi = Object.prototype.hasOwnProperty;
function Kc(r) {
  return r == null;
}
function nk(r, e) {
  var t = r.__typename, n = r.id, i = r._id;
  if (typeof t == "string" && (e && (e.keyObject = Kc(n) ? Kc(i) ? void 0 : { _id: i } : { id: n }), Kc(n) && !Kc(i) && (n = i), !Kc(n)))
    return "".concat(t, ":").concat(typeof n == "number" || typeof n == "string" ? n : JSON.stringify(n));
}
var ik = {
  dataIdFromObject: nk,
  addTypename: !0,
  resultCaching: !0,
  // Thanks to the shouldCanonizeResults helper, this should be the only line
  // you have to change to reenable canonization by default in the future.
  canonizeResults: !1
};
function NR(r) {
  return $u(ik, r);
}
function ak(r) {
  var e = r.canonizeResults;
  return e === void 0 ? ik.canonizeResults : e;
}
var sk = /^[_a-z][_0-9a-z]*/i;
function Hu(r) {
  var e = r.match(sk);
  return e ? e[0] : r;
}
function cy(r, e, t) {
  return li(e) ? ni(e) ? e.every(function(n) {
    return cy(r, n, t);
  }) : r.selections.every(function(n) {
    if (vo(n) && wd(n, t)) {
      var i = mo(n);
      return gi.call(e, i) && (!n.selectionSet || cy(n.selectionSet, e[i], t));
    }
    return !0;
  }) : !1;
}
function Eu(r) {
  return li(r) && !Tn(r) && !ni(r);
}
function LR() {
  return new Ao();
}
function ok(r, e) {
  var t = Zu(rc(r));
  return {
    fragmentMap: t,
    lookupFragment: function(n) {
      var i = t[n];
      return !i && e && (i = e.lookup(n)), i || null;
    }
  };
}
var Fp = /* @__PURE__ */ Object.create(null), Wm = function() {
  return Fp;
}, gw = /* @__PURE__ */ Object.create(null), nd = (
  /** @class */
  (function() {
    function r(e, t) {
      var n = this;
      this.policies = e, this.group = t, this.data = /* @__PURE__ */ Object.create(null), this.rootIds = /* @__PURE__ */ Object.create(null), this.refs = /* @__PURE__ */ Object.create(null), this.getFieldValue = function(i, a) {
        return Tn(i) ? n.get(i.__ref, a) : i && i[a];
      }, this.canRead = function(i) {
        return Tn(i) ? n.has(i.__ref) : typeof i == "object";
      }, this.toReference = function(i, a) {
        if (typeof i == "string")
          return Pu(i);
        if (Tn(i))
          return i;
        var s = n.policies.identify(i)[0];
        if (s) {
          var o = Pu(s);
          return a && n.merge(s, i), o;
        }
      };
    }
    return r.prototype.toObject = function() {
      return me({}, this.data);
    }, r.prototype.has = function(e) {
      return this.lookup(e, !0) !== void 0;
    }, r.prototype.get = function(e, t) {
      if (this.group.depend(e, t), gi.call(this.data, e)) {
        var n = this.data[e];
        if (n && gi.call(n, t))
          return n[t];
      }
      if (t === "__typename" && gi.call(this.policies.rootTypenamesById, e))
        return this.policies.rootTypenamesById[e];
      if (this instanceof eo)
        return this.parent.get(e, t);
    }, r.prototype.lookup = function(e, t) {
      if (t && this.group.depend(e, "__exists"), gi.call(this.data, e))
        return this.data[e];
      if (this instanceof eo)
        return this.parent.lookup(e, t);
      if (this.policies.rootTypenamesById[e])
        return /* @__PURE__ */ Object.create(null);
    }, r.prototype.merge = function(e, t) {
      var n = this, i;
      Tn(e) && (e = e.__ref), Tn(t) && (t = t.__ref);
      var a = typeof e == "string" ? this.lookup(i = e) : e, s = typeof t == "string" ? this.lookup(i = t) : t;
      if (s) {
        Mr(typeof i == "string", 2);
        var o = new Ao(VR).merge(a, s);
        if (this.data[i] = o, o !== a && (delete this.refs[i], this.group.caching)) {
          var l = /* @__PURE__ */ Object.create(null);
          a || (l.__exists = 1), Object.keys(s).forEach(function(u) {
            if (!a || a[u] !== o[u]) {
              l[u] = 1;
              var c = Hu(u);
              c !== u && !n.policies.hasKeyArgs(o.__typename, c) && (l[c] = 1), o[u] === void 0 && !(n instanceof eo) && delete o[u];
            }
          }), l.__typename && !(a && a.__typename) && // Since we return default root __typename strings
          // automatically from store.get, we don't need to dirty the
          // ROOT_QUERY.__typename field if merged.__typename is equal
          // to the default string (usually "Query").
          this.policies.rootTypenamesById[i] === o.__typename && delete l.__typename, Object.keys(l).forEach(function(u) {
            return n.group.dirty(i, u);
          });
        }
      }
    }, r.prototype.modify = function(e, t) {
      var n = this, i = this.lookup(e);
      if (i) {
        var a = /* @__PURE__ */ Object.create(null), s = !1, o = !0, l = {
          DELETE: Fp,
          INVALIDATE: gw,
          isReference: Tn,
          toReference: this.toReference,
          canRead: this.canRead,
          readField: function(u, c) {
            return n.policies.readField(typeof u == "string" ? {
              fieldName: u,
              from: c || Pu(e)
            } : u, { store: n });
          }
        };
        if (Object.keys(i).forEach(function(u) {
          var c = Hu(u), d = i[u];
          if (d !== void 0) {
            var f = typeof t == "function" ? t : t[u] || t[c];
            if (f) {
              var h = f === Wm ? Fp : f(d, me(me({}, l), { fieldName: c, storeFieldName: u, storage: n.getStorage(e, u) }));
              h === gw ? n.group.dirty(e, u) : (h === Fp && (h = void 0), h !== d && (a[u] = h, s = !0, d = h));
            }
            d !== void 0 && (o = !1);
          }
        }), s)
          return this.merge(e, a), o && (this instanceof eo ? this.data[e] = void 0 : delete this.data[e], this.group.dirty(e, "__exists")), !0;
      }
      return !1;
    }, r.prototype.delete = function(e, t, n) {
      var i, a = this.lookup(e);
      if (a) {
        var s = this.getFieldValue(a, "__typename"), o = t && n ? this.policies.getStoreFieldName({ typename: s, fieldName: t, args: n }) : t;
        return this.modify(e, o ? (i = {}, i[o] = Wm, i) : Wm);
      }
      return !1;
    }, r.prototype.evict = function(e, t) {
      var n = !1;
      return e.id && (gi.call(this.data, e.id) && (n = this.delete(e.id, e.fieldName, e.args)), this instanceof eo && this !== t && (n = this.parent.evict(e, t) || n), (e.fieldName || n) && this.group.dirty(e.id, e.fieldName || "__exists")), n;
    }, r.prototype.clear = function() {
      this.replace(null);
    }, r.prototype.extract = function() {
      var e = this, t = this.toObject(), n = [];
      return this.getRootIdSet().forEach(function(i) {
        gi.call(e.policies.rootTypenamesById, i) || n.push(i);
      }), n.length && (t.__META = { extraRootIds: n.sort() }), t;
    }, r.prototype.replace = function(e) {
      var t = this;
      if (Object.keys(this.data).forEach(function(a) {
        e && gi.call(e, a) || t.delete(a);
      }), e) {
        var n = e.__META, i = ns(e, ["__META"]);
        Object.keys(i).forEach(function(a) {
          t.merge(a, i[a]);
        }), n && n.extraRootIds.forEach(this.retain, this);
      }
    }, r.prototype.retain = function(e) {
      return this.rootIds[e] = (this.rootIds[e] || 0) + 1;
    }, r.prototype.release = function(e) {
      if (this.rootIds[e] > 0) {
        var t = --this.rootIds[e];
        return t || delete this.rootIds[e], t;
      }
      return 0;
    }, r.prototype.getRootIdSet = function(e) {
      return e === void 0 && (e = /* @__PURE__ */ new Set()), Object.keys(this.rootIds).forEach(e.add, e), this instanceof eo ? this.parent.getRootIdSet(e) : Object.keys(this.policies.rootTypenamesById).forEach(e.add, e), e;
    }, r.prototype.gc = function() {
      var e = this, t = this.getRootIdSet(), n = this.toObject();
      t.forEach(function(s) {
        gi.call(n, s) && (Object.keys(e.findChildRefIds(s)).forEach(t.add, t), delete n[s]);
      });
      var i = Object.keys(n);
      if (i.length) {
        for (var a = this; a instanceof eo; )
          a = a.parent;
        i.forEach(function(s) {
          return a.delete(s);
        });
      }
      return i;
    }, r.prototype.findChildRefIds = function(e) {
      if (!gi.call(this.refs, e)) {
        var t = this.refs[e] = /* @__PURE__ */ Object.create(null), n = this.data[e];
        if (!n)
          return t;
        var i = /* @__PURE__ */ new Set([n]);
        i.forEach(function(a) {
          Tn(a) && (t[a.__ref] = !0), li(a) && Object.keys(a).forEach(function(s) {
            var o = a[s];
            li(o) && i.add(o);
          });
        });
      }
      return this.refs[e];
    }, r.prototype.makeCacheKey = function() {
      return this.group.keyMaker.lookupArray(arguments);
    }, r;
  })()
), lk = (
  /** @class */
  (function() {
    function r(e, t) {
      t === void 0 && (t = null), this.caching = e, this.parent = t, this.d = null, this.resetCaching();
    }
    return r.prototype.resetCaching = function() {
      this.d = this.caching ? M2() : null, this.keyMaker = new Os(Cl);
    }, r.prototype.depend = function(e, t) {
      if (this.d) {
        this.d(Qm(e, t));
        var n = Hu(t);
        n !== t && this.d(Qm(e, n)), this.parent && this.parent.depend(e, t);
      }
    }, r.prototype.dirty = function(e, t) {
      this.d && this.d.dirty(
        Qm(e, t),
        // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        t === "__exists" ? "forget" : "setDirty"
      );
    }, r;
  })()
);
function Qm(r, e) {
  return e + "#" + r;
}
function mw(r, e) {
  Vf(r) && r.group.depend(e, "__exists");
}
(function(r) {
  var e = (
    /** @class */
    (function(t) {
      pa(n, t);
      function n(i) {
        var a = i.policies, s = i.resultCaching, o = s === void 0 ? !0 : s, l = i.seed, u = t.call(this, a, new lk(o)) || this;
        return u.stump = new UR(u), u.storageTrie = new Os(Cl), l && u.replace(l), u;
      }
      return n.prototype.addLayer = function(i, a) {
        return this.stump.addLayer(i, a);
      }, n.prototype.removeLayer = function() {
        return this;
      }, n.prototype.getStorage = function() {
        return this.storageTrie.lookupArray(arguments);
      }, n;
    })(r)
  );
  r.Root = e;
})(nd || (nd = {}));
var eo = (
  /** @class */
  (function(r) {
    pa(e, r);
    function e(t, n, i, a) {
      var s = r.call(this, n.policies, a) || this;
      return s.id = t, s.parent = n, s.replay = i, s.group = a, i(s), s;
    }
    return e.prototype.addLayer = function(t, n) {
      return new e(t, this, n, this.group);
    }, e.prototype.removeLayer = function(t) {
      var n = this, i = this.parent.removeLayer(t);
      return t === this.id ? (this.group.caching && Object.keys(this.data).forEach(function(a) {
        var s = n.data[a], o = i.lookup(a);
        o ? s ? s !== o && Object.keys(s).forEach(function(l) {
          Dn(s[l], o[l]) || n.group.dirty(a, l);
        }) : (n.group.dirty(a, "__exists"), Object.keys(o).forEach(function(l) {
          n.group.dirty(a, l);
        })) : n.delete(a);
      }), i) : i === this.parent ? this : i.addLayer(this.id, this.replay);
    }, e.prototype.toObject = function() {
      return me(me({}, this.parent.toObject()), this.data);
    }, e.prototype.findChildRefIds = function(t) {
      var n = this.parent.findChildRefIds(t);
      return gi.call(this.data, t) ? me(me({}, n), r.prototype.findChildRefIds.call(this, t)) : n;
    }, e.prototype.getStorage = function() {
      for (var t = this.parent; t.parent; )
        t = t.parent;
      return t.getStorage.apply(
        t,
        // @ts-expect-error
        arguments
      );
    }, e;
  })(nd)
), UR = (
  /** @class */
  (function(r) {
    pa(e, r);
    function e(t) {
      return r.call(this, "EntityStore.Stump", t, function() {
      }, new lk(t.group.caching, t.group)) || this;
    }
    return e.prototype.removeLayer = function() {
      return this;
    }, e.prototype.merge = function(t, n) {
      return this.parent.merge(t, n);
    }, e;
  })(eo)
);
function VR(r, e, t) {
  var n = r[t], i = e[t];
  return Dn(n, i) ? n : i;
}
function Vf(r) {
  return !!(r instanceof nd && r.group.caching);
}
var ui = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Bs(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
function zR(r) {
  return li(r) ? ni(r) ? r.slice(0) : me({ __proto__: Object.getPrototypeOf(r) }, r) : r;
}
var vw = (
  /** @class */
  (function() {
    function r() {
      this.known = new (hA ? WeakSet : Set)(), this.pool = new Os(Cl), this.passes = /* @__PURE__ */ new WeakMap(), this.keysByJSON = /* @__PURE__ */ new Map(), this.empty = this.admit({});
    }
    return r.prototype.isKnown = function(e) {
      return li(e) && this.known.has(e);
    }, r.prototype.pass = function(e) {
      if (li(e)) {
        var t = zR(e);
        return this.passes.set(t, e), t;
      }
      return e;
    }, r.prototype.admit = function(e) {
      var t = this;
      if (li(e)) {
        var n = this.passes.get(e);
        if (n)
          return n;
        var i = Object.getPrototypeOf(e);
        switch (i) {
          case Array.prototype: {
            if (this.known.has(e))
              return e;
            var a = e.map(this.admit, this), s = this.pool.lookupArray(a);
            return s.array || this.known.add(s.array = a), s.array;
          }
          case null:
          case Object.prototype: {
            if (this.known.has(e))
              return e;
            var o = Object.getPrototypeOf(e), l = [o], u = this.sortedKeys(e);
            l.push(u.json);
            var c = l.length;
            u.sorted.forEach(function(h) {
              l.push(t.admit(e[h]));
            });
            var s = this.pool.lookupArray(l);
            if (!s.object) {
              var d = s.object = Object.create(o);
              this.known.add(d), u.sorted.forEach(function(h, g) {
                d[h] = l[c + g];
              });
            }
            return s.object;
          }
        }
      }
      return e;
    }, r.prototype.sortedKeys = function(e) {
      var t = Object.keys(e), n = this.pool.lookupArray(t);
      if (!n.keys) {
        t.sort();
        var i = JSON.stringify(t);
        (n.keys = this.keysByJSON.get(i)) || this.keysByJSON.set(i, n.keys = { sorted: t, json: i });
      }
      return n.keys;
    }, r;
  })()
);
function yw(r) {
  return [
    r.selectionSet,
    r.objectOrReference,
    r.context,
    // We split out this property so we can pass different values
    // independently without modifying options.context itself.
    r.context.canonizeResults
  ];
}
var $R = (
  /** @class */
  (function() {
    function r(e) {
      var t = this;
      this.knownResults = new (Cl ? WeakMap : Map)(), this.config = $u(e, {
        addTypename: e.addTypename !== !1,
        canonizeResults: ak(e)
      }), this.canon = e.canon || new vw(), this.executeSelectionSet = Vu(function(n) {
        var i, a = n.context.canonizeResults, s = yw(n);
        s[3] = !a;
        var o = (i = t.executeSelectionSet).peek.apply(i, s);
        return o ? a ? me(me({}, o), {
          // If we previously read this result without canonizing it, we can
          // reuse that result simply by canonizing it now.
          result: t.canon.admit(o.result)
        }) : o : (mw(n.context.store, n.enclosingRef.__ref), t.execSelectionSetImpl(n));
      }, {
        max: this.config.resultCacheMaxSize || Rs["inMemoryCache.executeSelectionSet"] || 5e4,
        keyArgs: yw,
        // Note that the parameters of makeCacheKey are determined by the
        // array returned by keyArgs.
        makeCacheKey: function(n, i, a, s) {
          if (Vf(a.store))
            return a.store.makeCacheKey(n, Tn(i) ? i.__ref : i, a.varString, s);
        }
      }), this.executeSubSelectedArray = Vu(function(n) {
        return mw(n.context.store, n.enclosingRef.__ref), t.execSubSelectedArrayImpl(n);
      }, {
        max: this.config.resultCacheMaxSize || Rs["inMemoryCache.executeSubSelectedArray"] || 1e4,
        makeCacheKey: function(n) {
          var i = n.field, a = n.array, s = n.context;
          if (Vf(s.store))
            return s.store.makeCacheKey(i, a, s.varString);
        }
      });
    }
    return r.prototype.resetCanon = function() {
      this.canon = new vw();
    }, r.prototype.diffQueryAgainstStore = function(e) {
      var t = e.store, n = e.query, i = e.rootId, a = i === void 0 ? "ROOT_QUERY" : i, s = e.variables, o = e.returnPartialData, l = o === void 0 ? !0 : o, u = e.canonizeResults, c = u === void 0 ? this.config.canonizeResults : u, d = this.config.cache.policies;
      s = me(me({}, pA(vP(n))), s);
      var f = Pu(a), h = this.executeSelectionSet({
        selectionSet: xd(n).selectionSet,
        objectOrReference: f,
        enclosingRef: f,
        context: me({ store: t, query: n, policies: d, variables: s, varString: fo(s), canonizeResults: c }, ok(n, this.config.fragments))
      }), g;
      if (h.missing && (g = [
        new rk(HR(h.missing), h.missing, n, s)
      ], !l))
        throw g[0];
      return {
        result: h.result,
        complete: !g,
        missing: g
      };
    }, r.prototype.isFresh = function(e, t, n, i) {
      if (Vf(i.store) && this.knownResults.get(e) === n) {
        var a = this.executeSelectionSet.peek(
          n,
          t,
          i,
          // If result is canonical, then it could only have been previously
          // cached by the canonizing version of executeSelectionSet, so we can
          // avoid checking both possibilities here.
          this.canon.isKnown(e)
        );
        if (a && e === a.result)
          return !0;
      }
      return !1;
    }, r.prototype.execSelectionSetImpl = function(e) {
      var t = this, n = e.selectionSet, i = e.objectOrReference, a = e.enclosingRef, s = e.context;
      if (Tn(i) && !s.policies.rootTypenamesById[i.__ref] && !s.store.has(i.__ref))
        return {
          result: this.canon.empty,
          missing: "Dangling reference to missing ".concat(i.__ref, " object")
        };
      var o = s.variables, l = s.policies, u = s.store, c = u.getFieldValue(i, "__typename"), d = [], f, h = new Ao();
      this.config.addTypename && typeof c == "string" && !l.rootIdsByTypename[c] && d.push({ __typename: c });
      function g(k, F) {
        var S;
        return k.missing && (f = h.merge(f, (S = {}, S[F] = k.missing, S))), k.result;
      }
      var v = new Set(n.selections);
      v.forEach(function(k) {
        var F, S;
        if (wd(k, o))
          if (vo(k)) {
            var R = l.readField({
              fieldName: k.name.value,
              field: k,
              variables: s.variables,
              from: i
            }, s), M = mo(k);
            R === void 0 ? U2.added(k) || (f = h.merge(f, (F = {}, F[M] = "Can't find field '".concat(k.name.value, "' on ").concat(Tn(i) ? i.__ref + " object" : "object " + JSON.stringify(i, null, 2)), F))) : ni(R) ? R.length > 0 && (R = g(t.executeSubSelectedArray({
              field: k,
              array: R,
              enclosingRef: a,
              context: s
            }), M)) : k.selectionSet ? R != null && (R = g(t.executeSelectionSet({
              selectionSet: k.selectionSet,
              objectOrReference: R,
              enclosingRef: Tn(R) ? R : a,
              context: s
            }), M)) : s.canonizeResults && (R = t.canon.pass(R)), R !== void 0 && d.push((S = {}, S[M] = R, S));
          } else {
            var j = wg(k, s.lookupFragment);
            if (!j && k.kind === et.FRAGMENT_SPREAD)
              throw Hi(10, k.name.value);
            j && l.fragmentMatches(j, c) && j.selectionSet.selections.forEach(v.add, v);
          }
      });
      var y = Eg(d), A = { result: y, missing: f }, x = s.canonizeResults ? this.canon.admit(A) : A;
      return x.result && this.knownResults.set(x.result, n), x;
    }, r.prototype.execSubSelectedArrayImpl = function(e) {
      var t = this, n = e.field, i = e.array, a = e.enclosingRef, s = e.context, o, l = new Ao();
      function u(c, d) {
        var f;
        return c.missing && (o = l.merge(o, (f = {}, f[d] = c.missing, f))), c.result;
      }
      return n.selectionSet && (i = i.filter(s.store.canRead)), i = i.map(function(c, d) {
        return c === null ? null : ni(c) ? u(t.executeSubSelectedArray({
          field: n,
          array: c,
          enclosingRef: a,
          context: s
        }), d) : n.selectionSet ? u(t.executeSelectionSet({
          selectionSet: n.selectionSet,
          objectOrReference: c,
          enclosingRef: Tn(c) ? c : a,
          context: s
        }), d) : c;
      }), {
        result: s.canonizeResults ? this.canon.admit(i) : i,
        missing: o
      };
    }, r;
  })()
);
function HR(r) {
  try {
    JSON.stringify(r, function(e, t) {
      if (typeof t == "string")
        throw t;
      return t;
    });
  } catch (e) {
    return e;
  }
}
var SA = new nc(), Aw = /* @__PURE__ */ new WeakMap();
function zf(r) {
  var e = Aw.get(r);
  return e || Aw.set(r, e = {
    vars: /* @__PURE__ */ new Set(),
    dep: M2()
  }), e;
}
function bw(r) {
  zf(r).vars.forEach(function(e) {
    return e.forgetCache(r);
  });
}
function jR(r) {
  zf(r).vars.forEach(function(e) {
    return e.attachCache(r);
  });
}
function GR(r) {
  var e = /* @__PURE__ */ new Set(), t = /* @__PURE__ */ new Set(), n = function(a) {
    if (arguments.length > 0) {
      if (r !== a) {
        r = a, e.forEach(function(l) {
          zf(l).dep.dirty(n), qR(l);
        });
        var s = Array.from(t);
        t.clear(), s.forEach(function(l) {
          return l(r);
        });
      }
    } else {
      var o = SA.getValue();
      o && (i(o), zf(o).dep(n));
    }
    return r;
  };
  n.onNextChange = function(a) {
    return t.add(a), function() {
      t.delete(a);
    };
  };
  var i = n.attachCache = function(a) {
    return e.add(a), zf(a).vars.add(n), n;
  };
  return n.forgetCache = function(a) {
    return e.delete(a);
  }, n;
}
function qR(r) {
  r.broadcastWatches && r.broadcastWatches();
}
var ww = /* @__PURE__ */ Object.create(null);
function EA(r) {
  var e = JSON.stringify(r);
  return ww[e] || (ww[e] = /* @__PURE__ */ Object.create(null));
}
function xw(r) {
  var e = EA(r);
  return e.keyFieldsFn || (e.keyFieldsFn = function(t, n) {
    var i = function(s, o) {
      return n.readField(o, s);
    }, a = n.keyObject = kA(r, function(s) {
      var o = Ou(
        n.storeObject,
        s,
        // Using context.readField to extract paths from context.storeObject
        // allows the extraction to see through Reference objects and respect
        // custom read functions.
        i
      );
      return o === void 0 && t !== n.storeObject && gi.call(t, s[0]) && (o = Ou(t, s, ck)), Mr(o !== void 0, 5, s.join("."), t), o;
    });
    return "".concat(n.typename, ":").concat(JSON.stringify(a));
  });
}
function Cw(r) {
  var e = EA(r);
  return e.keyArgsFn || (e.keyArgsFn = function(t, n) {
    var i = n.field, a = n.variables, s = n.fieldName, o = kA(r, function(u) {
      var c = u[0], d = c.charAt(0);
      if (d === "@") {
        if (i && as(i.directives)) {
          var f = c.slice(1), h = i.directives.find(function(A) {
            return A.name.value === f;
          }), g = h && xg(h, a);
          return g && Ou(
            g,
            // If keyPath.length === 1, this code calls extractKeyPath with an
            // empty path, which works because it uses directiveArgs as the
            // extracted value.
            u.slice(1)
          );
        }
        return;
      }
      if (d === "$") {
        var v = c.slice(1);
        if (a && gi.call(a, v)) {
          var y = u.slice(0);
          return y[0] = v, Ou(a, y);
        }
        return;
      }
      if (t)
        return Ou(t, u);
    }), l = JSON.stringify(o);
    return (t || l !== "{}") && (s += ":" + l), s;
  });
}
function kA(r, e) {
  var t = new Ao();
  return uk(r).reduce(function(n, i) {
    var a, s = e(i);
    if (s !== void 0) {
      for (var o = i.length - 1; o >= 0; --o)
        s = (a = {}, a[i[o]] = s, a);
      n = t.merge(n, s);
    }
    return n;
  }, /* @__PURE__ */ Object.create(null));
}
function uk(r) {
  var e = EA(r);
  if (!e.paths) {
    var t = e.paths = [], n = [];
    r.forEach(function(i, a) {
      ni(i) ? (uk(i).forEach(function(s) {
        return t.push(n.concat(s));
      }), n.length = 0) : (n.push(i), ni(r[a + 1]) || (t.push(n.slice(0)), n.length = 0));
    });
  }
  return e.paths;
}
function ck(r, e) {
  return r[e];
}
function Ou(r, e, t) {
  return t = t || ck, fk(e.reduce(function n(i, a) {
    return ni(i) ? i.map(function(s) {
      return n(s, a);
    }) : i && t(i, a);
  }, r));
}
function fk(r) {
  return li(r) ? ni(r) ? r.map(fk) : kA(Object.keys(r).sort(), function(e) {
    return Ou(r, e);
  }) : r;
}
function fy(r) {
  return r.args !== void 0 ? r.args : r.field ? xg(r.field, r.variables) : null;
}
var WR = function() {
}, Sw = function(r, e) {
  return e.fieldName;
}, Ew = function(r, e, t) {
  var n = t.mergeObjects;
  return n(r, e);
}, kw = function(r, e) {
  return e;
}, QR = (
  /** @class */
  (function() {
    function r(e) {
      this.config = e, this.typePolicies = /* @__PURE__ */ Object.create(null), this.toBeAdded = /* @__PURE__ */ Object.create(null), this.supertypeMap = /* @__PURE__ */ new Map(), this.fuzzySubtypes = /* @__PURE__ */ new Map(), this.rootIdsByTypename = /* @__PURE__ */ Object.create(null), this.rootTypenamesById = /* @__PURE__ */ Object.create(null), this.usingPossibleTypes = !1, this.config = me({ dataIdFromObject: nk }, e), this.cache = this.config.cache, this.setRootTypename("Query"), this.setRootTypename("Mutation"), this.setRootTypename("Subscription"), e.possibleTypes && this.addPossibleTypes(e.possibleTypes), e.typePolicies && this.addTypePolicies(e.typePolicies);
    }
    return r.prototype.identify = function(e, t) {
      var n, i = this, a = t && (t.typename || ((n = t.storeObject) === null || n === void 0 ? void 0 : n.__typename)) || e.__typename;
      if (a === this.rootTypenamesById.ROOT_QUERY)
        return ["ROOT_QUERY"];
      var s = t && t.storeObject || e, o = me(me({}, t), { typename: a, storeObject: s, readField: t && t.readField || function() {
        var d = TA(arguments, s);
        return i.readField(d, {
          store: i.cache.data,
          variables: d.variables
        });
      } }), l, u = a && this.getTypePolicy(a), c = u && u.keyFn || this.config.dataIdFromObject;
      return Z2.withValue(!0, function() {
        for (; c; ) {
          var d = c(me(me({}, e), s), o);
          if (ni(d))
            c = xw(d);
          else {
            l = d;
            break;
          }
        }
      }), l = l ? String(l) : void 0, o.keyObject ? [l, o.keyObject] : [l];
    }, r.prototype.addTypePolicies = function(e) {
      var t = this;
      Object.keys(e).forEach(function(n) {
        var i = e[n], a = i.queryType, s = i.mutationType, o = i.subscriptionType, l = ns(i, ["queryType", "mutationType", "subscriptionType"]);
        a && t.setRootTypename("Query", n), s && t.setRootTypename("Mutation", n), o && t.setRootTypename("Subscription", n), gi.call(t.toBeAdded, n) ? t.toBeAdded[n].push(l) : t.toBeAdded[n] = [l];
      });
    }, r.prototype.updateTypePolicy = function(e, t, n) {
      var i = this.getTypePolicy(e), a = t.keyFields, s = t.fields;
      function o(l, u) {
        l.merge = typeof u == "function" ? u : u === !0 ? Ew : u === !1 ? kw : l.merge;
      }
      o(i, t.merge), i.keyFn = // Pass false to disable normalization for this typename.
      a === !1 ? WR : ni(a) ? xw(a) : typeof a == "function" ? a : i.keyFn, s && Object.keys(s).forEach(function(l) {
        var u = n[l];
        (!u || u?.typename !== e) && (u = n[l] = { typename: e });
        var c = s[l];
        if (typeof c == "function")
          u.read = c;
        else {
          var d = c.keyArgs, f = c.read, h = c.merge;
          u.keyFn = // Pass false to disable argument-based differentiation of
          // field identities.
          d === !1 ? Sw : ni(d) ? Cw(d) : typeof d == "function" ? d : u.keyFn, typeof f == "function" && (u.read = f), o(u, h);
        }
        u.read && u.merge && (u.keyFn = u.keyFn || Sw);
      });
    }, r.prototype.setRootTypename = function(e, t) {
      t === void 0 && (t = e);
      var n = "ROOT_" + e.toUpperCase(), i = this.rootTypenamesById[n];
      t !== i && (Mr(!i || i === e, 6, e), i && delete this.rootIdsByTypename[i], this.rootIdsByTypename[t] = n, this.rootTypenamesById[n] = t);
    }, r.prototype.addPossibleTypes = function(e) {
      var t = this;
      this.usingPossibleTypes = !0, Object.keys(e).forEach(function(n) {
        t.getSupertypeSet(n, !0), e[n].forEach(function(i) {
          t.getSupertypeSet(i, !0).add(n);
          var a = i.match(sk);
          (!a || a[0] !== i) && t.fuzzySubtypes.set(i, new RegExp(i));
        });
      });
    }, r.prototype.getTypePolicy = function(e) {
      var t = this;
      if (!gi.call(this.typePolicies, e)) {
        var n = this.typePolicies[e] = /* @__PURE__ */ Object.create(null);
        n.fields = /* @__PURE__ */ Object.create(null);
        var i = this.supertypeMap.get(e);
        !i && this.fuzzySubtypes.size && (i = this.getSupertypeSet(e, !0), this.fuzzySubtypes.forEach(function(s, o) {
          if (s.test(e)) {
            var l = t.supertypeMap.get(o);
            l && l.forEach(function(u) {
              return i.add(u);
            });
          }
        })), i && i.size && i.forEach(function(s) {
          var o = t.getTypePolicy(s), l = o.fields, u = ns(o, ["fields"]);
          Object.assign(n, u), Object.assign(n.fields, l);
        });
      }
      var a = this.toBeAdded[e];
      return a && a.length && a.splice(0).forEach(function(s) {
        t.updateTypePolicy(e, s, t.typePolicies[e].fields);
      }), this.typePolicies[e];
    }, r.prototype.getFieldPolicy = function(e, t) {
      if (e)
        return this.getTypePolicy(e).fields[t];
    }, r.prototype.getSupertypeSet = function(e, t) {
      var n = this.supertypeMap.get(e);
      return !n && t && this.supertypeMap.set(e, n = /* @__PURE__ */ new Set()), n;
    }, r.prototype.fragmentMatches = function(e, t, n, i) {
      var a = this;
      if (!e.typeCondition)
        return !0;
      if (!t)
        return !1;
      var s = e.typeCondition.name.value;
      if (t === s)
        return !0;
      if (this.usingPossibleTypes && this.supertypeMap.has(s))
        for (var o = this.getSupertypeSet(t, !0), l = [o], u = function(h) {
          var g = a.getSupertypeSet(h, !1);
          g && g.size && l.indexOf(g) < 0 && l.push(g);
        }, c = !!(n && this.fuzzySubtypes.size), d = 0; d < l.length; ++d) {
          var f = l[d];
          if (f.has(s))
            return o.has(s) || o.add(s), !0;
          f.forEach(u), c && // Start checking fuzzy subtypes only after exhausting all
          // non-fuzzy subtypes (after the final iteration of the loop).
          d === l.length - 1 && // We could wait to compare fragment.selectionSet to result
          // after we verify the supertype, but this check is often less
          // expensive than that search, and we will have to do the
          // comparison anyway whenever we find a potential match.
          cy(e.selectionSet, n, i) && (c = !1, this.fuzzySubtypes.forEach(function(h, g) {
            var v = t.match(h);
            v && v[0] === t && u(g);
          }));
        }
      return !1;
    }, r.prototype.hasKeyArgs = function(e, t) {
      var n = this.getFieldPolicy(e, t);
      return !!(n && n.keyFn);
    }, r.prototype.getStoreFieldName = function(e) {
      var t = e.typename, n = e.fieldName, i = this.getFieldPolicy(t, n), a, s = i && i.keyFn;
      if (s && t)
        for (var o = {
          typename: t,
          fieldName: n,
          field: e.field || null,
          variables: e.variables
        }, l = fy(e); s; ) {
          var u = s(l, o);
          if (ni(u))
            s = Cw(u);
          else {
            a = u || n;
            break;
          }
        }
      return a === void 0 && (a = e.field ? pP(e.field, e.variables) : S2(n, fy(e))), a === !1 ? n : n === Hu(a) ? a : n + ":" + a;
    }, r.prototype.readField = function(e, t) {
      var n = e.from;
      if (n) {
        var i = e.field || e.fieldName;
        if (i) {
          if (e.typename === void 0) {
            var a = t.store.getFieldValue(n, "__typename");
            a && (e.typename = a);
          }
          var s = this.getStoreFieldName(e), o = Hu(s), l = t.store.getFieldValue(n, s), u = this.getFieldPolicy(e.typename, o), c = u && u.read;
          if (c) {
            var d = Tw(this, n, e, t, t.store.getStorage(Tn(n) ? n.__ref : n, s));
            return SA.withValue(this.cache, c, [
              l,
              d
            ]);
          }
          return l;
        }
      }
    }, r.prototype.getReadFunction = function(e, t) {
      var n = this.getFieldPolicy(e, t);
      return n && n.read;
    }, r.prototype.getMergeFunction = function(e, t, n) {
      var i = this.getFieldPolicy(e, t), a = i && i.merge;
      return !a && n && (i = this.getTypePolicy(n), a = i && i.merge), a;
    }, r.prototype.runMergeFunction = function(e, t, n, i, a) {
      var s = n.field, o = n.typename, l = n.merge;
      return l === Ew ? dk(i.store)(e, t) : l === kw ? t : (i.overwrite && (e = void 0), l(e, t, Tw(
        this,
        // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0,
        {
          typename: o,
          fieldName: s.name.value,
          field: s,
          variables: i.variables
        },
        i,
        a || /* @__PURE__ */ Object.create(null)
      )));
    }, r;
  })()
);
function Tw(r, e, t, n, i) {
  var a = r.getStoreFieldName(t), s = Hu(a), o = t.variables || n.variables, l = n.store, u = l.toReference, c = l.canRead;
  return {
    args: fy(t),
    field: t.field || null,
    fieldName: s,
    storeFieldName: a,
    variables: o,
    isReference: Tn,
    toReference: u,
    storage: i,
    cache: r.cache,
    canRead: c,
    readField: function() {
      return r.readField(TA(arguments, e, o), n);
    },
    mergeObjects: dk(n.store)
  };
}
function TA(r, e, t) {
  var n = r[0], i = r[1], a = r.length, s;
  return typeof n == "string" ? s = {
    fieldName: n,
    // Default to objectOrReference only when no second argument was
    // passed for the from parameter, not when undefined is explicitly
    // passed as the second argument.
    from: a > 1 ? i : e
  } : (s = me({}, n), gi.call(s, "from") || (s.from = e)), s.variables === void 0 && (s.variables = t), s;
}
function dk(r) {
  return function(t, n) {
    if (ni(t) || ni(n))
      throw Hi(9);
    if (li(t) && li(n)) {
      var i = r.getFieldValue(t, "__typename"), a = r.getFieldValue(n, "__typename"), s = i && a && i !== a;
      if (s)
        return n;
      if (Tn(t) && Eu(n))
        return r.merge(t.__ref, n), t;
      if (Eu(t) && Tn(n))
        return r.merge(t, n.__ref), n;
      if (Eu(t) && Eu(n))
        return me(me({}, t), n);
    }
    return n;
  };
}
function Ym(r, e, t) {
  var n = "".concat(e).concat(t), i = r.flavors.get(n);
  return i || r.flavors.set(n, i = r.clientOnly === e && r.deferred === t ? r : me(me({}, r), { clientOnly: e, deferred: t })), i;
}
var YR = (
  /** @class */
  (function() {
    function r(e, t, n) {
      this.cache = e, this.reader = t, this.fragments = n;
    }
    return r.prototype.writeToStore = function(e, t) {
      var n = this, i = t.query, a = t.result, s = t.dataId, o = t.variables, l = t.overwrite, u = tc(i), c = LR();
      o = me(me({}, pA(u)), o);
      var d = me(me({ store: e, written: /* @__PURE__ */ Object.create(null), merge: function(h, g) {
        return c.merge(h, g);
      }, variables: o, varString: fo(o) }, ok(i, this.fragments)), { overwrite: !!l, incomingById: /* @__PURE__ */ new Map(), clientOnly: !1, deferred: !1, flavors: /* @__PURE__ */ new Map() }), f = this.processSelectionSet({
        result: a || /* @__PURE__ */ Object.create(null),
        dataId: s,
        selectionSet: u.selectionSet,
        mergeTree: { map: /* @__PURE__ */ new Map() },
        context: d
      });
      if (!Tn(f))
        throw Hi(12, a);
      return d.incomingById.forEach(function(h, g) {
        var v = h.storeObject, y = h.mergeTree;
        h.fieldNodeSet;
        var A = Pu(g);
        if (y && y.map.size) {
          var x = n.applyMerges(y, A, v, d);
          if (Tn(x))
            return;
          v = x;
        }
        e.merge(g, v);
      }), e.retain(f.__ref), f;
    }, r.prototype.processSelectionSet = function(e) {
      var t = this, n = e.dataId, i = e.result, a = e.selectionSet, s = e.context, o = e.mergeTree, l = this.cache.policies, u = /* @__PURE__ */ Object.create(null), c = n && l.rootTypenamesById[n] || ey(i, a, s.fragmentMap) || n && s.store.get(n, "__typename");
      typeof c == "string" && (u.__typename = c);
      var d = function() {
        var k = TA(arguments, u, s.variables);
        if (Tn(k.from)) {
          var F = s.incomingById.get(k.from.__ref);
          if (F) {
            var S = l.readField(me(me({}, k), { from: F.storeObject }), s);
            if (S !== void 0)
              return S;
          }
        }
        return l.readField(k, s);
      }, f = /* @__PURE__ */ new Set();
      this.flattenFields(
        a,
        i,
        // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        s,
        c
      ).forEach(function(k, F) {
        var S, R = mo(F), M = i[R];
        if (f.add(F), M !== void 0) {
          var j = l.getStoreFieldName({
            typename: c,
            fieldName: F.name.value,
            field: F,
            variables: k.variables
          }), G = Fw(o, j), ie = t.processFieldValue(
            M,
            F,
            // Reset context.clientOnly and context.deferred to their default
            // values before processing nested selection sets.
            F.selectionSet ? Ym(k, !1, !1) : k,
            G
          ), q = void 0;
          F.selectionSet && (Tn(ie) || Eu(ie)) && (q = d("__typename", ie));
          var Y = l.getMergeFunction(c, F.name.value, q);
          Y ? G.info = {
            // TODO Check compatibility against any existing childTree.field?
            field: F,
            typename: c,
            merge: Y
          } : Iw(o, j), u = k.merge(u, (S = {}, S[j] = ie, S));
        }
      });
      try {
        var h = l.identify(i, {
          typename: c,
          selectionSet: a,
          fragmentMap: s.fragmentMap,
          storeObject: u,
          readField: d
        }), g = h[0], v = h[1];
        n = n || g, v && (u = s.merge(u, v));
      } catch (k) {
        if (!n)
          throw k;
      }
      if (typeof n == "string") {
        var y = Pu(n), A = s.written[n] || (s.written[n] = []);
        if (A.indexOf(a) >= 0 || (A.push(a), this.reader && this.reader.isFresh(i, y, a, s)))
          return y;
        var x = s.incomingById.get(n);
        return x ? (x.storeObject = s.merge(x.storeObject, u), x.mergeTree = dy(x.mergeTree, o), f.forEach(function(k) {
          return x.fieldNodeSet.add(k);
        })) : s.incomingById.set(n, {
          storeObject: u,
          // Save a reference to mergeTree only if it is not empty, because
          // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
          // reused for entirely different parts of the result tree.
          mergeTree: Qp(o) ? void 0 : o,
          fieldNodeSet: f
        }), y;
      }
      return u;
    }, r.prototype.processFieldValue = function(e, t, n, i) {
      var a = this;
      return !t.selectionSet || e === null ? e : ni(e) ? e.map(function(s, o) {
        var l = a.processFieldValue(s, t, n, Fw(i, o));
        return Iw(i, o), l;
      }) : this.processSelectionSet({
        result: e,
        selectionSet: t.selectionSet,
        context: n,
        mergeTree: i
      });
    }, r.prototype.flattenFields = function(e, t, n, i) {
      i === void 0 && (i = ey(t, e, n.fragmentMap));
      var a = /* @__PURE__ */ new Map(), s = this.cache.policies, o = new Os(!1);
      return (function l(u, c) {
        var d = o.lookup(
          u,
          // Because we take inheritedClientOnly and inheritedDeferred into
          // consideration here (in addition to selectionSet), it's possible for
          // the same selection set to be flattened more than once, if it appears
          // in the query with different @client and/or @directive configurations.
          c.clientOnly,
          c.deferred
        );
        d.visited || (d.visited = !0, u.selections.forEach(function(f) {
          if (wd(f, n.variables)) {
            var h = c.clientOnly, g = c.deferred;
            if (
              // Since the presence of @client or @defer on this field can only
              // cause clientOnly or deferred to become true, we can skip the
              // forEach loop if both clientOnly and deferred are already true.
              !(h && g) && as(f.directives) && f.directives.forEach(function(A) {
                var x = A.name.value;
                if (x === "client" && (h = !0), x === "defer") {
                  var k = xg(A, n.variables);
                  (!k || k.if !== !1) && (g = !0);
                }
              }), vo(f)
            ) {
              var v = a.get(f);
              v && (h = h && v.clientOnly, g = g && v.deferred), a.set(f, Ym(n, h, g));
            } else {
              var y = wg(f, n.lookupFragment);
              if (!y && f.kind === et.FRAGMENT_SPREAD)
                throw Hi(14, f.name.value);
              y && s.fragmentMatches(y, i, t, n.variables) && l(y.selectionSet, Ym(n, h, g));
            }
          }
        }));
      })(e, n), a;
    }, r.prototype.applyMerges = function(e, t, n, i, a) {
      var s, o = this;
      if (e.map.size && !Tn(n)) {
        var l = (
          // Items in the same position in different arrays are not
          // necessarily related to each other, so when incoming is an array
          // we process its elements as if there was no existing data.
          !ni(n) && // Likewise, existing must be either a Reference or a StoreObject
          // in order for its fields to be safe to merge with the fields of
          // the incoming object.
          (Tn(t) || Eu(t)) ? t : void 0
        ), u = n;
        l && !a && (a = [Tn(l) ? l.__ref : l]);
        var c, d = function(f, h) {
          return ni(f) ? typeof h == "number" ? f[h] : void 0 : i.store.getFieldValue(f, String(h));
        };
        e.map.forEach(function(f, h) {
          var g = d(l, h), v = d(u, h);
          if (v !== void 0) {
            a && a.push(h);
            var y = o.applyMerges(f, g, v, i, a);
            y !== v && (c = c || /* @__PURE__ */ new Map(), c.set(h, y)), a && Mr(a.pop() === h);
          }
        }), c && (n = ni(u) ? u.slice(0) : me({}, u), c.forEach(function(f, h) {
          n[h] = f;
        }));
      }
      return e.info ? this.cache.policies.runMergeFunction(t, n, e.info, i, a && (s = i.store).getStorage.apply(s, a)) : n;
    }, r;
  })()
), hk = [];
function Fw(r, e) {
  var t = r.map;
  return t.has(e) || t.set(e, hk.pop() || { map: /* @__PURE__ */ new Map() }), t.get(e);
}
function dy(r, e) {
  if (r === e || !e || Qp(e))
    return r;
  if (!r || Qp(r))
    return e;
  var t = r.info && e.info ? me(me({}, r.info), e.info) : r.info || e.info, n = r.map.size && e.map.size, i = n ? /* @__PURE__ */ new Map() : r.map.size ? r.map : e.map, a = { info: t, map: i };
  if (n) {
    var s = new Set(e.map.keys());
    r.map.forEach(function(o, l) {
      a.map.set(l, dy(o, e.map.get(l))), s.delete(l);
    }), s.forEach(function(o) {
      a.map.set(o, dy(e.map.get(o), r.map.get(o)));
    });
  }
  return a;
}
function Qp(r) {
  return !r || !(r.info || r.map.size);
}
function Iw(r, e) {
  var t = r.map, n = t.get(e);
  n && Qp(n) && (hk.push(n), t.delete(e));
}
var XR = (
  /** @class */
  (function(r) {
    pa(e, r);
    function e(t) {
      t === void 0 && (t = {});
      var n = r.call(this) || this;
      return n.watches = /* @__PURE__ */ new Set(), n.addTypenameTransform = new _2(U2), n.assumeImmutableResults = !0, n.makeVar = GR, n.txCount = 0, n.config = NR(t), n.addTypename = !!n.config.addTypename, n.policies = new QR({
        cache: n,
        dataIdFromObject: n.config.dataIdFromObject,
        possibleTypes: n.config.possibleTypes,
        typePolicies: n.config.typePolicies
      }), n.init(), n;
    }
    return e.prototype.init = function() {
      var t = this.data = new nd.Root({
        policies: this.policies,
        resultCaching: this.config.resultCaching
      });
      this.optimisticData = t.stump, this.resetResultCache();
    }, e.prototype.resetResultCache = function(t) {
      var n = this, i = this.storeReader, a = this.config.fragments;
      this.addTypenameTransform.resetCache(), a?.resetCaches(), this.storeWriter = new YR(this, this.storeReader = new $R({
        cache: this,
        addTypename: this.addTypename,
        resultCacheMaxSize: this.config.resultCacheMaxSize,
        canonizeResults: ak(this.config),
        canon: t ? void 0 : i && i.canon,
        fragments: a
      }), a), this.maybeBroadcastWatch = Vu(function(s, o) {
        return n.broadcastWatch(s, o);
      }, {
        max: this.config.resultCacheMaxSize || Rs["inMemoryCache.maybeBroadcastWatch"] || 5e3,
        makeCacheKey: function(s) {
          var o = s.optimistic ? n.optimisticData : n.data;
          if (Vf(o)) {
            var l = s.optimistic, u = s.id, c = s.variables;
            return o.makeCacheKey(
              s.query,
              // Different watches can have the same query, optimistic
              // status, rootId, and variables, but if their callbacks are
              // different, the (identical) result needs to be delivered to
              // each distinct callback. The easiest way to achieve that
              // separation is to include c.callback in the cache key for
              // maybeBroadcastWatch calls. See issue #5733.
              s.callback,
              fo({ optimistic: l, id: u, variables: c })
            );
          }
        }
      }), (/* @__PURE__ */ new Set([this.data.group, this.optimisticData.group])).forEach(function(s) {
        return s.resetCaching();
      });
    }, e.prototype.restore = function(t) {
      return this.init(), t && this.data.replace(t), this;
    }, e.prototype.extract = function(t) {
      return t === void 0 && (t = !1), (t ? this.optimisticData : this.data).extract();
    }, e.prototype.read = function(t) {
      var n = t.returnPartialData, i = n === void 0 ? !1 : n;
      try {
        return this.storeReader.diffQueryAgainstStore(me(me({}, t), { store: t.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: i })).result || null;
      } catch (a) {
        if (a instanceof rk)
          return null;
        throw a;
      }
    }, e.prototype.write = function(t) {
      try {
        return ++this.txCount, this.storeWriter.writeToStore(this.data, t);
      } finally {
        !--this.txCount && t.broadcast !== !1 && this.broadcastWatches();
      }
    }, e.prototype.modify = function(t) {
      if (gi.call(t, "id") && !t.id)
        return !1;
      var n = t.optimistic ? this.optimisticData : this.data;
      try {
        return ++this.txCount, n.modify(t.id || "ROOT_QUERY", t.fields);
      } finally {
        !--this.txCount && t.broadcast !== !1 && this.broadcastWatches();
      }
    }, e.prototype.diff = function(t) {
      return this.storeReader.diffQueryAgainstStore(me(me({}, t), { store: t.optimistic ? this.optimisticData : this.data, rootId: t.id || "ROOT_QUERY", config: this.config }));
    }, e.prototype.watch = function(t) {
      var n = this;
      return this.watches.size || jR(this), this.watches.add(t), t.immediate && this.maybeBroadcastWatch(t), function() {
        n.watches.delete(t) && !n.watches.size && bw(n), n.maybeBroadcastWatch.forget(t);
      };
    }, e.prototype.gc = function(t) {
      fo.reset(), hl.reset();
      var n = this.optimisticData.gc();
      return t && !this.txCount && (t.resetResultCache ? this.resetResultCache(t.resetResultIdentities) : t.resetResultIdentities && this.storeReader.resetCanon()), n;
    }, e.prototype.retain = function(t, n) {
      return (n ? this.optimisticData : this.data).retain(t);
    }, e.prototype.release = function(t, n) {
      return (n ? this.optimisticData : this.data).release(t);
    }, e.prototype.identify = function(t) {
      if (Tn(t))
        return t.__ref;
      try {
        return this.policies.identify(t)[0];
      } catch {
      }
    }, e.prototype.evict = function(t) {
      if (!t.id) {
        if (gi.call(t, "id"))
          return !1;
        t = me(me({}, t), { id: "ROOT_QUERY" });
      }
      try {
        return ++this.txCount, this.optimisticData.evict(t, this.data);
      } finally {
        !--this.txCount && t.broadcast !== !1 && this.broadcastWatches();
      }
    }, e.prototype.reset = function(t) {
      var n = this;
      return this.init(), fo.reset(), t && t.discardWatches ? (this.watches.forEach(function(i) {
        return n.maybeBroadcastWatch.forget(i);
      }), this.watches.clear(), bw(this)) : this.broadcastWatches(), Promise.resolve();
    }, e.prototype.removeOptimistic = function(t) {
      var n = this.optimisticData.removeLayer(t);
      n !== this.optimisticData && (this.optimisticData = n, this.broadcastWatches());
    }, e.prototype.batch = function(t) {
      var n = this, i = t.update, a = t.optimistic, s = a === void 0 ? !0 : a, o = t.removeOptimistic, l = t.onWatchUpdated, u, c = function(f) {
        var h = n, g = h.data, v = h.optimisticData;
        ++n.txCount, f && (n.data = n.optimisticData = f);
        try {
          return u = i(n);
        } finally {
          --n.txCount, n.data = g, n.optimisticData = v;
        }
      }, d = /* @__PURE__ */ new Set();
      return l && !this.txCount && this.broadcastWatches(me(me({}, t), { onWatchUpdated: function(f) {
        return d.add(f), !1;
      } })), typeof s == "string" ? this.optimisticData = this.optimisticData.addLayer(s, c) : s === !1 ? c(this.data) : c(), typeof o == "string" && (this.optimisticData = this.optimisticData.removeLayer(o)), l && d.size ? (this.broadcastWatches(me(me({}, t), { onWatchUpdated: function(f, h) {
        var g = l.call(this, f, h);
        return g !== !1 && d.delete(f), g;
      } })), d.size && d.forEach(function(f) {
        return n.maybeBroadcastWatch.dirty(f);
      })) : this.broadcastWatches(t), u;
    }, e.prototype.performTransaction = function(t, n) {
      return this.batch({
        update: t,
        optimistic: n || n !== null
      });
    }, e.prototype.transformDocument = function(t) {
      return this.addTypenameToDocument(this.addFragmentsToDocument(t));
    }, e.prototype.fragmentMatches = function(t, n) {
      return this.policies.fragmentMatches(t, n);
    }, e.prototype.lookupFragment = function(t) {
      var n;
      return ((n = this.config.fragments) === null || n === void 0 ? void 0 : n.lookup(t)) || null;
    }, e.prototype.broadcastWatches = function(t) {
      var n = this;
      this.txCount || this.watches.forEach(function(i) {
        return n.maybeBroadcastWatch(i, t);
      });
    }, e.prototype.addFragmentsToDocument = function(t) {
      var n = this.config.fragments;
      return n ? n.transform(t) : t;
    }, e.prototype.addTypenameToDocument = function(t) {
      return this.addTypename ? this.addTypenameTransform.transformDocument(t) : t;
    }, e.prototype.broadcastWatch = function(t, n) {
      var i = this, a = t.lastDiff, s = Di("canonizeResults", function() {
        return i.diff(t);
      });
      n && (t.optimistic && typeof n.optimistic == "string" && (s.fromOptimisticTransaction = !0), n.onWatchUpdated && n.onWatchUpdated.call(this, t, s, a) === !1) || (!a || !Dn(a.result, s.result)) && t.callback(t.lastDiff = s, a);
    }, e;
  })(_R)
), Jr;
(function(r) {
  r[r.loading = 1] = "loading", r[r.setVariables = 2] = "setVariables", r[r.fetchMore = 3] = "fetchMore", r[r.refetch = 4] = "refetch", r[r.poll = 6] = "poll", r[r.ready = 7] = "ready", r[r.error = 8] = "error";
})(Jr || (Jr = {}));
function ku(r) {
  return r ? r < 7 : !1;
}
var Dw = Object.assign, Ip = (
  /** @class */
  (function(r) {
    pa(e, r);
    function e(t) {
      var n = t.queryManager, i = t.queryInfo, a = t.options, s = this, o = e.inactiveOnCreation.getValue();
      s = r.call(this, function(A) {
        s._getOrCreateQuery();
        try {
          var x = A._subscription._observer;
          x && !x.error && (x.error = JR);
        } catch {
        }
        var k = !s.observers.size;
        s.observers.add(A);
        var F = s.last;
        return F && F.error ? A.error && A.error(F.error) : F && F.result && A.next && A.next(s.maskResult(F.result)), k && s.reobserve().catch(function() {
        }), function() {
          s.observers.delete(A) && !s.observers.size && s.tearDownQuery();
        };
      }) || this, s.observers = /* @__PURE__ */ new Set(), s.subscriptions = /* @__PURE__ */ new Set(), s.dirty = !1, s._getOrCreateQuery = function() {
        return o && (n.queries.set(s.queryId, i), o = !1), s.queryManager.getOrCreateQuery(s.queryId);
      }, s.queryInfo = i, s.queryManager = n, s.waitForOwnResult = Xm(a.fetchPolicy), s.isTornDown = !1, s.subscribeToMore = s.subscribeToMore.bind(s), s.maskResult = s.maskResult.bind(s);
      var l = n.defaultOptions.watchQuery, u = l === void 0 ? {} : l, c = u.fetchPolicy, d = c === void 0 ? "cache-first" : c, f = a.fetchPolicy, h = f === void 0 ? d : f, g = a.initialFetchPolicy, v = g === void 0 ? h === "standby" ? d : h : g;
      s.options = me(me({}, a), {
        // Remember the initial options.fetchPolicy so we can revert back to this
        // policy when variables change. This information can also be specified
        // (or overridden) by providing options.initialFetchPolicy explicitly.
        initialFetchPolicy: v,
        // This ensures this.options.fetchPolicy always has a string value, in
        // case options.fetchPolicy was not provided.
        fetchPolicy: h
      }), s.queryId = i.queryId || n.generateQueryId();
      var y = tc(s.query);
      return s.queryName = y && y.name && y.name.value, s;
    }
    return Object.defineProperty(e.prototype, "query", {
      // The `query` computed property will always reflect the document transformed
      // by the last run query. `this.options.query` will always reflect the raw
      // untransformed query to ensure document transforms with runtime conditionals
      // are run on the original document.
      get: function() {
        return this.lastQuery || this.options.query;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "variables", {
      // Computed shorthand for this.options.variables, preserved for
      // backwards compatibility.
      /**
       * An object containing the variables that were provided for the query.
       */
      get: function() {
        return this.options.variables;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.result = function() {
      var t = this;
      return new Promise(function(n, i) {
        var a = {
          next: function(o) {
            n(o), t.observers.delete(a), t.observers.size || t.queryManager.removeQuery(t.queryId), setTimeout(function() {
              s.unsubscribe();
            }, 0);
          },
          error: i
        }, s = t.subscribe(a);
      });
    }, e.prototype.resetDiff = function() {
      this.queryInfo.resetDiff();
    }, e.prototype.getCurrentFullResult = function(t) {
      var n = this;
      t === void 0 && (t = !0);
      var i = Di("getLastResult", function() {
        return n.getLastResult(!0);
      }), a = this.queryInfo.networkStatus || i && i.networkStatus || Jr.ready, s = me(me({}, i), { loading: ku(a), networkStatus: a }), o = this.options.fetchPolicy, l = o === void 0 ? "cache-first" : o;
      if (
        // These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        !(Xm(l) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers)
      ) if (this.waitForOwnResult)
        this.queryInfo.updateWatch();
      else {
        var u = this.queryInfo.getDiff();
        (u.complete || this.options.returnPartialData) && (s.data = u.result), Dn(s.data, {}) && (s.data = void 0), u.complete ? (delete s.partial, u.complete && s.networkStatus === Jr.loading && (l === "cache-first" || l === "cache-only") && (s.networkStatus = Jr.ready, s.loading = !1)) : s.partial = !0, s.networkStatus === Jr.ready && (s.error || s.errors) && (s.networkStatus = Jr.error);
      }
      return t && this.updateLastResult(s), s;
    }, e.prototype.getCurrentResult = function(t) {
      return t === void 0 && (t = !0), this.maskResult(this.getCurrentFullResult(t));
    }, e.prototype.isDifferentFromLastResult = function(t, n) {
      if (!this.last)
        return !0;
      var i = this.queryManager.getDocumentInfo(this.query), a = this.queryManager.dataMasking, s = a ? i.nonReactiveQuery : this.query, o = a || i.hasNonreactiveDirective ? !X2(s, this.last.result, t, this.variables) : !Dn(this.last.result, t);
      return o || n && !Dn(this.last.variables, n);
    }, e.prototype.getLast = function(t, n) {
      var i = this.last;
      if (i && i[t] && (!n || Dn(i.variables, this.variables)))
        return i[t];
    }, e.prototype.getLastResult = function(t) {
      return this.getLast("result", t);
    }, e.prototype.getLastError = function(t) {
      return this.getLast("error", t);
    }, e.prototype.resetLastResults = function() {
      delete this.last, this.isTornDown = !1;
    }, e.prototype.resetQueryStoreErrors = function() {
      this.queryManager.resetErrors(this.queryId);
    }, e.prototype.refetch = function(t) {
      var n = {
        // Always disable polling for refetches.
        pollInterval: 0
      }, i = this.options.fetchPolicy;
      return i === "no-cache" ? n.fetchPolicy = "no-cache" : n.fetchPolicy = "network-only", t && !Dn(this.options.variables, t) && (n.variables = this.options.variables = me(me({}, this.options.variables), t)), this.queryInfo.resetLastWrite(), this.reobserve(n, Jr.refetch);
    }, e.prototype.fetchMore = function(t) {
      var n = this, i = me(me({}, t.query ? t : me(me(me(me({}, this.options), { query: this.options.query }), t), { variables: me(me({}, this.options.variables), t.variables) })), {
        // The fetchMore request goes immediately to the network and does
        // not automatically write its result to the cache (hence no-cache
        // instead of network-only), because we allow the caller of
        // fetchMore to provide an updateQuery callback that determines how
        // the data gets written to the cache.
        fetchPolicy: "no-cache"
      });
      i.query = this.transformDocument(i.query);
      var a = this.queryManager.generateQueryId();
      this.lastQuery = t.query ? this.transformDocument(this.options.query) : i.query;
      var s = this.queryInfo, o = s.networkStatus;
      s.networkStatus = Jr.fetchMore, i.notifyOnNetworkStatusChange && this.observe();
      var l = /* @__PURE__ */ new Set(), u = t?.updateQuery, c = this.options.fetchPolicy !== "no-cache";
      return c || Mr(u, 29), this.queryManager.fetchQuery(a, i, Jr.fetchMore).then(function(d) {
        if (n.queryManager.removeQuery(a), s.networkStatus === Jr.fetchMore && (s.networkStatus = o), c)
          n.queryManager.cache.batch({
            update: function(g) {
              var v = t.updateQuery;
              v ? g.updateQuery({
                query: n.query,
                variables: n.variables,
                returnPartialData: !0,
                optimistic: !1
              }, function(y) {
                return v(y, {
                  fetchMoreResult: d.data,
                  variables: i.variables
                });
              }) : g.writeQuery({
                query: i.query,
                variables: i.variables,
                data: d.data
              });
            },
            onWatchUpdated: function(g) {
              l.add(g.query);
            }
          });
        else {
          var f = n.getLast("result"), h = u(f.data, {
            fetchMoreResult: d.data,
            variables: i.variables
          });
          n.reportResult(me(me({}, f), { networkStatus: o, loading: ku(o), data: h }), n.variables);
        }
        return n.maskResult(d);
      }).finally(function() {
        c && !l.has(n.query) && n.reobserveCacheFirst();
      });
    }, e.prototype.subscribeToMore = function(t) {
      var n = this, i = this.queryManager.startGraphQLSubscription({
        query: t.document,
        variables: t.variables,
        context: t.context
      }).subscribe({
        next: function(a) {
          var s = t.updateQuery;
          s && n.updateQuery(function(o, l) {
            return s(o, me({ subscriptionData: a }, l));
          });
        },
        error: function(a) {
          if (t.onError) {
            t.onError(a);
            return;
          }
        }
      });
      return this.subscriptions.add(i), function() {
        n.subscriptions.delete(i) && i.unsubscribe();
      };
    }, e.prototype.setOptions = function(t) {
      return this.reobserve(t);
    }, e.prototype.silentSetOptions = function(t) {
      var n = $u(this.options, t || {});
      Dw(this.options, n);
    }, e.prototype.setVariables = function(t) {
      var n = this;
      return Dn(this.variables, t) ? this.observers.size ? Di("observableQuery.result", function() {
        return n.result();
      }) : Promise.resolve() : (this.options.variables = t, this.observers.size ? this.reobserve({
        // Reset options.fetchPolicy to its original value.
        fetchPolicy: this.options.initialFetchPolicy,
        variables: t
      }, Jr.setVariables) : Promise.resolve());
    }, e.prototype.updateQuery = function(t) {
      var n = this.queryManager, i = n.cache.diff({
        query: this.options.query,
        variables: this.variables,
        returnPartialData: !0,
        optimistic: !1
      }), a = i.result, s = i.complete, o = t(a, {
        variables: this.variables,
        complete: !!s,
        previousData: a
      });
      o && (n.cache.writeQuery({
        query: this.options.query,
        data: o,
        variables: this.variables
      }), n.broadcastQueries());
    }, e.prototype.startPolling = function(t) {
      this.options.pollInterval = t, this.updatePolling();
    }, e.prototype.stopPolling = function() {
      this.options.pollInterval = 0, this.updatePolling();
    }, e.prototype.applyNextFetchPolicy = function(t, n) {
      if (n.nextFetchPolicy) {
        var i = n.fetchPolicy, a = i === void 0 ? "cache-first" : i, s = n.initialFetchPolicy, o = s === void 0 ? a : s;
        a === "standby" || (typeof n.nextFetchPolicy == "function" ? n.fetchPolicy = n.nextFetchPolicy(a, {
          reason: t,
          options: n,
          observable: this,
          initialFetchPolicy: o
        }) : t === "variables-changed" ? n.fetchPolicy = o : n.fetchPolicy = n.nextFetchPolicy);
      }
      return n.fetchPolicy;
    }, e.prototype.fetch = function(t, n, i) {
      var a = this._getOrCreateQuery();
      return a.setObservableQuery(this), this.queryManager.fetchConcastWithInfo(a, t, n, i);
    }, e.prototype.updatePolling = function() {
      var t = this;
      if (!this.queryManager.ssrMode) {
        var n = this, i = n.pollingInfo, a = n.options.pollInterval;
        if (!a || !this.hasObservers()) {
          i && (clearTimeout(i.timeout), delete this.pollingInfo);
          return;
        }
        if (!(i && i.interval === a)) {
          Mr(a, 32);
          var s = i || (this.pollingInfo = {});
          s.interval = a;
          var o = function() {
            var u, c;
            t.pollingInfo && (!ku(t.queryInfo.networkStatus) && !(!((c = (u = t.options).skipPollAttempt) === null || c === void 0) && c.call(u)) ? t.reobserve({
              // Most fetchPolicy options don't make sense to use in a polling context, as
              // users wouldn't want to be polling the cache directly. However, network-only and
              // no-cache are both useful for when the user wants to control whether or not the
              // polled results are written to the cache.
              fetchPolicy: t.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
            }, Jr.poll).then(l, l) : l());
          }, l = function() {
            var u = t.pollingInfo;
            u && (clearTimeout(u.timeout), u.timeout = setTimeout(o, u.interval));
          };
          l();
        }
      }
    }, e.prototype.updateLastResult = function(t, n) {
      var i = this;
      n === void 0 && (n = this.variables);
      var a = Di("getLastError", function() {
        return i.getLastError();
      });
      return a && this.last && !Dn(n, this.last.variables) && (a = void 0), this.last = me({ result: this.queryManager.assumeImmutableResults ? t : WP(t), variables: n }, a ? { error: a } : null);
    }, e.prototype.reobserveAsConcast = function(t, n) {
      var i = this;
      this.isTornDown = !1;
      var a = (
        // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        n === Jr.refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        n === Jr.fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        n === Jr.poll
      ), s = this.options.variables, o = this.options.fetchPolicy, l = $u(this.options, t || {}), u = a ? (
        // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        l
      ) : Dw(this.options, l), c = this.transformDocument(u.query);
      this.lastQuery = c, a || (this.updatePolling(), t && t.variables && !Dn(t.variables, s) && // Don't mess with the fetchPolicy if it's currently "standby".
      u.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
      // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
      (u.fetchPolicy === o || // A `nextFetchPolicy` function has even higher priority, though,
      // so in that case `applyNextFetchPolicy` must be called.
      typeof u.nextFetchPolicy == "function") && (this.applyNextFetchPolicy("variables-changed", u), n === void 0 && (n = Jr.setVariables))), this.waitForOwnResult && (this.waitForOwnResult = Xm(u.fetchPolicy));
      var d = function() {
        i.concast === g && (i.waitForOwnResult = !1);
      }, f = u.variables && me({}, u.variables), h = this.fetch(u, n, c), g = h.concast, v = h.fromLink, y = {
        next: function(A) {
          Dn(i.variables, f) && (d(), i.reportResult(A, f));
        },
        error: function(A) {
          Dn(i.variables, f) && (W2(A) || (A = new ro({ networkError: A })), d(), i.reportError(A, f));
        }
      };
      return !a && (v || !this.concast) && (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = g, this.observer = y), g.addObserver(y), g;
    }, e.prototype.reobserve = function(t, n) {
      return GP(this.reobserveAsConcast(t, n).promise.then(this.maskResult));
    }, e.prototype.resubscribeAfterError = function() {
      for (var t = this, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var a = this.last;
      Di("resetLastResults", function() {
        return t.resetLastResults();
      });
      var s = this.subscribe.apply(this, n);
      return this.last = a, s;
    }, e.prototype.observe = function() {
      this.reportResult(
        // Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentFullResult(!1),
        this.variables
      );
    }, e.prototype.reportResult = function(t, n) {
      var i = this, a = Di("getLastError", function() {
        return i.getLastError();
      }), s = this.isDifferentFromLastResult(t, n);
      (a || !t.partial || this.options.returnPartialData) && this.updateLastResult(t, n), (a || s) && Uf(this.observers, "next", this.maskResult(t));
    }, e.prototype.reportError = function(t, n) {
      var i = this, a = me(me({}, Di("getLastResult", function() {
        return i.getLastResult();
      })), { error: t, errors: t.graphQLErrors, networkStatus: Jr.error, loading: !1 });
      this.updateLastResult(a, n), Uf(this.observers, "error", this.last.error = t);
    }, e.prototype.hasObservers = function() {
      return this.observers.size > 0;
    }, e.prototype.tearDownQuery = function() {
      this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(t) {
        return t.unsubscribe();
      }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
    }, e.prototype.transformDocument = function(t) {
      return this.queryManager.transform(t);
    }, e.prototype.maskResult = function(t) {
      return t && "data" in t ? me(me({}, t), { data: this.queryManager.maskOperation({
        document: this.query,
        data: t.data,
        fetchPolicy: this.options.fetchPolicy,
        id: this.queryId
      }) }) : t;
    }, e.prototype.resetNotifications = function() {
      this.cancelNotifyTimeout(), this.dirty = !1;
    }, e.prototype.cancelNotifyTimeout = function() {
      this.notifyTimeout && (clearTimeout(this.notifyTimeout), this.notifyTimeout = void 0);
    }, e.prototype.scheduleNotify = function() {
      var t = this;
      this.dirty || (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function() {
        return t.notify();
      }, 0)));
    }, e.prototype.notify = function() {
      if (this.cancelNotifyTimeout(), this.dirty && (this.options.fetchPolicy == "cache-only" || this.options.fetchPolicy == "cache-and-network" || !ku(this.queryInfo.networkStatus))) {
        var t = this.queryInfo.getDiff();
        t.fromOptimisticTransaction ? this.observe() : this.reobserveCacheFirst();
      }
      this.dirty = !1;
    }, e.prototype.reobserveCacheFirst = function() {
      var t = this.options, n = t.fetchPolicy, i = t.nextFetchPolicy;
      return n === "cache-and-network" || n === "network-only" ? this.reobserve({
        fetchPolicy: "cache-first",
        // Use a temporary nextFetchPolicy function that replaces itself with the
        // previous nextFetchPolicy value and returns the original fetchPolicy.
        nextFetchPolicy: function(a, s) {
          return this.nextFetchPolicy = i, typeof this.nextFetchPolicy == "function" ? this.nextFetchPolicy(a, s) : n;
        }
      }) : this.reobserve();
    }, e.inactiveOnCreation = new nc(), e;
  })(nn)
);
j2(Ip);
function JR(r) {
}
function Xm(r) {
  return r === "network-only" || r === "no-cache" || r === "standby";
}
var Tu = new (Cl ? WeakMap : Map)();
function Jm(r, e) {
  var t = r[e];
  typeof t == "function" && (r[e] = function() {
    return Tu.set(
      r,
      // The %1e15 allows the count to wrap around to 0 safely every
      // quadrillion evictions, so there's no risk of overflow. To be
      // clear, this is more of a pedantic principle than something
      // that matters in any conceivable practical scenario.
      (Tu.get(r) + 1) % 1e15
    ), t.apply(this, arguments);
  });
}
var Km = (
  /** @class */
  (function() {
    function r(e, t) {
      t === void 0 && (t = e.generateQueryId()), this.queryId = t, this.document = null, this.lastRequestId = 1, this.stopped = !1, this.observableQuery = null;
      var n = this.cache = e.cache;
      Tu.has(n) || (Tu.set(n, 0), Jm(n, "evict"), Jm(n, "modify"), Jm(n, "reset"));
    }
    return r.prototype.init = function(e) {
      var t = e.networkStatus || Jr.loading;
      return this.variables && this.networkStatus !== Jr.loading && !Dn(this.variables, e.variables) && (t = Jr.setVariables), Dn(e.variables, this.variables) || (this.lastDiff = void 0, this.cancel()), Object.assign(this, {
        document: e.document,
        variables: e.variables,
        networkError: null,
        graphQLErrors: this.graphQLErrors || [],
        networkStatus: t
      }), e.observableQuery && this.setObservableQuery(e.observableQuery), e.lastRequestId && (this.lastRequestId = e.lastRequestId), this;
    }, r.prototype.resetDiff = function() {
      this.lastDiff = void 0;
    }, r.prototype.getDiff = function() {
      var e = this, t = this.getDiffOptions();
      if (this.lastDiff && Dn(t, this.lastDiff.options))
        return this.lastDiff.diff;
      this.updateWatch(this.variables);
      var n = this.observableQuery;
      if (n && n.options.fetchPolicy === "no-cache")
        return { complete: !1 };
      var i = Di("canonizeResults", function() {
        return e.cache.diff(t);
      });
      return this.updateLastDiff(i, t), i;
    }, r.prototype.updateLastDiff = function(e, t) {
      this.lastDiff = e ? {
        diff: e,
        options: t || this.getDiffOptions()
      } : void 0;
    }, r.prototype.getDiffOptions = function(e) {
      var t;
      return e === void 0 && (e = this.variables), {
        query: this.document,
        variables: e,
        returnPartialData: !0,
        optimistic: !0,
        canonizeResults: (t = this.observableQuery) === null || t === void 0 ? void 0 : t.options.canonizeResults
      };
    }, r.prototype.setDiff = function(e) {
      var t = this, n, i = this.lastDiff && this.lastDiff.diff;
      e && !e.complete && Di("getLastError", function() {
        var a;
        return (a = t.observableQuery) === null || a === void 0 ? void 0 : a.getLastError();
      }) || (this.updateLastDiff(e), Dn(i && i.result, e && e.result) || (n = this.observableQuery) === null || n === void 0 || n.scheduleNotify());
    }, r.prototype.setObservableQuery = function(e) {
      e !== this.observableQuery && (this.observableQuery = e, e && (e.queryInfo = this));
    }, r.prototype.stop = function() {
      var e;
      if (!this.stopped) {
        this.stopped = !0, (e = this.observableQuery) === null || e === void 0 || e.resetNotifications(), this.cancel();
        var t = this.observableQuery;
        t && t.stopPolling();
      }
    }, r.prototype.cancel = function() {
      var e;
      (e = this.cancelWatch) === null || e === void 0 || e.call(this), this.cancelWatch = void 0;
    }, r.prototype.updateWatch = function(e) {
      var t = this;
      e === void 0 && (e = this.variables);
      var n = this.observableQuery;
      if (!(n && n.options.fetchPolicy === "no-cache")) {
        var i = me(me({}, this.getDiffOptions(e)), { watcher: this, callback: function(a) {
          return t.setDiff(a);
        } });
        (!this.lastWatch || !Dn(i, this.lastWatch)) && (this.cancel(), this.cancelWatch = this.cache.watch(this.lastWatch = i));
      }
    }, r.prototype.resetLastWrite = function() {
      this.lastWrite = void 0;
    }, r.prototype.shouldWrite = function(e, t) {
      var n = this.lastWrite;
      return !(n && // If cache.evict has been called since the last time we wrote this
      // data into the cache, there's a chance writing this result into
      // the cache will repair what was evicted.
      n.dmCount === Tu.get(this.cache) && Dn(t, n.variables) && Dn(e.data, n.result.data));
    }, r.prototype.markResult = function(e, t, n, i) {
      var a = this, s, o = new Ao(), l = as(e.errors) ? e.errors.slice(0) : [];
      if ((s = this.observableQuery) === null || s === void 0 || s.resetNotifications(), "incremental" in e && as(e.incremental)) {
        var u = G2(this.getDiff().result, e);
        e.data = u;
      } else if ("hasNext" in e && e.hasNext) {
        var c = this.getDiff();
        e.data = o.merge(c.result, e.data);
      }
      this.graphQLErrors = l, n.fetchPolicy === "no-cache" ? this.updateLastDiff({ result: e.data, complete: !0 }, this.getDiffOptions(n.variables)) : i !== 0 && (hy(e, n.errorPolicy) ? this.cache.performTransaction(function(d) {
        if (a.shouldWrite(e, n.variables))
          d.writeQuery({
            query: t,
            data: e.data,
            variables: n.variables,
            overwrite: i === 1
          }), a.lastWrite = {
            result: e,
            variables: n.variables,
            dmCount: Tu.get(a.cache)
          };
        else if (a.lastDiff && a.lastDiff.diff.complete) {
          e.data = a.lastDiff.diff.result;
          return;
        }
        var f = a.getDiffOptions(n.variables), h = Di("canonizeResults", function() {
          return d.diff(f);
        });
        !a.stopped && Dn(a.variables, n.variables) && a.updateWatch(n.variables), a.updateLastDiff(h, f), h.complete && (e.data = h.result);
      }) : this.lastWrite = void 0);
    }, r.prototype.markReady = function() {
      return this.networkError = null, this.networkStatus = Jr.ready;
    }, r.prototype.markError = function(e) {
      var t;
      return this.networkStatus = Jr.error, this.lastWrite = void 0, (t = this.observableQuery) === null || t === void 0 || t.resetNotifications(), e.graphQLErrors && (this.graphQLErrors = e.graphQLErrors), e.networkError && (this.networkError = e.networkError), e;
    }, r;
  })()
);
function hy(r, e) {
  e === void 0 && (e = "none");
  var t = e === "ignore" || e === "all", n = !kp(r);
  return !n && t && r.data && (n = !0), n;
}
var KR = Object.prototype.hasOwnProperty, Pw = /* @__PURE__ */ Object.create(null), ZR = (
  /** @class */
  (function() {
    function r(e) {
      var t = this;
      this.clientAwareness = {}, this.queries = /* @__PURE__ */ new Map(), this.fetchCancelFns = /* @__PURE__ */ new Map(), this.transformCache = new C2(
        Rs["queryManager.getDocumentInfo"] || 2e3
        /* defaultCacheSizes["queryManager.getDocumentInfo"] */
      ), this.queryIdCounter = 1, this.requestIdCounter = 1, this.mutationIdCounter = 1, this.inFlightLinkObservables = new Os(!1), this.noCacheWarningsByQueryId = /* @__PURE__ */ new Set();
      var n = new _2(
        function(a) {
          return t.cache.transformDocument(a);
        },
        // Allow the apollo cache to manage its own transform caches
        { cache: !1 }
      );
      this.cache = e.cache, this.link = e.link, this.defaultOptions = e.defaultOptions, this.queryDeduplication = e.queryDeduplication, this.clientAwareness = e.clientAwareness, this.localState = e.localState, this.ssrMode = e.ssrMode, this.assumeImmutableResults = e.assumeImmutableResults, this.dataMasking = e.dataMasking;
      var i = e.documentTransform;
      this.documentTransform = i ? n.concat(i).concat(n) : n, this.defaultContext = e.defaultContext || /* @__PURE__ */ Object.create(null), (this.onBroadcast = e.onBroadcast) && (this.mutationStore = /* @__PURE__ */ Object.create(null));
    }
    return r.prototype.stop = function() {
      var e = this;
      this.queries.forEach(function(t, n) {
        e.stopQueryNoBroadcast(n);
      }), this.cancelPendingFetches(Hi(35));
    }, r.prototype.cancelPendingFetches = function(e) {
      this.fetchCancelFns.forEach(function(t) {
        return t(e);
      }), this.fetchCancelFns.clear();
    }, r.prototype.mutate = function(e) {
      return Ka(this, arguments, void 0, function(t) {
        var n, i, a, s, o, l, u, c = t.mutation, d = t.variables, f = t.optimisticResponse, h = t.updateQueries, g = t.refetchQueries, v = g === void 0 ? [] : g, y = t.awaitRefetchQueries, A = y === void 0 ? !1 : y, x = t.update, k = t.onQueryUpdated, F = t.fetchPolicy, S = F === void 0 ? ((l = this.defaultOptions.mutate) === null || l === void 0 ? void 0 : l.fetchPolicy) || "network-only" : F, R = t.errorPolicy, M = R === void 0 ? ((u = this.defaultOptions.mutate) === null || u === void 0 ? void 0 : u.errorPolicy) || "none" : R, j = t.keepRootFields, G = t.context;
        return Za(this, function(ie) {
          switch (ie.label) {
            case 0:
              return Mr(c, 36), Mr(S === "network-only" || S === "no-cache", 37), n = this.generateMutationId(), c = this.cache.transformForLink(this.transform(c)), i = this.getDocumentInfo(c).hasClientExports, d = this.getVariables(c, d), i ? [4, this.localState.addExportedVariables(c, d, G)] : [3, 2];
            case 1:
              d = ie.sent(), ie.label = 2;
            case 2:
              return a = this.mutationStore && (this.mutationStore[n] = {
                mutation: c,
                variables: d,
                loading: !0,
                error: null
              }), s = f && this.markMutationOptimistic(f, {
                mutationId: n,
                document: c,
                variables: d,
                fetchPolicy: S,
                errorPolicy: M,
                context: G,
                updateQueries: h,
                update: x,
                keepRootFields: j
              }), this.broadcastQueries(), o = this, [2, new Promise(function(q, Y) {
                return Hm(o.getObservableFromLink(c, me(me({}, G), { optimisticResponse: s ? f : void 0 }), d, {}, !1), function(J) {
                  if (kp(J) && M === "none")
                    throw new ro({
                      graphQLErrors: iy(J)
                    });
                  a && (a.loading = !1, a.error = null);
                  var se = me({}, J);
                  return typeof v == "function" && (v = v(se)), M === "ignore" && kp(se) && delete se.errors, o.markMutationResult({
                    mutationId: n,
                    result: se,
                    document: c,
                    variables: d,
                    fetchPolicy: S,
                    errorPolicy: M,
                    context: G,
                    update: x,
                    updateQueries: h,
                    awaitRefetchQueries: A,
                    refetchQueries: v,
                    removeOptimistic: s ? n : void 0,
                    onQueryUpdated: k,
                    keepRootFields: j
                  });
                }).subscribe({
                  next: function(J) {
                    o.broadcastQueries(), (!("hasNext" in J) || J.hasNext === !1) && q(me(me({}, J), { data: o.maskOperation({
                      document: c,
                      data: J.data,
                      fetchPolicy: S,
                      id: n
                    }) }));
                  },
                  error: function(J) {
                    a && (a.loading = !1, a.error = J), s && o.cache.removeOptimistic(n), o.broadcastQueries(), Y(J instanceof ro ? J : new ro({
                      networkError: J
                    }));
                  }
                });
              })];
          }
        });
      });
    }, r.prototype.markMutationResult = function(e, t) {
      var n = this;
      t === void 0 && (t = this.cache);
      var i = e.result, a = [], s = e.fetchPolicy === "no-cache";
      if (!s && hy(i, e.errorPolicy)) {
        if (Ru(i) || a.push({
          result: i.data,
          dataId: "ROOT_MUTATION",
          query: e.document,
          variables: e.variables
        }), Ru(i) && as(i.incremental)) {
          var o = t.diff({
            id: "ROOT_MUTATION",
            // The cache complains if passed a mutation where it expects a
            // query, so we transform mutations and subscriptions to queries
            // (only once, thanks to this.transformCache).
            query: this.getDocumentInfo(e.document).asQuery,
            variables: e.variables,
            optimistic: !1,
            returnPartialData: !0
          }), l = void 0;
          o.result && (l = G2(o.result, i)), typeof l < "u" && (i.data = l, a.push({
            result: l,
            dataId: "ROOT_MUTATION",
            query: e.document,
            variables: e.variables
          }));
        }
        var u = e.updateQueries;
        u && this.queries.forEach(function(d, f) {
          var h = d.observableQuery, g = h && h.queryName;
          if (!(!g || !KR.call(u, g))) {
            var v = u[g], y = n.queries.get(f), A = y.document, x = y.variables, k = t.diff({
              query: A,
              variables: x,
              returnPartialData: !0,
              optimistic: !1
            }), F = k.result, S = k.complete;
            if (S && F) {
              var R = v(F, {
                mutationResult: i,
                queryName: A && Sp(A) || void 0,
                queryVariables: x
              });
              R && a.push({
                result: R,
                dataId: "ROOT_QUERY",
                query: A,
                variables: x
              });
            }
          }
        });
      }
      if (a.length > 0 || (e.refetchQueries || "").length > 0 || e.update || e.onQueryUpdated || e.removeOptimistic) {
        var c = [];
        if (this.refetchQueries({
          updateCache: function(d) {
            s || a.forEach(function(v) {
              return d.write(v);
            });
            var f = e.update, h = !YP(i) || Ru(i) && !i.hasNext;
            if (f) {
              if (!s) {
                var g = d.diff({
                  id: "ROOT_MUTATION",
                  // The cache complains if passed a mutation where it expects a
                  // query, so we transform mutations and subscriptions to queries
                  // (only once, thanks to this.transformCache).
                  query: n.getDocumentInfo(e.document).asQuery,
                  variables: e.variables,
                  optimistic: !1,
                  returnPartialData: !0
                });
                g.complete && (i = me(me({}, i), { data: g.result }), "incremental" in i && delete i.incremental, "hasNext" in i && delete i.hasNext);
              }
              h && f(d, i, {
                context: e.context,
                variables: e.variables
              });
            }
            !s && !e.keepRootFields && h && d.modify({
              id: "ROOT_MUTATION",
              fields: function(v, y) {
                var A = y.fieldName, x = y.DELETE;
                return A === "__typename" ? v : x;
              }
            });
          },
          include: e.refetchQueries,
          // Write the final mutation.result to the root layer of the cache.
          optimistic: !1,
          // Remove the corresponding optimistic layer at the same time as we
          // write the final non-optimistic result.
          removeOptimistic: e.removeOptimistic,
          // Let the caller of client.mutate optionally determine the refetching
          // behavior for watched queries after the mutation.update function runs.
          // If no onQueryUpdated function was provided for this mutation, pass
          // null instead of undefined to disable the default refetching behavior.
          onQueryUpdated: e.onQueryUpdated || null
        }).forEach(function(d) {
          return c.push(d);
        }), e.awaitRefetchQueries || e.onQueryUpdated)
          return Promise.all(c).then(function() {
            return i;
          });
      }
      return Promise.resolve(i);
    }, r.prototype.markMutationOptimistic = function(e, t) {
      var n = this, i = typeof e == "function" ? e(t.variables, { IGNORE: Pw }) : e;
      return i === Pw ? !1 : (this.cache.recordOptimisticTransaction(function(a) {
        try {
          n.markMutationResult(me(me({}, t), { result: { data: i } }), a);
        } catch {
        }
      }, t.mutationId), !0);
    }, r.prototype.fetchQuery = function(e, t, n) {
      return this.fetchConcastWithInfo(this.getOrCreateQuery(e), t, n).concast.promise;
    }, r.prototype.getQueryStore = function() {
      var e = /* @__PURE__ */ Object.create(null);
      return this.queries.forEach(function(t, n) {
        e[n] = {
          variables: t.variables,
          networkStatus: t.networkStatus,
          networkError: t.networkError,
          graphQLErrors: t.graphQLErrors
        };
      }), e;
    }, r.prototype.resetErrors = function(e) {
      var t = this.queries.get(e);
      t && (t.networkError = void 0, t.graphQLErrors = []);
    }, r.prototype.transform = function(e) {
      return this.documentTransform.transformDocument(e);
    }, r.prototype.getDocumentInfo = function(e) {
      var t = this.transformCache;
      if (!t.has(e)) {
        var n = {
          // TODO These three calls (hasClientExports, shouldForceResolvers, and
          // usesNonreactiveDirective) are performing independent full traversals
          // of the transformed document. We should consider merging these
          // traversals into a single pass in the future, though the work is
          // cached after the first time.
          hasClientExports: LD(e),
          hasForcedResolvers: this.localState.shouldForceResolvers(e),
          hasNonreactiveDirective: ed(["nonreactive"], e),
          nonReactiveQuery: BP(e),
          clientQuery: this.localState.clientQuery(e),
          serverQuery: L2([
            { name: "client", remove: !0 },
            { name: "connection" },
            { name: "nonreactive" },
            { name: "unmask" }
          ], e),
          defaultVars: pA(tc(e)),
          // Transform any mutation or subscription operations to query operations
          // so we can read/write them from/to the cache.
          asQuery: me(me({}, e), { definitions: e.definitions.map(function(i) {
            return i.kind === "OperationDefinition" && i.operation !== "query" ? me(me({}, i), { operation: "query" }) : i;
          }) })
        };
        t.set(e, n);
      }
      return t.get(e);
    }, r.prototype.getVariables = function(e, t) {
      return me(me({}, this.getDocumentInfo(e).defaultVars), t);
    }, r.prototype.watchQuery = function(e) {
      var t = this.transform(e.query);
      e = me(me({}, e), { variables: this.getVariables(t, e.variables) }), typeof e.notifyOnNetworkStatusChange > "u" && (e.notifyOnNetworkStatusChange = !1);
      var n = new Km(this), i = new Ip({
        queryManager: this,
        queryInfo: n,
        options: e
      });
      return i.lastQuery = t, Ip.inactiveOnCreation.getValue() || this.queries.set(i.queryId, n), n.init({
        document: t,
        observableQuery: i,
        variables: i.variables
      }), i;
    }, r.prototype.query = function(e, t) {
      var n = this;
      t === void 0 && (t = this.generateQueryId()), Mr(e.query, 38), Mr(e.query.kind === "Document", 39), Mr(!e.returnPartialData, 40), Mr(!e.pollInterval, 41);
      var i = this.transform(e.query);
      return this.fetchQuery(t, me(me({}, e), { query: i })).then(function(a) {
        return a && me(me({}, a), { data: n.maskOperation({
          document: i,
          data: a.data,
          fetchPolicy: e.fetchPolicy,
          id: t
        }) });
      }).finally(function() {
        return n.stopQuery(t);
      });
    }, r.prototype.generateQueryId = function() {
      return String(this.queryIdCounter++);
    }, r.prototype.generateRequestId = function() {
      return this.requestIdCounter++;
    }, r.prototype.generateMutationId = function() {
      return String(this.mutationIdCounter++);
    }, r.prototype.stopQueryInStore = function(e) {
      this.stopQueryInStoreNoBroadcast(e), this.broadcastQueries();
    }, r.prototype.stopQueryInStoreNoBroadcast = function(e) {
      var t = this.queries.get(e);
      t && t.stop();
    }, r.prototype.clearStore = function(e) {
      return e === void 0 && (e = {
        discardWatches: !0
      }), this.cancelPendingFetches(Hi(42)), this.queries.forEach(function(t) {
        t.observableQuery ? t.networkStatus = Jr.loading : t.stop();
      }), this.mutationStore && (this.mutationStore = /* @__PURE__ */ Object.create(null)), this.cache.reset(e);
    }, r.prototype.getObservableQueries = function(e) {
      var t = this;
      e === void 0 && (e = "active");
      var n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Set();
      return Array.isArray(e) && e.forEach(function(o) {
        if (typeof o == "string")
          i.set(o, o), a.set(o, !1);
        else if (iP(o)) {
          var l = hl(t.transform(o));
          i.set(l, Sp(o)), a.set(l, !1);
        } else li(o) && o.query && s.add(o);
      }), this.queries.forEach(function(o, l) {
        var u = o.observableQuery, c = o.document;
        if (u) {
          if (e === "all") {
            n.set(l, u);
            return;
          }
          var d = u.queryName, f = u.options.fetchPolicy;
          if (f === "standby" || e === "active" && !u.hasObservers())
            return;
          (e === "active" || d && a.has(d) || c && a.has(hl(c))) && (n.set(l, u), d && a.set(d, !0), c && a.set(hl(c), !0));
        }
      }), s.size && s.forEach(function(o) {
        var l = Qv("legacyOneTimeQuery"), u = t.getOrCreateQuery(l).init({
          document: o.query,
          variables: o.variables
        }), c = new Ip({
          queryManager: t,
          queryInfo: u,
          options: me(me({}, o), { fetchPolicy: "network-only" })
        });
        Mr(c.queryId === l), u.setObservableQuery(c), n.set(l, c);
      }), n;
    }, r.prototype.reFetchObservableQueries = function(e) {
      var t = this;
      e === void 0 && (e = !1);
      var n = [];
      return this.getObservableQueries(e ? "all" : "active").forEach(function(i, a) {
        var s = i.options.fetchPolicy;
        Di("resetLastResults", function() {
          return i.resetLastResults();
        }), (e || s !== "standby" && s !== "cache-only") && n.push(i.refetch()), (t.queries.get(a) || i.queryInfo).setDiff(null);
      }), this.broadcastQueries(), Promise.all(n);
    }, r.prototype.startGraphQLSubscription = function(e) {
      var t = this, n = e.query, i = e.variables, a = e.fetchPolicy, s = e.errorPolicy, o = s === void 0 ? "none" : s, l = e.context, u = l === void 0 ? {} : l, c = e.extensions, d = c === void 0 ? {} : c;
      n = this.transform(n), i = this.getVariables(n, i);
      var f = function(g) {
        return t.getObservableFromLink(n, u, g, d).map(function(v) {
          a !== "no-cache" && (hy(v, o) && t.cache.write({
            query: n,
            result: v.data,
            dataId: "ROOT_SUBSCRIPTION",
            variables: g
          }), t.broadcastQueries());
          var y = kp(v), A = CA(v);
          if (y || A) {
            var x = {};
            if (y && (x.graphQLErrors = v.errors), A && (x.protocolErrors = v.extensions[Cd]), o === "none" || A)
              throw new ro(x);
          }
          return o === "ignore" && delete v.errors, v;
        });
      };
      if (this.getDocumentInfo(n).hasClientExports) {
        var h = this.localState.addExportedVariables(n, i, u).then(f);
        return new nn(function(g) {
          var v = null;
          return h.then(function(y) {
            return v = y.subscribe(g);
          }, g.error), function() {
            return v && v.unsubscribe();
          };
        });
      }
      return f(i);
    }, r.prototype.stopQuery = function(e) {
      this.stopQueryNoBroadcast(e), this.broadcastQueries();
    }, r.prototype.stopQueryNoBroadcast = function(e) {
      this.stopQueryInStoreNoBroadcast(e), this.removeQuery(e);
    }, r.prototype.removeQuery = function(e) {
      var t;
      this.fetchCancelFns.delete(e), this.queries.has(e) && ((t = this.queries.get(e)) === null || t === void 0 || t.stop(), this.queries.delete(e));
    }, r.prototype.broadcastQueries = function() {
      this.onBroadcast && this.onBroadcast(), this.queries.forEach(function(e) {
        var t;
        return (t = e.observableQuery) === null || t === void 0 ? void 0 : t.notify();
      });
    }, r.prototype.getLocalState = function() {
      return this.localState;
    }, r.prototype.getObservableFromLink = function(e, t, n, i, a) {
      var s = this, o;
      a === void 0 && (a = (o = t?.queryDeduplication) !== null && o !== void 0 ? o : this.queryDeduplication);
      var l, u = this.getDocumentInfo(e), c = u.serverQuery, d = u.clientQuery;
      if (c) {
        var f = this, h = f.inFlightLinkObservables, g = f.link, v = {
          query: c,
          variables: n,
          operationName: Sp(c) || void 0,
          context: this.prepareContext(me(me({}, t), { forceFetch: !a })),
          extensions: i
        };
        if (t = v.context, a) {
          var y = hl(c), A = fo(n), x = h.lookup(y, A);
          if (l = x.observable, !l) {
            var k = new xu([
              sy(g, v)
            ]);
            l = x.observable = k, k.beforeNext(function F(S, R) {
              S === "next" && "hasNext" in R && R.hasNext ? k.beforeNext(F) : h.remove(y, A);
            });
          }
        } else
          l = new xu([
            sy(g, v)
          ]);
      } else
        l = new xu([nn.of({ data: {} })]), t = this.prepareContext(t);
      return d && (l = Hm(l, function(F) {
        return s.localState.runResolvers({
          document: d,
          remoteResult: F,
          context: t,
          variables: n
        });
      })), l;
    }, r.prototype.getResultsFromLink = function(e, t, n) {
      var i = e.lastRequestId = this.generateRequestId(), a = this.cache.transformForLink(n.query);
      return Hm(this.getObservableFromLink(a, n.context, n.variables), function(s) {
        var o = iy(s), l = o.length > 0, u = n.errorPolicy;
        if (i >= e.lastRequestId) {
          if (l && u === "none")
            throw e.markError(new ro({
              graphQLErrors: o
            }));
          e.markResult(s, a, n, t), e.markReady();
        }
        var c = {
          data: s.data,
          loading: !1,
          networkStatus: Jr.ready
        };
        return l && u === "none" && (c.data = void 0), l && u !== "ignore" && (c.errors = o, c.networkStatus = Jr.error), c;
      }, function(s) {
        var o = W2(s) ? s : new ro({ networkError: s });
        throw i >= e.lastRequestId && e.markError(o), o;
      });
    }, r.prototype.fetchConcastWithInfo = function(e, t, n, i) {
      var a = this;
      n === void 0 && (n = Jr.loading), i === void 0 && (i = t.query);
      var s = this.getVariables(i, t.variables), o = this.defaultOptions.watchQuery, l = t.fetchPolicy, u = l === void 0 ? o && o.fetchPolicy || "cache-first" : l, c = t.errorPolicy, d = c === void 0 ? o && o.errorPolicy || "none" : c, f = t.returnPartialData, h = f === void 0 ? !1 : f, g = t.notifyOnNetworkStatusChange, v = g === void 0 ? !1 : g, y = t.context, A = y === void 0 ? {} : y, x = Object.assign({}, t, {
        query: i,
        variables: s,
        fetchPolicy: u,
        errorPolicy: d,
        returnPartialData: h,
        notifyOnNetworkStatusChange: v,
        context: A
      }), k = function(j) {
        x.variables = j;
        var G = a.fetchQueryByPolicy(e, x, n);
        return (
          // If we're in standby, postpone advancing options.fetchPolicy using
          // applyNextFetchPolicy.
          x.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
          // this is another way to detect when nothing was done/fetched.
          G.sources.length > 0 && e.observableQuery && e.observableQuery.applyNextFetchPolicy("after-fetch", t), G
        );
      }, F = function() {
        return a.fetchCancelFns.delete(e.queryId);
      };
      this.fetchCancelFns.set(e.queryId, function(j) {
        F(), setTimeout(function() {
          return S.cancel(j);
        });
      });
      var S, R;
      if (this.getDocumentInfo(x.query).hasClientExports)
        S = new xu(this.localState.addExportedVariables(x.query, x.variables, x.context).then(k).then(function(j) {
          return j.sources;
        })), R = !0;
      else {
        var M = k(x.variables);
        R = M.fromLink, S = new xu(M.sources);
      }
      return S.promise.then(F, F), {
        concast: S,
        fromLink: R
      };
    }, r.prototype.refetchQueries = function(e) {
      var t = this, n = e.updateCache, i = e.include, a = e.optimistic, s = a === void 0 ? !1 : a, o = e.removeOptimistic, l = o === void 0 ? s ? Qv("refetchQueries") : void 0 : o, u = e.onQueryUpdated, c = /* @__PURE__ */ new Map();
      i && this.getObservableQueries(i).forEach(function(f, h) {
        c.set(h, {
          oq: f,
          lastDiff: (t.queries.get(h) || f.queryInfo).getDiff()
        });
      });
      var d = /* @__PURE__ */ new Map();
      return n && this.cache.batch({
        update: n,
        // Since you can perform any combination of cache reads and/or writes in
        // the cache.batch update function, its optimistic option can be either
        // a boolean or a string, representing three distinct modes of
        // operation:
        //
        // * false: read/write only the root layer
        // * true: read/write the topmost layer
        // * string: read/write a fresh optimistic layer with that ID string
        //
        // When typeof optimistic === "string", a new optimistic layer will be
        // temporarily created within cache.batch with that string as its ID. If
        // we then pass that same string as the removeOptimistic option, we can
        // make cache.batch immediately remove the optimistic layer after
        // running the updateCache function, triggering only one broadcast.
        //
        // However, the refetchQueries method accepts only true or false for its
        // optimistic option (not string). We interpret true to mean a temporary
        // optimistic layer should be created, to allow efficiently rolling back
        // the effect of the updateCache function, which involves passing a
        // string instead of true as the optimistic option to cache.batch, when
        // refetchQueries receives optimistic: true.
        //
        // In other words, we are deliberately not supporting the use case of
        // writing to an *existing* optimistic layer (using the refetchQueries
        // updateCache function), since that would potentially interfere with
        // other optimistic updates in progress. Instead, you can read/write
        // only the root layer by passing optimistic: false to refetchQueries,
        // or you can read/write a brand new optimistic layer that will be
        // automatically removed by passing optimistic: true.
        optimistic: s && l || !1,
        // The removeOptimistic option can also be provided by itself, even if
        // optimistic === false, to remove some previously-added optimistic
        // layer safely and efficiently, like we do in markMutationResult.
        //
        // If an explicit removeOptimistic string is provided with optimistic:
        // true, the removeOptimistic string will determine the ID of the
        // temporary optimistic layer, in case that ever matters.
        removeOptimistic: l,
        onWatchUpdated: function(f, h, g) {
          var v = f.watcher instanceof Km && f.watcher.observableQuery;
          if (v) {
            if (u) {
              c.delete(v.queryId);
              var y = u(v, h, g);
              return y === !0 && (y = v.refetch()), y !== !1 && d.set(v, y), y;
            }
            u !== null && c.set(v.queryId, { oq: v, lastDiff: g, diff: h });
          }
        }
      }), c.size && c.forEach(function(f, h) {
        var g = f.oq, v = f.lastDiff, y = f.diff, A;
        u && (y || (y = Di("canonizeResults", function() {
          return t.cache.diff(g.queryInfo.getDiffOptions());
        })), A = u(g, y, v)), (!u || A === !0) && (A = g.refetch()), A !== !1 && d.set(g, A), h.indexOf("legacyOneTimeQuery") >= 0 && t.stopQueryNoBroadcast(h);
      }), l && this.cache.removeOptimistic(l), d;
    }, r.prototype.maskOperation = function(e) {
      var t = e.document, n = e.data;
      return this.dataMasking ? MR(n, t, this.cache) : n;
    }, r.prototype.maskFragment = function(e) {
      var t = e.data, n = e.fragment, i = e.fragmentName;
      return this.dataMasking ? tk(t, n, this.cache, i) : t;
    }, r.prototype.fetchQueryByPolicy = function(e, t, n) {
      var i = this, a = t.query, s = t.variables, o = t.fetchPolicy, l = t.refetchWritePolicy, u = t.errorPolicy, c = t.returnPartialData, d = t.context, f = t.notifyOnNetworkStatusChange, h = e.networkStatus;
      e.init({
        document: a,
        variables: s,
        networkStatus: n
      });
      var g = function() {
        return e.getDiff();
      }, v = function(F, S) {
        S === void 0 && (S = e.networkStatus || Jr.loading);
        var R = F.result, M = function(j) {
          return nn.of(me({ data: j, loading: ku(S), networkStatus: S }, F.complete ? null : { partial: !0 }));
        };
        return R && i.getDocumentInfo(a).hasForcedResolvers ? i.localState.runResolvers({
          document: a,
          remoteResult: { data: R },
          context: d,
          variables: s,
          onlyRunForcedResolvers: !0
        }).then(function(j) {
          return M(j.data || void 0);
        }) : u === "none" && S === Jr.refetch && Array.isArray(F.missing) ? M(void 0) : M(R);
      }, y = o === "no-cache" ? 0 : n === Jr.refetch && l !== "merge" ? 1 : 2, A = function() {
        return i.getResultsFromLink(e, y, {
          query: a,
          variables: s,
          context: d,
          fetchPolicy: o,
          errorPolicy: u
        });
      }, x = f && typeof h == "number" && h !== n && ku(n);
      switch (o) {
        default:
        case "cache-first": {
          var k = g();
          return k.complete ? {
            fromLink: !1,
            sources: [v(k, e.markReady())]
          } : c || x ? {
            fromLink: !0,
            sources: [v(k), A()]
          } : { fromLink: !0, sources: [A()] };
        }
        case "cache-and-network": {
          var k = g();
          return k.complete || c || x ? {
            fromLink: !0,
            sources: [v(k), A()]
          } : { fromLink: !0, sources: [A()] };
        }
        case "cache-only":
          return {
            fromLink: !1,
            sources: [v(g(), e.markReady())]
          };
        case "network-only":
          return x ? {
            fromLink: !0,
            sources: [v(g()), A()]
          } : { fromLink: !0, sources: [A()] };
        case "no-cache":
          return x ? {
            fromLink: !0,
            // Note that queryInfo.getDiff() for no-cache queries does not call
            // cache.diff, but instead returns a { complete: false } stub result
            // when there is no queryInfo.diff already defined.
            sources: [v(e.getDiff()), A()]
          } : { fromLink: !0, sources: [A()] };
        case "standby":
          return { fromLink: !1, sources: [] };
      }
    }, r.prototype.getOrCreateQuery = function(e) {
      return e && !this.queries.has(e) && this.queries.set(e, new Km(this, e)), this.queries.get(e);
    }, r.prototype.prepareContext = function(e) {
      e === void 0 && (e = {});
      var t = this.localState.prepareContext(e);
      return me(me(me({}, this.defaultContext), t), { clientAwareness: this.clientAwareness });
    }, r;
  })()
), e4 = (
  /** @class */
  (function() {
    function r(e) {
      var t = e.cache, n = e.client, i = e.resolvers, a = e.fragmentMatcher;
      this.selectionsToResolveCache = /* @__PURE__ */ new WeakMap(), this.cache = t, n && (this.client = n), i && this.addResolvers(i), a && this.setFragmentMatcher(a);
    }
    return r.prototype.addResolvers = function(e) {
      var t = this;
      this.resolvers = this.resolvers || {}, Array.isArray(e) ? e.forEach(function(n) {
        t.resolvers = Kb(t.resolvers, n);
      }) : this.resolvers = Kb(this.resolvers, e);
    }, r.prototype.setResolvers = function(e) {
      this.resolvers = {}, this.addResolvers(e);
    }, r.prototype.getResolvers = function() {
      return this.resolvers || {};
    }, r.prototype.runResolvers = function(e) {
      return Ka(this, arguments, void 0, function(t) {
        var n = t.document, i = t.remoteResult, a = t.context, s = t.variables, o = t.onlyRunForcedResolvers, l = o === void 0 ? !1 : o;
        return Za(this, function(u) {
          return n ? [2, this.resolveDocument(n, i.data, a, s, this.fragmentMatcher, l).then(function(c) {
            return me(me({}, i), { data: c.result });
          })] : [2, i];
        });
      });
    }, r.prototype.setFragmentMatcher = function(e) {
      this.fragmentMatcher = e;
    }, r.prototype.getFragmentMatcher = function() {
      return this.fragmentMatcher;
    }, r.prototype.clientQuery = function(e) {
      return ed(["client"], e) && this.resolvers ? e : null;
    }, r.prototype.serverQuery = function(e) {
      return V2(e);
    }, r.prototype.prepareContext = function(e) {
      var t = this.cache;
      return me(me({}, e), {
        cache: t,
        // Getting an entry's cache key is useful for local state resolvers.
        getCacheKey: function(n) {
          return t.identify(n);
        }
      });
    }, r.prototype.addExportedVariables = function(e) {
      return Ka(this, arguments, void 0, function(t, n, i) {
        return n === void 0 && (n = {}), i === void 0 && (i = {}), Za(this, function(a) {
          return t ? [2, this.resolveDocument(t, this.buildRootValueFromCache(t, n) || {}, this.prepareContext(i), n).then(function(s) {
            return me(me({}, n), s.exportedVariables);
          })] : [2, me({}, n)];
        });
      });
    }, r.prototype.shouldForceResolvers = function(e) {
      var t = !1;
      return Fa(e, {
        Directive: {
          enter: function(n) {
            if (n.name.value === "client" && n.arguments && (t = n.arguments.some(function(i) {
              return i.name.value === "always" && i.value.kind === "BooleanValue" && i.value.value === !0;
            }), t))
              return dA;
          }
        }
      }), t;
    }, r.prototype.buildRootValueFromCache = function(e, t) {
      return this.cache.diff({
        query: OP(e),
        variables: t,
        returnPartialData: !0,
        optimistic: !1
      }).result;
    }, r.prototype.resolveDocument = function(e, t) {
      return Ka(this, arguments, void 0, function(n, i, a, s, o, l) {
        var u, c, d, f, h, g, v, y, A, x, k;
        return a === void 0 && (a = {}), s === void 0 && (s = {}), o === void 0 && (o = function() {
          return !0;
        }), l === void 0 && (l = !1), Za(this, function(F) {
          return u = xd(n), c = rc(n), d = Zu(c), f = this.collectSelectionsToResolve(u, d), h = u.operation, g = h ? h.charAt(0).toUpperCase() + h.slice(1) : "Query", v = this, y = v.cache, A = v.client, x = {
            fragmentMap: d,
            context: me(me({}, a), { cache: y, client: A }),
            variables: s,
            fragmentMatcher: o,
            defaultOperationType: g,
            exportedVariables: {},
            selectionsToResolve: f,
            onlyRunForcedResolvers: l
          }, k = !1, [2, this.resolveSelectionSet(u.selectionSet, k, i, x).then(function(S) {
            return {
              result: S,
              exportedVariables: x.exportedVariables
            };
          })];
        });
      });
    }, r.prototype.resolveSelectionSet = function(e, t, n, i) {
      return Ka(this, void 0, void 0, function() {
        var a, s, o, l, u, c = this;
        return Za(this, function(d) {
          return a = i.fragmentMap, s = i.context, o = i.variables, l = [n], u = function(f) {
            return Ka(c, void 0, void 0, function() {
              var h, g;
              return Za(this, function(v) {
                return !t && !i.selectionsToResolve.has(f) ? [
                  2
                  /*return*/
                ] : wd(f, o) ? vo(f) ? [2, this.resolveField(f, t, n, i).then(function(y) {
                  var A;
                  typeof y < "u" && l.push((A = {}, A[mo(f)] = y, A));
                })] : (mP(f) ? h = f : (h = a[f.name.value], Mr(h, 21, f.name.value)), h && h.typeCondition && (g = h.typeCondition.name.value, i.fragmentMatcher(n, g, s)) ? [2, this.resolveSelectionSet(h.selectionSet, t, n, i).then(function(y) {
                  l.push(y);
                })] : [
                  2
                  /*return*/
                ]) : [
                  2
                  /*return*/
                ];
              });
            });
          }, [2, Promise.all(e.selections.map(u)).then(function() {
            return Eg(l);
          })];
        });
      });
    }, r.prototype.resolveField = function(e, t, n, i) {
      return Ka(this, void 0, void 0, function() {
        var a, s, o, l, u, c, d, f, h, g = this;
        return Za(this, function(v) {
          return n ? (a = i.variables, s = e.name.value, o = mo(e), l = s !== o, u = n[o] || n[s], c = Promise.resolve(u), (!i.onlyRunForcedResolvers || this.shouldForceResolvers(e)) && (d = n.__typename || i.defaultOperationType, f = this.resolvers && this.resolvers[d], f && (h = f[l ? s : o], h && (c = Promise.resolve(
            // In case the resolve function accesses reactive variables,
            // set cacheSlot to the current cache instance.
            SA.withValue(this.cache, h, [
              n,
              xg(e, a),
              i.context,
              { field: e, fragmentMap: i.fragmentMap }
            ])
          )))), [2, c.then(function(y) {
            var A, x;
            if (y === void 0 && (y = u), e.directives && e.directives.forEach(function(F) {
              F.name.value === "export" && F.arguments && F.arguments.forEach(function(S) {
                S.name.value === "as" && S.value.kind === "StringValue" && (i.exportedVariables[S.value.value] = y);
              });
            }), !e.selectionSet || y == null)
              return y;
            var k = (x = (A = e.directives) === null || A === void 0 ? void 0 : A.some(function(F) {
              return F.name.value === "client";
            })) !== null && x !== void 0 ? x : !1;
            if (Array.isArray(y))
              return g.resolveSubSelectedArray(e, t || k, y, i);
            if (e.selectionSet)
              return g.resolveSelectionSet(e.selectionSet, t || k, y, i);
          })]) : [2, null];
        });
      });
    }, r.prototype.resolveSubSelectedArray = function(e, t, n, i) {
      var a = this;
      return Promise.all(n.map(function(s) {
        if (s === null)
          return null;
        if (Array.isArray(s))
          return a.resolveSubSelectedArray(e, t, s, i);
        if (e.selectionSet)
          return a.resolveSelectionSet(e.selectionSet, t, s, i);
      }));
    }, r.prototype.collectSelectionsToResolve = function(e, t) {
      var n = function(s) {
        return !Array.isArray(s);
      }, i = this.selectionsToResolveCache;
      function a(s) {
        if (!i.has(s)) {
          var o = /* @__PURE__ */ new Set();
          i.set(s, o), Fa(s, {
            Directive: function(l, u, c, d, f) {
              l.name.value === "client" && f.forEach(function(h) {
                n(h) && Hb(h) && o.add(h);
              });
            },
            FragmentSpread: function(l, u, c, d, f) {
              var h = t[l.name.value];
              Mr(h, 22, l.name.value);
              var g = a(h);
              g.size > 0 && (f.forEach(function(v) {
                n(v) && Hb(v) && o.add(v);
              }), o.add(l), g.forEach(function(v) {
                o.add(v);
              }));
            }
          });
        }
        return i.get(s);
      }
      return a(e);
    }, r;
  })()
), t4 = (
  /** @class */
  (function() {
    function r(e) {
      var t = this, n, i, a;
      if (this.resetStoreCallbacks = [], this.clearStoreCallbacks = [], !e.cache)
        throw Hi(16);
      var s = e.uri, o = e.credentials, l = e.headers, u = e.cache, c = e.documentTransform, d = e.ssrMode, f = d === void 0 ? !1 : d, h = e.ssrForceFetchDelay, g = h === void 0 ? 0 : h, v = e.connectToDevTools, y = e.queryDeduplication, A = y === void 0 ? !0 : y, x = e.defaultOptions, k = e.defaultContext, F = e.assumeImmutableResults, S = F === void 0 ? u.assumeImmutableResults : F, R = e.resolvers, M = e.typeDefs, j = e.fragmentMatcher, G = e.clientAwareness, ie = e.name, q = e.version, Y = e.devtools, J = e.dataMasking, se = e.link;
      se || (se = s ? new FR({ uri: s, credentials: o, headers: l }) : Oa.empty()), this.link = se, this.cache = u, this.disableNetworkFetches = f || g > 0, this.queryDeduplication = A, this.defaultOptions = x || /* @__PURE__ */ Object.create(null), this.typeDefs = M, this.devtoolsConfig = me(me({}, Y), { enabled: (n = Y?.enabled) !== null && n !== void 0 ? n : v }), this.devtoolsConfig.enabled === void 0 && (this.devtoolsConfig.enabled = !1), g && setTimeout(function() {
        return t.disableNetworkFetches = !1;
      }, g), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.watchFragment = this.watchFragment.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this), this.version = oA, this.localState = new e4({
        cache: u,
        client: this,
        resolvers: R,
        fragmentMatcher: j
      }), this.queryManager = new ZR({
        cache: this.cache,
        link: this.link,
        defaultOptions: this.defaultOptions,
        defaultContext: k,
        documentTransform: c,
        queryDeduplication: A,
        ssrMode: f,
        dataMasking: !!J,
        clientAwareness: {
          name: (i = G?.name) !== null && i !== void 0 ? i : ie,
          version: (a = G?.version) !== null && a !== void 0 ? a : q
        },
        localState: this.localState,
        assumeImmutableResults: S,
        onBroadcast: this.devtoolsConfig.enabled ? function() {
          t.devToolsHookCb && t.devToolsHookCb({
            action: {},
            state: {
              queries: t.queryManager.getQueryStore(),
              mutations: t.queryManager.mutationStore || {}
            },
            dataWithOptimisticResults: t.cache.extract(!0)
          });
        } : void 0
      }), this.devtoolsConfig.enabled && this.connectToDevTools();
    }
    return Object.defineProperty(r.prototype, "prioritizeCacheValues", {
      /**
       * Whether to prioritize cache values over network results when `query` or `watchQuery` is called.
       * This will essentially turn a `"network-only"` or `"cache-and-network"` fetchPolicy into a `"cache-first"` fetchPolicy,
       * but without influencing the `fetchPolicy` of the created `ObservableQuery` long-term.
       *
       * This can e.g. be used to prioritize the cache during the first render after SSR.
       */
      get: function() {
        return this.disableNetworkFetches;
      },
      set: function(e) {
        this.disableNetworkFetches = e;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.connectToDevTools = function() {
      if (!(typeof window > "u")) {
        var e = window, t = /* @__PURE__ */ Symbol.for("apollo.devtools");
        (e[t] = e[t] || []).push(this), e.__APOLLO_CLIENT__ = this;
      }
    }, Object.defineProperty(r.prototype, "documentTransform", {
      /**
       * The `DocumentTransform` used to modify GraphQL documents before a request
       * is made. If a custom `DocumentTransform` is not provided, this will be the
       * default document transform.
       */
      get: function() {
        return this.queryManager.documentTransform;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.stop = function() {
      this.queryManager.stop();
    }, r.prototype.watchQuery = function(e) {
      return this.defaultOptions.watchQuery && (e = jm(this.defaultOptions.watchQuery, e)), this.disableNetworkFetches && (e.fetchPolicy === "network-only" || e.fetchPolicy === "cache-and-network") && (e = me(me({}, e), { fetchPolicy: "cache-first" })), this.queryManager.watchQuery(e);
    }, r.prototype.query = function(e) {
      return this.defaultOptions.query && (e = jm(this.defaultOptions.query, e)), Mr(e.fetchPolicy !== "cache-and-network", 18), this.disableNetworkFetches && e.fetchPolicy === "network-only" && (e = me(me({}, e), { fetchPolicy: "cache-first" })), this.queryManager.query(e);
    }, r.prototype.mutate = function(e) {
      return this.defaultOptions.mutate && (e = jm(this.defaultOptions.mutate, e)), this.queryManager.mutate(e);
    }, r.prototype.subscribe = function(e) {
      var t = this, n = this.queryManager.generateQueryId();
      return this.queryManager.startGraphQLSubscription(e).map(function(i) {
        return me(me({}, i), { data: t.queryManager.maskOperation({
          document: e.query,
          data: i.data,
          fetchPolicy: e.fetchPolicy,
          id: n
        }) });
      });
    }, r.prototype.readQuery = function(e, t) {
      return t === void 0 && (t = !1), this.cache.readQuery(e, t);
    }, r.prototype.watchFragment = function(e) {
      var t;
      return this.cache.watchFragment(me(me({}, e), (t = {}, t[/* @__PURE__ */ Symbol.for("apollo.dataMasking")] = this.queryManager.dataMasking, t)));
    }, r.prototype.readFragment = function(e, t) {
      return t === void 0 && (t = !1), this.cache.readFragment(e, t);
    }, r.prototype.writeQuery = function(e) {
      var t = this.cache.writeQuery(e);
      return e.broadcast !== !1 && this.queryManager.broadcastQueries(), t;
    }, r.prototype.writeFragment = function(e) {
      var t = this.cache.writeFragment(e);
      return e.broadcast !== !1 && this.queryManager.broadcastQueries(), t;
    }, r.prototype.__actionHookForDevTools = function(e) {
      this.devToolsHookCb = e;
    }, r.prototype.__requestRaw = function(e) {
      return sy(this.link, e);
    }, r.prototype.resetStore = function() {
      var e = this;
      return Promise.resolve().then(function() {
        return e.queryManager.clearStore({
          discardWatches: !1
        });
      }).then(function() {
        return Promise.all(e.resetStoreCallbacks.map(function(t) {
          return t();
        }));
      }).then(function() {
        return e.reFetchObservableQueries();
      });
    }, r.prototype.clearStore = function() {
      var e = this;
      return Promise.resolve().then(function() {
        return e.queryManager.clearStore({
          discardWatches: !0
        });
      }).then(function() {
        return Promise.all(e.clearStoreCallbacks.map(function(t) {
          return t();
        }));
      });
    }, r.prototype.onResetStore = function(e) {
      var t = this;
      return this.resetStoreCallbacks.push(e), function() {
        t.resetStoreCallbacks = t.resetStoreCallbacks.filter(function(n) {
          return n !== e;
        });
      };
    }, r.prototype.onClearStore = function(e) {
      var t = this;
      return this.clearStoreCallbacks.push(e), function() {
        t.clearStoreCallbacks = t.clearStoreCallbacks.filter(function(n) {
          return n !== e;
        });
      };
    }, r.prototype.reFetchObservableQueries = function(e) {
      return this.queryManager.reFetchObservableQueries(e);
    }, r.prototype.refetchQueries = function(e) {
      var t = this.queryManager.refetchQueries(e), n = [], i = [];
      t.forEach(function(s, o) {
        n.push(o), i.push(s);
      });
      var a = Promise.all(i);
      return a.queries = n, a.results = i, a.catch(function(s) {
      }), a;
    }, r.prototype.getObservableQueries = function(e) {
      return e === void 0 && (e = "active"), this.queryManager.getObservableQueries(e);
    }, r.prototype.extract = function(e) {
      return this.cache.extract(e);
    }, r.prototype.restore = function(e) {
      return this.cache.restore(e);
    }, r.prototype.addResolvers = function(e) {
      this.localState.addResolvers(e);
    }, r.prototype.setResolvers = function(e) {
      this.localState.setResolvers(e);
    }, r.prototype.getResolvers = function() {
      return this.localState.getResolvers();
    }, r.prototype.setLocalStateFragmentMatcher = function(e) {
      this.localState.setFragmentMatcher(e);
    }, r.prototype.setLink = function(e) {
      this.link = this.queryManager.link = e;
    }, Object.defineProperty(r.prototype, "defaultContext", {
      get: function() {
        return this.queryManager.defaultContext;
      },
      enumerable: !1,
      configurable: !0
    }), r;
  })()
), Dp = /* @__PURE__ */ new Map(), py = /* @__PURE__ */ new Map(), pk = !0, $f = !1;
function gk(r) {
  return r.replace(/[\s,]+/g, " ").trim();
}
function r4(r) {
  return gk(r.source.body.substring(r.start, r.end));
}
function n4(r) {
  var e = /* @__PURE__ */ new Set(), t = [];
  return r.definitions.forEach(function(n) {
    if (n.kind === "FragmentDefinition") {
      var i = n.name.value, a = r4(n.loc), s = py.get(i);
      s && !s.has(a) ? pk && console.warn("Warning: fragment with name " + i + ` already exists.
graphql-tag enforces all fragment names across your application to be unique; read more about
this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names`) : s || py.set(i, s = /* @__PURE__ */ new Set()), s.add(a), e.has(a) || (e.add(a), t.push(n));
    } else
      t.push(n);
  }), me(me({}, r), { definitions: t });
}
function i4(r) {
  var e = new Set(r.definitions);
  e.forEach(function(n) {
    n.loc && delete n.loc, Object.keys(n).forEach(function(i) {
      var a = n[i];
      a && typeof a == "object" && e.add(a);
    });
  });
  var t = r.loc;
  return t && (delete t.startToken, delete t.endToken), r;
}
function a4(r) {
  var e = gk(r);
  if (!Dp.has(e)) {
    var t = FD(r, {
      experimentalFragmentVariables: $f,
      allowLegacyFragmentVariables: $f,
      experimentalFragmentArguments: $f
    });
    if (!t || t.kind !== "Document")
      throw new Error("Not a valid GraphQL document.");
    Dp.set(e, i4(n4(t)));
  }
  return Dp.get(e);
}
function Ee(r) {
  for (var e = [], t = 1; t < arguments.length; t++)
    e[t - 1] = arguments[t];
  typeof r == "string" && (r = [r]);
  var n = r[0];
  return e.forEach(function(i, a) {
    i && i.kind === "Document" ? n += i.loc.source.body : n += i, n += r[a + 1];
  }), a4(n);
}
function s4() {
  Dp.clear(), py.clear();
}
function o4() {
  pk = !1;
}
function l4() {
  $f = !0;
}
function u4() {
  $f = !1;
}
var Zc = {
  gql: Ee,
  resetCaches: s4,
  disableFragmentWarnings: o4,
  enableExperimentalFragmentVariables: l4,
  disableExperimentalFragmentVariables: u4
};
(function(r) {
  r.gql = Zc.gql, r.resetCaches = Zc.resetCaches, r.disableFragmentWarnings = Zc.disableFragmentWarnings, r.enableExperimentalFragmentVariables = Zc.enableExperimentalFragmentVariables, r.disableExperimentalFragmentVariables = Zc.disableExperimentalFragmentVariables;
})(Ee || (Ee = {}));
Ee.default = Ee;
var Yp = /* @__PURE__ */ ((r) => (r.Data = "Data", r.Font = "Font", r.Frame = "Frame", r.Illustration = "Illustration", r.Image = "Image", r.Model = "Model", r.Material = "Material", r.Color = "Color", r.QuestionnaireCollateral = "QuestionnaireCollateral", r.RequestCollateral = "RequestCollateral", r.SignupCollateral = "SignupCollateral", r.Video = "Video", r.ColorProfile = "ColorProfile", r.Environment = "Environment", r))(Yp || {}), mk = /* @__PURE__ */ ((r) => (r.AND = "AND", r.OR = "OR", r))(mk || {}), Qn = /* @__PURE__ */ ((r) => (r.FileUpload = "FileUpload", r.Option = "Option", r.ColorOption = "ColorOption", r.Text = "Text", r))(Qn || {}), Je = /* @__PURE__ */ ((r) => (r.Information = "Information", r.Bulk = "Bulk", r.DigitalContent = "DigitalContent", r.Finish = "Finish", r.Frame = "Frame", r.Illustration = "Illustration", r.Introduction = "Introduction", r.Material = "Material", r.Model = "Model", r.Module = "Module", r.Picture = "Picture", r.Photo = "Photo", r.Product = "Product", r.ProductOverlay = "ProductOverlay", r.Question = "Question", r.Shape = "Shape", r.SilentIllustration = "SilentIllustration", r.Text = "Text", r))(Je || {}), c4 = /* @__PURE__ */ ((r) => (r.Color = "Color", r.Colors = "Colors", r.Selection = "Selection", r.Selections = "Selections", r.Text = "Text", r.Upload = "Upload", r))(c4 || {}), id = /* @__PURE__ */ ((r) => (r.ThreeD = "ThreeD", r.FreeDesign = "FreeDesign", r.Print = "Print", r))(id || {}), tr = /* @__PURE__ */ ((r) => (r.Frame = "frame", r.Group = "group", r.Image = "image", r.Pattern = "pattern", r.Illustration = "illustration", r.Textbox = "textbox", r))(tr || {}), f4 = /* @__PURE__ */ ((r) => (r.Default = "Default", r.FirstTransaction = "FirstTransaction", r.OneToOne = "OneToOne", r))(f4 || {}), FA = /* @__PURE__ */ ((r) => (r.Pending = "Pending", r.Failed = "Failed", r.Validated = "Validated", r.Overridden = "Overridden", r.Skipped = "Skipped", r))(FA || {}), d4 = /* @__PURE__ */ ((r) => (r.Hyperlink = "Hyperlink", r.Edit = "Edit", r.Approve = "Approve", r))(d4 || {}), h4 = /* @__PURE__ */ ((r) => (r.Hub = "Hub", r.Shopify = "Shopify", r))(h4 || {}), IA = /* @__PURE__ */ ((r) => (r.AdvancedImageManipulation = "BackgroundRemover", r.ConversionAccelerator = "Conversion Accelerator", r.ProcessBuilder = "ProcessBuilder", r))(IA || {}), p4 = /* @__PURE__ */ ((r) => (r[r.Orbit = 0] = "Orbit", r[r.Pan = 1] = "Pan", r))(p4 || {}), vk = /* @__PURE__ */ ((r) => (r.Owner = "Owner", r.Approver = "Approver", r.Editor = "Editor", r.Viewer = "Viewer", r))(vk || {}), ic = /* @__PURE__ */ ((r) => (r.Autosize = "Autosize", r.Traditional = "Traditional", r))(ic || {}), Ci = /* @__PURE__ */ ((r) => (r[r.North = 0] = "North", r[r.Northeast = 1] = "Northeast", r[r.East = 2] = "East", r[r.Southeast = 3] = "Southeast", r[r.South = 4] = "South", r[r.Southwest = 5] = "Southwest", r[r.West = 6] = "West", r[r.Northwest = 7] = "Northwest", r))(Ci || {}), g4 = /* @__PURE__ */ ((r) => (r.Pixel = "px", r.Millimeter = "mm", r.Centimeter = "cm", r))(g4 || {}), Pp = /* @__PURE__ */ ((r) => (r.Email = "Email", r.FirstName = "FirstName", r.LastName = "LastName", r.Phone = "Phone", r.Apartment = "Apartment", r.City = "City", r.Country = "Country", r.OrganizationName = "OrganizationName", r.PostCode = "PostCode", r.State = "State", r.StreetAddress = "StreetAddress", r.Custom = "Custom", r))(Pp || {});
class yk extends Error {
  constructor(e) {
    super(e), this.name = this.constructor.name;
  }
}
class Sd extends yk {
  constructor(e) {
    super(`ConfigurationError - ${e}`);
  }
}
class Xp extends Sd {
  constructor(e) {
    super(`Option not Configured: ${e.stepTitle}`), this.optionId = e?.optionId || "N/A";
  }
}
class Ei extends Sd {
  constructor(e) {
    super(`Panel not Found: ${e.panelId}`), this.panelId = e?.panelId || "N/A";
  }
}
class bl extends Sd {
  constructor(e) {
    super(`Asset not found for variant: ${e.name}`), this.variant = e;
  }
}
class ad extends Sd {
  constructor(e) {
    super(`Resource not found for asset: ${e.name}`), this.asset = e;
  }
}
class Is extends Sd {
  constructor(e, t) {
    super(`Workflow Misconfiguration: ${e.stepName} - ${t}`), this.step = e;
  }
}
class kg extends yk {
  constructor(e) {
    super(`ImplementationError - ${e}`);
  }
}
class un extends kg {
  constructor(e) {
    super(`Unhandled Behavior Encountered: ${e}`);
  }
}
class Fu extends kg {
  constructor(e) {
    super(`Parsing Error: ${e}`);
  }
}
class ao extends kg {
  constructor(e) {
    super(`Client Error: ${e}`);
  }
}
class Tg extends kg {
  constructor(e) {
    super(`Resource Generation Failed: ${e}`);
  }
}
class m4 {
  get(e) {
    return localStorage.getItem(e) || void 0;
  }
  set(e, t) {
    localStorage.setItem(e, t);
  }
  remove(e) {
    localStorage.removeItem(e);
  }
  getMap(e) {
    const t = this.get(e);
    if (t)
      return new Map(JSON.parse(t));
  }
  setMap(e, t) {
    const n = JSON.stringify([...t.entries()]);
    this.set(e, n);
  }
}
class Rw {
  constructor() {
    this.storage = /* @__PURE__ */ new Map();
  }
  get(e) {
    return this.storage.get(e) || void 0;
  }
  set(e, t) {
    this.storage.set(e, t);
  }
  remove(e) {
    this.storage.delete(e);
  }
  getMap(e) {
    const t = this.get(e);
    if (t)
      return new Map(JSON.parse(t));
  }
  setMap(e, t) {
    const n = JSON.stringify([...t.entries()]);
    this.set(e, n);
  }
}
const v4 = () => {
  try {
    return localStorage ? new m4() : new Rw();
  } catch {
    return console.warn("Local storage was unavilable due to browser security settings. Using in-memory storage instead."), new Rw();
  }
}, Cr = v4();
function y4(r) {
  return new Oa(function(e, t) {
    var n = ns(e, []);
    return new nn(function(i) {
      var a, s = !1;
      return Promise.resolve(n).then(function(o) {
        return r(o, e.getContext());
      }).then(e.setContext).then(function() {
        s || (a = t(e).subscribe({
          next: i.next.bind(i),
          error: i.error.bind(i),
          complete: i.complete.bind(i)
        }));
      }).catch(i.error.bind(i)), function() {
        s = !0, a && a.unsubscribe();
      };
    });
  });
}
function Ak(r) {
  return new Oa(function(e, t) {
    return new nn(function(n) {
      var i, a, s;
      try {
        i = t(e).subscribe({
          next: function(o) {
            if (o.errors ? s = r({
              graphQLErrors: o.errors,
              response: o,
              operation: e,
              forward: t
            }) : CA(o) && (s = r({
              protocolErrors: o.extensions[Cd],
              response: o,
              operation: e,
              forward: t
            })), s) {
              a = s.subscribe({
                next: n.next.bind(n),
                error: n.error.bind(n),
                complete: n.complete.bind(n)
              });
              return;
            }
            n.next(o);
          },
          error: function(o) {
            if (s = r({
              operation: e,
              networkError: o,
              //Network errors can return GraphQL errors on for example a 403
              graphQLErrors: o && o.result && o.result.errors || void 0,
              forward: t
            }), s) {
              a = s.subscribe({
                next: n.next.bind(n),
                error: n.error.bind(n),
                complete: n.complete.bind(n)
              });
              return;
            }
            n.error(o);
          },
          complete: function() {
            s || n.complete.bind(n)();
          }
        });
      } catch (o) {
        r({ networkError: o, operation: e, forward: t }), n.error(o);
      }
      return function() {
        i && i.unsubscribe(), a && i.unsubscribe();
      };
    });
  });
}
(function(r) {
  pa(e, r);
  function e(t) {
    var n = r.call(this) || this;
    return n.link = Ak(t), n;
  }
  return e.prototype.request = function(t, n) {
    return this.link.request(t, n);
  }, e;
})(Oa);
class A4 {
  constructor() {
    this.defaultServerUrl = "https://moonlight.au.spiffcommerce.com", this.defaultServicesApiUrl = "https://services.au.spiffcommerce.com", this.defaultHubUrl = "https://hub.au.spiffcommerce.com", this.endpointVersion = "2026-07", this.serverUrl = this.defaultServerUrl + `/${this.endpointVersion}`, this.servicesApiUrl = this.defaultServicesApiUrl, this.hubUrl = this.defaultHubUrl, this.serverUrlCallbacks = [];
  }
  getServerUrl() {
    return this.serverUrl;
  }
  getServicesApiUrl() {
    return this.servicesApiUrl;
  }
  getHubUrl() {
    return this.hubUrl;
  }
  setServerUrl(e) {
    e.endsWith("/") && (e = e.slice(0, -1)), e.endsWith(".com") ? this.serverUrl = e + `/${this.endpointVersion}` : e.includes("spiffcommerce.com") ? (e = e.slice(0, e.lastIndexOf("/")), this.serverUrl = `${e}/${this.endpointVersion}`) : this.serverUrl = e, this.serverUrlCallbacks.forEach((t) => t());
  }
  setServicesApiUrl(e) {
    this.servicesApiUrl = e;
  }
  setHubUrl(e) {
    this.hubUrl = e;
  }
  addServerUrlCallback(e) {
    this.serverUrlCallbacks.push(e);
  }
}
const ml = new A4();
var Ys = {}, rl = {}, Th = { exports: {} }, Ar = {};
var Ow;
function b4() {
  if (Ow) return Ar;
  Ow = 1;
  var r = /* @__PURE__ */ Symbol.for("react.element"), e = /* @__PURE__ */ Symbol.for("react.portal"), t = /* @__PURE__ */ Symbol.for("react.fragment"), n = /* @__PURE__ */ Symbol.for("react.strict_mode"), i = /* @__PURE__ */ Symbol.for("react.profiler"), a = /* @__PURE__ */ Symbol.for("react.provider"), s = /* @__PURE__ */ Symbol.for("react.context"), o = /* @__PURE__ */ Symbol.for("react.forward_ref"), l = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.memo"), c = /* @__PURE__ */ Symbol.for("react.lazy"), d = Symbol.iterator;
  function f(ee) {
    return ee === null || typeof ee != "object" ? null : (ee = d && ee[d] || ee["@@iterator"], typeof ee == "function" ? ee : null);
  }
  var h = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, g = Object.assign, v = {};
  function y(ee, re, de) {
    this.props = ee, this.context = re, this.refs = v, this.updater = de || h;
  }
  y.prototype.isReactComponent = {}, y.prototype.setState = function(ee, re) {
    if (typeof ee != "object" && typeof ee != "function" && ee != null) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, ee, re, "setState");
  }, y.prototype.forceUpdate = function(ee) {
    this.updater.enqueueForceUpdate(this, ee, "forceUpdate");
  };
  function A() {
  }
  A.prototype = y.prototype;
  function x(ee, re, de) {
    this.props = ee, this.context = re, this.refs = v, this.updater = de || h;
  }
  var k = x.prototype = new A();
  k.constructor = x, g(k, y.prototype), k.isPureReactComponent = !0;
  var F = Array.isArray, S = Object.prototype.hasOwnProperty, R = { current: null }, M = { key: !0, ref: !0, __self: !0, __source: !0 };
  function j(ee, re, de) {
    var Be, ke = {}, ze = null, je = null;
    if (re != null) for (Be in re.ref !== void 0 && (je = re.ref), re.key !== void 0 && (ze = "" + re.key), re) S.call(re, Be) && !M.hasOwnProperty(Be) && (ke[Be] = re[Be]);
    var qe = arguments.length - 2;
    if (qe === 1) ke.children = de;
    else if (1 < qe) {
      for (var Ge = Array(qe), bt = 0; bt < qe; bt++) Ge[bt] = arguments[bt + 2];
      ke.children = Ge;
    }
    if (ee && ee.defaultProps) for (Be in qe = ee.defaultProps, qe) ke[Be] === void 0 && (ke[Be] = qe[Be]);
    return { $$typeof: r, type: ee, key: ze, ref: je, props: ke, _owner: R.current };
  }
  function G(ee, re) {
    return { $$typeof: r, type: ee.type, key: re, ref: ee.ref, props: ee.props, _owner: ee._owner };
  }
  function ie(ee) {
    return typeof ee == "object" && ee !== null && ee.$$typeof === r;
  }
  function q(ee) {
    var re = { "=": "=0", ":": "=2" };
    return "$" + ee.replace(/[=:]/g, function(de) {
      return re[de];
    });
  }
  var Y = /\/+/g;
  function J(ee, re) {
    return typeof ee == "object" && ee !== null && ee.key != null ? q("" + ee.key) : re.toString(36);
  }
  function se(ee, re, de, Be, ke) {
    var ze = typeof ee;
    (ze === "undefined" || ze === "boolean") && (ee = null);
    var je = !1;
    if (ee === null) je = !0;
    else switch (ze) {
      case "string":
      case "number":
        je = !0;
        break;
      case "object":
        switch (ee.$$typeof) {
          case r:
          case e:
            je = !0;
        }
    }
    if (je) return je = ee, ke = ke(je), ee = Be === "" ? "." + J(je, 0) : Be, F(ke) ? (de = "", ee != null && (de = ee.replace(Y, "$&/") + "/"), se(ke, re, de, "", function(bt) {
      return bt;
    })) : ke != null && (ie(ke) && (ke = G(ke, de + (!ke.key || je && je.key === ke.key ? "" : ("" + ke.key).replace(Y, "$&/") + "/") + ee)), re.push(ke)), 1;
    if (je = 0, Be = Be === "" ? "." : Be + ":", F(ee)) for (var qe = 0; qe < ee.length; qe++) {
      ze = ee[qe];
      var Ge = Be + J(ze, qe);
      je += se(ze, re, de, Ge, ke);
    }
    else if (Ge = f(ee), typeof Ge == "function") for (ee = Ge.call(ee), qe = 0; !(ze = ee.next()).done; ) ze = ze.value, Ge = Be + J(ze, qe++), je += se(ze, re, de, Ge, ke);
    else if (ze === "object") throw re = String(ee), Error("Objects are not valid as a React child (found: " + (re === "[object Object]" ? "object with keys {" + Object.keys(ee).join(", ") + "}" : re) + "). If you meant to render a collection of children, use an array instead.");
    return je;
  }
  function oe(ee, re, de) {
    if (ee == null) return ee;
    var Be = [], ke = 0;
    return se(ee, Be, "", "", function(ze) {
      return re.call(de, ze, ke++);
    }), Be;
  }
  function he(ee) {
    if (ee._status === -1) {
      var re = ee._result;
      re = re(), re.then(function(de) {
        (ee._status === 0 || ee._status === -1) && (ee._status = 1, ee._result = de);
      }, function(de) {
        (ee._status === 0 || ee._status === -1) && (ee._status = 2, ee._result = de);
      }), ee._status === -1 && (ee._status = 0, ee._result = re);
    }
    if (ee._status === 1) return ee._result.default;
    throw ee._result;
  }
  var ye = { current: null }, Ue = { transition: null }, Re = { ReactCurrentDispatcher: ye, ReactCurrentBatchConfig: Ue, ReactCurrentOwner: R };
  function Oe() {
    throw Error("act(...) is not supported in production builds of React.");
  }
  return Ar.Children = { map: oe, forEach: function(ee, re, de) {
    oe(ee, function() {
      re.apply(this, arguments);
    }, de);
  }, count: function(ee) {
    var re = 0;
    return oe(ee, function() {
      re++;
    }), re;
  }, toArray: function(ee) {
    return oe(ee, function(re) {
      return re;
    }) || [];
  }, only: function(ee) {
    if (!ie(ee)) throw Error("React.Children.only expected to receive a single React element child.");
    return ee;
  } }, Ar.Component = y, Ar.Fragment = t, Ar.Profiler = i, Ar.PureComponent = x, Ar.StrictMode = n, Ar.Suspense = l, Ar.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Re, Ar.act = Oe, Ar.cloneElement = function(ee, re, de) {
    if (ee == null) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + ee + ".");
    var Be = g({}, ee.props), ke = ee.key, ze = ee.ref, je = ee._owner;
    if (re != null) {
      if (re.ref !== void 0 && (ze = re.ref, je = R.current), re.key !== void 0 && (ke = "" + re.key), ee.type && ee.type.defaultProps) var qe = ee.type.defaultProps;
      for (Ge in re) S.call(re, Ge) && !M.hasOwnProperty(Ge) && (Be[Ge] = re[Ge] === void 0 && qe !== void 0 ? qe[Ge] : re[Ge]);
    }
    var Ge = arguments.length - 2;
    if (Ge === 1) Be.children = de;
    else if (1 < Ge) {
      qe = Array(Ge);
      for (var bt = 0; bt < Ge; bt++) qe[bt] = arguments[bt + 2];
      Be.children = qe;
    }
    return { $$typeof: r, type: ee.type, key: ke, ref: ze, props: Be, _owner: je };
  }, Ar.createContext = function(ee) {
    return ee = { $$typeof: s, _currentValue: ee, _currentValue2: ee, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, ee.Provider = { $$typeof: a, _context: ee }, ee.Consumer = ee;
  }, Ar.createElement = j, Ar.createFactory = function(ee) {
    var re = j.bind(null, ee);
    return re.type = ee, re;
  }, Ar.createRef = function() {
    return { current: null };
  }, Ar.forwardRef = function(ee) {
    return { $$typeof: o, render: ee };
  }, Ar.isValidElement = ie, Ar.lazy = function(ee) {
    return { $$typeof: c, _payload: { _status: -1, _result: ee }, _init: he };
  }, Ar.memo = function(ee, re) {
    return { $$typeof: u, type: ee, compare: re === void 0 ? null : re };
  }, Ar.startTransition = function(ee) {
    var re = Ue.transition;
    Ue.transition = {};
    try {
      ee();
    } finally {
      Ue.transition = re;
    }
  }, Ar.unstable_act = Oe, Ar.useCallback = function(ee, re) {
    return ye.current.useCallback(ee, re);
  }, Ar.useContext = function(ee) {
    return ye.current.useContext(ee);
  }, Ar.useDebugValue = function() {
  }, Ar.useDeferredValue = function(ee) {
    return ye.current.useDeferredValue(ee);
  }, Ar.useEffect = function(ee, re) {
    return ye.current.useEffect(ee, re);
  }, Ar.useId = function() {
    return ye.current.useId();
  }, Ar.useImperativeHandle = function(ee, re, de) {
    return ye.current.useImperativeHandle(ee, re, de);
  }, Ar.useInsertionEffect = function(ee, re) {
    return ye.current.useInsertionEffect(ee, re);
  }, Ar.useLayoutEffect = function(ee, re) {
    return ye.current.useLayoutEffect(ee, re);
  }, Ar.useMemo = function(ee, re) {
    return ye.current.useMemo(ee, re);
  }, Ar.useReducer = function(ee, re, de) {
    return ye.current.useReducer(ee, re, de);
  }, Ar.useRef = function(ee) {
    return ye.current.useRef(ee);
  }, Ar.useState = function(ee) {
    return ye.current.useState(ee);
  }, Ar.useSyncExternalStore = function(ee, re, de) {
    return ye.current.useSyncExternalStore(ee, re, de);
  }, Ar.useTransition = function() {
    return ye.current.useTransition();
  }, Ar.version = "18.3.1", Ar;
}
var If = { exports: {} };
If.exports;
var Bw;
function w4() {
  return Bw || (Bw = 1, (function(r, e) {
    process.env.NODE_ENV !== "production" && (function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var t = "18.3.1", n = /* @__PURE__ */ Symbol.for("react.element"), i = /* @__PURE__ */ Symbol.for("react.portal"), a = /* @__PURE__ */ Symbol.for("react.fragment"), s = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), l = /* @__PURE__ */ Symbol.for("react.provider"), u = /* @__PURE__ */ Symbol.for("react.context"), c = /* @__PURE__ */ Symbol.for("react.forward_ref"), d = /* @__PURE__ */ Symbol.for("react.suspense"), f = /* @__PURE__ */ Symbol.for("react.suspense_list"), h = /* @__PURE__ */ Symbol.for("react.memo"), g = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), y = Symbol.iterator, A = "@@iterator";
      function x(B) {
        if (B === null || typeof B != "object")
          return null;
        var Z = y && B[y] || B[A];
        return typeof Z == "function" ? Z : null;
      }
      var k = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, F = {
        transition: null
      }, S = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: !1,
        didScheduleLegacyUpdate: !1
      }, R = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, M = {}, j = null;
      function G(B) {
        j = B;
      }
      M.setExtraStackFrame = function(B) {
        j = B;
      }, M.getCurrentStack = null, M.getStackAddendum = function() {
        var B = "";
        j && (B += j);
        var Z = M.getCurrentStack;
        return Z && (B += Z() || ""), B;
      };
      var ie = !1, q = !1, Y = !1, J = !1, se = !1, oe = {
        ReactCurrentDispatcher: k,
        ReactCurrentBatchConfig: F,
        ReactCurrentOwner: R
      };
      oe.ReactDebugCurrentFrame = M, oe.ReactCurrentActQueue = S;
      function he(B) {
        {
          for (var Z = arguments.length, fe = new Array(Z > 1 ? Z - 1 : 0), be = 1; be < Z; be++)
            fe[be - 1] = arguments[be];
          Ue("warn", B, fe);
        }
      }
      function ye(B) {
        {
          for (var Z = arguments.length, fe = new Array(Z > 1 ? Z - 1 : 0), be = 1; be < Z; be++)
            fe[be - 1] = arguments[be];
          Ue("error", B, fe);
        }
      }
      function Ue(B, Z, fe) {
        {
          var be = oe.ReactDebugCurrentFrame, Me = be.getStackAddendum();
          Me !== "" && (Z += "%s", fe = fe.concat([Me]));
          var Ke = fe.map(function(Xe) {
            return String(Xe);
          });
          Ke.unshift("Warning: " + Z), Function.prototype.apply.call(console[B], console, Ke);
        }
      }
      var Re = {};
      function Oe(B, Z) {
        {
          var fe = B.constructor, be = fe && (fe.displayName || fe.name) || "ReactClass", Me = be + "." + Z;
          if (Re[Me])
            return;
          ye("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", Z, be), Re[Me] = !0;
        }
      }
      var ee = {
        /**
         * Checks whether or not this composite component is mounted.
         * @param {ReactClass} publicInstance The instance we want to test.
         * @return {boolean} True if mounted, false otherwise.
         * @protected
         * @final
         */
        isMounted: function(B) {
          return !1;
        },
        /**
         * Forces an update. This should only be invoked when it is known with
         * certainty that we are **not** in a DOM transaction.
         *
         * You may want to call this when you know that some deeper aspect of the
         * component's state has changed but `setState` was not called.
         *
         * This will not invoke `shouldComponentUpdate`, but it will invoke
         * `componentWillUpdate` and `componentDidUpdate`.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueForceUpdate: function(B, Z, fe) {
          Oe(B, "forceUpdate");
        },
        /**
         * Replaces all of the state. Always use this or `setState` to mutate state.
         * You should treat `this.state` as immutable.
         *
         * There is no guarantee that `this.state` will be immediately updated, so
         * accessing `this.state` after calling this method may return the old value.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} completeState Next state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueReplaceState: function(B, Z, fe, be) {
          Oe(B, "replaceState");
        },
        /**
         * Sets a subset of the state. This only exists because _pendingState is
         * internal. This provides a merging strategy that is not available to deep
         * properties which is confusing. TODO: Expose pendingState or don't use it
         * during the merge.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} partialState Next partial state to be merged with state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} Name of the calling function in the public API.
         * @internal
         */
        enqueueSetState: function(B, Z, fe, be) {
          Oe(B, "setState");
        }
      }, re = Object.assign, de = {};
      Object.freeze(de);
      function Be(B, Z, fe) {
        this.props = B, this.context = Z, this.refs = de, this.updater = fe || ee;
      }
      Be.prototype.isReactComponent = {}, Be.prototype.setState = function(B, Z) {
        if (typeof B != "object" && typeof B != "function" && B != null)
          throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, B, Z, "setState");
      }, Be.prototype.forceUpdate = function(B) {
        this.updater.enqueueForceUpdate(this, B, "forceUpdate");
      };
      {
        var ke = {
          isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
          replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
        }, ze = function(B, Z) {
          Object.defineProperty(Be.prototype, B, {
            get: function() {
              he("%s(...) is deprecated in plain JavaScript React classes. %s", Z[0], Z[1]);
            }
          });
        };
        for (var je in ke)
          ke.hasOwnProperty(je) && ze(je, ke[je]);
      }
      function qe() {
      }
      qe.prototype = Be.prototype;
      function Ge(B, Z, fe) {
        this.props = B, this.context = Z, this.refs = de, this.updater = fe || ee;
      }
      var bt = Ge.prototype = new qe();
      bt.constructor = Ge, re(bt, Be.prototype), bt.isPureReactComponent = !0;
      function rr() {
        var B = {
          current: null
        };
        return Object.seal(B), B;
      }
      var Pr = Array.isArray;
      function Gt(B) {
        return Pr(B);
      }
      function ar(B) {
        {
          var Z = typeof Symbol == "function" && Symbol.toStringTag, fe = Z && B[Symbol.toStringTag] || B.constructor.name || "Object";
          return fe;
        }
      }
      function St(B) {
        try {
          return st(B), !1;
        } catch {
          return !0;
        }
      }
      function st(B) {
        return "" + B;
      }
      function Qr(B) {
        if (St(B))
          return ye("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ar(B)), st(B);
      }
      function Sr(B, Z, fe) {
        var be = B.displayName;
        if (be)
          return be;
        var Me = Z.displayName || Z.name || "";
        return Me !== "" ? fe + "(" + Me + ")" : fe;
      }
      function gr(B) {
        return B.displayName || "Context";
      }
      function nr(B) {
        if (B == null)
          return null;
        if (typeof B.tag == "number" && ye("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof B == "function")
          return B.displayName || B.name || null;
        if (typeof B == "string")
          return B;
        switch (B) {
          case a:
            return "Fragment";
          case i:
            return "Portal";
          case o:
            return "Profiler";
          case s:
            return "StrictMode";
          case d:
            return "Suspense";
          case f:
            return "SuspenseList";
        }
        if (typeof B == "object")
          switch (B.$$typeof) {
            case u:
              var Z = B;
              return gr(Z) + ".Consumer";
            case l:
              var fe = B;
              return gr(fe._context) + ".Provider";
            case c:
              return Sr(B, B.render, "ForwardRef");
            case h:
              var be = B.displayName || null;
              return be !== null ? be : nr(B.type) || "Memo";
            case g: {
              var Me = B, Ke = Me._payload, Xe = Me._init;
              try {
                return nr(Xe(Ke));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var fr = Object.prototype.hasOwnProperty, Yt = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Xt, mt, wr;
      wr = {};
      function an(B) {
        if (fr.call(B, "ref")) {
          var Z = Object.getOwnPropertyDescriptor(B, "ref").get;
          if (Z && Z.isReactWarning)
            return !1;
        }
        return B.ref !== void 0;
      }
      function _r(B) {
        if (fr.call(B, "key")) {
          var Z = Object.getOwnPropertyDescriptor(B, "key").get;
          if (Z && Z.isReactWarning)
            return !1;
        }
        return B.key !== void 0;
      }
      function ir(B, Z) {
        var fe = function() {
          Xt || (Xt = !0, ye("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Z));
        };
        fe.isReactWarning = !0, Object.defineProperty(B, "key", {
          get: fe,
          configurable: !0
        });
      }
      function Yr(B, Z) {
        var fe = function() {
          mt || (mt = !0, ye("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Z));
        };
        fe.isReactWarning = !0, Object.defineProperty(B, "ref", {
          get: fe,
          configurable: !0
        });
      }
      function kr(B) {
        if (typeof B.ref == "string" && R.current && B.__self && R.current.stateNode !== B.__self) {
          var Z = nr(R.current.type);
          wr[Z] || (ye('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', Z, B.ref), wr[Z] = !0);
        }
      }
      var Zr = function(B, Z, fe, be, Me, Ke, Xe) {
        var yt = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: n,
          // Built-in properties that belong on the element
          type: B,
          key: Z,
          ref: fe,
          props: Xe,
          // Record the component responsible for creating this element.
          _owner: Ke
        };
        return yt._store = {}, Object.defineProperty(yt._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(yt, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: be
        }), Object.defineProperty(yt, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: Me
        }), Object.freeze && (Object.freeze(yt.props), Object.freeze(yt)), yt;
      };
      function Vr(B, Z, fe) {
        var be, Me = {}, Ke = null, Xe = null, yt = null, Ot = null;
        if (Z != null) {
          an(Z) && (Xe = Z.ref, kr(Z)), _r(Z) && (Qr(Z.key), Ke = "" + Z.key), yt = Z.__self === void 0 ? null : Z.__self, Ot = Z.__source === void 0 ? null : Z.__source;
          for (be in Z)
            fr.call(Z, be) && !Yt.hasOwnProperty(be) && (Me[be] = Z[be]);
        }
        var pr = arguments.length - 2;
        if (pr === 1)
          Me.children = fe;
        else if (pr > 1) {
          for (var yr = Array(pr), ur = 0; ur < pr; ur++)
            yr[ur] = arguments[ur + 2];
          Object.freeze && Object.freeze(yr), Me.children = yr;
        }
        if (B && B.defaultProps) {
          var Fr = B.defaultProps;
          for (be in Fr)
            Me[be] === void 0 && (Me[be] = Fr[be]);
        }
        if (Ke || Xe) {
          var Gr = typeof B == "function" ? B.displayName || B.name || "Unknown" : B;
          Ke && ir(Me, Gr), Xe && Yr(Me, Gr);
        }
        return Zr(B, Ke, Xe, yt, Ot, R.current, Me);
      }
      function pn(B, Z) {
        var fe = Zr(B.type, Z, B.ref, B._self, B._source, B._owner, B.props);
        return fe;
      }
      function gn(B, Z, fe) {
        if (B == null)
          throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + B + ".");
        var be, Me = re({}, B.props), Ke = B.key, Xe = B.ref, yt = B._self, Ot = B._source, pr = B._owner;
        if (Z != null) {
          an(Z) && (Xe = Z.ref, pr = R.current), _r(Z) && (Qr(Z.key), Ke = "" + Z.key);
          var yr;
          B.type && B.type.defaultProps && (yr = B.type.defaultProps);
          for (be in Z)
            fr.call(Z, be) && !Yt.hasOwnProperty(be) && (Z[be] === void 0 && yr !== void 0 ? Me[be] = yr[be] : Me[be] = Z[be]);
        }
        var ur = arguments.length - 2;
        if (ur === 1)
          Me.children = fe;
        else if (ur > 1) {
          for (var Fr = Array(ur), Gr = 0; Gr < ur; Gr++)
            Fr[Gr] = arguments[Gr + 2];
          Me.children = Fr;
        }
        return Zr(B.type, Ke, Xe, yt, Ot, pr, Me);
      }
      function Tr(B) {
        return typeof B == "object" && B !== null && B.$$typeof === n;
      }
      var zr = ".", en = ":";
      function $r(B) {
        var Z = /[=:]/g, fe = {
          "=": "=0",
          ":": "=2"
        }, be = B.replace(Z, function(Me) {
          return fe[Me];
        });
        return "$" + be;
      }
      var zt = !1, sr = /\/+/g;
      function Er(B) {
        return B.replace(sr, "$&/");
      }
      function tt(B, Z) {
        return typeof B == "object" && B !== null && B.key != null ? (Qr(B.key), $r("" + B.key)) : Z.toString(36);
      }
      function Nr(B, Z, fe, be, Me) {
        var Ke = typeof B;
        (Ke === "undefined" || Ke === "boolean") && (B = null);
        var Xe = !1;
        if (B === null)
          Xe = !0;
        else
          switch (Ke) {
            case "string":
            case "number":
              Xe = !0;
              break;
            case "object":
              switch (B.$$typeof) {
                case n:
                case i:
                  Xe = !0;
              }
          }
        if (Xe) {
          var yt = B, Ot = Me(yt), pr = be === "" ? zr + tt(yt, 0) : be;
          if (Gt(Ot)) {
            var yr = "";
            pr != null && (yr = Er(pr) + "/"), Nr(Ot, Z, yr, "", function(La) {
              return La;
            });
          } else Ot != null && (Tr(Ot) && (Ot.key && (!yt || yt.key !== Ot.key) && Qr(Ot.key), Ot = pn(
            Ot,
            // Keep both the (mapped) and old keys if they differ, just as
            // traverseAllChildren used to do for objects as children
            fe + // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
            (Ot.key && (!yt || yt.key !== Ot.key) ? (
              // $FlowFixMe Flow incorrectly thinks existing element's key can be a number
              // eslint-disable-next-line react-internal/safe-string-coercion
              Er("" + Ot.key) + "/"
            ) : "") + pr
          )), Z.push(Ot));
          return 1;
        }
        var ur, Fr, Gr = 0, yn = be === "" ? zr : be + en;
        if (Gt(B))
          for (var Wi = 0; Wi < B.length; Wi++)
            ur = B[Wi], Fr = yn + tt(ur, Wi), Gr += Nr(ur, Z, fe, Fr, Me);
        else {
          var aa = x(B);
          if (typeof aa == "function") {
            var Qi = B;
            aa === Qi.entries && (zt || he("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), zt = !0);
            for (var qn = aa.call(Qi), Yi, di = 0; !(Yi = qn.next()).done; )
              ur = Yi.value, Fr = yn + tt(ur, di++), Gr += Nr(ur, Z, fe, Fr, Me);
          } else if (Ke === "object") {
            var Na = String(B);
            throw new Error("Objects are not valid as a React child (found: " + (Na === "[object Object]" ? "object with keys {" + Object.keys(B).join(", ") + "}" : Na) + "). If you meant to render a collection of children, use an array instead.");
          }
        }
        return Gr;
      }
      function Xr(B, Z, fe) {
        if (B == null)
          return B;
        var be = [], Me = 0;
        return Nr(B, be, "", "", function(Ke) {
          return Z.call(fe, Ke, Me++);
        }), be;
      }
      function Se(B) {
        var Z = 0;
        return Xr(B, function() {
          Z++;
        }), Z;
      }
      function P(B, Z, fe) {
        Xr(B, function() {
          Z.apply(this, arguments);
        }, fe);
      }
      function U(B) {
        return Xr(B, function(Z) {
          return Z;
        }) || [];
      }
      function X(B) {
        if (!Tr(B))
          throw new Error("React.Children.only expected to receive a single React element child.");
        return B;
      }
      function ue(B) {
        var Z = {
          $$typeof: u,
          // As a workaround to support multiple concurrent renderers, we categorize
          // some renderers as primary and others as secondary. We only expect
          // there to be two concurrent renderers at most: React Native (primary) and
          // Fabric (secondary); React DOM (primary) and React ART (secondary).
          // Secondary renderers store their context values on separate fields.
          _currentValue: B,
          _currentValue2: B,
          // Used to track how many concurrent renderers this context currently
          // supports within in a single renderer. Such as parallel server rendering.
          _threadCount: 0,
          // These are circular
          Provider: null,
          Consumer: null,
          // Add these to use same hidden class in VM as ServerContext
          _defaultValue: null,
          _globalName: null
        };
        Z.Provider = {
          $$typeof: l,
          _context: Z
        };
        var fe = !1, be = !1, Me = !1;
        {
          var Ke = {
            $$typeof: u,
            _context: Z
          };
          Object.defineProperties(Ke, {
            Provider: {
              get: function() {
                return be || (be = !0, ye("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), Z.Provider;
              },
              set: function(Xe) {
                Z.Provider = Xe;
              }
            },
            _currentValue: {
              get: function() {
                return Z._currentValue;
              },
              set: function(Xe) {
                Z._currentValue = Xe;
              }
            },
            _currentValue2: {
              get: function() {
                return Z._currentValue2;
              },
              set: function(Xe) {
                Z._currentValue2 = Xe;
              }
            },
            _threadCount: {
              get: function() {
                return Z._threadCount;
              },
              set: function(Xe) {
                Z._threadCount = Xe;
              }
            },
            Consumer: {
              get: function() {
                return fe || (fe = !0, ye("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), Z.Consumer;
              }
            },
            displayName: {
              get: function() {
                return Z.displayName;
              },
              set: function(Xe) {
                Me || (he("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", Xe), Me = !0);
              }
            }
          }), Z.Consumer = Ke;
        }
        return Z._currentRenderer = null, Z._currentRenderer2 = null, Z;
      }
      var Fe = -1, We = 0, wt = 1, Pt = 2;
      function Nt(B) {
        if (B._status === Fe) {
          var Z = B._result, fe = Z();
          if (fe.then(function(Ke) {
            if (B._status === We || B._status === Fe) {
              var Xe = B;
              Xe._status = wt, Xe._result = Ke;
            }
          }, function(Ke) {
            if (B._status === We || B._status === Fe) {
              var Xe = B;
              Xe._status = Pt, Xe._result = Ke;
            }
          }), B._status === Fe) {
            var be = B;
            be._status = We, be._result = fe;
          }
        }
        if (B._status === wt) {
          var Me = B._result;
          return Me === void 0 && ye(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`, Me), "default" in Me || ye(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`, Me), Me.default;
        } else
          throw B._result;
      }
      function or(B) {
        var Z = {
          // We use these fields to store the result.
          _status: Fe,
          _result: B
        }, fe = {
          $$typeof: g,
          _payload: Z,
          _init: Nt
        };
        {
          var be, Me;
          Object.defineProperties(fe, {
            defaultProps: {
              configurable: !0,
              get: function() {
                return be;
              },
              set: function(Ke) {
                ye("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), be = Ke, Object.defineProperty(fe, "defaultProps", {
                  enumerable: !0
                });
              }
            },
            propTypes: {
              configurable: !0,
              get: function() {
                return Me;
              },
              set: function(Ke) {
                ye("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), Me = Ke, Object.defineProperty(fe, "propTypes", {
                  enumerable: !0
                });
              }
            }
          });
        }
        return fe;
      }
      function Lt(B) {
        B != null && B.$$typeof === h ? ye("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof B != "function" ? ye("forwardRef requires a render function but was given %s.", B === null ? "null" : typeof B) : B.length !== 0 && B.length !== 2 && ye("forwardRef render functions accept exactly two parameters: props and ref. %s", B.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), B != null && (B.defaultProps != null || B.propTypes != null) && ye("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        var Z = {
          $$typeof: c,
          render: B
        };
        {
          var fe;
          Object.defineProperty(Z, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return fe;
            },
            set: function(be) {
              fe = be, !B.name && !B.displayName && (B.displayName = be);
            }
          });
        }
        return Z;
      }
      var K;
      K = /* @__PURE__ */ Symbol.for("react.module.reference");
      function Ie(B) {
        return !!(typeof B == "string" || typeof B == "function" || B === a || B === o || se || B === s || B === d || B === f || J || B === v || ie || q || Y || typeof B == "object" && B !== null && (B.$$typeof === g || B.$$typeof === h || B.$$typeof === l || B.$$typeof === u || B.$$typeof === c || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        B.$$typeof === K || B.getModuleId !== void 0));
      }
      function Qe(B, Z) {
        Ie(B) || ye("memo: The first argument must be a component. Instead received: %s", B === null ? "null" : typeof B);
        var fe = {
          $$typeof: h,
          type: B,
          compare: Z === void 0 ? null : Z
        };
        {
          var be;
          Object.defineProperty(fe, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return be;
            },
            set: function(Me) {
              be = Me, !B.name && !B.displayName && (B.displayName = Me);
            }
          });
        }
        return fe;
      }
      function Ye() {
        var B = k.current;
        return B === null && ye(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`), B;
      }
      function Ct(B) {
        var Z = Ye();
        if (B._context !== void 0) {
          var fe = B._context;
          fe.Consumer === B ? ye("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : fe.Provider === B && ye("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return Z.useContext(B);
      }
      function dt(B) {
        var Z = Ye();
        return Z.useState(B);
      }
      function Rt(B, Z, fe) {
        var be = Ye();
        return be.useReducer(B, Z, fe);
      }
      function Et(B) {
        var Z = Ye();
        return Z.useRef(B);
      }
      function hr(B, Z) {
        var fe = Ye();
        return fe.useEffect(B, Z);
      }
      function er(B, Z) {
        var fe = Ye();
        return fe.useInsertionEffect(B, Z);
      }
      function dr(B, Z) {
        var fe = Ye();
        return fe.useLayoutEffect(B, Z);
      }
      function $t(B, Z) {
        var fe = Ye();
        return fe.useCallback(B, Z);
      }
      function On(B, Z) {
        var fe = Ye();
        return fe.useMemo(B, Z);
      }
      function Fn(B, Z, fe) {
        var be = Ye();
        return be.useImperativeHandle(B, Z, fe);
      }
      function mr(B, Z) {
        {
          var fe = Ye();
          return fe.useDebugValue(B, Z);
        }
      }
      function xr() {
        var B = Ye();
        return B.useTransition();
      }
      function wn(B) {
        var Z = Ye();
        return Z.useDeferredValue(B);
      }
      function Rr() {
        var B = Ye();
        return B.useId();
      }
      function jn(B, Z, fe) {
        var be = Ye();
        return be.useSyncExternalStore(B, Z, fe);
      }
      var xn = 0, Hr, Cn, cn, tn, Jn, ii, Sn;
      function mn() {
      }
      mn.__reactDisabledLog = !0;
      function sn() {
        {
          if (xn === 0) {
            Hr = console.log, Cn = console.info, cn = console.warn, tn = console.error, Jn = console.group, ii = console.groupCollapsed, Sn = console.groupEnd;
            var B = {
              configurable: !0,
              enumerable: !0,
              value: mn,
              writable: !0
            };
            Object.defineProperties(console, {
              info: B,
              log: B,
              warn: B,
              error: B,
              group: B,
              groupCollapsed: B,
              groupEnd: B
            });
          }
          xn++;
        }
      }
      function rn() {
        {
          if (xn--, xn === 0) {
            var B = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: re({}, B, {
                value: Hr
              }),
              info: re({}, B, {
                value: Cn
              }),
              warn: re({}, B, {
                value: cn
              }),
              error: re({}, B, {
                value: tn
              }),
              group: re({}, B, {
                value: Jn
              }),
              groupCollapsed: re({}, B, {
                value: ii
              }),
              groupEnd: re({}, B, {
                value: Sn
              })
            });
          }
          xn < 0 && ye("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Lr = oe.ReactCurrentDispatcher, on;
      function E(B, Z, fe) {
        {
          if (on === void 0)
            try {
              throw Error();
            } catch (Me) {
              var be = Me.stack.trim().match(/\n( *(at )?)/);
              on = be && be[1] || "";
            }
          return `
` + on + B;
        }
      }
      var O = !1, z;
      {
        var W = typeof WeakMap == "function" ? WeakMap : Map;
        z = new W();
      }
      function pe(B, Z) {
        if (!B || O)
          return "";
        {
          var fe = z.get(B);
          if (fe !== void 0)
            return fe;
        }
        var be;
        O = !0;
        var Me = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var Ke;
        Ke = Lr.current, Lr.current = null, sn();
        try {
          if (Z) {
            var Xe = function() {
              throw Error();
            };
            if (Object.defineProperty(Xe.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(Xe, []);
              } catch (yn) {
                be = yn;
              }
              Reflect.construct(B, [], Xe);
            } else {
              try {
                Xe.call();
              } catch (yn) {
                be = yn;
              }
              B.call(Xe.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (yn) {
              be = yn;
            }
            B();
          }
        } catch (yn) {
          if (yn && be && typeof yn.stack == "string") {
            for (var yt = yn.stack.split(`
`), Ot = be.stack.split(`
`), pr = yt.length - 1, yr = Ot.length - 1; pr >= 1 && yr >= 0 && yt[pr] !== Ot[yr]; )
              yr--;
            for (; pr >= 1 && yr >= 0; pr--, yr--)
              if (yt[pr] !== Ot[yr]) {
                if (pr !== 1 || yr !== 1)
                  do
                    if (pr--, yr--, yr < 0 || yt[pr] !== Ot[yr]) {
                      var ur = `
` + yt[pr].replace(" at new ", " at ");
                      return B.displayName && ur.includes("<anonymous>") && (ur = ur.replace("<anonymous>", B.displayName)), typeof B == "function" && z.set(B, ur), ur;
                    }
                  while (pr >= 1 && yr >= 0);
                break;
              }
          }
        } finally {
          O = !1, Lr.current = Ke, rn(), Error.prepareStackTrace = Me;
        }
        var Fr = B ? B.displayName || B.name : "", Gr = Fr ? E(Fr) : "";
        return typeof B == "function" && z.set(B, Gr), Gr;
      }
      function ce(B, Z, fe) {
        return pe(B, !1);
      }
      function Ce(B) {
        var Z = B.prototype;
        return !!(Z && Z.isReactComponent);
      }
      function _e(B, Z, fe) {
        if (B == null)
          return "";
        if (typeof B == "function")
          return pe(B, Ce(B));
        if (typeof B == "string")
          return E(B);
        switch (B) {
          case d:
            return E("Suspense");
          case f:
            return E("SuspenseList");
        }
        if (typeof B == "object")
          switch (B.$$typeof) {
            case c:
              return ce(B.render);
            case h:
              return _e(B.type, Z, fe);
            case g: {
              var be = B, Me = be._payload, Ke = be._init;
              try {
                return _e(Ke(Me), Z, fe);
              } catch {
              }
            }
          }
        return "";
      }
      var rt = {}, ut = oe.ReactDebugCurrentFrame;
      function nt(B) {
        if (B) {
          var Z = B._owner, fe = _e(B.type, B._source, Z ? Z.type : null);
          ut.setExtraStackFrame(fe);
        } else
          ut.setExtraStackFrame(null);
      }
      function Jt(B, Z, fe, be, Me) {
        {
          var Ke = Function.call.bind(fr);
          for (var Xe in B)
            if (Ke(B, Xe)) {
              var yt = void 0;
              try {
                if (typeof B[Xe] != "function") {
                  var Ot = Error((be || "React class") + ": " + fe + " type `" + Xe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof B[Xe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw Ot.name = "Invariant Violation", Ot;
                }
                yt = B[Xe](Z, Xe, be, fe, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (pr) {
                yt = pr;
              }
              yt && !(yt instanceof Error) && (nt(Me), ye("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", be || "React class", fe, Xe, typeof yt), nt(null)), yt instanceof Error && !(yt.message in rt) && (rt[yt.message] = !0, nt(Me), ye("Failed %s type: %s", fe, yt.message), nt(null));
            }
        }
      }
      function vr(B) {
        if (B) {
          var Z = B._owner, fe = _e(B.type, B._source, Z ? Z.type : null);
          G(fe);
        } else
          G(null);
      }
      var jr;
      jr = !1;
      function fn() {
        if (R.current) {
          var B = nr(R.current.type);
          if (B)
            return `

Check the render method of \`` + B + "`.";
        }
        return "";
      }
      function Kn(B) {
        if (B !== void 0) {
          var Z = B.fileName.replace(/^.*[\\\/]/, ""), fe = B.lineNumber;
          return `

Check your code at ` + Z + ":" + fe + ".";
        }
        return "";
      }
      function Ln(B) {
        return B != null ? Kn(B.__source) : "";
      }
      var vn = {};
      function Or(B) {
        var Z = fn();
        if (!Z) {
          var fe = typeof B == "string" ? B : B.displayName || B.name;
          fe && (Z = `

Check the top-level render call using <` + fe + ">.");
        }
        return Z;
      }
      function Gn(B, Z) {
        if (!(!B._store || B._store.validated || B.key != null)) {
          B._store.validated = !0;
          var fe = Or(Z);
          if (!vn[fe]) {
            vn[fe] = !0;
            var be = "";
            B && B._owner && B._owner !== R.current && (be = " It was passed a child from " + nr(B._owner.type) + "."), vr(B), ye('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', fe, be), vr(null);
          }
        }
      }
      function Bn(B, Z) {
        if (typeof B == "object") {
          if (Gt(B))
            for (var fe = 0; fe < B.length; fe++) {
              var be = B[fe];
              Tr(be) && Gn(be, Z);
            }
          else if (Tr(B))
            B._store && (B._store.validated = !0);
          else if (B) {
            var Me = x(B);
            if (typeof Me == "function" && Me !== B.entries)
              for (var Ke = Me.call(B), Xe; !(Xe = Ke.next()).done; )
                Tr(Xe.value) && Gn(Xe.value, Z);
          }
        }
      }
      function Mn(B) {
        {
          var Z = B.type;
          if (Z == null || typeof Z == "string")
            return;
          var fe;
          if (typeof Z == "function")
            fe = Z.propTypes;
          else if (typeof Z == "object" && (Z.$$typeof === c || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          Z.$$typeof === h))
            fe = Z.propTypes;
          else
            return;
          if (fe) {
            var be = nr(Z);
            Jt(fe, B.props, "prop", be, B);
          } else if (Z.PropTypes !== void 0 && !jr) {
            jr = !0;
            var Me = nr(Z);
            ye("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Me || "Unknown");
          }
          typeof Z.getDefaultProps == "function" && !Z.getDefaultProps.isReactClassApproved && ye("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Ri(B) {
        {
          for (var Z = Object.keys(B.props), fe = 0; fe < Z.length; fe++) {
            var be = Z[fe];
            if (be !== "children" && be !== "key") {
              vr(B), ye("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", be), vr(null);
              break;
            }
          }
          B.ref !== null && (vr(B), ye("Invalid attribute `ref` supplied to `React.Fragment`."), vr(null));
        }
      }
      function yi(B, Z, fe) {
        var be = Ie(B);
        if (!be) {
          var Me = "";
          (B === void 0 || typeof B == "object" && B !== null && Object.keys(B).length === 0) && (Me += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ke = Ln(Z);
          Ke ? Me += Ke : Me += fn();
          var Xe;
          B === null ? Xe = "null" : Gt(B) ? Xe = "array" : B !== void 0 && B.$$typeof === n ? (Xe = "<" + (nr(B.type) || "Unknown") + " />", Me = " Did you accidentally export a JSX literal instead of a component?") : Xe = typeof B, ye("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Xe, Me);
        }
        var yt = Vr.apply(this, arguments);
        if (yt == null)
          return yt;
        if (be)
          for (var Ot = 2; Ot < arguments.length; Ot++)
            Bn(arguments[Ot], B);
        return B === a ? Ri(yt) : Mn(yt), yt;
      }
      var Ai = !1;
      function _n(B) {
        var Z = yi.bind(null, B);
        return Z.type = B, Ai || (Ai = !0, he("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(Z, "type", {
          enumerable: !1,
          get: function() {
            return he("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
              value: B
            }), B;
          }
        }), Z;
      }
      function ki(B, Z, fe) {
        for (var be = gn.apply(this, arguments), Me = 2; Me < arguments.length; Me++)
          Bn(arguments[Me], be.type);
        return Mn(be), be;
      }
      function Un(B, Z) {
        var fe = F.transition;
        F.transition = {};
        var be = F.transition;
        F.transition._updatedFibers = /* @__PURE__ */ new Set();
        try {
          B();
        } finally {
          if (F.transition = fe, fe === null && be._updatedFibers) {
            var Me = be._updatedFibers.size;
            Me > 10 && he("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), be._updatedFibers.clear();
          }
        }
      }
      var En = !1, Zn = null;
      function lr(B) {
        if (Zn === null)
          try {
            var Z = ("require" + Math.random()).slice(0, 7), fe = r && r[Z];
            Zn = fe.call(r, "timers").setImmediate;
          } catch {
            Zn = function(Me) {
              En === !1 && (En = !0, typeof MessageChannel > "u" && ye("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
              var Ke = new MessageChannel();
              Ke.port1.onmessage = Me, Ke.port2.postMessage(void 0);
            };
          }
        return Zn(B);
      }
      var In = 0, bi = !1;
      function I(B) {
        {
          var Z = In;
          In++, S.current === null && (S.current = []);
          var fe = S.isBatchingLegacy, be;
          try {
            if (S.isBatchingLegacy = !0, be = B(), !fe && S.didScheduleLegacyUpdate) {
              var Me = S.current;
              Me !== null && (S.didScheduleLegacyUpdate = !1, ht(Me));
            }
          } catch (Fr) {
            throw $(Z), Fr;
          } finally {
            S.isBatchingLegacy = fe;
          }
          if (be !== null && typeof be == "object" && typeof be.then == "function") {
            var Ke = be, Xe = !1, yt = {
              then: function(Fr, Gr) {
                Xe = !0, Ke.then(function(yn) {
                  $(Z), In === 0 ? ae(yn, Fr, Gr) : Fr(yn);
                }, function(yn) {
                  $(Z), Gr(yn);
                });
              }
            };
            return !bi && typeof Promise < "u" && Promise.resolve().then(function() {
            }).then(function() {
              Xe || (bi = !0, ye("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
            }), yt;
          } else {
            var Ot = be;
            if ($(Z), In === 0) {
              var pr = S.current;
              pr !== null && (ht(pr), S.current = null);
              var yr = {
                then: function(Fr, Gr) {
                  S.current === null ? (S.current = [], ae(Ot, Fr, Gr)) : Fr(Ot);
                }
              };
              return yr;
            } else {
              var ur = {
                then: function(Fr, Gr) {
                  Fr(Ot);
                }
              };
              return ur;
            }
          }
        }
      }
      function $(B) {
        B !== In - 1 && ye("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "), In = B;
      }
      function ae(B, Z, fe) {
        {
          var be = S.current;
          if (be !== null)
            try {
              ht(be), lr(function() {
                be.length === 0 ? (S.current = null, Z(B)) : ae(B, Z, fe);
              });
            } catch (Me) {
              fe(Me);
            }
          else
            Z(B);
        }
      }
      var xe = !1;
      function ht(B) {
        if (!xe) {
          xe = !0;
          var Z = 0;
          try {
            for (; Z < B.length; Z++) {
              var fe = B[Z];
              do
                fe = fe(!0);
              while (fe !== null);
            }
            B.length = 0;
          } catch (be) {
            throw B = B.slice(Z + 1), be;
          } finally {
            xe = !1;
          }
        }
      }
      var lt = yi, Ht = ki, Ut = _n, Br = {
        map: Xr,
        forEach: P,
        count: Se,
        toArray: U,
        only: X
      };
      e.Children = Br, e.Component = Be, e.Fragment = a, e.Profiler = o, e.PureComponent = Ge, e.StrictMode = s, e.Suspense = d, e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = oe, e.act = I, e.cloneElement = Ht, e.createContext = ue, e.createElement = lt, e.createFactory = Ut, e.createRef = rr, e.forwardRef = Lt, e.isValidElement = Tr, e.lazy = or, e.memo = Qe, e.startTransition = Un, e.unstable_act = I, e.useCallback = $t, e.useContext = Ct, e.useDebugValue = mr, e.useDeferredValue = wn, e.useEffect = hr, e.useId = Rr, e.useImperativeHandle = Fn, e.useInsertionEffect = er, e.useLayoutEffect = dr, e.useMemo = On, e.useReducer = Rt, e.useRef = Et, e.useState = dt, e.useSyncExternalStore = jn, e.useTransition = xr, e.version = t, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    })();
  })(If, If.exports)), If.exports;
}
var Mw;
function Sl() {
  return Mw || (Mw = 1, process.env.NODE_ENV === "production" ? Th.exports = b4() : Th.exports = w4()), Th.exports;
}
var _w;
function x4() {
  if (_w) return rl;
  _w = 1;
  var r = Sl();
  function e(E) {
    for (var O = "https://reactjs.org/docs/error-decoder.html?invariant=" + E, z = 1; z < arguments.length; z++) O += "&args[]=" + encodeURIComponent(arguments[z]);
    return "Minified React error #" + E + "; visit " + O + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var t = Object.prototype.hasOwnProperty, n = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, i = {}, a = {};
  function s(E) {
    return t.call(a, E) ? !0 : t.call(i, E) ? !1 : n.test(E) ? a[E] = !0 : (i[E] = !0, !1);
  }
  function o(E, O, z, W, pe, ce, Ce) {
    this.acceptsBooleans = O === 2 || O === 3 || O === 4, this.attributeName = W, this.attributeNamespace = pe, this.mustUseProperty = z, this.propertyName = E, this.type = O, this.sanitizeURL = ce, this.removeEmptyString = Ce;
  }
  var l = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(E) {
    l[E] = new o(E, 0, !1, E, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(E) {
    var O = E[0];
    l[O] = new o(O, 1, !1, E[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(E) {
    l[E] = new o(E, 2, !1, E.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(E) {
    l[E] = new o(E, 2, !1, E, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(E) {
    l[E] = new o(E, 3, !1, E.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(E) {
    l[E] = new o(E, 3, !0, E, null, !1, !1);
  }), ["capture", "download"].forEach(function(E) {
    l[E] = new o(E, 4, !1, E, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(E) {
    l[E] = new o(E, 6, !1, E, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(E) {
    l[E] = new o(E, 5, !1, E.toLowerCase(), null, !1, !1);
  });
  var u = /[\-:]([a-z])/g;
  function c(E) {
    return E[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(E) {
    var O = E.replace(
      u,
      c
    );
    l[O] = new o(O, 1, !1, E, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(E) {
    var O = E.replace(u, c);
    l[O] = new o(O, 1, !1, E, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(E) {
    var O = E.replace(u, c);
    l[O] = new o(O, 1, !1, E, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(E) {
    l[E] = new o(E, 1, !1, E.toLowerCase(), null, !1, !1);
  }), l.xlinkHref = new o("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(E) {
    l[E] = new o(E, 1, !1, E.toLowerCase(), null, !0, !0);
  });
  var d = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, f = ["Webkit", "ms", "Moz", "O"];
  Object.keys(d).forEach(function(E) {
    f.forEach(function(O) {
      O = O + E.charAt(0).toUpperCase() + E.substring(1), d[O] = d[E];
    });
  });
  var h = /["'&<>]/;
  function g(E) {
    if (typeof E == "boolean" || typeof E == "number") return "" + E;
    E = "" + E;
    var O = h.exec(E);
    if (O) {
      var z = "", W, pe = 0;
      for (W = O.index; W < E.length; W++) {
        switch (E.charCodeAt(W)) {
          case 34:
            O = "&quot;";
            break;
          case 38:
            O = "&amp;";
            break;
          case 39:
            O = "&#x27;";
            break;
          case 60:
            O = "&lt;";
            break;
          case 62:
            O = "&gt;";
            break;
          default:
            continue;
        }
        pe !== W && (z += E.substring(pe, W)), pe = W + 1, z += O;
      }
      E = pe !== W ? z + E.substring(pe, W) : z;
    }
    return E;
  }
  var v = /([A-Z])/g, y = /^ms-/, A = Array.isArray;
  function x(E, O) {
    return { insertionMode: E, selectedValue: O };
  }
  function k(E, O, z) {
    switch (O) {
      case "select":
        return x(1, z.value != null ? z.value : z.defaultValue);
      case "svg":
        return x(2, null);
      case "math":
        return x(3, null);
      case "foreignObject":
        return x(1, null);
      case "table":
        return x(4, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return x(5, null);
      case "colgroup":
        return x(7, null);
      case "tr":
        return x(6, null);
    }
    return 4 <= E.insertionMode || E.insertionMode === 0 ? x(1, null) : E;
  }
  var F = /* @__PURE__ */ new Map();
  function S(E, O, z) {
    if (typeof z != "object") throw Error(e(62));
    O = !0;
    for (var W in z) if (t.call(z, W)) {
      var pe = z[W];
      if (pe != null && typeof pe != "boolean" && pe !== "") {
        if (W.indexOf("--") === 0) {
          var ce = g(W);
          pe = g(("" + pe).trim());
        } else {
          ce = W;
          var Ce = F.get(ce);
          Ce !== void 0 || (Ce = g(ce.replace(v, "-$1").toLowerCase().replace(y, "-ms-")), F.set(ce, Ce)), ce = Ce, pe = typeof pe == "number" ? pe === 0 || t.call(d, W) ? "" + pe : pe + "px" : g(("" + pe).trim());
        }
        O ? (O = !1, E.push(' style="', ce, ":", pe)) : E.push(";", ce, ":", pe);
      }
    }
    O || E.push('"');
  }
  function R(E, O, z, W) {
    switch (z) {
      case "style":
        S(E, O, W);
        return;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
        return;
    }
    if (!(2 < z.length) || z[0] !== "o" && z[0] !== "O" || z[1] !== "n" && z[1] !== "N") {
      if (O = l.hasOwnProperty(z) ? l[z] : null, O !== null) {
        switch (typeof W) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (!O.acceptsBooleans) return;
        }
        switch (z = O.attributeName, O.type) {
          case 3:
            W && E.push(" ", z, '=""');
            break;
          case 4:
            W === !0 ? E.push(" ", z, '=""') : W !== !1 && E.push(" ", z, '="', g(W), '"');
            break;
          case 5:
            isNaN(W) || E.push(" ", z, '="', g(W), '"');
            break;
          case 6:
            !isNaN(W) && 1 <= W && E.push(" ", z, '="', g(W), '"');
            break;
          default:
            O.sanitizeURL && (W = "" + W), E.push(" ", z, '="', g(W), '"');
        }
      } else if (s(z)) {
        switch (typeof W) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (O = z.toLowerCase().slice(0, 5), O !== "data-" && O !== "aria-") return;
        }
        E.push(" ", z, '="', g(W), '"');
      }
    }
  }
  function M(E, O, z) {
    if (O != null) {
      if (z != null) throw Error(e(60));
      if (typeof O != "object" || !("__html" in O)) throw Error(e(61));
      O = O.__html, O != null && E.push("" + O);
    }
  }
  function j(E) {
    var O = "";
    return r.Children.forEach(E, function(z) {
      z != null && (O += z);
    }), O;
  }
  function G(E, O, z, W) {
    E.push(Y(z));
    var pe = z = null, ce;
    for (ce in O) if (t.call(O, ce)) {
      var Ce = O[ce];
      if (Ce != null) switch (ce) {
        case "children":
          z = Ce;
          break;
        case "dangerouslySetInnerHTML":
          pe = Ce;
          break;
        default:
          R(E, W, ce, Ce);
      }
    }
    return E.push(">"), M(E, pe, z), typeof z == "string" ? (E.push(g(z)), null) : z;
  }
  var ie = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, q = /* @__PURE__ */ new Map();
  function Y(E) {
    var O = q.get(E);
    if (O === void 0) {
      if (!ie.test(E)) throw Error(e(65, E));
      O = "<" + E, q.set(E, O);
    }
    return O;
  }
  function J(E, O, z, W, pe) {
    switch (O) {
      case "select":
        E.push(Y("select"));
        var ce = null, Ce = null;
        for (nt in z) if (t.call(z, nt)) {
          var _e = z[nt];
          if (_e != null) switch (nt) {
            case "children":
              ce = _e;
              break;
            case "dangerouslySetInnerHTML":
              Ce = _e;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              R(E, W, nt, _e);
          }
        }
        return E.push(">"), M(E, Ce, ce), ce;
      case "option":
        Ce = pe.selectedValue, E.push(Y("option"));
        var rt = _e = null, ut = null, nt = null;
        for (ce in z) if (t.call(z, ce)) {
          var Jt = z[ce];
          if (Jt != null) switch (ce) {
            case "children":
              _e = Jt;
              break;
            case "selected":
              ut = Jt;
              break;
            case "dangerouslySetInnerHTML":
              nt = Jt;
              break;
            case "value":
              rt = Jt;
            default:
              R(E, W, ce, Jt);
          }
        }
        if (Ce != null) if (z = rt !== null ? "" + rt : j(_e), A(Ce)) {
          for (W = 0; W < Ce.length; W++)
            if ("" + Ce[W] === z) {
              E.push(' selected=""');
              break;
            }
        } else "" + Ce === z && E.push(' selected=""');
        else ut && E.push(' selected=""');
        return E.push(">"), M(E, nt, _e), _e;
      case "textarea":
        E.push(Y("textarea")), nt = Ce = ce = null;
        for (_e in z) if (t.call(z, _e) && (rt = z[_e], rt != null)) switch (_e) {
          case "children":
            nt = rt;
            break;
          case "value":
            ce = rt;
            break;
          case "defaultValue":
            Ce = rt;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(e(91));
          default:
            R(
              E,
              W,
              _e,
              rt
            );
        }
        if (ce === null && Ce !== null && (ce = Ce), E.push(">"), nt != null) {
          if (ce != null) throw Error(e(92));
          if (A(nt) && 1 < nt.length) throw Error(e(93));
          ce = "" + nt;
        }
        return typeof ce == "string" && ce[0] === `
` && E.push(`
`), ce !== null && E.push(g("" + ce)), null;
      case "input":
        E.push(Y("input")), rt = nt = _e = ce = null;
        for (Ce in z) if (t.call(z, Ce) && (ut = z[Ce], ut != null)) switch (Ce) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(e(399, "input"));
          case "defaultChecked":
            rt = ut;
            break;
          case "defaultValue":
            _e = ut;
            break;
          case "checked":
            nt = ut;
            break;
          case "value":
            ce = ut;
            break;
          default:
            R(E, W, Ce, ut);
        }
        return nt !== null ? R(E, W, "checked", nt) : rt !== null && R(E, W, "checked", rt), ce !== null ? R(E, W, "value", ce) : _e !== null && R(E, W, "value", _e), E.push("/>"), null;
      case "menuitem":
        E.push(Y("menuitem"));
        for (var vr in z) if (t.call(z, vr) && (ce = z[vr], ce != null)) switch (vr) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(e(400));
          default:
            R(E, W, vr, ce);
        }
        return E.push(">"), null;
      case "title":
        E.push(Y("title")), ce = null;
        for (Jt in z) if (t.call(z, Jt) && (Ce = z[Jt], Ce != null)) switch (Jt) {
          case "children":
            ce = Ce;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(e(434));
          default:
            R(E, W, Jt, Ce);
        }
        return E.push(">"), ce;
      case "listing":
      case "pre":
        E.push(Y(O)), Ce = ce = null;
        for (rt in z) if (t.call(z, rt) && (_e = z[rt], _e != null)) switch (rt) {
          case "children":
            ce = _e;
            break;
          case "dangerouslySetInnerHTML":
            Ce = _e;
            break;
          default:
            R(E, W, rt, _e);
        }
        if (E.push(">"), Ce != null) {
          if (ce != null) throw Error(e(60));
          if (typeof Ce != "object" || !("__html" in Ce)) throw Error(e(61));
          z = Ce.__html, z != null && (typeof z == "string" && 0 < z.length && z[0] === `
` ? E.push(`
`, z) : E.push("" + z));
        }
        return typeof ce == "string" && ce[0] === `
` && E.push(`
`), ce;
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "img":
      case "keygen":
      case "link":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
        E.push(Y(O));
        for (var jr in z) if (t.call(z, jr) && (ce = z[jr], ce != null)) switch (jr) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(e(399, O));
          default:
            R(E, W, jr, ce);
        }
        return E.push("/>"), null;
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return G(
          E,
          z,
          O,
          W
        );
      case "html":
        return pe.insertionMode === 0 && E.push("<!DOCTYPE html>"), G(E, z, O, W);
      default:
        if (O.indexOf("-") === -1 && typeof z.is != "string") return G(E, z, O, W);
        E.push(Y(O)), Ce = ce = null;
        for (ut in z) if (t.call(z, ut) && (_e = z[ut], _e != null)) switch (ut) {
          case "children":
            ce = _e;
            break;
          case "dangerouslySetInnerHTML":
            Ce = _e;
            break;
          case "style":
            S(E, W, _e);
            break;
          case "suppressContentEditableWarning":
          case "suppressHydrationWarning":
            break;
          default:
            s(ut) && typeof _e != "function" && typeof _e != "symbol" && E.push(" ", ut, '="', g(_e), '"');
        }
        return E.push(">"), M(E, Ce, ce), ce;
    }
  }
  function se(E, O, z) {
    if (E.push('<!--$?--><template id="'), z === null) throw Error(e(395));
    return E.push(z), E.push('"></template>');
  }
  function oe(E, O, z, W) {
    switch (z.insertionMode) {
      case 0:
      case 1:
        return E.push('<div hidden id="'), E.push(O.segmentPrefix), O = W.toString(16), E.push(O), E.push('">');
      case 2:
        return E.push('<svg aria-hidden="true" style="display:none" id="'), E.push(O.segmentPrefix), O = W.toString(16), E.push(O), E.push('">');
      case 3:
        return E.push('<math aria-hidden="true" style="display:none" id="'), E.push(O.segmentPrefix), O = W.toString(16), E.push(O), E.push('">');
      case 4:
        return E.push('<table hidden id="'), E.push(O.segmentPrefix), O = W.toString(16), E.push(O), E.push('">');
      case 5:
        return E.push('<table hidden><tbody id="'), E.push(O.segmentPrefix), O = W.toString(16), E.push(O), E.push('">');
      case 6:
        return E.push('<table hidden><tr id="'), E.push(O.segmentPrefix), O = W.toString(16), E.push(O), E.push('">');
      case 7:
        return E.push('<table hidden><colgroup id="'), E.push(O.segmentPrefix), O = W.toString(16), E.push(O), E.push('">');
      default:
        throw Error(e(397));
    }
  }
  function he(E, O) {
    switch (O.insertionMode) {
      case 0:
      case 1:
        return E.push("</div>");
      case 2:
        return E.push("</svg>");
      case 3:
        return E.push("</math>");
      case 4:
        return E.push("</table>");
      case 5:
        return E.push("</tbody></table>");
      case 6:
        return E.push("</tr></table>");
      case 7:
        return E.push("</colgroup></table>");
      default:
        throw Error(e(397));
    }
  }
  var ye = /[<\u2028\u2029]/g;
  function Ue(E) {
    return JSON.stringify(E).replace(ye, function(O) {
      switch (O) {
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  function Re(E, O) {
    return O = O === void 0 ? "" : O, { bootstrapChunks: [], startInlineScript: "<script>", placeholderPrefix: O + "P:", segmentPrefix: O + "S:", boundaryPrefix: O + "B:", idPrefix: O, nextSuspenseID: 0, sentCompleteSegmentFunction: !1, sentCompleteBoundaryFunction: !1, sentClientRenderFunction: !1, generateStaticMarkup: E };
  }
  function Oe(E, O, z, W) {
    return z.generateStaticMarkup ? (E.push(g(O)), !1) : (O === "" ? E = W : (W && E.push("<!-- -->"), E.push(g(O)), E = !0), E);
  }
  var ee = Object.assign, re = /* @__PURE__ */ Symbol.for("react.element"), de = /* @__PURE__ */ Symbol.for("react.portal"), Be = /* @__PURE__ */ Symbol.for("react.fragment"), ke = /* @__PURE__ */ Symbol.for("react.strict_mode"), ze = /* @__PURE__ */ Symbol.for("react.profiler"), je = /* @__PURE__ */ Symbol.for("react.provider"), qe = /* @__PURE__ */ Symbol.for("react.context"), Ge = /* @__PURE__ */ Symbol.for("react.forward_ref"), bt = /* @__PURE__ */ Symbol.for("react.suspense"), rr = /* @__PURE__ */ Symbol.for("react.suspense_list"), Pr = /* @__PURE__ */ Symbol.for("react.memo"), Gt = /* @__PURE__ */ Symbol.for("react.lazy"), ar = /* @__PURE__ */ Symbol.for("react.scope"), St = /* @__PURE__ */ Symbol.for("react.debug_trace_mode"), st = /* @__PURE__ */ Symbol.for("react.legacy_hidden"), Qr = /* @__PURE__ */ Symbol.for("react.default_value"), Sr = Symbol.iterator;
  function gr(E) {
    if (E == null) return null;
    if (typeof E == "function") return E.displayName || E.name || null;
    if (typeof E == "string") return E;
    switch (E) {
      case Be:
        return "Fragment";
      case de:
        return "Portal";
      case ze:
        return "Profiler";
      case ke:
        return "StrictMode";
      case bt:
        return "Suspense";
      case rr:
        return "SuspenseList";
    }
    if (typeof E == "object") switch (E.$$typeof) {
      case qe:
        return (E.displayName || "Context") + ".Consumer";
      case je:
        return (E._context.displayName || "Context") + ".Provider";
      case Ge:
        var O = E.render;
        return E = E.displayName, E || (E = O.displayName || O.name || "", E = E !== "" ? "ForwardRef(" + E + ")" : "ForwardRef"), E;
      case Pr:
        return O = E.displayName || null, O !== null ? O : gr(E.type) || "Memo";
      case Gt:
        O = E._payload, E = E._init;
        try {
          return gr(E(O));
        } catch {
        }
    }
    return null;
  }
  var nr = {};
  function fr(E, O) {
    if (E = E.contextTypes, !E) return nr;
    var z = {}, W;
    for (W in E) z[W] = O[W];
    return z;
  }
  var Yt = null;
  function Xt(E, O) {
    if (E !== O) {
      E.context._currentValue2 = E.parentValue, E = E.parent;
      var z = O.parent;
      if (E === null) {
        if (z !== null) throw Error(e(401));
      } else {
        if (z === null) throw Error(e(401));
        Xt(E, z);
      }
      O.context._currentValue2 = O.value;
    }
  }
  function mt(E) {
    E.context._currentValue2 = E.parentValue, E = E.parent, E !== null && mt(E);
  }
  function wr(E) {
    var O = E.parent;
    O !== null && wr(O), E.context._currentValue2 = E.value;
  }
  function an(E, O) {
    if (E.context._currentValue2 = E.parentValue, E = E.parent, E === null) throw Error(e(402));
    E.depth === O.depth ? Xt(E, O) : an(E, O);
  }
  function _r(E, O) {
    var z = O.parent;
    if (z === null) throw Error(e(402));
    E.depth === z.depth ? Xt(E, z) : _r(E, z), O.context._currentValue2 = O.value;
  }
  function ir(E) {
    var O = Yt;
    O !== E && (O === null ? wr(E) : E === null ? mt(O) : O.depth === E.depth ? Xt(O, E) : O.depth > E.depth ? an(O, E) : _r(O, E), Yt = E);
  }
  var Yr = { isMounted: function() {
    return !1;
  }, enqueueSetState: function(E, O) {
    E = E._reactInternals, E.queue !== null && E.queue.push(O);
  }, enqueueReplaceState: function(E, O) {
    E = E._reactInternals, E.replace = !0, E.queue = [O];
  }, enqueueForceUpdate: function() {
  } };
  function kr(E, O, z, W) {
    var pe = E.state !== void 0 ? E.state : null;
    E.updater = Yr, E.props = z, E.state = pe;
    var ce = { queue: [], replace: !1 };
    E._reactInternals = ce;
    var Ce = O.contextType;
    if (E.context = typeof Ce == "object" && Ce !== null ? Ce._currentValue2 : W, Ce = O.getDerivedStateFromProps, typeof Ce == "function" && (Ce = Ce(z, pe), pe = Ce == null ? pe : ee({}, pe, Ce), E.state = pe), typeof O.getDerivedStateFromProps != "function" && typeof E.getSnapshotBeforeUpdate != "function" && (typeof E.UNSAFE_componentWillMount == "function" || typeof E.componentWillMount == "function")) if (O = E.state, typeof E.componentWillMount == "function" && E.componentWillMount(), typeof E.UNSAFE_componentWillMount == "function" && E.UNSAFE_componentWillMount(), O !== E.state && Yr.enqueueReplaceState(E, E.state, null), ce.queue !== null && 0 < ce.queue.length) if (O = ce.queue, Ce = ce.replace, ce.queue = null, ce.replace = !1, Ce && O.length === 1) E.state = O[0];
    else {
      for (ce = Ce ? O[0] : E.state, pe = !0, Ce = Ce ? 1 : 0; Ce < O.length; Ce++) {
        var _e = O[Ce];
        _e = typeof _e == "function" ? _e.call(E, ce, z, W) : _e, _e != null && (pe ? (pe = !1, ce = ee({}, ce, _e)) : ee(ce, _e));
      }
      E.state = ce;
    }
    else ce.queue = null;
  }
  var Zr = { id: 1, overflow: "" };
  function Vr(E, O, z) {
    var W = E.id;
    E = E.overflow;
    var pe = 32 - pn(W) - 1;
    W &= ~(1 << pe), z += 1;
    var ce = 32 - pn(O) + pe;
    if (30 < ce) {
      var Ce = pe - pe % 5;
      return ce = (W & (1 << Ce) - 1).toString(32), W >>= Ce, pe -= Ce, { id: 1 << 32 - pn(O) + pe | z << pe | W, overflow: ce + E };
    }
    return { id: 1 << ce | z << pe | W, overflow: E };
  }
  var pn = Math.clz32 ? Math.clz32 : zr, gn = Math.log, Tr = Math.LN2;
  function zr(E) {
    return E >>>= 0, E === 0 ? 32 : 31 - (gn(E) / Tr | 0) | 0;
  }
  function en(E, O) {
    return E === O && (E !== 0 || 1 / E === 1 / O) || E !== E && O !== O;
  }
  var $r = typeof Object.is == "function" ? Object.is : en, zt = null, sr = null, Er = null, tt = null, Nr = !1, Xr = !1, Se = 0, P = null, U = 0;
  function X() {
    if (zt === null) throw Error(e(321));
    return zt;
  }
  function ue() {
    if (0 < U) throw Error(e(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function Fe() {
    return tt === null ? Er === null ? (Nr = !1, Er = tt = ue()) : (Nr = !0, tt = Er) : tt.next === null ? (Nr = !1, tt = tt.next = ue()) : (Nr = !0, tt = tt.next), tt;
  }
  function We() {
    sr = zt = null, Xr = !1, Er = null, U = 0, tt = P = null;
  }
  function wt(E, O) {
    return typeof O == "function" ? O(E) : O;
  }
  function Pt(E, O, z) {
    if (zt = X(), tt = Fe(), Nr) {
      var W = tt.queue;
      if (O = W.dispatch, P !== null && (z = P.get(W), z !== void 0)) {
        P.delete(W), W = tt.memoizedState;
        do
          W = E(W, z.action), z = z.next;
        while (z !== null);
        return tt.memoizedState = W, [W, O];
      }
      return [tt.memoizedState, O];
    }
    return E = E === wt ? typeof O == "function" ? O() : O : z !== void 0 ? z(O) : O, tt.memoizedState = E, E = tt.queue = { last: null, dispatch: null }, E = E.dispatch = or.bind(null, zt, E), [tt.memoizedState, E];
  }
  function Nt(E, O) {
    if (zt = X(), tt = Fe(), O = O === void 0 ? null : O, tt !== null) {
      var z = tt.memoizedState;
      if (z !== null && O !== null) {
        var W = z[1];
        e: if (W === null) W = !1;
        else {
          for (var pe = 0; pe < W.length && pe < O.length; pe++) if (!$r(O[pe], W[pe])) {
            W = !1;
            break e;
          }
          W = !0;
        }
        if (W) return z[0];
      }
    }
    return E = E(), tt.memoizedState = [E, O], E;
  }
  function or(E, O, z) {
    if (25 <= U) throw Error(e(301));
    if (E === zt) if (Xr = !0, E = { action: z, next: null }, P === null && (P = /* @__PURE__ */ new Map()), z = P.get(O), z === void 0) P.set(O, E);
    else {
      for (O = z; O.next !== null; ) O = O.next;
      O.next = E;
    }
  }
  function Lt() {
    throw Error(e(394));
  }
  function K() {
  }
  var Ie = { readContext: function(E) {
    return E._currentValue2;
  }, useContext: function(E) {
    return X(), E._currentValue2;
  }, useMemo: Nt, useReducer: Pt, useRef: function(E) {
    zt = X(), tt = Fe();
    var O = tt.memoizedState;
    return O === null ? (E = { current: E }, tt.memoizedState = E) : O;
  }, useState: function(E) {
    return Pt(wt, E);
  }, useInsertionEffect: K, useLayoutEffect: function() {
  }, useCallback: function(E, O) {
    return Nt(function() {
      return E;
    }, O);
  }, useImperativeHandle: K, useEffect: K, useDebugValue: K, useDeferredValue: function(E) {
    return X(), E;
  }, useTransition: function() {
    return X(), [
      !1,
      Lt
    ];
  }, useId: function() {
    var E = sr.treeContext, O = E.overflow;
    E = E.id, E = (E & ~(1 << 32 - pn(E) - 1)).toString(32) + O;
    var z = Qe;
    if (z === null) throw Error(e(404));
    return O = Se++, E = ":" + z.idPrefix + "R" + E, 0 < O && (E += "H" + O.toString(32)), E + ":";
  }, useMutableSource: function(E, O) {
    return X(), O(E._source);
  }, useSyncExternalStore: function(E, O, z) {
    if (z === void 0) throw Error(e(407));
    return z();
  } }, Qe = null, Ye = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
  function Ct(E) {
    return console.error(E), null;
  }
  function dt() {
  }
  function Rt(E, O, z, W, pe, ce, Ce, _e, rt) {
    var ut = [], nt = /* @__PURE__ */ new Set();
    return O = { destination: null, responseState: O, progressiveChunkSize: W === void 0 ? 12800 : W, status: 0, fatalError: null, nextSegmentId: 0, allPendingTasks: 0, pendingRootTasks: 0, completedRootSegment: null, abortableTasks: nt, pingedTasks: ut, clientRenderedBoundaries: [], completedBoundaries: [], partialBoundaries: [], onError: pe === void 0 ? Ct : pe, onAllReady: dt, onShellReady: Ce === void 0 ? dt : Ce, onShellError: dt, onFatalError: dt }, z = hr(O, 0, null, z, !1, !1), z.parentFlushed = !0, E = Et(O, E, null, z, nt, nr, null, Zr), ut.push(E), O;
  }
  function Et(E, O, z, W, pe, ce, Ce, _e) {
    E.allPendingTasks++, z === null ? E.pendingRootTasks++ : z.pendingTasks++;
    var rt = { node: O, ping: function() {
      var ut = E.pingedTasks;
      ut.push(rt), ut.length === 1 && cn(E);
    }, blockedBoundary: z, blockedSegment: W, abortSet: pe, legacyContext: ce, context: Ce, treeContext: _e };
    return pe.add(rt), rt;
  }
  function hr(E, O, z, W, pe, ce) {
    return { status: 0, id: -1, index: O, parentFlushed: !1, chunks: [], children: [], formatContext: W, boundary: z, lastPushedText: pe, textEmbedded: ce };
  }
  function er(E, O) {
    if (E = E.onError(O), E != null && typeof E != "string") throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof E + '" instead');
    return E;
  }
  function dr(E, O) {
    var z = E.onShellError;
    z(O), z = E.onFatalError, z(O), E.destination !== null ? (E.status = 2, E.destination.destroy(O)) : (E.status = 1, E.fatalError = O);
  }
  function $t(E, O, z, W, pe) {
    for (zt = {}, sr = O, Se = 0, E = z(W, pe); Xr; ) Xr = !1, Se = 0, U += 1, tt = null, E = z(W, pe);
    return We(), E;
  }
  function On(E, O, z, W) {
    var pe = z.render(), ce = W.childContextTypes;
    if (ce != null) {
      var Ce = O.legacyContext;
      if (typeof z.getChildContext != "function") W = Ce;
      else {
        z = z.getChildContext();
        for (var _e in z) if (!(_e in ce)) throw Error(e(108, gr(W) || "Unknown", _e));
        W = ee({}, Ce, z);
      }
      O.legacyContext = W, xr(E, O, pe), O.legacyContext = Ce;
    } else xr(E, O, pe);
  }
  function Fn(E, O) {
    if (E && E.defaultProps) {
      O = ee({}, O), E = E.defaultProps;
      for (var z in E) O[z] === void 0 && (O[z] = E[z]);
      return O;
    }
    return O;
  }
  function mr(E, O, z, W, pe) {
    if (typeof z == "function") if (z.prototype && z.prototype.isReactComponent) {
      pe = fr(z, O.legacyContext);
      var ce = z.contextType;
      ce = new z(W, typeof ce == "object" && ce !== null ? ce._currentValue2 : pe), kr(ce, z, W, pe), On(E, O, ce, z);
    } else {
      ce = fr(z, O.legacyContext), pe = $t(E, O, z, W, ce);
      var Ce = Se !== 0;
      if (typeof pe == "object" && pe !== null && typeof pe.render == "function" && pe.$$typeof === void 0) kr(pe, z, W, ce), On(E, O, pe, z);
      else if (Ce) {
        W = O.treeContext, O.treeContext = Vr(W, 1, 0);
        try {
          xr(E, O, pe);
        } finally {
          O.treeContext = W;
        }
      } else xr(E, O, pe);
    }
    else if (typeof z == "string") {
      switch (pe = O.blockedSegment, ce = J(pe.chunks, z, W, E.responseState, pe.formatContext), pe.lastPushedText = !1, Ce = pe.formatContext, pe.formatContext = k(Ce, z, W), Rr(E, O, ce), pe.formatContext = Ce, z) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          pe.chunks.push("</", z, ">");
      }
      pe.lastPushedText = !1;
    } else {
      switch (z) {
        case st:
        case St:
        case ke:
        case ze:
        case Be:
          xr(E, O, W.children);
          return;
        case rr:
          xr(E, O, W.children);
          return;
        case ar:
          throw Error(e(343));
        case bt:
          e: {
            z = O.blockedBoundary, pe = O.blockedSegment, ce = W.fallback, W = W.children, Ce = /* @__PURE__ */ new Set();
            var _e = { id: null, rootSegmentID: -1, parentFlushed: !1, pendingTasks: 0, forceClientRender: !1, completedSegments: [], byteSize: 0, fallbackAbortableTasks: Ce, errorDigest: null }, rt = hr(E, pe.chunks.length, _e, pe.formatContext, !1, !1);
            pe.children.push(rt), pe.lastPushedText = !1;
            var ut = hr(E, 0, null, pe.formatContext, !1, !1);
            ut.parentFlushed = !0, O.blockedBoundary = _e, O.blockedSegment = ut;
            try {
              if (Rr(
                E,
                O,
                W
              ), E.responseState.generateStaticMarkup || ut.lastPushedText && ut.textEmbedded && ut.chunks.push("<!-- -->"), ut.status = 1, Hr(_e, ut), _e.pendingTasks === 0) break e;
            } catch (nt) {
              ut.status = 4, _e.forceClientRender = !0, _e.errorDigest = er(E, nt);
            } finally {
              O.blockedBoundary = z, O.blockedSegment = pe;
            }
            O = Et(E, ce, z, rt, Ce, O.legacyContext, O.context, O.treeContext), E.pingedTasks.push(O);
          }
          return;
      }
      if (typeof z == "object" && z !== null) switch (z.$$typeof) {
        case Ge:
          if (W = $t(E, O, z.render, W, pe), Se !== 0) {
            z = O.treeContext, O.treeContext = Vr(z, 1, 0);
            try {
              xr(E, O, W);
            } finally {
              O.treeContext = z;
            }
          } else xr(E, O, W);
          return;
        case Pr:
          z = z.type, W = Fn(z, W), mr(E, O, z, W, pe);
          return;
        case je:
          if (pe = W.children, z = z._context, W = W.value, ce = z._currentValue2, z._currentValue2 = W, Ce = Yt, Yt = W = { parent: Ce, depth: Ce === null ? 0 : Ce.depth + 1, context: z, parentValue: ce, value: W }, O.context = W, xr(E, O, pe), E = Yt, E === null) throw Error(e(403));
          W = E.parentValue, E.context._currentValue2 = W === Qr ? E.context._defaultValue : W, E = Yt = E.parent, O.context = E;
          return;
        case qe:
          W = W.children, W = W(z._currentValue2), xr(E, O, W);
          return;
        case Gt:
          pe = z._init, z = pe(z._payload), W = Fn(z, W), mr(
            E,
            O,
            z,
            W,
            void 0
          );
          return;
      }
      throw Error(e(130, z == null ? z : typeof z, ""));
    }
  }
  function xr(E, O, z) {
    if (O.node = z, typeof z == "object" && z !== null) {
      switch (z.$$typeof) {
        case re:
          mr(E, O, z.type, z.props, z.ref);
          return;
        case de:
          throw Error(e(257));
        case Gt:
          var W = z._init;
          z = W(z._payload), xr(E, O, z);
          return;
      }
      if (A(z)) {
        wn(E, O, z);
        return;
      }
      if (z === null || typeof z != "object" ? W = null : (W = Sr && z[Sr] || z["@@iterator"], W = typeof W == "function" ? W : null), W && (W = W.call(z))) {
        if (z = W.next(), !z.done) {
          var pe = [];
          do
            pe.push(z.value), z = W.next();
          while (!z.done);
          wn(E, O, pe);
        }
        return;
      }
      throw E = Object.prototype.toString.call(z), Error(e(31, E === "[object Object]" ? "object with keys {" + Object.keys(z).join(", ") + "}" : E));
    }
    typeof z == "string" ? (W = O.blockedSegment, W.lastPushedText = Oe(O.blockedSegment.chunks, z, E.responseState, W.lastPushedText)) : typeof z == "number" && (W = O.blockedSegment, W.lastPushedText = Oe(O.blockedSegment.chunks, "" + z, E.responseState, W.lastPushedText));
  }
  function wn(E, O, z) {
    for (var W = z.length, pe = 0; pe < W; pe++) {
      var ce = O.treeContext;
      O.treeContext = Vr(ce, W, pe);
      try {
        Rr(E, O, z[pe]);
      } finally {
        O.treeContext = ce;
      }
    }
  }
  function Rr(E, O, z) {
    var W = O.blockedSegment.formatContext, pe = O.legacyContext, ce = O.context;
    try {
      return xr(E, O, z);
    } catch (rt) {
      if (We(), typeof rt == "object" && rt !== null && typeof rt.then == "function") {
        z = rt;
        var Ce = O.blockedSegment, _e = hr(E, Ce.chunks.length, null, Ce.formatContext, Ce.lastPushedText, !0);
        Ce.children.push(_e), Ce.lastPushedText = !1, E = Et(E, O.node, O.blockedBoundary, _e, O.abortSet, O.legacyContext, O.context, O.treeContext).ping, z.then(E, E), O.blockedSegment.formatContext = W, O.legacyContext = pe, O.context = ce, ir(ce);
      } else throw O.blockedSegment.formatContext = W, O.legacyContext = pe, O.context = ce, ir(ce), rt;
    }
  }
  function jn(E) {
    var O = E.blockedBoundary;
    E = E.blockedSegment, E.status = 3, Cn(this, O, E);
  }
  function xn(E, O, z) {
    var W = E.blockedBoundary;
    E.blockedSegment.status = 3, W === null ? (O.allPendingTasks--, O.status !== 2 && (O.status = 2, O.destination !== null && O.destination.push(null))) : (W.pendingTasks--, W.forceClientRender || (W.forceClientRender = !0, E = z === void 0 ? Error(e(432)) : z, W.errorDigest = O.onError(E), W.parentFlushed && O.clientRenderedBoundaries.push(W)), W.fallbackAbortableTasks.forEach(function(pe) {
      return xn(pe, O, z);
    }), W.fallbackAbortableTasks.clear(), O.allPendingTasks--, O.allPendingTasks === 0 && (W = O.onAllReady, W()));
  }
  function Hr(E, O) {
    if (O.chunks.length === 0 && O.children.length === 1 && O.children[0].boundary === null) {
      var z = O.children[0];
      z.id = O.id, z.parentFlushed = !0, z.status === 1 && Hr(E, z);
    } else E.completedSegments.push(O);
  }
  function Cn(E, O, z) {
    if (O === null) {
      if (z.parentFlushed) {
        if (E.completedRootSegment !== null) throw Error(e(389));
        E.completedRootSegment = z;
      }
      E.pendingRootTasks--, E.pendingRootTasks === 0 && (E.onShellError = dt, O = E.onShellReady, O());
    } else O.pendingTasks--, O.forceClientRender || (O.pendingTasks === 0 ? (z.parentFlushed && z.status === 1 && Hr(O, z), O.parentFlushed && E.completedBoundaries.push(O), O.fallbackAbortableTasks.forEach(jn, E), O.fallbackAbortableTasks.clear()) : z.parentFlushed && z.status === 1 && (Hr(O, z), O.completedSegments.length === 1 && O.parentFlushed && E.partialBoundaries.push(O)));
    E.allPendingTasks--, E.allPendingTasks === 0 && (E = E.onAllReady, E());
  }
  function cn(E) {
    if (E.status !== 2) {
      var O = Yt, z = Ye.current;
      Ye.current = Ie;
      var W = Qe;
      Qe = E.responseState;
      try {
        var pe = E.pingedTasks, ce;
        for (ce = 0; ce < pe.length; ce++) {
          var Ce = pe[ce], _e = E, rt = Ce.blockedSegment;
          if (rt.status === 0) {
            ir(Ce.context);
            try {
              xr(_e, Ce, Ce.node), _e.responseState.generateStaticMarkup || rt.lastPushedText && rt.textEmbedded && rt.chunks.push("<!-- -->"), Ce.abortSet.delete(Ce), rt.status = 1, Cn(_e, Ce.blockedBoundary, rt);
            } catch (fn) {
              if (We(), typeof fn == "object" && fn !== null && typeof fn.then == "function") {
                var ut = Ce.ping;
                fn.then(ut, ut);
              } else {
                Ce.abortSet.delete(Ce), rt.status = 4;
                var nt = Ce.blockedBoundary, Jt = fn, vr = er(_e, Jt);
                if (nt === null ? dr(_e, Jt) : (nt.pendingTasks--, nt.forceClientRender || (nt.forceClientRender = !0, nt.errorDigest = vr, nt.parentFlushed && _e.clientRenderedBoundaries.push(nt))), _e.allPendingTasks--, _e.allPendingTasks === 0) {
                  var jr = _e.onAllReady;
                  jr();
                }
              }
            }
          }
        }
        pe.splice(0, ce), E.destination !== null && sn(E, E.destination);
      } catch (fn) {
        er(E, fn), dr(E, fn);
      } finally {
        Qe = W, Ye.current = z, z === Ie && ir(O);
      }
    }
  }
  function tn(E, O, z) {
    switch (z.parentFlushed = !0, z.status) {
      case 0:
        var W = z.id = E.nextSegmentId++;
        return z.lastPushedText = !1, z.textEmbedded = !1, E = E.responseState, O.push('<template id="'), O.push(E.placeholderPrefix), E = W.toString(16), O.push(E), O.push('"></template>');
      case 1:
        z.status = 2;
        var pe = !0;
        W = z.chunks;
        var ce = 0;
        z = z.children;
        for (var Ce = 0; Ce < z.length; Ce++) {
          for (pe = z[Ce]; ce < pe.index; ce++) O.push(W[ce]);
          pe = Jn(E, O, pe);
        }
        for (; ce < W.length - 1; ce++) O.push(W[ce]);
        return ce < W.length && (pe = O.push(W[ce])), pe;
      default:
        throw Error(e(390));
    }
  }
  function Jn(E, O, z) {
    var W = z.boundary;
    if (W === null) return tn(E, O, z);
    if (W.parentFlushed = !0, W.forceClientRender) return E.responseState.generateStaticMarkup || (W = W.errorDigest, O.push("<!--$!-->"), O.push("<template"), W && (O.push(' data-dgst="'), W = g(W), O.push(W), O.push('"')), O.push("></template>")), tn(E, O, z), E = E.responseState.generateStaticMarkup ? !0 : O.push("<!--/$-->"), E;
    if (0 < W.pendingTasks) {
      W.rootSegmentID = E.nextSegmentId++, 0 < W.completedSegments.length && E.partialBoundaries.push(W);
      var pe = E.responseState, ce = pe.nextSuspenseID++;
      return pe = pe.boundaryPrefix + ce.toString(16), W = W.id = pe, se(O, E.responseState, W), tn(E, O, z), O.push("<!--/$-->");
    }
    if (W.byteSize > E.progressiveChunkSize) return W.rootSegmentID = E.nextSegmentId++, E.completedBoundaries.push(W), se(O, E.responseState, W.id), tn(E, O, z), O.push("<!--/$-->");
    if (E.responseState.generateStaticMarkup || O.push("<!--$-->"), z = W.completedSegments, z.length !== 1) throw Error(e(391));
    return Jn(E, O, z[0]), E = E.responseState.generateStaticMarkup ? !0 : O.push("<!--/$-->"), E;
  }
  function ii(E, O, z) {
    return oe(O, E.responseState, z.formatContext, z.id), Jn(E, O, z), he(O, z.formatContext);
  }
  function Sn(E, O, z) {
    for (var W = z.completedSegments, pe = 0; pe < W.length; pe++) mn(E, O, z, W[pe]);
    if (W.length = 0, E = E.responseState, W = z.id, z = z.rootSegmentID, O.push(E.startInlineScript), E.sentCompleteBoundaryFunction ? O.push('$RC("') : (E.sentCompleteBoundaryFunction = !0, O.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("')), W === null) throw Error(e(395));
    return z = z.toString(16), O.push(W), O.push('","'), O.push(E.segmentPrefix), O.push(z), O.push('")<\/script>');
  }
  function mn(E, O, z, W) {
    if (W.status === 2) return !0;
    var pe = W.id;
    if (pe === -1) {
      if ((W.id = z.rootSegmentID) === -1) throw Error(e(392));
      return ii(E, O, W);
    }
    return ii(E, O, W), E = E.responseState, O.push(E.startInlineScript), E.sentCompleteSegmentFunction ? O.push('$RS("') : (E.sentCompleteSegmentFunction = !0, O.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("')), O.push(E.segmentPrefix), pe = pe.toString(16), O.push(pe), O.push('","'), O.push(E.placeholderPrefix), O.push(pe), O.push('")<\/script>');
  }
  function sn(E, O) {
    try {
      var z = E.completedRootSegment;
      if (z !== null && E.pendingRootTasks === 0) {
        Jn(E, O, z), E.completedRootSegment = null;
        var W = E.responseState.bootstrapChunks;
        for (z = 0; z < W.length - 1; z++) O.push(W[z]);
        z < W.length && O.push(W[z]);
      }
      var pe = E.clientRenderedBoundaries, ce;
      for (ce = 0; ce < pe.length; ce++) {
        var Ce = pe[ce];
        W = O;
        var _e = E.responseState, rt = Ce.id, ut = Ce.errorDigest, nt = Ce.errorMessage, Jt = Ce.errorComponentStack;
        if (W.push(_e.startInlineScript), _e.sentClientRenderFunction ? W.push('$RX("') : (_e.sentClientRenderFunction = !0, W.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("')), rt === null) throw Error(e(395));
        if (W.push(rt), W.push('"'), ut || nt || Jt) {
          W.push(",");
          var vr = Ue(ut || "");
          W.push(vr);
        }
        if (nt || Jt) {
          W.push(",");
          var jr = Ue(nt || "");
          W.push(jr);
        }
        if (Jt) {
          W.push(",");
          var fn = Ue(Jt);
          W.push(fn);
        }
        if (!W.push(")<\/script>")) {
          E.destination = null, ce++, pe.splice(0, ce);
          return;
        }
      }
      pe.splice(0, ce);
      var Kn = E.completedBoundaries;
      for (ce = 0; ce < Kn.length; ce++) if (!Sn(E, O, Kn[ce])) {
        E.destination = null, ce++, Kn.splice(0, ce);
        return;
      }
      Kn.splice(0, ce);
      var Ln = E.partialBoundaries;
      for (ce = 0; ce < Ln.length; ce++) {
        var vn = Ln[ce];
        e: {
          pe = E, Ce = O;
          var Or = vn.completedSegments;
          for (_e = 0; _e < Or.length; _e++) if (!mn(pe, Ce, vn, Or[_e])) {
            _e++, Or.splice(0, _e);
            var Gn = !1;
            break e;
          }
          Or.splice(0, _e), Gn = !0;
        }
        if (!Gn) {
          E.destination = null, ce++, Ln.splice(0, ce);
          return;
        }
      }
      Ln.splice(0, ce);
      var Bn = E.completedBoundaries;
      for (ce = 0; ce < Bn.length; ce++) if (!Sn(E, O, Bn[ce])) {
        E.destination = null, ce++, Bn.splice(0, ce);
        return;
      }
      Bn.splice(0, ce);
    } finally {
      E.allPendingTasks === 0 && E.pingedTasks.length === 0 && E.clientRenderedBoundaries.length === 0 && E.completedBoundaries.length === 0 && O.push(null);
    }
  }
  function rn(E, O) {
    try {
      var z = E.abortableTasks;
      z.forEach(function(W) {
        return xn(W, E, O);
      }), z.clear(), E.destination !== null && sn(E, E.destination);
    } catch (W) {
      er(E, W), dr(E, W);
    }
  }
  function Lr() {
  }
  function on(E, O, z, W) {
    var pe = !1, ce = null, Ce = "", _e = { push: function(ut) {
      return ut !== null && (Ce += ut), !0;
    }, destroy: function(ut) {
      pe = !0, ce = ut;
    } }, rt = !1;
    if (E = Rt(E, Re(z, O ? O.identifierPrefix : void 0), { insertionMode: 1, selectedValue: null }, 1 / 0, Lr, void 0, function() {
      rt = !0;
    }), cn(E), rn(E, W), E.status === 1) E.status = 2, _e.destroy(E.fatalError);
    else if (E.status !== 2 && E.destination === null) {
      E.destination = _e;
      try {
        sn(E, _e);
      } catch (ut) {
        er(E, ut), dr(E, ut);
      }
    }
    if (pe) throw ce;
    if (!rt) throw Error(e(426));
    return Ce;
  }
  return rl.renderToNodeStream = function() {
    throw Error(e(207));
  }, rl.renderToStaticMarkup = function(E, O) {
    return on(E, O, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  }, rl.renderToStaticNodeStream = function() {
    throw Error(e(208));
  }, rl.renderToString = function(E, O) {
    return on(E, O, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  }, rl.version = "18.3.1", rl;
}
var Fh = {};
var Nw;
function C4() {
  if (Nw) return Fh;
  Nw = 1;
  var r = Sl();
  function e(T) {
    for (var _ = "https://reactjs.org/docs/error-decoder.html?invariant=" + T, V = 1; V < arguments.length; V++) _ += "&args[]=" + encodeURIComponent(arguments[V]);
    return "Minified React error #" + T + "; visit " + _ + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var t = null, n = 0;
  function i(T, _) {
    if (_.length !== 0) if (512 < _.length) 0 < n && (T.enqueue(new Uint8Array(t.buffer, 0, n)), t = new Uint8Array(512), n = 0), T.enqueue(_);
    else {
      var V = t.length - n;
      V < _.length && (V === 0 ? T.enqueue(t) : (t.set(_.subarray(0, V), n), T.enqueue(t), _ = _.subarray(V)), t = new Uint8Array(512), n = 0), t.set(_, n), n += _.length;
    }
  }
  function a(T, _) {
    return i(T, _), !0;
  }
  function s(T) {
    t && 0 < n && (T.enqueue(new Uint8Array(t.buffer, 0, n)), t = null, n = 0);
  }
  var o = new TextEncoder();
  function l(T) {
    return o.encode(T);
  }
  function u(T) {
    return o.encode(T);
  }
  function c(T, _) {
    typeof T.error == "function" ? T.error(_) : T.close();
  }
  var d = Object.prototype.hasOwnProperty, f = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, h = {}, g = {};
  function v(T) {
    return d.call(g, T) ? !0 : d.call(h, T) ? !1 : f.test(T) ? g[T] = !0 : (h[T] = !0, !1);
  }
  function y(T, _, V, Q, Ae, ve, Te) {
    this.acceptsBooleans = _ === 2 || _ === 3 || _ === 4, this.attributeName = Q, this.attributeNamespace = Ae, this.mustUseProperty = V, this.propertyName = T, this.type = _, this.sanitizeURL = ve, this.removeEmptyString = Te;
  }
  var A = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(T) {
    A[T] = new y(T, 0, !1, T, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(T) {
    var _ = T[0];
    A[_] = new y(_, 1, !1, T[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(T) {
    A[T] = new y(T, 2, !1, T.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(T) {
    A[T] = new y(T, 2, !1, T, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(T) {
    A[T] = new y(T, 3, !1, T.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(T) {
    A[T] = new y(T, 3, !0, T, null, !1, !1);
  }), ["capture", "download"].forEach(function(T) {
    A[T] = new y(T, 4, !1, T, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(T) {
    A[T] = new y(T, 6, !1, T, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(T) {
    A[T] = new y(T, 5, !1, T.toLowerCase(), null, !1, !1);
  });
  var x = /[\-:]([a-z])/g;
  function k(T) {
    return T[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(T) {
    var _ = T.replace(
      x,
      k
    );
    A[_] = new y(_, 1, !1, T, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(T) {
    var _ = T.replace(x, k);
    A[_] = new y(_, 1, !1, T, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(T) {
    var _ = T.replace(x, k);
    A[_] = new y(_, 1, !1, T, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(T) {
    A[T] = new y(T, 1, !1, T.toLowerCase(), null, !1, !1);
  }), A.xlinkHref = new y("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(T) {
    A[T] = new y(T, 1, !1, T.toLowerCase(), null, !0, !0);
  });
  var F = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, S = ["Webkit", "ms", "Moz", "O"];
  Object.keys(F).forEach(function(T) {
    S.forEach(function(_) {
      _ = _ + T.charAt(0).toUpperCase() + T.substring(1), F[_] = F[T];
    });
  });
  var R = /["'&<>]/;
  function M(T) {
    if (typeof T == "boolean" || typeof T == "number") return "" + T;
    T = "" + T;
    var _ = R.exec(T);
    if (_) {
      var V = "", Q, Ae = 0;
      for (Q = _.index; Q < T.length; Q++) {
        switch (T.charCodeAt(Q)) {
          case 34:
            _ = "&quot;";
            break;
          case 38:
            _ = "&amp;";
            break;
          case 39:
            _ = "&#x27;";
            break;
          case 60:
            _ = "&lt;";
            break;
          case 62:
            _ = "&gt;";
            break;
          default:
            continue;
        }
        Ae !== Q && (V += T.substring(Ae, Q)), Ae = Q + 1, V += _;
      }
      T = Ae !== Q ? V + T.substring(Ae, Q) : V;
    }
    return T;
  }
  var j = /([A-Z])/g, G = /^ms-/, ie = Array.isArray, q = u("<script>"), Y = u("<\/script>"), J = u('<script src="'), se = u('<script type="module" src="'), oe = u('" async=""><\/script>'), he = /(<\/|<)(s)(cript)/gi;
  function ye(T, _, V, Q) {
    return "" + _ + (V === "s" ? "\\u0073" : "\\u0053") + Q;
  }
  function Ue(T, _, V, Q, Ae) {
    T = T === void 0 ? "" : T, _ = _ === void 0 ? q : u('<script nonce="' + M(_) + '">');
    var ve = [];
    if (V !== void 0 && ve.push(_, l(("" + V).replace(he, ye)), Y), Q !== void 0) for (V = 0; V < Q.length; V++) ve.push(J, l(M(Q[V])), oe);
    if (Ae !== void 0) for (Q = 0; Q < Ae.length; Q++) ve.push(se, l(M(Ae[Q])), oe);
    return { bootstrapChunks: ve, startInlineScript: _, placeholderPrefix: u(T + "P:"), segmentPrefix: u(T + "S:"), boundaryPrefix: T + "B:", idPrefix: T, nextSuspenseID: 0, sentCompleteSegmentFunction: !1, sentCompleteBoundaryFunction: !1, sentClientRenderFunction: !1 };
  }
  function Re(T, _) {
    return { insertionMode: T, selectedValue: _ };
  }
  function Oe(T) {
    return Re(T === "http://www.w3.org/2000/svg" ? 2 : T === "http://www.w3.org/1998/Math/MathML" ? 3 : 0, null);
  }
  function ee(T, _, V) {
    switch (_) {
      case "select":
        return Re(1, V.value != null ? V.value : V.defaultValue);
      case "svg":
        return Re(2, null);
      case "math":
        return Re(3, null);
      case "foreignObject":
        return Re(1, null);
      case "table":
        return Re(4, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return Re(5, null);
      case "colgroup":
        return Re(7, null);
      case "tr":
        return Re(6, null);
    }
    return 4 <= T.insertionMode || T.insertionMode === 0 ? Re(1, null) : T;
  }
  var re = u("<!-- -->");
  function de(T, _, V, Q) {
    return _ === "" ? Q : (Q && T.push(re), T.push(l(M(_))), !0);
  }
  var Be = /* @__PURE__ */ new Map(), ke = u(' style="'), ze = u(":"), je = u(";");
  function qe(T, _, V) {
    if (typeof V != "object") throw Error(e(62));
    _ = !0;
    for (var Q in V) if (d.call(V, Q)) {
      var Ae = V[Q];
      if (Ae != null && typeof Ae != "boolean" && Ae !== "") {
        if (Q.indexOf("--") === 0) {
          var ve = l(M(Q));
          Ae = l(M(("" + Ae).trim()));
        } else {
          ve = Q;
          var Te = Be.get(ve);
          Te !== void 0 || (Te = u(M(ve.replace(j, "-$1").toLowerCase().replace(G, "-ms-"))), Be.set(ve, Te)), ve = Te, Ae = typeof Ae == "number" ? Ae === 0 || d.call(F, Q) ? l("" + Ae) : l(Ae + "px") : l(M(("" + Ae).trim()));
        }
        _ ? (_ = !1, T.push(ke, ve, ze, Ae)) : T.push(je, ve, ze, Ae);
      }
    }
    _ || T.push(rr);
  }
  var Ge = u(" "), bt = u('="'), rr = u('"'), Pr = u('=""');
  function Gt(T, _, V, Q) {
    switch (V) {
      case "style":
        qe(T, _, Q);
        return;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
        return;
    }
    if (!(2 < V.length) || V[0] !== "o" && V[0] !== "O" || V[1] !== "n" && V[1] !== "N") {
      if (_ = A.hasOwnProperty(V) ? A[V] : null, _ !== null) {
        switch (typeof Q) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (!_.acceptsBooleans) return;
        }
        switch (V = l(_.attributeName), _.type) {
          case 3:
            Q && T.push(Ge, V, Pr);
            break;
          case 4:
            Q === !0 ? T.push(Ge, V, Pr) : Q !== !1 && T.push(Ge, V, bt, l(M(Q)), rr);
            break;
          case 5:
            isNaN(Q) || T.push(Ge, V, bt, l(M(Q)), rr);
            break;
          case 6:
            !isNaN(Q) && 1 <= Q && T.push(Ge, V, bt, l(M(Q)), rr);
            break;
          default:
            _.sanitizeURL && (Q = "" + Q), T.push(Ge, V, bt, l(M(Q)), rr);
        }
      } else if (v(V)) {
        switch (typeof Q) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (_ = V.toLowerCase().slice(0, 5), _ !== "data-" && _ !== "aria-") return;
        }
        T.push(Ge, l(V), bt, l(M(Q)), rr);
      }
    }
  }
  var ar = u(">"), St = u("/>");
  function st(T, _, V) {
    if (_ != null) {
      if (V != null) throw Error(e(60));
      if (typeof _ != "object" || !("__html" in _)) throw Error(e(61));
      _ = _.__html, _ != null && T.push(l("" + _));
    }
  }
  function Qr(T) {
    var _ = "";
    return r.Children.forEach(T, function(V) {
      V != null && (_ += V);
    }), _;
  }
  var Sr = u(' selected=""');
  function gr(T, _, V, Q) {
    T.push(Xt(V));
    var Ae = V = null, ve;
    for (ve in _) if (d.call(_, ve)) {
      var Te = _[ve];
      if (Te != null) switch (ve) {
        case "children":
          V = Te;
          break;
        case "dangerouslySetInnerHTML":
          Ae = Te;
          break;
        default:
          Gt(T, Q, ve, Te);
      }
    }
    return T.push(ar), st(T, Ae, V), typeof V == "string" ? (T.push(l(M(V))), null) : V;
  }
  var nr = u(`
`), fr = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Yt = /* @__PURE__ */ new Map();
  function Xt(T) {
    var _ = Yt.get(T);
    if (_ === void 0) {
      if (!fr.test(T)) throw Error(e(65, T));
      _ = u("<" + T), Yt.set(T, _);
    }
    return _;
  }
  var mt = u("<!DOCTYPE html>");
  function wr(T, _, V, Q, Ae) {
    switch (_) {
      case "select":
        T.push(Xt("select"));
        var ve = null, Te = null;
        for (qt in V) if (d.call(V, qt)) {
          var $e = V[qt];
          if ($e != null) switch (qt) {
            case "children":
              ve = $e;
              break;
            case "dangerouslySetInnerHTML":
              Te = $e;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              Gt(T, Q, qt, $e);
          }
        }
        return T.push(ar), st(T, Te, ve), ve;
      case "option":
        Te = Ae.selectedValue, T.push(Xt("option"));
        var Bt = $e = null, Kt = null, qt = null;
        for (ve in V) if (d.call(V, ve)) {
          var qr = V[ve];
          if (qr != null) switch (ve) {
            case "children":
              $e = qr;
              break;
            case "selected":
              Kt = qr;
              break;
            case "dangerouslySetInnerHTML":
              qt = qr;
              break;
            case "value":
              Bt = qr;
            default:
              Gt(T, Q, ve, qr);
          }
        }
        if (Te != null) if (V = Bt !== null ? "" + Bt : Qr($e), ie(Te)) {
          for (Q = 0; Q < Te.length; Q++)
            if ("" + Te[Q] === V) {
              T.push(Sr);
              break;
            }
        } else "" + Te === V && T.push(Sr);
        else Kt && T.push(Sr);
        return T.push(ar), st(T, qt, $e), $e;
      case "textarea":
        T.push(Xt("textarea")), qt = Te = ve = null;
        for ($e in V) if (d.call(V, $e) && (Bt = V[$e], Bt != null)) switch ($e) {
          case "children":
            qt = Bt;
            break;
          case "value":
            ve = Bt;
            break;
          case "defaultValue":
            Te = Bt;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(e(91));
          default:
            Gt(T, Q, $e, Bt);
        }
        if (ve === null && Te !== null && (ve = Te), T.push(ar), qt != null) {
          if (ve != null) throw Error(e(92));
          if (ie(qt) && 1 < qt.length) throw Error(e(93));
          ve = "" + qt;
        }
        return typeof ve == "string" && ve[0] === `
` && T.push(nr), ve !== null && T.push(l(M("" + ve))), null;
      case "input":
        T.push(Xt("input")), Bt = qt = $e = ve = null;
        for (Te in V) if (d.call(V, Te) && (Kt = V[Te], Kt != null)) switch (Te) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(e(399, "input"));
          case "defaultChecked":
            Bt = Kt;
            break;
          case "defaultValue":
            $e = Kt;
            break;
          case "checked":
            qt = Kt;
            break;
          case "value":
            ve = Kt;
            break;
          default:
            Gt(T, Q, Te, Kt);
        }
        return qt !== null ? Gt(
          T,
          Q,
          "checked",
          qt
        ) : Bt !== null && Gt(T, Q, "checked", Bt), ve !== null ? Gt(T, Q, "value", ve) : $e !== null && Gt(T, Q, "value", $e), T.push(St), null;
      case "menuitem":
        T.push(Xt("menuitem"));
        for (var L in V) if (d.call(V, L) && (ve = V[L], ve != null)) switch (L) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(e(400));
          default:
            Gt(T, Q, L, ve);
        }
        return T.push(ar), null;
      case "title":
        T.push(Xt("title")), ve = null;
        for (qr in V) if (d.call(V, qr) && (Te = V[qr], Te != null)) switch (qr) {
          case "children":
            ve = Te;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(e(434));
          default:
            Gt(T, Q, qr, Te);
        }
        return T.push(ar), ve;
      case "listing":
      case "pre":
        T.push(Xt(_)), Te = ve = null;
        for (Bt in V) if (d.call(V, Bt) && ($e = V[Bt], $e != null)) switch (Bt) {
          case "children":
            ve = $e;
            break;
          case "dangerouslySetInnerHTML":
            Te = $e;
            break;
          default:
            Gt(T, Q, Bt, $e);
        }
        if (T.push(ar), Te != null) {
          if (ve != null) throw Error(e(60));
          if (typeof Te != "object" || !("__html" in Te)) throw Error(e(61));
          V = Te.__html, V != null && (typeof V == "string" && 0 < V.length && V[0] === `
` ? T.push(nr, l(V)) : T.push(l("" + V)));
        }
        return typeof ve == "string" && ve[0] === `
` && T.push(nr), ve;
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "img":
      case "keygen":
      case "link":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
        T.push(Xt(_));
        for (var te in V) if (d.call(V, te) && (ve = V[te], ve != null)) switch (te) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(e(399, _));
          default:
            Gt(T, Q, te, ve);
        }
        return T.push(St), null;
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return gr(T, V, _, Q);
      case "html":
        return Ae.insertionMode === 0 && T.push(mt), gr(T, V, _, Q);
      default:
        if (_.indexOf("-") === -1 && typeof V.is != "string") return gr(T, V, _, Q);
        T.push(Xt(_)), Te = ve = null;
        for (Kt in V) if (d.call(V, Kt) && ($e = V[Kt], $e != null)) switch (Kt) {
          case "children":
            ve = $e;
            break;
          case "dangerouslySetInnerHTML":
            Te = $e;
            break;
          case "style":
            qe(T, Q, $e);
            break;
          case "suppressContentEditableWarning":
          case "suppressHydrationWarning":
            break;
          default:
            v(Kt) && typeof $e != "function" && typeof $e != "symbol" && T.push(Ge, l(Kt), bt, l(M($e)), rr);
        }
        return T.push(ar), st(T, Te, ve), ve;
    }
  }
  var an = u("</"), _r = u(">"), ir = u('<template id="'), Yr = u('"></template>'), kr = u("<!--$-->"), Zr = u('<!--$?--><template id="'), Vr = u('"></template>'), pn = u("<!--$!-->"), gn = u("<!--/$-->"), Tr = u("<template"), zr = u('"'), en = u(' data-dgst="');
  u(' data-msg="'), u(' data-stck="');
  var $r = u("></template>");
  function zt(T, _, V) {
    if (i(T, Zr), V === null) throw Error(e(395));
    return i(T, V), a(T, Vr);
  }
  var sr = u('<div hidden id="'), Er = u('">'), tt = u("</div>"), Nr = u('<svg aria-hidden="true" style="display:none" id="'), Xr = u('">'), Se = u("</svg>"), P = u('<math aria-hidden="true" style="display:none" id="'), U = u('">'), X = u("</math>"), ue = u('<table hidden id="'), Fe = u('">'), We = u("</table>"), wt = u('<table hidden><tbody id="'), Pt = u('">'), Nt = u("</tbody></table>"), or = u('<table hidden><tr id="'), Lt = u('">'), K = u("</tr></table>"), Ie = u('<table hidden><colgroup id="'), Qe = u('">'), Ye = u("</colgroup></table>");
  function Ct(T, _, V, Q) {
    switch (V.insertionMode) {
      case 0:
      case 1:
        return i(T, sr), i(T, _.segmentPrefix), i(T, l(Q.toString(16))), a(T, Er);
      case 2:
        return i(T, Nr), i(T, _.segmentPrefix), i(T, l(Q.toString(16))), a(T, Xr);
      case 3:
        return i(T, P), i(T, _.segmentPrefix), i(T, l(Q.toString(16))), a(T, U);
      case 4:
        return i(T, ue), i(T, _.segmentPrefix), i(T, l(Q.toString(16))), a(T, Fe);
      case 5:
        return i(T, wt), i(T, _.segmentPrefix), i(T, l(Q.toString(16))), a(T, Pt);
      case 6:
        return i(T, or), i(T, _.segmentPrefix), i(T, l(Q.toString(16))), a(T, Lt);
      case 7:
        return i(
          T,
          Ie
        ), i(T, _.segmentPrefix), i(T, l(Q.toString(16))), a(T, Qe);
      default:
        throw Error(e(397));
    }
  }
  function dt(T, _) {
    switch (_.insertionMode) {
      case 0:
      case 1:
        return a(T, tt);
      case 2:
        return a(T, Se);
      case 3:
        return a(T, X);
      case 4:
        return a(T, We);
      case 5:
        return a(T, Nt);
      case 6:
        return a(T, K);
      case 7:
        return a(T, Ye);
      default:
        throw Error(e(397));
    }
  }
  var Rt = u('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), Et = u('$RS("'), hr = u('","'), er = u('")<\/script>'), dr = u('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), $t = u('$RC("'), On = u('","'), Fn = u('")<\/script>'), mr = u('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), xr = u('$RX("'), wn = u('"'), Rr = u(")<\/script>"), jn = u(","), xn = /[<\u2028\u2029]/g;
  function Hr(T) {
    return JSON.stringify(T).replace(xn, function(_) {
      switch (_) {
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  var Cn = Object.assign, cn = /* @__PURE__ */ Symbol.for("react.element"), tn = /* @__PURE__ */ Symbol.for("react.portal"), Jn = /* @__PURE__ */ Symbol.for("react.fragment"), ii = /* @__PURE__ */ Symbol.for("react.strict_mode"), Sn = /* @__PURE__ */ Symbol.for("react.profiler"), mn = /* @__PURE__ */ Symbol.for("react.provider"), sn = /* @__PURE__ */ Symbol.for("react.context"), rn = /* @__PURE__ */ Symbol.for("react.forward_ref"), Lr = /* @__PURE__ */ Symbol.for("react.suspense"), on = /* @__PURE__ */ Symbol.for("react.suspense_list"), E = /* @__PURE__ */ Symbol.for("react.memo"), O = /* @__PURE__ */ Symbol.for("react.lazy"), z = /* @__PURE__ */ Symbol.for("react.scope"), W = /* @__PURE__ */ Symbol.for("react.debug_trace_mode"), pe = /* @__PURE__ */ Symbol.for("react.legacy_hidden"), ce = /* @__PURE__ */ Symbol.for("react.default_value"), Ce = Symbol.iterator;
  function _e(T) {
    if (T == null) return null;
    if (typeof T == "function") return T.displayName || T.name || null;
    if (typeof T == "string") return T;
    switch (T) {
      case Jn:
        return "Fragment";
      case tn:
        return "Portal";
      case Sn:
        return "Profiler";
      case ii:
        return "StrictMode";
      case Lr:
        return "Suspense";
      case on:
        return "SuspenseList";
    }
    if (typeof T == "object") switch (T.$$typeof) {
      case sn:
        return (T.displayName || "Context") + ".Consumer";
      case mn:
        return (T._context.displayName || "Context") + ".Provider";
      case rn:
        var _ = T.render;
        return T = T.displayName, T || (T = _.displayName || _.name || "", T = T !== "" ? "ForwardRef(" + T + ")" : "ForwardRef"), T;
      case E:
        return _ = T.displayName || null, _ !== null ? _ : _e(T.type) || "Memo";
      case O:
        _ = T._payload, T = T._init;
        try {
          return _e(T(_));
        } catch {
        }
    }
    return null;
  }
  var rt = {};
  function ut(T, _) {
    if (T = T.contextTypes, !T) return rt;
    var V = {}, Q;
    for (Q in T) V[Q] = _[Q];
    return V;
  }
  var nt = null;
  function Jt(T, _) {
    if (T !== _) {
      T.context._currentValue = T.parentValue, T = T.parent;
      var V = _.parent;
      if (T === null) {
        if (V !== null) throw Error(e(401));
      } else {
        if (V === null) throw Error(e(401));
        Jt(T, V);
      }
      _.context._currentValue = _.value;
    }
  }
  function vr(T) {
    T.context._currentValue = T.parentValue, T = T.parent, T !== null && vr(T);
  }
  function jr(T) {
    var _ = T.parent;
    _ !== null && jr(_), T.context._currentValue = T.value;
  }
  function fn(T, _) {
    if (T.context._currentValue = T.parentValue, T = T.parent, T === null) throw Error(e(402));
    T.depth === _.depth ? Jt(T, _) : fn(T, _);
  }
  function Kn(T, _) {
    var V = _.parent;
    if (V === null) throw Error(e(402));
    T.depth === V.depth ? Jt(T, V) : Kn(T, V), _.context._currentValue = _.value;
  }
  function Ln(T) {
    var _ = nt;
    _ !== T && (_ === null ? jr(T) : T === null ? vr(_) : _.depth === T.depth ? Jt(_, T) : _.depth > T.depth ? fn(_, T) : Kn(_, T), nt = T);
  }
  var vn = { isMounted: function() {
    return !1;
  }, enqueueSetState: function(T, _) {
    T = T._reactInternals, T.queue !== null && T.queue.push(_);
  }, enqueueReplaceState: function(T, _) {
    T = T._reactInternals, T.replace = !0, T.queue = [_];
  }, enqueueForceUpdate: function() {
  } };
  function Or(T, _, V, Q) {
    var Ae = T.state !== void 0 ? T.state : null;
    T.updater = vn, T.props = V, T.state = Ae;
    var ve = { queue: [], replace: !1 };
    T._reactInternals = ve;
    var Te = _.contextType;
    if (T.context = typeof Te == "object" && Te !== null ? Te._currentValue : Q, Te = _.getDerivedStateFromProps, typeof Te == "function" && (Te = Te(V, Ae), Ae = Te == null ? Ae : Cn({}, Ae, Te), T.state = Ae), typeof _.getDerivedStateFromProps != "function" && typeof T.getSnapshotBeforeUpdate != "function" && (typeof T.UNSAFE_componentWillMount == "function" || typeof T.componentWillMount == "function")) if (_ = T.state, typeof T.componentWillMount == "function" && T.componentWillMount(), typeof T.UNSAFE_componentWillMount == "function" && T.UNSAFE_componentWillMount(), _ !== T.state && vn.enqueueReplaceState(T, T.state, null), ve.queue !== null && 0 < ve.queue.length) if (_ = ve.queue, Te = ve.replace, ve.queue = null, ve.replace = !1, Te && _.length === 1) T.state = _[0];
    else {
      for (ve = Te ? _[0] : T.state, Ae = !0, Te = Te ? 1 : 0; Te < _.length; Te++) {
        var $e = _[Te];
        $e = typeof $e == "function" ? $e.call(T, ve, V, Q) : $e, $e != null && (Ae ? (Ae = !1, ve = Cn({}, ve, $e)) : Cn(ve, $e));
      }
      T.state = ve;
    }
    else ve.queue = null;
  }
  var Gn = { id: 1, overflow: "" };
  function Bn(T, _, V) {
    var Q = T.id;
    T = T.overflow;
    var Ae = 32 - Mn(Q) - 1;
    Q &= ~(1 << Ae), V += 1;
    var ve = 32 - Mn(_) + Ae;
    if (30 < ve) {
      var Te = Ae - Ae % 5;
      return ve = (Q & (1 << Te) - 1).toString(32), Q >>= Te, Ae -= Te, { id: 1 << 32 - Mn(_) + Ae | V << Ae | Q, overflow: ve + T };
    }
    return { id: 1 << ve | V << Ae | Q, overflow: T };
  }
  var Mn = Math.clz32 ? Math.clz32 : Ai, Ri = Math.log, yi = Math.LN2;
  function Ai(T) {
    return T >>>= 0, T === 0 ? 32 : 31 - (Ri(T) / yi | 0) | 0;
  }
  function _n(T, _) {
    return T === _ && (T !== 0 || 1 / T === 1 / _) || T !== T && _ !== _;
  }
  var ki = typeof Object.is == "function" ? Object.is : _n, Un = null, En = null, Zn = null, lr = null, In = !1, bi = !1, I = 0, $ = null, ae = 0;
  function xe() {
    if (Un === null) throw Error(e(321));
    return Un;
  }
  function ht() {
    if (0 < ae) throw Error(e(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function lt() {
    return lr === null ? Zn === null ? (In = !1, Zn = lr = ht()) : (In = !0, lr = Zn) : lr.next === null ? (In = !1, lr = lr.next = ht()) : (In = !0, lr = lr.next), lr;
  }
  function Ht() {
    En = Un = null, bi = !1, Zn = null, ae = 0, lr = $ = null;
  }
  function Ut(T, _) {
    return typeof _ == "function" ? _(T) : _;
  }
  function Br(T, _, V) {
    if (Un = xe(), lr = lt(), In) {
      var Q = lr.queue;
      if (_ = Q.dispatch, $ !== null && (V = $.get(Q), V !== void 0)) {
        $.delete(Q), Q = lr.memoizedState;
        do
          Q = T(Q, V.action), V = V.next;
        while (V !== null);
        return lr.memoizedState = Q, [Q, _];
      }
      return [lr.memoizedState, _];
    }
    return T = T === Ut ? typeof _ == "function" ? _() : _ : V !== void 0 ? V(_) : _, lr.memoizedState = T, T = lr.queue = { last: null, dispatch: null }, T = T.dispatch = Z.bind(null, Un, T), [lr.memoizedState, T];
  }
  function B(T, _) {
    if (Un = xe(), lr = lt(), _ = _ === void 0 ? null : _, lr !== null) {
      var V = lr.memoizedState;
      if (V !== null && _ !== null) {
        var Q = V[1];
        e: if (Q === null) Q = !1;
        else {
          for (var Ae = 0; Ae < Q.length && Ae < _.length; Ae++) if (!ki(_[Ae], Q[Ae])) {
            Q = !1;
            break e;
          }
          Q = !0;
        }
        if (Q) return V[0];
      }
    }
    return T = T(), lr.memoizedState = [T, _], T;
  }
  function Z(T, _, V) {
    if (25 <= ae) throw Error(e(301));
    if (T === Un) if (bi = !0, T = { action: V, next: null }, $ === null && ($ = /* @__PURE__ */ new Map()), V = $.get(_), V === void 0) $.set(_, T);
    else {
      for (_ = V; _.next !== null; ) _ = _.next;
      _.next = T;
    }
  }
  function fe() {
    throw Error(e(394));
  }
  function be() {
  }
  var Me = { readContext: function(T) {
    return T._currentValue;
  }, useContext: function(T) {
    return xe(), T._currentValue;
  }, useMemo: B, useReducer: Br, useRef: function(T) {
    Un = xe(), lr = lt();
    var _ = lr.memoizedState;
    return _ === null ? (T = { current: T }, lr.memoizedState = T) : _;
  }, useState: function(T) {
    return Br(Ut, T);
  }, useInsertionEffect: be, useLayoutEffect: function() {
  }, useCallback: function(T, _) {
    return B(function() {
      return T;
    }, _);
  }, useImperativeHandle: be, useEffect: be, useDebugValue: be, useDeferredValue: function(T) {
    return xe(), T;
  }, useTransition: function() {
    return xe(), [!1, fe];
  }, useId: function() {
    var T = En.treeContext, _ = T.overflow;
    T = T.id, T = (T & ~(1 << 32 - Mn(T) - 1)).toString(32) + _;
    var V = Ke;
    if (V === null) throw Error(e(404));
    return _ = I++, T = ":" + V.idPrefix + "R" + T, 0 < _ && (T += "H" + _.toString(32)), T + ":";
  }, useMutableSource: function(T, _) {
    return xe(), _(T._source);
  }, useSyncExternalStore: function(T, _, V) {
    if (V === void 0) throw Error(e(407));
    return V();
  } }, Ke = null, Xe = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
  function yt(T) {
    return console.error(T), null;
  }
  function Ot() {
  }
  function pr(T, _, V, Q, Ae, ve, Te, $e, Bt) {
    var Kt = [], qt = /* @__PURE__ */ new Set();
    return _ = { destination: null, responseState: _, progressiveChunkSize: Q === void 0 ? 12800 : Q, status: 0, fatalError: null, nextSegmentId: 0, allPendingTasks: 0, pendingRootTasks: 0, completedRootSegment: null, abortableTasks: qt, pingedTasks: Kt, clientRenderedBoundaries: [], completedBoundaries: [], partialBoundaries: [], onError: Ae === void 0 ? yt : Ae, onAllReady: ve === void 0 ? Ot : ve, onShellReady: Te === void 0 ? Ot : Te, onShellError: $e === void 0 ? Ot : $e, onFatalError: Bt === void 0 ? Ot : Bt }, V = ur(_, 0, null, V, !1, !1), V.parentFlushed = !0, T = yr(_, T, null, V, qt, rt, null, Gn), Kt.push(T), _;
  }
  function yr(T, _, V, Q, Ae, ve, Te, $e) {
    T.allPendingTasks++, V === null ? T.pendingRootTasks++ : V.pendingTasks++;
    var Bt = { node: _, ping: function() {
      var Kt = T.pingedTasks;
      Kt.push(Bt), Kt.length === 1 && ls(T);
    }, blockedBoundary: V, blockedSegment: Q, abortSet: Ae, legacyContext: ve, context: Te, treeContext: $e };
    return Ae.add(Bt), Bt;
  }
  function ur(T, _, V, Q, Ae, ve) {
    return { status: 0, id: -1, index: _, parentFlushed: !1, chunks: [], children: [], formatContext: Q, boundary: V, lastPushedText: Ae, textEmbedded: ve };
  }
  function Fr(T, _) {
    if (T = T.onError(_), T != null && typeof T != "string") throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof T + '" instead');
    return T;
  }
  function Gr(T, _) {
    var V = T.onShellError;
    V(_), V = T.onFatalError, V(_), T.destination !== null ? (T.status = 2, c(T.destination, _)) : (T.status = 1, T.fatalError = _);
  }
  function yn(T, _, V, Q, Ae) {
    for (Un = {}, En = _, I = 0, T = V(Q, Ae); bi; ) bi = !1, I = 0, ae += 1, lr = null, T = V(Q, Ae);
    return Ht(), T;
  }
  function Wi(T, _, V, Q) {
    var Ae = V.render(), ve = Q.childContextTypes;
    if (ve != null) {
      var Te = _.legacyContext;
      if (typeof V.getChildContext != "function") Q = Te;
      else {
        V = V.getChildContext();
        for (var $e in V) if (!($e in ve)) throw Error(e(108, _e(Q) || "Unknown", $e));
        Q = Cn({}, Te, V);
      }
      _.legacyContext = Q, qn(T, _, Ae), _.legacyContext = Te;
    } else qn(T, _, Ae);
  }
  function aa(T, _) {
    if (T && T.defaultProps) {
      _ = Cn({}, _), T = T.defaultProps;
      for (var V in T) _[V] === void 0 && (_[V] = T[V]);
      return _;
    }
    return _;
  }
  function Qi(T, _, V, Q, Ae) {
    if (typeof V == "function") if (V.prototype && V.prototype.isReactComponent) {
      Ae = ut(V, _.legacyContext);
      var ve = V.contextType;
      ve = new V(Q, typeof ve == "object" && ve !== null ? ve._currentValue : Ae), Or(ve, V, Q, Ae), Wi(T, _, ve, V);
    } else {
      ve = ut(V, _.legacyContext), Ae = yn(T, _, V, Q, ve);
      var Te = I !== 0;
      if (typeof Ae == "object" && Ae !== null && typeof Ae.render == "function" && Ae.$$typeof === void 0) Or(Ae, V, Q, ve), Wi(T, _, Ae, V);
      else if (Te) {
        Q = _.treeContext, _.treeContext = Bn(Q, 1, 0);
        try {
          qn(T, _, Ae);
        } finally {
          _.treeContext = Q;
        }
      } else qn(T, _, Ae);
    }
    else if (typeof V == "string") {
      switch (Ae = _.blockedSegment, ve = wr(Ae.chunks, V, Q, T.responseState, Ae.formatContext), Ae.lastPushedText = !1, Te = Ae.formatContext, Ae.formatContext = ee(Te, V, Q), di(T, _, ve), Ae.formatContext = Te, V) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          Ae.chunks.push(an, l(V), _r);
      }
      Ae.lastPushedText = !1;
    } else {
      switch (V) {
        case pe:
        case W:
        case ii:
        case Sn:
        case Jn:
          qn(T, _, Q.children);
          return;
        case on:
          qn(T, _, Q.children);
          return;
        case z:
          throw Error(e(343));
        case Lr:
          e: {
            V = _.blockedBoundary, Ae = _.blockedSegment, ve = Q.fallback, Q = Q.children, Te = /* @__PURE__ */ new Set();
            var $e = { id: null, rootSegmentID: -1, parentFlushed: !1, pendingTasks: 0, forceClientRender: !1, completedSegments: [], byteSize: 0, fallbackAbortableTasks: Te, errorDigest: null }, Bt = ur(T, Ae.chunks.length, $e, Ae.formatContext, !1, !1);
            Ae.children.push(Bt), Ae.lastPushedText = !1;
            var Kt = ur(T, 0, null, Ae.formatContext, !1, !1);
            Kt.parentFlushed = !0, _.blockedBoundary = $e, _.blockedSegment = Kt;
            try {
              if (di(
                T,
                _,
                Q
              ), Kt.lastPushedText && Kt.textEmbedded && Kt.chunks.push(re), Kt.status = 1, sa($e, Kt), $e.pendingTasks === 0) break e;
            } catch (qt) {
              Kt.status = 4, $e.forceClientRender = !0, $e.errorDigest = Fr(T, qt);
            } finally {
              _.blockedBoundary = V, _.blockedSegment = Ae;
            }
            _ = yr(T, ve, V, Bt, Te, _.legacyContext, _.context, _.treeContext), T.pingedTasks.push(_);
          }
          return;
      }
      if (typeof V == "object" && V !== null) switch (V.$$typeof) {
        case rn:
          if (Q = yn(T, _, V.render, Q, Ae), I !== 0) {
            V = _.treeContext, _.treeContext = Bn(V, 1, 0);
            try {
              qn(T, _, Q);
            } finally {
              _.treeContext = V;
            }
          } else qn(T, _, Q);
          return;
        case E:
          V = V.type, Q = aa(V, Q), Qi(T, _, V, Q, Ae);
          return;
        case mn:
          if (Ae = Q.children, V = V._context, Q = Q.value, ve = V._currentValue, V._currentValue = Q, Te = nt, nt = Q = { parent: Te, depth: Te === null ? 0 : Te.depth + 1, context: V, parentValue: ve, value: Q }, _.context = Q, qn(T, _, Ae), T = nt, T === null) throw Error(e(403));
          Q = T.parentValue, T.context._currentValue = Q === ce ? T.context._defaultValue : Q, T = nt = T.parent, _.context = T;
          return;
        case sn:
          Q = Q.children, Q = Q(V._currentValue), qn(T, _, Q);
          return;
        case O:
          Ae = V._init, V = Ae(V._payload), Q = aa(V, Q), Qi(T, _, V, Q, void 0);
          return;
      }
      throw Error(e(
        130,
        V == null ? V : typeof V,
        ""
      ));
    }
  }
  function qn(T, _, V) {
    if (_.node = V, typeof V == "object" && V !== null) {
      switch (V.$$typeof) {
        case cn:
          Qi(T, _, V.type, V.props, V.ref);
          return;
        case tn:
          throw Error(e(257));
        case O:
          var Q = V._init;
          V = Q(V._payload), qn(T, _, V);
          return;
      }
      if (ie(V)) {
        Yi(T, _, V);
        return;
      }
      if (V === null || typeof V != "object" ? Q = null : (Q = Ce && V[Ce] || V["@@iterator"], Q = typeof Q == "function" ? Q : null), Q && (Q = Q.call(V))) {
        if (V = Q.next(), !V.done) {
          var Ae = [];
          do
            Ae.push(V.value), V = Q.next();
          while (!V.done);
          Yi(T, _, Ae);
        }
        return;
      }
      throw T = Object.prototype.toString.call(V), Error(e(31, T === "[object Object]" ? "object with keys {" + Object.keys(V).join(", ") + "}" : T));
    }
    typeof V == "string" ? (Q = _.blockedSegment, Q.lastPushedText = de(_.blockedSegment.chunks, V, T.responseState, Q.lastPushedText)) : typeof V == "number" && (Q = _.blockedSegment, Q.lastPushedText = de(_.blockedSegment.chunks, "" + V, T.responseState, Q.lastPushedText));
  }
  function Yi(T, _, V) {
    for (var Q = V.length, Ae = 0; Ae < Q; Ae++) {
      var ve = _.treeContext;
      _.treeContext = Bn(ve, Q, Ae);
      try {
        di(T, _, V[Ae]);
      } finally {
        _.treeContext = ve;
      }
    }
  }
  function di(T, _, V) {
    var Q = _.blockedSegment.formatContext, Ae = _.legacyContext, ve = _.context;
    try {
      return qn(T, _, V);
    } catch (Bt) {
      if (Ht(), typeof Bt == "object" && Bt !== null && typeof Bt.then == "function") {
        V = Bt;
        var Te = _.blockedSegment, $e = ur(T, Te.chunks.length, null, Te.formatContext, Te.lastPushedText, !0);
        Te.children.push($e), Te.lastPushedText = !1, T = yr(T, _.node, _.blockedBoundary, $e, _.abortSet, _.legacyContext, _.context, _.treeContext).ping, V.then(T, T), _.blockedSegment.formatContext = Q, _.legacyContext = Ae, _.context = ve, Ln(ve);
      } else throw _.blockedSegment.formatContext = Q, _.legacyContext = Ae, _.context = ve, Ln(ve), Bt;
    }
  }
  function Na(T) {
    var _ = T.blockedBoundary;
    T = T.blockedSegment, T.status = 3, os(this, _, T);
  }
  function La(T, _, V) {
    var Q = T.blockedBoundary;
    T.blockedSegment.status = 3, Q === null ? (_.allPendingTasks--, _.status !== 2 && (_.status = 2, _.destination !== null && _.destination.close())) : (Q.pendingTasks--, Q.forceClientRender || (Q.forceClientRender = !0, T = V === void 0 ? Error(e(432)) : V, Q.errorDigest = _.onError(T), Q.parentFlushed && _.clientRenderedBoundaries.push(Q)), Q.fallbackAbortableTasks.forEach(function(Ae) {
      return La(Ae, _, V);
    }), Q.fallbackAbortableTasks.clear(), _.allPendingTasks--, _.allPendingTasks === 0 && (Q = _.onAllReady, Q()));
  }
  function sa(T, _) {
    if (_.chunks.length === 0 && _.children.length === 1 && _.children[0].boundary === null) {
      var V = _.children[0];
      V.id = _.id, V.parentFlushed = !0, V.status === 1 && sa(T, V);
    } else T.completedSegments.push(_);
  }
  function os(T, _, V) {
    if (_ === null) {
      if (V.parentFlushed) {
        if (T.completedRootSegment !== null) throw Error(e(389));
        T.completedRootSegment = V;
      }
      T.pendingRootTasks--, T.pendingRootTasks === 0 && (T.onShellError = Ot, _ = T.onShellReady, _());
    } else _.pendingTasks--, _.forceClientRender || (_.pendingTasks === 0 ? (V.parentFlushed && V.status === 1 && sa(_, V), _.parentFlushed && T.completedBoundaries.push(_), _.fallbackAbortableTasks.forEach(Na, T), _.fallbackAbortableTasks.clear()) : V.parentFlushed && V.status === 1 && (sa(_, V), _.completedSegments.length === 1 && _.parentFlushed && T.partialBoundaries.push(_)));
    T.allPendingTasks--, T.allPendingTasks === 0 && (T = T.onAllReady, T());
  }
  function ls(T) {
    if (T.status !== 2) {
      var _ = nt, V = Xe.current;
      Xe.current = Me;
      var Q = Ke;
      Ke = T.responseState;
      try {
        var Ae = T.pingedTasks, ve;
        for (ve = 0; ve < Ae.length; ve++) {
          var Te = Ae[ve], $e = T, Bt = Te.blockedSegment;
          if (Bt.status === 0) {
            Ln(Te.context);
            try {
              qn($e, Te, Te.node), Bt.lastPushedText && Bt.textEmbedded && Bt.chunks.push(re), Te.abortSet.delete(Te), Bt.status = 1, os($e, Te.blockedBoundary, Bt);
            } catch (le) {
              if (Ht(), typeof le == "object" && le !== null && typeof le.then == "function") {
                var Kt = Te.ping;
                le.then(Kt, Kt);
              } else {
                Te.abortSet.delete(Te), Bt.status = 4;
                var qt = Te.blockedBoundary, qr = le, L = Fr($e, qr);
                if (qt === null ? Gr($e, qr) : (qt.pendingTasks--, qt.forceClientRender || (qt.forceClientRender = !0, qt.errorDigest = L, qt.parentFlushed && $e.clientRenderedBoundaries.push(qt))), $e.allPendingTasks--, $e.allPendingTasks === 0) {
                  var te = $e.onAllReady;
                  te();
                }
              }
            }
          }
        }
        Ae.splice(0, ve), T.destination !== null && oa(T, T.destination);
      } catch (le) {
        Fr(T, le), Gr(T, le);
      } finally {
        Ke = Q, Xe.current = V, V === Me && Ln(_);
      }
    }
  }
  function Ti(T, _, V) {
    switch (V.parentFlushed = !0, V.status) {
      case 0:
        var Q = V.id = T.nextSegmentId++;
        return V.lastPushedText = !1, V.textEmbedded = !1, T = T.responseState, i(_, ir), i(_, T.placeholderPrefix), T = l(Q.toString(16)), i(_, T), a(_, Yr);
      case 1:
        V.status = 2;
        var Ae = !0;
        Q = V.chunks;
        var ve = 0;
        V = V.children;
        for (var Te = 0; Te < V.length; Te++) {
          for (Ae = V[Te]; ve < Ae.index; ve++) i(_, Q[ve]);
          Ae = Ua(T, _, Ae);
        }
        for (; ve < Q.length - 1; ve++) i(_, Q[ve]);
        return ve < Q.length && (Ae = a(_, Q[ve])), Ae;
      default:
        throw Error(e(390));
    }
  }
  function Ua(T, _, V) {
    var Q = V.boundary;
    if (Q === null) return Ti(T, _, V);
    if (Q.parentFlushed = !0, Q.forceClientRender) Q = Q.errorDigest, a(_, pn), i(_, Tr), Q && (i(_, en), i(_, l(M(Q))), i(_, zr)), a(_, $r), Ti(T, _, V);
    else if (0 < Q.pendingTasks) {
      Q.rootSegmentID = T.nextSegmentId++, 0 < Q.completedSegments.length && T.partialBoundaries.push(Q);
      var Ae = T.responseState, ve = Ae.nextSuspenseID++;
      Ae = u(Ae.boundaryPrefix + ve.toString(16)), Q = Q.id = Ae, zt(_, T.responseState, Q), Ti(T, _, V);
    } else if (Q.byteSize > T.progressiveChunkSize) Q.rootSegmentID = T.nextSegmentId++, T.completedBoundaries.push(Q), zt(_, T.responseState, Q.id), Ti(T, _, V);
    else {
      if (a(_, kr), V = Q.completedSegments, V.length !== 1) throw Error(e(391));
      Ua(T, _, V[0]);
    }
    return a(_, gn);
  }
  function us(T, _, V) {
    return Ct(_, T.responseState, V.formatContext, V.id), Ua(T, _, V), dt(_, V.formatContext);
  }
  function cs(T, _, V) {
    for (var Q = V.completedSegments, Ae = 0; Ae < Q.length; Ae++) fs(T, _, V, Q[Ae]);
    if (Q.length = 0, T = T.responseState, Q = V.id, V = V.rootSegmentID, i(_, T.startInlineScript), T.sentCompleteBoundaryFunction ? i(_, $t) : (T.sentCompleteBoundaryFunction = !0, i(_, dr)), Q === null) throw Error(e(395));
    return V = l(V.toString(16)), i(_, Q), i(_, On), i(_, T.segmentPrefix), i(_, V), a(_, Fn);
  }
  function fs(T, _, V, Q) {
    if (Q.status === 2) return !0;
    var Ae = Q.id;
    if (Ae === -1) {
      if ((Q.id = V.rootSegmentID) === -1) throw Error(e(392));
      return us(T, _, Q);
    }
    return us(T, _, Q), T = T.responseState, i(_, T.startInlineScript), T.sentCompleteSegmentFunction ? i(_, Et) : (T.sentCompleteSegmentFunction = !0, i(_, Rt)), i(_, T.segmentPrefix), Ae = l(Ae.toString(16)), i(_, Ae), i(_, hr), i(_, T.placeholderPrefix), i(_, Ae), a(_, er);
  }
  function oa(T, _) {
    t = new Uint8Array(512), n = 0;
    try {
      var V = T.completedRootSegment;
      if (V !== null && T.pendingRootTasks === 0) {
        Ua(T, _, V), T.completedRootSegment = null;
        var Q = T.responseState.bootstrapChunks;
        for (V = 0; V < Q.length - 1; V++) i(_, Q[V]);
        V < Q.length && a(_, Q[V]);
      }
      var Ae = T.clientRenderedBoundaries, ve;
      for (ve = 0; ve < Ae.length; ve++) {
        var Te = Ae[ve];
        Q = _;
        var $e = T.responseState, Bt = Te.id, Kt = Te.errorDigest, qt = Te.errorMessage, qr = Te.errorComponentStack;
        if (i(Q, $e.startInlineScript), $e.sentClientRenderFunction ? i(Q, xr) : ($e.sentClientRenderFunction = !0, i(
          Q,
          mr
        )), Bt === null) throw Error(e(395));
        i(Q, Bt), i(Q, wn), (Kt || qt || qr) && (i(Q, jn), i(Q, l(Hr(Kt || "")))), (qt || qr) && (i(Q, jn), i(Q, l(Hr(qt || "")))), qr && (i(Q, jn), i(Q, l(Hr(qr)))), a(Q, Rr);
      }
      Ae.splice(0, ve);
      var L = T.completedBoundaries;
      for (ve = 0; ve < L.length; ve++) cs(T, _, L[ve]);
      L.splice(0, ve), s(_), t = new Uint8Array(512), n = 0;
      var te = T.partialBoundaries;
      for (ve = 0; ve < te.length; ve++) {
        var le = te[ve];
        e: {
          Ae = T, Te = _;
          var Ve = le.completedSegments;
          for ($e = 0; $e < Ve.length; $e++) if (!fs(
            Ae,
            Te,
            le,
            Ve[$e]
          )) {
            $e++, Ve.splice(0, $e);
            var pt = !1;
            break e;
          }
          Ve.splice(0, $e), pt = !0;
        }
        if (!pt) {
          T.destination = null, ve++, te.splice(0, ve);
          return;
        }
      }
      te.splice(0, ve);
      var _t = T.completedBoundaries;
      for (ve = 0; ve < _t.length; ve++) cs(T, _, _t[ve]);
      _t.splice(0, ve);
    } finally {
      s(_), T.allPendingTasks === 0 && T.pingedTasks.length === 0 && T.clientRenderedBoundaries.length === 0 && T.completedBoundaries.length === 0 && _.close();
    }
  }
  function Ui(T, _) {
    try {
      var V = T.abortableTasks;
      V.forEach(function(Q) {
        return La(Q, T, _);
      }), V.clear(), T.destination !== null && oa(T, T.destination);
    } catch (Q) {
      Fr(T, Q), Gr(T, Q);
    }
  }
  return Fh.renderToReadableStream = function(T, _) {
    return new Promise(function(V, Q) {
      var Ae, ve, Te = new Promise(function(qt, qr) {
        ve = qt, Ae = qr;
      }), $e = pr(T, Ue(_ ? _.identifierPrefix : void 0, _ ? _.nonce : void 0, _ ? _.bootstrapScriptContent : void 0, _ ? _.bootstrapScripts : void 0, _ ? _.bootstrapModules : void 0), Oe(_ ? _.namespaceURI : void 0), _ ? _.progressiveChunkSize : void 0, _ ? _.onError : void 0, ve, function() {
        var qt = new ReadableStream({ type: "bytes", pull: function(qr) {
          if ($e.status === 1) $e.status = 2, c(qr, $e.fatalError);
          else if ($e.status !== 2 && $e.destination === null) {
            $e.destination = qr;
            try {
              oa($e, qr);
            } catch (L) {
              Fr($e, L), Gr($e, L);
            }
          }
        }, cancel: function() {
          Ui($e);
        } }, { highWaterMark: 0 });
        qt.allReady = Te, V(qt);
      }, function(qt) {
        Te.catch(function() {
        }), Q(qt);
      }, Ae);
      if (_ && _.signal) {
        var Bt = _.signal, Kt = function() {
          Ui($e, Bt.reason), Bt.removeEventListener("abort", Kt);
        };
        Bt.addEventListener("abort", Kt);
      }
      ls($e);
    });
  }, Fh.version = "18.3.1", Fh;
}
var nl = {};
var Lw;
function S4() {
  return Lw || (Lw = 1, process.env.NODE_ENV !== "production" && (function() {
    var r = Sl(), e = "18.3.1", t = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(p) {
      {
        for (var m = arguments.length, b = new Array(m > 1 ? m - 1 : 0), C = 1; C < m; C++)
          b[C - 1] = arguments[C];
        a("warn", p, b);
      }
    }
    function i(p) {
      {
        for (var m = arguments.length, b = new Array(m > 1 ? m - 1 : 0), C = 1; C < m; C++)
          b[C - 1] = arguments[C];
        a("error", p, b);
      }
    }
    function a(p, m, b) {
      {
        var C = t.ReactDebugCurrentFrame, D = C.getStackAddendum();
        D !== "" && (m += "%s", b = b.concat([D]));
        var N = b.map(function(H) {
          return String(H);
        });
        N.unshift("Warning: " + m), Function.prototype.apply.call(console[p], console, N);
      }
    }
    function s(p) {
      p();
    }
    function o(p) {
    }
    function l(p, m) {
      u(p, m);
    }
    function u(p, m) {
      return p.push(m);
    }
    function c(p) {
    }
    function d(p) {
      p.push(null);
    }
    function f(p) {
      return p;
    }
    function h(p) {
      return p;
    }
    function g(p, m) {
      p.destroy(m);
    }
    function v(p) {
      {
        var m = typeof Symbol == "function" && Symbol.toStringTag, b = m && p[Symbol.toStringTag] || p.constructor.name || "Object";
        return b;
      }
    }
    function y(p) {
      try {
        return A(p), !1;
      } catch {
        return !0;
      }
    }
    function A(p) {
      return "" + p;
    }
    function x(p, m) {
      if (y(p))
        return i("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", m, v(p)), A(p);
    }
    function k(p, m) {
      if (y(p))
        return i("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", m, v(p)), A(p);
    }
    function F(p) {
      if (y(p))
        return i("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", v(p)), A(p);
    }
    var S = Object.prototype.hasOwnProperty, R = 0, M = 1, j = 2, G = 3, ie = 4, q = 5, Y = 6, J = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", se = J + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", oe = new RegExp("^[" + J + "][" + se + "]*$"), he = {}, ye = {};
    function Ue(p) {
      return S.call(ye, p) ? !0 : S.call(he, p) ? !1 : oe.test(p) ? (ye[p] = !0, !0) : (he[p] = !0, i("Invalid attribute name: `%s`", p), !1);
    }
    function Re(p, m, b, C) {
      if (b !== null && b.type === R)
        return !1;
      switch (typeof m) {
        case "function":
        // $FlowIssue symbol is perfectly valid here
        case "symbol":
          return !0;
        case "boolean": {
          if (b !== null)
            return !b.acceptsBooleans;
          var D = p.toLowerCase().slice(0, 5);
          return D !== "data-" && D !== "aria-";
        }
        default:
          return !1;
      }
    }
    function Oe(p) {
      return re.hasOwnProperty(p) ? re[p] : null;
    }
    function ee(p, m, b, C, D, N, H) {
      this.acceptsBooleans = m === j || m === G || m === ie, this.attributeName = C, this.attributeNamespace = D, this.mustUseProperty = b, this.propertyName = p, this.type = m, this.sanitizeURL = N, this.removeEmptyString = H;
    }
    var re = {}, de = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    de.forEach(function(p) {
      re[p] = new ee(
        p,
        R,
        !1,
        // mustUseProperty
        p,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(p) {
      var m = p[0], b = p[1];
      re[m] = new ee(
        m,
        M,
        !1,
        // mustUseProperty
        b,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(p) {
      re[p] = new ee(
        p,
        j,
        !1,
        // mustUseProperty
        p.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(p) {
      re[p] = new ee(
        p,
        j,
        !1,
        // mustUseProperty
        p,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(p) {
      re[p] = new ee(
        p,
        G,
        !1,
        // mustUseProperty
        p.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(p) {
      re[p] = new ee(
        p,
        G,
        !0,
        // mustUseProperty
        p,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(p) {
      re[p] = new ee(
        p,
        ie,
        !1,
        // mustUseProperty
        p,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(p) {
      re[p] = new ee(
        p,
        Y,
        !1,
        // mustUseProperty
        p,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(p) {
      re[p] = new ee(
        p,
        q,
        !1,
        // mustUseProperty
        p.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var Be = /[\-\:]([a-z])/g, ke = function(p) {
      return p[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(p) {
      var m = p.replace(Be, ke);
      re[m] = new ee(
        m,
        M,
        !1,
        // mustUseProperty
        p,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(p) {
      var m = p.replace(Be, ke);
      re[m] = new ee(
        m,
        M,
        !1,
        // mustUseProperty
        p,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(p) {
      var m = p.replace(Be, ke);
      re[m] = new ee(
        m,
        M,
        !1,
        // mustUseProperty
        p,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(p) {
      re[p] = new ee(
        p,
        M,
        !1,
        // mustUseProperty
        p.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var ze = "xlinkHref";
    re[ze] = new ee(
      "xlinkHref",
      M,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(p) {
      re[p] = new ee(
        p,
        M,
        !1,
        // mustUseProperty
        p.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var je = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function qe(p, m) {
      return p + m.charAt(0).toUpperCase() + m.substring(1);
    }
    var Ge = ["Webkit", "ms", "Moz", "O"];
    Object.keys(je).forEach(function(p) {
      Ge.forEach(function(m) {
        je[qe(m, p)] = je[p];
      });
    });
    var bt = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function rr(p, m) {
      bt[m.type] || m.onChange || m.onInput || m.readOnly || m.disabled || m.value == null || i("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), m.onChange || m.readOnly || m.disabled || m.checked == null || i("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function Pr(p, m) {
      if (p.indexOf("-") === -1)
        return typeof m.is == "string";
      switch (p) {
        // These are reserved SVG and MathML elements.
        // We don't mind this list too much because we expect it to never grow.
        // The alternative is to track the namespace in a few places which is convoluted.
        // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Gt = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, ar = {}, St = new RegExp("^(aria)-[" + se + "]*$"), st = new RegExp("^(aria)[A-Z][" + se + "]*$");
    function Qr(p, m) {
      {
        if (S.call(ar, m) && ar[m])
          return !0;
        if (st.test(m)) {
          var b = "aria-" + m.slice(4).toLowerCase(), C = Gt.hasOwnProperty(b) ? b : null;
          if (C == null)
            return i("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", m), ar[m] = !0, !0;
          if (m !== C)
            return i("Invalid ARIA attribute `%s`. Did you mean `%s`?", m, C), ar[m] = !0, !0;
        }
        if (St.test(m)) {
          var D = m.toLowerCase(), N = Gt.hasOwnProperty(D) ? D : null;
          if (N == null)
            return ar[m] = !0, !1;
          if (m !== N)
            return i("Unknown ARIA attribute `%s`. Did you mean `%s`?", m, N), ar[m] = !0, !0;
        }
      }
      return !0;
    }
    function Sr(p, m) {
      {
        var b = [];
        for (var C in m) {
          var D = Qr(p, C);
          D || b.push(C);
        }
        var N = b.map(function(H) {
          return "`" + H + "`";
        }).join(", ");
        b.length === 1 ? i("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", N, p) : b.length > 1 && i("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", N, p);
      }
    }
    function gr(p, m) {
      Pr(p, m) || Sr(p, m);
    }
    var nr = !1;
    function fr(p, m) {
      {
        if (p !== "input" && p !== "textarea" && p !== "select")
          return;
        m != null && m.value === null && !nr && (nr = !0, p === "select" && m.multiple ? i("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", p) : i("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", p));
      }
    }
    var Yt = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, Xt = function() {
    };
    {
      var mt = {}, wr = /^on./, an = /^on[^A-Z]/, _r = new RegExp("^(aria)-[" + se + "]*$"), ir = new RegExp("^(aria)[A-Z][" + se + "]*$");
      Xt = function(p, m, b, C) {
        if (S.call(mt, m) && mt[m])
          return !0;
        var D = m.toLowerCase();
        if (D === "onfocusin" || D === "onfocusout")
          return i("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), mt[m] = !0, !0;
        if (C != null) {
          var N = C.registrationNameDependencies, H = C.possibleRegistrationNames;
          if (N.hasOwnProperty(m))
            return !0;
          var ne = H.hasOwnProperty(D) ? H[D] : null;
          if (ne != null)
            return i("Invalid event handler property `%s`. Did you mean `%s`?", m, ne), mt[m] = !0, !0;
          if (wr.test(m))
            return i("Unknown event handler property `%s`. It will be ignored.", m), mt[m] = !0, !0;
        } else if (wr.test(m))
          return an.test(m) && i("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", m), mt[m] = !0, !0;
        if (_r.test(m) || ir.test(m))
          return !0;
        if (D === "innerhtml")
          return i("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), mt[m] = !0, !0;
        if (D === "aria")
          return i("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), mt[m] = !0, !0;
        if (D === "is" && b !== null && b !== void 0 && typeof b != "string")
          return i("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof b), mt[m] = !0, !0;
        if (typeof b == "number" && isNaN(b))
          return i("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", m), mt[m] = !0, !0;
        var ge = Oe(m), Pe = ge !== null && ge.type === R;
        if (Yt.hasOwnProperty(D)) {
          var Ne = Yt[D];
          if (Ne !== m)
            return i("Invalid DOM property `%s`. Did you mean `%s`?", m, Ne), mt[m] = !0, !0;
        } else if (!Pe && m !== D)
          return i("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", m, D), mt[m] = !0, !0;
        return typeof b == "boolean" && Re(m, b, ge) ? (b ? i('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', b, m, m, b, m) : i('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', b, m, m, b, m, m, m), mt[m] = !0, !0) : Pe ? !0 : Re(m, b, ge) ? (mt[m] = !0, !1) : ((b === "false" || b === "true") && ge !== null && ge.type === G && (i("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", b, m, b === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', m, b), mt[m] = !0), !0);
      };
    }
    var Yr = function(p, m, b) {
      {
        var C = [];
        for (var D in m) {
          var N = Xt(p, D, m[D], b);
          N || C.push(D);
        }
        var H = C.map(function(ne) {
          return "`" + ne + "`";
        }).join(", ");
        C.length === 1 ? i("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", H, p) : C.length > 1 && i("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", H, p);
      }
    };
    function kr(p, m, b) {
      Pr(p, m) || Yr(p, m, b);
    }
    var Zr = function() {
    };
    {
      var Vr = /^(?:webkit|moz|o)[A-Z]/, pn = /^-ms-/, gn = /-(.)/g, Tr = /;\s*$/, zr = {}, en = {}, $r = !1, zt = !1, sr = function(p) {
        return p.replace(gn, function(m, b) {
          return b.toUpperCase();
        });
      }, Er = function(p) {
        zr.hasOwnProperty(p) && zr[p] || (zr[p] = !0, i(
          "Unsupported style property %s. Did you mean %s?",
          p,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          sr(p.replace(pn, "ms-"))
        ));
      }, tt = function(p) {
        zr.hasOwnProperty(p) && zr[p] || (zr[p] = !0, i("Unsupported vendor-prefixed style property %s. Did you mean %s?", p, p.charAt(0).toUpperCase() + p.slice(1)));
      }, Nr = function(p, m) {
        en.hasOwnProperty(m) && en[m] || (en[m] = !0, i(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, p, m.replace(Tr, "")));
      }, Xr = function(p, m) {
        $r || ($r = !0, i("`NaN` is an invalid value for the `%s` css style property.", p));
      }, Se = function(p, m) {
        zt || (zt = !0, i("`Infinity` is an invalid value for the `%s` css style property.", p));
      };
      Zr = function(p, m) {
        p.indexOf("-") > -1 ? Er(p) : Vr.test(p) ? tt(p) : Tr.test(m) && Nr(p, m), typeof m == "number" && (isNaN(m) ? Xr(p, m) : isFinite(m) || Se(p, m));
      };
    }
    var P = Zr, U = /["'&<>]/;
    function X(p) {
      F(p);
      var m = "" + p, b = U.exec(m);
      if (!b)
        return m;
      var C, D = "", N, H = 0;
      for (N = b.index; N < m.length; N++) {
        switch (m.charCodeAt(N)) {
          case 34:
            C = "&quot;";
            break;
          case 38:
            C = "&amp;";
            break;
          case 39:
            C = "&#x27;";
            break;
          case 60:
            C = "&lt;";
            break;
          case 62:
            C = "&gt;";
            break;
          default:
            continue;
        }
        H !== N && (D += m.substring(H, N)), H = N + 1, D += C;
      }
      return H !== N ? D + m.substring(H, N) : D;
    }
    function ue(p) {
      return typeof p == "boolean" || typeof p == "number" ? "" + p : X(p);
    }
    var Fe = /([A-Z])/g, We = /^ms-/;
    function wt(p) {
      return p.replace(Fe, "-$1").toLowerCase().replace(We, "-ms-");
    }
    var Pt = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, Nt = !1;
    function or(p) {
      !Nt && Pt.test(p) && (Nt = !0, i("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(p)));
    }
    var Lt = Array.isArray;
    function K(p) {
      return Lt(p);
    }
    var Ie = "<script>";
    function Qe(p, m, b, C, D) {
      var N = p === void 0 ? "" : p, H = Ie, ne = [];
      return {
        bootstrapChunks: ne,
        startInlineScript: H,
        placeholderPrefix: N + "P:",
        segmentPrefix: N + "S:",
        boundaryPrefix: N + "B:",
        idPrefix: N,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
      };
    }
    var Ye = 0, Ct = 1, dt = 2, Rt = 3, Et = 4, hr = 5, er = 6, dr = 7;
    function $t(p, m) {
      return {
        insertionMode: p,
        selectedValue: m
      };
    }
    function On(p, m, b) {
      switch (m) {
        case "select":
          return $t(Ct, b.value != null ? b.value : b.defaultValue);
        case "svg":
          return $t(dt, null);
        case "math":
          return $t(Rt, null);
        case "foreignObject":
          return $t(Ct, null);
        // Table parents are special in that their children can only be created at all if they're
        // wrapped in a table parent. So we need to encode that we're entering this mode.
        case "table":
          return $t(Et, null);
        case "thead":
        case "tbody":
        case "tfoot":
          return $t(hr, null);
        case "colgroup":
          return $t(dr, null);
        case "tr":
          return $t(er, null);
      }
      return p.insertionMode >= Et || p.insertionMode === Ye ? $t(Ct, null) : p;
    }
    var Fn = null;
    function mr(p) {
      var m = p.nextSuspenseID++;
      return p.boundaryPrefix + m.toString(16);
    }
    function xr(p, m, b) {
      var C = p.idPrefix, D = ":" + C + "R" + m;
      return b > 0 && (D += "H" + b.toString(32)), D + ":";
    }
    function wn(p) {
      return ue(p);
    }
    var Rr = "<!-- -->";
    function jn(p, m, b, C) {
      return m === "" ? C : (C && p.push(Rr), p.push(wn(m)), !0);
    }
    function xn(p, m, b, C) {
      b && C && p.push(Rr);
    }
    var Hr = /* @__PURE__ */ new Map();
    function Cn(p) {
      var m = Hr.get(p);
      if (m !== void 0)
        return m;
      var b = ue(wt(p));
      return Hr.set(p, b), b;
    }
    var cn = ' style="', tn = ":", Jn = ";";
    function ii(p, m, b) {
      if (typeof b != "object")
        throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      var C = !0;
      for (var D in b)
        if (S.call(b, D)) {
          var N = b[D];
          if (!(N == null || typeof N == "boolean" || N === "")) {
            var H = void 0, ne = void 0, ge = D.indexOf("--") === 0;
            ge ? (H = ue(D), k(N, D), ne = ue(("" + N).trim())) : (P(D, N), H = Cn(D), typeof N == "number" ? N !== 0 && !S.call(je, D) ? ne = N + "px" : ne = "" + N : (k(N, D), ne = ue(("" + N).trim()))), C ? (C = !1, p.push(cn, H, tn, ne)) : p.push(Jn, H, tn, ne);
          }
        }
      C || p.push(sn);
    }
    var Sn = " ", mn = '="', sn = '"', rn = '=""';
    function Lr(p, m, b, C) {
      switch (b) {
        case "style": {
          ii(p, m, C);
          return;
        }
        case "defaultValue":
        case "defaultChecked":
        // These shouldn't be set as attributes on generic HTML elements.
        case "innerHTML":
        // Must use dangerouslySetInnerHTML instead.
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
          return;
      }
      if (
        // shouldIgnoreAttribute
        // We have already filtered out null/undefined and reserved words.
        !(b.length > 2 && (b[0] === "o" || b[0] === "O") && (b[1] === "n" || b[1] === "N"))
      ) {
        var D = Oe(b);
        if (D !== null) {
          switch (typeof C) {
            case "function":
            // $FlowIssue symbol is perfectly valid here
            case "symbol":
              return;
            case "boolean":
              if (!D.acceptsBooleans)
                return;
          }
          var N = D.attributeName, H = N;
          switch (D.type) {
            case G:
              C && p.push(Sn, H, rn);
              return;
            case ie:
              C === !0 ? p.push(Sn, H, rn) : C === !1 || p.push(Sn, H, mn, ue(C), sn);
              return;
            case q:
              isNaN(C) || p.push(Sn, H, mn, ue(C), sn);
              break;
            case Y:
              !isNaN(C) && C >= 1 && p.push(Sn, H, mn, ue(C), sn);
              break;
            default:
              D.sanitizeURL && (x(C, N), C = "" + C, or(C)), p.push(Sn, H, mn, ue(C), sn);
          }
        } else if (Ue(b)) {
          switch (typeof C) {
            case "function":
            // $FlowIssue symbol is perfectly valid here
            case "symbol":
              return;
            case "boolean": {
              var ne = b.toLowerCase().slice(0, 5);
              if (ne !== "data-" && ne !== "aria-")
                return;
            }
          }
          p.push(Sn, b, mn, ue(C), sn);
        }
      }
    }
    var on = ">", E = "/>";
    function O(p, m, b) {
      if (m != null) {
        if (b != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof m != "object" || !("__html" in m))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var C = m.__html;
        C != null && (F(C), p.push("" + C));
      }
    }
    var z = !1, W = !1, pe = !1, ce = !1, Ce = !1, _e = !1, rt = !1;
    function ut(p, m) {
      {
        var b = p[m];
        if (b != null) {
          var C = K(b);
          p.multiple && !C ? i("The `%s` prop supplied to <select> must be an array if `multiple` is true.", m) : !p.multiple && C && i("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", m);
        }
      }
    }
    function nt(p, m, b) {
      rr("select", m), ut(m, "value"), ut(m, "defaultValue"), m.value !== void 0 && m.defaultValue !== void 0 && !pe && (i("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), pe = !0), p.push(_n("select"));
      var C = null, D = null;
      for (var N in m)
        if (S.call(m, N)) {
          var H = m[N];
          if (H == null)
            continue;
          switch (N) {
            case "children":
              C = H;
              break;
            case "dangerouslySetInnerHTML":
              D = H;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              Lr(p, b, N, H);
              break;
          }
        }
      return p.push(on), O(p, D, C), C;
    }
    function Jt(p) {
      var m = "";
      return r.Children.forEach(p, function(b) {
        b != null && (m += b, !Ce && typeof b != "string" && typeof b != "number" && (Ce = !0, i("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }), m;
    }
    var vr = ' selected=""';
    function jr(p, m, b, C) {
      var D = C.selectedValue;
      p.push(_n("option"));
      var N = null, H = null, ne = null, ge = null;
      for (var Pe in m)
        if (S.call(m, Pe)) {
          var Ne = m[Pe];
          if (Ne == null)
            continue;
          switch (Pe) {
            case "children":
              N = Ne;
              break;
            case "selected":
              ne = Ne, rt || (i("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), rt = !0);
              break;
            case "dangerouslySetInnerHTML":
              ge = Ne;
              break;
            // eslint-disable-next-line-no-fallthrough
            case "value":
              H = Ne;
            // We intentionally fallthrough to also set the attribute on the node.
            // eslint-disable-next-line-no-fallthrough
            default:
              Lr(p, b, Pe, Ne);
              break;
          }
        }
      if (D != null) {
        var Ze;
        if (H !== null ? (x(H, "value"), Ze = "" + H) : (ge !== null && (_e || (_e = !0, i("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."))), Ze = Jt(N)), K(D))
          for (var Vt = 0; Vt < D.length; Vt++) {
            x(D[Vt], "value");
            var Dr = "" + D[Vt];
            if (Dr === Ze) {
              p.push(vr);
              break;
            }
          }
        else
          x(D, "select.value"), "" + D === Ze && p.push(vr);
      } else ne && p.push(vr);
      return p.push(on), O(p, ge, N), N;
    }
    function fn(p, m, b) {
      rr("input", m), m.checked !== void 0 && m.defaultChecked !== void 0 && !W && (i("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", m.type), W = !0), m.value !== void 0 && m.defaultValue !== void 0 && !z && (i("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", m.type), z = !0), p.push(_n("input"));
      var C = null, D = null, N = null, H = null;
      for (var ne in m)
        if (S.call(m, ne)) {
          var ge = m[ne];
          if (ge == null)
            continue;
          switch (ne) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("input is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            // eslint-disable-next-line-no-fallthrough
            case "defaultChecked":
              H = ge;
              break;
            case "defaultValue":
              D = ge;
              break;
            case "checked":
              N = ge;
              break;
            case "value":
              C = ge;
              break;
            default:
              Lr(p, b, ne, ge);
              break;
          }
        }
      return N !== null ? Lr(p, b, "checked", N) : H !== null && Lr(p, b, "checked", H), C !== null ? Lr(p, b, "value", C) : D !== null && Lr(p, b, "value", D), p.push(E), null;
    }
    function Kn(p, m, b) {
      rr("textarea", m), m.value !== void 0 && m.defaultValue !== void 0 && !ce && (i("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components"), ce = !0), p.push(_n("textarea"));
      var C = null, D = null, N = null;
      for (var H in m)
        if (S.call(m, H)) {
          var ne = m[H];
          if (ne == null)
            continue;
          switch (H) {
            case "children":
              N = ne;
              break;
            case "value":
              C = ne;
              break;
            case "defaultValue":
              D = ne;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
            // eslint-disable-next-line-no-fallthrough
            default:
              Lr(p, b, H, ne);
              break;
          }
        }
      if (C === null && D !== null && (C = D), p.push(on), N != null) {
        if (i("Use the `defaultValue` or `value` props instead of setting children on <textarea>."), C != null)
          throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
        if (K(N)) {
          if (N.length > 1)
            throw new Error("<textarea> can only have at most one child.");
          F(N[0]), C = "" + N[0];
        }
        F(N), C = "" + N;
      }
      return typeof C == "string" && C[0] === `
` && p.push(Mn), C !== null && (x(C, "value"), p.push(wn("" + C))), null;
    }
    function Ln(p, m, b, C) {
      p.push(_n(b));
      for (var D in m)
        if (S.call(m, D)) {
          var N = m[D];
          if (N == null)
            continue;
          switch (D) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error(b + " is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            // eslint-disable-next-line-no-fallthrough
            default:
              Lr(p, C, D, N);
              break;
          }
        }
      return p.push(E), null;
    }
    function vn(p, m, b) {
      p.push(_n("menuitem"));
      for (var C in m)
        if (S.call(m, C)) {
          var D = m[C];
          if (D == null)
            continue;
          switch (C) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("menuitems cannot have `children` nor `dangerouslySetInnerHTML`.");
            // eslint-disable-next-line-no-fallthrough
            default:
              Lr(p, b, C, D);
              break;
          }
        }
      return p.push(on), null;
    }
    function Or(p, m, b) {
      p.push(_n("title"));
      var C = null;
      for (var D in m)
        if (S.call(m, D)) {
          var N = m[D];
          if (N == null)
            continue;
          switch (D) {
            case "children":
              C = N;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <title>.");
            // eslint-disable-next-line-no-fallthrough
            default:
              Lr(p, b, D, N);
              break;
          }
        }
      p.push(on);
      {
        var H = Array.isArray(C) && C.length < 2 ? C[0] || null : C;
        Array.isArray(C) && C.length > 1 ? i("A title element received an array with more than 1 element as children. In browsers title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : H != null && H.$$typeof != null ? i("A title element received a React element for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : H != null && typeof H != "string" && typeof H != "number" && i("A title element received a value that was not a string or number for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
      }
      return C;
    }
    function Gn(p, m, b, C) {
      p.push(_n(b));
      var D = null, N = null;
      for (var H in m)
        if (S.call(m, H)) {
          var ne = m[H];
          if (ne == null)
            continue;
          switch (H) {
            case "children":
              D = ne;
              break;
            case "dangerouslySetInnerHTML":
              N = ne;
              break;
            default:
              Lr(p, C, H, ne);
              break;
          }
        }
      return p.push(on), O(p, N, D), typeof D == "string" ? (p.push(wn(D)), null) : D;
    }
    function Bn(p, m, b, C) {
      p.push(_n(b));
      var D = null, N = null;
      for (var H in m)
        if (S.call(m, H)) {
          var ne = m[H];
          if (ne == null)
            continue;
          switch (H) {
            case "children":
              D = ne;
              break;
            case "dangerouslySetInnerHTML":
              N = ne;
              break;
            case "style":
              ii(p, C, ne);
              break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
              break;
            default:
              Ue(H) && typeof ne != "function" && typeof ne != "symbol" && p.push(Sn, H, mn, ue(ne), sn);
              break;
          }
        }
      return p.push(on), O(p, N, D), D;
    }
    var Mn = `
`;
    function Ri(p, m, b, C) {
      p.push(_n(b));
      var D = null, N = null;
      for (var H in m)
        if (S.call(m, H)) {
          var ne = m[H];
          if (ne == null)
            continue;
          switch (H) {
            case "children":
              D = ne;
              break;
            case "dangerouslySetInnerHTML":
              N = ne;
              break;
            default:
              Lr(p, C, H, ne);
              break;
          }
        }
      if (p.push(on), N != null) {
        if (D != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof N != "object" || !("__html" in N))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var ge = N.__html;
        ge != null && (typeof ge == "string" && ge.length > 0 && ge[0] === `
` ? p.push(Mn, ge) : (F(ge), p.push("" + ge)));
      }
      return typeof D == "string" && D[0] === `
` && p.push(Mn), D;
    }
    var yi = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Ai = /* @__PURE__ */ new Map();
    function _n(p) {
      var m = Ai.get(p);
      if (m === void 0) {
        if (!yi.test(p))
          throw new Error("Invalid tag: " + p);
        m = "<" + p, Ai.set(p, m);
      }
      return m;
    }
    var ki = "<!DOCTYPE html>";
    function Un(p, m, b, C, D) {
      switch (gr(m, b), fr(m, b), kr(m, b, null), !b.suppressContentEditableWarning && b.contentEditable && b.children != null && i("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), D.insertionMode !== dt && D.insertionMode !== Rt && m.indexOf("-") === -1 && typeof b.is != "string" && m.toLowerCase() !== m && i("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", m), m) {
        // Special tags
        case "select":
          return nt(p, b, C);
        case "option":
          return jr(p, b, C, D);
        case "textarea":
          return Kn(p, b, C);
        case "input":
          return fn(p, b, C);
        case "menuitem":
          return vn(p, b, C);
        case "title":
          return Or(p, b, C);
        // Newline eating tags
        case "listing":
        case "pre":
          return Ri(p, b, m, C);
        // Omitted close tags
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          return Ln(p, b, m, C);
        // These are reserved SVG and MathML elements, that are never custom elements.
        // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return Gn(p, b, m, C);
        case "html":
          return D.insertionMode === Ye && p.push(ki), Gn(p, b, m, C);
        default:
          return m.indexOf("-") === -1 && typeof b.is != "string" ? Gn(p, b, m, C) : Bn(p, b, m, C);
      }
    }
    var En = "</", Zn = ">";
    function lr(p, m, b) {
      switch (m) {
        // Omitted close tags
        // TODO: Instead of repeating this switch we could try to pass a flag from above.
        // That would require returning a tuple. Which might be ok if it gets inlined.
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          p.push(En, m, Zn);
      }
    }
    function In(p, m) {
      for (var b = m.bootstrapChunks, C = 0; C < b.length - 1; C++)
        l(p, b[C]);
      return C < b.length ? u(p, b[C]) : !0;
    }
    var bi = '<template id="', I = '"></template>';
    function $(p, m, b) {
      l(p, bi), l(p, m.placeholderPrefix);
      var C = b.toString(16);
      return l(p, C), u(p, I);
    }
    var ae = "<!--$-->", xe = '<!--$?--><template id="', ht = '"></template>', lt = "<!--$!-->", Ht = "<!--/$-->", Ut = "<template", Br = '"', B = ' data-dgst="', Z = ' data-msg="', fe = ' data-stck="', be = "></template>";
    function Me(p, m) {
      return u(p, ae);
    }
    function Ke(p, m, b) {
      if (l(p, xe), b === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return l(p, b), u(p, ht);
    }
    function Xe(p, m, b, C, D) {
      var N;
      return N = u(p, lt), l(p, Ut), b && (l(p, B), l(p, ue(b)), l(p, Br)), C && (l(p, Z), l(p, ue(C)), l(p, Br)), D && (l(p, fe), l(p, ue(D)), l(p, Br)), N = u(p, be), N;
    }
    function yt(p, m) {
      return u(p, Ht);
    }
    function Ot(p, m) {
      return u(p, Ht);
    }
    function pr(p, m) {
      return u(p, Ht);
    }
    var yr = '<div hidden id="', ur = '">', Fr = "</div>", Gr = '<svg aria-hidden="true" style="display:none" id="', yn = '">', Wi = "</svg>", aa = '<math aria-hidden="true" style="display:none" id="', Qi = '">', qn = "</math>", Yi = '<table hidden id="', di = '">', Na = "</table>", La = '<table hidden><tbody id="', sa = '">', os = "</tbody></table>", ls = '<table hidden><tr id="', Ti = '">', Ua = "</tr></table>", us = '<table hidden><colgroup id="', cs = '">', fs = "</colgroup></table>";
    function oa(p, m, b, C) {
      switch (b.insertionMode) {
        case Ye:
        case Ct:
          return l(p, yr), l(p, m.segmentPrefix), l(p, C.toString(16)), u(p, ur);
        case dt:
          return l(p, Gr), l(p, m.segmentPrefix), l(p, C.toString(16)), u(p, yn);
        case Rt:
          return l(p, aa), l(p, m.segmentPrefix), l(p, C.toString(16)), u(p, Qi);
        case Et:
          return l(p, Yi), l(p, m.segmentPrefix), l(p, C.toString(16)), u(p, di);
        // TODO: For the rest of these, there will be extra wrapper nodes that never
        // get deleted from the document. We need to delete the table too as part
        // of the injected scripts. They are invisible though so it's not too terrible
        // and it's kind of an edge case to suspend in a table. Totally supported though.
        case hr:
          return l(p, La), l(p, m.segmentPrefix), l(p, C.toString(16)), u(p, sa);
        case er:
          return l(p, ls), l(p, m.segmentPrefix), l(p, C.toString(16)), u(p, Ti);
        case dr:
          return l(p, us), l(p, m.segmentPrefix), l(p, C.toString(16)), u(p, cs);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    function Ui(p, m) {
      switch (m.insertionMode) {
        case Ye:
        case Ct:
          return u(p, Fr);
        case dt:
          return u(p, Wi);
        case Rt:
          return u(p, qn);
        case Et:
          return u(p, Na);
        case hr:
          return u(p, os);
        case er:
          return u(p, Ua);
        case dr:
          return u(p, fs);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    var T = "function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)}", _ = 'function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}}', V = 'function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())}', Q = T + ';$RS("', Ae = '$RS("', ve = '","', Te = '")<\/script>';
    function $e(p, m, b) {
      l(p, m.startInlineScript), m.sentCompleteSegmentFunction ? l(p, Ae) : (m.sentCompleteSegmentFunction = !0, l(p, Q)), l(p, m.segmentPrefix);
      var C = b.toString(16);
      return l(p, C), l(p, ve), l(p, m.placeholderPrefix), l(p, C), u(p, Te);
    }
    var Bt = _ + ';$RC("', Kt = '$RC("', qt = '","', qr = '")<\/script>';
    function L(p, m, b, C) {
      if (l(p, m.startInlineScript), m.sentCompleteBoundaryFunction ? l(p, Kt) : (m.sentCompleteBoundaryFunction = !0, l(p, Bt)), b === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      var D = C.toString(16);
      return l(p, b), l(p, qt), l(p, m.segmentPrefix), l(p, D), u(p, qr);
    }
    var te = V + ';$RX("', le = '$RX("', Ve = '"', pt = ")<\/script>", _t = ",";
    function Wr(p, m, b, C, D, N) {
      if (l(p, m.startInlineScript), m.sentClientRenderFunction ? l(p, le) : (m.sentClientRenderFunction = !0, l(p, te)), b === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return l(p, b), l(p, Ve), (C || D || N) && (l(p, _t), l(p, ai(C || ""))), (D || N) && (l(p, _t), l(p, ai(D || ""))), N && (l(p, _t), l(p, ai(N))), u(p, pt);
    }
    var Vn = /[<\u2028\u2029]/g;
    function ai(p) {
      var m = JSON.stringify(p);
      return m.replace(Vn, function(b) {
        switch (b) {
          // santizing breaking out of strings and script tags
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw new Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
      });
    }
    function Vi(p, m) {
      var b = Qe(m);
      return {
        // Keep this in sync with ReactDOMServerFormatConfig
        bootstrapChunks: b.bootstrapChunks,
        startInlineScript: b.startInlineScript,
        placeholderPrefix: b.placeholderPrefix,
        segmentPrefix: b.segmentPrefix,
        boundaryPrefix: b.boundaryPrefix,
        idPrefix: b.idPrefix,
        nextSuspenseID: b.nextSuspenseID,
        sentCompleteSegmentFunction: b.sentCompleteSegmentFunction,
        sentCompleteBoundaryFunction: b.sentCompleteBoundaryFunction,
        sentClientRenderFunction: b.sentClientRenderFunction,
        // This is an extra field for the legacy renderer
        generateStaticMarkup: p
      };
    }
    function Dl() {
      return {
        insertionMode: Ct,
        // We skip the root mode because we don't want to emit the DOCTYPE in legacy mode.
        selectedValue: null
      };
    }
    function Pl(p, m, b, C) {
      return b.generateStaticMarkup ? (p.push(ue(m)), !1) : jn(p, m, b, C);
    }
    function Io(p, m, b, C) {
      if (!m.generateStaticMarkup)
        return xn(p, m, b, C);
    }
    function la(p, m) {
      return m.generateStaticMarkup ? !0 : Me(p);
    }
    function va(p, m, b, C, D) {
      return m.generateStaticMarkup ? !0 : Xe(p, m, b, C, D);
    }
    function Gg(p, m) {
      return m.generateStaticMarkup ? !0 : yt(p);
    }
    function qg(p, m) {
      return m.generateStaticMarkup ? !0 : pr(p);
    }
    var Fi = Object.assign, Wg = /* @__PURE__ */ Symbol.for("react.element"), Ud = /* @__PURE__ */ Symbol.for("react.portal"), Rl = /* @__PURE__ */ Symbol.for("react.fragment"), Oi = /* @__PURE__ */ Symbol.for("react.strict_mode"), Vd = /* @__PURE__ */ Symbol.for("react.profiler"), Ol = /* @__PURE__ */ Symbol.for("react.provider"), Bl = /* @__PURE__ */ Symbol.for("react.context"), Ml = /* @__PURE__ */ Symbol.for("react.forward_ref"), _l = /* @__PURE__ */ Symbol.for("react.suspense"), Do = /* @__PURE__ */ Symbol.for("react.suspense_list"), Po = /* @__PURE__ */ Symbol.for("react.memo"), Ns = /* @__PURE__ */ Symbol.for("react.lazy"), dc = /* @__PURE__ */ Symbol.for("react.scope"), hc = /* @__PURE__ */ Symbol.for("react.debug_trace_mode"), pc = /* @__PURE__ */ Symbol.for("react.legacy_hidden"), Nl = /* @__PURE__ */ Symbol.for("react.default_value"), zd = Symbol.iterator, Qg = "@@iterator";
    function Yg(p) {
      if (p === null || typeof p != "object")
        return null;
      var m = zd && p[zd] || p[Qg];
      return typeof m == "function" ? m : null;
    }
    function Xg(p, m, b) {
      var C = p.displayName;
      if (C)
        return C;
      var D = m.displayName || m.name || "";
      return D !== "" ? b + "(" + D + ")" : b;
    }
    function gc(p) {
      return p.displayName || "Context";
    }
    function An(p) {
      if (p == null)
        return null;
      if (typeof p.tag == "number" && i("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof p == "function")
        return p.displayName || p.name || null;
      if (typeof p == "string")
        return p;
      switch (p) {
        case Rl:
          return "Fragment";
        case Ud:
          return "Portal";
        case Vd:
          return "Profiler";
        case Oi:
          return "StrictMode";
        case _l:
          return "Suspense";
        case Do:
          return "SuspenseList";
      }
      if (typeof p == "object")
        switch (p.$$typeof) {
          case Bl:
            var m = p;
            return gc(m) + ".Consumer";
          case Ol:
            var b = p;
            return gc(b._context) + ".Provider";
          case Ml:
            return Xg(p, p.render, "ForwardRef");
          case Po:
            var C = p.displayName || null;
            return C !== null ? C : An(p.type) || "Memo";
          case Ns: {
            var D = p, N = D._payload, H = D._init;
            try {
              return An(H(N));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Ro = 0, $d, mc, dn, Ls, vc, yc, Ac;
    function bc() {
    }
    bc.__reactDisabledLog = !0;
    function Hd() {
      {
        if (Ro === 0) {
          $d = console.log, mc = console.info, dn = console.warn, Ls = console.error, vc = console.group, yc = console.groupCollapsed, Ac = console.groupEnd;
          var p = {
            configurable: !0,
            enumerable: !0,
            value: bc,
            writable: !0
          };
          Object.defineProperties(console, {
            info: p,
            log: p,
            warn: p,
            error: p,
            group: p,
            groupCollapsed: p,
            groupEnd: p
          });
        }
        Ro++;
      }
    }
    function jd() {
      {
        if (Ro--, Ro === 0) {
          var p = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Fi({}, p, {
              value: $d
            }),
            info: Fi({}, p, {
              value: mc
            }),
            warn: Fi({}, p, {
              value: dn
            }),
            error: Fi({}, p, {
              value: Ls
            }),
            group: Fi({}, p, {
              value: vc
            }),
            groupCollapsed: Fi({}, p, {
              value: yc
            }),
            groupEnd: Fi({}, p, {
              value: Ac
            })
          });
        }
        Ro < 0 && i("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ll = t.ReactCurrentDispatcher, Ul;
    function Oo(p, m, b) {
      {
        if (Ul === void 0)
          try {
            throw Error();
          } catch (D) {
            var C = D.stack.trim().match(/\n( *(at )?)/);
            Ul = C && C[1] || "";
          }
        return `
` + Ul + p;
      }
    }
    var wc = !1, Us;
    {
      var xc = typeof WeakMap == "function" ? WeakMap : Map;
      Us = new xc();
    }
    function ds(p, m) {
      if (!p || wc)
        return "";
      {
        var b = Us.get(p);
        if (b !== void 0)
          return b;
      }
      var C;
      wc = !0;
      var D = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var N;
      N = Ll.current, Ll.current = null, Hd();
      try {
        if (m) {
          var H = function() {
            throw Error();
          };
          if (Object.defineProperty(H.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(H, []);
            } catch (si) {
              C = si;
            }
            Reflect.construct(p, [], H);
          } else {
            try {
              H.call();
            } catch (si) {
              C = si;
            }
            p.call(H.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (si) {
            C = si;
          }
          p();
        }
      } catch (si) {
        if (si && C && typeof si.stack == "string") {
          for (var ne = si.stack.split(`
`), ge = C.stack.split(`
`), Pe = ne.length - 1, Ne = ge.length - 1; Pe >= 1 && Ne >= 0 && ne[Pe] !== ge[Ne]; )
            Ne--;
          for (; Pe >= 1 && Ne >= 0; Pe--, Ne--)
            if (ne[Pe] !== ge[Ne]) {
              if (Pe !== 1 || Ne !== 1)
                do
                  if (Pe--, Ne--, Ne < 0 || ne[Pe] !== ge[Ne]) {
                    var Ze = `
` + ne[Pe].replace(" at new ", " at ");
                    return p.displayName && Ze.includes("<anonymous>") && (Ze = Ze.replace("<anonymous>", p.displayName)), typeof p == "function" && Us.set(p, Ze), Ze;
                  }
                while (Pe >= 1 && Ne >= 0);
              break;
            }
        }
      } finally {
        wc = !1, Ll.current = N, jd(), Error.prepareStackTrace = D;
      }
      var Vt = p ? p.displayName || p.name : "", Dr = Vt ? Oo(Vt) : "";
      return typeof p == "function" && Us.set(p, Dr), Dr;
    }
    function Cc(p, m, b) {
      return ds(p, !0);
    }
    function Bo(p, m, b) {
      return ds(p, !1);
    }
    function Jg(p) {
      var m = p.prototype;
      return !!(m && m.isReactComponent);
    }
    function Mo(p, m, b) {
      if (p == null)
        return "";
      if (typeof p == "function")
        return ds(p, Jg(p));
      if (typeof p == "string")
        return Oo(p);
      switch (p) {
        case _l:
          return Oo("Suspense");
        case Do:
          return Oo("SuspenseList");
      }
      if (typeof p == "object")
        switch (p.$$typeof) {
          case Ml:
            return Bo(p.render);
          case Po:
            return Mo(p.type, m, b);
          case Ns: {
            var C = p, D = C._payload, N = C._init;
            try {
              return Mo(N(D), m, b);
            } catch {
            }
          }
        }
      return "";
    }
    var Gd = {}, Sc = t.ReactDebugCurrentFrame;
    function Vl(p) {
      if (p) {
        var m = p._owner, b = Mo(p.type, p._source, m ? m.type : null);
        Sc.setExtraStackFrame(b);
      } else
        Sc.setExtraStackFrame(null);
    }
    function zl(p, m, b, C, D) {
      {
        var N = Function.call.bind(S);
        for (var H in p)
          if (N(p, H)) {
            var ne = void 0;
            try {
              if (typeof p[H] != "function") {
                var ge = Error((C || "React class") + ": " + b + " type `" + H + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof p[H] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ge.name = "Invariant Violation", ge;
              }
              ne = p[H](m, H, C, b, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Pe) {
              ne = Pe;
            }
            ne && !(ne instanceof Error) && (Vl(D), i("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", C || "React class", b, H, typeof ne), Vl(null)), ne instanceof Error && !(ne.message in Gd) && (Gd[ne.message] = !0, Vl(D), i("Failed %s type: %s", b, ne.message), Vl(null));
          }
      }
    }
    var $l;
    $l = {};
    var _o = {};
    Object.freeze(_o);
    function No(p, m) {
      {
        var b = p.contextTypes;
        if (!b)
          return _o;
        var C = {};
        for (var D in b)
          C[D] = m[D];
        {
          var N = An(p) || "Unknown";
          zl(b, C, "context", N);
        }
        return C;
      }
    }
    function qd(p, m, b, C) {
      {
        if (typeof p.getChildContext != "function") {
          {
            var D = An(m) || "Unknown";
            $l[D] || ($l[D] = !0, i("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", D, D));
          }
          return b;
        }
        var N = p.getChildContext();
        for (var H in N)
          if (!(H in C))
            throw new Error((An(m) || "Unknown") + '.getChildContext(): key "' + H + '" is not defined in childContextTypes.');
        {
          var ne = An(m) || "Unknown";
          zl(C, N, "child context", ne);
        }
        return Fi({}, b, N);
      }
    }
    var hs;
    hs = {};
    var Hl = null, Va = null;
    function Ec(p) {
      p.context._currentValue2 = p.parentValue;
    }
    function ps(p) {
      p.context._currentValue2 = p.value;
    }
    function jl(p, m) {
      if (p !== m) {
        Ec(p);
        var b = p.parent, C = m.parent;
        if (b === null) {
          if (C !== null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
        } else {
          if (C === null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
          jl(b, C);
        }
        ps(m);
      }
    }
    function za(p) {
      Ec(p);
      var m = p.parent;
      m !== null && za(m);
    }
    function Gl(p) {
      var m = p.parent;
      m !== null && Gl(m), ps(p);
    }
    function ql(p, m) {
      Ec(p);
      var b = p.parent;
      if (b === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      b.depth === m.depth ? jl(b, m) : ql(b, m);
    }
    function Lo(p, m) {
      var b = m.parent;
      if (b === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      p.depth === b.depth ? jl(p, b) : Lo(p, b), ps(m);
    }
    function Uo(p) {
      var m = Va, b = p;
      m !== b && (m === null ? Gl(b) : b === null ? za(m) : m.depth === b.depth ? jl(m, b) : m.depth > b.depth ? ql(m, b) : Lo(m, b), Va = b);
    }
    function Wd(p, m) {
      var b;
      b = p._currentValue2, p._currentValue2 = m, p._currentRenderer2 !== void 0 && p._currentRenderer2 !== null && p._currentRenderer2 !== hs && i("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), p._currentRenderer2 = hs;
      var C = Va, D = {
        parent: C,
        depth: C === null ? 0 : C.depth + 1,
        context: p,
        parentValue: b,
        value: m
      };
      return Va = D, D;
    }
    function Qd(p) {
      var m = Va;
      if (m === null)
        throw new Error("Tried to pop a Context at the root of the app. This is a bug in React.");
      m.context !== p && i("The parent context is not the expected context. This is probably a bug in React.");
      {
        var b = m.parentValue;
        b === Nl ? m.context._currentValue2 = m.context._defaultValue : m.context._currentValue2 = b, p._currentRenderer2 !== void 0 && p._currentRenderer2 !== null && p._currentRenderer2 !== hs && i("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), p._currentRenderer2 = hs;
      }
      return Va = m.parent;
    }
    function Yd() {
      return Va;
    }
    function $a(p) {
      var m = p._currentValue2;
      return m;
    }
    function kc(p) {
      return p._reactInternals;
    }
    function Kg(p, m) {
      p._reactInternals = m;
    }
    var Xd = {}, Vs = {}, Vo, Tc, Wl, Ql, Yl, zs, zo, $o, Xl;
    {
      Vo = /* @__PURE__ */ new Set(), Tc = /* @__PURE__ */ new Set(), Wl = /* @__PURE__ */ new Set(), zo = /* @__PURE__ */ new Set(), Ql = /* @__PURE__ */ new Set(), $o = /* @__PURE__ */ new Set(), Xl = /* @__PURE__ */ new Set();
      var Ho = /* @__PURE__ */ new Set();
      zs = function(p, m) {
        if (!(p === null || typeof p == "function")) {
          var b = m + "_" + p;
          Ho.has(b) || (Ho.add(b), i("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", m, p));
        }
      }, Yl = function(p, m) {
        if (m === void 0) {
          var b = An(p) || "Component";
          Ql.has(b) || (Ql.add(b), i("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", b));
        }
      };
    }
    function Jl(p, m) {
      {
        var b = p.constructor, C = b && An(b) || "ReactClass", D = C + "." + m;
        if (Xd[D])
          return;
        i(`%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.

Please check the code for the %s component.`, m, m, C), Xd[D] = !0;
      }
    }
    var Kl = {
      isMounted: function(p) {
        return !1;
      },
      enqueueSetState: function(p, m, b) {
        var C = kc(p);
        C.queue === null ? Jl(p, "setState") : (C.queue.push(m), b != null && zs(b, "setState"));
      },
      enqueueReplaceState: function(p, m, b) {
        var C = kc(p);
        C.replace = !0, C.queue = [m], b != null && zs(b, "setState");
      },
      enqueueForceUpdate: function(p, m) {
        var b = kc(p);
        b.queue === null ? Jl(p, "forceUpdate") : m != null && zs(m, "setState");
      }
    };
    function Fc(p, m, b, C, D) {
      var N = b(D, C);
      Yl(m, N);
      var H = N == null ? C : Fi({}, C, N);
      return H;
    }
    function Jd(p, m, b) {
      var C = _o, D = p.contextType;
      if ("contextType" in p) {
        var N = (
          // Allow null for conditional declaration
          D === null || D !== void 0 && D.$$typeof === Bl && D._context === void 0
        );
        if (!N && !Xl.has(p)) {
          Xl.add(p);
          var H = "";
          D === void 0 ? H = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof D != "object" ? H = " However, it is set to a " + typeof D + "." : D.$$typeof === Ol ? H = " Did you accidentally pass the Context.Provider instead?" : D._context !== void 0 ? H = " Did you accidentally pass the Context.Consumer instead?" : H = " However, it is set to an object with keys {" + Object.keys(D).join(", ") + "}.", i("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", An(p) || "Component", H);
        }
      }
      typeof D == "object" && D !== null ? C = $a(D) : C = b;
      var ne = new p(m, C);
      {
        if (typeof p.getDerivedStateFromProps == "function" && (ne.state === null || ne.state === void 0)) {
          var ge = An(p) || "Component";
          Vo.has(ge) || (Vo.add(ge), i("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", ge, ne.state === null ? "null" : "undefined", ge));
        }
        if (typeof p.getDerivedStateFromProps == "function" || typeof ne.getSnapshotBeforeUpdate == "function") {
          var Pe = null, Ne = null, Ze = null;
          if (typeof ne.componentWillMount == "function" && ne.componentWillMount.__suppressDeprecationWarning !== !0 ? Pe = "componentWillMount" : typeof ne.UNSAFE_componentWillMount == "function" && (Pe = "UNSAFE_componentWillMount"), typeof ne.componentWillReceiveProps == "function" && ne.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? Ne = "componentWillReceiveProps" : typeof ne.UNSAFE_componentWillReceiveProps == "function" && (Ne = "UNSAFE_componentWillReceiveProps"), typeof ne.componentWillUpdate == "function" && ne.componentWillUpdate.__suppressDeprecationWarning !== !0 ? Ze = "componentWillUpdate" : typeof ne.UNSAFE_componentWillUpdate == "function" && (Ze = "UNSAFE_componentWillUpdate"), Pe !== null || Ne !== null || Ze !== null) {
            var Vt = An(p) || "Component", Dr = typeof p.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            Wl.has(Vt) || (Wl.add(Vt), i(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, Vt, Dr, Pe !== null ? `
  ` + Pe : "", Ne !== null ? `
  ` + Ne : "", Ze !== null ? `
  ` + Ze : ""));
          }
        }
      }
      return ne;
    }
    function Kd(p, m, b) {
      {
        var C = An(m) || "Component", D = p.render;
        D || (m.prototype && typeof m.prototype.render == "function" ? i("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", C) : i("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", C)), p.getInitialState && !p.getInitialState.isReactClassApproved && !p.state && i("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", C), p.getDefaultProps && !p.getDefaultProps.isReactClassApproved && i("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", C), p.propTypes && i("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", C), p.contextType && i("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", C), p.contextTypes && i("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", C), m.contextType && m.contextTypes && !$o.has(m) && ($o.add(m), i("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", C)), typeof p.componentShouldUpdate == "function" && i("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", C), m.prototype && m.prototype.isPureReactComponent && typeof p.shouldComponentUpdate < "u" && i("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", An(m) || "A pure component"), typeof p.componentDidUnmount == "function" && i("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", C), typeof p.componentDidReceiveProps == "function" && i("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", C), typeof p.componentWillRecieveProps == "function" && i("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", C), typeof p.UNSAFE_componentWillRecieveProps == "function" && i("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", C);
        var N = p.props !== b;
        p.props !== void 0 && N && i("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", C, C), p.defaultProps && i("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", C, C), typeof p.getSnapshotBeforeUpdate == "function" && typeof p.componentDidUpdate != "function" && !Tc.has(m) && (Tc.add(m), i("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", An(m))), typeof p.getDerivedStateFromProps == "function" && i("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", C), typeof p.getDerivedStateFromError == "function" && i("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", C), typeof m.getSnapshotBeforeUpdate == "function" && i("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", C);
        var H = p.state;
        H && (typeof H != "object" || K(H)) && i("%s.state: must be set to an object or null", C), typeof p.getChildContext == "function" && typeof m.childContextTypes != "object" && i("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", C);
      }
    }
    function Zd(p, m) {
      var b = m.state;
      if (typeof m.componentWillMount == "function") {
        if (m.componentWillMount.__suppressDeprecationWarning !== !0) {
          var C = An(p) || "Unknown";
          Vs[C] || (n(
            // keep this warning in sync with ReactStrictModeWarning.js
            `componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.

Please update the following components: %s`,
            C
          ), Vs[C] = !0);
        }
        m.componentWillMount();
      }
      typeof m.UNSAFE_componentWillMount == "function" && m.UNSAFE_componentWillMount(), b !== m.state && (i("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", An(p) || "Component"), Kl.enqueueReplaceState(m, m.state, null));
    }
    function Zg(p, m, b, C) {
      if (p.queue !== null && p.queue.length > 0) {
        var D = p.queue, N = p.replace;
        if (p.queue = null, p.replace = !1, N && D.length === 1)
          m.state = D[0];
        else {
          for (var H = N ? D[0] : m.state, ne = !0, ge = N ? 1 : 0; ge < D.length; ge++) {
            var Pe = D[ge], Ne = typeof Pe == "function" ? Pe.call(m, H, b, C) : Pe;
            Ne != null && (ne ? (ne = !1, H = Fi({}, H, Ne)) : Fi(H, Ne));
          }
          m.state = H;
        }
      } else
        p.queue = null;
    }
    function eh(p, m, b, C) {
      Kd(p, m, b);
      var D = p.state !== void 0 ? p.state : null;
      p.updater = Kl, p.props = b, p.state = D;
      var N = {
        queue: [],
        replace: !1
      };
      Kg(p, N);
      var H = m.contextType;
      if (typeof H == "object" && H !== null ? p.context = $a(H) : p.context = C, p.state === b) {
        var ne = An(m) || "Component";
        zo.has(ne) || (zo.add(ne), i("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", ne));
      }
      var ge = m.getDerivedStateFromProps;
      typeof ge == "function" && (p.state = Fc(p, m, ge, D, b)), typeof m.getDerivedStateFromProps != "function" && typeof p.getSnapshotBeforeUpdate != "function" && (typeof p.UNSAFE_componentWillMount == "function" || typeof p.componentWillMount == "function") && (Zd(m, p), Zg(N, p, b, C));
    }
    var em = {
      id: 1,
      overflow: ""
    };
    function tm(p) {
      var m = p.overflow, b = p.id, C = b & ~rm(b);
      return C.toString(32) + m;
    }
    function Ic(p, m, b) {
      var C = p.id, D = p.overflow, N = jo(C) - 1, H = C & ~(1 << N), ne = b + 1, ge = jo(m) + N;
      if (ge > 30) {
        var Pe = N - N % 5, Ne = (1 << Pe) - 1, Ze = (H & Ne).toString(32), Vt = H >> Pe, Dr = N - Pe, si = jo(m) + Dr, ws = ne << Dr, xs = ws | Vt, xa = Ze + D;
        return {
          id: 1 << si | xs,
          overflow: xa
        };
      } else {
        var Qs = ne << N, Bm = Qs | H, WI = D;
        return {
          id: 1 << ge | Bm,
          overflow: WI
        };
      }
    }
    function jo(p) {
      return 32 - nm(p);
    }
    function rm(p) {
      return 1 << jo(p) - 1;
    }
    var nm = Math.clz32 ? Math.clz32 : im, Dc = Math.log, Zl = Math.LN2;
    function im(p) {
      var m = p >>> 0;
      return m === 0 ? 32 : 31 - (Dc(m) / Zl | 0) | 0;
    }
    function am(p, m) {
      return p === m && (p !== 0 || 1 / p === 1 / m) || p !== p && m !== m;
    }
    var sm = typeof Object.is == "function" ? Object.is : am, ya = null, Pc = null, eu = null, ln = null, Bi = !1, $s = !1, gs = 0, Ir = null, Ha = 0, tu = 25, Mi = !1, _i;
    function ua() {
      if (ya === null)
        throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
      return Mi && i("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks"), ya;
    }
    function om(p, m) {
      if (m === null)
        return i("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", _i), !1;
      p.length !== m.length && i(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, _i, "[" + p.join(", ") + "]", "[" + m.join(", ") + "]");
      for (var b = 0; b < m.length && b < p.length; b++)
        if (!sm(p[b], m[b]))
          return !1;
      return !0;
    }
    function Xi() {
      if (Ha > 0)
        throw new Error("Rendered more hooks than during the previous render");
      return {
        memoizedState: null,
        queue: null,
        next: null
      };
    }
    function ja() {
      return ln === null ? eu === null ? (Bi = !1, eu = ln = Xi()) : (Bi = !0, ln = eu) : ln.next === null ? (Bi = !1, ln = ln.next = Xi()) : (Bi = !0, ln = ln.next), ln;
    }
    function ms(p, m) {
      ya = m, Pc = p, Mi = !1, gs = 0;
    }
    function lm(p, m, b, C) {
      for (; $s; )
        $s = !1, gs = 0, Ha += 1, ln = null, b = p(m, C);
      return Go(), b;
    }
    function Rc() {
      var p = gs !== 0;
      return p;
    }
    function Go() {
      Mi = !1, ya = null, Pc = null, $s = !1, eu = null, Ha = 0, Ir = null, ln = null;
    }
    function um(p) {
      return Mi && i("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."), $a(p);
    }
    function cm(p) {
      return _i = "useContext", ua(), $a(p);
    }
    function ru(p, m) {
      return typeof m == "function" ? m(p) : m;
    }
    function Oc(p) {
      return _i = "useState", th(
        ru,
        // useReducer has a special case to support lazy useState initializers
        p
      );
    }
    function th(p, m, b) {
      if (p !== ru && (_i = "useReducer"), ya = ua(), ln = ja(), Bi) {
        var C = ln.queue, D = C.dispatch;
        if (Ir !== null) {
          var N = Ir.get(C);
          if (N !== void 0) {
            Ir.delete(C);
            var H = ln.memoizedState, ne = N;
            do {
              var ge = ne.action;
              Mi = !0, H = p(H, ge), Mi = !1, ne = ne.next;
            } while (ne !== null);
            return ln.memoizedState = H, [H, D];
          }
        }
        return [ln.memoizedState, D];
      } else {
        Mi = !0;
        var Pe;
        p === ru ? Pe = typeof m == "function" ? m() : m : Pe = b !== void 0 ? b(m) : m, Mi = !1, ln.memoizedState = Pe;
        var Ne = ln.queue = {
          last: null,
          dispatch: null
        }, Ze = Ne.dispatch = nh.bind(null, ya, Ne);
        return [ln.memoizedState, Ze];
      }
    }
    function rh(p, m) {
      ya = ua(), ln = ja();
      var b = m === void 0 ? null : m;
      if (ln !== null) {
        var C = ln.memoizedState;
        if (C !== null && b !== null) {
          var D = C[1];
          if (om(b, D))
            return C[0];
        }
      }
      Mi = !0;
      var N = p();
      return Mi = !1, ln.memoizedState = [N, b], N;
    }
    function Bc(p) {
      ya = ua(), ln = ja();
      var m = ln.memoizedState;
      if (m === null) {
        var b = {
          current: p
        };
        return Object.seal(b), ln.memoizedState = b, b;
      } else
        return m;
    }
    function fm(p, m) {
      _i = "useLayoutEffect", i("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://reactjs.org/link/uselayouteffect-ssr for common fixes.");
    }
    function nh(p, m, b) {
      if (Ha >= tu)
        throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
      if (p === ya) {
        $s = !0;
        var C = {
          action: b,
          next: null
        };
        Ir === null && (Ir = /* @__PURE__ */ new Map());
        var D = Ir.get(m);
        if (D === void 0)
          Ir.set(m, C);
        else {
          for (var N = D; N.next !== null; )
            N = N.next;
          N.next = C;
        }
      }
    }
    function ih(p, m) {
      return rh(function() {
        return p;
      }, m);
    }
    function dm(p, m, b) {
      return ua(), m(p._source);
    }
    function hm(p, m, b) {
      if (b === void 0)
        throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
      return b();
    }
    function pm(p) {
      return ua(), p;
    }
    function gm() {
      throw new Error("startTransition cannot be called during server rendering.");
    }
    function mm() {
      return ua(), [!1, gm];
    }
    function vm() {
      var p = Pc, m = tm(p.treeContext), b = Mc;
      if (b === null)
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component.");
      var C = gs++;
      return xr(b, m, C);
    }
    function nu() {
    }
    var ah = {
      readContext: um,
      useContext: cm,
      useMemo: rh,
      useReducer: th,
      useRef: Bc,
      useState: Oc,
      useInsertionEffect: nu,
      useLayoutEffect: fm,
      useCallback: ih,
      // useImperativeHandle is not run in the server environment
      useImperativeHandle: nu,
      // Effects are not run in the server environment.
      useEffect: nu,
      // Debugging effect
      useDebugValue: nu,
      useDeferredValue: pm,
      useTransition: mm,
      useId: vm,
      // Subscriptions are not setup in a server environment.
      useMutableSource: dm,
      useSyncExternalStore: hm
    }, Mc = null;
    function sh(p) {
      Mc = p;
    }
    function iu(p) {
      try {
        var m = "", b = p;
        do {
          switch (b.tag) {
            case 0:
              m += Oo(b.type, null, null);
              break;
            case 1:
              m += Bo(b.type, null, null);
              break;
            case 2:
              m += Cc(b.type, null, null);
              break;
          }
          b = b.parent;
        } while (b);
        return m;
      } catch (C) {
        return `
Error generating stack: ` + C.message + `
` + C.stack;
      }
    }
    var au = t.ReactCurrentDispatcher, qo = t.ReactDebugCurrentFrame, su = 0, Hs = 1, ou = 2, lu = 3, uu = 4, js = 0, _c = 1, vs = 2, oh = 12800;
    function ym(p) {
      return console.error(p), null;
    }
    function Gs() {
    }
    function qs(p, m, b, C, D, N, H, ne, ge) {
      var Pe = [], Ne = /* @__PURE__ */ new Set(), Ze = {
        destination: null,
        responseState: m,
        progressiveChunkSize: C === void 0 ? oh : C,
        status: js,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: Ne,
        pingedTasks: Pe,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: D === void 0 ? ym : D,
        onAllReady: Gs,
        onShellReady: H === void 0 ? Gs : H,
        onShellError: Gs,
        onFatalError: Gs
      }, Vt = cu(
        Ze,
        0,
        null,
        b,
        // Root segments are never embedded in Text on either edge
        !1,
        !1
      );
      Vt.parentFlushed = !0;
      var Dr = ys(Ze, p, null, Vt, Ne, _o, Hl, em);
      return Pe.push(Dr), Ze;
    }
    function Am(p, m) {
      var b = p.pingedTasks;
      b.push(m), b.length === 1 && s(function() {
        return qc(p);
      });
    }
    function bm(p, m) {
      return {
        id: Fn,
        rootSegmentID: -1,
        parentFlushed: !1,
        pendingTasks: 0,
        forceClientRender: !1,
        completedSegments: [],
        byteSize: 0,
        fallbackAbortableTasks: m,
        errorDigest: null
      };
    }
    function ys(p, m, b, C, D, N, H, ne) {
      p.allPendingTasks++, b === null ? p.pendingRootTasks++ : b.pendingTasks++;
      var ge = {
        node: m,
        ping: function() {
          return Am(p, ge);
        },
        blockedBoundary: b,
        blockedSegment: C,
        abortSet: D,
        legacyContext: N,
        context: H,
        treeContext: ne
      };
      return ge.componentStack = null, D.add(ge), ge;
    }
    function cu(p, m, b, C, D, N) {
      return {
        status: su,
        id: -1,
        // lazily assigned later
        index: m,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: C,
        boundary: b,
        lastPushedText: D,
        textEmbedded: N
      };
    }
    var Aa = null;
    function Nc() {
      return Aa === null || Aa.componentStack === null ? "" : iu(Aa.componentStack);
    }
    function As(p, m) {
      p.componentStack = {
        tag: 0,
        parent: p.componentStack,
        type: m
      };
    }
    function Wo(p, m) {
      p.componentStack = {
        tag: 1,
        parent: p.componentStack,
        type: m
      };
    }
    function ba(p, m) {
      p.componentStack = {
        tag: 2,
        parent: p.componentStack,
        type: m
      };
    }
    function ca(p) {
      p.componentStack === null ? i("Unexpectedly popped too many stack frames. This is a bug in React.") : p.componentStack = p.componentStack.parent;
    }
    var wa = null;
    function fu(p, m) {
      {
        var b;
        typeof m == "string" ? b = m : m && typeof m.message == "string" ? b = m.message : b = String(m);
        var C = wa || Nc();
        wa = null, p.errorMessage = b, p.errorComponentStack = C;
      }
    }
    function Qo(p, m) {
      var b = p.onError(m);
      if (b != null && typeof b != "string")
        throw new Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof b + '" instead');
      return b;
    }
    function Ji(p, m) {
      var b = p.onShellError;
      b(m);
      var C = p.onFatalError;
      C(m), p.destination !== null ? (p.status = vs, g(p.destination, m)) : (p.status = _c, p.fatalError = m);
    }
    function Yo(p, m, b) {
      As(m, "Suspense");
      var C = m.blockedBoundary, D = m.blockedSegment, N = b.fallback, H = b.children, ne = /* @__PURE__ */ new Set(), ge = bm(p, ne), Pe = D.chunks.length, Ne = cu(
        p,
        Pe,
        ge,
        D.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      D.children.push(Ne), D.lastPushedText = !1;
      var Ze = cu(
        p,
        0,
        null,
        D.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      Ze.parentFlushed = !0, m.blockedBoundary = ge, m.blockedSegment = Ze;
      try {
        if (wi(p, m, H), Io(Ze.chunks, p.responseState, Ze.lastPushedText, Ze.textEmbedded), Ze.status = Hs, Ws(ge, Ze), ge.pendingTasks === 0) {
          ca(m);
          return;
        }
      } catch (Dr) {
        Ze.status = uu, ge.forceClientRender = !0, ge.errorDigest = Qo(p, Dr), fu(ge, Dr);
      } finally {
        m.blockedBoundary = C, m.blockedSegment = D;
      }
      var Vt = ys(p, N, C, Ne, ne, m.legacyContext, m.context, m.treeContext);
      Vt.componentStack = m.componentStack, p.pingedTasks.push(Vt), ca(m);
    }
    function Lc(p, m, b, C) {
      As(m, b);
      var D = m.blockedSegment, N = Un(D.chunks, b, C, p.responseState, D.formatContext);
      D.lastPushedText = !1;
      var H = D.formatContext;
      D.formatContext = On(H, b, C), wi(p, m, N), D.formatContext = H, lr(D.chunks, b), D.lastPushedText = !1, ca(m);
    }
    function Xo(p) {
      return p.prototype && p.prototype.isReactComponent;
    }
    function Jo(p, m, b, C, D) {
      var N = {};
      ms(m, N);
      var H = b(C, D);
      return lm(b, C, H, D);
    }
    function lh(p, m, b, C, D) {
      var N = b.render();
      b.props !== D && (Vc || i("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", An(C) || "a component"), Vc = !0);
      {
        var H = C.childContextTypes;
        if (H != null) {
          var ne = m.legacyContext, ge = qd(b, C, ne, H);
          m.legacyContext = ge, Ni(p, m, N), m.legacyContext = ne;
          return;
        }
      }
      Ni(p, m, N);
    }
    function wm(p, m, b, C) {
      ba(m, b);
      var D = No(b, m.legacyContext), N = Jd(b, C, D);
      eh(N, b, C, D), lh(p, m, N, b, C), ca(m);
    }
    var uh = {}, Ko = {}, Uc = {}, ch = {}, Vc = !1, Zo = {}, zc = !1, $c = !1, Hc = !1;
    function fh(p, m, b, C) {
      var D;
      if (D = No(b, m.legacyContext), Wo(m, b), b.prototype && typeof b.prototype.render == "function") {
        var N = An(b) || "Unknown";
        uh[N] || (i("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", N, N), uh[N] = !0);
      }
      var H = Jo(p, m, b, C, D), ne = Rc();
      if (typeof H == "object" && H !== null && typeof H.render == "function" && H.$$typeof === void 0) {
        var ge = An(b) || "Unknown";
        Ko[ge] || (i("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", ge, ge, ge), Ko[ge] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof H == "object" && H !== null && typeof H.render == "function" && H.$$typeof === void 0
      ) {
        {
          var Pe = An(b) || "Unknown";
          Ko[Pe] || (i("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", Pe, Pe, Pe), Ko[Pe] = !0);
        }
        eh(H, b, C, D), lh(p, m, H, b, C);
      } else if (dh(b), ne) {
        var Ne = m.treeContext, Ze = 1, Vt = 0;
        m.treeContext = Ic(Ne, Ze, Vt);
        try {
          Ni(p, m, H);
        } finally {
          m.treeContext = Ne;
        }
      } else
        Ni(p, m, H);
      ca(m);
    }
    function dh(p) {
      {
        if (p && p.childContextTypes && i("%s(...): childContextTypes cannot be defined on a function component.", p.displayName || p.name || "Component"), p.defaultProps !== void 0) {
          var m = An(p) || "Unknown";
          Zo[m] || (i("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", m), Zo[m] = !0);
        }
        if (typeof p.getDerivedStateFromProps == "function") {
          var b = An(p) || "Unknown";
          ch[b] || (i("%s: Function components do not support getDerivedStateFromProps.", b), ch[b] = !0);
        }
        if (typeof p.contextType == "object" && p.contextType !== null) {
          var C = An(p) || "Unknown";
          Uc[C] || (i("%s: Function components do not support contextType.", C), Uc[C] = !0);
        }
      }
    }
    function jc(p, m) {
      if (p && p.defaultProps) {
        var b = Fi({}, m), C = p.defaultProps;
        for (var D in C)
          b[D] === void 0 && (b[D] = C[D]);
        return b;
      }
      return m;
    }
    function hh(p, m, b, C, D) {
      Wo(m, b.render);
      var N = Jo(p, m, b.render, C, D), H = Rc();
      if (H) {
        var ne = m.treeContext, ge = 1, Pe = 0;
        m.treeContext = Ic(ne, ge, Pe);
        try {
          Ni(p, m, N);
        } finally {
          m.treeContext = ne;
        }
      } else
        Ni(p, m, N);
      ca(m);
    }
    function xm(p, m, b, C, D) {
      var N = b.type, H = jc(N, C);
      Gc(p, m, N, H, D);
    }
    function Cm(p, m, b, C) {
      b._context === void 0 ? b !== b.Consumer && (Hc || (Hc = !0, i("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : b = b._context;
      var D = C.children;
      typeof D != "function" && i("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
      var N = $a(b), H = D(N);
      Ni(p, m, H);
    }
    function ph(p, m, b, C) {
      var D = b._context, N = C.value, H = C.children, ne;
      ne = m.context, m.context = Wd(D, N), Ni(p, m, H), m.context = Qd(D), ne !== m.context && i("Popping the context provider did not return back to the original snapshot. This is a bug in React.");
    }
    function Sm(p, m, b, C, D) {
      As(m, "Lazy");
      var N = b._payload, H = b._init, ne = H(N), ge = jc(ne, C);
      Gc(p, m, ne, ge, D), ca(m);
    }
    function Gc(p, m, b, C, D) {
      if (typeof b == "function")
        if (Xo(b)) {
          wm(p, m, b, C);
          return;
        } else {
          fh(p, m, b, C);
          return;
        }
      if (typeof b == "string") {
        Lc(p, m, b, C);
        return;
      }
      switch (b) {
        // TODO: LegacyHidden acts the same as a fragment. This only works
        // because we currently assume that every instance of LegacyHidden is
        // accompanied by a host component wrapper. In the hidden mode, the host
        // component is given a `hidden` attribute, which ensures that the
        // initial HTML is not visible. To support the use of LegacyHidden as a
        // true fragment, without an extra DOM node, we would have to hide the
        // initial HTML in some other way.
        // TODO: Add REACT_OFFSCREEN_TYPE here too with the same capability.
        case pc:
        case hc:
        case Oi:
        case Vd:
        case Rl: {
          Ni(p, m, C.children);
          return;
        }
        case Do: {
          As(m, "SuspenseList"), Ni(p, m, C.children), ca(m);
          return;
        }
        case dc:
          throw new Error("ReactDOMServer does not yet support scope components.");
        // eslint-disable-next-line-no-fallthrough
        case _l: {
          Yo(p, m, C);
          return;
        }
      }
      if (typeof b == "object" && b !== null)
        switch (b.$$typeof) {
          case Ml: {
            hh(p, m, b, C, D);
            return;
          }
          case Po: {
            xm(p, m, b, C, D);
            return;
          }
          case Ol: {
            ph(p, m, b, C);
            return;
          }
          case Bl: {
            Cm(p, m, b, C);
            return;
          }
          case Ns: {
            Sm(p, m, b, C);
            return;
          }
        }
      var N = "";
      throw (b === void 0 || typeof b == "object" && b !== null && Object.keys(b).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (b == null ? b : typeof b) + "." + N));
    }
    function Em(p, m) {
      typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
      p[Symbol.toStringTag] === "Generator" && (zc || i("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), zc = !0), p.entries === m && ($c || i("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), $c = !0);
    }
    function Ni(p, m, b) {
      try {
        return km(p, m, b);
      } catch (C) {
        throw typeof C == "object" && C !== null && typeof C.then == "function" || (wa = wa !== null ? wa : Nc()), C;
      }
    }
    function km(p, m, b) {
      if (m.node = b, typeof b == "object" && b !== null) {
        switch (b.$$typeof) {
          case Wg: {
            var C = b, D = C.type, N = C.props, H = C.ref;
            Gc(p, m, D, N, H);
            return;
          }
          case Ud:
            throw new Error("Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render.");
          // eslint-disable-next-line-no-fallthrough
          case Ns: {
            var ne = b, ge = ne._payload, Pe = ne._init, Ne;
            try {
              Ne = Pe(ge);
            } catch (Qs) {
              throw typeof Qs == "object" && Qs !== null && typeof Qs.then == "function" && As(m, "Lazy"), Qs;
            }
            Ni(p, m, Ne);
            return;
          }
        }
        if (K(b)) {
          du(p, m, b);
          return;
        }
        var Ze = Yg(b);
        if (Ze) {
          Em(b, Ze);
          var Vt = Ze.call(b);
          if (Vt) {
            var Dr = Vt.next();
            if (!Dr.done) {
              var si = [];
              do
                si.push(Dr.value), Dr = Vt.next();
              while (!Dr.done);
              du(p, m, si);
              return;
            }
            return;
          }
        }
        var ws = Object.prototype.toString.call(b);
        throw new Error("Objects are not valid as a React child (found: " + (ws === "[object Object]" ? "object with keys {" + Object.keys(b).join(", ") + "}" : ws) + "). If you meant to render a collection of children, use an array instead.");
      }
      if (typeof b == "string") {
        var xs = m.blockedSegment;
        xs.lastPushedText = Pl(m.blockedSegment.chunks, b, p.responseState, xs.lastPushedText);
        return;
      }
      if (typeof b == "number") {
        var xa = m.blockedSegment;
        xa.lastPushedText = Pl(m.blockedSegment.chunks, "" + b, p.responseState, xa.lastPushedText);
        return;
      }
      typeof b == "function" && i("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function du(p, m, b) {
      for (var C = b.length, D = 0; D < C; D++) {
        var N = m.treeContext;
        m.treeContext = Ic(N, C, D);
        try {
          wi(p, m, b[D]);
        } finally {
          m.treeContext = N;
        }
      }
    }
    function Tm(p, m, b) {
      var C = m.blockedSegment, D = C.chunks.length, N = cu(
        p,
        D,
        null,
        C.formatContext,
        // Adopt the parent segment's leading text embed
        C.lastPushedText,
        // Assume we are text embedded at the trailing edge
        !0
      );
      C.children.push(N), C.lastPushedText = !1;
      var H = ys(p, m.node, m.blockedBoundary, N, m.abortSet, m.legacyContext, m.context, m.treeContext);
      m.componentStack !== null && (H.componentStack = m.componentStack.parent);
      var ne = H.ping;
      b.then(ne, ne);
    }
    function wi(p, m, b) {
      var C = m.blockedSegment.formatContext, D = m.legacyContext, N = m.context, H = null;
      H = m.componentStack;
      try {
        return Ni(p, m, b);
      } catch (ne) {
        if (Go(), typeof ne == "object" && ne !== null && typeof ne.then == "function") {
          Tm(p, m, ne), m.blockedSegment.formatContext = C, m.legacyContext = D, m.context = N, Uo(N), m.componentStack = H;
          return;
        } else
          throw m.blockedSegment.formatContext = C, m.legacyContext = D, m.context = N, Uo(N), m.componentStack = H, ne;
      }
    }
    function Fm(p, m, b, C) {
      var D = Qo(p, C);
      if (m === null ? Ji(p, C) : (m.pendingTasks--, m.forceClientRender || (m.forceClientRender = !0, m.errorDigest = D, fu(m, C), m.parentFlushed && p.clientRenderedBoundaries.push(m))), p.allPendingTasks--, p.allPendingTasks === 0) {
        var N = p.onAllReady;
        N();
      }
    }
    function gh(p) {
      var m = this, b = p.blockedBoundary, C = p.blockedSegment;
      C.status = lu, vh(m, b, C);
    }
    function mh(p, m, b) {
      var C = p.blockedBoundary, D = p.blockedSegment;
      if (D.status = lu, C === null)
        m.allPendingTasks--, m.status !== vs && (m.status = vs, m.destination !== null && d(m.destination));
      else {
        if (C.pendingTasks--, !C.forceClientRender) {
          C.forceClientRender = !0;
          var N = b === void 0 ? new Error("The render was aborted by the server without a reason.") : b;
          C.errorDigest = m.onError(N);
          {
            var H = "The server did not finish this Suspense boundary: ";
            N && typeof N.message == "string" ? N = H + N.message : N = H + String(N);
            var ne = Aa;
            Aa = p;
            try {
              fu(C, N);
            } finally {
              Aa = ne;
            }
          }
          C.parentFlushed && m.clientRenderedBoundaries.push(C);
        }
        if (C.fallbackAbortableTasks.forEach(function(Pe) {
          return mh(Pe, m, b);
        }), C.fallbackAbortableTasks.clear(), m.allPendingTasks--, m.allPendingTasks === 0) {
          var ge = m.onAllReady;
          ge();
        }
      }
    }
    function Ws(p, m) {
      if (m.chunks.length === 0 && m.children.length === 1 && m.children[0].boundary === null) {
        var b = m.children[0];
        b.id = m.id, b.parentFlushed = !0, b.status === Hs && Ws(p, b);
      } else {
        var C = p.completedSegments;
        C.push(m);
      }
    }
    function vh(p, m, b) {
      if (m === null) {
        if (b.parentFlushed) {
          if (p.completedRootSegment !== null)
            throw new Error("There can only be one root segment. This is a bug in React.");
          p.completedRootSegment = b;
        }
        if (p.pendingRootTasks--, p.pendingRootTasks === 0) {
          p.onShellError = Gs;
          var C = p.onShellReady;
          C();
        }
      } else if (m.pendingTasks--, !m.forceClientRender) {
        if (m.pendingTasks === 0)
          b.parentFlushed && b.status === Hs && Ws(m, b), m.parentFlushed && p.completedBoundaries.push(m), m.fallbackAbortableTasks.forEach(gh, p), m.fallbackAbortableTasks.clear();
        else if (b.parentFlushed && b.status === Hs) {
          Ws(m, b);
          var D = m.completedSegments;
          D.length === 1 && m.parentFlushed && p.partialBoundaries.push(m);
        }
      }
      if (p.allPendingTasks--, p.allPendingTasks === 0) {
        var N = p.onAllReady;
        N();
      }
    }
    function Im(p, m) {
      var b = m.blockedSegment;
      if (b.status === su) {
        Uo(m.context);
        var C = null;
        C = Aa, Aa = m;
        try {
          Ni(p, m, m.node), Io(b.chunks, p.responseState, b.lastPushedText, b.textEmbedded), m.abortSet.delete(m), b.status = Hs, vh(p, m.blockedBoundary, b);
        } catch (N) {
          if (Go(), typeof N == "object" && N !== null && typeof N.then == "function") {
            var D = m.ping;
            N.then(D, D);
          } else
            m.abortSet.delete(m), b.status = uu, Fm(p, m.blockedBoundary, b, N);
        } finally {
          Aa = C;
        }
      }
    }
    function qc(p) {
      if (p.status !== vs) {
        var m = Yd(), b = au.current;
        au.current = ah;
        var C;
        C = qo.getCurrentStack, qo.getCurrentStack = Nc;
        var D = Mc;
        sh(p.responseState);
        try {
          var N = p.pingedTasks, H;
          for (H = 0; H < N.length; H++) {
            var ne = N[H];
            Im(p, ne);
          }
          N.splice(0, H), p.destination !== null && pu(p, p.destination);
        } catch (ge) {
          Qo(p, ge), Ji(p, ge);
        } finally {
          sh(D), au.current = b, qo.getCurrentStack = C, b === ah && Uo(m);
        }
      }
    }
    function bs(p, m, b) {
      switch (b.parentFlushed = !0, b.status) {
        case su: {
          var C = b.id = p.nextSegmentId++;
          return b.lastPushedText = !1, b.textEmbedded = !1, $(m, p.responseState, C);
        }
        case Hs: {
          b.status = ou;
          for (var D = !0, N = b.chunks, H = 0, ne = b.children, ge = 0; ge < ne.length; ge++) {
            for (var Pe = ne[ge]; H < Pe.index; H++)
              l(m, N[H]);
            D = el(p, m, Pe);
          }
          for (; H < N.length - 1; H++)
            l(m, N[H]);
          return H < N.length && (D = u(m, N[H])), D;
        }
        default:
          throw new Error("Aborted, errored or already flushed boundaries should not be flushed again. This is a bug in React.");
      }
    }
    function el(p, m, b) {
      var C = b.boundary;
      if (C === null)
        return bs(p, m, b);
      if (C.parentFlushed = !0, C.forceClientRender)
        return va(m, p.responseState, C.errorDigest, C.errorMessage, C.errorComponentStack), bs(p, m, b), qg(m, p.responseState);
      if (C.pendingTasks > 0) {
        C.rootSegmentID = p.nextSegmentId++, C.completedSegments.length > 0 && p.partialBoundaries.push(C);
        var D = C.id = mr(p.responseState);
        return Ke(m, p.responseState, D), bs(p, m, b), Ot(m, p.responseState);
      } else {
        if (C.byteSize > p.progressiveChunkSize)
          return C.rootSegmentID = p.nextSegmentId++, p.completedBoundaries.push(C), Ke(m, p.responseState, C.id), bs(p, m, b), Ot(m, p.responseState);
        la(m, p.responseState);
        var N = C.completedSegments;
        if (N.length !== 1)
          throw new Error("A previously unvisited boundary must have exactly one root segment. This is a bug in React.");
        var H = N[0];
        return el(p, m, H), Gg(m, p.responseState);
      }
    }
    function Dm(p, m, b) {
      return Wr(m, p.responseState, b.id, b.errorDigest, b.errorMessage, b.errorComponentStack);
    }
    function Wc(p, m, b) {
      return oa(m, p.responseState, b.formatContext, b.id), el(p, m, b), Ui(m, b.formatContext);
    }
    function tl(p, m, b) {
      for (var C = b.completedSegments, D = 0; D < C.length; D++) {
        var N = C[D];
        yh(p, m, b, N);
      }
      return C.length = 0, L(m, p.responseState, b.id, b.rootSegmentID);
    }
    function hu(p, m, b) {
      for (var C = b.completedSegments, D = 0; D < C.length; D++) {
        var N = C[D];
        if (!yh(p, m, b, N))
          return D++, C.splice(0, D), !1;
      }
      return C.splice(0, D), !0;
    }
    function yh(p, m, b, C) {
      if (C.status === ou)
        return !0;
      var D = C.id;
      if (D === -1) {
        var N = C.id = b.rootSegmentID;
        if (N === -1)
          throw new Error("A root segment ID must have been assigned by now. This is a bug in React.");
        return Wc(p, m, C);
      } else
        return Wc(p, m, C), $e(m, p.responseState, D);
    }
    function pu(p, m) {
      try {
        var b = p.completedRootSegment;
        b !== null && p.pendingRootTasks === 0 && (el(p, m, b), p.completedRootSegment = null, In(m, p.responseState));
        var C = p.clientRenderedBoundaries, D;
        for (D = 0; D < C.length; D++) {
          var N = C[D];
          if (!Dm(p, m, N)) {
            p.destination = null, D++, C.splice(0, D);
            return;
          }
        }
        C.splice(0, D);
        var H = p.completedBoundaries;
        for (D = 0; D < H.length; D++) {
          var ne = H[D];
          if (!tl(p, m, ne)) {
            p.destination = null, D++, H.splice(0, D);
            return;
          }
        }
        H.splice(0, D);
        var ge = p.partialBoundaries;
        for (D = 0; D < ge.length; D++) {
          var Pe = ge[D];
          if (!hu(p, m, Pe)) {
            p.destination = null, D++, ge.splice(0, D);
            return;
          }
        }
        ge.splice(0, D);
        var Ne = p.completedBoundaries;
        for (D = 0; D < Ne.length; D++) {
          var Ze = Ne[D];
          if (!tl(p, m, Ze)) {
            p.destination = null, D++, Ne.splice(0, D);
            return;
          }
        }
        Ne.splice(0, D);
      } finally {
        p.allPendingTasks === 0 && p.pingedTasks.length === 0 && p.clientRenderedBoundaries.length === 0 && p.completedBoundaries.length === 0 && (p.abortableTasks.size !== 0 && i("There was still abortable task at the root when we closed. This is a bug in React."), d(m));
      }
    }
    function Ah(p) {
      s(function() {
        return qc(p);
      });
    }
    function Pm(p, m) {
      if (p.status === _c) {
        p.status = vs, g(m, p.fatalError);
        return;
      }
      if (p.status !== vs && p.destination === null) {
        p.destination = m;
        try {
          pu(p, m);
        } catch (b) {
          Qo(p, b), Ji(p, b);
        }
      }
    }
    function bh(p, m) {
      try {
        var b = p.abortableTasks;
        b.forEach(function(C) {
          return mh(C, p, m);
        }), b.clear(), p.destination !== null && pu(p, p.destination);
      } catch (C) {
        Qo(p, C), Ji(p, C);
      }
    }
    function Qc() {
    }
    function wh(p, m, b, C) {
      var D = !1, N = null, H = "", ne = {
        push: function(Ze) {
          return Ze !== null && (H += Ze), !0;
        },
        destroy: function(Ze) {
          D = !0, N = Ze;
        }
      }, ge = !1;
      function Pe() {
        ge = !0;
      }
      var Ne = qs(p, Vi(b, m ? m.identifierPrefix : void 0), Dl(), 1 / 0, Qc, void 0, Pe);
      if (Ah(Ne), bh(Ne, C), Pm(Ne, ne), D)
        throw N;
      if (!ge)
        throw new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
      return H;
    }
    function Rm(p, m) {
      return wh(p, m, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
    }
    function xh(p, m) {
      return wh(p, m, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
    }
    function Om() {
      throw new Error("ReactDOMServer.renderToNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToString() instead.");
    }
    function w() {
      throw new Error("ReactDOMServer.renderToStaticNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToStaticMarkup() instead.");
    }
    nl.renderToNodeStream = Om, nl.renderToStaticMarkup = xh, nl.renderToStaticNodeStream = w, nl.renderToString = Rm, nl.version = e;
  })()), nl;
}
var Ih = {};
var Uw;
function E4() {
  return Uw || (Uw = 1, process.env.NODE_ENV !== "production" && (function() {
    var r = Sl(), e = "18.3.1", t = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(w) {
      {
        for (var p = arguments.length, m = new Array(p > 1 ? p - 1 : 0), b = 1; b < p; b++)
          m[b - 1] = arguments[b];
        a("warn", w, m);
      }
    }
    function i(w) {
      {
        for (var p = arguments.length, m = new Array(p > 1 ? p - 1 : 0), b = 1; b < p; b++)
          m[b - 1] = arguments[b];
        a("error", w, m);
      }
    }
    function a(w, p, m) {
      {
        var b = t.ReactDebugCurrentFrame, C = b.getStackAddendum();
        C !== "" && (p += "%s", m = m.concat([C]));
        var D = m.map(function(N) {
          return String(N);
        });
        D.unshift("Warning: " + p), Function.prototype.apply.call(console[w], console, D);
      }
    }
    function s(w) {
      w();
    }
    var o = 512, l = null, u = 0;
    function c(w) {
      l = new Uint8Array(o), u = 0;
    }
    function d(w, p) {
      if (p.length !== 0) {
        if (p.length > o) {
          u > 0 && (w.enqueue(new Uint8Array(l.buffer, 0, u)), l = new Uint8Array(o), u = 0), w.enqueue(p);
          return;
        }
        var m = p, b = l.length - u;
        b < m.length && (b === 0 ? w.enqueue(l) : (l.set(m.subarray(0, b), u), w.enqueue(l), m = m.subarray(b)), l = new Uint8Array(o), u = 0), l.set(m, u), u += m.length;
      }
    }
    function f(w, p) {
      return d(w, p), !0;
    }
    function h(w) {
      l && u > 0 && (w.enqueue(new Uint8Array(l.buffer, 0, u)), l = null, u = 0);
    }
    function g(w) {
      w.close();
    }
    var v = new TextEncoder();
    function y(w) {
      return v.encode(w);
    }
    function A(w) {
      return v.encode(w);
    }
    function x(w, p) {
      typeof w.error == "function" ? w.error(p) : w.close();
    }
    function k(w) {
      {
        var p = typeof Symbol == "function" && Symbol.toStringTag, m = p && w[Symbol.toStringTag] || w.constructor.name || "Object";
        return m;
      }
    }
    function F(w) {
      try {
        return S(w), !1;
      } catch {
        return !0;
      }
    }
    function S(w) {
      return "" + w;
    }
    function R(w, p) {
      if (F(w))
        return i("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", p, k(w)), S(w);
    }
    function M(w, p) {
      if (F(w))
        return i("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", p, k(w)), S(w);
    }
    function j(w) {
      if (F(w))
        return i("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", k(w)), S(w);
    }
    var G = Object.prototype.hasOwnProperty, ie = 0, q = 1, Y = 2, J = 3, se = 4, oe = 5, he = 6, ye = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", Ue = ye + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", Re = new RegExp("^[" + ye + "][" + Ue + "]*$"), Oe = {}, ee = {};
    function re(w) {
      return G.call(ee, w) ? !0 : G.call(Oe, w) ? !1 : Re.test(w) ? (ee[w] = !0, !0) : (Oe[w] = !0, i("Invalid attribute name: `%s`", w), !1);
    }
    function de(w, p, m, b) {
      if (m !== null && m.type === ie)
        return !1;
      switch (typeof p) {
        case "function":
        // $FlowIssue symbol is perfectly valid here
        case "symbol":
          return !0;
        case "boolean": {
          if (m !== null)
            return !m.acceptsBooleans;
          var C = w.toLowerCase().slice(0, 5);
          return C !== "data-" && C !== "aria-";
        }
        default:
          return !1;
      }
    }
    function Be(w) {
      return ze.hasOwnProperty(w) ? ze[w] : null;
    }
    function ke(w, p, m, b, C, D, N) {
      this.acceptsBooleans = p === Y || p === J || p === se, this.attributeName = b, this.attributeNamespace = C, this.mustUseProperty = m, this.propertyName = w, this.type = p, this.sanitizeURL = D, this.removeEmptyString = N;
    }
    var ze = {}, je = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    je.forEach(function(w) {
      ze[w] = new ke(
        w,
        ie,
        !1,
        // mustUseProperty
        w,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(w) {
      var p = w[0], m = w[1];
      ze[p] = new ke(
        p,
        q,
        !1,
        // mustUseProperty
        m,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(w) {
      ze[w] = new ke(
        w,
        Y,
        !1,
        // mustUseProperty
        w.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(w) {
      ze[w] = new ke(
        w,
        Y,
        !1,
        // mustUseProperty
        w,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(w) {
      ze[w] = new ke(
        w,
        J,
        !1,
        // mustUseProperty
        w.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(w) {
      ze[w] = new ke(
        w,
        J,
        !0,
        // mustUseProperty
        w,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(w) {
      ze[w] = new ke(
        w,
        se,
        !1,
        // mustUseProperty
        w,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(w) {
      ze[w] = new ke(
        w,
        he,
        !1,
        // mustUseProperty
        w,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(w) {
      ze[w] = new ke(
        w,
        oe,
        !1,
        // mustUseProperty
        w.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var qe = /[\-\:]([a-z])/g, Ge = function(w) {
      return w[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(w) {
      var p = w.replace(qe, Ge);
      ze[p] = new ke(
        p,
        q,
        !1,
        // mustUseProperty
        w,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(w) {
      var p = w.replace(qe, Ge);
      ze[p] = new ke(
        p,
        q,
        !1,
        // mustUseProperty
        w,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(w) {
      var p = w.replace(qe, Ge);
      ze[p] = new ke(
        p,
        q,
        !1,
        // mustUseProperty
        w,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(w) {
      ze[w] = new ke(
        w,
        q,
        !1,
        // mustUseProperty
        w.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var bt = "xlinkHref";
    ze[bt] = new ke(
      "xlinkHref",
      q,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(w) {
      ze[w] = new ke(
        w,
        q,
        !1,
        // mustUseProperty
        w.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var rr = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function Pr(w, p) {
      return w + p.charAt(0).toUpperCase() + p.substring(1);
    }
    var Gt = ["Webkit", "ms", "Moz", "O"];
    Object.keys(rr).forEach(function(w) {
      Gt.forEach(function(p) {
        rr[Pr(p, w)] = rr[w];
      });
    });
    var ar = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function St(w, p) {
      ar[p.type] || p.onChange || p.onInput || p.readOnly || p.disabled || p.value == null || i("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), p.onChange || p.readOnly || p.disabled || p.checked == null || i("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function st(w, p) {
      if (w.indexOf("-") === -1)
        return typeof p.is == "string";
      switch (w) {
        // These are reserved SVG and MathML elements.
        // We don't mind this list too much because we expect it to never grow.
        // The alternative is to track the namespace in a few places which is convoluted.
        // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Qr = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, Sr = {}, gr = new RegExp("^(aria)-[" + Ue + "]*$"), nr = new RegExp("^(aria)[A-Z][" + Ue + "]*$");
    function fr(w, p) {
      {
        if (G.call(Sr, p) && Sr[p])
          return !0;
        if (nr.test(p)) {
          var m = "aria-" + p.slice(4).toLowerCase(), b = Qr.hasOwnProperty(m) ? m : null;
          if (b == null)
            return i("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", p), Sr[p] = !0, !0;
          if (p !== b)
            return i("Invalid ARIA attribute `%s`. Did you mean `%s`?", p, b), Sr[p] = !0, !0;
        }
        if (gr.test(p)) {
          var C = p.toLowerCase(), D = Qr.hasOwnProperty(C) ? C : null;
          if (D == null)
            return Sr[p] = !0, !1;
          if (p !== D)
            return i("Unknown ARIA attribute `%s`. Did you mean `%s`?", p, D), Sr[p] = !0, !0;
        }
      }
      return !0;
    }
    function Yt(w, p) {
      {
        var m = [];
        for (var b in p) {
          var C = fr(w, b);
          C || m.push(b);
        }
        var D = m.map(function(N) {
          return "`" + N + "`";
        }).join(", ");
        m.length === 1 ? i("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", D, w) : m.length > 1 && i("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", D, w);
      }
    }
    function Xt(w, p) {
      st(w, p) || Yt(w, p);
    }
    var mt = !1;
    function wr(w, p) {
      {
        if (w !== "input" && w !== "textarea" && w !== "select")
          return;
        p != null && p.value === null && !mt && (mt = !0, w === "select" && p.multiple ? i("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", w) : i("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", w));
      }
    }
    var an = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, _r = function() {
    };
    {
      var ir = {}, Yr = /^on./, kr = /^on[^A-Z]/, Zr = new RegExp("^(aria)-[" + Ue + "]*$"), Vr = new RegExp("^(aria)[A-Z][" + Ue + "]*$");
      _r = function(w, p, m, b) {
        if (G.call(ir, p) && ir[p])
          return !0;
        var C = p.toLowerCase();
        if (C === "onfocusin" || C === "onfocusout")
          return i("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), ir[p] = !0, !0;
        if (b != null) {
          var D = b.registrationNameDependencies, N = b.possibleRegistrationNames;
          if (D.hasOwnProperty(p))
            return !0;
          var H = N.hasOwnProperty(C) ? N[C] : null;
          if (H != null)
            return i("Invalid event handler property `%s`. Did you mean `%s`?", p, H), ir[p] = !0, !0;
          if (Yr.test(p))
            return i("Unknown event handler property `%s`. It will be ignored.", p), ir[p] = !0, !0;
        } else if (Yr.test(p))
          return kr.test(p) && i("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", p), ir[p] = !0, !0;
        if (Zr.test(p) || Vr.test(p))
          return !0;
        if (C === "innerhtml")
          return i("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), ir[p] = !0, !0;
        if (C === "aria")
          return i("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), ir[p] = !0, !0;
        if (C === "is" && m !== null && m !== void 0 && typeof m != "string")
          return i("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof m), ir[p] = !0, !0;
        if (typeof m == "number" && isNaN(m))
          return i("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", p), ir[p] = !0, !0;
        var ne = Be(p), ge = ne !== null && ne.type === ie;
        if (an.hasOwnProperty(C)) {
          var Pe = an[C];
          if (Pe !== p)
            return i("Invalid DOM property `%s`. Did you mean `%s`?", p, Pe), ir[p] = !0, !0;
        } else if (!ge && p !== C)
          return i("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", p, C), ir[p] = !0, !0;
        return typeof m == "boolean" && de(p, m, ne) ? (m ? i('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', m, p, p, m, p) : i('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', m, p, p, m, p, p, p), ir[p] = !0, !0) : ge ? !0 : de(p, m, ne) ? (ir[p] = !0, !1) : ((m === "false" || m === "true") && ne !== null && ne.type === J && (i("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", m, p, m === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', p, m), ir[p] = !0), !0);
      };
    }
    var pn = function(w, p, m) {
      {
        var b = [];
        for (var C in p) {
          var D = _r(w, C, p[C], m);
          D || b.push(C);
        }
        var N = b.map(function(H) {
          return "`" + H + "`";
        }).join(", ");
        b.length === 1 ? i("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", N, w) : b.length > 1 && i("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", N, w);
      }
    };
    function gn(w, p, m) {
      st(w, p) || pn(w, p, m);
    }
    var Tr = function() {
    };
    {
      var zr = /^(?:webkit|moz|o)[A-Z]/, en = /^-ms-/, $r = /-(.)/g, zt = /;\s*$/, sr = {}, Er = {}, tt = !1, Nr = !1, Xr = function(w) {
        return w.replace($r, function(p, m) {
          return m.toUpperCase();
        });
      }, Se = function(w) {
        sr.hasOwnProperty(w) && sr[w] || (sr[w] = !0, i(
          "Unsupported style property %s. Did you mean %s?",
          w,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          Xr(w.replace(en, "ms-"))
        ));
      }, P = function(w) {
        sr.hasOwnProperty(w) && sr[w] || (sr[w] = !0, i("Unsupported vendor-prefixed style property %s. Did you mean %s?", w, w.charAt(0).toUpperCase() + w.slice(1)));
      }, U = function(w, p) {
        Er.hasOwnProperty(p) && Er[p] || (Er[p] = !0, i(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, w, p.replace(zt, "")));
      }, X = function(w, p) {
        tt || (tt = !0, i("`NaN` is an invalid value for the `%s` css style property.", w));
      }, ue = function(w, p) {
        Nr || (Nr = !0, i("`Infinity` is an invalid value for the `%s` css style property.", w));
      };
      Tr = function(w, p) {
        w.indexOf("-") > -1 ? Se(w) : zr.test(w) ? P(w) : zt.test(p) && U(w, p), typeof p == "number" && (isNaN(p) ? X(w, p) : isFinite(p) || ue(w, p));
      };
    }
    var Fe = Tr, We = /["'&<>]/;
    function wt(w) {
      j(w);
      var p = "" + w, m = We.exec(p);
      if (!m)
        return p;
      var b, C = "", D, N = 0;
      for (D = m.index; D < p.length; D++) {
        switch (p.charCodeAt(D)) {
          case 34:
            b = "&quot;";
            break;
          case 38:
            b = "&amp;";
            break;
          case 39:
            b = "&#x27;";
            break;
          case 60:
            b = "&lt;";
            break;
          case 62:
            b = "&gt;";
            break;
          default:
            continue;
        }
        N !== D && (C += p.substring(N, D)), N = D + 1, C += b;
      }
      return N !== D ? C + p.substring(N, D) : C;
    }
    function Pt(w) {
      return typeof w == "boolean" || typeof w == "number" ? "" + w : wt(w);
    }
    var Nt = /([A-Z])/g, or = /^ms-/;
    function Lt(w) {
      return w.replace(Nt, "-$1").toLowerCase().replace(or, "-ms-");
    }
    var K = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, Ie = !1;
    function Qe(w) {
      !Ie && K.test(w) && (Ie = !0, i("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(w)));
    }
    var Ye = Array.isArray;
    function Ct(w) {
      return Ye(w);
    }
    var dt = A("<script>"), Rt = A("<\/script>"), Et = A('<script src="'), hr = A('<script type="module" src="'), er = A('" async=""><\/script>');
    function dr(w) {
      return j(w), ("" + w).replace($t, On);
    }
    var $t = /(<\/|<)(s)(cript)/gi, On = function(w, p, m, b) {
      return "" + p + (m === "s" ? "\\u0073" : "\\u0053") + b;
    };
    function Fn(w, p, m, b, C) {
      var D = w === void 0 ? "" : w, N = p === void 0 ? dt : A('<script nonce="' + Pt(p) + '">'), H = [];
      if (m !== void 0 && H.push(N, y(dr(m)), Rt), b !== void 0)
        for (var ne = 0; ne < b.length; ne++)
          H.push(Et, y(Pt(b[ne])), er);
      if (C !== void 0)
        for (var ge = 0; ge < C.length; ge++)
          H.push(hr, y(Pt(C[ge])), er);
      return {
        bootstrapChunks: H,
        startInlineScript: N,
        placeholderPrefix: A(D + "P:"),
        segmentPrefix: A(D + "S:"),
        boundaryPrefix: D + "B:",
        idPrefix: D,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
      };
    }
    var mr = 0, xr = 1, wn = 2, Rr = 3, jn = 4, xn = 5, Hr = 6, Cn = 7;
    function cn(w, p) {
      return {
        insertionMode: w,
        selectedValue: p
      };
    }
    function tn(w) {
      var p = w === "http://www.w3.org/2000/svg" ? wn : w === "http://www.w3.org/1998/Math/MathML" ? Rr : mr;
      return cn(p, null);
    }
    function Jn(w, p, m) {
      switch (p) {
        case "select":
          return cn(xr, m.value != null ? m.value : m.defaultValue);
        case "svg":
          return cn(wn, null);
        case "math":
          return cn(Rr, null);
        case "foreignObject":
          return cn(xr, null);
        // Table parents are special in that their children can only be created at all if they're
        // wrapped in a table parent. So we need to encode that we're entering this mode.
        case "table":
          return cn(jn, null);
        case "thead":
        case "tbody":
        case "tfoot":
          return cn(xn, null);
        case "colgroup":
          return cn(Cn, null);
        case "tr":
          return cn(Hr, null);
      }
      return w.insertionMode >= jn || w.insertionMode === mr ? cn(xr, null) : w;
    }
    var ii = null;
    function Sn(w) {
      var p = w.nextSuspenseID++;
      return A(w.boundaryPrefix + p.toString(16));
    }
    function mn(w, p, m) {
      var b = w.idPrefix, C = ":" + b + "R" + p;
      return m > 0 && (C += "H" + m.toString(32)), C + ":";
    }
    function sn(w) {
      return Pt(w);
    }
    var rn = A("<!-- -->");
    function Lr(w, p, m, b) {
      return p === "" ? b : (b && w.push(rn), w.push(y(sn(p))), !0);
    }
    function on(w, p, m, b) {
      m && b && w.push(rn);
    }
    var E = /* @__PURE__ */ new Map();
    function O(w) {
      var p = E.get(w);
      if (p !== void 0)
        return p;
      var m = A(Pt(Lt(w)));
      return E.set(w, m), m;
    }
    var z = A(' style="'), W = A(":"), pe = A(";");
    function ce(w, p, m) {
      if (typeof m != "object")
        throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      var b = !0;
      for (var C in m)
        if (G.call(m, C)) {
          var D = m[C];
          if (!(D == null || typeof D == "boolean" || D === "")) {
            var N = void 0, H = void 0, ne = C.indexOf("--") === 0;
            ne ? (N = y(Pt(C)), M(D, C), H = y(Pt(("" + D).trim()))) : (Fe(C, D), N = O(C), typeof D == "number" ? D !== 0 && !G.call(rr, C) ? H = y(D + "px") : H = y("" + D) : (M(D, C), H = y(Pt(("" + D).trim())))), b ? (b = !1, w.push(z, N, W, H)) : w.push(pe, N, W, H);
          }
        }
      b || w.push(rt);
    }
    var Ce = A(" "), _e = A('="'), rt = A('"'), ut = A('=""');
    function nt(w, p, m, b) {
      switch (m) {
        case "style": {
          ce(w, p, b);
          return;
        }
        case "defaultValue":
        case "defaultChecked":
        // These shouldn't be set as attributes on generic HTML elements.
        case "innerHTML":
        // Must use dangerouslySetInnerHTML instead.
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
          return;
      }
      if (
        // shouldIgnoreAttribute
        // We have already filtered out null/undefined and reserved words.
        !(m.length > 2 && (m[0] === "o" || m[0] === "O") && (m[1] === "n" || m[1] === "N"))
      ) {
        var C = Be(m);
        if (C !== null) {
          switch (typeof b) {
            case "function":
            // $FlowIssue symbol is perfectly valid here
            case "symbol":
              return;
            case "boolean":
              if (!C.acceptsBooleans)
                return;
          }
          var D = C.attributeName, N = y(D);
          switch (C.type) {
            case J:
              b && w.push(Ce, N, ut);
              return;
            case se:
              b === !0 ? w.push(Ce, N, ut) : b === !1 || w.push(Ce, N, _e, y(Pt(b)), rt);
              return;
            case oe:
              isNaN(b) || w.push(Ce, N, _e, y(Pt(b)), rt);
              break;
            case he:
              !isNaN(b) && b >= 1 && w.push(Ce, N, _e, y(Pt(b)), rt);
              break;
            default:
              C.sanitizeURL && (R(b, D), b = "" + b, Qe(b)), w.push(Ce, N, _e, y(Pt(b)), rt);
          }
        } else if (re(m)) {
          switch (typeof b) {
            case "function":
            // $FlowIssue symbol is perfectly valid here
            case "symbol":
              return;
            case "boolean": {
              var H = m.toLowerCase().slice(0, 5);
              if (H !== "data-" && H !== "aria-")
                return;
            }
          }
          w.push(Ce, y(m), _e, y(Pt(b)), rt);
        }
      }
    }
    var Jt = A(">"), vr = A("/>");
    function jr(w, p, m) {
      if (p != null) {
        if (m != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof p != "object" || !("__html" in p))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var b = p.__html;
        b != null && (j(b), w.push(y("" + b)));
      }
    }
    var fn = !1, Kn = !1, Ln = !1, vn = !1, Or = !1, Gn = !1, Bn = !1;
    function Mn(w, p) {
      {
        var m = w[p];
        if (m != null) {
          var b = Ct(m);
          w.multiple && !b ? i("The `%s` prop supplied to <select> must be an array if `multiple` is true.", p) : !w.multiple && b && i("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", p);
        }
      }
    }
    function Ri(w, p, m) {
      St("select", p), Mn(p, "value"), Mn(p, "defaultValue"), p.value !== void 0 && p.defaultValue !== void 0 && !Ln && (i("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Ln = !0), w.push(ht("select"));
      var b = null, C = null;
      for (var D in p)
        if (G.call(p, D)) {
          var N = p[D];
          if (N == null)
            continue;
          switch (D) {
            case "children":
              b = N;
              break;
            case "dangerouslySetInnerHTML":
              C = N;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              nt(w, m, D, N);
              break;
          }
        }
      return w.push(Jt), jr(w, C, b), b;
    }
    function yi(w) {
      var p = "";
      return r.Children.forEach(w, function(m) {
        m != null && (p += m, !Or && typeof m != "string" && typeof m != "number" && (Or = !0, i("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }), p;
    }
    var Ai = A(' selected=""');
    function _n(w, p, m, b) {
      var C = b.selectedValue;
      w.push(ht("option"));
      var D = null, N = null, H = null, ne = null;
      for (var ge in p)
        if (G.call(p, ge)) {
          var Pe = p[ge];
          if (Pe == null)
            continue;
          switch (ge) {
            case "children":
              D = Pe;
              break;
            case "selected":
              H = Pe, Bn || (i("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), Bn = !0);
              break;
            case "dangerouslySetInnerHTML":
              ne = Pe;
              break;
            // eslint-disable-next-line-no-fallthrough
            case "value":
              N = Pe;
            // We intentionally fallthrough to also set the attribute on the node.
            // eslint-disable-next-line-no-fallthrough
            default:
              nt(w, m, ge, Pe);
              break;
          }
        }
      if (C != null) {
        var Ne;
        if (N !== null ? (R(N, "value"), Ne = "" + N) : (ne !== null && (Gn || (Gn = !0, i("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."))), Ne = yi(D)), Ct(C))
          for (var Ze = 0; Ze < C.length; Ze++) {
            R(C[Ze], "value");
            var Vt = "" + C[Ze];
            if (Vt === Ne) {
              w.push(Ai);
              break;
            }
          }
        else
          R(C, "select.value"), "" + C === Ne && w.push(Ai);
      } else H && w.push(Ai);
      return w.push(Jt), jr(w, ne, D), D;
    }
    function ki(w, p, m) {
      St("input", p), p.checked !== void 0 && p.defaultChecked !== void 0 && !Kn && (i("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", p.type), Kn = !0), p.value !== void 0 && p.defaultValue !== void 0 && !fn && (i("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", p.type), fn = !0), w.push(ht("input"));
      var b = null, C = null, D = null, N = null;
      for (var H in p)
        if (G.call(p, H)) {
          var ne = p[H];
          if (ne == null)
            continue;
          switch (H) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("input is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            // eslint-disable-next-line-no-fallthrough
            case "defaultChecked":
              N = ne;
              break;
            case "defaultValue":
              C = ne;
              break;
            case "checked":
              D = ne;
              break;
            case "value":
              b = ne;
              break;
            default:
              nt(w, m, H, ne);
              break;
          }
        }
      return D !== null ? nt(w, m, "checked", D) : N !== null && nt(w, m, "checked", N), b !== null ? nt(w, m, "value", b) : C !== null && nt(w, m, "value", C), w.push(vr), null;
    }
    function Un(w, p, m) {
      St("textarea", p), p.value !== void 0 && p.defaultValue !== void 0 && !vn && (i("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components"), vn = !0), w.push(ht("textarea"));
      var b = null, C = null, D = null;
      for (var N in p)
        if (G.call(p, N)) {
          var H = p[N];
          if (H == null)
            continue;
          switch (N) {
            case "children":
              D = H;
              break;
            case "value":
              b = H;
              break;
            case "defaultValue":
              C = H;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
            // eslint-disable-next-line-no-fallthrough
            default:
              nt(w, m, N, H);
              break;
          }
        }
      if (b === null && C !== null && (b = C), w.push(Jt), D != null) {
        if (i("Use the `defaultValue` or `value` props instead of setting children on <textarea>."), b != null)
          throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
        if (Ct(D)) {
          if (D.length > 1)
            throw new Error("<textarea> can only have at most one child.");
          j(D[0]), b = "" + D[0];
        }
        j(D), b = "" + D;
      }
      return typeof b == "string" && b[0] === `
` && w.push(I), b !== null && (R(b, "value"), w.push(y(sn("" + b)))), null;
    }
    function En(w, p, m, b) {
      w.push(ht(m));
      for (var C in p)
        if (G.call(p, C)) {
          var D = p[C];
          if (D == null)
            continue;
          switch (C) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error(m + " is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            // eslint-disable-next-line-no-fallthrough
            default:
              nt(w, b, C, D);
              break;
          }
        }
      return w.push(vr), null;
    }
    function Zn(w, p, m) {
      w.push(ht("menuitem"));
      for (var b in p)
        if (G.call(p, b)) {
          var C = p[b];
          if (C == null)
            continue;
          switch (b) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("menuitems cannot have `children` nor `dangerouslySetInnerHTML`.");
            // eslint-disable-next-line-no-fallthrough
            default:
              nt(w, m, b, C);
              break;
          }
        }
      return w.push(Jt), null;
    }
    function lr(w, p, m) {
      w.push(ht("title"));
      var b = null;
      for (var C in p)
        if (G.call(p, C)) {
          var D = p[C];
          if (D == null)
            continue;
          switch (C) {
            case "children":
              b = D;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <title>.");
            // eslint-disable-next-line-no-fallthrough
            default:
              nt(w, m, C, D);
              break;
          }
        }
      w.push(Jt);
      {
        var N = Array.isArray(b) && b.length < 2 ? b[0] || null : b;
        Array.isArray(b) && b.length > 1 ? i("A title element received an array with more than 1 element as children. In browsers title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : N != null && N.$$typeof != null ? i("A title element received a React element for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : N != null && typeof N != "string" && typeof N != "number" && i("A title element received a value that was not a string or number for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
      }
      return b;
    }
    function In(w, p, m, b) {
      w.push(ht(m));
      var C = null, D = null;
      for (var N in p)
        if (G.call(p, N)) {
          var H = p[N];
          if (H == null)
            continue;
          switch (N) {
            case "children":
              C = H;
              break;
            case "dangerouslySetInnerHTML":
              D = H;
              break;
            default:
              nt(w, b, N, H);
              break;
          }
        }
      return w.push(Jt), jr(w, D, C), typeof C == "string" ? (w.push(y(sn(C))), null) : C;
    }
    function bi(w, p, m, b) {
      w.push(ht(m));
      var C = null, D = null;
      for (var N in p)
        if (G.call(p, N)) {
          var H = p[N];
          if (H == null)
            continue;
          switch (N) {
            case "children":
              C = H;
              break;
            case "dangerouslySetInnerHTML":
              D = H;
              break;
            case "style":
              ce(w, b, H);
              break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
              break;
            default:
              re(N) && typeof H != "function" && typeof H != "symbol" && w.push(Ce, y(N), _e, y(Pt(H)), rt);
              break;
          }
        }
      return w.push(Jt), jr(w, D, C), C;
    }
    var I = A(`
`);
    function $(w, p, m, b) {
      w.push(ht(m));
      var C = null, D = null;
      for (var N in p)
        if (G.call(p, N)) {
          var H = p[N];
          if (H == null)
            continue;
          switch (N) {
            case "children":
              C = H;
              break;
            case "dangerouslySetInnerHTML":
              D = H;
              break;
            default:
              nt(w, b, N, H);
              break;
          }
        }
      if (w.push(Jt), D != null) {
        if (C != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof D != "object" || !("__html" in D))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var ne = D.__html;
        ne != null && (typeof ne == "string" && ne.length > 0 && ne[0] === `
` ? w.push(I, y(ne)) : (j(ne), w.push(y("" + ne))));
      }
      return typeof C == "string" && C[0] === `
` && w.push(I), C;
    }
    var ae = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, xe = /* @__PURE__ */ new Map();
    function ht(w) {
      var p = xe.get(w);
      if (p === void 0) {
        if (!ae.test(w))
          throw new Error("Invalid tag: " + w);
        p = A("<" + w), xe.set(w, p);
      }
      return p;
    }
    var lt = A("<!DOCTYPE html>");
    function Ht(w, p, m, b, C) {
      switch (Xt(p, m), wr(p, m), gn(p, m, null), !m.suppressContentEditableWarning && m.contentEditable && m.children != null && i("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), C.insertionMode !== wn && C.insertionMode !== Rr && p.indexOf("-") === -1 && typeof m.is != "string" && p.toLowerCase() !== p && i("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", p), p) {
        // Special tags
        case "select":
          return Ri(w, m, b);
        case "option":
          return _n(w, m, b, C);
        case "textarea":
          return Un(w, m, b);
        case "input":
          return ki(w, m, b);
        case "menuitem":
          return Zn(w, m, b);
        case "title":
          return lr(w, m, b);
        // Newline eating tags
        case "listing":
        case "pre":
          return $(w, m, p, b);
        // Omitted close tags
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          return En(w, m, p, b);
        // These are reserved SVG and MathML elements, that are never custom elements.
        // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return In(w, m, p, b);
        case "html":
          return C.insertionMode === mr && w.push(lt), In(w, m, p, b);
        default:
          return p.indexOf("-") === -1 && typeof m.is != "string" ? In(w, m, p, b) : bi(w, m, p, b);
      }
    }
    var Ut = A("</"), Br = A(">");
    function B(w, p, m) {
      switch (p) {
        // Omitted close tags
        // TODO: Instead of repeating this switch we could try to pass a flag from above.
        // That would require returning a tuple. Which might be ok if it gets inlined.
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          w.push(Ut, y(p), Br);
      }
    }
    function Z(w, p) {
      for (var m = p.bootstrapChunks, b = 0; b < m.length - 1; b++)
        d(w, m[b]);
      return b < m.length ? f(w, m[b]) : !0;
    }
    var fe = A('<template id="'), be = A('"></template>');
    function Me(w, p, m) {
      d(w, fe), d(w, p.placeholderPrefix);
      var b = y(m.toString(16));
      return d(w, b), f(w, be);
    }
    var Ke = A("<!--$-->"), Xe = A('<!--$?--><template id="'), yt = A('"></template>'), Ot = A("<!--$!-->"), pr = A("<!--/$-->"), yr = A("<template"), ur = A('"'), Fr = A(' data-dgst="'), Gr = A(' data-msg="'), yn = A(' data-stck="'), Wi = A("></template>");
    function aa(w, p) {
      return f(w, Ke);
    }
    function Qi(w, p, m) {
      if (d(w, Xe), m === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return d(w, m), f(w, yt);
    }
    function qn(w, p, m, b, C) {
      var D;
      return D = f(w, Ot), d(w, yr), m && (d(w, Fr), d(w, y(Pt(m))), d(w, ur)), b && (d(w, Gr), d(w, y(Pt(b))), d(w, ur)), C && (d(w, yn), d(w, y(Pt(C))), d(w, ur)), D = f(w, Wi), D;
    }
    function Yi(w, p) {
      return f(w, pr);
    }
    function di(w, p) {
      return f(w, pr);
    }
    function Na(w, p) {
      return f(w, pr);
    }
    var La = A('<div hidden id="'), sa = A('">'), os = A("</div>"), ls = A('<svg aria-hidden="true" style="display:none" id="'), Ti = A('">'), Ua = A("</svg>"), us = A('<math aria-hidden="true" style="display:none" id="'), cs = A('">'), fs = A("</math>"), oa = A('<table hidden id="'), Ui = A('">'), T = A("</table>"), _ = A('<table hidden><tbody id="'), V = A('">'), Q = A("</tbody></table>"), Ae = A('<table hidden><tr id="'), ve = A('">'), Te = A("</tr></table>"), $e = A('<table hidden><colgroup id="'), Bt = A('">'), Kt = A("</colgroup></table>");
    function qt(w, p, m, b) {
      switch (m.insertionMode) {
        case mr:
        case xr:
          return d(w, La), d(w, p.segmentPrefix), d(w, y(b.toString(16))), f(w, sa);
        case wn:
          return d(w, ls), d(w, p.segmentPrefix), d(w, y(b.toString(16))), f(w, Ti);
        case Rr:
          return d(w, us), d(w, p.segmentPrefix), d(w, y(b.toString(16))), f(w, cs);
        case jn:
          return d(w, oa), d(w, p.segmentPrefix), d(w, y(b.toString(16))), f(w, Ui);
        // TODO: For the rest of these, there will be extra wrapper nodes that never
        // get deleted from the document. We need to delete the table too as part
        // of the injected scripts. They are invisible though so it's not too terrible
        // and it's kind of an edge case to suspend in a table. Totally supported though.
        case xn:
          return d(w, _), d(w, p.segmentPrefix), d(w, y(b.toString(16))), f(w, V);
        case Hr:
          return d(w, Ae), d(w, p.segmentPrefix), d(w, y(b.toString(16))), f(w, ve);
        case Cn:
          return d(w, $e), d(w, p.segmentPrefix), d(w, y(b.toString(16))), f(w, Bt);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    function qr(w, p) {
      switch (p.insertionMode) {
        case mr:
        case xr:
          return f(w, os);
        case wn:
          return f(w, Ua);
        case Rr:
          return f(w, fs);
        case jn:
          return f(w, T);
        case xn:
          return f(w, Q);
        case Hr:
          return f(w, Te);
        case Cn:
          return f(w, Kt);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    var L = "function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)}", te = 'function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}}', le = 'function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())}', Ve = A(L + ';$RS("'), pt = A('$RS("'), _t = A('","'), Wr = A('")<\/script>');
    function Vn(w, p, m) {
      d(w, p.startInlineScript), p.sentCompleteSegmentFunction ? d(w, pt) : (p.sentCompleteSegmentFunction = !0, d(w, Ve)), d(w, p.segmentPrefix);
      var b = y(m.toString(16));
      return d(w, b), d(w, _t), d(w, p.placeholderPrefix), d(w, b), f(w, Wr);
    }
    var ai = A(te + ';$RC("'), Vi = A('$RC("'), Dl = A('","'), Pl = A('")<\/script>');
    function Io(w, p, m, b) {
      if (d(w, p.startInlineScript), p.sentCompleteBoundaryFunction ? d(w, Vi) : (p.sentCompleteBoundaryFunction = !0, d(w, ai)), m === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      var C = y(b.toString(16));
      return d(w, m), d(w, Dl), d(w, p.segmentPrefix), d(w, C), f(w, Pl);
    }
    var la = A(le + ';$RX("'), va = A('$RX("'), Gg = A('"'), qg = A(")<\/script>"), Fi = A(",");
    function Wg(w, p, m, b, C, D) {
      if (d(w, p.startInlineScript), p.sentClientRenderFunction ? d(w, va) : (p.sentClientRenderFunction = !0, d(w, la)), m === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return d(w, m), d(w, Gg), (b || C || D) && (d(w, Fi), d(w, y(Rl(b || "")))), (C || D) && (d(w, Fi), d(w, y(Rl(C || "")))), D && (d(w, Fi), d(w, y(Rl(D)))), f(w, qg);
    }
    var Ud = /[<\u2028\u2029]/g;
    function Rl(w) {
      var p = JSON.stringify(w);
      return p.replace(Ud, function(m) {
        switch (m) {
          // santizing breaking out of strings and script tags
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw new Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
      });
    }
    var Oi = Object.assign, Vd = /* @__PURE__ */ Symbol.for("react.element"), Ol = /* @__PURE__ */ Symbol.for("react.portal"), Bl = /* @__PURE__ */ Symbol.for("react.fragment"), Ml = /* @__PURE__ */ Symbol.for("react.strict_mode"), _l = /* @__PURE__ */ Symbol.for("react.profiler"), Do = /* @__PURE__ */ Symbol.for("react.provider"), Po = /* @__PURE__ */ Symbol.for("react.context"), Ns = /* @__PURE__ */ Symbol.for("react.forward_ref"), dc = /* @__PURE__ */ Symbol.for("react.suspense"), hc = /* @__PURE__ */ Symbol.for("react.suspense_list"), pc = /* @__PURE__ */ Symbol.for("react.memo"), Nl = /* @__PURE__ */ Symbol.for("react.lazy"), zd = /* @__PURE__ */ Symbol.for("react.scope"), Qg = /* @__PURE__ */ Symbol.for("react.debug_trace_mode"), Yg = /* @__PURE__ */ Symbol.for("react.legacy_hidden"), Xg = /* @__PURE__ */ Symbol.for("react.default_value"), gc = Symbol.iterator, An = "@@iterator";
    function Ro(w) {
      if (w === null || typeof w != "object")
        return null;
      var p = gc && w[gc] || w[An];
      return typeof p == "function" ? p : null;
    }
    function $d(w, p, m) {
      var b = w.displayName;
      if (b)
        return b;
      var C = p.displayName || p.name || "";
      return C !== "" ? m + "(" + C + ")" : m;
    }
    function mc(w) {
      return w.displayName || "Context";
    }
    function dn(w) {
      if (w == null)
        return null;
      if (typeof w.tag == "number" && i("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof w == "function")
        return w.displayName || w.name || null;
      if (typeof w == "string")
        return w;
      switch (w) {
        case Bl:
          return "Fragment";
        case Ol:
          return "Portal";
        case _l:
          return "Profiler";
        case Ml:
          return "StrictMode";
        case dc:
          return "Suspense";
        case hc:
          return "SuspenseList";
      }
      if (typeof w == "object")
        switch (w.$$typeof) {
          case Po:
            var p = w;
            return mc(p) + ".Consumer";
          case Do:
            var m = w;
            return mc(m._context) + ".Provider";
          case Ns:
            return $d(w, w.render, "ForwardRef");
          case pc:
            var b = w.displayName || null;
            return b !== null ? b : dn(w.type) || "Memo";
          case Nl: {
            var C = w, D = C._payload, N = C._init;
            try {
              return dn(N(D));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Ls = 0, vc, yc, Ac, bc, Hd, jd, Ll;
    function Ul() {
    }
    Ul.__reactDisabledLog = !0;
    function Oo() {
      {
        if (Ls === 0) {
          vc = console.log, yc = console.info, Ac = console.warn, bc = console.error, Hd = console.group, jd = console.groupCollapsed, Ll = console.groupEnd;
          var w = {
            configurable: !0,
            enumerable: !0,
            value: Ul,
            writable: !0
          };
          Object.defineProperties(console, {
            info: w,
            log: w,
            warn: w,
            error: w,
            group: w,
            groupCollapsed: w,
            groupEnd: w
          });
        }
        Ls++;
      }
    }
    function wc() {
      {
        if (Ls--, Ls === 0) {
          var w = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Oi({}, w, {
              value: vc
            }),
            info: Oi({}, w, {
              value: yc
            }),
            warn: Oi({}, w, {
              value: Ac
            }),
            error: Oi({}, w, {
              value: bc
            }),
            group: Oi({}, w, {
              value: Hd
            }),
            groupCollapsed: Oi({}, w, {
              value: jd
            }),
            groupEnd: Oi({}, w, {
              value: Ll
            })
          });
        }
        Ls < 0 && i("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Us = t.ReactCurrentDispatcher, xc;
    function ds(w, p, m) {
      {
        if (xc === void 0)
          try {
            throw Error();
          } catch (C) {
            var b = C.stack.trim().match(/\n( *(at )?)/);
            xc = b && b[1] || "";
          }
        return `
` + xc + w;
      }
    }
    var Cc = !1, Bo;
    {
      var Jg = typeof WeakMap == "function" ? WeakMap : Map;
      Bo = new Jg();
    }
    function Mo(w, p) {
      if (!w || Cc)
        return "";
      {
        var m = Bo.get(w);
        if (m !== void 0)
          return m;
      }
      var b;
      Cc = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var D;
      D = Us.current, Us.current = null, Oo();
      try {
        if (p) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (Dr) {
              b = Dr;
            }
            Reflect.construct(w, [], N);
          } else {
            try {
              N.call();
            } catch (Dr) {
              b = Dr;
            }
            w.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Dr) {
            b = Dr;
          }
          w();
        }
      } catch (Dr) {
        if (Dr && b && typeof Dr.stack == "string") {
          for (var H = Dr.stack.split(`
`), ne = b.stack.split(`
`), ge = H.length - 1, Pe = ne.length - 1; ge >= 1 && Pe >= 0 && H[ge] !== ne[Pe]; )
            Pe--;
          for (; ge >= 1 && Pe >= 0; ge--, Pe--)
            if (H[ge] !== ne[Pe]) {
              if (ge !== 1 || Pe !== 1)
                do
                  if (ge--, Pe--, Pe < 0 || H[ge] !== ne[Pe]) {
                    var Ne = `
` + H[ge].replace(" at new ", " at ");
                    return w.displayName && Ne.includes("<anonymous>") && (Ne = Ne.replace("<anonymous>", w.displayName)), typeof w == "function" && Bo.set(w, Ne), Ne;
                  }
                while (ge >= 1 && Pe >= 0);
              break;
            }
        }
      } finally {
        Cc = !1, Us.current = D, wc(), Error.prepareStackTrace = C;
      }
      var Ze = w ? w.displayName || w.name : "", Vt = Ze ? ds(Ze) : "";
      return typeof w == "function" && Bo.set(w, Vt), Vt;
    }
    function Gd(w, p, m) {
      return Mo(w, !0);
    }
    function Sc(w, p, m) {
      return Mo(w, !1);
    }
    function Vl(w) {
      var p = w.prototype;
      return !!(p && p.isReactComponent);
    }
    function zl(w, p, m) {
      if (w == null)
        return "";
      if (typeof w == "function")
        return Mo(w, Vl(w));
      if (typeof w == "string")
        return ds(w);
      switch (w) {
        case dc:
          return ds("Suspense");
        case hc:
          return ds("SuspenseList");
      }
      if (typeof w == "object")
        switch (w.$$typeof) {
          case Ns:
            return Sc(w.render);
          case pc:
            return zl(w.type, p, m);
          case Nl: {
            var b = w, C = b._payload, D = b._init;
            try {
              return zl(D(C), p, m);
            } catch {
            }
          }
        }
      return "";
    }
    var $l = {}, _o = t.ReactDebugCurrentFrame;
    function No(w) {
      if (w) {
        var p = w._owner, m = zl(w.type, w._source, p ? p.type : null);
        _o.setExtraStackFrame(m);
      } else
        _o.setExtraStackFrame(null);
    }
    function qd(w, p, m, b, C) {
      {
        var D = Function.call.bind(G);
        for (var N in w)
          if (D(w, N)) {
            var H = void 0;
            try {
              if (typeof w[N] != "function") {
                var ne = Error((b || "React class") + ": " + m + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof w[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              H = w[N](p, N, b, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ge) {
              H = ge;
            }
            H && !(H instanceof Error) && (No(C), i("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", b || "React class", m, N, typeof H), No(null)), H instanceof Error && !(H.message in $l) && ($l[H.message] = !0, No(C), i("Failed %s type: %s", m, H.message), No(null));
          }
      }
    }
    var hs;
    hs = {};
    var Hl = {};
    Object.freeze(Hl);
    function Va(w, p) {
      {
        var m = w.contextTypes;
        if (!m)
          return Hl;
        var b = {};
        for (var C in m)
          b[C] = p[C];
        {
          var D = dn(w) || "Unknown";
          qd(m, b, "context", D);
        }
        return b;
      }
    }
    function Ec(w, p, m, b) {
      {
        if (typeof w.getChildContext != "function") {
          {
            var C = dn(p) || "Unknown";
            hs[C] || (hs[C] = !0, i("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", C, C));
          }
          return m;
        }
        var D = w.getChildContext();
        for (var N in D)
          if (!(N in b))
            throw new Error((dn(p) || "Unknown") + '.getChildContext(): key "' + N + '" is not defined in childContextTypes.');
        {
          var H = dn(p) || "Unknown";
          qd(b, D, "child context", H);
        }
        return Oi({}, m, D);
      }
    }
    var ps;
    ps = {};
    var jl = null, za = null;
    function Gl(w) {
      w.context._currentValue = w.parentValue;
    }
    function ql(w) {
      w.context._currentValue = w.value;
    }
    function Lo(w, p) {
      if (w !== p) {
        Gl(w);
        var m = w.parent, b = p.parent;
        if (m === null) {
          if (b !== null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
        } else {
          if (b === null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
          Lo(m, b);
        }
        ql(p);
      }
    }
    function Uo(w) {
      Gl(w);
      var p = w.parent;
      p !== null && Uo(p);
    }
    function Wd(w) {
      var p = w.parent;
      p !== null && Wd(p), ql(w);
    }
    function Qd(w, p) {
      Gl(w);
      var m = w.parent;
      if (m === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      m.depth === p.depth ? Lo(m, p) : Qd(m, p);
    }
    function Yd(w, p) {
      var m = p.parent;
      if (m === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      w.depth === m.depth ? Lo(w, m) : Yd(w, m), ql(p);
    }
    function $a(w) {
      var p = za, m = w;
      p !== m && (p === null ? Wd(m) : m === null ? Uo(p) : p.depth === m.depth ? Lo(p, m) : p.depth > m.depth ? Qd(p, m) : Yd(p, m), za = m);
    }
    function kc(w, p) {
      var m;
      m = w._currentValue, w._currentValue = p, w._currentRenderer !== void 0 && w._currentRenderer !== null && w._currentRenderer !== ps && i("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), w._currentRenderer = ps;
      var b = za, C = {
        parent: b,
        depth: b === null ? 0 : b.depth + 1,
        context: w,
        parentValue: m,
        value: p
      };
      return za = C, C;
    }
    function Kg(w) {
      var p = za;
      if (p === null)
        throw new Error("Tried to pop a Context at the root of the app. This is a bug in React.");
      p.context !== w && i("The parent context is not the expected context. This is probably a bug in React.");
      {
        var m = p.parentValue;
        m === Xg ? p.context._currentValue = p.context._defaultValue : p.context._currentValue = m, w._currentRenderer !== void 0 && w._currentRenderer !== null && w._currentRenderer !== ps && i("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), w._currentRenderer = ps;
      }
      return za = p.parent;
    }
    function Xd() {
      return za;
    }
    function Vs(w) {
      var p = w._currentValue;
      return p;
    }
    function Vo(w) {
      return w._reactInternals;
    }
    function Tc(w, p) {
      w._reactInternals = p;
    }
    var Wl = {}, Ql = {}, Yl, zs, zo, $o, Xl, Ho, Jl, Kl, Fc;
    {
      Yl = /* @__PURE__ */ new Set(), zs = /* @__PURE__ */ new Set(), zo = /* @__PURE__ */ new Set(), Jl = /* @__PURE__ */ new Set(), $o = /* @__PURE__ */ new Set(), Kl = /* @__PURE__ */ new Set(), Fc = /* @__PURE__ */ new Set();
      var Jd = /* @__PURE__ */ new Set();
      Ho = function(w, p) {
        if (!(w === null || typeof w == "function")) {
          var m = p + "_" + w;
          Jd.has(m) || (Jd.add(m), i("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", p, w));
        }
      }, Xl = function(w, p) {
        if (p === void 0) {
          var m = dn(w) || "Component";
          $o.has(m) || ($o.add(m), i("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", m));
        }
      };
    }
    function Kd(w, p) {
      {
        var m = w.constructor, b = m && dn(m) || "ReactClass", C = b + "." + p;
        if (Wl[C])
          return;
        i(`%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.

Please check the code for the %s component.`, p, p, b), Wl[C] = !0;
      }
    }
    var Zd = {
      isMounted: function(w) {
        return !1;
      },
      enqueueSetState: function(w, p, m) {
        var b = Vo(w);
        b.queue === null ? Kd(w, "setState") : (b.queue.push(p), m != null && Ho(m, "setState"));
      },
      enqueueReplaceState: function(w, p, m) {
        var b = Vo(w);
        b.replace = !0, b.queue = [p], m != null && Ho(m, "setState");
      },
      enqueueForceUpdate: function(w, p) {
        var m = Vo(w);
        m.queue === null ? Kd(w, "forceUpdate") : p != null && Ho(p, "setState");
      }
    };
    function Zg(w, p, m, b, C) {
      var D = m(C, b);
      Xl(p, D);
      var N = D == null ? b : Oi({}, b, D);
      return N;
    }
    function eh(w, p, m) {
      var b = Hl, C = w.contextType;
      if ("contextType" in w) {
        var D = (
          // Allow null for conditional declaration
          C === null || C !== void 0 && C.$$typeof === Po && C._context === void 0
        );
        if (!D && !Fc.has(w)) {
          Fc.add(w);
          var N = "";
          C === void 0 ? N = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof C != "object" ? N = " However, it is set to a " + typeof C + "." : C.$$typeof === Do ? N = " Did you accidentally pass the Context.Provider instead?" : C._context !== void 0 ? N = " Did you accidentally pass the Context.Consumer instead?" : N = " However, it is set to an object with keys {" + Object.keys(C).join(", ") + "}.", i("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", dn(w) || "Component", N);
        }
      }
      typeof C == "object" && C !== null ? b = Vs(C) : b = m;
      var H = new w(p, b);
      {
        if (typeof w.getDerivedStateFromProps == "function" && (H.state === null || H.state === void 0)) {
          var ne = dn(w) || "Component";
          Yl.has(ne) || (Yl.add(ne), i("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", ne, H.state === null ? "null" : "undefined", ne));
        }
        if (typeof w.getDerivedStateFromProps == "function" || typeof H.getSnapshotBeforeUpdate == "function") {
          var ge = null, Pe = null, Ne = null;
          if (typeof H.componentWillMount == "function" && H.componentWillMount.__suppressDeprecationWarning !== !0 ? ge = "componentWillMount" : typeof H.UNSAFE_componentWillMount == "function" && (ge = "UNSAFE_componentWillMount"), typeof H.componentWillReceiveProps == "function" && H.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? Pe = "componentWillReceiveProps" : typeof H.UNSAFE_componentWillReceiveProps == "function" && (Pe = "UNSAFE_componentWillReceiveProps"), typeof H.componentWillUpdate == "function" && H.componentWillUpdate.__suppressDeprecationWarning !== !0 ? Ne = "componentWillUpdate" : typeof H.UNSAFE_componentWillUpdate == "function" && (Ne = "UNSAFE_componentWillUpdate"), ge !== null || Pe !== null || Ne !== null) {
            var Ze = dn(w) || "Component", Vt = typeof w.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            zo.has(Ze) || (zo.add(Ze), i(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, Ze, Vt, ge !== null ? `
  ` + ge : "", Pe !== null ? `
  ` + Pe : "", Ne !== null ? `
  ` + Ne : ""));
          }
        }
      }
      return H;
    }
    function em(w, p, m) {
      {
        var b = dn(p) || "Component", C = w.render;
        C || (p.prototype && typeof p.prototype.render == "function" ? i("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", b) : i("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", b)), w.getInitialState && !w.getInitialState.isReactClassApproved && !w.state && i("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", b), w.getDefaultProps && !w.getDefaultProps.isReactClassApproved && i("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", b), w.propTypes && i("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", b), w.contextType && i("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", b), w.contextTypes && i("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", b), p.contextType && p.contextTypes && !Kl.has(p) && (Kl.add(p), i("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", b)), typeof w.componentShouldUpdate == "function" && i("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", b), p.prototype && p.prototype.isPureReactComponent && typeof w.shouldComponentUpdate < "u" && i("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", dn(p) || "A pure component"), typeof w.componentDidUnmount == "function" && i("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", b), typeof w.componentDidReceiveProps == "function" && i("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", b), typeof w.componentWillRecieveProps == "function" && i("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", b), typeof w.UNSAFE_componentWillRecieveProps == "function" && i("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", b);
        var D = w.props !== m;
        w.props !== void 0 && D && i("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", b, b), w.defaultProps && i("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", b, b), typeof w.getSnapshotBeforeUpdate == "function" && typeof w.componentDidUpdate != "function" && !zs.has(p) && (zs.add(p), i("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", dn(p))), typeof w.getDerivedStateFromProps == "function" && i("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", b), typeof w.getDerivedStateFromError == "function" && i("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", b), typeof p.getSnapshotBeforeUpdate == "function" && i("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", b);
        var N = w.state;
        N && (typeof N != "object" || Ct(N)) && i("%s.state: must be set to an object or null", b), typeof w.getChildContext == "function" && typeof p.childContextTypes != "object" && i("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", b);
      }
    }
    function tm(w, p) {
      var m = p.state;
      if (typeof p.componentWillMount == "function") {
        if (p.componentWillMount.__suppressDeprecationWarning !== !0) {
          var b = dn(w) || "Unknown";
          Ql[b] || (n(
            // keep this warning in sync with ReactStrictModeWarning.js
            `componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.

Please update the following components: %s`,
            b
          ), Ql[b] = !0);
        }
        p.componentWillMount();
      }
      typeof p.UNSAFE_componentWillMount == "function" && p.UNSAFE_componentWillMount(), m !== p.state && (i("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", dn(w) || "Component"), Zd.enqueueReplaceState(p, p.state, null));
    }
    function Ic(w, p, m, b) {
      if (w.queue !== null && w.queue.length > 0) {
        var C = w.queue, D = w.replace;
        if (w.queue = null, w.replace = !1, D && C.length === 1)
          p.state = C[0];
        else {
          for (var N = D ? C[0] : p.state, H = !0, ne = D ? 1 : 0; ne < C.length; ne++) {
            var ge = C[ne], Pe = typeof ge == "function" ? ge.call(p, N, m, b) : ge;
            Pe != null && (H ? (H = !1, N = Oi({}, N, Pe)) : Oi(N, Pe));
          }
          p.state = N;
        }
      } else
        w.queue = null;
    }
    function jo(w, p, m, b) {
      em(w, p, m);
      var C = w.state !== void 0 ? w.state : null;
      w.updater = Zd, w.props = m, w.state = C;
      var D = {
        queue: [],
        replace: !1
      };
      Tc(w, D);
      var N = p.contextType;
      if (typeof N == "object" && N !== null ? w.context = Vs(N) : w.context = b, w.state === m) {
        var H = dn(p) || "Component";
        Jl.has(H) || (Jl.add(H), i("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", H));
      }
      var ne = p.getDerivedStateFromProps;
      typeof ne == "function" && (w.state = Zg(w, p, ne, C, m)), typeof p.getDerivedStateFromProps != "function" && typeof w.getSnapshotBeforeUpdate != "function" && (typeof w.UNSAFE_componentWillMount == "function" || typeof w.componentWillMount == "function") && (tm(p, w), Ic(D, w, m, b));
    }
    var rm = {
      id: 1,
      overflow: ""
    };
    function nm(w) {
      var p = w.overflow, m = w.id, b = m & ~im(m);
      return b.toString(32) + p;
    }
    function Dc(w, p, m) {
      var b = w.id, C = w.overflow, D = Zl(b) - 1, N = b & ~(1 << D), H = m + 1, ne = Zl(p) + D;
      if (ne > 30) {
        var ge = D - D % 5, Pe = (1 << ge) - 1, Ne = (N & Pe).toString(32), Ze = N >> ge, Vt = D - ge, Dr = Zl(p) + Vt, si = H << Vt, ws = si | Ze, xs = Ne + C;
        return {
          id: 1 << Dr | ws,
          overflow: xs
        };
      } else {
        var xa = H << D, Qs = xa | N, Bm = C;
        return {
          id: 1 << ne | Qs,
          overflow: Bm
        };
      }
    }
    function Zl(w) {
      return 32 - am(w);
    }
    function im(w) {
      return 1 << Zl(w) - 1;
    }
    var am = Math.clz32 ? Math.clz32 : Pc, sm = Math.log, ya = Math.LN2;
    function Pc(w) {
      var p = w >>> 0;
      return p === 0 ? 32 : 31 - (sm(p) / ya | 0) | 0;
    }
    function eu(w, p) {
      return w === p && (w !== 0 || 1 / w === 1 / p) || w !== w && p !== p;
    }
    var ln = typeof Object.is == "function" ? Object.is : eu, Bi = null, $s = null, gs = null, Ir = null, Ha = !1, tu = !1, Mi = 0, _i = null, ua = 0, om = 25, Xi = !1, ja;
    function ms() {
      if (Bi === null)
        throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
      return Xi && i("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks"), Bi;
    }
    function lm(w, p) {
      if (p === null)
        return i("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", ja), !1;
      w.length !== p.length && i(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, ja, "[" + w.join(", ") + "]", "[" + p.join(", ") + "]");
      for (var m = 0; m < p.length && m < w.length; m++)
        if (!ln(w[m], p[m]))
          return !1;
      return !0;
    }
    function Rc() {
      if (ua > 0)
        throw new Error("Rendered more hooks than during the previous render");
      return {
        memoizedState: null,
        queue: null,
        next: null
      };
    }
    function Go() {
      return Ir === null ? gs === null ? (Ha = !1, gs = Ir = Rc()) : (Ha = !0, Ir = gs) : Ir.next === null ? (Ha = !1, Ir = Ir.next = Rc()) : (Ha = !0, Ir = Ir.next), Ir;
    }
    function um(w, p) {
      Bi = p, $s = w, Xi = !1, Mi = 0;
    }
    function cm(w, p, m, b) {
      for (; tu; )
        tu = !1, Mi = 0, ua += 1, Ir = null, m = w(p, b);
      return Oc(), m;
    }
    function ru() {
      var w = Mi !== 0;
      return w;
    }
    function Oc() {
      Xi = !1, Bi = null, $s = null, tu = !1, gs = null, ua = 0, _i = null, Ir = null;
    }
    function th(w) {
      return Xi && i("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."), Vs(w);
    }
    function rh(w) {
      return ja = "useContext", ms(), Vs(w);
    }
    function Bc(w, p) {
      return typeof p == "function" ? p(w) : p;
    }
    function fm(w) {
      return ja = "useState", nh(
        Bc,
        // useReducer has a special case to support lazy useState initializers
        w
      );
    }
    function nh(w, p, m) {
      if (w !== Bc && (ja = "useReducer"), Bi = ms(), Ir = Go(), Ha) {
        var b = Ir.queue, C = b.dispatch;
        if (_i !== null) {
          var D = _i.get(b);
          if (D !== void 0) {
            _i.delete(b);
            var N = Ir.memoizedState, H = D;
            do {
              var ne = H.action;
              Xi = !0, N = w(N, ne), Xi = !1, H = H.next;
            } while (H !== null);
            return Ir.memoizedState = N, [N, C];
          }
        }
        return [Ir.memoizedState, C];
      } else {
        Xi = !0;
        var ge;
        w === Bc ? ge = typeof p == "function" ? p() : p : ge = m !== void 0 ? m(p) : p, Xi = !1, Ir.memoizedState = ge;
        var Pe = Ir.queue = {
          last: null,
          dispatch: null
        }, Ne = Pe.dispatch = pm.bind(null, Bi, Pe);
        return [Ir.memoizedState, Ne];
      }
    }
    function ih(w, p) {
      Bi = ms(), Ir = Go();
      var m = p === void 0 ? null : p;
      if (Ir !== null) {
        var b = Ir.memoizedState;
        if (b !== null && m !== null) {
          var C = b[1];
          if (lm(m, C))
            return b[0];
        }
      }
      Xi = !0;
      var D = w();
      return Xi = !1, Ir.memoizedState = [D, m], D;
    }
    function dm(w) {
      Bi = ms(), Ir = Go();
      var p = Ir.memoizedState;
      if (p === null) {
        var m = {
          current: w
        };
        return Object.seal(m), Ir.memoizedState = m, m;
      } else
        return p;
    }
    function hm(w, p) {
      ja = "useLayoutEffect", i("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://reactjs.org/link/uselayouteffect-ssr for common fixes.");
    }
    function pm(w, p, m) {
      if (ua >= om)
        throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
      if (w === Bi) {
        tu = !0;
        var b = {
          action: m,
          next: null
        };
        _i === null && (_i = /* @__PURE__ */ new Map());
        var C = _i.get(p);
        if (C === void 0)
          _i.set(p, b);
        else {
          for (var D = C; D.next !== null; )
            D = D.next;
          D.next = b;
        }
      }
    }
    function gm(w, p) {
      return ih(function() {
        return w;
      }, p);
    }
    function mm(w, p, m) {
      return ms(), p(w._source);
    }
    function vm(w, p, m) {
      if (m === void 0)
        throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
      return m();
    }
    function nu(w) {
      return ms(), w;
    }
    function ah() {
      throw new Error("startTransition cannot be called during server rendering.");
    }
    function Mc() {
      return ms(), [!1, ah];
    }
    function sh() {
      var w = $s, p = nm(w.treeContext), m = qo;
      if (m === null)
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component.");
      var b = Mi++;
      return mn(m, p, b);
    }
    function iu() {
    }
    var au = {
      readContext: th,
      useContext: rh,
      useMemo: ih,
      useReducer: nh,
      useRef: dm,
      useState: fm,
      useInsertionEffect: iu,
      useLayoutEffect: hm,
      useCallback: gm,
      // useImperativeHandle is not run in the server environment
      useImperativeHandle: iu,
      // Effects are not run in the server environment.
      useEffect: iu,
      // Debugging effect
      useDebugValue: iu,
      useDeferredValue: nu,
      useTransition: Mc,
      useId: sh,
      // Subscriptions are not setup in a server environment.
      useMutableSource: mm,
      useSyncExternalStore: vm
    }, qo = null;
    function su(w) {
      qo = w;
    }
    function Hs(w) {
      try {
        var p = "", m = w;
        do {
          switch (m.tag) {
            case 0:
              p += ds(m.type, null, null);
              break;
            case 1:
              p += Sc(m.type, null, null);
              break;
            case 2:
              p += Gd(m.type, null, null);
              break;
          }
          m = m.parent;
        } while (m);
        return p;
      } catch (b) {
        return `
Error generating stack: ` + b.message + `
` + b.stack;
      }
    }
    var ou = t.ReactCurrentDispatcher, lu = t.ReactDebugCurrentFrame, uu = 0, js = 1, _c = 2, vs = 3, oh = 4, ym = 0, Gs = 1, qs = 2, Am = 12800;
    function bm(w) {
      return console.error(w), null;
    }
    function ys() {
    }
    function cu(w, p, m, b, C, D, N, H, ne) {
      var ge = [], Pe = /* @__PURE__ */ new Set(), Ne = {
        destination: null,
        responseState: p,
        progressiveChunkSize: b === void 0 ? Am : b,
        status: ym,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: Pe,
        pingedTasks: ge,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: C === void 0 ? bm : C,
        onAllReady: D === void 0 ? ys : D,
        onShellReady: N === void 0 ? ys : N,
        onShellError: H === void 0 ? ys : H,
        onFatalError: ne === void 0 ? ys : ne
      }, Ze = Wo(
        Ne,
        0,
        null,
        m,
        // Root segments are never embedded in Text on either edge
        !1,
        !1
      );
      Ze.parentFlushed = !0;
      var Vt = As(Ne, w, null, Ze, Pe, Hl, jl, rm);
      return ge.push(Vt), Ne;
    }
    function Aa(w, p) {
      var m = w.pingedTasks;
      m.push(p), m.length === 1 && s(function() {
        return Wc(w);
      });
    }
    function Nc(w, p) {
      return {
        id: ii,
        rootSegmentID: -1,
        parentFlushed: !1,
        pendingTasks: 0,
        forceClientRender: !1,
        completedSegments: [],
        byteSize: 0,
        fallbackAbortableTasks: p,
        errorDigest: null
      };
    }
    function As(w, p, m, b, C, D, N, H) {
      w.allPendingTasks++, m === null ? w.pendingRootTasks++ : m.pendingTasks++;
      var ne = {
        node: p,
        ping: function() {
          return Aa(w, ne);
        },
        blockedBoundary: m,
        blockedSegment: b,
        abortSet: C,
        legacyContext: D,
        context: N,
        treeContext: H
      };
      return ne.componentStack = null, C.add(ne), ne;
    }
    function Wo(w, p, m, b, C, D) {
      return {
        status: uu,
        id: -1,
        // lazily assigned later
        index: p,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: b,
        boundary: m,
        lastPushedText: C,
        textEmbedded: D
      };
    }
    var ba = null;
    function ca() {
      return ba === null || ba.componentStack === null ? "" : Hs(ba.componentStack);
    }
    function wa(w, p) {
      w.componentStack = {
        tag: 0,
        parent: w.componentStack,
        type: p
      };
    }
    function fu(w, p) {
      w.componentStack = {
        tag: 1,
        parent: w.componentStack,
        type: p
      };
    }
    function Qo(w, p) {
      w.componentStack = {
        tag: 2,
        parent: w.componentStack,
        type: p
      };
    }
    function Ji(w) {
      w.componentStack === null ? i("Unexpectedly popped too many stack frames. This is a bug in React.") : w.componentStack = w.componentStack.parent;
    }
    var Yo = null;
    function Lc(w, p) {
      {
        var m;
        typeof p == "string" ? m = p : p && typeof p.message == "string" ? m = p.message : m = String(p);
        var b = Yo || ca();
        Yo = null, w.errorMessage = m, w.errorComponentStack = b;
      }
    }
    function Xo(w, p) {
      var m = w.onError(p);
      if (m != null && typeof m != "string")
        throw new Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof m + '" instead');
      return m;
    }
    function Jo(w, p) {
      var m = w.onShellError;
      m(p);
      var b = w.onFatalError;
      b(p), w.destination !== null ? (w.status = qs, x(w.destination, p)) : (w.status = Gs, w.fatalError = p);
    }
    function lh(w, p, m) {
      wa(p, "Suspense");
      var b = p.blockedBoundary, C = p.blockedSegment, D = m.fallback, N = m.children, H = /* @__PURE__ */ new Set(), ne = Nc(w, H), ge = C.chunks.length, Pe = Wo(
        w,
        ge,
        ne,
        C.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      C.children.push(Pe), C.lastPushedText = !1;
      var Ne = Wo(
        w,
        0,
        null,
        C.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      Ne.parentFlushed = !0, p.blockedBoundary = ne, p.blockedSegment = Ne;
      try {
        if (Ws(w, p, N), on(Ne.chunks, w.responseState, Ne.lastPushedText, Ne.textEmbedded), Ne.status = js, bs(ne, Ne), ne.pendingTasks === 0) {
          Ji(p);
          return;
        }
      } catch (Vt) {
        Ne.status = oh, ne.forceClientRender = !0, ne.errorDigest = Xo(w, Vt), Lc(ne, Vt);
      } finally {
        p.blockedBoundary = b, p.blockedSegment = C;
      }
      var Ze = As(w, D, b, Pe, H, p.legacyContext, p.context, p.treeContext);
      Ze.componentStack = p.componentStack, w.pingedTasks.push(Ze), Ji(p);
    }
    function wm(w, p, m, b) {
      wa(p, m);
      var C = p.blockedSegment, D = Ht(C.chunks, m, b, w.responseState, C.formatContext);
      C.lastPushedText = !1;
      var N = C.formatContext;
      C.formatContext = Jn(N, m, b), Ws(w, p, D), C.formatContext = N, B(C.chunks, m), C.lastPushedText = !1, Ji(p);
    }
    function uh(w) {
      return w.prototype && w.prototype.isReactComponent;
    }
    function Ko(w, p, m, b, C) {
      var D = {};
      um(p, D);
      var N = m(b, C);
      return cm(m, b, N, C);
    }
    function Uc(w, p, m, b, C) {
      var D = m.render();
      m.props !== C && (Hc || i("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", dn(b) || "a component"), Hc = !0);
      {
        var N = b.childContextTypes;
        if (N != null) {
          var H = p.legacyContext, ne = Ec(m, b, H, N);
          p.legacyContext = ne, wi(w, p, D), p.legacyContext = H;
          return;
        }
      }
      wi(w, p, D);
    }
    function ch(w, p, m, b) {
      Qo(p, m);
      var C = Va(m, p.legacyContext), D = eh(m, b, C);
      jo(D, m, b, C), Uc(w, p, D, m, b), Ji(p);
    }
    var Vc = {}, Zo = {}, zc = {}, $c = {}, Hc = !1, fh = {}, dh = !1, jc = !1, hh = !1;
    function xm(w, p, m, b) {
      var C;
      if (C = Va(m, p.legacyContext), fu(p, m), m.prototype && typeof m.prototype.render == "function") {
        var D = dn(m) || "Unknown";
        Vc[D] || (i("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", D, D), Vc[D] = !0);
      }
      var N = Ko(w, p, m, b, C), H = ru();
      if (typeof N == "object" && N !== null && typeof N.render == "function" && N.$$typeof === void 0) {
        var ne = dn(m) || "Unknown";
        Zo[ne] || (i("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", ne, ne, ne), Zo[ne] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof N == "object" && N !== null && typeof N.render == "function" && N.$$typeof === void 0
      ) {
        {
          var ge = dn(m) || "Unknown";
          Zo[ge] || (i("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", ge, ge, ge), Zo[ge] = !0);
        }
        jo(N, m, b, C), Uc(w, p, N, m, b);
      } else if (Cm(m), H) {
        var Pe = p.treeContext, Ne = 1, Ze = 0;
        p.treeContext = Dc(Pe, Ne, Ze);
        try {
          wi(w, p, N);
        } finally {
          p.treeContext = Pe;
        }
      } else
        wi(w, p, N);
      Ji(p);
    }
    function Cm(w) {
      {
        if (w && w.childContextTypes && i("%s(...): childContextTypes cannot be defined on a function component.", w.displayName || w.name || "Component"), w.defaultProps !== void 0) {
          var p = dn(w) || "Unknown";
          fh[p] || (i("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", p), fh[p] = !0);
        }
        if (typeof w.getDerivedStateFromProps == "function") {
          var m = dn(w) || "Unknown";
          $c[m] || (i("%s: Function components do not support getDerivedStateFromProps.", m), $c[m] = !0);
        }
        if (typeof w.contextType == "object" && w.contextType !== null) {
          var b = dn(w) || "Unknown";
          zc[b] || (i("%s: Function components do not support contextType.", b), zc[b] = !0);
        }
      }
    }
    function ph(w, p) {
      if (w && w.defaultProps) {
        var m = Oi({}, p), b = w.defaultProps;
        for (var C in b)
          m[C] === void 0 && (m[C] = b[C]);
        return m;
      }
      return p;
    }
    function Sm(w, p, m, b, C) {
      fu(p, m.render);
      var D = Ko(w, p, m.render, b, C), N = ru();
      if (N) {
        var H = p.treeContext, ne = 1, ge = 0;
        p.treeContext = Dc(H, ne, ge);
        try {
          wi(w, p, D);
        } finally {
          p.treeContext = H;
        }
      } else
        wi(w, p, D);
      Ji(p);
    }
    function Gc(w, p, m, b, C) {
      var D = m.type, N = ph(D, b);
      du(w, p, D, N, C);
    }
    function Em(w, p, m, b) {
      m._context === void 0 ? m !== m.Consumer && (hh || (hh = !0, i("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : m = m._context;
      var C = b.children;
      typeof C != "function" && i("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
      var D = Vs(m), N = C(D);
      wi(w, p, N);
    }
    function Ni(w, p, m, b) {
      var C = m._context, D = b.value, N = b.children, H;
      H = p.context, p.context = kc(C, D), wi(w, p, N), p.context = Kg(C), H !== p.context && i("Popping the context provider did not return back to the original snapshot. This is a bug in React.");
    }
    function km(w, p, m, b, C) {
      wa(p, "Lazy");
      var D = m._payload, N = m._init, H = N(D), ne = ph(H, b);
      du(w, p, H, ne, C), Ji(p);
    }
    function du(w, p, m, b, C) {
      if (typeof m == "function")
        if (uh(m)) {
          ch(w, p, m, b);
          return;
        } else {
          xm(w, p, m, b);
          return;
        }
      if (typeof m == "string") {
        wm(w, p, m, b);
        return;
      }
      switch (m) {
        // TODO: LegacyHidden acts the same as a fragment. This only works
        // because we currently assume that every instance of LegacyHidden is
        // accompanied by a host component wrapper. In the hidden mode, the host
        // component is given a `hidden` attribute, which ensures that the
        // initial HTML is not visible. To support the use of LegacyHidden as a
        // true fragment, without an extra DOM node, we would have to hide the
        // initial HTML in some other way.
        // TODO: Add REACT_OFFSCREEN_TYPE here too with the same capability.
        case Yg:
        case Qg:
        case Ml:
        case _l:
        case Bl: {
          wi(w, p, b.children);
          return;
        }
        case hc: {
          wa(p, "SuspenseList"), wi(w, p, b.children), Ji(p);
          return;
        }
        case zd:
          throw new Error("ReactDOMServer does not yet support scope components.");
        // eslint-disable-next-line-no-fallthrough
        case dc: {
          lh(w, p, b);
          return;
        }
      }
      if (typeof m == "object" && m !== null)
        switch (m.$$typeof) {
          case Ns: {
            Sm(w, p, m, b, C);
            return;
          }
          case pc: {
            Gc(w, p, m, b, C);
            return;
          }
          case Do: {
            Ni(w, p, m, b);
            return;
          }
          case Po: {
            Em(w, p, m, b);
            return;
          }
          case Nl: {
            km(w, p, m, b);
            return;
          }
        }
      var D = "";
      throw (m === void 0 || typeof m == "object" && m !== null && Object.keys(m).length === 0) && (D += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (m == null ? m : typeof m) + "." + D));
    }
    function Tm(w, p) {
      typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
      w[Symbol.toStringTag] === "Generator" && (dh || i("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), dh = !0), w.entries === p && (jc || i("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), jc = !0);
    }
    function wi(w, p, m) {
      try {
        return Fm(w, p, m);
      } catch (b) {
        throw typeof b == "object" && b !== null && typeof b.then == "function" || (Yo = Yo !== null ? Yo : ca()), b;
      }
    }
    function Fm(w, p, m) {
      if (p.node = m, typeof m == "object" && m !== null) {
        switch (m.$$typeof) {
          case Vd: {
            var b = m, C = b.type, D = b.props, N = b.ref;
            du(w, p, C, D, N);
            return;
          }
          case Ol:
            throw new Error("Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render.");
          // eslint-disable-next-line-no-fallthrough
          case Nl: {
            var H = m, ne = H._payload, ge = H._init, Pe;
            try {
              Pe = ge(ne);
            } catch (xa) {
              throw typeof xa == "object" && xa !== null && typeof xa.then == "function" && wa(p, "Lazy"), xa;
            }
            wi(w, p, Pe);
            return;
          }
        }
        if (Ct(m)) {
          gh(w, p, m);
          return;
        }
        var Ne = Ro(m);
        if (Ne) {
          Tm(m, Ne);
          var Ze = Ne.call(m);
          if (Ze) {
            var Vt = Ze.next();
            if (!Vt.done) {
              var Dr = [];
              do
                Dr.push(Vt.value), Vt = Ze.next();
              while (!Vt.done);
              gh(w, p, Dr);
              return;
            }
            return;
          }
        }
        var si = Object.prototype.toString.call(m);
        throw new Error("Objects are not valid as a React child (found: " + (si === "[object Object]" ? "object with keys {" + Object.keys(m).join(", ") + "}" : si) + "). If you meant to render a collection of children, use an array instead.");
      }
      if (typeof m == "string") {
        var ws = p.blockedSegment;
        ws.lastPushedText = Lr(p.blockedSegment.chunks, m, w.responseState, ws.lastPushedText);
        return;
      }
      if (typeof m == "number") {
        var xs = p.blockedSegment;
        xs.lastPushedText = Lr(p.blockedSegment.chunks, "" + m, w.responseState, xs.lastPushedText);
        return;
      }
      typeof m == "function" && i("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function gh(w, p, m) {
      for (var b = m.length, C = 0; C < b; C++) {
        var D = p.treeContext;
        p.treeContext = Dc(D, b, C);
        try {
          Ws(w, p, m[C]);
        } finally {
          p.treeContext = D;
        }
      }
    }
    function mh(w, p, m) {
      var b = p.blockedSegment, C = b.chunks.length, D = Wo(
        w,
        C,
        null,
        b.formatContext,
        // Adopt the parent segment's leading text embed
        b.lastPushedText,
        // Assume we are text embedded at the trailing edge
        !0
      );
      b.children.push(D), b.lastPushedText = !1;
      var N = As(w, p.node, p.blockedBoundary, D, p.abortSet, p.legacyContext, p.context, p.treeContext);
      p.componentStack !== null && (N.componentStack = p.componentStack.parent);
      var H = N.ping;
      m.then(H, H);
    }
    function Ws(w, p, m) {
      var b = p.blockedSegment.formatContext, C = p.legacyContext, D = p.context, N = null;
      N = p.componentStack;
      try {
        return wi(w, p, m);
      } catch (H) {
        if (Oc(), typeof H == "object" && H !== null && typeof H.then == "function") {
          mh(w, p, H), p.blockedSegment.formatContext = b, p.legacyContext = C, p.context = D, $a(D), p.componentStack = N;
          return;
        } else
          throw p.blockedSegment.formatContext = b, p.legacyContext = C, p.context = D, $a(D), p.componentStack = N, H;
      }
    }
    function vh(w, p, m, b) {
      var C = Xo(w, b);
      if (p === null ? Jo(w, b) : (p.pendingTasks--, p.forceClientRender || (p.forceClientRender = !0, p.errorDigest = C, Lc(p, b), p.parentFlushed && w.clientRenderedBoundaries.push(p))), w.allPendingTasks--, w.allPendingTasks === 0) {
        var D = w.onAllReady;
        D();
      }
    }
    function Im(w) {
      var p = this, m = w.blockedBoundary, b = w.blockedSegment;
      b.status = vs, el(p, m, b);
    }
    function qc(w, p, m) {
      var b = w.blockedBoundary, C = w.blockedSegment;
      if (C.status = vs, b === null)
        p.allPendingTasks--, p.status !== qs && (p.status = qs, p.destination !== null && g(p.destination));
      else {
        if (b.pendingTasks--, !b.forceClientRender) {
          b.forceClientRender = !0;
          var D = m === void 0 ? new Error("The render was aborted by the server without a reason.") : m;
          b.errorDigest = p.onError(D);
          {
            var N = "The server did not finish this Suspense boundary: ";
            D && typeof D.message == "string" ? D = N + D.message : D = N + String(D);
            var H = ba;
            ba = w;
            try {
              Lc(b, D);
            } finally {
              ba = H;
            }
          }
          b.parentFlushed && p.clientRenderedBoundaries.push(b);
        }
        if (b.fallbackAbortableTasks.forEach(function(ge) {
          return qc(ge, p, m);
        }), b.fallbackAbortableTasks.clear(), p.allPendingTasks--, p.allPendingTasks === 0) {
          var ne = p.onAllReady;
          ne();
        }
      }
    }
    function bs(w, p) {
      if (p.chunks.length === 0 && p.children.length === 1 && p.children[0].boundary === null) {
        var m = p.children[0];
        m.id = p.id, m.parentFlushed = !0, m.status === js && bs(w, m);
      } else {
        var b = w.completedSegments;
        b.push(p);
      }
    }
    function el(w, p, m) {
      if (p === null) {
        if (m.parentFlushed) {
          if (w.completedRootSegment !== null)
            throw new Error("There can only be one root segment. This is a bug in React.");
          w.completedRootSegment = m;
        }
        if (w.pendingRootTasks--, w.pendingRootTasks === 0) {
          w.onShellError = ys;
          var b = w.onShellReady;
          b();
        }
      } else if (p.pendingTasks--, !p.forceClientRender) {
        if (p.pendingTasks === 0)
          m.parentFlushed && m.status === js && bs(p, m), p.parentFlushed && w.completedBoundaries.push(p), p.fallbackAbortableTasks.forEach(Im, w), p.fallbackAbortableTasks.clear();
        else if (m.parentFlushed && m.status === js) {
          bs(p, m);
          var C = p.completedSegments;
          C.length === 1 && p.parentFlushed && w.partialBoundaries.push(p);
        }
      }
      if (w.allPendingTasks--, w.allPendingTasks === 0) {
        var D = w.onAllReady;
        D();
      }
    }
    function Dm(w, p) {
      var m = p.blockedSegment;
      if (m.status === uu) {
        $a(p.context);
        var b = null;
        b = ba, ba = p;
        try {
          wi(w, p, p.node), on(m.chunks, w.responseState, m.lastPushedText, m.textEmbedded), p.abortSet.delete(p), m.status = js, el(w, p.blockedBoundary, m);
        } catch (D) {
          if (Oc(), typeof D == "object" && D !== null && typeof D.then == "function") {
            var C = p.ping;
            D.then(C, C);
          } else
            p.abortSet.delete(p), m.status = oh, vh(w, p.blockedBoundary, m, D);
        } finally {
          ba = b;
        }
      }
    }
    function Wc(w) {
      if (w.status !== qs) {
        var p = Xd(), m = ou.current;
        ou.current = au;
        var b;
        b = lu.getCurrentStack, lu.getCurrentStack = ca;
        var C = qo;
        su(w.responseState);
        try {
          var D = w.pingedTasks, N;
          for (N = 0; N < D.length; N++) {
            var H = D[N];
            Dm(w, H);
          }
          D.splice(0, N), w.destination !== null && Qc(w, w.destination);
        } catch (ne) {
          Xo(w, ne), Jo(w, ne);
        } finally {
          su(C), ou.current = m, lu.getCurrentStack = b, m === au && $a(p);
        }
      }
    }
    function tl(w, p, m) {
      switch (m.parentFlushed = !0, m.status) {
        case uu: {
          var b = m.id = w.nextSegmentId++;
          return m.lastPushedText = !1, m.textEmbedded = !1, Me(p, w.responseState, b);
        }
        case js: {
          m.status = _c;
          for (var C = !0, D = m.chunks, N = 0, H = m.children, ne = 0; ne < H.length; ne++) {
            for (var ge = H[ne]; N < ge.index; N++)
              d(p, D[N]);
            C = hu(w, p, ge);
          }
          for (; N < D.length - 1; N++)
            d(p, D[N]);
          return N < D.length && (C = f(p, D[N])), C;
        }
        default:
          throw new Error("Aborted, errored or already flushed boundaries should not be flushed again. This is a bug in React.");
      }
    }
    function hu(w, p, m) {
      var b = m.boundary;
      if (b === null)
        return tl(w, p, m);
      if (b.parentFlushed = !0, b.forceClientRender)
        return qn(p, w.responseState, b.errorDigest, b.errorMessage, b.errorComponentStack), tl(w, p, m), Na(p, w.responseState);
      if (b.pendingTasks > 0) {
        b.rootSegmentID = w.nextSegmentId++, b.completedSegments.length > 0 && w.partialBoundaries.push(b);
        var C = b.id = Sn(w.responseState);
        return Qi(p, w.responseState, C), tl(w, p, m), di(p, w.responseState);
      } else {
        if (b.byteSize > w.progressiveChunkSize)
          return b.rootSegmentID = w.nextSegmentId++, w.completedBoundaries.push(b), Qi(p, w.responseState, b.id), tl(w, p, m), di(p, w.responseState);
        aa(p, w.responseState);
        var D = b.completedSegments;
        if (D.length !== 1)
          throw new Error("A previously unvisited boundary must have exactly one root segment. This is a bug in React.");
        var N = D[0];
        return hu(w, p, N), Yi(p, w.responseState);
      }
    }
    function yh(w, p, m) {
      return Wg(p, w.responseState, m.id, m.errorDigest, m.errorMessage, m.errorComponentStack);
    }
    function pu(w, p, m) {
      return qt(p, w.responseState, m.formatContext, m.id), hu(w, p, m), qr(p, m.formatContext);
    }
    function Ah(w, p, m) {
      for (var b = m.completedSegments, C = 0; C < b.length; C++) {
        var D = b[C];
        bh(w, p, m, D);
      }
      return b.length = 0, Io(p, w.responseState, m.id, m.rootSegmentID);
    }
    function Pm(w, p, m) {
      for (var b = m.completedSegments, C = 0; C < b.length; C++) {
        var D = b[C];
        if (!bh(w, p, m, D))
          return C++, b.splice(0, C), !1;
      }
      return b.splice(0, C), !0;
    }
    function bh(w, p, m, b) {
      if (b.status === _c)
        return !0;
      var C = b.id;
      if (C === -1) {
        var D = b.id = m.rootSegmentID;
        if (D === -1)
          throw new Error("A root segment ID must have been assigned by now. This is a bug in React.");
        return pu(w, p, b);
      } else
        return pu(w, p, b), Vn(p, w.responseState, C);
    }
    function Qc(w, p) {
      c();
      try {
        var m = w.completedRootSegment;
        m !== null && w.pendingRootTasks === 0 && (hu(w, p, m), w.completedRootSegment = null, Z(p, w.responseState));
        var b = w.clientRenderedBoundaries, C;
        for (C = 0; C < b.length; C++) {
          var D = b[C];
          yh(w, p, D);
        }
        b.splice(0, C);
        var N = w.completedBoundaries;
        for (C = 0; C < N.length; C++) {
          var H = N[C];
          Ah(w, p, H);
        }
        N.splice(0, C), h(p), c(p);
        var ne = w.partialBoundaries;
        for (C = 0; C < ne.length; C++) {
          var ge = ne[C];
          if (!Pm(w, p, ge)) {
            w.destination = null, C++, ne.splice(0, C);
            return;
          }
        }
        ne.splice(0, C);
        var Pe = w.completedBoundaries;
        for (C = 0; C < Pe.length; C++) {
          var Ne = Pe[C];
          Ah(w, p, Ne);
        }
        Pe.splice(0, C);
      } finally {
        h(p), w.allPendingTasks === 0 && w.pingedTasks.length === 0 && w.clientRenderedBoundaries.length === 0 && w.completedBoundaries.length === 0 && (w.abortableTasks.size !== 0 && i("There was still abortable task at the root when we closed. This is a bug in React."), g(p));
      }
    }
    function wh(w) {
      s(function() {
        return Wc(w);
      });
    }
    function Rm(w, p) {
      if (w.status === Gs) {
        w.status = qs, x(p, w.fatalError);
        return;
      }
      if (w.status !== qs && w.destination === null) {
        w.destination = p;
        try {
          Qc(w, p);
        } catch (m) {
          Xo(w, m), Jo(w, m);
        }
      }
    }
    function xh(w, p) {
      try {
        var m = w.abortableTasks;
        m.forEach(function(b) {
          return qc(b, w, p);
        }), m.clear(), w.destination !== null && Qc(w, w.destination);
      } catch (b) {
        Xo(w, b), Jo(w, b);
      }
    }
    function Om(w, p) {
      return new Promise(function(m, b) {
        var C, D, N = new Promise(function(Ze, Vt) {
          D = Ze, C = Vt;
        });
        function H() {
          var Ze = new ReadableStream(
            {
              type: "bytes",
              pull: function(Vt) {
                Rm(ge, Vt);
              },
              cancel: function(Vt) {
                xh(ge);
              }
            },
            // $FlowFixMe size() methods are not allowed on byte streams.
            {
              highWaterMark: 0
            }
          );
          Ze.allReady = N, m(Ze);
        }
        function ne(Ze) {
          N.catch(function() {
          }), b(Ze);
        }
        var ge = cu(w, Fn(p ? p.identifierPrefix : void 0, p ? p.nonce : void 0, p ? p.bootstrapScriptContent : void 0, p ? p.bootstrapScripts : void 0, p ? p.bootstrapModules : void 0), tn(p ? p.namespaceURI : void 0), p ? p.progressiveChunkSize : void 0, p ? p.onError : void 0, D, H, ne, C);
        if (p && p.signal) {
          var Pe = p.signal, Ne = function() {
            xh(ge, Pe.reason), Pe.removeEventListener("abort", Ne);
          };
          Pe.addEventListener("abort", Ne);
        }
        wh(ge);
      });
    }
    Ih.renderToReadableStream = Om, Ih.version = e;
  })()), Ih;
}
var Vw;
function k4() {
  if (Vw) return Ys;
  Vw = 1;
  var r, e;
  return process.env.NODE_ENV === "production" ? (r = x4(), e = C4()) : (r = S4(), e = E4()), Ys.version = r.version, Ys.renderToString = r.renderToString, Ys.renderToStaticMarkup = r.renderToStaticMarkup, Ys.renderToNodeStream = r.renderToNodeStream, Ys.renderToStaticNodeStream = r.renderToStaticNodeStream, Ys.renderToReadableStream = e.renderToReadableStream, Ys;
}
var T4 = k4();
let gy, my;
function iQ(r) {
  gy = r;
}
function aQ(r) {
  my = r;
}
function Ed() {
  return gy ? new gy().window : (console.log(
    "DOM constructor is not registered. Assuming browser environment. If not, please register DOM constructor before calling this function."
  ), window);
}
function Ms(r, e) {
  if (!my) {
    if (typeof window < "u" && window.fetch)
      return window.fetch(r, e);
    if (typeof global < "u" && global.fetch)
      return global.fetch(r, e);
    throw new Error("Fetch implementation is not registered. Please register it before calling this function.");
  }
  return my(r, e);
}
const bk = /* @__PURE__ */ new Map(), zw = /* @__PURE__ */ new Map(), $w = /* @__PURE__ */ new Map(), wk = async (r) => {
  const e = zw.get(r);
  if (e) return e;
  const n = (async () => {
    const i = await Ms(r);
    return bk.set(r, i.headers?.get("content-type") || ""), await i.arrayBuffer();
  })();
  return zw.set(r, n), n;
}, F4 = async (r) => {
  const e = $w.get(r);
  if (e) return e;
  const n = (async () => await (await Ms(r)).text())();
  return $w.set(r, n), n;
}, ac = (r) => r.every((e) => e !== "undefined"), Dh = (r) => ac([typeof document]) ? document.createElement(r) : Ed().document.createElement(r), I4 = (r, e) => {
  if (ac([typeof document]))
    return document.createElementNS(r, e);
  const n = Ed().document.createElement(e);
  return n.setAttribute("xmlns", r), n;
}, _s = () => {
  if (ac([typeof DOMParser]))
    return new DOMParser();
  const r = Ed();
  return new r.DOMParser();
}, D4 = () => ac([typeof DOMParser]) ? DOMParser : Ed().DOMParser, Fg = (r, e) => new Promise((t, n) => {
  e ? wk(r).then(t).catch(n) : Ms(r).then((i) => {
    i.arrayBuffer().then(t).catch(n);
  }).catch((i) => {
    n(i);
  });
}), ha = (r, e) => new Promise((t, n) => {
  e ? F4(r).then(t).catch(n) : Ms(r).then((i) => {
    i.text().then(t).catch(n);
  }).catch(n);
}), xk = (r) => T4.renderToStaticMarkup(r), Zm = /* @__PURE__ */ new Map(), P4 = async (r, e) => {
  if (ac([typeof FontFace])) {
    if (Zm.has(e))
      return Zm.get(e);
    const t = r.names.fullName.en, n = new FontFace(t, `url(${e})`);
    document.fonts.add(n);
    const i = n.load();
    return Zm.set(e, i), i;
  }
}, El = () => {
  if (ac([typeof XMLSerializer]))
    return new XMLSerializer();
  const r = Ed();
  return new r.XMLSerializer();
}, Hw = (r) => btoa(r), Ig = (r) => {
  function e() {
    const n = new Uint8Array(r), i = 4;
    if (n.length >= i) {
      const a = new Array(i);
      for (let l = 0; l < i; l++) a[l] = new Uint8Array(r)[l].toString(16);
      const s = a.join("").toUpperCase();
      switch (s) {
        case "89504E47":
          return "image/png";
        case "47494638":
          return "image/gif";
        case "25504446":
          return "application/pdf";
        case "504B0304":
          return "application/zip";
      }
      if (s.slice(0, 4) === "FFD8")
        return "image/jpeg";
    }
    return null;
  }
  const t = e();
  return t || "image/svg+xml";
}, sQ = async (r) => {
  const e = await wk(r), t = bk.get(r) || Ig(e);
  return await B4(new Blob([e], { type: t }));
}, R4 = (r) => {
  let e = "";
  const t = r.byteLength;
  for (let n = 0; n < t; n++)
    e += String.fromCharCode(r[n]);
  return e;
}, O4 = async (r) => {
  const e = Ig(r), t = new Uint8Array(r), n = R4(t), i = btoa(n);
  return `data:${e};base64,${i}`;
}, DA = (r) => `data:image/svg+xml;base64,${btoa(r)}`, Ck = (r) => {
  const e = r.replace(/\r?\n/g, ""), t = e.indexOf(",");
  if (t === -1 || t <= 4)
    throw new TypeError("malformed data: URI");
  const n = e.substring(5, t).split(";");
  let i = !1;
  for (let s = 1; s < n.length; s++)
    n[s] === "base64" && (i = !0);
  const a = decodeURI(e.substring(t + 1));
  return i ? new Uint8Array(
    atob(a).split("").map((o) => o.charCodeAt(0))
  ).buffer : new Uint8Array(a.split("").map((o) => o.charCodeAt(0))).buffer;
}, B4 = (r) => new Promise((e, t) => {
  const n = new FileReader();
  n.onload = function(i) {
    const a = i.target;
    !a || !a.result ? t() : e(a.result.toString());
  }, n.readAsDataURL(r);
});
var M4 = "__KEEP";
function _4(r) {
  return r === void 0 && (r = /* @__PURE__ */ Object.create(null)), Object.assign(new Oa(function(e, t) {
    var n = r.except, i = e.query, a = e.variables;
    return a && (e.variables = n ? N4(i, a, n) : xA(a)), t(e);
  }), {});
}
function N4(r, e, t) {
  var n = L4(r);
  return Object.fromEntries(Object.entries(e).map(function(i) {
    var a = i[0], s = i[1], o = n[a], l = t[o];
    return i[1] = l ? vy(s, l) : xA(s), i;
  }));
}
function vy(r, e) {
  if (e === M4)
    return r;
  if (Array.isArray(r))
    return r.map(function(n) {
      return vy(n, e);
    });
  if (w2(r)) {
    var t = {};
    return Object.keys(r).forEach(function(n) {
      var i = r[n];
      if (n !== "__typename") {
        var a = e[n];
        t[n] = a ? vy(i, a) : xA(i);
      }
    }), t;
  }
  return r;
}
var L4 = Vu(function(r) {
  var e = {};
  return Fa(r, {
    VariableDefinition: function(t) {
      e[t.variable.name.value] = yy(t.type);
    }
  }), e;
}, {
  max: Rs["removeTypenameFromVariables.getVariableDefinitions"] || 2e3,
  cache: td
});
function yy(r) {
  switch (r.kind) {
    case et.NON_NULL_TYPE:
      return yy(r.type);
    case et.LIST_TYPE:
      return yy(r.type);
    case et.NAMED_TYPE:
      return r.name.value;
  }
}
function U4(r) {
  var e = r || {}, t = e.initial, n = t === void 0 ? 300 : t, i = e.jitter, a = i === void 0 ? !0 : i, s = e.max, o = s === void 0 ? 1 / 0 : s, l = a ? n : n / 2;
  return function(c) {
    var d = Math.min(o, l * Math.pow(2, c));
    return a && (d = Math.random() * d), d;
  };
}
function V4(r) {
  var e = r || {}, t = e.retryIf, n = e.max, i = n === void 0 ? 5 : n;
  return function(s, o, l) {
    return s >= i ? !1 : t ? t(l, o) : !!l;
  };
}
var z4 = (
  /** @class */
  (function() {
    function r(e, t, n, i, a) {
      var s = this;
      this.observer = e, this.operation = t, this.forward = n, this.delayFor = i, this.retryIf = a, this.retryCount = 0, this.currentSubscription = null, this.onError = function(o) {
        return Ka(s, void 0, void 0, function() {
          var l;
          return Za(this, function(u) {
            switch (u.label) {
              case 0:
                return this.retryCount += 1, [4, this.retryIf(this.retryCount, this.operation, o)];
              case 1:
                return l = u.sent(), l ? (this.scheduleRetry(this.delayFor(this.retryCount, this.operation, o)), [
                  2
                  /*return*/
                ]) : (this.observer.error(o), [
                  2
                  /*return*/
                ]);
            }
          });
        });
      }, this.try();
    }
    return r.prototype.cancel = function() {
      this.currentSubscription && this.currentSubscription.unsubscribe(), clearTimeout(this.timerId), this.timerId = void 0, this.currentSubscription = null;
    }, r.prototype.try = function() {
      var e = this;
      this.currentSubscription = this.forward(this.operation).subscribe({
        next: function(t) {
          var n;
          if (CA(t)) {
            e.onError(new ro({
              protocolErrors: t.extensions[Cd]
            })), (n = e.currentSubscription) === null || n === void 0 || n.unsubscribe();
            return;
          }
          e.observer.next(t);
        },
        error: this.onError,
        complete: this.observer.complete.bind(this.observer)
      });
    }, r.prototype.scheduleRetry = function(e) {
      var t = this;
      if (this.timerId)
        throw new Error("RetryLink BUG! Encountered overlapping retries");
      this.timerId = setTimeout(function() {
        t.timerId = void 0, t.try();
      }, e);
    }, r;
  })()
), $4 = (
  /** @class */
  (function(r) {
    pa(e, r);
    function e(t) {
      var n = r.call(this) || this, i = t || {}, a = i.attempts, s = i.delay;
      return n.delayFor = typeof s == "function" ? s : U4(s), n.retryIf = typeof a == "function" ? a : V4(a), n;
    }
    return e.prototype.request = function(t, n) {
      var i = this;
      return new nn(function(a) {
        var s = new z4(a, t, n, i.delayFor, i.retryIf);
        return function() {
          s.cancel();
        };
      });
    }, e;
  })(Oa)
);
let Sk;
const e0 = (r) => {
  Sk = r;
};
let PA;
const H4 = (r) => {
  PA = r;
}, j4 = () => PA;
let Ek;
const G4 = (r) => {
  Ek = r;
}, q4 = () => new Promise((r) => {
  const e = ml.getHubUrl(), t = (n) => {
    n.origin === e && (window.removeEventListener("message", t), r(n.data));
  };
  window.parent !== window && (window.addEventListener("message", t, !1), window.parent.postMessage("ready", e));
}), W4 = async () => {
  const r = {
    applicationKey: PA,
    customerToken: Sk,
    bearer: Ek
  };
  return typeof window < "u" && (window.location.href.includes("/workflows/product/") || window.location.href.includes("hub=true")) ? { ...await q4(), ...r } : r;
};
class Q4 {
  constructor() {
    this.shadowGraphqlClient = this.constructShadowGraphqlClient(), ml.addServerUrlCallback(() => {
      this.shadowGraphqlClient = this.constructShadowGraphqlClient();
    });
  }
  setSpiffCommerceClient(e) {
    this.spiffClient = e, this.shadowGraphqlClient = this.constructShadowGraphqlClient();
  }
  getShadowGraphqlClient() {
    return this.shadowGraphqlClient;
  }
  constructShadowGraphqlClient() {
    const e = Y2({
      uri: `${ml.getServerUrl()}/graphql`,
      fetch: Ms
    }), t = y4(async (s, o) => {
      const { headers: l } = o, u = l || {}, c = await W4();
      let d = o.bearer ?? c.bearer, f = !1;
      if (this.spiffClient) {
        try {
          d = await this.spiffClient.loggedInBearerToken();
        } catch {
        }
        try {
          o.skipIntegrationCheck || (f = await this.spiffClient.getBetaEnabled());
        } catch {
        }
      }
      const h = o.partnerId ?? c.partnerId, g = o.activeIntegration ?? c.activeIntegration, v = o.transactionOwnerId, y = o.customerToken ?? c.customerToken, A = o.applicationKey ?? c.applicationKey, x = o.bundleOwnerId;
      try {
        if (window && window.__SENTRY__) {
          const k = window.__SENTRY__.hub;
          if (k) {
            const F = k.traceHeaders();
            Object.entries(F).forEach(([S, R]) => {
              u[S] = R;
            });
          }
        }
      } catch {
      }
      return d && (u.Authorization = `Bearer ${d}`), h && (u.partnerId = h), g && (u.activeIntegration = g), v && (u.transactionOwnerId = v), y && (u.customerToken = y), A && (u["X-Application-Key"] = A), x && (u.bundleOwnerId = x), f && (u["X-Spiff-Beta"] = "true"), u["Allow-Moonlight-Redirect"] = "true", {
        headers: u
      };
    }), n = Ak(({ operation: s, graphQLErrors: o, networkError: l }) => {
      const u = o || [], c = s.getContext();
      l && !c?.fetchOptions?.signal?.aborted && console.log("GraphQL Network error"), u.forEach(() => console.log("GraphQL Error: " + s.operationName));
    }), i = _4(), a = new $4({
      attempts: {
        max: 5,
        retryIf(s, o) {
          return !!(s && s.result && s.result.status === 429);
        }
      },
      delay: (s, o, l) => {
        const u = Math.random() * 1.5 + 0.5;
        return s * 200 * u;
      }
    });
    return new t4({
      link: rR([i, n, t, e, a]),
      cache: new XR(),
      name: "Core"
    });
  }
}
const He = new Q4();
let Ay, by;
const bo = (r, e, t) => {
  if (Ay !== void 0)
    return Ay(r, e, t);
  try {
    const n = Tk(!0);
    return kk(n), n.createCanvas(r, e, t);
  } catch {
    throw new Error("Canvas module not set");
  }
}, kd = (r, e) => {
  if (by !== void 0)
    return by(r, e);
  try {
    const t = Tk(!0);
    return kk(t), t.loadImage(r, e);
  } catch {
    throw new Error("Canvas module not set");
  }
};
function kk(r) {
  Ay = r?.createCanvas, by = r?.loadImage;
}
function Tk(r) {
  try {
    if (document.createElement("canvas").getContext("2d"))
      return {
        createCanvas: (t, n, i) => {
          const a = document.createElement("canvas");
          return t != null && (a.width = t), n != null && (a.height = n), a;
        },
        loadImage: (t, n) => new Promise((i, a) => {
          const s = document.createElement("img");
          n !== !1 && (s.crossOrigin = "Anonymous"), s.onload = () => {
            i(s);
          }, s.onerror = a, s.src = t;
        })
      };
  } catch (e) {
    throw e;
  }
}
let t0;
function RA() {
  return t0 === void 0 && (t0 = D4()), t0;
}
var Df = { exports: {} }, Y4 = Df.exports, jw;
function X4() {
  return jw || (jw = 1, (function(r, e) {
    (function(t, n) {
      n(e);
    })(Y4, (function(t) {
      function n(Se, P, U) {
        return P in Se ? Object.defineProperty(Se, P, { value: U, enumerable: !0, configurable: !0, writable: !0 }) : Se[P] = U, Se;
      }
      var i = typeof self < "u" ? self : ui;
      const a = typeof navigator < "u", s = a && typeof HTMLImageElement > "u", o = !(typeof ui > "u" || typeof process > "u" || !process.versions || !process.versions.node), l = i.Buffer, u = !!l, c = (Se) => Se !== void 0;
      function d(Se) {
        return Se === void 0 || (Se instanceof Map ? Se.size === 0 : Object.values(Se).filter(c).length === 0);
      }
      function f(Se) {
        let P = new Error(Se);
        throw delete P.stack, P;
      }
      function h(Se) {
        let P = (function(U) {
          let X = 0;
          return U.ifd0.enabled && (X += 1024), U.exif.enabled && (X += 2048), U.makerNote && (X += 2048), U.userComment && (X += 1024), U.gps.enabled && (X += 512), U.interop.enabled && (X += 100), U.ifd1.enabled && (X += 1024), X + 2048;
        })(Se);
        return Se.jfif.enabled && (P += 50), Se.xmp.enabled && (P += 2e4), Se.iptc.enabled && (P += 14e3), Se.icc.enabled && (P += 6e3), P;
      }
      const g = (Se) => String.fromCharCode.apply(null, Se), v = typeof TextDecoder < "u" ? new TextDecoder("utf-8") : void 0;
      class y {
        static from(P, U) {
          return P instanceof this && P.le === U ? P : new y(P, void 0, void 0, U);
        }
        constructor(P, U = 0, X, ue) {
          if (typeof ue == "boolean" && (this.le = ue), Array.isArray(P) && (P = new Uint8Array(P)), P === 0) this.byteOffset = 0, this.byteLength = 0;
          else if (P instanceof ArrayBuffer) {
            X === void 0 && (X = P.byteLength - U);
            let Fe = new DataView(P, U, X);
            this._swapDataView(Fe);
          } else if (P instanceof Uint8Array || P instanceof DataView || P instanceof y) {
            X === void 0 && (X = P.byteLength - U), (U += P.byteOffset) + X > P.byteOffset + P.byteLength && f("Creating view outside of available memory in ArrayBuffer");
            let Fe = new DataView(P.buffer, U, X);
            this._swapDataView(Fe);
          } else if (typeof P == "number") {
            let Fe = new DataView(new ArrayBuffer(P));
            this._swapDataView(Fe);
          } else f("Invalid input argument for BufferView: " + P);
        }
        _swapArrayBuffer(P) {
          this._swapDataView(new DataView(P));
        }
        _swapBuffer(P) {
          this._swapDataView(new DataView(P.buffer, P.byteOffset, P.byteLength));
        }
        _swapDataView(P) {
          this.dataView = P, this.buffer = P.buffer, this.byteOffset = P.byteOffset, this.byteLength = P.byteLength;
        }
        _lengthToEnd(P) {
          return this.byteLength - P;
        }
        set(P, U, X = y) {
          return P instanceof DataView || P instanceof y ? P = new Uint8Array(P.buffer, P.byteOffset, P.byteLength) : P instanceof ArrayBuffer && (P = new Uint8Array(P)), P instanceof Uint8Array || f("BufferView.set(): Invalid data argument."), this.toUint8().set(P, U), new X(this, U, P.byteLength);
        }
        subarray(P, U) {
          return U = U || this._lengthToEnd(P), new y(this, P, U);
        }
        toUint8() {
          return new Uint8Array(this.buffer, this.byteOffset, this.byteLength);
        }
        getUint8Array(P, U) {
          return new Uint8Array(this.buffer, this.byteOffset + P, U);
        }
        getString(P = 0, U = this.byteLength) {
          return ue = this.getUint8Array(P, U), v ? v.decode(ue) : u ? Buffer.from(ue).toString("utf8") : decodeURIComponent(escape(g(ue)));
          var ue;
        }
        getLatin1String(P = 0, U = this.byteLength) {
          let X = this.getUint8Array(P, U);
          return g(X);
        }
        getUnicodeString(P = 0, U = this.byteLength) {
          const X = [];
          for (let ue = 0; ue < U && P + ue < this.byteLength; ue += 2) X.push(this.getUint16(P + ue));
          return g(X);
        }
        getInt8(P) {
          return this.dataView.getInt8(P);
        }
        getUint8(P) {
          return this.dataView.getUint8(P);
        }
        getInt16(P, U = this.le) {
          return this.dataView.getInt16(P, U);
        }
        getInt32(P, U = this.le) {
          return this.dataView.getInt32(P, U);
        }
        getUint16(P, U = this.le) {
          return this.dataView.getUint16(P, U);
        }
        getUint32(P, U = this.le) {
          return this.dataView.getUint32(P, U);
        }
        getFloat32(P, U = this.le) {
          return this.dataView.getFloat32(P, U);
        }
        getFloat64(P, U = this.le) {
          return this.dataView.getFloat64(P, U);
        }
        getFloat(P, U = this.le) {
          return this.dataView.getFloat32(P, U);
        }
        getDouble(P, U = this.le) {
          return this.dataView.getFloat64(P, U);
        }
        getUintBytes(P, U, X) {
          switch (U) {
            case 1:
              return this.getUint8(P, X);
            case 2:
              return this.getUint16(P, X);
            case 4:
              return this.getUint32(P, X);
            case 8:
              return this.getUint64 && this.getUint64(P, X);
          }
        }
        getUint(P, U, X) {
          switch (U) {
            case 8:
              return this.getUint8(P, X);
            case 16:
              return this.getUint16(P, X);
            case 32:
              return this.getUint32(P, X);
            case 64:
              return this.getUint64 && this.getUint64(P, X);
          }
        }
        toString(P) {
          return this.dataView.toString(P, this.constructor.name);
        }
        ensureChunk() {
        }
      }
      function A(Se, P) {
        f(`${Se} '${P}' was not loaded, try using full build of exifr.`);
      }
      class x extends Map {
        constructor(P) {
          super(), this.kind = P;
        }
        get(P, U) {
          return this.has(P) || A(this.kind, P), U && (P in U || (function(X, ue) {
            f(`Unknown ${X} '${ue}'.`);
          })(this.kind, P), U[P].enabled || A(this.kind, P)), super.get(P);
        }
        keyList() {
          return Array.from(this.keys());
        }
      }
      var k = new x("file parser"), F = new x("segment parser"), S = new x("file reader");
      let R = i.fetch;
      const M = "Invalid input argument";
      function j(Se, P) {
        return (U = Se).startsWith("data:") || U.length > 1e4 ? ie(Se, P, "base64") : o && Se.includes("://") ? G(Se, P, "url", q) : o ? ie(Se, P, "fs") : a ? G(Se, P, "url", q) : void f(M);
        var U;
      }
      async function G(Se, P, U, X) {
        return S.has(U) ? ie(Se, P, U) : X ? (async function(ue, Fe) {
          let We = await Fe(ue);
          return new y(We);
        })(Se, X) : void f(`Parser ${U} is not loaded`);
      }
      async function ie(Se, P, U) {
        let X = new (S.get(U))(Se, P);
        return await X.read(), X;
      }
      const q = (Se) => R(Se).then(((P) => P.arrayBuffer())), Y = (Se) => new Promise(((P, U) => {
        let X = new FileReader();
        X.onloadend = () => P(X.result || new ArrayBuffer()), X.onerror = U, X.readAsArrayBuffer(Se);
      }));
      class J extends Map {
        get tagKeys() {
          return this.allKeys || (this.allKeys = Array.from(this.keys())), this.allKeys;
        }
        get tagValues() {
          return this.allValues || (this.allValues = Array.from(this.values())), this.allValues;
        }
      }
      function se(Se, P, U) {
        let X = new J();
        for (let [ue, Fe] of U) X.set(ue, Fe);
        if (Array.isArray(P)) for (let ue of P) Se.set(ue, X);
        else Se.set(P, X);
        return X;
      }
      function oe(Se, P, U) {
        let X, ue = Se.get(P);
        for (X of U) ue.set(X[0], X[1]);
      }
      const he = /* @__PURE__ */ new Map(), ye = /* @__PURE__ */ new Map(), Ue = /* @__PURE__ */ new Map(), Re = 37500, Oe = 37510, ee = 33723, re = 34675, de = 34665, Be = 34853, ke = 40965, ze = ["chunked", "firstChunkSize", "firstChunkSizeNode", "firstChunkSizeBrowser", "chunkSize", "chunkLimit"], je = ["jfif", "xmp", "icc", "iptc", "ihdr"], qe = ["tiff", ...je], Ge = ["ifd0", "ifd1", "exif", "gps", "interop"], bt = [...qe, ...Ge], rr = ["makerNote", "userComment"], Pr = ["translateKeys", "translateValues", "reviveValues", "multiSegment"], Gt = [...Pr, "sanitize", "mergeOutput", "silentErrors"];
      class ar {
        get translate() {
          return this.translateKeys || this.translateValues || this.reviveValues;
        }
      }
      class St extends ar {
        get needed() {
          return this.enabled || this.deps.size > 0;
        }
        constructor(P, U, X, ue) {
          if (super(), n(this, "enabled", !1), n(this, "skip", /* @__PURE__ */ new Set()), n(this, "pick", /* @__PURE__ */ new Set()), n(this, "deps", /* @__PURE__ */ new Set()), n(this, "translateKeys", !1), n(this, "translateValues", !1), n(this, "reviveValues", !1), this.key = P, this.enabled = U, this.parse = this.enabled, this.applyInheritables(ue), this.canBeFiltered = Ge.includes(P), this.canBeFiltered && (this.dict = he.get(P)), X !== void 0) if (Array.isArray(X)) this.parse = this.enabled = !0, this.canBeFiltered && X.length > 0 && this.translateTagSet(X, this.pick);
          else if (typeof X == "object") {
            if (this.enabled = !0, this.parse = X.parse !== !1, this.canBeFiltered) {
              let { pick: Fe, skip: We } = X;
              Fe && Fe.length > 0 && this.translateTagSet(Fe, this.pick), We && We.length > 0 && this.translateTagSet(We, this.skip);
            }
            this.applyInheritables(X);
          } else X === !0 || X === !1 ? this.parse = this.enabled = X : f(`Invalid options argument: ${X}`);
        }
        applyInheritables(P) {
          let U, X;
          for (U of Pr) X = P[U], X !== void 0 && (this[U] = X);
        }
        translateTagSet(P, U) {
          if (this.dict) {
            let X, ue, { tagKeys: Fe, tagValues: We } = this.dict;
            for (X of P) typeof X == "string" ? (ue = We.indexOf(X), ue === -1 && (ue = Fe.indexOf(Number(X))), ue !== -1 && U.add(Number(Fe[ue]))) : U.add(X);
          } else for (let X of P) U.add(X);
        }
        finalizeFilters() {
          !this.enabled && this.deps.size > 0 ? (this.enabled = !0, fr(this.pick, this.deps)) : this.enabled && this.pick.size > 0 && fr(this.pick, this.deps);
        }
      }
      var st = { jfif: !1, tiff: !0, xmp: !1, icc: !1, iptc: !1, ifd0: !0, ifd1: !1, exif: !0, gps: !0, interop: !1, ihdr: void 0, makerNote: !1, userComment: !1, multiSegment: !1, skip: [], pick: [], translateKeys: !0, translateValues: !0, reviveValues: !0, sanitize: !0, mergeOutput: !0, silentErrors: !0, chunked: !0, firstChunkSize: void 0, firstChunkSizeNode: 512, firstChunkSizeBrowser: 65536, chunkSize: 65536, chunkLimit: 5 }, Qr = /* @__PURE__ */ new Map();
      class Sr extends ar {
        static useCached(P) {
          let U = Qr.get(P);
          return U !== void 0 || (U = new this(P), Qr.set(P, U)), U;
        }
        constructor(P) {
          super(), P === !0 ? this.setupFromTrue() : P === void 0 ? this.setupFromUndefined() : Array.isArray(P) ? this.setupFromArray(P) : typeof P == "object" ? this.setupFromObject(P) : f(`Invalid options argument ${P}`), this.firstChunkSize === void 0 && (this.firstChunkSize = a ? this.firstChunkSizeBrowser : this.firstChunkSizeNode), this.mergeOutput && (this.ifd1.enabled = !1), this.filterNestedSegmentTags(), this.traverseTiffDependencyTree(), this.checkLoadedPlugins();
        }
        setupFromUndefined() {
          let P;
          for (P of ze) this[P] = st[P];
          for (P of Gt) this[P] = st[P];
          for (P of rr) this[P] = st[P];
          for (P of bt) this[P] = new St(P, st[P], void 0, this);
        }
        setupFromTrue() {
          let P;
          for (P of ze) this[P] = st[P];
          for (P of Gt) this[P] = st[P];
          for (P of rr) this[P] = !0;
          for (P of bt) this[P] = new St(P, !0, void 0, this);
        }
        setupFromArray(P) {
          let U;
          for (U of ze) this[U] = st[U];
          for (U of Gt) this[U] = st[U];
          for (U of rr) this[U] = st[U];
          for (U of bt) this[U] = new St(U, !1, void 0, this);
          this.setupGlobalFilters(P, void 0, Ge);
        }
        setupFromObject(P) {
          let U;
          for (U of (Ge.ifd0 = Ge.ifd0 || Ge.image, Ge.ifd1 = Ge.ifd1 || Ge.thumbnail, Object.assign(this, P), ze)) this[U] = nr(P[U], st[U]);
          for (U of Gt) this[U] = nr(P[U], st[U]);
          for (U of rr) this[U] = nr(P[U], st[U]);
          for (U of qe) this[U] = new St(U, st[U], P[U], this);
          for (U of Ge) this[U] = new St(U, st[U], P[U], this.tiff);
          this.setupGlobalFilters(P.pick, P.skip, Ge, bt), P.tiff === !0 ? this.batchEnableWithBool(Ge, !0) : P.tiff === !1 ? this.batchEnableWithUserValue(Ge, P) : Array.isArray(P.tiff) ? this.setupGlobalFilters(P.tiff, void 0, Ge) : typeof P.tiff == "object" && this.setupGlobalFilters(P.tiff.pick, P.tiff.skip, Ge);
        }
        batchEnableWithBool(P, U) {
          for (let X of P) this[X].enabled = U;
        }
        batchEnableWithUserValue(P, U) {
          for (let X of P) {
            let ue = U[X];
            this[X].enabled = ue !== !1 && ue !== void 0;
          }
        }
        setupGlobalFilters(P, U, X, ue = X) {
          if (P && P.length) {
            for (let We of ue) this[We].enabled = !1;
            let Fe = gr(P, X);
            for (let [We, wt] of Fe) fr(this[We].pick, wt), this[We].enabled = !0;
          } else if (U && U.length) {
            let Fe = gr(U, X);
            for (let [We, wt] of Fe) fr(this[We].skip, wt);
          }
        }
        filterNestedSegmentTags() {
          let { ifd0: P, exif: U, xmp: X, iptc: ue, icc: Fe } = this;
          this.makerNote ? U.deps.add(Re) : U.skip.add(Re), this.userComment ? U.deps.add(Oe) : U.skip.add(Oe), X.enabled || P.skip.add(700), ue.enabled || P.skip.add(ee), Fe.enabled || P.skip.add(re);
        }
        traverseTiffDependencyTree() {
          let { ifd0: P, exif: U, gps: X, interop: ue } = this;
          ue.needed && (U.deps.add(ke), P.deps.add(ke)), U.needed && P.deps.add(de), X.needed && P.deps.add(Be), this.tiff.enabled = Ge.some(((Fe) => this[Fe].enabled === !0)) || this.makerNote || this.userComment;
          for (let Fe of Ge) this[Fe].finalizeFilters();
        }
        get onlyTiff() {
          return !je.map(((P) => this[P].enabled)).some(((P) => P === !0)) && this.tiff.enabled;
        }
        checkLoadedPlugins() {
          for (let P of qe) this[P].enabled && !F.has(P) && A("segment parser", P);
        }
      }
      function gr(Se, P) {
        let U, X, ue, Fe, We = [];
        for (ue of P) {
          for (Fe of (U = he.get(ue), X = [], U)) (Se.includes(Fe[0]) || Se.includes(Fe[1])) && X.push(Fe[0]);
          X.length && We.push([ue, X]);
        }
        return We;
      }
      function nr(Se, P) {
        return Se !== void 0 ? Se : P !== void 0 ? P : void 0;
      }
      function fr(Se, P) {
        for (let U of P) Se.add(U);
      }
      n(Sr, "default", st);
      class Yt {
        constructor(P) {
          n(this, "parsers", {}), n(this, "output", {}), n(this, "errors", []), n(this, "pushToErrors", ((U) => this.errors.push(U))), this.options = Sr.useCached(P);
        }
        async read(P) {
          this.file = await (function(U, X) {
            return typeof U == "string" ? j(U, X) : a && !s && U instanceof HTMLImageElement ? j(U.src, X) : U instanceof Uint8Array || U instanceof ArrayBuffer || U instanceof DataView ? new y(U) : a && U instanceof Blob ? G(U, X, "blob", Y) : void f(M);
          })(P, this.options);
        }
        setup() {
          if (this.fileParser) return;
          let { file: P } = this, U = P.getUint16(0);
          for (let [X, ue] of k) if (ue.canHandle(P, U)) return this.fileParser = new ue(this.options, this.file, this.parsers), P[X] = !0;
          this.file.close && this.file.close(), f("Unknown file format");
        }
        async parse() {
          let { output: P, errors: U } = this;
          return this.setup(), this.options.silentErrors ? (await this.executeParsers().catch(this.pushToErrors), U.push(...this.fileParser.errors)) : await this.executeParsers(), this.file.close && this.file.close(), this.options.silentErrors && U.length > 0 && (P.errors = U), d(X = P) ? void 0 : X;
          var X;
        }
        async executeParsers() {
          let { output: P } = this;
          await this.fileParser.parse();
          let U = Object.values(this.parsers).map((async (X) => {
            let ue = await X.parse();
            X.assignToOutput(P, ue);
          }));
          this.options.silentErrors && (U = U.map(((X) => X.catch(this.pushToErrors)))), await Promise.all(U);
        }
        async extractThumbnail() {
          this.setup();
          let { options: P, file: U } = this, X = F.get("tiff", P);
          var ue;
          if (U.tiff ? ue = { start: 0, type: "tiff" } : U.jpeg && (ue = await this.fileParser.getOrFindSegment("tiff")), ue === void 0) return;
          let Fe = await this.fileParser.ensureSegmentChunk(ue), We = this.parsers.tiff = new X(Fe, P, U), wt = await We.extractThumbnail();
          return U.close && U.close(), wt;
        }
      }
      async function Xt(Se, P) {
        let U = new Yt(P);
        return await U.read(Se), U.parse();
      }
      var mt = Object.freeze({ __proto__: null, parse: Xt, Exifr: Yt, fileParsers: k, segmentParsers: F, fileReaders: S, tagKeys: he, tagValues: ye, tagRevivers: Ue, createDictionary: se, extendDictionary: oe, fetchUrlAsArrayBuffer: q, readBlobAsArrayBuffer: Y, chunkedProps: ze, otherSegments: je, segments: qe, tiffBlocks: Ge, segmentsAndBlocks: bt, tiffExtractables: rr, inheritables: Pr, allFormatters: Gt, Options: Sr });
      class wr {
        static findPosition(P, U) {
          let X = P.getUint16(U + 2) + 2, ue = typeof this.headerLength == "function" ? this.headerLength(P, U, X) : this.headerLength, Fe = U + ue, We = X - ue;
          return { offset: U, length: X, headerLength: ue, start: Fe, size: We, end: Fe + We };
        }
        static parse(P, U = {}) {
          return new this(P, new Sr({ [this.type]: U }), P).parse();
        }
        normalizeInput(P) {
          return P instanceof y ? P : new y(P);
        }
        constructor(P, U = {}, X) {
          n(this, "errors", []), n(this, "raw", /* @__PURE__ */ new Map()), n(this, "handleError", ((ue) => {
            if (!this.options.silentErrors) throw ue;
            this.errors.push(ue.message);
          })), this.chunk = this.normalizeInput(P), this.file = X, this.type = this.constructor.type, this.globalOptions = this.options = U, this.localOptions = U[this.type], this.canTranslate = this.localOptions && this.localOptions.translate;
        }
        translate() {
          this.canTranslate && (this.translated = this.translateBlock(this.raw, this.type));
        }
        get output() {
          return this.translated ? this.translated : this.raw ? Object.fromEntries(this.raw) : void 0;
        }
        translateBlock(P, U) {
          let X = Ue.get(U), ue = ye.get(U), Fe = he.get(U), We = this.options[U], wt = We.reviveValues && !!X, Pt = We.translateValues && !!ue, Nt = We.translateKeys && !!Fe, or = {};
          for (let [Lt, K] of P) wt && X.has(Lt) ? K = X.get(Lt)(K) : Pt && ue.has(Lt) && (K = this.translateValue(K, ue.get(Lt))), Nt && Fe.has(Lt) && (Lt = Fe.get(Lt) || Lt), or[Lt] = K;
          return or;
        }
        translateValue(P, U) {
          return U[P] || U.DEFAULT || P;
        }
        assignToOutput(P, U) {
          this.assignObjectToOutput(P, this.constructor.type, U);
        }
        assignObjectToOutput(P, U, X) {
          if (this.globalOptions.mergeOutput) return Object.assign(P, X);
          P[U] ? Object.assign(P[U], X) : P[U] = X;
        }
      }
      n(wr, "headerLength", 4), n(wr, "type", void 0), n(wr, "multiSegment", !1), n(wr, "canHandle", (() => !1));
      function an(Se) {
        return Se === 192 || Se === 194 || Se === 196 || Se === 219 || Se === 221 || Se === 218 || Se === 254;
      }
      function _r(Se) {
        return Se >= 224 && Se <= 239;
      }
      function ir(Se, P, U) {
        for (let [X, ue] of F) if (ue.canHandle(Se, P, U)) return X;
      }
      class Yr extends class {
        constructor(P, U, X) {
          n(this, "errors", []), n(this, "ensureSegmentChunk", (async (ue) => {
            let Fe = ue.start, We = ue.size || 65536;
            if (this.file.chunked) if (this.file.available(Fe, We)) ue.chunk = this.file.subarray(Fe, We);
            else try {
              ue.chunk = await this.file.readChunk(Fe, We);
            } catch (wt) {
              f(`Couldn't read segment: ${JSON.stringify(ue)}. ${wt.message}`);
            }
            else this.file.byteLength > Fe + We ? ue.chunk = this.file.subarray(Fe, We) : ue.size === void 0 ? ue.chunk = this.file.subarray(Fe) : f("Segment unreachable: " + JSON.stringify(ue));
            return ue.chunk;
          })), this.extendOptions && this.extendOptions(P), this.options = P, this.file = U, this.parsers = X;
        }
        injectSegment(P, U) {
          this.options[P].enabled && this.createParser(P, U);
        }
        createParser(P, U) {
          let X = new (F.get(P))(U, this.options, this.file);
          return this.parsers[P] = X;
        }
        createParsers(P) {
          for (let U of P) {
            let { type: X, chunk: ue } = U, Fe = this.options[X];
            if (Fe && Fe.enabled) {
              let We = this.parsers[X];
              We && We.append || We || this.createParser(X, ue);
            }
          }
        }
        async readSegments(P) {
          let U = P.map(this.ensureSegmentChunk);
          await Promise.all(U);
        }
      } {
        constructor(...P) {
          super(...P), n(this, "appSegments", []), n(this, "jpegSegments", []), n(this, "unknownSegments", []);
        }
        static canHandle(P, U) {
          return U === 65496;
        }
        async parse() {
          await this.findAppSegments(), await this.readSegments(this.appSegments), this.mergeMultiSegments(), this.createParsers(this.mergedAppSegments || this.appSegments);
        }
        setupSegmentFinderArgs(P) {
          P === !0 ? (this.findAll = !0, this.wanted = new Set(F.keyList())) : (P = P === void 0 ? F.keyList().filter(((U) => this.options[U].enabled)) : P.filter(((U) => this.options[U].enabled && F.has(U))), this.findAll = !1, this.remaining = new Set(P), this.wanted = new Set(P)), this.unfinishedMultiSegment = !1;
        }
        async findAppSegments(P = 0, U) {
          this.setupSegmentFinderArgs(U);
          let { file: X, findAll: ue, wanted: Fe, remaining: We } = this;
          if (!ue && this.file.chunked && (ue = Array.from(Fe).some(((wt) => {
            let Pt = F.get(wt), Nt = this.options[wt];
            return Pt.multiSegment && Nt.multiSegment;
          })), ue && await this.file.readWhole()), P = this.findAppSegmentsInRange(P, X.byteLength), !this.options.onlyTiff && X.chunked) {
            let wt = !1;
            for (; We.size > 0 && !wt && (X.canReadNextChunk || this.unfinishedMultiSegment); ) {
              let { nextChunkOffset: Pt } = X, Nt = this.appSegments.some(((or) => !this.file.available(or.offset || or.start, or.length || or.size)));
              if (wt = P > Pt && !Nt ? !await X.readNextChunk(P) : !await X.readNextChunk(Pt), (P = this.findAppSegmentsInRange(P, X.byteLength)) === void 0) return;
            }
          }
        }
        findAppSegmentsInRange(P, U) {
          U -= 2;
          let X, ue, Fe, We, wt, Pt, { file: Nt, findAll: or, wanted: Lt, remaining: K, options: Ie } = this;
          for (; P < U; P++) if (Nt.getUint8(P) === 255) {
            if (X = Nt.getUint8(P + 1), _r(X)) {
              if (ue = Nt.getUint16(P + 2), Fe = ir(Nt, P, ue), Fe && Lt.has(Fe) && (We = F.get(Fe), wt = We.findPosition(Nt, P), Pt = Ie[Fe], wt.type = Fe, this.appSegments.push(wt), !or && (We.multiSegment && Pt.multiSegment ? (this.unfinishedMultiSegment = wt.chunkNumber < wt.chunkCount, this.unfinishedMultiSegment || K.delete(Fe)) : K.delete(Fe), K.size === 0))) break;
              Ie.recordUnknownSegments && (wt = wr.findPosition(Nt, P), wt.marker = X, this.unknownSegments.push(wt)), P += ue + 1;
            } else if (an(X)) {
              if (ue = Nt.getUint16(P + 2), X === 218 && Ie.stopAfterSos !== !1) return;
              Ie.recordJpegSegments && this.jpegSegments.push({ offset: P, length: ue, marker: X }), P += ue + 1;
            }
          }
          return P;
        }
        mergeMultiSegments() {
          if (!this.appSegments.some(((U) => U.multiSegment))) return;
          let P = (function(U, X) {
            let ue, Fe, We, wt = /* @__PURE__ */ new Map();
            for (let Pt = 0; Pt < U.length; Pt++) ue = U[Pt], Fe = ue[X], wt.has(Fe) ? We = wt.get(Fe) : wt.set(Fe, We = []), We.push(ue);
            return Array.from(wt);
          })(this.appSegments, "type");
          this.mergedAppSegments = P.map((([U, X]) => {
            let ue = F.get(U, this.options);
            return ue.handleMultiSegments ? { type: U, chunk: ue.handleMultiSegments(X) } : X[0];
          }));
        }
        getSegment(P) {
          return this.appSegments.find(((U) => U.type === P));
        }
        async getOrFindSegment(P) {
          let U = this.getSegment(P);
          return U === void 0 && (await this.findAppSegments(0, [P]), U = this.getSegment(P)), U;
        }
      }
      n(Yr, "type", "jpeg"), k.set("jpeg", Yr);
      const kr = [void 0, 1, 1, 2, 4, 8, 1, 1, 2, 4, 8, 4, 8, 4];
      class Zr extends wr {
        parseHeader() {
          var P = this.chunk.getUint16();
          P === 18761 ? this.le = !0 : P === 19789 && (this.le = !1), this.chunk.le = this.le, this.headerParsed = !0;
        }
        parseTags(P, U, X = /* @__PURE__ */ new Map()) {
          let { pick: ue, skip: Fe } = this.options[U];
          ue = new Set(ue);
          let We = ue.size > 0, wt = Fe.size === 0, Pt = this.chunk.getUint16(P);
          P += 2;
          for (let Nt = 0; Nt < Pt; Nt++) {
            let or = this.chunk.getUint16(P);
            if (We) {
              if (ue.has(or) && (X.set(or, this.parseTag(P, or, U)), ue.delete(or), ue.size === 0)) break;
            } else !wt && Fe.has(or) || X.set(or, this.parseTag(P, or, U));
            P += 12;
          }
          return X;
        }
        parseTag(P, U, X) {
          let { chunk: ue } = this, Fe = ue.getUint16(P + 2), We = ue.getUint32(P + 4), wt = kr[Fe];
          if (wt * We <= 4 ? P += 8 : P = ue.getUint32(P + 8), (Fe < 1 || Fe > 13) && f(`Invalid TIFF value type. block: ${X.toUpperCase()}, tag: ${U.toString(16)}, type: ${Fe}, offset ${P}`), P > ue.byteLength && f(`Invalid TIFF value offset. block: ${X.toUpperCase()}, tag: ${U.toString(16)}, type: ${Fe}, offset ${P} is outside of chunk size ${ue.byteLength}`), Fe === 1) return ue.getUint8Array(P, We);
          if (Fe === 2) return (Pt = (function(Nt) {
            for (; Nt.endsWith("\0"); ) Nt = Nt.slice(0, -1);
            return Nt;
          })(Pt = ue.getString(P, We)).trim()) === "" ? void 0 : Pt;
          var Pt;
          if (Fe === 7) return ue.getUint8Array(P, We);
          if (We === 1) return this.parseTagValue(Fe, P);
          {
            let Nt = new ((function(Lt) {
              switch (Lt) {
                case 1:
                  return Uint8Array;
                case 3:
                  return Uint16Array;
                case 4:
                  return Uint32Array;
                case 5:
                  return Array;
                case 6:
                  return Int8Array;
                case 8:
                  return Int16Array;
                case 9:
                  return Int32Array;
                case 10:
                  return Array;
                case 11:
                  return Float32Array;
                case 12:
                  return Float64Array;
                default:
                  return Array;
              }
            })(Fe))(We), or = wt;
            for (let Lt = 0; Lt < We; Lt++) Nt[Lt] = this.parseTagValue(Fe, P), P += or;
            return Nt;
          }
        }
        parseTagValue(P, U) {
          let { chunk: X } = this;
          switch (P) {
            case 1:
              return X.getUint8(U);
            case 3:
              return X.getUint16(U);
            case 4:
              return X.getUint32(U);
            case 5:
              return X.getUint32(U) / X.getUint32(U + 4);
            case 6:
              return X.getInt8(U);
            case 8:
              return X.getInt16(U);
            case 9:
              return X.getInt32(U);
            case 10:
              return X.getInt32(U) / X.getInt32(U + 4);
            case 11:
              return X.getFloat(U);
            case 12:
              return X.getDouble(U);
            case 13:
              return X.getUint32(U);
            default:
              f(`Invalid tiff type ${P}`);
          }
        }
      }
      class Vr extends Zr {
        static canHandle(P, U) {
          return P.getUint8(U + 1) === 225 && P.getUint32(U + 4) === 1165519206 && P.getUint16(U + 8) === 0;
        }
        async parse() {
          this.parseHeader();
          let { options: P } = this;
          return P.ifd0.enabled && await this.parseIfd0Block(), P.exif.enabled && await this.safeParse("parseExifBlock"), P.gps.enabled && await this.safeParse("parseGpsBlock"), P.interop.enabled && await this.safeParse("parseInteropBlock"), P.ifd1.enabled && await this.safeParse("parseThumbnailBlock"), this.createOutput();
        }
        safeParse(P) {
          let U = this[P]();
          return U.catch !== void 0 && (U = U.catch(this.handleError)), U;
        }
        findIfd0Offset() {
          this.ifd0Offset === void 0 && (this.ifd0Offset = this.chunk.getUint32(4));
        }
        findIfd1Offset() {
          if (this.ifd1Offset === void 0) {
            this.findIfd0Offset();
            let P = this.chunk.getUint16(this.ifd0Offset), U = this.ifd0Offset + 2 + 12 * P;
            this.ifd1Offset = this.chunk.getUint32(U);
          }
        }
        parseBlock(P, U) {
          let X = /* @__PURE__ */ new Map();
          return this[U] = X, this.parseTags(P, U, X), X;
        }
        async parseIfd0Block() {
          if (this.ifd0) return;
          let { file: P } = this;
          this.findIfd0Offset(), this.ifd0Offset < 8 && f("Malformed EXIF data"), !P.chunked && this.ifd0Offset > P.byteLength && f(`IFD0 offset points to outside of file.
this.ifd0Offset: ${this.ifd0Offset}, file.byteLength: ${P.byteLength}`), P.tiff && await P.ensureChunk(this.ifd0Offset, h(this.options));
          let U = this.parseBlock(this.ifd0Offset, "ifd0");
          return U.size !== 0 ? (this.exifOffset = U.get(de), this.interopOffset = U.get(ke), this.gpsOffset = U.get(Be), this.xmp = U.get(700), this.iptc = U.get(ee), this.icc = U.get(re), this.options.sanitize && (U.delete(de), U.delete(ke), U.delete(Be), U.delete(700), U.delete(ee), U.delete(re)), U) : void 0;
        }
        async parseExifBlock() {
          if (this.exif || (this.ifd0 || await this.parseIfd0Block(), this.exifOffset === void 0)) return;
          this.file.tiff && await this.file.ensureChunk(this.exifOffset, h(this.options));
          let P = this.parseBlock(this.exifOffset, "exif");
          return this.interopOffset || (this.interopOffset = P.get(ke)), this.makerNote = P.get(Re), this.userComment = P.get(Oe), this.options.sanitize && (P.delete(ke), P.delete(Re), P.delete(Oe)), this.unpack(P, 41728), this.unpack(P, 41729), P;
        }
        unpack(P, U) {
          let X = P.get(U);
          X && X.length === 1 && P.set(U, X[0]);
        }
        async parseGpsBlock() {
          if (this.gps || (this.ifd0 || await this.parseIfd0Block(), this.gpsOffset === void 0)) return;
          let P = this.parseBlock(this.gpsOffset, "gps");
          return P && P.has(2) && P.has(4) && (P.set("latitude", pn(...P.get(2), P.get(1))), P.set("longitude", pn(...P.get(4), P.get(3)))), P;
        }
        async parseInteropBlock() {
          if (!this.interop && (this.ifd0 || await this.parseIfd0Block(), this.interopOffset !== void 0 || this.exif || await this.parseExifBlock(), this.interopOffset !== void 0)) return this.parseBlock(this.interopOffset, "interop");
        }
        async parseThumbnailBlock(P = !1) {
          if (!this.ifd1 && !this.ifd1Parsed && (!this.options.mergeOutput || P)) return this.findIfd1Offset(), this.ifd1Offset > 0 && (this.parseBlock(this.ifd1Offset, "ifd1"), this.ifd1Parsed = !0), this.ifd1;
        }
        async extractThumbnail() {
          if (this.headerParsed || this.parseHeader(), this.ifd1Parsed || await this.parseThumbnailBlock(!0), this.ifd1 === void 0) return;
          let P = this.ifd1.get(513), U = this.ifd1.get(514);
          return this.chunk.getUint8Array(P, U);
        }
        get image() {
          return this.ifd0;
        }
        get thumbnail() {
          return this.ifd1;
        }
        createOutput() {
          let P, U, X, ue = {};
          for (U of Ge) if (P = this[U], !d(P)) if (X = this.canTranslate ? this.translateBlock(P, U) : Object.fromEntries(P), this.options.mergeOutput) {
            if (U === "ifd1") continue;
            Object.assign(ue, X);
          } else ue[U] = X;
          return this.makerNote && (ue.makerNote = this.makerNote), this.userComment && (ue.userComment = this.userComment), ue;
        }
        assignToOutput(P, U) {
          if (this.globalOptions.mergeOutput) Object.assign(P, U);
          else for (let [X, ue] of Object.entries(U)) this.assignObjectToOutput(P, X, ue);
        }
      }
      function pn(Se, P, U, X) {
        var ue = Se + P / 60 + U / 3600;
        return X !== "S" && X !== "W" || (ue *= -1), ue;
      }
      n(Vr, "type", "tiff"), n(Vr, "headerLength", 10), F.set("tiff", Vr);
      var gn = Object.freeze({ __proto__: null, default: mt, Exifr: Yt, fileParsers: k, segmentParsers: F, fileReaders: S, tagKeys: he, tagValues: ye, tagRevivers: Ue, createDictionary: se, extendDictionary: oe, fetchUrlAsArrayBuffer: q, readBlobAsArrayBuffer: Y, chunkedProps: ze, otherSegments: je, segments: qe, tiffBlocks: Ge, segmentsAndBlocks: bt, tiffExtractables: rr, inheritables: Pr, allFormatters: Gt, Options: Sr, parse: Xt });
      const Tr = { ifd0: !1, ifd1: !1, exif: !1, gps: !1, interop: !1, sanitize: !1, reviveValues: !0, translateKeys: !1, translateValues: !1, mergeOutput: !1 }, zr = Object.assign({}, Tr, { firstChunkSize: 4e4, gps: [1, 2, 3, 4] }), en = Object.assign({}, Tr, { tiff: !1, ifd1: !0, mergeOutput: !1 }), $r = Object.assign({}, Tr, { firstChunkSize: 4e4, ifd0: [274] });
      async function zt(Se) {
        let P = new Yt($r);
        await P.read(Se);
        let U = await P.parse();
        if (U && U.ifd0) return U.ifd0[274];
      }
      const sr = Object.freeze({ 1: { dimensionSwapped: !1, scaleX: 1, scaleY: 1, deg: 0, rad: 0 }, 2: { dimensionSwapped: !1, scaleX: -1, scaleY: 1, deg: 0, rad: 0 }, 3: { dimensionSwapped: !1, scaleX: 1, scaleY: 1, deg: 180, rad: 180 * Math.PI / 180 }, 4: { dimensionSwapped: !1, scaleX: -1, scaleY: 1, deg: 180, rad: 180 * Math.PI / 180 }, 5: { dimensionSwapped: !0, scaleX: 1, scaleY: -1, deg: 90, rad: 90 * Math.PI / 180 }, 6: { dimensionSwapped: !0, scaleX: 1, scaleY: 1, deg: 90, rad: 90 * Math.PI / 180 }, 7: { dimensionSwapped: !0, scaleX: 1, scaleY: -1, deg: 270, rad: 270 * Math.PI / 180 }, 8: { dimensionSwapped: !0, scaleX: 1, scaleY: 1, deg: 270, rad: 270 * Math.PI / 180 } });
      if (t.rotateCanvas = !0, t.rotateCss = !0, typeof navigator == "object") {
        let Se = navigator.userAgent;
        if (Se.includes("iPad") || Se.includes("iPhone")) {
          let P = Se.match(/OS (\d+)_(\d+)/);
          if (P) {
            let [, U, X] = P, ue = Number(U) + 0.1 * Number(X);
            t.rotateCanvas = ue < 13.4, t.rotateCss = !1;
          }
        } else if (Se.includes("OS X 10")) {
          let [, P] = Se.match(/OS X 10[_.](\d+)/);
          t.rotateCanvas = t.rotateCss = Number(P) < 15;
        }
        if (Se.includes("Chrome/")) {
          let [, P] = Se.match(/Chrome\/(\d+)/);
          t.rotateCanvas = t.rotateCss = Number(P) < 81;
        } else if (Se.includes("Firefox/")) {
          let [, P] = Se.match(/Firefox\/(\d+)/);
          t.rotateCanvas = t.rotateCss = Number(P) < 77;
        }
      }
      class Er extends y {
        constructor(...P) {
          super(...P), n(this, "ranges", new tt()), this.byteLength !== 0 && this.ranges.add(0, this.byteLength);
        }
        _tryExtend(P, U, X) {
          if (P === 0 && this.byteLength === 0 && X) {
            let ue = new DataView(X.buffer || X, X.byteOffset, X.byteLength);
            this._swapDataView(ue);
          } else {
            let ue = P + U;
            if (ue > this.byteLength) {
              let { dataView: Fe } = this._extend(ue);
              this._swapDataView(Fe);
            }
          }
        }
        _extend(P) {
          let U;
          U = u ? l.allocUnsafe(P) : new Uint8Array(P);
          let X = new DataView(U.buffer, U.byteOffset, U.byteLength);
          return U.set(new Uint8Array(this.buffer, this.byteOffset, this.byteLength), 0), { uintView: U, dataView: X };
        }
        subarray(P, U, X = !1) {
          return U = U || this._lengthToEnd(P), X && this._tryExtend(P, U), this.ranges.add(P, U), super.subarray(P, U);
        }
        set(P, U, X = !1) {
          X && this._tryExtend(U, P.byteLength, P);
          let ue = super.set(P, U);
          return this.ranges.add(U, ue.byteLength), ue;
        }
        async ensureChunk(P, U) {
          this.chunked && (this.ranges.available(P, U) || await this.readChunk(P, U));
        }
        available(P, U) {
          return this.ranges.available(P, U);
        }
      }
      class tt {
        constructor() {
          n(this, "list", []);
        }
        get length() {
          return this.list.length;
        }
        add(P, U, X = 0) {
          let ue = P + U, Fe = this.list.filter(((We) => Nr(P, We.offset, ue) || Nr(P, We.end, ue)));
          if (Fe.length > 0) {
            P = Math.min(P, ...Fe.map(((wt) => wt.offset))), ue = Math.max(ue, ...Fe.map(((wt) => wt.end))), U = ue - P;
            let We = Fe.shift();
            We.offset = P, We.length = U, We.end = ue, this.list = this.list.filter(((wt) => !Fe.includes(wt)));
          } else this.list.push({ offset: P, length: U, end: ue });
        }
        available(P, U) {
          let X = P + U;
          return this.list.some(((ue) => ue.offset <= P && X <= ue.end));
        }
      }
      function Nr(Se, P, U) {
        return Se <= P && P <= U;
      }
      class Xr extends Er {
        constructor(P, U) {
          super(0), n(this, "chunksRead", 0), this.input = P, this.options = U;
        }
        async readWhole() {
          this.chunked = !1, await this.readChunk(this.nextChunkOffset);
        }
        async readChunked() {
          this.chunked = !0, await this.readChunk(0, this.options.firstChunkSize);
        }
        async readNextChunk(P = this.nextChunkOffset) {
          if (this.fullyRead) return this.chunksRead++, !1;
          let U = this.options.chunkSize, X = await this.readChunk(P, U);
          return !!X && X.byteLength === U;
        }
        async readChunk(P, U) {
          if (this.chunksRead++, (U = this.safeWrapAddress(P, U)) !== 0) return this._readChunk(P, U);
        }
        safeWrapAddress(P, U) {
          return this.size !== void 0 && P + U > this.size ? Math.max(0, this.size - P) : U;
        }
        get nextChunkOffset() {
          if (this.ranges.list.length !== 0) return this.ranges.list[0].length;
        }
        get canReadNextChunk() {
          return this.chunksRead < this.options.chunkLimit;
        }
        get fullyRead() {
          return this.size !== void 0 && this.nextChunkOffset === this.size;
        }
        read() {
          return this.options.chunked ? this.readChunked() : this.readWhole();
        }
        close() {
        }
      }
      S.set("blob", class extends Xr {
        async readWhole() {
          this.chunked = !1;
          let Se = await Y(this.input);
          this._swapArrayBuffer(Se);
        }
        readChunked() {
          return this.chunked = !0, this.size = this.input.size, super.readChunked();
        }
        async _readChunk(Se, P) {
          let U = P ? Se + P : void 0, X = this.input.slice(Se, U), ue = await Y(X);
          return this.set(ue, Se, !0);
        }
      }), t.Exifr = Yt, t.Options = Sr, t.allFormatters = Gt, t.chunkedProps = ze, t.createDictionary = se, t.default = gn, t.extendDictionary = oe, t.fetchUrlAsArrayBuffer = q, t.fileParsers = k, t.fileReaders = S, t.gps = async function(Se) {
        let P = new Yt(zr);
        await P.read(Se);
        let U = await P.parse();
        if (U && U.gps) {
          let { latitude: X, longitude: ue } = U.gps;
          return { latitude: X, longitude: ue };
        }
      }, t.gpsOnlyOptions = zr, t.inheritables = Pr, t.orientation = zt, t.orientationOnlyOptions = $r, t.otherSegments = je, t.parse = Xt, t.readBlobAsArrayBuffer = Y, t.rotation = async function(Se) {
        let P = await zt(Se);
        return Object.assign({ canvas: t.rotateCanvas, css: t.rotateCss }, sr[P]);
      }, t.rotations = sr, t.segmentParsers = F, t.segments = qe, t.segmentsAndBlocks = bt, t.tagKeys = he, t.tagRevivers = Ue, t.tagValues = ye, t.thumbnail = async function(Se) {
        let P = new Yt(en);
        await P.read(Se);
        let U = await P.extractThumbnail();
        return U && u ? l.from(U) : U;
      }, t.thumbnailOnlyOptions = en, t.thumbnailUrl = async function(Se) {
        let P = await this.thumbnail(Se);
        if (P !== void 0) {
          let U = new Blob([P]);
          return URL.createObjectURL(U);
        }
      }, t.tiffBlocks = Ge, t.tiffExtractables = rr, Object.defineProperty(t, "__esModule", { value: !0 });
    }));
  })(Df, Df.exports)), Df.exports;
}
var J4 = X4();
let Ph = null;
const K4 = (r) => new Promise((e) => {
  if (Ig(r) !== "image/jpeg")
    return e(1);
  J4.orientation(r).then((n) => e(n || 1)).catch(() => e(1));
}), Z4 = async () => {
  if (Ph !== null)
    return !Ph;
  const e = await kd("data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAAAAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAIAAwMBEQACEQEDEQH/xABRAAEAAAAAAAAAAAAAAAAAAAAKEAEBAQADAQEAAAAAAAAAAAAGBQQDCAkCBwEBAAAAAAAAAAAAAAAAAAAAABEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AG8T9NfSMEVMhQvoP3fFiRZ+MTHDifa/95OFSZU5OzRzxkyejv8ciEfhSceSXGjS8eSdLnZc2HDm4M3BxcXwH/9k=");
  return Ph = e.width === 2 && e.height === 3, !Ph;
}, eO = (r) => {
  const t = r.naturalWidth / r.naturalHeight;
  return r.naturalHeight <= 8192 && r.naturalWidth <= 8192 ? [r.naturalWidth, r.naturalHeight] : r.naturalHeight > r.naturalWidth ? [t * 8192, 8192] : [8192, 8192 / t];
}, tO = async (r) => {
  const e = await O4(r), t = await kd(e), [n, i] = eO(t);
  if (!await Z4()) {
    const d = bo(n, i);
    return d.getContext("2d")?.drawImage(t, 0, 0, n, i), d;
  }
  const s = await K4(r), [o, l] = s > 4 ? [i, n] : [n, i], u = bo(o, l), c = u.getContext("2d");
  switch (s) {
    case 2:
      c.translate(o, 0), c.scale(-1, 1);
      break;
    case 3:
      c.translate(o, l), c.rotate(Math.PI);
      break;
    case 4:
      c.translate(0, l), c.scale(1, -1);
      break;
    case 5:
      c.rotate(-0.5 * Math.PI), c.scale(-1, 1);
      break;
    case 6:
      c.rotate(-0.5 * Math.PI), c.translate(-o, 0);
      break;
    case 7:
      c.rotate(-0.5 * Math.PI), c.translate(-o, l), c.scale(1, -1);
      break;
    case 8:
      c.rotate(0.5 * Math.PI), c.translate(0, -l);
      break;
  }
  return c.drawImage(t, 0, 0, o, l), u;
}, Dg = async (r) => {
  const e = await tO(r);
  return Ig(r) === "image/jpeg" ? {
    dataUrl: e.toDataURL("image/jpeg", 1),
    height: e.height,
    width: e.width
  } : {
    dataUrl: e.toDataURL(),
    height: e.height,
    width: e.width
  };
};
var r0 = {}, n0, Gw;
function rO() {
  if (Gw) return n0;
  Gw = 1;
  var r = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
  n0 = function(n, i) {
    i = i || {};
    var a = 1, s = 1;
    function o(re) {
      var de = re.match(/\n/g);
      de && (a += de.length);
      var Be = re.lastIndexOf(`
`);
      s = ~Be ? re.length - Be : s + re.length;
    }
    function l() {
      var re = { line: a, column: s };
      return function(de) {
        return de.position = new u(re), A(), de;
      };
    }
    function u(re) {
      this.start = re, this.end = { line: a, column: s }, this.source = i.source;
    }
    u.prototype.content = n;
    var c = [];
    function d(re) {
      var de = new Error(i.source + ":" + a + ":" + s + ": " + re);
      if (de.reason = re, de.filename = i.source, de.line = a, de.column = s, de.source = n, i.silent)
        c.push(de);
      else
        throw de;
    }
    function f() {
      var re = v();
      return {
        type: "stylesheet",
        stylesheet: {
          source: i.source,
          rules: re,
          parsingErrors: c
        }
      };
    }
    function h() {
      return y(/^{\s*/);
    }
    function g() {
      return y(/^}/);
    }
    function v() {
      var re, de = [];
      for (A(), x(de); n.length && n.charAt(0) != "}" && (re = Oe() || ee()); )
        re !== !1 && (de.push(re), x(de));
      return de;
    }
    function y(re) {
      var de = re.exec(n);
      if (de) {
        var Be = de[0];
        return o(Be), n = n.slice(Be.length), de;
      }
    }
    function A() {
      y(/^\s*/);
    }
    function x(re) {
      var de;
      for (re = re || []; de = k(); )
        de !== !1 && re.push(de);
      return re;
    }
    function k() {
      var re = l();
      if (!(n.charAt(0) != "/" || n.charAt(1) != "*")) {
        for (var de = 2; n.charAt(de) != "" && (n.charAt(de) != "*" || n.charAt(de + 1) != "/"); ) ++de;
        if (de += 2, n.charAt(de - 1) === "")
          return d("End of comment missing");
        var Be = n.slice(2, de - 2);
        return s += 2, o(Be), n = n.slice(de), s += 2, re({
          type: "comment",
          comment: Be
        });
      }
    }
    function F() {
      var re = y(/^([^{]+)/);
      if (re)
        return e(re[0]).replace(/\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*\/+/g, "").replace(/"(?:\\"|[^"])*"|'(?:\\'|[^'])*'/g, function(de) {
          return de.replace(/,/g, "‌");
        }).split(/\s*(?![^(]*\)),\s*/).map(function(de) {
          return de.replace(/\u200C/g, ",");
        });
    }
    function S() {
      var re = l(), de = y(/^(\*?[-#\/\*\\\w]+(\[[0-9a-z_-]+\])?)\s*/);
      if (de) {
        if (de = e(de[0]), !y(/^:\s*/)) return d("property missing ':'");
        var Be = y(/^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^\)]*?\)|[^};])+)/), ke = re({
          type: "declaration",
          property: de.replace(r, ""),
          value: Be ? e(Be[0]).replace(r, "") : ""
        });
        return y(/^[;\s]*/), ke;
      }
    }
    function R() {
      var re = [];
      if (!h()) return d("missing '{'");
      x(re);
      for (var de; de = S(); )
        de !== !1 && (re.push(de), x(re));
      return g() ? re : d("missing '}'");
    }
    function M() {
      for (var re, de = [], Be = l(); re = y(/^((\d+\.\d+|\.\d+|\d+)%?|[a-z]+)\s*/); )
        de.push(re[1]), y(/^,\s*/);
      if (de.length)
        return Be({
          type: "keyframe",
          values: de,
          declarations: R()
        });
    }
    function j() {
      var re = l(), Be = y(/^@([-\w]+)?keyframes\s*/);
      if (Be) {
        var de = Be[1], Be = y(/^([-\w]+)\s*/);
        if (!Be) return d("@keyframes missing name");
        var ke = Be[1];
        if (!h()) return d("@keyframes missing '{'");
        for (var ze, je = x(); ze = M(); )
          je.push(ze), je = je.concat(x());
        return g() ? re({
          type: "keyframes",
          name: ke,
          vendor: de,
          keyframes: je
        }) : d("@keyframes missing '}'");
      }
    }
    function G() {
      var re = l(), de = y(/^@supports *([^{]+)/);
      if (de) {
        var Be = e(de[1]);
        if (!h()) return d("@supports missing '{'");
        var ke = x().concat(v());
        return g() ? re({
          type: "supports",
          supports: Be,
          rules: ke
        }) : d("@supports missing '}'");
      }
    }
    function ie() {
      var re = l(), de = y(/^@host\s*/);
      if (de) {
        if (!h()) return d("@host missing '{'");
        var Be = x().concat(v());
        return g() ? re({
          type: "host",
          rules: Be
        }) : d("@host missing '}'");
      }
    }
    function q() {
      var re = l(), de = y(/^@media *([^{]+)/);
      if (de) {
        var Be = e(de[1]);
        if (!h()) return d("@media missing '{'");
        var ke = x().concat(v());
        return g() ? re({
          type: "media",
          media: Be,
          rules: ke
        }) : d("@media missing '}'");
      }
    }
    function Y() {
      var re = l(), de = y(/^@custom-media\s+(--[^\s]+)\s*([^{;]+);/);
      if (de)
        return re({
          type: "custom-media",
          name: e(de[1]),
          media: e(de[2])
        });
    }
    function J() {
      var re = l(), de = y(/^@page */);
      if (de) {
        var Be = F() || [];
        if (!h()) return d("@page missing '{'");
        for (var ke = x(), ze; ze = S(); )
          ke.push(ze), ke = ke.concat(x());
        return g() ? re({
          type: "page",
          selectors: Be,
          declarations: ke
        }) : d("@page missing '}'");
      }
    }
    function se() {
      var re = l(), de = y(/^@([-\w]+)?document *([^{]+)/);
      if (de) {
        var Be = e(de[1]), ke = e(de[2]);
        if (!h()) return d("@document missing '{'");
        var ze = x().concat(v());
        return g() ? re({
          type: "document",
          document: ke,
          vendor: Be,
          rules: ze
        }) : d("@document missing '}'");
      }
    }
    function oe() {
      var re = l(), de = y(/^@font-face\s*/);
      if (de) {
        if (!h()) return d("@font-face missing '{'");
        for (var Be = x(), ke; ke = S(); )
          Be.push(ke), Be = Be.concat(x());
        return g() ? re({
          type: "font-face",
          declarations: Be
        }) : d("@font-face missing '}'");
      }
    }
    var he = Re("import"), ye = Re("charset"), Ue = Re("namespace");
    function Re(re) {
      var de = new RegExp("^@" + re + "\\s*([^;]+);");
      return function() {
        var Be = l(), ke = y(de);
        if (ke) {
          var ze = { type: re };
          return ze[re] = ke[1].trim(), Be(ze);
        }
      };
    }
    function Oe() {
      if (n[0] == "@")
        return j() || q() || Y() || G() || he() || ye() || Ue() || se() || J() || ie() || oe();
    }
    function ee() {
      var re = l(), de = F();
      return de ? (x(), re({
        type: "rule",
        selectors: de,
        declarations: R()
      })) : d("selector missing");
    }
    return t(f());
  };
  function e(n) {
    return n ? n.replace(/^\s+|\s+$/g, "") : "";
  }
  function t(n, i) {
    var a = n && typeof n.type == "string", s = a ? n : i;
    for (var o in n) {
      var l = n[o];
      Array.isArray(l) ? l.forEach(function(u) {
        t(u, s);
      }) : l && typeof l == "object" && t(l, s);
    }
    return a && Object.defineProperty(n, "parent", {
      configurable: !0,
      writable: !0,
      enumerable: !1,
      value: i || null
    }), n;
  }
  return n0;
}
var qw;
function nO() {
  return qw || (qw = 1, r0.parse = rO()), r0;
}
var Fk = nO();
function ko(r) {
  return Array.isArray ? Array.isArray(r) : Dk(r) === "[object Array]";
}
function iO(r) {
  if (typeof r == "string") return r;
  if (typeof r == "bigint") return r.toString();
  const e = r + "";
  return e == "0" && 1 / r == -1 / 0 ? "-0" : e;
}
function wy(r) {
  return r == null ? "" : iO(r);
}
function Li(r) {
  return typeof r == "string";
}
function Rp(r) {
  return typeof r == "number";
}
function aO(r) {
  return r === !0 || r === !1 || sO(r) && Dk(r) == "[object Boolean]";
}
function Ik(r) {
  return typeof r == "object";
}
function sO(r) {
  return Ik(r) && r !== null;
}
function ea(r) {
  return r != null;
}
function Rh(r) {
  return !r.trim().length;
}
function Dk(r) {
  return r == null ? r === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(r);
}
const oO = "Incorrect 'index' type", xy = "Invalid doc index: must be a non-negative integer within the bounds of the docs array", lO = (r) => `Invalid value for key ${r}`, uO = (r) => `Pattern length exceeds max of ${r}.`, cO = (r) => `Missing ${r} property in key`, fO = (r) => `Property 'weight' in key '${r}' must be a positive integer`, dO = "Fuse.match does not support useTokenSearch: token search requires corpus-level statistics (df, fieldCount) that a one-off string comparison does not have. Use new Fuse(...).search(...) instead.", Ww = Object.prototype.hasOwnProperty;
var hO = class {
  constructor(r) {
    this._keys = [], this._keyMap = {};
    let e = 0;
    r.forEach((t) => {
      const n = Pk(t);
      this._keys.push(n), this._keyMap[n.id] = n, e += n.weight;
    }), this._keys.forEach((t) => {
      t.weight /= e;
    });
  }
  get(r) {
    return this._keyMap[r];
  }
  keys() {
    return this._keys;
  }
  toJSON() {
    return JSON.stringify(this._keys);
  }
};
function Pk(r) {
  let e = null, t = null, n = null, i = 1, a = null;
  if (Li(r) || ko(r))
    n = r, e = Qw(r), t = Op(r);
  else {
    if (!Ww.call(r, "name")) throw new Error(cO("name"));
    const s = r.name;
    if (n = s, Ww.call(r, "weight") && r.weight !== void 0 && (i = r.weight, i <= 0))
      throw new Error(fO(Op(s)));
    e = Qw(s), t = Op(s), a = r.getFn ?? null;
  }
  return {
    path: e,
    id: t,
    weight: i,
    src: n,
    getFn: a
  };
}
function Qw(r) {
  return ko(r) ? r : r.split(".");
}
function Op(r) {
  return ko(r) ? r.join(".") : r;
}
function pO(r, e) {
  const t = [];
  let n = !1;
  const i = (a, s, o, l) => {
    if (ea(a))
      if (!s[o]) t.push(l !== void 0 ? {
        v: a,
        i: l
      } : a);
      else {
        const u = a[s[o]];
        if (!ea(u)) return;
        if (o === s.length - 1 && (Li(u) || Rp(u) || aO(u) || typeof u == "bigint")) t.push(l !== void 0 ? {
          v: wy(u),
          i: l
        } : wy(u));
        else if (ko(u)) {
          n = !0;
          for (let c = 0, d = u.length; c < d; c += 1) i(u[c], s, o + 1, c);
        } else s.length && i(u, s, o + 1, l);
      }
  };
  return i(r, Li(e) ? e.split(".") : e, 0), n ? t : t[0];
}
const gO = {
  includeMatches: !1,
  findAllMatches: !1,
  minMatchCharLength: 1
}, mO = {
  isCaseSensitive: !1,
  ignoreDiacritics: !1,
  includeScore: !1,
  keys: [],
  shouldSort: !0,
  sortFn: (r, e) => r.score === e.score ? r.idx < e.idx ? -1 : 1 : r.score < e.score ? -1 : 1
}, vO = {
  location: 0,
  threshold: 0.6,
  distance: 100
}, yO = {
  useExtendedSearch: !1,
  useTokenSearch: !1,
  tokenize: void 0,
  tokenMatch: "any",
  getFn: pO,
  ignoreLocation: !1,
  ignoreFieldNorm: !1,
  fieldNormWeight: 1
}, Wt = Object.freeze({
  ...mO,
  ...gO,
  ...vO,
  ...yO
});
function AO(r = 1, e = 3) {
  const t = /* @__PURE__ */ new Map(), n = Math.pow(10, e);
  return {
    get(i) {
      let a = 1, s = !1;
      for (let l = 0; l < i.length; l++) i.charCodeAt(l) === 32 ? s || (a++, s = !0) : s = !1;
      if (t.has(a)) return t.get(a);
      const o = Math.round(n / Math.pow(a, 0.5 * r)) / n;
      return t.set(a, o), o;
    },
    clear() {
      t.clear();
    }
  };
}
var OA = class {
  constructor({ getFn: r = Wt.getFn, fieldNormWeight: e = Wt.fieldNormWeight } = {}) {
    this.norm = AO(e, 3), this.getFn = r, this.isCreated = !1, this.docs = [], this.keys = [], this._keysMap = {}, this.setIndexRecords();
  }
  setSources(r = []) {
    this.docs = r;
  }
  setIndexRecords(r = []) {
    this.records = r;
  }
  setKeys(r = []) {
    this.keys = r, this._keysMap = {}, r.forEach((e, t) => {
      this._keysMap[e.id] = t;
    });
  }
  create() {
    if (this.isCreated || !this.docs.length) return;
    this.isCreated = !0;
    const r = this.docs.length;
    this.records = new Array(r);
    let e = 0;
    if (Li(this.docs[0])) for (let t = 0; t < r; t++) {
      const n = this._createStringRecord(this.docs[t], t);
      n && (this.records[e++] = n);
    }
    else for (let t = 0; t < r; t++) this.records[e++] = this._createObjectRecord(this.docs[t], t);
    this.records.length = e, this.norm.clear();
  }
  add(r, e) {
    if (!Number.isInteger(e) || e < 0) throw new Error(xy);
    if (Li(r)) {
      const n = this._createStringRecord(r, e);
      return n && this.records.push(n), n;
    }
    const t = this._createObjectRecord(r, e);
    return this.records.push(t), t;
  }
  removeAt(r) {
    if (!Number.isInteger(r) || r < 0) throw new Error(xy);
    for (let e = 0, t = this.records.length; e < t; e += 1) if (this.records[e].i === r) {
      this.records.splice(e, 1);
      break;
    }
    for (let e = 0, t = this.records.length; e < t; e += 1) this.records[e].i > r && (this.records[e].i -= 1);
  }
  removeAll(r) {
    const e = /* @__PURE__ */ new Set();
    for (const n of r) Number.isInteger(n) && n >= 0 && e.add(n);
    if (e.size === 0) return;
    this.records = this.records.filter((n) => !e.has(n.i));
    const t = Array.from(e).sort((n, i) => n - i);
    for (const n of this.records) {
      let i = 0, a = t.length;
      for (; i < a; ) {
        const s = i + a >>> 1;
        t[s] < n.i ? i = s + 1 : a = s;
      }
      n.i -= i;
    }
  }
  getValueForItemAtKeyId(r, e) {
    return r[this._keysMap[e]];
  }
  size() {
    return this.records.length;
  }
  _createStringRecord(r, e) {
    return !ea(r) || Rh(r) ? null : {
      v: r,
      i: e,
      n: this.norm.get(r)
    };
  }
  _createObjectRecord(r, e) {
    const t = {
      i: e,
      $: {}
    };
    for (let n = 0, i = this.keys.length; n < i; n++) {
      const a = this.keys[n], s = a.getFn ? a.getFn(r) : this.getFn(r, a.path);
      if (ea(s)) {
        if (ko(s)) {
          const o = [];
          for (let l = 0, u = s.length; l < u; l += 1) {
            const c = s[l];
            if (ea(c)) {
              if (Li(c)) {
                if (!Rh(c)) {
                  const d = {
                    v: c,
                    i: l,
                    n: this.norm.get(c)
                  };
                  o.push(d);
                }
              } else if (ea(c.v)) {
                const d = Li(c.v) ? c.v : wy(c.v);
                if (!Rh(d)) {
                  const f = {
                    v: d,
                    i: c.i,
                    n: this.norm.get(d)
                  };
                  o.push(f);
                }
              }
            }
          }
          t.$[n] = o;
        } else if (Li(s) && !Rh(s)) {
          const o = {
            v: s,
            n: this.norm.get(s)
          };
          t.$[n] = o;
        }
      }
    }
    return t;
  }
  toJSON() {
    return {
      keys: this.keys.map(({ getFn: r, ...e }) => e),
      records: this.records
    };
  }
};
function Rk(r, e, { getFn: t = Wt.getFn, fieldNormWeight: n = Wt.fieldNormWeight } = {}) {
  const i = new OA({
    getFn: t,
    fieldNormWeight: n
  });
  return i.setKeys(r.map(Pk)), i.setSources(e), i.create(), i;
}
function bO(r, { getFn: e = Wt.getFn, fieldNormWeight: t = Wt.fieldNormWeight } = {}) {
  const { keys: n, records: i } = r, a = new OA({
    getFn: e,
    fieldNormWeight: t
  });
  return a.setKeys(n), a.setIndexRecords(i), a;
}
function wO(r = [], e = Wt.minMatchCharLength) {
  const t = [];
  let n = -1, i = -1, a = 0;
  for (let s = r.length; a < s; a += 1) {
    const o = r[a];
    o && n === -1 ? n = a : !o && n !== -1 && (i = a - 1, i - n + 1 >= e && t.push([n, i]), n = -1);
  }
  return r[a - 1] && a - n >= e && t.push([n, a - 1]), t;
}
function xO(r, e, t, { location: n = Wt.location, distance: i = Wt.distance, threshold: a = Wt.threshold, findAllMatches: s = Wt.findAllMatches, minMatchCharLength: o = Wt.minMatchCharLength, includeMatches: l = Wt.includeMatches, ignoreLocation: u = Wt.ignoreLocation } = {}) {
  if (e.length > 32) throw new Error(uO(32));
  const c = e.length, d = r.length, f = Math.max(0, Math.min(n, d));
  let h = a, g = f;
  const v = (G, ie) => {
    const q = G / c;
    if (u) return q;
    const Y = Math.abs(f - ie);
    return i ? q + Y / i : Y ? 1 : q;
  }, y = o > 1 || l, A = y ? Array(d) : [];
  let x;
  for (; (x = r.indexOf(e, g)) > -1; ) {
    const G = v(0, x);
    if (h = Math.min(G, h), g = x + c, y) {
      let ie = 0;
      for (; ie < c; )
        A[x + ie] = 1, ie += 1;
    }
  }
  g = -1;
  let k = [], F = 1, S = 0, R = c + d;
  const M = 1 << c - 1;
  for (let G = 0; G < c; G += 1) {
    let ie = 0, q = R;
    for (; ie < q; )
      v(G, f + q) <= h ? ie = q : R = q, q = Math.floor((R - ie) / 2 + ie);
    R = q;
    let Y = Math.max(1, f - q + 1);
    const J = s ? d : Math.min(f + q, d) + c, se = Array(J + 2);
    se[J + 1] = (1 << G) - 1;
    for (let oe = J; oe >= Y; oe -= 1) {
      const he = oe - 1, ye = t[r[he]];
      if (se[oe] = (se[oe + 1] << 1 | 1) & ye, G && (se[oe] |= (k[oe + 1] | k[oe]) << 1 | 1 | k[oe + 1]), se[oe] & M && (F = v(G, he), F <= h)) {
        if (h = F, g = he, S = G, g <= f) break;
        Y = Math.max(1, 2 * f - g);
      }
    }
    if (v(G + 1, f) > h) break;
    k = se;
  }
  if (y && g >= 0) {
    const G = Math.min(d - 1, g + c - 1 + S);
    for (let ie = g; ie <= G; ie += 1) t[r[ie]] && (A[ie] = 1);
  }
  const j = {
    isMatch: g >= 0,
    score: Math.max(1e-3, F)
  };
  if (y) {
    const G = wO(A, o);
    G.length ? l && (j.indices = G) : j.isMatch = !1;
  }
  return j;
}
function CO(r) {
  const e = {};
  for (let t = 0, n = r.length; t < n; t += 1) {
    const i = r.charAt(t);
    e[i] = (e[i] || 0) | 1 << n - t - 1;
  }
  return e;
}
function BA(r) {
  if (r.length <= 1) return r;
  r.sort((t, n) => t[0] - n[0] || t[1] - n[1]);
  const e = [r[0]];
  for (let t = 1, n = r.length; t < n; t += 1) {
    const i = e[e.length - 1], a = r[t];
    a[0] <= i[1] + 1 ? i[1] = Math.max(i[1], a[1]) : e.push(a);
  }
  return e;
}
const Ok = {
  ł: "l",
  Ł: "L",
  đ: "d",
  Đ: "D",
  ø: "o",
  Ø: "O",
  ħ: "h",
  Ħ: "H",
  ŧ: "t",
  Ŧ: "T",
  ı: "i",
  ß: "ss"
}, SO = new RegExp("[" + Object.keys(Ok).join("") + "]", "g"), sd = typeof String.prototype.normalize == "function" ? (r) => r.normalize("NFD").replace(/[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C04\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ABE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2-\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]/g, "").replace(SO, (e) => Ok[e]) : (r) => r;
var MA = class {
  constructor(r, { location: e = Wt.location, threshold: t = Wt.threshold, distance: n = Wt.distance, includeMatches: i = Wt.includeMatches, findAllMatches: a = Wt.findAllMatches, minMatchCharLength: s = Wt.minMatchCharLength, isCaseSensitive: o = Wt.isCaseSensitive, ignoreDiacritics: l = Wt.ignoreDiacritics, ignoreLocation: u = Wt.ignoreLocation } = {}) {
    if (this.options = {
      location: e,
      threshold: t,
      distance: n,
      includeMatches: i,
      findAllMatches: a,
      minMatchCharLength: s,
      isCaseSensitive: o,
      ignoreDiacritics: l,
      ignoreLocation: u
    }, r = o ? r : r.toLowerCase(), r = l ? sd(r) : r, this.pattern = r, this.chunks = [], !this.pattern.length) return;
    const c = (f, h) => {
      this.chunks.push({
        pattern: f,
        alphabet: CO(f),
        startIndex: h
      });
    }, d = this.pattern.length;
    if (d > 32) {
      let f = 0;
      const h = d % 32, g = d - h;
      for (; f < g; )
        c(this.pattern.substr(f, 32), f), f += 32;
      if (h) {
        const v = d - 32;
        c(this.pattern.substr(v), v);
      }
    } else c(this.pattern, 0);
  }
  searchIn(r) {
    const { isCaseSensitive: e, ignoreDiacritics: t, includeMatches: n } = this.options;
    if (r = e ? r : r.toLowerCase(), r = t ? sd(r) : r, this.pattern === r) {
      const g = {
        isMatch: !0,
        score: 0
      };
      return n && (g.indices = [[0, r.length - 1]]), g;
    }
    const { location: i, distance: a, threshold: s, findAllMatches: o, minMatchCharLength: l, ignoreLocation: u } = this.options, c = [];
    let d = 0, f = !1;
    this.chunks.forEach(({ pattern: g, alphabet: v, startIndex: y }) => {
      const { isMatch: A, score: x, indices: k } = xO(r, g, v, {
        location: i + y,
        distance: a,
        threshold: s,
        findAllMatches: o,
        minMatchCharLength: l,
        includeMatches: n,
        ignoreLocation: u
      });
      A && (f = !0), d += x, A && k && c.push(...k);
    });
    const h = {
      isMatch: f,
      score: f ? d / this.chunks.length : 1
    };
    return f && n && (h.indices = BA(c)), h;
  }
};
const EO = /* @__PURE__ */ new Set(["fuzzy", "include"]);
function kO(r) {
  return r.startsWith("inverse");
}
const Cy = [
  {
    type: "exact",
    multiRegex: /^="(.*)"$/,
    singleRegex: /^=(.*)$/,
    create: (r) => ({
      type: "exact",
      search(e) {
        const t = e === r;
        return {
          isMatch: t,
          score: t ? 0 : 1,
          indices: [0, r.length - 1]
        };
      }
    })
  },
  {
    type: "include",
    multiRegex: /^'"(.*)"$/,
    singleRegex: /^'(.*)$/,
    create: (r) => ({
      type: "include",
      search(e) {
        let t = 0, n;
        const i = [], a = r.length;
        for (; (n = e.indexOf(r, t)) > -1; )
          t = n + a, i.push([n, t - 1]);
        const s = !!i.length;
        return {
          isMatch: s,
          score: s ? 0 : 1,
          indices: i
        };
      }
    })
  },
  {
    type: "prefix-exact",
    multiRegex: /^\^"(.*)"$/,
    singleRegex: /^\^(.*)$/,
    create: (r) => ({
      type: "prefix-exact",
      search(e) {
        const t = e.startsWith(r);
        return {
          isMatch: t,
          score: t ? 0 : 1,
          indices: [0, r.length - 1]
        };
      }
    })
  },
  {
    type: "inverse-prefix-exact",
    multiRegex: /^!\^"(.*)"$/,
    singleRegex: /^!\^(.*)$/,
    create: (r) => ({
      type: "inverse-prefix-exact",
      search(e) {
        const t = !e.startsWith(r);
        return {
          isMatch: t,
          score: t ? 0 : 1,
          indices: [0, e.length - 1]
        };
      }
    })
  },
  {
    type: "inverse-suffix-exact",
    multiRegex: /^!"(.*)"\$$/,
    singleRegex: /^!(.*)\$$/,
    create: (r) => ({
      type: "inverse-suffix-exact",
      search(e) {
        const t = !e.endsWith(r);
        return {
          isMatch: t,
          score: t ? 0 : 1,
          indices: [0, e.length - 1]
        };
      }
    })
  },
  {
    type: "suffix-exact",
    multiRegex: /^"(.*)"\$$/,
    singleRegex: /^(.*)\$$/,
    create: (r) => ({
      type: "suffix-exact",
      search(e) {
        const t = e.endsWith(r);
        return {
          isMatch: t,
          score: t ? 0 : 1,
          indices: [e.length - r.length, e.length - 1]
        };
      }
    })
  },
  {
    type: "inverse-exact",
    multiRegex: /^!"(.*)"$/,
    singleRegex: /^!(.*)$/,
    create: (r) => ({
      type: "inverse-exact",
      search(e) {
        const t = e.indexOf(r) === -1;
        return {
          isMatch: t,
          score: t ? 0 : 1,
          indices: [0, e.length - 1]
        };
      }
    })
  },
  {
    type: "fuzzy",
    multiRegex: /^"(.*)"$/,
    singleRegex: /^(.*)$/,
    create: (r, e = {}) => {
      const t = new MA(r, {
        location: e.location ?? Wt.location,
        threshold: e.threshold ?? Wt.threshold,
        distance: e.distance ?? Wt.distance,
        includeMatches: e.includeMatches ?? Wt.includeMatches,
        findAllMatches: e.findAllMatches ?? Wt.findAllMatches,
        minMatchCharLength: e.minMatchCharLength ?? Wt.minMatchCharLength,
        isCaseSensitive: e.isCaseSensitive ?? Wt.isCaseSensitive,
        ignoreDiacritics: e.ignoreDiacritics ?? Wt.ignoreDiacritics,
        ignoreLocation: e.ignoreLocation ?? Wt.ignoreLocation
      });
      return {
        type: "fuzzy",
        search(n) {
          return t.searchIn(n);
        }
      };
    }
  }
], Yw = Cy.length, TO = "\0", FO = "|";
function IO(r) {
  const e = [], t = r.length;
  let n = 0;
  for (; n < t; ) {
    for (; n < t && r[n] === " "; ) n++;
    if (n >= t) break;
    let i = n;
    for (; i < t && r[i] !== " " && r[i] !== '"'; ) i++;
    if (i < t && r[i] === '"') {
      for (i++; i < t; ) {
        if (r[i] === '"') {
          const a = i + 1;
          if (a >= t || r[a] === " ") {
            i++;
            break;
          }
          if (r[a] === "$" && (a + 1 >= t || r[a + 1] === " ")) {
            i += 2;
            break;
          }
        }
        i++;
      }
      e.push(r.substring(n, i)), n = i;
    } else {
      for (; i < t && r[i] !== " "; ) i++;
      e.push(r.substring(n, i)), n = i;
    }
  }
  return e;
}
function Xw(r, e) {
  const t = r.match(e);
  return t ? t[1] : null;
}
function DO(r, e = {}) {
  return r.replace(/\\\|/g, TO).split(FO).map((t) => {
    const n = IO(t.replace(/\u0000/g, "|").trim()).filter((a) => a && !!a.trim()), i = [];
    for (let a = 0, s = n.length; a < s; a += 1) {
      const o = n[a];
      let l = !1, u = -1;
      for (; !l && ++u < Yw; ) {
        const c = Cy[u], d = Xw(o, c.multiRegex);
        d && (i.push(c.create(d, e)), l = !0);
      }
      if (!l)
        for (u = -1; ++u < Yw; ) {
          const c = Cy[u], d = Xw(o, c.singleRegex);
          if (d) {
            i.push(c.create(d, e));
            break;
          }
        }
    }
    return i;
  });
}
var PO = class {
  constructor(r, { isCaseSensitive: e = Wt.isCaseSensitive, ignoreDiacritics: t = Wt.ignoreDiacritics, includeMatches: n = Wt.includeMatches, minMatchCharLength: i = Wt.minMatchCharLength, ignoreLocation: a = Wt.ignoreLocation, findAllMatches: s = Wt.findAllMatches, location: o = Wt.location, threshold: l = Wt.threshold, distance: u = Wt.distance } = {}) {
    this.query = null, this.options = {
      isCaseSensitive: e,
      ignoreDiacritics: t,
      includeMatches: n,
      minMatchCharLength: i,
      findAllMatches: s,
      ignoreLocation: a,
      location: o,
      threshold: l,
      distance: u
    }, r = e ? r : r.toLowerCase(), r = t ? sd(r) : r, this.pattern = r, this.query = DO(this.pattern, this.options);
  }
  static condition(r, e) {
    return e.useExtendedSearch;
  }
  searchIn(r) {
    const e = this.query;
    if (!e) return {
      isMatch: !1,
      score: 1
    };
    const { includeMatches: t, isCaseSensitive: n, ignoreDiacritics: i } = this.options;
    r = n ? r : r.toLowerCase(), r = i ? sd(r) : r;
    let a = 0;
    const s = [];
    let o = 0, l = !1;
    for (let u = 0, c = e.length; u < c; u += 1) {
      const d = e[u];
      s.length = 0, a = 0, l = !1;
      for (let f = 0, h = d.length; f < h; f += 1) {
        const g = d[f], { isMatch: v, indices: y, score: A } = g.search(r);
        if (v)
          a += 1, o += A, kO(g.type) && (l = !0), t && (EO.has(g.type) ? s.push(...y) : s.push(y));
        else {
          o = 0, a = 0, s.length = 0, l = !1;
          break;
        }
      }
      if (a) {
        const f = {
          isMatch: !0,
          score: o / a
        };
        return l && (f.hasInverse = !0), t && (f.indices = BA(s)), f;
      }
    }
    return {
      isMatch: !1,
      score: 1
    };
  }
};
const Sy = [];
function _A(...r) {
  Sy.push(...r);
}
function Jp(r, e) {
  for (let t = 0, n = Sy.length; t < n; t += 1) {
    const i = Sy[t];
    if (i.condition(r, e)) return new i(r, e);
  }
  return new MA(r, e);
}
const Kp = {
  AND: "$and",
  OR: "$or"
}, Ey = {
  PATH: "$path",
  PATTERN: "$val"
}, ky = (r) => !!(r[Kp.AND] || r[Kp.OR]), RO = (r) => !!r[Ey.PATH], OO = (r) => !ko(r) && Ik(r) && !ky(r), Jw = (r) => ({ [Kp.AND]: Object.keys(r).map((e) => ({ [e]: r[e] })) });
function Bk(r, e, { auto: t = !0 } = {}) {
  const n = (i) => {
    if (Li(i)) {
      const l = {
        keyId: null,
        pattern: i
      };
      return t && (l.searcher = Jp(i, e)), l;
    }
    const a = Object.keys(i), s = RO(i);
    if (!s && a.length > 1 && !ky(i)) return n(Jw(i));
    if (OO(i)) {
      const l = s ? i[Ey.PATH] : a[0], u = s ? i[Ey.PATTERN] : i[l];
      if (!Li(u)) throw new Error(lO(l));
      const c = {
        keyId: Op(l),
        pattern: u
      };
      return t && (c.searcher = Jp(u, e)), c;
    }
    const o = {
      children: [],
      operator: a[0]
    };
    return a.forEach((l) => {
      const u = i[l];
      ko(u) && u.forEach((c) => {
        o.children.push(n(c));
      });
    }), o;
  };
  return ky(r) || (r = Jw(r)), n(r);
}
function Ty(r, { ignoreFieldNorm: e = Wt.ignoreFieldNorm }) {
  let t = 1;
  return r.forEach(({ key: n, norm: i, score: a }) => {
    const s = n ? n.weight : null;
    t *= Math.pow(a === 0 && s ? Number.EPSILON : a, (s || 1) * (e ? 1 : i));
  }), t;
}
function BO(r, { ignoreFieldNorm: e = Wt.ignoreFieldNorm }) {
  r.forEach((t) => {
    t.score = Ty(t.matches, { ignoreFieldNorm: e });
  });
}
var MO = class {
  constructor(r) {
    this.limit = r, this.heap = [];
  }
  get size() {
    return this.heap.length;
  }
  shouldInsert(r) {
    return this.size < this.limit || r < this.heap[0].score;
  }
  insert(r) {
    this.size < this.limit ? (this.heap.push(r), this._bubbleUp(this.size - 1)) : r.score < this.heap[0].score && (this.heap[0] = r, this._sinkDown(0));
  }
  extractSorted(r) {
    return this.heap.sort(r);
  }
  _bubbleUp(r) {
    const e = this.heap;
    for (; r > 0; ) {
      const t = r - 1 >> 1;
      if (e[r].score <= e[t].score) break;
      const n = e[r];
      e[r] = e[t], e[t] = n, r = t;
    }
  }
  _sinkDown(r) {
    const e = this.heap, t = e.length;
    let n = r;
    do {
      r = n;
      const i = 2 * r + 1, a = 2 * r + 2;
      if (i < t && e[i].score > e[n].score && (n = i), a < t && e[a].score > e[n].score && (n = a), n !== r) {
        const s = e[r];
        e[r] = e[n], e[n] = s;
      }
    } while (n !== r);
  }
};
function _O(r) {
  const e = [];
  return r.matches.forEach((t) => {
    if (!ea(t.indices) || !t.indices.length) return;
    const n = {
      indices: t.indices,
      value: t.value
    };
    t.key && (n.key = t.key.id), t.idx > -1 && (n.refIndex = t.idx), e.push(n);
  }), e;
}
function NO(r, e, { includeMatches: t = Wt.includeMatches, includeScore: n = Wt.includeScore } = {}) {
  return r.map((i) => {
    const { idx: a } = i, s = {
      item: e[a],
      refIndex: a
    };
    return t && (s.matches = _O(i)), n && (s.score = i.score), s;
  });
}
const LO = /[\p{L}\p{M}\p{N}_]+/gu, Kw = /* @__PURE__ */ new WeakSet();
function UO(r) {
  Kw.has(r) || (Kw.add(r), console.warn(`[Fuse] tokenize regex ${r} lacks the global flag; only the first match per text will be returned. Add the 'g' flag.`));
}
function VO(r) {
  if (typeof r == "function") {
    let e = !1;
    return (t) => {
      const n = r(t);
      if (!e && (e = !0, !Array.isArray(n) || n.some((i) => typeof i != "string")))
        throw new Error(`[Fuse] tokenize function must return string[]; received ${Array.isArray(n) ? "array containing non-strings" : typeof n}.`);
      return n;
    };
  }
  return r instanceof RegExp ? (r.global || UO(r), (e) => e.match(r) || []) : (e) => e.match(LO) || [];
}
function Fy({ isCaseSensitive: r = !1, ignoreDiacritics: e = !1, tokenize: t } = {}) {
  const n = VO(t);
  return { tokenize(i) {
    return r || (i = i.toLowerCase()), e && (i = sd(i)), n(i);
  } };
}
var zO = class {
  static condition(r, e) {
    return e.useTokenSearch;
  }
  constructor(r, e) {
    this.options = e, this.analyzer = Fy({
      isCaseSensitive: e.isCaseSensitive,
      ignoreDiacritics: e.ignoreDiacritics,
      tokenize: e.tokenize
    });
    const t = this.analyzer.tokenize(r), { df: n, fieldCount: i } = e._invertedIndex;
    this.termSearchers = [], this.idfWeights = [];
    for (const a of t) {
      this.termSearchers.push(new MA(a, {
        location: e.location,
        threshold: e.threshold,
        distance: e.distance,
        includeMatches: e.includeMatches,
        findAllMatches: e.findAllMatches,
        minMatchCharLength: e.minMatchCharLength,
        isCaseSensitive: e.isCaseSensitive,
        ignoreDiacritics: e.ignoreDiacritics,
        ignoreLocation: !0
      }));
      const s = n.get(a) || 0, o = Math.log(1 + (i - s + 0.5) / (s + 0.5));
      this.idfWeights.push(o);
    }
    this.combineAll = e.tokenMatch === "all", this.numTerms = this.termSearchers.length, this.useMask = this.numTerms <= 31;
  }
  searchIn(r) {
    if (!this.termSearchers.length) return {
      isMatch: !1,
      score: 1
    };
    const e = [];
    let t = 0, n = 0, i = 0, a = 0;
    const s = this.combineAll && !this.useMask ? /* @__PURE__ */ new Set() : null;
    for (let u = 0; u < this.termSearchers.length; u++) {
      const c = this.termSearchers[u].searchIn(r), d = this.idfWeights[u];
      n += d, c.isMatch && (i++, t += d * (1 - c.score), c.indices && e.push(...c.indices), this.combineAll && (this.useMask ? a |= 1 << u : s.add(u)));
    }
    if (i === 0) return {
      isMatch: !1,
      score: 1
    };
    const o = n > 0 ? 1 - t / n : 0, l = {
      isMatch: !0,
      score: Math.max(1e-3, o)
    };
    return this.options.includeMatches && e.length && (l.indices = BA(e)), this.combineAll && (this.useMask ? l.matchedMask = a : l.matchedTerms = s, l.termCount = this.numTerms), l;
  }
};
function i0(r, e, t, n) {
  const i = n.tokenize(e);
  if (!i.length) return;
  r.fieldCount++, r.docFieldCount.set(t, (r.docFieldCount.get(t) || 0) + 1);
  const a = new Set(i);
  let s = r.docTermFieldHits.get(t);
  s || (s = /* @__PURE__ */ new Map(), r.docTermFieldHits.set(t, s));
  for (const o of a)
    s.set(o, (s.get(o) || 0) + 1), r.df.set(o, (r.df.get(o) || 0) + 1);
}
function Mk(r, e, t, n) {
  const { i, v: a, $: s } = e;
  if (a !== void 0) {
    i0(r, a, i, n);
    return;
  }
  if (s)
    for (let o = 0; o < t; o++) {
      const l = s[o];
      if (l)
        if (Array.isArray(l)) for (const u of l) i0(r, u.v, i, n);
        else i0(r, l.v, i, n);
    }
}
function $O(r, e, t) {
  const n = {
    fieldCount: 0,
    df: /* @__PURE__ */ new Map(),
    docFieldCount: /* @__PURE__ */ new Map(),
    docTermFieldHits: /* @__PURE__ */ new Map()
  };
  for (const i of r) Mk(n, i, e, t);
  return n;
}
function HO(r, e, t, n) {
  Mk(r, e, t, n);
}
function jO(r, e) {
  const t = r.docFieldCount.get(e);
  if (t === void 0) return;
  r.fieldCount -= t, r.docFieldCount.delete(e);
  const n = r.docTermFieldHits.get(e);
  if (n) {
    for (const [i, a] of n) {
      const s = (r.df.get(i) || 0) - a;
      s <= 0 ? r.df.delete(i) : r.df.set(i, s);
    }
    r.docTermFieldHits.delete(e);
  }
}
function Zw(r, e) {
  if (e.length === 0) return;
  const t = Array.from(new Set(e)).sort((o, l) => o - l);
  for (const o of t) jO(r, o);
  const n = (o) => {
    let l = 0, u = t.length;
    for (; l < u; ) {
      const c = l + u >>> 1;
      t[c] < o ? l = c + 1 : u = c;
    }
    return o - l;
  }, i = t[0], a = /* @__PURE__ */ new Map();
  for (const [o, l] of r.docFieldCount) a.set(o > i ? n(o) : o, l);
  r.docFieldCount = a;
  const s = /* @__PURE__ */ new Map();
  for (const [o, l] of r.docTermFieldHits) s.set(o > i ? n(o) : o, l);
  r.docTermFieldHits = s;
}
var To = class {
  constructor(r, e, t) {
    this.options = {
      ...Wt,
      ...e
    }, this.options.useExtendedSearch, this.options.useTokenSearch, this._keyStore = new hO(this.options.keys), this._docs = r, this._myIndex = null, this._invertedIndex = null, this.setCollection(r, t), this._lastQuery = null, this._lastSearcher = null;
  }
  _getSearcher(r) {
    if (this._lastQuery === r) return this._lastSearcher;
    const e = Jp(r, this._invertedIndex ? {
      ...this.options,
      _invertedIndex: this._invertedIndex
    } : this.options);
    return this._lastQuery = r, this._lastSearcher = e, e;
  }
  setCollection(r, e) {
    if (this._docs = r, e && !(e instanceof OA)) throw new Error(oO);
    if (this._myIndex = e || Rk(this.options.keys, this._docs, {
      getFn: this.options.getFn,
      fieldNormWeight: this.options.fieldNormWeight
    }), this.options.useTokenSearch) {
      const t = Fy({
        isCaseSensitive: this.options.isCaseSensitive,
        ignoreDiacritics: this.options.ignoreDiacritics,
        tokenize: this.options.tokenize
      });
      this._invertedIndex = $O(this._myIndex.records, this._myIndex.keys.length, t);
    }
    this._invalidateSearcherCache();
  }
  add(r) {
    if (!ea(r)) return;
    this._docs.push(r);
    const e = this._myIndex.add(r, this._docs.length - 1);
    if (this._invertedIndex && e) {
      const t = Fy({
        isCaseSensitive: this.options.isCaseSensitive,
        ignoreDiacritics: this.options.ignoreDiacritics,
        tokenize: this.options.tokenize
      });
      HO(this._invertedIndex, e, this._myIndex.keys.length, t);
    }
    this._invalidateSearcherCache();
  }
  remove(r = () => !1) {
    const e = [], t = [];
    for (let n = 0, i = this._docs.length; n < i; n += 1) r(this._docs[n], n) && (e.push(this._docs[n]), t.push(n));
    if (t.length) {
      this._invertedIndex && Zw(this._invertedIndex, t);
      const n = new Set(t);
      this._docs = this._docs.filter((i, a) => !n.has(a)), this._myIndex.removeAll(t), this._invalidateSearcherCache();
    }
    return e;
  }
  removeAt(r) {
    if (!Number.isInteger(r) || r < 0 || r >= this._docs.length) throw new Error(xy);
    this._invertedIndex && Zw(this._invertedIndex, [r]);
    const e = this._docs.splice(r, 1)[0];
    return this._myIndex.removeAt(r), this._invalidateSearcherCache(), e;
  }
  _invalidateSearcherCache() {
    this._lastQuery = null, this._lastSearcher = null;
  }
  getIndex() {
    return this._myIndex;
  }
  search(r, e) {
    const { limit: t = -1 } = e || {}, { includeMatches: n, includeScore: i, shouldSort: a, sortFn: s, ignoreFieldNorm: o } = this.options;
    if (Li(r) && !r.trim()) {
      let c = this._docs.map((d, f) => ({
        item: d,
        refIndex: f
      }));
      return Rp(t) && t > -1 && (c = c.slice(0, t)), c;
    }
    const l = Rp(t) && t > 0 && Li(r);
    let u;
    if (l) {
      const c = new MO(t);
      Li(this._docs[0]) ? this._searchStringList(r, {
        heap: c,
        ignoreFieldNorm: o
      }) : this._searchObjectList(r, {
        heap: c,
        ignoreFieldNorm: o
      }), u = c.extractSorted(s);
    } else
      u = Li(r) ? Li(this._docs[0]) ? this._searchStringList(r) : this._searchObjectList(r) : this._searchLogical(r), BO(u, { ignoreFieldNorm: o }), a && u.sort(s), Rp(t) && t > -1 && (u = u.slice(0, t));
    return NO(u, this._docs, {
      includeMatches: n,
      includeScore: i
    });
  }
  _searchStringList(r, { heap: e, ignoreFieldNorm: t } = {}) {
    const n = this._getSearcher(r), i = this.options.useTokenSearch && this.options.tokenMatch === "all", { records: a } = this._myIndex, s = e ? null : [];
    return a.forEach(({ v: o, i: l, n: u }) => {
      if (!ea(o)) return;
      const c = n.searchIn(o);
      if (c.isMatch) {
        const d = {
          score: c.score,
          value: o,
          norm: u,
          indices: c.indices
        };
        i && (d.matchedMask = c.matchedMask, d.matchedTerms = c.matchedTerms, d.termCount = c.termCount);
        const f = [d];
        if (!i || this._coversAllTokens(f)) {
          const h = {
            item: o,
            idx: l,
            matches: f
          };
          e ? (h.score = Ty(h.matches, { ignoreFieldNorm: t }), e.shouldInsert(h.score) && e.insert(h)) : s.push(h);
        }
      }
    }), s;
  }
  _searchLogical(r) {
    const e = Bk(r, this.options), t = (s, o, l) => {
      if (!("children" in s)) {
        const { keyId: f, searcher: h } = s;
        let g;
        return f === null ? (g = [], this._myIndex.keys.forEach((v, y) => {
          g.push(...this._findMatches({
            key: v,
            value: o[y],
            searcher: h
          }));
        })) : g = this._findMatches({
          key: this._keyStore.get(f),
          value: this._myIndex.getValueForItemAtKeyId(o, f),
          searcher: h
        }), g && g.length ? [{
          idx: l,
          item: o,
          matches: g
        }] : [];
      }
      const { children: u, operator: c } = s, d = [];
      for (let f = 0, h = u.length; f < h; f += 1) {
        const g = u[f], v = t(g, o, l);
        if (v.length) d.push(...v);
        else if (c === Kp.AND) return [];
      }
      return d;
    }, n = this._myIndex.records, i = /* @__PURE__ */ new Map(), a = [];
    return n.forEach(({ $: s, i: o }) => {
      if (ea(s)) {
        const l = t(e, s, o);
        l.length && (i.has(o) || (i.set(o, {
          idx: o,
          item: s,
          matches: []
        }), a.push(i.get(o))), l.forEach(({ matches: u }) => {
          i.get(o).matches.push(...u);
        }));
      }
    }), a;
  }
  _searchObjectList(r, { heap: e, ignoreFieldNorm: t } = {}) {
    const n = this._getSearcher(r), i = this.options.useTokenSearch && this.options.tokenMatch === "all", { keys: a, records: s } = this._myIndex, o = e ? null : [];
    return s.forEach(({ $: l, i: u }) => {
      if (!ea(l)) return;
      const c = [];
      let d = !1, f = !1;
      if (a.forEach((h, g) => {
        const v = this._findMatches({
          key: h,
          value: l[g],
          searcher: n
        });
        v.length ? (c.push(...v), v[0].hasInverse && (f = !0)) : d = !0;
      }), !(f && d) && c.length && (!i || this._coversAllTokens(c))) {
        const h = {
          idx: u,
          item: l,
          matches: c
        };
        e ? (h.score = Ty(h.matches, { ignoreFieldNorm: t }), e.shouldInsert(h.score) && e.insert(h)) : o.push(h);
      }
    }), o;
  }
  _findMatches({ key: r, value: e, searcher: t }) {
    if (!ea(e)) return [];
    const n = [];
    if (ko(e)) e.forEach(({ v: i, i: a, n: s }) => {
      if (!ea(i)) return;
      const o = t.searchIn(i);
      if (o.isMatch) {
        const l = {
          score: o.score,
          key: r,
          value: i,
          idx: a,
          norm: s,
          indices: o.indices,
          hasInverse: o.hasInverse
        };
        o.termCount !== void 0 && (l.matchedMask = o.matchedMask, l.matchedTerms = o.matchedTerms, l.termCount = o.termCount), n.push(l);
      }
    });
    else {
      const { v: i, n: a } = e, s = t.searchIn(i);
      if (s.isMatch) {
        const o = {
          score: s.score,
          key: r,
          value: i,
          norm: a,
          indices: s.indices,
          hasInverse: s.hasInverse
        };
        s.termCount !== void 0 && (o.matchedMask = s.matchedMask, o.matchedTerms = s.matchedTerms, o.termCount = s.termCount), n.push(o);
      }
    }
    return n;
  }
  _coversAllTokens(r) {
    const e = r.length ? r[0].termCount : void 0;
    if (e === void 0) return !0;
    if (e <= 31) {
      let n = 0;
      for (let i = 0; i < r.length; i++) n |= r[i].matchedMask || 0;
      return n === 2 ** e - 1;
    }
    const t = /* @__PURE__ */ new Set();
    for (let n = 0; n < r.length; n++) {
      const i = r[n].matchedTerms;
      if (i) for (const a of i) t.add(a);
    }
    return t.size === e;
  }
};
To.version = "7.4.2";
To.createIndex = Rk;
To.parseIndex = bO;
To.config = Wt;
To.match = function(r, e, t) {
  if (t && t.useTokenSearch) throw new Error(dO);
  return Jp(r, {
    ...Wt,
    ...t
  }).searchIn(e);
};
To.parseQuery = Bk;
_A(PO);
_A(zO);
To.use = function(...r) {
  r.forEach((e) => _A(e));
};
var GO = To;
const od = [
  "White C",
  "Yellow C",
  "Yellow 012 C",
  "Orange 021 C",
  "Warm Red C",
  "Red 032 C",
  "Rubine Red C",
  "Rhodamine Red C",
  "Purple C",
  "Violet C",
  "Blue 072 C",
  "Reflex Blue C",
  "Process Blue C",
  "Green C",
  "Black C",
  "Yellow 0131 C",
  "Red 0331 C",
  "Magenta 0521 C",
  "Violet 0631 C",
  "Blue 0821 C",
  "Green 0921 C",
  "Black 0961 C",
  "801 C",
  "802 C",
  "803 C",
  "804 C",
  "805 C",
  "806 C",
  "807 C",
  "871 C",
  "872 C",
  "873 C",
  "874 C",
  "875 C",
  "876 C",
  "877 C",
  "Medium Yellow C",
  "Bright Orange C",
  "Bright Red C",
  "Strong Red C",
  "Pink C",
  "Medium Purple C",
  "Dark Blue C",
  "Medium Blue C",
  "Bright Green C",
  "Neutral Black C",
  "100 C",
  "101 C",
  "102 C",
  "103 C",
  "104 C",
  "105 C",
  "7401 C",
  "7402 C",
  "7403 C",
  "7404 C",
  "7405 C",
  "7406 C",
  "7407 C",
  "106 C",
  "107 C",
  "108 C",
  "109 C",
  "110 C",
  "111 C",
  "112 C",
  "113 C",
  "114 C",
  "115 C",
  "116 C",
  "117 C",
  "118 C",
  "119 C",
  "127 C",
  "128 C",
  "129 C",
  "130 C",
  "131 C",
  "132 C",
  "133 C",
  "1205 C",
  "1215 C",
  "1225 C",
  "1235 C",
  "1245 C",
  "1255 C",
  "1265 C",
  "120 C",
  "121 C",
  "122 C",
  "123 C",
  "124 C",
  "125 C",
  "126 C",
  "7548 C",
  "7549 C",
  "7550 C",
  "7551 C",
  "7552 C",
  "7553 C",
  "7554 C",
  "7555 C",
  "7556 C",
  "7557 C",
  "7558 C",
  "7559 C",
  "7560 C",
  "7561 C",
  "134 C",
  "135 C",
  "136 C",
  "137 C",
  "138 C",
  "139 C",
  "140 C",
  "1345 C",
  "1355 C",
  "1365 C",
  "1375 C",
  "1385 C",
  "1395 C",
  "1405 C",
  "141 C",
  "142 C",
  "143 C",
  "144 C",
  "145 C",
  "146 C",
  "147 C",
  "7408 C",
  "7409 C",
  "7410 C",
  "7411 C",
  "7412 C",
  "7413 C",
  "7414 C",
  "7562 C",
  "7563 C",
  "7564 C",
  "7565 C",
  "7566 C",
  "7567 C",
  "7568 C",
  "7569 C",
  "7570 C",
  "7571 C",
  "7572 C",
  "7573 C",
  "7574 C",
  "7575 C",
  "712 C",
  "713 C",
  "714 C",
  "715 C",
  "716 C",
  "717 C",
  "718 C",
  "148 C",
  "149 C",
  "150 C",
  "151 C",
  "152 C",
  "153 C",
  "154 C",
  "155 C",
  "156 C",
  "157 C",
  "158 C",
  "159 C",
  "160 C",
  "161 C",
  "1485 C",
  "1495 C",
  "1505 C",
  "1525 C",
  "1535 C",
  "1545 C",
  "1555 C",
  "1565 C",
  "1575 C",
  "1585 C",
  "1595 C",
  "1605 C",
  "1615 C",
  "162 C",
  "163 C",
  "164 C",
  "165 C",
  "166 C",
  "167 C",
  "168 C",
  "7576 C",
  "7577 C",
  "7578 C",
  "7579 C",
  "7580 C",
  "7581 C",
  "7582 C",
  "1625 C",
  "1635 C",
  "1645 C",
  "1655 C",
  "1665 C",
  "1675 C",
  "1685 C",
  "169 C",
  "170 C",
  "171 C",
  "172 C",
  "173 C",
  "174 C",
  "175 C",
  "7583 C",
  "7584 C",
  "7585 C",
  "7586 C",
  "7587 C",
  "7588 C",
  "7589 C",
  "7590 C",
  "7591 C",
  "7592 C",
  "7593 C",
  "7594 C",
  "7595 C",
  "7596 C",
  "7597 C",
  "7598 C",
  "7599 C",
  "7600 C",
  "7601 C",
  "7602 C",
  "7603 C",
  "7604 C",
  "7605 C",
  "7606 C",
  "7607 C",
  "7608 C",
  "7609 C",
  "7610 C",
  "7611 C",
  "7612 C",
  "7613 C",
  "7614 C",
  "7615 C",
  "7616 C",
  "7617 C",
  "7520 C",
  "7521 C",
  "7522 C",
  "7523 C",
  "7524 C",
  "7525 C",
  "7526 C",
  "489 C",
  "488 C",
  "487 C",
  "486 C",
  "485 C",
  "484 C",
  "483 C",
  "176 C",
  "177 C",
  "178 C",
  "179 C",
  "180 C",
  "181 C",
  "1765 C",
  "1775 C",
  "1785 C",
  "1788 C",
  "1795 C",
  "1805 C",
  "1815 C",
  "1767 C",
  "1777 C",
  "1787 C",
  "1797 C",
  "1807 C",
  "1817 C",
  "7618 C",
  "7619 C",
  "7620 C",
  "7621 C",
  "7622 C",
  "7623 C",
  "7624 C",
  "7625 C",
  "7626 C",
  "7627 C",
  "7628 C",
  "7629 C",
  "7630 C",
  "7631 C",
  "7415 C",
  "7416 C",
  "7417 C",
  "7418 C",
  "7419 C",
  "7420 C",
  "7421 C",
  "182 C",
  "183 C",
  "184 C",
  "185 C",
  "186 C",
  "187 C",
  "188 C",
  "196 C",
  "197 C",
  "198 C",
  "199 C",
  "200 C",
  "201 C",
  "202 C",
  "189 C",
  "190 C",
  "191 C",
  "192 C",
  "193 C",
  "194 C",
  "195 C",
  "1895 C",
  "1905 C",
  "1915 C",
  "1925 C",
  "1935 C",
  "1945 C",
  "1955 C",
  "705 C",
  "706 C",
  "707 C",
  "708 C",
  "709 C",
  "710 C",
  "711 C",
  "698 C",
  "699 C",
  "700 C",
  "701 C",
  "702 C",
  "703 C",
  "704 C",
  "203 C",
  "204 C",
  "205 C",
  "206 C",
  "207 C",
  "208 C",
  "209 C",
  "210 C",
  "211 C",
  "212 C",
  "213 C",
  "214 C",
  "215 C",
  "216 C",
  "7422 C",
  "7423 C",
  "7424 C",
  "7425 C",
  "7426 C",
  "7427 C",
  "7428 C",
  "7632 C",
  "7633 C",
  "7634 C",
  "7635 C",
  "7636 C",
  "7637 C",
  "7638 C",
  "217 C",
  "218 C",
  "219 C",
  "220 C",
  "221 C",
  "222 C",
  "7639 C",
  "7640 C",
  "7641 C",
  "7642 C",
  "7643 C",
  "7644 C",
  "7645 C",
  "223 C",
  "224 C",
  "225 C",
  "226 C",
  "227 C",
  "228 C",
  "229 C",
  "230 C",
  "231 C",
  "232 C",
  "233 C",
  "234 C",
  "235 C",
  "670 C",
  "671 C",
  "672 C",
  "673 C",
  "674 C",
  "675 C",
  "676 C",
  "677 C",
  "678 C",
  "679 C",
  "680 C",
  "681 C",
  "682 C",
  "683 C",
  "684 C",
  "685 C",
  "686 C",
  "687 C",
  "688 C",
  "689 C",
  "690 C",
  "510 C",
  "509 C",
  "508 C",
  "507 C",
  "506 C",
  "505 C",
  "504 C",
  "7429 C",
  "7430 C",
  "7431 C",
  "7432 C",
  "7433 C",
  "7434 C",
  "7435 C",
  "691 C",
  "692 C",
  "693 C",
  "694 C",
  "695 C",
  "696 C",
  "697 C",
  "496 C",
  "495 C",
  "494 C",
  "493 C",
  "492 C",
  "491 C",
  "490 C",
  "503 C",
  "502 C",
  "501 C",
  "500 C",
  "499 C",
  "498 C",
  "497 C",
  "5035 C",
  "5025 C",
  "5015 C",
  "5005 C",
  "4995 C",
  "4985 C",
  "4975 C",
  "236 C",
  "237 C",
  "238 C",
  "239 C",
  "240 C",
  "241 C",
  "242 C",
  "2365 C",
  "2375 C",
  "2385 C",
  "2395 C",
  "2405 C",
  "2415 C",
  "2425 C",
  "243 C",
  "244 C",
  "245 C",
  "246 C",
  "247 C",
  "248 C",
  "249 C",
  "7646 C",
  "7647 C",
  "7648 C",
  "7649 C",
  "7650 C",
  "7651 C",
  "7652 C",
  "250 C",
  "251 C",
  "252 C",
  "253 C",
  "254 C",
  "255 C",
  "517 C",
  "516 C",
  "515 C",
  "514 C",
  "513 C",
  "512 C",
  "511 C",
  "7436 C",
  "7437 C",
  "7438 C",
  "7439 C",
  "7440 C",
  "7441 C",
  "7442 C",
  "2562 C",
  "2572 C",
  "2582 C",
  "2592 C",
  "2602 C",
  "2612 C",
  "2622 C",
  "7653 C",
  "7654 C",
  "7655 C",
  "7656 C",
  "7657 C",
  "7658 C",
  "7659 C",
  "524 C",
  "523 C",
  "522 C",
  "521 C",
  "520 C",
  "519 C",
  "518 C",
  "5245 C",
  "5235 C",
  "5225 C",
  "5215 C",
  "5205 C",
  "5195 C",
  "5185 C",
  "5175 C",
  "5165 C",
  "5155 C",
  "5145 C",
  "5135 C",
  "5125 C",
  "5115 C",
  "531 C",
  "530 C",
  "529 C",
  "528 C",
  "527 C",
  "526 C",
  "525 C",
  "256 C",
  "257 C",
  "258 C",
  "259 C",
  "260 C",
  "261 C",
  "262 C",
  "2563 C",
  "2573 C",
  "2583 C",
  "2593 C",
  "2603 C",
  "2613 C",
  "2623 C",
  "7660 C",
  "7661 C",
  "7662 C",
  "7663 C",
  "7664 C",
  "7665 C",
  "7666 C",
  "2567 C",
  "2577 C",
  "2587 C",
  "2597 C",
  "2607 C",
  "2617 C",
  "2627 C",
  "263 C",
  "264 C",
  "265 C",
  "266 C",
  "267 C",
  "268 C",
  "269 C",
  "2635 C",
  "2645 C",
  "2655 C",
  "2665 C",
  "2685 C",
  "2695 C",
  "270 C",
  "271 C",
  "272 C",
  "273 C",
  "274 C",
  "275 C",
  "276 C",
  "2705 C",
  "2715 C",
  "2725 C",
  "2735 C",
  "2745 C",
  "2755 C",
  "2765 C",
  "7667 C",
  "7668 C",
  "7669 C",
  "7670 C",
  "7671 C",
  "7672 C",
  "7673 C",
  "7443 C",
  "7444 C",
  "7445 C",
  "7446 C",
  "7447 C",
  "7448 C",
  "7449 C",
  "7674 C",
  "7675 C",
  "7676 C",
  "7677 C",
  "7678 C",
  "7679 C",
  "7680 C",
  "663 C",
  "664 C",
  "665 C",
  "666 C",
  "667 C",
  "668 C",
  "669 C",
  "5315 C",
  "5305 C",
  "5295 C",
  "5285 C",
  "5275 C",
  "5265 C",
  "5255 C",
  "538 C",
  "537 C",
  "536 C",
  "535 C",
  "534 C",
  "533 C",
  "532 C",
  "7541 C",
  "7542 C",
  "7543 C",
  "7544 C",
  "7545 C",
  "7546 C",
  "7547 C",
  "552 C",
  "551 C",
  "550 C",
  "549 C",
  "548 C",
  "547 C",
  "546 C",
  "5455 C",
  "5445 C",
  "5435 C",
  "5425 C",
  "5415 C",
  "5405 C",
  "5395 C",
  "642 C",
  "643 C",
  "644 C",
  "645 C",
  "646 C",
  "647 C",
  "648 C",
  "649 C",
  "650 C",
  "651 C",
  "652 C",
  "653 C",
  "654 C",
  "655 C",
  "656 C",
  "657 C",
  "658 C",
  "659 C",
  "660 C",
  "661 C",
  "662 C",
  "7450 C",
  "7451 C",
  "7452 C",
  "7453 C",
  "7454 C",
  "7455 C",
  "7456 C",
  "2706 C",
  "2716 C",
  "2726 C",
  "2736 C",
  "2746 C",
  "2756 C",
  "2766 C",
  "2708 C",
  "2718 C",
  "2728 C",
  "2738 C",
  "2748 C",
  "2758 C",
  "2768 C",
  "2707 C",
  "2717 C",
  "2727 C",
  "2747 C",
  "2757 C",
  "2767 C",
  "277 C",
  "278 C",
  "279 C",
  "280 C",
  "281 C",
  "282 C",
  "283 C",
  "284 C",
  "285 C",
  "286 C",
  "287 C",
  "288 C",
  "289 C",
  "7681 C",
  "7682 C",
  "7683 C",
  "7684 C",
  "7685 C",
  "7686 C",
  "7687 C",
  "545 C",
  "544 C",
  "543 C",
  "542 C",
  "541 C",
  "540 C",
  "539 C",
  "290 C",
  "291 C",
  "292 C",
  "293 C",
  "294 C",
  "295 C",
  "296 C",
  "2905 C",
  "2915 C",
  "2925 C",
  "2935 C",
  "2945 C",
  "2955 C",
  "2965 C",
  "297 C",
  "298 C",
  "299 C",
  "300 C",
  "301 C",
  "302 C",
  "303 C",
  "7688 C",
  "7689 C",
  "7690 C",
  "7691 C",
  "7692 C",
  "7693 C",
  "7694 C",
  "2975 C",
  "2985 C",
  "2995 C",
  "3005 C",
  "3015 C",
  "3025 C",
  "3035 C",
  "7695 C",
  "7696 C",
  "7697 C",
  "7698 C",
  "7699 C",
  "7700 C",
  "7701 C",
  "7457 C",
  "7458 C",
  "7459 C",
  "7460 C",
  "7461 C",
  "7462 C",
  "7463 C",
  "304 C",
  "305 C",
  "306 C",
  "307 C",
  "308 C",
  "309 C",
  "635 C",
  "636 C",
  "637 C",
  "638 C",
  "639 C",
  "640 C",
  "641 C",
  "7702 C",
  "7703 C",
  "7704 C",
  "7705 C",
  "7706 C",
  "7707 C",
  "7708 C",
  "628 C",
  "629 C",
  "630 C",
  "631 C",
  "632 C",
  "633 C",
  "634 C",
  "310 C",
  "311 C",
  "312 C",
  "313 C",
  "314 C",
  "315 C",
  "316 C",
  "3105 C",
  "3115 C",
  "3125 C",
  "3135 C",
  "3145 C",
  "3155 C",
  "3165 C",
  "7709 C",
  "7710 C",
  "7711 C",
  "7712 C",
  "7713 C",
  "7714 C",
  "7715 C",
  "317 C",
  "318 C",
  "319 C",
  "320 C",
  "321 C",
  "322 C",
  "323 C",
  "7464 C",
  "7465 C",
  "7466 C",
  "7467 C",
  "7468 C",
  "7469 C",
  "7470 C",
  "7471 C",
  "7472 C",
  "7473 C",
  "7474 C",
  "7475 C",
  "7476 C",
  "7477 C",
  "5523 C",
  "5513 C",
  "5503 C",
  "5493 C",
  "5483 C",
  "5473 C",
  "5463 C",
  "7716 C",
  "7717 C",
  "7718 C",
  "7719 C",
  "7720 C",
  "7721 C",
  "7722 C",
  "324 C",
  "325 C",
  "326 C",
  "327 C",
  "328 C",
  "329 C",
  "330 C",
  "3242 C",
  "3252 C",
  "3262 C",
  "3272 C",
  "3282 C",
  "3292 C",
  "3302 C",
  "3245 C",
  "3255 C",
  "3265 C",
  "3275 C",
  "3285 C",
  "3295 C",
  "3305 C",
  "3248 C",
  "3258 C",
  "3268 C",
  "3278 C",
  "3288 C",
  "3298 C",
  "3308 C",
  "566 C",
  "565 C",
  "564 C",
  "563 C",
  "562 C",
  "561 C",
  "560 C",
  "573 C",
  "572 C",
  "571 C",
  "570 C",
  "569 C",
  "568 C",
  "567 C",
  "559 C",
  "558 C",
  "557 C",
  "556 C",
  "555 C",
  "554 C",
  "553 C",
  "5595 C",
  "5585 C",
  "5575 C",
  "5565 C",
  "5555 C",
  "5545 C",
  "5535 C",
  "5665 C",
  "5655 C",
  "5645 C",
  "5635 C",
  "5625 C",
  "5615 C",
  "5605 C",
  "5527 C",
  "5517 C",
  "5507 C",
  "5497 C",
  "5487 C",
  "5477 C",
  "5467 C",
  "621 C",
  "622 C",
  "623 C",
  "624 C",
  "625 C",
  "626 C",
  "627 C",
  "331 C",
  "332 C",
  "333 C",
  "334 C",
  "335 C",
  "336 C",
  "337 C",
  "338 C",
  "339 C",
  "340 C",
  "341 C",
  "342 C",
  "343 C",
  "7723 C",
  "7724 C",
  "7725 C",
  "7726 C",
  "7727 C",
  "7728 C",
  "7729 C",
  "3375 C",
  "3385 C",
  "3395 C",
  "3405 C",
  "3415 C",
  "3425 C",
  "3435 C",
  "344 C",
  "345 C",
  "346 C",
  "347 C",
  "348 C",
  "349 C",
  "350 C",
  "351 C",
  "352 C",
  "353 C",
  "354 C",
  "355 C",
  "356 C",
  "357 C",
  "7478 C",
  "7479 C",
  "7480 C",
  "7481 C",
  "7482 C",
  "7483 C",
  "7484 C",
  "7730 C",
  "7731 C",
  "7732 C",
  "7733 C",
  "7734 C",
  "7735 C",
  "7736 C",
  "7737 C",
  "7738 C",
  "7739 C",
  "7740 C",
  "7741 C",
  "7742 C",
  "7743 C",
  "358 C",
  "359 C",
  "360 C",
  "361 C",
  "362 C",
  "363 C",
  "364 C",
  "7485 C",
  "7486 C",
  "7487 C",
  "7488 C",
  "7489 C",
  "7490 C",
  "7491 C",
  "365 C",
  "366 C",
  "367 C",
  "368 C",
  "369 C",
  "370 C",
  "371 C",
  "372 C",
  "373 C",
  "374 C",
  "375 C",
  "376 C",
  "377 C",
  "378 C",
  "580 C",
  "579 C",
  "578 C",
  "577 C",
  "576 C",
  "575 C",
  "574 C",
  "5807 C",
  "5797 C",
  "5787 C",
  "5777 C",
  "5767 C",
  "5757 C",
  "5747 C",
  "5875 C",
  "5865 C",
  "5855 C",
  "5845 C",
  "5835 C",
  "5825 C",
  "5815 C",
  "5803 C",
  "5793 C",
  "5783 C",
  "5773 C",
  "5763 C",
  "5753 C",
  "5743 C",
  "7492 C",
  "7493 C",
  "7494 C",
  "7495 C",
  "7496 C",
  "7497 C",
  "7498 C",
  "7744 C",
  "7745 C",
  "7746 C",
  "7747 C",
  "7748 C",
  "7749 C",
  "7750 C",
  "379 C",
  "380 C",
  "381 C",
  "382 C",
  "383 C",
  "384 C",
  "385 C",
  "386 C",
  "387 C",
  "388 C",
  "389 C",
  "390 C",
  "391 C",
  "392 C",
  "587 C",
  "586 C",
  "585 C",
  "584 C",
  "583 C",
  "582 C",
  "581 C",
  "393 C",
  "394 C",
  "395 C",
  "396 C",
  "397 C",
  "398 C",
  "399 C",
  "3935 C",
  "3945 C",
  "3955 C",
  "3965 C",
  "3975 C",
  "3985 C",
  "3995 C",
  "600 C",
  "601 C",
  "602 C",
  "603 C",
  "604 C",
  "605 C",
  "606 C",
  "607 C",
  "608 C",
  "609 C",
  "610 C",
  "611 C",
  "612 C",
  "613 C",
  "461 C",
  "460 C",
  "459 C",
  "458 C",
  "457 C",
  "456 C",
  "455 C",
  "614 C",
  "615 C",
  "616 C",
  "617 C",
  "618 C",
  "619 C",
  "620 C",
  "7751 C",
  "7752 C",
  "7753 C",
  "7754 C",
  "7755 C",
  "7756 C",
  "7757 C",
  "7758 C",
  "7759 C",
  "7760 C",
  "7761 C",
  "7762 C",
  "7763 C",
  "7764 C",
  "7765 C",
  "7766 C",
  "7767 C",
  "7768 C",
  "7769 C",
  "7770 C",
  "7771 C",
  "4545 C",
  "4535 C",
  "4525 C",
  "4515 C",
  "4505 C",
  "4495 C",
  "4485 C",
  "454 C",
  "453 C",
  "452 C",
  "451 C",
  "450 C",
  "449 C",
  "448 C",
  "7499 C",
  "7500 C",
  "7501 C",
  "7502 C",
  "7503 C",
  "7504 C",
  "7505 C",
  "468 C",
  "467 C",
  "466 C",
  "465 C",
  "464 C",
  "463 C",
  "462 C",
  "7506 C",
  "7507 C",
  "7508 C",
  "7509 C",
  "7510 C",
  "7511 C",
  "7512 C",
  "719 C",
  "720 C",
  "721 C",
  "722 C",
  "723 C",
  "724 C",
  "725 C",
  "475 C",
  "474 C",
  "473 C",
  "472 C",
  "471 C",
  "470 C",
  "469 C",
  "726 C",
  "727 C",
  "728 C",
  "729 C",
  "730 C",
  "731 C",
  "732 C",
  "4685 C",
  "4675 C",
  "4665 C",
  "4655 C",
  "4645 C",
  "4635 C",
  "4625 C",
  "7513 C",
  "7514 C",
  "7515 C",
  "7516 C",
  "7517 C",
  "7518 C",
  "7519 C",
  "4755 C",
  "4745 C",
  "4735 C",
  "4725 C",
  "4715 C",
  "4705 C",
  "4695 C",
  "482 C",
  "481 C",
  "480 C",
  "479 C",
  "478 C",
  "477 C",
  "476 C",
  "7527 C",
  "7528 C",
  "7529 C",
  "7530 C",
  "7531 C",
  "7532 C",
  "7533 C",
  "7534 C",
  "7535 C",
  "7536 C",
  "7537 C",
  "7538 C",
  "7539 C",
  "7540 C",
  "427 C",
  "428 C",
  "429 C",
  "430 C",
  "431 C",
  "432 C",
  "433 C",
  "420 C",
  "421 C",
  "422 C",
  "423 C",
  "424 C",
  "425 C",
  "426 C",
  "441 C",
  "442 C",
  "443 C",
  "444 C",
  "445 C",
  "446 C",
  "447 C",
  "413 C",
  "414 C",
  "415 C",
  "416 C",
  "417 C",
  "418 C",
  "419 C",
  "400 C",
  "401 C",
  "402 C",
  "403 C",
  "404 C",
  "405 C",
  "406 C",
  "407 C",
  "408 C",
  "409 C",
  "410 C",
  "411 C",
  "412 C",
  "434 C",
  "435 C",
  "436 C",
  "437 C",
  "438 C",
  "439 C",
  "440 C",
  "Warm Gray 1 C",
  "Warm Gray 2 C",
  "Warm Gray 3 C",
  "Warm Gray 4 C",
  "Warm Gray 5 C",
  "Warm Gray 6 C",
  "Warm Gray 7 C",
  "Warm Gray 8 C",
  "Warm Gray 9 C",
  "Warm Gray 10 C",
  "Warm Gray 11 C",
  "Cool Gray 1 C",
  "Cool Gray 2 C",
  "Cool Gray 3 C",
  "Cool Gray 4 C",
  "Cool Gray 5 C",
  "Cool Gray 6 C",
  "Cool Gray 7 C",
  "Cool Gray 8 C",
  "Cool Gray 9 C",
  "Cool Gray 10 C",
  "Cool Gray 11 C",
  "Black 2 C",
  "Black 3 C",
  "Black 4 C",
  "Black 5 C",
  "Black 6 C",
  "Black 7 C"
], ju = [
  "FFFFFF",
  "FEDD00",
  "FFD700",
  "FE5000",
  "F9423A",
  "EF3340",
  "CE0058",
  "E10098",
  "BB29BB",
  "440099",
  "10069F",
  "001489",
  "0085CA",
  "00AB84",
  "2D2926",
  "F2F0A1",
  "FCAEBB",
  "F1B2DC",
  "BF9BDE",
  "74D1EA",
  "9DE7D7",
  "9E978E",
  "009ACE",
  "44D62C",
  "FFE900",
  "FFAA4D",
  "FF7276",
  "FF3EB5",
  "EA27C2",
  "84754E",
  "85714D",
  "866D4B",
  "8B6F4E",
  "87674F",
  "8B634B",
  "8A8D8F",
  "FFD900",
  "FF5E00",
  "F93822",
  "CE0056",
  "D62598",
  "4E008E",
  "00239C",
  "0084CA",
  "00B08B",
  "222223",
  "F6EB61",
  "F7EA48",
  "FCE300",
  "C5A900",
  "AF9800",
  "897A27",
  "F5E1A4",
  "ECD898",
  "EED484",
  "F4DA40",
  "F2CD00",
  "F1C400",
  "CBA052",
  "F9E547",
  "FBE122",
  "FEDB00",
  "FFD100",
  "DAAA00",
  "AA8A00",
  "9C8412",
  "FAE053",
  "FBDD40",
  "FDDA24",
  "FFCD00",
  "C99700",
  "AC8400",
  "897322",
  "F3DD6D",
  "F3D54E",
  "F3D03E",
  "F2A900",
  "CC8A00",
  "A07400",
  "6C571B",
  "F8E08E",
  "FBD872",
  "FFC845",
  "FFB81C",
  "C69214",
  "AD841F",
  "886B25",
  "FBDB65",
  "FDD757",
  "FED141",
  "FFC72C",
  "EAAA00",
  "B58500",
  "9A7611",
  "FFC600",
  "FFB500",
  "D19000",
  "B47E00",
  "73531D",
  "5A4522",
  "4B3D2A",
  "D29F13",
  "B78B20",
  "9F7D23",
  "967126",
  "8F6A2A",
  "7D622E",
  "6C5D34",
  "FDD26E",
  "FFC658",
  "FFBF3F",
  "FFA300",
  "DE7C00",
  "AF6D04",
  "74531C",
  "FDD086",
  "FFC56E",
  "FFB549",
  "FF9E1B",
  "D57800",
  "996017",
  "6E4C1E",
  "F2C75C",
  "F1BE48",
  "F1B434",
  "ED8B00",
  "CF7F00",
  "A76D11",
  "715C2A",
  "F6BE00",
  "F0B323",
  "FEAD77",
  "E6A65D",
  "D38235",
  "DC8633",
  "C16C18",
  "BD9B60",
  "D69A2D",
  "DB8A06",
  "CD7925",
  "AD6433",
  "89532F",
  "775135",
  "D78825",
  "D3832B",
  "C67D30",
  "B67233",
  "A7662B",
  "9E6A38",
  "835D32",
  "FCC89B",
  "FDBE87",
  "FDAA63",
  "F68D2E",
  "EA7600",
  "D45D00",
  "BE4D00",
  "FECB8B",
  "FFC27B",
  "FFB25B",
  "FF8200",
  "E57200",
  "BE6A14",
  "9B5A1A",
  "EFD19F",
  "EFBE7D",
  "ECA154",
  "E87722",
  "CB6015",
  "A1561C",
  "603D20",
  "FFAE62",
  "FF8F1C",
  "FF6900",
  "B94700",
  "94450B",
  "653819",
  "FFB990",
  "FFA06A",
  "FF7F32",
  "FF6A13",
  "D86018",
  "A65523",
  "8B4720",
  "FFBE9F",
  "FF9D6E",
  "FF7F41",
  "FF671F",
  "E35205",
  "BE531C",
  "73381D",
  "DB864E",
  "E07E3C",
  "DC6B2F",
  "DC582A",
  "C05131",
  "864A33",
  "674736",
  "FFA38B",
  "FF8D6D",
  "FF6A39",
  "FC4C02",
  "DC4405",
  "A9431E",
  "833921",
  "FFB3AB",
  "FF8674",
  "FF5C39",
  "FA4616",
  "CF4520",
  "963821",
  "6B3529",
  "C4622D",
  "BA5826",
  "AF5C37",
  "9E5330",
  "924C2E",
  "7B4D35",
  "5C4738",
  "D4B59E",
  "C07D59",
  "B15533",
  "9D432C",
  "7C3A2D",
  "6B3D2E",
  "5C3D31",
  "D14124",
  "BD472A",
  "B33D26",
  "8D3F2B",
  "83412C",
  "7B4931",
  "674230",
  "E4D5D3",
  "E1BBB4",
  "D6938A",
  "C26E60",
  "A4493D",
  "823B34",
  "683431",
  "DDBCB0",
  "CA9A8E",
  "BC8A7E",
  "A37F74",
  "866761",
  "6B4C4C",
  "583D3E",
  "EABEB0",
  "C09C83",
  "B46A55",
  "AB5C57",
  "A45248",
  "9A6A4F",
  "8A391B",
  "ECC3B2",
  "ECBAA8",
  "EAA794",
  "E8927C",
  "DA291C",
  "9A3324",
  "653024",
  "FFB1BB",
  "FF808B",
  "FF585D",
  "E03C31",
  "BE3A34",
  "81312F",
  "FFA3B5",
  "FF8DA1",
  "F8485E",
  "EE2737",
  "D22630",
  "AF272F",
  "7C2529",
  "FCAFC0",
  "FB637E",
  "F4364C",
  "CB333B",
  "A4343A",
  "643335",
  "C66E4E",
  "C04C36",
  "B7312C",
  "AB2328",
  "93272C",
  "8A2A2B",
  "802F2D",
  "E1523D",
  "C63527",
  "A72B2A",
  "9E2A2B",
  "6D3332",
  "633231",
  "572D2D",
  "E6BAA8",
  "E56A54",
  "E04E39",
  "CD545B",
  "B04A5A",
  "9B2242",
  "651D32",
  "FABBCB",
  "FC9BB3",
  "F65275",
  "E4002B",
  "C8102E",
  "A6192E",
  "76232F",
  "ECC7CD",
  "E89CAE",
  "DF4661",
  "D50032",
  "BA0C2F",
  "9D2235",
  "862633",
  "F8A3BC",
  "F67599",
  "EF426F",
  "E40046",
  "BF0D3E",
  "9B2743",
  "782F40",
  "F5B6CD",
  "F59BBB",
  "EF4A81",
  "E0004D",
  "C5003E",
  "A6093D",
  "8A1538",
  "F5DADF",
  "F7CED7",
  "F9B5C4",
  "F890A5",
  "EF6079",
  "E03E52",
  "CB2C30",
  "F2D4D7",
  "F4C3CC",
  "F2ACB9",
  "E68699",
  "D25B73",
  "B83A4B",
  "9E2A2F",
  "ECB3CB",
  "E782A9",
  "E0457B",
  "CE0037",
  "A50034",
  "861F41",
  "6F263D",
  "F99FC9",
  "F57EB6",
  "F04E98",
  "E31C79",
  "CE0F69",
  "AC145A",
  "7D2248",
  "F4CDD4",
  "E06287",
  "E24585",
  "B52555",
  "A4123F",
  "971B2F",
  "6A2C3E",
  "D6C9CA",
  "C4A4A7",
  "C16784",
  "C63663",
  "BC204B",
  "912F46",
  "7E2D40",
  "EABEDB",
  "E56DB1",
  "DA1884",
  "A50050",
  "910048",
  "6C1D45",
  "936D73",
  "934054",
  "8E2C48",
  "732E4A",
  "672E45",
  "582D40",
  "502B3A",
  "EF95CF",
  "EB6FBD",
  "DF1995",
  "D0006F",
  "AA0061",
  "890C58",
  "672146",
  "F4A6D7",
  "F277C6",
  "E93CAC",
  "C6007E",
  "A20067",
  "840B55",
  "EAD3E2",
  "E6BCD8",
  "DFA0C9",
  "D986BA",
  "C6579A",
  "AE2573",
  "960051",
  "E5CEDB",
  "E3C8D8",
  "DEBED2",
  "C996B6",
  "B06C96",
  "994878",
  "7C2855",
  "E4C6D4",
  "DCB6C9",
  "D0A1BA",
  "BE84A3",
  "A76389",
  "893B67",
  "612141",
  "EBBECB",
  "E8B3C3",
  "E4A9BB",
  "D592AA",
  "84344E",
  "6F2C3F",
  "572932",
  "E2BCCB",
  "DCA9BF",
  "C9809E",
  "B55C80",
  "A73A64",
  "9B3259",
  "872651",
  "E9CDD0",
  "E4BEC3",
  "D7A3AB",
  "C48490",
  "B46B7A",
  "984856",
  "893C47",
  "F2C6CF",
  "F1BDC8",
  "E9A2B2",
  "DC8699",
  "8F3237",
  "7F3035",
  "5D2A2C",
  "E9C4C7",
  "E5BAC1",
  "DAA5AD",
  "C6858F",
  "7A3E3A",
  "6A3735",
  "512F2E",
  "DFC2C3",
  "DBB7BB",
  "CCA1A6",
  "B07C83",
  "9C6169",
  "874B52",
  "3F2021",
  "F1A7DC",
  "EC86D0",
  "E45DBF",
  "DB3EB1",
  "C5299B",
  "AF1685",
  "80225F",
  "EFBAE1",
  "E277CD",
  "D539B5",
  "C800A1",
  "B0008E",
  "9E007E",
  "830065",
  "EAB8E4",
  "E59BDC",
  "DD7FD3",
  "C724B1",
  "BB16A3",
  "A51890",
  "80276C",
  "A56E87",
  "A83D72",
  "991E66",
  "8A1B61",
  "722257",
  "6A2A5B",
  "5E2751",
  "E7BAE4",
  "DD9CDF",
  "C964CF",
  "AD1AAC",
  "981D97",
  "72246C",
  "EBC6DF",
  "E6BEDD",
  "E2ACD7",
  "D48BC8",
  "93328E",
  "833177",
  "612C51",
  "EEDAEA",
  "CCAED0",
  "D59ED7",
  "B288B9",
  "A277A6",
  "9F5CC0",
  "963CBD",
  "D7A9E3",
  "C98BDB",
  "AC4FC6",
  "9B26B6",
  "87189D",
  "772583",
  "653165",
  "948794",
  "A2789C",
  "A15A95",
  "8E3A80",
  "6E2B62",
  "6A3460",
  "5D3754",
  "D5C2D8",
  "C9B1D0",
  "BA9CC5",
  "A57FB2",
  "642F6C",
  "59315F",
  "4B3048",
  "DBCDD3",
  "D0BEC7",
  "C6B0BC",
  "AF95A6",
  "86647A",
  "66435A",
  "4A3041",
  "D8C8D1",
  "D3C0CD",
  "BFA5B8",
  "9B7793",
  "7E5475",
  "693C5E",
  "512A44",
  "DFC8E7",
  "D7B9E4",
  "CAA2DD",
  "B580D1",
  "8031A7",
  "702F8A",
  "572C5F",
  "D6BFDD",
  "C6A1CF",
  "8C4799",
  "6D2077",
  "642667",
  "5D285F",
  "51284F",
  "CBA3D8",
  "B884CB",
  "A05EB5",
  "84329B",
  "702082",
  "671E75",
  "5F2167",
  "9991A4",
  "8D6E97",
  "7A4183",
  "6B3077",
  "653279",
  "5E366E",
  "5C4E63",
  "C1A0DA",
  "A77BCA",
  "8246AF",
  "5C068C",
  "500778",
  "470A68",
  "3C1053",
  "D7C6E6",
  "C1A7E2",
  "9063CD",
  "753BBD",
  "5F259F",
  "582C83",
  "512D6D",
  "C5B4E3",
  "AD96DC",
  "9678D3",
  "7D55C7",
  "330072",
  "2E1A47",
  "B4B5DF",
  "9595D2",
  "7474C1",
  "24135F",
  "211551",
  "201747",
  "221C35",
  "A7A4E0",
  "8B84D7",
  "685BC7",
  "2E008B",
  "280071",
  "250E62",
  "201547",
  "6E7CA0",
  "686E9F",
  "615E9B",
  "565294",
  "514689",
  "4C4184",
  "535486",
  "DDDAE8",
  "B6B8DC",
  "A7A2C3",
  "8986CA",
  "5D4777",
  "4B384C",
  "41273B",
  "878CB4",
  "7C7FAB",
  "7566A0",
  "6F5091",
  "68478D",
  "563D82",
  "523178",
  "E5E1E6",
  "E0DBE3",
  "C6BCD0",
  "A192B2",
  "7C6992",
  "614B79",
  "3F2A56",
  "D8D7DF",
  "C6C4D2",
  "B3B0C4",
  "8D89A5",
  "595478",
  "403A60",
  "1E1A34",
  "C5CFDA",
  "BBC7D6",
  "A2B2C8",
  "8E9FBC",
  "1B365D",
  "1F2A44",
  "1C1F2A",
  "D9E1E2",
  "A4BCC2",
  "98A4AE",
  "768692",
  "425563",
  "253746",
  "131E29",
  "B9D3DC",
  "A3C7D2",
  "8DB9CA",
  "6BA4B8",
  "003D4C",
  "00313C",
  "072B31",
  "BFCED6",
  "B7C9D3",
  "A6BBC8",
  "7A99AC",
  "5B7F95",
  "4F758B",
  "081F2C",
  "D1DDE6",
  "C6D6E3",
  "9BB8D3",
  "7DA1C4",
  "5E8AB4",
  "236192",
  "002E5D",
  "DBE2E9",
  "CED9E5",
  "A7BCD6",
  "7D9BC1",
  "326295",
  "003A70",
  "002554",
  "DDE5ED",
  "C8D8EB",
  "B1C9E8",
  "7BA4DB",
  "407EC9",
  "003594",
  "001A70",
  "BDC5DB",
  "89ABE3",
  "8094DD",
  "7BA6DE",
  "5F8FB4",
  "3A5DAE",
  "606EB2",
  "CBD3EB",
  "9FAEE5",
  "485CC7",
  "1E22AA",
  "171C8F",
  "151F6D",
  "141B4D",
  "B8CCEA",
  "5C88DA",
  "0047BB",
  "06038D",
  "001871",
  "001E62",
  "071D49",
  "C3D7EE",
  "A7C6ED",
  "307FE2",
  "001A72",
  "001E60",
  "13294B",
  "ABCAE9",
  "8BB8E8",
  "418FDE",
  "012169",
  "00205B",
  "041E42",
  "92C1E9",
  "6CACE4",
  "0072CE",
  "0033A0",
  "003087",
  "002D72",
  "0C2340",
  "94A9CB",
  "6787B7",
  "426DA9",
  "385E9D",
  "2C5697",
  "1D4F91",
  "1D428A",
  "C6DAE7",
  "BDD6E6",
  "A4C8E1",
  "7BAFD4",
  "003C71",
  "003057",
  "00263A",
  "B9D9EB",
  "9BCBEB",
  "69B3E7",
  "003DA5",
  "002F6C",
  "002855",
  "041C2C",
  "8DC8E8",
  "62B5E5",
  "009CDE",
  "0057B8",
  "004C97",
  "003865",
  "00263E",
  "71C5E8",
  "41B6E6",
  "00A3E0",
  "005EB8",
  "004B87",
  "003B5C",
  "002A3A",
  "4698CB",
  "298FC2",
  "0076A8",
  "006298",
  "005587",
  "004976",
  "01426A",
  "99D6EA",
  "5BC2E7",
  "00A9E0",
  "0077C8",
  "00629B",
  "004F71",
  "003E51",
  "7BA7BC",
  "6399AE",
  "4E87A0",
  "41748D",
  "34657F",
  "165C7D",
  "005776",
  "BBDDE6",
  "71B2C9",
  "4298B5",
  "0086BF",
  "007DBA",
  "00558C",
  "002B49",
  "9ADBE8",
  "59CBE8",
  "00B5E2",
  "006BA6",
  "00587C",
  "003B49",
  "A4DBE8",
  "8BD3E6",
  "4EC3E0",
  "00AFD7",
  "0095C8",
  "0082BA",
  "0067A0",
  "48A9C5",
  "009CBD",
  "0085AD",
  "007096",
  "006A8E",
  "00617F",
  "005670",
  "B8DDE1",
  "9BD3DD",
  "77C5D5",
  "3EB1C8",
  "0093B2",
  "007396",
  "005F83",
  "6AD1E3",
  "05C3DE",
  "00A9CE",
  "0092BC",
  "007FA3",
  "00677F",
  "004851",
  "68D2DF",
  "00C1D5",
  "00AEC7",
  "008EAA",
  "00778B",
  "006272",
  "004F59",
  "63B1BC",
  "00A7B5",
  "0097A9",
  "00859B",
  "007D8A",
  "007680",
  "006269",
  "B1E4E3",
  "88DBDF",
  "2DCCD3",
  "009CA6",
  "008C95",
  "007377",
  "005F61",
  "A0D1CA",
  "40C1AC",
  "00B0B9",
  "00A3AD",
  "007398",
  "005F86",
  "005A70",
  "7EDDD3",
  "5CB8B2",
  "279989",
  "007681",
  "487A7B",
  "0D5257",
  "244C5A",
  "B6CFD0",
  "ABC7CA",
  "94B7BB",
  "7FA9AE",
  "4F868E",
  "115E67",
  "07272D",
  "00968F",
  "00857D",
  "007672",
  "006D68",
  "00635B",
  "005E5D",
  "005151",
  "9CDBD9",
  "64CCC9",
  "00B2A9",
  "008675",
  "007367",
  "00685E",
  "00534C",
  "71DBD4",
  "2AD2C9",
  "00BFB3",
  "00A499",
  "008578",
  "00594F",
  "004C45",
  "7CE0D3",
  "2CD5C4",
  "00C7B1",
  "00B398",
  "009681",
  "007864",
  "004E42",
  "6DCDB8",
  "49C5B1",
  "00AB8E",
  "009B77",
  "008264",
  "006A52",
  "034638",
  "B9DCD2",
  "A1D6CA",
  "86C8BC",
  "6BBBAE",
  "006F62",
  "00594C",
  "1D3C34",
  "B5E3D8",
  "A5DFD3",
  "98DBCE",
  "6BCABA",
  "00816D",
  "006C5B",
  "173F35",
  "ADCAB8",
  "9ABEAA",
  "85B09A",
  "6FA287",
  "28724F",
  "205C40",
  "284734",
  "BFCEC2",
  "A7BDB1",
  "92ACA0",
  "7F9C90",
  "5C7F71",
  "43695B",
  "183028",
  "BAC5B9",
  "B0BDB0",
  "A3B2A4",
  "94A596",
  "708573",
  "5E7461",
  "22372B",
  "BCC9C5",
  "B1C0BC",
  "9DB0AC",
  "829995",
  "5D7975",
  "3E5D58",
  "18332F",
  "D1E0D7",
  "B7CDC2",
  "9AB9AD",
  "789F90",
  "507F70",
  "285C4D",
  "13322B",
  "A7E6D7",
  "8CE2D0",
  "3CDBC0",
  "009775",
  "007B5F",
  "00664F",
  "8FD6BD",
  "6ECEB2",
  "00B388",
  "00965E",
  "007A53",
  "006747",
  "115740",
  "50A684",
  "00966C",
  "008755",
  "007B4B",
  "006F44",
  "006845",
  "005844",
  "7AE1BF",
  "47D7AC",
  "00C389",
  "00AF66",
  "007749",
  "006341",
  "154734",
  "A0DAB3",
  "91D6AC",
  "71CC98",
  "009A44",
  "00843D",
  "046A38",
  "2C5234",
  "A2E4B8",
  "8FE2B0",
  "80E0A7",
  "00B140",
  "009639",
  "007A33",
  "215732",
  "9BE3BF",
  "26D07C",
  "00BF6F",
  "00B74F",
  "009F4D",
  "275D38",
  "00573F",
  "4B9560",
  "228848",
  "007A3E",
  "007041",
  "286140",
  "36573B",
  "395542",
  "6BA539",
  "48A23F",
  "319B42",
  "3A913F",
  "44883E",
  "4A773C",
  "44693D",
  "ADDC91",
  "A1D884",
  "6CC24A",
  "43B02A",
  "509E2F",
  "4C8C2B",
  "4A7729",
  "D0DEBB",
  "BCE194",
  "8EDD65",
  "78D64B",
  "74AA50",
  "719949",
  "79863C",
  "C2E189",
  "B7DD79",
  "A4D65E",
  "78BE20",
  "64A70B",
  "658D1B",
  "546223",
  "D4EB8E",
  "CDEA80",
  "C5E86C",
  "97D700",
  "84BD00",
  "7A9A01",
  "59621D",
  "C4D6A4",
  "BCD19B",
  "B7CE95",
  "A9C47F",
  "789D4A",
  "67823A",
  "4E5B31",
  "D0D1AB",
  "C6C89B",
  "BABD8B",
  "A2A569",
  "8A8D4A",
  "6D712E",
  "3D441E",
  "D2CE9E",
  "CBC793",
  "C0BB87",
  "AFA96E",
  "A09958",
  "89813D",
  "555025",
  "C3C6A8",
  "B3B995",
  "A3AA83",
  "899064",
  "737B4C",
  "5E6738",
  "3E4827",
  "BFCC80",
  "BBC592",
  "9CAF88",
  "8F993E",
  "76881D",
  "7A7256",
  "5B6236",
  "BABC16",
  "ABAD23",
  "999B30",
  "888D30",
  "7C8034",
  "727337",
  "656635",
  "E2E868",
  "DBE442",
  "CEDC00",
  "C4D600",
  "A8AD00",
  "949300",
  "787121",
  "E9EC6B",
  "E3E935",
  "E0E721",
  "D0DF00",
  "B5BD00",
  "9A9500",
  "827A04",
  "E3E48D",
  "E0E27C",
  "DBDE70",
  "D2D755",
  "B7BF10",
  "8E8C13",
  "625D20",
  "F0EC74",
  "EDE939",
  "ECE81A",
  "E1E000",
  "BFB800",
  "ADA400",
  "A09200",
  "F3EA5D",
  "F3E500",
  "EFDF00",
  "EEDC00",
  "BBA600",
  "9A8700",
  "685C20",
  "F1EB9C",
  "F0E991",
  "F0E87B",
  "EDE04B",
  "EADA24",
  "E1CD00",
  "CFB500",
  "EBE49A",
  "E9E186",
  "E6DE77",
  "E1D555",
  "D7C826",
  "C4B000",
  "B39B00",
  "E9DF97",
  "E4D77E",
  "DECD63",
  "D9C756",
  "B89D18",
  "A28E2A",
  "695B24",
  "DCD59A",
  "D6CF8D",
  "D0C883",
  "C0B561",
  "AC9F3C",
  "9F912A",
  "8A7B19",
  "CAB64B",
  "CFB023",
  "C1A01E",
  "A08629",
  "897630",
  "736635",
  "675E33",
  "D4C304",
  "C4B200",
  "91852C",
  "747136",
  "5D6439",
  "585C3B",
  "535435",
  "BBB323",
  "B4A91F",
  "AA9D2E",
  "8F7E35",
  "716135",
  "635939",
  "4E4934",
  "D5CB9F",
  "CFC493",
  "C5B783",
  "B3A369",
  "998542",
  "8C7732",
  "614F25",
  "CAC7A7",
  "BFBB98",
  "B0AA7E",
  "9B945F",
  "594A25",
  "524727",
  "4A412A",
  "F1E6B2",
  "DFD1A7",
  "D9C89E",
  "CEB888",
  "A89968",
  "94795D",
  "816040",
  "DDCBA4",
  "D3BC8D",
  "C6AA76",
  "B9975B",
  "8B5B29",
  "744F28",
  "5C462B",
  "EFDBB2",
  "FCD299",
  "E1B87F",
  "D6A461",
  "C6893F",
  "B77729",
  "A6631B",
  "EDC8A3",
  "E7B78A",
  "DDA46F",
  "C88242",
  "B36924",
  "934D11",
  "7D3F16",
  "F3CFB3",
  "F1C6A7",
  "F0BF9B",
  "E59E6D",
  "B86125",
  "A45A2A",
  "693F23",
  "E0C09F",
  "D9B48F",
  "CDA077",
  "B58150",
  "9E652E",
  "774212",
  "623412",
  "E0C6AD",
  "DCBFA6",
  "CDA788",
  "BF9474",
  "AD7C59",
  "946037",
  "4F2C1D",
  "E1B7A7",
  "D5A286",
  "C58B68",
  "99552B",
  "85431E",
  "6D4F47",
  "5E4B3C",
  "D7C4B7",
  "CDB5A7",
  "C0A392",
  "AE8A79",
  "956C58",
  "7C4D3A",
  "5B3427",
  "DBC8B6",
  "D3BBA8",
  "C6A992",
  "AA8066",
  "703F2A",
  "623B2A",
  "4E3629",
  "D6D2C4",
  "C5B9AC",
  "B7A99A",
  "A39382",
  "7A6855",
  "63513D",
  "473729",
  "D1CCBD",
  "B7B09C",
  "A69F88",
  "A7ACA2",
  "949A90",
  "8E9089",
  "4B4F54",
  "D0D3D4",
  "C1C6C8",
  "A2AAAD",
  "7C878E",
  "5B6770",
  "333F48",
  "1D252D",
  "C7C9C7",
  "B2B4B2",
  "9EA2A2",
  "898D8D",
  "707372",
  "54585A",
  "25282A",
  "BEC6C4",
  "A2ACAB",
  "919D9D",
  "717C7D",
  "505759",
  "3F4444",
  "373A36",
  "BABBB1",
  "A8A99E",
  "919388",
  "7E7F74",
  "65665C",
  "51534A",
  "212322",
  "C4BFB6",
  "AFA9A0",
  "9D968D",
  "8C857B",
  "776E64",
  "696158",
  "C4BCB7",
  "B2A8A2",
  "978C87",
  "857874",
  "746661",
  "5E514D",
  "382F2D",
  "D0C4C5",
  "C1B2B6",
  "AB989D",
  "7B6469",
  "584446",
  "453536",
  "382E2C",
  "D7D2CB",
  "CBC4BC",
  "BFB8AF",
  "B6ADA5",
  "ACA39A",
  "A59C94",
  "968C83",
  "8C8279",
  "83786F",
  "796E65",
  "6E6259",
  "D9D9D6",
  "D0D0CE",
  "C8C9C7",
  "BBBCBC",
  "B1B3B3",
  "A7A8AA",
  "97999B",
  "888B8D",
  "75787B",
  "63666A",
  "53565A",
  "332F21",
  "212721",
  "31261D",
  "3E2B2E",
  "101820",
  "3D3935"
], a0 = ju.map((r) => [
  parseInt(r.substring(0, 2), 16),
  parseInt(r.substring(2, 4), 16),
  parseInt(r.substring(4, 6), 16)
]);
function oQ(r) {
  const e = od.indexOf(r);
  return e >= 0 ? ju[e] : "";
}
function qO(r) {
  const e = ju.indexOf(r);
  return e >= 0 ? od[e] : "";
}
function lQ(r, e = 64) {
  const t = [], n = [], i = qO(r);
  i && t.push({
    pms: i,
    hex: r,
    distance: 0
  });
  const a = parseInt(r.substring(0, 2), 16), s = parseInt(r.substring(2, 4), 16), o = parseInt(r.substring(4, 6), 16);
  let l, u, c;
  for (let d = 0; d < ju.length; d++) {
    l = a0[d][0], u = a0[d][1], c = a0[d][2];
    const f = Math.sqrt(Math.pow(a - l, 2) + Math.pow(s - u, 2) + Math.pow(o - c, 2));
    n.push(f);
  }
  for (let d = 0; d < n.length; d++)
    n[d] <= e && !t.some((f) => f.pms === od[d]) && t.push({ pms: od[d], hex: ju[d], distance: n[d] });
  return t.sort((d, f) => d.distance - f.distance);
}
const WO = od.map((r, e) => ({ pms: r, hex: ju[e] })), QO = new GO(WO, { keys: ["pms"] });
function uQ(r, e) {
  return QO.search(r, e ? { limit: e } : void 0);
}
function YO(r) {
  const e = r.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
  if (!e)
    return "";
  const t = parseInt(e[1], 10), n = parseInt(e[2], 10), i = parseInt(e[3], 10);
  return [t, n, i].map((a) => a.toString(16).padStart(2, "0")).join("").toUpperCase();
}
let ef = null;
function XO(r) {
  if (r.startsWith("#"))
    return ex(r);
  if (r.startsWith("rgba") || r.startsWith("rgb")) {
    const t = YO(r);
    if (t)
      return t;
  }
  if (!document)
    throw new Error("browserColorToHex is only supported on browsers");
  if (ef || (ef = document.createElement("canvas").getContext("2d")), !ef)
    throw new Error("Failed to create canvas context required to convert colors");
  ef.fillStyle = r;
  const e = ex(ef.fillStyle);
  return e || console.error(`Unknown browser color ${r}`), e;
}
function ex(r) {
  const e = r.substring(1).toUpperCase();
  return e.length === 6 ? e : e.length === 3 ? `${e[0]}${e[0]}${e[1]}${e[1]}${e[2]}${e[2]}` : "";
}
const Oh = (r) => {
  const e = _k(r.spotColor);
  return e ? `${r.browserValue} ${e}` : r.browserValue;
}, _k = (r) => {
  if (!r)
    return "";
  if (r.profileName.includes("/") && r.profileName.includes(".icc")) {
    const e = r.profileName.replace(/\s/g, "-"), t = e.lastIndexOf("/");
    return `icc-named-color(${e.slice(t + 1).slice(0, -4)}, ${r.namedColor})`;
  }
  return `icc-named-color(${r.profileName}, ${r.namedColor})`;
}, tx = (r) => {
  const e = r.split(/[ ](?=[^)]*?(?:\(|$))/);
  if (e.length === 0)
    return { browserValue: "#000000" };
  if (e.length === 1)
    return { browserValue: e[0] };
  const t = e[1].match(/\(([^)]+)\)/gm);
  if (!t)
    throw new Error("Unhandled state of color value in SVG");
  const n = t[0].replace(/[() ]/g, "").split(",");
  return {
    browserValue: e[0],
    spotColor: { profileName: n[0], namedColor: n[1] }
  };
}, JO = [
  "altGlyph",
  "circle",
  "ellipse",
  "path",
  "polygon",
  "polyline",
  "rect",
  "text",
  "textPath",
  "tref",
  "tspan"
], KO = ["fill", "stroke"], wl = (r, e) => {
  e(r), r.children.length > 0 && Array.from(r.children).forEach((t) => wl(t, e));
}, Nk = (r, e) => {
  const t = e(r);
  if (t)
    return t;
  const n = r.parentElement;
  if (n)
    return Nk(n, e);
}, ZO = (r, e) => {
  try {
    return r.matches(e);
  } catch {
    return r.classList.contains(e.substring(1));
  }
}, NA = (r, e = !1) => {
  !e && r.setAttribute("preserveAspectRatio", "none");
  const t = [];
  wl(r, (n) => {
    if (n.tagName === "script") {
      n.remove();
      return;
    }
    if (n.tagName === "style") {
      try {
        Fk.parse(n.innerHTML).stylesheet?.rules.forEach((s) => {
          t.push(s);
        }), n.remove();
      } catch (a) {
        console.error(a);
      }
      return;
    }
    const i = n.attributes.getNamedItem("style")?.value?.trim();
    if (i) {
      const a = [];
      i.split(";").forEach((o) => {
        const l = o.trim();
        if (l) {
          const [u, c] = l.split(":"), d = u.toLowerCase();
          KO.indexOf(d) > -1 ? n.setAttribute(d, c.trim()) : a.push(l);
        }
      }), a.length > 0 ? n.setAttribute("style", a.join(";")) : n.removeAttribute("style");
    }
  }), wl(r, (n) => {
    t.forEach((i) => {
      i.selectors?.forEach((a) => {
        ZO(n, a) && i.declarations?.forEach((s) => {
          s.property && s.value && n.setAttribute(s.property, s.value);
        });
      });
    });
  });
}, eB = (r) => {
  const e = /pt|pc|mm|cm|in/gm, t = r.getAttribute("viewBox"), n = r.getAttribute("width"), i = r.getAttribute("height");
  if (!t) throw new Error("viewBox not specified on SVG!");
  n && r.setAttribute("width", n.replace(e, "")), i && r.setAttribute("height", i.replace(e, ""));
}, LA = (r) => _s().parseFromString(r, "image/svg+xml").firstElementChild, tB = (r, e, t) => {
  r.setAttribute("height", `${t}px`), r.setAttribute("width", `${e}px`);
}, Lk = (r, e, t) => {
  wl(r, (n) => {
    const i = n.attributes.getNamedItem("fill");
    i && i.value !== "none" && n.classList.forEach((s) => {
      if (s.startsWith("spiff-fill")) {
        const o = e[s.replace("spiff-fill-", "")];
        if (o)
          n.setAttribute(
            "fill",
            t ? Oh(o) : o.browserValue
          );
        else {
          const l = e[s];
          l && n.setAttribute(
            "fill",
            t ? Oh(l) : l.browserValue
          );
        }
      }
    });
    const a = n.attributes.getNamedItem("stroke");
    a && a.value !== "none" && n.classList.forEach((s) => {
      if (s.startsWith("spiff-stroke")) {
        const o = e[s.replace("spiff-stroke-", "")];
        if (o)
          n.setAttribute(
            "stroke",
            t ? Oh(o) : o.browserValue
          );
        else {
          const l = e[s];
          l && n.setAttribute(
            "fill",
            // Should this be "stroke"? Is this code still relevant anyway?
            t ? Oh(l) : l.browserValue
          );
        }
      }
    });
  });
}, UA = (r) => El().serializeToString(r), VA = (r, e, t, n, i) => {
  const a = LA(r);
  if (!a)
    throw new Error("Failed to read SVG.");
  return tB(a, e, t), Lk(a, n, i), UA(a);
}, zA = (r, e, t) => {
  const n = LA(r);
  if (!n)
    throw new Error("Failed to read SVG.");
  return Lk(n, e, t), UA(n);
}, rB = (r) => {
  const e = /<svg.*<\/svg>/s, t = r.match(e) || [], n = t?.length > 0 ? t[0] : "";
  return _s().parseFromString(n, "image/svg+xml");
}, ss = async (r) => {
  const t = rB(r).firstElementChild;
  if (!t)
    throw new Error("Failed to read SVG.");
  NA(t);
  const n = {};
  wl(t, (s) => {
    if (JO.includes(s.tagName) && !s.attributes.getNamedItem("fill")) {
      let u = "black";
      const c = s.parentElement;
      if (c) {
        const d = Nk(c, (f) => {
          const g = f.style.fill;
          if (g)
            return g;
          const v = f.getAttribute("fill");
          if (v)
            return v;
        });
        d && (u = d);
      }
      s.setAttribute("fill", u);
    }
    const o = s.attributes.getNamedItem("fill");
    if (o && o.value !== "none" && !o.value.startsWith("url(")) {
      const u = tx(o.value), c = u.browserValue.replace(/\W/g, ""), d = `spiff-fill-${c}`;
      s.setAttribute("fill", u.browserValue), s.classList.add(d), n[c] = u;
    }
    const l = s.attributes.getNamedItem("stroke");
    if (l && l.value !== "none" && !l.value.startsWith("url(")) {
      const u = tx(l.value), c = u.browserValue.replace(/\W/g, ""), d = `spiff-stroke-${c}`;
      s.classList.add(d), s.setAttribute("stroke", u.browserValue), n[c] = u;
    }
  });
  const a = El().serializeToString(t);
  return {
    colors: n,
    svg: a
  };
}, nB = (r, e, t, n, i) => {
  const a = LA(r);
  if (!a)
    throw new Error("Failed to parse SVG for color merging");
  wl(a, (o) => {
    let l = !1, u = !1;
    t.forEach((c) => {
      const d = `spiff-fill-${c}`, f = `spiff-stroke-${c}`;
      o.classList.contains(d) && (o.classList.remove(d), l = !0), o.classList.contains(f) && (o.classList.remove(f), u = !0);
    }), l && (o.classList.add(`spiff-fill-${n}`), o.setAttribute("fill", i.browserValue)), u && (o.classList.add(`spiff-stroke-${n}`), o.setAttribute("stroke", i.browserValue));
  });
  const s = { ...e };
  return t.forEach((o) => {
    o !== n && delete s[o];
  }), s[n] = i, {
    svg: UA(a),
    colors: s
  };
}, iB = Ee`
    fragment AssetMetadataFields on Asset {
        metadata {
            key
            value
        }
    }
`, aB = Ee`
    fragment AssetVersionsFields on Asset {
        versions {
            name
            link
        }
    }
`, sc = (r, e) => Ee`
        ${r && iB || ""}
        ${e && aB || ""}
        fragment AssetFields on Asset {
            name
            key
            type
            createdAt
            mimeType
            fileLink
            assetConfiguration {
                assetKey
                colorOption {
                    id
                    name
                    variants {
                        id
                        name
                        enabled
                        namedColor
                        color
                    }
                }
                channelNumbers {
                    id
                    number
                }
                defaultColorVariants {
                    channelNumber
                    variant {
                        id
                        name
                        enabled
                        namedColor
                        color
                    }
                }
            }
            ${e && "...AssetVersionsFields" || ""}
            ${r && "...AssetMetadataFields" || ""}
           
        }
    `, Uk = Ee`
    fragment MaterialFields on Material {
        id
        name
        createdAt
        clearCoat
        clearCoatIor
        refractionIntensity
        reflectionIntensity
        reflectionRotation
        albedoMap {
            key
            fileLink
        }
        alphaMap {
            key
            fileLink
        }
        ambientMap {
            key
            fileLink
        }
        emissionMap {
            key
            fileLink
        }
        metallicMap {
            key
            fileLink
        }
        normalMap {
            key
            fileLink
        }
        refractionMap {
            key
            fileLink
        }
        reflectionMap {
            key
            fileLink
        }
        roughnessMap {
            key
            fileLink
        }
    }
`, sB = Ee`
    ${Uk}
    query GetMaterials($ids: [String]) {
        materials(id: $ids) {
            ...MaterialFields
        }
    }
`, oB = Ee`
    mutation CreateAsset($name: String!, $type: String!, $mimeType: String!, $anonymous: Boolean, $temporary: Boolean) {
        assetCreate(name: $name, type: $type, mimeType: $mimeType, anonymous: $anonymous, temporary: $temporary) {
            uploadUrl
            asset {
                name
                key
                type
                createdAt
                mimeType
                fileLink
            }
        }
    }
`, lB = Ee`
    mutation SetAssetMime($assetKey: String!, $mimeType: String!) {
        assetSetMime(assetKey: $assetKey, mimeType: $mimeType) {
            uploadUrl
            asset {
                name
                key
                type
                createdAt
                mimeType
                fileLink
            }
        }
    }
`, uB = Ee`
    ${sc(!1, !1)}
    mutation RemoveBackgroundFromAsset($key: String!) {
        assetRemoveBackground(key: $key) {
            ...AssetFields
        }
    }
`, cB = Ee`
    ${sc(!1, !1)}
    mutation VectorizeAsset($key: String!, $options: AssetVectorizeOptions) {
        assetVectorize(key: $key, options: $options) {
            ...AssetFields
        }
    }
`, fB = Ee`
    ${sc(!1, !1)}
    mutation EnhanceWithAI($key: String!, $options: AssetEnhanceOptions) {
        assetEnhanceWithAI(key: $key, options: $options) {
            ...AssetFields
        }
    }
`, Zp = async (r, e = !0) => (await He.getShadowGraphqlClient().query({
  query: Ee`
            ${sc(!1, e)}
            query GetAssets($keys: [String]!) {
                assets(keys: $keys) {
                    ...AssetFields
                }
            }
        `,
  errorPolicy: "all",
  fetchPolicy: "no-cache",
  variables: {
    keys: r
  }
})).data.assets, dB = async (r) => (await He.getShadowGraphqlClient().query({
  query: sB,
  errorPolicy: "all",
  variables: {
    ids: r
  }
})).data.materials, rx = async (r, e, t, n, i) => (await He.getShadowGraphqlClient().mutate({
  mutation: oB,
  errorPolicy: "all",
  fetchPolicy: "no-cache",
  variables: {
    name: r,
    type: e,
    mimeType: t,
    anonymous: n,
    temporary: i
  }
})).data?.assetCreate, hB = async (r, e) => (await He.getShadowGraphqlClient().mutate({
  mutation: lB,
  errorPolicy: "all",
  fetchPolicy: "no-cache",
  variables: {
    assetKey: r,
    mimeType: e
  }
})).data?.assetSetMime;
class pB {
  constructor() {
    this.cache = /* @__PURE__ */ new Map(), this.bgrmProcessCache = /* @__PURE__ */ new Map(), this.materialCache = /* @__PURE__ */ new Map(), this.loadImageAsFileInfo = async (e) => {
      const t = await e.arrayBuffer(), n = await Dg(t), i = (a, s) => {
        const o = atob(a.split(",")[1]), l = [];
        for (let u = 0; u < o.length; u++)
          l.push(o.charCodeAt(u));
        return new Blob([new Uint8Array(l)], { type: s });
      };
      return {
        name: e.name.substring(e.name.lastIndexOf("/") + 1),
        blob: i(n.dataUrl, e.type)
      };
    };
  }
  /**
   * Allows for retrieving an asset, returns the option from a cache if possible.
   */
  async getLocalOrFromServer(e) {
    if (this.cache.has(e)) {
      const i = this.cache.get(e);
      if (!i) throw new un("Failed to get asset from cache!");
      return i;
    }
    const n = (async () => (await Zp([e]))[0])();
    return this.cache.set(e, n), n;
  }
  /**
   * Retrieves the asset from the server, bypassing cache (but still writing the result to cache)
   */
  async getFromServer(e) {
    const n = (async () => (await Zp([e]))[0])();
    return this.cache.set(e, n), n;
  }
  keyFromURL(e) {
    let t;
    try {
      t = new URL(e).pathname;
    } catch {
      t = void 0;
    }
    return t !== void 0 && t.startsWith("/") && (t = t.replace("/", "")), t?.split("?")[0];
  }
  /**
   * Caches an asset if it doesn't already exist.
   */
  cacheAsset(e) {
    if (!e.key) throw new un("Asset has no key!");
    this.cache.has(e.key) || this.cache.set(e.key, Promise.resolve(e));
  }
  /**
   * Caches a material if it doesn't already exist.
   */
  cacheMaterial(e) {
    if (!e.id) throw new un("Material has no id!");
    this.materialCache.has(e.id) || this.materialCache.set(e.id, Promise.resolve(e));
  }
  /**
   * Allows for retrieving a material, returns the option from a cache if possible.
   * @param id The option ID to be retrieved.
   */
  async getMaterialLocalOrFromServer(e) {
    if (this.materialCache.has(e))
      return this.materialCache.get(e);
    const n = (async () => (await dB([e]))[0])();
    return this.materialCache.set(e, n), n;
  }
  /**
   * Upload a user asset to the server. Using callbacks to notify important events.
   * The asset will be stored via the persistence service for future access, if available.
   */
  async uploadAssetWithProgress(e, t, n, i, a) {
    const s = await this.dispatchCreateAssetRequest(e, t, i, a);
    if (!s)
      throw new Error("Failed to create asset.");
    return await new Promise((o, l) => {
      const u = new XMLHttpRequest();
      u.open("PUT", s.assetResponse.uploadUrl, !0), u.setRequestHeader("Content-Type", s.mimeType), u.setRequestHeader("Cache-Control", "public,max-age=31536000,immutable"), u.upload.onprogress = (c) => {
        c.lengthComputable && n(c.loaded * 100 / c.total);
      }, u.onload = () => {
        const c = s.assetResponse.asset;
        Xa.add(s.assetResponse.asset), o(c);
      }, u.onerror = l, this.postProcessFileUpload(e, s.mimeType).then((c) => u.send(c.blob)).catch(l);
    }), this.cacheAsset(s.assetResponse.asset), s.assetResponse.asset;
  }
  async uploadAsset(e, t, n, i) {
    return this.uploadAssetWithProgress(e, t, () => {
    }, n, i);
  }
  async uploadFile(e, t) {
    const i = this.isRaster(e) ? Yp.Image : Yp.Illustration, a = await this.loadImageAsFileInfo(e);
    return await this.uploadAssetWithProgress(a, i, t, !0);
  }
  async setAssetMime(e, t) {
    const n = await hB(e, t);
    if (!n)
      throw new Error("Failed to set asset mime type.");
    return this.cacheAsset(n.asset), n;
  }
  async createAssetWithoutUpload(e, t, n, i) {
    const a = await rx(e, t, "", n, i);
    if (!a)
      throw new Error("Failed to create asset.");
    return this.cacheAsset(a.asset), a.asset;
  }
  async removeBackgroundFromAsset(e) {
    const t = e.key;
    if (this.bgrmProcessCache.has(t))
      return this.bgrmProcessCache.get(t);
    if (bn.has(rf, t)) {
      const a = this.getLocalOrFromServer(
        bn.get(rf, t)
      );
      return this.bgrmProcessCache.set(t, a), a;
    }
    const i = (async () => {
      const a = await He.getShadowGraphqlClient().mutate({
        mutation: uB,
        fetchPolicy: "no-cache",
        errorPolicy: "all",
        variables: {
          key: t
        }
      });
      if (this.bgrmProcessCache.delete(t), console.log(a), !a.data?.assetRemoveBackground?.key)
        throw new Error("Failed to remove background from image");
      return Xa.add(a.data.assetRemoveBackground), bn.add(
        rf,
        t,
        a.data.assetRemoveBackground.key
      ), this.cache.set(
        a.data.assetRemoveBackground.key,
        Promise.resolve(a.data.assetRemoveBackground)
      ), a.data.assetRemoveBackground;
    })();
    return this.bgrmProcessCache.set(t, i), i;
  }
  async vectorizeAsset(e, t = void 0) {
    const n = e.key;
    if (this.bgrmProcessCache.has(n))
      return this.bgrmProcessCache.get(n);
    if (bn.has(nf, n)) {
      const s = this.getLocalOrFromServer(
        bn.get(nf, n)
      );
      return this.bgrmProcessCache.set(n, s), s;
    }
    const a = (async () => {
      const s = await He.getShadowGraphqlClient().mutate({
        mutation: cB,
        fetchPolicy: "no-cache",
        errorPolicy: "all",
        variables: {
          key: n,
          options: {
            maxColorCount: t
          }
        }
      });
      if (this.bgrmProcessCache.delete(n), !s.data?.assetVectorize?.key)
        throw new Error("Failed to vectorize image");
      return Xa.add(s.data.assetVectorize), bn.add(
        nf,
        n,
        s.data.assetVectorize.key
      ), this.cache.set(
        s.data.assetVectorize.key,
        Promise.resolve(s.data.assetVectorize)
      ), s.data.assetVectorize;
    })();
    return this.bgrmProcessCache.set(n, a), a;
  }
  async enhanceWithAI(e, t) {
    const n = e.key;
    if (this.bgrmProcessCache.has(n))
      return this.bgrmProcessCache.get(n);
    if (bn.has(af, n)) {
      const s = this.getLocalOrFromServer(
        bn.get(af, n)
      );
      return this.bgrmProcessCache.set(n, s), s;
    }
    const a = (async () => {
      const s = await He.getShadowGraphqlClient().mutate({
        mutation: fB,
        fetchPolicy: "no-cache",
        errorPolicy: "all",
        variables: {
          key: n,
          options: t || {}
        }
      });
      if (this.bgrmProcessCache.delete(n), !s.data?.assetEnhanceWithAI?.key)
        throw new Error("Failed to enhance image with AI");
      return Xa.add(s.data.assetEnhanceWithAI), bn.add(
        af,
        n,
        s.data.assetEnhanceWithAI.key
      ), this.cache.set(
        s.data.assetEnhanceWithAI.key,
        Promise.resolve(s.data.assetEnhanceWithAI)
      ), s.data.assetEnhanceWithAI;
    })();
    return this.bgrmProcessCache.set(n, a), a;
  }
  removePersistedAsset(e) {
    Xa.remove(e), bn.delete(rf, e), bn.delete(nf, e), bn.delete(af, e), bn.deleteForTransformedKey(rf, e), bn.deleteForTransformedKey(nf, e), bn.deleteForTransformedKey(af, e);
  }
  getPersistedAssets() {
    return Xa.list();
  }
  registerPersistedAssetListener(e) {
    Xa.addCallback(e);
  }
  unRegisterPersistedAssetListener(e) {
    Xa.removeCallback(e);
  }
  isRaster(e) {
    return !(e.type === "image/svg+xml" || e.type === "application/pdf" || e.type === "application/postscript");
  }
  async postProcessFileUpload(e, t) {
    if (t === "image/svg+xml") {
      const n = await e.blob.text(), s = new window.DOMParser().parseFromString(n, "image/svg+xml").documentElement;
      if (!s) throw new Fu("Failed to read SVG.");
      eB(s);
      const l = El().serializeToString(s);
      return {
        name: e.name,
        blob: new Blob([l], { type: "image/svg+xml" })
      };
    }
    return e;
  }
  /**
   * Handles mimeType resolution & asset creation request
   * @param file A file info object containing data about the file and its name
   * @param assetType The type of asset we're expecting to upload
   */
  async dispatchCreateAssetRequest(e, t, n, i) {
    const a = e.blob.type ? e.blob.type : this.guessMIME(e.name), s = await rx(e.name, t, a, n, i);
    if (s)
      return {
        assetResponse: s,
        mimeType: a
      };
  }
  guessMIME(e) {
    const t = e.split(".").pop();
    switch (t) {
      case "glb":
        return "model/gltf-binary";
      case "ttf":
        return "font/ttf";
      case "mkv":
        return "video/x-matroska";
      default:
        throw new un("Unexpected mimetype: " + t);
    }
  }
}
const tf = "persistentAssets", Ts = class Ts {
  /**
   * Add a new asset to persistence
   * @param asset The asset to add.
   */
  static add(e) {
    if (!e.fileLink) {
      console.error("Failed to find cdn link on asset, cannot persist!");
      return;
    }
    const t = /* @__PURE__ */ new Map();
    t.set(e.key || "", e.fileLink);
    const n = Cr.getMap(tf);
    n && n.forEach((i, a) => {
      t.set(a, i);
    }), Cr.setMap(tf, t), Ts.executeCallbacks();
  }
  /**
   * Remove an existing asset from persistence. Noop if the asset doesn't exist.
   * @param assetKey The key to remove.
   */
  static remove(e) {
    const t = Cr.getMap(tf);
    if (!t) return;
    const n = Array.from(t.entries()).find((i) => i[0] === e);
    n && (t.delete(n[0]), Cr.setMap(tf, t), Ts.executeCallbacks());
  }
  /**
   * Get a list of all persisted assets.
   */
  static list() {
    const e = Cr.getMap(tf);
    return e ? Array.from(e.entries()).map((t) => ({ assetKey: t[0], src: t[1] })) : [];
  }
  /**
   * Adds a callback that will be called whenever assets are added/removed from persistence.
   */
  static addCallback(e) {
    Ts.callbacks.push(e);
  }
  /**
   * Removes an existing callback.
   */
  static removeCallback(e) {
    Ts.callbacks = Ts.callbacks.filter((t) => t !== e);
  }
  static executeCallbacks() {
    Ts.callbacks.forEach((e) => e());
  }
};
Ts.callbacks = [];
let Xa = Ts;
const rf = "bgrmPersistentAssets", nf = "vectorizePersistentAssets", af = "enhanceAIPersistentAssets";
class bn {
  static has(e, t) {
    return bn.getMap(e).has(t);
  }
  static get(e, t) {
    return bn.getMap(e).get(t);
  }
  static keys(e) {
    return bn.getMap(e).keys();
  }
  static values(e) {
    return bn.getMap(e).values();
  }
  static add(e, t, n) {
    const i = bn.getMap(e);
    i.set(t, n), bn.setMap(e, i);
  }
  static delete(e, t) {
    const n = bn.getMap(e);
    n.delete(t), bn.setMap(e, n);
  }
  static deleteForTransformedKey(e, t) {
    const n = bn.getMap(e), i = Array.from(n.keys()).find((a) => n.get(a) === t);
    i && (n.delete(i), bn.setMap(e, n));
  }
  static getMap(e) {
    return Cr.getMap(e) || /* @__PURE__ */ new Map();
  }
  static setMap(e, t) {
    Cr.setMap(e, t);
  }
}
const zn = new pB();
class gB {
  constructor() {
    this.cache = {}, this.disabled = !1;
  }
  /**
   * Gets a promise from the cache, or undefined if it doesn't exist.
   */
  get(e) {
    if (this.disabled) return;
    const t = JSON.stringify(e);
    return this.cache[t];
  }
  /**
   * Sets a promise in the cache and returns it.
   */
  set(e, t) {
    if (this.disabled) return t;
    const n = JSON.stringify(e);
    return this.cache[n] = t, t;
  }
  /**
   * Some environments don't want workflows to be cached. An example is a server
   * that doesn't launch a fresh instance per request. This method allows disabling
   * caching in a transparent way.
   */
  disable(e) {
    this.disabled = e;
  }
}
const eg = new gB(), $A = (r, e = 512, t, n) => {
  const i = typeof r == "string" ? r : r.fileLink;
  if (!i)
    return;
  const a = i.includes("?") ? "&" : "?", s = [`w=${e}`, `h=${e}`];
  return n !== void 0 && s.push(`q=${n}`), t && s.push(`format=${t}`), `${i}${a}${s.join("&")}`;
}, mB = Ee`
    fragment OptionMinimalFields on Option {
        id
        defaultVariant {
            id
        }
    }
`, vB = Ee`
    fragment OptionFields on Option {
        id
        name
        public
        currencyCode
        type
        workflowId
        displayType
        integrationOptions {
            id
            integrationId
        }
        variants {
            id
            name
            enabled
            color
            namedColor
            priceModifier
            asset {
                ...AssetFields
            }
            thumbnail {
                ...AssetFields
            }
            material {
                ...MaterialFields
            }
            category
            product {
                id
                name
                basePrice
                workflows {
                    id
                    workflowName
                }
                integrationProducts {
                    id
                    integration {
                        id
                    }
                }
            }
        }
        defaultVariant {
            id
        }
        colorProfile {
            ...AssetFields
        }
    }
`, yB = Ee`
    query GetTagsMany($ids: [String!]!) {
        tagsMany(entityIds: $ids) {
            id
            entityId
            name
        }
    }
`, AB = async (r) => {
  const e = await He.getShadowGraphqlClient().query({
    query: Ee`
            ${sc(!1, !1)}
            ${Uk}
            ${vB}
            query GetOptions($ids: [String]!) {
                options(ids: $ids) {
                    ...OptionFields
                }
            }
        `,
    errorPolicy: "all",
    variables: {
      ids: r
    }
  });
  return e.data.options.forEach((t) => {
    t.colorProfile && zn.cacheAsset(t.colorProfile), t.variants?.forEach((n) => {
      n.asset && zn.cacheAsset(n.asset), n.thumbnail && zn.cacheAsset(n.thumbnail), n.material && zn.cacheMaterial(n.material);
    });
  }), e.data.options;
}, bB = async (r, e) => (await e).find((n) => n.id === r), s0 = async (r) => {
  const e = new Map(r.map((i) => [i, eg.get({ id: i })])), t = r.filter((i) => e.get(i) === void 0);
  if (t.length > 0) {
    const i = AB(t);
    t.forEach(
      (a) => e.set(a, eg.set({ id: a }, bB(a, i)))
    );
  }
  return (await Promise.all(r.map((i) => e.get(i)))).filter((i) => i !== void 0);
}, nx = (r) => {
  if (!(!r || !r.fileLink))
    return $A(r, 512, "webp");
}, ix = (r, e, t) => {
  if (r.length === 1)
    return r[0];
  if (t) {
    const n = r.find((i) => i.id === t);
    if (n)
      return n;
  }
  if (e.defaultVariant !== void 0)
    return r.find((n) => n.id === e.defaultVariant?.id);
};
class wB {
  constructor() {
    this.getDefaultVariant = async (e, t) => {
      const n = e?.variants;
      if (n)
        return ix(n, e, t);
      const a = (await this.getOption(e.id))?.variants;
      if (a)
        return ix(a, e, t);
    }, this.getTagsForAssets = async (e) => {
      const t = e?.map((s) => s.asset?.key) || [], n = e?.map((s) => s.material?.id) || [], i = [...t, ...n].filter((s) => !!s);
      return i.length === 0 ? [] : (await He.getShadowGraphqlClient().query({
        query: yB,
        errorPolicy: "all",
        variables: {
          ids: i
        }
      })).data.tagsMany;
    };
  }
  /**
   * Allows for retrieving an option, returns the option from a cache if possible.
   * @param id The option ID to be retrieved.
   */
  async getOption(e) {
    return e ? (await s0([e]))[0] : void 0;
  }
  async getOptions(e) {
    return s0(e);
  }
  async getOptionForStep(e) {
    return this.ensureFullOption(e.option);
  }
  /**
   * Utility function to get the full option from either the network or return the existing option if it can be considered to have the "full" state.
   *
   * @returns The full option resource, or `undefined` if invalid.
   */
  async ensureFullOption(e) {
    return e?.variants ? e : e?.id ? (await s0([e.id]))[0] : void 0;
  }
  /**
   * Returns the URL of the image to be used for a given variant. The priority is:
   * 1. The variant's thumbnail (if it exists)
   * 2. The variant's asset (if it exists)
   * 3. The variant's material ID (if it exists) // TODO: Does this really make sense?
   * 4. An empty string if none of the above exist
   * @param variant The variant for which to retrieve the image URL.
   * @returns A promise that resolves to the URL of the image to be used for the given variant, or an empty string if no image is available.
   */
  async getAssetTileImageForVariant(e) {
    const t = nx(e.thumbnail) ?? nx(e.asset);
    return t || (e.material ? e.material.id : "");
  }
}
const ft = new wB(), Vk = Ee`
    fragment ActiveIntegrationFields on Integration {
        id
        logo
        name
        theme {
            id
            configuration
            primaryColor
            secondaryColor
            textColor
        }
        partner {
            id
            name
            activeAddons
            currencyCode
            beta
        }
    }
`, Pg = Ee`
    fragment AdditionalIntegrationProductFields on IntegrationProduct {
        id
        product {
            id
            basePrice
            enabled
            name
            description
            sku
            skuCode
            weight
            imageUrl
            modelUrl
            overlayImageUrl
            preloadImageUrl
        }
    }
`, zk = Ee`
    fragment RecipientFields on Recipient {
        id
        firstName
        lastName
        address
        suburb
        state
        email
        postalCode
        country
        mobile
        company
        apartment
        customField1
        customField2
        customField3
        customField4
        customField5
        conversionConfigurationId
    }
`, Td = Ee`
    fragment ConversionConfigurationFields on ConversionConfiguration {
        id
        partnerId
        name
        locations
        mandatory
        requestedData
        requestedDataItems {
            type
            mandatory
            title
            uniqueIdentifier
            customFieldIndex
            optionId
            option {
                id
                name
                variants {
                    id
                    name
                    enabled
                }
                defaultVariant {
                    id
                }
            }
        }
    }
`, xB = Ee`
    ${zk}
    mutation CreateTransactions(
        $inputs: [TransactionCreateInput]!
        $marketplaceThemeInstallId: String
        $marketplaceThemeInstallConfigurationId: String
    ) {
        transactionCreateMany(
            inputs: $inputs
            marketplaceThemeInstallId: $marketplaceThemeInstallId
            marketplaceThemeInstallConfigurationId: $marketplaceThemeInstallConfigurationId
        ) {
            id
            designName
            transactionOwnerId
            workflowId
            customLogoLink
            quantity
            workflowFooterLogoLink
            restApiIntegrationLink
            workflowState
            workflowViewerLink
            workflowViewerReadOnlyLink
            recipient {
                ...RecipientFields
            }
            parentTransaction {
                id
            }
            integrationProductId
        }
    }
`, $k = Ee`
    fragment StakeholderFields on Stakeholder {
        id
        type
        authorizationDate
        authorizationNote
        authorizationStatus
    }
`, Hk = Ee`
    fragment TransactionShareActionFields on TransactionShareAction {
        id
        title
        type
        stakeholderType
        precedence
        url
    }
`, jk = Ee`
    ${Pg}
    ${Td}
    ${Vk}
    query ReadIntegrationProducts($ids: [String!]!) {
        integrationProducts(ids: $ids) {
            id
            externalProductId
            externalVariantId
            additionalExternalProductId
            additionalExternalVariantId
            additionalIntegrationProduct {
                ...AdditionalIntegrationProductFields
            }
            product {
                id
                basePrice
                enabled
                minimumOrderQuantity
                name
                description
                partner {
                    id
                    name
                    currencyCode
                    customerDetailsPromptMarkdown
                }
                productImages {
                    id
                    precedence
                    asset {
                        key
                        fileLink
                        name
                        type
                    }
                }
                integrationProducts {
                    id
                    integration {
                        id
                        type
                    }
                    externalProductId
                    externalVariantId
                    additionalExternalProductId
                    additionalExternalVariantId
                    additionalIntegrationProduct {
                        ...AdditionalIntegrationProductFields
                    }
                }
                profanities {
                    id
                    word
                }
                sku
                skuCode
                weight
                workflows {
                    id
                    friendlyName
                    isPresent
                    workflowName
                    imageUrl
                }
                imageUrl
                modelUrl
                overlayImageUrl
                preloadImageUrl
                promptForCustomerDetails
                conversionConfiguration {
                    ...ConversionConfigurationFields
                }
                productTags {
                    id
                    name
                }
                priceBreaks {
                    id
                    minQty
                    percentage
                }
            }
            integration {
                ...ActiveIntegrationFields
            }
        }
    }
`, CB = Ee`
    ${$k}
    ${Hk}
    ${zk}
    query ReadTransactions($ids: [String]!) {
        transactions(ids: $ids) {
            customLogoLink
            designName
            externalDesignProductId
            externalDesignProductVariantId
            externalCartProductId
            externalCartProductVariantId
            id
            completed
            lastSyncedAt
            priceModifierTotal
            restApiIntegrationLink
            workflowFooterLogoLink
            workflowId
            workflowState
            workflowViewerLink
            workflowViewerReadOnlyLink
            previewImageLink
            isOrdered
            quantity
            printFileUrl1
            printFileUrl2
            printFileUrl3
            printFileUrl4
            printFileUrl5
            printFileName1
            printFileName2
            printFileName3
            printFileName4
            printFileName5
            stakeholders {
                ...StakeholderFields
            }
            currentStakeholder {
                ...StakeholderFields
            }
            hasAuthenticatedActions
            transactionShareActions {
                ...TransactionShareActionFields
            }
            addressValidationStatus
            recipient {
                ...RecipientFields
            }
            parentTransaction {
                id
            }
            integrationProductId
        }
    }
`, SB = Ee`
    mutation UpdateTransactionWorkflowState($id: String!, $workflowState: String!) {
        transactionUpdate(id: $id, workflowState: $workflowState) {
            id
        }
    }
`, EB = Ee`
    mutation UpdateTransactionQuantity($id: String!, $quantity: Int) {
        transactionUpdate(id: $id, quantity: $quantity) {
            id
        }
    }
`, kB = Ee`
    mutation UpdateTransactionWorkflow($id: String!, $workflowId: String!) {
        transactionUpdate(id: $id, workflowId: $workflowId) {
            id
        }
    }
`, TB = Ee`
    ${Td}
    query ReadConversionConfigurationQuery($id: String!) {
        conversionConfiguration(id: $id) {
            ...ConversionConfigurationFields
        }
    }
`, FB = Ee`
    ${Td}
    query ReadTransactionForDesignCreation($id: String!) {
        transactions(ids: [$id]) {
            id
            completed
            createdAt
            designName
            product {
                name
                sku
                basePrice
                minimumOrderQuantity
                promptForCustomerDetails
                partner {
                    id
                    name
                    customerDetailsPromptMarkdown
                }
                conversionConfiguration {
                    ...ConversionConfigurationFields
                }
                productTags {
                    id
                    name
                }
                priceBreaks {
                    id
                    minQty
                    percentage
                }
            }
            bundle {
                id
                metadata {
                    key
                    value
                }
                bundleStakeholders {
                    type
                    customer {
                        emailAddress
                    }
                }
            }
            externalCartProductId
            externalCartProductVariantId
            externalDesignProductId
            externalDesignProductVariantId
            lastSyncedAt
            previewImageLink
            priceModifierTotal
            quantity
            workflowId
            workflowState
            workflowViewerLink
            workflowViewerReadOnlyLink
        }
    }
`, IB = Ee`
    ${Hk}
    query ReadTransactionForShareActions($id: String!) {
        transactions(ids: [$id]) {
            id
            hasAuthenticatedActions
            transactionShareActions {
                ...TransactionShareActionFields
            }
        }
    }
`, DB = Ee`
    query ConfirmWorkflowStates($transactions: [TransactionConfirmInput!]!) {
        transactionConfirmWorkflowStates(transactions: $transactions)
    }
`, Gk = (r) => Ee`
    ${Pg}
    fragment IntegrationProductFields on IntegrationProduct {
        id
        externalProductId
        externalVariantId
        additionalExternalProductId
        additionalExternalVariantId
        additionalIntegrationProduct {
            ...AdditionalIntegrationProductFields
        }
        integration {
            id
            enabled
            externalIntegrationId
            type
            isCurrent
        }
        product {
            id
            basePrice
            enabled
            minimumOrderQuantity
            imageUrl
            modelUrl
            name
            description
            overlayImageUrl
            preloadImageUrl
            sku
            skuCode
            workflows {
                id
                index
                friendlyName
                isPresent
                workflowName
                imageUrl
            }
            productTags {
                id
                name
            }
            productImages {
                id
                precedence
                asset {
                    key
                    fileLink
                    name
                    type
                }
            }
            priceBreaks {
                id
                minQty
                percentage
            }
            ${r ? `
                integrationProducts {
                    id
                    externalProductId
                    externalVariantId
                    additionalExternalProductId
                    additionalExternalVariantId
                    additionalIntegrationProduct {
                        ...AdditionalIntegrationProductFields
                    }
                    integration {
                        id
                        enabled
                        externalIntegrationId
                        type
                        isCurrent
                    }
                }
            ` : ""}
        }
    }
`, PB = (r) => Ee`
    ${Gk(r)}
    query GetIntegrationProducts($ids: [String!]!) {
        integrationProducts(ids: $ids) {
            ...IntegrationProductFields
        }
    }
`, RB = (r) => Ee`
    ${Gk(r)}
    query GetIntegrationProductFromExternalIds($externalIntegrationId: String!, $externalProductId: String!) {
        integrationProductFromExternalIds(
            externalIntegrationId: $externalIntegrationId
            externalProductId: $externalProductId
        ) {
            ...IntegrationProductFields
        }
    }
`, OB = Ee`
    ${$k}
    query ReadTransactionForStakeholders($id: String!) {
        transactions(ids: [$id]) {
            stakeholders {
                ...StakeholderFields
            }
            currentStakeholder {
                ...StakeholderFields
            }
        }
    }
`, BB = Ee`
    mutation FinalizeUpdateTransaction($transactionId: String!) {
        transactionFinalizeUpdate(transactionId: $transactionId)
    }
`, MB = Ee`
    fragment RegionFields on Region {
        width
        top
        left
        height
        layer
        layerIndex
        rotation
        panelId
        immutable
        adjustmentBoundary {
            width
            x
            y
            height
        }
    }
`, _B = Ee`
    fragment LookAtAnimationFields on LookAtAnimation {
        latDeg
        lonDeg
        radius
        target {
            x
            y
            z
        }
    }
`, NB = Ee`
    fragment RenderingPipelineConfigurationFields on RenderingPipelineConfiguration {
        antiAliasing {
            samples
            fxaaEnabled
        }
        bloom {
            enabled
            kernel
            scale
            threshold
            weight
        }
        chromaticAberration {
            enabled
            aberrationAmount
            direction {
                x
                y
            }
            radialIntensity
        }
        colorCurves {
            enabled
            globalDensity
            globalExposure
            globalHue
            globalSaturation
            highlightsDensity
            highlightsExposure
            highlightsHue
            highlightsSaturation
            midtonesDensity
            midtonesExposure
            midtonesHue
            midtonesSaturation
            shadowsDensity
            shadowsExposure
            shadowsHue
            shadowsSaturation
        }
        depthOfField {
            enabled
            blurLevel
            focusDistance
            focalLength
            fStop
            lensSize
        }
        grain {
            enabled
            animated
            intensity
        }
        misc {
            contrast
            exposure
            toneMappingEnabled
            toneMappingType
        }
        sharpen {
            enabled
            colorAmount
            edgeAmount
        }
        vignette {
            enabled
            blendMode
            cameraFov
            center {
                x
                y
            }
            colorRgba {
                r
                g
                b
                a
            }
            colorHex
            stretch
            weight
        }
    }
`, LB = Ee`
    fragment ModelAnimationFields on ModelAnimation {
        from
        to
        loop
        name
    }
`, UB = (r) => Ee`
        ${sc(r, !1)}
        ${mB}
        ${MB}
        ${_B}
        ${NB}
        ${LB}
        query GetWorkflows($ids: [String!]!) {
            workflows(ids: $ids) {
                partner {
                    termsMarkdown
                }
                allowProofDownload
                defaultPreviewPanelIndex
                finalizeStepConfig {
                    termsMarkdown
                    lookAtAnimation {
                        ...LookAtAnimationFields
                    }
                    modelAnimation {
                        ...ModelAnimationFields
                    }
                }
                globalPreviewConfig {
                    autoRotation
                    backgroundColor
                    backgroundImage
                    clearColor
                    disableActionBar
                    disableAutomaticOrientation
                    emissiveGlowIntensity
                    enableAR
                    environmentFile
                    environmentIntensity
                    environmentRotationY
                    idleTimeBeforeRotation
                    lowerAlphaLimitDeg
                    lowerBetaLimitDeg
                    maxZoomOverride
                    minZoomOverride
                    noPan
                    upperAlphaLimitDeg
                    upperBetaLimitDeg
                    renderingPipelineConfiguration {
                        ...RenderingPipelineConfigurationFields
                    }
                }
                id
                name
                panels {
                    editableArea {
                        height
                        width
                        x
                        y
                    }
                    height
                    width
                    index
                    name
                    title
                    useEditableArea
                    transparentBackground
                    previewRegion {
                        ...RegionFields
                    }
                }
                previewAsset {
                    ...AssetFields
                }
                showModelOnFinishStep
                showPlusInVariantPrices
                showPricing
                skuCode
                stepGroups {
                    name
                    stepNames
                }
                steps {
                    stepName
                    type
                    tags
                    globalPropertyAspectConfigurations {
                        aspectName
                        globalPropertyConfigurationId
                    }
                    conversionConfigurationFieldLinks {
                        identifier
                        conversionConfigurationId
                    }
                    overrideDefaultVariantId
                    option {
                        ...OptionMinimalFields
                    }
                    stepTitle
                    helpText
                    mandatory
                    relevantPanelName
                    silent
                    conditions {
                        requiredVariantMetafields {
                            variantMetafieldConfigurationId
                            variantMetafieldValue
                        }
                        requiredVariantSelections
                        targetStepName
                        action
                        type
                    }
                    data {
                        __typename
                        ... on InformationStepData {
                            content
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                        }
                        ... on DigitalContentStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            baseUrl
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            regions {
                                ...RegionFields
                            }
                        }
                        ... on FrameStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            colorOption {
                                ...OptionMinimalFields
                            }
                            colorPickerEnabled
                            initialZoomLevel
                            disablePlaceholder
                            displayImageOnFinishStep
                            displaySelectionOnFinishStep
                            enableVariantCategories
                            forceImageCover
                            hideImageInCart
                            hideSelectionInCart
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            shouldVectorize
                            vectorizeMaxColors
                            vectorizationMinimumPixelThreshold
                            maxColors
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            overlayImageKey
                            overlayImageUrl
                            placeholderImageKey
                            placeholderImageUrl
                            regions {
                                ...RegionFields
                            }
                            whitelistedExtensions
                        }
                        ... on IllustrationStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            colorOption {
                                ...OptionMinimalFields
                            }
                            colorPickerEnabled
                            pmsPickerEnabled
                            displayColorsOnFinishStep
                            displaySelectionOnFinishStep
                            enableVariantCategories
                            enableVariantSearch
                            hideColorsInCart
                            hideSelectionInCart
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            regions {
                                ...RegionFields
                            }
                        }
                        ... on MaterialStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            displaySelectionOnFinishStep
                            enableVariantCategories
                            hideSelectionInCart
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            targetMaterials
                        }
                        ... on ModelStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            displaySelectionOnFinishStep
                            enableVariantCategories
                            hideSelectionInCart
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            replaceProductModel
                        }
                        ... on ModuleStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            displayTextOnFinishStep
                            hideTextInCart
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            maxLength
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            module
                            regions {
                                ...RegionFields
                            }
                        }
                        ... on PictureStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            displaySelectionOnFinishStep
                            enableVariantCategories
                            enableVariantSearch
                            hideSelectionInCart
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            regions {
                                ...RegionFields
                            }
                        }
                        ... on ProductOverlayStepData {
                            regions {
                                ...RegionFields
                            }
                            overlayType
                        }
                        ... on ProductStepData {
                            baseContents
                            categoryFilterEnabled
                            lockedAddOns {
                                lockedQty
                                variantId
                            }
                            max
                            min
                            pricing
                            searchBarEnabled
                            workflows
                        }
                        ... on QuestionStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            allowMultipleSelections
                            displaySelectionsOnFinishStep
                            displayType
                            hideSelectionsInCart
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                        }
                        ... on ShapeStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            displaySelectionOnFinishStep
                            enableVariantCategories
                            excludeFromPrint
                            hideSelectionInCart
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            regions {
                                ...RegionFields
                            }
                        }
                        ... on SilentIllustrationStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            asset {
                                ...AssetFields
                            }
                            excludeFromPrint
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            regions {
                                ...RegionFields
                            }
                        }
                        ... on TextStepData {
                            advancedEditorAnimation {
                                x
                                y
                                zoom
                                layoutName
                            }
                            allowNewlines
                            colorOption {
                                ...OptionMinimalFields
                            }
                            colorPickerEnabled
                            curved
                            defaultText
                            deleteDefaultOnFocus
                            displayColorOnFinishStep
                            displayImageFillOnFinishStep
                            displayStrokeOnFinishStep
                            displayTextOnFinishStep
                            enableVariantCategories
                            hideColorInCart
                            hideImageFillInCart
                            hideSelectionInCart
                            hideStrokeInCart
                            hideTextInCart
                            imageFillOption {
                                ...OptionMinimalFields
                            }
                            imageFillScale
                            lookAtAnimation {
                                ...LookAtAnimationFields
                            }
                            maxLength
                            maxSize
                            minSize
                            modelAnimation {
                                ...ModelAnimationFields
                            }
                            paths
                            regions {
                                ...RegionFields
                            }
                            replaceableText
                            size
                            strokeEnabled
                            strokeOption {
                                ...OptionMinimalFields
                            }
                            strokeThickness
                            textAlign
                            uppercase
                            userCanReplaceText
                            vertical
                            verticalAlign
                        }
                    }
                }
            }
        }
    `, Fd = Ee`
    ${Td}
    fragment MarketplaceThemeInstallConfigurationFields on MarketplaceThemeInstallConfiguration {
        id
        themeInstallId
        fields {
            type
            key
            value
            asset {
                key
                name
                fileLink
                type
            }
            conversionConfiguration {
                ...ConversionConfigurationFields
            }
            listValues
            objectValues
            schema
            root
        }
        themeVersion {
            id
            version
            status
            createdAt
            updatedAt
            launchData {
                targetFiles {
                    filename
                    type
                    mimeType
                    fileLink
                    preload
                }
            }
            configurationSchema {
                customSchemas {
                    name
                    type
                    title
                    fields
                    extends
                    schemas
                }
                fields {
                    key
                    type
                    title
                    required
                    defaultValue
                    options {
                        key
                        value
                    }
                    assetType
                    multiLine
                    limit
                    items
                    fields
                    schema
                    root
                }
            }
        }
    }
`, VB = Ee`
    ${Fd}
    query GetMarketplaceThemeInstallConfiguration($themeConfigurationId: String!, $themeInstallId: String!) {
        marketplaceThemeInstallConfiguration(id: $themeConfigurationId, themeInstallId: $themeInstallId, raw: false) {
            ...MarketplaceThemeInstallConfigurationFields
        }
    }
`, zB = Ee`
    ${Vk}
    ${Fd}
    query GetCurrentIntegration($themeConfigurationId: String) {
        currentIntegration {
            id
            type
            marketplaceThemeInstallConfiguration(id: $themeConfigurationId, raw: false) {
                ...MarketplaceThemeInstallConfigurationFields
            }
            ...ActiveIntegrationFields
        }
    }
`, $B = Ee`
    ${Fd}
    query ReadTransactionForMarketplaceTheme($id: String!) {
        transactions(ids: [$id]) {
            marketplaceThemeInstallConfiguration(raw: false) {
                ...MarketplaceThemeInstallConfigurationFields
            }
        }
    }
`, HB = Ee`
    ${Fd}
    query ReadBundleForMarketplaceTheme($id: String!) {
        bundles(ids: [$id]) {
            marketplaceThemeInstallConfiguration(raw: false) {
                ...MarketplaceThemeInstallConfigurationFields
            }
        }
    }
`, jB = Ee`
    mutation CreateOrder($orderItems: [OrderItemInput]!) {
        orderCreate(orderItems: $orderItems, paid: false, generateInternalId: true) {
            id
            internalId
        }
    }
`, GB = Ee`
    query CurrencyConversion($from: String!, $to: String!) {
        currencyConversion(from: $from, to: $to) {
            rateFrom
            rateTo
            timestamp
        }
    }
`, cQ = Ee`
    query AssetConfigurations {
        assetConfigurations {
            id
            assetKey
            colorOption {
                id
                name
            }
            channelNumbers {
                id
                number
            }
            defaultColorVariants {
                channelNumber
                variant {
                    id
                    name
                }
            }
            template
            customerId
        }
    }
`, fQ = Ee`
    mutation AssetConfigurationUpdate(
        $assetKey: String!
        $colorOptionId: String
        $channelNumbers: [AssetConfigurationChannelNumberInput]
        $defaultColorVariants: [AssetConfigurationDefaultColorVariantInput]
        $template: Boolean
        $customerId: String
    ) {
        assetConfigurationUpdate(
            assetKey: $assetKey
            colorOptionId: $colorOptionId
            channelNumbers: $channelNumbers
            defaultColorVariants: $defaultColorVariants
            template: $template
            customerId: $customerId
        ) {
            assetKey
            colorOption {
                id
                name
            }
            channelNumbers {
                id
                number
            }
            defaultColorVariants {
                channelNumber
                variant {
                    id
                    name
                }
            }
            template
            customerId
        }
    }
`, dQ = Ee`
    mutation AssetConfigurationDelete($id: String!) {
        assetConfigurationDelete(id: $id)
    }
`, hQ = Ee`
    query GetAssetsForProductImages($keys: [String!]!) {
        assets(keys: $keys) {
            key
            fileLink
            versions {
                name
                link
            }
        }
    }
`, qB = Ee`
    ${Fd}
    query GetActivation($id: String!) {
        activation(id: $id) {
            id
            name
            marketplaceThemeInstallConfiguration {
                ...MarketplaceThemeInstallConfigurationFields
            }
            activationProductCollections {
                id
                productCollection {
                    id
                }
            }
        }
    }
`;
var sf = { exports: {} }, ll = { exports: {} }, WB = ll.exports, ax;
function QB() {
  return ax || (ax = 1, (function() {
    var r, e, t, n, i, a;
    typeof performance < "u" && performance !== null && performance.now ? ll.exports = function() {
      return performance.now();
    } : typeof process < "u" && process !== null && process.hrtime ? (ll.exports = function() {
      return (r() - i) / 1e6;
    }, e = process.hrtime, r = function() {
      var s;
      return s = e(), s[0] * 1e9 + s[1];
    }, n = r(), a = process.uptime() * 1e9, i = n - a) : Date.now ? (ll.exports = function() {
      return Date.now() - t;
    }, t = Date.now()) : (ll.exports = function() {
      return (/* @__PURE__ */ new Date()).getTime() - t;
    }, t = (/* @__PURE__ */ new Date()).getTime());
  }).call(WB)), ll.exports;
}
var sx;
function YB() {
  if (sx) return sf.exports;
  sx = 1;
  for (var r = QB(), e = typeof window > "u" ? ui : window, t = ["moz", "webkit"], n = "AnimationFrame", i = e["request" + n], a = e["cancel" + n] || e["cancelRequest" + n], s = 0; !i && s < t.length; s++)
    i = e[t[s] + "Request" + n], a = e[t[s] + "Cancel" + n] || e[t[s] + "CancelRequest" + n];
  if (!i || !a) {
    var o = 0, l = 0, u = [], c = 1e3 / 60;
    i = function(d) {
      if (u.length === 0) {
        var f = r(), h = Math.max(0, c - (f - o));
        o = h + f, setTimeout(function() {
          var g = u.slice(0);
          u.length = 0;
          for (var v = 0; v < g.length; v++)
            if (!g[v].cancelled)
              try {
                g[v].callback(o);
              } catch (y) {
                setTimeout(function() {
                  throw y;
                }, 0);
              }
        }, Math.round(h));
      }
      return u.push({
        handle: ++l,
        callback: d,
        cancelled: !1
      }), l;
    }, a = function(d) {
      for (var f = 0; f < u.length; f++)
        u[f].handle === d && (u[f].cancelled = !0);
    };
  }
  return sf.exports = function(d) {
    return i.call(e, d);
  }, sf.exports.cancel = function() {
    a.apply(e, arguments);
  }, sf.exports.polyfill = function(d) {
    d || (d = e), d.requestAnimationFrame = i, d.cancelAnimationFrame = a;
  }, sf.exports;
}
var XB = YB();
const o0 = /* @__PURE__ */ Bs(XB);
var l0, ox;
function JB() {
  return ox || (ox = 1, l0 = function(r) {
    this.ok = !1, this.alpha = 1, r.charAt(0) == "#" && (r = r.substr(1, 6)), r = r.replace(/ /g, ""), r = r.toLowerCase();
    var e = {
      aliceblue: "f0f8ff",
      antiquewhite: "faebd7",
      aqua: "00ffff",
      aquamarine: "7fffd4",
      azure: "f0ffff",
      beige: "f5f5dc",
      bisque: "ffe4c4",
      black: "000000",
      blanchedalmond: "ffebcd",
      blue: "0000ff",
      blueviolet: "8a2be2",
      brown: "a52a2a",
      burlywood: "deb887",
      cadetblue: "5f9ea0",
      chartreuse: "7fff00",
      chocolate: "d2691e",
      coral: "ff7f50",
      cornflowerblue: "6495ed",
      cornsilk: "fff8dc",
      crimson: "dc143c",
      cyan: "00ffff",
      darkblue: "00008b",
      darkcyan: "008b8b",
      darkgoldenrod: "b8860b",
      darkgray: "a9a9a9",
      darkgreen: "006400",
      darkkhaki: "bdb76b",
      darkmagenta: "8b008b",
      darkolivegreen: "556b2f",
      darkorange: "ff8c00",
      darkorchid: "9932cc",
      darkred: "8b0000",
      darksalmon: "e9967a",
      darkseagreen: "8fbc8f",
      darkslateblue: "483d8b",
      darkslategray: "2f4f4f",
      darkturquoise: "00ced1",
      darkviolet: "9400d3",
      deeppink: "ff1493",
      deepskyblue: "00bfff",
      dimgray: "696969",
      dodgerblue: "1e90ff",
      feldspar: "d19275",
      firebrick: "b22222",
      floralwhite: "fffaf0",
      forestgreen: "228b22",
      fuchsia: "ff00ff",
      gainsboro: "dcdcdc",
      ghostwhite: "f8f8ff",
      gold: "ffd700",
      goldenrod: "daa520",
      gray: "808080",
      green: "008000",
      greenyellow: "adff2f",
      honeydew: "f0fff0",
      hotpink: "ff69b4",
      indianred: "cd5c5c",
      indigo: "4b0082",
      ivory: "fffff0",
      khaki: "f0e68c",
      lavender: "e6e6fa",
      lavenderblush: "fff0f5",
      lawngreen: "7cfc00",
      lemonchiffon: "fffacd",
      lightblue: "add8e6",
      lightcoral: "f08080",
      lightcyan: "e0ffff",
      lightgoldenrodyellow: "fafad2",
      lightgrey: "d3d3d3",
      lightgreen: "90ee90",
      lightpink: "ffb6c1",
      lightsalmon: "ffa07a",
      lightseagreen: "20b2aa",
      lightskyblue: "87cefa",
      lightslateblue: "8470ff",
      lightslategray: "778899",
      lightsteelblue: "b0c4de",
      lightyellow: "ffffe0",
      lime: "00ff00",
      limegreen: "32cd32",
      linen: "faf0e6",
      magenta: "ff00ff",
      maroon: "800000",
      mediumaquamarine: "66cdaa",
      mediumblue: "0000cd",
      mediumorchid: "ba55d3",
      mediumpurple: "9370d8",
      mediumseagreen: "3cb371",
      mediumslateblue: "7b68ee",
      mediumspringgreen: "00fa9a",
      mediumturquoise: "48d1cc",
      mediumvioletred: "c71585",
      midnightblue: "191970",
      mintcream: "f5fffa",
      mistyrose: "ffe4e1",
      moccasin: "ffe4b5",
      navajowhite: "ffdead",
      navy: "000080",
      oldlace: "fdf5e6",
      olive: "808000",
      olivedrab: "6b8e23",
      orange: "ffa500",
      orangered: "ff4500",
      orchid: "da70d6",
      palegoldenrod: "eee8aa",
      palegreen: "98fb98",
      paleturquoise: "afeeee",
      palevioletred: "d87093",
      papayawhip: "ffefd5",
      peachpuff: "ffdab9",
      peru: "cd853f",
      pink: "ffc0cb",
      plum: "dda0dd",
      powderblue: "b0e0e6",
      purple: "800080",
      rebeccapurple: "663399",
      red: "ff0000",
      rosybrown: "bc8f8f",
      royalblue: "4169e1",
      saddlebrown: "8b4513",
      salmon: "fa8072",
      sandybrown: "f4a460",
      seagreen: "2e8b57",
      seashell: "fff5ee",
      sienna: "a0522d",
      silver: "c0c0c0",
      skyblue: "87ceeb",
      slateblue: "6a5acd",
      slategray: "708090",
      snow: "fffafa",
      springgreen: "00ff7f",
      steelblue: "4682b4",
      tan: "d2b48c",
      teal: "008080",
      thistle: "d8bfd8",
      tomato: "ff6347",
      turquoise: "40e0d0",
      violet: "ee82ee",
      violetred: "d02090",
      wheat: "f5deb3",
      white: "ffffff",
      whitesmoke: "f5f5f5",
      yellow: "ffff00",
      yellowgreen: "9acd32"
    };
    r = e[r] || r;
    for (var t = [
      {
        re: /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*((?:\d?\.)?\d)\)$/,
        example: ["rgba(123, 234, 45, 0.8)", "rgba(255,234,245,1.0)"],
        process: function(l) {
          return [
            parseInt(l[1]),
            parseInt(l[2]),
            parseInt(l[3]),
            parseFloat(l[4])
          ];
        }
      },
      {
        re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
        example: ["rgb(123, 234, 45)", "rgb(255,234,245)"],
        process: function(l) {
          return [
            parseInt(l[1]),
            parseInt(l[2]),
            parseInt(l[3])
          ];
        }
      },
      {
        re: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        example: ["#00ff00", "336699"],
        process: function(l) {
          return [
            parseInt(l[1], 16),
            parseInt(l[2], 16),
            parseInt(l[3], 16)
          ];
        }
      },
      {
        re: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        example: ["#fb0", "f0f"],
        process: function(l) {
          return [
            parseInt(l[1] + l[1], 16),
            parseInt(l[2] + l[2], 16),
            parseInt(l[3] + l[3], 16)
          ];
        }
      }
    ], n = 0; n < t.length; n++) {
      var i = t[n].re, a = t[n].process, s = i.exec(r);
      if (s) {
        var o = a(s);
        this.r = o[0], this.g = o[1], this.b = o[2], o.length > 3 && (this.alpha = o[3]), this.ok = !0;
      }
    }
    this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.alpha = this.alpha < 0 ? 0 : this.alpha > 1 || isNaN(this.alpha) ? 1 : this.alpha, this.toRGB = function() {
      return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
    }, this.toRGBA = function() {
      return "rgba(" + this.r + ", " + this.g + ", " + this.b + ", " + this.alpha + ")";
    }, this.toHex = function() {
      var l = this.r.toString(16), u = this.g.toString(16), c = this.b.toString(16);
      return l.length == 1 && (l = "0" + l), u.length == 1 && (u = "0" + u), c.length == 1 && (c = "0" + c), "#" + l + u + c;
    }, this.getHelpXML = function() {
      for (var l = new Array(), u = 0; u < t.length; u++)
        for (var c = t[u].example, d = 0; d < c.length; d++)
          l[l.length] = c[d];
      for (var f in e)
        l[l.length] = f;
      var h = document.createElement("ul");
      h.setAttribute("id", "rgbcolor-examples");
      for (var u = 0; u < l.length; u++)
        try {
          var g = document.createElement("li"), v = new RGBColor(l[u]), y = document.createElement("div");
          y.style.cssText = "margin: 3px; border: 1px solid black; background:" + v.toHex() + "; color:" + v.toHex(), y.appendChild(document.createTextNode("test"));
          var A = document.createTextNode(
            " " + l[u] + " -> " + v.toRGB() + " -> " + v.toHex()
          );
          g.appendChild(y), g.appendChild(A), h.appendChild(g);
        } catch {
        }
      return h;
    };
  }), l0;
}
var KB = JB();
const Iy = /* @__PURE__ */ Bs(KB);
var qk = function(r, e) {
  return (qk = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, n) {
    t.__proto__ = n;
  } || function(t, n) {
    for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
  })(r, e);
};
function Wk(r, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  function t() {
    this.constructor = r;
  }
  qk(r, e), r.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
}
function ZB(r) {
  var e = "";
  Array.isArray(r) || (r = [r]);
  for (var t = 0; t < r.length; t++) {
    var n = r[t];
    if (n.type === Le.CLOSE_PATH) e += "z";
    else if (n.type === Le.HORIZ_LINE_TO) e += (n.relative ? "h" : "H") + n.x;
    else if (n.type === Le.VERT_LINE_TO) e += (n.relative ? "v" : "V") + n.y;
    else if (n.type === Le.MOVE_TO) e += (n.relative ? "m" : "M") + n.x + " " + n.y;
    else if (n.type === Le.LINE_TO) e += (n.relative ? "l" : "L") + n.x + " " + n.y;
    else if (n.type === Le.CURVE_TO) e += (n.relative ? "c" : "C") + n.x1 + " " + n.y1 + " " + n.x2 + " " + n.y2 + " " + n.x + " " + n.y;
    else if (n.type === Le.SMOOTH_CURVE_TO) e += (n.relative ? "s" : "S") + n.x2 + " " + n.y2 + " " + n.x + " " + n.y;
    else if (n.type === Le.QUAD_TO) e += (n.relative ? "q" : "Q") + n.x1 + " " + n.y1 + " " + n.x + " " + n.y;
    else if (n.type === Le.SMOOTH_QUAD_TO) e += (n.relative ? "t" : "T") + n.x + " " + n.y;
    else {
      if (n.type !== Le.ARC) throw new Error('Unexpected command type "' + n.type + '" at index ' + t + ".");
      e += (n.relative ? "a" : "A") + n.rX + " " + n.rY + " " + n.xRot + " " + +n.lArcFlag + " " + +n.sweepFlag + " " + n.x + " " + n.y;
    }
  }
  return e;
}
function Dy(r, e) {
  var t = r[0], n = r[1];
  return [t * Math.cos(e) - n * Math.sin(e), t * Math.sin(e) + n * Math.cos(e)];
}
function ka() {
  for (var r = [], e = 0; e < arguments.length; e++) r[e] = arguments[e];
  for (var t = 0; t < r.length; t++) if (typeof r[t] != "number") throw new Error("assertNumbers arguments[" + t + "] is not a number. " + typeof r[t] + " == typeof " + r[t]);
  return !0;
}
var no = Math.PI;
function u0(r, e, t) {
  r.lArcFlag = r.lArcFlag === 0 ? 0 : 1, r.sweepFlag = r.sweepFlag === 0 ? 0 : 1;
  var n = r.rX, i = r.rY, a = r.x, s = r.y;
  n = Math.abs(r.rX), i = Math.abs(r.rY);
  var o = Dy([(e - a) / 2, (t - s) / 2], -r.xRot / 180 * no), l = o[0], u = o[1], c = Math.pow(l, 2) / Math.pow(n, 2) + Math.pow(u, 2) / Math.pow(i, 2);
  1 < c && (n *= Math.sqrt(c), i *= Math.sqrt(c)), r.rX = n, r.rY = i;
  var d = Math.pow(n, 2) * Math.pow(u, 2) + Math.pow(i, 2) * Math.pow(l, 2), f = (r.lArcFlag !== r.sweepFlag ? 1 : -1) * Math.sqrt(Math.max(0, (Math.pow(n, 2) * Math.pow(i, 2) - d) / d)), h = n * u / i * f, g = -i * l / n * f, v = Dy([h, g], r.xRot / 180 * no);
  r.cX = v[0] + (e + a) / 2, r.cY = v[1] + (t + s) / 2, r.phi1 = Math.atan2((u - g) / i, (l - h) / n), r.phi2 = Math.atan2((-u - g) / i, (-l - h) / n), r.sweepFlag === 0 && r.phi2 > r.phi1 && (r.phi2 -= 2 * no), r.sweepFlag === 1 && r.phi2 < r.phi1 && (r.phi2 += 2 * no), r.phi1 *= 180 / no, r.phi2 *= 180 / no;
}
function lx(r, e, t) {
  ka(r, e, t);
  var n = r * r + e * e - t * t;
  if (0 > n) return [];
  if (n === 0) return [[r * t / (r * r + e * e), e * t / (r * r + e * e)]];
  var i = Math.sqrt(n);
  return [[(r * t + e * i) / (r * r + e * e), (e * t - r * i) / (r * r + e * e)], [(r * t - e * i) / (r * r + e * e), (e * t + r * i) / (r * r + e * e)]];
}
var ti, Cs = Math.PI / 180;
function ux(r, e, t) {
  return (1 - t) * r + t * e;
}
function cx(r, e, t, n) {
  return r + Math.cos(n / 180 * no) * e + Math.sin(n / 180 * no) * t;
}
function fx(r, e, t, n) {
  var i = 1e-6, a = e - r, s = t - e, o = 3 * a + 3 * (n - t) - 6 * s, l = 6 * (s - a), u = 3 * a;
  return Math.abs(o) < i ? [-u / l] : (function(c, d, f) {
    var h = c * c / 4 - d;
    if (h < -f) return [];
    if (h <= f) return [-c / 2];
    var g = Math.sqrt(h);
    return [-c / 2 - g, -c / 2 + g];
  })(l / o, u / o, i);
}
function dx(r, e, t, n, i) {
  var a = 1 - i;
  return r * (a * a * a) + e * (3 * a * a * i) + t * (3 * a * i * i) + n * (i * i * i);
}
(function(r) {
  function e() {
    return i((function(o, l, u) {
      return o.relative && (o.x1 !== void 0 && (o.x1 += l), o.y1 !== void 0 && (o.y1 += u), o.x2 !== void 0 && (o.x2 += l), o.y2 !== void 0 && (o.y2 += u), o.x !== void 0 && (o.x += l), o.y !== void 0 && (o.y += u), o.relative = !1), o;
    }));
  }
  function t() {
    var o = NaN, l = NaN, u = NaN, c = NaN;
    return i((function(d, f, h) {
      return d.type & Le.SMOOTH_CURVE_TO && (d.type = Le.CURVE_TO, o = isNaN(o) ? f : o, l = isNaN(l) ? h : l, d.x1 = d.relative ? f - o : 2 * f - o, d.y1 = d.relative ? h - l : 2 * h - l), d.type & Le.CURVE_TO ? (o = d.relative ? f + d.x2 : d.x2, l = d.relative ? h + d.y2 : d.y2) : (o = NaN, l = NaN), d.type & Le.SMOOTH_QUAD_TO && (d.type = Le.QUAD_TO, u = isNaN(u) ? f : u, c = isNaN(c) ? h : c, d.x1 = d.relative ? f - u : 2 * f - u, d.y1 = d.relative ? h - c : 2 * h - c), d.type & Le.QUAD_TO ? (u = d.relative ? f + d.x1 : d.x1, c = d.relative ? h + d.y1 : d.y1) : (u = NaN, c = NaN), d;
    }));
  }
  function n() {
    var o = NaN, l = NaN;
    return i((function(u, c, d) {
      if (u.type & Le.SMOOTH_QUAD_TO && (u.type = Le.QUAD_TO, o = isNaN(o) ? c : o, l = isNaN(l) ? d : l, u.x1 = u.relative ? c - o : 2 * c - o, u.y1 = u.relative ? d - l : 2 * d - l), u.type & Le.QUAD_TO) {
        o = u.relative ? c + u.x1 : u.x1, l = u.relative ? d + u.y1 : u.y1;
        var f = u.x1, h = u.y1;
        u.type = Le.CURVE_TO, u.x1 = ((u.relative ? 0 : c) + 2 * f) / 3, u.y1 = ((u.relative ? 0 : d) + 2 * h) / 3, u.x2 = (u.x + 2 * f) / 3, u.y2 = (u.y + 2 * h) / 3;
      } else o = NaN, l = NaN;
      return u;
    }));
  }
  function i(o) {
    var l = 0, u = 0, c = NaN, d = NaN;
    return function(f) {
      if (isNaN(c) && !(f.type & Le.MOVE_TO)) throw new Error("path must start with moveto");
      var h = o(f, l, u, c, d);
      return f.type & Le.CLOSE_PATH && (l = c, u = d), f.x !== void 0 && (l = f.relative ? l + f.x : f.x), f.y !== void 0 && (u = f.relative ? u + f.y : f.y), f.type & Le.MOVE_TO && (c = l, d = u), h;
    };
  }
  function a(o, l, u, c, d, f) {
    return ka(o, l, u, c, d, f), i((function(h, g, v, y) {
      var A = h.x1, x = h.x2, k = h.relative && !isNaN(y), F = h.x !== void 0 ? h.x : k ? 0 : g, S = h.y !== void 0 ? h.y : k ? 0 : v;
      function R(re) {
        return re * re;
      }
      h.type & Le.HORIZ_LINE_TO && l !== 0 && (h.type = Le.LINE_TO, h.y = h.relative ? 0 : v), h.type & Le.VERT_LINE_TO && u !== 0 && (h.type = Le.LINE_TO, h.x = h.relative ? 0 : g), h.x !== void 0 && (h.x = h.x * o + S * u + (k ? 0 : d)), h.y !== void 0 && (h.y = F * l + h.y * c + (k ? 0 : f)), h.x1 !== void 0 && (h.x1 = h.x1 * o + h.y1 * u + (k ? 0 : d)), h.y1 !== void 0 && (h.y1 = A * l + h.y1 * c + (k ? 0 : f)), h.x2 !== void 0 && (h.x2 = h.x2 * o + h.y2 * u + (k ? 0 : d)), h.y2 !== void 0 && (h.y2 = x * l + h.y2 * c + (k ? 0 : f));
      var M = o * c - l * u;
      if (h.xRot !== void 0 && (o !== 1 || l !== 0 || u !== 0 || c !== 1)) if (M === 0) delete h.rX, delete h.rY, delete h.xRot, delete h.lArcFlag, delete h.sweepFlag, h.type = Le.LINE_TO;
      else {
        var j = h.xRot * Math.PI / 180, G = Math.sin(j), ie = Math.cos(j), q = 1 / R(h.rX), Y = 1 / R(h.rY), J = R(ie) * q + R(G) * Y, se = 2 * G * ie * (q - Y), oe = R(G) * q + R(ie) * Y, he = J * c * c - se * l * c + oe * l * l, ye = se * (o * c + l * u) - 2 * (J * u * c + oe * o * l), Ue = J * u * u - se * o * u + oe * o * o, Re = (Math.atan2(ye, he - Ue) + Math.PI) % Math.PI / 2, Oe = Math.sin(Re), ee = Math.cos(Re);
        h.rX = Math.abs(M) / Math.sqrt(he * R(ee) + ye * Oe * ee + Ue * R(Oe)), h.rY = Math.abs(M) / Math.sqrt(he * R(Oe) - ye * Oe * ee + Ue * R(ee)), h.xRot = 180 * Re / Math.PI;
      }
      return h.sweepFlag !== void 0 && 0 > M && (h.sweepFlag = +!h.sweepFlag), h;
    }));
  }
  function s() {
    return function(o) {
      var l = {};
      for (var u in o) l[u] = o[u];
      return l;
    };
  }
  r.ROUND = function(o) {
    function l(u) {
      return Math.round(u * o) / o;
    }
    return o === void 0 && (o = 1e13), ka(o), function(u) {
      return u.x1 !== void 0 && (u.x1 = l(u.x1)), u.y1 !== void 0 && (u.y1 = l(u.y1)), u.x2 !== void 0 && (u.x2 = l(u.x2)), u.y2 !== void 0 && (u.y2 = l(u.y2)), u.x !== void 0 && (u.x = l(u.x)), u.y !== void 0 && (u.y = l(u.y)), u.rX !== void 0 && (u.rX = l(u.rX)), u.rY !== void 0 && (u.rY = l(u.rY)), u;
    };
  }, r.TO_ABS = e, r.TO_REL = function() {
    return i((function(o, l, u) {
      return o.relative || (o.x1 !== void 0 && (o.x1 -= l), o.y1 !== void 0 && (o.y1 -= u), o.x2 !== void 0 && (o.x2 -= l), o.y2 !== void 0 && (o.y2 -= u), o.x !== void 0 && (o.x -= l), o.y !== void 0 && (o.y -= u), o.relative = !0), o;
    }));
  }, r.NORMALIZE_HVZ = function(o, l, u) {
    return o === void 0 && (o = !0), l === void 0 && (l = !0), u === void 0 && (u = !0), i((function(c, d, f, h, g) {
      if (isNaN(h) && !(c.type & Le.MOVE_TO)) throw new Error("path must start with moveto");
      return l && c.type & Le.HORIZ_LINE_TO && (c.type = Le.LINE_TO, c.y = c.relative ? 0 : f), u && c.type & Le.VERT_LINE_TO && (c.type = Le.LINE_TO, c.x = c.relative ? 0 : d), o && c.type & Le.CLOSE_PATH && (c.type = Le.LINE_TO, c.x = c.relative ? h - d : h, c.y = c.relative ? g - f : g), c.type & Le.ARC && (c.rX === 0 || c.rY === 0) && (c.type = Le.LINE_TO, delete c.rX, delete c.rY, delete c.xRot, delete c.lArcFlag, delete c.sweepFlag), c;
    }));
  }, r.NORMALIZE_ST = t, r.QT_TO_C = n, r.INFO = i, r.SANITIZE = function(o) {
    o === void 0 && (o = 0), ka(o);
    var l = NaN, u = NaN, c = NaN, d = NaN;
    return i((function(f, h, g, v, y) {
      var A = Math.abs, x = !1, k = 0, F = 0;
      if (f.type & Le.SMOOTH_CURVE_TO && (k = isNaN(l) ? 0 : h - l, F = isNaN(u) ? 0 : g - u), f.type & (Le.CURVE_TO | Le.SMOOTH_CURVE_TO) ? (l = f.relative ? h + f.x2 : f.x2, u = f.relative ? g + f.y2 : f.y2) : (l = NaN, u = NaN), f.type & Le.SMOOTH_QUAD_TO ? (c = isNaN(c) ? h : 2 * h - c, d = isNaN(d) ? g : 2 * g - d) : f.type & Le.QUAD_TO ? (c = f.relative ? h + f.x1 : f.x1, d = f.relative ? g + f.y1 : f.y2) : (c = NaN, d = NaN), f.type & Le.LINE_COMMANDS || f.type & Le.ARC && (f.rX === 0 || f.rY === 0 || !f.lArcFlag) || f.type & Le.CURVE_TO || f.type & Le.SMOOTH_CURVE_TO || f.type & Le.QUAD_TO || f.type & Le.SMOOTH_QUAD_TO) {
        var S = f.x === void 0 ? 0 : f.relative ? f.x : f.x - h, R = f.y === void 0 ? 0 : f.relative ? f.y : f.y - g;
        k = isNaN(c) ? f.x1 === void 0 ? k : f.relative ? f.x : f.x1 - h : c - h, F = isNaN(d) ? f.y1 === void 0 ? F : f.relative ? f.y : f.y1 - g : d - g;
        var M = f.x2 === void 0 ? 0 : f.relative ? f.x : f.x2 - h, j = f.y2 === void 0 ? 0 : f.relative ? f.y : f.y2 - g;
        A(S) <= o && A(R) <= o && A(k) <= o && A(F) <= o && A(M) <= o && A(j) <= o && (x = !0);
      }
      return f.type & Le.CLOSE_PATH && A(h - v) <= o && A(g - y) <= o && (x = !0), x ? [] : f;
    }));
  }, r.MATRIX = a, r.ROTATE = function(o, l, u) {
    l === void 0 && (l = 0), u === void 0 && (u = 0), ka(o, l, u);
    var c = Math.sin(o), d = Math.cos(o);
    return a(d, c, -c, d, l - l * d + u * c, u - l * c - u * d);
  }, r.TRANSLATE = function(o, l) {
    return l === void 0 && (l = 0), ka(o, l), a(1, 0, 0, 1, o, l);
  }, r.SCALE = function(o, l) {
    return l === void 0 && (l = o), ka(o, l), a(o, 0, 0, l, 0, 0);
  }, r.SKEW_X = function(o) {
    return ka(o), a(1, 0, Math.atan(o), 1, 0, 0);
  }, r.SKEW_Y = function(o) {
    return ka(o), a(1, Math.atan(o), 0, 1, 0, 0);
  }, r.X_AXIS_SYMMETRY = function(o) {
    return o === void 0 && (o = 0), ka(o), a(-1, 0, 0, 1, o, 0);
  }, r.Y_AXIS_SYMMETRY = function(o) {
    return o === void 0 && (o = 0), ka(o), a(1, 0, 0, -1, 0, o);
  }, r.A_TO_C = function() {
    return i((function(o, l, u) {
      return Le.ARC === o.type ? (function(c, d, f) {
        var h, g, v, y;
        c.cX || u0(c, d, f);
        for (var A = Math.min(c.phi1, c.phi2), x = Math.max(c.phi1, c.phi2) - A, k = Math.ceil(x / 90), F = new Array(k), S = d, R = f, M = 0; M < k; M++) {
          var j = ux(c.phi1, c.phi2, M / k), G = ux(c.phi1, c.phi2, (M + 1) / k), ie = G - j, q = 4 / 3 * Math.tan(ie * Cs / 4), Y = [Math.cos(j * Cs) - q * Math.sin(j * Cs), Math.sin(j * Cs) + q * Math.cos(j * Cs)], J = Y[0], se = Y[1], oe = [Math.cos(G * Cs), Math.sin(G * Cs)], he = oe[0], ye = oe[1], Ue = [he + q * Math.sin(G * Cs), ye - q * Math.cos(G * Cs)], Re = Ue[0], Oe = Ue[1];
          F[M] = { relative: c.relative, type: Le.CURVE_TO };
          var ee = function(re, de) {
            var Be = Dy([re * c.rX, de * c.rY], c.xRot), ke = Be[0], ze = Be[1];
            return [c.cX + ke, c.cY + ze];
          };
          h = ee(J, se), F[M].x1 = h[0], F[M].y1 = h[1], g = ee(Re, Oe), F[M].x2 = g[0], F[M].y2 = g[1], v = ee(he, ye), F[M].x = v[0], F[M].y = v[1], c.relative && (F[M].x1 -= S, F[M].y1 -= R, F[M].x2 -= S, F[M].y2 -= R, F[M].x -= S, F[M].y -= R), S = (y = [F[M].x, F[M].y])[0], R = y[1];
        }
        return F;
      })(o, o.relative ? 0 : l, o.relative ? 0 : u) : o;
    }));
  }, r.ANNOTATE_ARCS = function() {
    return i((function(o, l, u) {
      return o.relative && (l = 0, u = 0), Le.ARC === o.type && u0(o, l, u), o;
    }));
  }, r.CLONE = s, r.CALCULATE_BOUNDS = function() {
    var o = function(f) {
      var h = {};
      for (var g in f) h[g] = f[g];
      return h;
    }, l = e(), u = n(), c = t(), d = i((function(f, h, g) {
      var v = c(u(l(o(f))));
      function y(Oe) {
        Oe > d.maxX && (d.maxX = Oe), Oe < d.minX && (d.minX = Oe);
      }
      function A(Oe) {
        Oe > d.maxY && (d.maxY = Oe), Oe < d.minY && (d.minY = Oe);
      }
      if (v.type & Le.DRAWING_COMMANDS && (y(h), A(g)), v.type & Le.HORIZ_LINE_TO && y(v.x), v.type & Le.VERT_LINE_TO && A(v.y), v.type & Le.LINE_TO && (y(v.x), A(v.y)), v.type & Le.CURVE_TO) {
        y(v.x), A(v.y);
        for (var x = 0, k = fx(h, v.x1, v.x2, v.x); x < k.length; x++)
          0 < (Re = k[x]) && 1 > Re && y(dx(h, v.x1, v.x2, v.x, Re));
        for (var F = 0, S = fx(g, v.y1, v.y2, v.y); F < S.length; F++)
          0 < (Re = S[F]) && 1 > Re && A(dx(g, v.y1, v.y2, v.y, Re));
      }
      if (v.type & Le.ARC) {
        y(v.x), A(v.y), u0(v, h, g);
        for (var R = v.xRot / 180 * Math.PI, M = Math.cos(R) * v.rX, j = Math.sin(R) * v.rX, G = -Math.sin(R) * v.rY, ie = Math.cos(R) * v.rY, q = v.phi1 < v.phi2 ? [v.phi1, v.phi2] : -180 > v.phi2 ? [v.phi2 + 360, v.phi1 + 360] : [v.phi2, v.phi1], Y = q[0], J = q[1], se = function(Oe) {
          var ee = Oe[0], re = Oe[1], de = 180 * Math.atan2(re, ee) / Math.PI;
          return de < Y ? de + 360 : de;
        }, oe = 0, he = lx(G, -M, 0).map(se); oe < he.length; oe++)
          (Re = he[oe]) > Y && Re < J && y(cx(v.cX, M, G, Re));
        for (var ye = 0, Ue = lx(ie, -j, 0).map(se); ye < Ue.length; ye++) {
          var Re;
          (Re = Ue[ye]) > Y && Re < J && A(cx(v.cY, j, ie, Re));
        }
      }
      return f;
    }));
    return d.minX = 1 / 0, d.maxX = -1 / 0, d.minY = 1 / 0, d.maxY = -1 / 0, d;
  };
})(ti || (ti = {}));
var Sa, Qk = (function() {
  function r() {
  }
  return r.prototype.round = function(e) {
    return this.transform(ti.ROUND(e));
  }, r.prototype.toAbs = function() {
    return this.transform(ti.TO_ABS());
  }, r.prototype.toRel = function() {
    return this.transform(ti.TO_REL());
  }, r.prototype.normalizeHVZ = function(e, t, n) {
    return this.transform(ti.NORMALIZE_HVZ(e, t, n));
  }, r.prototype.normalizeST = function() {
    return this.transform(ti.NORMALIZE_ST());
  }, r.prototype.qtToC = function() {
    return this.transform(ti.QT_TO_C());
  }, r.prototype.aToC = function() {
    return this.transform(ti.A_TO_C());
  }, r.prototype.sanitize = function(e) {
    return this.transform(ti.SANITIZE(e));
  }, r.prototype.translate = function(e, t) {
    return this.transform(ti.TRANSLATE(e, t));
  }, r.prototype.scale = function(e, t) {
    return this.transform(ti.SCALE(e, t));
  }, r.prototype.rotate = function(e, t, n) {
    return this.transform(ti.ROTATE(e, t, n));
  }, r.prototype.matrix = function(e, t, n, i, a, s) {
    return this.transform(ti.MATRIX(e, t, n, i, a, s));
  }, r.prototype.skewX = function(e) {
    return this.transform(ti.SKEW_X(e));
  }, r.prototype.skewY = function(e) {
    return this.transform(ti.SKEW_Y(e));
  }, r.prototype.xSymmetry = function(e) {
    return this.transform(ti.X_AXIS_SYMMETRY(e));
  }, r.prototype.ySymmetry = function(e) {
    return this.transform(ti.Y_AXIS_SYMMETRY(e));
  }, r.prototype.annotateArcs = function() {
    return this.transform(ti.ANNOTATE_ARCS());
  }, r;
})(), e3 = function(r) {
  return r === " " || r === "	" || r === "\r" || r === `
`;
}, hx = function(r) {
  return 48 <= r.charCodeAt(0) && r.charCodeAt(0) <= 57;
}, t3 = (function(r) {
  function e() {
    var t = r.call(this) || this;
    return t.curNumber = "", t.curCommandType = -1, t.curCommandRelative = !1, t.canParseCommandOrComma = !0, t.curNumberHasExp = !1, t.curNumberHasExpDigits = !1, t.curNumberHasDecimal = !1, t.curArgs = [], t;
  }
  return Wk(e, r), e.prototype.finish = function(t) {
    if (t === void 0 && (t = []), this.parse(" ", t), this.curArgs.length !== 0 || !this.canParseCommandOrComma) throw new SyntaxError("Unterminated command at the path end.");
    return t;
  }, e.prototype.parse = function(t, n) {
    var i = this;
    n === void 0 && (n = []);
    for (var a = function(d) {
      n.push(d), i.curArgs.length = 0, i.canParseCommandOrComma = !0;
    }, s = 0; s < t.length; s++) {
      var o = t[s], l = !(this.curCommandType !== Le.ARC || this.curArgs.length !== 3 && this.curArgs.length !== 4 || this.curNumber.length !== 1 || this.curNumber !== "0" && this.curNumber !== "1"), u = hx(o) && (this.curNumber === "0" && o === "0" || l);
      if (!hx(o) || u) if (o !== "e" && o !== "E") if (o !== "-" && o !== "+" || !this.curNumberHasExp || this.curNumberHasExpDigits) if (o !== "." || this.curNumberHasExp || this.curNumberHasDecimal || l) {
        if (this.curNumber && this.curCommandType !== -1) {
          var c = Number(this.curNumber);
          if (isNaN(c)) throw new SyntaxError("Invalid number ending at " + s);
          if (this.curCommandType === Le.ARC) {
            if (this.curArgs.length === 0 || this.curArgs.length === 1) {
              if (0 > c) throw new SyntaxError('Expected positive number, got "' + c + '" at index "' + s + '"');
            } else if ((this.curArgs.length === 3 || this.curArgs.length === 4) && this.curNumber !== "0" && this.curNumber !== "1") throw new SyntaxError('Expected a flag, got "' + this.curNumber + '" at index "' + s + '"');
          }
          this.curArgs.push(c), this.curArgs.length === r3[this.curCommandType] && (Le.HORIZ_LINE_TO === this.curCommandType ? a({ type: Le.HORIZ_LINE_TO, relative: this.curCommandRelative, x: c }) : Le.VERT_LINE_TO === this.curCommandType ? a({ type: Le.VERT_LINE_TO, relative: this.curCommandRelative, y: c }) : this.curCommandType === Le.MOVE_TO || this.curCommandType === Le.LINE_TO || this.curCommandType === Le.SMOOTH_QUAD_TO ? (a({ type: this.curCommandType, relative: this.curCommandRelative, x: this.curArgs[0], y: this.curArgs[1] }), Le.MOVE_TO === this.curCommandType && (this.curCommandType = Le.LINE_TO)) : this.curCommandType === Le.CURVE_TO ? a({ type: Le.CURVE_TO, relative: this.curCommandRelative, x1: this.curArgs[0], y1: this.curArgs[1], x2: this.curArgs[2], y2: this.curArgs[3], x: this.curArgs[4], y: this.curArgs[5] }) : this.curCommandType === Le.SMOOTH_CURVE_TO ? a({ type: Le.SMOOTH_CURVE_TO, relative: this.curCommandRelative, x2: this.curArgs[0], y2: this.curArgs[1], x: this.curArgs[2], y: this.curArgs[3] }) : this.curCommandType === Le.QUAD_TO ? a({ type: Le.QUAD_TO, relative: this.curCommandRelative, x1: this.curArgs[0], y1: this.curArgs[1], x: this.curArgs[2], y: this.curArgs[3] }) : this.curCommandType === Le.ARC && a({ type: Le.ARC, relative: this.curCommandRelative, rX: this.curArgs[0], rY: this.curArgs[1], xRot: this.curArgs[2], lArcFlag: this.curArgs[3], sweepFlag: this.curArgs[4], x: this.curArgs[5], y: this.curArgs[6] })), this.curNumber = "", this.curNumberHasExpDigits = !1, this.curNumberHasExp = !1, this.curNumberHasDecimal = !1, this.canParseCommandOrComma = !0;
        }
        if (!e3(o)) if (o === "," && this.canParseCommandOrComma) this.canParseCommandOrComma = !1;
        else if (o !== "+" && o !== "-" && o !== ".") if (u) this.curNumber = o, this.curNumberHasDecimal = !1;
        else {
          if (this.curArgs.length !== 0) throw new SyntaxError("Unterminated command at index " + s + ".");
          if (!this.canParseCommandOrComma) throw new SyntaxError('Unexpected character "' + o + '" at index ' + s + ". Command cannot follow comma");
          if (this.canParseCommandOrComma = !1, o !== "z" && o !== "Z") if (o === "h" || o === "H") this.curCommandType = Le.HORIZ_LINE_TO, this.curCommandRelative = o === "h";
          else if (o === "v" || o === "V") this.curCommandType = Le.VERT_LINE_TO, this.curCommandRelative = o === "v";
          else if (o === "m" || o === "M") this.curCommandType = Le.MOVE_TO, this.curCommandRelative = o === "m";
          else if (o === "l" || o === "L") this.curCommandType = Le.LINE_TO, this.curCommandRelative = o === "l";
          else if (o === "c" || o === "C") this.curCommandType = Le.CURVE_TO, this.curCommandRelative = o === "c";
          else if (o === "s" || o === "S") this.curCommandType = Le.SMOOTH_CURVE_TO, this.curCommandRelative = o === "s";
          else if (o === "q" || o === "Q") this.curCommandType = Le.QUAD_TO, this.curCommandRelative = o === "q";
          else if (o === "t" || o === "T") this.curCommandType = Le.SMOOTH_QUAD_TO, this.curCommandRelative = o === "t";
          else {
            if (o !== "a" && o !== "A") throw new SyntaxError('Unexpected character "' + o + '" at index ' + s + ".");
            this.curCommandType = Le.ARC, this.curCommandRelative = o === "a";
          }
          else n.push({ type: Le.CLOSE_PATH }), this.canParseCommandOrComma = !0, this.curCommandType = -1;
        }
        else this.curNumber = o, this.curNumberHasDecimal = o === ".";
      } else this.curNumber += o, this.curNumberHasDecimal = !0;
      else this.curNumber += o;
      else this.curNumber += o, this.curNumberHasExp = !0;
      else this.curNumber += o, this.curNumberHasExpDigits = this.curNumberHasExp;
    }
    return n;
  }, e.prototype.transform = function(t) {
    return Object.create(this, { parse: { value: function(n, i) {
      i === void 0 && (i = []);
      for (var a = 0, s = Object.getPrototypeOf(this).parse.call(this, n); a < s.length; a++) {
        var o = s[a], l = t(o);
        Array.isArray(l) ? i.push.apply(i, l) : i.push(l);
      }
      return i;
    } } });
  }, e;
})(Qk), Le = (function(r) {
  function e(t) {
    var n = r.call(this) || this;
    return n.commands = typeof t == "string" ? e.parse(t) : t, n;
  }
  return Wk(e, r), e.prototype.encode = function() {
    return e.encode(this.commands);
  }, e.prototype.getBounds = function() {
    var t = ti.CALCULATE_BOUNDS();
    return this.transform(t), t;
  }, e.prototype.transform = function(t) {
    for (var n = [], i = 0, a = this.commands; i < a.length; i++) {
      var s = t(a[i]);
      Array.isArray(s) ? n.push.apply(n, s) : n.push(s);
    }
    return this.commands = n, this;
  }, e.encode = function(t) {
    return ZB(t);
  }, e.parse = function(t) {
    var n = new t3(), i = [];
    return n.parse(t, i), n.finish(i), i;
  }, e.CLOSE_PATH = 1, e.MOVE_TO = 2, e.HORIZ_LINE_TO = 4, e.VERT_LINE_TO = 8, e.LINE_TO = 16, e.CURVE_TO = 32, e.SMOOTH_CURVE_TO = 64, e.QUAD_TO = 128, e.SMOOTH_QUAD_TO = 256, e.ARC = 512, e.LINE_COMMANDS = e.LINE_TO | e.HORIZ_LINE_TO | e.VERT_LINE_TO, e.DRAWING_COMMANDS = e.HORIZ_LINE_TO | e.VERT_LINE_TO | e.LINE_TO | e.CURVE_TO | e.SMOOTH_CURVE_TO | e.QUAD_TO | e.SMOOTH_QUAD_TO | e.ARC, e;
})(Qk), r3 = ((Sa = {})[Le.MOVE_TO] = 2, Sa[Le.LINE_TO] = 2, Sa[Le.HORIZ_LINE_TO] = 1, Sa[Le.VERT_LINE_TO] = 1, Sa[Le.CLOSE_PATH] = 0, Sa[Le.QUAD_TO] = 4, Sa[Le.SMOOTH_QUAD_TO] = 2, Sa[Le.CURVE_TO] = 6, Sa[Le.SMOOTH_CURVE_TO] = 4, Sa[Le.ARC] = 7, Sa);
function Bp(r) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Bp = function(e) {
    return typeof e;
  } : Bp = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Bp(r);
}
function n3(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
var i3 = [512, 512, 456, 512, 328, 456, 335, 512, 405, 328, 271, 456, 388, 335, 292, 512, 454, 405, 364, 328, 298, 271, 496, 456, 420, 388, 360, 335, 312, 292, 273, 512, 482, 454, 428, 405, 383, 364, 345, 328, 312, 298, 284, 271, 259, 496, 475, 456, 437, 420, 404, 388, 374, 360, 347, 335, 323, 312, 302, 292, 282, 273, 265, 512, 497, 482, 468, 454, 441, 428, 417, 405, 394, 383, 373, 364, 354, 345, 337, 328, 320, 312, 305, 298, 291, 284, 278, 271, 265, 259, 507, 496, 485, 475, 465, 456, 446, 437, 428, 420, 412, 404, 396, 388, 381, 374, 367, 360, 354, 347, 341, 335, 329, 323, 318, 312, 307, 302, 297, 292, 287, 282, 278, 273, 269, 265, 261, 512, 505, 497, 489, 482, 475, 468, 461, 454, 447, 441, 435, 428, 422, 417, 411, 405, 399, 394, 389, 383, 378, 373, 368, 364, 359, 354, 350, 345, 341, 337, 332, 328, 324, 320, 316, 312, 309, 305, 301, 298, 294, 291, 287, 284, 281, 278, 274, 271, 268, 265, 262, 259, 257, 507, 501, 496, 491, 485, 480, 475, 470, 465, 460, 456, 451, 446, 442, 437, 433, 428, 424, 420, 416, 412, 408, 404, 400, 396, 392, 388, 385, 381, 377, 374, 370, 367, 363, 360, 357, 354, 350, 347, 344, 341, 338, 335, 332, 329, 326, 323, 320, 318, 315, 312, 310, 307, 304, 302, 299, 297, 294, 292, 289, 287, 285, 282, 280, 278, 275, 273, 271, 269, 267, 265, 263, 261, 259], a3 = [9, 11, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24];
function s3(r, e, t, n, i) {
  if (typeof r == "string" && (r = document.getElementById(r)), !r || Bp(r) !== "object" || !("getContext" in r))
    throw new TypeError("Expecting canvas with `getContext` method in processCanvasRGB(A) calls!");
  var a = r.getContext("2d");
  try {
    return a.getImageData(e, t, n, i);
  } catch (s) {
    throw new Error("unable to access image data: " + s);
  }
}
function o3(r, e, t, n, i, a) {
  if (!(isNaN(a) || a < 1)) {
    a |= 0;
    var s = s3(r, e, t, n, i);
    s = l3(s, e, t, n, i, a), r.getContext("2d").putImageData(s, e, t);
  }
}
function l3(r, e, t, n, i, a) {
  for (var s = r.data, o = 2 * a + 1, l = n - 1, u = i - 1, c = a + 1, d = c * (c + 1) / 2, f = new px(), h = f, g, v = 1; v < o; v++)
    h = h.next = new px(), v === c && (g = h);
  h.next = f;
  for (var y = null, A = null, x = 0, k = 0, F = i3[a], S = a3[a], R = 0; R < i; R++) {
    h = f;
    for (var M = s[k], j = s[k + 1], G = s[k + 2], ie = s[k + 3], q = 0; q < c; q++)
      h.r = M, h.g = j, h.b = G, h.a = ie, h = h.next;
    for (var Y = 0, J = 0, se = 0, oe = 0, he = c * M, ye = c * j, Ue = c * G, Re = c * ie, Oe = d * M, ee = d * j, re = d * G, de = d * ie, Be = 1; Be < c; Be++) {
      var ke = k + ((l < Be ? l : Be) << 2), ze = s[ke], je = s[ke + 1], qe = s[ke + 2], Ge = s[ke + 3], bt = c - Be;
      Oe += (h.r = ze) * bt, ee += (h.g = je) * bt, re += (h.b = qe) * bt, de += (h.a = Ge) * bt, Y += ze, J += je, se += qe, oe += Ge, h = h.next;
    }
    y = f, A = g;
    for (var rr = 0; rr < n; rr++) {
      var Pr = de * F >>> S;
      if (s[k + 3] = Pr, Pr !== 0) {
        var Gt = 255 / Pr;
        s[k] = (Oe * F >>> S) * Gt, s[k + 1] = (ee * F >>> S) * Gt, s[k + 2] = (re * F >>> S) * Gt;
      } else
        s[k] = s[k + 1] = s[k + 2] = 0;
      Oe -= he, ee -= ye, re -= Ue, de -= Re, he -= y.r, ye -= y.g, Ue -= y.b, Re -= y.a;
      var ar = rr + a + 1;
      ar = x + (ar < l ? ar : l) << 2, Y += y.r = s[ar], J += y.g = s[ar + 1], se += y.b = s[ar + 2], oe += y.a = s[ar + 3], Oe += Y, ee += J, re += se, de += oe, y = y.next;
      var St = A, st = St.r, Qr = St.g, Sr = St.b, gr = St.a;
      he += st, ye += Qr, Ue += Sr, Re += gr, Y -= st, J -= Qr, se -= Sr, oe -= gr, A = A.next, k += 4;
    }
    x += n;
  }
  for (var nr = 0; nr < n; nr++) {
    k = nr << 2;
    var fr = s[k], Yt = s[k + 1], Xt = s[k + 2], mt = s[k + 3], wr = c * fr, an = c * Yt, _r = c * Xt, ir = c * mt, Yr = d * fr, kr = d * Yt, Zr = d * Xt, Vr = d * mt;
    h = f;
    for (var pn = 0; pn < c; pn++)
      h.r = fr, h.g = Yt, h.b = Xt, h.a = mt, h = h.next;
    for (var gn = n, Tr = 0, zr = 0, en = 0, $r = 0, zt = 1; zt <= a; zt++) {
      k = gn + nr << 2;
      var sr = c - zt;
      Yr += (h.r = fr = s[k]) * sr, kr += (h.g = Yt = s[k + 1]) * sr, Zr += (h.b = Xt = s[k + 2]) * sr, Vr += (h.a = mt = s[k + 3]) * sr, $r += fr, Tr += Yt, zr += Xt, en += mt, h = h.next, zt < u && (gn += n);
    }
    k = nr, y = f, A = g;
    for (var Er = 0; Er < i; Er++) {
      var tt = k << 2;
      s[tt + 3] = mt = Vr * F >>> S, mt > 0 ? (mt = 255 / mt, s[tt] = (Yr * F >>> S) * mt, s[tt + 1] = (kr * F >>> S) * mt, s[tt + 2] = (Zr * F >>> S) * mt) : s[tt] = s[tt + 1] = s[tt + 2] = 0, Yr -= wr, kr -= an, Zr -= _r, Vr -= ir, wr -= y.r, an -= y.g, _r -= y.b, ir -= y.a, tt = nr + ((tt = Er + c) < u ? tt : u) * n << 2, Yr += $r += y.r = s[tt], kr += Tr += y.g = s[tt + 1], Zr += zr += y.b = s[tt + 2], Vr += en += y.a = s[tt + 3], y = y.next, wr += fr = A.r, an += Yt = A.g, _r += Xt = A.b, ir += mt = A.a, $r -= fr, Tr -= Yt, zr -= Xt, en -= mt, A = A.next, k += n;
    }
  }
  return r;
}
var px = (
  /**
   * Set properties.
   */
  function r() {
    n3(this, r), this.r = 0, this.g = 0, this.b = 0, this.a = 0, this.next = null;
  }
);
function pl(r, e, t, n, i, a) {
  return r[t * n * 4 + e * 4 + a];
}
function gl(r, e, t, n, i, a, s) {
  r[t * n * 4 + e * 4 + a] = s;
}
function Id(r) {
  return r.replace(/(?!\u3000)\s+/gm, " ");
}
function $i(r) {
  const e = r.match(/-?(\d+(?:\.\d*(?:[eE][+-]?\d+)?)?|\.\d+)(?=\D|$)/gm);
  return e ? e.map(parseFloat) : [];
}
function u3(r) {
  const e = $i(r);
  return [
    e[0] || 0,
    e[1] || 0,
    e[2] || 0,
    e[3] || 0,
    e[4] || 0,
    e[5] || 0
  ];
}
const c3 = /^[A-Z-]+$/;
function f3(r) {
  return c3.test(r) ? r.toLowerCase() : r;
}
function gx(r) {
  const e = /url\(('([^']+)'|"([^"]+)"|([^'")]+))\)/.exec(r);
  return e && (e[2] || e[3] || e[4]) || "";
}
function d3(r) {
  if (!r.startsWith("rgb"))
    return r;
  let e = 3;
  return r.replace(/\d+(\.\d+)?/g, (n, i) => e-- && i ? String(Math.round(parseFloat(n))) : n);
}
const h3 = /(\[[^\]]+\])/g, p3 = /(#[^\s+>~.[:]+)/g, g3 = /(\.[^\s+>~.[:]+)/g, m3 = /(::[^\s+>~.[:]+|:first-line|:first-letter|:before|:after)/gi, v3 = /(:[\w-]+\([^)]*\))/gi, y3 = /(:[^\s+>~.[:]+)/g, A3 = /([^\s+>~.[:]+)/g;
function il(r, e) {
  const t = e.exec(r);
  return t ? [r.replace(e, " "), t.length] : [r, 0];
}
function b3(r) {
  const e = [
    0,
    0,
    0
  ];
  let t = r.replace(/:not\(([^)]*)\)/g, "     $1 ").replace(/{[\s\S]*/gm, " "), n = 0;
  return [t, n] = il(t, h3), e[1] += n, [t, n] = il(t, p3), e[0] += n, [t, n] = il(t, g3), e[1] += n, [t, n] = il(t, m3), e[2] += n, [t, n] = il(t, v3), e[1] += n, [t, n] = il(t, y3), e[1] += n, t = t.replace(/[*\s+>~]/g, " ").replace(/[#.]/g, " "), [t, n] = il(t, A3), e[2] += n, e.join("");
}
const Bu = 1e-8;
function mx(r) {
  return Math.sqrt(Math.pow(r[0], 2) + Math.pow(r[1], 2));
}
function Py(r, e) {
  return (r[0] * e[0] + r[1] * e[1]) / (mx(r) * mx(e));
}
function vx(r, e) {
  return (r[0] * e[1] < r[1] * e[0] ? -1 : 1) * Math.acos(Py(r, e));
}
function yx(r) {
  return r * r * r;
}
function Ax(r) {
  return 3 * r * r * (1 - r);
}
function bx(r) {
  return 3 * r * (1 - r) * (1 - r);
}
function wx(r) {
  return (1 - r) * (1 - r) * (1 - r);
}
function xx(r) {
  return r * r;
}
function Cx(r) {
  return 2 * r * (1 - r);
}
function Sx(r) {
  return (1 - r) * (1 - r);
}
class Mt {
  document;
  name;
  value;
  static empty(e) {
    return new Mt(e, "EMPTY", "");
  }
  static textBaselineMapping = {
    baseline: "alphabetic",
    "before-edge": "top",
    "text-before-edge": "top",
    middle: "middle",
    central: "middle",
    "after-edge": "bottom",
    "text-after-edge": "bottom",
    ideographic: "ideographic",
    alphabetic: "alphabetic",
    hanging: "hanging",
    mathematical: "alphabetic"
  };
  isNormalizedColor = !1;
  constructor(e, t, n) {
    this.document = e, this.name = t, this.value = n;
  }
  split(e = " ") {
    const { document: t, name: n } = this;
    return Id(this.getString()).trim().split(e).map((i) => new Mt(t, n, i));
  }
  hasValue(e) {
    const t = this.value;
    return t !== null && t !== "" && (e || t !== 0) && typeof t < "u";
  }
  isString(e) {
    const { value: t } = this, n = typeof t == "string";
    return !n || !e ? n : e.test(t);
  }
  isUrlDefinition() {
    return this.isString(/^url\(/);
  }
  isPixels() {
    if (!this.hasValue())
      return !1;
    const e = this.getString();
    switch (!0) {
      case e.endsWith("px"):
      case /^[0-9]+$/.test(e):
        return !0;
      default:
        return !1;
    }
  }
  setValue(e) {
    return this.value = e, this;
  }
  getValue(e) {
    return typeof e > "u" || this.hasValue() ? this.value : e;
  }
  getNumber(e) {
    if (!this.hasValue())
      return typeof e > "u" ? 0 : parseFloat(e);
    const { value: t } = this;
    let n = parseFloat(t);
    return this.isString(/%$/) && (n /= 100), n;
  }
  getString(e) {
    return typeof e > "u" || this.hasValue() ? typeof this.value > "u" ? "" : String(this.value) : String(e);
  }
  getColor(e) {
    let t = this.getString(e);
    return this.isNormalizedColor || (this.isNormalizedColor = !0, t = d3(t), this.value = t), t;
  }
  getDpi() {
    return 96;
  }
  getRem() {
    return this.document.rootEmSize;
  }
  getEm() {
    return this.document.emSize;
  }
  getUnits() {
    return this.getString().replace(/[0-9.-]/g, "");
  }
  getPixels(e, t = !1) {
    if (!this.hasValue())
      return 0;
    const [n, i] = typeof e == "boolean" ? [void 0, e] : [e], { viewPort: a } = this.document.screen;
    switch (!0) {
      case this.isString(/vmin$/):
        return this.getNumber() / 100 * Math.min(a.computeSize("x"), a.computeSize("y"));
      case this.isString(/vmax$/):
        return this.getNumber() / 100 * Math.max(a.computeSize("x"), a.computeSize("y"));
      case this.isString(/vw$/):
        return this.getNumber() / 100 * a.computeSize("x");
      case this.isString(/vh$/):
        return this.getNumber() / 100 * a.computeSize("y");
      case this.isString(/rem$/):
        return this.getNumber() * this.getRem(
          /* viewPort */
        );
      case this.isString(/em$/):
        return this.getNumber() * this.getEm(
          /* viewPort */
        );
      case this.isString(/ex$/):
        return this.getNumber() * this.getEm(
          /* viewPort */
        ) / 2;
      case this.isString(/px$/):
        return this.getNumber();
      case this.isString(/pt$/):
        return this.getNumber() * this.getDpi(
          /* viewPort */
        ) * (1 / 72);
      case this.isString(/pc$/):
        return this.getNumber() * 15;
      case this.isString(/cm$/):
        return this.getNumber() * this.getDpi(
          /* viewPort */
        ) / 2.54;
      case this.isString(/mm$/):
        return this.getNumber() * this.getDpi(
          /* viewPort */
        ) / 25.4;
      case this.isString(/in$/):
        return this.getNumber() * this.getDpi(
          /* viewPort */
        );
      case (this.isString(/%$/) && i):
        return this.getNumber() * this.getEm(
          /* viewPort */
        );
      case this.isString(/%$/):
        return this.getNumber() * a.computeSize(n);
      default: {
        const s = this.getNumber();
        return t && s < 1 ? s * a.computeSize(n) : s;
      }
    }
  }
  getMilliseconds() {
    return this.hasValue() ? this.isString(/ms$/) ? this.getNumber() : this.getNumber() * 1e3 : 0;
  }
  getRadians() {
    if (!this.hasValue())
      return 0;
    switch (!0) {
      case this.isString(/deg$/):
        return this.getNumber() * (Math.PI / 180);
      case this.isString(/grad$/):
        return this.getNumber() * (Math.PI / 200);
      case this.isString(/rad$/):
        return this.getNumber();
      default:
        return this.getNumber() * (Math.PI / 180);
    }
  }
  getDefinition() {
    const e = this.getString(), n = /#([^)'"]+)/.exec(e)?.[1] || e;
    return this.document.definitions[n];
  }
  getFillStyleDefinition(e, t) {
    let n = this.getDefinition();
    if (!n)
      return null;
    if (typeof n.createGradient == "function" && "getBoundingBox" in e)
      return n.createGradient(this.document.ctx, e, t);
    if (typeof n.createPattern == "function") {
      if (n.getHrefAttribute().hasValue()) {
        const i = n.getAttribute("patternTransform");
        n = n.getHrefAttribute().getDefinition(), n && i.hasValue() && n.getAttribute("patternTransform", !0).setValue(i.value);
      }
      if (n)
        return n.createPattern(this.document.ctx, e, t);
    }
    return null;
  }
  getTextBaseline() {
    if (!this.hasValue())
      return null;
    const e = this.getString();
    return Mt.textBaselineMapping[e] || null;
  }
  addOpacity(e) {
    let t = this.getColor();
    const n = t.length;
    let i = 0;
    for (let a = 0; a < n && (t[a] === "," && i++, i !== 3); a++)
      ;
    if (e.hasValue() && this.isString() && i !== 3) {
      const a = new Iy(t);
      a.ok && (a.alpha = e.getNumber(), t = a.toRGBA());
    }
    return new Mt(this.document, this.name, t);
  }
}
class Ry {
  static DEFAULT_VIEWPORT_WIDTH = 800;
  static DEFAULT_VIEWPORT_HEIGHT = 600;
  viewPorts = [];
  clear() {
    this.viewPorts = [];
  }
  setCurrent(e, t) {
    this.viewPorts.push({
      width: e,
      height: t
    });
  }
  removeCurrent() {
    this.viewPorts.pop();
  }
  getRoot() {
    const [e] = this.viewPorts;
    return e || Ex();
  }
  getCurrent() {
    const { viewPorts: e } = this, t = e[e.length - 1];
    return t || Ex();
  }
  get width() {
    return this.getCurrent().width;
  }
  get height() {
    return this.getCurrent().height;
  }
  computeSize(e) {
    return typeof e == "number" ? e : e === "x" ? this.width : e === "y" ? this.height : Math.sqrt(Math.pow(this.width, 2) + Math.pow(this.height, 2)) / Math.sqrt(2);
  }
}
function Ex() {
  return {
    width: Ry.DEFAULT_VIEWPORT_WIDTH,
    height: Ry.DEFAULT_VIEWPORT_HEIGHT
  };
}
class Pn {
  x;
  y;
  static parse(e, t = 0) {
    const [n = t, i = t] = $i(e);
    return new Pn(n, i);
  }
  static parseScale(e, t = 1) {
    const [n = t, i = n] = $i(e);
    return new Pn(n, i);
  }
  static parsePath(e) {
    const t = $i(e), n = t.length, i = [];
    for (let a = 0; a < n; a += 2)
      i.push(new Pn(t[a], t[a + 1]));
    return i;
  }
  constructor(e, t) {
    this.x = e, this.y = t;
  }
  angleTo(e) {
    return Math.atan2(e.y - this.y, e.x - this.x);
  }
  applyTransform(e) {
    const { x: t, y: n } = this, i = t * e[0] + n * e[2] + e[4], a = t * e[1] + n * e[3] + e[5];
    this.x = i, this.y = a;
  }
}
class w3 {
  screen;
  working = !1;
  events = [];
  eventElements = [];
  constructor(e) {
    this.screen = e, this.onClick = this.onClick.bind(this), this.onMouseMove = this.onMouseMove.bind(this);
  }
  isWorking() {
    return this.working;
  }
  start() {
    if (this.working)
      return;
    const { screen: e, onClick: t, onMouseMove: n } = this, i = e.ctx.canvas;
    i.onclick = t, i.onmousemove = n, this.working = !0;
  }
  stop() {
    if (!this.working)
      return;
    const e = this.screen.ctx.canvas;
    this.working = !1, e.onclick = null, e.onmousemove = null;
  }
  hasEvents() {
    return this.working && this.events.length > 0;
  }
  runEvents() {
    if (!this.working)
      return;
    const { screen: e, events: t, eventElements: n } = this, { style: i } = e.ctx.canvas;
    let a;
    i && (i.cursor = ""), t.forEach(({ run: s }, o) => {
      for (a = n[o]; a; )
        s(a), a = a.parent;
    }), this.events = [], this.eventElements = [];
  }
  checkPath(e, t) {
    if (!this.working || !t)
      return;
    const { events: n, eventElements: i } = this;
    n.forEach(({ x: a, y: s }, o) => {
      !i[o] && t.isPointInPath && t.isPointInPath(a, s) && (i[o] = e);
    });
  }
  checkBoundingBox(e, t) {
    if (!this.working || !t)
      return;
    const { events: n, eventElements: i } = this;
    n.forEach(({ x: a, y: s }, o) => {
      !i[o] && t.isPointInBox(a, s) && (i[o] = e);
    });
  }
  mapXY(e, t) {
    const { window: n, ctx: i } = this.screen, a = new Pn(e, t);
    let s = i.canvas;
    for (; s; )
      a.x -= s.offsetLeft, a.y -= s.offsetTop, s = s.offsetParent;
    return n?.scrollX && (a.x += n.scrollX), n?.scrollY && (a.y += n.scrollY), a;
  }
  onClick(e) {
    const { x: t, y: n } = this.mapXY(e.clientX, e.clientY);
    this.events.push({
      type: "onclick",
      x: t,
      y: n,
      run(i) {
        i.onClick && i.onClick();
      }
    });
  }
  onMouseMove(e) {
    const { x: t, y: n } = this.mapXY(e.clientX, e.clientY);
    this.events.push({
      type: "onmousemove",
      x: t,
      y: n,
      run(i) {
        i.onMouseMove && i.onMouseMove();
      }
    });
  }
}
const kx = typeof window < "u" ? window : null, Tx = typeof fetch < "u" ? fetch.bind(void 0) : void 0;
class Dd {
  ctx;
  static defaultWindow = kx;
  static defaultFetch = Tx;
  static FRAMERATE = 30;
  static MAX_VIRTUAL_PIXELS = 3e4;
  window;
  fetch;
  viewPort = new Ry();
  mouse = new w3(this);
  animations = [];
  readyPromise;
  resolveReady;
  waits = [];
  frameDuration = 0;
  isReadyLock = !1;
  isFirstRender = !0;
  intervalId = null;
  constructor(e, { fetch: t = Tx, window: n = kx } = {}) {
    if (this.ctx = e, this.window = n, !t)
      throw new Error("Can't find 'fetch' in 'globalThis', please provide it via options");
    this.fetch = t;
  }
  wait(e) {
    this.waits.push(e);
  }
  ready() {
    return this.readyPromise ? this.readyPromise : Promise.resolve();
  }
  isReady() {
    if (this.isReadyLock)
      return !0;
    const e = this.waits.every((t) => t());
    return e && (this.waits = [], this.resolveReady && this.resolveReady()), this.isReadyLock = e, e;
  }
  setDefaults(e) {
    e.strokeStyle = "rgba(0,0,0,0)", e.lineCap = "butt", e.lineJoin = "miter", e.miterLimit = 4;
  }
  setViewBox({ document: e, ctx: t, aspectRatio: n, width: i, desiredWidth: a, height: s, desiredHeight: o, minX: l = 0, minY: u = 0, refX: c, refY: d, clip: f = !1, clipX: h = 0, clipY: g = 0 }) {
    const v = Id(n).replace(/^defer\s/, ""), [y, A] = v.split(" "), x = y || "xMidYMid", k = A || "meet", F = i / a, S = s / o, R = Math.min(F, S), M = Math.max(F, S);
    let j = a, G = o;
    k === "meet" && (j *= R, G *= R), k === "slice" && (j *= M, G *= M);
    const ie = new Mt(e, "refX", c), q = new Mt(e, "refY", d), Y = ie.hasValue() && q.hasValue();
    if (Y && t.translate(-R * ie.getPixels("x"), -R * q.getPixels("y")), f) {
      const J = R * h, se = R * g;
      t.beginPath(), t.moveTo(J, se), t.lineTo(i, se), t.lineTo(i, s), t.lineTo(J, s), t.closePath(), t.clip();
    }
    if (!Y) {
      const J = k === "meet" && R === S, se = k === "slice" && M === S, oe = k === "meet" && R === F, he = k === "slice" && M === F;
      x.startsWith("xMid") && (J || se) && t.translate(i / 2 - j / 2, 0), x.endsWith("YMid") && (oe || he) && t.translate(0, s / 2 - G / 2), x.startsWith("xMax") && (J || se) && t.translate(i - j, 0), x.endsWith("YMax") && (oe || he) && t.translate(0, s - G);
    }
    switch (!0) {
      case x === "none":
        t.scale(F, S);
        break;
      case k === "meet":
        t.scale(R, R);
        break;
      case k === "slice":
        t.scale(M, M);
        break;
    }
    t.translate(-l, -u);
  }
  start(e, { enableRedraw: t = !1, ignoreMouse: n = !1, ignoreAnimation: i = !1, ignoreDimensions: a = !1, ignoreClear: s = !1, forceRedraw: o, scaleWidth: l, scaleHeight: u, offsetX: c, offsetY: d } = {}) {
    const { mouse: f } = this, h = 1e3 / Dd.FRAMERATE;
    if (this.isReadyLock = !1, this.frameDuration = h, this.readyPromise = new Promise((x) => {
      this.resolveReady = x;
    }), this.isReady() && this.render(e, a, s, l, u, c, d), !t)
      return;
    let g = Date.now(), v = g, y = 0;
    const A = () => {
      g = Date.now(), y = g - v, y >= h && (v = g - y % h, this.shouldUpdate(i, o) && (this.render(e, a, s, l, u, c, d), f.runEvents())), this.intervalId = o0(A);
    };
    n || f.start(), this.intervalId = o0(A);
  }
  stop() {
    this.intervalId && (o0.cancel(this.intervalId), this.intervalId = null), this.mouse.stop();
  }
  shouldUpdate(e, t) {
    if (!e) {
      const { frameDuration: n } = this;
      if (this.animations.reduce((a, s) => s.update(n) || a, !1))
        return !0;
    }
    return !!(typeof t == "function" && t() || !this.isReadyLock && this.isReady() || this.mouse.hasEvents());
  }
  render(e, t, n, i, a, s, o) {
    const { viewPort: l, ctx: u, isFirstRender: c } = this, d = u.canvas;
    l.clear(), d.width && d.height && l.setCurrent(d.width, d.height);
    const f = e.getStyle("width"), h = e.getStyle("height");
    !t && (c || typeof i != "number" && typeof a != "number") && (f.hasValue() && (d.width = f.getPixels("x"), d.style && (d.style.width = `${d.width}px`)), h.hasValue() && (d.height = h.getPixels("y"), d.style && (d.style.height = `${d.height}px`)));
    let g = d.clientWidth || d.width, v = d.clientHeight || d.height;
    if (t && f.hasValue() && h.hasValue() && (g = f.getPixels("x"), v = h.getPixels("y")), l.setCurrent(g, v), typeof s == "number" && e.getAttribute("x", !0).setValue(s), typeof o == "number" && e.getAttribute("y", !0).setValue(o), typeof i == "number" || typeof a == "number") {
      const y = $i(e.getAttribute("viewBox").getString());
      let A = 0, x = 0;
      if (typeof i == "number") {
        const F = e.getStyle("width");
        F.hasValue() ? A = F.getPixels("x") / i : y[2] && !isNaN(y[2]) && (A = y[2] / i);
      }
      if (typeof a == "number") {
        const F = e.getStyle("height");
        F.hasValue() ? x = F.getPixels("y") / a : y[3] && !isNaN(y[3]) && (x = y[3] / a);
      }
      A || (A = x), x || (x = A), e.getAttribute("width", !0).setValue(i), e.getAttribute("height", !0).setValue(a);
      const k = e.getStyle("transform", !0, !0);
      k.setValue(`${k.getString()} scale(${1 / A}, ${1 / x})`);
    }
    n || u.clearRect(0, 0, g, v), e.render(u), c && (this.isFirstRender = !1);
  }
}
const { defaultFetch: x3 } = Dd, C3 = typeof DOMParser < "u" ? DOMParser : void 0;
let c0 = class {
  fetch;
  DOMParser;
  constructor({ fetch: e = x3, DOMParser: t = C3 } = {}) {
    if (!e)
      throw new Error("Can't find 'fetch' in 'globalThis', please provide it via options");
    if (!t)
      throw new Error("Can't find 'DOMParser' in 'globalThis', please provide it via options");
    this.fetch = e, this.DOMParser = t;
  }
  async parse(e) {
    return e.startsWith("<") ? this.parseFromString(e) : this.load(e);
  }
  parseFromString(e) {
    const t = new this.DOMParser();
    try {
      return this.checkDocument(t.parseFromString(e, "image/svg+xml"));
    } catch {
      return this.checkDocument(t.parseFromString(e, "text/xml"));
    }
  }
  checkDocument(e) {
    const t = e.getElementsByTagName("parsererror")[0];
    if (t)
      throw new Error(t.textContent || "Unknown parse error");
    return e;
  }
  async load(e) {
    const n = await (await this.fetch(e)).text();
    return this.parseFromString(n);
  }
};
class S3 {
  type = "translate";
  point;
  constructor(e, t) {
    this.point = Pn.parse(t);
  }
  apply(e) {
    const { x: t, y: n } = this.point;
    e.translate(t || 0, n || 0);
  }
  unapply(e) {
    const { x: t, y: n } = this.point;
    e.translate(-1 * t || 0, -1 * n || 0);
  }
  applyToPoint(e) {
    const { x: t, y: n } = this.point;
    e.applyTransform([
      1,
      0,
      0,
      1,
      t || 0,
      n || 0
    ]);
  }
}
class E3 {
  type = "rotate";
  angle;
  originX;
  originY;
  cx;
  cy;
  constructor(e, t, n) {
    const i = $i(t);
    this.angle = new Mt(e, "angle", i[0]), this.originX = n[0], this.originY = n[1], this.cx = i[1] || 0, this.cy = i[2] || 0;
  }
  apply(e) {
    const { cx: t, cy: n, originX: i, originY: a, angle: s } = this, o = t + i.getPixels("x"), l = n + a.getPixels("y");
    e.translate(o, l), e.rotate(s.getRadians()), e.translate(-o, -l);
  }
  unapply(e) {
    const { cx: t, cy: n, originX: i, originY: a, angle: s } = this, o = t + i.getPixels("x"), l = n + a.getPixels("y");
    e.translate(o, l), e.rotate(-1 * s.getRadians()), e.translate(-o, -l);
  }
  applyToPoint(e) {
    const { cx: t, cy: n, angle: i } = this, a = i.getRadians();
    e.applyTransform([
      1,
      0,
      0,
      1,
      t || 0,
      n || 0
      // this.p.y
    ]), e.applyTransform([
      Math.cos(a),
      Math.sin(a),
      -Math.sin(a),
      Math.cos(a),
      0,
      0
    ]), e.applyTransform([
      1,
      0,
      0,
      1,
      -t || 0,
      -n || 0
      // -this.p.y
    ]);
  }
}
class k3 {
  type = "scale";
  scale;
  originX;
  originY;
  constructor(e, t, n) {
    const i = Pn.parseScale(t);
    (i.x === 0 || i.y === 0) && (i.x = Bu, i.y = Bu), this.scale = i, this.originX = n[0], this.originY = n[1];
  }
  apply(e) {
    const { scale: { x: t, y: n }, originX: i, originY: a } = this, s = i.getPixels("x"), o = a.getPixels("y");
    e.translate(s, o), e.scale(t, n || t), e.translate(-s, -o);
  }
  unapply(e) {
    const { scale: { x: t, y: n }, originX: i, originY: a } = this, s = i.getPixels("x"), o = a.getPixels("y");
    e.translate(s, o), e.scale(1 / t, 1 / n || t), e.translate(-s, -o);
  }
  applyToPoint(e) {
    const { x: t, y: n } = this.scale;
    e.applyTransform([
      t || 0,
      0,
      0,
      n || 0,
      0,
      0
    ]);
  }
}
class Yk {
  type = "matrix";
  matrix;
  originX;
  originY;
  constructor(e, t, n) {
    this.matrix = u3(t), this.originX = n[0], this.originY = n[1];
  }
  apply(e) {
    const { originX: t, originY: n, matrix: i } = this, a = t.getPixels("x"), s = n.getPixels("y");
    e.translate(a, s), e.transform(i[0], i[1], i[2], i[3], i[4], i[5]), e.translate(-a, -s);
  }
  unapply(e) {
    const { originX: t, originY: n, matrix: i } = this, a = i[0], s = i[2], o = i[4], l = i[1], u = i[3], c = i[5], d = 0, f = 0, h = 1, g = 1 / (a * (u * h - c * f) - s * (l * h - c * d) + o * (l * f - u * d)), v = t.getPixels("x"), y = n.getPixels("y");
    e.translate(v, y), e.transform(g * (u * h - c * f), g * (c * d - l * h), g * (o * f - s * h), g * (a * h - o * d), g * (s * c - o * u), g * (o * l - a * c)), e.translate(-v, -y);
  }
  applyToPoint(e) {
    e.applyTransform(this.matrix);
  }
}
class Xk extends Yk {
  type = "skew";
  angle;
  constructor(e, t, n) {
    super(e, t, n), this.angle = new Mt(e, "angle", t);
  }
}
class T3 extends Xk {
  type = "skewX";
  constructor(e, t, n) {
    super(e, t, n), this.matrix = [
      1,
      0,
      Math.tan(this.angle.getRadians()),
      1,
      0,
      0
    ];
  }
}
class F3 extends Xk {
  type = "skewY";
  constructor(e, t, n) {
    super(e, t, n), this.matrix = [
      1,
      Math.tan(this.angle.getRadians()),
      0,
      1,
      0,
      0
    ];
  }
}
function I3(r) {
  return Id(r).trim().replace(/\)([a-zA-Z])/g, ") $1").replace(/\)(\s?,\s?)/g, ") ").split(/\s(?=[a-z])/);
}
function D3(r) {
  const [e = "", t = ""] = r.split("(");
  return [e.trim(), t.trim().replace(")", "")];
}
class Gu {
  document;
  static fromElement(e, t) {
    const n = t.getStyle("transform", !1, !0);
    if (n.hasValue()) {
      const [i, a = i] = t.getStyle("transform-origin", !1, !0).split();
      if (i && a) {
        const s = [i, a];
        return new Gu(e, n.getString(), s);
      }
    }
    return null;
  }
  static transformTypes = {
    translate: S3,
    rotate: E3,
    scale: k3,
    matrix: Yk,
    skewX: T3,
    skewY: F3
  };
  transforms = [];
  constructor(e, t, n) {
    this.document = e, I3(t).forEach((a) => {
      if (a === "none")
        return;
      const [s, o] = D3(a), l = Gu.transformTypes[s];
      l && this.transforms.push(new l(this.document, o, n));
    });
  }
  apply(e) {
    this.transforms.forEach((t) => t.apply(e));
  }
  unapply(e) {
    this.transforms.forEach((t) => t.unapply(e));
  }
  // TODO: applyToPoint unused ... remove?
  applyToPoint(e) {
    this.transforms.forEach((t) => t.applyToPoint(e));
  }
}
class Yn {
  document;
  node;
  captureTextNodes;
  static ignoreChildTypes = ["title"];
  type = "";
  attributes = {};
  styles = {};
  stylesSpecificity = {};
  animationFrozen = !1;
  animationFrozenValue = "";
  parent = null;
  children = [];
  constructor(e, t, n = !1) {
    if (this.document = e, this.node = t, this.captureTextNodes = n, !t || t.nodeType !== 1)
      return;
    Array.from(t.attributes).forEach((s) => {
      const o = f3(s.nodeName);
      this.attributes[o] = new Mt(e, o, s.value);
    }), this.addStylesFromStyleDefinition(), this.getAttribute("style").hasValue() && this.getAttribute("style").getString().split(";").map((o) => o.trim()).forEach((o) => {
      if (!o)
        return;
      const [l, u] = o.split(":").map((c) => c.trim());
      l && (this.styles[l] = new Mt(e, l, u));
    });
    const { definitions: i } = e, a = this.getAttribute("id");
    a.hasValue() && (i[a.getString()] || (i[a.getString()] = this)), Array.from(t.childNodes).forEach((s) => {
      if (s.nodeType === 1)
        this.addChild(s);
      else if (n && (s.nodeType === 3 || s.nodeType === 4)) {
        const o = e.createTextNode(s);
        o.getText().length > 0 && this.addChild(o);
      }
    });
  }
  getAttribute(e, t = !1) {
    const n = this.attributes[e];
    if (!n && t) {
      const i = new Mt(this.document, e, "");
      return this.attributes[e] = i, i;
    }
    return n || Mt.empty(this.document);
  }
  getHrefAttribute() {
    let e;
    for (const t in this.attributes)
      if (t === "href" || t.endsWith(":href")) {
        e = this.attributes[t];
        break;
      }
    return e || Mt.empty(this.document);
  }
  getStyle(e, t = !1, n = !1) {
    const i = this.styles[e];
    if (i)
      return i;
    const a = this.getAttribute(e);
    if (a.hasValue())
      return this.styles[e] = a, a;
    if (!n) {
      const { parent: s } = this;
      if (s) {
        const o = s.getStyle(e);
        if (o.hasValue())
          return o;
      }
    }
    if (t) {
      const s = new Mt(this.document, e, "");
      return this.styles[e] = s, s;
    }
    return Mt.empty(this.document);
  }
  render(e) {
    if (!(this.getStyle("display").getString() === "none" || this.getStyle("visibility").getString() === "hidden")) {
      if (e.save(), this.getStyle("mask").hasValue()) {
        const t = this.getStyle("mask").getDefinition();
        t && (this.applyEffects(e), t.apply(e, this));
      } else if (this.getStyle("filter").getValue("none") !== "none") {
        const t = this.getStyle("filter").getDefinition();
        t && (this.applyEffects(e), t.apply(e, this));
      } else
        this.setContext(e), this.renderChildren(e), this.clearContext(e);
      e.restore();
    }
  }
  setContext(e) {
  }
  applyEffects(e) {
    const t = Gu.fromElement(this.document, this);
    t && t.apply(e);
    const n = this.getStyle("clip-path", !1, !0);
    if (n.hasValue()) {
      const i = n.getDefinition();
      i && i.apply(e);
    }
  }
  clearContext(e) {
  }
  renderChildren(e) {
    this.children.forEach((t) => {
      t.render(e);
    });
  }
  addChild(e) {
    const t = e instanceof Yn ? e : this.document.createElement(e);
    t.parent = this, Yn.ignoreChildTypes.includes(t.type) || this.children.push(t);
  }
  matchesSelector(e) {
    const { node: t } = this;
    if (!t)
      return !1;
    if (typeof t.matches == "function")
      return t.matches(e);
    const n = t.getAttribute?.("class");
    return !n || n === "" ? !1 : n.split(" ").some((i) => `.${i}` === e);
  }
  addStylesFromStyleDefinition() {
    const { styles: e, stylesSpecificity: t } = this.document;
    let n;
    for (const i in e)
      if (!i.startsWith("@") && this.matchesSelector(i)) {
        const a = e[i], s = t[i];
        if (a)
          for (const o in a) {
            let l = this.stylesSpecificity[o];
            typeof l > "u" && (l = "000"), s && s >= l && (n = a[o], n && (this.styles[o] = n), this.stylesSpecificity[o] = s);
          }
      }
  }
  removeStyles(e, t) {
    return t.reduce((i, a) => {
      const s = e.getStyle(a);
      if (!s.hasValue())
        return i;
      const o = s.getString();
      return s.setValue(""), [...i, [a, o]];
    }, []);
  }
  restoreStyles(e, t) {
    t.forEach(([n, i]) => {
      e.getStyle(n, !0).setValue(i);
    });
  }
  isFirstChild() {
    return this.parent?.children.indexOf(this) === 0;
  }
}
class kl extends Yn {
}
class P3 extends Yn {
  constructor(e, t, n) {
    super(e, t, n);
  }
}
function R3(r) {
  const e = r.trim();
  return /^('|")/.test(e) ? e : `"${e}"`;
}
function O3(r) {
  return typeof process > "u" ? r : r.trim().split(",").map(R3).join(",");
}
function B3(r) {
  if (!r)
    return "";
  const e = r.trim().toLowerCase();
  switch (e) {
    case "normal":
    case "italic":
    case "oblique":
    case "inherit":
    case "initial":
    case "unset":
      return e;
    default:
      return /^oblique\s+(-|)\d+deg$/.test(e) ? e : "";
  }
}
function M3(r) {
  if (!r)
    return "";
  const e = r.trim().toLowerCase();
  switch (e) {
    case "normal":
    case "bold":
    case "lighter":
    case "bolder":
    case "inherit":
    case "initial":
    case "unset":
      return e;
    default:
      return /^[\d.]+$/.test(e) ? e : "";
  }
}
let qu = class Cu {
  static parse(e = "", t) {
    let n = "", i = "", a = "", s = "", o = "";
    const l = Id(e).trim().split(" "), u = {
      fontSize: !1,
      fontStyle: !1,
      fontWeight: !1,
      fontVariant: !1
    };
    return l.forEach((c) => {
      switch (!0) {
        case (!u.fontStyle && Cu.styles.includes(c)):
          c !== "inherit" && (n = c), u.fontStyle = !0;
          break;
        case (!u.fontVariant && Cu.variants.includes(c)):
          c !== "inherit" && (i = c), u.fontStyle = !0, u.fontVariant = !0;
          break;
        case (!u.fontWeight && Cu.weights.includes(c)):
          c !== "inherit" && (a = c), u.fontStyle = !0, u.fontVariant = !0, u.fontWeight = !0;
          break;
        case !u.fontSize:
          c !== "inherit" && (s = c.split("/")[0] || ""), u.fontStyle = !0, u.fontVariant = !0, u.fontWeight = !0, u.fontSize = !0;
          break;
        default:
          c !== "inherit" && (o += c);
      }
    }), new Cu(n, i, a, s, o, t);
  }
  static styles = "normal|italic|oblique|inherit";
  static variants = "normal|small-caps|inherit";
  static weights = "normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900|inherit";
  fontFamily;
  fontSize;
  fontStyle;
  fontWeight;
  fontVariant;
  constructor(e, t, n, i, a, s) {
    const o = s ? typeof s == "string" ? Cu.parse(s) : s : {};
    this.fontFamily = a || o.fontFamily, this.fontSize = i || o.fontSize, this.fontStyle = e || o.fontStyle, this.fontWeight = n || o.fontWeight, this.fontVariant = t || o.fontVariant;
  }
  toString() {
    return [
      B3(this.fontStyle),
      this.fontVariant,
      M3(this.fontWeight),
      this.fontSize,
      // Wrap fontFamily only on nodejs and only for canvas.ctx
      O3(this.fontFamily)
    ].join(" ").trim();
  }
}, Ba = class {
  x1;
  y1;
  x2;
  y2;
  constructor(e = Number.NaN, t = Number.NaN, n = Number.NaN, i = Number.NaN) {
    this.x1 = e, this.y1 = t, this.x2 = n, this.y2 = i, this.addPoint(e, t), this.addPoint(n, i);
  }
  get x() {
    return this.x1;
  }
  get y() {
    return this.y1;
  }
  get width() {
    return this.x2 - this.x1;
  }
  get height() {
    return this.y2 - this.y1;
  }
  addPoint(e, t) {
    typeof e < "u" && ((isNaN(this.x1) || isNaN(this.x2)) && (this.x1 = e, this.x2 = e), e < this.x1 && (this.x1 = e), e > this.x2 && (this.x2 = e)), typeof t < "u" && ((isNaN(this.y1) || isNaN(this.y2)) && (this.y1 = t, this.y2 = t), t < this.y1 && (this.y1 = t), t > this.y2 && (this.y2 = t));
  }
  addX(e) {
    this.addPoint(e, 0);
  }
  addY(e) {
    this.addPoint(0, e);
  }
  addBoundingBox(e) {
    if (!e)
      return;
    const { x1: t, y1: n, x2: i, y2: a } = e;
    this.addPoint(t, n), this.addPoint(i, a);
  }
  sumCubic(e, t, n, i, a) {
    return Math.pow(1 - e, 3) * t + 3 * Math.pow(1 - e, 2) * e * n + 3 * (1 - e) * Math.pow(e, 2) * i + Math.pow(e, 3) * a;
  }
  bezierCurveAdd(e, t, n, i, a) {
    const s = 6 * t - 12 * n + 6 * i, o = -3 * t + 9 * n - 9 * i + 3 * a, l = 3 * n - 3 * t;
    if (o === 0) {
      if (s === 0)
        return;
      const f = -l / s;
      0 < f && f < 1 && (e ? this.addX(this.sumCubic(f, t, n, i, a)) : this.addY(this.sumCubic(f, t, n, i, a)));
      return;
    }
    const u = Math.pow(s, 2) - 4 * l * o;
    if (u < 0)
      return;
    const c = (-s + Math.sqrt(u)) / (2 * o);
    0 < c && c < 1 && (e ? this.addX(this.sumCubic(c, t, n, i, a)) : this.addY(this.sumCubic(c, t, n, i, a)));
    const d = (-s - Math.sqrt(u)) / (2 * o);
    0 < d && d < 1 && (e ? this.addX(this.sumCubic(d, t, n, i, a)) : this.addY(this.sumCubic(d, t, n, i, a)));
  }
  // from http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
  addBezierCurve(e, t, n, i, a, s, o, l) {
    this.addPoint(e, t), this.addPoint(o, l), this.bezierCurveAdd(!0, e, n, a, o), this.bezierCurveAdd(!1, t, i, s, l);
  }
  addQuadraticCurve(e, t, n, i, a, s) {
    const o = e + 0.6666666666666666 * (n - e), l = t + 2 / 3 * (i - t), u = o + 1 / 3 * (a - e), c = l + 1 / 3 * (s - t);
    this.addBezierCurve(e, t, o, u, l, c, a, s);
  }
  isPointInBox(e, t) {
    const { x1: n, y1: i, x2: a, y2: s } = this;
    return n <= e && e <= a && i <= t && t <= s;
  }
};
class Tl extends Yn {
  modifiedEmSizeStack = !1;
  calculateOpacity() {
    let e = 1, t = this;
    for (; t; ) {
      const n = t.getStyle("opacity", !1, !0);
      n.hasValue(!0) && (e *= n.getNumber()), t = t.parent;
    }
    return e;
  }
  setContext(e, t = !1) {
    if (!t) {
      const n = this.getStyle("fill"), i = this.getStyle("fill-opacity"), a = this.getStyle("stroke"), s = this.getStyle("stroke-opacity");
      if (n.isUrlDefinition()) {
        const h = n.getFillStyleDefinition(this, i);
        h && (e.fillStyle = h);
      } else if (n.hasValue()) {
        n.getString() === "currentColor" && n.setValue(this.getStyle("color").getColor());
        const h = n.getColor();
        h !== "inherit" && (e.fillStyle = h === "none" ? "rgba(0,0,0,0)" : h);
      }
      if (i.hasValue()) {
        const h = new Mt(this.document, "fill", e.fillStyle).addOpacity(i).getColor();
        e.fillStyle = h;
      }
      if (a.isUrlDefinition()) {
        const h = a.getFillStyleDefinition(this, s);
        h && (e.strokeStyle = h);
      } else if (a.hasValue()) {
        a.getString() === "currentColor" && a.setValue(this.getStyle("color").getColor());
        const h = a.getString();
        h !== "inherit" && (e.strokeStyle = h === "none" ? "rgba(0,0,0,0)" : h);
      }
      if (s.hasValue()) {
        const h = new Mt(this.document, "stroke", e.strokeStyle).addOpacity(s).getString();
        e.strokeStyle = h;
      }
      const o = this.getStyle("stroke-width");
      if (o.hasValue()) {
        const h = o.getPixels();
        e.lineWidth = h || Bu;
      }
      const l = this.getStyle("stroke-linecap"), u = this.getStyle("stroke-linejoin"), c = this.getStyle("stroke-miterlimit"), d = this.getStyle("stroke-dasharray"), f = this.getStyle("stroke-dashoffset");
      if (l.hasValue() && (e.lineCap = l.getString()), u.hasValue() && (e.lineJoin = u.getString()), c.hasValue() && (e.miterLimit = c.getNumber()), d.hasValue() && d.getString() !== "none") {
        const h = $i(d.getString());
        typeof e.setLineDash < "u" ? e.setLineDash(h) : typeof e.webkitLineDash < "u" ? e.webkitLineDash = h : typeof e.mozDash < "u" && !(h.length === 1 && h[0] === 0) && (e.mozDash = h);
        const g = f.getPixels();
        typeof e.lineDashOffset < "u" ? e.lineDashOffset = g : typeof e.webkitLineDashOffset < "u" ? e.webkitLineDashOffset = g : typeof e.mozDashOffset < "u" && (e.mozDashOffset = g);
      }
    }
    if (this.modifiedEmSizeStack = !1, typeof e.font < "u") {
      const n = this.getStyle("font"), i = this.getStyle("font-style"), a = this.getStyle("font-variant"), s = this.getStyle("font-weight"), o = this.getStyle("font-size"), l = this.getStyle("font-family"), u = new qu(i.getString(), a.getString(), s.getString(), o.hasValue() ? `${o.getPixels(!0)}px` : "", l.getString(), qu.parse(n.getString(), e.font));
      i.setValue(u.fontStyle), a.setValue(u.fontVariant), s.setValue(u.fontWeight), o.setValue(u.fontSize), l.setValue(u.fontFamily), e.font = u.toString(), o.isPixels() && (this.document.emSize = o.getPixels(), this.modifiedEmSizeStack = !0);
    }
    t || (this.applyEffects(e), e.globalAlpha = this.calculateOpacity());
  }
  clearContext(e) {
    super.clearContext(e), this.modifiedEmSizeStack && this.document.popEmSize();
  }
}
class wo extends Tl {
  type = "text";
  x = 0;
  y = 0;
  leafTexts = [];
  textChunkStart = 0;
  minX = Number.POSITIVE_INFINITY;
  maxX = Number.NEGATIVE_INFINITY;
  measureCache = -1;
  constructor(e, t, n) {
    super(e, t, new.target === wo ? !0 : n);
  }
  setContext(e, t = !1) {
    super.setContext(e, t);
    const n = this.getStyle("dominant-baseline").getTextBaseline() || this.getStyle("alignment-baseline").getTextBaseline();
    n && (e.textBaseline = n);
  }
  initializeCoordinates() {
    this.x = 0, this.y = 0, this.leafTexts = [], this.textChunkStart = 0, this.minX = Number.POSITIVE_INFINITY, this.maxX = Number.NEGATIVE_INFINITY;
  }
  getBoundingBox(e) {
    if (this.type !== "text")
      return this.getTElementBoundingBox(e);
    this.initializeCoordinates(), this.adjustChildCoordinatesRecursive(e);
    let t = null;
    return this.children.forEach((n, i) => {
      const a = this.getChildBoundingBox(e, this, this, i);
      t ? t.addBoundingBox(a) : t = a;
    }), t;
  }
  getFontSize() {
    const { document: e, parent: t } = this, n = qu.parse(e.ctx.font).fontSize;
    return t.getStyle("font-size").getNumber(n);
  }
  getTElementBoundingBox(e) {
    const t = this.getFontSize();
    return new Ba(this.x, this.y - t, this.x + this.measureText(e), this.y);
  }
  getGlyph(e, t, n) {
    const i = t[n];
    let a;
    if (e.isArabic) {
      const s = t.length, o = t[n - 1], l = t[n + 1];
      let u = "isolated";
      (n === 0 || o === " ") && n < s - 1 && l !== " " && (u = "terminal"), n > 0 && o !== " " && n < s - 1 && l !== " " && (u = "medial"), n > 0 && o !== " " && (n === s - 1 || l === " ") && (u = "initial"), a = e.arabicGlyphs[i]?.[u] || e.glyphs[i];
    } else
      a = e.glyphs[i];
    return a || (a = e.missingGlyph), a;
  }
  getText() {
    return "";
  }
  getTextFromNode(e) {
    return (e || this.node).textContent;
  }
  renderChildren(e) {
    if (this.type !== "text") {
      this.renderTElementChildren(e);
      return;
    }
    this.initializeCoordinates(), this.adjustChildCoordinatesRecursive(e), this.children.forEach((n, i) => {
      this.renderChild(e, this, this, i);
    });
    const { mouse: t } = this.document.screen;
    t.isWorking() && t.checkBoundingBox(this, this.getBoundingBox(e));
  }
  renderTElementChildren(e) {
    const { document: t, parent: n } = this, i = this.getText(), a = n.getStyle("font-family").getDefinition();
    if (a?.fontFace) {
      const { unitsPerEm: l } = a.fontFace, u = qu.parse(t.ctx.font), c = n.getStyle("font-size").getNumber(u.fontSize), d = n.getStyle("font-style").getString(u.fontStyle), f = c / l, h = a.isRTL ? i.split("").reverse().join("") : i, g = $i(n.getAttribute("dx").getString()), v = h.length;
      for (let y = 0; y < v; y++) {
        const A = this.getGlyph(a, h, y);
        e.translate(this.x, this.y), e.scale(f, -f);
        const x = e.lineWidth;
        e.lineWidth = e.lineWidth * l / c, d === "italic" && e.transform(1, 0, 0.4, 1, 0, 0), A.render(e), d === "italic" && e.transform(1, 0, -0.4, 1, 0, 0), e.lineWidth = x, e.scale(1 / f, -1 / f), e.translate(-this.x, -this.y), this.x += c * (A.horizAdvX || a.horizAdvX) / l, typeof g[y] < "u" && !isNaN(g[y]) && (this.x += g[y]);
      }
      return;
    }
    const { x: s, y: o } = this;
    e.fillStyle && e.fillText(i, s, o), e.strokeStyle && e.strokeText(i, s, o);
  }
  applyAnchoring() {
    if (this.textChunkStart >= this.leafTexts.length)
      return;
    const e = this.leafTexts[this.textChunkStart], t = e.getStyle("text-anchor").getString("start"), n = !1;
    let i = 0;
    t === "start" && !n || t === "end" && n ? i = e.x - this.minX : t === "end" && !n || t === "start" && n ? i = e.x - this.maxX : i = e.x - (this.minX + this.maxX) / 2;
    for (let a = this.textChunkStart; a < this.leafTexts.length; a++)
      this.leafTexts[a].x += i;
    this.minX = Number.POSITIVE_INFINITY, this.maxX = Number.NEGATIVE_INFINITY, this.textChunkStart = this.leafTexts.length;
  }
  adjustChildCoordinatesRecursive(e) {
    this.children.forEach((t, n) => {
      this.adjustChildCoordinatesRecursiveCore(e, this, this, n);
    }), this.applyAnchoring();
  }
  adjustChildCoordinatesRecursiveCore(e, t, n, i) {
    const a = n.children[i];
    a.children.length > 0 ? a.children.forEach((s, o) => {
      t.adjustChildCoordinatesRecursiveCore(e, t, a, o);
    }) : this.adjustChildCoordinates(e, t, n, i);
  }
  adjustChildCoordinates(e, t, n, i) {
    const a = n.children[i];
    if (typeof a.measureText != "function")
      return a;
    e.save(), a.setContext(e, !0);
    const s = a.getAttribute("x"), o = a.getAttribute("y"), l = a.getAttribute("dx"), u = a.getAttribute("dy"), d = !!a.getStyle("font-family").getDefinition()?.isRTL;
    i === 0 && (s.hasValue() || s.setValue(a.getInheritedAttribute("x")), o.hasValue() || o.setValue(a.getInheritedAttribute("y")), l.hasValue() || l.setValue(a.getInheritedAttribute("dx")), u.hasValue() || u.setValue(a.getInheritedAttribute("dy")));
    const f = a.measureText(e);
    return d && (t.x -= f), s.hasValue() ? (t.applyAnchoring(), a.x = s.getPixels("x"), l.hasValue() && (a.x += l.getPixels("x"))) : (l.hasValue() && (t.x += l.getPixels("x")), a.x = t.x), t.x = a.x, d || (t.x += f), o.hasValue() ? (a.y = o.getPixels("y"), u.hasValue() && (a.y += u.getPixels("y"))) : (u.hasValue() && (t.y += u.getPixels("y")), a.y = t.y), t.y = a.y, t.leafTexts.push(a), t.minX = Math.min(t.minX, a.x, a.x + f), t.maxX = Math.max(t.maxX, a.x, a.x + f), a.clearContext(e), e.restore(), a;
  }
  getChildBoundingBox(e, t, n, i) {
    const a = n.children[i];
    if (typeof a.getBoundingBox != "function")
      return null;
    const s = a.getBoundingBox(e);
    return s && a.children.forEach((o, l) => {
      const u = t.getChildBoundingBox(e, t, a, l);
      s.addBoundingBox(u);
    }), s;
  }
  renderChild(e, t, n, i) {
    const a = n.children[i];
    a.render(e), a.children.forEach((s, o) => {
      t.renderChild(e, t, a, o);
    });
  }
  measureText(e) {
    const { measureCache: t } = this;
    if (~t)
      return t;
    const n = this.getText(), i = this.measureTargetText(e, n);
    return this.measureCache = i, i;
  }
  measureTargetText(e, t) {
    if (!t.length)
      return 0;
    const { parent: n } = this, i = n.getStyle("font-family").getDefinition();
    if (i) {
      const s = this.getFontSize(), o = i.isRTL ? t.split("").reverse().join("") : t, l = $i(n.getAttribute("dx").getString()), u = o.length;
      let c = 0;
      for (let d = 0; d < u; d++) {
        const f = this.getGlyph(i, o, d);
        c += (f.horizAdvX || i.horizAdvX) * s / i.fontFace.unitsPerEm, typeof l[d] < "u" && !isNaN(l[d]) && (c += l[d]);
      }
      return c;
    }
    if (!e.measureText)
      return t.length * 10;
    e.save(), this.setContext(e, !0);
    const { width: a } = e.measureText(t);
    return this.clearContext(e), e.restore(), a;
  }
  /**
   * Inherits positional attributes from {@link TextElement} parent(s). Attributes
   * are only inherited from a parent to its first child.
   * @param name - The attribute name.
   * @returns The attribute value or null.
   */
  getInheritedAttribute(e) {
    let t = this;
    for (; t instanceof wo && t.isFirstChild() && t.parent; ) {
      const n = t.parent.getAttribute(e);
      if (n.hasValue(!0))
        return n.getString("0");
      t = t.parent;
    }
    return null;
  }
}
class Rg extends wo {
  type = "tspan";
  text;
  constructor(e, t, n) {
    super(e, t, new.target === Rg ? !0 : n), this.text = this.children.length > 0 ? "" : this.getTextFromNode();
  }
  getText() {
    return this.text;
  }
}
class _3 extends Rg {
  type = "textNode";
}
class cr extends Le {
  control = new Pn(0, 0);
  start = new Pn(0, 0);
  current = new Pn(0, 0);
  command = null;
  i = -1;
  previousCommand = null;
  points = [];
  angles = [];
  constructor(e) {
    super(e.replace(/([+\-.])\s+/gm, "$1").replace(/[^MmZzLlHhVvCcSsQqTtAae\d\s.,+-].*/g, ""));
  }
  reset() {
    this.i = -1, this.command = null, this.previousCommand = null, this.start = new Pn(0, 0), this.control = new Pn(0, 0), this.current = new Pn(0, 0), this.points = [], this.angles = [];
  }
  isEnd() {
    const { i: e, commands: t } = this;
    return e >= t.length - 1;
  }
  next() {
    const e = this.commands[++this.i];
    return this.previousCommand = this.command, this.command = e, e;
  }
  getPoint(e = "x", t = "y") {
    const n = new Pn(this.command[e], this.command[t]);
    return this.makeAbsolute(n);
  }
  getAsControlPoint(e, t) {
    const n = this.getPoint(e, t);
    return this.control = n, n;
  }
  getAsCurrentPoint(e, t) {
    const n = this.getPoint(e, t);
    return this.current = n, n;
  }
  getReflectedControlPoint() {
    const e = this.previousCommand.type;
    if (e !== Le.CURVE_TO && e !== Le.SMOOTH_CURVE_TO && e !== Le.QUAD_TO && e !== Le.SMOOTH_QUAD_TO)
      return this.current;
    const { current: { x: t, y: n }, control: { x: i, y: a } } = this;
    return new Pn(2 * t - i, 2 * n - a);
  }
  makeAbsolute(e) {
    if (this.command.relative) {
      const { x: t, y: n } = this.current;
      e.x += t, e.y += n;
    }
    return e;
  }
  addMarker(e, t, n) {
    const { points: i, angles: a } = this;
    n && a.length > 0 && !a[a.length - 1] && (a[a.length - 1] = i[i.length - 1].angleTo(n)), this.addMarkerAngle(e, t ? t.angleTo(e) : null);
  }
  addMarkerAngle(e, t) {
    this.points.push(e), this.angles.push(t);
  }
  getMarkerPoints() {
    return this.points;
  }
  getMarkerAngles() {
    const { angles: e } = this, t = e.length;
    for (let n = 0; n < t; n++)
      if (!e[n]) {
        for (let i = n + 1; i < t; i++)
          if (e[i]) {
            e[n] = e[i];
            break;
          }
      }
    return e;
  }
}
class Kr extends Tl {
  type = "path";
  pathParser;
  constructor(e, t, n) {
    super(e, t, n), this.pathParser = new cr(this.getAttribute("d").getString());
  }
  path(e) {
    const { pathParser: t } = this, n = new Ba();
    for (t.reset(), e && e.beginPath(); !t.isEnd(); )
      switch (t.next().type) {
        case cr.MOVE_TO:
          this.pathM(e, n);
          break;
        case cr.LINE_TO:
          this.pathL(e, n);
          break;
        case cr.HORIZ_LINE_TO:
          this.pathH(e, n);
          break;
        case cr.VERT_LINE_TO:
          this.pathV(e, n);
          break;
        case cr.CURVE_TO:
          this.pathC(e, n);
          break;
        case cr.SMOOTH_CURVE_TO:
          this.pathS(e, n);
          break;
        case cr.QUAD_TO:
          this.pathQ(e, n);
          break;
        case cr.SMOOTH_QUAD_TO:
          this.pathT(e, n);
          break;
        case cr.ARC:
          this.pathA(e, n);
          break;
        case cr.CLOSE_PATH:
          this.pathZ(e, n);
          break;
      }
    return n;
  }
  getBoundingBox(e) {
    return this.path();
  }
  getMarkers() {
    const { pathParser: e } = this, t = e.getMarkerPoints(), n = e.getMarkerAngles();
    return !t || !n ? null : t.map((a, s) => [a, n[s]]);
  }
  renderChildren(e) {
    this.path(e), this.document.screen.mouse.checkPath(this, e);
    const t = this.getStyle("fill-rule");
    e.fillStyle !== "" && (t.getString("inherit") !== "inherit" ? e.fill(t.getString()) : e.fill()), e.strokeStyle !== "" && (this.getAttribute("vector-effect").getString() === "non-scaling-stroke" ? (e.save(), e.setTransform(1, 0, 0, 1, 0, 0), e.stroke(), e.restore()) : e.stroke());
    const n = this.getMarkers();
    if (n) {
      const i = n.length - 1, a = this.getStyle("marker-start"), s = this.getStyle("marker-mid"), o = this.getStyle("marker-end");
      if (a.isUrlDefinition()) {
        const l = a.getDefinition(), [u, c] = n[0];
        l && l.render(e, u, c === null ? void 0 : c);
      }
      if (s.isUrlDefinition()) {
        const l = s.getDefinition();
        for (let u = 1; u < i; u++) {
          const [c, d] = n[u];
          l && l.render(e, c, d === null ? void 0 : d);
        }
      }
      if (o.isUrlDefinition()) {
        const l = o.getDefinition(), [u, c] = n[i];
        l && l.render(e, u, c === null ? void 0 : c);
      }
    }
  }
  static pathM(e) {
    const t = e.getAsCurrentPoint();
    return e.start = e.current, {
      point: t
    };
  }
  pathM(e, t) {
    const { pathParser: n } = this, { point: i } = Kr.pathM(n), { x: a, y: s } = i;
    n.addMarker(i), t.addPoint(a, s), e && e.moveTo(a, s);
  }
  static pathL(e) {
    const { current: t } = e, n = e.getAsCurrentPoint();
    return {
      current: t,
      point: n
    };
  }
  pathL(e, t) {
    const { pathParser: n } = this, { current: i, point: a } = Kr.pathL(n), { x: s, y: o } = a;
    n.addMarker(a, i), t.addPoint(s, o), e && e.lineTo(s, o);
  }
  static pathH(e) {
    const { current: t, command: n } = e, i = new Pn((n?.relative ? t.x : 0) + n.x, t.y);
    return e.current = i, {
      current: t,
      point: i
    };
  }
  pathH(e, t) {
    const { pathParser: n } = this, { current: i, point: a } = Kr.pathH(n), { x: s, y: o } = a;
    n.addMarker(a, i), t.addPoint(s, o), e && e.lineTo(s, o);
  }
  static pathV(e) {
    const { current: t, command: n } = e, i = new Pn(t.x, (n.relative ? t.y : 0) + n.y);
    return e.current = i, {
      current: t,
      point: i
    };
  }
  pathV(e, t) {
    const { pathParser: n } = this, { current: i, point: a } = Kr.pathV(n), { x: s, y: o } = a;
    n.addMarker(a, i), t.addPoint(s, o), e && e.lineTo(s, o);
  }
  static pathC(e) {
    const { current: t } = e, n = e.getPoint("x1", "y1"), i = e.getAsControlPoint("x2", "y2"), a = e.getAsCurrentPoint();
    return {
      current: t,
      point: n,
      controlPoint: i,
      currentPoint: a
    };
  }
  pathC(e, t) {
    const { pathParser: n } = this, { current: i, point: a, controlPoint: s, currentPoint: o } = Kr.pathC(n);
    n.addMarker(o, s, a), t.addBezierCurve(i.x, i.y, a.x, a.y, s.x, s.y, o.x, o.y), e && e.bezierCurveTo(a.x, a.y, s.x, s.y, o.x, o.y);
  }
  static pathS(e) {
    const { current: t } = e, n = e.getReflectedControlPoint(), i = e.getAsControlPoint("x2", "y2"), a = e.getAsCurrentPoint();
    return {
      current: t,
      point: n,
      controlPoint: i,
      currentPoint: a
    };
  }
  pathS(e, t) {
    const { pathParser: n } = this, { current: i, point: a, controlPoint: s, currentPoint: o } = Kr.pathS(n);
    n.addMarker(o, s, a), t.addBezierCurve(i.x, i.y, a.x, a.y, s.x, s.y, o.x, o.y), e && e.bezierCurveTo(a.x, a.y, s.x, s.y, o.x, o.y);
  }
  static pathQ(e) {
    const { current: t } = e, n = e.getAsControlPoint("x1", "y1"), i = e.getAsCurrentPoint();
    return {
      current: t,
      controlPoint: n,
      currentPoint: i
    };
  }
  pathQ(e, t) {
    const { pathParser: n } = this, { current: i, controlPoint: a, currentPoint: s } = Kr.pathQ(n);
    n.addMarker(s, a, a), t.addQuadraticCurve(i.x, i.y, a.x, a.y, s.x, s.y), e && e.quadraticCurveTo(a.x, a.y, s.x, s.y);
  }
  static pathT(e) {
    const { current: t } = e, n = e.getReflectedControlPoint();
    e.control = n;
    const i = e.getAsCurrentPoint();
    return {
      current: t,
      controlPoint: n,
      currentPoint: i
    };
  }
  pathT(e, t) {
    const { pathParser: n } = this, { current: i, controlPoint: a, currentPoint: s } = Kr.pathT(n);
    n.addMarker(s, a, a), t.addQuadraticCurve(i.x, i.y, a.x, a.y, s.x, s.y), e && e.quadraticCurveTo(a.x, a.y, s.x, s.y);
  }
  static pathA(e) {
    const { current: t, command: n } = e;
    let { rX: i, rY: a, xRot: s, lArcFlag: o, sweepFlag: l } = n;
    const u = s * (Math.PI / 180), c = e.getAsCurrentPoint(), d = new Pn(Math.cos(u) * (t.x - c.x) / 2 + Math.sin(u) * (t.y - c.y) / 2, -Math.sin(u) * (t.x - c.x) / 2 + Math.cos(u) * (t.y - c.y) / 2), f = Math.pow(d.x, 2) / Math.pow(i, 2) + Math.pow(d.y, 2) / Math.pow(a, 2);
    f > 1 && (i *= Math.sqrt(f), a *= Math.sqrt(f));
    let h = (o === l ? -1 : 1) * Math.sqrt((Math.pow(i, 2) * Math.pow(a, 2) - Math.pow(i, 2) * Math.pow(d.y, 2) - Math.pow(a, 2) * Math.pow(d.x, 2)) / (Math.pow(i, 2) * Math.pow(d.y, 2) + Math.pow(a, 2) * Math.pow(d.x, 2)));
    isNaN(h) && (h = 0);
    const g = new Pn(h * i * d.y / a, h * -a * d.x / i), v = new Pn((t.x + c.x) / 2 + Math.cos(u) * g.x - Math.sin(u) * g.y, (t.y + c.y) / 2 + Math.sin(u) * g.x + Math.cos(u) * g.y), y = vx([1, 0], [(d.x - g.x) / i, (d.y - g.y) / a]), A = [(d.x - g.x) / i, (d.y - g.y) / a], x = [(-d.x - g.x) / i, (-d.y - g.y) / a];
    let k = vx(A, x);
    return Py(A, x) <= -1 && (k = Math.PI), Py(A, x) >= 1 && (k = 0), {
      currentPoint: c,
      rX: i,
      rY: a,
      sweepFlag: l,
      xAxisRotation: u,
      centp: v,
      a1: y,
      ad: k
    };
  }
  pathA(e, t) {
    const { pathParser: n } = this, { currentPoint: i, rX: a, rY: s, sweepFlag: o, xAxisRotation: l, centp: u, a1: c, ad: d } = Kr.pathA(n), f = 1 - o ? 1 : -1, h = c + f * (d / 2), g = new Pn(u.x + a * Math.cos(h), u.y + s * Math.sin(h));
    if (n.addMarkerAngle(g, h - f * Math.PI / 2), n.addMarkerAngle(i, h - f * Math.PI), t.addPoint(i.x, i.y), e && !isNaN(c) && !isNaN(d)) {
      const v = a > s ? a : s, y = a > s ? 1 : a / s, A = a > s ? s / a : 1;
      e.translate(u.x, u.y), e.rotate(l), e.scale(y, A), e.arc(0, 0, v, c, c + d, !!(1 - o)), e.scale(1 / y, 1 / A), e.rotate(-l), e.translate(-u.x, -u.y);
    }
  }
  static pathZ(e) {
    e.current = e.start;
  }
  pathZ(e, t) {
    Kr.pathZ(this.pathParser), e && t.x1 !== t.x2 && t.y1 !== t.y2 && e.closePath();
  }
}
class Pd extends Tl {
  type = "svg";
  root = !1;
  setContext(e) {
    const { document: t } = this, { screen: n, window: i } = t, a = e.canvas;
    if (n.setDefaults(e), "style" in a && typeof e.font < "u" && i && typeof i.getComputedStyle < "u") {
      e.font = i.getComputedStyle(a).getPropertyValue("font");
      const A = new Mt(t, "fontSize", qu.parse(e.font).fontSize);
      A.hasValue() && (t.rootEmSize = A.getPixels("y"), t.emSize = t.rootEmSize);
    }
    this.getAttribute("x").hasValue() || this.getAttribute("x", !0).setValue(0), this.getAttribute("y").hasValue() || this.getAttribute("y", !0).setValue(0);
    let { width: s, height: o } = n.viewPort;
    this.getStyle("width").hasValue() || this.getStyle("width", !0).setValue("100%"), this.getStyle("height").hasValue() || this.getStyle("height", !0).setValue("100%"), this.getStyle("color").hasValue() || this.getStyle("color", !0).setValue("black");
    const l = this.getAttribute("refX"), u = this.getAttribute("refY"), c = this.getAttribute("viewBox"), d = c.hasValue() ? $i(c.getString()) : null, f = !this.root && this.getStyle("overflow").getValue("hidden") !== "visible";
    let h = 0, g = 0, v = 0, y = 0;
    d && (h = d[0], g = d[1]), this.root || (s = this.getStyle("width").getPixels("x"), o = this.getStyle("height").getPixels("y"), this.type === "marker" && (v = h, y = g, h = 0, g = 0)), n.viewPort.setCurrent(s, o), this.node && (!this.parent || this.node.parentNode?.nodeName === "foreignObject") && this.getStyle("transform", !1, !0).hasValue() && !this.getStyle("transform-origin", !1, !0).hasValue() && this.getStyle("transform-origin", !0, !0).setValue("50% 50%"), super.setContext(e), e.translate(this.getAttribute("x").getPixels("x"), this.getAttribute("y").getPixels("y")), d && (s = d[2], o = d[3]), t.setViewBox({
      ctx: e,
      aspectRatio: this.getAttribute("preserveAspectRatio").getString(),
      width: n.viewPort.width,
      desiredWidth: s,
      height: n.viewPort.height,
      desiredHeight: o,
      minX: h,
      minY: g,
      refX: l.getValue(),
      refY: u.getValue(),
      clip: f,
      clipX: v,
      clipY: y
    }), d && (n.viewPort.removeCurrent(), n.viewPort.setCurrent(s, o));
  }
  clearContext(e) {
    super.clearContext(e), this.document.screen.viewPort.removeCurrent();
  }
  /**
   * Resize SVG to fit in given size.
   * @param width
   * @param height
   * @param preserveAspectRatio
   */
  resize(e, t = e, n = !1) {
    const i = this.getAttribute("width", !0), a = this.getAttribute("height", !0), s = this.getAttribute("viewBox"), o = this.getAttribute("style"), l = i.getNumber(0), u = a.getNumber(0);
    if (n)
      if (typeof n == "string")
        this.getAttribute("preserveAspectRatio", !0).setValue(n);
      else {
        const c = this.getAttribute("preserveAspectRatio");
        c.hasValue() && c.setValue(c.getString().replace(/^\s*(\S.*\S)\s*$/, "$1"));
      }
    if (i.setValue(e), a.setValue(t), s.hasValue() || s.setValue(`0 0 ${l || e} ${u || t}`), o.hasValue()) {
      const c = this.getStyle("width"), d = this.getStyle("height");
      c.hasValue() && c.setValue(`${e}px`), d.hasValue() && d.setValue(`${t}px`);
    }
  }
}
class Jk extends Kr {
  type = "rect";
  path(e) {
    const t = this.getAttribute("x").getPixels("x"), n = this.getAttribute("y").getPixels("y"), i = this.getStyle("width", !1, !0).getPixels("x"), a = this.getStyle("height", !1, !0).getPixels("y"), s = this.getAttribute("rx"), o = this.getAttribute("ry");
    let l = s.getPixels("x"), u = o.getPixels("y");
    if (s.hasValue() && !o.hasValue() && (u = l), o.hasValue() && !s.hasValue() && (l = u), l = Math.min(l, i / 2), u = Math.min(u, a / 2), e) {
      const c = 4 * ((Math.sqrt(2) - 1) / 3);
      e.beginPath(), a > 0 && i > 0 && (e.moveTo(t + l, n), e.lineTo(t + i - l, n), e.bezierCurveTo(t + i - l + c * l, n, t + i, n + u - c * u, t + i, n + u), e.lineTo(t + i, n + a - u), e.bezierCurveTo(t + i, n + a - u + c * u, t + i - l + c * l, n + a, t + i - l, n + a), e.lineTo(t + l, n + a), e.bezierCurveTo(t + l - c * l, n + a, t, n + a - u + c * u, t, n + a - u), e.lineTo(t, n + u), e.bezierCurveTo(t, n + u - c * u, t + l - c * l, n, t + l, n), e.closePath());
    }
    return new Ba(t, n, t + i, n + a);
  }
  getMarkers() {
    return null;
  }
}
class N3 extends Kr {
  type = "circle";
  path(e) {
    const t = this.getAttribute("cx").getPixels("x"), n = this.getAttribute("cy").getPixels("y"), i = this.getAttribute("r").getPixels();
    return e && i > 0 && (e.beginPath(), e.arc(t, n, i, 0, Math.PI * 2, !1), e.closePath()), new Ba(t - i, n - i, t + i, n + i);
  }
  getMarkers() {
    return null;
  }
}
class L3 extends Kr {
  type = "ellipse";
  path(e) {
    const t = 4 * ((Math.sqrt(2) - 1) / 3), n = this.getAttribute("rx").getPixels("x"), i = this.getAttribute("ry").getPixels("y"), a = this.getAttribute("cx").getPixels("x"), s = this.getAttribute("cy").getPixels("y");
    return e && n > 0 && i > 0 && (e.beginPath(), e.moveTo(a + n, s), e.bezierCurveTo(a + n, s + t * i, a + t * n, s + i, a, s + i), e.bezierCurveTo(a - t * n, s + i, a - n, s + t * i, a - n, s), e.bezierCurveTo(a - n, s - t * i, a - t * n, s - i, a, s - i), e.bezierCurveTo(a + t * n, s - i, a + n, s - t * i, a + n, s), e.closePath()), new Ba(a - n, s - i, a + n, s + i);
  }
  getMarkers() {
    return null;
  }
}
class U3 extends Kr {
  type = "line";
  getPoints() {
    return [
      new Pn(this.getAttribute("x1").getPixels("x"), this.getAttribute("y1").getPixels("y")),
      new Pn(this.getAttribute("x2").getPixels("x"), this.getAttribute("y2").getPixels("y"))
    ];
  }
  path(e) {
    const [{ x: t, y: n }, { x: i, y: a }] = this.getPoints();
    return e && (e.beginPath(), e.moveTo(t, n), e.lineTo(i, a)), new Ba(t, n, i, a);
  }
  getMarkers() {
    const [e, t] = this.getPoints(), n = e.angleTo(t);
    return [[e, n], [t, n]];
  }
}
class Kk extends Kr {
  type = "polyline";
  points = [];
  constructor(e, t, n) {
    super(e, t, n), this.points = Pn.parsePath(this.getAttribute("points").getString());
  }
  path(e) {
    const { points: t } = this, [{ x: n, y: i }] = t, a = new Ba(n, i);
    return e && (e.beginPath(), e.moveTo(n, i)), t.forEach(({ x: s, y: o }) => {
      a.addPoint(s, o), e && e.lineTo(s, o);
    }), a;
  }
  getMarkers() {
    const { points: e } = this, t = e.length - 1, n = [];
    return e.forEach((i, a) => {
      a !== t && n.push([i, i.angleTo(e[a + 1])]);
    }), n.length > 0 && n.push([e[e.length - 1], n[n.length - 1][1]]), n;
  }
}
class V3 extends Kk {
  type = "polygon";
  path(e) {
    const t = super.path(e), [{ x: n, y: i }] = this.points;
    return e && (e.lineTo(n, i), e.closePath()), t;
  }
}
class z3 extends Yn {
  type = "pattern";
  createPattern(e, t, n) {
    const i = this.getStyle("width").getPixels("x", !0), a = this.getStyle("height").getPixels("y", !0), s = this.getAttribute("data-frame-width"), o = this.getAttribute("data-frame-height"), l = s.hasValue() ? s.getPixels("x", !0) : i, u = o.hasValue() ? o.getPixels("y", !0) : a, c = s.hasValue() && o.hasValue(), d = new Pd(this.document, void 0);
    d.attributes.viewBox = new Mt(this.document, "viewBox", this.getAttribute("viewBox").getValue()), d.attributes.width = new Mt(this.document, "width", `${l}px`), d.attributes.height = new Mt(this.document, "height", `${u}px`), d.attributes.transform = new Mt(this.document, "transform", this.getAttribute("patternTransform").getValue()), d.children = this.children;
    const f = this.document.createCanvas(l, u), h = f.getContext("2d");
    h.imageSmoothingEnabled = !0, h.imageSmoothingQuality = "high";
    const g = this.getAttribute("x"), v = this.getAttribute("y");
    g.hasValue() && v.hasValue() && h.translate(g.getPixels("x", !0), v.getPixels("y", !0)), n.hasValue() ? this.styles["fill-opacity"] = n : Reflect.deleteProperty(this.styles, "fill-opacity");
    for (let A = -1; A <= 1; A++)
      for (let x = -1; x <= 1; x++)
        h.save(), d.attributes.x = new Mt(this.document, "x", A * f.width), d.attributes.y = new Mt(this.document, "y", x * f.height), d.render(h), h.restore();
    return e.createPattern(f, c ? "no-repeat" : "repeat");
  }
}
class $3 extends Yn {
  type = "marker";
  render(e, t, n) {
    if (!t)
      return;
    const { x: i, y: a } = t, s = this.getAttribute("orient").getString("auto"), o = this.getAttribute("markerUnits").getString("strokeWidth");
    e.translate(i, a), s === "auto" && n && e.rotate(n), o === "strokeWidth" && e.scale(e.lineWidth, e.lineWidth), e.save();
    const l = new Pd(this.document);
    l.type = this.type, l.attributes.viewBox = new Mt(this.document, "viewBox", this.getAttribute("viewBox").getValue()), l.attributes.refX = new Mt(this.document, "refX", this.getAttribute("refX").getValue()), l.attributes.refY = new Mt(this.document, "refY", this.getAttribute("refY").getValue()), l.attributes.width = new Mt(this.document, "width", this.getAttribute("markerWidth").getValue()), l.attributes.height = new Mt(this.document, "height", this.getAttribute("markerHeight").getValue()), l.attributes.overflow = new Mt(this.document, "overflow", this.getAttribute("overflow").getValue()), l.attributes.fill = new Mt(this.document, "fill", this.getAttribute("fill").getColor("black")), l.attributes.stroke = new Mt(this.document, "stroke", this.getAttribute("stroke").getValue("none")), l.children = this.children, l.render(e), e.restore(), o === "strokeWidth" && e.scale(1 / e.lineWidth, 1 / e.lineWidth), s === "auto" && n && e.rotate(-n), e.translate(-i, -a);
  }
}
class H3 extends Yn {
  type = "defs";
  render() {
  }
}
class HA extends Tl {
  type = "g";
  getBoundingBox(e) {
    const t = new Ba();
    return this.children.forEach((n) => {
      n instanceof Kr && t.addBoundingBox(n.getBoundingBox(e));
    }), t;
  }
}
class Zk extends Yn {
  attributesToInherit = ["gradientUnits"];
  stops = [];
  constructor(e, t, n) {
    super(e, t, n);
    const { stops: i, children: a } = this;
    a.forEach((s) => {
      s.type === "stop" && i.push(s);
    });
  }
  getGradientUnits() {
    return this.getAttribute("gradientUnits").getString("objectBoundingBox");
  }
  createGradient(e, t, n) {
    let i = this;
    this.getHrefAttribute().hasValue() && (i = this.getHrefAttribute().getDefinition(), this.inheritStopContainer(i));
    const { stops: a } = i, s = this.getGradient(e, t);
    if (!s)
      return this.addParentOpacity(n, a[a.length - 1].color);
    if (a.forEach((o) => {
      s.addColorStop(o.offset, this.addParentOpacity(n, o.color));
    }), this.getAttribute("gradientTransform").hasValue()) {
      const { document: o } = this, { MAX_VIRTUAL_PIXELS: l } = Dd, { viewPort: u } = o.screen, c = u.getRoot(), d = new Jk(o);
      d.attributes.x = new Mt(o, "x", -l / 3), d.attributes.y = new Mt(o, "y", -l / 3), d.attributes.width = new Mt(o, "width", l), d.attributes.height = new Mt(o, "height", l);
      const f = new HA(o);
      f.attributes.transform = new Mt(o, "transform", this.getAttribute("gradientTransform").getValue()), f.children = [d];
      const h = new Pd(o);
      h.attributes.x = new Mt(o, "x", 0), h.attributes.y = new Mt(o, "y", 0), h.attributes.width = new Mt(o, "width", c.width), h.attributes.height = new Mt(o, "height", c.height), h.children = [f];
      const g = o.createCanvas(c.width, c.height), v = g.getContext("2d");
      return v.fillStyle = s, h.render(v), v.createPattern(g, "no-repeat");
    }
    return s;
  }
  inheritStopContainer(e) {
    this.attributesToInherit.forEach((t) => {
      !this.getAttribute(t).hasValue() && e.getAttribute(t).hasValue() && this.getAttribute(t, !0).setValue(e.getAttribute(t).getValue());
    });
  }
  addParentOpacity(e, t) {
    return e.hasValue() ? new Mt(this.document, "color", t).addOpacity(e).getColor() : t;
  }
}
class j3 extends Zk {
  type = "linearGradient";
  constructor(e, t, n) {
    super(e, t, n), this.attributesToInherit.push("x1", "y1", "x2", "y2");
  }
  getGradient(e, t) {
    const n = this.getGradientUnits() === "objectBoundingBox", i = n ? t.getBoundingBox(e) : null;
    if (n || !i)
      return null;
    !this.getAttribute("x1").hasValue() && !this.getAttribute("y1").hasValue() && !this.getAttribute("x2").hasValue() && !this.getAttribute("y2").hasValue() && (this.getAttribute("x1", !0).setValue(0), this.getAttribute("y1", !0).setValue(0), this.getAttribute("x2", !0).setValue(1), this.getAttribute("y2", !0).setValue(0));
    const a = n ? i.x + i.width * this.getAttribute("x1").getNumber() : this.getAttribute("x1").getPixels("x"), s = n ? i.y + i.height * this.getAttribute("y1").getNumber() : this.getAttribute("y1").getPixels("y"), o = n ? i.x + i.width * this.getAttribute("x2").getNumber() : this.getAttribute("x2").getPixels("x"), l = n ? i.y + i.height * this.getAttribute("y2").getNumber() : this.getAttribute("y2").getPixels("y");
    return a === o && s === l ? null : e.createLinearGradient(a, s, o, l);
  }
}
class G3 extends Zk {
  type = "radialGradient";
  constructor(e, t, n) {
    super(e, t, n), this.attributesToInherit.push("cx", "cy", "r", "fx", "fy", "fr");
  }
  getGradient(e, t) {
    const n = this.getGradientUnits() === "objectBoundingBox", i = t.getBoundingBox(e);
    if (n && !i)
      return null;
    this.getAttribute("cx").hasValue() || this.getAttribute("cx", !0).setValue("50%"), this.getAttribute("cy").hasValue() || this.getAttribute("cy", !0).setValue("50%"), this.getAttribute("r").hasValue() || this.getAttribute("r", !0).setValue("50%");
    const a = n ? i.x + i.width * this.getAttribute("cx").getNumber() : this.getAttribute("cx").getPixels("x"), s = n ? i.y + i.height * this.getAttribute("cy").getNumber() : this.getAttribute("cy").getPixels("y");
    let o = a, l = s;
    this.getAttribute("fx").hasValue() && (o = n ? i.x + i.width * this.getAttribute("fx").getNumber() : this.getAttribute("fx").getPixels("x")), this.getAttribute("fy").hasValue() && (l = n ? i.y + i.height * this.getAttribute("fy").getNumber() : this.getAttribute("fy").getPixels("y"));
    const u = n ? (i.width + i.height) / 2 * this.getAttribute("r").getNumber() : this.getAttribute("r").getPixels(), c = this.getAttribute("fr").getPixels();
    return e.createRadialGradient(o, l, c, a, s, u);
  }
}
class q3 extends Yn {
  type = "stop";
  offset;
  color;
  constructor(e, t, n) {
    super(e, t, n);
    const i = Math.max(0, Math.min(1, this.getAttribute("offset").getNumber())), a = this.getStyle("stop-opacity");
    let s = this.getStyle("stop-color", !0);
    s.getString() === "" && s.setValue("#000"), a.hasValue() && (s = s.addOpacity(a)), this.offset = i, this.color = s.getColor();
  }
}
class jA extends Yn {
  type = "animate";
  begin;
  maxDuration;
  from;
  to;
  values;
  duration = 0;
  initialValue;
  initialUnits = "";
  removed = !1;
  frozen = !1;
  constructor(e, t, n) {
    super(e, t, n), e.screen.animations.push(this), this.begin = this.getAttribute("begin").getMilliseconds(), this.maxDuration = this.begin + this.getAttribute("dur").getMilliseconds(), this.from = this.getAttribute("from"), this.to = this.getAttribute("to"), this.values = new Mt(e, "values", null);
    const i = this.getAttribute("values");
    i.hasValue() && this.values.setValue(i.getString().split(";"));
  }
  getProperty() {
    const e = this.getAttribute("attributeType").getString(), t = this.getAttribute("attributeName").getString();
    return e === "CSS" ? this.parent?.getStyle(t, !0) : this.parent?.getAttribute(t, !0);
  }
  calcValue() {
    const { initialUnits: e } = this, { progress: t, from: n, to: i } = this.getProgress();
    let a = n.getNumber() + (i.getNumber() - n.getNumber()) * t;
    return e === "%" && (a *= 100), `${a}${e}`;
  }
  update(e) {
    const { parent: t } = this, n = this.getProperty();
    if (!n)
      return !1;
    if (this.initialValue || (this.initialValue = n.getString(), this.initialUnits = n.getUnits()), this.duration > this.maxDuration) {
      const a = this.getAttribute("fill").getString("remove");
      if (this.getAttribute("repeatCount").getString() === "indefinite" || this.getAttribute("repeatDur").getString() === "indefinite")
        this.duration = 0;
      else if (a === "freeze" && !this.frozen)
        this.frozen = !0, t && n && (t.animationFrozen = !0, t.animationFrozenValue = n.getString());
      else if (a === "remove" && !this.removed)
        return this.removed = !0, t && n && n.setValue(t.animationFrozen ? t.animationFrozenValue : this.initialValue), !0;
      return !1;
    }
    this.duration += e;
    let i = !1;
    if (this.begin < this.duration) {
      let a = this.calcValue();
      const s = this.getAttribute("type");
      s.hasValue() && (a = `${s.getString()}(${a})`), n.setValue(a), i = !0;
    }
    return i;
  }
  getProgress() {
    const { document: e, values: t } = this;
    let n = (this.duration - this.begin) / (this.maxDuration - this.begin), i, a;
    if (t.hasValue()) {
      const s = n * (t.getValue().length - 1), o = Math.floor(s), l = Math.ceil(s);
      let u;
      u = t.getValue()[o], i = new Mt(e, "from", u ? parseFloat(u) : 0), u = t.getValue()[l], a = new Mt(e, "to", u ? parseFloat(u) : 0), n = (s - o) / (l - o);
    } else
      i = this.from, a = this.to;
    return {
      progress: n,
      from: i,
      to: a
    };
  }
}
class W3 extends jA {
  type = "animateColor";
  calcValue() {
    const { progress: e, from: t, to: n } = this.getProgress(), i = new Iy(t.getColor()), a = new Iy(n.getColor());
    if (i.ok && a.ok) {
      const s = i.r + (a.r - i.r) * e, o = i.g + (a.g - i.g) * e, l = i.b + (a.b - i.b) * e;
      return `rgb(${Math.floor(s)}, ${Math.floor(o)}, ${Math.floor(l)})`;
    }
    return this.getAttribute("from").getColor();
  }
}
class Q3 extends jA {
  type = "animateTransform";
  calcValue() {
    const { progress: e, from: t, to: n } = this.getProgress(), i = $i(t.getString()), a = $i(n.getString());
    return i.map((o, l) => {
      const u = a[l];
      return o + (u - o) * e;
    }).join(" ");
  }
}
class eT extends Yn {
  type = "font-face";
  ascent;
  descent;
  unitsPerEm;
  constructor(e, t, n) {
    super(e, t, n), this.ascent = this.getAttribute("ascent").getNumber(), this.descent = this.getAttribute("descent").getNumber(), this.unitsPerEm = this.getAttribute("units-per-em").getNumber();
  }
}
class GA extends Kr {
  type = "glyph";
  horizAdvX;
  unicode;
  arabicForm;
  constructor(e, t, n) {
    super(e, t, n), this.horizAdvX = this.getAttribute("horiz-adv-x").getNumber(), this.unicode = this.getAttribute("unicode").getString(), this.arabicForm = this.getAttribute("arabic-form").getString();
  }
}
class tT extends GA {
  type = "missing-glyph";
  horizAdvX = 0;
}
class Y3 extends Yn {
  type = "font";
  isArabic = !1;
  missingGlyph;
  glyphs = {};
  arabicGlyphs = {};
  horizAdvX;
  isRTL = !1;
  fontFace;
  constructor(e, t, n) {
    super(e, t, n), this.horizAdvX = this.getAttribute("horiz-adv-x").getNumber();
    const { definitions: i } = e, { children: a } = this;
    for (const s of a)
      if (s instanceof eT) {
        this.fontFace = s;
        const o = s.getStyle("font-family");
        o.hasValue() && (i[o.getString()] = this);
      } else if (s instanceof tT)
        this.missingGlyph = s;
      else if (s instanceof GA)
        if (s.arabicForm) {
          this.isRTL = !0, this.isArabic = !0;
          const o = this.arabicGlyphs[s.unicode];
          typeof o > "u" ? this.arabicGlyphs[s.unicode] = {
            [s.arabicForm]: s
          } : o[s.arabicForm] = s;
        } else
          this.glyphs[s.unicode] = s;
  }
  render() {
  }
}
class X3 extends wo {
  type = "tref";
  getText() {
    const e = this.getHrefAttribute().getDefinition();
    if (e) {
      const t = e.children[0];
      if (t)
        return t.getText();
    }
    return "";
  }
}
class J3 extends wo {
  type = "a";
  hasText;
  text;
  constructor(e, t, n) {
    super(e, t, n);
    const { childNodes: i } = t, a = i[0], s = i.length > 0 && Array.from(i).every((o) => o.nodeType === 3);
    this.hasText = s, this.text = s ? this.getTextFromNode(a) : "";
  }
  getText() {
    return this.text;
  }
  renderChildren(e) {
    if (this.hasText) {
      super.renderChildren(e);
      const { document: t, x: n, y: i } = this, { mouse: a } = t.screen, s = new Mt(t, "fontSize", qu.parse(t.ctx.font).fontSize);
      a.isWorking() && a.checkBoundingBox(this, new Ba(n, i - s.getPixels("y"), n + this.measureText(e), i));
    } else if (this.children.length > 0) {
      const t = new HA(this.document);
      t.children = this.children, t.parent = this, t.render(e);
    }
  }
  onClick() {
    const { window: e } = this.document;
    e && e.open(this.getHrefAttribute().getString());
  }
  onMouseMove() {
    const e = this.document.ctx;
    e.canvas.style.cursor = "pointer";
  }
}
class K3 extends wo {
  type = "textPath";
  textWidth = 0;
  textHeight = 0;
  pathLength = -1;
  glyphInfo = null;
  text;
  dataArray;
  letterSpacingCache = [];
  equidistantCache = null;
  measuresCache = /* @__PURE__ */ new Map([["", 0]]);
  constructor(e, t, n) {
    super(e, t, n);
    const i = this.getHrefAttribute().getDefinition();
    this.text = this.getTextFromNode(), this.dataArray = this.parsePathData(i);
  }
  getText() {
    return this.text;
  }
  path(e) {
    const { dataArray: t } = this;
    e && e.beginPath(), t.forEach(({ type: n, points: i }) => {
      switch (n) {
        case cr.LINE_TO:
          e && e.lineTo(i[0], i[1]);
          break;
        case cr.MOVE_TO:
          e && e.moveTo(i[0], i[1]);
          break;
        case cr.CURVE_TO:
          e && e.bezierCurveTo(i[0], i[1], i[2], i[3], i[4], i[5]);
          break;
        case cr.QUAD_TO:
          e && e.quadraticCurveTo(i[0], i[1], i[2], i[3]);
          break;
        case cr.ARC: {
          const [a, s, o, l, u, c, d, f] = i, h = o > l ? o : l, g = o > l ? 1 : o / l, v = o > l ? l / o : 1;
          e && (e.translate(a, s), e.rotate(d), e.scale(g, v), e.arc(0, 0, h, u, u + c, !!(1 - f)), e.scale(1 / g, 1 / v), e.rotate(-d), e.translate(-a, -s));
          break;
        }
        case cr.CLOSE_PATH:
          e && e.closePath();
          break;
      }
    });
  }
  renderChildren(e) {
    this.setTextData(e), e.save();
    const t = this.parent?.getStyle("text-decoration").getString(), n = this.getFontSize(), { glyphInfo: i } = this, a = e.fillStyle;
    t === "underline" && e.beginPath(), i.forEach((s, o) => {
      const { p0: l, p1: u, rotation: c, text: d } = s;
      e.save(), e.translate(l.x, l.y), e.rotate(c), e.fillStyle && e.fillText(d, 0, 0), e.strokeStyle && e.strokeText(d, 0, 0), e.restore(), t === "underline" && (o === 0 && e.moveTo(l.x, l.y + n / 8), e.lineTo(u.x, u.y + n / 5));
    }), t === "underline" && (e.lineWidth = n / 20, e.strokeStyle = a, e.stroke(), e.closePath()), e.restore();
  }
  getLetterSpacingAt(e = 0) {
    return this.letterSpacingCache[e] || 0;
  }
  findSegmentToFitChar(e, t, n, i, a, s, o, l, u) {
    let c = s, d = this.measureText(e, l);
    l === " " && t === "justify" && n < i && (d += (i - n) / a), u > -1 && (c += this.getLetterSpacingAt(u));
    const f = this.textHeight / 20, h = this.getEquidistantPointOnPath(c, f, 0), g = this.getEquidistantPointOnPath(c + d, f, 0), v = {
      p0: h,
      p1: g
    }, y = h && g ? Math.atan2(g.y - h.y, g.x - h.x) : 0;
    if (o) {
      const A = Math.cos(Math.PI / 2 + y) * o, x = Math.cos(-y) * o;
      v.p0 = {
        ...h,
        distance: h.distance || 0,
        x: h.x + A,
        y: h.y + x
      }, v.p1 = {
        ...g,
        distance: g.distance || 0,
        x: g.x + A,
        y: g.y + x
      };
    }
    return c += d, {
      offset: c,
      segment: v,
      rotation: y
    };
  }
  measureText(e, t) {
    const { measuresCache: n } = this, i = t || this.getText();
    if (n.has(i))
      return n.get(i);
    const a = this.measureTargetText(e, i);
    return n.set(i, a), a;
  }
  // This method supposes what all custom fonts already loaded.
  // If some font will be loaded after this method call, <textPath> will not be rendered correctly.
  // You need to call this method manually to update glyphs cache.
  setTextData(e) {
    if (this.glyphInfo)
      return;
    const t = this.getText(), n = t.split(""), i = t.split(" ").length - 1, a = this.parent?.getAttribute("dx").split().map((k) => k.getPixels("x")), s = this.parent?.getAttribute("dy").getPixels("y"), o = this.getAttribute("text-anchor").getString("start"), l = this.getStyle("letter-spacing"), u = this.parent?.getStyle("letter-spacing");
    let c = 0;
    !l.hasValue() || l.getValue() === "inherit" ? c = u.getPixels() : l.hasValue() && l.getValue() !== "initial" && l.getValue() !== "unset" && (c = l.getPixels());
    const d = [], f = t.length;
    this.letterSpacingCache = d;
    for (let k = 0; k < f; k++)
      d.push(typeof a[k] < "u" ? a[k] : c);
    const h = d.reduce((k, F, S) => S === 0 ? 0 : k + F || 0, 0), g = this.measureText(e), v = Math.max(g + h, 0);
    this.textWidth = g, this.textHeight = this.getFontSize(), this.glyphInfo = [];
    const y = this.getPathLength(), A = this.getAttribute("startOffset").getNumber(0) * y;
    let x = 0;
    (o === "middle" || o === "center") && (x = -v / 2), (o === "end" || o === "right") && (x = -v), x += A, n.forEach((k, F) => {
      const { offset: S, segment: R, rotation: M } = this.findSegmentToFitChar(e, o, v, y, i, x, s, k, F);
      x = S, !(!R.p0 || !R.p1) && this.glyphInfo.push({
        // transposeX: midpoint.x,
        // transposeY: midpoint.y,
        text: n[F],
        p0: R.p0,
        p1: R.p1,
        rotation: M
      });
    });
  }
  parsePathData(e) {
    if (this.pathLength = -1, !e)
      return [];
    const t = [], { pathParser: n } = e;
    for (n.reset(); !n.isEnd(); ) {
      const { current: i } = n, a = i ? i.x : 0, s = i ? i.y : 0, o = n.next();
      let l = o.type, u = [];
      switch (o.type) {
        case cr.MOVE_TO:
          this.pathM(n, u);
          break;
        case cr.LINE_TO:
          l = this.pathL(n, u);
          break;
        case cr.HORIZ_LINE_TO:
          l = this.pathH(n, u);
          break;
        case cr.VERT_LINE_TO:
          l = this.pathV(n, u);
          break;
        case cr.CURVE_TO:
          this.pathC(n, u);
          break;
        case cr.SMOOTH_CURVE_TO:
          l = this.pathS(n, u);
          break;
        case cr.QUAD_TO:
          this.pathQ(n, u);
          break;
        case cr.SMOOTH_QUAD_TO:
          l = this.pathT(n, u);
          break;
        case cr.ARC:
          u = this.pathA(n);
          break;
        case cr.CLOSE_PATH:
          Kr.pathZ(n);
          break;
      }
      o.type !== cr.CLOSE_PATH ? t.push({
        type: l,
        points: u,
        start: {
          x: a,
          y: s
        },
        pathLength: this.calcLength(a, s, l, u)
      }) : t.push({
        type: cr.CLOSE_PATH,
        points: [],
        pathLength: 0
      });
    }
    return t;
  }
  pathM(e, t) {
    const { x: n, y: i } = Kr.pathM(e).point;
    t.push(n, i);
  }
  pathL(e, t) {
    const { x: n, y: i } = Kr.pathL(e).point;
    return t.push(n, i), cr.LINE_TO;
  }
  pathH(e, t) {
    const { x: n, y: i } = Kr.pathH(e).point;
    return t.push(n, i), cr.LINE_TO;
  }
  pathV(e, t) {
    const { x: n, y: i } = Kr.pathV(e).point;
    return t.push(n, i), cr.LINE_TO;
  }
  pathC(e, t) {
    const { point: n, controlPoint: i, currentPoint: a } = Kr.pathC(e);
    t.push(n.x, n.y, i.x, i.y, a.x, a.y);
  }
  pathS(e, t) {
    const { point: n, controlPoint: i, currentPoint: a } = Kr.pathS(e);
    return t.push(n.x, n.y, i.x, i.y, a.x, a.y), cr.CURVE_TO;
  }
  pathQ(e, t) {
    const { controlPoint: n, currentPoint: i } = Kr.pathQ(e);
    t.push(n.x, n.y, i.x, i.y);
  }
  pathT(e, t) {
    const { controlPoint: n, currentPoint: i } = Kr.pathT(e);
    return t.push(n.x, n.y, i.x, i.y), cr.QUAD_TO;
  }
  pathA(e) {
    let { rX: t, rY: n, sweepFlag: i, xAxisRotation: a, centp: s, a1: o, ad: l } = Kr.pathA(e);
    return i === 0 && l > 0 && (l -= 2 * Math.PI), i === 1 && l < 0 && (l += 2 * Math.PI), [
      s.x,
      s.y,
      t,
      n,
      o,
      l,
      a,
      i
    ];
  }
  calcLength(e, t, n, i) {
    let a = 0, s = null, o = null, l = 0;
    switch (n) {
      case cr.LINE_TO:
        return this.getLineLength(e, t, i[0], i[1]);
      case cr.CURVE_TO:
        for (a = 0, s = this.getPointOnCubicBezier(0, e, t, i[0], i[1], i[2], i[3], i[4], i[5]), l = 0.01; l <= 1; l += 0.01)
          o = this.getPointOnCubicBezier(l, e, t, i[0], i[1], i[2], i[3], i[4], i[5]), a += this.getLineLength(s.x, s.y, o.x, o.y), s = o;
        return a;
      case cr.QUAD_TO:
        for (a = 0, s = this.getPointOnQuadraticBezier(0, e, t, i[0], i[1], i[2], i[3]), l = 0.01; l <= 1; l += 0.01)
          o = this.getPointOnQuadraticBezier(l, e, t, i[0], i[1], i[2], i[3]), a += this.getLineLength(s.x, s.y, o.x, o.y), s = o;
        return a;
      case cr.ARC: {
        a = 0;
        const u = i[4], c = i[5], d = i[4] + c;
        let f = Math.PI / 180;
        if (Math.abs(u - d) < f && (f = Math.abs(u - d)), s = this.getPointOnEllipticalArc(i[0], i[1], i[2], i[3], u, 0), c < 0)
          for (l = u - f; l > d; l -= f)
            o = this.getPointOnEllipticalArc(i[0], i[1], i[2], i[3], l, 0), a += this.getLineLength(s.x, s.y, o.x, o.y), s = o;
        else
          for (l = u + f; l < d; l += f)
            o = this.getPointOnEllipticalArc(i[0], i[1], i[2], i[3], l, 0), a += this.getLineLength(s.x, s.y, o.x, o.y), s = o;
        return o = this.getPointOnEllipticalArc(i[0], i[1], i[2], i[3], d, 0), a += this.getLineLength(s.x, s.y, o.x, o.y), a;
      }
    }
    return 0;
  }
  getPointOnLine(e, t, n, i, a, s = t, o = n) {
    const l = (a - n) / (i - t + Bu);
    let u = Math.sqrt(e * e / (1 + l * l));
    i < t && (u *= -1);
    let c = l * u, d = null;
    if (i === t)
      d = {
        x: s,
        y: o + c
      };
    else if ((o - n) / (s - t + Bu) === l)
      d = {
        x: s + u,
        y: o + c
      };
    else {
      let f = 0, h = 0;
      const g = this.getLineLength(t, n, i, a);
      if (g < Bu)
        return null;
      let v = (s - t) * (i - t) + (o - n) * (a - n);
      v /= g * g, f = t + v * (i - t), h = n + v * (a - n);
      const y = this.getLineLength(s, o, f, h), A = Math.sqrt(e * e - y * y);
      u = Math.sqrt(A * A / (1 + l * l)), i < t && (u *= -1), c = l * u, d = {
        x: f + u,
        y: h + c
      };
    }
    return d;
  }
  getPointOnPath(e) {
    const t = this.getPathLength();
    let n = 0, i = null;
    if (e < -5e-5 || e - 5e-5 > t)
      return null;
    const { dataArray: a } = this;
    for (const s of a) {
      if (s && (s.pathLength < 5e-5 || n + s.pathLength + 5e-5 < e)) {
        n += s.pathLength;
        continue;
      }
      const o = e - n;
      let l = 0;
      switch (s.type) {
        case cr.LINE_TO:
          i = this.getPointOnLine(o, s.start.x, s.start.y, s.points[0], s.points[1], s.start.x, s.start.y);
          break;
        case cr.ARC: {
          const u = s.points[4], c = s.points[5], d = s.points[4] + c;
          if (l = u + o / s.pathLength * c, c < 0 && l < d || c >= 0 && l > d)
            break;
          i = this.getPointOnEllipticalArc(s.points[0], s.points[1], s.points[2], s.points[3], l, s.points[6]);
          break;
        }
        case cr.CURVE_TO:
          l = o / s.pathLength, l > 1 && (l = 1), i = this.getPointOnCubicBezier(l, s.start.x, s.start.y, s.points[0], s.points[1], s.points[2], s.points[3], s.points[4], s.points[5]);
          break;
        case cr.QUAD_TO:
          l = o / s.pathLength, l > 1 && (l = 1), i = this.getPointOnQuadraticBezier(l, s.start.x, s.start.y, s.points[0], s.points[1], s.points[2], s.points[3]);
          break;
      }
      if (i)
        return i;
      break;
    }
    return null;
  }
  getLineLength(e, t, n, i) {
    return Math.sqrt((n - e) * (n - e) + (i - t) * (i - t));
  }
  getPathLength() {
    return this.pathLength === -1 && (this.pathLength = this.dataArray.reduce((e, t) => t.pathLength > 0 ? e + t.pathLength : e, 0)), this.pathLength;
  }
  getPointOnCubicBezier(e, t, n, i, a, s, o, l, u) {
    const c = l * yx(e) + s * Ax(e) + i * bx(e) + t * wx(e), d = u * yx(e) + o * Ax(e) + a * bx(e) + n * wx(e);
    return {
      x: c,
      y: d
    };
  }
  getPointOnQuadraticBezier(e, t, n, i, a, s, o) {
    const l = s * xx(e) + i * Cx(e) + t * Sx(e), u = o * xx(e) + a * Cx(e) + n * Sx(e);
    return {
      x: l,
      y: u
    };
  }
  getPointOnEllipticalArc(e, t, n, i, a, s) {
    const o = Math.cos(s), l = Math.sin(s), u = {
      x: n * Math.cos(a),
      y: i * Math.sin(a)
    };
    return {
      x: e + (u.x * o - u.y * l),
      y: t + (u.x * l + u.y * o)
    };
  }
  // TODO need some optimisations. possibly build cache only for curved segments?
  buildEquidistantCache(e, t) {
    const n = this.getPathLength(), i = t || 0.25, a = e || n / 100;
    if (!this.equidistantCache || this.equidistantCache.step !== a || this.equidistantCache.precision !== i) {
      this.equidistantCache = {
        step: a,
        precision: i,
        points: []
      };
      let s = 0;
      for (let o = 0; o <= n; o += i) {
        const l = this.getPointOnPath(o), u = this.getPointOnPath(o + i);
        !l || !u || (s += this.getLineLength(l.x, l.y, u.x, u.y), s >= a && (this.equidistantCache.points.push({
          x: l.x,
          y: l.y,
          distance: o
        }), s -= a));
      }
    }
  }
  getEquidistantPointOnPath(e, t, n) {
    if (this.buildEquidistantCache(t, n), e < 0 || e - this.getPathLength() > 5e-5)
      return null;
    const i = Math.round(e / this.getPathLength() * (this.equidistantCache.points.length - 1));
    return this.equidistantCache.points[i] || null;
  }
}
const Z3 = /^\s*data:(([^/,;]+\/[^/,;]+)(?:;([^,;=]+=[^,;=]+))?)?(?:;(base64))?,(.*)$/i;
class eM extends Tl {
  type = "image";
  loaded = !1;
  image;
  constructor(e, t, n) {
    super(e, t, n);
    const i = this.getHrefAttribute().getString();
    if (!i)
      return;
    const a = i.endsWith(".svg") || /^\s*data:image\/svg\+xml/i.test(i);
    e.images.push(this), a ? this.loadSvg(i) : this.loadImage(i);
  }
  async loadImage(e) {
    try {
      const t = await this.document.createImage(e, !0);
      this.image = t;
    } catch (t) {
      console.error(`Error while loading image "${e}":`, t);
    }
    this.loaded = !0;
  }
  async loadSvg(e) {
    const t = Z3.exec(e);
    if (t) {
      const n = t[5];
      n && (t[4] === "base64" ? this.image = atob(n) : this.image = decodeURIComponent(n));
    } else
      try {
        const i = await (await this.document.fetch(e)).text();
        this.image = i;
      } catch (n) {
        console.error(`Error while loading image "${e}":`, n);
      }
    this.loaded = !0;
  }
  renderChildren(e) {
    const { document: t, image: n, loaded: i } = this, a = this.getAttribute("x").getPixels("x"), s = this.getAttribute("y").getPixels("y"), o = this.getStyle("width").getPixels("x"), l = this.getStyle("height").getPixels("y");
    if (!(!i || !n || !o || !l)) {
      if (e.save(), e.translate(a, s), typeof n == "string") {
        const u = t.pith.forkString(e, n, {
          ignoreMouse: !0,
          ignoreAnimation: !0,
          ignoreDimensions: !0,
          ignoreClear: !0,
          offsetX: 0,
          offsetY: 0,
          scaleWidth: o,
          scaleHeight: l
        }), { documentElement: c } = u.document;
        c && (c.parent = this), u.resize(o, l, this.getAttribute("preserveAspectRatio").getString()), u.render();
      } else
        t.setViewBox({
          ctx: e,
          aspectRatio: this.getAttribute("preserveAspectRatio").getString(),
          width: o,
          desiredWidth: n.width,
          height: l,
          desiredHeight: n.height
        }), this.loaded && (!("complete" in n) || n.complete) && e.drawImage(n, 0, 0);
      e.restore();
    }
  }
  getBoundingBox() {
    const e = this.getAttribute("x").getPixels("x"), t = this.getAttribute("y").getPixels("y"), n = this.getStyle("width").getPixels("x"), i = this.getStyle("height").getPixels("y");
    return new Ba(e, t, e + n, t + i);
  }
}
class tM extends Tl {
  type = "symbol";
  render(e) {
  }
}
class rM {
  document;
  loaded = !1;
  constructor(e) {
    this.document = e, e.fonts.push(this);
  }
  async load(e, t) {
    try {
      const { document: n } = this, a = (await n.pith.parser.load(t)).getElementsByTagName("font");
      Array.from(a).forEach((s) => {
        const o = n.createElement(s);
        n.definitions[e] = o;
      });
    } catch (n) {
      console.error(`Error while loading font "${t}":`, n);
    }
    this.loaded = !0;
  }
}
class nM extends Yn {
  static parseExternalUrl = gx;
  type = "style";
  constructor(e, t, n) {
    super(e, t, n), Id(
      Array.from(t.childNodes).map((s) => s.textContent).join("").replace(/(\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*+\/)|(^[\s]*\/\/.*)/gm, "").replace(/@import.*;/g, "")
      // remove imports
    ).split("}").forEach((s) => {
      const o = s.trim();
      if (!o)
        return;
      const l = o.split("{"), u = l[0].split(","), c = l[1].split(";");
      u.forEach((d) => {
        const f = d.trim();
        if (!f)
          return;
        const h = e.styles[f] || {};
        if (c.forEach((g) => {
          const v = g.indexOf(":"), y = g.substr(0, v).trim(), A = g.substr(v + 1, g.length - v).trim();
          y && A && (h[y] = new Mt(e, y, A));
        }), e.styles[f] = h, e.stylesSpecificity[f] = b3(f), f === "@font-face") {
          const g = h["font-family"].getString().replace(/"|'/g, "");
          h.src.getString().split(",").forEach((y) => {
            if (y.indexOf('format("svg")') > 0) {
              const A = gx(y);
              A && new rM(e).load(g, A);
            }
          });
        }
      });
    });
  }
}
class iM extends Tl {
  type = "use";
  cachedElement;
  setContext(e) {
    super.setContext(e);
    const t = this.getAttribute("x"), n = this.getAttribute("y");
    t.hasValue() && e.translate(t.getPixels("x"), 0), n.hasValue() && e.translate(0, n.getPixels("y"));
  }
  path(e) {
    const { element: t } = this;
    t && t.path(e);
  }
  renderChildren(e) {
    const { document: t, element: n } = this;
    if (n) {
      let i = n;
      if (n.type === "symbol" && (i = new Pd(t), i.attributes.viewBox = new Mt(t, "viewBox", n.getAttribute("viewBox").getString()), i.attributes.preserveAspectRatio = new Mt(t, "preserveAspectRatio", n.getAttribute("preserveAspectRatio").getString()), i.attributes.overflow = new Mt(t, "overflow", n.getAttribute("overflow").getString()), i.children = n.children, n.styles.opacity = new Mt(t, "opacity", this.calculateOpacity())), i.type === "svg") {
        const s = this.getStyle("width", !1, !0), o = this.getStyle("height", !1, !0);
        s.hasValue() && (i.attributes.width = new Mt(t, "width", s.getString())), o.hasValue() && (i.attributes.height = new Mt(t, "height", o.getString()));
      }
      const a = i.parent;
      i.parent = this, i.render(e), i.parent = a;
    }
  }
  getBoundingBox(e) {
    const { element: t } = this;
    return t ? t.getBoundingBox(e) : null;
  }
  elementTransform() {
    const { document: e, element: t } = this;
    return t ? Gu.fromElement(e, t) : null;
  }
  get element() {
    return this.cachedElement || (this.cachedElement = this.getHrefAttribute().getDefinition()), this.cachedElement;
  }
}
function ei(r, e, t) {
  return r[e] * t;
}
function Ss(r, e, t, n) {
  return e + Math.cos(r) * t + Math.sin(r) * n;
}
class rT extends kl {
  type = "feColorMatrix";
  matrix;
  includeOpacity;
  constructor(e, t, n) {
    super(e, t, n);
    let i = $i(this.getAttribute("values").getString());
    switch (this.getAttribute("type").getString("matrix")) {
      // http://www.w3.org/TR/SVG/filters.html#feColorMatrixElement
      case "saturate": {
        const a = i[0];
        i = [
          0.213 + 0.787 * a,
          0.715 - 0.715 * a,
          0.072 - 0.072 * a,
          0,
          0,
          0.213 - 0.213 * a,
          0.715 + 0.285 * a,
          0.072 - 0.072 * a,
          0,
          0,
          0.213 - 0.213 * a,
          0.715 - 0.715 * a,
          0.072 + 0.928 * a,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1
        ];
        break;
      }
      case "hueRotate": {
        const a = i[0] * Math.PI / 180;
        i = [
          Ss(a, 0.213, 0.787, -0.213),
          Ss(a, 0.715, -0.715, -0.715),
          Ss(a, 0.072, -0.072, 0.928),
          0,
          0,
          Ss(a, 0.213, -0.213, 0.143),
          Ss(a, 0.715, 0.285, 0.14),
          Ss(a, 0.072, -0.072, -0.283),
          0,
          0,
          Ss(a, 0.213, -0.213, -0.787),
          Ss(a, 0.715, -0.715, 0.715),
          Ss(a, 0.072, 0.928, 0.072),
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1
        ];
        break;
      }
      case "luminanceToAlpha":
        i = [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.2125,
          0.7154,
          0.0721,
          0,
          0,
          0,
          0,
          0,
          0,
          1
        ];
        break;
    }
    this.matrix = i, this.includeOpacity = this.getAttribute("includeOpacity").hasValue();
  }
  apply(e, t, n, i, a) {
    const { includeOpacity: s, matrix: o } = this, l = e.getImageData(0, 0, i, a);
    for (let u = 0; u < a; u++)
      for (let c = 0; c < i; c++) {
        const d = pl(l.data, c, u, i, a, 0), f = pl(l.data, c, u, i, a, 1), h = pl(l.data, c, u, i, a, 2), g = pl(l.data, c, u, i, a, 3);
        let v = ei(o, 0, d) + ei(o, 1, f) + ei(o, 2, h) + ei(o, 3, g) + ei(o, 4, 1), y = ei(o, 5, d) + ei(o, 6, f) + ei(o, 7, h) + ei(o, 8, g) + ei(o, 9, 1), A = ei(o, 10, d) + ei(o, 11, f) + ei(o, 12, h) + ei(o, 13, g) + ei(o, 14, 1), x = ei(o, 15, d) + ei(o, 16, f) + ei(o, 17, h) + ei(o, 18, g) + ei(o, 19, 1);
        s && (v = 0, y = 0, A = 0, x *= g / 255), gl(l.data, c, u, i, a, 0, v), gl(l.data, c, u, i, a, 1, y), gl(l.data, c, u, i, a, 2, A), gl(l.data, c, u, i, a, 3, x);
      }
    e.clearRect(0, 0, i, a), e.putImageData(l, 0, 0);
  }
}
class qA extends Yn {
  static ignoreStyles = [
    "mask",
    "transform",
    "clip-path"
  ];
  type = "mask";
  apply(e, t) {
    const { document: n } = this;
    let i = this.getAttribute("x").getPixels("x"), a = this.getAttribute("y").getPixels("y"), s = this.getStyle("width").getPixels("x"), o = this.getStyle("height").getPixels("y");
    if (!s && !o) {
      const h = new Ba();
      this.children.forEach((g) => {
        g instanceof Kr && h.addBoundingBox(g.getBoundingBox(e));
      }), i = Math.floor(h.x1), a = Math.floor(h.y1), s = Math.floor(h.width), o = Math.floor(h.height);
    }
    const l = this.removeStyles(t, qA.ignoreStyles), u = n.createCanvas(i + s, a + o), c = u.getContext("2d");
    n.screen.setDefaults(c), this.renderChildren(c), new rT(n, {
      nodeType: 1,
      childNodes: [],
      attributes: [
        {
          nodeName: "type",
          value: "luminanceToAlpha"
        },
        {
          nodeName: "includeOpacity",
          value: "true"
        }
      ]
    }).apply(c, 0, 0, i + s, a + o);
    const d = n.createCanvas(i + s, a + o), f = d.getContext("2d");
    n.screen.setDefaults(f), t.render(f), f.globalCompositeOperation = "destination-in", f.fillStyle = c.createPattern(u, "no-repeat"), f.fillRect(0, 0, i + s, a + o), e.fillStyle = f.createPattern(d, "no-repeat"), e.fillRect(0, 0, i + s, a + o), this.restoreStyles(t, l);
  }
  render(e) {
  }
}
const Fx = () => {
};
class aM extends Yn {
  type = "clipPath";
  apply(e) {
    const { document: t } = this, n = Reflect.getPrototypeOf(e), { beginPath: i, closePath: a } = e;
    n && (n.beginPath = Fx, n.closePath = Fx), Reflect.apply(i, e, []), this.children.forEach((s) => {
      if (!("path" in s))
        return;
      let o = "elementTransform" in s ? s.elementTransform() : null;
      o || (o = Gu.fromElement(t, s)), o && o.apply(e), s.path(e), n && (n.closePath = a), o && o.unapply(e);
    }), Reflect.apply(a, e, []), e.clip(), n && (n.beginPath = i, n.closePath = a);
  }
  render(e) {
  }
}
class nT extends kl {
  type = "feGaussianBlur";
  extraFilterDistance;
  blurRadius;
  constructor(e, t, n) {
    super(e, t, n), this.blurRadius = Math.floor(this.getAttribute("stdDeviation").getNumber()), this.extraFilterDistance = this.blurRadius;
  }
  apply(e, t, n, i, a) {
    const { document: s, blurRadius: o } = this, l = s.window ? s.window.document.body : null, u = e.canvas;
    u.id = s.getUniqueId(), l && (u.style.display = "none", l.appendChild(u)), o3(u, t, n, i, a, o), l && l.removeChild(u);
  }
}
class WA extends Yn {
  static ignoreStyles = [
    "filter",
    "transform",
    "clip-path"
  ];
  type = "filter";
  apply(e, t) {
    const { document: n, children: i } = this, a = "getBoundingBox" in t ? t.getBoundingBox(e) : null;
    if (!a)
      return;
    let s = 0, o = 0;
    i.forEach((A) => {
      if (!(A instanceof nT))
        return;
      const x = A.extraFilterDistance || 0;
      s = Math.max(s, x), o = Math.max(o, x);
    });
    const l = Math.floor(a.width), u = Math.floor(a.height), c = l + 2 * s, d = u + 2 * o;
    if (Number.isNaN(c) || Number.isNaN(d) || c < 1 || d < 1)
      return;
    const f = Math.floor(a.x), h = Math.floor(a.y), g = this.removeStyles(t, WA.ignoreStyles), v = n.createCanvas(c, d), y = v.getContext("2d");
    n.screen.setDefaults(y), y.translate(-f + s, -h + o), t.render(y), i.forEach((A) => {
      A instanceof kl && A.apply(y, 0, 0, c, d);
    }), e.drawImage(v, 0, 0, c, d, f - s, h - o, c, d), this.restoreStyles(t, g);
  }
  render(e) {
  }
}
class sM extends kl {
  type = "feDropShadow";
  constructor(e, t, n) {
    super(e, t, n), this.addStylesFromStyleDefinition();
  }
  apply(e, t, n, i, a) {
  }
}
class oM extends kl {
  type = "feMorphology";
  apply(e, t, n, i, a) {
  }
}
class lM extends kl {
  type = "feComposite";
  apply(e, t, n, i, a) {
  }
}
class uM extends Yn {
  type = "title";
}
class cM extends Yn {
  type = "desc";
}
class QA extends Yn {
  tableValues;
  constructor(e, t, n) {
    super(e, t, n), this.tableValues = $i(this.getAttribute("tableValues").getString());
  }
}
class iT extends QA {
  type = "feFuncR";
}
class aT extends QA {
  type = "feFuncG";
}
class sT extends QA {
  type = "feFuncB";
}
class fM extends kl {
  type = "feComponentTransfer";
  constructor(e, t, n) {
    super(e, t, n);
  }
  // New pixel value in accordance with the logic in the spec.
  // https://www.w3.org/TR/SVG11/filters.html#feComponentTransferElement
  // At the time of writing, assume the func elements are always the discrete type.
  calculateDiscrete(e, t) {
    const n = e / 255, i = t.tableValues.length;
    if (n === 1)
      return 255 * t.tableValues[i - 1];
    for (let a = 0; a < i; a++)
      if (a / i <= n && n < (a + 1) / i)
        return 255 * t.tableValues[a];
    return 255 * t.tableValues[0];
  }
  apply(e, t, n, i, a) {
    const { children: s } = this;
    let o, l, u;
    s.forEach((d) => {
      d instanceof iT ? o = d : d instanceof aT ? l = d : d instanceof sT && (u = d);
    });
    const c = e.getImageData(0, 0, i, a);
    for (let d = 0; d < a; d++)
      for (let f = 0; f < i; f++) {
        const h = pl(c.data, f, d, i, a, 0), g = pl(c.data, f, d, i, a, 1), v = pl(c.data, f, d, i, a, 2), y = this.calculateDiscrete(h, o), A = this.calculateDiscrete(g, l), x = this.calculateDiscrete(v, u);
        gl(c.data, f, d, i, a, 0, y), gl(c.data, f, d, i, a, 1, A), gl(c.data, f, d, i, a, 2, x);
      }
    e.clearRect(0, 0, i, a), e.putImageData(c, 0, 0);
  }
}
const dM = {
  svg: Pd,
  rect: Jk,
  circle: N3,
  ellipse: L3,
  line: U3,
  polyline: Kk,
  polygon: V3,
  path: Kr,
  pattern: z3,
  marker: $3,
  defs: H3,
  linearGradient: j3,
  radialGradient: G3,
  stop: q3,
  animate: jA,
  animateColor: W3,
  animateTransform: Q3,
  font: Y3,
  "font-face": eT,
  "missing-glyph": tT,
  glyph: GA,
  text: wo,
  tspan: Rg,
  tref: X3,
  a: J3,
  textPath: K3,
  image: eM,
  g: HA,
  symbol: tM,
  style: nM,
  use: iM,
  mask: qA,
  clipPath: aM,
  filter: WA,
  feDropShadow: sM,
  feFuncR: iT,
  feFuncG: aT,
  feFuncB: sT,
  feMorphology: oM,
  feComponentTransfer: fM,
  feComposite: lM,
  feColorMatrix: rT,
  feGaussianBlur: nT,
  title: uM,
  desc: cM
};
function hM(r, e) {
  const t = document.createElement("canvas");
  return t.width = r, t.height = e, t;
}
async function pM(r, e = !1) {
  const t = document.createElement("img");
  return e && (t.crossOrigin = "Anonymous"), new Promise((n, i) => {
    t.onload = () => {
      n(t);
    }, t.onerror = (a, s, o, l, u) => {
      i(u);
    }, t.src = r;
  });
}
const f0 = 12;
class Hf {
  pith;
  static createCanvas = hM;
  static createImage = pM;
  static elementTypes = dM;
  rootEmSize;
  documentElement;
  screen;
  createCanvas;
  createImage;
  definitions = {};
  styles = {};
  stylesSpecificity = {};
  images = [];
  fonts = [];
  emSizeStack = [];
  uniqueId = 0;
  constructor(e, { rootEmSize: t = f0, emSize: n = f0, createCanvas: i = Hf.createCanvas, createImage: a = Hf.createImage, anonymousCrossOrigin: s } = {}) {
    this.pith = e, this.screen = e.screen, this.rootEmSize = t, this.emSize = n, this.createCanvas = i, this.createImage = this.bindCreateImage(a, s), this.screen.wait(() => this.isImagesLoaded()), this.screen.wait(() => this.isFontsLoaded());
  }
  bindCreateImage(e, t) {
    return typeof t == "boolean" ? (n, i) => e(n, typeof i == "boolean" ? i : t) : e;
  }
  get window() {
    return this.screen.window;
  }
  get fetch() {
    return this.screen.fetch;
  }
  get ctx() {
    return this.screen.ctx;
  }
  get emSize() {
    const { emSizeStack: e } = this;
    return e[e.length - 1] || f0;
  }
  set emSize(e) {
    const { emSizeStack: t } = this;
    t.push(e);
  }
  popEmSize() {
    const { emSizeStack: e } = this;
    e.pop();
  }
  getUniqueId() {
    return `pith${++this.uniqueId}`;
  }
  isImagesLoaded() {
    return this.images.every((e) => e.loaded);
  }
  isFontsLoaded() {
    return this.fonts.every((e) => e.loaded);
  }
  createDocumentElement(e) {
    const t = this.createElement(e.documentElement, "svg");
    return t.root = !0, t.addStylesFromStyleDefinition(), this.documentElement = t, t;
  }
  createElement(e, t) {
    const n = t || e.nodeName.replace(/^[^:]+:/, ""), i = Hf.elementTypes[n];
    return i ? new i(this, e) : new P3(this, e);
  }
  createTextNode(e) {
    return new _3(this, e);
  }
  setViewBox(e) {
    this.screen.setViewBox({
      document: this,
      ...e
    });
  }
}
class so {
  /**
   * Create Pith instance from SVG source string or URL.
   * @param ctx - Rendering context.
   * @param svg - SVG source string or URL.
   * @param options - Rendering options.
   * @returns Pith instance.
   */
  static async from(e, t, n = {}) {
    const a = await new c0(n).parse(t);
    return new so(e, a, n);
  }
  /**
   * Create Pith instance from SVG source string.
   * @param ctx - Rendering context.
   * @param svg - SVG source string.
   * @param options - Rendering options.
   * @returns Pith instance.
   */
  static fromString(e, t, n = {}) {
    const a = new c0(n).parseFromString(t);
    return new so(e, a, n);
  }
  /**
   * XML/HTML parser instance.
   */
  parser;
  /**
   * Screen instance.
   */
  screen;
  /**
   * Pith Document.
   */
  document;
  documentElement;
  options;
  /**
   * Main constructor.
   * @param ctx - Rendering context.
   * @param svg - SVG Document.
   * @param options - Rendering options.
   */
  constructor(e, t, n = {}) {
    this.parser = new c0(n), this.screen = new Dd(e, n), this.options = n;
    const i = new Hf(this, n), a = i.createDocumentElement(t);
    this.document = i, this.documentElement = a;
  }
  /**
   * Create new Pith instance with inherited options.
   * @param ctx - Rendering context.
   * @param svg - SVG source string or URL.
   * @param options - Rendering options.
   * @returns Pith instance.
   */
  fork(e, t, n = {}) {
    return so.from(e, t, {
      ...this.options,
      ...n
    });
  }
  /**
   * Create new Pith instance with inherited options.
   * @param ctx - Rendering context.
   * @param svg - SVG source string.
   * @param options - Rendering options.
   * @returns Pith instance.
   */
  forkString(e, t, n = {}) {
    return so.fromString(e, t, {
      ...this.options,
      ...n
    });
  }
  /**
   * Document is ready promise.
   * @returns Ready promise.
   */
  ready() {
    return this.screen.ready();
  }
  /**
   * Document is ready value.
   * @returns Is ready or not.
   */
  isReady() {
    return this.screen.isReady();
  }
  /**
   * Render only first frame, ignoring animations and mouse.
   * @param options - Rendering options.
   */
  async render(e = {}) {
    this.start({
      enableRedraw: !0,
      ignoreAnimation: !0,
      ignoreMouse: !0,
      ...e
    }), await this.ready(), this.stop();
  }
  /**
   * Start rendering.
   * @param options - Render options.
   */
  start(e = {}) {
    const { documentElement: t, screen: n, options: i } = this;
    n.start(t, {
      enableRedraw: !0,
      ...i,
      ...e
    });
  }
  /**
   * Stop rendering.
   */
  stop() {
    this.screen.stop();
  }
  /**
   * Resize SVG to fit in given size.
   * @param width
   * @param height
   * @param preserveAspectRatio
   */
  resize(e, t = e, n = !1) {
    this.documentElement.resize(e, t, n);
  }
}
const d0 = [Je.SilentIllustration, Je.ProductOverlay], Ix = (r) => {
  const e = [];
  for (const n of r.steps) {
    const i = gM(n.stepName, r.stepGroups);
    if (!i)
      throw new Error(
        "Workflow step does not belong to a group, all steps must belong to a group. Step: " + n.stepName
      );
    const a = e.find((s) => s.name === i.name);
    a ? d0.includes(n.type) ? a.silentSteps.push(n) : a.renderableSteps.push(n) : e.push({
      name: i.name,
      title: i.name,
      renderableSteps: d0.includes(n.type) ? [] : [n],
      silentSteps: d0.includes(n.type) ? [n] : []
    });
  }
  const t = "workflow.steps.finish.confirmDesign";
  return e.push({
    name: "Finish",
    title: t,
    renderableSteps: [
      {
        type: Je.Finish,
        stepName: "Finish",
        stepTitle: t,
        helpText: "",
        data: {
          modelAnimation: r.finalizeStepConfig ? r.finalizeStepConfig.modelAnimation : void 0,
          lookAtAnimation: r.finalizeStepConfig ? r.finalizeStepConfig.lookAtAnimation : void 0
        },
        conditions: []
      }
    ],
    silentSteps: []
  }), e;
}, gM = (r, e) => e.find((t) => t.stepNames.includes(r)), oo = async (r, e) => (await Promise.all(
  (r.conditions || []).map(async (n) => {
    const i = e[n.targetStepName];
    if (i && i.selectedVariants) {
      const a = i.selectedVariants;
      return n.type === "VariantMetafield" ? (await Ky.ensureIdsArePresent(a.map((o) => o.id)), n.requiredVariantMetafields?.some((o) => a.find((l) => Ky.requestIfAvailable(
        l.id,
        o.variantMetafieldConfigurationId || ""
      )?.value === o.variantMetafieldValue))) : n.requiredVariantSelections.some(
        (s) => a.find((o) => o.id === s) !== void 0
      );
    }
    return !1;
  })
)).every((n) => n), mM = async (r, e) => {
  const t = await Promise.all(
    r.renderableSteps.map((o) => oo(o, e))
  ), n = r.renderableSteps.filter((o, l) => t[l]), i = await Promise.all(
    r.silentSteps.map((o) => oo(o, e))
  ), a = r.silentSteps.filter((o, l) => i[l]), s = {
    name: r.name,
    title: r.title,
    renderableSteps: n,
    silentSteps: a
  };
  return s.silentSteps.length === 0 && s.renderableSteps.length === 0 ? null : s;
}, Ya = async (r, e) => (await Promise.all(r.map((n) => mM(n, e)))).filter((n) => n !== null), vM = async (r, e, t = !1) => {
  const n = await Ya(r, e), i = [];
  for (const s of n)
    for (const o of s.renderableSteps) {
      let l = 0;
      if (o.type !== "Finish" && o.type !== "Module") {
        let u;
        o.option?.variants ? (u = o.option, l = u?.variants?.length || 0) : (u = await ft.getOption(o.option?.id), l = u?.variants?.length || 0);
      }
      o.silent || (o.type === Je.Model || o.type === Je.Material || o.type === Je.Picture || o.type === Je.Shape ? (l > 1 || t) && i.push(o.stepName) : i.push(o.stepName));
    }
  const a = n.filter((s) => s.renderableSteps.filter(
    (l) => i.includes(l.stepName)
  ).length > 0);
  for (const s of a)
    s.renderableSteps = s.renderableSteps.filter(
      (o) => i.includes(o.stepName)
    );
  return a;
};
class YA {
  constructor() {
    this.timestamp = Date.now();
  }
}
class XA {
  /**
   * Constructs a new promise queue.
   * @param queueMaxSize An optional maximum size, when the max size is hit.
   *                     The older promises will be discarded.
   * @param enabled When false, the queue will not process any jobs. Assign `enabled` to true to start processing.
   */
  constructor(e, t = !0) {
    this.queue = [], this.activePromise = void 0, this.queueMaxSize = void 0, this.queueMaxSize = e, this.isEnabled = t;
  }
  /**
   * Enqueue a new promise.
   * @param promise A new promise to add to the queue.
   */
  enqueue(e) {
    if (this.queue.push(e), this.queueMaxSize !== void 0 && this.queue.length > this.queueMaxSize) {
      const t = this.queue.length - 1;
      for (let n = 0; n < t; ++n)
        this.queue.shift();
    }
    this.isEnabled && (this.activePromise || (this.activePromise = this.dequeue()));
  }
  get enabled() {
    return this.isEnabled;
  }
  /**
   * Enable or disable the queue. When disabled, the queue will not process any jobs.
   * Disabling processing will not cancel any active promises.
   */
  set enabled(e) {
    !this.isEnabled && e && !this.activePromise && this.getRemainingQueueSize() > 0 && (this.activePromise = this.dequeue()), this.isEnabled = e;
  }
  /**
   * @returns Returns true when work is being actively processed by this queue.
   */
  hasActivePromise() {
    return !!this.activePromise;
  }
  /**
   * @returns The number of unexecuted jobs remaining in the queue. Not including the active job.
   */
  getRemainingQueueSize() {
    return this.queue.length;
  }
  /**
   * Finalize the queue, any jobs that come in while this is in progress will result
   * in the promise being extended.
   */
  async finalize() {
    return this.activePromise ? this.activePromise : Promise.resolve();
  }
  /**
   * Once called will recursively resolve the jobs in the
   * queue until no more are available.
   */
  async dequeue() {
    const e = this.queue.shift();
    if (!e) {
      this.activePromise = void 0;
      return;
    }
    try {
      await e.execute();
    } catch (t) {
      console.log(t);
    } finally {
      await this.dequeue();
    }
  }
}
var Pf = { exports: {} };
Pf.exports;
var Dx;
function yM() {
  return Dx || (Dx = 1, (function(r, e) {
    var t = 200, n = "__lodash_hash_undefined__", i = 9007199254740991, a = "[object Arguments]", s = "[object Array]", o = "[object Boolean]", l = "[object Date]", u = "[object Error]", c = "[object Function]", d = "[object GeneratorFunction]", f = "[object Map]", h = "[object Number]", g = "[object Object]", v = "[object Promise]", y = "[object RegExp]", A = "[object Set]", x = "[object String]", k = "[object Symbol]", F = "[object WeakMap]", S = "[object ArrayBuffer]", R = "[object DataView]", M = "[object Float32Array]", j = "[object Float64Array]", G = "[object Int8Array]", ie = "[object Int16Array]", q = "[object Int32Array]", Y = "[object Uint8Array]", J = "[object Uint8ClampedArray]", se = "[object Uint16Array]", oe = "[object Uint32Array]", he = /[\\^$.*+?()[\]{}|]/g, ye = /\w*$/, Ue = /^\[object .+?Constructor\]$/, Re = /^(?:0|[1-9]\d*)$/, Oe = {};
    Oe[a] = Oe[s] = Oe[S] = Oe[R] = Oe[o] = Oe[l] = Oe[M] = Oe[j] = Oe[G] = Oe[ie] = Oe[q] = Oe[f] = Oe[h] = Oe[g] = Oe[y] = Oe[A] = Oe[x] = Oe[k] = Oe[Y] = Oe[J] = Oe[se] = Oe[oe] = !0, Oe[u] = Oe[c] = Oe[F] = !1;
    var ee = typeof ui == "object" && ui && ui.Object === Object && ui, re = typeof self == "object" && self && self.Object === Object && self, de = ee || re || Function("return this")(), Be = e && !e.nodeType && e, ke = Be && !0 && r && !r.nodeType && r, ze = ke && ke.exports === Be;
    function je(I, $) {
      return I.set($[0], $[1]), I;
    }
    function qe(I, $) {
      return I.add($), I;
    }
    function Ge(I, $) {
      for (var ae = -1, xe = I ? I.length : 0; ++ae < xe && $(I[ae], ae, I) !== !1; )
        ;
      return I;
    }
    function bt(I, $) {
      for (var ae = -1, xe = $.length, ht = I.length; ++ae < xe; )
        I[ht + ae] = $[ae];
      return I;
    }
    function rr(I, $, ae, xe) {
      for (var ht = -1, lt = I ? I.length : 0; ++ht < lt; )
        ae = $(ae, I[ht], ht, I);
      return ae;
    }
    function Pr(I, $) {
      for (var ae = -1, xe = Array(I); ++ae < I; )
        xe[ae] = $(ae);
      return xe;
    }
    function Gt(I, $) {
      return I?.[$];
    }
    function ar(I) {
      var $ = !1;
      if (I != null && typeof I.toString != "function")
        try {
          $ = !!(I + "");
        } catch {
        }
      return $;
    }
    function St(I) {
      var $ = -1, ae = Array(I.size);
      return I.forEach(function(xe, ht) {
        ae[++$] = [ht, xe];
      }), ae;
    }
    function st(I, $) {
      return function(ae) {
        return I($(ae));
      };
    }
    function Qr(I) {
      var $ = -1, ae = Array(I.size);
      return I.forEach(function(xe) {
        ae[++$] = xe;
      }), ae;
    }
    var Sr = Array.prototype, gr = Function.prototype, nr = Object.prototype, fr = de["__core-js_shared__"], Yt = (function() {
      var I = /[^.]+$/.exec(fr && fr.keys && fr.keys.IE_PROTO || "");
      return I ? "Symbol(src)_1." + I : "";
    })(), Xt = gr.toString, mt = nr.hasOwnProperty, wr = nr.toString, an = RegExp(
      "^" + Xt.call(mt).replace(he, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), _r = ze ? de.Buffer : void 0, ir = de.Symbol, Yr = de.Uint8Array, kr = st(Object.getPrototypeOf, Object), Zr = Object.create, Vr = nr.propertyIsEnumerable, pn = Sr.splice, gn = Object.getOwnPropertySymbols, Tr = _r ? _r.isBuffer : void 0, zr = st(Object.keys, Object), en = rt(de, "DataView"), $r = rt(de, "Map"), zt = rt(de, "Promise"), sr = rt(de, "Set"), Er = rt(de, "WeakMap"), tt = rt(Object, "create"), Nr = Or(en), Xr = Or($r), Se = Or(zt), P = Or(sr), U = Or(Er), X = ir ? ir.prototype : void 0, ue = X ? X.valueOf : void 0;
    function Fe(I) {
      var $ = -1, ae = I ? I.length : 0;
      for (this.clear(); ++$ < ae; ) {
        var xe = I[$];
        this.set(xe[0], xe[1]);
      }
    }
    function We() {
      this.__data__ = tt ? tt(null) : {};
    }
    function wt(I) {
      return this.has(I) && delete this.__data__[I];
    }
    function Pt(I) {
      var $ = this.__data__;
      if (tt) {
        var ae = $[I];
        return ae === n ? void 0 : ae;
      }
      return mt.call($, I) ? $[I] : void 0;
    }
    function Nt(I) {
      var $ = this.__data__;
      return tt ? $[I] !== void 0 : mt.call($, I);
    }
    function or(I, $) {
      var ae = this.__data__;
      return ae[I] = tt && $ === void 0 ? n : $, this;
    }
    Fe.prototype.clear = We, Fe.prototype.delete = wt, Fe.prototype.get = Pt, Fe.prototype.has = Nt, Fe.prototype.set = or;
    function Lt(I) {
      var $ = -1, ae = I ? I.length : 0;
      for (this.clear(); ++$ < ae; ) {
        var xe = I[$];
        this.set(xe[0], xe[1]);
      }
    }
    function K() {
      this.__data__ = [];
    }
    function Ie(I) {
      var $ = this.__data__, ae = xn($, I);
      if (ae < 0)
        return !1;
      var xe = $.length - 1;
      return ae == xe ? $.pop() : pn.call($, ae, 1), !0;
    }
    function Qe(I) {
      var $ = this.__data__, ae = xn($, I);
      return ae < 0 ? void 0 : $[ae][1];
    }
    function Ye(I) {
      return xn(this.__data__, I) > -1;
    }
    function Ct(I, $) {
      var ae = this.__data__, xe = xn(ae, I);
      return xe < 0 ? ae.push([I, $]) : ae[xe][1] = $, this;
    }
    Lt.prototype.clear = K, Lt.prototype.delete = Ie, Lt.prototype.get = Qe, Lt.prototype.has = Ye, Lt.prototype.set = Ct;
    function dt(I) {
      var $ = -1, ae = I ? I.length : 0;
      for (this.clear(); ++$ < ae; ) {
        var xe = I[$];
        this.set(xe[0], xe[1]);
      }
    }
    function Rt() {
      this.__data__ = {
        hash: new Fe(),
        map: new ($r || Lt)(),
        string: new Fe()
      };
    }
    function Et(I) {
      return _e(this, I).delete(I);
    }
    function hr(I) {
      return _e(this, I).get(I);
    }
    function er(I) {
      return _e(this, I).has(I);
    }
    function dr(I, $) {
      return _e(this, I).set(I, $), this;
    }
    dt.prototype.clear = Rt, dt.prototype.delete = Et, dt.prototype.get = hr, dt.prototype.has = er, dt.prototype.set = dr;
    function $t(I) {
      this.__data__ = new Lt(I);
    }
    function On() {
      this.__data__ = new Lt();
    }
    function Fn(I) {
      return this.__data__.delete(I);
    }
    function mr(I) {
      return this.__data__.get(I);
    }
    function xr(I) {
      return this.__data__.has(I);
    }
    function wn(I, $) {
      var ae = this.__data__;
      if (ae instanceof Lt) {
        var xe = ae.__data__;
        if (!$r || xe.length < t - 1)
          return xe.push([I, $]), this;
        ae = this.__data__ = new dt(xe);
      }
      return ae.set(I, $), this;
    }
    $t.prototype.clear = On, $t.prototype.delete = Fn, $t.prototype.get = mr, $t.prototype.has = xr, $t.prototype.set = wn;
    function Rr(I, $) {
      var ae = Ri(I) || Mn(I) ? Pr(I.length, String) : [], xe = ae.length, ht = !!xe;
      for (var lt in I)
        mt.call(I, lt) && !(ht && (lt == "length" || fn(lt, xe))) && ae.push(lt);
      return ae;
    }
    function jn(I, $, ae) {
      var xe = I[$];
      (!(mt.call(I, $) && Bn(xe, ae)) || ae === void 0 && !($ in I)) && (I[$] = ae);
    }
    function xn(I, $) {
      for (var ae = I.length; ae--; )
        if (Bn(I[ae][0], $))
          return ae;
      return -1;
    }
    function Hr(I, $) {
      return I && pe($, lr($), I);
    }
    function Cn(I, $, ae, xe, ht, lt, Ht) {
      var Ut;
      if (xe && (Ut = lt ? xe(I, ht, lt, Ht) : xe(I)), Ut !== void 0)
        return Ut;
      if (!En(I))
        return I;
      var Br = Ri(I);
      if (Br) {
        if (Ut = Jt(I), !$)
          return W(I, Ut);
      } else {
        var B = nt(I), Z = B == c || B == d;
        if (_n(I))
          return mn(I, $);
        if (B == g || B == a || Z && !lt) {
          if (ar(I))
            return lt ? I : {};
          if (Ut = vr(Z ? {} : I), !$)
            return ce(I, Hr(Ut, I));
        } else {
          if (!Oe[B])
            return lt ? I : {};
          Ut = jr(I, B, Cn, $);
        }
      }
      Ht || (Ht = new $t());
      var fe = Ht.get(I);
      if (fe)
        return fe;
      if (Ht.set(I, Ut), !Br)
        var be = ae ? Ce(I) : lr(I);
      return Ge(be || I, function(Me, Ke) {
        be && (Ke = Me, Me = I[Ke]), jn(Ut, Ke, Cn(Me, $, ae, xe, Ke, I, Ht));
      }), Ut;
    }
    function cn(I) {
      return En(I) ? Zr(I) : {};
    }
    function tn(I, $, ae) {
      var xe = $(I);
      return Ri(I) ? xe : bt(xe, ae(I));
    }
    function Jn(I) {
      return wr.call(I);
    }
    function ii(I) {
      if (!En(I) || Ln(I))
        return !1;
      var $ = ki(I) || ar(I) ? an : Ue;
      return $.test(Or(I));
    }
    function Sn(I) {
      if (!vn(I))
        return zr(I);
      var $ = [];
      for (var ae in Object(I))
        mt.call(I, ae) && ae != "constructor" && $.push(ae);
      return $;
    }
    function mn(I, $) {
      if ($)
        return I.slice();
      var ae = new I.constructor(I.length);
      return I.copy(ae), ae;
    }
    function sn(I) {
      var $ = new I.constructor(I.byteLength);
      return new Yr($).set(new Yr(I)), $;
    }
    function rn(I, $) {
      var ae = $ ? sn(I.buffer) : I.buffer;
      return new I.constructor(ae, I.byteOffset, I.byteLength);
    }
    function Lr(I, $, ae) {
      var xe = $ ? ae(St(I), !0) : St(I);
      return rr(xe, je, new I.constructor());
    }
    function on(I) {
      var $ = new I.constructor(I.source, ye.exec(I));
      return $.lastIndex = I.lastIndex, $;
    }
    function E(I, $, ae) {
      var xe = $ ? ae(Qr(I), !0) : Qr(I);
      return rr(xe, qe, new I.constructor());
    }
    function O(I) {
      return ue ? Object(ue.call(I)) : {};
    }
    function z(I, $) {
      var ae = $ ? sn(I.buffer) : I.buffer;
      return new I.constructor(ae, I.byteOffset, I.length);
    }
    function W(I, $) {
      var ae = -1, xe = I.length;
      for ($ || ($ = Array(xe)); ++ae < xe; )
        $[ae] = I[ae];
      return $;
    }
    function pe(I, $, ae, xe) {
      ae || (ae = {});
      for (var ht = -1, lt = $.length; ++ht < lt; ) {
        var Ht = $[ht], Ut = void 0;
        jn(ae, Ht, Ut === void 0 ? I[Ht] : Ut);
      }
      return ae;
    }
    function ce(I, $) {
      return pe(I, ut(I), $);
    }
    function Ce(I) {
      return tn(I, lr, ut);
    }
    function _e(I, $) {
      var ae = I.__data__;
      return Kn($) ? ae[typeof $ == "string" ? "string" : "hash"] : ae.map;
    }
    function rt(I, $) {
      var ae = Gt(I, $);
      return ii(ae) ? ae : void 0;
    }
    var ut = gn ? st(gn, Object) : In, nt = Jn;
    (en && nt(new en(new ArrayBuffer(1))) != R || $r && nt(new $r()) != f || zt && nt(zt.resolve()) != v || sr && nt(new sr()) != A || Er && nt(new Er()) != F) && (nt = function(I) {
      var $ = wr.call(I), ae = $ == g ? I.constructor : void 0, xe = ae ? Or(ae) : void 0;
      if (xe)
        switch (xe) {
          case Nr:
            return R;
          case Xr:
            return f;
          case Se:
            return v;
          case P:
            return A;
          case U:
            return F;
        }
      return $;
    });
    function Jt(I) {
      var $ = I.length, ae = I.constructor($);
      return $ && typeof I[0] == "string" && mt.call(I, "index") && (ae.index = I.index, ae.input = I.input), ae;
    }
    function vr(I) {
      return typeof I.constructor == "function" && !vn(I) ? cn(kr(I)) : {};
    }
    function jr(I, $, ae, xe) {
      var ht = I.constructor;
      switch ($) {
        case S:
          return sn(I);
        case o:
        case l:
          return new ht(+I);
        case R:
          return rn(I, xe);
        case M:
        case j:
        case G:
        case ie:
        case q:
        case Y:
        case J:
        case se:
        case oe:
          return z(I, xe);
        case f:
          return Lr(I, xe, ae);
        case h:
        case x:
          return new ht(I);
        case y:
          return on(I);
        case A:
          return E(I, xe, ae);
        case k:
          return O(I);
      }
    }
    function fn(I, $) {
      return $ = $ ?? i, !!$ && (typeof I == "number" || Re.test(I)) && I > -1 && I % 1 == 0 && I < $;
    }
    function Kn(I) {
      var $ = typeof I;
      return $ == "string" || $ == "number" || $ == "symbol" || $ == "boolean" ? I !== "__proto__" : I === null;
    }
    function Ln(I) {
      return !!Yt && Yt in I;
    }
    function vn(I) {
      var $ = I && I.constructor, ae = typeof $ == "function" && $.prototype || nr;
      return I === ae;
    }
    function Or(I) {
      if (I != null) {
        try {
          return Xt.call(I);
        } catch {
        }
        try {
          return I + "";
        } catch {
        }
      }
      return "";
    }
    function Gn(I) {
      return Cn(I, !0, !0);
    }
    function Bn(I, $) {
      return I === $ || I !== I && $ !== $;
    }
    function Mn(I) {
      return Ai(I) && mt.call(I, "callee") && (!Vr.call(I, "callee") || wr.call(I) == a);
    }
    var Ri = Array.isArray;
    function yi(I) {
      return I != null && Un(I.length) && !ki(I);
    }
    function Ai(I) {
      return Zn(I) && yi(I);
    }
    var _n = Tr || bi;
    function ki(I) {
      var $ = En(I) ? wr.call(I) : "";
      return $ == c || $ == d;
    }
    function Un(I) {
      return typeof I == "number" && I > -1 && I % 1 == 0 && I <= i;
    }
    function En(I) {
      var $ = typeof I;
      return !!I && ($ == "object" || $ == "function");
    }
    function Zn(I) {
      return !!I && typeof I == "object";
    }
    function lr(I) {
      return yi(I) ? Rr(I) : Sn(I);
    }
    function In() {
      return [];
    }
    function bi() {
      return !1;
    }
    r.exports = Gn;
  })(Pf, Pf.exports)), Pf.exports;
}
var AM = yM();
const ho = /* @__PURE__ */ Bs(AM);
var Rf = { exports: {} };
Rf.exports;
var Px;
function bM() {
  return Px || (Px = 1, (function(r, e) {
    var t = 200, n = "__lodash_hash_undefined__", i = 1, a = 2, s = 9007199254740991, o = "[object Arguments]", l = "[object Array]", u = "[object AsyncFunction]", c = "[object Boolean]", d = "[object Date]", f = "[object Error]", h = "[object Function]", g = "[object GeneratorFunction]", v = "[object Map]", y = "[object Number]", A = "[object Null]", x = "[object Object]", k = "[object Promise]", F = "[object Proxy]", S = "[object RegExp]", R = "[object Set]", M = "[object String]", j = "[object Symbol]", G = "[object Undefined]", ie = "[object WeakMap]", q = "[object ArrayBuffer]", Y = "[object DataView]", J = "[object Float32Array]", se = "[object Float64Array]", oe = "[object Int8Array]", he = "[object Int16Array]", ye = "[object Int32Array]", Ue = "[object Uint8Array]", Re = "[object Uint8ClampedArray]", Oe = "[object Uint16Array]", ee = "[object Uint32Array]", re = /[\\^$.*+?()[\]{}|]/g, de = /^\[object .+?Constructor\]$/, Be = /^(?:0|[1-9]\d*)$/, ke = {};
    ke[J] = ke[se] = ke[oe] = ke[he] = ke[ye] = ke[Ue] = ke[Re] = ke[Oe] = ke[ee] = !0, ke[o] = ke[l] = ke[q] = ke[c] = ke[Y] = ke[d] = ke[f] = ke[h] = ke[v] = ke[y] = ke[x] = ke[S] = ke[R] = ke[M] = ke[ie] = !1;
    var ze = typeof ui == "object" && ui && ui.Object === Object && ui, je = typeof self == "object" && self && self.Object === Object && self, qe = ze || je || Function("return this")(), Ge = e && !e.nodeType && e, bt = Ge && !0 && r && !r.nodeType && r, rr = bt && bt.exports === Ge, Pr = rr && ze.process, Gt = (function() {
      try {
        return Pr && Pr.binding && Pr.binding("util");
      } catch {
      }
    })(), ar = Gt && Gt.isTypedArray;
    function St(I, $) {
      for (var ae = -1, xe = I == null ? 0 : I.length, ht = 0, lt = []; ++ae < xe; ) {
        var Ht = I[ae];
        $(Ht, ae, I) && (lt[ht++] = Ht);
      }
      return lt;
    }
    function st(I, $) {
      for (var ae = -1, xe = $.length, ht = I.length; ++ae < xe; )
        I[ht + ae] = $[ae];
      return I;
    }
    function Qr(I, $) {
      for (var ae = -1, xe = I == null ? 0 : I.length; ++ae < xe; )
        if ($(I[ae], ae, I))
          return !0;
      return !1;
    }
    function Sr(I, $) {
      for (var ae = -1, xe = Array(I); ++ae < I; )
        xe[ae] = $(ae);
      return xe;
    }
    function gr(I) {
      return function($) {
        return I($);
      };
    }
    function nr(I, $) {
      return I.has($);
    }
    function fr(I, $) {
      return I?.[$];
    }
    function Yt(I) {
      var $ = -1, ae = Array(I.size);
      return I.forEach(function(xe, ht) {
        ae[++$] = [ht, xe];
      }), ae;
    }
    function Xt(I, $) {
      return function(ae) {
        return I($(ae));
      };
    }
    function mt(I) {
      var $ = -1, ae = Array(I.size);
      return I.forEach(function(xe) {
        ae[++$] = xe;
      }), ae;
    }
    var wr = Array.prototype, an = Function.prototype, _r = Object.prototype, ir = qe["__core-js_shared__"], Yr = an.toString, kr = _r.hasOwnProperty, Zr = (function() {
      var I = /[^.]+$/.exec(ir && ir.keys && ir.keys.IE_PROTO || "");
      return I ? "Symbol(src)_1." + I : "";
    })(), Vr = _r.toString, pn = RegExp(
      "^" + Yr.call(kr).replace(re, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), gn = rr ? qe.Buffer : void 0, Tr = qe.Symbol, zr = qe.Uint8Array, en = _r.propertyIsEnumerable, $r = wr.splice, zt = Tr ? Tr.toStringTag : void 0, sr = Object.getOwnPropertySymbols, Er = gn ? gn.isBuffer : void 0, tt = Xt(Object.keys, Object), Nr = ut(qe, "DataView"), Xr = ut(qe, "Map"), Se = ut(qe, "Promise"), P = ut(qe, "Set"), U = ut(qe, "WeakMap"), X = ut(Object, "create"), ue = Or(Nr), Fe = Or(Xr), We = Or(Se), wt = Or(P), Pt = Or(U), Nt = Tr ? Tr.prototype : void 0, or = Nt ? Nt.valueOf : void 0;
    function Lt(I) {
      var $ = -1, ae = I == null ? 0 : I.length;
      for (this.clear(); ++$ < ae; ) {
        var xe = I[$];
        this.set(xe[0], xe[1]);
      }
    }
    function K() {
      this.__data__ = X ? X(null) : {}, this.size = 0;
    }
    function Ie(I) {
      var $ = this.has(I) && delete this.__data__[I];
      return this.size -= $ ? 1 : 0, $;
    }
    function Qe(I) {
      var $ = this.__data__;
      if (X) {
        var ae = $[I];
        return ae === n ? void 0 : ae;
      }
      return kr.call($, I) ? $[I] : void 0;
    }
    function Ye(I) {
      var $ = this.__data__;
      return X ? $[I] !== void 0 : kr.call($, I);
    }
    function Ct(I, $) {
      var ae = this.__data__;
      return this.size += this.has(I) ? 0 : 1, ae[I] = X && $ === void 0 ? n : $, this;
    }
    Lt.prototype.clear = K, Lt.prototype.delete = Ie, Lt.prototype.get = Qe, Lt.prototype.has = Ye, Lt.prototype.set = Ct;
    function dt(I) {
      var $ = -1, ae = I == null ? 0 : I.length;
      for (this.clear(); ++$ < ae; ) {
        var xe = I[$];
        this.set(xe[0], xe[1]);
      }
    }
    function Rt() {
      this.__data__ = [], this.size = 0;
    }
    function Et(I) {
      var $ = this.__data__, ae = mn($, I);
      if (ae < 0)
        return !1;
      var xe = $.length - 1;
      return ae == xe ? $.pop() : $r.call($, ae, 1), --this.size, !0;
    }
    function hr(I) {
      var $ = this.__data__, ae = mn($, I);
      return ae < 0 ? void 0 : $[ae][1];
    }
    function er(I) {
      return mn(this.__data__, I) > -1;
    }
    function dr(I, $) {
      var ae = this.__data__, xe = mn(ae, I);
      return xe < 0 ? (++this.size, ae.push([I, $])) : ae[xe][1] = $, this;
    }
    dt.prototype.clear = Rt, dt.prototype.delete = Et, dt.prototype.get = hr, dt.prototype.has = er, dt.prototype.set = dr;
    function $t(I) {
      var $ = -1, ae = I == null ? 0 : I.length;
      for (this.clear(); ++$ < ae; ) {
        var xe = I[$];
        this.set(xe[0], xe[1]);
      }
    }
    function On() {
      this.size = 0, this.__data__ = {
        hash: new Lt(),
        map: new (Xr || dt)(),
        string: new Lt()
      };
    }
    function Fn(I) {
      var $ = rt(this, I).delete(I);
      return this.size -= $ ? 1 : 0, $;
    }
    function mr(I) {
      return rt(this, I).get(I);
    }
    function xr(I) {
      return rt(this, I).has(I);
    }
    function wn(I, $) {
      var ae = rt(this, I), xe = ae.size;
      return ae.set(I, $), this.size += ae.size == xe ? 0 : 1, this;
    }
    $t.prototype.clear = On, $t.prototype.delete = Fn, $t.prototype.get = mr, $t.prototype.has = xr, $t.prototype.set = wn;
    function Rr(I) {
      var $ = -1, ae = I == null ? 0 : I.length;
      for (this.__data__ = new $t(); ++$ < ae; )
        this.add(I[$]);
    }
    function jn(I) {
      return this.__data__.set(I, n), this;
    }
    function xn(I) {
      return this.__data__.has(I);
    }
    Rr.prototype.add = Rr.prototype.push = jn, Rr.prototype.has = xn;
    function Hr(I) {
      var $ = this.__data__ = new dt(I);
      this.size = $.size;
    }
    function Cn() {
      this.__data__ = new dt(), this.size = 0;
    }
    function cn(I) {
      var $ = this.__data__, ae = $.delete(I);
      return this.size = $.size, ae;
    }
    function tn(I) {
      return this.__data__.get(I);
    }
    function Jn(I) {
      return this.__data__.has(I);
    }
    function ii(I, $) {
      var ae = this.__data__;
      if (ae instanceof dt) {
        var xe = ae.__data__;
        if (!Xr || xe.length < t - 1)
          return xe.push([I, $]), this.size = ++ae.size, this;
        ae = this.__data__ = new $t(xe);
      }
      return ae.set(I, $), this.size = ae.size, this;
    }
    Hr.prototype.clear = Cn, Hr.prototype.delete = cn, Hr.prototype.get = tn, Hr.prototype.has = Jn, Hr.prototype.set = ii;
    function Sn(I, $) {
      var ae = Mn(I), xe = !ae && Bn(I), ht = !ae && !xe && yi(I), lt = !ae && !xe && !ht && Zn(I), Ht = ae || xe || ht || lt, Ut = Ht ? Sr(I.length, String) : [], Br = Ut.length;
      for (var B in I)
        kr.call(I, B) && !(Ht && // Safari 9 has enumerable `arguments.length` in strict mode.
        (B == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        ht && (B == "offset" || B == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        lt && (B == "buffer" || B == "byteLength" || B == "byteOffset") || // Skip index properties.
        jr(B, Br))) && Ut.push(B);
      return Ut;
    }
    function mn(I, $) {
      for (var ae = I.length; ae--; )
        if (Gn(I[ae][0], $))
          return ae;
      return -1;
    }
    function sn(I, $, ae) {
      var xe = $(I);
      return Mn(I) ? xe : st(xe, ae(I));
    }
    function rn(I) {
      return I == null ? I === void 0 ? G : A : zt && zt in Object(I) ? nt(I) : vn(I);
    }
    function Lr(I) {
      return En(I) && rn(I) == o;
    }
    function on(I, $, ae, xe, ht) {
      return I === $ ? !0 : I == null || $ == null || !En(I) && !En($) ? I !== I && $ !== $ : E(I, $, ae, xe, on, ht);
    }
    function E(I, $, ae, xe, ht, lt) {
      var Ht = Mn(I), Ut = Mn($), Br = Ht ? l : vr(I), B = Ut ? l : vr($);
      Br = Br == o ? x : Br, B = B == o ? x : B;
      var Z = Br == x, fe = B == x, be = Br == B;
      if (be && yi(I)) {
        if (!yi($))
          return !1;
        Ht = !0, Z = !1;
      }
      if (be && !Z)
        return lt || (lt = new Hr()), Ht || Zn(I) ? pe(I, $, ae, xe, ht, lt) : ce(I, $, Br, ae, xe, ht, lt);
      if (!(ae & i)) {
        var Me = Z && kr.call(I, "__wrapped__"), Ke = fe && kr.call($, "__wrapped__");
        if (Me || Ke) {
          var Xe = Me ? I.value() : I, yt = Ke ? $.value() : $;
          return lt || (lt = new Hr()), ht(Xe, yt, ae, xe, lt);
        }
      }
      return be ? (lt || (lt = new Hr()), Ce(I, $, ae, xe, ht, lt)) : !1;
    }
    function O(I) {
      if (!Un(I) || Kn(I))
        return !1;
      var $ = _n(I) ? pn : de;
      return $.test(Or(I));
    }
    function z(I) {
      return En(I) && ki(I.length) && !!ke[rn(I)];
    }
    function W(I) {
      if (!Ln(I))
        return tt(I);
      var $ = [];
      for (var ae in Object(I))
        kr.call(I, ae) && ae != "constructor" && $.push(ae);
      return $;
    }
    function pe(I, $, ae, xe, ht, lt) {
      var Ht = ae & i, Ut = I.length, Br = $.length;
      if (Ut != Br && !(Ht && Br > Ut))
        return !1;
      var B = lt.get(I);
      if (B && lt.get($))
        return B == $;
      var Z = -1, fe = !0, be = ae & a ? new Rr() : void 0;
      for (lt.set(I, $), lt.set($, I); ++Z < Ut; ) {
        var Me = I[Z], Ke = $[Z];
        if (xe)
          var Xe = Ht ? xe(Ke, Me, Z, $, I, lt) : xe(Me, Ke, Z, I, $, lt);
        if (Xe !== void 0) {
          if (Xe)
            continue;
          fe = !1;
          break;
        }
        if (be) {
          if (!Qr($, function(yt, Ot) {
            if (!nr(be, Ot) && (Me === yt || ht(Me, yt, ae, xe, lt)))
              return be.push(Ot);
          })) {
            fe = !1;
            break;
          }
        } else if (!(Me === Ke || ht(Me, Ke, ae, xe, lt))) {
          fe = !1;
          break;
        }
      }
      return lt.delete(I), lt.delete($), fe;
    }
    function ce(I, $, ae, xe, ht, lt, Ht) {
      switch (ae) {
        case Y:
          if (I.byteLength != $.byteLength || I.byteOffset != $.byteOffset)
            return !1;
          I = I.buffer, $ = $.buffer;
        case q:
          return !(I.byteLength != $.byteLength || !lt(new zr(I), new zr($)));
        case c:
        case d:
        case y:
          return Gn(+I, +$);
        case f:
          return I.name == $.name && I.message == $.message;
        case S:
        case M:
          return I == $ + "";
        case v:
          var Ut = Yt;
        case R:
          var Br = xe & i;
          if (Ut || (Ut = mt), I.size != $.size && !Br)
            return !1;
          var B = Ht.get(I);
          if (B)
            return B == $;
          xe |= a, Ht.set(I, $);
          var Z = pe(Ut(I), Ut($), xe, ht, lt, Ht);
          return Ht.delete(I), Z;
        case j:
          if (or)
            return or.call(I) == or.call($);
      }
      return !1;
    }
    function Ce(I, $, ae, xe, ht, lt) {
      var Ht = ae & i, Ut = _e(I), Br = Ut.length, B = _e($), Z = B.length;
      if (Br != Z && !Ht)
        return !1;
      for (var fe = Br; fe--; ) {
        var be = Ut[fe];
        if (!(Ht ? be in $ : kr.call($, be)))
          return !1;
      }
      var Me = lt.get(I);
      if (Me && lt.get($))
        return Me == $;
      var Ke = !0;
      lt.set(I, $), lt.set($, I);
      for (var Xe = Ht; ++fe < Br; ) {
        be = Ut[fe];
        var yt = I[be], Ot = $[be];
        if (xe)
          var pr = Ht ? xe(Ot, yt, be, $, I, lt) : xe(yt, Ot, be, I, $, lt);
        if (!(pr === void 0 ? yt === Ot || ht(yt, Ot, ae, xe, lt) : pr)) {
          Ke = !1;
          break;
        }
        Xe || (Xe = be == "constructor");
      }
      if (Ke && !Xe) {
        var yr = I.constructor, ur = $.constructor;
        yr != ur && "constructor" in I && "constructor" in $ && !(typeof yr == "function" && yr instanceof yr && typeof ur == "function" && ur instanceof ur) && (Ke = !1);
      }
      return lt.delete(I), lt.delete($), Ke;
    }
    function _e(I) {
      return sn(I, lr, Jt);
    }
    function rt(I, $) {
      var ae = I.__data__;
      return fn($) ? ae[typeof $ == "string" ? "string" : "hash"] : ae.map;
    }
    function ut(I, $) {
      var ae = fr(I, $);
      return O(ae) ? ae : void 0;
    }
    function nt(I) {
      var $ = kr.call(I, zt), ae = I[zt];
      try {
        I[zt] = void 0;
        var xe = !0;
      } catch {
      }
      var ht = Vr.call(I);
      return xe && ($ ? I[zt] = ae : delete I[zt]), ht;
    }
    var Jt = sr ? function(I) {
      return I == null ? [] : (I = Object(I), St(sr(I), function($) {
        return en.call(I, $);
      }));
    } : In, vr = rn;
    (Nr && vr(new Nr(new ArrayBuffer(1))) != Y || Xr && vr(new Xr()) != v || Se && vr(Se.resolve()) != k || P && vr(new P()) != R || U && vr(new U()) != ie) && (vr = function(I) {
      var $ = rn(I), ae = $ == x ? I.constructor : void 0, xe = ae ? Or(ae) : "";
      if (xe)
        switch (xe) {
          case ue:
            return Y;
          case Fe:
            return v;
          case We:
            return k;
          case wt:
            return R;
          case Pt:
            return ie;
        }
      return $;
    });
    function jr(I, $) {
      return $ = $ ?? s, !!$ && (typeof I == "number" || Be.test(I)) && I > -1 && I % 1 == 0 && I < $;
    }
    function fn(I) {
      var $ = typeof I;
      return $ == "string" || $ == "number" || $ == "symbol" || $ == "boolean" ? I !== "__proto__" : I === null;
    }
    function Kn(I) {
      return !!Zr && Zr in I;
    }
    function Ln(I) {
      var $ = I && I.constructor, ae = typeof $ == "function" && $.prototype || _r;
      return I === ae;
    }
    function vn(I) {
      return Vr.call(I);
    }
    function Or(I) {
      if (I != null) {
        try {
          return Yr.call(I);
        } catch {
        }
        try {
          return I + "";
        } catch {
        }
      }
      return "";
    }
    function Gn(I, $) {
      return I === $ || I !== I && $ !== $;
    }
    var Bn = Lr(/* @__PURE__ */ (function() {
      return arguments;
    })()) ? Lr : function(I) {
      return En(I) && kr.call(I, "callee") && !en.call(I, "callee");
    }, Mn = Array.isArray;
    function Ri(I) {
      return I != null && ki(I.length) && !_n(I);
    }
    var yi = Er || bi;
    function Ai(I, $) {
      return on(I, $);
    }
    function _n(I) {
      if (!Un(I))
        return !1;
      var $ = rn(I);
      return $ == h || $ == g || $ == u || $ == F;
    }
    function ki(I) {
      return typeof I == "number" && I > -1 && I % 1 == 0 && I <= s;
    }
    function Un(I) {
      var $ = typeof I;
      return I != null && ($ == "object" || $ == "function");
    }
    function En(I) {
      return I != null && typeof I == "object";
    }
    var Zn = ar ? gr(ar) : z;
    function lr(I) {
      return Ri(I) ? Sn(I) : W(I);
    }
    function In() {
      return [];
    }
    function bi() {
      return !1;
    }
    r.exports = Ai;
  })(Rf, Rf.exports)), Rf.exports;
}
var wM = bM();
const ld = /* @__PURE__ */ Bs(wM);
var Bh = { exports: {} }, of = {};
var Rx;
function xM() {
  if (Rx) return of;
  Rx = 1;
  var r = Sl(), e = /* @__PURE__ */ Symbol.for("react.element"), t = /* @__PURE__ */ Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(o, l, u) {
    var c, d = {}, f = null, h = null;
    u !== void 0 && (f = "" + u), l.key !== void 0 && (f = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (c in l) n.call(l, c) && !a.hasOwnProperty(c) && (d[c] = l[c]);
    if (o && o.defaultProps) for (c in l = o.defaultProps, l) d[c] === void 0 && (d[c] = l[c]);
    return { $$typeof: e, type: o, key: f, ref: h, props: d, _owner: i.current };
  }
  return of.Fragment = t, of.jsx = s, of.jsxs = s, of;
}
var lf = {};
var Ox;
function CM() {
  return Ox || (Ox = 1, process.env.NODE_ENV !== "production" && (function() {
    var r = Sl(), e = /* @__PURE__ */ Symbol.for("react.element"), t = /* @__PURE__ */ Symbol.for("react.portal"), n = /* @__PURE__ */ Symbol.for("react.fragment"), i = /* @__PURE__ */ Symbol.for("react.strict_mode"), a = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), o = /* @__PURE__ */ Symbol.for("react.context"), l = /* @__PURE__ */ Symbol.for("react.forward_ref"), u = /* @__PURE__ */ Symbol.for("react.suspense"), c = /* @__PURE__ */ Symbol.for("react.suspense_list"), d = /* @__PURE__ */ Symbol.for("react.memo"), f = /* @__PURE__ */ Symbol.for("react.lazy"), h = /* @__PURE__ */ Symbol.for("react.offscreen"), g = Symbol.iterator, v = "@@iterator";
    function y(K) {
      if (K === null || typeof K != "object")
        return null;
      var Ie = g && K[g] || K[v];
      return typeof Ie == "function" ? Ie : null;
    }
    var A = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function x(K) {
      {
        for (var Ie = arguments.length, Qe = new Array(Ie > 1 ? Ie - 1 : 0), Ye = 1; Ye < Ie; Ye++)
          Qe[Ye - 1] = arguments[Ye];
        k("error", K, Qe);
      }
    }
    function k(K, Ie, Qe) {
      {
        var Ye = A.ReactDebugCurrentFrame, Ct = Ye.getStackAddendum();
        Ct !== "" && (Ie += "%s", Qe = Qe.concat([Ct]));
        var dt = Qe.map(function(Rt) {
          return String(Rt);
        });
        dt.unshift("Warning: " + Ie), Function.prototype.apply.call(console[K], console, dt);
      }
    }
    var F = !1, S = !1, R = !1, M = !1, j = !1, G;
    G = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ie(K) {
      return !!(typeof K == "string" || typeof K == "function" || K === n || K === a || j || K === i || K === u || K === c || M || K === h || F || S || R || typeof K == "object" && K !== null && (K.$$typeof === f || K.$$typeof === d || K.$$typeof === s || K.$$typeof === o || K.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      K.$$typeof === G || K.getModuleId !== void 0));
    }
    function q(K, Ie, Qe) {
      var Ye = K.displayName;
      if (Ye)
        return Ye;
      var Ct = Ie.displayName || Ie.name || "";
      return Ct !== "" ? Qe + "(" + Ct + ")" : Qe;
    }
    function Y(K) {
      return K.displayName || "Context";
    }
    function J(K) {
      if (K == null)
        return null;
      if (typeof K.tag == "number" && x("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof K == "function")
        return K.displayName || K.name || null;
      if (typeof K == "string")
        return K;
      switch (K) {
        case n:
          return "Fragment";
        case t:
          return "Portal";
        case a:
          return "Profiler";
        case i:
          return "StrictMode";
        case u:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof K == "object")
        switch (K.$$typeof) {
          case o:
            var Ie = K;
            return Y(Ie) + ".Consumer";
          case s:
            var Qe = K;
            return Y(Qe._context) + ".Provider";
          case l:
            return q(K, K.render, "ForwardRef");
          case d:
            var Ye = K.displayName || null;
            return Ye !== null ? Ye : J(K.type) || "Memo";
          case f: {
            var Ct = K, dt = Ct._payload, Rt = Ct._init;
            try {
              return J(Rt(dt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var se = Object.assign, oe = 0, he, ye, Ue, Re, Oe, ee, re;
    function de() {
    }
    de.__reactDisabledLog = !0;
    function Be() {
      {
        if (oe === 0) {
          he = console.log, ye = console.info, Ue = console.warn, Re = console.error, Oe = console.group, ee = console.groupCollapsed, re = console.groupEnd;
          var K = {
            configurable: !0,
            enumerable: !0,
            value: de,
            writable: !0
          };
          Object.defineProperties(console, {
            info: K,
            log: K,
            warn: K,
            error: K,
            group: K,
            groupCollapsed: K,
            groupEnd: K
          });
        }
        oe++;
      }
    }
    function ke() {
      {
        if (oe--, oe === 0) {
          var K = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: se({}, K, {
              value: he
            }),
            info: se({}, K, {
              value: ye
            }),
            warn: se({}, K, {
              value: Ue
            }),
            error: se({}, K, {
              value: Re
            }),
            group: se({}, K, {
              value: Oe
            }),
            groupCollapsed: se({}, K, {
              value: ee
            }),
            groupEnd: se({}, K, {
              value: re
            })
          });
        }
        oe < 0 && x("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ze = A.ReactCurrentDispatcher, je;
    function qe(K, Ie, Qe) {
      {
        if (je === void 0)
          try {
            throw Error();
          } catch (Ct) {
            var Ye = Ct.stack.trim().match(/\n( *(at )?)/);
            je = Ye && Ye[1] || "";
          }
        return `
` + je + K;
      }
    }
    var Ge = !1, bt;
    {
      var rr = typeof WeakMap == "function" ? WeakMap : Map;
      bt = new rr();
    }
    function Pr(K, Ie) {
      if (!K || Ge)
        return "";
      {
        var Qe = bt.get(K);
        if (Qe !== void 0)
          return Qe;
      }
      var Ye;
      Ge = !0;
      var Ct = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var dt;
      dt = ze.current, ze.current = null, Be();
      try {
        if (Ie) {
          var Rt = function() {
            throw Error();
          };
          if (Object.defineProperty(Rt.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Rt, []);
            } catch (mr) {
              Ye = mr;
            }
            Reflect.construct(K, [], Rt);
          } else {
            try {
              Rt.call();
            } catch (mr) {
              Ye = mr;
            }
            K.call(Rt.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (mr) {
            Ye = mr;
          }
          K();
        }
      } catch (mr) {
        if (mr && Ye && typeof mr.stack == "string") {
          for (var Et = mr.stack.split(`
`), hr = Ye.stack.split(`
`), er = Et.length - 1, dr = hr.length - 1; er >= 1 && dr >= 0 && Et[er] !== hr[dr]; )
            dr--;
          for (; er >= 1 && dr >= 0; er--, dr--)
            if (Et[er] !== hr[dr]) {
              if (er !== 1 || dr !== 1)
                do
                  if (er--, dr--, dr < 0 || Et[er] !== hr[dr]) {
                    var $t = `
` + Et[er].replace(" at new ", " at ");
                    return K.displayName && $t.includes("<anonymous>") && ($t = $t.replace("<anonymous>", K.displayName)), typeof K == "function" && bt.set(K, $t), $t;
                  }
                while (er >= 1 && dr >= 0);
              break;
            }
        }
      } finally {
        Ge = !1, ze.current = dt, ke(), Error.prepareStackTrace = Ct;
      }
      var On = K ? K.displayName || K.name : "", Fn = On ? qe(On) : "";
      return typeof K == "function" && bt.set(K, Fn), Fn;
    }
    function Gt(K, Ie, Qe) {
      return Pr(K, !1);
    }
    function ar(K) {
      var Ie = K.prototype;
      return !!(Ie && Ie.isReactComponent);
    }
    function St(K, Ie, Qe) {
      if (K == null)
        return "";
      if (typeof K == "function")
        return Pr(K, ar(K));
      if (typeof K == "string")
        return qe(K);
      switch (K) {
        case u:
          return qe("Suspense");
        case c:
          return qe("SuspenseList");
      }
      if (typeof K == "object")
        switch (K.$$typeof) {
          case l:
            return Gt(K.render);
          case d:
            return St(K.type, Ie, Qe);
          case f: {
            var Ye = K, Ct = Ye._payload, dt = Ye._init;
            try {
              return St(dt(Ct), Ie, Qe);
            } catch {
            }
          }
        }
      return "";
    }
    var st = Object.prototype.hasOwnProperty, Qr = {}, Sr = A.ReactDebugCurrentFrame;
    function gr(K) {
      if (K) {
        var Ie = K._owner, Qe = St(K.type, K._source, Ie ? Ie.type : null);
        Sr.setExtraStackFrame(Qe);
      } else
        Sr.setExtraStackFrame(null);
    }
    function nr(K, Ie, Qe, Ye, Ct) {
      {
        var dt = Function.call.bind(st);
        for (var Rt in K)
          if (dt(K, Rt)) {
            var Et = void 0;
            try {
              if (typeof K[Rt] != "function") {
                var hr = Error((Ye || "React class") + ": " + Qe + " type `" + Rt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof K[Rt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw hr.name = "Invariant Violation", hr;
              }
              Et = K[Rt](Ie, Rt, Ye, Qe, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (er) {
              Et = er;
            }
            Et && !(Et instanceof Error) && (gr(Ct), x("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ye || "React class", Qe, Rt, typeof Et), gr(null)), Et instanceof Error && !(Et.message in Qr) && (Qr[Et.message] = !0, gr(Ct), x("Failed %s type: %s", Qe, Et.message), gr(null));
          }
      }
    }
    var fr = Array.isArray;
    function Yt(K) {
      return fr(K);
    }
    function Xt(K) {
      {
        var Ie = typeof Symbol == "function" && Symbol.toStringTag, Qe = Ie && K[Symbol.toStringTag] || K.constructor.name || "Object";
        return Qe;
      }
    }
    function mt(K) {
      try {
        return wr(K), !1;
      } catch {
        return !0;
      }
    }
    function wr(K) {
      return "" + K;
    }
    function an(K) {
      if (mt(K))
        return x("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Xt(K)), wr(K);
    }
    var _r = A.ReactCurrentOwner, ir = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Yr, kr;
    function Zr(K) {
      if (st.call(K, "ref")) {
        var Ie = Object.getOwnPropertyDescriptor(K, "ref").get;
        if (Ie && Ie.isReactWarning)
          return !1;
      }
      return K.ref !== void 0;
    }
    function Vr(K) {
      if (st.call(K, "key")) {
        var Ie = Object.getOwnPropertyDescriptor(K, "key").get;
        if (Ie && Ie.isReactWarning)
          return !1;
      }
      return K.key !== void 0;
    }
    function pn(K, Ie) {
      typeof K.ref == "string" && _r.current;
    }
    function gn(K, Ie) {
      {
        var Qe = function() {
          Yr || (Yr = !0, x("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ie));
        };
        Qe.isReactWarning = !0, Object.defineProperty(K, "key", {
          get: Qe,
          configurable: !0
        });
      }
    }
    function Tr(K, Ie) {
      {
        var Qe = function() {
          kr || (kr = !0, x("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ie));
        };
        Qe.isReactWarning = !0, Object.defineProperty(K, "ref", {
          get: Qe,
          configurable: !0
        });
      }
    }
    var zr = function(K, Ie, Qe, Ye, Ct, dt, Rt) {
      var Et = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: K,
        key: Ie,
        ref: Qe,
        props: Rt,
        // Record the component responsible for creating this element.
        _owner: dt
      };
      return Et._store = {}, Object.defineProperty(Et._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Et, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ye
      }), Object.defineProperty(Et, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ct
      }), Object.freeze && (Object.freeze(Et.props), Object.freeze(Et)), Et;
    };
    function en(K, Ie, Qe, Ye, Ct) {
      {
        var dt, Rt = {}, Et = null, hr = null;
        Qe !== void 0 && (an(Qe), Et = "" + Qe), Vr(Ie) && (an(Ie.key), Et = "" + Ie.key), Zr(Ie) && (hr = Ie.ref, pn(Ie, Ct));
        for (dt in Ie)
          st.call(Ie, dt) && !ir.hasOwnProperty(dt) && (Rt[dt] = Ie[dt]);
        if (K && K.defaultProps) {
          var er = K.defaultProps;
          for (dt in er)
            Rt[dt] === void 0 && (Rt[dt] = er[dt]);
        }
        if (Et || hr) {
          var dr = typeof K == "function" ? K.displayName || K.name || "Unknown" : K;
          Et && gn(Rt, dr), hr && Tr(Rt, dr);
        }
        return zr(K, Et, hr, Ct, Ye, _r.current, Rt);
      }
    }
    var $r = A.ReactCurrentOwner, zt = A.ReactDebugCurrentFrame;
    function sr(K) {
      if (K) {
        var Ie = K._owner, Qe = St(K.type, K._source, Ie ? Ie.type : null);
        zt.setExtraStackFrame(Qe);
      } else
        zt.setExtraStackFrame(null);
    }
    var Er;
    Er = !1;
    function tt(K) {
      return typeof K == "object" && K !== null && K.$$typeof === e;
    }
    function Nr() {
      {
        if ($r.current) {
          var K = J($r.current.type);
          if (K)
            return `

Check the render method of \`` + K + "`.";
        }
        return "";
      }
    }
    function Xr(K) {
      return "";
    }
    var Se = {};
    function P(K) {
      {
        var Ie = Nr();
        if (!Ie) {
          var Qe = typeof K == "string" ? K : K.displayName || K.name;
          Qe && (Ie = `

Check the top-level render call using <` + Qe + ">.");
        }
        return Ie;
      }
    }
    function U(K, Ie) {
      {
        if (!K._store || K._store.validated || K.key != null)
          return;
        K._store.validated = !0;
        var Qe = P(Ie);
        if (Se[Qe])
          return;
        Se[Qe] = !0;
        var Ye = "";
        K && K._owner && K._owner !== $r.current && (Ye = " It was passed a child from " + J(K._owner.type) + "."), sr(K), x('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Qe, Ye), sr(null);
      }
    }
    function X(K, Ie) {
      {
        if (typeof K != "object")
          return;
        if (Yt(K))
          for (var Qe = 0; Qe < K.length; Qe++) {
            var Ye = K[Qe];
            tt(Ye) && U(Ye, Ie);
          }
        else if (tt(K))
          K._store && (K._store.validated = !0);
        else if (K) {
          var Ct = y(K);
          if (typeof Ct == "function" && Ct !== K.entries)
            for (var dt = Ct.call(K), Rt; !(Rt = dt.next()).done; )
              tt(Rt.value) && U(Rt.value, Ie);
        }
      }
    }
    function ue(K) {
      {
        var Ie = K.type;
        if (Ie == null || typeof Ie == "string")
          return;
        var Qe;
        if (typeof Ie == "function")
          Qe = Ie.propTypes;
        else if (typeof Ie == "object" && (Ie.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Ie.$$typeof === d))
          Qe = Ie.propTypes;
        else
          return;
        if (Qe) {
          var Ye = J(Ie);
          nr(Qe, K.props, "prop", Ye, K);
        } else if (Ie.PropTypes !== void 0 && !Er) {
          Er = !0;
          var Ct = J(Ie);
          x("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ct || "Unknown");
        }
        typeof Ie.getDefaultProps == "function" && !Ie.getDefaultProps.isReactClassApproved && x("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Fe(K) {
      {
        for (var Ie = Object.keys(K.props), Qe = 0; Qe < Ie.length; Qe++) {
          var Ye = Ie[Qe];
          if (Ye !== "children" && Ye !== "key") {
            sr(K), x("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ye), sr(null);
            break;
          }
        }
        K.ref !== null && (sr(K), x("Invalid attribute `ref` supplied to `React.Fragment`."), sr(null));
      }
    }
    var We = {};
    function wt(K, Ie, Qe, Ye, Ct, dt) {
      {
        var Rt = ie(K);
        if (!Rt) {
          var Et = "";
          (K === void 0 || typeof K == "object" && K !== null && Object.keys(K).length === 0) && (Et += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var hr = Xr();
          hr ? Et += hr : Et += Nr();
          var er;
          K === null ? er = "null" : Yt(K) ? er = "array" : K !== void 0 && K.$$typeof === e ? (er = "<" + (J(K.type) || "Unknown") + " />", Et = " Did you accidentally export a JSX literal instead of a component?") : er = typeof K, x("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", er, Et);
        }
        var dr = en(K, Ie, Qe, Ct, dt);
        if (dr == null)
          return dr;
        if (Rt) {
          var $t = Ie.children;
          if ($t !== void 0)
            if (Ye)
              if (Yt($t)) {
                for (var On = 0; On < $t.length; On++)
                  X($t[On], K);
                Object.freeze && Object.freeze($t);
              } else
                x("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              X($t, K);
        }
        if (st.call(Ie, "key")) {
          var Fn = J(K), mr = Object.keys(Ie).filter(function(Rr) {
            return Rr !== "key";
          }), xr = mr.length > 0 ? "{key: someKey, " + mr.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!We[Fn + xr]) {
            var wn = mr.length > 0 ? "{" + mr.join(": ..., ") + ": ...}" : "{}";
            x(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, xr, Fn, wn, Fn), We[Fn + xr] = !0;
          }
        }
        return K === n ? Fe(dr) : ue(dr), dr;
      }
    }
    function Pt(K, Ie, Qe) {
      return wt(K, Ie, Qe, !0);
    }
    function Nt(K, Ie, Qe) {
      return wt(K, Ie, Qe, !1);
    }
    var or = Nt, Lt = Pt;
    lf.Fragment = n, lf.jsx = or, lf.jsxs = Lt;
  })()), lf;
}
var Bx;
function SM() {
  return Bx || (Bx = 1, process.env.NODE_ENV === "production" ? Bh.exports = xM() : Bh.exports = CM()), Bh.exports;
}
var At = SM();
const br = () => {
  const r = () => Math.floor((1 + Math.random()) * 65536).toString(16).substring(1);
  return r() + r() + "-" + r() + "-" + r() + "-" + r() + "-" + r() + r() + r();
}, oT = ({
  backgroundColor: r,
  outlineColor: e,
  borderRadius: t,
  configuration: n,
  elements: i,
  height: a,
  maxHeight: s,
  maxWidth: o,
  outlineArea: l,
  position: u,
  preserveAspectRatio: c,
  viewBox: d,
  width: f
}) => {
  const h = t || 0, g = 2 * (l?.scale || 1), v = d || { x: 0, y: 0, width: f, height: a }, y = `${v.x} ${v.y} ${v.width} ${v.height}`, A = br(), x = n.purpose === id.FreeDesign && /* @__PURE__ */ At.jsx("defs", { children: /* @__PURE__ */ At.jsx("clipPath", { id: "viewboxClip", children: /* @__PURE__ */ At.jsx("rect", { width: v.width, height: v.height, rx: h }) }) }), k = n.colorProfiles?.map((R, M) => (
    /* @ts-ignore */
    /* @__PURE__ */ At.jsx("color-profile", { name: R.name, xlinkHref: R.key, children: " " }, M)
  )), F = i.map((R) => ({
    ...R,
    _renderingConfiguration: n,
    mask: l ? `url(#viewmask-${A})` : void 0
  })), S = f1(F);
  return /* @__PURE__ */ At.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      xmlSpace: "preserve",
      version: "1.1",
      preserveAspectRatio: c,
      width: f,
      height: a,
      style: {
        gridColumn: 1,
        gridRow: 1,
        maxWidth: o,
        maxHeight: s,
        position: u
      },
      viewBox: y,
      children: [
        k,
        x,
        !!r && /* @__PURE__ */ At.jsx(
          "rect",
          {
            id: "layout-background",
            width: v.width,
            height: v.height,
            fill: r,
            rx: h
          }
        ),
        /* @__PURE__ */ At.jsx(
          "g",
          {
            id: "element-group",
            clipPath: n.purpose === id.FreeDesign ? "url(#viewboxClip)" : void 0,
            children: S.map((R) => vF(R)).filter((R) => !!R)
          }
        ),
        l && /* @__PURE__ */ At.jsx(
          "rect",
          {
            x: l.x,
            y: l.y,
            width: l.width,
            height: l.height,
            fill: "none",
            stroke: l.hidden ? "none" : e || "#aaaaaa",
            strokeWidth: g / 2,
            strokeDasharray: `${g * 2} ${g}`
          }
        ),
        l && /* @__PURE__ */ At.jsxs("mask", { id: `viewmask-${A}`, children: [
          /* @__PURE__ */ At.jsx(
            "rect",
            {
              x: v.x,
              y: v.y,
              width: v.width,
              height: v.height,
              fill: "black"
            }
          ),
          /* @__PURE__ */ At.jsx(
            "rect",
            {
              x: l.x,
              y: l.y,
              width: l.width,
              height: l.height,
              fill: "white"
            }
          )
        ] })
      ]
    }
  );
}, mQ = (r, e, t, n, i) => {
  const a = xo(i), s = t / 2, o = n / 2, l = r + s, u = e + o, c = Math.sin(a), d = Math.cos(a), f = s, h = s, g = -o, v = o, y = f * d - g * c, A = h * d - v * c, x = f * c + g * d, k = h * c + v * d, F = Math.max(Math.abs(y), Math.abs(A)), S = Math.max(Math.abs(x), Math.abs(k));
  return {
    minX: l - F,
    maxX: l + F,
    minY: u - S,
    maxY: u + S
  };
}, vQ = (r, e, t) => {
  const n = Math.sqrt(Math.pow(e.x - r.x, 2) + Math.pow(e.y - r.y, 2)), i = Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2)), a = Math.sqrt(Math.pow(t.x - r.x, 2) + Math.pow(t.y - r.y, 2));
  return Math.acos((i * i + n * n - a * a) / (2 * i * n)) * (180 / Math.PI);
}, xo = (r) => r * (Math.PI / 180), yQ = (r, e, t) => Math.abs(r - e) < t, AQ = (r, e, t) => {
  const n = Math.sin(xo(t)), i = Math.cos(xo(t));
  return {
    x: (r.x - e.x) * i - (r.y - e.y) * n + e.x,
    y: (r.x - e.x) * n + (r.y - e.y) * i + e.y
  };
}, bQ = (r, e) => ({
  x: (r.x + e.x) / 2,
  y: (r.y + e.y) / 2
}), wQ = (r, e, t, n) => ({
  x: r.x + e?.x * t,
  y: r.y + e?.y * n
}), xQ = (r, e, t, n) => ({
  x: r.x + (e?.x + e?.width) * t,
  y: r.y + e?.y * n
}), CQ = (r, e, t, n) => ({
  x: r.x + (e?.x + e?.width) * t,
  y: r.y + (e?.y + e?.height) * n
}), gu = (r) => {
  switch (r) {
    case Ci.North:
      return Ci.East;
    case Ci.East:
      return Ci.South;
    case Ci.South:
      return Ci.West;
    case Ci.West:
      return Ci.North;
    case Ci.Northwest:
      return Ci.Northeast;
    case Ci.Northeast:
      return Ci.Southeast;
    case Ci.Southeast:
      return Ci.Southwest;
    case Ci.Southwest:
      return Ci.Northwest;
  }
}, SQ = (r, e) => e > 45 && e <= 135 ? gu(r) : e > 135 && e <= 225 ? gu(gu(r)) : e > 225 && e <= 315 ? gu(gu(gu(r))) : r, EQ = (r, e = { x: 0, y: 0 }, t = { x: 1, y: 1 }) => {
  const n = xo(r.rotation), i = {
    x: e.x + r.x * t.x,
    y: e.x + r.y * t.y
  }, a = {
    x: r.x + r.width,
    y: r.y
  }, s = {
    x: e.x + (r.x + r.width) * t.x,
    y: e.y + (r.height + r.y) * t.y
  }, o = {
    x: e.x + r.x * t.x,
    y: e.y + (r.height + r.y) * t.y
  }, l = {
    x: (o.x + s.x) / 2,
    y: o.y - r.height * t.y / 2
  };
  return {
    a: Mh(i, l, n),
    b: Mh(a, l, n),
    c: Mh(s, l, n),
    d: Mh(o, l, n),
    center: l
  };
}, Mh = (r, e, t) => {
  const n = Math.sin(t), i = Math.cos(t);
  return {
    x: (r.x - e.x) * i - (r.y - e.y) * n + e.x,
    y: (r.x - e.x) * n + (r.y - e.y) * i + e.y
  };
}, kQ = 0.352778, TQ = 0.035277, lT = (r) => {
  const e = r.rotation || 0, t = xo(e), n = Math.cos(t), i = -Math.sin(t);
  return /* @__PURE__ */ At.jsx("g", { mask: r.stepName || r.productOverlay ? void 0 : r.mask, children: /* @__PURE__ */ At.jsx(
    "g",
    {
      transform: `
                matrix(1, 0, 0, 1, ${r.x}, ${r.y})
                matrix(1, 0, 0, 1, ${r.width / 2}, ${r.height / 2})
                matrix(${n}, ${-i}, ${i}, ${n}, 0, 0)
                matrix(1, 0, 0, 1, ${-r.width / 2}, ${-r.height / 2})
                `,
      children: /* @__PURE__ */ At.jsx(
        "image",
        {
          xlinkHref: r.src,
          preserveAspectRatio: r.preserveAspectRatio,
          width: r.width,
          height: r.height
        }
      )
    }
  ) });
}, uT = (r) => {
  const e = `spiff-group-clip-${r.id}`, t = r.rotation || 0, n = xo(t), i = Math.cos(n), a = -Math.sin(n), s = f1(r.children), o = () => /* @__PURE__ */ At.jsx("clipPath", { id: e, preserveAspectRatio: "none", children: r.clipPath ? /* @__PURE__ */ At.jsx("path", { d: r.clipPath }) : /* @__PURE__ */ At.jsx("rect", { x: 0, y: 0, width: r.width, height: r.height }) });
  return /* @__PURE__ */ At.jsxs(At.Fragment, { children: [
    /* @__PURE__ */ At.jsx("defs", { children: o() }),
    /* @__PURE__ */ At.jsxs(
      "g",
      {
        transform: `
                matrix(1, 0, 0, 1, ${r.x}, ${r.y})
                matrix(1, 0, 0, 1, ${r.width / 2}, ${r.height / 2})
                matrix(${i}, ${-a}, ${a}, ${i}, 0, 0)
                matrix(1, 0, 0, 1, ${-r.width / 2}, ${-r.height / 2})
                `,
        children: [
          r._renderingConfiguration?.debug ? /* @__PURE__ */ At.jsx(
            "rect",
            {
              stroke: "red",
              opacity: 0.3,
              fill: "none",
              x: 0,
              y: 0,
              width: r.width,
              height: r.height
            }
          ) : void 0,
          s.map((l) => vF(l)).filter((l) => !!l).map((l) => /* @__PURE__ */ At.jsx("g", { clipPath: `url(#${e})`, children: l }, e))
        ]
      }
    )
  ] });
};
var EM = Sl();
const kM = (r) => {
  const e = `spiff-frame-${r.id}`, t = `spiff-frame-threshold-${r.id}`, n = () => {
    if (!r.pattern)
      return "";
    if (r.pattern.svg) {
      const d = zA(r.pattern.svg, r.pattern.colors || {}, !1);
      return DA(d);
    }
    return r.pattern.src;
  };
  if (!n())
    return /* @__PURE__ */ At.jsx(EM.Fragment, {});
  const i = () => r.threshold ? r.invertThreshold ? "1 ".repeat(r.threshold) + "0 ".repeat(256 - r.threshold) : "0 ".repeat(r.threshold) + "1 ".repeat(256 - r.threshold) : "", a = () => /* @__PURE__ */ At.jsx(At.Fragment, { children: r.useThreshold && /* @__PURE__ */ At.jsx("defs", { children: /* @__PURE__ */ At.jsxs("filter", { id: t, "color-interpolation-filters": "sRGB", children: [
    /* @__PURE__ */ At.jsx(
      "feColorMatrix",
      {
        type: "matrix",
        values: `
                            ${r.thresholdSaturation} ${r.thresholdSaturation} ${r.thresholdSaturation} 0 0
                            ${r.thresholdSaturation} ${r.thresholdSaturation} ${r.thresholdSaturation} 0 0
                            ${r.thresholdSaturation} ${r.thresholdSaturation} ${r.thresholdSaturation} 0 0
                            0 0 0 1 0
                        `,
        result: "greyscale"
      }
    ),
    /* @__PURE__ */ At.jsxs("feComponentTransfer", { in: "greyscale", children: [
      /* @__PURE__ */ At.jsx("feFuncR", { type: "discrete", tableValues: i() }),
      /* @__PURE__ */ At.jsx("feFuncG", { type: "discrete", tableValues: i() }),
      /* @__PURE__ */ At.jsx("feFuncB", { type: "discrete", tableValues: i() })
    ] })
  ] }) }) }), s = r.rotation || 0, o = xo(s), l = Math.cos(o), u = -Math.sin(o), c = () => {
    const d = r.pattern?.x || 0, f = r.pattern?.y || 0, h = r.pattern?.width || 0, g = r.pattern?.height || 0, v = r.pattern?.scaleX || 1, y = r.pattern?.scaleY || 1, A = r.pattern?.rotation || 0;
    return [r.pattern?.svg ? {
      id: `${e}-contents`,
      type: tr.Illustration,
      x: d,
      y: f,
      rotation: A,
      width: h * v,
      height: g * y,
      src: n(),
      svg: r.pattern?.svg,
      colors: r.pattern?.colors
    } : {
      id: `${e}-contents`,
      type: tr.Image,
      x: d,
      y: f,
      rotation: A,
      width: h * v,
      height: g * y,
      src: n()
    }];
  };
  return /* @__PURE__ */ At.jsxs(At.Fragment, { children: [
    a(),
    /* @__PURE__ */ At.jsx(
      "g",
      {
        opacity: r.opacity,
        mask: r.stepName ? void 0 : r.mask,
        filter: r.useThreshold ? `url(#${t})` : void 0,
        children: /* @__PURE__ */ At.jsx(
          "g",
          {
            transform: `
                matrix(1, 0, 0, 1, ${r.x}, ${r.y})
                matrix(1, 0, 0, 1, ${r.width / 2}, ${r.height / 2})
                matrix(${l}, ${-u}, ${u}, ${l}, 0, 0)
                matrix(1, 0, 0, 1, ${-r.width / 2}, ${-r.height / 2})
                matrix(${r.scaleX}, 0, 0, ${r.scaleY}, 0, 0)
                `,
            children: /* @__PURE__ */ At.jsx(
              uT,
              {
                id: e,
                x: 0,
                y: 0,
                rotation: 0,
                width: r.width,
                height: r.height,
                clipPath: r.path,
                children: c()
              }
            )
          }
        )
      }
    )
  ] });
};
String.prototype.codePointAt || (function() {
  var r = (function() {
    try {
      var t = {}, n = Object.defineProperty, i = n(t, t, t) && n;
    } catch {
    }
    return i;
  })(), e = function(t) {
    if (this == null)
      throw TypeError();
    var n = String(this), i = n.length, a = t ? Number(t) : 0;
    if (a != a && (a = 0), !(a < 0 || a >= i)) {
      var s = n.charCodeAt(a), o;
      return (
        // check if it’s the start of a surrogate pair
        s >= 55296 && s <= 56319 && // high surrogate
        i > a + 1 && (o = n.charCodeAt(a + 1), o >= 56320 && o <= 57343) ? (s - 55296) * 1024 + o - 56320 + 65536 : s
      );
    }
  };
  r ? r(String.prototype, "codePointAt", {
    value: e,
    configurable: !0,
    writable: !0
  }) : String.prototype.codePointAt = e;
})();
var JA = 0, cT = -3;
function ud() {
  this.table = new Uint16Array(16), this.trans = new Uint16Array(288);
}
function TM(r, e) {
  this.source = r, this.sourceIndex = 0, this.tag = 0, this.bitcount = 0, this.dest = e, this.destLen = 0, this.ltree = new ud(), this.dtree = new ud();
}
var fT = new ud(), dT = new ud(), KA = new Uint8Array(30), ZA = new Uint16Array(30), hT = new Uint8Array(30), pT = new Uint16Array(30), FM = new Uint8Array([
  16,
  17,
  18,
  0,
  8,
  7,
  9,
  6,
  10,
  5,
  11,
  4,
  12,
  3,
  13,
  2,
  14,
  1,
  15
]), Mx = new ud(), Ga = new Uint8Array(320);
function gT(r, e, t, n) {
  var i, a;
  for (i = 0; i < t; ++i)
    r[i] = 0;
  for (i = 0; i < 30 - t; ++i)
    r[i + t] = i / t | 0;
  for (a = n, i = 0; i < 30; ++i)
    e[i] = a, a += 1 << r[i];
}
function IM(r, e) {
  var t;
  for (t = 0; t < 7; ++t)
    r.table[t] = 0;
  for (r.table[7] = 24, r.table[8] = 152, r.table[9] = 112, t = 0; t < 24; ++t)
    r.trans[t] = 256 + t;
  for (t = 0; t < 144; ++t)
    r.trans[24 + t] = t;
  for (t = 0; t < 8; ++t)
    r.trans[168 + t] = 280 + t;
  for (t = 0; t < 112; ++t)
    r.trans[176 + t] = 144 + t;
  for (t = 0; t < 5; ++t)
    e.table[t] = 0;
  for (e.table[5] = 32, t = 0; t < 32; ++t)
    e.trans[t] = t;
}
var _x = new Uint16Array(16);
function h0(r, e, t, n) {
  var i, a;
  for (i = 0; i < 16; ++i)
    r.table[i] = 0;
  for (i = 0; i < n; ++i)
    r.table[e[t + i]]++;
  for (r.table[0] = 0, a = 0, i = 0; i < 16; ++i)
    _x[i] = a, a += r.table[i];
  for (i = 0; i < n; ++i)
    e[t + i] && (r.trans[_x[e[t + i]]++] = i);
}
function DM(r) {
  r.bitcount-- || (r.tag = r.source[r.sourceIndex++], r.bitcount = 7);
  var e = r.tag & 1;
  return r.tag >>>= 1, e;
}
function Ja(r, e, t) {
  if (!e)
    return t;
  for (; r.bitcount < 24; )
    r.tag |= r.source[r.sourceIndex++] << r.bitcount, r.bitcount += 8;
  var n = r.tag & 65535 >>> 16 - e;
  return r.tag >>>= e, r.bitcount -= e, n + t;
}
function Oy(r, e) {
  for (; r.bitcount < 24; )
    r.tag |= r.source[r.sourceIndex++] << r.bitcount, r.bitcount += 8;
  var t = 0, n = 0, i = 0, a = r.tag;
  do
    n = 2 * n + (a & 1), a >>>= 1, ++i, t += e.table[i], n -= e.table[i];
  while (n >= 0);
  return r.tag = a, r.bitcount -= i, e.trans[t + n];
}
function PM(r, e, t) {
  var n, i, a, s, o, l;
  for (n = Ja(r, 5, 257), i = Ja(r, 5, 1), a = Ja(r, 4, 4), s = 0; s < 19; ++s)
    Ga[s] = 0;
  for (s = 0; s < a; ++s) {
    var u = Ja(r, 3, 0);
    Ga[FM[s]] = u;
  }
  for (h0(Mx, Ga, 0, 19), o = 0; o < n + i; ) {
    var c = Oy(r, Mx);
    switch (c) {
      case 16:
        var d = Ga[o - 1];
        for (l = Ja(r, 2, 3); l; --l)
          Ga[o++] = d;
        break;
      case 17:
        for (l = Ja(r, 3, 3); l; --l)
          Ga[o++] = 0;
        break;
      case 18:
        for (l = Ja(r, 7, 11); l; --l)
          Ga[o++] = 0;
        break;
      default:
        Ga[o++] = c;
        break;
    }
  }
  h0(e, Ga, 0, n), h0(t, Ga, n, i);
}
function Nx(r, e, t) {
  for (; ; ) {
    var n = Oy(r, e);
    if (n === 256)
      return JA;
    if (n < 256)
      r.dest[r.destLen++] = n;
    else {
      var i, a, s, o;
      for (n -= 257, i = Ja(r, KA[n], ZA[n]), a = Oy(r, t), s = r.destLen - Ja(r, hT[a], pT[a]), o = s; o < s + i; ++o)
        r.dest[r.destLen++] = r.dest[o];
    }
  }
}
function RM(r) {
  for (var e, t, n; r.bitcount > 8; )
    r.sourceIndex--, r.bitcount -= 8;
  if (e = r.source[r.sourceIndex + 1], e = 256 * e + r.source[r.sourceIndex], t = r.source[r.sourceIndex + 3], t = 256 * t + r.source[r.sourceIndex + 2], e !== (~t & 65535))
    return cT;
  for (r.sourceIndex += 4, n = e; n; --n)
    r.dest[r.destLen++] = r.source[r.sourceIndex++];
  return r.bitcount = 0, JA;
}
function OM(r, e) {
  var t = new TM(r, e), n, i, a;
  do {
    switch (n = DM(t), i = Ja(t, 2, 0), i) {
      case 0:
        a = RM(t);
        break;
      case 1:
        a = Nx(t, fT, dT);
        break;
      case 2:
        PM(t, t.ltree, t.dtree), a = Nx(t, t.ltree, t.dtree);
        break;
      default:
        a = cT;
    }
    if (a !== JA)
      throw new Error("Data error");
  } while (!n);
  return t.destLen < t.dest.length ? typeof t.dest.slice == "function" ? t.dest.slice(0, t.destLen) : t.dest.subarray(0, t.destLen) : t.dest;
}
IM(fT, dT);
gT(KA, ZA, 4, 3);
gT(hT, pT, 2, 1);
KA[28] = 0;
ZA[28] = 258;
var BM = OM;
function mu(r, e, t, n, i) {
  return Math.pow(1 - i, 3) * r + 3 * Math.pow(1 - i, 2) * i * e + 3 * (1 - i) * Math.pow(i, 2) * t + Math.pow(i, 3) * n;
}
function Fo() {
  this.x1 = Number.NaN, this.y1 = Number.NaN, this.x2 = Number.NaN, this.y2 = Number.NaN;
}
Fo.prototype.isEmpty = function() {
  return isNaN(this.x1) || isNaN(this.y1) || isNaN(this.x2) || isNaN(this.y2);
};
Fo.prototype.addPoint = function(r, e) {
  typeof r == "number" && ((isNaN(this.x1) || isNaN(this.x2)) && (this.x1 = r, this.x2 = r), r < this.x1 && (this.x1 = r), r > this.x2 && (this.x2 = r)), typeof e == "number" && ((isNaN(this.y1) || isNaN(this.y2)) && (this.y1 = e, this.y2 = e), e < this.y1 && (this.y1 = e), e > this.y2 && (this.y2 = e));
};
Fo.prototype.addX = function(r) {
  this.addPoint(r, null);
};
Fo.prototype.addY = function(r) {
  this.addPoint(null, r);
};
Fo.prototype.addBezier = function(r, e, t, n, i, a, s, o) {
  var l = [r, e], u = [t, n], c = [i, a], d = [s, o];
  this.addPoint(r, e), this.addPoint(s, o);
  for (var f = 0; f <= 1; f++) {
    var h = 6 * l[f] - 12 * u[f] + 6 * c[f], g = -3 * l[f] + 9 * u[f] - 9 * c[f] + 3 * d[f], v = 3 * u[f] - 3 * l[f];
    if (g === 0) {
      if (h === 0)
        continue;
      var y = -v / h;
      0 < y && y < 1 && (f === 0 && this.addX(mu(l[f], u[f], c[f], d[f], y)), f === 1 && this.addY(mu(l[f], u[f], c[f], d[f], y)));
      continue;
    }
    var A = Math.pow(h, 2) - 4 * v * g;
    if (!(A < 0)) {
      var x = (-h + Math.sqrt(A)) / (2 * g);
      0 < x && x < 1 && (f === 0 && this.addX(mu(l[f], u[f], c[f], d[f], x)), f === 1 && this.addY(mu(l[f], u[f], c[f], d[f], x)));
      var k = (-h - Math.sqrt(A)) / (2 * g);
      0 < k && k < 1 && (f === 0 && this.addX(mu(l[f], u[f], c[f], d[f], k)), f === 1 && this.addY(mu(l[f], u[f], c[f], d[f], k)));
    }
  }
};
Fo.prototype.addQuad = function(r, e, t, n, i, a) {
  var s = r + 0.6666666666666666 * (t - r), o = e + 2 / 3 * (n - e), l = s + 1 / 3 * (i - r), u = o + 1 / 3 * (a - e);
  this.addBezier(r, e, s, o, l, u, i, a);
};
function ci() {
  this.commands = [], this.fill = "black", this.stroke = null, this.strokeWidth = 1;
}
ci.prototype.moveTo = function(r, e) {
  this.commands.push({
    type: "M",
    x: r,
    y: e
  });
};
ci.prototype.lineTo = function(r, e) {
  this.commands.push({
    type: "L",
    x: r,
    y: e
  });
};
ci.prototype.curveTo = ci.prototype.bezierCurveTo = function(r, e, t, n, i, a) {
  this.commands.push({
    type: "C",
    x1: r,
    y1: e,
    x2: t,
    y2: n,
    x: i,
    y: a
  });
};
ci.prototype.quadTo = ci.prototype.quadraticCurveTo = function(r, e, t, n) {
  this.commands.push({
    type: "Q",
    x1: r,
    y1: e,
    x: t,
    y: n
  });
};
ci.prototype.close = ci.prototype.closePath = function() {
  this.commands.push({
    type: "Z"
  });
};
ci.prototype.extend = function(r) {
  if (r.commands)
    r = r.commands;
  else if (r instanceof Fo) {
    var e = r;
    this.moveTo(e.x1, e.y1), this.lineTo(e.x2, e.y1), this.lineTo(e.x2, e.y2), this.lineTo(e.x1, e.y2), this.close();
    return;
  }
  Array.prototype.push.apply(this.commands, r);
};
ci.prototype.getBoundingBox = function() {
  for (var r = new Fo(), e = 0, t = 0, n = 0, i = 0, a = 0; a < this.commands.length; a++) {
    var s = this.commands[a];
    switch (s.type) {
      case "M":
        r.addPoint(s.x, s.y), e = n = s.x, t = i = s.y;
        break;
      case "L":
        r.addPoint(s.x, s.y), n = s.x, i = s.y;
        break;
      case "Q":
        r.addQuad(n, i, s.x1, s.y1, s.x, s.y), n = s.x, i = s.y;
        break;
      case "C":
        r.addBezier(n, i, s.x1, s.y1, s.x2, s.y2, s.x, s.y), n = s.x, i = s.y;
        break;
      case "Z":
        n = e, i = t;
        break;
      default:
        throw new Error("Unexpected path command " + s.type);
    }
  }
  return r.isEmpty() && r.addPoint(0, 0), r;
};
ci.prototype.draw = function(r) {
  r.beginPath();
  for (var e = 0; e < this.commands.length; e += 1) {
    var t = this.commands[e];
    t.type === "M" ? r.moveTo(t.x, t.y) : t.type === "L" ? r.lineTo(t.x, t.y) : t.type === "C" ? r.bezierCurveTo(t.x1, t.y1, t.x2, t.y2, t.x, t.y) : t.type === "Q" ? r.quadraticCurveTo(t.x1, t.y1, t.x, t.y) : t.type === "Z" && r.closePath();
  }
  this.fill && (r.fillStyle = this.fill, r.fill()), this.stroke && (r.strokeStyle = this.stroke, r.lineWidth = this.strokeWidth, r.stroke());
};
ci.prototype.toPathData = function(r) {
  r = r !== void 0 ? r : 2;
  function e(s) {
    return Math.round(s) === s ? "" + Math.round(s) : s.toFixed(r);
  }
  function t() {
    for (var s = arguments, o = "", l = 0; l < arguments.length; l += 1) {
      var u = s[l];
      u >= 0 && l > 0 && (o += " "), o += e(u);
    }
    return o;
  }
  for (var n = "", i = 0; i < this.commands.length; i += 1) {
    var a = this.commands[i];
    a.type === "M" ? n += "M" + t(a.x, a.y) : a.type === "L" ? n += "L" + t(a.x, a.y) : a.type === "C" ? n += "C" + t(a.x1, a.y1, a.x2, a.y2, a.x, a.y) : a.type === "Q" ? n += "Q" + t(a.x1, a.y1, a.x, a.y) : a.type === "Z" && (n += "Z");
  }
  return n;
};
ci.prototype.toSVG = function(r) {
  var e = '<path d="';
  return e += this.toPathData(r), e += '"', this.fill && this.fill !== "black" && (this.fill === null ? e += ' fill="none"' : e += ' fill="' + this.fill + '"'), this.stroke && (e += ' stroke="' + this.stroke + '" stroke-width="' + this.strokeWidth + '"'), e += "/>", e;
};
ci.prototype.toDOMElement = function(r) {
  var e = this.toPathData(r), t = document.createElementNS("http://www.w3.org/2000/svg", "path");
  return t.setAttribute("d", e), t;
};
function mT(r) {
  throw new Error(r);
}
function Lx(r, e) {
  r || mT(e);
}
var jt = { fail: mT, argument: Lx, assert: Lx }, Ux = 32768, Vx = 2147483648, Wu = {}, it = {}, Qt = {};
function Ma(r) {
  return function() {
    return r;
  };
}
it.BYTE = function(r) {
  return jt.argument(r >= 0 && r <= 255, "Byte value should be between 0 and 255."), [r];
};
Qt.BYTE = Ma(1);
it.CHAR = function(r) {
  return [r.charCodeAt(0)];
};
Qt.CHAR = Ma(1);
it.CHARARRAY = function(r) {
  typeof r > "u" && (r = "", console.warn("Undefined CHARARRAY encountered and treated as an empty string. This is probably caused by a missing glyph name."));
  for (var e = [], t = 0; t < r.length; t += 1)
    e[t] = r.charCodeAt(t);
  return e;
};
Qt.CHARARRAY = function(r) {
  return typeof r > "u" ? 0 : r.length;
};
it.USHORT = function(r) {
  return [r >> 8 & 255, r & 255];
};
Qt.USHORT = Ma(2);
it.SHORT = function(r) {
  return r >= Ux && (r = -(2 * Ux - r)), [r >> 8 & 255, r & 255];
};
Qt.SHORT = Ma(2);
it.UINT24 = function(r) {
  return [r >> 16 & 255, r >> 8 & 255, r & 255];
};
Qt.UINT24 = Ma(3);
it.ULONG = function(r) {
  return [r >> 24 & 255, r >> 16 & 255, r >> 8 & 255, r & 255];
};
Qt.ULONG = Ma(4);
it.LONG = function(r) {
  return r >= Vx && (r = -(2 * Vx - r)), [r >> 24 & 255, r >> 16 & 255, r >> 8 & 255, r & 255];
};
Qt.LONG = Ma(4);
it.FIXED = it.ULONG;
Qt.FIXED = Qt.ULONG;
it.FWORD = it.SHORT;
Qt.FWORD = Qt.SHORT;
it.UFWORD = it.USHORT;
Qt.UFWORD = Qt.USHORT;
it.LONGDATETIME = function(r) {
  return [0, 0, 0, 0, r >> 24 & 255, r >> 16 & 255, r >> 8 & 255, r & 255];
};
Qt.LONGDATETIME = Ma(8);
it.TAG = function(r) {
  return jt.argument(r.length === 4, "Tag should be exactly 4 ASCII characters."), [
    r.charCodeAt(0),
    r.charCodeAt(1),
    r.charCodeAt(2),
    r.charCodeAt(3)
  ];
};
Qt.TAG = Ma(4);
it.Card8 = it.BYTE;
Qt.Card8 = Qt.BYTE;
it.Card16 = it.USHORT;
Qt.Card16 = Qt.USHORT;
it.OffSize = it.BYTE;
Qt.OffSize = Qt.BYTE;
it.SID = it.USHORT;
Qt.SID = Qt.USHORT;
it.NUMBER = function(r) {
  return r >= -107 && r <= 107 ? [r + 139] : r >= 108 && r <= 1131 ? (r = r - 108, [(r >> 8) + 247, r & 255]) : r >= -1131 && r <= -108 ? (r = -r - 108, [(r >> 8) + 251, r & 255]) : r >= -32768 && r <= 32767 ? it.NUMBER16(r) : it.NUMBER32(r);
};
Qt.NUMBER = function(r) {
  return it.NUMBER(r).length;
};
it.NUMBER16 = function(r) {
  return [28, r >> 8 & 255, r & 255];
};
Qt.NUMBER16 = Ma(3);
it.NUMBER32 = function(r) {
  return [29, r >> 24 & 255, r >> 16 & 255, r >> 8 & 255, r & 255];
};
Qt.NUMBER32 = Ma(5);
it.REAL = function(r) {
  var e = r.toString(), t = /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/.exec(e);
  if (t) {
    var n = parseFloat("1e" + ((t[2] ? +t[2] : 0) + t[1].length));
    e = (Math.round(r * n) / n).toString();
  }
  for (var i = "", a = 0, s = e.length; a < s; a += 1) {
    var o = e[a];
    o === "e" ? i += e[++a] === "-" ? "c" : "b" : o === "." ? i += "a" : o === "-" ? i += "e" : i += o;
  }
  i += i.length & 1 ? "f" : "ff";
  for (var l = [30], u = 0, c = i.length; u < c; u += 2)
    l.push(parseInt(i.substr(u, 2), 16));
  return l;
};
Qt.REAL = function(r) {
  return it.REAL(r).length;
};
it.NAME = it.CHARARRAY;
Qt.NAME = Qt.CHARARRAY;
it.STRING = it.CHARARRAY;
Qt.STRING = Qt.CHARARRAY;
Wu.UTF8 = function(r, e, t) {
  for (var n = [], i = t, a = 0; a < i; a++, e += 1)
    n[a] = r.getUint8(e);
  return String.fromCharCode.apply(null, n);
};
Wu.UTF16 = function(r, e, t) {
  for (var n = [], i = t / 2, a = 0; a < i; a++, e += 2)
    n[a] = r.getUint16(e);
  return String.fromCharCode.apply(null, n);
};
it.UTF16 = function(r) {
  for (var e = [], t = 0; t < r.length; t += 1) {
    var n = r.charCodeAt(t);
    e[e.length] = n >> 8 & 255, e[e.length] = n & 255;
  }
  return e;
};
Qt.UTF16 = function(r) {
  return r.length * 2;
};
var By = {
  "x-mac-croatian": (
    // Python: 'mac_croatian'
    "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®Š™´¨≠ŽØ∞±≤≥∆µ∂∑∏š∫ªºΩžø¿¡¬√ƒ≈Ć«Č… ÀÃÕŒœĐ—“”‘’÷◊©⁄€‹›Æ»–·‚„‰ÂćÁčÈÍÎÏÌÓÔđÒÚÛÙıˆ˜¯πË˚¸Êæˇ"
  ),
  "x-mac-cyrillic": (
    // Python: 'mac_cyrillic'
    "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°Ґ£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµґЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю"
  ),
  "x-mac-gaelic": (
    // http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/GAELIC.TXT
    "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØḂ±≤≥ḃĊċḊḋḞḟĠġṀæøṁṖṗɼƒſṠ«»… ÀÃÕŒœ–—“”‘’ṡẛÿŸṪ€‹›Ŷŷṫ·Ỳỳ⁊ÂÊÁËÈÍÎÏÌÓÔ♣ÒÚÛÙıÝýŴŵẄẅẀẁẂẃ"
  ),
  "x-mac-greek": (
    // Python: 'mac_greek'
    "Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦€ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ­"
  ),
  "x-mac-icelandic": (
    // Python: 'mac_iceland'
    "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
  ),
  "x-mac-inuit": (
    // http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/INUIT.TXT
    "ᐃᐄᐅᐆᐊᐋᐱᐲᐳᐴᐸᐹᑉᑎᑏᑐᑑᑕᑖᑦᑭᑮᑯᑰᑲᑳᒃᒋᒌᒍᒎᒐᒑ°ᒡᒥᒦ•¶ᒧ®©™ᒨᒪᒫᒻᓂᓃᓄᓅᓇᓈᓐᓯᓰᓱᓲᓴᓵᔅᓕᓖᓗᓘᓚᓛᓪᔨᔩᔪᔫᔭ… ᔮᔾᕕᕖᕗ–—“”‘’ᕘᕙᕚᕝᕆᕇᕈᕉᕋᕌᕐᕿᖀᖁᖂᖃᖄᖅᖏᖐᖑᖒᖓᖔᖕᙱᙲᙳᙴᙵᙶᖖᖠᖡᖢᖣᖤᖥᖦᕼŁł"
  ),
  "x-mac-ce": (
    // Python: 'mac_latin2'
    "ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ"
  ),
  macintosh: (
    // Python: 'mac_roman'
    "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
  ),
  "x-mac-romanian": (
    // Python: 'mac_romanian'
    "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ĂȘ∞±≤≥¥µ∂∑∏π∫ªºΩăș¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€‹›Țț‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
  ),
  "x-mac-turkish": (
    // Python: 'mac_turkish'
    "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙˆ˜¯˘˙˚¸˝˛ˇ"
  )
};
Wu.MACSTRING = function(r, e, t, n) {
  var i = By[n];
  if (i !== void 0) {
    for (var a = "", s = 0; s < t; s++) {
      var o = r.getUint8(e + s);
      o <= 127 ? a += String.fromCharCode(o) : a += i[o & 127];
    }
    return a;
  }
};
var _h = typeof WeakMap == "function" && /* @__PURE__ */ new WeakMap(), Nh, MM = function(r) {
  if (!Nh) {
    Nh = {};
    for (var e in By)
      Nh[e] = new String(e);
  }
  var t = Nh[r];
  if (t !== void 0) {
    if (_h) {
      var n = _h.get(t);
      if (n !== void 0)
        return n;
    }
    var i = By[r];
    if (i !== void 0) {
      for (var a = {}, s = 0; s < i.length; s++)
        a[i.charCodeAt(s)] = s + 128;
      return _h && _h.set(t, a), a;
    }
  }
};
it.MACSTRING = function(r, e) {
  var t = MM(e);
  if (t !== void 0) {
    for (var n = [], i = 0; i < r.length; i++) {
      var a = r.charCodeAt(i);
      if (a >= 128 && (a = t[a], a === void 0))
        return;
      n[i] = a;
    }
    return n;
  }
};
Qt.MACSTRING = function(r, e) {
  var t = it.MACSTRING(r, e);
  return t !== void 0 ? t.length : 0;
};
function My(r) {
  return r >= -128 && r <= 127;
}
function _M(r, e, t) {
  for (var n = 0, i = r.length; e < i && n < 64 && r[e] === 0; )
    ++e, ++n;
  return t.push(128 | n - 1), e;
}
function NM(r, e, t) {
  for (var n = 0, i = r.length, a = e; a < i && n < 64; ) {
    var s = r[a];
    if (!My(s) || s === 0 && a + 1 < i && r[a + 1] === 0)
      break;
    ++a, ++n;
  }
  t.push(n - 1);
  for (var o = e; o < a; ++o)
    t.push(r[o] + 256 & 255);
  return a;
}
function LM(r, e, t) {
  for (var n = 0, i = r.length, a = e; a < i && n < 64; ) {
    var s = r[a];
    if (s === 0 || My(s) && a + 1 < i && My(r[a + 1]))
      break;
    ++a, ++n;
  }
  t.push(64 | n - 1);
  for (var o = e; o < a; ++o) {
    var l = r[o];
    t.push(l + 65536 >> 8 & 255, l + 256 & 255);
  }
  return a;
}
it.VARDELTAS = function(r) {
  for (var e = 0, t = []; e < r.length; ) {
    var n = r[e];
    n === 0 ? e = _M(r, e, t) : n >= -128 && n <= 127 ? e = NM(r, e, t) : e = LM(r, e, t);
  }
  return t;
};
it.INDEX = function(r) {
  for (var e = 1, t = [e], n = [], i = 0; i < r.length; i += 1) {
    var a = it.OBJECT(r[i]);
    Array.prototype.push.apply(n, a), e += a.length, t.push(e);
  }
  if (n.length === 0)
    return [0, 0];
  for (var s = [], o = 1 + Math.floor(Math.log(e) / Math.log(2)) / 8 | 0, l = [void 0, it.BYTE, it.USHORT, it.UINT24, it.ULONG][o], u = 0; u < t.length; u += 1) {
    var c = l(t[u]);
    Array.prototype.push.apply(s, c);
  }
  return Array.prototype.concat(
    it.Card16(r.length),
    it.OffSize(o),
    s,
    n
  );
};
Qt.INDEX = function(r) {
  return it.INDEX(r).length;
};
it.DICT = function(r) {
  for (var e = [], t = Object.keys(r), n = t.length, i = 0; i < n; i += 1) {
    var a = parseInt(t[i], 0), s = r[a];
    e = e.concat(it.OPERAND(s.value, s.type)), e = e.concat(it.OPERATOR(a));
  }
  return e;
};
Qt.DICT = function(r) {
  return it.DICT(r).length;
};
it.OPERATOR = function(r) {
  return r < 1200 ? [r] : [12, r - 1200];
};
it.OPERAND = function(r, e) {
  var t = [];
  if (Array.isArray(e))
    for (var n = 0; n < e.length; n += 1)
      jt.argument(r.length === e.length, "Not enough arguments given for type" + e), t = t.concat(it.OPERAND(r[n], e[n]));
  else if (e === "SID")
    t = t.concat(it.NUMBER(r));
  else if (e === "offset")
    t = t.concat(it.NUMBER32(r));
  else if (e === "number")
    t = t.concat(it.NUMBER(r));
  else if (e === "real")
    t = t.concat(it.REAL(r));
  else
    throw new Error("Unknown operand type " + e);
  return t;
};
it.OP = it.BYTE;
Qt.OP = Qt.BYTE;
var Lh = typeof WeakMap == "function" && /* @__PURE__ */ new WeakMap();
it.CHARSTRING = function(r) {
  if (Lh) {
    var e = Lh.get(r);
    if (e !== void 0)
      return e;
  }
  for (var t = [], n = r.length, i = 0; i < n; i += 1) {
    var a = r[i];
    t = t.concat(it[a.type](a.value));
  }
  return Lh && Lh.set(r, t), t;
};
Qt.CHARSTRING = function(r) {
  return it.CHARSTRING(r).length;
};
it.OBJECT = function(r) {
  var e = it[r.type];
  return jt.argument(e !== void 0, "No encoding function for type " + r.type), e(r.value);
};
Qt.OBJECT = function(r) {
  var e = Qt[r.type];
  return jt.argument(e !== void 0, "No sizeOf function for type " + r.type), e(r.value);
};
it.TABLE = function(r) {
  for (var e = [], t = r.fields.length, n = [], i = [], a = 0; a < t; a += 1) {
    var s = r.fields[a], o = it[s.type];
    jt.argument(o !== void 0, "No encoding function for field type " + s.type + " (" + s.name + ")");
    var l = r[s.name];
    l === void 0 && (l = s.value);
    var u = o(l);
    s.type === "TABLE" ? (i.push(e.length), e = e.concat([0, 0]), n.push(u)) : e = e.concat(u);
  }
  for (var c = 0; c < n.length; c += 1) {
    var d = i[c], f = e.length;
    jt.argument(f < 65536, "Table " + r.tableName + " too big."), e[d] = f >> 8, e[d + 1] = f & 255, e = e.concat(n[c]);
  }
  return e;
};
Qt.TABLE = function(r) {
  for (var e = 0, t = r.fields.length, n = 0; n < t; n += 1) {
    var i = r.fields[n], a = Qt[i.type];
    jt.argument(a !== void 0, "No sizeOf function for field type " + i.type + " (" + i.name + ")");
    var s = r[i.name];
    s === void 0 && (s = i.value), e += a(s), i.type === "TABLE" && (e += 2);
  }
  return e;
};
it.RECORD = it.TABLE;
Qt.RECORD = Qt.TABLE;
it.LITERAL = function(r) {
  return r;
};
Qt.LITERAL = function(r) {
  return r.length;
};
function vi(r, e, t) {
  if (e.length && (e[0].name !== "coverageFormat" || e[0].value === 1))
    for (var n = 0; n < e.length; n += 1) {
      var i = e[n];
      this[i.name] = i.value;
    }
  if (this.tableName = r, this.fields = e, t)
    for (var a = Object.keys(t), s = 0; s < a.length; s += 1) {
      var o = a[s], l = t[o];
      this[o] !== void 0 && (this[o] = l);
    }
}
vi.prototype.encode = function() {
  return it.TABLE(this);
};
vi.prototype.sizeOf = function() {
  return Qt.TABLE(this);
};
function cd(r, e, t) {
  t === void 0 && (t = e.length);
  var n = new Array(e.length + 1);
  n[0] = { name: r + "Count", type: "USHORT", value: t };
  for (var i = 0; i < e.length; i++)
    n[i + 1] = { name: r + i, type: "USHORT", value: e[i] };
  return n;
}
function _y(r, e, t) {
  var n = e.length, i = new Array(n + 1);
  i[0] = { name: r + "Count", type: "USHORT", value: n };
  for (var a = 0; a < n; a++)
    i[a + 1] = { name: r + a, type: "TABLE", value: t(e[a], a) };
  return i;
}
function fd(r, e, t) {
  var n = e.length, i = [];
  i[0] = { name: r + "Count", type: "USHORT", value: n };
  for (var a = 0; a < n; a++)
    i = i.concat(t(e[a], a));
  return i;
}
function tg(r) {
  r.format === 1 ? vi.call(
    this,
    "coverageTable",
    [{ name: "coverageFormat", type: "USHORT", value: 1 }].concat(cd("glyph", r.glyphs))
  ) : r.format === 2 ? vi.call(
    this,
    "coverageTable",
    [{ name: "coverageFormat", type: "USHORT", value: 2 }].concat(fd("rangeRecord", r.ranges, function(e) {
      return [
        { name: "startGlyphID", type: "USHORT", value: e.start },
        { name: "endGlyphID", type: "USHORT", value: e.end },
        { name: "startCoverageIndex", type: "USHORT", value: e.index }
      ];
    }))
  ) : jt.assert(!1, "Coverage format must be 1 or 2.");
}
tg.prototype = Object.create(vi.prototype);
tg.prototype.constructor = tg;
function rg(r) {
  vi.call(
    this,
    "scriptListTable",
    fd("scriptRecord", r, function(e, t) {
      var n = e.script, i = n.defaultLangSys;
      return jt.assert(!!i, "Unable to write GSUB: script " + e.tag + " has no default language system."), [
        { name: "scriptTag" + t, type: "TAG", value: e.tag },
        { name: "script" + t, type: "TABLE", value: new vi("scriptTable", [
          { name: "defaultLangSys", type: "TABLE", value: new vi("defaultLangSys", [
            { name: "lookupOrder", type: "USHORT", value: 0 },
            { name: "reqFeatureIndex", type: "USHORT", value: i.reqFeatureIndex }
          ].concat(cd("featureIndex", i.featureIndexes))) }
        ].concat(fd("langSys", n.langSysRecords, function(a, s) {
          var o = a.langSys;
          return [
            { name: "langSysTag" + s, type: "TAG", value: a.tag },
            { name: "langSys" + s, type: "TABLE", value: new vi("langSys", [
              { name: "lookupOrder", type: "USHORT", value: 0 },
              { name: "reqFeatureIndex", type: "USHORT", value: o.reqFeatureIndex }
            ].concat(cd("featureIndex", o.featureIndexes))) }
          ];
        }))) }
      ];
    })
  );
}
rg.prototype = Object.create(vi.prototype);
rg.prototype.constructor = rg;
function ng(r) {
  vi.call(
    this,
    "featureListTable",
    fd("featureRecord", r, function(e, t) {
      var n = e.feature;
      return [
        { name: "featureTag" + t, type: "TAG", value: e.tag },
        { name: "feature" + t, type: "TABLE", value: new vi("featureTable", [
          { name: "featureParams", type: "USHORT", value: n.featureParams }
        ].concat(cd("lookupListIndex", n.lookupListIndexes))) }
      ];
    })
  );
}
ng.prototype = Object.create(vi.prototype);
ng.prototype.constructor = ng;
function ig(r, e) {
  vi.call(this, "lookupListTable", _y("lookup", r, function(t) {
    var n = e[t.lookupType];
    return jt.assert(!!n, "Unable to write GSUB lookup type " + t.lookupType + " tables."), new vi("lookupTable", [
      { name: "lookupType", type: "USHORT", value: t.lookupType },
      { name: "lookupFlag", type: "USHORT", value: t.lookupFlag }
    ].concat(_y("subtable", t.subtables, n)));
  }));
}
ig.prototype = Object.create(vi.prototype);
ig.prototype.constructor = ig;
var ct = {
  Table: vi,
  Record: vi,
  Coverage: tg,
  ScriptList: rg,
  FeatureList: ng,
  LookupList: ig,
  ushortList: cd,
  tableList: _y,
  recordList: fd
};
function zx(r, e) {
  return r.getUint8(e);
}
function ag(r, e) {
  return r.getUint16(e, !1);
}
function UM(r, e) {
  return r.getInt16(e, !1);
}
function e1(r, e) {
  return r.getUint32(e, !1);
}
function vT(r, e) {
  var t = r.getInt16(e, !1), n = r.getUint16(e + 2, !1);
  return t + n / 65535;
}
function VM(r, e) {
  for (var t = "", n = e; n < e + 4; n += 1)
    t += String.fromCharCode(r.getInt8(n));
  return t;
}
function zM(r, e, t) {
  for (var n = 0, i = 0; i < t; i += 1)
    n <<= 8, n += r.getUint8(e + i);
  return n;
}
function $M(r, e, t) {
  for (var n = [], i = e; i < t; i += 1)
    n.push(r.getUint8(i));
  return n;
}
function HM(r) {
  for (var e = "", t = 0; t < r.length; t += 1)
    e += String.fromCharCode(r[t]);
  return e;
}
var jM = {
  byte: 1,
  uShort: 2,
  short: 2,
  uLong: 4,
  fixed: 4,
  longDateTime: 8,
  tag: 4
};
function we(r, e) {
  this.data = r, this.offset = e, this.relativeOffset = 0;
}
we.prototype.parseByte = function() {
  var r = this.data.getUint8(this.offset + this.relativeOffset);
  return this.relativeOffset += 1, r;
};
we.prototype.parseChar = function() {
  var r = this.data.getInt8(this.offset + this.relativeOffset);
  return this.relativeOffset += 1, r;
};
we.prototype.parseCard8 = we.prototype.parseByte;
we.prototype.parseUShort = function() {
  var r = this.data.getUint16(this.offset + this.relativeOffset);
  return this.relativeOffset += 2, r;
};
we.prototype.parseCard16 = we.prototype.parseUShort;
we.prototype.parseSID = we.prototype.parseUShort;
we.prototype.parseOffset16 = we.prototype.parseUShort;
we.prototype.parseShort = function() {
  var r = this.data.getInt16(this.offset + this.relativeOffset);
  return this.relativeOffset += 2, r;
};
we.prototype.parseF2Dot14 = function() {
  var r = this.data.getInt16(this.offset + this.relativeOffset) / 16384;
  return this.relativeOffset += 2, r;
};
we.prototype.parseULong = function() {
  var r = e1(this.data, this.offset + this.relativeOffset);
  return this.relativeOffset += 4, r;
};
we.prototype.parseOffset32 = we.prototype.parseULong;
we.prototype.parseFixed = function() {
  var r = vT(this.data, this.offset + this.relativeOffset);
  return this.relativeOffset += 4, r;
};
we.prototype.parseString = function(r) {
  var e = this.data, t = this.offset + this.relativeOffset, n = "";
  this.relativeOffset += r;
  for (var i = 0; i < r; i++)
    n += String.fromCharCode(e.getUint8(t + i));
  return n;
};
we.prototype.parseTag = function() {
  return this.parseString(4);
};
we.prototype.parseLongDateTime = function() {
  var r = e1(this.data, this.offset + this.relativeOffset + 4);
  return r -= 2082844800, this.relativeOffset += 8, r;
};
we.prototype.parseVersion = function(r) {
  var e = ag(this.data, this.offset + this.relativeOffset), t = ag(this.data, this.offset + this.relativeOffset + 2);
  return this.relativeOffset += 4, r === void 0 && (r = 4096), e + t / r / 10;
};
we.prototype.skip = function(r, e) {
  e === void 0 && (e = 1), this.relativeOffset += jM[r] * e;
};
we.prototype.parseULongList = function(r) {
  r === void 0 && (r = this.parseULong());
  for (var e = new Array(r), t = this.data, n = this.offset + this.relativeOffset, i = 0; i < r; i++)
    e[i] = t.getUint32(n), n += 4;
  return this.relativeOffset += r * 4, e;
};
we.prototype.parseOffset16List = we.prototype.parseUShortList = function(r) {
  r === void 0 && (r = this.parseUShort());
  for (var e = new Array(r), t = this.data, n = this.offset + this.relativeOffset, i = 0; i < r; i++)
    e[i] = t.getUint16(n), n += 2;
  return this.relativeOffset += r * 2, e;
};
we.prototype.parseShortList = function(r) {
  for (var e = new Array(r), t = this.data, n = this.offset + this.relativeOffset, i = 0; i < r; i++)
    e[i] = t.getInt16(n), n += 2;
  return this.relativeOffset += r * 2, e;
};
we.prototype.parseByteList = function(r) {
  for (var e = new Array(r), t = this.data, n = this.offset + this.relativeOffset, i = 0; i < r; i++)
    e[i] = t.getUint8(n++);
  return this.relativeOffset += r, e;
};
we.prototype.parseList = function(r, e) {
  e || (e = r, r = this.parseUShort());
  for (var t = new Array(r), n = 0; n < r; n++)
    t[n] = e.call(this);
  return t;
};
we.prototype.parseList32 = function(r, e) {
  e || (e = r, r = this.parseULong());
  for (var t = new Array(r), n = 0; n < r; n++)
    t[n] = e.call(this);
  return t;
};
we.prototype.parseRecordList = function(r, e) {
  e || (e = r, r = this.parseUShort());
  for (var t = new Array(r), n = Object.keys(e), i = 0; i < r; i++) {
    for (var a = {}, s = 0; s < n.length; s++) {
      var o = n[s], l = e[o];
      a[o] = l.call(this);
    }
    t[i] = a;
  }
  return t;
};
we.prototype.parseRecordList32 = function(r, e) {
  e || (e = r, r = this.parseULong());
  for (var t = new Array(r), n = Object.keys(e), i = 0; i < r; i++) {
    for (var a = {}, s = 0; s < n.length; s++) {
      var o = n[s], l = e[o];
      a[o] = l.call(this);
    }
    t[i] = a;
  }
  return t;
};
we.prototype.parseStruct = function(r) {
  if (typeof r == "function")
    return r.call(this);
  for (var e = Object.keys(r), t = {}, n = 0; n < e.length; n++) {
    var i = e[n], a = r[i];
    t[i] = a.call(this);
  }
  return t;
};
we.prototype.parseValueRecord = function(r) {
  if (r === void 0 && (r = this.parseUShort()), r !== 0) {
    var e = {};
    return r & 1 && (e.xPlacement = this.parseShort()), r & 2 && (e.yPlacement = this.parseShort()), r & 4 && (e.xAdvance = this.parseShort()), r & 8 && (e.yAdvance = this.parseShort()), r & 16 && (e.xPlaDevice = void 0, this.parseShort()), r & 32 && (e.yPlaDevice = void 0, this.parseShort()), r & 64 && (e.xAdvDevice = void 0, this.parseShort()), r & 128 && (e.yAdvDevice = void 0, this.parseShort()), e;
  }
};
we.prototype.parseValueRecordList = function() {
  for (var r = this.parseUShort(), e = this.parseUShort(), t = new Array(e), n = 0; n < e; n++)
    t[n] = this.parseValueRecord(r);
  return t;
};
we.prototype.parsePointer = function(r) {
  var e = this.parseOffset16();
  if (e > 0)
    return new we(this.data, this.offset + e).parseStruct(r);
};
we.prototype.parsePointer32 = function(r) {
  var e = this.parseOffset32();
  if (e > 0)
    return new we(this.data, this.offset + e).parseStruct(r);
};
we.prototype.parseListOfLists = function(r) {
  for (var e = this.parseOffset16List(), t = e.length, n = this.relativeOffset, i = new Array(t), a = 0; a < t; a++) {
    var s = e[a];
    if (s === 0) {
      i[a] = void 0;
      continue;
    }
    if (this.relativeOffset = s, r) {
      for (var o = this.parseOffset16List(), l = new Array(o.length), u = 0; u < o.length; u++)
        this.relativeOffset = s + o[u], l[u] = r.call(this);
      i[a] = l;
    } else
      i[a] = this.parseUShortList();
  }
  return this.relativeOffset = n, i;
};
we.prototype.parseCoverage = function() {
  var r = this.offset + this.relativeOffset, e = this.parseUShort(), t = this.parseUShort();
  if (e === 1)
    return {
      format: 1,
      glyphs: this.parseUShortList(t)
    };
  if (e === 2) {
    for (var n = new Array(t), i = 0; i < t; i++)
      n[i] = {
        start: this.parseUShort(),
        end: this.parseUShort(),
        index: this.parseUShort()
      };
    return {
      format: 2,
      ranges: n
    };
  }
  throw new Error("0x" + r.toString(16) + ": Coverage format must be 1 or 2.");
};
we.prototype.parseClassDef = function() {
  var r = this.offset + this.relativeOffset, e = this.parseUShort();
  if (e === 1)
    return {
      format: 1,
      startGlyph: this.parseUShort(),
      classes: this.parseUShortList()
    };
  if (e === 2)
    return {
      format: 2,
      ranges: this.parseRecordList({
        start: we.uShort,
        end: we.uShort,
        classId: we.uShort
      })
    };
  throw new Error("0x" + r.toString(16) + ": ClassDef format must be 1 or 2.");
};
we.list = function(r, e) {
  return function() {
    return this.parseList(r, e);
  };
};
we.list32 = function(r, e) {
  return function() {
    return this.parseList32(r, e);
  };
};
we.recordList = function(r, e) {
  return function() {
    return this.parseRecordList(r, e);
  };
};
we.recordList32 = function(r, e) {
  return function() {
    return this.parseRecordList32(r, e);
  };
};
we.pointer = function(r) {
  return function() {
    return this.parsePointer(r);
  };
};
we.pointer32 = function(r) {
  return function() {
    return this.parsePointer32(r);
  };
};
we.tag = we.prototype.parseTag;
we.byte = we.prototype.parseByte;
we.uShort = we.offset16 = we.prototype.parseUShort;
we.uShortList = we.prototype.parseUShortList;
we.uLong = we.offset32 = we.prototype.parseULong;
we.uLongList = we.prototype.parseULongList;
we.struct = we.prototype.parseStruct;
we.coverage = we.prototype.parseCoverage;
we.classDef = we.prototype.parseClassDef;
var $x = {
  reserved: we.uShort,
  reqFeatureIndex: we.uShort,
  featureIndexes: we.uShortList
};
we.prototype.parseScriptList = function() {
  return this.parsePointer(we.recordList({
    tag: we.tag,
    script: we.pointer({
      defaultLangSys: we.pointer($x),
      langSysRecords: we.recordList({
        tag: we.tag,
        langSys: we.pointer($x)
      })
    })
  })) || [];
};
we.prototype.parseFeatureList = function() {
  return this.parsePointer(we.recordList({
    tag: we.tag,
    feature: we.pointer({
      featureParams: we.offset16,
      lookupListIndexes: we.uShortList
    })
  })) || [];
};
we.prototype.parseLookupList = function(r) {
  return this.parsePointer(we.list(we.pointer(function() {
    var e = this.parseUShort();
    jt.argument(1 <= e && e <= 9, "GPOS/GSUB lookup type " + e + " unknown.");
    var t = this.parseUShort(), n = t & 16;
    return {
      lookupType: e,
      lookupFlag: t,
      subtables: this.parseList(we.pointer(r[e])),
      markFilteringSet: n ? this.parseUShort() : void 0
    };
  }))) || [];
};
we.prototype.parseFeatureVariationsList = function() {
  return this.parsePointer32(function() {
    var r = this.parseUShort(), e = this.parseUShort();
    jt.argument(r === 1 && e < 1, "GPOS/GSUB feature variations table unknown.");
    var t = this.parseRecordList32({
      conditionSetOffset: we.offset32,
      featureTableSubstitutionOffset: we.offset32
    });
    return t;
  }) || [];
};
var vt = {
  getByte: zx,
  getCard8: zx,
  getUShort: ag,
  getCard16: ag,
  getShort: UM,
  getULong: e1,
  getFixed: vT,
  getTag: VM,
  getOffset: zM,
  getBytes: $M,
  bytesToString: HM,
  Parser: we
};
function GM(r, e) {
  e.parseUShort(), r.length = e.parseULong(), r.language = e.parseULong();
  var t;
  r.groupCount = t = e.parseULong(), r.glyphIndexMap = {};
  for (var n = 0; n < t; n += 1)
    for (var i = e.parseULong(), a = e.parseULong(), s = e.parseULong(), o = i; o <= a; o += 1)
      r.glyphIndexMap[o] = s, s++;
}
function qM(r, e, t, n, i) {
  r.length = e.parseUShort(), r.language = e.parseUShort();
  var a;
  r.segCount = a = e.parseUShort() >> 1, e.skip("uShort", 3), r.glyphIndexMap = {};
  for (var s = new vt.Parser(t, n + i + 14), o = new vt.Parser(t, n + i + 16 + a * 2), l = new vt.Parser(t, n + i + 16 + a * 4), u = new vt.Parser(t, n + i + 16 + a * 6), c = n + i + 16 + a * 8, d = 0; d < a - 1; d += 1)
    for (var f = void 0, h = s.parseUShort(), g = o.parseUShort(), v = l.parseShort(), y = u.parseUShort(), A = g; A <= h; A += 1)
      y !== 0 ? (c = u.offset + u.relativeOffset - 2, c += y, c += (A - g) * 2, f = vt.getUShort(t, c), f !== 0 && (f = f + v & 65535)) : f = A + v & 65535, r.glyphIndexMap[A] = f;
}
function WM(r, e) {
  var t = {};
  t.version = vt.getUShort(r, e), jt.argument(t.version === 0, "cmap table version should be 0."), t.numTables = vt.getUShort(r, e + 2);
  for (var n = -1, i = t.numTables - 1; i >= 0; i -= 1) {
    var a = vt.getUShort(r, e + 4 + i * 8), s = vt.getUShort(r, e + 4 + i * 8 + 2);
    if (a === 3 && (s === 0 || s === 1 || s === 10) || a === 0 && (s === 0 || s === 1 || s === 2 || s === 3 || s === 4)) {
      n = vt.getULong(r, e + 4 + i * 8 + 4);
      break;
    }
  }
  if (n === -1)
    throw new Error("No valid cmap sub-tables found.");
  var o = new vt.Parser(r, e + n);
  if (t.format = o.parseUShort(), t.format === 12)
    GM(t, o);
  else if (t.format === 4)
    qM(t, o, r, e, n);
  else
    throw new Error("Only format 4 and 12 cmap tables are supported (found format " + t.format + ").");
  return t;
}
function QM(r, e, t) {
  r.segments.push({
    end: e,
    start: e,
    delta: -(e - t),
    offset: 0,
    glyphIndex: t
  });
}
function YM(r) {
  r.segments.push({
    end: 65535,
    start: 65535,
    delta: 1,
    offset: 0
  });
}
function XM(r) {
  var e = !0, t;
  for (t = r.length - 1; t > 0; t -= 1) {
    var n = r.get(t);
    if (n.unicode > 65535) {
      console.log("Adding CMAP format 12 (needed!)"), e = !1;
      break;
    }
  }
  var i = [
    { name: "version", type: "USHORT", value: 0 },
    { name: "numTables", type: "USHORT", value: e ? 1 : 2 },
    // CMAP 4 header
    { name: "platformID", type: "USHORT", value: 3 },
    { name: "encodingID", type: "USHORT", value: 1 },
    { name: "offset", type: "ULONG", value: e ? 12 : 20 }
  ];
  e || (i = i.concat([
    // CMAP 12 header
    { name: "cmap12PlatformID", type: "USHORT", value: 3 },
    // We encode only for PlatformID = 3 (Windows) because it is supported everywhere
    { name: "cmap12EncodingID", type: "USHORT", value: 10 },
    { name: "cmap12Offset", type: "ULONG", value: 0 }
  ])), i = i.concat([
    // CMAP 4 Subtable
    { name: "format", type: "USHORT", value: 4 },
    { name: "cmap4Length", type: "USHORT", value: 0 },
    { name: "language", type: "USHORT", value: 0 },
    { name: "segCountX2", type: "USHORT", value: 0 },
    { name: "searchRange", type: "USHORT", value: 0 },
    { name: "entrySelector", type: "USHORT", value: 0 },
    { name: "rangeShift", type: "USHORT", value: 0 }
  ]);
  var a = new ct.Table("cmap", i);
  for (a.segments = [], t = 0; t < r.length; t += 1) {
    for (var s = r.get(t), o = 0; o < s.unicodes.length; o += 1)
      QM(a, s.unicodes[o], t);
    a.segments = a.segments.sort(function(x, k) {
      return x.start - k.start;
    });
  }
  YM(a);
  var l = a.segments.length, u = 0, c = [], d = [], f = [], h = [], g = [], v = [];
  for (t = 0; t < l; t += 1) {
    var y = a.segments[t];
    y.end <= 65535 && y.start <= 65535 ? (c = c.concat({ name: "end_" + t, type: "USHORT", value: y.end }), d = d.concat({ name: "start_" + t, type: "USHORT", value: y.start }), f = f.concat({ name: "idDelta_" + t, type: "SHORT", value: y.delta }), h = h.concat({ name: "idRangeOffset_" + t, type: "USHORT", value: y.offset }), y.glyphId !== void 0 && (g = g.concat({ name: "glyph_" + t, type: "USHORT", value: y.glyphId }))) : u += 1, !e && y.glyphIndex !== void 0 && (v = v.concat({ name: "cmap12Start_" + t, type: "ULONG", value: y.start }), v = v.concat({ name: "cmap12End_" + t, type: "ULONG", value: y.end }), v = v.concat({ name: "cmap12Glyph_" + t, type: "ULONG", value: y.glyphIndex }));
  }
  if (a.segCountX2 = (l - u) * 2, a.searchRange = Math.pow(2, Math.floor(Math.log(l - u) / Math.log(2))) * 2, a.entrySelector = Math.log(a.searchRange / 2) / Math.log(2), a.rangeShift = a.segCountX2 - a.searchRange, a.fields = a.fields.concat(c), a.fields.push({ name: "reservedPad", type: "USHORT", value: 0 }), a.fields = a.fields.concat(d), a.fields = a.fields.concat(f), a.fields = a.fields.concat(h), a.fields = a.fields.concat(g), a.cmap4Length = 14 + // Subtable header
  c.length * 2 + 2 + // reservedPad
  d.length * 2 + f.length * 2 + h.length * 2 + g.length * 2, !e) {
    var A = 16 + // Subtable header
    v.length * 4;
    a.cmap12Offset = 20 + a.cmap4Length, a.fields = a.fields.concat([
      { name: "cmap12Format", type: "USHORT", value: 12 },
      { name: "cmap12Reserved", type: "USHORT", value: 0 },
      { name: "cmap12Length", type: "ULONG", value: A },
      { name: "cmap12Language", type: "ULONG", value: 0 },
      { name: "cmap12nGroups", type: "ULONG", value: v.length / 3 }
    ]), a.fields = a.fields.concat(v);
  }
  return a;
}
var yT = { parse: WM, make: XM }, Mp = [
  ".notdef",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quoteright",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "quoteleft",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "exclamdown",
  "cent",
  "sterling",
  "fraction",
  "yen",
  "florin",
  "section",
  "currency",
  "quotesingle",
  "quotedblleft",
  "guillemotleft",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "endash",
  "dagger",
  "daggerdbl",
  "periodcentered",
  "paragraph",
  "bullet",
  "quotesinglbase",
  "quotedblbase",
  "quotedblright",
  "guillemotright",
  "ellipsis",
  "perthousand",
  "questiondown",
  "grave",
  "acute",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "dieresis",
  "ring",
  "cedilla",
  "hungarumlaut",
  "ogonek",
  "caron",
  "emdash",
  "AE",
  "ordfeminine",
  "Lslash",
  "Oslash",
  "OE",
  "ordmasculine",
  "ae",
  "dotlessi",
  "lslash",
  "oslash",
  "oe",
  "germandbls",
  "onesuperior",
  "logicalnot",
  "mu",
  "trademark",
  "Eth",
  "onehalf",
  "plusminus",
  "Thorn",
  "onequarter",
  "divide",
  "brokenbar",
  "degree",
  "thorn",
  "threequarters",
  "twosuperior",
  "registered",
  "minus",
  "eth",
  "multiply",
  "threesuperior",
  "copyright",
  "Aacute",
  "Acircumflex",
  "Adieresis",
  "Agrave",
  "Aring",
  "Atilde",
  "Ccedilla",
  "Eacute",
  "Ecircumflex",
  "Edieresis",
  "Egrave",
  "Iacute",
  "Icircumflex",
  "Idieresis",
  "Igrave",
  "Ntilde",
  "Oacute",
  "Ocircumflex",
  "Odieresis",
  "Ograve",
  "Otilde",
  "Scaron",
  "Uacute",
  "Ucircumflex",
  "Udieresis",
  "Ugrave",
  "Yacute",
  "Ydieresis",
  "Zcaron",
  "aacute",
  "acircumflex",
  "adieresis",
  "agrave",
  "aring",
  "atilde",
  "ccedilla",
  "eacute",
  "ecircumflex",
  "edieresis",
  "egrave",
  "iacute",
  "icircumflex",
  "idieresis",
  "igrave",
  "ntilde",
  "oacute",
  "ocircumflex",
  "odieresis",
  "ograve",
  "otilde",
  "scaron",
  "uacute",
  "ucircumflex",
  "udieresis",
  "ugrave",
  "yacute",
  "ydieresis",
  "zcaron",
  "exclamsmall",
  "Hungarumlautsmall",
  "dollaroldstyle",
  "dollarsuperior",
  "ampersandsmall",
  "Acutesmall",
  "parenleftsuperior",
  "parenrightsuperior",
  "266 ff",
  "onedotenleader",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "questionsmall",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "isuperior",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "ff",
  "ffi",
  "ffl",
  "parenleftinferior",
  "parenrightinferior",
  "Circumflexsmall",
  "hyphensuperior",
  "Gravesmall",
  "Asmall",
  "Bsmall",
  "Csmall",
  "Dsmall",
  "Esmall",
  "Fsmall",
  "Gsmall",
  "Hsmall",
  "Ismall",
  "Jsmall",
  "Ksmall",
  "Lsmall",
  "Msmall",
  "Nsmall",
  "Osmall",
  "Psmall",
  "Qsmall",
  "Rsmall",
  "Ssmall",
  "Tsmall",
  "Usmall",
  "Vsmall",
  "Wsmall",
  "Xsmall",
  "Ysmall",
  "Zsmall",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "Tildesmall",
  "exclamdownsmall",
  "centoldstyle",
  "Lslashsmall",
  "Scaronsmall",
  "Zcaronsmall",
  "Dieresissmall",
  "Brevesmall",
  "Caronsmall",
  "Dotaccentsmall",
  "Macronsmall",
  "figuredash",
  "hypheninferior",
  "Ogoneksmall",
  "Ringsmall",
  "Cedillasmall",
  "questiondownsmall",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "zerosuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior",
  "Agravesmall",
  "Aacutesmall",
  "Acircumflexsmall",
  "Atildesmall",
  "Adieresissmall",
  "Aringsmall",
  "AEsmall",
  "Ccedillasmall",
  "Egravesmall",
  "Eacutesmall",
  "Ecircumflexsmall",
  "Edieresissmall",
  "Igravesmall",
  "Iacutesmall",
  "Icircumflexsmall",
  "Idieresissmall",
  "Ethsmall",
  "Ntildesmall",
  "Ogravesmall",
  "Oacutesmall",
  "Ocircumflexsmall",
  "Otildesmall",
  "Odieresissmall",
  "OEsmall",
  "Oslashsmall",
  "Ugravesmall",
  "Uacutesmall",
  "Ucircumflexsmall",
  "Udieresissmall",
  "Yacutesmall",
  "Thornsmall",
  "Ydieresissmall",
  "001.000",
  "001.001",
  "001.002",
  "001.003",
  "Black",
  "Bold",
  "Book",
  "Light",
  "Medium",
  "Regular",
  "Roman",
  "Semibold"
], JM = [
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quoteright",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "quoteleft",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "exclamdown",
  "cent",
  "sterling",
  "fraction",
  "yen",
  "florin",
  "section",
  "currency",
  "quotesingle",
  "quotedblleft",
  "guillemotleft",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "",
  "endash",
  "dagger",
  "daggerdbl",
  "periodcentered",
  "",
  "paragraph",
  "bullet",
  "quotesinglbase",
  "quotedblbase",
  "quotedblright",
  "guillemotright",
  "ellipsis",
  "perthousand",
  "",
  "questiondown",
  "",
  "grave",
  "acute",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "dieresis",
  "",
  "ring",
  "cedilla",
  "",
  "hungarumlaut",
  "ogonek",
  "caron",
  "emdash",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "AE",
  "",
  "ordfeminine",
  "",
  "",
  "",
  "",
  "Lslash",
  "Oslash",
  "OE",
  "ordmasculine",
  "",
  "",
  "",
  "",
  "",
  "ae",
  "",
  "",
  "",
  "dotlessi",
  "",
  "",
  "lslash",
  "oslash",
  "oe",
  "germandbls"
], KM = [
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "space",
  "exclamsmall",
  "Hungarumlautsmall",
  "",
  "dollaroldstyle",
  "dollarsuperior",
  "ampersandsmall",
  "Acutesmall",
  "parenleftsuperior",
  "parenrightsuperior",
  "twodotenleader",
  "onedotenleader",
  "comma",
  "hyphen",
  "period",
  "fraction",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "colon",
  "semicolon",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "questionsmall",
  "",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "",
  "",
  "isuperior",
  "",
  "",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "",
  "",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "",
  "ff",
  "fi",
  "fl",
  "ffi",
  "ffl",
  "parenleftinferior",
  "",
  "parenrightinferior",
  "Circumflexsmall",
  "hyphensuperior",
  "Gravesmall",
  "Asmall",
  "Bsmall",
  "Csmall",
  "Dsmall",
  "Esmall",
  "Fsmall",
  "Gsmall",
  "Hsmall",
  "Ismall",
  "Jsmall",
  "Ksmall",
  "Lsmall",
  "Msmall",
  "Nsmall",
  "Osmall",
  "Psmall",
  "Qsmall",
  "Rsmall",
  "Ssmall",
  "Tsmall",
  "Usmall",
  "Vsmall",
  "Wsmall",
  "Xsmall",
  "Ysmall",
  "Zsmall",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "Tildesmall",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "exclamdownsmall",
  "centoldstyle",
  "Lslashsmall",
  "",
  "",
  "Scaronsmall",
  "Zcaronsmall",
  "Dieresissmall",
  "Brevesmall",
  "Caronsmall",
  "",
  "Dotaccentsmall",
  "",
  "",
  "Macronsmall",
  "",
  "",
  "figuredash",
  "hypheninferior",
  "",
  "",
  "Ogoneksmall",
  "Ringsmall",
  "Cedillasmall",
  "",
  "",
  "",
  "onequarter",
  "onehalf",
  "threequarters",
  "questiondownsmall",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "",
  "",
  "zerosuperior",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior",
  "Agravesmall",
  "Aacutesmall",
  "Acircumflexsmall",
  "Atildesmall",
  "Adieresissmall",
  "Aringsmall",
  "AEsmall",
  "Ccedillasmall",
  "Egravesmall",
  "Eacutesmall",
  "Ecircumflexsmall",
  "Edieresissmall",
  "Igravesmall",
  "Iacutesmall",
  "Icircumflexsmall",
  "Idieresissmall",
  "Ethsmall",
  "Ntildesmall",
  "Ogravesmall",
  "Oacutesmall",
  "Ocircumflexsmall",
  "Otildesmall",
  "Odieresissmall",
  "OEsmall",
  "Oslashsmall",
  "Ugravesmall",
  "Uacutesmall",
  "Ucircumflexsmall",
  "Udieresissmall",
  "Yacutesmall",
  "Thornsmall",
  "Ydieresissmall"
], fl = [
  ".notdef",
  ".null",
  "nonmarkingreturn",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quotesingle",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "grave",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "Adieresis",
  "Aring",
  "Ccedilla",
  "Eacute",
  "Ntilde",
  "Odieresis",
  "Udieresis",
  "aacute",
  "agrave",
  "acircumflex",
  "adieresis",
  "atilde",
  "aring",
  "ccedilla",
  "eacute",
  "egrave",
  "ecircumflex",
  "edieresis",
  "iacute",
  "igrave",
  "icircumflex",
  "idieresis",
  "ntilde",
  "oacute",
  "ograve",
  "ocircumflex",
  "odieresis",
  "otilde",
  "uacute",
  "ugrave",
  "ucircumflex",
  "udieresis",
  "dagger",
  "degree",
  "cent",
  "sterling",
  "section",
  "bullet",
  "paragraph",
  "germandbls",
  "registered",
  "copyright",
  "trademark",
  "acute",
  "dieresis",
  "notequal",
  "AE",
  "Oslash",
  "infinity",
  "plusminus",
  "lessequal",
  "greaterequal",
  "yen",
  "mu",
  "partialdiff",
  "summation",
  "product",
  "pi",
  "integral",
  "ordfeminine",
  "ordmasculine",
  "Omega",
  "ae",
  "oslash",
  "questiondown",
  "exclamdown",
  "logicalnot",
  "radical",
  "florin",
  "approxequal",
  "Delta",
  "guillemotleft",
  "guillemotright",
  "ellipsis",
  "nonbreakingspace",
  "Agrave",
  "Atilde",
  "Otilde",
  "OE",
  "oe",
  "endash",
  "emdash",
  "quotedblleft",
  "quotedblright",
  "quoteleft",
  "quoteright",
  "divide",
  "lozenge",
  "ydieresis",
  "Ydieresis",
  "fraction",
  "currency",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "daggerdbl",
  "periodcentered",
  "quotesinglbase",
  "quotedblbase",
  "perthousand",
  "Acircumflex",
  "Ecircumflex",
  "Aacute",
  "Edieresis",
  "Egrave",
  "Iacute",
  "Icircumflex",
  "Idieresis",
  "Igrave",
  "Oacute",
  "Ocircumflex",
  "apple",
  "Ograve",
  "Uacute",
  "Ucircumflex",
  "Ugrave",
  "dotlessi",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "ring",
  "cedilla",
  "hungarumlaut",
  "ogonek",
  "caron",
  "Lslash",
  "lslash",
  "Scaron",
  "scaron",
  "Zcaron",
  "zcaron",
  "brokenbar",
  "Eth",
  "eth",
  "Yacute",
  "yacute",
  "Thorn",
  "thorn",
  "minus",
  "multiply",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "onehalf",
  "onequarter",
  "threequarters",
  "franc",
  "Gbreve",
  "gbreve",
  "Idotaccent",
  "Scedilla",
  "scedilla",
  "Cacute",
  "cacute",
  "Ccaron",
  "ccaron",
  "dcroat"
];
function AT(r) {
  this.font = r;
}
AT.prototype.charToGlyphIndex = function(r) {
  var e = r.codePointAt(0), t = this.font.glyphs;
  if (t) {
    for (var n = 0; n < t.length; n += 1)
      for (var i = t.get(n), a = 0; a < i.unicodes.length; a += 1)
        if (i.unicodes[a] === e)
          return n;
  }
  return null;
};
function bT(r) {
  this.cmap = r;
}
bT.prototype.charToGlyphIndex = function(r) {
  return this.cmap.glyphIndexMap[r.codePointAt(0)] || 0;
};
function sg(r, e) {
  this.encoding = r, this.charset = e;
}
sg.prototype.charToGlyphIndex = function(r) {
  var e = r.codePointAt(0), t = this.encoding[e];
  return this.charset.indexOf(t);
};
function t1(r) {
  switch (r.version) {
    case 1:
      this.names = fl.slice();
      break;
    case 2:
      this.names = new Array(r.numberOfGlyphs);
      for (var e = 0; e < r.numberOfGlyphs; e++)
        r.glyphNameIndex[e] < fl.length ? this.names[e] = fl[r.glyphNameIndex[e]] : this.names[e] = r.names[r.glyphNameIndex[e] - fl.length];
      break;
    case 2.5:
      this.names = new Array(r.numberOfGlyphs);
      for (var t = 0; t < r.numberOfGlyphs; t++)
        this.names[t] = fl[t + r.glyphNameIndex[t]];
      break;
    case 3:
      this.names = [];
      break;
    default:
      this.names = [];
      break;
  }
}
t1.prototype.nameToGlyphIndex = function(r) {
  return this.names.indexOf(r);
};
t1.prototype.glyphIndexToName = function(r) {
  return this.names[r];
};
function ZM(r) {
  for (var e, t = r.tables.cmap.glyphIndexMap, n = Object.keys(t), i = 0; i < n.length; i += 1) {
    var a = n[i], s = t[a];
    e = r.glyphs.get(s), e.addUnicode(parseInt(a));
  }
  for (var o = 0; o < r.glyphs.length; o += 1)
    e = r.glyphs.get(o), r.cffEncoding ? r.isCIDFont ? e.name = "gid" + o : e.name = r.cffEncoding.charset[o] : r.glyphNames.names && (e.name = r.glyphNames.glyphIndexToName(o));
}
function e_(r) {
  r._IndexToUnicodeMap = {};
  for (var e = r.tables.cmap.glyphIndexMap, t = Object.keys(e), n = 0; n < t.length; n += 1) {
    var i = t[n], a = e[i];
    r._IndexToUnicodeMap[a] === void 0 ? r._IndexToUnicodeMap[a] = {
      unicodes: [parseInt(i)]
    } : r._IndexToUnicodeMap[a].unicodes.push(parseInt(i));
  }
}
function t_(r, e) {
  e.lowMemory ? e_(r) : ZM(r);
}
function r_(r, e, t, n, i) {
  r.beginPath(), r.moveTo(e, t), r.lineTo(n, i), r.stroke();
}
var al = { line: r_ };
function n_(r, e) {
  var t = e || new ci();
  return {
    configurable: !0,
    get: function() {
      return typeof t == "function" && (t = t()), t;
    },
    set: function(n) {
      t = n;
    }
  };
}
function ga(r) {
  this.bindConstructorValues(r);
}
ga.prototype.bindConstructorValues = function(r) {
  this.index = r.index || 0, this.name = r.name || null, this.unicode = r.unicode || void 0, this.unicodes = r.unicodes || r.unicode !== void 0 ? [r.unicode] : [], "xMin" in r && (this.xMin = r.xMin), "yMin" in r && (this.yMin = r.yMin), "xMax" in r && (this.xMax = r.xMax), "yMax" in r && (this.yMax = r.yMax), "advanceWidth" in r && (this.advanceWidth = r.advanceWidth), Object.defineProperty(this, "path", n_(this, r.path));
};
ga.prototype.addUnicode = function(r) {
  this.unicodes.length === 0 && (this.unicode = r), this.unicodes.push(r);
};
ga.prototype.getBoundingBox = function() {
  return this.path.getBoundingBox();
};
ga.prototype.getPath = function(r, e, t, n, i) {
  r = r !== void 0 ? r : 0, e = e !== void 0 ? e : 0, t = t !== void 0 ? t : 72;
  var a, s;
  n || (n = {});
  var o = n.xScale, l = n.yScale;
  if (n.hinting && i && i.hinting && (s = this.path && i.hinting.exec(this, t)), s)
    a = i.hinting.getCommands(s), r = Math.round(r), e = Math.round(e), o = l = 1;
  else {
    a = this.path.commands;
    var u = 1 / (this.path.unitsPerEm || 1e3) * t;
    o === void 0 && (o = u), l === void 0 && (l = u);
  }
  for (var c = new ci(), d = 0; d < a.length; d += 1) {
    var f = a[d];
    f.type === "M" ? c.moveTo(r + f.x * o, e + -f.y * l) : f.type === "L" ? c.lineTo(r + f.x * o, e + -f.y * l) : f.type === "Q" ? c.quadraticCurveTo(
      r + f.x1 * o,
      e + -f.y1 * l,
      r + f.x * o,
      e + -f.y * l
    ) : f.type === "C" ? c.curveTo(
      r + f.x1 * o,
      e + -f.y1 * l,
      r + f.x2 * o,
      e + -f.y2 * l,
      r + f.x * o,
      e + -f.y * l
    ) : f.type === "Z" && c.closePath();
  }
  return c;
};
ga.prototype.getContours = function() {
  if (this.points === void 0)
    return [];
  for (var r = [], e = [], t = 0; t < this.points.length; t += 1) {
    var n = this.points[t];
    e.push(n), n.lastPointOfContour && (r.push(e), e = []);
  }
  return jt.argument(e.length === 0, "There are still points left in the current contour."), r;
};
ga.prototype.getMetrics = function() {
  for (var r = this.path.commands, e = [], t = [], n = 0; n < r.length; n += 1) {
    var i = r[n];
    i.type !== "Z" && (e.push(i.x), t.push(i.y)), (i.type === "Q" || i.type === "C") && (e.push(i.x1), t.push(i.y1)), i.type === "C" && (e.push(i.x2), t.push(i.y2));
  }
  var a = {
    xMin: Math.min.apply(null, e),
    yMin: Math.min.apply(null, t),
    xMax: Math.max.apply(null, e),
    yMax: Math.max.apply(null, t),
    leftSideBearing: this.leftSideBearing
  };
  return isFinite(a.xMin) || (a.xMin = 0), isFinite(a.xMax) || (a.xMax = this.advanceWidth), isFinite(a.yMin) || (a.yMin = 0), isFinite(a.yMax) || (a.yMax = 0), a.rightSideBearing = this.advanceWidth - a.leftSideBearing - (a.xMax - a.xMin), a;
};
ga.prototype.draw = function(r, e, t, n, i) {
  this.getPath(e, t, n, i).draw(r);
};
ga.prototype.drawPoints = function(r, e, t, n) {
  function i(d, f, h, g) {
    r.beginPath();
    for (var v = 0; v < d.length; v += 1)
      r.moveTo(f + d[v].x * g, h + d[v].y * g), r.arc(f + d[v].x * g, h + d[v].y * g, 2, 0, Math.PI * 2, !1);
    r.closePath(), r.fill();
  }
  e = e !== void 0 ? e : 0, t = t !== void 0 ? t : 0, n = n !== void 0 ? n : 24;
  for (var a = 1 / this.path.unitsPerEm * n, s = [], o = [], l = this.path, u = 0; u < l.commands.length; u += 1) {
    var c = l.commands[u];
    c.x !== void 0 && s.push({ x: c.x, y: -c.y }), c.x1 !== void 0 && o.push({ x: c.x1, y: -c.y1 }), c.x2 !== void 0 && o.push({ x: c.x2, y: -c.y2 });
  }
  r.fillStyle = "blue", i(s, e, t, a), r.fillStyle = "red", i(o, e, t, a);
};
ga.prototype.drawMetrics = function(r, e, t, n) {
  var i;
  e = e !== void 0 ? e : 0, t = t !== void 0 ? t : 0, n = n !== void 0 ? n : 24, i = 1 / this.path.unitsPerEm * n, r.lineWidth = 1, r.strokeStyle = "black", al.line(r, e, -1e4, e, 1e4), al.line(r, -1e4, t, 1e4, t);
  var a = this.xMin || 0, s = this.yMin || 0, o = this.xMax || 0, l = this.yMax || 0, u = this.advanceWidth || 0;
  r.strokeStyle = "blue", al.line(r, e + a * i, -1e4, e + a * i, 1e4), al.line(r, e + o * i, -1e4, e + o * i, 1e4), al.line(r, -1e4, t + -s * i, 1e4, t + -s * i), al.line(r, -1e4, t + -l * i, 1e4, t + -l * i), r.strokeStyle = "green", al.line(r, e + u * i, -1e4, e + u * i, 1e4);
};
function Uh(r, e, t) {
  Object.defineProperty(r, e, {
    get: function() {
      return r.path, r[t];
    },
    set: function(n) {
      r[t] = n;
    },
    enumerable: !0,
    configurable: !0
  });
}
function r1(r, e) {
  if (this.font = r, this.glyphs = {}, Array.isArray(e))
    for (var t = 0; t < e.length; t++) {
      var n = e[t];
      n.path.unitsPerEm = r.unitsPerEm, this.glyphs[t] = n;
    }
  this.length = e && e.length || 0;
}
r1.prototype.get = function(r) {
  if (this.glyphs[r] === void 0) {
    this.font._push(r), typeof this.glyphs[r] == "function" && (this.glyphs[r] = this.glyphs[r]());
    var e = this.glyphs[r], t = this.font._IndexToUnicodeMap[r];
    if (t)
      for (var n = 0; n < t.unicodes.length; n++)
        e.addUnicode(t.unicodes[n]);
    this.font.cffEncoding ? this.font.isCIDFont ? e.name = "gid" + r : e.name = this.font.cffEncoding.charset[r] : this.font.glyphNames.names && (e.name = this.font.glyphNames.glyphIndexToName(r)), this.glyphs[r].advanceWidth = this.font._hmtxTableData[r].advanceWidth, this.glyphs[r].leftSideBearing = this.font._hmtxTableData[r].leftSideBearing;
  } else
    typeof this.glyphs[r] == "function" && (this.glyphs[r] = this.glyphs[r]());
  return this.glyphs[r];
};
r1.prototype.push = function(r, e) {
  this.glyphs[r] = e, this.length++;
};
function i_(r, e) {
  return new ga({ index: e, font: r });
}
function a_(r, e, t, n, i, a) {
  return function() {
    var s = new ga({ index: e, font: r });
    return s.path = function() {
      t(s, n, i);
      var o = a(r.glyphs, s);
      return o.unitsPerEm = r.unitsPerEm, o;
    }, Uh(s, "xMin", "_xMin"), Uh(s, "xMax", "_xMax"), Uh(s, "yMin", "_yMin"), Uh(s, "yMax", "_yMax"), s;
  };
}
function s_(r, e, t, n) {
  return function() {
    var i = new ga({ index: e, font: r });
    return i.path = function() {
      var a = t(r, i, n);
      return a.unitsPerEm = r.unitsPerEm, a;
    }, i;
  };
}
var is = { GlyphSet: r1, glyphLoader: i_, ttfGlyphLoader: a_, cffGlyphLoader: s_ };
function wT(r, e) {
  if (r === e)
    return !0;
  if (Array.isArray(r) && Array.isArray(e)) {
    if (r.length !== e.length)
      return !1;
    for (var t = 0; t < r.length; t += 1)
      if (!wT(r[t], e[t]))
        return !1;
    return !0;
  } else
    return !1;
}
function Ny(r) {
  var e;
  return r.length < 1240 ? e = 107 : r.length < 33900 ? e = 1131 : e = 32768, e;
}
function to(r, e, t) {
  var n = [], i = [], a = vt.getCard16(r, e), s, o;
  if (a !== 0) {
    var l = vt.getByte(r, e + 2);
    s = e + (a + 1) * l + 2;
    for (var u = e + 3, c = 0; c < a + 1; c += 1)
      n.push(vt.getOffset(r, u, l)), u += l;
    o = s + n[a];
  } else
    o = e + 2;
  for (var d = 0; d < n.length - 1; d += 1) {
    var f = vt.getBytes(r, s + n[d], s + n[d + 1]);
    t && (f = t(f)), i.push(f);
  }
  return { objects: i, startOffset: e, endOffset: o };
}
function o_(r, e) {
  var t = [], n = vt.getCard16(r, e), i, a;
  if (n !== 0) {
    var s = vt.getByte(r, e + 2);
    i = e + (n + 1) * s + 2;
    for (var o = e + 3, l = 0; l < n + 1; l += 1)
      t.push(vt.getOffset(r, o, s)), o += s;
    a = i + t[n];
  } else
    a = e + 2;
  return { offsets: t, startOffset: e, endOffset: a };
}
function l_(r, e, t, n, i) {
  var a = vt.getCard16(t, n), s = 0;
  if (a !== 0) {
    var o = vt.getByte(t, n + 2);
    s = n + (a + 1) * o + 2;
  }
  var l = vt.getBytes(t, s + e[r], s + e[r + 1]);
  return l;
}
function u_(r) {
  for (var e = "", t = 15, n = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "E", "E-", null, "-"]; ; ) {
    var i = r.parseByte(), a = i >> 4, s = i & 15;
    if (a === t || (e += n[a], s === t))
      break;
    e += n[s];
  }
  return parseFloat(e);
}
function c_(r, e) {
  var t, n, i, a;
  if (e === 28)
    return t = r.parseByte(), n = r.parseByte(), t << 8 | n;
  if (e === 29)
    return t = r.parseByte(), n = r.parseByte(), i = r.parseByte(), a = r.parseByte(), t << 24 | n << 16 | i << 8 | a;
  if (e === 30)
    return u_(r);
  if (e >= 32 && e <= 246)
    return e - 139;
  if (e >= 247 && e <= 250)
    return t = r.parseByte(), (e - 247) * 256 + t + 108;
  if (e >= 251 && e <= 254)
    return t = r.parseByte(), -(e - 251) * 256 - t - 108;
  throw new Error("Invalid b0 " + e);
}
function f_(r) {
  for (var e = {}, t = 0; t < r.length; t += 1) {
    var n = r[t][0], i = r[t][1], a = void 0;
    if (i.length === 1 ? a = i[0] : a = i, e.hasOwnProperty(n) && !isNaN(e[n]))
      throw new Error("Object " + e + " already has key " + n);
    e[n] = a;
  }
  return e;
}
function xT(r, e, t) {
  e = e !== void 0 ? e : 0;
  var n = new vt.Parser(r, e), i = [], a = [];
  for (t = t !== void 0 ? t : r.length; n.relativeOffset < t; ) {
    var s = n.parseByte();
    s <= 21 ? (s === 12 && (s = 1200 + n.parseByte()), i.push([s, a]), a = []) : a.push(c_(n, s));
  }
  return f_(i);
}
function jf(r, e) {
  return e <= 390 ? e = Mp[e] : e = r[e - 391], e;
}
function CT(r, e, t) {
  for (var n = {}, i, a = 0; a < e.length; a += 1) {
    var s = e[a];
    if (Array.isArray(s.type)) {
      var o = [];
      o.length = s.type.length;
      for (var l = 0; l < s.type.length; l++)
        i = r[s.op] !== void 0 ? r[s.op][l] : void 0, i === void 0 && (i = s.value !== void 0 && s.value[l] !== void 0 ? s.value[l] : null), s.type[l] === "SID" && (i = jf(t, i)), o[l] = i;
      n[s.name] = o;
    } else
      i = r[s.op], i === void 0 && (i = s.value !== void 0 ? s.value : null), s.type === "SID" && (i = jf(t, i)), n[s.name] = i;
  }
  return n;
}
function d_(r, e) {
  var t = {};
  return t.formatMajor = vt.getCard8(r, e), t.formatMinor = vt.getCard8(r, e + 1), t.size = vt.getCard8(r, e + 2), t.offsetSize = vt.getCard8(r, e + 3), t.startOffset = e, t.endOffset = e + 4, t;
}
var ST = [
  { name: "version", op: 0, type: "SID" },
  { name: "notice", op: 1, type: "SID" },
  { name: "copyright", op: 1200, type: "SID" },
  { name: "fullName", op: 2, type: "SID" },
  { name: "familyName", op: 3, type: "SID" },
  { name: "weight", op: 4, type: "SID" },
  { name: "isFixedPitch", op: 1201, type: "number", value: 0 },
  { name: "italicAngle", op: 1202, type: "number", value: 0 },
  { name: "underlinePosition", op: 1203, type: "number", value: -100 },
  { name: "underlineThickness", op: 1204, type: "number", value: 50 },
  { name: "paintType", op: 1205, type: "number", value: 0 },
  { name: "charstringType", op: 1206, type: "number", value: 2 },
  {
    name: "fontMatrix",
    op: 1207,
    type: ["real", "real", "real", "real", "real", "real"],
    value: [1e-3, 0, 0, 1e-3, 0, 0]
  },
  { name: "uniqueId", op: 13, type: "number" },
  { name: "fontBBox", op: 5, type: ["number", "number", "number", "number"], value: [0, 0, 0, 0] },
  { name: "strokeWidth", op: 1208, type: "number", value: 0 },
  { name: "xuid", op: 14, type: [], value: null },
  { name: "charset", op: 15, type: "offset", value: 0 },
  { name: "encoding", op: 16, type: "offset", value: 0 },
  { name: "charStrings", op: 17, type: "offset", value: 0 },
  { name: "private", op: 18, type: ["number", "offset"], value: [0, 0] },
  { name: "ros", op: 1230, type: ["SID", "SID", "number"] },
  { name: "cidFontVersion", op: 1231, type: "number", value: 0 },
  { name: "cidFontRevision", op: 1232, type: "number", value: 0 },
  { name: "cidFontType", op: 1233, type: "number", value: 0 },
  { name: "cidCount", op: 1234, type: "number", value: 8720 },
  { name: "uidBase", op: 1235, type: "number" },
  { name: "fdArray", op: 1236, type: "offset" },
  { name: "fdSelect", op: 1237, type: "offset" },
  { name: "fontName", op: 1238, type: "SID" }
], ET = [
  { name: "subrs", op: 19, type: "offset", value: 0 },
  { name: "defaultWidthX", op: 20, type: "number", value: 0 },
  { name: "nominalWidthX", op: 21, type: "number", value: 0 }
];
function h_(r, e) {
  var t = xT(r, 0, r.byteLength);
  return CT(t, ST, e);
}
function kT(r, e, t, n) {
  var i = xT(r, e, t);
  return CT(i, ET, n);
}
function Hx(r, e, t, n) {
  for (var i = [], a = 0; a < t.length; a += 1) {
    var s = new DataView(new Uint8Array(t[a]).buffer), o = h_(s, n);
    o._subrs = [], o._subrsBias = 0, o._defaultWidthX = 0, o._nominalWidthX = 0;
    var l = o.private[0], u = o.private[1];
    if (l !== 0 && u !== 0) {
      var c = kT(r, u + e, l, n);
      if (o._defaultWidthX = c.defaultWidthX, o._nominalWidthX = c.nominalWidthX, c.subrs !== 0) {
        var d = u + c.subrs, f = to(r, d + e);
        o._subrs = f.objects, o._subrsBias = Ny(o._subrs);
      }
      o._privateDict = c;
    }
    i.push(o);
  }
  return i;
}
function p_(r, e, t, n) {
  var i, a, s = new vt.Parser(r, e);
  t -= 1;
  var o = [".notdef"], l = s.parseCard8();
  if (l === 0)
    for (var u = 0; u < t; u += 1)
      i = s.parseSID(), o.push(jf(n, i));
  else if (l === 1)
    for (; o.length <= t; ) {
      i = s.parseSID(), a = s.parseCard8();
      for (var c = 0; c <= a; c += 1)
        o.push(jf(n, i)), i += 1;
    }
  else if (l === 2)
    for (; o.length <= t; ) {
      i = s.parseSID(), a = s.parseCard16();
      for (var d = 0; d <= a; d += 1)
        o.push(jf(n, i)), i += 1;
    }
  else
    throw new Error("Unknown charset format " + l);
  return o;
}
function g_(r, e, t) {
  var n, i = {}, a = new vt.Parser(r, e), s = a.parseCard8();
  if (s === 0)
    for (var o = a.parseCard8(), l = 0; l < o; l += 1)
      n = a.parseCard8(), i[n] = l;
  else if (s === 1) {
    var u = a.parseCard8();
    n = 1;
    for (var c = 0; c < u; c += 1)
      for (var d = a.parseCard8(), f = a.parseCard8(), h = d; h <= d + f; h += 1)
        i[h] = n, n += 1;
  } else
    throw new Error("Unknown encoding format " + s);
  return new sg(i, t);
}
function jx(r, e, t) {
  var n, i, a, s, o = new ci(), l = [], u = 0, c = !1, d = !1, f = 0, h = 0, g, v, y, A;
  if (r.isCIDFont) {
    var x = r.tables.cff.topDict._fdSelect[e.index], k = r.tables.cff.topDict._fdArray[x];
    g = k._subrs, v = k._subrsBias, y = k._defaultWidthX, A = k._nominalWidthX;
  } else
    g = r.tables.cff.topDict._subrs, v = r.tables.cff.topDict._subrsBias, y = r.tables.cff.topDict._defaultWidthX, A = r.tables.cff.topDict._nominalWidthX;
  var F = y;
  function S(j, G) {
    d && o.closePath(), o.moveTo(j, G), d = !0;
  }
  function R() {
    var j;
    j = l.length % 2 !== 0, j && !c && (F = l.shift() + A), u += l.length >> 1, l.length = 0, c = !0;
  }
  function M(j) {
    for (var G, ie, q, Y, J, se, oe, he, ye, Ue, Re, Oe, ee = 0; ee < j.length; ) {
      var re = j[ee];
      switch (ee += 1, re) {
        case 1:
          R();
          break;
        case 3:
          R();
          break;
        case 4:
          l.length > 1 && !c && (F = l.shift() + A, c = !0), h += l.pop(), S(f, h);
          break;
        case 5:
          for (; l.length > 0; )
            f += l.shift(), h += l.shift(), o.lineTo(f, h);
          break;
        case 6:
          for (; l.length > 0 && (f += l.shift(), o.lineTo(f, h), l.length !== 0); )
            h += l.shift(), o.lineTo(f, h);
          break;
        case 7:
          for (; l.length > 0 && (h += l.shift(), o.lineTo(f, h), l.length !== 0); )
            f += l.shift(), o.lineTo(f, h);
          break;
        case 8:
          for (; l.length > 0; )
            n = f + l.shift(), i = h + l.shift(), a = n + l.shift(), s = i + l.shift(), f = a + l.shift(), h = s + l.shift(), o.curveTo(n, i, a, s, f, h);
          break;
        case 10:
          J = l.pop() + v, se = g[J], se && M(se);
          break;
        case 11:
          return;
        case 12:
          switch (re = j[ee], ee += 1, re) {
            case 35:
              n = f + l.shift(), i = h + l.shift(), a = n + l.shift(), s = i + l.shift(), oe = a + l.shift(), he = s + l.shift(), ye = oe + l.shift(), Ue = he + l.shift(), Re = ye + l.shift(), Oe = Ue + l.shift(), f = Re + l.shift(), h = Oe + l.shift(), l.shift(), o.curveTo(n, i, a, s, oe, he), o.curveTo(ye, Ue, Re, Oe, f, h);
              break;
            case 34:
              n = f + l.shift(), i = h, a = n + l.shift(), s = i + l.shift(), oe = a + l.shift(), he = s, ye = oe + l.shift(), Ue = s, Re = ye + l.shift(), Oe = h, f = Re + l.shift(), o.curveTo(n, i, a, s, oe, he), o.curveTo(ye, Ue, Re, Oe, f, h);
              break;
            case 36:
              n = f + l.shift(), i = h + l.shift(), a = n + l.shift(), s = i + l.shift(), oe = a + l.shift(), he = s, ye = oe + l.shift(), Ue = s, Re = ye + l.shift(), Oe = Ue + l.shift(), f = Re + l.shift(), o.curveTo(n, i, a, s, oe, he), o.curveTo(ye, Ue, Re, Oe, f, h);
              break;
            case 37:
              n = f + l.shift(), i = h + l.shift(), a = n + l.shift(), s = i + l.shift(), oe = a + l.shift(), he = s + l.shift(), ye = oe + l.shift(), Ue = he + l.shift(), Re = ye + l.shift(), Oe = Ue + l.shift(), Math.abs(Re - f) > Math.abs(Oe - h) ? f = Re + l.shift() : h = Oe + l.shift(), o.curveTo(n, i, a, s, oe, he), o.curveTo(ye, Ue, Re, Oe, f, h);
              break;
            default:
              console.log("Glyph " + e.index + ": unknown operator 1200" + re), l.length = 0;
          }
          break;
        case 14:
          l.length > 0 && !c && (F = l.shift() + A, c = !0), d && (o.closePath(), d = !1);
          break;
        case 18:
          R();
          break;
        case 19:
        // hintmask
        case 20:
          R(), ee += u + 7 >> 3;
          break;
        case 21:
          l.length > 2 && !c && (F = l.shift() + A, c = !0), h += l.pop(), f += l.pop(), S(f, h);
          break;
        case 22:
          l.length > 1 && !c && (F = l.shift() + A, c = !0), f += l.pop(), S(f, h);
          break;
        case 23:
          R();
          break;
        case 24:
          for (; l.length > 2; )
            n = f + l.shift(), i = h + l.shift(), a = n + l.shift(), s = i + l.shift(), f = a + l.shift(), h = s + l.shift(), o.curveTo(n, i, a, s, f, h);
          f += l.shift(), h += l.shift(), o.lineTo(f, h);
          break;
        case 25:
          for (; l.length > 6; )
            f += l.shift(), h += l.shift(), o.lineTo(f, h);
          n = f + l.shift(), i = h + l.shift(), a = n + l.shift(), s = i + l.shift(), f = a + l.shift(), h = s + l.shift(), o.curveTo(n, i, a, s, f, h);
          break;
        case 26:
          for (l.length % 2 && (f += l.shift()); l.length > 0; )
            n = f, i = h + l.shift(), a = n + l.shift(), s = i + l.shift(), f = a, h = s + l.shift(), o.curveTo(n, i, a, s, f, h);
          break;
        case 27:
          for (l.length % 2 && (h += l.shift()); l.length > 0; )
            n = f + l.shift(), i = h, a = n + l.shift(), s = i + l.shift(), f = a + l.shift(), h = s, o.curveTo(n, i, a, s, f, h);
          break;
        case 28:
          G = j[ee], ie = j[ee + 1], l.push((G << 24 | ie << 16) >> 16), ee += 2;
          break;
        case 29:
          J = l.pop() + r.gsubrsBias, se = r.gsubrs[J], se && M(se);
          break;
        case 30:
          for (; l.length > 0 && (n = f, i = h + l.shift(), a = n + l.shift(), s = i + l.shift(), f = a + l.shift(), h = s + (l.length === 1 ? l.shift() : 0), o.curveTo(n, i, a, s, f, h), l.length !== 0); )
            n = f + l.shift(), i = h, a = n + l.shift(), s = i + l.shift(), h = s + l.shift(), f = a + (l.length === 1 ? l.shift() : 0), o.curveTo(n, i, a, s, f, h);
          break;
        case 31:
          for (; l.length > 0 && (n = f + l.shift(), i = h, a = n + l.shift(), s = i + l.shift(), h = s + l.shift(), f = a + (l.length === 1 ? l.shift() : 0), o.curveTo(n, i, a, s, f, h), l.length !== 0); )
            n = f, i = h + l.shift(), a = n + l.shift(), s = i + l.shift(), f = a + l.shift(), h = s + (l.length === 1 ? l.shift() : 0), o.curveTo(n, i, a, s, f, h);
          break;
        default:
          re < 32 ? console.log("Glyph " + e.index + ": unknown operator " + re) : re < 247 ? l.push(re - 139) : re < 251 ? (G = j[ee], ee += 1, l.push((re - 247) * 256 + G + 108)) : re < 255 ? (G = j[ee], ee += 1, l.push(-(re - 251) * 256 - G - 108)) : (G = j[ee], ie = j[ee + 1], q = j[ee + 2], Y = j[ee + 3], ee += 4, l.push((G << 24 | ie << 16 | q << 8 | Y) / 65536));
      }
    }
  }
  return M(t), e.advanceWidth = F, o;
}
function m_(r, e, t, n) {
  var i = [], a, s = new vt.Parser(r, e), o = s.parseCard8();
  if (o === 0)
    for (var l = 0; l < t; l++) {
      if (a = s.parseCard8(), a >= n)
        throw new Error("CFF table CID Font FDSelect has bad FD index value " + a + " (FD count " + n + ")");
      i.push(a);
    }
  else if (o === 3) {
    var u = s.parseCard16(), c = s.parseCard16();
    if (c !== 0)
      throw new Error("CFF Table CID Font FDSelect format 3 range has bad initial GID " + c);
    for (var d, f = 0; f < u; f++) {
      if (a = s.parseCard8(), d = s.parseCard16(), a >= n)
        throw new Error("CFF table CID Font FDSelect has bad FD index value " + a + " (FD count " + n + ")");
      if (d > t)
        throw new Error("CFF Table CID Font FDSelect format 3 range has bad GID " + d);
      for (; c < d; c++)
        i.push(a);
      c = d;
    }
    if (d !== t)
      throw new Error("CFF Table CID Font FDSelect format 3 range has bad final GID " + d);
  } else
    throw new Error("CFF Table CID Font FDSelect table has unsupported format " + o);
  return i;
}
function v_(r, e, t, n) {
  t.tables.cff = {};
  var i = d_(r, e), a = to(r, i.endOffset, vt.bytesToString), s = to(r, a.endOffset), o = to(r, s.endOffset, vt.bytesToString), l = to(r, o.endOffset);
  t.gsubrs = l.objects, t.gsubrsBias = Ny(t.gsubrs);
  var u = Hx(r, e, s.objects, o.objects);
  if (u.length !== 1)
    throw new Error("CFF table has too many fonts in 'FontSet' - count of fonts NameIndex.length = " + u.length);
  var c = u[0];
  if (t.tables.cff.topDict = c, c._privateDict && (t.defaultWidthX = c._privateDict.defaultWidthX, t.nominalWidthX = c._privateDict.nominalWidthX), c.ros[0] !== void 0 && c.ros[1] !== void 0 && (t.isCIDFont = !0), t.isCIDFont) {
    var d = c.fdArray, f = c.fdSelect;
    if (d === 0 || f === 0)
      throw new Error("Font is marked as a CID font, but FDArray and/or FDSelect information is missing");
    d += e;
    var h = to(r, d), g = Hx(r, e, h.objects, o.objects);
    c._fdArray = g, f += e, c._fdSelect = m_(r, f, t.numGlyphs, g.length);
  }
  var v = e + c.private[1], y = kT(r, v, c.private[0], o.objects);
  if (t.defaultWidthX = y.defaultWidthX, t.nominalWidthX = y.nominalWidthX, y.subrs !== 0) {
    var A = v + y.subrs, x = to(r, A);
    t.subrs = x.objects, t.subrsBias = Ny(t.subrs);
  } else
    t.subrs = [], t.subrsBias = 0;
  var k;
  n.lowMemory ? (k = o_(r, e + c.charStrings), t.nGlyphs = k.offsets.length) : (k = to(r, e + c.charStrings), t.nGlyphs = k.objects.length);
  var F = p_(r, e + c.charset, t.nGlyphs, o.objects);
  if (c.encoding === 0 ? t.cffEncoding = new sg(JM, F) : c.encoding === 1 ? t.cffEncoding = new sg(KM, F) : t.cffEncoding = g_(r, e + c.encoding, F), t.encoding = t.encoding || t.cffEncoding, t.glyphs = new is.GlyphSet(t), n.lowMemory)
    t._push = function(M) {
      var j = l_(M, k.offsets, r, e + c.charStrings);
      t.glyphs.push(M, is.cffGlyphLoader(t, M, jx, j));
    };
  else
    for (var S = 0; S < t.nGlyphs; S += 1) {
      var R = k.objects[S];
      t.glyphs.push(S, is.cffGlyphLoader(t, S, jx, R));
    }
}
function TT(r, e) {
  var t, n = Mp.indexOf(r);
  return n >= 0 && (t = n), n = e.indexOf(r), n >= 0 ? t = n + Mp.length : (t = Mp.length + e.length, e.push(r)), t;
}
function y_() {
  return new ct.Record("Header", [
    { name: "major", type: "Card8", value: 1 },
    { name: "minor", type: "Card8", value: 0 },
    { name: "hdrSize", type: "Card8", value: 4 },
    { name: "major", type: "Card8", value: 1 }
  ]);
}
function A_(r) {
  var e = new ct.Record("Name INDEX", [
    { name: "names", type: "INDEX", value: [] }
  ]);
  e.names = [];
  for (var t = 0; t < r.length; t += 1)
    e.names.push({ name: "name_" + t, type: "NAME", value: r[t] });
  return e;
}
function FT(r, e, t) {
  for (var n = {}, i = 0; i < r.length; i += 1) {
    var a = r[i], s = e[a.name];
    s !== void 0 && !wT(s, a.value) && (a.type === "SID" && (s = TT(s, t)), n[a.op] = { name: a.name, type: a.type, value: s });
  }
  return n;
}
function Gx(r, e) {
  var t = new ct.Record("Top DICT", [
    { name: "dict", type: "DICT", value: {} }
  ]);
  return t.dict = FT(ST, r, e), t;
}
function qx(r) {
  var e = new ct.Record("Top DICT INDEX", [
    { name: "topDicts", type: "INDEX", value: [] }
  ]);
  return e.topDicts = [{ name: "topDict_0", type: "TABLE", value: r }], e;
}
function b_(r) {
  var e = new ct.Record("String INDEX", [
    { name: "strings", type: "INDEX", value: [] }
  ]);
  e.strings = [];
  for (var t = 0; t < r.length; t += 1)
    e.strings.push({ name: "string_" + t, type: "STRING", value: r[t] });
  return e;
}
function w_() {
  return new ct.Record("Global Subr INDEX", [
    { name: "subrs", type: "INDEX", value: [] }
  ]);
}
function x_(r, e) {
  for (var t = new ct.Record("Charsets", [
    { name: "format", type: "Card8", value: 0 }
  ]), n = 0; n < r.length; n += 1) {
    var i = r[n], a = TT(i, e);
    t.fields.push({ name: "glyph_" + n, type: "SID", value: a });
  }
  return t;
}
function C_(r) {
  var e = [], t = r.path;
  e.push({ name: "width", type: "NUMBER", value: r.advanceWidth });
  for (var n = 0, i = 0, a = 0; a < t.commands.length; a += 1) {
    var s = void 0, o = void 0, l = t.commands[a];
    if (l.type === "Q") {
      var u = 0.3333333333333333, c = 2 / 3;
      l = {
        type: "C",
        x: l.x,
        y: l.y,
        x1: Math.round(u * n + c * l.x1),
        y1: Math.round(u * i + c * l.y1),
        x2: Math.round(u * l.x + c * l.x1),
        y2: Math.round(u * l.y + c * l.y1)
      };
    }
    if (l.type === "M")
      s = Math.round(l.x - n), o = Math.round(l.y - i), e.push({ name: "dx", type: "NUMBER", value: s }), e.push({ name: "dy", type: "NUMBER", value: o }), e.push({ name: "rmoveto", type: "OP", value: 21 }), n = Math.round(l.x), i = Math.round(l.y);
    else if (l.type === "L")
      s = Math.round(l.x - n), o = Math.round(l.y - i), e.push({ name: "dx", type: "NUMBER", value: s }), e.push({ name: "dy", type: "NUMBER", value: o }), e.push({ name: "rlineto", type: "OP", value: 5 }), n = Math.round(l.x), i = Math.round(l.y);
    else if (l.type === "C") {
      var d = Math.round(l.x1 - n), f = Math.round(l.y1 - i), h = Math.round(l.x2 - l.x1), g = Math.round(l.y2 - l.y1);
      s = Math.round(l.x - l.x2), o = Math.round(l.y - l.y2), e.push({ name: "dx1", type: "NUMBER", value: d }), e.push({ name: "dy1", type: "NUMBER", value: f }), e.push({ name: "dx2", type: "NUMBER", value: h }), e.push({ name: "dy2", type: "NUMBER", value: g }), e.push({ name: "dx", type: "NUMBER", value: s }), e.push({ name: "dy", type: "NUMBER", value: o }), e.push({ name: "rrcurveto", type: "OP", value: 8 }), n = Math.round(l.x), i = Math.round(l.y);
    }
  }
  return e.push({ name: "endchar", type: "OP", value: 14 }), e;
}
function S_(r) {
  for (var e = new ct.Record("CharStrings INDEX", [
    { name: "charStrings", type: "INDEX", value: [] }
  ]), t = 0; t < r.length; t += 1) {
    var n = r.get(t), i = C_(n);
    e.charStrings.push({ name: n.name, type: "CHARSTRING", value: i });
  }
  return e;
}
function E_(r, e) {
  var t = new ct.Record("Private DICT", [
    { name: "dict", type: "DICT", value: {} }
  ]);
  return t.dict = FT(ET, r, e), t;
}
function k_(r, e) {
  for (var t = new ct.Table("CFF ", [
    { name: "header", type: "RECORD" },
    { name: "nameIndex", type: "RECORD" },
    { name: "topDictIndex", type: "RECORD" },
    { name: "stringIndex", type: "RECORD" },
    { name: "globalSubrIndex", type: "RECORD" },
    { name: "charsets", type: "RECORD" },
    { name: "charStringsIndex", type: "RECORD" },
    { name: "privateDict", type: "RECORD" }
  ]), n = 1 / e.unitsPerEm, i = {
    version: e.version,
    fullName: e.fullName,
    familyName: e.familyName,
    weight: e.weightName,
    fontBBox: e.fontBBox || [0, 0, 0, 0],
    fontMatrix: [n, 0, 0, n, 0, 0],
    charset: 999,
    encoding: 0,
    charStrings: 999,
    private: [0, 999]
  }, a = {}, s = [], o, l = 1; l < r.length; l += 1)
    o = r.get(l), s.push(o.name);
  var u = [];
  t.header = y_(), t.nameIndex = A_([e.postScriptName]);
  var c = Gx(i, u);
  t.topDictIndex = qx(c), t.globalSubrIndex = w_(), t.charsets = x_(s, u), t.charStringsIndex = S_(r), t.privateDict = E_(a, u), t.stringIndex = b_(u);
  var d = t.header.sizeOf() + t.nameIndex.sizeOf() + t.topDictIndex.sizeOf() + t.stringIndex.sizeOf() + t.globalSubrIndex.sizeOf();
  return i.charset = d, i.encoding = 0, i.charStrings = i.charset + t.charsets.sizeOf(), i.private[1] = i.charStrings + t.charStringsIndex.sizeOf(), c = Gx(i, u), t.topDictIndex = qx(c), t;
}
var IT = { parse: v_, make: k_ };
function T_(r, e) {
  var t = {}, n = new vt.Parser(r, e);
  return t.version = n.parseVersion(), t.fontRevision = Math.round(n.parseFixed() * 1e3) / 1e3, t.checkSumAdjustment = n.parseULong(), t.magicNumber = n.parseULong(), jt.argument(t.magicNumber === 1594834165, "Font header has wrong magic number."), t.flags = n.parseUShort(), t.unitsPerEm = n.parseUShort(), t.created = n.parseLongDateTime(), t.modified = n.parseLongDateTime(), t.xMin = n.parseShort(), t.yMin = n.parseShort(), t.xMax = n.parseShort(), t.yMax = n.parseShort(), t.macStyle = n.parseUShort(), t.lowestRecPPEM = n.parseUShort(), t.fontDirectionHint = n.parseShort(), t.indexToLocFormat = n.parseShort(), t.glyphDataFormat = n.parseShort(), t;
}
function F_(r) {
  var e = Math.round((/* @__PURE__ */ new Date()).getTime() / 1e3) + 2082844800, t = e;
  return r.createdTimestamp && (t = r.createdTimestamp + 2082844800), new ct.Table("head", [
    { name: "version", type: "FIXED", value: 65536 },
    { name: "fontRevision", type: "FIXED", value: 65536 },
    { name: "checkSumAdjustment", type: "ULONG", value: 0 },
    { name: "magicNumber", type: "ULONG", value: 1594834165 },
    { name: "flags", type: "USHORT", value: 0 },
    { name: "unitsPerEm", type: "USHORT", value: 1e3 },
    { name: "created", type: "LONGDATETIME", value: t },
    { name: "modified", type: "LONGDATETIME", value: e },
    { name: "xMin", type: "SHORT", value: 0 },
    { name: "yMin", type: "SHORT", value: 0 },
    { name: "xMax", type: "SHORT", value: 0 },
    { name: "yMax", type: "SHORT", value: 0 },
    { name: "macStyle", type: "USHORT", value: 0 },
    { name: "lowestRecPPEM", type: "USHORT", value: 0 },
    { name: "fontDirectionHint", type: "SHORT", value: 2 },
    { name: "indexToLocFormat", type: "SHORT", value: 0 },
    { name: "glyphDataFormat", type: "SHORT", value: 0 }
  ], r);
}
var DT = { parse: T_, make: F_ };
function I_(r, e) {
  var t = {}, n = new vt.Parser(r, e);
  return t.version = n.parseVersion(), t.ascender = n.parseShort(), t.descender = n.parseShort(), t.lineGap = n.parseShort(), t.advanceWidthMax = n.parseUShort(), t.minLeftSideBearing = n.parseShort(), t.minRightSideBearing = n.parseShort(), t.xMaxExtent = n.parseShort(), t.caretSlopeRise = n.parseShort(), t.caretSlopeRun = n.parseShort(), t.caretOffset = n.parseShort(), n.relativeOffset += 8, t.metricDataFormat = n.parseShort(), t.numberOfHMetrics = n.parseUShort(), t;
}
function D_(r) {
  return new ct.Table("hhea", [
    { name: "version", type: "FIXED", value: 65536 },
    { name: "ascender", type: "FWORD", value: 0 },
    { name: "descender", type: "FWORD", value: 0 },
    { name: "lineGap", type: "FWORD", value: 0 },
    { name: "advanceWidthMax", type: "UFWORD", value: 0 },
    { name: "minLeftSideBearing", type: "FWORD", value: 0 },
    { name: "minRightSideBearing", type: "FWORD", value: 0 },
    { name: "xMaxExtent", type: "FWORD", value: 0 },
    { name: "caretSlopeRise", type: "SHORT", value: 1 },
    { name: "caretSlopeRun", type: "SHORT", value: 0 },
    { name: "caretOffset", type: "SHORT", value: 0 },
    { name: "reserved1", type: "SHORT", value: 0 },
    { name: "reserved2", type: "SHORT", value: 0 },
    { name: "reserved3", type: "SHORT", value: 0 },
    { name: "reserved4", type: "SHORT", value: 0 },
    { name: "metricDataFormat", type: "SHORT", value: 0 },
    { name: "numberOfHMetrics", type: "USHORT", value: 0 }
  ], r);
}
var PT = { parse: I_, make: D_ };
function P_(r, e, t, n, i) {
  for (var a, s, o = new vt.Parser(r, e), l = 0; l < n; l += 1) {
    l < t && (a = o.parseUShort(), s = o.parseShort());
    var u = i.get(l);
    u.advanceWidth = a, u.leftSideBearing = s;
  }
}
function R_(r, e, t, n, i) {
  r._hmtxTableData = {};
  for (var a, s, o = new vt.Parser(e, t), l = 0; l < i; l += 1)
    l < n && (a = o.parseUShort(), s = o.parseShort()), r._hmtxTableData[l] = {
      advanceWidth: a,
      leftSideBearing: s
    };
}
function O_(r, e, t, n, i, a, s) {
  s.lowMemory ? R_(r, e, t, n, i) : P_(e, t, n, i, a);
}
function B_(r) {
  for (var e = new ct.Table("hmtx", []), t = 0; t < r.length; t += 1) {
    var n = r.get(t), i = n.advanceWidth || 0, a = n.leftSideBearing || 0;
    e.fields.push({ name: "advanceWidth_" + t, type: "USHORT", value: i }), e.fields.push({ name: "leftSideBearing_" + t, type: "SHORT", value: a });
  }
  return e;
}
var RT = { parse: O_, make: B_ };
function M_(r) {
  for (var e = new ct.Table("ltag", [
    { name: "version", type: "ULONG", value: 1 },
    { name: "flags", type: "ULONG", value: 0 },
    { name: "numTags", type: "ULONG", value: r.length }
  ]), t = "", n = 12 + r.length * 4, i = 0; i < r.length; ++i) {
    var a = t.indexOf(r[i]);
    a < 0 && (a = t.length, t += r[i]), e.fields.push({ name: "offset " + i, type: "USHORT", value: n + a }), e.fields.push({ name: "length " + i, type: "USHORT", value: r[i].length });
  }
  return e.fields.push({ name: "stringPool", type: "CHARARRAY", value: t }), e;
}
function __(r, e) {
  var t = new vt.Parser(r, e), n = t.parseULong();
  jt.argument(n === 1, "Unsupported ltag table version."), t.skip("uLong", 1);
  for (var i = t.parseULong(), a = [], s = 0; s < i; s++) {
    for (var o = "", l = e + t.parseUShort(), u = t.parseUShort(), c = l; c < l + u; ++c)
      o += String.fromCharCode(r.getInt8(c));
    a.push(o);
  }
  return a;
}
var OT = { make: M_, parse: __ };
function N_(r, e) {
  var t = {}, n = new vt.Parser(r, e);
  return t.version = n.parseVersion(), t.numGlyphs = n.parseUShort(), t.version === 1 && (t.maxPoints = n.parseUShort(), t.maxContours = n.parseUShort(), t.maxCompositePoints = n.parseUShort(), t.maxCompositeContours = n.parseUShort(), t.maxZones = n.parseUShort(), t.maxTwilightPoints = n.parseUShort(), t.maxStorage = n.parseUShort(), t.maxFunctionDefs = n.parseUShort(), t.maxInstructionDefs = n.parseUShort(), t.maxStackElements = n.parseUShort(), t.maxSizeOfInstructions = n.parseUShort(), t.maxComponentElements = n.parseUShort(), t.maxComponentDepth = n.parseUShort()), t;
}
function L_(r) {
  return new ct.Table("maxp", [
    { name: "version", type: "FIXED", value: 20480 },
    { name: "numGlyphs", type: "USHORT", value: r }
  ]);
}
var BT = { parse: N_, make: L_ }, MT = [
  "copyright",
  // 0
  "fontFamily",
  // 1
  "fontSubfamily",
  // 2
  "uniqueID",
  // 3
  "fullName",
  // 4
  "version",
  // 5
  "postScriptName",
  // 6
  "trademark",
  // 7
  "manufacturer",
  // 8
  "designer",
  // 9
  "description",
  // 10
  "manufacturerURL",
  // 11
  "designerURL",
  // 12
  "license",
  // 13
  "licenseURL",
  // 14
  "reserved",
  // 15
  "preferredFamily",
  // 16
  "preferredSubfamily",
  // 17
  "compatibleFullName",
  // 18
  "sampleText",
  // 19
  "postScriptFindFontName",
  // 20
  "wwsFamily",
  // 21
  "wwsSubfamily"
  // 22
], _T = {
  0: "en",
  1: "fr",
  2: "de",
  3: "it",
  4: "nl",
  5: "sv",
  6: "es",
  7: "da",
  8: "pt",
  9: "no",
  10: "he",
  11: "ja",
  12: "ar",
  13: "fi",
  14: "el",
  15: "is",
  16: "mt",
  17: "tr",
  18: "hr",
  19: "zh-Hant",
  20: "ur",
  21: "hi",
  22: "th",
  23: "ko",
  24: "lt",
  25: "pl",
  26: "hu",
  27: "es",
  28: "lv",
  29: "se",
  30: "fo",
  31: "fa",
  32: "ru",
  33: "zh",
  34: "nl-BE",
  35: "ga",
  36: "sq",
  37: "ro",
  38: "cz",
  39: "sk",
  40: "si",
  41: "yi",
  42: "sr",
  43: "mk",
  44: "bg",
  45: "uk",
  46: "be",
  47: "uz",
  48: "kk",
  49: "az-Cyrl",
  50: "az-Arab",
  51: "hy",
  52: "ka",
  53: "mo",
  54: "ky",
  55: "tg",
  56: "tk",
  57: "mn-CN",
  58: "mn",
  59: "ps",
  60: "ks",
  61: "ku",
  62: "sd",
  63: "bo",
  64: "ne",
  65: "sa",
  66: "mr",
  67: "bn",
  68: "as",
  69: "gu",
  70: "pa",
  71: "or",
  72: "ml",
  73: "kn",
  74: "ta",
  75: "te",
  76: "si",
  77: "my",
  78: "km",
  79: "lo",
  80: "vi",
  81: "id",
  82: "tl",
  83: "ms",
  84: "ms-Arab",
  85: "am",
  86: "ti",
  87: "om",
  88: "so",
  89: "sw",
  90: "rw",
  91: "rn",
  92: "ny",
  93: "mg",
  94: "eo",
  128: "cy",
  129: "eu",
  130: "ca",
  131: "la",
  132: "qu",
  133: "gn",
  134: "ay",
  135: "tt",
  136: "ug",
  137: "dz",
  138: "jv",
  139: "su",
  140: "gl",
  141: "af",
  142: "br",
  143: "iu",
  144: "gd",
  145: "gv",
  146: "ga",
  147: "to",
  148: "el-polyton",
  149: "kl",
  150: "az",
  151: "nn"
}, U_ = {
  0: 0,
  // langEnglish → smRoman
  1: 0,
  // langFrench → smRoman
  2: 0,
  // langGerman → smRoman
  3: 0,
  // langItalian → smRoman
  4: 0,
  // langDutch → smRoman
  5: 0,
  // langSwedish → smRoman
  6: 0,
  // langSpanish → smRoman
  7: 0,
  // langDanish → smRoman
  8: 0,
  // langPortuguese → smRoman
  9: 0,
  // langNorwegian → smRoman
  10: 5,
  // langHebrew → smHebrew
  11: 1,
  // langJapanese → smJapanese
  12: 4,
  // langArabic → smArabic
  13: 0,
  // langFinnish → smRoman
  14: 6,
  // langGreek → smGreek
  15: 0,
  // langIcelandic → smRoman (modified)
  16: 0,
  // langMaltese → smRoman
  17: 0,
  // langTurkish → smRoman (modified)
  18: 0,
  // langCroatian → smRoman (modified)
  19: 2,
  // langTradChinese → smTradChinese
  20: 4,
  // langUrdu → smArabic
  21: 9,
  // langHindi → smDevanagari
  22: 21,
  // langThai → smThai
  23: 3,
  // langKorean → smKorean
  24: 29,
  // langLithuanian → smCentralEuroRoman
  25: 29,
  // langPolish → smCentralEuroRoman
  26: 29,
  // langHungarian → smCentralEuroRoman
  27: 29,
  // langEstonian → smCentralEuroRoman
  28: 29,
  // langLatvian → smCentralEuroRoman
  29: 0,
  // langSami → smRoman
  30: 0,
  // langFaroese → smRoman (modified)
  31: 4,
  // langFarsi → smArabic (modified)
  32: 7,
  // langRussian → smCyrillic
  33: 25,
  // langSimpChinese → smSimpChinese
  34: 0,
  // langFlemish → smRoman
  35: 0,
  // langIrishGaelic → smRoman (modified)
  36: 0,
  // langAlbanian → smRoman
  37: 0,
  // langRomanian → smRoman (modified)
  38: 29,
  // langCzech → smCentralEuroRoman
  39: 29,
  // langSlovak → smCentralEuroRoman
  40: 0,
  // langSlovenian → smRoman (modified)
  41: 5,
  // langYiddish → smHebrew
  42: 7,
  // langSerbian → smCyrillic
  43: 7,
  // langMacedonian → smCyrillic
  44: 7,
  // langBulgarian → smCyrillic
  45: 7,
  // langUkrainian → smCyrillic (modified)
  46: 7,
  // langByelorussian → smCyrillic
  47: 7,
  // langUzbek → smCyrillic
  48: 7,
  // langKazakh → smCyrillic
  49: 7,
  // langAzerbaijani → smCyrillic
  50: 4,
  // langAzerbaijanAr → smArabic
  51: 24,
  // langArmenian → smArmenian
  52: 23,
  // langGeorgian → smGeorgian
  53: 7,
  // langMoldavian → smCyrillic
  54: 7,
  // langKirghiz → smCyrillic
  55: 7,
  // langTajiki → smCyrillic
  56: 7,
  // langTurkmen → smCyrillic
  57: 27,
  // langMongolian → smMongolian
  58: 7,
  // langMongolianCyr → smCyrillic
  59: 4,
  // langPashto → smArabic
  60: 4,
  // langKurdish → smArabic
  61: 4,
  // langKashmiri → smArabic
  62: 4,
  // langSindhi → smArabic
  63: 26,
  // langTibetan → smTibetan
  64: 9,
  // langNepali → smDevanagari
  65: 9,
  // langSanskrit → smDevanagari
  66: 9,
  // langMarathi → smDevanagari
  67: 13,
  // langBengali → smBengali
  68: 13,
  // langAssamese → smBengali
  69: 11,
  // langGujarati → smGujarati
  70: 10,
  // langPunjabi → smGurmukhi
  71: 12,
  // langOriya → smOriya
  72: 17,
  // langMalayalam → smMalayalam
  73: 16,
  // langKannada → smKannada
  74: 14,
  // langTamil → smTamil
  75: 15,
  // langTelugu → smTelugu
  76: 18,
  // langSinhalese → smSinhalese
  77: 19,
  // langBurmese → smBurmese
  78: 20,
  // langKhmer → smKhmer
  79: 22,
  // langLao → smLao
  80: 30,
  // langVietnamese → smVietnamese
  81: 0,
  // langIndonesian → smRoman
  82: 0,
  // langTagalog → smRoman
  83: 0,
  // langMalayRoman → smRoman
  84: 4,
  // langMalayArabic → smArabic
  85: 28,
  // langAmharic → smEthiopic
  86: 28,
  // langTigrinya → smEthiopic
  87: 28,
  // langOromo → smEthiopic
  88: 0,
  // langSomali → smRoman
  89: 0,
  // langSwahili → smRoman
  90: 0,
  // langKinyarwanda → smRoman
  91: 0,
  // langRundi → smRoman
  92: 0,
  // langNyanja → smRoman
  93: 0,
  // langMalagasy → smRoman
  94: 0,
  // langEsperanto → smRoman
  128: 0,
  // langWelsh → smRoman (modified)
  129: 0,
  // langBasque → smRoman
  130: 0,
  // langCatalan → smRoman
  131: 0,
  // langLatin → smRoman
  132: 0,
  // langQuechua → smRoman
  133: 0,
  // langGuarani → smRoman
  134: 0,
  // langAymara → smRoman
  135: 7,
  // langTatar → smCyrillic
  136: 4,
  // langUighur → smArabic
  137: 26,
  // langDzongkha → smTibetan
  138: 0,
  // langJavaneseRom → smRoman
  139: 0,
  // langSundaneseRom → smRoman
  140: 0,
  // langGalician → smRoman
  141: 0,
  // langAfrikaans → smRoman
  142: 0,
  // langBreton → smRoman (modified)
  143: 28,
  // langInuktitut → smEthiopic (modified)
  144: 0,
  // langScottishGaelic → smRoman (modified)
  145: 0,
  // langManxGaelic → smRoman (modified)
  146: 0,
  // langIrishGaelicScript → smRoman (modified)
  147: 0,
  // langTongan → smRoman
  148: 6,
  // langGreekAncient → smRoman
  149: 0,
  // langGreenlandic → smRoman
  150: 0,
  // langAzerbaijanRoman → smRoman
  151: 0
  // langNynorsk → smRoman
}, NT = {
  1078: "af",
  1052: "sq",
  1156: "gsw",
  1118: "am",
  5121: "ar-DZ",
  15361: "ar-BH",
  3073: "ar",
  2049: "ar-IQ",
  11265: "ar-JO",
  13313: "ar-KW",
  12289: "ar-LB",
  4097: "ar-LY",
  6145: "ary",
  8193: "ar-OM",
  16385: "ar-QA",
  1025: "ar-SA",
  10241: "ar-SY",
  7169: "aeb",
  14337: "ar-AE",
  9217: "ar-YE",
  1067: "hy",
  1101: "as",
  2092: "az-Cyrl",
  1068: "az",
  1133: "ba",
  1069: "eu",
  1059: "be",
  2117: "bn",
  1093: "bn-IN",
  8218: "bs-Cyrl",
  5146: "bs",
  1150: "br",
  1026: "bg",
  1027: "ca",
  3076: "zh-HK",
  5124: "zh-MO",
  2052: "zh",
  4100: "zh-SG",
  1028: "zh-TW",
  1155: "co",
  1050: "hr",
  4122: "hr-BA",
  1029: "cs",
  1030: "da",
  1164: "prs",
  1125: "dv",
  2067: "nl-BE",
  1043: "nl",
  3081: "en-AU",
  10249: "en-BZ",
  4105: "en-CA",
  9225: "en-029",
  16393: "en-IN",
  6153: "en-IE",
  8201: "en-JM",
  17417: "en-MY",
  5129: "en-NZ",
  13321: "en-PH",
  18441: "en-SG",
  7177: "en-ZA",
  11273: "en-TT",
  2057: "en-GB",
  1033: "en",
  12297: "en-ZW",
  1061: "et",
  1080: "fo",
  1124: "fil",
  1035: "fi",
  2060: "fr-BE",
  3084: "fr-CA",
  1036: "fr",
  5132: "fr-LU",
  6156: "fr-MC",
  4108: "fr-CH",
  1122: "fy",
  1110: "gl",
  1079: "ka",
  3079: "de-AT",
  1031: "de",
  5127: "de-LI",
  4103: "de-LU",
  2055: "de-CH",
  1032: "el",
  1135: "kl",
  1095: "gu",
  1128: "ha",
  1037: "he",
  1081: "hi",
  1038: "hu",
  1039: "is",
  1136: "ig",
  1057: "id",
  1117: "iu",
  2141: "iu-Latn",
  2108: "ga",
  1076: "xh",
  1077: "zu",
  1040: "it",
  2064: "it-CH",
  1041: "ja",
  1099: "kn",
  1087: "kk",
  1107: "km",
  1158: "quc",
  1159: "rw",
  1089: "sw",
  1111: "kok",
  1042: "ko",
  1088: "ky",
  1108: "lo",
  1062: "lv",
  1063: "lt",
  2094: "dsb",
  1134: "lb",
  1071: "mk",
  2110: "ms-BN",
  1086: "ms",
  1100: "ml",
  1082: "mt",
  1153: "mi",
  1146: "arn",
  1102: "mr",
  1148: "moh",
  1104: "mn",
  2128: "mn-CN",
  1121: "ne",
  1044: "nb",
  2068: "nn",
  1154: "oc",
  1096: "or",
  1123: "ps",
  1045: "pl",
  1046: "pt",
  2070: "pt-PT",
  1094: "pa",
  1131: "qu-BO",
  2155: "qu-EC",
  3179: "qu",
  1048: "ro",
  1047: "rm",
  1049: "ru",
  9275: "smn",
  4155: "smj-NO",
  5179: "smj",
  3131: "se-FI",
  1083: "se",
  2107: "se-SE",
  8251: "sms",
  6203: "sma-NO",
  7227: "sms",
  1103: "sa",
  7194: "sr-Cyrl-BA",
  3098: "sr",
  6170: "sr-Latn-BA",
  2074: "sr-Latn",
  1132: "nso",
  1074: "tn",
  1115: "si",
  1051: "sk",
  1060: "sl",
  11274: "es-AR",
  16394: "es-BO",
  13322: "es-CL",
  9226: "es-CO",
  5130: "es-CR",
  7178: "es-DO",
  12298: "es-EC",
  17418: "es-SV",
  4106: "es-GT",
  18442: "es-HN",
  2058: "es-MX",
  19466: "es-NI",
  6154: "es-PA",
  15370: "es-PY",
  10250: "es-PE",
  20490: "es-PR",
  // Microsoft has defined two different language codes for
  // “Spanish with modern sorting” and “Spanish with traditional
  // sorting”. This makes sense for collation APIs, and it would be
  // possible to express this in BCP 47 language tags via Unicode
  // extensions (eg., es-u-co-trad is Spanish with traditional
  // sorting). However, for storing names in fonts, the distinction
  // does not make sense, so we give “es” in both cases.
  3082: "es",
  1034: "es",
  21514: "es-US",
  14346: "es-UY",
  8202: "es-VE",
  2077: "sv-FI",
  1053: "sv",
  1114: "syr",
  1064: "tg",
  2143: "tzm",
  1097: "ta",
  1092: "tt",
  1098: "te",
  1054: "th",
  1105: "bo",
  1055: "tr",
  1090: "tk",
  1152: "ug",
  1058: "uk",
  1070: "hsb",
  1056: "ur",
  2115: "uz-Cyrl",
  1091: "uz",
  1066: "vi",
  1106: "cy",
  1160: "wo",
  1157: "sah",
  1144: "ii",
  1130: "yo"
};
function V_(r, e, t) {
  switch (r) {
    case 0:
      if (e === 65535)
        return "und";
      if (t)
        return t[e];
      break;
    case 1:
      return _T[e];
    case 3:
      return NT[e];
  }
}
var Ly = "utf-16", z_ = {
  0: "macintosh",
  // smRoman
  1: "x-mac-japanese",
  // smJapanese
  2: "x-mac-chinesetrad",
  // smTradChinese
  3: "x-mac-korean",
  // smKorean
  6: "x-mac-greek",
  // smGreek
  7: "x-mac-cyrillic",
  // smCyrillic
  9: "x-mac-devanagai",
  // smDevanagari
  10: "x-mac-gurmukhi",
  // smGurmukhi
  11: "x-mac-gujarati",
  // smGujarati
  12: "x-mac-oriya",
  // smOriya
  13: "x-mac-bengali",
  // smBengali
  14: "x-mac-tamil",
  // smTamil
  15: "x-mac-telugu",
  // smTelugu
  16: "x-mac-kannada",
  // smKannada
  17: "x-mac-malayalam",
  // smMalayalam
  18: "x-mac-sinhalese",
  // smSinhalese
  19: "x-mac-burmese",
  // smBurmese
  20: "x-mac-khmer",
  // smKhmer
  21: "x-mac-thai",
  // smThai
  22: "x-mac-lao",
  // smLao
  23: "x-mac-georgian",
  // smGeorgian
  24: "x-mac-armenian",
  // smArmenian
  25: "x-mac-chinesesimp",
  // smSimpChinese
  26: "x-mac-tibetan",
  // smTibetan
  27: "x-mac-mongolian",
  // smMongolian
  28: "x-mac-ethiopic",
  // smEthiopic
  29: "x-mac-ce",
  // smCentralEuroRoman
  30: "x-mac-vietnamese",
  // smVietnamese
  31: "x-mac-extarabic"
  // smExtArabic
}, $_ = {
  15: "x-mac-icelandic",
  // langIcelandic
  17: "x-mac-turkish",
  // langTurkish
  18: "x-mac-croatian",
  // langCroatian
  24: "x-mac-ce",
  // langLithuanian
  25: "x-mac-ce",
  // langPolish
  26: "x-mac-ce",
  // langHungarian
  27: "x-mac-ce",
  // langEstonian
  28: "x-mac-ce",
  // langLatvian
  30: "x-mac-icelandic",
  // langFaroese
  37: "x-mac-romanian",
  // langRomanian
  38: "x-mac-ce",
  // langCzech
  39: "x-mac-ce",
  // langSlovak
  40: "x-mac-ce",
  // langSlovenian
  143: "x-mac-inuit",
  // langInuktitut
  146: "x-mac-gaelic"
  // langIrishGaelicScript
};
function LT(r, e, t) {
  switch (r) {
    case 0:
      return Ly;
    case 1:
      return $_[t] || z_[e];
    case 3:
      if (e === 1 || e === 10)
        return Ly;
      break;
  }
}
function H_(r, e, t) {
  for (var n = {}, i = new vt.Parser(r, e), a = i.parseUShort(), s = i.parseUShort(), o = i.offset + i.parseUShort(), l = 0; l < s; l++) {
    var u = i.parseUShort(), c = i.parseUShort(), d = i.parseUShort(), f = i.parseUShort(), h = MT[f] || f, g = i.parseUShort(), v = i.parseUShort(), y = V_(u, d, t), A = LT(u, c, d);
    if (A !== void 0 && y !== void 0) {
      var x = void 0;
      if (A === Ly ? x = Wu.UTF16(r, o + v, g) : x = Wu.MACSTRING(r, o + v, g, A), x) {
        var k = n[h];
        k === void 0 && (k = n[h] = {}), k[y] = x;
      }
    }
  }
  return a === 1 && i.parseUShort(), n;
}
function p0(r) {
  var e = {};
  for (var t in r)
    e[r[t]] = parseInt(t);
  return e;
}
function Wx(r, e, t, n, i, a) {
  return new ct.Record("NameRecord", [
    { name: "platformID", type: "USHORT", value: r },
    { name: "encodingID", type: "USHORT", value: e },
    { name: "languageID", type: "USHORT", value: t },
    { name: "nameID", type: "USHORT", value: n },
    { name: "length", type: "USHORT", value: i },
    { name: "offset", type: "USHORT", value: a }
  ]);
}
function j_(r, e) {
  var t = r.length, n = e.length - t + 1;
  e:
    for (var i = 0; i < n; i++)
      for (; i < n; i++) {
        for (var a = 0; a < t; a++)
          if (e[i + a] !== r[a])
            continue e;
        return i;
      }
  return -1;
}
function Qx(r, e) {
  var t = j_(r, e);
  if (t < 0) {
    t = e.length;
    for (var n = 0, i = r.length; n < i; ++n)
      e.push(r[n]);
  }
  return t;
}
function G_(r, e) {
  var t, n = [], i = {}, a = p0(MT);
  for (var s in r) {
    var o = a[s];
    if (o === void 0 && (o = s), t = parseInt(o), isNaN(t))
      throw new Error('Name table entry "' + s + '" does not exist, see nameTableNames for complete list.');
    i[t] = r[s], n.push(t);
  }
  for (var l = p0(_T), u = p0(NT), c = [], d = [], f = 0; f < n.length; f++) {
    t = n[f];
    var h = i[t];
    for (var g in h) {
      var v = h[g], y = 1, A = l[g], x = U_[A], k = LT(y, x, A), F = it.MACSTRING(v, k);
      F === void 0 && (y = 0, A = e.indexOf(g), A < 0 && (A = e.length, e.push(g)), x = 4, F = it.UTF16(v));
      var S = Qx(F, d);
      c.push(Wx(
        y,
        x,
        A,
        t,
        F.length,
        S
      ));
      var R = u[g];
      if (R !== void 0) {
        var M = it.UTF16(v), j = Qx(M, d);
        c.push(Wx(
          3,
          1,
          R,
          t,
          M.length,
          j
        ));
      }
    }
  }
  c.sort(function(q, Y) {
    return q.platformID - Y.platformID || q.encodingID - Y.encodingID || q.languageID - Y.languageID || q.nameID - Y.nameID;
  });
  for (var G = new ct.Table("name", [
    { name: "format", type: "USHORT", value: 0 },
    { name: "count", type: "USHORT", value: c.length },
    { name: "stringOffset", type: "USHORT", value: 6 + c.length * 12 }
  ]), ie = 0; ie < c.length; ie++)
    G.fields.push({ name: "record_" + ie, type: "RECORD", value: c[ie] });
  return G.fields.push({ name: "strings", type: "LITERAL", value: d }), G;
}
var UT = { parse: H_, make: G_ }, Uy = [
  { begin: 0, end: 127 },
  // Basic Latin
  { begin: 128, end: 255 },
  // Latin-1 Supplement
  { begin: 256, end: 383 },
  // Latin Extended-A
  { begin: 384, end: 591 },
  // Latin Extended-B
  { begin: 592, end: 687 },
  // IPA Extensions
  { begin: 688, end: 767 },
  // Spacing Modifier Letters
  { begin: 768, end: 879 },
  // Combining Diacritical Marks
  { begin: 880, end: 1023 },
  // Greek and Coptic
  { begin: 11392, end: 11519 },
  // Coptic
  { begin: 1024, end: 1279 },
  // Cyrillic
  { begin: 1328, end: 1423 },
  // Armenian
  { begin: 1424, end: 1535 },
  // Hebrew
  { begin: 42240, end: 42559 },
  // Vai
  { begin: 1536, end: 1791 },
  // Arabic
  { begin: 1984, end: 2047 },
  // NKo
  { begin: 2304, end: 2431 },
  // Devanagari
  { begin: 2432, end: 2559 },
  // Bengali
  { begin: 2560, end: 2687 },
  // Gurmukhi
  { begin: 2688, end: 2815 },
  // Gujarati
  { begin: 2816, end: 2943 },
  // Oriya
  { begin: 2944, end: 3071 },
  // Tamil
  { begin: 3072, end: 3199 },
  // Telugu
  { begin: 3200, end: 3327 },
  // Kannada
  { begin: 3328, end: 3455 },
  // Malayalam
  { begin: 3584, end: 3711 },
  // Thai
  { begin: 3712, end: 3839 },
  // Lao
  { begin: 4256, end: 4351 },
  // Georgian
  { begin: 6912, end: 7039 },
  // Balinese
  { begin: 4352, end: 4607 },
  // Hangul Jamo
  { begin: 7680, end: 7935 },
  // Latin Extended Additional
  { begin: 7936, end: 8191 },
  // Greek Extended
  { begin: 8192, end: 8303 },
  // General Punctuation
  { begin: 8304, end: 8351 },
  // Superscripts And Subscripts
  { begin: 8352, end: 8399 },
  // Currency Symbol
  { begin: 8400, end: 8447 },
  // Combining Diacritical Marks For Symbols
  { begin: 8448, end: 8527 },
  // Letterlike Symbols
  { begin: 8528, end: 8591 },
  // Number Forms
  { begin: 8592, end: 8703 },
  // Arrows
  { begin: 8704, end: 8959 },
  // Mathematical Operators
  { begin: 8960, end: 9215 },
  // Miscellaneous Technical
  { begin: 9216, end: 9279 },
  // Control Pictures
  { begin: 9280, end: 9311 },
  // Optical Character Recognition
  { begin: 9312, end: 9471 },
  // Enclosed Alphanumerics
  { begin: 9472, end: 9599 },
  // Box Drawing
  { begin: 9600, end: 9631 },
  // Block Elements
  { begin: 9632, end: 9727 },
  // Geometric Shapes
  { begin: 9728, end: 9983 },
  // Miscellaneous Symbols
  { begin: 9984, end: 10175 },
  // Dingbats
  { begin: 12288, end: 12351 },
  // CJK Symbols And Punctuation
  { begin: 12352, end: 12447 },
  // Hiragana
  { begin: 12448, end: 12543 },
  // Katakana
  { begin: 12544, end: 12591 },
  // Bopomofo
  { begin: 12592, end: 12687 },
  // Hangul Compatibility Jamo
  { begin: 43072, end: 43135 },
  // Phags-pa
  { begin: 12800, end: 13055 },
  // Enclosed CJK Letters And Months
  { begin: 13056, end: 13311 },
  // CJK Compatibility
  { begin: 44032, end: 55215 },
  // Hangul Syllables
  { begin: 55296, end: 57343 },
  // Non-Plane 0 *
  { begin: 67840, end: 67871 },
  // Phoenicia
  { begin: 19968, end: 40959 },
  // CJK Unified Ideographs
  { begin: 57344, end: 63743 },
  // Private Use Area (plane 0)
  { begin: 12736, end: 12783 },
  // CJK Strokes
  { begin: 64256, end: 64335 },
  // Alphabetic Presentation Forms
  { begin: 64336, end: 65023 },
  // Arabic Presentation Forms-A
  { begin: 65056, end: 65071 },
  // Combining Half Marks
  { begin: 65040, end: 65055 },
  // Vertical Forms
  { begin: 65104, end: 65135 },
  // Small Form Variants
  { begin: 65136, end: 65279 },
  // Arabic Presentation Forms-B
  { begin: 65280, end: 65519 },
  // Halfwidth And Fullwidth Forms
  { begin: 65520, end: 65535 },
  // Specials
  { begin: 3840, end: 4095 },
  // Tibetan
  { begin: 1792, end: 1871 },
  // Syriac
  { begin: 1920, end: 1983 },
  // Thaana
  { begin: 3456, end: 3583 },
  // Sinhala
  { begin: 4096, end: 4255 },
  // Myanmar
  { begin: 4608, end: 4991 },
  // Ethiopic
  { begin: 5024, end: 5119 },
  // Cherokee
  { begin: 5120, end: 5759 },
  // Unified Canadian Aboriginal Syllabics
  { begin: 5760, end: 5791 },
  // Ogham
  { begin: 5792, end: 5887 },
  // Runic
  { begin: 6016, end: 6143 },
  // Khmer
  { begin: 6144, end: 6319 },
  // Mongolian
  { begin: 10240, end: 10495 },
  // Braille Patterns
  { begin: 40960, end: 42127 },
  // Yi Syllables
  { begin: 5888, end: 5919 },
  // Tagalog
  { begin: 66304, end: 66351 },
  // Old Italic
  { begin: 66352, end: 66383 },
  // Gothic
  { begin: 66560, end: 66639 },
  // Deseret
  { begin: 118784, end: 119039 },
  // Byzantine Musical Symbols
  { begin: 119808, end: 120831 },
  // Mathematical Alphanumeric Symbols
  { begin: 1044480, end: 1048573 },
  // Private Use (plane 15)
  { begin: 65024, end: 65039 },
  // Variation Selectors
  { begin: 917504, end: 917631 },
  // Tags
  { begin: 6400, end: 6479 },
  // Limbu
  { begin: 6480, end: 6527 },
  // Tai Le
  { begin: 6528, end: 6623 },
  // New Tai Lue
  { begin: 6656, end: 6687 },
  // Buginese
  { begin: 11264, end: 11359 },
  // Glagolitic
  { begin: 11568, end: 11647 },
  // Tifinagh
  { begin: 19904, end: 19967 },
  // Yijing Hexagram Symbols
  { begin: 43008, end: 43055 },
  // Syloti Nagri
  { begin: 65536, end: 65663 },
  // Linear B Syllabary
  { begin: 65856, end: 65935 },
  // Ancient Greek Numbers
  { begin: 66432, end: 66463 },
  // Ugaritic
  { begin: 66464, end: 66527 },
  // Old Persian
  { begin: 66640, end: 66687 },
  // Shavian
  { begin: 66688, end: 66735 },
  // Osmanya
  { begin: 67584, end: 67647 },
  // Cypriot Syllabary
  { begin: 68096, end: 68191 },
  // Kharoshthi
  { begin: 119552, end: 119647 },
  // Tai Xuan Jing Symbols
  { begin: 73728, end: 74751 },
  // Cuneiform
  { begin: 119648, end: 119679 },
  // Counting Rod Numerals
  { begin: 7040, end: 7103 },
  // Sundanese
  { begin: 7168, end: 7247 },
  // Lepcha
  { begin: 7248, end: 7295 },
  // Ol Chiki
  { begin: 43136, end: 43231 },
  // Saurashtra
  { begin: 43264, end: 43311 },
  // Kayah Li
  { begin: 43312, end: 43359 },
  // Rejang
  { begin: 43520, end: 43615 },
  // Cham
  { begin: 65936, end: 65999 },
  // Ancient Symbols
  { begin: 66e3, end: 66047 },
  // Phaistos Disc
  { begin: 66208, end: 66271 },
  // Carian
  { begin: 127024, end: 127135 }
  // Domino Tiles
];
function q_(r) {
  for (var e = 0; e < Uy.length; e += 1) {
    var t = Uy[e];
    if (r >= t.begin && r < t.end)
      return e;
  }
  return -1;
}
function W_(r, e) {
  var t = {}, n = new vt.Parser(r, e);
  t.version = n.parseUShort(), t.xAvgCharWidth = n.parseShort(), t.usWeightClass = n.parseUShort(), t.usWidthClass = n.parseUShort(), t.fsType = n.parseUShort(), t.ySubscriptXSize = n.parseShort(), t.ySubscriptYSize = n.parseShort(), t.ySubscriptXOffset = n.parseShort(), t.ySubscriptYOffset = n.parseShort(), t.ySuperscriptXSize = n.parseShort(), t.ySuperscriptYSize = n.parseShort(), t.ySuperscriptXOffset = n.parseShort(), t.ySuperscriptYOffset = n.parseShort(), t.yStrikeoutSize = n.parseShort(), t.yStrikeoutPosition = n.parseShort(), t.sFamilyClass = n.parseShort(), t.panose = [];
  for (var i = 0; i < 10; i++)
    t.panose[i] = n.parseByte();
  return t.ulUnicodeRange1 = n.parseULong(), t.ulUnicodeRange2 = n.parseULong(), t.ulUnicodeRange3 = n.parseULong(), t.ulUnicodeRange4 = n.parseULong(), t.achVendID = String.fromCharCode(n.parseByte(), n.parseByte(), n.parseByte(), n.parseByte()), t.fsSelection = n.parseUShort(), t.usFirstCharIndex = n.parseUShort(), t.usLastCharIndex = n.parseUShort(), t.sTypoAscender = n.parseShort(), t.sTypoDescender = n.parseShort(), t.sTypoLineGap = n.parseShort(), t.usWinAscent = n.parseUShort(), t.usWinDescent = n.parseUShort(), t.version >= 1 && (t.ulCodePageRange1 = n.parseULong(), t.ulCodePageRange2 = n.parseULong()), t.version >= 2 && (t.sxHeight = n.parseShort(), t.sCapHeight = n.parseShort(), t.usDefaultChar = n.parseUShort(), t.usBreakChar = n.parseUShort(), t.usMaxContent = n.parseUShort()), t;
}
function Q_(r) {
  return new ct.Table("OS/2", [
    { name: "version", type: "USHORT", value: 3 },
    { name: "xAvgCharWidth", type: "SHORT", value: 0 },
    { name: "usWeightClass", type: "USHORT", value: 0 },
    { name: "usWidthClass", type: "USHORT", value: 0 },
    { name: "fsType", type: "USHORT", value: 0 },
    { name: "ySubscriptXSize", type: "SHORT", value: 650 },
    { name: "ySubscriptYSize", type: "SHORT", value: 699 },
    { name: "ySubscriptXOffset", type: "SHORT", value: 0 },
    { name: "ySubscriptYOffset", type: "SHORT", value: 140 },
    { name: "ySuperscriptXSize", type: "SHORT", value: 650 },
    { name: "ySuperscriptYSize", type: "SHORT", value: 699 },
    { name: "ySuperscriptXOffset", type: "SHORT", value: 0 },
    { name: "ySuperscriptYOffset", type: "SHORT", value: 479 },
    { name: "yStrikeoutSize", type: "SHORT", value: 49 },
    { name: "yStrikeoutPosition", type: "SHORT", value: 258 },
    { name: "sFamilyClass", type: "SHORT", value: 0 },
    { name: "bFamilyType", type: "BYTE", value: 0 },
    { name: "bSerifStyle", type: "BYTE", value: 0 },
    { name: "bWeight", type: "BYTE", value: 0 },
    { name: "bProportion", type: "BYTE", value: 0 },
    { name: "bContrast", type: "BYTE", value: 0 },
    { name: "bStrokeVariation", type: "BYTE", value: 0 },
    { name: "bArmStyle", type: "BYTE", value: 0 },
    { name: "bLetterform", type: "BYTE", value: 0 },
    { name: "bMidline", type: "BYTE", value: 0 },
    { name: "bXHeight", type: "BYTE", value: 0 },
    { name: "ulUnicodeRange1", type: "ULONG", value: 0 },
    { name: "ulUnicodeRange2", type: "ULONG", value: 0 },
    { name: "ulUnicodeRange3", type: "ULONG", value: 0 },
    { name: "ulUnicodeRange4", type: "ULONG", value: 0 },
    { name: "achVendID", type: "CHARARRAY", value: "XXXX" },
    { name: "fsSelection", type: "USHORT", value: 0 },
    { name: "usFirstCharIndex", type: "USHORT", value: 0 },
    { name: "usLastCharIndex", type: "USHORT", value: 0 },
    { name: "sTypoAscender", type: "SHORT", value: 0 },
    { name: "sTypoDescender", type: "SHORT", value: 0 },
    { name: "sTypoLineGap", type: "SHORT", value: 0 },
    { name: "usWinAscent", type: "USHORT", value: 0 },
    { name: "usWinDescent", type: "USHORT", value: 0 },
    { name: "ulCodePageRange1", type: "ULONG", value: 0 },
    { name: "ulCodePageRange2", type: "ULONG", value: 0 },
    { name: "sxHeight", type: "SHORT", value: 0 },
    { name: "sCapHeight", type: "SHORT", value: 0 },
    { name: "usDefaultChar", type: "USHORT", value: 0 },
    { name: "usBreakChar", type: "USHORT", value: 0 },
    { name: "usMaxContext", type: "USHORT", value: 0 }
  ], r);
}
var Vy = { parse: W_, make: Q_, unicodeRanges: Uy, getUnicodeRange: q_ };
function Y_(r, e) {
  var t = {}, n = new vt.Parser(r, e);
  switch (t.version = n.parseVersion(), t.italicAngle = n.parseFixed(), t.underlinePosition = n.parseShort(), t.underlineThickness = n.parseShort(), t.isFixedPitch = n.parseULong(), t.minMemType42 = n.parseULong(), t.maxMemType42 = n.parseULong(), t.minMemType1 = n.parseULong(), t.maxMemType1 = n.parseULong(), t.version) {
    case 1:
      t.names = fl.slice();
      break;
    case 2:
      t.numberOfGlyphs = n.parseUShort(), t.glyphNameIndex = new Array(t.numberOfGlyphs);
      for (var i = 0; i < t.numberOfGlyphs; i++)
        t.glyphNameIndex[i] = n.parseUShort();
      t.names = [];
      for (var a = 0; a < t.numberOfGlyphs; a++)
        if (t.glyphNameIndex[a] >= fl.length) {
          var s = n.parseChar();
          t.names.push(n.parseString(s));
        }
      break;
    case 2.5:
      t.numberOfGlyphs = n.parseUShort(), t.offset = new Array(t.numberOfGlyphs);
      for (var o = 0; o < t.numberOfGlyphs; o++)
        t.offset[o] = n.parseChar();
      break;
  }
  return t;
}
function X_() {
  return new ct.Table("post", [
    { name: "version", type: "FIXED", value: 196608 },
    { name: "italicAngle", type: "FIXED", value: 0 },
    { name: "underlinePosition", type: "FWORD", value: 0 },
    { name: "underlineThickness", type: "FWORD", value: 0 },
    { name: "isFixedPitch", type: "ULONG", value: 0 },
    { name: "minMemType42", type: "ULONG", value: 0 },
    { name: "maxMemType42", type: "ULONG", value: 0 },
    { name: "minMemType1", type: "ULONG", value: 0 },
    { name: "maxMemType1", type: "ULONG", value: 0 }
  ]);
}
var VT = { parse: Y_, make: X_ }, Ia = new Array(9);
Ia[1] = function() {
  var e = this.offset + this.relativeOffset, t = this.parseUShort();
  if (t === 1)
    return {
      substFormat: 1,
      coverage: this.parsePointer(we.coverage),
      deltaGlyphId: this.parseUShort()
    };
  if (t === 2)
    return {
      substFormat: 2,
      coverage: this.parsePointer(we.coverage),
      substitute: this.parseOffset16List()
    };
  jt.assert(!1, "0x" + e.toString(16) + ": lookup type 1 format must be 1 or 2.");
};
Ia[2] = function() {
  var e = this.parseUShort();
  return jt.argument(e === 1, "GSUB Multiple Substitution Subtable identifier-format must be 1"), {
    substFormat: e,
    coverage: this.parsePointer(we.coverage),
    sequences: this.parseListOfLists()
  };
};
Ia[3] = function() {
  var e = this.parseUShort();
  return jt.argument(e === 1, "GSUB Alternate Substitution Subtable identifier-format must be 1"), {
    substFormat: e,
    coverage: this.parsePointer(we.coverage),
    alternateSets: this.parseListOfLists()
  };
};
Ia[4] = function() {
  var e = this.parseUShort();
  return jt.argument(e === 1, "GSUB ligature table identifier-format must be 1"), {
    substFormat: e,
    coverage: this.parsePointer(we.coverage),
    ligatureSets: this.parseListOfLists(function() {
      return {
        ligGlyph: this.parseUShort(),
        components: this.parseUShortList(this.parseUShort() - 1)
      };
    })
  };
};
var Mu = {
  sequenceIndex: we.uShort,
  lookupListIndex: we.uShort
};
Ia[5] = function() {
  var e = this.offset + this.relativeOffset, t = this.parseUShort();
  if (t === 1)
    return {
      substFormat: t,
      coverage: this.parsePointer(we.coverage),
      ruleSets: this.parseListOfLists(function() {
        var a = this.parseUShort(), s = this.parseUShort();
        return {
          input: this.parseUShortList(a - 1),
          lookupRecords: this.parseRecordList(s, Mu)
        };
      })
    };
  if (t === 2)
    return {
      substFormat: t,
      coverage: this.parsePointer(we.coverage),
      classDef: this.parsePointer(we.classDef),
      classSets: this.parseListOfLists(function() {
        var a = this.parseUShort(), s = this.parseUShort();
        return {
          classes: this.parseUShortList(a - 1),
          lookupRecords: this.parseRecordList(s, Mu)
        };
      })
    };
  if (t === 3) {
    var n = this.parseUShort(), i = this.parseUShort();
    return {
      substFormat: t,
      coverages: this.parseList(n, we.pointer(we.coverage)),
      lookupRecords: this.parseRecordList(i, Mu)
    };
  }
  jt.assert(!1, "0x" + e.toString(16) + ": lookup type 5 format must be 1, 2 or 3.");
};
Ia[6] = function() {
  var e = this.offset + this.relativeOffset, t = this.parseUShort();
  if (t === 1)
    return {
      substFormat: 1,
      coverage: this.parsePointer(we.coverage),
      chainRuleSets: this.parseListOfLists(function() {
        return {
          backtrack: this.parseUShortList(),
          input: this.parseUShortList(this.parseShort() - 1),
          lookahead: this.parseUShortList(),
          lookupRecords: this.parseRecordList(Mu)
        };
      })
    };
  if (t === 2)
    return {
      substFormat: 2,
      coverage: this.parsePointer(we.coverage),
      backtrackClassDef: this.parsePointer(we.classDef),
      inputClassDef: this.parsePointer(we.classDef),
      lookaheadClassDef: this.parsePointer(we.classDef),
      chainClassSet: this.parseListOfLists(function() {
        return {
          backtrack: this.parseUShortList(),
          input: this.parseUShortList(this.parseShort() - 1),
          lookahead: this.parseUShortList(),
          lookupRecords: this.parseRecordList(Mu)
        };
      })
    };
  if (t === 3)
    return {
      substFormat: 3,
      backtrackCoverage: this.parseList(we.pointer(we.coverage)),
      inputCoverage: this.parseList(we.pointer(we.coverage)),
      lookaheadCoverage: this.parseList(we.pointer(we.coverage)),
      lookupRecords: this.parseRecordList(Mu)
    };
  jt.assert(!1, "0x" + e.toString(16) + ": lookup type 6 format must be 1, 2 or 3.");
};
Ia[7] = function() {
  var e = this.parseUShort();
  jt.argument(e === 1, "GSUB Extension Substitution subtable identifier-format must be 1");
  var t = this.parseUShort(), n = new we(this.data, this.offset + this.parseULong());
  return {
    substFormat: 1,
    lookupType: t,
    extension: Ia[t].call(n)
  };
};
Ia[8] = function() {
  var e = this.parseUShort();
  return jt.argument(e === 1, "GSUB Reverse Chaining Contextual Single Substitution Subtable identifier-format must be 1"), {
    substFormat: e,
    coverage: this.parsePointer(we.coverage),
    backtrackCoverage: this.parseList(we.pointer(we.coverage)),
    lookaheadCoverage: this.parseList(we.pointer(we.coverage)),
    substitutes: this.parseUShortList()
  };
};
function J_(r, e) {
  e = e || 0;
  var t = new we(r, e), n = t.parseVersion(1);
  return jt.argument(n === 1 || n === 1.1, "Unsupported GSUB table version."), n === 1 ? {
    version: n,
    scripts: t.parseScriptList(),
    features: t.parseFeatureList(),
    lookups: t.parseLookupList(Ia)
  } : {
    version: n,
    scripts: t.parseScriptList(),
    features: t.parseFeatureList(),
    lookups: t.parseLookupList(Ia),
    variations: t.parseFeatureVariationsList()
  };
}
var oc = new Array(9);
oc[1] = function(e) {
  return e.substFormat === 1 ? new ct.Table("substitutionTable", [
    { name: "substFormat", type: "USHORT", value: 1 },
    { name: "coverage", type: "TABLE", value: new ct.Coverage(e.coverage) },
    { name: "deltaGlyphID", type: "USHORT", value: e.deltaGlyphId }
  ]) : new ct.Table("substitutionTable", [
    { name: "substFormat", type: "USHORT", value: 2 },
    { name: "coverage", type: "TABLE", value: new ct.Coverage(e.coverage) }
  ].concat(ct.ushortList("substitute", e.substitute)));
};
oc[2] = function(e) {
  return jt.assert(e.substFormat === 1, "Lookup type 2 substFormat must be 1."), new ct.Table("substitutionTable", [
    { name: "substFormat", type: "USHORT", value: 1 },
    { name: "coverage", type: "TABLE", value: new ct.Coverage(e.coverage) }
  ].concat(ct.tableList("seqSet", e.sequences, function(t) {
    return new ct.Table("sequenceSetTable", ct.ushortList("sequence", t));
  })));
};
oc[3] = function(e) {
  return jt.assert(e.substFormat === 1, "Lookup type 3 substFormat must be 1."), new ct.Table("substitutionTable", [
    { name: "substFormat", type: "USHORT", value: 1 },
    { name: "coverage", type: "TABLE", value: new ct.Coverage(e.coverage) }
  ].concat(ct.tableList("altSet", e.alternateSets, function(t) {
    return new ct.Table("alternateSetTable", ct.ushortList("alternate", t));
  })));
};
oc[4] = function(e) {
  return jt.assert(e.substFormat === 1, "Lookup type 4 substFormat must be 1."), new ct.Table("substitutionTable", [
    { name: "substFormat", type: "USHORT", value: 1 },
    { name: "coverage", type: "TABLE", value: new ct.Coverage(e.coverage) }
  ].concat(ct.tableList("ligSet", e.ligatureSets, function(t) {
    return new ct.Table("ligatureSetTable", ct.tableList("ligature", t, function(n) {
      return new ct.Table(
        "ligatureTable",
        [{ name: "ligGlyph", type: "USHORT", value: n.ligGlyph }].concat(ct.ushortList("component", n.components, n.components.length + 1))
      );
    }));
  })));
};
oc[6] = function(e) {
  if (e.substFormat === 1) {
    var t = new ct.Table("chainContextTable", [
      { name: "substFormat", type: "USHORT", value: e.substFormat },
      { name: "coverage", type: "TABLE", value: new ct.Coverage(e.coverage) }
    ].concat(ct.tableList("chainRuleSet", e.chainRuleSets, function(a) {
      return new ct.Table("chainRuleSetTable", ct.tableList("chainRule", a, function(s) {
        var o = ct.ushortList("backtrackGlyph", s.backtrack, s.backtrack.length).concat(ct.ushortList("inputGlyph", s.input, s.input.length + 1)).concat(ct.ushortList("lookaheadGlyph", s.lookahead, s.lookahead.length)).concat(ct.ushortList("substitution", [], s.lookupRecords.length));
        return s.lookupRecords.forEach(function(l, u) {
          o = o.concat({ name: "sequenceIndex" + u, type: "USHORT", value: l.sequenceIndex }).concat({ name: "lookupListIndex" + u, type: "USHORT", value: l.lookupListIndex });
        }), new ct.Table("chainRuleTable", o);
      }));
    })));
    return t;
  } else if (e.substFormat === 2)
    jt.assert(!1, "lookup type 6 format 2 is not yet supported.");
  else if (e.substFormat === 3) {
    var n = [
      { name: "substFormat", type: "USHORT", value: e.substFormat }
    ];
    n.push({ name: "backtrackGlyphCount", type: "USHORT", value: e.backtrackCoverage.length }), e.backtrackCoverage.forEach(function(a, s) {
      n.push({ name: "backtrackCoverage" + s, type: "TABLE", value: new ct.Coverage(a) });
    }), n.push({ name: "inputGlyphCount", type: "USHORT", value: e.inputCoverage.length }), e.inputCoverage.forEach(function(a, s) {
      n.push({ name: "inputCoverage" + s, type: "TABLE", value: new ct.Coverage(a) });
    }), n.push({ name: "lookaheadGlyphCount", type: "USHORT", value: e.lookaheadCoverage.length }), e.lookaheadCoverage.forEach(function(a, s) {
      n.push({ name: "lookaheadCoverage" + s, type: "TABLE", value: new ct.Coverage(a) });
    }), n.push({ name: "substitutionCount", type: "USHORT", value: e.lookupRecords.length }), e.lookupRecords.forEach(function(a, s) {
      n = n.concat({ name: "sequenceIndex" + s, type: "USHORT", value: a.sequenceIndex }).concat({ name: "lookupListIndex" + s, type: "USHORT", value: a.lookupListIndex });
    });
    var i = new ct.Table("chainContextTable", n);
    return i;
  }
  jt.assert(!1, "lookup type 6 format must be 1, 2 or 3.");
};
function K_(r) {
  return new ct.Table("GSUB", [
    { name: "version", type: "ULONG", value: 65536 },
    { name: "scripts", type: "TABLE", value: new ct.ScriptList(r.scripts) },
    { name: "features", type: "TABLE", value: new ct.FeatureList(r.features) },
    { name: "lookups", type: "TABLE", value: new ct.LookupList(r.lookups, oc) }
  ]);
}
var zT = { parse: J_, make: K_ };
function Z_(r, e) {
  var t = new vt.Parser(r, e), n = t.parseULong();
  jt.argument(n === 1, "Unsupported META table version."), t.parseULong(), t.parseULong();
  for (var i = t.parseULong(), a = {}, s = 0; s < i; s++) {
    var o = t.parseTag(), l = t.parseULong(), u = t.parseULong(), c = Wu.UTF8(r, e + l, u);
    a[o] = c;
  }
  return a;
}
function e5(r) {
  var e = Object.keys(r).length, t = "", n = 16 + e * 12, i = new ct.Table("meta", [
    { name: "version", type: "ULONG", value: 1 },
    { name: "flags", type: "ULONG", value: 0 },
    { name: "offset", type: "ULONG", value: n },
    { name: "numTags", type: "ULONG", value: e }
  ]);
  for (var a in r) {
    var s = t.length;
    t += r[a], i.fields.push({ name: "tag " + a, type: "TAG", value: a }), i.fields.push({ name: "offset " + a, type: "ULONG", value: n + s }), i.fields.push({ name: "length " + a, type: "ULONG", value: r[a].length });
  }
  return i.fields.push({ name: "stringPool", type: "CHARARRAY", value: t }), i;
}
var $T = { parse: Z_, make: e5 };
function Yx(r) {
  return Math.log(r) / Math.log(2) | 0;
}
function n1(r) {
  for (; r.length % 4 !== 0; )
    r.push(0);
  for (var e = 0, t = 0; t < r.length; t += 4)
    e += (r[t] << 24) + (r[t + 1] << 16) + (r[t + 2] << 8) + r[t + 3];
  return e %= Math.pow(2, 32), e;
}
function Xx(r, e, t, n) {
  return new ct.Record("Table Record", [
    { name: "tag", type: "TAG", value: r !== void 0 ? r : "" },
    { name: "checkSum", type: "ULONG", value: e !== void 0 ? e : 0 },
    { name: "offset", type: "ULONG", value: t !== void 0 ? t : 0 },
    { name: "length", type: "ULONG", value: n !== void 0 ? n : 0 }
  ]);
}
function HT(r) {
  var e = new ct.Table("sfnt", [
    { name: "version", type: "TAG", value: "OTTO" },
    { name: "numTables", type: "USHORT", value: 0 },
    { name: "searchRange", type: "USHORT", value: 0 },
    { name: "entrySelector", type: "USHORT", value: 0 },
    { name: "rangeShift", type: "USHORT", value: 0 }
  ]);
  e.tables = r, e.numTables = r.length;
  var t = Math.pow(2, Yx(e.numTables));
  e.searchRange = 16 * t, e.entrySelector = Yx(t), e.rangeShift = e.numTables * 16 - e.searchRange;
  for (var n = [], i = [], a = e.sizeOf() + Xx().sizeOf() * e.numTables; a % 4 !== 0; )
    a += 1, i.push({ name: "padding", type: "BYTE", value: 0 });
  for (var s = 0; s < r.length; s += 1) {
    var o = r[s];
    jt.argument(o.tableName.length === 4, "Table name" + o.tableName + " is invalid.");
    var l = o.sizeOf(), u = Xx(o.tableName, n1(o.encode()), a, l);
    for (n.push({ name: u.tag + " Table Record", type: "RECORD", value: u }), i.push({ name: o.tableName + " table", type: "RECORD", value: o }), a += l, jt.argument(!isNaN(a), "Something went wrong calculating the offset."); a % 4 !== 0; )
      a += 1, i.push({ name: "padding", type: "BYTE", value: 0 });
  }
  return n.sort(function(c, d) {
    return c.value.tag > d.value.tag ? 1 : -1;
  }), e.fields = e.fields.concat(n), e.fields = e.fields.concat(i), e;
}
function Jx(r, e, t) {
  for (var n = 0; n < e.length; n += 1) {
    var i = r.charToGlyphIndex(e[n]);
    if (i > 0) {
      var a = r.glyphs.get(i);
      return a.getMetrics();
    }
  }
  return t;
}
function t5(r) {
  for (var e = 0, t = 0; t < r.length; t += 1)
    e += r[t];
  return e / r.length;
}
function r5(r) {
  for (var e = [], t = [], n = [], i = [], a = [], s = [], o = [], l, u = 0, c = 0, d = 0, f = 0, h = 0, g = 0; g < r.glyphs.length; g += 1) {
    var v = r.glyphs.get(g), y = v.unicode | 0;
    if (isNaN(v.advanceWidth))
      throw new Error("Glyph " + v.name + " (" + g + "): advanceWidth is not a number.");
    (l > y || l === void 0) && y > 0 && (l = y), u < y && (u = y);
    var A = Vy.getUnicodeRange(y);
    if (A < 32)
      c |= 1 << A;
    else if (A < 64)
      d |= 1 << A - 32;
    else if (A < 96)
      f |= 1 << A - 64;
    else if (A < 123)
      h |= 1 << A - 96;
    else
      throw new Error("Unicode ranges bits > 123 are reserved for internal usage");
    if (v.name !== ".notdef") {
      var x = v.getMetrics();
      e.push(x.xMin), t.push(x.yMin), n.push(x.xMax), i.push(x.yMax), s.push(x.leftSideBearing), o.push(x.rightSideBearing), a.push(v.advanceWidth);
    }
  }
  var k = {
    xMin: Math.min.apply(null, e),
    yMin: Math.min.apply(null, t),
    xMax: Math.max.apply(null, n),
    yMax: Math.max.apply(null, i),
    advanceWidthMax: Math.max.apply(null, a),
    advanceWidthAvg: t5(a),
    minLeftSideBearing: Math.min.apply(null, s),
    maxLeftSideBearing: Math.max.apply(null, s),
    minRightSideBearing: Math.min.apply(null, o)
  };
  k.ascender = r.ascender, k.descender = r.descender;
  var F = DT.make({
    flags: 3,
    // 00000011 (baseline for font at y=0; left sidebearing point at x=0)
    unitsPerEm: r.unitsPerEm,
    xMin: k.xMin,
    yMin: k.yMin,
    xMax: k.xMax,
    yMax: k.yMax,
    lowestRecPPEM: 3,
    createdTimestamp: r.createdTimestamp
  }), S = PT.make({
    ascender: k.ascender,
    descender: k.descender,
    advanceWidthMax: k.advanceWidthMax,
    minLeftSideBearing: k.minLeftSideBearing,
    minRightSideBearing: k.minRightSideBearing,
    xMaxExtent: k.maxLeftSideBearing + (k.xMax - k.xMin),
    numberOfHMetrics: r.glyphs.length
  }), R = BT.make(r.glyphs.length), M = Vy.make(Object.assign({
    xAvgCharWidth: Math.round(k.advanceWidthAvg),
    usFirstCharIndex: l,
    usLastCharIndex: u,
    ulUnicodeRange1: c,
    ulUnicodeRange2: d,
    ulUnicodeRange3: f,
    ulUnicodeRange4: h,
    // See http://typophile.com/node/13081 for more info on vertical metrics.
    // We get metrics for typical characters (such as "x" for xHeight).
    // We provide some fallback characters if characters are unavailable: their
    // ordering was chosen experimentally.
    sTypoAscender: k.ascender,
    sTypoDescender: k.descender,
    sTypoLineGap: 0,
    usWinAscent: k.yMax,
    usWinDescent: Math.abs(k.yMin),
    ulCodePageRange1: 1,
    // FIXME: hard-code Latin 1 support for now
    sxHeight: Jx(r, "xyvw", { yMax: Math.round(k.ascender / 2) }).yMax,
    sCapHeight: Jx(r, "HIKLEFJMNTZBDPRAGOQSUVWXY", k).yMax,
    usDefaultChar: r.hasChar(" ") ? 32 : 0,
    // Use space as the default character, if available.
    usBreakChar: r.hasChar(" ") ? 32 : 0
    // Use space as the break character, if available.
  }, r.tables.os2)), j = RT.make(r.glyphs), G = yT.make(r.glyphs), ie = r.getEnglishName("fontFamily"), q = r.getEnglishName("fontSubfamily"), Y = ie + " " + q, J = r.getEnglishName("postScriptName");
  J || (J = ie.replace(/\s/g, "") + "-" + q);
  var se = {};
  for (var oe in r.names)
    se[oe] = r.names[oe];
  se.uniqueID || (se.uniqueID = { en: r.getEnglishName("manufacturer") + ":" + Y }), se.postScriptName || (se.postScriptName = { en: J }), se.preferredFamily || (se.preferredFamily = r.names.fontFamily), se.preferredSubfamily || (se.preferredSubfamily = r.names.fontSubfamily);
  var he = [], ye = UT.make(se, he), Ue = he.length > 0 ? OT.make(he) : void 0, Re = VT.make(), Oe = IT.make(r.glyphs, {
    version: r.getEnglishName("version"),
    fullName: Y,
    familyName: ie,
    weightName: q,
    postScriptName: J,
    unitsPerEm: r.unitsPerEm,
    fontBBox: [0, k.yMin, k.ascender, k.advanceWidthMax]
  }), ee = r.metas && Object.keys(r.metas).length > 0 ? $T.make(r.metas) : void 0, re = [F, S, R, M, ye, G, Re, Oe, j];
  Ue && re.push(Ue), r.tables.gsub && re.push(zT.make(r.tables.gsub)), ee && re.push(ee);
  for (var de = HT(re), Be = de.encode(), ke = n1(Be), ze = de.fields, je = !1, qe = 0; qe < ze.length; qe += 1)
    if (ze[qe].name === "head table") {
      ze[qe].value.checkSumAdjustment = 2981146554 - ke, je = !0;
      break;
    }
  if (!je)
    throw new Error("Could not find head table with checkSum to adjust.");
  return de;
}
var n5 = { make: HT, fontToTable: r5, computeCheckSum: n1 };
function g0(r, e) {
  for (var t = 0, n = r.length - 1; t <= n; ) {
    var i = t + n >>> 1, a = r[i].tag;
    if (a === e)
      return i;
    a < e ? t = i + 1 : n = i - 1;
  }
  return -t - 1;
}
function Kx(r, e) {
  for (var t = 0, n = r.length - 1; t <= n; ) {
    var i = t + n >>> 1, a = r[i];
    if (a === e)
      return i;
    a < e ? t = i + 1 : n = i - 1;
  }
  return -t - 1;
}
function Zx(r, e) {
  for (var t, n = 0, i = r.length - 1; n <= i; ) {
    var a = n + i >>> 1;
    t = r[a];
    var s = t.start;
    if (s === e)
      return t;
    s < e ? n = a + 1 : i = a - 1;
  }
  if (n > 0)
    return t = r[n - 1], e > t.end ? 0 : t;
}
function Rd(r, e) {
  this.font = r, this.tableName = e;
}
Rd.prototype = {
  /**
   * Binary search an object by "tag" property
   * @instance
   * @function searchTag
   * @memberof opentype.Layout
   * @param  {Array} arr
   * @param  {string} tag
   * @return {number}
   */
  searchTag: g0,
  /**
   * Binary search in a list of numbers
   * @instance
   * @function binSearch
   * @memberof opentype.Layout
   * @param  {Array} arr
   * @param  {number} value
   * @return {number}
   */
  binSearch: Kx,
  /**
   * Get or create the Layout table (GSUB, GPOS etc).
   * @param  {boolean} create - Whether to create a new one.
   * @return {Object} The GSUB or GPOS table.
   */
  getTable: function(r) {
    var e = this.font.tables[this.tableName];
    return !e && r && (e = this.font.tables[this.tableName] = this.createDefaultTable()), e;
  },
  /**
   * Returns all scripts in the substitution table.
   * @instance
   * @return {Array}
   */
  getScriptNames: function() {
    var r = this.getTable();
    return r ? r.scripts.map(function(e) {
      return e.tag;
    }) : [];
  },
  /**
   * Returns the best bet for a script name.
   * Returns 'DFLT' if it exists.
   * If not, returns 'latn' if it exists.
   * If neither exist, returns undefined.
   */
  getDefaultScriptName: function() {
    var r = this.getTable();
    if (r) {
      for (var e = !1, t = 0; t < r.scripts.length; t++) {
        var n = r.scripts[t].tag;
        if (n === "DFLT")
          return n;
        n === "latn" && (e = !0);
      }
      if (e)
        return "latn";
    }
  },
  /**
   * Returns all LangSysRecords in the given script.
   * @instance
   * @param {string} [script='DFLT']
   * @param {boolean} create - forces the creation of this script table if it doesn't exist.
   * @return {Object} An object with tag and script properties.
   */
  getScriptTable: function(r, e) {
    var t = this.getTable(e);
    if (t) {
      r = r || "DFLT";
      var n = t.scripts, i = g0(t.scripts, r);
      if (i >= 0)
        return n[i].script;
      if (e) {
        var a = {
          tag: r,
          script: {
            defaultLangSys: { reserved: 0, reqFeatureIndex: 65535, featureIndexes: [] },
            langSysRecords: []
          }
        };
        return n.splice(-1 - i, 0, a), a.script;
      }
    }
  },
  /**
   * Returns a language system table
   * @instance
   * @param {string} [script='DFLT']
   * @param {string} [language='dlft']
   * @param {boolean} create - forces the creation of this langSysTable if it doesn't exist.
   * @return {Object}
   */
  getLangSysTable: function(r, e, t) {
    var n = this.getScriptTable(r, t);
    if (n) {
      if (!e || e === "dflt" || e === "DFLT")
        return n.defaultLangSys;
      var i = g0(n.langSysRecords, e);
      if (i >= 0)
        return n.langSysRecords[i].langSys;
      if (t) {
        var a = {
          tag: e,
          langSys: { reserved: 0, reqFeatureIndex: 65535, featureIndexes: [] }
        };
        return n.langSysRecords.splice(-1 - i, 0, a), a.langSys;
      }
    }
  },
  /**
   * Get a specific feature table.
   * @instance
   * @param {string} [script='DFLT']
   * @param {string} [language='dlft']
   * @param {string} feature - One of the codes listed at https://www.microsoft.com/typography/OTSPEC/featurelist.htm
   * @param {boolean} create - forces the creation of the feature table if it doesn't exist.
   * @return {Object}
   */
  getFeatureTable: function(r, e, t, n) {
    var i = this.getLangSysTable(r, e, n);
    if (i) {
      for (var a, s = i.featureIndexes, o = this.font.tables[this.tableName].features, l = 0; l < s.length; l++)
        if (a = o[s[l]], a.tag === t)
          return a.feature;
      if (n) {
        var u = o.length;
        return jt.assert(u === 0 || t >= o[u - 1].tag, "Features must be added in alphabetical order."), a = {
          tag: t,
          feature: { params: 0, lookupListIndexes: [] }
        }, o.push(a), s.push(u), a.feature;
      }
    }
  },
  /**
   * Get the lookup tables of a given type for a script/language/feature.
   * @instance
   * @param {string} [script='DFLT']
   * @param {string} [language='dlft']
   * @param {string} feature - 4-letter feature code
   * @param {number} lookupType - 1 to 9
   * @param {boolean} create - forces the creation of the lookup table if it doesn't exist, with no subtables.
   * @return {Object[]}
   */
  getLookupTables: function(r, e, t, n, i) {
    var a = this.getFeatureTable(r, e, t, i), s = [];
    if (a) {
      for (var o, l = a.lookupListIndexes, u = this.font.tables[this.tableName].lookups, c = 0; c < l.length; c++)
        o = u[l[c]], o.lookupType === n && s.push(o);
      if (s.length === 0 && i) {
        o = {
          lookupType: n,
          lookupFlag: 0,
          subtables: [],
          markFilteringSet: void 0
        };
        var d = u.length;
        return u.push(o), l.push(d), [o];
      }
    }
    return s;
  },
  /**
   * Find a glyph in a class definition table
   * https://docs.microsoft.com/en-us/typography/opentype/spec/chapter2#class-definition-table
   * @param {object} classDefTable - an OpenType Layout class definition table
   * @param {number} glyphIndex - the index of the glyph to find
   * @returns {number} -1 if not found
   */
  getGlyphClass: function(r, e) {
    switch (r.format) {
      case 1:
        return r.startGlyph <= e && e < r.startGlyph + r.classes.length ? r.classes[e - r.startGlyph] : 0;
      case 2:
        var t = Zx(r.ranges, e);
        return t ? t.classId : 0;
    }
  },
  /**
   * Find a glyph in a coverage table
   * https://docs.microsoft.com/en-us/typography/opentype/spec/chapter2#coverage-table
   * @param {object} coverageTable - an OpenType Layout coverage table
   * @param {number} glyphIndex - the index of the glyph to find
   * @returns {number} -1 if not found
   */
  getCoverageIndex: function(r, e) {
    switch (r.format) {
      case 1:
        var t = Kx(r.glyphs, e);
        return t >= 0 ? t : -1;
      case 2:
        var n = Zx(r.ranges, e);
        return n ? n.index + e - n.start : -1;
    }
  },
  /**
   * Returns the list of glyph indexes of a coverage table.
   * Format 1: the list is stored raw
   * Format 2: compact list as range records.
   * @instance
   * @param  {Object} coverageTable
   * @return {Array}
   */
  expandCoverage: function(r) {
    if (r.format === 1)
      return r.glyphs;
    for (var e = [], t = r.ranges, n = 0; n < t.length; n++)
      for (var i = t[n], a = i.start, s = i.end, o = a; o <= s; o++)
        e.push(o);
    return e;
  }
};
function Od(r) {
  Rd.call(this, r, "gpos");
}
Od.prototype = Rd.prototype;
Od.prototype.init = function() {
  var r = this.getDefaultScriptName();
  this.defaultKerningTables = this.getKerningTables(r);
};
Od.prototype.getKerningValue = function(r, e, t) {
  for (var n = 0; n < r.length; n++)
    for (var i = r[n].subtables, a = 0; a < i.length; a++) {
      var s = i[a], o = this.getCoverageIndex(s.coverage, e);
      if (!(o < 0))
        switch (s.posFormat) {
          case 1:
            for (var l = s.pairSets[o], u = 0; u < l.length; u++) {
              var c = l[u];
              if (c.secondGlyph === t)
                return c.value1 && c.value1.xAdvance || 0;
            }
            break;
          // left glyph found, not right glyph - try next subtable
          case 2:
            var d = this.getGlyphClass(s.classDef1, e), f = this.getGlyphClass(s.classDef2, t), h = s.classRecords[d][f];
            return h.value1 && h.value1.xAdvance || 0;
        }
    }
  return 0;
};
Od.prototype.getKerningTables = function(r, e) {
  if (this.font.tables.gpos)
    return this.getLookupTables(r, e, "kern", 2);
};
function na(r) {
  Rd.call(this, r, "gsub");
}
function i5(r, e) {
  var t = r.length;
  if (t !== e.length)
    return !1;
  for (var n = 0; n < t; n++)
    if (r[n] !== e[n])
      return !1;
  return !0;
}
function i1(r, e, t) {
  for (var n = r.subtables, i = 0; i < n.length; i++) {
    var a = n[i];
    if (a.substFormat === e)
      return a;
  }
  if (t)
    return n.push(t), t;
}
na.prototype = Rd.prototype;
na.prototype.createDefaultTable = function() {
  return {
    version: 1,
    scripts: [{
      tag: "DFLT",
      script: {
        defaultLangSys: { reserved: 0, reqFeatureIndex: 65535, featureIndexes: [] },
        langSysRecords: []
      }
    }],
    features: [],
    lookups: []
  };
};
na.prototype.getSingle = function(r, e, t) {
  for (var n = [], i = this.getLookupTables(e, t, r, 1), a = 0; a < i.length; a++)
    for (var s = i[a].subtables, o = 0; o < s.length; o++) {
      var l = s[o], u = this.expandCoverage(l.coverage), c = void 0;
      if (l.substFormat === 1) {
        var d = l.deltaGlyphId;
        for (c = 0; c < u.length; c++) {
          var f = u[c];
          n.push({ sub: f, by: f + d });
        }
      } else {
        var h = l.substitute;
        for (c = 0; c < u.length; c++)
          n.push({ sub: u[c], by: h[c] });
      }
    }
  return n;
};
na.prototype.getMultiple = function(r, e, t) {
  for (var n = [], i = this.getLookupTables(e, t, r, 2), a = 0; a < i.length; a++)
    for (var s = i[a].subtables, o = 0; o < s.length; o++) {
      var l = s[o], u = this.expandCoverage(l.coverage), c = void 0;
      for (c = 0; c < u.length; c++) {
        var d = u[c], f = l.sequences[c];
        n.push({ sub: d, by: f });
      }
    }
  return n;
};
na.prototype.getAlternates = function(r, e, t) {
  for (var n = [], i = this.getLookupTables(e, t, r, 3), a = 0; a < i.length; a++)
    for (var s = i[a].subtables, o = 0; o < s.length; o++)
      for (var l = s[o], u = this.expandCoverage(l.coverage), c = l.alternateSets, d = 0; d < u.length; d++)
        n.push({ sub: u[d], by: c[d] });
  return n;
};
na.prototype.getLigatures = function(r, e, t) {
  for (var n = [], i = this.getLookupTables(e, t, r, 4), a = 0; a < i.length; a++)
    for (var s = i[a].subtables, o = 0; o < s.length; o++)
      for (var l = s[o], u = this.expandCoverage(l.coverage), c = l.ligatureSets, d = 0; d < u.length; d++)
        for (var f = u[d], h = c[d], g = 0; g < h.length; g++) {
          var v = h[g];
          n.push({
            sub: [f].concat(v.components),
            by: v.ligGlyph
          });
        }
  return n;
};
na.prototype.addSingle = function(r, e, t, n) {
  var i = this.getLookupTables(t, n, r, 1, !0)[0], a = i1(i, 2, {
    // lookup type 1 subtable, format 2, coverage format 1
    substFormat: 2,
    coverage: { format: 1, glyphs: [] },
    substitute: []
  });
  jt.assert(a.coverage.format === 1, "Single: unable to modify coverage table format " + a.coverage.format);
  var s = e.sub, o = this.binSearch(a.coverage.glyphs, s);
  o < 0 && (o = -1 - o, a.coverage.glyphs.splice(o, 0, s), a.substitute.splice(o, 0, 0)), a.substitute[o] = e.by;
};
na.prototype.addMultiple = function(r, e, t, n) {
  jt.assert(e.by instanceof Array && e.by.length > 1, 'Multiple: "by" must be an array of two or more ids');
  var i = this.getLookupTables(t, n, r, 2, !0)[0], a = i1(i, 1, {
    // lookup type 2 subtable, format 1, coverage format 1
    substFormat: 1,
    coverage: { format: 1, glyphs: [] },
    sequences: []
  });
  jt.assert(a.coverage.format === 1, "Multiple: unable to modify coverage table format " + a.coverage.format);
  var s = e.sub, o = this.binSearch(a.coverage.glyphs, s);
  o < 0 && (o = -1 - o, a.coverage.glyphs.splice(o, 0, s), a.sequences.splice(o, 0, 0)), a.sequences[o] = e.by;
};
na.prototype.addAlternate = function(r, e, t, n) {
  var i = this.getLookupTables(t, n, r, 3, !0)[0], a = i1(i, 1, {
    // lookup type 3 subtable, format 1, coverage format 1
    substFormat: 1,
    coverage: { format: 1, glyphs: [] },
    alternateSets: []
  });
  jt.assert(a.coverage.format === 1, "Alternate: unable to modify coverage table format " + a.coverage.format);
  var s = e.sub, o = this.binSearch(a.coverage.glyphs, s);
  o < 0 && (o = -1 - o, a.coverage.glyphs.splice(o, 0, s), a.alternateSets.splice(o, 0, 0)), a.alternateSets[o] = e.by;
};
na.prototype.addLigature = function(r, e, t, n) {
  var i = this.getLookupTables(t, n, r, 4, !0)[0], a = i.subtables[0];
  a || (a = {
    // lookup type 4 subtable, format 1, coverage format 1
    substFormat: 1,
    coverage: { format: 1, glyphs: [] },
    ligatureSets: []
  }, i.subtables[0] = a), jt.assert(a.coverage.format === 1, "Ligature: unable to modify coverage table format " + a.coverage.format);
  var s = e.sub[0], o = e.sub.slice(1), l = {
    ligGlyph: e.by,
    components: o
  }, u = this.binSearch(a.coverage.glyphs, s);
  if (u >= 0) {
    for (var c = a.ligatureSets[u], d = 0; d < c.length; d++)
      if (i5(c[d].components, o))
        return;
    c.push(l);
  } else
    u = -1 - u, a.coverage.glyphs.splice(u, 0, s), a.ligatureSets.splice(u, 0, [l]);
};
na.prototype.getFeature = function(r, e, t) {
  if (/ss\d\d/.test(r))
    return this.getSingle(r, e, t);
  switch (r) {
    case "aalt":
    case "salt":
      return this.getSingle(r, e, t).concat(this.getAlternates(r, e, t));
    case "dlig":
    case "liga":
    case "rlig":
      return this.getLigatures(r, e, t);
    case "ccmp":
      return this.getMultiple(r, e, t).concat(this.getLigatures(r, e, t));
    case "stch":
      return this.getMultiple(r, e, t);
  }
};
na.prototype.add = function(r, e, t, n) {
  if (/ss\d\d/.test(r))
    return this.addSingle(r, e, t, n);
  switch (r) {
    case "aalt":
    case "salt":
      return typeof e.by == "number" ? this.addSingle(r, e, t, n) : this.addAlternate(r, e, t, n);
    case "dlig":
    case "liga":
    case "rlig":
      return this.addLigature(r, e, t, n);
    case "ccmp":
      return e.by instanceof Array ? this.addMultiple(r, e, t, n) : this.addLigature(r, e, t, n);
  }
};
function a5() {
  return typeof window < "u";
}
function s5(r) {
  for (var e = new Buffer(r.byteLength), t = new Uint8Array(r), n = 0; n < e.length; ++n)
    e[n] = t[n];
  return e;
}
function uf(r, e) {
  if (!r)
    throw e;
}
function eC(r, e, t, n, i) {
  var a;
  return (e & n) > 0 ? (a = r.parseByte(), (e & i) === 0 && (a = -a), a = t + a) : (e & i) > 0 ? a = t : a = t + r.parseShort(), a;
}
function jT(r, e, t) {
  var n = new vt.Parser(e, t);
  r.numberOfContours = n.parseShort(), r._xMin = n.parseShort(), r._yMin = n.parseShort(), r._xMax = n.parseShort(), r._yMax = n.parseShort();
  var i, a;
  if (r.numberOfContours > 0) {
    for (var s = r.endPointIndices = [], o = 0; o < r.numberOfContours; o += 1)
      s.push(n.parseUShort());
    r.instructionLength = n.parseUShort(), r.instructions = [];
    for (var l = 0; l < r.instructionLength; l += 1)
      r.instructions.push(n.parseByte());
    var u = s[s.length - 1] + 1;
    i = [];
    for (var c = 0; c < u; c += 1)
      if (a = n.parseByte(), i.push(a), (a & 8) > 0)
        for (var d = n.parseByte(), f = 0; f < d; f += 1)
          i.push(a), c += 1;
    if (jt.argument(i.length === u, "Bad flags."), s.length > 0) {
      var h = [], g;
      if (u > 0) {
        for (var v = 0; v < u; v += 1)
          a = i[v], g = {}, g.onCurve = !!(a & 1), g.lastPointOfContour = s.indexOf(v) >= 0, h.push(g);
        for (var y = 0, A = 0; A < u; A += 1)
          a = i[A], g = h[A], g.x = eC(n, a, y, 2, 16), y = g.x;
        for (var x = 0, k = 0; k < u; k += 1)
          a = i[k], g = h[k], g.y = eC(n, a, x, 4, 32), x = g.y;
      }
      r.points = h;
    } else
      r.points = [];
  } else if (r.numberOfContours === 0)
    r.points = [];
  else {
    r.isComposite = !0, r.points = [], r.components = [];
    for (var F = !0; F; ) {
      i = n.parseUShort();
      var S = {
        glyphIndex: n.parseUShort(),
        xScale: 1,
        scale01: 0,
        scale10: 0,
        yScale: 1,
        dx: 0,
        dy: 0
      };
      (i & 1) > 0 ? (i & 2) > 0 ? (S.dx = n.parseShort(), S.dy = n.parseShort()) : S.matchedPoints = [n.parseUShort(), n.parseUShort()] : (i & 2) > 0 ? (S.dx = n.parseChar(), S.dy = n.parseChar()) : S.matchedPoints = [n.parseByte(), n.parseByte()], (i & 8) > 0 ? S.xScale = S.yScale = n.parseF2Dot14() : (i & 64) > 0 ? (S.xScale = n.parseF2Dot14(), S.yScale = n.parseF2Dot14()) : (i & 128) > 0 && (S.xScale = n.parseF2Dot14(), S.scale01 = n.parseF2Dot14(), S.scale10 = n.parseF2Dot14(), S.yScale = n.parseF2Dot14()), r.components.push(S), F = !!(i & 32);
    }
    if (i & 256) {
      r.instructionLength = n.parseUShort(), r.instructions = [];
      for (var R = 0; R < r.instructionLength; R += 1)
        r.instructions.push(n.parseByte());
    }
  }
}
function m0(r, e) {
  for (var t = [], n = 0; n < r.length; n += 1) {
    var i = r[n], a = {
      x: e.xScale * i.x + e.scale01 * i.y + e.dx,
      y: e.scale10 * i.x + e.yScale * i.y + e.dy,
      onCurve: i.onCurve,
      lastPointOfContour: i.lastPointOfContour
    };
    t.push(a);
  }
  return t;
}
function o5(r) {
  for (var e = [], t = [], n = 0; n < r.length; n += 1) {
    var i = r[n];
    t.push(i), i.lastPointOfContour && (e.push(t), t = []);
  }
  return jt.argument(t.length === 0, "There are still points left in the current contour."), e;
}
function GT(r) {
  var e = new ci();
  if (!r)
    return e;
  for (var t = o5(r), n = 0; n < t.length; ++n) {
    var i = t[n], a = null, s = i[i.length - 1], o = i[0];
    if (s.onCurve)
      e.moveTo(s.x, s.y);
    else if (o.onCurve)
      e.moveTo(o.x, o.y);
    else {
      var l = { x: (s.x + o.x) * 0.5, y: (s.y + o.y) * 0.5 };
      e.moveTo(l.x, l.y);
    }
    for (var u = 0; u < i.length; ++u)
      if (a = s, s = o, o = i[(u + 1) % i.length], s.onCurve)
        e.lineTo(s.x, s.y);
      else {
        var c = o;
        a.onCurve || ((s.x + a.x) * 0.5, (s.y + a.y) * 0.5), o.onCurve || (c = { x: (s.x + o.x) * 0.5, y: (s.y + o.y) * 0.5 }), e.quadraticCurveTo(s.x, s.y, c.x, c.y);
      }
    e.closePath();
  }
  return e;
}
function qT(r, e) {
  if (e.isComposite)
    for (var t = 0; t < e.components.length; t += 1) {
      var n = e.components[t], i = r.get(n.glyphIndex);
      if (i.getPath(), i.points) {
        var a = void 0;
        if (n.matchedPoints === void 0)
          a = m0(i.points, n);
        else {
          if (n.matchedPoints[0] > e.points.length - 1 || n.matchedPoints[1] > i.points.length - 1)
            throw Error("Matched points out of range in " + e.name);
          var s = e.points[n.matchedPoints[0]], o = i.points[n.matchedPoints[1]], l = {
            xScale: n.xScale,
            scale01: n.scale01,
            scale10: n.scale10,
            yScale: n.yScale,
            dx: 0,
            dy: 0
          };
          o = m0([o], l)[0], l.dx = s.x - o.x, l.dy = s.y - o.y, a = m0(i.points, l);
        }
        e.points = e.points.concat(a);
      }
    }
  return GT(e.points);
}
function l5(r, e, t, n) {
  for (var i = new is.GlyphSet(n), a = 0; a < t.length - 1; a += 1) {
    var s = t[a], o = t[a + 1];
    s !== o ? i.push(a, is.ttfGlyphLoader(n, a, jT, r, e + s, qT)) : i.push(a, is.glyphLoader(n, a));
  }
  return i;
}
function u5(r, e, t, n) {
  var i = new is.GlyphSet(n);
  return n._push = function(a) {
    var s = t[a], o = t[a + 1];
    s !== o ? i.push(a, is.ttfGlyphLoader(n, a, jT, r, e + s, qT)) : i.push(a, is.glyphLoader(n, a));
  }, i;
}
function c5(r, e, t, n, i) {
  return i.lowMemory ? u5(r, e, t, n) : l5(r, e, t, n);
}
var WT = { getPath: GT, parse: c5 }, QT, xl, YT, zy;
function XT(r) {
  this.font = r, this.getCommands = function(e) {
    return WT.getPath(e).commands;
  }, this._fpgmState = this._prepState = void 0, this._errorState = 0;
}
function f5(r) {
  return r;
}
function JT(r) {
  return Math.sign(r) * Math.round(Math.abs(r));
}
function d5(r) {
  return Math.sign(r) * Math.round(Math.abs(r * 2)) / 2;
}
function h5(r) {
  return Math.sign(r) * (Math.round(Math.abs(r) + 0.5) - 0.5);
}
function p5(r) {
  return Math.sign(r) * Math.ceil(Math.abs(r));
}
function g5(r) {
  return Math.sign(r) * Math.floor(Math.abs(r));
}
var KT = function(r) {
  var e = this.srPeriod, t = this.srPhase, n = this.srThreshold, i = 1;
  return r < 0 && (r = -r, i = -1), r += n - t, r = Math.trunc(r / e) * e, r += t, r < 0 ? t * i : r * i;
}, ts = {
  x: 1,
  y: 0,
  axis: "x",
  // Gets the projected distance between two points.
  // o1/o2 ... if true, respective original position is used.
  distance: function(r, e, t, n) {
    return (t ? r.xo : r.x) - (n ? e.xo : e.x);
  },
  // Moves point p so the moved position has the same relative
  // position to the moved positions of rp1 and rp2 than the
  // original positions had.
  //
  // See APPENDIX on INTERPOLATE at the bottom of this file.
  interpolate: function(r, e, t, n) {
    var i, a, s, o, l, u, c;
    if (!n || n === this) {
      if (i = r.xo - e.xo, a = r.xo - t.xo, l = e.x - e.xo, u = t.x - t.xo, s = Math.abs(i), o = Math.abs(a), c = s + o, c === 0) {
        r.x = r.xo + (l + u) / 2;
        return;
      }
      r.x = r.xo + (l * o + u * s) / c;
      return;
    }
    if (i = n.distance(r, e, !0, !0), a = n.distance(r, t, !0, !0), l = n.distance(e, e, !1, !0), u = n.distance(t, t, !1, !0), s = Math.abs(i), o = Math.abs(a), c = s + o, c === 0) {
      ts.setRelative(r, r, (l + u) / 2, n, !0);
      return;
    }
    ts.setRelative(r, r, (l * o + u * s) / c, n, !0);
  },
  // Slope of line normal to this
  normalSlope: Number.NEGATIVE_INFINITY,
  // Sets the point 'p' relative to point 'rp'
  // by the distance 'd'.
  //
  // See APPENDIX on SETRELATIVE at the bottom of this file.
  //
  // p   ... point to set
  // rp  ... reference point
  // d   ... distance on projection vector
  // pv  ... projection vector (undefined = this)
  // org ... if true, uses the original position of rp as reference.
  setRelative: function(r, e, t, n, i) {
    if (!n || n === this) {
      r.x = (i ? e.xo : e.x) + t;
      return;
    }
    var a = i ? e.xo : e.x, s = i ? e.yo : e.y, o = a + t * n.x, l = s + t * n.y;
    r.x = o + (r.y - l) / n.normalSlope;
  },
  // Slope of vector line.
  slope: 0,
  // Touches the point p.
  touch: function(r) {
    r.xTouched = !0;
  },
  // Tests if a point p is touched.
  touched: function(r) {
    return r.xTouched;
  },
  // Untouches the point p.
  untouch: function(r) {
    r.xTouched = !1;
  }
}, Fs = {
  x: 0,
  y: 1,
  axis: "y",
  // Gets the projected distance between two points.
  // o1/o2 ... if true, respective original position is used.
  distance: function(r, e, t, n) {
    return (t ? r.yo : r.y) - (n ? e.yo : e.y);
  },
  // Moves point p so the moved position has the same relative
  // position to the moved positions of rp1 and rp2 than the
  // original positions had.
  //
  // See APPENDIX on INTERPOLATE at the bottom of this file.
  interpolate: function(r, e, t, n) {
    var i, a, s, o, l, u, c;
    if (!n || n === this) {
      if (i = r.yo - e.yo, a = r.yo - t.yo, l = e.y - e.yo, u = t.y - t.yo, s = Math.abs(i), o = Math.abs(a), c = s + o, c === 0) {
        r.y = r.yo + (l + u) / 2;
        return;
      }
      r.y = r.yo + (l * o + u * s) / c;
      return;
    }
    if (i = n.distance(r, e, !0, !0), a = n.distance(r, t, !0, !0), l = n.distance(e, e, !1, !0), u = n.distance(t, t, !1, !0), s = Math.abs(i), o = Math.abs(a), c = s + o, c === 0) {
      Fs.setRelative(r, r, (l + u) / 2, n, !0);
      return;
    }
    Fs.setRelative(r, r, (l * o + u * s) / c, n, !0);
  },
  // Slope of line normal to this.
  normalSlope: 0,
  // Sets the point 'p' relative to point 'rp'
  // by the distance 'd'
  //
  // See APPENDIX on SETRELATIVE at the bottom of this file.
  //
  // p   ... point to set
  // rp  ... reference point
  // d   ... distance on projection vector
  // pv  ... projection vector (undefined = this)
  // org ... if true, uses the original position of rp as reference.
  setRelative: function(r, e, t, n, i) {
    if (!n || n === this) {
      r.y = (i ? e.yo : e.y) + t;
      return;
    }
    var a = i ? e.xo : e.x, s = i ? e.yo : e.y, o = a + t * n.x, l = s + t * n.y;
    r.y = l + n.normalSlope * (r.x - o);
  },
  // Slope of vector line.
  slope: Number.POSITIVE_INFINITY,
  // Touches the point p.
  touch: function(r) {
    r.yTouched = !0;
  },
  // Tests if a point p is touched.
  touched: function(r) {
    return r.yTouched;
  },
  // Untouches the point p.
  untouch: function(r) {
    r.yTouched = !1;
  }
};
Object.freeze(ts);
Object.freeze(Fs);
function Bd(r, e) {
  this.x = r, this.y = e, this.axis = void 0, this.slope = e / r, this.normalSlope = -r / e, Object.freeze(this);
}
Bd.prototype.distance = function(r, e, t, n) {
  return this.x * ts.distance(r, e, t, n) + this.y * Fs.distance(r, e, t, n);
};
Bd.prototype.interpolate = function(r, e, t, n) {
  var i, a, s, o, l, u, c;
  if (s = n.distance(r, e, !0, !0), o = n.distance(r, t, !0, !0), i = n.distance(e, e, !1, !0), a = n.distance(t, t, !1, !0), l = Math.abs(s), u = Math.abs(o), c = l + u, c === 0) {
    this.setRelative(r, r, (i + a) / 2, n, !0);
    return;
  }
  this.setRelative(r, r, (i * u + a * l) / c, n, !0);
};
Bd.prototype.setRelative = function(r, e, t, n, i) {
  n = n || this;
  var a = i ? e.xo : e.x, s = i ? e.yo : e.y, o = a + t * n.x, l = s + t * n.y, u = n.normalSlope, c = this.slope, d = r.x, f = r.y;
  r.x = (c * d - u * o + l - f) / (c - u), r.y = c * (r.x - d) + f;
};
Bd.prototype.touch = function(r) {
  r.xTouched = !0, r.yTouched = !0;
};
function Md(r, e) {
  var t = Math.sqrt(r * r + e * e);
  return r /= t, e /= t, r === 1 && e === 0 ? ts : r === 0 && e === 1 ? Fs : new Bd(r, e);
}
function Ds(r, e, t, n) {
  this.x = this.xo = Math.round(r * 64) / 64, this.y = this.yo = Math.round(e * 64) / 64, this.lastPointOfContour = t, this.onCurve = n, this.prevPointOnContour = void 0, this.nextPointOnContour = void 0, this.xTouched = !1, this.yTouched = !1, Object.preventExtensions(this);
}
Ds.prototype.nextTouched = function(r) {
  for (var e = this.nextPointOnContour; !r.touched(e) && e !== this; )
    e = e.nextPointOnContour;
  return e;
};
Ds.prototype.prevTouched = function(r) {
  for (var e = this.prevPointOnContour; !r.touched(e) && e !== this; )
    e = e.prevPointOnContour;
  return e;
};
var dd = Object.freeze(new Ds(0, 0)), m5 = {
  cvCutIn: 17 / 16,
  // control value cut in
  deltaBase: 9,
  deltaShift: 0.125,
  loop: 1,
  // loops some instructions
  minDis: 1,
  // minimum distance
  autoFlip: !0
};
function lo(r, e) {
  switch (this.env = r, this.stack = [], this.prog = e, r) {
    case "glyf":
      this.zp0 = this.zp1 = this.zp2 = 1, this.rp0 = this.rp1 = this.rp2 = 0;
    /* fall through */
    case "prep":
      this.fv = this.pv = this.dpv = ts, this.round = JT;
  }
}
XT.prototype.exec = function(r, e) {
  if (typeof e != "number")
    throw new Error("Point size is not a number!");
  if (!(this._errorState > 2)) {
    var t = this.font, n = this._prepState;
    if (!n || n.ppem !== e) {
      var i = this._fpgmState;
      if (!i) {
        lo.prototype = m5, i = this._fpgmState = new lo("fpgm", t.tables.fpgm), i.funcs = [], i.font = t, exports.DEBUG && (console.log("---EXEC FPGM---"), i.step = -1);
        try {
          xl(i);
        } catch (u) {
          console.log("Hinting error in FPGM:" + u), this._errorState = 3;
          return;
        }
      }
      lo.prototype = i, n = this._prepState = new lo("prep", t.tables.prep), n.ppem = e;
      var a = t.tables.cvt;
      if (a)
        for (var s = n.cvt = new Array(a.length), o = e / t.unitsPerEm, l = 0; l < a.length; l++)
          s[l] = a[l] * o;
      else
        n.cvt = [];
      exports.DEBUG && (console.log("---EXEC PREP---"), n.step = -1);
      try {
        xl(n);
      } catch (u) {
        this._errorState < 2 && console.log("Hinting error in PREP:" + u), this._errorState = 2;
      }
    }
    if (!(this._errorState > 1))
      try {
        return YT(r, n);
      } catch (u) {
        this._errorState < 1 && (console.log("Hinting error:" + u), console.log("Note: further hinting errors are silenced")), this._errorState = 1;
        return;
      }
  }
};
YT = function(r, e) {
  var t = e.ppem / e.font.unitsPerEm, n = t, i = r.components, a, s, o;
  if (lo.prototype = e, !i)
    o = new lo("glyf", r.instructions), exports.DEBUG && (console.log("---EXEC GLYPH---"), o.step = -1), zy(r, o, t, n), s = o.gZone;
  else {
    var l = e.font;
    s = [], a = [];
    for (var u = 0; u < i.length; u++) {
      var c = i[u], d = l.glyphs.get(c.glyphIndex);
      o = new lo("glyf", d.instructions), exports.DEBUG && (console.log("---EXEC COMP " + u + "---"), o.step = -1), zy(d, o, t, n);
      for (var f = Math.round(c.dx * t), h = Math.round(c.dy * n), g = o.gZone, v = o.contours, y = 0; y < g.length; y++) {
        var A = g[y];
        A.xTouched = A.yTouched = !1, A.xo = A.x = A.x + f, A.yo = A.y = A.y + h;
      }
      var x = s.length;
      s.push.apply(s, g);
      for (var k = 0; k < v.length; k++)
        a.push(v[k] + x);
    }
    r.instructions && !o.inhibitGridFit && (o = new lo("glyf", r.instructions), o.gZone = o.z0 = o.z1 = o.z2 = s, o.contours = a, s.push(
      new Ds(0, 0),
      new Ds(Math.round(r.advanceWidth * t), 0)
    ), exports.DEBUG && (console.log("---EXEC COMPOSITE---"), o.step = -1), xl(o), s.length -= 2);
  }
  return s;
};
zy = function(r, e, t, n) {
  for (var i = r.points || [], a = i.length, s = e.gZone = e.z0 = e.z1 = e.z2 = [], o = e.contours = [], l, u = 0; u < a; u++)
    l = i[u], s[u] = new Ds(
      l.x * t,
      l.y * n,
      l.lastPointOfContour,
      l.onCurve
    );
  for (var c, d, f = 0; f < a; f++)
    l = s[f], c || (c = l, o.push(f)), l.lastPointOfContour ? (l.nextPointOnContour = c, c.prevPointOnContour = l, c = void 0) : (d = s[f + 1], l.nextPointOnContour = d, d.prevPointOnContour = l);
  if (!e.inhibitGridFit) {
    if (exports.DEBUG) {
      console.log("PROCESSING GLYPH", e.stack);
      for (var h = 0; h < a; h++)
        console.log(h, s[h].x, s[h].y);
    }
    if (s.push(
      new Ds(0, 0),
      new Ds(Math.round(r.advanceWidth * t), 0)
    ), xl(e), s.length -= 2, exports.DEBUG) {
      console.log("FINISHED GLYPH", e.stack);
      for (var g = 0; g < a; g++)
        console.log(g, s[g].x, s[g].y);
    }
  }
};
xl = function(r) {
  var e = r.prog;
  if (e) {
    var t = e.length, n;
    for (r.ip = 0; r.ip < t; r.ip++) {
      if (exports.DEBUG && r.step++, n = QT[e[r.ip]], !n)
        throw new Error(
          "unknown instruction: 0x" + Number(e[r.ip]).toString(16)
        );
      n(r);
    }
  }
};
function Og(r) {
  for (var e = r.tZone = new Array(r.gZone.length), t = 0; t < e.length; t++)
    e[t] = new Ds(0, 0);
}
function ZT(r, e) {
  var t = r.prog, n = r.ip, i = 1, a;
  do
    if (a = t[++n], a === 88)
      i++;
    else if (a === 89)
      i--;
    else if (a === 64)
      n += t[n + 1] + 1;
    else if (a === 65)
      n += 2 * t[n + 1] + 1;
    else if (a >= 176 && a <= 183)
      n += a - 176 + 1;
    else if (a >= 184 && a <= 191)
      n += (a - 184 + 1) * 2;
    else if (e && i === 1 && a === 27)
      break;
  while (i > 0);
  r.ip = n;
}
function tC(r, e) {
  exports.DEBUG && console.log(e.step, "SVTCA[" + r.axis + "]"), e.fv = e.pv = e.dpv = r;
}
function rC(r, e) {
  exports.DEBUG && console.log(e.step, "SPVTCA[" + r.axis + "]"), e.pv = e.dpv = r;
}
function nC(r, e) {
  exports.DEBUG && console.log(e.step, "SFVTCA[" + r.axis + "]"), e.fv = r;
}
function iC(r, e) {
  var t = e.stack, n = t.pop(), i = t.pop(), a = e.z2[n], s = e.z1[i];
  exports.DEBUG && console.log("SPVTL[" + r + "]", n, i);
  var o, l;
  r ? (o = a.y - s.y, l = s.x - a.x) : (o = s.x - a.x, l = s.y - a.y), e.pv = e.dpv = Md(o, l);
}
function aC(r, e) {
  var t = e.stack, n = t.pop(), i = t.pop(), a = e.z2[n], s = e.z1[i];
  exports.DEBUG && console.log("SFVTL[" + r + "]", n, i);
  var o, l;
  r ? (o = a.y - s.y, l = s.x - a.x) : (o = s.x - a.x, l = s.y - a.y), e.fv = Md(o, l);
}
function v5(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "SPVFS[]", t, n), r.pv = r.dpv = Md(n, t);
}
function y5(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "SPVFS[]", t, n), r.fv = Md(n, t);
}
function A5(r) {
  var e = r.stack, t = r.pv;
  exports.DEBUG && console.log(r.step, "GPV[]"), e.push(t.x * 16384), e.push(t.y * 16384);
}
function b5(r) {
  var e = r.stack, t = r.fv;
  exports.DEBUG && console.log(r.step, "GFV[]"), e.push(t.x * 16384), e.push(t.y * 16384);
}
function w5(r) {
  r.fv = r.pv, exports.DEBUG && console.log(r.step, "SFVTPV[]");
}
function x5(r) {
  var e = r.stack, t = e.pop(), n = e.pop(), i = e.pop(), a = e.pop(), s = e.pop(), o = r.z0, l = r.z1, u = o[t], c = o[n], d = l[i], f = l[a], h = r.z2[s];
  exports.DEBUG && console.log("ISECT[], ", t, n, i, a, s);
  var g = u.x, v = u.y, y = c.x, A = c.y, x = d.x, k = d.y, F = f.x, S = f.y, R = (g - y) * (k - S) - (v - A) * (x - F), M = g * A - v * y, j = x * S - k * F;
  h.x = (M * (x - F) - j * (g - y)) / R, h.y = (M * (k - S) - j * (v - A)) / R;
}
function C5(r) {
  r.rp0 = r.stack.pop(), exports.DEBUG && console.log(r.step, "SRP0[]", r.rp0);
}
function S5(r) {
  r.rp1 = r.stack.pop(), exports.DEBUG && console.log(r.step, "SRP1[]", r.rp1);
}
function E5(r) {
  r.rp2 = r.stack.pop(), exports.DEBUG && console.log(r.step, "SRP2[]", r.rp2);
}
function k5(r) {
  var e = r.stack.pop();
  switch (exports.DEBUG && console.log(r.step, "SZP0[]", e), r.zp0 = e, e) {
    case 0:
      r.tZone || Og(r), r.z0 = r.tZone;
      break;
    case 1:
      r.z0 = r.gZone;
      break;
    default:
      throw new Error("Invalid zone pointer");
  }
}
function T5(r) {
  var e = r.stack.pop();
  switch (exports.DEBUG && console.log(r.step, "SZP1[]", e), r.zp1 = e, e) {
    case 0:
      r.tZone || Og(r), r.z1 = r.tZone;
      break;
    case 1:
      r.z1 = r.gZone;
      break;
    default:
      throw new Error("Invalid zone pointer");
  }
}
function F5(r) {
  var e = r.stack.pop();
  switch (exports.DEBUG && console.log(r.step, "SZP2[]", e), r.zp2 = e, e) {
    case 0:
      r.tZone || Og(r), r.z2 = r.tZone;
      break;
    case 1:
      r.z2 = r.gZone;
      break;
    default:
      throw new Error("Invalid zone pointer");
  }
}
function I5(r) {
  var e = r.stack.pop();
  switch (exports.DEBUG && console.log(r.step, "SZPS[]", e), r.zp0 = r.zp1 = r.zp2 = e, e) {
    case 0:
      r.tZone || Og(r), r.z0 = r.z1 = r.z2 = r.tZone;
      break;
    case 1:
      r.z0 = r.z1 = r.z2 = r.gZone;
      break;
    default:
      throw new Error("Invalid zone pointer");
  }
}
function D5(r) {
  r.loop = r.stack.pop(), exports.DEBUG && console.log(r.step, "SLOOP[]", r.loop);
}
function P5(r) {
  exports.DEBUG && console.log(r.step, "RTG[]"), r.round = JT;
}
function R5(r) {
  exports.DEBUG && console.log(r.step, "RTHG[]"), r.round = h5;
}
function O5(r) {
  var e = r.stack.pop();
  exports.DEBUG && console.log(r.step, "SMD[]", e), r.minDis = e / 64;
}
function B5(r) {
  exports.DEBUG && console.log(r.step, "ELSE[]"), ZT(r, !1);
}
function M5(r) {
  var e = r.stack.pop();
  exports.DEBUG && console.log(r.step, "JMPR[]", e), r.ip += e - 1;
}
function _5(r) {
  var e = r.stack.pop();
  exports.DEBUG && console.log(r.step, "SCVTCI[]", e), r.cvCutIn = e / 64;
}
function N5(r) {
  var e = r.stack;
  exports.DEBUG && console.log(r.step, "DUP[]"), e.push(e[e.length - 1]);
}
function v0(r) {
  exports.DEBUG && console.log(r.step, "POP[]"), r.stack.pop();
}
function L5(r) {
  exports.DEBUG && console.log(r.step, "CLEAR[]"), r.stack.length = 0;
}
function U5(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "SWAP[]"), e.push(t), e.push(n);
}
function V5(r) {
  var e = r.stack;
  exports.DEBUG && console.log(r.step, "DEPTH[]"), e.push(e.length);
}
function z5(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "LOOPCALL[]", t, n);
  var i = r.ip, a = r.prog;
  r.prog = r.funcs[t];
  for (var s = 0; s < n; s++)
    xl(r), exports.DEBUG && console.log(
      ++r.step,
      s + 1 < n ? "next loopcall" : "done loopcall",
      s
    );
  r.ip = i, r.prog = a;
}
function $5(r) {
  var e = r.stack.pop();
  exports.DEBUG && console.log(r.step, "CALL[]", e);
  var t = r.ip, n = r.prog;
  r.prog = r.funcs[e], xl(r), r.ip = t, r.prog = n, exports.DEBUG && console.log(++r.step, "returning from", e);
}
function H5(r) {
  var e = r.stack, t = e.pop();
  exports.DEBUG && console.log(r.step, "CINDEX[]", t), e.push(e[e.length - t]);
}
function j5(r) {
  var e = r.stack, t = e.pop();
  exports.DEBUG && console.log(r.step, "MINDEX[]", t), e.push(e.splice(e.length - t, 1)[0]);
}
function G5(r) {
  if (r.env !== "fpgm")
    throw new Error("FDEF not allowed here");
  var e = r.stack, t = r.prog, n = r.ip, i = e.pop(), a = n;
  for (exports.DEBUG && console.log(r.step, "FDEF[]", i); t[++n] !== 45; )
    ;
  r.ip = n, r.funcs[i] = t.slice(a + 1, n);
}
function sC(r, e) {
  var t = e.stack.pop(), n = e.z0[t], i = e.fv, a = e.pv;
  exports.DEBUG && console.log(e.step, "MDAP[" + r + "]", t);
  var s = a.distance(n, dd);
  r && (s = e.round(s)), i.setRelative(n, dd, s, a), i.touch(n), e.rp0 = e.rp1 = t;
}
function oC(r, e) {
  var t = e.z2, n = t.length - 2, i, a, s;
  exports.DEBUG && console.log(e.step, "IUP[" + r.axis + "]");
  for (var o = 0; o < n; o++)
    i = t[o], !r.touched(i) && (a = i.prevTouched(r), a !== i && (s = i.nextTouched(r), a === s && r.setRelative(i, i, r.distance(a, a, !1, !0), r, !0), r.interpolate(i, a, s, r)));
}
function lC(r, e) {
  for (var t = e.stack, n = r ? e.rp1 : e.rp2, i = (r ? e.z0 : e.z1)[n], a = e.fv, s = e.pv, o = e.loop, l = e.z2; o--; ) {
    var u = t.pop(), c = l[u], d = s.distance(i, i, !1, !0);
    a.setRelative(c, c, d, s), a.touch(c), exports.DEBUG && console.log(
      e.step,
      (e.loop > 1 ? "loop " + (e.loop - o) + ": " : "") + "SHP[" + (r ? "rp1" : "rp2") + "]",
      u
    );
  }
  e.loop = 1;
}
function uC(r, e) {
  var t = e.stack, n = r ? e.rp1 : e.rp2, i = (r ? e.z0 : e.z1)[n], a = e.fv, s = e.pv, o = t.pop(), l = e.z2[e.contours[o]], u = l;
  exports.DEBUG && console.log(e.step, "SHC[" + r + "]", o);
  var c = s.distance(i, i, !1, !0);
  do
    u !== i && a.setRelative(u, u, c, s), u = u.nextPointOnContour;
  while (u !== l);
}
function cC(r, e) {
  var t = e.stack, n = r ? e.rp1 : e.rp2, i = (r ? e.z0 : e.z1)[n], a = e.fv, s = e.pv, o = t.pop();
  exports.DEBUG && console.log(e.step, "SHZ[" + r + "]", o);
  var l;
  switch (o) {
    case 0:
      l = e.tZone;
      break;
    case 1:
      l = e.gZone;
      break;
    default:
      throw new Error("Invalid zone");
  }
  for (var u, c = s.distance(i, i, !1, !0), d = l.length - 2, f = 0; f < d; f++)
    u = l[f], a.setRelative(u, u, c, s);
}
function q5(r) {
  for (var e = r.stack, t = r.loop, n = r.fv, i = e.pop() / 64, a = r.z2; t--; ) {
    var s = e.pop(), o = a[s];
    exports.DEBUG && console.log(
      r.step,
      (r.loop > 1 ? "loop " + (r.loop - t) + ": " : "") + "SHPIX[]",
      s,
      i
    ), n.setRelative(o, o, i), n.touch(o);
  }
  r.loop = 1;
}
function W5(r) {
  for (var e = r.stack, t = r.rp1, n = r.rp2, i = r.loop, a = r.z0[t], s = r.z1[n], o = r.fv, l = r.dpv, u = r.z2; i--; ) {
    var c = e.pop(), d = u[c];
    exports.DEBUG && console.log(
      r.step,
      (r.loop > 1 ? "loop " + (r.loop - i) + ": " : "") + "IP[]",
      c,
      t,
      "<->",
      n
    ), o.interpolate(d, a, s, l), o.touch(d);
  }
  r.loop = 1;
}
function fC(r, e) {
  var t = e.stack, n = t.pop() / 64, i = t.pop(), a = e.z1[i], s = e.z0[e.rp0], o = e.fv, l = e.pv;
  o.setRelative(a, s, n, l), o.touch(a), exports.DEBUG && console.log(e.step, "MSIRP[" + r + "]", n, i), e.rp1 = e.rp0, e.rp2 = i, r && (e.rp0 = i);
}
function Q5(r) {
  for (var e = r.stack, t = r.rp0, n = r.z0[t], i = r.loop, a = r.fv, s = r.pv, o = r.z1; i--; ) {
    var l = e.pop(), u = o[l];
    exports.DEBUG && console.log(
      r.step,
      (r.loop > 1 ? "loop " + (r.loop - i) + ": " : "") + "ALIGNRP[]",
      l
    ), a.setRelative(u, n, 0, s), a.touch(u);
  }
  r.loop = 1;
}
function Y5(r) {
  exports.DEBUG && console.log(r.step, "RTDG[]"), r.round = d5;
}
function dC(r, e) {
  var t = e.stack, n = t.pop(), i = t.pop(), a = e.z0[i], s = e.fv, o = e.pv, l = e.cvt[n];
  exports.DEBUG && console.log(
    e.step,
    "MIAP[" + r + "]",
    n,
    "(",
    l,
    ")",
    i
  );
  var u = o.distance(a, dd);
  r && (Math.abs(u - l) < e.cvCutIn && (u = l), u = e.round(u)), s.setRelative(a, dd, u, o), e.zp0 === 0 && (a.xo = a.x, a.yo = a.y), s.touch(a), e.rp0 = e.rp1 = i;
}
function X5(r) {
  var e = r.prog, t = r.ip, n = r.stack, i = e[++t];
  exports.DEBUG && console.log(r.step, "NPUSHB[]", i);
  for (var a = 0; a < i; a++)
    n.push(e[++t]);
  r.ip = t;
}
function J5(r) {
  var e = r.ip, t = r.prog, n = r.stack, i = t[++e];
  exports.DEBUG && console.log(r.step, "NPUSHW[]", i);
  for (var a = 0; a < i; a++) {
    var s = t[++e] << 8 | t[++e];
    s & 32768 && (s = -((s ^ 65535) + 1)), n.push(s);
  }
  r.ip = e;
}
function K5(r) {
  var e = r.stack, t = r.store;
  t || (t = r.store = []);
  var n = e.pop(), i = e.pop();
  exports.DEBUG && console.log(r.step, "WS", n, i), t[i] = n;
}
function Z5(r) {
  var e = r.stack, t = r.store, n = e.pop();
  exports.DEBUG && console.log(r.step, "RS", n);
  var i = t && t[n] || 0;
  e.push(i);
}
function e6(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "WCVTP", t, n), r.cvt[n] = t / 64;
}
function t6(r) {
  var e = r.stack, t = e.pop();
  exports.DEBUG && console.log(r.step, "RCVT", t), e.push(r.cvt[t] * 64);
}
function hC(r, e) {
  var t = e.stack, n = t.pop(), i = e.z2[n];
  exports.DEBUG && console.log(e.step, "GC[" + r + "]", n), t.push(e.dpv.distance(i, dd, r, !1) * 64);
}
function pC(r, e) {
  var t = e.stack, n = t.pop(), i = t.pop(), a = e.z1[n], s = e.z0[i], o = e.dpv.distance(s, a, r, r);
  exports.DEBUG && console.log(e.step, "MD[" + r + "]", n, i, "->", o), e.stack.push(Math.round(o * 64));
}
function r6(r) {
  exports.DEBUG && console.log(r.step, "MPPEM[]"), r.stack.push(r.ppem);
}
function n6(r) {
  exports.DEBUG && console.log(r.step, "FLIPON[]"), r.autoFlip = !0;
}
function i6(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "LT[]", t, n), e.push(n < t ? 1 : 0);
}
function a6(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "LTEQ[]", t, n), e.push(n <= t ? 1 : 0);
}
function s6(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "GT[]", t, n), e.push(n > t ? 1 : 0);
}
function o6(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "GTEQ[]", t, n), e.push(n >= t ? 1 : 0);
}
function l6(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "EQ[]", t, n), e.push(t === n ? 1 : 0);
}
function u6(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "NEQ[]", t, n), e.push(t !== n ? 1 : 0);
}
function c6(r) {
  var e = r.stack, t = e.pop();
  exports.DEBUG && console.log(r.step, "ODD[]", t), e.push(Math.trunc(t) % 2 ? 1 : 0);
}
function f6(r) {
  var e = r.stack, t = e.pop();
  exports.DEBUG && console.log(r.step, "EVEN[]", t), e.push(Math.trunc(t) % 2 ? 0 : 1);
}
function d6(r) {
  var e = r.stack.pop();
  exports.DEBUG && console.log(r.step, "IF[]", e), e || (ZT(r, !0), exports.DEBUG && console.log(r.step, "EIF[]"));
}
function h6(r) {
  exports.DEBUG && console.log(r.step, "EIF[]");
}
function p6(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "AND[]", t, n), e.push(t && n ? 1 : 0);
}
function g6(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "OR[]", t, n), e.push(t || n ? 1 : 0);
}
function m6(r) {
  var e = r.stack, t = e.pop();
  exports.DEBUG && console.log(r.step, "NOT[]", t), e.push(t ? 0 : 1);
}
function y0(r, e) {
  var t = e.stack, n = t.pop(), i = e.fv, a = e.pv, s = e.ppem, o = e.deltaBase + (r - 1) * 16, l = e.deltaShift, u = e.z0;
  exports.DEBUG && console.log(e.step, "DELTAP[" + r + "]", n, t);
  for (var c = 0; c < n; c++) {
    var d = t.pop(), f = t.pop(), h = o + ((f & 240) >> 4);
    if (h === s) {
      var g = (f & 15) - 8;
      g >= 0 && g++, exports.DEBUG && console.log(e.step, "DELTAPFIX", d, "by", g * l);
      var v = u[d];
      i.setRelative(v, v, g * l, a);
    }
  }
}
function v6(r) {
  var e = r.stack, t = e.pop();
  exports.DEBUG && console.log(r.step, "SDB[]", t), r.deltaBase = t;
}
function y6(r) {
  var e = r.stack, t = e.pop();
  exports.DEBUG && console.log(r.step, "SDS[]", t), r.deltaShift = Math.pow(0.5, t);
}
function A6(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "ADD[]", t, n), e.push(n + t);
}
function b6(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "SUB[]", t, n), e.push(n - t);
}
function w6(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "DIV[]", t, n), e.push(n * 64 / t);
}
function x6(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "MUL[]", t, n), e.push(n * t / 64);
}
function C6(r) {
  var e = r.stack, t = e.pop();
  exports.DEBUG && console.log(r.step, "ABS[]", t), e.push(Math.abs(t));
}
function S6(r) {
  var e = r.stack, t = e.pop();
  exports.DEBUG && console.log(r.step, "NEG[]", t), e.push(-t);
}
function E6(r) {
  var e = r.stack, t = e.pop();
  exports.DEBUG && console.log(r.step, "FLOOR[]", t), e.push(Math.floor(t / 64) * 64);
}
function k6(r) {
  var e = r.stack, t = e.pop();
  exports.DEBUG && console.log(r.step, "CEILING[]", t), e.push(Math.ceil(t / 64) * 64);
}
function Vh(r, e) {
  var t = e.stack, n = t.pop();
  exports.DEBUG && console.log(e.step, "ROUND[]"), t.push(e.round(n / 64) * 64);
}
function T6(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "WCVTF[]", t, n), r.cvt[n] = t * r.ppem / r.font.unitsPerEm;
}
function A0(r, e) {
  var t = e.stack, n = t.pop(), i = e.ppem, a = e.deltaBase + (r - 1) * 16, s = e.deltaShift;
  exports.DEBUG && console.log(e.step, "DELTAC[" + r + "]", n, t);
  for (var o = 0; o < n; o++) {
    var l = t.pop(), u = t.pop(), c = a + ((u & 240) >> 4);
    if (c === i) {
      var d = (u & 15) - 8;
      d >= 0 && d++;
      var f = d * s;
      exports.DEBUG && console.log(e.step, "DELTACFIX", l, "by", f), e.cvt[l] += f;
    }
  }
}
function F6(r) {
  var e = r.stack.pop();
  exports.DEBUG && console.log(r.step, "SROUND[]", e), r.round = KT;
  var t;
  switch (e & 192) {
    case 0:
      t = 0.5;
      break;
    case 64:
      t = 1;
      break;
    case 128:
      t = 2;
      break;
    default:
      throw new Error("invalid SROUND value");
  }
  switch (r.srPeriod = t, e & 48) {
    case 0:
      r.srPhase = 0;
      break;
    case 16:
      r.srPhase = 0.25 * t;
      break;
    case 32:
      r.srPhase = 0.5 * t;
      break;
    case 48:
      r.srPhase = 0.75 * t;
      break;
    default:
      throw new Error("invalid SROUND value");
  }
  e &= 15, e === 0 ? r.srThreshold = 0 : r.srThreshold = (e / 8 - 0.5) * t;
}
function I6(r) {
  var e = r.stack.pop();
  exports.DEBUG && console.log(r.step, "S45ROUND[]", e), r.round = KT;
  var t;
  switch (e & 192) {
    case 0:
      t = Math.sqrt(2) / 2;
      break;
    case 64:
      t = Math.sqrt(2);
      break;
    case 128:
      t = 2 * Math.sqrt(2);
      break;
    default:
      throw new Error("invalid S45ROUND value");
  }
  switch (r.srPeriod = t, e & 48) {
    case 0:
      r.srPhase = 0;
      break;
    case 16:
      r.srPhase = 0.25 * t;
      break;
    case 32:
      r.srPhase = 0.5 * t;
      break;
    case 48:
      r.srPhase = 0.75 * t;
      break;
    default:
      throw new Error("invalid S45ROUND value");
  }
  e &= 15, e === 0 ? r.srThreshold = 0 : r.srThreshold = (e / 8 - 0.5) * t;
}
function D6(r) {
  exports.DEBUG && console.log(r.step, "ROFF[]"), r.round = f5;
}
function P6(r) {
  exports.DEBUG && console.log(r.step, "RUTG[]"), r.round = p5;
}
function R6(r) {
  exports.DEBUG && console.log(r.step, "RDTG[]"), r.round = g5;
}
function O6(r) {
  var e = r.stack.pop();
  exports.DEBUG && console.log(r.step, "SCANCTRL[]", e);
}
function gC(r, e) {
  var t = e.stack, n = t.pop(), i = t.pop(), a = e.z2[n], s = e.z1[i];
  exports.DEBUG && console.log(e.step, "SDPVTL[" + r + "]", n, i);
  var o, l;
  r ? (o = a.y - s.y, l = s.x - a.x) : (o = s.x - a.x, l = s.y - a.y), e.dpv = Md(o, l);
}
function B6(r) {
  var e = r.stack, t = e.pop(), n = 0;
  exports.DEBUG && console.log(r.step, "GETINFO[]", t), t & 1 && (n = 35), t & 32 && (n |= 4096), e.push(n);
}
function M6(r) {
  var e = r.stack, t = e.pop(), n = e.pop(), i = e.pop();
  exports.DEBUG && console.log(r.step, "ROLL[]"), e.push(n), e.push(t), e.push(i);
}
function _6(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "MAX[]", t, n), e.push(Math.max(n, t));
}
function N6(r) {
  var e = r.stack, t = e.pop(), n = e.pop();
  exports.DEBUG && console.log(r.step, "MIN[]", t, n), e.push(Math.min(n, t));
}
function L6(r) {
  var e = r.stack.pop();
  exports.DEBUG && console.log(r.step, "SCANTYPE[]", e);
}
function U6(r) {
  var e = r.stack.pop(), t = r.stack.pop();
  switch (exports.DEBUG && console.log(r.step, "INSTCTRL[]", e, t), e) {
    case 1:
      r.inhibitGridFit = !!t;
      return;
    case 2:
      r.ignoreCvt = !!t;
      return;
    default:
      throw new Error("invalid INSTCTRL[] selector");
  }
}
function Xs(r, e) {
  var t = e.stack, n = e.prog, i = e.ip;
  exports.DEBUG && console.log(e.step, "PUSHB[" + r + "]");
  for (var a = 0; a < r; a++)
    t.push(n[++i]);
  e.ip = i;
}
function Js(r, e) {
  var t = e.ip, n = e.prog, i = e.stack;
  exports.DEBUG && console.log(e.ip, "PUSHW[" + r + "]");
  for (var a = 0; a < r; a++) {
    var s = n[++t] << 8 | n[++t];
    s & 32768 && (s = -((s ^ 65535) + 1)), i.push(s);
  }
  e.ip = t;
}
function gt(r, e, t, n, i, a) {
  var s = a.stack, o = r && s.pop(), l = s.pop(), u = a.rp0, c = a.z0[u], d = a.z1[l], f = a.minDis, h = a.fv, g = a.dpv, v, y, A, x;
  y = v = g.distance(d, c, !0, !0), A = y >= 0 ? 1 : -1, y = Math.abs(y), r && (x = a.cvt[o], n && Math.abs(y - x) < a.cvCutIn && (y = x)), t && y < f && (y = f), n && (y = a.round(y)), h.setRelative(d, c, A * y, g), h.touch(d), exports.DEBUG && console.log(
    a.step,
    (r ? "MIRP[" : "MDRP[") + (e ? "M" : "m") + (t ? ">" : "_") + (n ? "R" : "_") + (i === 0 ? "Gr" : i === 1 ? "Bl" : i === 2 ? "Wh" : "") + "]",
    r ? o + "(" + a.cvt[o] + "," + x + ")" : "",
    l,
    "(d =",
    v,
    "->",
    A * y,
    ")"
  ), a.rp1 = a.rp0, a.rp2 = l, e && (a.rp0 = l);
}
QT = [
  /* 0x00 */
  tC.bind(void 0, Fs),
  /* 0x01 */
  tC.bind(void 0, ts),
  /* 0x02 */
  rC.bind(void 0, Fs),
  /* 0x03 */
  rC.bind(void 0, ts),
  /* 0x04 */
  nC.bind(void 0, Fs),
  /* 0x05 */
  nC.bind(void 0, ts),
  /* 0x06 */
  iC.bind(void 0, 0),
  /* 0x07 */
  iC.bind(void 0, 1),
  /* 0x08 */
  aC.bind(void 0, 0),
  /* 0x09 */
  aC.bind(void 0, 1),
  /* 0x0A */
  v5,
  /* 0x0B */
  y5,
  /* 0x0C */
  A5,
  /* 0x0D */
  b5,
  /* 0x0E */
  w5,
  /* 0x0F */
  x5,
  /* 0x10 */
  C5,
  /* 0x11 */
  S5,
  /* 0x12 */
  E5,
  /* 0x13 */
  k5,
  /* 0x14 */
  T5,
  /* 0x15 */
  F5,
  /* 0x16 */
  I5,
  /* 0x17 */
  D5,
  /* 0x18 */
  P5,
  /* 0x19 */
  R5,
  /* 0x1A */
  O5,
  /* 0x1B */
  B5,
  /* 0x1C */
  M5,
  /* 0x1D */
  _5,
  /* 0x1E */
  void 0,
  // TODO SSWCI
  /* 0x1F */
  void 0,
  // TODO SSW
  /* 0x20 */
  N5,
  /* 0x21 */
  v0,
  /* 0x22 */
  L5,
  /* 0x23 */
  U5,
  /* 0x24 */
  V5,
  /* 0x25 */
  H5,
  /* 0x26 */
  j5,
  /* 0x27 */
  void 0,
  // TODO ALIGNPTS
  /* 0x28 */
  void 0,
  /* 0x29 */
  void 0,
  // TODO UTP
  /* 0x2A */
  z5,
  /* 0x2B */
  $5,
  /* 0x2C */
  G5,
  /* 0x2D */
  void 0,
  // ENDF (eaten by FDEF)
  /* 0x2E */
  sC.bind(void 0, 0),
  /* 0x2F */
  sC.bind(void 0, 1),
  /* 0x30 */
  oC.bind(void 0, Fs),
  /* 0x31 */
  oC.bind(void 0, ts),
  /* 0x32 */
  lC.bind(void 0, 0),
  /* 0x33 */
  lC.bind(void 0, 1),
  /* 0x34 */
  uC.bind(void 0, 0),
  /* 0x35 */
  uC.bind(void 0, 1),
  /* 0x36 */
  cC.bind(void 0, 0),
  /* 0x37 */
  cC.bind(void 0, 1),
  /* 0x38 */
  q5,
  /* 0x39 */
  W5,
  /* 0x3A */
  fC.bind(void 0, 0),
  /* 0x3B */
  fC.bind(void 0, 1),
  /* 0x3C */
  Q5,
  /* 0x3D */
  Y5,
  /* 0x3E */
  dC.bind(void 0, 0),
  /* 0x3F */
  dC.bind(void 0, 1),
  /* 0x40 */
  X5,
  /* 0x41 */
  J5,
  /* 0x42 */
  K5,
  /* 0x43 */
  Z5,
  /* 0x44 */
  e6,
  /* 0x45 */
  t6,
  /* 0x46 */
  hC.bind(void 0, 0),
  /* 0x47 */
  hC.bind(void 0, 1),
  /* 0x48 */
  void 0,
  // TODO SCFS
  /* 0x49 */
  pC.bind(void 0, 0),
  /* 0x4A */
  pC.bind(void 0, 1),
  /* 0x4B */
  r6,
  /* 0x4C */
  void 0,
  // TODO MPS
  /* 0x4D */
  n6,
  /* 0x4E */
  void 0,
  // TODO FLIPOFF
  /* 0x4F */
  void 0,
  // TODO DEBUG
  /* 0x50 */
  i6,
  /* 0x51 */
  a6,
  /* 0x52 */
  s6,
  /* 0x53 */
  o6,
  /* 0x54 */
  l6,
  /* 0x55 */
  u6,
  /* 0x56 */
  c6,
  /* 0x57 */
  f6,
  /* 0x58 */
  d6,
  /* 0x59 */
  h6,
  /* 0x5A */
  p6,
  /* 0x5B */
  g6,
  /* 0x5C */
  m6,
  /* 0x5D */
  y0.bind(void 0, 1),
  /* 0x5E */
  v6,
  /* 0x5F */
  y6,
  /* 0x60 */
  A6,
  /* 0x61 */
  b6,
  /* 0x62 */
  w6,
  /* 0x63 */
  x6,
  /* 0x64 */
  C6,
  /* 0x65 */
  S6,
  /* 0x66 */
  E6,
  /* 0x67 */
  k6,
  /* 0x68 */
  Vh.bind(void 0, 0),
  /* 0x69 */
  Vh.bind(void 0, 1),
  /* 0x6A */
  Vh.bind(void 0, 2),
  /* 0x6B */
  Vh.bind(void 0, 3),
  /* 0x6C */
  void 0,
  // TODO NROUND[ab]
  /* 0x6D */
  void 0,
  // TODO NROUND[ab]
  /* 0x6E */
  void 0,
  // TODO NROUND[ab]
  /* 0x6F */
  void 0,
  // TODO NROUND[ab]
  /* 0x70 */
  T6,
  /* 0x71 */
  y0.bind(void 0, 2),
  /* 0x72 */
  y0.bind(void 0, 3),
  /* 0x73 */
  A0.bind(void 0, 1),
  /* 0x74 */
  A0.bind(void 0, 2),
  /* 0x75 */
  A0.bind(void 0, 3),
  /* 0x76 */
  F6,
  /* 0x77 */
  I6,
  /* 0x78 */
  void 0,
  // TODO JROT[]
  /* 0x79 */
  void 0,
  // TODO JROF[]
  /* 0x7A */
  D6,
  /* 0x7B */
  void 0,
  /* 0x7C */
  P6,
  /* 0x7D */
  R6,
  /* 0x7E */
  v0,
  // actually SANGW, supposed to do only a pop though
  /* 0x7F */
  v0,
  // actually AA, supposed to do only a pop though
  /* 0x80 */
  void 0,
  // TODO FLIPPT
  /* 0x81 */
  void 0,
  // TODO FLIPRGON
  /* 0x82 */
  void 0,
  // TODO FLIPRGOFF
  /* 0x83 */
  void 0,
  /* 0x84 */
  void 0,
  /* 0x85 */
  O6,
  /* 0x86 */
  gC.bind(void 0, 0),
  /* 0x87 */
  gC.bind(void 0, 1),
  /* 0x88 */
  B6,
  /* 0x89 */
  void 0,
  // TODO IDEF
  /* 0x8A */
  M6,
  /* 0x8B */
  _6,
  /* 0x8C */
  N6,
  /* 0x8D */
  L6,
  /* 0x8E */
  U6,
  /* 0x8F */
  void 0,
  /* 0x90 */
  void 0,
  /* 0x91 */
  void 0,
  /* 0x92 */
  void 0,
  /* 0x93 */
  void 0,
  /* 0x94 */
  void 0,
  /* 0x95 */
  void 0,
  /* 0x96 */
  void 0,
  /* 0x97 */
  void 0,
  /* 0x98 */
  void 0,
  /* 0x99 */
  void 0,
  /* 0x9A */
  void 0,
  /* 0x9B */
  void 0,
  /* 0x9C */
  void 0,
  /* 0x9D */
  void 0,
  /* 0x9E */
  void 0,
  /* 0x9F */
  void 0,
  /* 0xA0 */
  void 0,
  /* 0xA1 */
  void 0,
  /* 0xA2 */
  void 0,
  /* 0xA3 */
  void 0,
  /* 0xA4 */
  void 0,
  /* 0xA5 */
  void 0,
  /* 0xA6 */
  void 0,
  /* 0xA7 */
  void 0,
  /* 0xA8 */
  void 0,
  /* 0xA9 */
  void 0,
  /* 0xAA */
  void 0,
  /* 0xAB */
  void 0,
  /* 0xAC */
  void 0,
  /* 0xAD */
  void 0,
  /* 0xAE */
  void 0,
  /* 0xAF */
  void 0,
  /* 0xB0 */
  Xs.bind(void 0, 1),
  /* 0xB1 */
  Xs.bind(void 0, 2),
  /* 0xB2 */
  Xs.bind(void 0, 3),
  /* 0xB3 */
  Xs.bind(void 0, 4),
  /* 0xB4 */
  Xs.bind(void 0, 5),
  /* 0xB5 */
  Xs.bind(void 0, 6),
  /* 0xB6 */
  Xs.bind(void 0, 7),
  /* 0xB7 */
  Xs.bind(void 0, 8),
  /* 0xB8 */
  Js.bind(void 0, 1),
  /* 0xB9 */
  Js.bind(void 0, 2),
  /* 0xBA */
  Js.bind(void 0, 3),
  /* 0xBB */
  Js.bind(void 0, 4),
  /* 0xBC */
  Js.bind(void 0, 5),
  /* 0xBD */
  Js.bind(void 0, 6),
  /* 0xBE */
  Js.bind(void 0, 7),
  /* 0xBF */
  Js.bind(void 0, 8),
  /* 0xC0 */
  gt.bind(void 0, 0, 0, 0, 0, 0),
  /* 0xC1 */
  gt.bind(void 0, 0, 0, 0, 0, 1),
  /* 0xC2 */
  gt.bind(void 0, 0, 0, 0, 0, 2),
  /* 0xC3 */
  gt.bind(void 0, 0, 0, 0, 0, 3),
  /* 0xC4 */
  gt.bind(void 0, 0, 0, 0, 1, 0),
  /* 0xC5 */
  gt.bind(void 0, 0, 0, 0, 1, 1),
  /* 0xC6 */
  gt.bind(void 0, 0, 0, 0, 1, 2),
  /* 0xC7 */
  gt.bind(void 0, 0, 0, 0, 1, 3),
  /* 0xC8 */
  gt.bind(void 0, 0, 0, 1, 0, 0),
  /* 0xC9 */
  gt.bind(void 0, 0, 0, 1, 0, 1),
  /* 0xCA */
  gt.bind(void 0, 0, 0, 1, 0, 2),
  /* 0xCB */
  gt.bind(void 0, 0, 0, 1, 0, 3),
  /* 0xCC */
  gt.bind(void 0, 0, 0, 1, 1, 0),
  /* 0xCD */
  gt.bind(void 0, 0, 0, 1, 1, 1),
  /* 0xCE */
  gt.bind(void 0, 0, 0, 1, 1, 2),
  /* 0xCF */
  gt.bind(void 0, 0, 0, 1, 1, 3),
  /* 0xD0 */
  gt.bind(void 0, 0, 1, 0, 0, 0),
  /* 0xD1 */
  gt.bind(void 0, 0, 1, 0, 0, 1),
  /* 0xD2 */
  gt.bind(void 0, 0, 1, 0, 0, 2),
  /* 0xD3 */
  gt.bind(void 0, 0, 1, 0, 0, 3),
  /* 0xD4 */
  gt.bind(void 0, 0, 1, 0, 1, 0),
  /* 0xD5 */
  gt.bind(void 0, 0, 1, 0, 1, 1),
  /* 0xD6 */
  gt.bind(void 0, 0, 1, 0, 1, 2),
  /* 0xD7 */
  gt.bind(void 0, 0, 1, 0, 1, 3),
  /* 0xD8 */
  gt.bind(void 0, 0, 1, 1, 0, 0),
  /* 0xD9 */
  gt.bind(void 0, 0, 1, 1, 0, 1),
  /* 0xDA */
  gt.bind(void 0, 0, 1, 1, 0, 2),
  /* 0xDB */
  gt.bind(void 0, 0, 1, 1, 0, 3),
  /* 0xDC */
  gt.bind(void 0, 0, 1, 1, 1, 0),
  /* 0xDD */
  gt.bind(void 0, 0, 1, 1, 1, 1),
  /* 0xDE */
  gt.bind(void 0, 0, 1, 1, 1, 2),
  /* 0xDF */
  gt.bind(void 0, 0, 1, 1, 1, 3),
  /* 0xE0 */
  gt.bind(void 0, 1, 0, 0, 0, 0),
  /* 0xE1 */
  gt.bind(void 0, 1, 0, 0, 0, 1),
  /* 0xE2 */
  gt.bind(void 0, 1, 0, 0, 0, 2),
  /* 0xE3 */
  gt.bind(void 0, 1, 0, 0, 0, 3),
  /* 0xE4 */
  gt.bind(void 0, 1, 0, 0, 1, 0),
  /* 0xE5 */
  gt.bind(void 0, 1, 0, 0, 1, 1),
  /* 0xE6 */
  gt.bind(void 0, 1, 0, 0, 1, 2),
  /* 0xE7 */
  gt.bind(void 0, 1, 0, 0, 1, 3),
  /* 0xE8 */
  gt.bind(void 0, 1, 0, 1, 0, 0),
  /* 0xE9 */
  gt.bind(void 0, 1, 0, 1, 0, 1),
  /* 0xEA */
  gt.bind(void 0, 1, 0, 1, 0, 2),
  /* 0xEB */
  gt.bind(void 0, 1, 0, 1, 0, 3),
  /* 0xEC */
  gt.bind(void 0, 1, 0, 1, 1, 0),
  /* 0xED */
  gt.bind(void 0, 1, 0, 1, 1, 1),
  /* 0xEE */
  gt.bind(void 0, 1, 0, 1, 1, 2),
  /* 0xEF */
  gt.bind(void 0, 1, 0, 1, 1, 3),
  /* 0xF0 */
  gt.bind(void 0, 1, 1, 0, 0, 0),
  /* 0xF1 */
  gt.bind(void 0, 1, 1, 0, 0, 1),
  /* 0xF2 */
  gt.bind(void 0, 1, 1, 0, 0, 2),
  /* 0xF3 */
  gt.bind(void 0, 1, 1, 0, 0, 3),
  /* 0xF4 */
  gt.bind(void 0, 1, 1, 0, 1, 0),
  /* 0xF5 */
  gt.bind(void 0, 1, 1, 0, 1, 1),
  /* 0xF6 */
  gt.bind(void 0, 1, 1, 0, 1, 2),
  /* 0xF7 */
  gt.bind(void 0, 1, 1, 0, 1, 3),
  /* 0xF8 */
  gt.bind(void 0, 1, 1, 1, 0, 0),
  /* 0xF9 */
  gt.bind(void 0, 1, 1, 1, 0, 1),
  /* 0xFA */
  gt.bind(void 0, 1, 1, 1, 0, 2),
  /* 0xFB */
  gt.bind(void 0, 1, 1, 1, 0, 3),
  /* 0xFC */
  gt.bind(void 0, 1, 1, 1, 1, 0),
  /* 0xFD */
  gt.bind(void 0, 1, 1, 1, 1, 1),
  /* 0xFE */
  gt.bind(void 0, 1, 1, 1, 1, 2),
  /* 0xFF */
  gt.bind(void 0, 1, 1, 1, 1, 3)
];
function lc(r) {
  this.char = r, this.state = {}, this.activeState = null;
}
function a1(r, e, t) {
  this.contextName = t, this.startIndex = r, this.endOffset = e;
}
function V6(r, e, t) {
  this.contextName = r, this.openRange = null, this.ranges = [], this.checkStart = e, this.checkEnd = t;
}
function Da(r, e) {
  this.context = r, this.index = e, this.length = r.length, this.current = r[e], this.backtrack = r.slice(0, e), this.lookahead = r.slice(e + 1);
}
function Bg(r) {
  this.eventId = r, this.subscribers = [];
}
function z6(r) {
  var e = this, t = [
    "start",
    "end",
    "next",
    "newToken",
    "contextStart",
    "contextEnd",
    "insertToken",
    "removeToken",
    "removeRange",
    "replaceToken",
    "replaceRange",
    "composeRUD",
    "updateContextsRanges"
  ];
  t.forEach(function(i) {
    Object.defineProperty(e.events, i, {
      value: new Bg(i)
    });
  }), r && t.forEach(function(i) {
    var a = r[i];
    typeof a == "function" && e.events[i].subscribe(a);
  });
  var n = [
    "insertToken",
    "removeToken",
    "removeRange",
    "replaceToken",
    "replaceRange",
    "composeRUD"
  ];
  n.forEach(function(i) {
    e.events[i].subscribe(
      e.updateContextsRanges
    );
  });
}
function Hn(r) {
  this.tokens = [], this.registeredContexts = {}, this.contextCheckers = [], this.events = {}, this.registeredModifiers = [], z6.call(this, r);
}
lc.prototype.setState = function(r, e) {
  return this.state[r] = e, this.activeState = { key: r, value: this.state[r] }, this.activeState;
};
lc.prototype.getState = function(r) {
  return this.state[r] || null;
};
Hn.prototype.inboundIndex = function(r) {
  return r >= 0 && r < this.tokens.length;
};
Hn.prototype.composeRUD = function(r) {
  var e = this, t = !0, n = r.map(function(a) {
    return e[a[0]].apply(e, a.slice(1).concat(t));
  }), i = function(a) {
    return typeof a == "object" && a.hasOwnProperty("FAIL");
  };
  if (n.every(i))
    return {
      FAIL: "composeRUD: one or more operations hasn't completed successfully",
      report: n.filter(i)
    };
  this.dispatch("composeRUD", [n.filter(function(a) {
    return !i(a);
  })]);
};
Hn.prototype.replaceRange = function(r, e, t, n) {
  e = e !== null ? e : this.tokens.length;
  var i = t.every(function(s) {
    return s instanceof lc;
  });
  if (!isNaN(r) && this.inboundIndex(r) && i) {
    var a = this.tokens.splice.apply(
      this.tokens,
      [r, e].concat(t)
    );
    return n || this.dispatch("replaceToken", [r, e, t]), [a, t];
  } else
    return { FAIL: "replaceRange: invalid tokens or startIndex." };
};
Hn.prototype.replaceToken = function(r, e, t) {
  if (!isNaN(r) && this.inboundIndex(r) && e instanceof lc) {
    var n = this.tokens.splice(r, 1, e);
    return t || this.dispatch("replaceToken", [r, e]), [n[0], e];
  } else
    return { FAIL: "replaceToken: invalid token or index." };
};
Hn.prototype.removeRange = function(r, e, t) {
  e = isNaN(e) ? this.tokens.length : e;
  var n = this.tokens.splice(r, e);
  return t || this.dispatch("removeRange", [n, r, e]), n;
};
Hn.prototype.removeToken = function(r, e) {
  if (!isNaN(r) && this.inboundIndex(r)) {
    var t = this.tokens.splice(r, 1);
    return e || this.dispatch("removeToken", [t, r]), t;
  } else
    return { FAIL: "removeToken: invalid token index." };
};
Hn.prototype.insertToken = function(r, e, t) {
  var n = r.every(
    function(i) {
      return i instanceof lc;
    }
  );
  return n ? (this.tokens.splice.apply(
    this.tokens,
    [e, 0].concat(r)
  ), t || this.dispatch("insertToken", [r, e]), r) : { FAIL: "insertToken: invalid token(s)." };
};
Hn.prototype.registerModifier = function(r, e, t) {
  this.events.newToken.subscribe(function(n, i) {
    var a = [n, i], s = e === null || e.apply(this, a) === !0, o = [n, i];
    if (s) {
      var l = t.apply(this, o);
      n.setState(r, l);
    }
  }), this.registeredModifiers.push(r);
};
Bg.prototype.subscribe = function(r) {
  return typeof r == "function" ? this.subscribers.push(r) - 1 : { FAIL: "invalid '" + this.eventId + "' event handler" };
};
Bg.prototype.unsubscribe = function(r) {
  this.subscribers.splice(r, 1);
};
Da.prototype.setCurrentIndex = function(r) {
  this.index = r, this.current = this.context[r], this.backtrack = this.context.slice(0, r), this.lookahead = this.context.slice(r + 1);
};
Da.prototype.get = function(r) {
  switch (!0) {
    case r === 0:
      return this.current;
    case (r < 0 && Math.abs(r) <= this.backtrack.length):
      return this.backtrack.slice(r)[0];
    case (r > 0 && r <= this.lookahead.length):
      return this.lookahead[r - 1];
    default:
      return null;
  }
};
Hn.prototype.rangeToText = function(r) {
  if (r instanceof a1)
    return this.getRangeTokens(r).map(function(e) {
      return e.char;
    }).join("");
};
Hn.prototype.getText = function() {
  return this.tokens.map(function(r) {
    return r.char;
  }).join("");
};
Hn.prototype.getContext = function(r) {
  var e = this.registeredContexts[r];
  return e || null;
};
Hn.prototype.on = function(r, e) {
  var t = this.events[r];
  return t ? t.subscribe(e) : null;
};
Hn.prototype.dispatch = function(r, e) {
  var t = this, n = this.events[r];
  n instanceof Bg && n.subscribers.forEach(function(i) {
    i.apply(t, e || []);
  });
};
Hn.prototype.registerContextChecker = function(r, e, t) {
  if (this.getContext(r))
    return {
      FAIL: "context name '" + r + "' is already registered."
    };
  if (typeof e != "function")
    return {
      FAIL: "missing context start check."
    };
  if (typeof t != "function")
    return {
      FAIL: "missing context end check."
    };
  var n = new V6(
    r,
    e,
    t
  );
  return this.registeredContexts[r] = n, this.contextCheckers.push(n), n;
};
Hn.prototype.getRangeTokens = function(r) {
  var e = r.startIndex + r.endOffset;
  return [].concat(
    this.tokens.slice(r.startIndex, e)
  );
};
Hn.prototype.getContextRanges = function(r) {
  var e = this.getContext(r);
  return e ? e.ranges : { FAIL: "context checker '" + r + "' is not registered." };
};
Hn.prototype.resetContextsRanges = function() {
  var r = this.registeredContexts;
  for (var e in r)
    if (r.hasOwnProperty(e)) {
      var t = r[e];
      t.ranges = [];
    }
};
Hn.prototype.updateContextsRanges = function() {
  this.resetContextsRanges();
  for (var r = this.tokens.map(function(n) {
    return n.char;
  }), e = 0; e < r.length; e++) {
    var t = new Da(r, e);
    this.runContextCheck(t);
  }
  this.dispatch("updateContextsRanges", [this.registeredContexts]);
};
Hn.prototype.setEndOffset = function(r, e) {
  var t = this.getContext(e).openRange.startIndex, n = new a1(t, r, e), i = this.getContext(e).ranges;
  return n.rangeId = e + "." + i.length, i.push(n), this.getContext(e).openRange = null, n;
};
Hn.prototype.runContextCheck = function(r) {
  var e = this, t = r.index;
  this.contextCheckers.forEach(function(n) {
    var i = n.contextName, a = e.getContext(i).openRange;
    if (!a && n.checkStart(r) && (a = new a1(t, null, i), e.getContext(i).openRange = a, e.dispatch("contextStart", [i, t])), a && n.checkEnd(r)) {
      var s = t - a.startIndex + 1, o = e.setEndOffset(s, i);
      e.dispatch("contextEnd", [i, o]);
    }
  });
};
Hn.prototype.tokenize = function(r) {
  this.tokens = [], this.resetContextsRanges();
  var e = Array.from(r);
  this.dispatch("start");
  for (var t = 0; t < e.length; t++) {
    var n = e[t], i = new Da(e, t);
    this.dispatch("next", [i]), this.runContextCheck(i);
    var a = new lc(n);
    this.tokens.push(a), this.dispatch("newToken", [a, i]);
  }
  return this.dispatch("end", [this.tokens]), this.tokens;
};
function po(r) {
  return /[\u0600-\u065F\u066A-\u06D2\u06FA-\u06FF]/.test(r);
}
function eF(r) {
  return /[\u0630\u0690\u0621\u0631\u0661\u0671\u0622\u0632\u0672\u0692\u06C2\u0623\u0673\u0693\u06C3\u0624\u0694\u06C4\u0625\u0675\u0695\u06C5\u06E5\u0676\u0696\u06C6\u0627\u0677\u0697\u06C7\u0648\u0688\u0698\u06C8\u0689\u0699\u06C9\u068A\u06CA\u066B\u068B\u06CB\u068C\u068D\u06CD\u06FD\u068E\u06EE\u06FE\u062F\u068F\u06CF\u06EF]/.test(r);
}
function Co(r) {
  return /[\u0600-\u0605\u060C-\u060E\u0610-\u061B\u061E\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED]/.test(r);
}
function _p(r) {
  return /[A-z]/.test(r);
}
function $6(r) {
  return /\s/.test(r);
}
function ia(r) {
  this.font = r, this.features = {};
}
function dl(r) {
  this.id = r.id, this.tag = r.tag, this.substitution = r.substitution;
}
function _d(r, e) {
  if (!r)
    return -1;
  switch (e.format) {
    case 1:
      return e.glyphs.indexOf(r);
    case 2:
      for (var t = e.ranges, n = 0; n < t.length; n++) {
        var i = t[n];
        if (r >= i.start && r <= i.end) {
          var a = r - i.start;
          return i.index + a;
        }
      }
      break;
    default:
      return -1;
  }
  return -1;
}
function H6(r, e) {
  var t = _d(r, e.coverage);
  return t === -1 ? null : r + e.deltaGlyphId;
}
function j6(r, e) {
  var t = _d(r, e.coverage);
  return t === -1 ? null : e.substitute[t];
}
function b0(r, e) {
  for (var t = [], n = 0; n < r.length; n++) {
    var i = r[n], a = e.current;
    a = Array.isArray(a) ? a[0] : a;
    var s = _d(a, i);
    s !== -1 && t.push(s);
  }
  return t.length !== r.length ? -1 : t;
}
function G6(r, e) {
  var t = e.inputCoverage.length + e.lookaheadCoverage.length + e.backtrackCoverage.length;
  if (r.context.length < t)
    return [];
  var n = b0(
    e.inputCoverage,
    r
  );
  if (n === -1)
    return [];
  var i = e.inputCoverage.length - 1;
  if (r.lookahead.length < e.lookaheadCoverage.length)
    return [];
  for (var a = r.lookahead.slice(i); a.length && Co(a[0].char); )
    a.shift();
  var s = new Da(a, 0), o = b0(
    e.lookaheadCoverage,
    s
  ), l = [].concat(r.backtrack);
  for (l.reverse(); l.length && Co(l[0].char); )
    l.shift();
  if (l.length < e.backtrackCoverage.length)
    return [];
  var u = new Da(l, 0), c = b0(
    e.backtrackCoverage,
    u
  ), d = n.length === e.inputCoverage.length && o.length === e.lookaheadCoverage.length && c.length === e.backtrackCoverage.length, f = [];
  if (d)
    for (var h = 0; h < e.lookupRecords.length; h++)
      for (var g = e.lookupRecords[h], v = g.lookupListIndex, y = this.getLookupByIndex(v), A = 0; A < y.subtables.length; A++) {
        var x = y.subtables[A], k = this.getLookupMethod(y, x), F = this.getSubstitutionType(y, x);
        if (F === "12")
          for (var S = 0; S < n.length; S++) {
            var R = r.get(S), M = k(R);
            M && f.push(M);
          }
      }
  return f;
}
function q6(r, e) {
  var t = r.current, n = _d(t, e.coverage);
  if (n === -1)
    return null;
  for (var i, a = e.ligatureSets[n], s = 0; s < a.length; s++) {
    i = a[s];
    for (var o = 0; o < i.components.length; o++) {
      var l = r.lookahead[o], u = i.components[o];
      if (l !== u)
        break;
      if (o === i.components.length - 1)
        return i;
    }
  }
  return null;
}
function W6(r, e) {
  var t = _d(r, e.coverage);
  return t === -1 ? null : e.sequences[t];
}
ia.prototype.getDefaultScriptFeaturesIndexes = function() {
  for (var r = this.font.tables.gsub.scripts, e = 0; e < r.length; e++) {
    var t = r[e];
    if (t.tag === "DFLT")
      return t.script.defaultLangSys.featureIndexes;
  }
  return [];
};
ia.prototype.getScriptFeaturesIndexes = function(r) {
  var e = this.font.tables;
  if (!e.gsub)
    return [];
  if (!r)
    return this.getDefaultScriptFeaturesIndexes();
  for (var t = this.font.tables.gsub.scripts, n = 0; n < t.length; n++) {
    var i = t[n];
    if (i.tag === r && i.script.defaultLangSys)
      return i.script.defaultLangSys.featureIndexes;
    var a = i.langSysRecords;
    if (a)
      for (var s = 0; s < a.length; s++) {
        var o = a[s];
        if (o.tag === r) {
          var l = o.langSys;
          return l.featureIndexes;
        }
      }
  }
  return this.getDefaultScriptFeaturesIndexes();
};
ia.prototype.mapTagsToFeatures = function(r, e) {
  for (var t = {}, n = 0; n < r.length; n++) {
    var i = r[n].tag, a = r[n].feature;
    t[i] = a;
  }
  this.features[e].tags = t;
};
ia.prototype.getScriptFeatures = function(r) {
  var e = this.features[r];
  if (this.features.hasOwnProperty(r))
    return e;
  var t = this.getScriptFeaturesIndexes(r);
  if (!t)
    return null;
  var n = this.font.tables.gsub;
  return e = t.map(function(i) {
    return n.features[i];
  }), this.features[r] = e, this.mapTagsToFeatures(e, r), e;
};
ia.prototype.getSubstitutionType = function(r, e) {
  var t = r.lookupType.toString(), n = e.substFormat.toString();
  return t + n;
};
ia.prototype.getLookupMethod = function(r, e) {
  var t = this, n = this.getSubstitutionType(r, e);
  switch (n) {
    case "11":
      return function(i) {
        return H6.apply(
          t,
          [i, e]
        );
      };
    case "12":
      return function(i) {
        return j6.apply(
          t,
          [i, e]
        );
      };
    case "63":
      return function(i) {
        return G6.apply(
          t,
          [i, e]
        );
      };
    case "41":
      return function(i) {
        return q6.apply(
          t,
          [i, e]
        );
      };
    case "21":
      return function(i) {
        return W6.apply(
          t,
          [i, e]
        );
      };
    default:
      throw new Error(
        "lookupType: " + r.lookupType + " - substFormat: " + e.substFormat + " is not yet supported"
      );
  }
};
ia.prototype.lookupFeature = function(r) {
  var e = r.contextParams, t = e.index, n = this.getFeature({
    tag: r.tag,
    script: r.script
  });
  if (!n)
    return new Error(
      "font '" + this.font.names.fullName.en + "' doesn't support feature '" + r.tag + "' for script '" + r.script + "'."
    );
  for (var i = this.getFeatureLookups(n), a = [].concat(e.context), s = 0; s < i.length; s++)
    for (var o = i[s], l = this.getLookupSubtables(o), u = 0; u < l.length; u++) {
      var c = l[u], d = this.getSubstitutionType(o, c), f = this.getLookupMethod(o, c), h = void 0;
      switch (d) {
        case "11":
          h = f(e.current), h && a.splice(t, 1, new dl({
            id: 11,
            tag: r.tag,
            substitution: h
          }));
          break;
        case "12":
          h = f(e.current), h && a.splice(t, 1, new dl({
            id: 12,
            tag: r.tag,
            substitution: h
          }));
          break;
        case "63":
          h = f(e), Array.isArray(h) && h.length && a.splice(t, 1, new dl({
            id: 63,
            tag: r.tag,
            substitution: h
          }));
          break;
        case "41":
          h = f(e), h && a.splice(t, 1, new dl({
            id: 41,
            tag: r.tag,
            substitution: h
          }));
          break;
        case "21":
          h = f(e.current), h && a.splice(t, 1, new dl({
            id: 21,
            tag: r.tag,
            substitution: h
          }));
          break;
      }
      e = new Da(a, t), !(Array.isArray(h) && !h.length) && (h = null);
    }
  return a.length ? a : null;
};
ia.prototype.supports = function(r) {
  if (!r.script)
    return !1;
  this.getScriptFeatures(r.script);
  var e = this.features.hasOwnProperty(r.script);
  if (!r.tag)
    return e;
  var t = this.features[r.script].some(function(n) {
    return n.tag === r.tag;
  });
  return e && t;
};
ia.prototype.getLookupSubtables = function(r) {
  return r.subtables || null;
};
ia.prototype.getLookupByIndex = function(r) {
  var e = this.font.tables.gsub.lookups;
  return e[r] || null;
};
ia.prototype.getFeatureLookups = function(r) {
  return r.lookupListIndexes.map(this.getLookupByIndex.bind(this));
};
ia.prototype.getFeature = function(e) {
  if (!this.font)
    return { FAIL: "No font was found" };
  this.features.hasOwnProperty(e.script) || this.getScriptFeatures(e.script);
  var t = this.features[e.script];
  return t ? t.tags[e.tag] ? this.features[e.script].tags[e.tag] : null : { FAIL: "No feature for script " + e.script };
};
function Q6(r) {
  var e = r.current, t = r.get(-1);
  return (
    // ? arabic first char
    t === null && po(e) || // ? arabic char preceded with a non arabic char
    !po(t) && po(e)
  );
}
function Y6(r) {
  var e = r.get(1);
  return (
    // ? last arabic char
    e === null || // ? next char is not arabic
    !po(e)
  );
}
var X6 = {
  startCheck: Q6,
  endCheck: Y6
};
function J6(r) {
  var e = r.current, t = r.get(-1);
  return (
    // ? an arabic char preceded with a non arabic char
    (po(e) || Co(e)) && !po(t)
  );
}
function K6(r) {
  var e = r.get(1);
  switch (!0) {
    case e === null:
      return !0;
    case (!po(e) && !Co(e)):
      var t = $6(e);
      if (!t)
        return !0;
      if (t) {
        var n = !1;
        if (n = r.lookahead.some(
          function(i) {
            return po(i) || Co(i);
          }
        ), !n)
          return !0;
      }
      break;
    default:
      return !1;
  }
}
var Z6 = {
  startCheck: J6,
  endCheck: K6
};
function eN(r, e, t) {
  e[t].setState(r.tag, r.substitution);
}
function tN(r, e, t) {
  e[t].setState(r.tag, r.substitution);
}
function rN(r, e, t) {
  r.substitution.forEach(function(n, i) {
    var a = e[t + i];
    a.setState(r.tag, n);
  });
}
function nN(r, e, t) {
  var n = e[t];
  n.setState(r.tag, r.substitution.ligGlyph);
  for (var i = r.substitution.components.length, a = 0; a < i; a++)
    n = e[t + a + 1], n.setState("deleted", !0);
}
var mC = {
  11: eN,
  12: tN,
  63: rN,
  41: nN
};
function s1(r, e, t) {
  r instanceof dl && mC[r.id] && mC[r.id](r, e, t);
}
function iN(r) {
  for (var e = [].concat(r.backtrack), t = e.length - 1; t >= 0; t--) {
    var n = e[t], i = eF(n), a = Co(n);
    if (!i && !a)
      return !0;
    if (i)
      return !1;
  }
  return !1;
}
function aN(r) {
  if (eF(r.current))
    return !1;
  for (var e = 0; e < r.lookahead.length; e++) {
    var t = r.lookahead[e], n = Co(t);
    if (!n)
      return !0;
  }
  return !1;
}
function sN(r) {
  var e = this, t = "arab", n = this.featuresTags[t], i = this.tokenizer.getRangeTokens(r);
  if (i.length !== 1) {
    var a = new Da(
      i.map(
        function(o) {
          return o.getState("glyphIndex");
        }
      ),
      0
    ), s = new Da(
      i.map(
        function(o) {
          return o.char;
        }
      ),
      0
    );
    i.forEach(function(o, l) {
      if (!Co(o.char)) {
        a.setCurrentIndex(l), s.setCurrentIndex(l);
        var u = 0;
        iN(s) && (u |= 1), aN(s) && (u |= 2);
        var c;
        switch (u) {
          case 1:
            c = "fina";
            break;
          case 2:
            c = "init";
            break;
          case 3:
            c = "medi";
            break;
        }
        if (n.indexOf(c) !== -1) {
          var d = e.query.lookupFeature({
            tag: c,
            script: t,
            contextParams: a
          });
          if (d instanceof Error)
            return console.info(d.message);
          d.forEach(function(f, h) {
            f instanceof dl && (s1(f, i, h), a.context[h] = f.substitution);
          });
        }
      }
    });
  }
}
function vC(r, e) {
  var t = r.map(function(n) {
    return n.activeState.value;
  });
  return new Da(t, 0);
}
function oN(r) {
  var e = this, t = "arab", n = this.tokenizer.getRangeTokens(r), i = vC(n);
  i.context.forEach(function(a, s) {
    i.setCurrentIndex(s);
    var o = e.query.lookupFeature({
      tag: "rlig",
      script: t,
      contextParams: i
    });
    o.length && (o.forEach(
      function(l) {
        return s1(l, n, s);
      }
    ), i = vC(n));
  });
}
function lN(r) {
  var e = r.current, t = r.get(-1);
  return (
    // ? latin first char
    t === null && _p(e) || // ? latin char preceded with a non latin char
    !_p(t) && _p(e)
  );
}
function uN(r) {
  var e = r.get(1);
  return (
    // ? last latin char
    e === null || // ? next char is not latin
    !_p(e)
  );
}
var cN = {
  startCheck: lN,
  endCheck: uN
};
function yC(r, e) {
  var t = r.map(function(n) {
    return n.activeState.value;
  });
  return new Da(t, 0);
}
function fN(r) {
  var e = this, t = "latn", n = this.tokenizer.getRangeTokens(r), i = yC(n);
  i.context.forEach(function(a, s) {
    i.setCurrentIndex(s);
    var o = e.query.lookupFeature({
      tag: "liga",
      script: t,
      contextParams: i
    });
    o.length && (o.forEach(
      function(l) {
        return s1(l, n, s);
      }
    ), i = yC(n));
  });
}
function _a(r) {
  this.baseDir = r || "ltr", this.tokenizer = new Hn(), this.featuresTags = {};
}
_a.prototype.setText = function(r) {
  this.text = r;
};
_a.prototype.contextChecks = {
  latinWordCheck: cN,
  arabicWordCheck: X6,
  arabicSentenceCheck: Z6
};
function w0(r) {
  var e = this.contextChecks[r + "Check"];
  return this.tokenizer.registerContextChecker(
    r,
    e.startCheck,
    e.endCheck
  );
}
function dN() {
  return w0.call(this, "latinWord"), w0.call(this, "arabicWord"), w0.call(this, "arabicSentence"), this.tokenizer.tokenize(this.text);
}
function hN() {
  var r = this, e = this.tokenizer.getContextRanges("arabicSentence");
  e.forEach(function(t) {
    var n = r.tokenizer.getRangeTokens(t);
    r.tokenizer.replaceRange(
      t.startIndex,
      t.endOffset,
      n.reverse()
    );
  });
}
_a.prototype.registerFeatures = function(r, e) {
  var t = this, n = e.filter(
    function(i) {
      return t.query.supports({ script: r, tag: i });
    }
  );
  this.featuresTags.hasOwnProperty(r) ? this.featuresTags[r] = this.featuresTags[r].concat(n) : this.featuresTags[r] = n;
};
_a.prototype.applyFeatures = function(r, e) {
  if (!r)
    throw new Error(
      "No valid font was provided to apply features"
    );
  this.query || (this.query = new ia(r));
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    this.query.supports({ script: n.script }) && this.registerFeatures(n.script, n.tags);
  }
};
_a.prototype.registerModifier = function(r, e, t) {
  this.tokenizer.registerModifier(r, e, t);
};
function o1() {
  if (this.tokenizer.registeredModifiers.indexOf("glyphIndex") === -1)
    throw new Error(
      "glyphIndex modifier is required to apply arabic presentation features."
    );
}
function pN() {
  var r = this, e = "arab";
  if (this.featuresTags.hasOwnProperty(e)) {
    o1.call(this);
    var t = this.tokenizer.getContextRanges("arabicWord");
    t.forEach(function(n) {
      sN.call(r, n);
    });
  }
}
function gN() {
  var r = this, e = "arab";
  if (this.featuresTags.hasOwnProperty(e)) {
    var t = this.featuresTags[e];
    if (t.indexOf("rlig") !== -1) {
      o1.call(this);
      var n = this.tokenizer.getContextRanges("arabicWord");
      n.forEach(function(i) {
        oN.call(r, i);
      });
    }
  }
}
function mN() {
  var r = this, e = "latn";
  if (this.featuresTags.hasOwnProperty(e)) {
    var t = this.featuresTags[e];
    if (t.indexOf("liga") !== -1) {
      o1.call(this);
      var n = this.tokenizer.getContextRanges("latinWord");
      n.forEach(function(i) {
        fN.call(r, i);
      });
    }
  }
}
_a.prototype.checkContextReady = function(r) {
  return !!this.tokenizer.getContext(r);
};
_a.prototype.applyFeaturesToContexts = function() {
  this.checkContextReady("arabicWord") && (pN.call(this), gN.call(this)), this.checkContextReady("latinWord") && mN.call(this), this.checkContextReady("arabicSentence") && hN.call(this);
};
_a.prototype.processText = function(r) {
  (!this.text || this.text !== r) && (this.setText(r), dN.call(this), this.applyFeaturesToContexts());
};
_a.prototype.getBidiText = function(r) {
  return this.processText(r), this.tokenizer.getText();
};
_a.prototype.getTextGlyphs = function(r) {
  this.processText(r);
  for (var e = [], t = 0; t < this.tokenizer.tokens.length; t++) {
    var n = this.tokenizer.tokens[t];
    if (!n.state.deleted) {
      var i = n.activeState.value;
      e.push(Array.isArray(i) ? i[0] : i);
    }
  }
  return e;
};
function hn(r) {
  r = r || {}, r.tables = r.tables || {}, r.empty || (uf(r.familyName, "When creating a new Font object, familyName is required."), uf(r.styleName, "When creating a new Font object, styleName is required."), uf(r.unitsPerEm, "When creating a new Font object, unitsPerEm is required."), uf(r.ascender, "When creating a new Font object, ascender is required."), uf(r.descender <= 0, "When creating a new Font object, negative descender value is required."), this.names = {
    fontFamily: { en: r.familyName || " " },
    fontSubfamily: { en: r.styleName || " " },
    fullName: { en: r.fullName || r.familyName + " " + r.styleName },
    // postScriptName may not contain any whitespace
    postScriptName: { en: r.postScriptName || (r.familyName + r.styleName).replace(/\s/g, "") },
    designer: { en: r.designer || " " },
    designerURL: { en: r.designerURL || " " },
    manufacturer: { en: r.manufacturer || " " },
    manufacturerURL: { en: r.manufacturerURL || " " },
    license: { en: r.license || " " },
    licenseURL: { en: r.licenseURL || " " },
    version: { en: r.version || "Version 0.1" },
    description: { en: r.description || " " },
    copyright: { en: r.copyright || " " },
    trademark: { en: r.trademark || " " }
  }, this.unitsPerEm = r.unitsPerEm || 1e3, this.ascender = r.ascender, this.descender = r.descender, this.createdTimestamp = r.createdTimestamp, this.tables = Object.assign(r.tables, {
    os2: Object.assign({
      usWeightClass: r.weightClass || this.usWeightClasses.MEDIUM,
      usWidthClass: r.widthClass || this.usWidthClasses.MEDIUM,
      fsSelection: r.fsSelection || this.fsSelectionValues.REGULAR
    }, r.tables.os2)
  })), this.supported = !0, this.glyphs = new is.GlyphSet(this, r.glyphs || []), this.encoding = new AT(this), this.position = new Od(this), this.substitution = new na(this), this.tables = this.tables || {}, this._push = null, this._hmtxTableData = {}, Object.defineProperty(this, "hinting", {
    get: function() {
      if (this._hinting)
        return this._hinting;
      if (this.outlinesFormat === "truetype")
        return this._hinting = new XT(this);
    }
  });
}
hn.prototype.hasChar = function(r) {
  return this.encoding.charToGlyphIndex(r) !== null;
};
hn.prototype.charToGlyphIndex = function(r) {
  return this.encoding.charToGlyphIndex(r);
};
hn.prototype.charToGlyph = function(r) {
  var e = this.charToGlyphIndex(r), t = this.glyphs.get(e);
  return t || (t = this.glyphs.get(0)), t;
};
hn.prototype.updateFeatures = function(r) {
  return this.defaultRenderOptions.features.map(function(e) {
    return e.script === "latn" ? {
      script: "latn",
      tags: e.tags.filter(function(t) {
        return r[t];
      })
    } : e;
  });
};
hn.prototype.stringToGlyphs = function(r, e) {
  var t = this, n = new _a(), i = function(d) {
    return t.charToGlyphIndex(d.char);
  };
  n.registerModifier("glyphIndex", null, i);
  var a = e ? this.updateFeatures(e.features) : this.defaultRenderOptions.features;
  n.applyFeatures(this, a);
  for (var s = n.getTextGlyphs(r), o = s.length, l = new Array(o), u = this.glyphs.get(0), c = 0; c < o; c += 1)
    l[c] = this.glyphs.get(s[c]) || u;
  return l;
};
hn.prototype.nameToGlyphIndex = function(r) {
  return this.glyphNames.nameToGlyphIndex(r);
};
hn.prototype.nameToGlyph = function(r) {
  var e = this.nameToGlyphIndex(r), t = this.glyphs.get(e);
  return t || (t = this.glyphs.get(0)), t;
};
hn.prototype.glyphIndexToName = function(r) {
  return this.glyphNames.glyphIndexToName ? this.glyphNames.glyphIndexToName(r) : "";
};
hn.prototype.getKerningValue = function(r, e) {
  r = r.index || r, e = e.index || e;
  var t = this.position.defaultKerningTables;
  return t ? this.position.getKerningValue(t, r, e) : this.kerningPairs[r + "," + e] || 0;
};
hn.prototype.defaultRenderOptions = {
  kerning: !0,
  features: [
    /**
     * these 4 features are required to render Arabic text properly
     * and shouldn't be turned off when rendering arabic text.
     */
    { script: "arab", tags: ["init", "medi", "fina", "rlig"] },
    { script: "latn", tags: ["liga", "rlig"] }
  ]
};
hn.prototype.forEachGlyph = function(r, e, t, n, i, a) {
  e = e !== void 0 ? e : 0, t = t !== void 0 ? t : 0, n = n !== void 0 ? n : 72, i = Object.assign({}, this.defaultRenderOptions, i);
  var s = 1 / this.unitsPerEm * n, o = this.stringToGlyphs(r, i), l;
  if (i.kerning) {
    var u = i.script || this.position.getDefaultScriptName();
    l = this.position.getKerningTables(u, i.language);
  }
  for (var c = 0; c < o.length; c += 1) {
    var d = o[c];
    if (a.call(this, d, e, t, n, i), d.advanceWidth && (e += d.advanceWidth * s), i.kerning && c < o.length - 1) {
      var f = l ? this.position.getKerningValue(l, d.index, o[c + 1].index) : this.getKerningValue(d, o[c + 1]);
      e += f * s;
    }
    i.letterSpacing ? e += i.letterSpacing * n : i.tracking && (e += i.tracking / 1e3 * n);
  }
  return e;
};
hn.prototype.getPath = function(r, e, t, n, i) {
  var a = new ci();
  return this.forEachGlyph(r, e, t, n, i, function(s, o, l, u) {
    var c = s.getPath(o, l, u, i, this);
    a.extend(c);
  }), a;
};
hn.prototype.getPaths = function(r, e, t, n, i) {
  var a = [];
  return this.forEachGlyph(r, e, t, n, i, function(s, o, l, u) {
    var c = s.getPath(o, l, u, i, this);
    a.push(c);
  }), a;
};
hn.prototype.getAdvanceWidth = function(r, e, t) {
  return this.forEachGlyph(r, 0, 0, e, t, function() {
  });
};
hn.prototype.draw = function(r, e, t, n, i, a) {
  this.getPath(e, t, n, i, a).draw(r);
};
hn.prototype.drawPoints = function(r, e, t, n, i, a) {
  this.forEachGlyph(e, t, n, i, a, function(s, o, l, u) {
    s.drawPoints(r, o, l, u);
  });
};
hn.prototype.drawMetrics = function(r, e, t, n, i, a) {
  this.forEachGlyph(e, t, n, i, a, function(s, o, l, u) {
    s.drawMetrics(r, o, l, u);
  });
};
hn.prototype.getEnglishName = function(r) {
  var e = this.names[r];
  if (e)
    return e.en;
};
hn.prototype.validate = function() {
  var r = this;
  function e(n, i) {
  }
  function t(n) {
    var i = r.getEnglishName(n);
    i && i.trim().length > 0;
  }
  t("fontFamily"), t("weightName"), t("manufacturer"), t("copyright"), t("version"), this.unitsPerEm > 0;
};
hn.prototype.toTables = function() {
  return n5.fontToTable(this);
};
hn.prototype.toBuffer = function() {
  return console.warn("Font.toBuffer is deprecated. Use Font.toArrayBuffer instead."), this.toArrayBuffer();
};
hn.prototype.toArrayBuffer = function() {
  for (var r = this.toTables(), e = r.encode(), t = new ArrayBuffer(e.length), n = new Uint8Array(t), i = 0; i < e.length; i++)
    n[i] = e[i];
  return t;
};
hn.prototype.download = function(r) {
  var e = this.getEnglishName("fontFamily"), t = this.getEnglishName("fontSubfamily");
  r = r || e.replace(/\s/g, "") + "-" + t + ".otf";
  var n = this.toArrayBuffer();
  if (a5())
    if (window.URL = window.URL || window.webkitURL, window.URL) {
      var i = new DataView(n), a = new Blob([i], { type: "font/opentype" }), s = document.createElement("a");
      s.href = window.URL.createObjectURL(a), s.download = r;
      var o = document.createEvent("MouseEvents");
      o.initEvent("click", !0, !1), s.dispatchEvent(o);
    } else
      console.warn("Font file could not be downloaded. Try using a different browser.");
  else {
    var l = require("fs"), u = s5(n);
    l.writeFileSync(r, u);
  }
};
hn.prototype.fsSelectionValues = {
  ITALIC: 1,
  //1
  UNDERSCORE: 2,
  //2
  NEGATIVE: 4,
  //4
  OUTLINED: 8,
  //8
  STRIKEOUT: 16,
  //16
  BOLD: 32,
  //32
  REGULAR: 64,
  //64
  USER_TYPO_METRICS: 128,
  //128
  WWS: 256,
  //256
  OBLIQUE: 512
  //512
};
hn.prototype.usWidthClasses = {
  ULTRA_CONDENSED: 1,
  EXTRA_CONDENSED: 2,
  CONDENSED: 3,
  SEMI_CONDENSED: 4,
  MEDIUM: 5,
  SEMI_EXPANDED: 6,
  EXPANDED: 7,
  EXTRA_EXPANDED: 8,
  ULTRA_EXPANDED: 9
};
hn.prototype.usWeightClasses = {
  THIN: 100,
  EXTRA_LIGHT: 200,
  LIGHT: 300,
  NORMAL: 400,
  MEDIUM: 500,
  SEMI_BOLD: 600,
  BOLD: 700,
  EXTRA_BOLD: 800,
  BLACK: 900
};
function tF(r, e) {
  var t = JSON.stringify(r), n = 256;
  for (var i in e) {
    var a = parseInt(i);
    if (!(!a || a < 256)) {
      if (JSON.stringify(e[i]) === t)
        return a;
      n <= a && (n = a + 1);
    }
  }
  return e[n] = r, n;
}
function vN(r, e, t) {
  var n = tF(e.name, t);
  return [
    { name: "tag_" + r, type: "TAG", value: e.tag },
    { name: "minValue_" + r, type: "FIXED", value: e.minValue << 16 },
    { name: "defaultValue_" + r, type: "FIXED", value: e.defaultValue << 16 },
    { name: "maxValue_" + r, type: "FIXED", value: e.maxValue << 16 },
    { name: "flags_" + r, type: "USHORT", value: 0 },
    { name: "nameID_" + r, type: "USHORT", value: n }
  ];
}
function yN(r, e, t) {
  var n = {}, i = new vt.Parser(r, e);
  return n.tag = i.parseTag(), n.minValue = i.parseFixed(), n.defaultValue = i.parseFixed(), n.maxValue = i.parseFixed(), i.skip("uShort", 1), n.name = t[i.parseUShort()] || {}, n;
}
function AN(r, e, t, n) {
  for (var i = tF(e.name, n), a = [
    { name: "nameID_" + r, type: "USHORT", value: i },
    { name: "flags_" + r, type: "USHORT", value: 0 }
  ], s = 0; s < t.length; ++s) {
    var o = t[s].tag;
    a.push({
      name: "axis_" + r + " " + o,
      type: "FIXED",
      value: e.coordinates[o] << 16
    });
  }
  return a;
}
function bN(r, e, t, n) {
  var i = {}, a = new vt.Parser(r, e);
  i.name = n[a.parseUShort()] || {}, a.skip("uShort", 1), i.coordinates = {};
  for (var s = 0; s < t.length; ++s)
    i.coordinates[t[s].tag] = a.parseFixed();
  return i;
}
function wN(r, e) {
  var t = new ct.Table("fvar", [
    { name: "version", type: "ULONG", value: 65536 },
    { name: "offsetToData", type: "USHORT", value: 0 },
    { name: "countSizePairs", type: "USHORT", value: 2 },
    { name: "axisCount", type: "USHORT", value: r.axes.length },
    { name: "axisSize", type: "USHORT", value: 20 },
    { name: "instanceCount", type: "USHORT", value: r.instances.length },
    { name: "instanceSize", type: "USHORT", value: 4 + r.axes.length * 4 }
  ]);
  t.offsetToData = t.sizeOf();
  for (var n = 0; n < r.axes.length; n++)
    t.fields = t.fields.concat(vN(n, r.axes[n], e));
  for (var i = 0; i < r.instances.length; i++)
    t.fields = t.fields.concat(AN(i, r.instances[i], r.axes, e));
  return t;
}
function xN(r, e, t) {
  var n = new vt.Parser(r, e), i = n.parseULong();
  jt.argument(i === 65536, "Unsupported fvar table version.");
  var a = n.parseOffset16();
  n.skip("uShort", 1);
  for (var s = n.parseUShort(), o = n.parseUShort(), l = n.parseUShort(), u = n.parseUShort(), c = [], d = 0; d < s; d++)
    c.push(yN(r, e + a + d * o, t));
  for (var f = [], h = e + a + s * o, g = 0; g < l; g++)
    f.push(bN(r, h + g * u, c, t));
  return { axes: c, instances: f };
}
var CN = { make: wN, parse: xN }, SN = function() {
  return {
    coverage: this.parsePointer(we.coverage),
    attachPoints: this.parseList(we.pointer(we.uShortList))
  };
}, EN = function() {
  var r = this.parseUShort();
  if (jt.argument(
    r === 1 || r === 2 || r === 3,
    "Unsupported CaretValue table version."
  ), r === 1)
    return { coordinate: this.parseShort() };
  if (r === 2)
    return { pointindex: this.parseShort() };
  if (r === 3)
    return { coordinate: this.parseShort() };
}, kN = function() {
  return this.parseList(we.pointer(EN));
}, TN = function() {
  return {
    coverage: this.parsePointer(we.coverage),
    ligGlyphs: this.parseList(we.pointer(kN))
  };
}, FN = function() {
  return this.parseUShort(), this.parseList(we.pointer(we.coverage));
};
function IN(r, e) {
  e = e || 0;
  var t = new we(r, e), n = t.parseVersion(1);
  jt.argument(
    n === 1 || n === 1.2 || n === 1.3,
    "Unsupported GDEF table version."
  );
  var i = {
    version: n,
    classDef: t.parsePointer(we.classDef),
    attachList: t.parsePointer(SN),
    ligCaretList: t.parsePointer(TN),
    markAttachClassDef: t.parsePointer(we.classDef)
  };
  return n >= 1.2 && (i.markGlyphSets = t.parsePointer(FN)), i;
}
var DN = { parse: IN }, Pa = new Array(10);
Pa[1] = function() {
  var e = this.offset + this.relativeOffset, t = this.parseUShort();
  if (t === 1)
    return {
      posFormat: 1,
      coverage: this.parsePointer(we.coverage),
      value: this.parseValueRecord()
    };
  if (t === 2)
    return {
      posFormat: 2,
      coverage: this.parsePointer(we.coverage),
      values: this.parseValueRecordList()
    };
  jt.assert(!1, "0x" + e.toString(16) + ": GPOS lookup type 1 format must be 1 or 2.");
};
Pa[2] = function() {
  var e = this.offset + this.relativeOffset, t = this.parseUShort();
  jt.assert(t === 1 || t === 2, "0x" + e.toString(16) + ": GPOS lookup type 2 format must be 1 or 2.");
  var n = this.parsePointer(we.coverage), i = this.parseUShort(), a = this.parseUShort();
  if (t === 1)
    return {
      posFormat: t,
      coverage: n,
      valueFormat1: i,
      valueFormat2: a,
      pairSets: this.parseList(we.pointer(we.list(function() {
        return {
          // pairValueRecord
          secondGlyph: this.parseUShort(),
          value1: this.parseValueRecord(i),
          value2: this.parseValueRecord(a)
        };
      })))
    };
  if (t === 2) {
    var s = this.parsePointer(we.classDef), o = this.parsePointer(we.classDef), l = this.parseUShort(), u = this.parseUShort();
    return {
      // Class Pair Adjustment
      posFormat: t,
      coverage: n,
      valueFormat1: i,
      valueFormat2: a,
      classDef1: s,
      classDef2: o,
      class1Count: l,
      class2Count: u,
      classRecords: this.parseList(l, we.list(u, function() {
        return {
          value1: this.parseValueRecord(i),
          value2: this.parseValueRecord(a)
        };
      }))
    };
  }
};
Pa[3] = function() {
  return { error: "GPOS Lookup 3 not supported" };
};
Pa[4] = function() {
  return { error: "GPOS Lookup 4 not supported" };
};
Pa[5] = function() {
  return { error: "GPOS Lookup 5 not supported" };
};
Pa[6] = function() {
  return { error: "GPOS Lookup 6 not supported" };
};
Pa[7] = function() {
  return { error: "GPOS Lookup 7 not supported" };
};
Pa[8] = function() {
  return { error: "GPOS Lookup 8 not supported" };
};
Pa[9] = function() {
  return { error: "GPOS Lookup 9 not supported" };
};
function PN(r, e) {
  e = e || 0;
  var t = new we(r, e), n = t.parseVersion(1);
  return jt.argument(n === 1 || n === 1.1, "Unsupported GPOS table version " + n), n === 1 ? {
    version: n,
    scripts: t.parseScriptList(),
    features: t.parseFeatureList(),
    lookups: t.parseLookupList(Pa)
  } : {
    version: n,
    scripts: t.parseScriptList(),
    features: t.parseFeatureList(),
    lookups: t.parseLookupList(Pa),
    variations: t.parseFeatureVariationsList()
  };
}
var RN = new Array(10);
function ON(r) {
  return new ct.Table("GPOS", [
    { name: "version", type: "ULONG", value: 65536 },
    { name: "scripts", type: "TABLE", value: new ct.ScriptList(r.scripts) },
    { name: "features", type: "TABLE", value: new ct.FeatureList(r.features) },
    { name: "lookups", type: "TABLE", value: new ct.LookupList(r.lookups, RN) }
  ]);
}
var BN = { parse: PN, make: ON };
function MN(r) {
  var e = {};
  r.skip("uShort");
  var t = r.parseUShort();
  jt.argument(t === 0, "Unsupported kern sub-table version."), r.skip("uShort", 2);
  var n = r.parseUShort();
  r.skip("uShort", 3);
  for (var i = 0; i < n; i += 1) {
    var a = r.parseUShort(), s = r.parseUShort(), o = r.parseShort();
    e[a + "," + s] = o;
  }
  return e;
}
function _N(r) {
  var e = {};
  r.skip("uShort");
  var t = r.parseULong();
  t > 1 && console.warn("Only the first kern subtable is supported."), r.skip("uLong");
  var n = r.parseUShort(), i = n & 255;
  if (r.skip("uShort"), i === 0) {
    var a = r.parseUShort();
    r.skip("uShort", 3);
    for (var s = 0; s < a; s += 1) {
      var o = r.parseUShort(), l = r.parseUShort(), u = r.parseShort();
      e[o + "," + l] = u;
    }
  }
  return e;
}
function NN(r, e) {
  var t = new vt.Parser(r, e), n = t.parseUShort();
  if (n === 0)
    return MN(t);
  if (n === 1)
    return _N(t);
  throw new Error("Unsupported kern table version (" + n + ").");
}
var LN = { parse: NN };
function UN(r, e, t, n) {
  for (var i = new vt.Parser(r, e), a = n ? i.parseUShort : i.parseULong, s = [], o = 0; o < t + 1; o += 1) {
    var l = a.call(i);
    n && (l *= 2), s.push(l);
  }
  return s;
}
var VN = { parse: UN };
function AC(r, e) {
  for (var t = [], n = 12, i = 0; i < e; i += 1) {
    var a = vt.getTag(r, n), s = vt.getULong(r, n + 4), o = vt.getULong(r, n + 8), l = vt.getULong(r, n + 12);
    t.push({ tag: a, checksum: s, offset: o, length: l, compression: !1 }), n += 16;
  }
  return t;
}
function zN(r, e) {
  for (var t = [], n = 44, i = 0; i < e; i += 1) {
    var a = vt.getTag(r, n), s = vt.getULong(r, n + 4), o = vt.getULong(r, n + 8), l = vt.getULong(r, n + 12), u = void 0;
    o < l ? u = "WOFF" : u = !1, t.push({
      tag: a,
      offset: s,
      compression: u,
      compressedLength: o,
      length: l
    }), n += 20;
  }
  return t;
}
function Wn(r, e) {
  if (e.compression === "WOFF") {
    var t = new Uint8Array(r.buffer, e.offset + 2, e.compressedLength - 2), n = new Uint8Array(e.length);
    if (BM(t, n), n.byteLength !== e.length)
      throw new Error("Decompression error: " + e.tag + " decompressed length doesn't match recorded length");
    var i = new DataView(n.buffer, 0);
    return { data: i, offset: 0 };
  } else
    return { data: r, offset: e.offset };
}
function $y(r, e) {
  e = e ?? {};
  var t, n, i = new hn({ empty: !0 }), a = new DataView(r, 0), s, o = [], l = vt.getTag(a, 0);
  if (l === "\0\0\0" || l === "true" || l === "typ1")
    i.outlinesFormat = "truetype", s = vt.getUShort(a, 4), o = AC(a, s);
  else if (l === "OTTO")
    i.outlinesFormat = "cff", s = vt.getUShort(a, 4), o = AC(a, s);
  else if (l === "wOFF") {
    var u = vt.getTag(a, 4);
    if (u === "\0\0\0")
      i.outlinesFormat = "truetype";
    else if (u === "OTTO")
      i.outlinesFormat = "cff";
    else
      throw new Error("Unsupported OpenType flavor " + l);
    s = vt.getUShort(a, 12), o = zN(a, s);
  } else
    throw new Error("Unsupported OpenType signature " + l);
  for (var c, d, f, h, g, v, y, A, x, k, F, S, R = 0; R < s; R += 1) {
    var M = o[R], j = void 0;
    switch (M.tag) {
      case "cmap":
        j = Wn(a, M), i.tables.cmap = yT.parse(j.data, j.offset), i.encoding = new bT(i.tables.cmap);
        break;
      case "cvt ":
        j = Wn(a, M), S = new vt.Parser(j.data, j.offset), i.tables.cvt = S.parseShortList(M.length / 2);
        break;
      case "fvar":
        d = M;
        break;
      case "fpgm":
        j = Wn(a, M), S = new vt.Parser(j.data, j.offset), i.tables.fpgm = S.parseByteList(M.length);
        break;
      case "head":
        j = Wn(a, M), i.tables.head = DT.parse(j.data, j.offset), i.unitsPerEm = i.tables.head.unitsPerEm, t = i.tables.head.indexToLocFormat;
        break;
      case "hhea":
        j = Wn(a, M), i.tables.hhea = PT.parse(j.data, j.offset), i.ascender = i.tables.hhea.ascender, i.descender = i.tables.hhea.descender, i.numberOfHMetrics = i.tables.hhea.numberOfHMetrics;
        break;
      case "hmtx":
        y = M;
        break;
      case "ltag":
        j = Wn(a, M), n = OT.parse(j.data, j.offset);
        break;
      case "maxp":
        j = Wn(a, M), i.tables.maxp = BT.parse(j.data, j.offset), i.numGlyphs = i.tables.maxp.numGlyphs;
        break;
      case "name":
        k = M;
        break;
      case "OS/2":
        j = Wn(a, M), i.tables.os2 = Vy.parse(j.data, j.offset);
        break;
      case "post":
        j = Wn(a, M), i.tables.post = VT.parse(j.data, j.offset), i.glyphNames = new t1(i.tables.post);
        break;
      case "prep":
        j = Wn(a, M), S = new vt.Parser(j.data, j.offset), i.tables.prep = S.parseByteList(M.length);
        break;
      case "glyf":
        f = M;
        break;
      case "loca":
        x = M;
        break;
      case "CFF ":
        c = M;
        break;
      case "kern":
        A = M;
        break;
      case "GDEF":
        h = M;
        break;
      case "GPOS":
        g = M;
        break;
      case "GSUB":
        v = M;
        break;
      case "meta":
        F = M;
        break;
    }
  }
  var G = Wn(a, k);
  if (i.tables.name = UT.parse(G.data, G.offset, n), i.names = i.tables.name, f && x) {
    var ie = t === 0, q = Wn(a, x), Y = VN.parse(q.data, q.offset, i.numGlyphs, ie), J = Wn(a, f);
    i.glyphs = WT.parse(J.data, J.offset, Y, i, e);
  } else if (c) {
    var se = Wn(a, c);
    IT.parse(se.data, se.offset, i, e);
  } else
    throw new Error("Font doesn't contain TrueType or CFF outlines.");
  var oe = Wn(a, y);
  if (RT.parse(i, oe.data, oe.offset, i.numberOfHMetrics, i.numGlyphs, i.glyphs, e), t_(i, e), A) {
    var he = Wn(a, A);
    i.kerningPairs = LN.parse(he.data, he.offset);
  } else
    i.kerningPairs = {};
  if (h) {
    var ye = Wn(a, h);
    i.tables.gdef = DN.parse(ye.data, ye.offset);
  }
  if (g) {
    var Ue = Wn(a, g);
    i.tables.gpos = BN.parse(Ue.data, Ue.offset), i.position.init();
  }
  if (v) {
    var Re = Wn(a, v);
    i.tables.gsub = zT.parse(Re.data, Re.offset);
  }
  if (d) {
    var Oe = Wn(a, d);
    i.tables.fvar = CN.parse(Oe.data, Oe.offset, i.names);
  }
  if (F) {
    var ee = Wn(a, F);
    i.tables.meta = $T.parse(ee.data, ee.offset), i.metas = i.tables.meta;
  }
  return i;
}
var Iu = function() {
  return Iu = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, Iu.apply(this, arguments);
}, $N = "~", HN = "~~";
function l1(r, e) {
  for (var t = {}, n = {}, i = r.split(HN), a = !1, s = 0; i.length > s; s++) {
    for (var o = i[s].split($N), l = 0; l < o.length; l += 2) {
      var u = o[l], c = o[l + 1], d = "&" + u + ";";
      t[d] = c, a && (t["&" + u] = c), n[c] = d;
    }
    a = !0;
  }
  return e ? { entities: Iu(Iu({}, t), e.entities), characters: Iu(Iu({}, n), e.characters) } : { entities: t, characters: n };
}
var x0 = {
  xml: /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g,
  html4: /&notin;|&(?:nbsp|iexcl|cent|pound|curren|yen|brvbar|sect|uml|copy|ordf|laquo|not|shy|reg|macr|deg|plusmn|sup2|sup3|acute|micro|para|middot|cedil|sup1|ordm|raquo|frac14|frac12|frac34|iquest|Agrave|Aacute|Acirc|Atilde|Auml|Aring|AElig|Ccedil|Egrave|Eacute|Ecirc|Euml|Igrave|Iacute|Icirc|Iuml|ETH|Ntilde|Ograve|Oacute|Ocirc|Otilde|Ouml|times|Oslash|Ugrave|Uacute|Ucirc|Uuml|Yacute|THORN|szlig|agrave|aacute|acirc|atilde|auml|aring|aelig|ccedil|egrave|eacute|ecirc|euml|igrave|iacute|icirc|iuml|eth|ntilde|ograve|oacute|ocirc|otilde|ouml|divide|oslash|ugrave|uacute|ucirc|uuml|yacute|thorn|yuml|quot|amp|lt|gt|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g,
  html5: /&centerdot;|&copysr;|&divideontimes;|&gtcc;|&gtcir;|&gtdot;|&gtlPar;|&gtquest;|&gtrapprox;|&gtrarr;|&gtrdot;|&gtreqless;|&gtreqqless;|&gtrless;|&gtrsim;|&ltcc;|&ltcir;|&ltdot;|&lthree;|&ltimes;|&ltlarr;|&ltquest;|&ltrPar;|&ltri;|&ltrie;|&ltrif;|&notin;|&notinE;|&notindot;|&notinva;|&notinvb;|&notinvc;|&notni;|&notniva;|&notnivb;|&notnivc;|&parallel;|&timesb;|&timesbar;|&timesd;|&(?:AElig|AMP|Aacute|Acirc|Agrave|Aring|Atilde|Auml|COPY|Ccedil|ETH|Eacute|Ecirc|Egrave|Euml|GT|Iacute|Icirc|Igrave|Iuml|LT|Ntilde|Oacute|Ocirc|Ograve|Oslash|Otilde|Ouml|QUOT|REG|THORN|Uacute|Ucirc|Ugrave|Uuml|Yacute|aacute|acirc|acute|aelig|agrave|amp|aring|atilde|auml|brvbar|ccedil|cedil|cent|copy|curren|deg|divide|eacute|ecirc|egrave|eth|euml|frac12|frac14|frac34|gt|iacute|icirc|iexcl|igrave|iquest|iuml|laquo|lt|macr|micro|middot|nbsp|not|ntilde|oacute|ocirc|ograve|ordf|ordm|oslash|otilde|ouml|para|plusmn|pound|quot|raquo|reg|sect|shy|sup1|sup2|sup3|szlig|thorn|times|uacute|ucirc|ugrave|uml|uuml|yacute|yen|yuml|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g
}, Qu = {};
Qu.xml = l1(`lt~<~gt~>~quot~"~apos~'~amp~&`);
Qu.html4 = l1(`apos~'~OElig~Œ~oelig~œ~Scaron~Š~scaron~š~Yuml~Ÿ~circ~ˆ~tilde~˜~ensp~ ~emsp~ ~thinsp~ ~zwnj~‌~zwj~‍~lrm~‎~rlm~‏~ndash~–~mdash~—~lsquo~‘~rsquo~’~sbquo~‚~ldquo~“~rdquo~”~bdquo~„~dagger~†~Dagger~‡~permil~‰~lsaquo~‹~rsaquo~›~euro~€~fnof~ƒ~Alpha~Α~Beta~Β~Gamma~Γ~Delta~Δ~Epsilon~Ε~Zeta~Ζ~Eta~Η~Theta~Θ~Iota~Ι~Kappa~Κ~Lambda~Λ~Mu~Μ~Nu~Ν~Xi~Ξ~Omicron~Ο~Pi~Π~Rho~Ρ~Sigma~Σ~Tau~Τ~Upsilon~Υ~Phi~Φ~Chi~Χ~Psi~Ψ~Omega~Ω~alpha~α~beta~β~gamma~γ~delta~δ~epsilon~ε~zeta~ζ~eta~η~theta~θ~iota~ι~kappa~κ~lambda~λ~mu~μ~nu~ν~xi~ξ~omicron~ο~pi~π~rho~ρ~sigmaf~ς~sigma~σ~tau~τ~upsilon~υ~phi~φ~chi~χ~psi~ψ~omega~ω~thetasym~ϑ~upsih~ϒ~piv~ϖ~bull~•~hellip~…~prime~′~Prime~″~oline~‾~frasl~⁄~weierp~℘~image~ℑ~real~ℜ~trade~™~alefsym~ℵ~larr~←~uarr~↑~rarr~→~darr~↓~harr~↔~crarr~↵~lArr~⇐~uArr~⇑~rArr~⇒~dArr~⇓~hArr~⇔~forall~∀~part~∂~exist~∃~empty~∅~nabla~∇~isin~∈~notin~∉~ni~∋~prod~∏~sum~∑~minus~−~lowast~∗~radic~√~prop~∝~infin~∞~ang~∠~and~∧~or~∨~cap~∩~cup~∪~int~∫~there4~∴~sim~∼~cong~≅~asymp~≈~ne~≠~equiv~≡~le~≤~ge~≥~sub~⊂~sup~⊃~nsub~⊄~sube~⊆~supe~⊇~oplus~⊕~otimes~⊗~perp~⊥~sdot~⋅~lceil~⌈~rceil~⌉~lfloor~⌊~rfloor~⌋~lang~〈~rang~〉~loz~◊~spades~♠~clubs~♣~hearts~♥~diams~♦~~nbsp~ ~iexcl~¡~cent~¢~pound~£~curren~¤~yen~¥~brvbar~¦~sect~§~uml~¨~copy~©~ordf~ª~laquo~«~not~¬~shy~­~reg~®~macr~¯~deg~°~plusmn~±~sup2~²~sup3~³~acute~´~micro~µ~para~¶~middot~·~cedil~¸~sup1~¹~ordm~º~raquo~»~frac14~¼~frac12~½~frac34~¾~iquest~¿~Agrave~À~Aacute~Á~Acirc~Â~Atilde~Ã~Auml~Ä~Aring~Å~AElig~Æ~Ccedil~Ç~Egrave~È~Eacute~É~Ecirc~Ê~Euml~Ë~Igrave~Ì~Iacute~Í~Icirc~Î~Iuml~Ï~ETH~Ð~Ntilde~Ñ~Ograve~Ò~Oacute~Ó~Ocirc~Ô~Otilde~Õ~Ouml~Ö~times~×~Oslash~Ø~Ugrave~Ù~Uacute~Ú~Ucirc~Û~Uuml~Ü~Yacute~Ý~THORN~Þ~szlig~ß~agrave~à~aacute~á~acirc~â~atilde~ã~auml~ä~aring~å~aelig~æ~ccedil~ç~egrave~è~eacute~é~ecirc~ê~euml~ë~igrave~ì~iacute~í~icirc~î~iuml~ï~eth~ð~ntilde~ñ~ograve~ò~oacute~ó~ocirc~ô~otilde~õ~ouml~ö~divide~÷~oslash~ø~ugrave~ù~uacute~ú~ucirc~û~uuml~ü~yacute~ý~thorn~þ~yuml~ÿ~quot~"~amp~&~lt~<~gt~>`);
Qu.html5 = l1('Abreve~Ă~Acy~А~Afr~𝔄~Amacr~Ā~And~⩓~Aogon~Ą~Aopf~𝔸~ApplyFunction~⁡~Ascr~𝒜~Assign~≔~Backslash~∖~Barv~⫧~Barwed~⌆~Bcy~Б~Because~∵~Bernoullis~ℬ~Bfr~𝔅~Bopf~𝔹~Breve~˘~Bscr~ℬ~Bumpeq~≎~CHcy~Ч~Cacute~Ć~Cap~⋒~CapitalDifferentialD~ⅅ~Cayleys~ℭ~Ccaron~Č~Ccirc~Ĉ~Cconint~∰~Cdot~Ċ~Cedilla~¸~CenterDot~·~Cfr~ℭ~CircleDot~⊙~CircleMinus~⊖~CirclePlus~⊕~CircleTimes~⊗~ClockwiseContourIntegral~∲~CloseCurlyDoubleQuote~”~CloseCurlyQuote~’~Colon~∷~Colone~⩴~Congruent~≡~Conint~∯~ContourIntegral~∮~Copf~ℂ~Coproduct~∐~CounterClockwiseContourIntegral~∳~Cross~⨯~Cscr~𝒞~Cup~⋓~CupCap~≍~DD~ⅅ~DDotrahd~⤑~DJcy~Ђ~DScy~Ѕ~DZcy~Џ~Darr~↡~Dashv~⫤~Dcaron~Ď~Dcy~Д~Del~∇~Dfr~𝔇~DiacriticalAcute~´~DiacriticalDot~˙~DiacriticalDoubleAcute~˝~DiacriticalGrave~`~DiacriticalTilde~˜~Diamond~⋄~DifferentialD~ⅆ~Dopf~𝔻~Dot~¨~DotDot~⃜~DotEqual~≐~DoubleContourIntegral~∯~DoubleDot~¨~DoubleDownArrow~⇓~DoubleLeftArrow~⇐~DoubleLeftRightArrow~⇔~DoubleLeftTee~⫤~DoubleLongLeftArrow~⟸~DoubleLongLeftRightArrow~⟺~DoubleLongRightArrow~⟹~DoubleRightArrow~⇒~DoubleRightTee~⊨~DoubleUpArrow~⇑~DoubleUpDownArrow~⇕~DoubleVerticalBar~∥~DownArrow~↓~DownArrowBar~⤓~DownArrowUpArrow~⇵~DownBreve~̑~DownLeftRightVector~⥐~DownLeftTeeVector~⥞~DownLeftVector~↽~DownLeftVectorBar~⥖~DownRightTeeVector~⥟~DownRightVector~⇁~DownRightVectorBar~⥗~DownTee~⊤~DownTeeArrow~↧~Downarrow~⇓~Dscr~𝒟~Dstrok~Đ~ENG~Ŋ~Ecaron~Ě~Ecy~Э~Edot~Ė~Efr~𝔈~Element~∈~Emacr~Ē~EmptySmallSquare~◻~EmptyVerySmallSquare~▫~Eogon~Ę~Eopf~𝔼~Equal~⩵~EqualTilde~≂~Equilibrium~⇌~Escr~ℰ~Esim~⩳~Exists~∃~ExponentialE~ⅇ~Fcy~Ф~Ffr~𝔉~FilledSmallSquare~◼~FilledVerySmallSquare~▪~Fopf~𝔽~ForAll~∀~Fouriertrf~ℱ~Fscr~ℱ~GJcy~Ѓ~Gammad~Ϝ~Gbreve~Ğ~Gcedil~Ģ~Gcirc~Ĝ~Gcy~Г~Gdot~Ġ~Gfr~𝔊~Gg~⋙~Gopf~𝔾~GreaterEqual~≥~GreaterEqualLess~⋛~GreaterFullEqual~≧~GreaterGreater~⪢~GreaterLess~≷~GreaterSlantEqual~⩾~GreaterTilde~≳~Gscr~𝒢~Gt~≫~HARDcy~Ъ~Hacek~ˇ~Hat~^~Hcirc~Ĥ~Hfr~ℌ~HilbertSpace~ℋ~Hopf~ℍ~HorizontalLine~─~Hscr~ℋ~Hstrok~Ħ~HumpDownHump~≎~HumpEqual~≏~IEcy~Е~IJlig~Ĳ~IOcy~Ё~Icy~И~Idot~İ~Ifr~ℑ~Im~ℑ~Imacr~Ī~ImaginaryI~ⅈ~Implies~⇒~Int~∬~Integral~∫~Intersection~⋂~InvisibleComma~⁣~InvisibleTimes~⁢~Iogon~Į~Iopf~𝕀~Iscr~ℐ~Itilde~Ĩ~Iukcy~І~Jcirc~Ĵ~Jcy~Й~Jfr~𝔍~Jopf~𝕁~Jscr~𝒥~Jsercy~Ј~Jukcy~Є~KHcy~Х~KJcy~Ќ~Kcedil~Ķ~Kcy~К~Kfr~𝔎~Kopf~𝕂~Kscr~𝒦~LJcy~Љ~Lacute~Ĺ~Lang~⟪~Laplacetrf~ℒ~Larr~↞~Lcaron~Ľ~Lcedil~Ļ~Lcy~Л~LeftAngleBracket~⟨~LeftArrow~←~LeftArrowBar~⇤~LeftArrowRightArrow~⇆~LeftCeiling~⌈~LeftDoubleBracket~⟦~LeftDownTeeVector~⥡~LeftDownVector~⇃~LeftDownVectorBar~⥙~LeftFloor~⌊~LeftRightArrow~↔~LeftRightVector~⥎~LeftTee~⊣~LeftTeeArrow~↤~LeftTeeVector~⥚~LeftTriangle~⊲~LeftTriangleBar~⧏~LeftTriangleEqual~⊴~LeftUpDownVector~⥑~LeftUpTeeVector~⥠~LeftUpVector~↿~LeftUpVectorBar~⥘~LeftVector~↼~LeftVectorBar~⥒~Leftarrow~⇐~Leftrightarrow~⇔~LessEqualGreater~⋚~LessFullEqual~≦~LessGreater~≶~LessLess~⪡~LessSlantEqual~⩽~LessTilde~≲~Lfr~𝔏~Ll~⋘~Lleftarrow~⇚~Lmidot~Ŀ~LongLeftArrow~⟵~LongLeftRightArrow~⟷~LongRightArrow~⟶~Longleftarrow~⟸~Longleftrightarrow~⟺~Longrightarrow~⟹~Lopf~𝕃~LowerLeftArrow~↙~LowerRightArrow~↘~Lscr~ℒ~Lsh~↰~Lstrok~Ł~Lt~≪~Map~⤅~Mcy~М~MediumSpace~ ~Mellintrf~ℳ~Mfr~𝔐~MinusPlus~∓~Mopf~𝕄~Mscr~ℳ~NJcy~Њ~Nacute~Ń~Ncaron~Ň~Ncedil~Ņ~Ncy~Н~NegativeMediumSpace~​~NegativeThickSpace~​~NegativeThinSpace~​~NegativeVeryThinSpace~​~NestedGreaterGreater~≫~NestedLessLess~≪~NewLine~\n~Nfr~𝔑~NoBreak~⁠~NonBreakingSpace~ ~Nopf~ℕ~Not~⫬~NotCongruent~≢~NotCupCap~≭~NotDoubleVerticalBar~∦~NotElement~∉~NotEqual~≠~NotEqualTilde~≂̸~NotExists~∄~NotGreater~≯~NotGreaterEqual~≱~NotGreaterFullEqual~≧̸~NotGreaterGreater~≫̸~NotGreaterLess~≹~NotGreaterSlantEqual~⩾̸~NotGreaterTilde~≵~NotHumpDownHump~≎̸~NotHumpEqual~≏̸~NotLeftTriangle~⋪~NotLeftTriangleBar~⧏̸~NotLeftTriangleEqual~⋬~NotLess~≮~NotLessEqual~≰~NotLessGreater~≸~NotLessLess~≪̸~NotLessSlantEqual~⩽̸~NotLessTilde~≴~NotNestedGreaterGreater~⪢̸~NotNestedLessLess~⪡̸~NotPrecedes~⊀~NotPrecedesEqual~⪯̸~NotPrecedesSlantEqual~⋠~NotReverseElement~∌~NotRightTriangle~⋫~NotRightTriangleBar~⧐̸~NotRightTriangleEqual~⋭~NotSquareSubset~⊏̸~NotSquareSubsetEqual~⋢~NotSquareSuperset~⊐̸~NotSquareSupersetEqual~⋣~NotSubset~⊂⃒~NotSubsetEqual~⊈~NotSucceeds~⊁~NotSucceedsEqual~⪰̸~NotSucceedsSlantEqual~⋡~NotSucceedsTilde~≿̸~NotSuperset~⊃⃒~NotSupersetEqual~⊉~NotTilde~≁~NotTildeEqual~≄~NotTildeFullEqual~≇~NotTildeTilde~≉~NotVerticalBar~∤~Nscr~𝒩~Ocy~О~Odblac~Ő~Ofr~𝔒~Omacr~Ō~Oopf~𝕆~OpenCurlyDoubleQuote~“~OpenCurlyQuote~‘~Or~⩔~Oscr~𝒪~Otimes~⨷~OverBar~‾~OverBrace~⏞~OverBracket~⎴~OverParenthesis~⏜~PartialD~∂~Pcy~П~Pfr~𝔓~PlusMinus~±~Poincareplane~ℌ~Popf~ℙ~Pr~⪻~Precedes~≺~PrecedesEqual~⪯~PrecedesSlantEqual~≼~PrecedesTilde~≾~Product~∏~Proportion~∷~Proportional~∝~Pscr~𝒫~Qfr~𝔔~Qopf~ℚ~Qscr~𝒬~RBarr~⤐~Racute~Ŕ~Rang~⟫~Rarr~↠~Rarrtl~⤖~Rcaron~Ř~Rcedil~Ŗ~Rcy~Р~Re~ℜ~ReverseElement~∋~ReverseEquilibrium~⇋~ReverseUpEquilibrium~⥯~Rfr~ℜ~RightAngleBracket~⟩~RightArrow~→~RightArrowBar~⇥~RightArrowLeftArrow~⇄~RightCeiling~⌉~RightDoubleBracket~⟧~RightDownTeeVector~⥝~RightDownVector~⇂~RightDownVectorBar~⥕~RightFloor~⌋~RightTee~⊢~RightTeeArrow~↦~RightTeeVector~⥛~RightTriangle~⊳~RightTriangleBar~⧐~RightTriangleEqual~⊵~RightUpDownVector~⥏~RightUpTeeVector~⥜~RightUpVector~↾~RightUpVectorBar~⥔~RightVector~⇀~RightVectorBar~⥓~Rightarrow~⇒~Ropf~ℝ~RoundImplies~⥰~Rrightarrow~⇛~Rscr~ℛ~Rsh~↱~RuleDelayed~⧴~SHCHcy~Щ~SHcy~Ш~SOFTcy~Ь~Sacute~Ś~Sc~⪼~Scedil~Ş~Scirc~Ŝ~Scy~С~Sfr~𝔖~ShortDownArrow~↓~ShortLeftArrow~←~ShortRightArrow~→~ShortUpArrow~↑~SmallCircle~∘~Sopf~𝕊~Sqrt~√~Square~□~SquareIntersection~⊓~SquareSubset~⊏~SquareSubsetEqual~⊑~SquareSuperset~⊐~SquareSupersetEqual~⊒~SquareUnion~⊔~Sscr~𝒮~Star~⋆~Sub~⋐~Subset~⋐~SubsetEqual~⊆~Succeeds~≻~SucceedsEqual~⪰~SucceedsSlantEqual~≽~SucceedsTilde~≿~SuchThat~∋~Sum~∑~Sup~⋑~Superset~⊃~SupersetEqual~⊇~Supset~⋑~TRADE~™~TSHcy~Ћ~TScy~Ц~Tab~	~Tcaron~Ť~Tcedil~Ţ~Tcy~Т~Tfr~𝔗~Therefore~∴~ThickSpace~  ~ThinSpace~ ~Tilde~∼~TildeEqual~≃~TildeFullEqual~≅~TildeTilde~≈~Topf~𝕋~TripleDot~⃛~Tscr~𝒯~Tstrok~Ŧ~Uarr~↟~Uarrocir~⥉~Ubrcy~Ў~Ubreve~Ŭ~Ucy~У~Udblac~Ű~Ufr~𝔘~Umacr~Ū~UnderBar~_~UnderBrace~⏟~UnderBracket~⎵~UnderParenthesis~⏝~Union~⋃~UnionPlus~⊎~Uogon~Ų~Uopf~𝕌~UpArrow~↑~UpArrowBar~⤒~UpArrowDownArrow~⇅~UpDownArrow~↕~UpEquilibrium~⥮~UpTee~⊥~UpTeeArrow~↥~Uparrow~⇑~Updownarrow~⇕~UpperLeftArrow~↖~UpperRightArrow~↗~Upsi~ϒ~Uring~Ů~Uscr~𝒰~Utilde~Ũ~VDash~⊫~Vbar~⫫~Vcy~В~Vdash~⊩~Vdashl~⫦~Vee~⋁~Verbar~‖~Vert~‖~VerticalBar~∣~VerticalLine~|~VerticalSeparator~❘~VerticalTilde~≀~VeryThinSpace~ ~Vfr~𝔙~Vopf~𝕍~Vscr~𝒱~Vvdash~⊪~Wcirc~Ŵ~Wedge~⋀~Wfr~𝔚~Wopf~𝕎~Wscr~𝒲~Xfr~𝔛~Xopf~𝕏~Xscr~𝒳~YAcy~Я~YIcy~Ї~YUcy~Ю~Ycirc~Ŷ~Ycy~Ы~Yfr~𝔜~Yopf~𝕐~Yscr~𝒴~ZHcy~Ж~Zacute~Ź~Zcaron~Ž~Zcy~З~Zdot~Ż~ZeroWidthSpace~​~Zfr~ℨ~Zopf~ℤ~Zscr~𝒵~abreve~ă~ac~∾~acE~∾̳~acd~∿~acy~а~af~⁡~afr~𝔞~aleph~ℵ~amacr~ā~amalg~⨿~andand~⩕~andd~⩜~andslope~⩘~andv~⩚~ange~⦤~angle~∠~angmsd~∡~angmsdaa~⦨~angmsdab~⦩~angmsdac~⦪~angmsdad~⦫~angmsdae~⦬~angmsdaf~⦭~angmsdag~⦮~angmsdah~⦯~angrt~∟~angrtvb~⊾~angrtvbd~⦝~angsph~∢~angst~Å~angzarr~⍼~aogon~ą~aopf~𝕒~ap~≈~apE~⩰~apacir~⩯~ape~≊~apid~≋~approx~≈~approxeq~≊~ascr~𝒶~ast~*~asympeq~≍~awconint~∳~awint~⨑~bNot~⫭~backcong~≌~backepsilon~϶~backprime~‵~backsim~∽~backsimeq~⋍~barvee~⊽~barwed~⌅~barwedge~⌅~bbrk~⎵~bbrktbrk~⎶~bcong~≌~bcy~б~becaus~∵~because~∵~bemptyv~⦰~bepsi~϶~bernou~ℬ~beth~ℶ~between~≬~bfr~𝔟~bigcap~⋂~bigcirc~◯~bigcup~⋃~bigodot~⨀~bigoplus~⨁~bigotimes~⨂~bigsqcup~⨆~bigstar~★~bigtriangledown~▽~bigtriangleup~△~biguplus~⨄~bigvee~⋁~bigwedge~⋀~bkarow~⤍~blacklozenge~⧫~blacksquare~▪~blacktriangle~▴~blacktriangledown~▾~blacktriangleleft~◂~blacktriangleright~▸~blank~␣~blk12~▒~blk14~░~blk34~▓~block~█~bne~=⃥~bnequiv~≡⃥~bnot~⌐~bopf~𝕓~bot~⊥~bottom~⊥~bowtie~⋈~boxDL~╗~boxDR~╔~boxDl~╖~boxDr~╓~boxH~═~boxHD~╦~boxHU~╩~boxHd~╤~boxHu~╧~boxUL~╝~boxUR~╚~boxUl~╜~boxUr~╙~boxV~║~boxVH~╬~boxVL~╣~boxVR~╠~boxVh~╫~boxVl~╢~boxVr~╟~boxbox~⧉~boxdL~╕~boxdR~╒~boxdl~┐~boxdr~┌~boxh~─~boxhD~╥~boxhU~╨~boxhd~┬~boxhu~┴~boxminus~⊟~boxplus~⊞~boxtimes~⊠~boxuL~╛~boxuR~╘~boxul~┘~boxur~└~boxv~│~boxvH~╪~boxvL~╡~boxvR~╞~boxvh~┼~boxvl~┤~boxvr~├~bprime~‵~breve~˘~bscr~𝒷~bsemi~⁏~bsim~∽~bsime~⋍~bsol~\\~bsolb~⧅~bsolhsub~⟈~bullet~•~bump~≎~bumpE~⪮~bumpe~≏~bumpeq~≏~cacute~ć~capand~⩄~capbrcup~⩉~capcap~⩋~capcup~⩇~capdot~⩀~caps~∩︀~caret~⁁~caron~ˇ~ccaps~⩍~ccaron~č~ccirc~ĉ~ccups~⩌~ccupssm~⩐~cdot~ċ~cemptyv~⦲~centerdot~·~cfr~𝔠~chcy~ч~check~✓~checkmark~✓~cir~○~cirE~⧃~circeq~≗~circlearrowleft~↺~circlearrowright~↻~circledR~®~circledS~Ⓢ~circledast~⊛~circledcirc~⊚~circleddash~⊝~cire~≗~cirfnint~⨐~cirmid~⫯~cirscir~⧂~clubsuit~♣~colon~:~colone~≔~coloneq~≔~comma~,~commat~@~comp~∁~compfn~∘~complement~∁~complexes~ℂ~congdot~⩭~conint~∮~copf~𝕔~coprod~∐~copysr~℗~cross~✗~cscr~𝒸~csub~⫏~csube~⫑~csup~⫐~csupe~⫒~ctdot~⋯~cudarrl~⤸~cudarrr~⤵~cuepr~⋞~cuesc~⋟~cularr~↶~cularrp~⤽~cupbrcap~⩈~cupcap~⩆~cupcup~⩊~cupdot~⊍~cupor~⩅~cups~∪︀~curarr~↷~curarrm~⤼~curlyeqprec~⋞~curlyeqsucc~⋟~curlyvee~⋎~curlywedge~⋏~curvearrowleft~↶~curvearrowright~↷~cuvee~⋎~cuwed~⋏~cwconint~∲~cwint~∱~cylcty~⌭~dHar~⥥~daleth~ℸ~dash~‐~dashv~⊣~dbkarow~⤏~dblac~˝~dcaron~ď~dcy~д~dd~ⅆ~ddagger~‡~ddarr~⇊~ddotseq~⩷~demptyv~⦱~dfisht~⥿~dfr~𝔡~dharl~⇃~dharr~⇂~diam~⋄~diamond~⋄~diamondsuit~♦~die~¨~digamma~ϝ~disin~⋲~div~÷~divideontimes~⋇~divonx~⋇~djcy~ђ~dlcorn~⌞~dlcrop~⌍~dollar~$~dopf~𝕕~dot~˙~doteq~≐~doteqdot~≑~dotminus~∸~dotplus~∔~dotsquare~⊡~doublebarwedge~⌆~downarrow~↓~downdownarrows~⇊~downharpoonleft~⇃~downharpoonright~⇂~drbkarow~⤐~drcorn~⌟~drcrop~⌌~dscr~𝒹~dscy~ѕ~dsol~⧶~dstrok~đ~dtdot~⋱~dtri~▿~dtrif~▾~duarr~⇵~duhar~⥯~dwangle~⦦~dzcy~џ~dzigrarr~⟿~eDDot~⩷~eDot~≑~easter~⩮~ecaron~ě~ecir~≖~ecolon~≕~ecy~э~edot~ė~ee~ⅇ~efDot~≒~efr~𝔢~eg~⪚~egs~⪖~egsdot~⪘~el~⪙~elinters~⏧~ell~ℓ~els~⪕~elsdot~⪗~emacr~ē~emptyset~∅~emptyv~∅~emsp13~ ~emsp14~ ~eng~ŋ~eogon~ę~eopf~𝕖~epar~⋕~eparsl~⧣~eplus~⩱~epsi~ε~epsiv~ϵ~eqcirc~≖~eqcolon~≕~eqsim~≂~eqslantgtr~⪖~eqslantless~⪕~equals~=~equest~≟~equivDD~⩸~eqvparsl~⧥~erDot~≓~erarr~⥱~escr~ℯ~esdot~≐~esim~≂~excl~!~expectation~ℰ~exponentiale~ⅇ~fallingdotseq~≒~fcy~ф~female~♀~ffilig~ﬃ~fflig~ﬀ~ffllig~ﬄ~ffr~𝔣~filig~ﬁ~fjlig~fj~flat~♭~fllig~ﬂ~fltns~▱~fopf~𝕗~fork~⋔~forkv~⫙~fpartint~⨍~frac13~⅓~frac15~⅕~frac16~⅙~frac18~⅛~frac23~⅔~frac25~⅖~frac35~⅗~frac38~⅜~frac45~⅘~frac56~⅚~frac58~⅝~frac78~⅞~frown~⌢~fscr~𝒻~gE~≧~gEl~⪌~gacute~ǵ~gammad~ϝ~gap~⪆~gbreve~ğ~gcirc~ĝ~gcy~г~gdot~ġ~gel~⋛~geq~≥~geqq~≧~geqslant~⩾~ges~⩾~gescc~⪩~gesdot~⪀~gesdoto~⪂~gesdotol~⪄~gesl~⋛︀~gesles~⪔~gfr~𝔤~gg~≫~ggg~⋙~gimel~ℷ~gjcy~ѓ~gl~≷~glE~⪒~gla~⪥~glj~⪤~gnE~≩~gnap~⪊~gnapprox~⪊~gne~⪈~gneq~⪈~gneqq~≩~gnsim~⋧~gopf~𝕘~grave~`~gscr~ℊ~gsim~≳~gsime~⪎~gsiml~⪐~gtcc~⪧~gtcir~⩺~gtdot~⋗~gtlPar~⦕~gtquest~⩼~gtrapprox~⪆~gtrarr~⥸~gtrdot~⋗~gtreqless~⋛~gtreqqless~⪌~gtrless~≷~gtrsim~≳~gvertneqq~≩︀~gvnE~≩︀~hairsp~ ~half~½~hamilt~ℋ~hardcy~ъ~harrcir~⥈~harrw~↭~hbar~ℏ~hcirc~ĥ~heartsuit~♥~hercon~⊹~hfr~𝔥~hksearow~⤥~hkswarow~⤦~hoarr~⇿~homtht~∻~hookleftarrow~↩~hookrightarrow~↪~hopf~𝕙~horbar~―~hscr~𝒽~hslash~ℏ~hstrok~ħ~hybull~⁃~hyphen~‐~ic~⁣~icy~и~iecy~е~iff~⇔~ifr~𝔦~ii~ⅈ~iiiint~⨌~iiint~∭~iinfin~⧜~iiota~℩~ijlig~ĳ~imacr~ī~imagline~ℐ~imagpart~ℑ~imath~ı~imof~⊷~imped~Ƶ~in~∈~incare~℅~infintie~⧝~inodot~ı~intcal~⊺~integers~ℤ~intercal~⊺~intlarhk~⨗~intprod~⨼~iocy~ё~iogon~į~iopf~𝕚~iprod~⨼~iscr~𝒾~isinE~⋹~isindot~⋵~isins~⋴~isinsv~⋳~isinv~∈~it~⁢~itilde~ĩ~iukcy~і~jcirc~ĵ~jcy~й~jfr~𝔧~jmath~ȷ~jopf~𝕛~jscr~𝒿~jsercy~ј~jukcy~є~kappav~ϰ~kcedil~ķ~kcy~к~kfr~𝔨~kgreen~ĸ~khcy~х~kjcy~ќ~kopf~𝕜~kscr~𝓀~lAarr~⇚~lAtail~⤛~lBarr~⤎~lE~≦~lEg~⪋~lHar~⥢~lacute~ĺ~laemptyv~⦴~lagran~ℒ~langd~⦑~langle~⟨~lap~⪅~larrb~⇤~larrbfs~⤟~larrfs~⤝~larrhk~↩~larrlp~↫~larrpl~⤹~larrsim~⥳~larrtl~↢~lat~⪫~latail~⤙~late~⪭~lates~⪭︀~lbarr~⤌~lbbrk~❲~lbrace~{~lbrack~[~lbrke~⦋~lbrksld~⦏~lbrkslu~⦍~lcaron~ľ~lcedil~ļ~lcub~{~lcy~л~ldca~⤶~ldquor~„~ldrdhar~⥧~ldrushar~⥋~ldsh~↲~leftarrow~←~leftarrowtail~↢~leftharpoondown~↽~leftharpoonup~↼~leftleftarrows~⇇~leftrightarrow~↔~leftrightarrows~⇆~leftrightharpoons~⇋~leftrightsquigarrow~↭~leftthreetimes~⋋~leg~⋚~leq~≤~leqq~≦~leqslant~⩽~les~⩽~lescc~⪨~lesdot~⩿~lesdoto~⪁~lesdotor~⪃~lesg~⋚︀~lesges~⪓~lessapprox~⪅~lessdot~⋖~lesseqgtr~⋚~lesseqqgtr~⪋~lessgtr~≶~lesssim~≲~lfisht~⥼~lfr~𝔩~lg~≶~lgE~⪑~lhard~↽~lharu~↼~lharul~⥪~lhblk~▄~ljcy~љ~ll~≪~llarr~⇇~llcorner~⌞~llhard~⥫~lltri~◺~lmidot~ŀ~lmoust~⎰~lmoustache~⎰~lnE~≨~lnap~⪉~lnapprox~⪉~lne~⪇~lneq~⪇~lneqq~≨~lnsim~⋦~loang~⟬~loarr~⇽~lobrk~⟦~longleftarrow~⟵~longleftrightarrow~⟷~longmapsto~⟼~longrightarrow~⟶~looparrowleft~↫~looparrowright~↬~lopar~⦅~lopf~𝕝~loplus~⨭~lotimes~⨴~lowbar~_~lozenge~◊~lozf~⧫~lpar~(~lparlt~⦓~lrarr~⇆~lrcorner~⌟~lrhar~⇋~lrhard~⥭~lrtri~⊿~lscr~𝓁~lsh~↰~lsim~≲~lsime~⪍~lsimg~⪏~lsqb~[~lsquor~‚~lstrok~ł~ltcc~⪦~ltcir~⩹~ltdot~⋖~lthree~⋋~ltimes~⋉~ltlarr~⥶~ltquest~⩻~ltrPar~⦖~ltri~◃~ltrie~⊴~ltrif~◂~lurdshar~⥊~luruhar~⥦~lvertneqq~≨︀~lvnE~≨︀~mDDot~∺~male~♂~malt~✠~maltese~✠~map~↦~mapsto~↦~mapstodown~↧~mapstoleft~↤~mapstoup~↥~marker~▮~mcomma~⨩~mcy~м~measuredangle~∡~mfr~𝔪~mho~℧~mid~∣~midast~*~midcir~⫰~minusb~⊟~minusd~∸~minusdu~⨪~mlcp~⫛~mldr~…~mnplus~∓~models~⊧~mopf~𝕞~mp~∓~mscr~𝓂~mstpos~∾~multimap~⊸~mumap~⊸~nGg~⋙̸~nGt~≫⃒~nGtv~≫̸~nLeftarrow~⇍~nLeftrightarrow~⇎~nLl~⋘̸~nLt~≪⃒~nLtv~≪̸~nRightarrow~⇏~nVDash~⊯~nVdash~⊮~nacute~ń~nang~∠⃒~nap~≉~napE~⩰̸~napid~≋̸~napos~ŉ~napprox~≉~natur~♮~natural~♮~naturals~ℕ~nbump~≎̸~nbumpe~≏̸~ncap~⩃~ncaron~ň~ncedil~ņ~ncong~≇~ncongdot~⩭̸~ncup~⩂~ncy~н~neArr~⇗~nearhk~⤤~nearr~↗~nearrow~↗~nedot~≐̸~nequiv~≢~nesear~⤨~nesim~≂̸~nexist~∄~nexists~∄~nfr~𝔫~ngE~≧̸~nge~≱~ngeq~≱~ngeqq~≧̸~ngeqslant~⩾̸~nges~⩾̸~ngsim~≵~ngt~≯~ngtr~≯~nhArr~⇎~nharr~↮~nhpar~⫲~nis~⋼~nisd~⋺~niv~∋~njcy~њ~nlArr~⇍~nlE~≦̸~nlarr~↚~nldr~‥~nle~≰~nleftarrow~↚~nleftrightarrow~↮~nleq~≰~nleqq~≦̸~nleqslant~⩽̸~nles~⩽̸~nless~≮~nlsim~≴~nlt~≮~nltri~⋪~nltrie~⋬~nmid~∤~nopf~𝕟~notinE~⋹̸~notindot~⋵̸~notinva~∉~notinvb~⋷~notinvc~⋶~notni~∌~notniva~∌~notnivb~⋾~notnivc~⋽~npar~∦~nparallel~∦~nparsl~⫽⃥~npart~∂̸~npolint~⨔~npr~⊀~nprcue~⋠~npre~⪯̸~nprec~⊀~npreceq~⪯̸~nrArr~⇏~nrarr~↛~nrarrc~⤳̸~nrarrw~↝̸~nrightarrow~↛~nrtri~⋫~nrtrie~⋭~nsc~⊁~nsccue~⋡~nsce~⪰̸~nscr~𝓃~nshortmid~∤~nshortparallel~∦~nsim~≁~nsime~≄~nsimeq~≄~nsmid~∤~nspar~∦~nsqsube~⋢~nsqsupe~⋣~nsubE~⫅̸~nsube~⊈~nsubset~⊂⃒~nsubseteq~⊈~nsubseteqq~⫅̸~nsucc~⊁~nsucceq~⪰̸~nsup~⊅~nsupE~⫆̸~nsupe~⊉~nsupset~⊃⃒~nsupseteq~⊉~nsupseteqq~⫆̸~ntgl~≹~ntlg~≸~ntriangleleft~⋪~ntrianglelefteq~⋬~ntriangleright~⋫~ntrianglerighteq~⋭~num~#~numero~№~numsp~ ~nvDash~⊭~nvHarr~⤄~nvap~≍⃒~nvdash~⊬~nvge~≥⃒~nvgt~>⃒~nvinfin~⧞~nvlArr~⤂~nvle~≤⃒~nvlt~<⃒~nvltrie~⊴⃒~nvrArr~⤃~nvrtrie~⊵⃒~nvsim~∼⃒~nwArr~⇖~nwarhk~⤣~nwarr~↖~nwarrow~↖~nwnear~⤧~oS~Ⓢ~oast~⊛~ocir~⊚~ocy~о~odash~⊝~odblac~ő~odiv~⨸~odot~⊙~odsold~⦼~ofcir~⦿~ofr~𝔬~ogon~˛~ogt~⧁~ohbar~⦵~ohm~Ω~oint~∮~olarr~↺~olcir~⦾~olcross~⦻~olt~⧀~omacr~ō~omid~⦶~ominus~⊖~oopf~𝕠~opar~⦷~operp~⦹~orarr~↻~ord~⩝~order~ℴ~orderof~ℴ~origof~⊶~oror~⩖~orslope~⩗~orv~⩛~oscr~ℴ~osol~⊘~otimesas~⨶~ovbar~⌽~par~∥~parallel~∥~parsim~⫳~parsl~⫽~pcy~п~percnt~%~period~.~pertenk~‱~pfr~𝔭~phiv~ϕ~phmmat~ℳ~phone~☎~pitchfork~⋔~planck~ℏ~planckh~ℎ~plankv~ℏ~plus~+~plusacir~⨣~plusb~⊞~pluscir~⨢~plusdo~∔~plusdu~⨥~pluse~⩲~plussim~⨦~plustwo~⨧~pm~±~pointint~⨕~popf~𝕡~pr~≺~prE~⪳~prap~⪷~prcue~≼~pre~⪯~prec~≺~precapprox~⪷~preccurlyeq~≼~preceq~⪯~precnapprox~⪹~precneqq~⪵~precnsim~⋨~precsim~≾~primes~ℙ~prnE~⪵~prnap~⪹~prnsim~⋨~profalar~⌮~profline~⌒~profsurf~⌓~propto~∝~prsim~≾~prurel~⊰~pscr~𝓅~puncsp~ ~qfr~𝔮~qint~⨌~qopf~𝕢~qprime~⁗~qscr~𝓆~quaternions~ℍ~quatint~⨖~quest~?~questeq~≟~rAarr~⇛~rAtail~⤜~rBarr~⤏~rHar~⥤~race~∽̱~racute~ŕ~raemptyv~⦳~rangd~⦒~range~⦥~rangle~⟩~rarrap~⥵~rarrb~⇥~rarrbfs~⤠~rarrc~⤳~rarrfs~⤞~rarrhk~↪~rarrlp~↬~rarrpl~⥅~rarrsim~⥴~rarrtl~↣~rarrw~↝~ratail~⤚~ratio~∶~rationals~ℚ~rbarr~⤍~rbbrk~❳~rbrace~}~rbrack~]~rbrke~⦌~rbrksld~⦎~rbrkslu~⦐~rcaron~ř~rcedil~ŗ~rcub~}~rcy~р~rdca~⤷~rdldhar~⥩~rdquor~”~rdsh~↳~realine~ℛ~realpart~ℜ~reals~ℝ~rect~▭~rfisht~⥽~rfr~𝔯~rhard~⇁~rharu~⇀~rharul~⥬~rhov~ϱ~rightarrow~→~rightarrowtail~↣~rightharpoondown~⇁~rightharpoonup~⇀~rightleftarrows~⇄~rightleftharpoons~⇌~rightrightarrows~⇉~rightsquigarrow~↝~rightthreetimes~⋌~ring~˚~risingdotseq~≓~rlarr~⇄~rlhar~⇌~rmoust~⎱~rmoustache~⎱~rnmid~⫮~roang~⟭~roarr~⇾~robrk~⟧~ropar~⦆~ropf~𝕣~roplus~⨮~rotimes~⨵~rpar~)~rpargt~⦔~rppolint~⨒~rrarr~⇉~rscr~𝓇~rsh~↱~rsqb~]~rsquor~’~rthree~⋌~rtimes~⋊~rtri~▹~rtrie~⊵~rtrif~▸~rtriltri~⧎~ruluhar~⥨~rx~℞~sacute~ś~sc~≻~scE~⪴~scap~⪸~sccue~≽~sce~⪰~scedil~ş~scirc~ŝ~scnE~⪶~scnap~⪺~scnsim~⋩~scpolint~⨓~scsim~≿~scy~с~sdotb~⊡~sdote~⩦~seArr~⇘~searhk~⤥~searr~↘~searrow~↘~semi~;~seswar~⤩~setminus~∖~setmn~∖~sext~✶~sfr~𝔰~sfrown~⌢~sharp~♯~shchcy~щ~shcy~ш~shortmid~∣~shortparallel~∥~sigmav~ς~simdot~⩪~sime~≃~simeq~≃~simg~⪞~simgE~⪠~siml~⪝~simlE~⪟~simne~≆~simplus~⨤~simrarr~⥲~slarr~←~smallsetminus~∖~smashp~⨳~smeparsl~⧤~smid~∣~smile~⌣~smt~⪪~smte~⪬~smtes~⪬︀~softcy~ь~sol~/~solb~⧄~solbar~⌿~sopf~𝕤~spadesuit~♠~spar~∥~sqcap~⊓~sqcaps~⊓︀~sqcup~⊔~sqcups~⊔︀~sqsub~⊏~sqsube~⊑~sqsubset~⊏~sqsubseteq~⊑~sqsup~⊐~sqsupe~⊒~sqsupset~⊐~sqsupseteq~⊒~squ~□~square~□~squarf~▪~squf~▪~srarr~→~sscr~𝓈~ssetmn~∖~ssmile~⌣~sstarf~⋆~star~☆~starf~★~straightepsilon~ϵ~straightphi~ϕ~strns~¯~subE~⫅~subdot~⪽~subedot~⫃~submult~⫁~subnE~⫋~subne~⊊~subplus~⪿~subrarr~⥹~subset~⊂~subseteq~⊆~subseteqq~⫅~subsetneq~⊊~subsetneqq~⫋~subsim~⫇~subsub~⫕~subsup~⫓~succ~≻~succapprox~⪸~succcurlyeq~≽~succeq~⪰~succnapprox~⪺~succneqq~⪶~succnsim~⋩~succsim~≿~sung~♪~supE~⫆~supdot~⪾~supdsub~⫘~supedot~⫄~suphsol~⟉~suphsub~⫗~suplarr~⥻~supmult~⫂~supnE~⫌~supne~⊋~supplus~⫀~supset~⊃~supseteq~⊇~supseteqq~⫆~supsetneq~⊋~supsetneqq~⫌~supsim~⫈~supsub~⫔~supsup~⫖~swArr~⇙~swarhk~⤦~swarr~↙~swarrow~↙~swnwar~⤪~target~⌖~tbrk~⎴~tcaron~ť~tcedil~ţ~tcy~т~tdot~⃛~telrec~⌕~tfr~𝔱~therefore~∴~thetav~ϑ~thickapprox~≈~thicksim~∼~thkap~≈~thksim~∼~timesb~⊠~timesbar~⨱~timesd~⨰~tint~∭~toea~⤨~top~⊤~topbot~⌶~topcir~⫱~topf~𝕥~topfork~⫚~tosa~⤩~tprime~‴~triangle~▵~triangledown~▿~triangleleft~◃~trianglelefteq~⊴~triangleq~≜~triangleright~▹~trianglerighteq~⊵~tridot~◬~trie~≜~triminus~⨺~triplus~⨹~trisb~⧍~tritime~⨻~trpezium~⏢~tscr~𝓉~tscy~ц~tshcy~ћ~tstrok~ŧ~twixt~≬~twoheadleftarrow~↞~twoheadrightarrow~↠~uHar~⥣~ubrcy~ў~ubreve~ŭ~ucy~у~udarr~⇅~udblac~ű~udhar~⥮~ufisht~⥾~ufr~𝔲~uharl~↿~uharr~↾~uhblk~▀~ulcorn~⌜~ulcorner~⌜~ulcrop~⌏~ultri~◸~umacr~ū~uogon~ų~uopf~𝕦~uparrow~↑~updownarrow~↕~upharpoonleft~↿~upharpoonright~↾~uplus~⊎~upsi~υ~upuparrows~⇈~urcorn~⌝~urcorner~⌝~urcrop~⌎~uring~ů~urtri~◹~uscr~𝓊~utdot~⋰~utilde~ũ~utri~▵~utrif~▴~uuarr~⇈~uwangle~⦧~vArr~⇕~vBar~⫨~vBarv~⫩~vDash~⊨~vangrt~⦜~varepsilon~ϵ~varkappa~ϰ~varnothing~∅~varphi~ϕ~varpi~ϖ~varpropto~∝~varr~↕~varrho~ϱ~varsigma~ς~varsubsetneq~⊊︀~varsubsetneqq~⫋︀~varsupsetneq~⊋︀~varsupsetneqq~⫌︀~vartheta~ϑ~vartriangleleft~⊲~vartriangleright~⊳~vcy~в~vdash~⊢~vee~∨~veebar~⊻~veeeq~≚~vellip~⋮~verbar~|~vert~|~vfr~𝔳~vltri~⊲~vnsub~⊂⃒~vnsup~⊃⃒~vopf~𝕧~vprop~∝~vrtri~⊳~vscr~𝓋~vsubnE~⫋︀~vsubne~⊊︀~vsupnE~⫌︀~vsupne~⊋︀~vzigzag~⦚~wcirc~ŵ~wedbar~⩟~wedge~∧~wedgeq~≙~wfr~𝔴~wopf~𝕨~wp~℘~wr~≀~wreath~≀~wscr~𝓌~xcap~⋂~xcirc~◯~xcup~⋃~xdtri~▽~xfr~𝔵~xhArr~⟺~xharr~⟷~xlArr~⟸~xlarr~⟵~xmap~⟼~xnis~⋻~xodot~⨀~xopf~𝕩~xoplus~⨁~xotime~⨂~xrArr~⟹~xrarr~⟶~xscr~𝓍~xsqcup~⨆~xuplus~⨄~xutri~△~xvee~⋁~xwedge~⋀~yacy~я~ycirc~ŷ~ycy~ы~yfr~𝔶~yicy~ї~yopf~𝕪~yscr~𝓎~yucy~ю~zacute~ź~zcaron~ž~zcy~з~zdot~ż~zeetrf~ℨ~zfr~𝔷~zhcy~ж~zigrarr~⇝~zopf~𝕫~zscr~𝓏~~AMP~&~COPY~©~GT~>~LT~<~QUOT~"~REG~®', Qu.html4);
var jN = {
  0: 65533,
  128: 8364,
  130: 8218,
  131: 402,
  132: 8222,
  133: 8230,
  134: 8224,
  135: 8225,
  136: 710,
  137: 8240,
  138: 352,
  139: 8249,
  140: 338,
  142: 381,
  145: 8216,
  146: 8217,
  147: 8220,
  148: 8221,
  149: 8226,
  150: 8211,
  151: 8212,
  152: 732,
  153: 8482,
  154: 353,
  155: 8250,
  156: 339,
  158: 382,
  159: 376
}, GN = String.fromCodePoint || function(r) {
  return String.fromCharCode(Math.floor((r - 65536) / 1024) + 55296, (r - 65536) % 1024 + 56320);
}, Yu = function() {
  return Yu = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, Yu.apply(this, arguments);
}, qN = Yu(Yu({}, Qu), { all: Qu.html5 }), WN = {
  scope: "body",
  level: "all"
}, C0 = /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);/g, S0 = /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+)[;=]?/g, bC = {
  xml: {
    strict: C0,
    attribute: S0,
    body: x0.xml
  },
  html4: {
    strict: C0,
    attribute: S0,
    body: x0.html4
  },
  html5: {
    strict: C0,
    attribute: S0,
    body: x0.html5
  }
}, QN = Yu(Yu({}, bC), { all: bC.html5 }), rF = String.fromCharCode, YN = rF(65533);
function XN(r, e, t, n) {
  var i = r, a = r[r.length - 1];
  if (t && a === "=")
    i = r;
  else if (n && a !== ";")
    i = r;
  else {
    var s = e[r];
    if (s)
      i = s;
    else if (r[0] === "&" && r[1] === "#") {
      var o = r[2], l = o == "x" || o == "X" ? parseInt(r.substr(3), 16) : parseInt(r.substr(2));
      i = l >= 1114111 ? YN : l > 65535 ? GN(l) : rF(jN[l] || l);
    }
  }
  return i;
}
function JN(r, e) {
  var t = WN, n = t.level, i = n === void 0 ? "all" : n, a = t.scope, s = a === void 0 ? i === "xml" ? "strict" : "body" : a;
  if (!r)
    return "";
  var o = QN[i][s], l = qN[i].entities, u = s === "attribute", c = s === "strict";
  return r.replace(o, function(d) {
    return XN(d, l, u, c);
  });
}
const nF = /* @__PURE__ */ new Map();
class KN {
  constructor(e) {
    this.font = e, this.glyphsFromText = /* @__PURE__ */ new Map(), this.kerningValues = /* @__PURE__ */ new Map(), this.height = this.calculateApproximateHeight();
  }
  getFont() {
    return this.font;
  }
  getGlyphs(e) {
    const t = this.glyphsFromText.get(e);
    if (t)
      return t;
    const n = this.font.stringToGlyphs(e);
    return this.glyphsFromText.set(e, n), n;
  }
  /**
   * @returns The approximate height of any text line based on all main characters of the alphabet.
   */
  getApproximateHeight() {
    return this.height;
  }
  /**
   * Computes the exact height of a line of text.
   * @param text
   * @returns
   */
  getExactHeight(e) {
    const t = this.font.stringToGlyphs(e);
    let n = 0, i = 0;
    return t.forEach((a) => {
      const s = a.getMetrics();
      n = Math.max(n, s.yMax), i = Math.min(i, s.yMin);
    }), n - i;
  }
  getKerningValue(e, t) {
    if (!e.name || !t.name) return;
    let n = this.kerningValues.get(e.name);
    n || (n = /* @__PURE__ */ new Map(), this.kerningValues.set(e.name, n));
    let i = n.get(t.name);
    return i || (i = this.font.getKerningValue(e, t), n.set(t.name, i)), i;
  }
  calculateApproximateHeight() {
    const t = this.font.stringToGlyphs("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789");
    let n = 0, i = 0;
    return t.forEach((a) => {
      const s = a.getMetrics();
      n = Math.max(n, s.yMax), i = Math.min(i, s.yMin);
    }), n - i;
  }
}
const ZN = (r) => r.substring(0, 5).toLowerCase().trim() === "data:", E0 = /* @__PURE__ */ new Map(), uc = async (r) => {
  if (E0.has(r))
    return E0.get(r);
  const t = (async () => {
    try {
      return So(r).getFont();
    } catch {
      if (ZN(r)) {
        const n = Ck(r), i = $y(n);
        return Hy(r, i), i;
      } else {
        const n = await Fg(r, !0), i = $y(n);
        return Hy(r, i), await P4(i, r), i;
      }
    }
  })();
  return E0.set(r, t), t;
}, e8 = (r) => {
  const e = Ck(r), t = $y(e);
  return Hy(r, t), t;
}, So = (r) => {
  const e = nF.get(r);
  if (e)
    return e;
  throw new Error("Font metrics unavailable for font");
}, Hy = (r, e) => {
  const t = new KN(e);
  return nF.set(r, t), t;
}, FQ = async (r) => {
  const e = _s(), t = e.parseFromString(r, "image/svg+xml"), n = t.firstElementChild, i = /* @__PURE__ */ new Map();
  n.querySelectorAll("style").forEach((c) => {
    Fk.parse(c.innerHTML).stylesheet?.rules.forEach((f) => {
      if (f.type === "font-face" && f.declarations) {
        const h = f.declarations.find(
          (y) => y.property === "font-family"
        )?.value, v = f.declarations.find((y) => y.property === "src")?.value?.match(/'(https.*?)'/)?.[1];
        h && v && i.set(h, v);
      }
    });
  });
  const s = t.querySelectorAll("tspan");
  for (let c = 0; c < s.length; c++) {
    const d = s.item(c), f = d.closest("text"), h = d.closest("g"), g = f.getAttribute("font-family"), v = await uc(i.get(g)), y = JN(d.innerHTML), A = f.getAttribute("fill"), x = f.getAttribute("stroke"), k = f.getAttribute("stroke-width"), F = v.getPath(y, 0, 0, parseInt(f.getAttribute("font-size") ?? "72")), S = F.getBoundingBox().x2 - F.getBoundingBox().x1;
    let R = 0;
    const M = d.getAttribute("text-anchor");
    M === "middle" ? R = S / 2 : M === "end" && (R = S);
    const j = v.getPath(
      y,
      parseFloat(d.getAttribute("x") ?? "0") - R,
      parseFloat(d.getAttribute("y") ?? "0"),
      parseInt(f.getAttribute("font-size") ?? "72")
    );
    j.fill = A, j.stroke = x, j.strokeWidth = parseFloat(k ?? "0");
    const G = j.toSVG(2), q = e.parseFromString(G, "image/svg+xml").firstElementChild;
    h.appendChild(q);
  }
  return t.querySelectorAll("text").forEach((c) => c.remove()), El().serializeToString(n);
}, og = (r, e, t, n) => Math.max(i8(r.join(`
`), t, n), e), wC = (r, e, t, n, i, a) => {
  const s = (a || sF) * i.getApproximateHeight(), o = e.split(`
`);
  try {
    const l = o.flatMap((c) => Np(c, r.width, n, i)), u = l.flatMap((c) => c.lines);
    return {
      lines: u,
      requiredHeight: l.flatMap((c) => c.lines).length * (n * s),
      fontSize: t,
      requiredWidth: og(u, r.width, n, i)
    };
  } catch {
    const u = e.split("");
    return {
      lines: u,
      requiredHeight: u.length * (n * s),
      fontSize: t,
      requiredWidth: og(u, r.width, n, i)
    };
  }
}, Np = (r, e, t, n) => {
  const i = uo(r, t, n);
  if (i <= e)
    return { lines: [r], width: i };
  if (!(r.indexOf(" ") > -1)) {
    if (r.length <= 1)
      throw new Error(`Character ${r} is wider than region`);
    const c = Math.floor(r.length / 2), d = Np(r.slice(0, c), e, t, n), f = Np(r.slice(c), e, t, n);
    return { lines: [...d.lines, ...f.lines], width: Math.max(d.width, f.width) };
  }
  const s = r.split(" "), o = [];
  let l = -1 / 0, u = 0;
  for (; u < s.length; ) {
    const c = s[u];
    if (uo(c, t, n) > e) {
      const d = Np(c, e, t, n);
      o.push(...d.lines), l = Math.max(l, d.width), u++;
    } else {
      const d = [c];
      l = Math.max(l, uo(c, t, n));
      let f = u + 1, h = !0;
      for (; f < s.length && h; ) {
        const g = s[f], v = uo(`${d.join(" ")} ${g}`, t, n);
        v <= e ? (d.push(g), l = Math.max(l, v), f++) : h = !1;
      }
      o.push(d.join(" ")), u = f;
    }
  }
  if (l < 0)
    throw new Error(`No max width calculated for text: ${o}.`);
  return { lines: o, width: l };
}, t8 = (r, e, t, n, i, a) => {
  const s = (a ?? sF) * e.getApproximateHeight(), o = 1 / t.unitsPerEm, l = iF(r, o, e), u = r.length * s * o, c = n / l, d = i / u;
  return Math.min(d, c);
}, r8 = (r, e, t, n) => {
  const i = So(e.fontData.assetUrl), a = i.getFont(), s = e.fontSize / a.unitsPerEm;
  if (!t)
    return wC(
      e,
      r,
      e.fontSize,
      s,
      i,
      n
    );
  let o;
  if (e.text ? o = e.text.split(`
`) : o = e.input?.split(`
`) ?? [""], t.input === r && e.width === t.width && e.height === t.height && e.lineHeight === t.lineHeight)
    return {
      lines: o,
      requiredHeight: e.height,
      requiredWidth: og(o, e.width, s, i),
      fontSize: e.fontSize
    };
  const l = e.width !== t.width != (e.height !== t.height);
  return e.lineHeight === t.lineHeight && !l && t.input === r ? {
    lines: o,
    requiredHeight: e.height,
    requiredWidth: og(o, e.width, s, i),
    fontSize: t8(o, i, a, e.width, e.height, n)
  } : wC(
    e,
    r,
    e.fontSize,
    s,
    i,
    n
  );
}, n8 = (r, e, t, n, i) => {
  const s = So(e.assetUrl).getFont();
  let o = { ...r };
  const l = { ...r }, u = iF(n, t / s.unitsPerEm, So(e.assetUrl));
  return u && u < o.width && (l.width = u, i === "left" ? (l.left += Math.sin(o.rotation * Math.PI / 360) * (o.width - u), l.top += Math.sin(o.rotation * Math.PI / 180) * (u - o.width) / 2) : i === "right" ? l.left += o.width - u : l.left += (o.width - u) / 2, n && a8(n, n).every(([c, d]) => c === d) && (o = l)), o;
}, k0 = 1, uo = (r, e, t) => {
  let n = 0;
  const i = t.getGlyphs(r);
  return i.forEach((a, s) => {
    if (a.advanceWidth && (n += a.advanceWidth), s < i.length - 1) {
      const o = t.getKerningValue(a, i[s + 1]);
      n += o || 0;
    }
  }), n *= e, n;
}, i8 = (r, e, t) => {
  let n = 0;
  const i = t.getGlyphs(r);
  return i.forEach((a, s) => {
    if (a.advanceWidth && (n = Math.max(n, a.advanceWidth)), s < i.length - 1) {
      const o = t.getKerningValue(a, i[s + 1]);
      n = Math.max(n, o || 0);
    }
  }), n *= e, n;
}, iF = (r, e, t) => {
  let n = 0;
  return r.forEach((i) => {
    n = Math.max(n, uo(i, e, t));
  }), n;
}, xC = {
  stripControlCharacters: !0,
  vertical: !1,
  uppercase: !1
}, lg = (r, e = xC) => {
  const t = { ...xC, ...e };
  let n = r || "";
  return t.stripControlCharacters && (n = n.replace(/^(?![\u000A\u000D])[\u0000-\u001F\u007F-\u009F]/g, "")), t.uppercase && (n = n.toUpperCase()), t.vertical && (n = n.split("").join(`
`)), n;
}, a8 = (r, e) => r.map((t, n) => [t, e[n]]), s8 = (r = "center", e = !1) => e ? "center" : r, aF = (r) => r === "left" ? "start" : r === "right" ? "end" : "middle", Nd = (r, e, t) => r.fontData ? {
  ...r,
  ...(() => {
    if (r.algorithm === ic.Traditional) {
      const i = r8(e, r, t, r.lineHeight);
      return {
        text: i.lines.join(`
`),
        height: i.requiredHeight,
        width: i.requiredWidth,
        fontSize: i.fontSize,
        input: e
      };
    } else
      return {
        text: e
      };
  })()
} : r, sF = 1.1;
var zh = { exports: {} }, $h = { exports: {} }, Ea = {}, zi = {}, CC;
function Gi() {
  if (CC) return zi;
  CC = 1, zi.__esModule = !0, zi.extend = i, zi.indexOf = l, zi.escapeExpression = u, zi.isEmpty = c, zi.createFrame = d, zi.blockParams = f, zi.appendContextPath = h;
  var r = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#x27;",
    "`": "&#x60;",
    "=": "&#x3D;"
  }, e = /[&<>"'`=]/g, t = /[&<>"'`=]/;
  function n(g) {
    return r[g];
  }
  function i(g) {
    for (var v = 1; v < arguments.length; v++)
      for (var y in arguments[v])
        Object.prototype.hasOwnProperty.call(arguments[v], y) && (g[y] = arguments[v][y]);
    return g;
  }
  var a = Object.prototype.toString;
  zi.toString = a;
  var s = function(v) {
    return typeof v == "function";
  };
  s(/x/) && (zi.isFunction = s = function(g) {
    return typeof g == "function" && a.call(g) === "[object Function]";
  }), zi.isFunction = s;
  var o = Array.isArray || function(g) {
    return g && typeof g == "object" ? a.call(g) === "[object Array]" : !1;
  };
  zi.isArray = o;
  function l(g, v) {
    for (var y = 0, A = g.length; y < A; y++)
      if (g[y] === v)
        return y;
    return -1;
  }
  function u(g) {
    if (typeof g != "string") {
      if (g && g.toHTML)
        return g.toHTML();
      if (g == null)
        return "";
      if (!g)
        return g + "";
      g = "" + g;
    }
    return t.test(g) ? g.replace(e, n) : g;
  }
  function c(g) {
    return !g && g !== 0 ? !0 : !!(o(g) && g.length === 0);
  }
  function d(g) {
    var v = i({}, g);
    return v._parent = g, v;
  }
  function f(g, v) {
    return g.path = v, g;
  }
  function h(g, v) {
    return (g ? g + "." : "") + v;
  }
  return zi;
}
var Hh = { exports: {} }, SC;
function ma() {
  return SC || (SC = 1, (function(r, e) {
    e.__esModule = !0;
    var t = ["description", "fileName", "lineNumber", "endLineNumber", "message", "name", "number", "stack"];
    function n(i, a) {
      var s = a && a.loc, o = void 0, l = void 0, u = void 0, c = void 0;
      s && (o = s.start.line, l = s.end.line, u = s.start.column, c = s.end.column, i += " - " + o + ":" + u);
      for (var d = Error.prototype.constructor.call(this, i), f = 0; f < t.length; f++)
        this[t[f]] = d[t[f]];
      Error.captureStackTrace && Error.captureStackTrace(this, n);
      try {
        s && (this.lineNumber = o, this.endLineNumber = l, Object.defineProperty ? (Object.defineProperty(this, "column", {
          value: u,
          enumerable: !0
        }), Object.defineProperty(this, "endColumn", {
          value: c,
          enumerable: !0
        })) : (this.column = u, this.endColumn = c));
      } catch {
      }
    }
    n.prototype = new Error(), e.default = n, r.exports = e.default;
  })(Hh, Hh.exports)), Hh.exports;
}
var cf = {}, jh = { exports: {} }, EC;
function o8() {
  return EC || (EC = 1, (function(r, e) {
    e.__esModule = !0;
    var t = Gi();
    e.default = function(n) {
      n.registerHelper("blockHelperMissing", function(i, a) {
        var s = a.inverse, o = a.fn;
        if (i === !0)
          return o(this);
        if (i === !1 || i == null)
          return s(this);
        if (t.isArray(i))
          return i.length > 0 ? (a.ids && (a.ids = [a.name]), n.helpers.each(i, a)) : s(this);
        if (a.data && a.ids) {
          var l = t.createFrame(a.data);
          l.contextPath = t.appendContextPath(a.data.contextPath, a.name), a = { data: l };
        }
        return o(i, a);
      });
    }, r.exports = e.default;
  })(jh, jh.exports)), jh.exports;
}
var Gh = { exports: {} }, kC;
function l8() {
  return kC || (kC = 1, (function(r, e) {
    e.__esModule = !0;
    function t(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var n = Gi(), i = ma(), a = t(i);
    e.default = function(s) {
      s.registerHelper("each", function(o, l) {
        if (!l)
          throw new a.default("Must pass iterator to #each");
        var u = l.fn, c = l.inverse, d = 0, f = "", h = void 0, g = void 0;
        l.data && l.ids && (g = n.appendContextPath(l.data.contextPath, l.ids[0]) + "."), n.isFunction(o) && (o = o.call(this)), l.data && (h = n.createFrame(l.data));
        function v(F, S, R) {
          h && (h.key = F, h.index = S, h.first = S === 0, h.last = !!R, g && (h.contextPath = g + F)), f = f + u(o[F], {
            data: h,
            blockParams: n.blockParams([o[F], F], [g + F, null])
          });
        }
        if (o && typeof o == "object")
          if (n.isArray(o))
            for (var y = o.length; d < y; d++)
              d in o && v(d, d, d === o.length - 1);
          else if (typeof Symbol == "function" && o[Symbol.iterator]) {
            for (var A = [], x = o[Symbol.iterator](), k = x.next(); !k.done; k = x.next())
              A.push(k.value);
            o = A;
            for (var y = o.length; d < y; d++)
              v(d, d, d === o.length - 1);
          } else
            (function() {
              var F = void 0;
              Object.keys(o).forEach(function(S) {
                F !== void 0 && v(F, d - 1), F = S, d++;
              }), F !== void 0 && v(F, d - 1, !0);
            })();
        return d === 0 && (f = c(this)), f;
      });
    }, r.exports = e.default;
  })(Gh, Gh.exports)), Gh.exports;
}
var qh = { exports: {} }, TC;
function u8() {
  return TC || (TC = 1, (function(r, e) {
    e.__esModule = !0;
    function t(a) {
      return a && a.__esModule ? a : { default: a };
    }
    var n = ma(), i = t(n);
    e.default = function(a) {
      a.registerHelper("helperMissing", function() {
        if (arguments.length !== 1)
          throw new i.default('Missing helper: "' + arguments[arguments.length - 1].name + '"');
      });
    }, r.exports = e.default;
  })(qh, qh.exports)), qh.exports;
}
var Wh = { exports: {} }, FC;
function c8() {
  return FC || (FC = 1, (function(r, e) {
    e.__esModule = !0;
    function t(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var n = Gi(), i = ma(), a = t(i);
    e.default = function(s) {
      s.registerHelper("if", function(o, l) {
        if (arguments.length != 2)
          throw new a.default("#if requires exactly one argument");
        return n.isFunction(o) && (o = o.call(this)), !l.hash.includeZero && !o || n.isEmpty(o) ? l.inverse(this) : l.fn(this);
      }), s.registerHelper("unless", function(o, l) {
        if (arguments.length != 2)
          throw new a.default("#unless requires exactly one argument");
        return s.helpers.if.call(this, o, {
          fn: l.inverse,
          inverse: l.fn,
          hash: l.hash
        });
      });
    }, r.exports = e.default;
  })(Wh, Wh.exports)), Wh.exports;
}
var Qh = { exports: {} }, IC;
function f8() {
  return IC || (IC = 1, (function(r, e) {
    e.__esModule = !0, e.default = function(t) {
      t.registerHelper("log", function() {
        for (var n = [void 0], i = arguments[arguments.length - 1], a = 0; a < arguments.length - 1; a++)
          n.push(arguments[a]);
        var s = 1;
        i.hash.level != null ? s = i.hash.level : i.data && i.data.level != null && (s = i.data.level), n[0] = s, t.log.apply(t, n);
      });
    }, r.exports = e.default;
  })(Qh, Qh.exports)), Qh.exports;
}
var Yh = { exports: {} }, DC;
function d8() {
  return DC || (DC = 1, (function(r, e) {
    e.__esModule = !0, e.default = function(t) {
      t.registerHelper("lookup", function(n, i, a) {
        return n && a.lookupProperty(n, i);
      });
    }, r.exports = e.default;
  })(Yh, Yh.exports)), Yh.exports;
}
var Xh = { exports: {} }, PC;
function h8() {
  return PC || (PC = 1, (function(r, e) {
    e.__esModule = !0;
    function t(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var n = Gi(), i = ma(), a = t(i);
    e.default = function(s) {
      s.registerHelper("with", function(o, l) {
        if (arguments.length != 2)
          throw new a.default("#with requires exactly one argument");
        n.isFunction(o) && (o = o.call(this));
        var u = l.fn;
        if (n.isEmpty(o))
          return l.inverse(this);
        var c = l.data;
        return l.data && l.ids && (c = n.createFrame(l.data), c.contextPath = n.appendContextPath(l.data.contextPath, l.ids[0])), u(o, {
          data: c,
          blockParams: n.blockParams([o], [c && c.contextPath])
        });
      });
    }, r.exports = e.default;
  })(Xh, Xh.exports)), Xh.exports;
}
var RC;
function oF() {
  if (RC) return cf;
  RC = 1, cf.__esModule = !0, cf.registerDefaultHelpers = v, cf.moveHelperToHooks = y;
  function r(A) {
    return A && A.__esModule ? A : { default: A };
  }
  var e = o8(), t = r(e), n = l8(), i = r(n), a = u8(), s = r(a), o = c8(), l = r(o), u = f8(), c = r(u), d = d8(), f = r(d), h = h8(), g = r(h);
  function v(A) {
    t.default(A), i.default(A), s.default(A), l.default(A), c.default(A), f.default(A), g.default(A);
  }
  function y(A, x, k) {
    A.helpers[x] && (A.hooks[x] = A.helpers[x], k || (A.helpers[x] = void 0));
  }
  return cf;
}
var Jh = {}, Kh = { exports: {} }, OC;
function p8() {
  return OC || (OC = 1, (function(r, e) {
    e.__esModule = !0;
    var t = Gi();
    e.default = function(n) {
      n.registerDecorator("inline", function(i, a, s, o) {
        var l = i;
        return a.partials || (a.partials = {}, l = function(u, c) {
          var d = s.partials;
          s.partials = t.extend({}, d, a.partials);
          var f = i(u, c);
          return s.partials = d, f;
        }), a.partials[o.args[0]] = o.fn, l;
      });
    }, r.exports = e.default;
  })(Kh, Kh.exports)), Kh.exports;
}
var BC;
function g8() {
  if (BC) return Jh;
  BC = 1, Jh.__esModule = !0, Jh.registerDefaultDecorators = n;
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var e = p8(), t = r(e);
  function n(i) {
    t.default(i);
  }
  return Jh;
}
var Zh = { exports: {} }, MC;
function lF() {
  return MC || (MC = 1, (function(r, e) {
    e.__esModule = !0;
    var t = Gi(), n = {
      methodMap: ["debug", "info", "warn", "error"],
      level: "info",
      // Maps a given level value to the `methodMap` indexes above.
      lookupLevel: function(a) {
        if (typeof a == "string") {
          var s = t.indexOf(n.methodMap, a.toLowerCase());
          s >= 0 ? a = s : a = parseInt(a, 10);
        }
        return a;
      },
      // Can be overridden in the host environment
      log: function(a) {
        if (a = n.lookupLevel(a), typeof console < "u" && n.lookupLevel(n.level) <= a) {
          var s = n.methodMap[a];
          console[s] || (s = "log");
          for (var o = arguments.length, l = Array(o > 1 ? o - 1 : 0), u = 1; u < o; u++)
            l[u - 1] = arguments[u];
          console[s].apply(console, l);
        }
      }
    };
    e.default = n, r.exports = e.default;
  })(Zh, Zh.exports)), Zh.exports;
}
var vu = {}, _C;
function uF() {
  if (_C) return vu;
  _C = 1, vu.__esModule = !0, vu.createProtoAccessControl = a, vu.resultIsAllowed = s, vu.resetLoggedProperties = u;
  function r(c) {
    return c && c.__esModule ? c : { default: c };
  }
  var e = Gi(), t = lF(), n = r(t), i = /* @__PURE__ */ Object.create(null);
  function a(c) {
    var d = /* @__PURE__ */ Object.create(null);
    d.__proto__ = !1, e.extend(d, c.allowedProtoProperties);
    var f = /* @__PURE__ */ Object.create(null);
    return f.constructor = !1, f.__defineGetter__ = !1, f.__defineSetter__ = !1, f.__lookupGetter__ = !1, f.__lookupSetter__ = !1, e.extend(f, c.allowedProtoMethods), {
      properties: {
        whitelist: d,
        defaultValue: c.allowProtoPropertiesByDefault
      },
      methods: {
        whitelist: f,
        defaultValue: c.allowProtoMethodsByDefault
      }
    };
  }
  function s(c, d, f) {
    return o(typeof c == "function" ? d.methods : d.properties, f);
  }
  function o(c, d) {
    return c.whitelist[d] !== void 0 ? c.whitelist[d] === !0 : c.defaultValue !== void 0 ? c.defaultValue : (l(d), !1);
  }
  function l(c) {
    i[c] !== !0 && (i[c] = !0, n.default.log("error", 'Handlebars: Access has been denied to resolve the property "' + c + `" because it is not an "own property" of its parent.
You can add a runtime option to disable the check or this warning:
See https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details`));
  }
  function u() {
    Object.keys(i).forEach(function(c) {
      delete i[c];
    });
  }
  return vu;
}
var NC;
function u1() {
  if (NC) return Ea;
  NC = 1, Ea.__esModule = !0, Ea.HandlebarsEnvironment = g;
  function r(y) {
    return y && y.__esModule ? y : { default: y };
  }
  var e = Gi(), t = ma(), n = r(t), i = oF(), a = g8(), s = lF(), o = r(s), l = uF(), u = "4.7.9";
  Ea.VERSION = u;
  var c = 8;
  Ea.COMPILER_REVISION = c;
  var d = 7;
  Ea.LAST_COMPATIBLE_COMPILER_REVISION = d;
  var f = {
    1: "<= 1.0.rc.2",
    // 1.0.rc.2 is actually rev2 but doesn't report it
    2: "== 1.0.0-rc.3",
    3: "== 1.0.0-rc.4",
    4: "== 1.x.x",
    5: "== 2.0.0-alpha.x",
    6: ">= 2.0.0-beta.1",
    7: ">= 4.0.0 <4.3.0",
    8: ">= 4.3.0"
  };
  Ea.REVISION_CHANGES = f;
  var h = "[object Object]";
  function g(y, A, x) {
    this.helpers = y || {}, this.partials = A || {}, this.decorators = x || {}, i.registerDefaultHelpers(this), a.registerDefaultDecorators(this);
  }
  g.prototype = {
    constructor: g,
    logger: o.default,
    log: o.default.log,
    registerHelper: function(A, x) {
      if (e.toString.call(A) === h) {
        if (x)
          throw new n.default("Arg not supported with multiple helpers");
        e.extend(this.helpers, A);
      } else
        this.helpers[A] = x;
    },
    unregisterHelper: function(A) {
      delete this.helpers[A];
    },
    registerPartial: function(A, x) {
      if (e.toString.call(A) === h)
        e.extend(this.partials, A);
      else {
        if (typeof x > "u")
          throw new n.default('Attempting to register a partial called "' + A + '" as undefined');
        this.partials[A] = x;
      }
    },
    unregisterPartial: function(A) {
      delete this.partials[A];
    },
    registerDecorator: function(A, x) {
      if (e.toString.call(A) === h) {
        if (x)
          throw new n.default("Arg not supported with multiple decorators");
        e.extend(this.decorators, A);
      } else
        this.decorators[A] = x;
    },
    unregisterDecorator: function(A) {
      delete this.decorators[A];
    },
    /**
     * Reset the memory of illegal property accesses that have already been logged.
     * @deprecated should only be used in handlebars test-cases
     */
    resetLoggedPropertyAccesses: function() {
      l.resetLoggedProperties();
    }
  };
  var v = o.default.log;
  return Ea.log = v, Ea.createFrame = e.createFrame, Ea.logger = o.default, Ea;
}
var ep = { exports: {} }, LC;
function m8() {
  return LC || (LC = 1, (function(r, e) {
    e.__esModule = !0;
    function t(n) {
      this.string = n;
    }
    t.prototype.toString = t.prototype.toHTML = function() {
      return "" + this.string;
    }, e.default = t, r.exports = e.default;
  })(ep, ep.exports)), ep.exports;
}
var Es = {}, tp = {}, UC;
function v8() {
  if (UC) return tp;
  UC = 1, tp.__esModule = !0, tp.wrapHelper = r;
  function r(e, t) {
    if (typeof e != "function")
      return e;
    var n = function() {
      var a = arguments[arguments.length - 1];
      return arguments[arguments.length - 1] = t(a), e.apply(this, arguments);
    };
    return n;
  }
  return tp;
}
var VC;
function y8() {
  if (VC) return Es;
  VC = 1, Es.__esModule = !0, Es.checkRevision = c, Es.template = d, Es.wrapProgram = f, Es.resolvePartial = h, Es.invokePartial = g, Es.noop = v;
  function r(S) {
    return S && S.__esModule ? S : { default: S };
  }
  function e(S) {
    if (S && S.__esModule)
      return S;
    var R = {};
    if (S != null)
      for (var M in S)
        Object.prototype.hasOwnProperty.call(S, M) && (R[M] = S[M]);
    return R.default = S, R;
  }
  var t = Gi(), n = e(t), i = ma(), a = r(i), s = u1(), o = oF(), l = v8(), u = uF();
  function c(S) {
    var R = S && S[0] || 1, M = s.COMPILER_REVISION;
    if (!(R >= s.LAST_COMPATIBLE_COMPILER_REVISION && R <= s.COMPILER_REVISION))
      if (R < s.LAST_COMPATIBLE_COMPILER_REVISION) {
        var j = s.REVISION_CHANGES[M], G = s.REVISION_CHANGES[R];
        throw new a.default("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" + j + ") or downgrade your runtime to an older version (" + G + ").");
      } else
        throw new a.default("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" + S[1] + ").");
  }
  function d(S, R) {
    if (!R)
      throw new a.default("No environment passed to template");
    if (!S || !S.main)
      throw new a.default("Unknown template object: " + typeof S);
    S.main.decorator = S.main_d, R.VM.checkRevision(S.compiler);
    var M = S.compiler && S.compiler[0] === 7;
    function j(q, Y, J) {
      J.hash && (Y = n.extend({}, Y, J.hash), J.ids && (J.ids[0] = !0)), q = R.VM.resolvePartial.call(this, q, Y, J), J.hooks = this.hooks, J.protoAccessControl = this.protoAccessControl;
      var se = R.VM.invokePartial.call(this, q, Y, J);
      if (se == null && R.compile && (J.partials[J.name] = R.compile(q, S.compilerOptions, R), se = J.partials[J.name](Y, J)), se != null) {
        if (J.indent) {
          for (var oe = se.split(`
`), he = 0, ye = oe.length; he < ye && !(!oe[he] && he + 1 === ye); he++)
            oe[he] = J.indent + oe[he];
          se = oe.join(`
`);
        }
        return se;
      } else
        throw new a.default("The partial " + J.name + " could not be compiled when running in runtime-only mode");
    }
    var G = {
      strict: function(Y, J, se) {
        if (!Y || !(J in Y))
          throw new a.default('"' + J + '" not defined in ' + Y, {
            loc: se
          });
        return G.lookupProperty(Y, J);
      },
      lookupProperty: function(Y, J) {
        var se = Y[J];
        if (se == null || Object.prototype.hasOwnProperty.call(Y, J) || u.resultIsAllowed(se, G.protoAccessControl, J))
          return se;
      },
      lookup: function(Y, J) {
        for (var se = Y.length, oe = 0; oe < se; oe++) {
          var he = Y[oe] && G.lookupProperty(Y[oe], J);
          if (he != null)
            return he;
        }
      },
      lambda: function(Y, J) {
        return typeof Y == "function" ? Y.call(J) : Y;
      },
      escapeExpression: n.escapeExpression,
      invokePartial: j,
      fn: function(Y) {
        var J = S[Y];
        return J.decorator = S[Y + "_d"], J;
      },
      programs: [],
      program: function(Y, J, se, oe, he) {
        var ye = this.programs[Y], Ue = this.fn(Y);
        return J || he || oe || se ? ye = f(this, Y, Ue, J, se, oe, he) : ye || (ye = this.programs[Y] = f(this, Y, Ue)), ye;
      },
      data: function(Y, J) {
        for (; Y && J--; )
          Y = Y._parent;
        return Y;
      },
      mergeIfNeeded: function(Y, J) {
        var se = Y || J;
        return Y && J && Y !== J && (se = n.extend({}, J, Y)), se;
      },
      // An empty object to use as replacement for null-contexts
      nullContext: Object.seal({}),
      noop: R.VM.noop,
      compilerInfo: S.compiler
    };
    function ie(q) {
      var Y = arguments.length <= 1 || arguments[1] === void 0 ? {} : arguments[1], J = Y.data;
      ie._setup(Y), !Y.partial && S.useData && (J = A(q, J));
      var se = void 0, oe = S.useBlockParams ? [] : void 0;
      S.useDepths && (Y.depths ? se = q != Y.depths[0] ? [q].concat(Y.depths) : Y.depths : se = [q]);
      function he(ye) {
        return "" + S.main(G, ye, G.helpers, G.partials, J, oe, se);
      }
      return he = x(S.main, he, G, Y.depths || [], J, oe), he(q, Y);
    }
    return ie.isTop = !0, ie._setup = function(q) {
      if (q.partial)
        G.protoAccessControl = q.protoAccessControl, G.helpers = q.helpers, G.partials = q.partials, G.decorators = q.decorators, G.hooks = q.hooks;
      else {
        var Y = {};
        k(Y, R.helpers, G), k(Y, q.helpers, G), G.helpers = Y, S.usePartial && (G.partials = G.mergeIfNeeded(q.partials, R.partials)), (S.usePartial || S.useDecorators) && (G.decorators = n.extend({}, R.decorators, q.decorators)), G.hooks = {}, G.protoAccessControl = u.createProtoAccessControl(q);
        var J = q.allowCallsToHelperMissing || M;
        o.moveHelperToHooks(G, "helperMissing", J), o.moveHelperToHooks(G, "blockHelperMissing", J);
      }
    }, ie._child = function(q, Y, J, se) {
      if (S.useBlockParams && !J)
        throw new a.default("must pass block params");
      if (S.useDepths && !se)
        throw new a.default("must pass parent depths");
      return f(G, q, S[q], Y, 0, J, se);
    }, ie;
  }
  function f(S, R, M, j, G, ie, q) {
    function Y(J) {
      var se = arguments.length <= 1 || arguments[1] === void 0 ? {} : arguments[1], oe = q;
      return q && J != q[0] && !(J === S.nullContext && q[0] === null) && (oe = [J].concat(q)), M(S, J, S.helpers, S.partials, se.data || j, ie && [se.blockParams].concat(ie), oe);
    }
    return Y = x(M, Y, S, q, j, ie), Y.program = R, Y.depth = q ? q.length : 0, Y.blockParams = G || 0, Y;
  }
  function h(S, R, M) {
    return S ? !S.call && !M.name && (M.name = S, S = y(M.partials, S)) : M.name === "@partial-block" ? S = y(M.data, "partial-block") : S = y(M.partials, M.name), S;
  }
  function g(S, R, M) {
    var j = y(M.data, "partial-block");
    M.partial = !0, M.ids && (M.data.contextPath = M.ids[0] || M.data.contextPath);
    var G = void 0;
    if (M.fn && M.fn !== v && (function() {
      M.data = s.createFrame(M.data);
      var ie = M.fn;
      G = M.data["partial-block"] = function(Y) {
        var J = arguments.length <= 1 || arguments[1] === void 0 ? {} : arguments[1];
        return J.data = s.createFrame(J.data), J.data["partial-block"] = j, ie(Y, J);
      }, ie.partials && (M.partials = n.extend({}, M.partials, ie.partials));
    })(), S === void 0 && G && (S = G), S === void 0)
      throw new a.default("The partial " + M.name + " could not be found");
    if (S instanceof Function)
      return S(R, M);
  }
  function v() {
    return "";
  }
  function y(S, R) {
    if (S && Object.prototype.hasOwnProperty.call(S, R))
      return S[R];
  }
  function A(S, R) {
    return (!R || !("root" in R)) && (R = R ? s.createFrame(R) : {}, R.root = S), R;
  }
  function x(S, R, M, j, G, ie) {
    if (S.decorator) {
      var q = {};
      R = S.decorator(R, q, M, j && j[0], G, ie, j), n.extend(R, q);
    }
    return R;
  }
  function k(S, R, M) {
    R && Object.keys(R).forEach(function(j) {
      var G = R[j];
      S[j] = F(G, M);
    });
  }
  function F(S, R) {
    var M = R.lookupProperty;
    return l.wrapHelper(S, function(j) {
      return j.lookupProperty = M, j;
    });
  }
  return Es;
}
var rp = { exports: {} }, zC;
function cF() {
  return zC || (zC = 1, (function(r, e) {
    e.__esModule = !0, e.default = function(t) {
      (function() {
        typeof globalThis != "object" && (Object.prototype.__defineGetter__("__magic__", function() {
          return this;
        }), __magic__.globalThis = __magic__, delete Object.prototype.__magic__);
      })();
      var n = globalThis.Handlebars;
      t.noConflict = function() {
        return globalThis.Handlebars === t && (globalThis.Handlebars = n), t;
      };
    }, r.exports = e.default;
  })(rp, rp.exports)), rp.exports;
}
var $C;
function A8() {
  return $C || ($C = 1, (function(r, e) {
    e.__esModule = !0;
    function t(x) {
      return x && x.__esModule ? x : { default: x };
    }
    function n(x) {
      if (x && x.__esModule)
        return x;
      var k = {};
      if (x != null)
        for (var F in x)
          Object.prototype.hasOwnProperty.call(x, F) && (k[F] = x[F]);
      return k.default = x, k;
    }
    var i = u1(), a = n(i), s = m8(), o = t(s), l = ma(), u = t(l), c = Gi(), d = n(c), f = y8(), h = n(f), g = cF(), v = t(g);
    function y() {
      var x = new a.HandlebarsEnvironment();
      return d.extend(x, a), x.SafeString = o.default, x.Exception = u.default, x.Utils = d, x.escapeExpression = d.escapeExpression, x.VM = h, x.template = function(k) {
        return h.template(k, x);
      }, x;
    }
    var A = y();
    A.create = y, v.default(A), A.default = A, e.default = A, r.exports = e.default;
  })($h, $h.exports)), $h.exports;
}
var np = { exports: {} }, HC;
function fF() {
  return HC || (HC = 1, (function(r, e) {
    e.__esModule = !0;
    var t = {
      // Public API used to evaluate derived attributes regarding AST nodes
      helpers: {
        // a mustache is definitely a helper if:
        // * it is an eligible helper, and
        // * it has at least one parameter or hash segment
        helperExpression: function(i) {
          return i.type === "SubExpression" || (i.type === "MustacheStatement" || i.type === "BlockStatement") && !!(i.params && i.params.length || i.hash);
        },
        scopedId: function(i) {
          return /^\.|this\b/.test(i.original);
        },
        // an ID is simple if it only has one part, and that part is not
        // `..` or `this`.
        simpleId: function(i) {
          return i.parts.length === 1 && !t.helpers.scopedId(i) && !i.depth;
        }
      }
    };
    e.default = t, r.exports = e.default;
  })(np, np.exports)), np.exports;
}
var yu = {}, ip = { exports: {} }, jC;
function b8() {
  return jC || (jC = 1, (function(r, e) {
    e.__esModule = !0;
    var t = (function() {
      var n = {
        trace: function() {
        },
        yy: {},
        symbols_: { error: 2, root: 3, program: 4, EOF: 5, program_repetition0: 6, statement: 7, mustache: 8, block: 9, rawBlock: 10, partial: 11, partialBlock: 12, content: 13, COMMENT: 14, CONTENT: 15, openRawBlock: 16, rawBlock_repetition0: 17, END_RAW_BLOCK: 18, OPEN_RAW_BLOCK: 19, helperName: 20, openRawBlock_repetition0: 21, openRawBlock_option0: 22, CLOSE_RAW_BLOCK: 23, openBlock: 24, block_option0: 25, closeBlock: 26, openInverse: 27, block_option1: 28, OPEN_BLOCK: 29, openBlock_repetition0: 30, openBlock_option0: 31, openBlock_option1: 32, CLOSE: 33, OPEN_INVERSE: 34, openInverse_repetition0: 35, openInverse_option0: 36, openInverse_option1: 37, openInverseChain: 38, OPEN_INVERSE_CHAIN: 39, openInverseChain_repetition0: 40, openInverseChain_option0: 41, openInverseChain_option1: 42, inverseAndProgram: 43, INVERSE: 44, inverseChain: 45, inverseChain_option0: 46, OPEN_ENDBLOCK: 47, OPEN: 48, mustache_repetition0: 49, mustache_option0: 50, OPEN_UNESCAPED: 51, mustache_repetition1: 52, mustache_option1: 53, CLOSE_UNESCAPED: 54, OPEN_PARTIAL: 55, partialName: 56, partial_repetition0: 57, partial_option0: 58, openPartialBlock: 59, OPEN_PARTIAL_BLOCK: 60, openPartialBlock_repetition0: 61, openPartialBlock_option0: 62, param: 63, sexpr: 64, OPEN_SEXPR: 65, sexpr_repetition0: 66, sexpr_option0: 67, CLOSE_SEXPR: 68, hash: 69, hash_repetition_plus0: 70, hashSegment: 71, ID: 72, EQUALS: 73, blockParams: 74, OPEN_BLOCK_PARAMS: 75, blockParams_repetition_plus0: 76, CLOSE_BLOCK_PARAMS: 77, path: 78, dataName: 79, STRING: 80, NUMBER: 81, BOOLEAN: 82, UNDEFINED: 83, NULL: 84, DATA: 85, pathSegments: 86, SEP: 87, $accept: 0, $end: 1 },
        terminals_: { 2: "error", 5: "EOF", 14: "COMMENT", 15: "CONTENT", 18: "END_RAW_BLOCK", 19: "OPEN_RAW_BLOCK", 23: "CLOSE_RAW_BLOCK", 29: "OPEN_BLOCK", 33: "CLOSE", 34: "OPEN_INVERSE", 39: "OPEN_INVERSE_CHAIN", 44: "INVERSE", 47: "OPEN_ENDBLOCK", 48: "OPEN", 51: "OPEN_UNESCAPED", 54: "CLOSE_UNESCAPED", 55: "OPEN_PARTIAL", 60: "OPEN_PARTIAL_BLOCK", 65: "OPEN_SEXPR", 68: "CLOSE_SEXPR", 72: "ID", 73: "EQUALS", 75: "OPEN_BLOCK_PARAMS", 77: "CLOSE_BLOCK_PARAMS", 80: "STRING", 81: "NUMBER", 82: "BOOLEAN", 83: "UNDEFINED", 84: "NULL", 85: "DATA", 87: "SEP" },
        productions_: [0, [3, 2], [4, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [13, 1], [10, 3], [16, 5], [9, 4], [9, 4], [24, 6], [27, 6], [38, 6], [43, 2], [45, 3], [45, 1], [26, 3], [8, 5], [8, 5], [11, 5], [12, 3], [59, 5], [63, 1], [63, 1], [64, 5], [69, 1], [71, 3], [74, 3], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [56, 1], [56, 1], [79, 2], [78, 1], [86, 3], [86, 1], [6, 0], [6, 2], [17, 0], [17, 2], [21, 0], [21, 2], [22, 0], [22, 1], [25, 0], [25, 1], [28, 0], [28, 1], [30, 0], [30, 2], [31, 0], [31, 1], [32, 0], [32, 1], [35, 0], [35, 2], [36, 0], [36, 1], [37, 0], [37, 1], [40, 0], [40, 2], [41, 0], [41, 1], [42, 0], [42, 1], [46, 0], [46, 1], [49, 0], [49, 2], [50, 0], [50, 1], [52, 0], [52, 2], [53, 0], [53, 1], [57, 0], [57, 2], [58, 0], [58, 1], [61, 0], [61, 2], [62, 0], [62, 1], [66, 0], [66, 2], [67, 0], [67, 1], [70, 1], [70, 2], [76, 1], [76, 2]],
        performAction: function(o, l, u, c, d, f, h) {
          var g = f.length - 1;
          switch (d) {
            case 1:
              return f[g - 1];
            case 2:
              this.$ = c.prepareProgram(f[g]);
              break;
            case 3:
              this.$ = f[g];
              break;
            case 4:
              this.$ = f[g];
              break;
            case 5:
              this.$ = f[g];
              break;
            case 6:
              this.$ = f[g];
              break;
            case 7:
              this.$ = f[g];
              break;
            case 8:
              this.$ = f[g];
              break;
            case 9:
              this.$ = {
                type: "CommentStatement",
                value: c.stripComment(f[g]),
                strip: c.stripFlags(f[g], f[g]),
                loc: c.locInfo(this._$)
              };
              break;
            case 10:
              this.$ = {
                type: "ContentStatement",
                original: f[g],
                value: f[g],
                loc: c.locInfo(this._$)
              };
              break;
            case 11:
              this.$ = c.prepareRawBlock(f[g - 2], f[g - 1], f[g], this._$);
              break;
            case 12:
              this.$ = { path: f[g - 3], params: f[g - 2], hash: f[g - 1] };
              break;
            case 13:
              this.$ = c.prepareBlock(f[g - 3], f[g - 2], f[g - 1], f[g], !1, this._$);
              break;
            case 14:
              this.$ = c.prepareBlock(f[g - 3], f[g - 2], f[g - 1], f[g], !0, this._$);
              break;
            case 15:
              this.$ = { open: f[g - 5], path: f[g - 4], params: f[g - 3], hash: f[g - 2], blockParams: f[g - 1], strip: c.stripFlags(f[g - 5], f[g]) };
              break;
            case 16:
              this.$ = { path: f[g - 4], params: f[g - 3], hash: f[g - 2], blockParams: f[g - 1], strip: c.stripFlags(f[g - 5], f[g]) };
              break;
            case 17:
              this.$ = { path: f[g - 4], params: f[g - 3], hash: f[g - 2], blockParams: f[g - 1], strip: c.stripFlags(f[g - 5], f[g]) };
              break;
            case 18:
              this.$ = { strip: c.stripFlags(f[g - 1], f[g - 1]), program: f[g] };
              break;
            case 19:
              var v = c.prepareBlock(f[g - 2], f[g - 1], f[g], f[g], !1, this._$), y = c.prepareProgram([v], f[g - 1].loc);
              y.chained = !0, this.$ = { strip: f[g - 2].strip, program: y, chain: !0 };
              break;
            case 20:
              this.$ = f[g];
              break;
            case 21:
              this.$ = { path: f[g - 1], strip: c.stripFlags(f[g - 2], f[g]) };
              break;
            case 22:
              this.$ = c.prepareMustache(f[g - 3], f[g - 2], f[g - 1], f[g - 4], c.stripFlags(f[g - 4], f[g]), this._$);
              break;
            case 23:
              this.$ = c.prepareMustache(f[g - 3], f[g - 2], f[g - 1], f[g - 4], c.stripFlags(f[g - 4], f[g]), this._$);
              break;
            case 24:
              this.$ = {
                type: "PartialStatement",
                name: f[g - 3],
                params: f[g - 2],
                hash: f[g - 1],
                indent: "",
                strip: c.stripFlags(f[g - 4], f[g]),
                loc: c.locInfo(this._$)
              };
              break;
            case 25:
              this.$ = c.preparePartialBlock(f[g - 2], f[g - 1], f[g], this._$);
              break;
            case 26:
              this.$ = { path: f[g - 3], params: f[g - 2], hash: f[g - 1], strip: c.stripFlags(f[g - 4], f[g]) };
              break;
            case 27:
              this.$ = f[g];
              break;
            case 28:
              this.$ = f[g];
              break;
            case 29:
              this.$ = {
                type: "SubExpression",
                path: f[g - 3],
                params: f[g - 2],
                hash: f[g - 1],
                loc: c.locInfo(this._$)
              };
              break;
            case 30:
              this.$ = { type: "Hash", pairs: f[g], loc: c.locInfo(this._$) };
              break;
            case 31:
              this.$ = { type: "HashPair", key: c.id(f[g - 2]), value: f[g], loc: c.locInfo(this._$) };
              break;
            case 32:
              this.$ = c.id(f[g - 1]);
              break;
            case 33:
              this.$ = f[g];
              break;
            case 34:
              this.$ = f[g];
              break;
            case 35:
              this.$ = { type: "StringLiteral", value: f[g], original: f[g], loc: c.locInfo(this._$) };
              break;
            case 36:
              this.$ = { type: "NumberLiteral", value: Number(f[g]), original: Number(f[g]), loc: c.locInfo(this._$) };
              break;
            case 37:
              this.$ = { type: "BooleanLiteral", value: f[g] === "true", original: f[g] === "true", loc: c.locInfo(this._$) };
              break;
            case 38:
              this.$ = { type: "UndefinedLiteral", original: void 0, value: void 0, loc: c.locInfo(this._$) };
              break;
            case 39:
              this.$ = { type: "NullLiteral", original: null, value: null, loc: c.locInfo(this._$) };
              break;
            case 40:
              this.$ = f[g];
              break;
            case 41:
              this.$ = f[g];
              break;
            case 42:
              this.$ = c.preparePath(!0, f[g], this._$);
              break;
            case 43:
              this.$ = c.preparePath(!1, f[g], this._$);
              break;
            case 44:
              f[g - 2].push({ part: c.id(f[g]), original: f[g], separator: f[g - 1] }), this.$ = f[g - 2];
              break;
            case 45:
              this.$ = [{ part: c.id(f[g]), original: f[g] }];
              break;
            case 46:
              this.$ = [];
              break;
            case 47:
              f[g - 1].push(f[g]);
              break;
            case 48:
              this.$ = [];
              break;
            case 49:
              f[g - 1].push(f[g]);
              break;
            case 50:
              this.$ = [];
              break;
            case 51:
              f[g - 1].push(f[g]);
              break;
            case 58:
              this.$ = [];
              break;
            case 59:
              f[g - 1].push(f[g]);
              break;
            case 64:
              this.$ = [];
              break;
            case 65:
              f[g - 1].push(f[g]);
              break;
            case 70:
              this.$ = [];
              break;
            case 71:
              f[g - 1].push(f[g]);
              break;
            case 78:
              this.$ = [];
              break;
            case 79:
              f[g - 1].push(f[g]);
              break;
            case 82:
              this.$ = [];
              break;
            case 83:
              f[g - 1].push(f[g]);
              break;
            case 86:
              this.$ = [];
              break;
            case 87:
              f[g - 1].push(f[g]);
              break;
            case 90:
              this.$ = [];
              break;
            case 91:
              f[g - 1].push(f[g]);
              break;
            case 94:
              this.$ = [];
              break;
            case 95:
              f[g - 1].push(f[g]);
              break;
            case 98:
              this.$ = [f[g]];
              break;
            case 99:
              f[g - 1].push(f[g]);
              break;
            case 100:
              this.$ = [f[g]];
              break;
            case 101:
              f[g - 1].push(f[g]);
              break;
          }
        },
        table: [{ 3: 1, 4: 2, 5: [2, 46], 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 1: [3] }, { 5: [1, 4] }, { 5: [2, 2], 7: 5, 8: 6, 9: 7, 10: 8, 11: 9, 12: 10, 13: 11, 14: [1, 12], 15: [1, 20], 16: 17, 19: [1, 23], 24: 15, 27: 16, 29: [1, 21], 34: [1, 22], 39: [2, 2], 44: [2, 2], 47: [2, 2], 48: [1, 13], 51: [1, 14], 55: [1, 18], 59: 19, 60: [1, 24] }, { 1: [2, 1] }, { 5: [2, 47], 14: [2, 47], 15: [2, 47], 19: [2, 47], 29: [2, 47], 34: [2, 47], 39: [2, 47], 44: [2, 47], 47: [2, 47], 48: [2, 47], 51: [2, 47], 55: [2, 47], 60: [2, 47] }, { 5: [2, 3], 14: [2, 3], 15: [2, 3], 19: [2, 3], 29: [2, 3], 34: [2, 3], 39: [2, 3], 44: [2, 3], 47: [2, 3], 48: [2, 3], 51: [2, 3], 55: [2, 3], 60: [2, 3] }, { 5: [2, 4], 14: [2, 4], 15: [2, 4], 19: [2, 4], 29: [2, 4], 34: [2, 4], 39: [2, 4], 44: [2, 4], 47: [2, 4], 48: [2, 4], 51: [2, 4], 55: [2, 4], 60: [2, 4] }, { 5: [2, 5], 14: [2, 5], 15: [2, 5], 19: [2, 5], 29: [2, 5], 34: [2, 5], 39: [2, 5], 44: [2, 5], 47: [2, 5], 48: [2, 5], 51: [2, 5], 55: [2, 5], 60: [2, 5] }, { 5: [2, 6], 14: [2, 6], 15: [2, 6], 19: [2, 6], 29: [2, 6], 34: [2, 6], 39: [2, 6], 44: [2, 6], 47: [2, 6], 48: [2, 6], 51: [2, 6], 55: [2, 6], 60: [2, 6] }, { 5: [2, 7], 14: [2, 7], 15: [2, 7], 19: [2, 7], 29: [2, 7], 34: [2, 7], 39: [2, 7], 44: [2, 7], 47: [2, 7], 48: [2, 7], 51: [2, 7], 55: [2, 7], 60: [2, 7] }, { 5: [2, 8], 14: [2, 8], 15: [2, 8], 19: [2, 8], 29: [2, 8], 34: [2, 8], 39: [2, 8], 44: [2, 8], 47: [2, 8], 48: [2, 8], 51: [2, 8], 55: [2, 8], 60: [2, 8] }, { 5: [2, 9], 14: [2, 9], 15: [2, 9], 19: [2, 9], 29: [2, 9], 34: [2, 9], 39: [2, 9], 44: [2, 9], 47: [2, 9], 48: [2, 9], 51: [2, 9], 55: [2, 9], 60: [2, 9] }, { 20: 25, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 36, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 4: 37, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 39: [2, 46], 44: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 4: 38, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 44: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 15: [2, 48], 17: 39, 18: [2, 48] }, { 20: 41, 56: 40, 64: 42, 65: [1, 43], 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 4: 44, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 5: [2, 10], 14: [2, 10], 15: [2, 10], 18: [2, 10], 19: [2, 10], 29: [2, 10], 34: [2, 10], 39: [2, 10], 44: [2, 10], 47: [2, 10], 48: [2, 10], 51: [2, 10], 55: [2, 10], 60: [2, 10] }, { 20: 45, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 46, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 47, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 41, 56: 48, 64: 42, 65: [1, 43], 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 33: [2, 78], 49: 49, 65: [2, 78], 72: [2, 78], 80: [2, 78], 81: [2, 78], 82: [2, 78], 83: [2, 78], 84: [2, 78], 85: [2, 78] }, { 23: [2, 33], 33: [2, 33], 54: [2, 33], 65: [2, 33], 68: [2, 33], 72: [2, 33], 75: [2, 33], 80: [2, 33], 81: [2, 33], 82: [2, 33], 83: [2, 33], 84: [2, 33], 85: [2, 33] }, { 23: [2, 34], 33: [2, 34], 54: [2, 34], 65: [2, 34], 68: [2, 34], 72: [2, 34], 75: [2, 34], 80: [2, 34], 81: [2, 34], 82: [2, 34], 83: [2, 34], 84: [2, 34], 85: [2, 34] }, { 23: [2, 35], 33: [2, 35], 54: [2, 35], 65: [2, 35], 68: [2, 35], 72: [2, 35], 75: [2, 35], 80: [2, 35], 81: [2, 35], 82: [2, 35], 83: [2, 35], 84: [2, 35], 85: [2, 35] }, { 23: [2, 36], 33: [2, 36], 54: [2, 36], 65: [2, 36], 68: [2, 36], 72: [2, 36], 75: [2, 36], 80: [2, 36], 81: [2, 36], 82: [2, 36], 83: [2, 36], 84: [2, 36], 85: [2, 36] }, { 23: [2, 37], 33: [2, 37], 54: [2, 37], 65: [2, 37], 68: [2, 37], 72: [2, 37], 75: [2, 37], 80: [2, 37], 81: [2, 37], 82: [2, 37], 83: [2, 37], 84: [2, 37], 85: [2, 37] }, { 23: [2, 38], 33: [2, 38], 54: [2, 38], 65: [2, 38], 68: [2, 38], 72: [2, 38], 75: [2, 38], 80: [2, 38], 81: [2, 38], 82: [2, 38], 83: [2, 38], 84: [2, 38], 85: [2, 38] }, { 23: [2, 39], 33: [2, 39], 54: [2, 39], 65: [2, 39], 68: [2, 39], 72: [2, 39], 75: [2, 39], 80: [2, 39], 81: [2, 39], 82: [2, 39], 83: [2, 39], 84: [2, 39], 85: [2, 39] }, { 23: [2, 43], 33: [2, 43], 54: [2, 43], 65: [2, 43], 68: [2, 43], 72: [2, 43], 75: [2, 43], 80: [2, 43], 81: [2, 43], 82: [2, 43], 83: [2, 43], 84: [2, 43], 85: [2, 43], 87: [1, 50] }, { 72: [1, 35], 86: 51 }, { 23: [2, 45], 33: [2, 45], 54: [2, 45], 65: [2, 45], 68: [2, 45], 72: [2, 45], 75: [2, 45], 80: [2, 45], 81: [2, 45], 82: [2, 45], 83: [2, 45], 84: [2, 45], 85: [2, 45], 87: [2, 45] }, { 52: 52, 54: [2, 82], 65: [2, 82], 72: [2, 82], 80: [2, 82], 81: [2, 82], 82: [2, 82], 83: [2, 82], 84: [2, 82], 85: [2, 82] }, { 25: 53, 38: 55, 39: [1, 57], 43: 56, 44: [1, 58], 45: 54, 47: [2, 54] }, { 28: 59, 43: 60, 44: [1, 58], 47: [2, 56] }, { 13: 62, 15: [1, 20], 18: [1, 61] }, { 33: [2, 86], 57: 63, 65: [2, 86], 72: [2, 86], 80: [2, 86], 81: [2, 86], 82: [2, 86], 83: [2, 86], 84: [2, 86], 85: [2, 86] }, { 33: [2, 40], 65: [2, 40], 72: [2, 40], 80: [2, 40], 81: [2, 40], 82: [2, 40], 83: [2, 40], 84: [2, 40], 85: [2, 40] }, { 33: [2, 41], 65: [2, 41], 72: [2, 41], 80: [2, 41], 81: [2, 41], 82: [2, 41], 83: [2, 41], 84: [2, 41], 85: [2, 41] }, { 20: 64, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 26: 65, 47: [1, 66] }, { 30: 67, 33: [2, 58], 65: [2, 58], 72: [2, 58], 75: [2, 58], 80: [2, 58], 81: [2, 58], 82: [2, 58], 83: [2, 58], 84: [2, 58], 85: [2, 58] }, { 33: [2, 64], 35: 68, 65: [2, 64], 72: [2, 64], 75: [2, 64], 80: [2, 64], 81: [2, 64], 82: [2, 64], 83: [2, 64], 84: [2, 64], 85: [2, 64] }, { 21: 69, 23: [2, 50], 65: [2, 50], 72: [2, 50], 80: [2, 50], 81: [2, 50], 82: [2, 50], 83: [2, 50], 84: [2, 50], 85: [2, 50] }, { 33: [2, 90], 61: 70, 65: [2, 90], 72: [2, 90], 80: [2, 90], 81: [2, 90], 82: [2, 90], 83: [2, 90], 84: [2, 90], 85: [2, 90] }, { 20: 74, 33: [2, 80], 50: 71, 63: 72, 64: 75, 65: [1, 43], 69: 73, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 72: [1, 79] }, { 23: [2, 42], 33: [2, 42], 54: [2, 42], 65: [2, 42], 68: [2, 42], 72: [2, 42], 75: [2, 42], 80: [2, 42], 81: [2, 42], 82: [2, 42], 83: [2, 42], 84: [2, 42], 85: [2, 42], 87: [1, 50] }, { 20: 74, 53: 80, 54: [2, 84], 63: 81, 64: 75, 65: [1, 43], 69: 82, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 26: 83, 47: [1, 66] }, { 47: [2, 55] }, { 4: 84, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 39: [2, 46], 44: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 47: [2, 20] }, { 20: 85, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 4: 86, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 26: 87, 47: [1, 66] }, { 47: [2, 57] }, { 5: [2, 11], 14: [2, 11], 15: [2, 11], 19: [2, 11], 29: [2, 11], 34: [2, 11], 39: [2, 11], 44: [2, 11], 47: [2, 11], 48: [2, 11], 51: [2, 11], 55: [2, 11], 60: [2, 11] }, { 15: [2, 49], 18: [2, 49] }, { 20: 74, 33: [2, 88], 58: 88, 63: 89, 64: 75, 65: [1, 43], 69: 90, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 65: [2, 94], 66: 91, 68: [2, 94], 72: [2, 94], 80: [2, 94], 81: [2, 94], 82: [2, 94], 83: [2, 94], 84: [2, 94], 85: [2, 94] }, { 5: [2, 25], 14: [2, 25], 15: [2, 25], 19: [2, 25], 29: [2, 25], 34: [2, 25], 39: [2, 25], 44: [2, 25], 47: [2, 25], 48: [2, 25], 51: [2, 25], 55: [2, 25], 60: [2, 25] }, { 20: 92, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 74, 31: 93, 33: [2, 60], 63: 94, 64: 75, 65: [1, 43], 69: 95, 70: 76, 71: 77, 72: [1, 78], 75: [2, 60], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 74, 33: [2, 66], 36: 96, 63: 97, 64: 75, 65: [1, 43], 69: 98, 70: 76, 71: 77, 72: [1, 78], 75: [2, 66], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 74, 22: 99, 23: [2, 52], 63: 100, 64: 75, 65: [1, 43], 69: 101, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 74, 33: [2, 92], 62: 102, 63: 103, 64: 75, 65: [1, 43], 69: 104, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 33: [1, 105] }, { 33: [2, 79], 65: [2, 79], 72: [2, 79], 80: [2, 79], 81: [2, 79], 82: [2, 79], 83: [2, 79], 84: [2, 79], 85: [2, 79] }, { 33: [2, 81] }, { 23: [2, 27], 33: [2, 27], 54: [2, 27], 65: [2, 27], 68: [2, 27], 72: [2, 27], 75: [2, 27], 80: [2, 27], 81: [2, 27], 82: [2, 27], 83: [2, 27], 84: [2, 27], 85: [2, 27] }, { 23: [2, 28], 33: [2, 28], 54: [2, 28], 65: [2, 28], 68: [2, 28], 72: [2, 28], 75: [2, 28], 80: [2, 28], 81: [2, 28], 82: [2, 28], 83: [2, 28], 84: [2, 28], 85: [2, 28] }, { 23: [2, 30], 33: [2, 30], 54: [2, 30], 68: [2, 30], 71: 106, 72: [1, 107], 75: [2, 30] }, { 23: [2, 98], 33: [2, 98], 54: [2, 98], 68: [2, 98], 72: [2, 98], 75: [2, 98] }, { 23: [2, 45], 33: [2, 45], 54: [2, 45], 65: [2, 45], 68: [2, 45], 72: [2, 45], 73: [1, 108], 75: [2, 45], 80: [2, 45], 81: [2, 45], 82: [2, 45], 83: [2, 45], 84: [2, 45], 85: [2, 45], 87: [2, 45] }, { 23: [2, 44], 33: [2, 44], 54: [2, 44], 65: [2, 44], 68: [2, 44], 72: [2, 44], 75: [2, 44], 80: [2, 44], 81: [2, 44], 82: [2, 44], 83: [2, 44], 84: [2, 44], 85: [2, 44], 87: [2, 44] }, { 54: [1, 109] }, { 54: [2, 83], 65: [2, 83], 72: [2, 83], 80: [2, 83], 81: [2, 83], 82: [2, 83], 83: [2, 83], 84: [2, 83], 85: [2, 83] }, { 54: [2, 85] }, { 5: [2, 13], 14: [2, 13], 15: [2, 13], 19: [2, 13], 29: [2, 13], 34: [2, 13], 39: [2, 13], 44: [2, 13], 47: [2, 13], 48: [2, 13], 51: [2, 13], 55: [2, 13], 60: [2, 13] }, { 38: 55, 39: [1, 57], 43: 56, 44: [1, 58], 45: 111, 46: 110, 47: [2, 76] }, { 33: [2, 70], 40: 112, 65: [2, 70], 72: [2, 70], 75: [2, 70], 80: [2, 70], 81: [2, 70], 82: [2, 70], 83: [2, 70], 84: [2, 70], 85: [2, 70] }, { 47: [2, 18] }, { 5: [2, 14], 14: [2, 14], 15: [2, 14], 19: [2, 14], 29: [2, 14], 34: [2, 14], 39: [2, 14], 44: [2, 14], 47: [2, 14], 48: [2, 14], 51: [2, 14], 55: [2, 14], 60: [2, 14] }, { 33: [1, 113] }, { 33: [2, 87], 65: [2, 87], 72: [2, 87], 80: [2, 87], 81: [2, 87], 82: [2, 87], 83: [2, 87], 84: [2, 87], 85: [2, 87] }, { 33: [2, 89] }, { 20: 74, 63: 115, 64: 75, 65: [1, 43], 67: 114, 68: [2, 96], 69: 116, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 33: [1, 117] }, { 32: 118, 33: [2, 62], 74: 119, 75: [1, 120] }, { 33: [2, 59], 65: [2, 59], 72: [2, 59], 75: [2, 59], 80: [2, 59], 81: [2, 59], 82: [2, 59], 83: [2, 59], 84: [2, 59], 85: [2, 59] }, { 33: [2, 61], 75: [2, 61] }, { 33: [2, 68], 37: 121, 74: 122, 75: [1, 120] }, { 33: [2, 65], 65: [2, 65], 72: [2, 65], 75: [2, 65], 80: [2, 65], 81: [2, 65], 82: [2, 65], 83: [2, 65], 84: [2, 65], 85: [2, 65] }, { 33: [2, 67], 75: [2, 67] }, { 23: [1, 123] }, { 23: [2, 51], 65: [2, 51], 72: [2, 51], 80: [2, 51], 81: [2, 51], 82: [2, 51], 83: [2, 51], 84: [2, 51], 85: [2, 51] }, { 23: [2, 53] }, { 33: [1, 124] }, { 33: [2, 91], 65: [2, 91], 72: [2, 91], 80: [2, 91], 81: [2, 91], 82: [2, 91], 83: [2, 91], 84: [2, 91], 85: [2, 91] }, { 33: [2, 93] }, { 5: [2, 22], 14: [2, 22], 15: [2, 22], 19: [2, 22], 29: [2, 22], 34: [2, 22], 39: [2, 22], 44: [2, 22], 47: [2, 22], 48: [2, 22], 51: [2, 22], 55: [2, 22], 60: [2, 22] }, { 23: [2, 99], 33: [2, 99], 54: [2, 99], 68: [2, 99], 72: [2, 99], 75: [2, 99] }, { 73: [1, 108] }, { 20: 74, 63: 125, 64: 75, 65: [1, 43], 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 5: [2, 23], 14: [2, 23], 15: [2, 23], 19: [2, 23], 29: [2, 23], 34: [2, 23], 39: [2, 23], 44: [2, 23], 47: [2, 23], 48: [2, 23], 51: [2, 23], 55: [2, 23], 60: [2, 23] }, { 47: [2, 19] }, { 47: [2, 77] }, { 20: 74, 33: [2, 72], 41: 126, 63: 127, 64: 75, 65: [1, 43], 69: 128, 70: 76, 71: 77, 72: [1, 78], 75: [2, 72], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 5: [2, 24], 14: [2, 24], 15: [2, 24], 19: [2, 24], 29: [2, 24], 34: [2, 24], 39: [2, 24], 44: [2, 24], 47: [2, 24], 48: [2, 24], 51: [2, 24], 55: [2, 24], 60: [2, 24] }, { 68: [1, 129] }, { 65: [2, 95], 68: [2, 95], 72: [2, 95], 80: [2, 95], 81: [2, 95], 82: [2, 95], 83: [2, 95], 84: [2, 95], 85: [2, 95] }, { 68: [2, 97] }, { 5: [2, 21], 14: [2, 21], 15: [2, 21], 19: [2, 21], 29: [2, 21], 34: [2, 21], 39: [2, 21], 44: [2, 21], 47: [2, 21], 48: [2, 21], 51: [2, 21], 55: [2, 21], 60: [2, 21] }, { 33: [1, 130] }, { 33: [2, 63] }, { 72: [1, 132], 76: 131 }, { 33: [1, 133] }, { 33: [2, 69] }, { 15: [2, 12], 18: [2, 12] }, { 14: [2, 26], 15: [2, 26], 19: [2, 26], 29: [2, 26], 34: [2, 26], 47: [2, 26], 48: [2, 26], 51: [2, 26], 55: [2, 26], 60: [2, 26] }, { 23: [2, 31], 33: [2, 31], 54: [2, 31], 68: [2, 31], 72: [2, 31], 75: [2, 31] }, { 33: [2, 74], 42: 134, 74: 135, 75: [1, 120] }, { 33: [2, 71], 65: [2, 71], 72: [2, 71], 75: [2, 71], 80: [2, 71], 81: [2, 71], 82: [2, 71], 83: [2, 71], 84: [2, 71], 85: [2, 71] }, { 33: [2, 73], 75: [2, 73] }, { 23: [2, 29], 33: [2, 29], 54: [2, 29], 65: [2, 29], 68: [2, 29], 72: [2, 29], 75: [2, 29], 80: [2, 29], 81: [2, 29], 82: [2, 29], 83: [2, 29], 84: [2, 29], 85: [2, 29] }, { 14: [2, 15], 15: [2, 15], 19: [2, 15], 29: [2, 15], 34: [2, 15], 39: [2, 15], 44: [2, 15], 47: [2, 15], 48: [2, 15], 51: [2, 15], 55: [2, 15], 60: [2, 15] }, { 72: [1, 137], 77: [1, 136] }, { 72: [2, 100], 77: [2, 100] }, { 14: [2, 16], 15: [2, 16], 19: [2, 16], 29: [2, 16], 34: [2, 16], 44: [2, 16], 47: [2, 16], 48: [2, 16], 51: [2, 16], 55: [2, 16], 60: [2, 16] }, { 33: [1, 138] }, { 33: [2, 75] }, { 33: [2, 32] }, { 72: [2, 101], 77: [2, 101] }, { 14: [2, 17], 15: [2, 17], 19: [2, 17], 29: [2, 17], 34: [2, 17], 39: [2, 17], 44: [2, 17], 47: [2, 17], 48: [2, 17], 51: [2, 17], 55: [2, 17], 60: [2, 17] }],
        defaultActions: { 4: [2, 1], 54: [2, 55], 56: [2, 20], 60: [2, 57], 73: [2, 81], 82: [2, 85], 86: [2, 18], 90: [2, 89], 101: [2, 53], 104: [2, 93], 110: [2, 19], 111: [2, 77], 116: [2, 97], 119: [2, 63], 122: [2, 69], 135: [2, 75], 136: [2, 32] },
        parseError: function(o, l) {
          throw new Error(o);
        },
        parse: function(o) {
          var l = this, u = [0], c = [null], d = [], f = this.table, h = "", g = 0, v = 0;
          this.lexer.setInput(o), this.lexer.yy = this.yy, this.yy.lexer = this.lexer, this.yy.parser = this, typeof this.lexer.yylloc > "u" && (this.lexer.yylloc = {});
          var y = this.lexer.yylloc;
          d.push(y);
          var A = this.lexer.options && this.lexer.options.ranges;
          typeof this.yy.parseError == "function" && (this.parseError = this.yy.parseError);
          function x() {
            var J;
            return J = l.lexer.lex() || 1, typeof J != "number" && (J = l.symbols_[J] || J), J;
          }
          for (var k, F, S, R, M = {}, j, G, ie, q; ; ) {
            if (F = u[u.length - 1], this.defaultActions[F] ? S = this.defaultActions[F] : ((k === null || typeof k > "u") && (k = x()), S = f[F] && f[F][k]), typeof S > "u" || !S.length || !S[0]) {
              var Y = "";
              {
                q = [];
                for (j in f[F]) this.terminals_[j] && j > 2 && q.push("'" + this.terminals_[j] + "'");
                this.lexer.showPosition ? Y = "Parse error on line " + (g + 1) + `:
` + this.lexer.showPosition() + `
Expecting ` + q.join(", ") + ", got '" + (this.terminals_[k] || k) + "'" : Y = "Parse error on line " + (g + 1) + ": Unexpected " + (k == 1 ? "end of input" : "'" + (this.terminals_[k] || k) + "'"), this.parseError(Y, { text: this.lexer.match, token: this.terminals_[k] || k, line: this.lexer.yylineno, loc: y, expected: q });
              }
            }
            if (S[0] instanceof Array && S.length > 1)
              throw new Error("Parse Error: multiple actions possible at state: " + F + ", token: " + k);
            switch (S[0]) {
              case 1:
                u.push(k), c.push(this.lexer.yytext), d.push(this.lexer.yylloc), u.push(S[1]), k = null, v = this.lexer.yyleng, h = this.lexer.yytext, g = this.lexer.yylineno, y = this.lexer.yylloc;
                break;
              case 2:
                if (G = this.productions_[S[1]][1], M.$ = c[c.length - G], M._$ = { first_line: d[d.length - (G || 1)].first_line, last_line: d[d.length - 1].last_line, first_column: d[d.length - (G || 1)].first_column, last_column: d[d.length - 1].last_column }, A && (M._$.range = [d[d.length - (G || 1)].range[0], d[d.length - 1].range[1]]), R = this.performAction.call(M, h, v, g, this.yy, S[1], c, d), typeof R < "u")
                  return R;
                G && (u = u.slice(0, -1 * G * 2), c = c.slice(0, -1 * G), d = d.slice(0, -1 * G)), u.push(this.productions_[S[1]][0]), c.push(M.$), d.push(M._$), ie = f[u[u.length - 2]][u[u.length - 1]], u.push(ie);
                break;
              case 3:
                return !0;
            }
          }
          return !0;
        }
      }, i = (function() {
        var s = {
          EOF: 1,
          parseError: function(l, u) {
            if (this.yy.parser)
              this.yy.parser.parseError(l, u);
            else
              throw new Error(l);
          },
          setInput: function(l) {
            return this._input = l, this._more = this._less = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = { first_line: 1, first_column: 0, last_line: 1, last_column: 0 }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
          },
          input: function() {
            var l = this._input[0];
            this.yytext += l, this.yyleng++, this.offset++, this.match += l, this.matched += l;
            var u = l.match(/(?:\r\n?|\n).*/g);
            return u ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), l;
          },
          unput: function(l) {
            var u = l.length, c = l.split(/(?:\r\n?|\n)/g);
            this._input = l + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - u - 1), this.offset -= u;
            var d = this.match.split(/(?:\r\n?|\n)/g);
            this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), c.length - 1 && (this.yylineno -= c.length - 1);
            var f = this.yylloc.range;
            return this.yylloc = {
              first_line: this.yylloc.first_line,
              last_line: this.yylineno + 1,
              first_column: this.yylloc.first_column,
              last_column: c ? (c.length === d.length ? this.yylloc.first_column : 0) + d[d.length - c.length].length - c[0].length : this.yylloc.first_column - u
            }, this.options.ranges && (this.yylloc.range = [f[0], f[0] + this.yyleng - u]), this;
          },
          more: function() {
            return this._more = !0, this;
          },
          less: function(l) {
            this.unput(this.match.slice(l));
          },
          pastInput: function() {
            var l = this.matched.substr(0, this.matched.length - this.match.length);
            return (l.length > 20 ? "..." : "") + l.substr(-20).replace(/\n/g, "");
          },
          upcomingInput: function() {
            var l = this.match;
            return l.length < 20 && (l += this._input.substr(0, 20 - l.length)), (l.substr(0, 20) + (l.length > 20 ? "..." : "")).replace(/\n/g, "");
          },
          showPosition: function() {
            var l = this.pastInput(), u = new Array(l.length + 1).join("-");
            return l + this.upcomingInput() + `
` + u + "^";
          },
          next: function() {
            if (this.done)
              return this.EOF;
            this._input || (this.done = !0);
            var l, u, c, d, f;
            this._more || (this.yytext = "", this.match = "");
            for (var h = this._currentRules(), g = 0; g < h.length && (c = this._input.match(this.rules[h[g]]), !(c && (!u || c[0].length > u[0].length) && (u = c, d = g, !this.options.flex))); g++)
              ;
            return u ? (f = u[0].match(/(?:\r\n?|\n).*/g), f && (this.yylineno += f.length), this.yylloc = {
              first_line: this.yylloc.last_line,
              last_line: this.yylineno + 1,
              first_column: this.yylloc.last_column,
              last_column: f ? f[f.length - 1].length - f[f.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + u[0].length
            }, this.yytext += u[0], this.match += u[0], this.matches = u, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._input = this._input.slice(u[0].length), this.matched += u[0], l = this.performAction.call(this, this.yy, this, h[d], this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), l || void 0) : this._input === "" ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + `. Unrecognized text.
` + this.showPosition(), { text: "", token: null, line: this.yylineno });
          },
          lex: function() {
            var l = this.next();
            return typeof l < "u" ? l : this.lex();
          },
          begin: function(l) {
            this.conditionStack.push(l);
          },
          popState: function() {
            return this.conditionStack.pop();
          },
          _currentRules: function() {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
          },
          topState: function() {
            return this.conditionStack[this.conditionStack.length - 2];
          },
          pushState: function(l) {
            this.begin(l);
          }
        };
        return s.options = {}, s.performAction = function(l, u, c, d) {
          function f(h, g) {
            return u.yytext = u.yytext.substring(h, u.yyleng - g + h);
          }
          switch (c) {
            case 0:
              if (u.yytext.slice(-2) === "\\\\" ? (f(0, 1), this.begin("mu")) : u.yytext.slice(-1) === "\\" ? (f(0, 1), this.begin("emu")) : this.begin("mu"), u.yytext) return 15;
              break;
            case 1:
              return 15;
            case 2:
              return this.popState(), 15;
            case 3:
              return this.begin("raw"), 15;
            case 4:
              return this.popState(), this.conditionStack[this.conditionStack.length - 1] === "raw" ? 15 : (f(5, 9), "END_RAW_BLOCK");
            case 5:
              return 15;
            case 6:
              return this.popState(), 14;
            case 7:
              return 65;
            case 8:
              return 68;
            case 9:
              return 19;
            case 10:
              return this.popState(), this.begin("raw"), 23;
            case 11:
              return 55;
            case 12:
              return 60;
            case 13:
              return 29;
            case 14:
              return 47;
            case 15:
              return this.popState(), 44;
            case 16:
              return this.popState(), 44;
            case 17:
              return 34;
            case 18:
              return 39;
            case 19:
              return 51;
            case 20:
              return 48;
            case 21:
              this.unput(u.yytext), this.popState(), this.begin("com");
              break;
            case 22:
              return this.popState(), 14;
            case 23:
              return 48;
            case 24:
              return 73;
            case 25:
              return 72;
            case 26:
              return 72;
            case 27:
              return 87;
            case 28:
              break;
            case 29:
              return this.popState(), 54;
            case 30:
              return this.popState(), 33;
            case 31:
              return u.yytext = f(1, 2).replace(/\\"/g, '"'), 80;
            case 32:
              return u.yytext = f(1, 2).replace(/\\'/g, "'"), 80;
            case 33:
              return 85;
            case 34:
              return 82;
            case 35:
              return 82;
            case 36:
              return 83;
            case 37:
              return 84;
            case 38:
              return 81;
            case 39:
              return 75;
            case 40:
              return 77;
            case 41:
              return 72;
            case 42:
              return u.yytext = u.yytext.replace(/\\([\\\]])/g, "$1"), 72;
            case 43:
              return "INVALID";
            case 44:
              return 5;
          }
        }, s.rules = [/^(?:[^\x00]*?(?=(\{\{)))/, /^(?:[^\x00]+)/, /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/, /^(?:\{\{\{\{(?=[^\/]))/, /^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/, /^(?:[^\x00]+?(?=(\{\{\{\{)))/, /^(?:[\s\S]*?--(~)?\}\})/, /^(?:\()/, /^(?:\))/, /^(?:\{\{\{\{)/, /^(?:\}\}\}\})/, /^(?:\{\{(~)?>)/, /^(?:\{\{(~)?#>)/, /^(?:\{\{(~)?#\*?)/, /^(?:\{\{(~)?\/)/, /^(?:\{\{(~)?\^\s*(~)?\}\})/, /^(?:\{\{(~)?\s*else\s*(~)?\}\})/, /^(?:\{\{(~)?\^)/, /^(?:\{\{(~)?\s*else\b)/, /^(?:\{\{(~)?\{)/, /^(?:\{\{(~)?&)/, /^(?:\{\{(~)?!--)/, /^(?:\{\{(~)?![\s\S]*?\}\})/, /^(?:\{\{(~)?\*?)/, /^(?:=)/, /^(?:\.\.)/, /^(?:\.(?=([=~}\s\/.)|])))/, /^(?:[\/.])/, /^(?:\s+)/, /^(?:\}(~)?\}\})/, /^(?:(~)?\}\})/, /^(?:"(\\["]|[^"])*")/, /^(?:'(\\[']|[^'])*')/, /^(?:@)/, /^(?:true(?=([~}\s)])))/, /^(?:false(?=([~}\s)])))/, /^(?:undefined(?=([~}\s)])))/, /^(?:null(?=([~}\s)])))/, /^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/, /^(?:as\s+\|)/, /^(?:\|)/, /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/, /^(?:\[(\\\]|[^\]])*\])/, /^(?:.)/, /^(?:$)/], s.conditions = { mu: { rules: [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44], inclusive: !1 }, emu: { rules: [2], inclusive: !1 }, com: { rules: [6], inclusive: !1 }, raw: { rules: [3, 4, 5], inclusive: !1 }, INITIAL: { rules: [0, 1, 44], inclusive: !0 } }, s;
      })();
      n.lexer = i;
      function a() {
        this.yy = {};
      }
      return a.prototype = n, n.Parser = a, new a();
    })();
    e.default = t, r.exports = e.default;
  })(ip, ip.exports)), ip.exports;
}
var ap = { exports: {} }, sp = { exports: {} }, GC;
function dF() {
  return GC || (GC = 1, (function(r, e) {
    e.__esModule = !0;
    function t(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var n = ma(), i = t(n);
    function a() {
      this.parents = [];
    }
    a.prototype = {
      constructor: a,
      mutating: !1,
      // Visits a given value. If mutating, will replace the value if necessary.
      acceptKey: function(c, d) {
        var f = this.accept(c[d]);
        if (this.mutating) {
          if (f && !a.prototype[f.type])
            throw new i.default('Unexpected node type "' + f.type + '" found when accepting ' + d + " on " + c.type);
          c[d] = f;
        }
      },
      // Performs an accept operation with added sanity check to ensure
      // required keys are not removed.
      acceptRequired: function(c, d) {
        if (this.acceptKey(c, d), !c[d])
          throw new i.default(c.type + " requires " + d);
      },
      // Traverses a given array. If mutating, empty respnses will be removed
      // for child elements.
      acceptArray: function(c) {
        for (var d = 0, f = c.length; d < f; d++)
          this.acceptKey(c, d), c[d] || (c.splice(d, 1), d--, f--);
      },
      accept: function(c) {
        if (c) {
          if (!this[c.type])
            throw new i.default("Unknown type: " + c.type, c);
          this.current && this.parents.unshift(this.current), this.current = c;
          var d = this[c.type](c);
          if (this.current = this.parents.shift(), !this.mutating || d)
            return d;
          if (d !== !1)
            return c;
        }
      },
      Program: function(c) {
        this.acceptArray(c.body);
      },
      MustacheStatement: s,
      Decorator: s,
      BlockStatement: o,
      DecoratorBlock: o,
      PartialStatement: l,
      PartialBlockStatement: function(c) {
        l.call(this, c), this.acceptKey(c, "program");
      },
      ContentStatement: function() {
      },
      CommentStatement: function() {
      },
      SubExpression: s,
      PathExpression: function() {
      },
      StringLiteral: function() {
      },
      NumberLiteral: function() {
      },
      BooleanLiteral: function() {
      },
      UndefinedLiteral: function() {
      },
      NullLiteral: function() {
      },
      Hash: function(c) {
        this.acceptArray(c.pairs);
      },
      HashPair: function(c) {
        this.acceptRequired(c, "value");
      }
    };
    function s(u) {
      this.acceptRequired(u, "path"), this.acceptArray(u.params), this.acceptKey(u, "hash");
    }
    function o(u) {
      s.call(this, u), this.acceptKey(u, "program"), this.acceptKey(u, "inverse");
    }
    function l(u) {
      this.acceptRequired(u, "name"), this.acceptArray(u.params), this.acceptKey(u, "hash");
    }
    e.default = a, r.exports = e.default;
  })(sp, sp.exports)), sp.exports;
}
var qC;
function w8() {
  return qC || (qC = 1, (function(r, e) {
    e.__esModule = !0;
    function t(c) {
      return c && c.__esModule ? c : { default: c };
    }
    var n = dF(), i = t(n);
    function a() {
      var c = arguments.length <= 0 || arguments[0] === void 0 ? {} : arguments[0];
      this.options = c;
    }
    a.prototype = new i.default(), a.prototype.Program = function(c) {
      var d = !this.options.ignoreStandalone, f = !this.isRootSeen;
      this.isRootSeen = !0;
      for (var h = c.body, g = 0, v = h.length; g < v; g++) {
        var y = h[g], A = this.accept(y);
        if (A) {
          var x = s(h, g, f), k = o(h, g, f), F = A.openStandalone && x, S = A.closeStandalone && k, R = A.inlineStandalone && x && k;
          A.close && l(h, g, !0), A.open && u(h, g, !0), d && R && (l(h, g), u(h, g) && y.type === "PartialStatement" && (y.indent = /([ \t]+$)/.exec(h[g - 1].original)[1])), d && F && (l((y.program || y.inverse).body), u(h, g)), d && S && (l(h, g), u((y.inverse || y.program).body));
        }
      }
      return c;
    }, a.prototype.BlockStatement = a.prototype.DecoratorBlock = a.prototype.PartialBlockStatement = function(c) {
      this.accept(c.program), this.accept(c.inverse);
      var d = c.program || c.inverse, f = c.program && c.inverse, h = f, g = f;
      if (f && f.chained)
        for (h = f.body[0].program; g.chained; )
          g = g.body[g.body.length - 1].program;
      var v = {
        open: c.openStrip.open,
        close: c.closeStrip.close,
        // Determine the standalone candiacy. Basically flag our content as being possibly standalone
        // so our parent can determine if we actually are standalone
        openStandalone: o(d.body),
        closeStandalone: s((h || d).body)
      };
      if (c.openStrip.close && l(d.body, null, !0), f) {
        var y = c.inverseStrip;
        y.open && u(d.body, null, !0), y.close && l(h.body, null, !0), c.closeStrip.open && u(g.body, null, !0), !this.options.ignoreStandalone && s(d.body) && o(h.body) && (u(d.body), l(h.body));
      } else c.closeStrip.open && u(d.body, null, !0);
      return v;
    }, a.prototype.Decorator = a.prototype.MustacheStatement = function(c) {
      return c.strip;
    }, a.prototype.PartialStatement = a.prototype.CommentStatement = function(c) {
      var d = c.strip || {};
      return {
        inlineStandalone: !0,
        open: d.open,
        close: d.close
      };
    };
    function s(c, d, f) {
      d === void 0 && (d = c.length);
      var h = c[d - 1], g = c[d - 2];
      if (!h)
        return f;
      if (h.type === "ContentStatement")
        return (g || !f ? /\r?\n\s*?$/ : /(^|\r?\n)\s*?$/).test(h.original);
    }
    function o(c, d, f) {
      d === void 0 && (d = -1);
      var h = c[d + 1], g = c[d + 2];
      if (!h)
        return f;
      if (h.type === "ContentStatement")
        return (g || !f ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(h.original);
    }
    function l(c, d, f) {
      var h = c[d == null ? 0 : d + 1];
      if (!(!h || h.type !== "ContentStatement" || !f && h.rightStripped)) {
        var g = h.value;
        h.value = h.value.replace(f ? /^\s+/ : /^[ \t]*\r?\n?/, ""), h.rightStripped = h.value !== g;
      }
    }
    function u(c, d, f) {
      var h = c[d == null ? c.length - 1 : d - 1];
      if (!(!h || h.type !== "ContentStatement" || !f && h.leftStripped)) {
        var g = h.value;
        return h.value = h.value.replace(f ? /\s+$/ : /[ \t]+$/, ""), h.leftStripped = h.value !== g, h.leftStripped;
      }
    }
    e.default = a, r.exports = e.default;
  })(ap, ap.exports)), ap.exports;
}
var Ki = {}, WC;
function x8() {
  if (WC) return Ki;
  WC = 1, Ki.__esModule = !0, Ki.SourceLocation = i, Ki.id = a, Ki.stripFlags = s, Ki.stripComment = o, Ki.preparePath = l, Ki.prepareMustache = u, Ki.prepareRawBlock = c, Ki.prepareBlock = d, Ki.prepareProgram = f, Ki.preparePartialBlock = h;
  function r(g) {
    return g && g.__esModule ? g : { default: g };
  }
  var e = ma(), t = r(e);
  function n(g, v) {
    if (v = v.path ? v.path.original : v, g.path.original !== v) {
      var y = { loc: g.path.loc };
      throw new t.default(g.path.original + " doesn't match " + v, y);
    }
  }
  function i(g, v) {
    this.source = g, this.start = {
      line: v.first_line,
      column: v.first_column
    }, this.end = {
      line: v.last_line,
      column: v.last_column
    };
  }
  function a(g) {
    return /^\[.*\]$/.test(g) ? g.substring(1, g.length - 1) : g;
  }
  function s(g, v) {
    return {
      open: g.charAt(2) === "~",
      close: v.charAt(v.length - 3) === "~"
    };
  }
  function o(g) {
    return g.replace(/^\{\{~?!-?-?/, "").replace(/-?-?~?\}\}$/, "");
  }
  function l(g, v, y) {
    y = this.locInfo(y);
    for (var A = g ? "@" : "", x = [], k = 0, F = 0, S = v.length; F < S; F++) {
      var R = v[F].part, M = v[F].original !== R;
      if (A += (v[F].separator || "") + R, !M && (R === ".." || R === "." || R === "this")) {
        if (x.length > 0)
          throw new t.default("Invalid path: " + A, { loc: y });
        R === ".." && k++;
      } else
        x.push(R);
    }
    return {
      type: "PathExpression",
      data: g,
      depth: k,
      parts: x,
      original: A,
      loc: y
    };
  }
  function u(g, v, y, A, x, k) {
    var F = A.charAt(3) || A.charAt(2), S = F !== "{" && F !== "&", R = /\*/.test(A);
    return {
      type: R ? "Decorator" : "MustacheStatement",
      path: g,
      params: v,
      hash: y,
      escaped: S,
      strip: x,
      loc: this.locInfo(k)
    };
  }
  function c(g, v, y, A) {
    n(g, y), A = this.locInfo(A);
    var x = {
      type: "Program",
      body: v,
      strip: {},
      loc: A
    };
    return {
      type: "BlockStatement",
      path: g.path,
      params: g.params,
      hash: g.hash,
      program: x,
      openStrip: {},
      inverseStrip: {},
      closeStrip: {},
      loc: A
    };
  }
  function d(g, v, y, A, x, k) {
    A && A.path && n(g, A);
    var F = /\*/.test(g.open);
    v.blockParams = g.blockParams;
    var S = void 0, R = void 0;
    if (y) {
      if (F)
        throw new t.default("Unexpected inverse block on decorator", y);
      y.chain && (y.program.body[0].closeStrip = A.strip), R = y.strip, S = y.program;
    }
    return x && (x = S, S = v, v = x), {
      type: F ? "DecoratorBlock" : "BlockStatement",
      path: g.path,
      params: g.params,
      hash: g.hash,
      program: v,
      inverse: S,
      openStrip: g.strip,
      inverseStrip: R,
      closeStrip: A && A.strip,
      loc: this.locInfo(k)
    };
  }
  function f(g, v) {
    if (!v && g.length) {
      var y = g[0].loc, A = g[g.length - 1].loc;
      y && A && (v = {
        source: y.source,
        start: {
          line: y.start.line,
          column: y.start.column
        },
        end: {
          line: A.end.line,
          column: A.end.column
        }
      });
    }
    return {
      type: "Program",
      body: g,
      strip: {},
      loc: v
    };
  }
  function h(g, v, y, A) {
    return n(g, y), {
      type: "PartialBlockStatement",
      name: g.path,
      params: g.params,
      hash: g.hash,
      program: v,
      openStrip: g.strip,
      closeStrip: y && y.strip,
      loc: this.locInfo(A)
    };
  }
  return Ki;
}
var QC;
function C8() {
  if (QC) return yu;
  QC = 1, yu.__esModule = !0, yu.parseWithoutProcessing = f, yu.parse = h;
  function r(A) {
    if (A && A.__esModule)
      return A;
    var x = {};
    if (A != null)
      for (var k in A)
        Object.prototype.hasOwnProperty.call(A, k) && (x[k] = A[k]);
    return x.default = A, x;
  }
  function e(A) {
    return A && A.__esModule ? A : { default: A };
  }
  var t = b8(), n = e(t), i = w8(), a = e(i), s = x8(), o = r(s), l = ma(), u = e(l), c = Gi();
  yu.parser = n.default;
  var d = {};
  c.extend(d, o);
  function f(A, x) {
    if (A.type === "Program")
      return g(A), A;
    n.default.yy = d, d.locInfo = function(F) {
      return new d.SourceLocation(x && x.srcName, F);
    };
    var k = n.default.parse(A);
    return k;
  }
  function h(A, x) {
    var k = f(A, x), F = new a.default(x);
    return F.accept(k);
  }
  function g(A) {
    v(A);
  }
  function v(A) {
    if (A != null) {
      if (Array.isArray(A)) {
        A.forEach(v);
        return;
      }
      if (typeof A == "object") {
        if (A.type === "PathExpression") {
          if (!y(A.depth))
            throw new u.default("Invalid AST: PathExpression.depth must be an integer");
          if (!Array.isArray(A.parts))
            throw new u.default("Invalid AST: PathExpression.parts must be an array");
          for (var x = 0; x < A.parts.length; x++)
            if (typeof A.parts[x] != "string")
              throw new u.default("Invalid AST: PathExpression.parts must only contain strings");
        } else if (A.type === "NumberLiteral") {
          if (typeof A.value != "number" || !isFinite(A.value))
            throw new u.default("Invalid AST: NumberLiteral.value must be a number");
        } else if (A.type === "BooleanLiteral" && typeof A.value != "boolean")
          throw new u.default("Invalid AST: BooleanLiteral.value must be a boolean");
        Object.keys(A).forEach(function(k) {
          k !== "loc" && v(A[k]);
        });
      }
    }
  }
  function y(A) {
    return typeof A == "number" && isFinite(A) && Math.floor(A) === A && A >= 0;
  }
  return yu;
}
var Au = {}, YC;
function S8() {
  if (YC) return Au;
  YC = 1, Au.__esModule = !0, Au.Compiler = o, Au.precompile = l, Au.compile = u;
  function r(f) {
    return f && f.__esModule ? f : { default: f };
  }
  var e = ma(), t = r(e), n = Gi(), i = fF(), a = r(i), s = [].slice;
  function o() {
  }
  o.prototype = {
    compiler: o,
    equals: function(h) {
      var g = this.opcodes.length;
      if (h.opcodes.length !== g)
        return !1;
      for (var v = 0; v < g; v++) {
        var y = this.opcodes[v], A = h.opcodes[v];
        if (y.opcode !== A.opcode || !c(y.args, A.args))
          return !1;
      }
      g = this.children.length;
      for (var v = 0; v < g; v++)
        if (!this.children[v].equals(h.children[v]))
          return !1;
      return !0;
    },
    guid: 0,
    compile: function(h, g) {
      return this.sourceNode = [], this.opcodes = [], this.children = [], this.options = g, this.stringParams = g.stringParams, this.trackIds = g.trackIds, g.blockParams = g.blockParams || [], g.knownHelpers = n.extend(/* @__PURE__ */ Object.create(null), {
        helperMissing: !0,
        blockHelperMissing: !0,
        each: !0,
        if: !0,
        unless: !0,
        with: !0,
        log: !0,
        lookup: !0
      }, g.knownHelpers), this.accept(h);
    },
    compileProgram: function(h) {
      var g = new this.compiler(), v = g.compile(h, this.options), y = this.guid++;
      return this.usePartial = this.usePartial || v.usePartial, this.children[y] = v, this.useDepths = this.useDepths || v.useDepths, y;
    },
    accept: function(h) {
      if (!this[h.type])
        throw new t.default("Unknown type: " + h.type, h);
      this.sourceNode.unshift(h);
      var g = this[h.type](h);
      return this.sourceNode.shift(), g;
    },
    Program: function(h) {
      this.options.blockParams.unshift(h.blockParams);
      for (var g = h.body, v = g.length, y = 0; y < v; y++)
        this.accept(g[y]);
      return this.options.blockParams.shift(), this.isSimple = v === 1, this.blockParams = h.blockParams ? h.blockParams.length : 0, this;
    },
    BlockStatement: function(h) {
      d(h);
      var g = h.program, v = h.inverse;
      g = g && this.compileProgram(g), v = v && this.compileProgram(v);
      var y = this.classifySexpr(h);
      y === "helper" ? this.helperSexpr(h, g, v) : y === "simple" ? (this.simpleSexpr(h), this.opcode("pushProgram", g), this.opcode("pushProgram", v), this.opcode("emptyHash"), this.opcode("blockValue", h.path.original)) : (this.ambiguousSexpr(h, g, v), this.opcode("pushProgram", g), this.opcode("pushProgram", v), this.opcode("emptyHash"), this.opcode("ambiguousBlockValue")), this.opcode("append");
    },
    DecoratorBlock: function(h) {
      var g = h.program && this.compileProgram(h.program), v = this.setupFullMustacheParams(h, g, void 0), y = h.path;
      this.useDecorators = !0, this.opcode("registerDecorator", v.length, y.original);
    },
    PartialStatement: function(h) {
      this.usePartial = !0;
      var g = h.program;
      g && (g = this.compileProgram(h.program));
      var v = h.params;
      if (v.length > 1)
        throw new t.default("Unsupported number of partial arguments: " + v.length, h);
      v.length || (this.options.explicitPartialContext ? this.opcode("pushLiteral", "undefined") : v.push({ type: "PathExpression", parts: [], depth: 0 }));
      var y = h.name.original, A = h.name.type === "SubExpression";
      A && this.accept(h.name), this.setupFullMustacheParams(h, g, void 0, !0);
      var x = h.indent || "";
      this.options.preventIndent && x && (this.opcode("appendContent", x), x = ""), this.opcode("invokePartial", A, y, x), this.opcode("append");
    },
    PartialBlockStatement: function(h) {
      this.PartialStatement(h);
    },
    MustacheStatement: function(h) {
      this.SubExpression(h), h.escaped && !this.options.noEscape ? this.opcode("appendEscaped") : this.opcode("append");
    },
    Decorator: function(h) {
      this.DecoratorBlock(h);
    },
    ContentStatement: function(h) {
      h.value && this.opcode("appendContent", h.value);
    },
    CommentStatement: function() {
    },
    SubExpression: function(h) {
      d(h);
      var g = this.classifySexpr(h);
      g === "simple" ? this.simpleSexpr(h) : g === "helper" ? this.helperSexpr(h) : this.ambiguousSexpr(h);
    },
    ambiguousSexpr: function(h, g, v) {
      var y = h.path, A = y.parts[0], x = g != null || v != null;
      this.opcode("getContext", y.depth), this.opcode("pushProgram", g), this.opcode("pushProgram", v), y.strict = !0, this.accept(y), this.opcode("invokeAmbiguous", A, x);
    },
    simpleSexpr: function(h) {
      var g = h.path;
      g.strict = !0, this.accept(g), this.opcode("resolvePossibleLambda");
    },
    helperSexpr: function(h, g, v) {
      var y = this.setupFullMustacheParams(h, g, v), A = h.path, x = A.parts[0];
      if (this.options.knownHelpers[x])
        this.opcode("invokeKnownHelper", y.length, x);
      else {
        if (this.options.knownHelpersOnly)
          throw new t.default("You specified knownHelpersOnly, but used the unknown helper " + x, h);
        A.strict = !0, A.falsy = !0, this.accept(A), this.opcode("invokeHelper", y.length, A.original, a.default.helpers.simpleId(A));
      }
    },
    PathExpression: function(h) {
      this.addDepth(h.depth), this.opcode("getContext", h.depth);
      var g = h.parts[0], v = a.default.helpers.scopedId(h), y = !h.depth && !v && this.blockParamIndex(g);
      y ? this.opcode("lookupBlockParam", y, h.parts) : g ? h.data ? (this.options.data = !0, this.opcode("lookupData", h.depth, h.parts, h.strict)) : this.opcode("lookupOnContext", h.parts, h.falsy, h.strict, v) : this.opcode("pushContext");
    },
    StringLiteral: function(h) {
      this.opcode("pushString", h.value);
    },
    NumberLiteral: function(h) {
      this.opcode("pushLiteral", h.value);
    },
    BooleanLiteral: function(h) {
      this.opcode("pushLiteral", h.value);
    },
    UndefinedLiteral: function() {
      this.opcode("pushLiteral", "undefined");
    },
    NullLiteral: function() {
      this.opcode("pushLiteral", "null");
    },
    Hash: function(h) {
      var g = h.pairs, v = 0, y = g.length;
      for (this.opcode("pushHash"); v < y; v++)
        this.pushParam(g[v].value);
      for (; v--; )
        this.opcode("assignToHash", g[v].key);
      this.opcode("popHash");
    },
    // HELPERS
    opcode: function(h) {
      this.opcodes.push({
        opcode: h,
        args: s.call(arguments, 1),
        loc: this.sourceNode[0].loc
      });
    },
    addDepth: function(h) {
      h && (this.useDepths = !0);
    },
    classifySexpr: function(h) {
      var g = a.default.helpers.simpleId(h.path), v = g && !!this.blockParamIndex(h.path.parts[0]), y = !v && a.default.helpers.helperExpression(h), A = !v && (y || g);
      if (A && !y) {
        var x = h.path.parts[0], k = this.options;
        k.knownHelpers[x] ? y = !0 : k.knownHelpersOnly && (A = !1);
      }
      return y ? "helper" : A ? "ambiguous" : "simple";
    },
    pushParams: function(h) {
      for (var g = 0, v = h.length; g < v; g++)
        this.pushParam(h[g]);
    },
    pushParam: function(h) {
      var g = h.value != null ? h.value : h.original || "";
      if (this.stringParams)
        g.replace && (g = g.replace(/^(\.?\.\/)*/g, "").replace(/\//g, ".")), h.depth && this.addDepth(h.depth), this.opcode("getContext", h.depth || 0), this.opcode("pushStringParam", g, h.type), h.type === "SubExpression" && this.accept(h);
      else {
        if (this.trackIds) {
          var v = void 0;
          if (h.parts && !a.default.helpers.scopedId(h) && !h.depth && (v = this.blockParamIndex(h.parts[0])), v) {
            var y = h.parts.slice(1).join(".");
            this.opcode("pushId", "BlockParam", v, y);
          } else
            g = h.original || g, g.replace && (g = g.replace(/^this(?:\.|$)/, "").replace(/^\.\//, "").replace(/^\.$/, "")), this.opcode("pushId", h.type, g);
        }
        this.accept(h);
      }
    },
    setupFullMustacheParams: function(h, g, v, y) {
      var A = h.params;
      return this.pushParams(A), this.opcode("pushProgram", g), this.opcode("pushProgram", v), h.hash ? this.accept(h.hash) : this.opcode("emptyHash", y), A;
    },
    blockParamIndex: function(h) {
      for (var g = 0, v = this.options.blockParams.length; g < v; g++) {
        var y = this.options.blockParams[g], A = y && n.indexOf(y, h);
        if (y && A >= 0)
          return [g, A];
      }
    }
  };
  function l(f, h, g) {
    if (f == null || typeof f != "string" && f.type !== "Program")
      throw new t.default("You must pass a string or Handlebars AST to Handlebars.precompile. You passed " + f);
    h = h || {}, "data" in h || (h.data = !0), h.compat && (h.useDepths = !0);
    var v = g.parse(f, h), y = new g.Compiler().compile(v, h);
    return new g.JavaScriptCompiler().compile(y, h);
  }
  function u(f, h, g) {
    if (h === void 0 && (h = {}), f == null || typeof f != "string" && f.type !== "Program")
      throw new t.default("You must pass a string or Handlebars AST to Handlebars.compile. You passed " + f);
    h = n.extend({}, h), "data" in h || (h.data = !0), h.compat && (h.useDepths = !0);
    var v = void 0;
    function y() {
      var x = g.parse(f, h), k = new g.Compiler().compile(x, h), F = new g.JavaScriptCompiler().compile(k, h, void 0, !0);
      return g.template(F);
    }
    function A(x, k) {
      return v || (v = y()), v.call(this, x, k);
    }
    return A._setup = function(x) {
      return v || (v = y()), v._setup(x);
    }, A._child = function(x, k, F, S) {
      return v || (v = y()), v._child(x, k, F, S);
    }, A;
  }
  function c(f, h) {
    if (f === h)
      return !0;
    if (n.isArray(f) && n.isArray(h) && f.length === h.length) {
      for (var g = 0; g < f.length; g++)
        if (!c(f[g], h[g]))
          return !1;
      return !0;
    }
  }
  function d(f) {
    if (!f.path.parts) {
      var h = f.path;
      f.path = {
        type: "PathExpression",
        data: !1,
        depth: 0,
        parts: [h.original + ""],
        original: h.original + "",
        loc: h.loc
      };
    }
  }
  return Au;
}
var op = { exports: {} }, lp = { exports: {} }, ff = {}, T0 = {}, up = {}, cp = {}, XC;
function E8() {
  if (XC) return cp;
  XC = 1;
  var r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
  return cp.encode = function(e) {
    if (0 <= e && e < r.length)
      return r[e];
    throw new TypeError("Must be between 0 and 63: " + e);
  }, cp.decode = function(e) {
    var t = 65, n = 90, i = 97, a = 122, s = 48, o = 57, l = 43, u = 47, c = 26, d = 52;
    return t <= e && e <= n ? e - t : i <= e && e <= a ? e - i + c : s <= e && e <= o ? e - s + d : e == l ? 62 : e == u ? 63 : -1;
  }, cp;
}
var JC;
function hF() {
  if (JC) return up;
  JC = 1;
  var r = E8(), e = 5, t = 1 << e, n = t - 1, i = t;
  function a(o) {
    return o < 0 ? (-o << 1) + 1 : (o << 1) + 0;
  }
  function s(o) {
    var l = (o & 1) === 1, u = o >> 1;
    return l ? -u : u;
  }
  return up.encode = function(l) {
    var u = "", c, d = a(l);
    do
      c = d & n, d >>>= e, d > 0 && (c |= i), u += r.encode(c);
    while (d > 0);
    return u;
  }, up.decode = function(l, u, c) {
    var d = l.length, f = 0, h = 0, g, v;
    do {
      if (u >= d)
        throw new Error("Expected more digits in base 64 VLQ value.");
      if (v = r.decode(l.charCodeAt(u++)), v === -1)
        throw new Error("Invalid base64 digit: " + l.charAt(u - 1));
      g = !!(v & i), v &= n, f = f + (v << h), h += e;
    } while (g);
    c.value = s(f), c.rest = u;
  }, up;
}
var F0 = {}, KC;
function Ld() {
  return KC || (KC = 1, (function(r) {
    function e(F, S, R) {
      if (S in F)
        return F[S];
      if (arguments.length === 3)
        return R;
      throw new Error('"' + S + '" is a required argument.');
    }
    r.getArg = e;
    var t = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.-]*)(?::(\d+))?(.*)$/, n = /^data:.+\,.+$/;
    function i(F) {
      var S = F.match(t);
      return S ? {
        scheme: S[1],
        auth: S[2],
        host: S[3],
        port: S[4],
        path: S[5]
      } : null;
    }
    r.urlParse = i;
    function a(F) {
      var S = "";
      return F.scheme && (S += F.scheme + ":"), S += "//", F.auth && (S += F.auth + "@"), F.host && (S += F.host), F.port && (S += ":" + F.port), F.path && (S += F.path), S;
    }
    r.urlGenerate = a;
    function s(F) {
      var S = F, R = i(F);
      if (R) {
        if (!R.path)
          return F;
        S = R.path;
      }
      for (var M = r.isAbsolute(S), j = S.split(/\/+/), G, ie = 0, q = j.length - 1; q >= 0; q--)
        G = j[q], G === "." ? j.splice(q, 1) : G === ".." ? ie++ : ie > 0 && (G === "" ? (j.splice(q + 1, ie), ie = 0) : (j.splice(q, 2), ie--));
      return S = j.join("/"), S === "" && (S = M ? "/" : "."), R ? (R.path = S, a(R)) : S;
    }
    r.normalize = s;
    function o(F, S) {
      F === "" && (F = "."), S === "" && (S = ".");
      var R = i(S), M = i(F);
      if (M && (F = M.path || "/"), R && !R.scheme)
        return M && (R.scheme = M.scheme), a(R);
      if (R || S.match(n))
        return S;
      if (M && !M.host && !M.path)
        return M.host = S, a(M);
      var j = S.charAt(0) === "/" ? S : s(F.replace(/\/+$/, "") + "/" + S);
      return M ? (M.path = j, a(M)) : j;
    }
    r.join = o, r.isAbsolute = function(F) {
      return F.charAt(0) === "/" || t.test(F);
    };
    function l(F, S) {
      F === "" && (F = "."), F = F.replace(/\/$/, "");
      for (var R = 0; S.indexOf(F + "/") !== 0; ) {
        var M = F.lastIndexOf("/");
        if (M < 0 || (F = F.slice(0, M), F.match(/^([^\/]+:\/)?\/*$/)))
          return S;
        ++R;
      }
      return Array(R + 1).join("../") + S.substr(F.length + 1);
    }
    r.relative = l;
    var u = (function() {
      var F = /* @__PURE__ */ Object.create(null);
      return !("__proto__" in F);
    })();
    function c(F) {
      return F;
    }
    function d(F) {
      return h(F) ? "$" + F : F;
    }
    r.toSetString = u ? c : d;
    function f(F) {
      return h(F) ? F.slice(1) : F;
    }
    r.fromSetString = u ? c : f;
    function h(F) {
      if (!F)
        return !1;
      var S = F.length;
      if (S < 9 || F.charCodeAt(S - 1) !== 95 || F.charCodeAt(S - 2) !== 95 || F.charCodeAt(S - 3) !== 111 || F.charCodeAt(S - 4) !== 116 || F.charCodeAt(S - 5) !== 111 || F.charCodeAt(S - 6) !== 114 || F.charCodeAt(S - 7) !== 112 || F.charCodeAt(S - 8) !== 95 || F.charCodeAt(S - 9) !== 95)
        return !1;
      for (var R = S - 10; R >= 0; R--)
        if (F.charCodeAt(R) !== 36)
          return !1;
      return !0;
    }
    function g(F, S, R) {
      var M = y(F.source, S.source);
      return M !== 0 || (M = F.originalLine - S.originalLine, M !== 0) || (M = F.originalColumn - S.originalColumn, M !== 0 || R) || (M = F.generatedColumn - S.generatedColumn, M !== 0) || (M = F.generatedLine - S.generatedLine, M !== 0) ? M : y(F.name, S.name);
    }
    r.compareByOriginalPositions = g;
    function v(F, S, R) {
      var M = F.generatedLine - S.generatedLine;
      return M !== 0 || (M = F.generatedColumn - S.generatedColumn, M !== 0 || R) || (M = y(F.source, S.source), M !== 0) || (M = F.originalLine - S.originalLine, M !== 0) || (M = F.originalColumn - S.originalColumn, M !== 0) ? M : y(F.name, S.name);
    }
    r.compareByGeneratedPositionsDeflated = v;
    function y(F, S) {
      return F === S ? 0 : F === null ? 1 : S === null ? -1 : F > S ? 1 : -1;
    }
    function A(F, S) {
      var R = F.generatedLine - S.generatedLine;
      return R !== 0 || (R = F.generatedColumn - S.generatedColumn, R !== 0) || (R = y(F.source, S.source), R !== 0) || (R = F.originalLine - S.originalLine, R !== 0) || (R = F.originalColumn - S.originalColumn, R !== 0) ? R : y(F.name, S.name);
    }
    r.compareByGeneratedPositionsInflated = A;
    function x(F) {
      return JSON.parse(F.replace(/^\)]}'[^\n]*\n/, ""));
    }
    r.parseSourceMapInput = x;
    function k(F, S, R) {
      if (S = S || "", F && (F[F.length - 1] !== "/" && S[0] !== "/" && (F += "/"), S = F + S), R) {
        var M = i(R);
        if (!M)
          throw new Error("sourceMapURL could not be parsed");
        if (M.path) {
          var j = M.path.lastIndexOf("/");
          j >= 0 && (M.path = M.path.substring(0, j + 1));
        }
        S = o(a(M), S);
      }
      return s(S);
    }
    r.computeSourceURL = k;
  })(F0)), F0;
}
var I0 = {}, ZC;
function pF() {
  if (ZC) return I0;
  ZC = 1;
  var r = Ld(), e = Object.prototype.hasOwnProperty, t = typeof Map < "u";
  function n() {
    this._array = [], this._set = t ? /* @__PURE__ */ new Map() : /* @__PURE__ */ Object.create(null);
  }
  return n.fromArray = function(a, s) {
    for (var o = new n(), l = 0, u = a.length; l < u; l++)
      o.add(a[l], s);
    return o;
  }, n.prototype.size = function() {
    return t ? this._set.size : Object.getOwnPropertyNames(this._set).length;
  }, n.prototype.add = function(a, s) {
    var o = t ? a : r.toSetString(a), l = t ? this.has(a) : e.call(this._set, o), u = this._array.length;
    (!l || s) && this._array.push(a), l || (t ? this._set.set(a, u) : this._set[o] = u);
  }, n.prototype.has = function(a) {
    if (t)
      return this._set.has(a);
    var s = r.toSetString(a);
    return e.call(this._set, s);
  }, n.prototype.indexOf = function(a) {
    if (t) {
      var s = this._set.get(a);
      if (s >= 0)
        return s;
    } else {
      var o = r.toSetString(a);
      if (e.call(this._set, o))
        return this._set[o];
    }
    throw new Error('"' + a + '" is not in the set.');
  }, n.prototype.at = function(a) {
    if (a >= 0 && a < this._array.length)
      return this._array[a];
    throw new Error("No element indexed by " + a);
  }, n.prototype.toArray = function() {
    return this._array.slice();
  }, I0.ArraySet = n, I0;
}
var D0 = {}, eS;
function k8() {
  if (eS) return D0;
  eS = 1;
  var r = Ld();
  function e(n, i) {
    var a = n.generatedLine, s = i.generatedLine, o = n.generatedColumn, l = i.generatedColumn;
    return s > a || s == a && l >= o || r.compareByGeneratedPositionsInflated(n, i) <= 0;
  }
  function t() {
    this._array = [], this._sorted = !0, this._last = { generatedLine: -1, generatedColumn: 0 };
  }
  return t.prototype.unsortedForEach = function(i, a) {
    this._array.forEach(i, a);
  }, t.prototype.add = function(i) {
    e(this._last, i) ? (this._last = i, this._array.push(i)) : (this._sorted = !1, this._array.push(i));
  }, t.prototype.toArray = function() {
    return this._sorted || (this._array.sort(r.compareByGeneratedPositionsInflated), this._sorted = !0), this._array;
  }, D0.MappingList = t, D0;
}
var tS;
function gF() {
  if (tS) return T0;
  tS = 1;
  var r = hF(), e = Ld(), t = pF().ArraySet, n = k8().MappingList;
  function i(a) {
    a || (a = {}), this._file = e.getArg(a, "file", null), this._sourceRoot = e.getArg(a, "sourceRoot", null), this._skipValidation = e.getArg(a, "skipValidation", !1), this._sources = new t(), this._names = new t(), this._mappings = new n(), this._sourcesContents = null;
  }
  return i.prototype._version = 3, i.fromSourceMap = function(s) {
    var o = s.sourceRoot, l = new i({
      file: s.file,
      sourceRoot: o
    });
    return s.eachMapping(function(u) {
      var c = {
        generated: {
          line: u.generatedLine,
          column: u.generatedColumn
        }
      };
      u.source != null && (c.source = u.source, o != null && (c.source = e.relative(o, c.source)), c.original = {
        line: u.originalLine,
        column: u.originalColumn
      }, u.name != null && (c.name = u.name)), l.addMapping(c);
    }), s.sources.forEach(function(u) {
      var c = u;
      o !== null && (c = e.relative(o, u)), l._sources.has(c) || l._sources.add(c);
      var d = s.sourceContentFor(u);
      d != null && l.setSourceContent(u, d);
    }), l;
  }, i.prototype.addMapping = function(s) {
    var o = e.getArg(s, "generated"), l = e.getArg(s, "original", null), u = e.getArg(s, "source", null), c = e.getArg(s, "name", null);
    this._skipValidation || this._validateMapping(o, l, u, c), u != null && (u = String(u), this._sources.has(u) || this._sources.add(u)), c != null && (c = String(c), this._names.has(c) || this._names.add(c)), this._mappings.add({
      generatedLine: o.line,
      generatedColumn: o.column,
      originalLine: l != null && l.line,
      originalColumn: l != null && l.column,
      source: u,
      name: c
    });
  }, i.prototype.setSourceContent = function(s, o) {
    var l = s;
    this._sourceRoot != null && (l = e.relative(this._sourceRoot, l)), o != null ? (this._sourcesContents || (this._sourcesContents = /* @__PURE__ */ Object.create(null)), this._sourcesContents[e.toSetString(l)] = o) : this._sourcesContents && (delete this._sourcesContents[e.toSetString(l)], Object.keys(this._sourcesContents).length === 0 && (this._sourcesContents = null));
  }, i.prototype.applySourceMap = function(s, o, l) {
    var u = o;
    if (o == null) {
      if (s.file == null)
        throw new Error(
          `SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, or the source map's "file" property. Both were omitted.`
        );
      u = s.file;
    }
    var c = this._sourceRoot;
    c != null && (u = e.relative(c, u));
    var d = new t(), f = new t();
    this._mappings.unsortedForEach(function(h) {
      if (h.source === u && h.originalLine != null) {
        var g = s.originalPositionFor({
          line: h.originalLine,
          column: h.originalColumn
        });
        g.source != null && (h.source = g.source, l != null && (h.source = e.join(l, h.source)), c != null && (h.source = e.relative(c, h.source)), h.originalLine = g.line, h.originalColumn = g.column, g.name != null && (h.name = g.name));
      }
      var v = h.source;
      v != null && !d.has(v) && d.add(v);
      var y = h.name;
      y != null && !f.has(y) && f.add(y);
    }, this), this._sources = d, this._names = f, s.sources.forEach(function(h) {
      var g = s.sourceContentFor(h);
      g != null && (l != null && (h = e.join(l, h)), c != null && (h = e.relative(c, h)), this.setSourceContent(h, g));
    }, this);
  }, i.prototype._validateMapping = function(s, o, l, u) {
    if (o && typeof o.line != "number" && typeof o.column != "number")
      throw new Error(
        "original.line and original.column are not numbers -- you probably meant to omit the original mapping entirely and only map the generated position. If so, pass null for the original mapping instead of an object with empty or null values."
      );
    if (!(s && "line" in s && "column" in s && s.line > 0 && s.column >= 0 && !o && !l && !u)) {
      if (s && "line" in s && "column" in s && o && "line" in o && "column" in o && s.line > 0 && s.column >= 0 && o.line > 0 && o.column >= 0 && l)
        return;
      throw new Error("Invalid mapping: " + JSON.stringify({
        generated: s,
        source: l,
        original: o,
        name: u
      }));
    }
  }, i.prototype._serializeMappings = function() {
    for (var s = 0, o = 1, l = 0, u = 0, c = 0, d = 0, f = "", h, g, v, y, A = this._mappings.toArray(), x = 0, k = A.length; x < k; x++) {
      if (g = A[x], h = "", g.generatedLine !== o)
        for (s = 0; g.generatedLine !== o; )
          h += ";", o++;
      else if (x > 0) {
        if (!e.compareByGeneratedPositionsInflated(g, A[x - 1]))
          continue;
        h += ",";
      }
      h += r.encode(g.generatedColumn - s), s = g.generatedColumn, g.source != null && (y = this._sources.indexOf(g.source), h += r.encode(y - d), d = y, h += r.encode(g.originalLine - 1 - u), u = g.originalLine - 1, h += r.encode(g.originalColumn - l), l = g.originalColumn, g.name != null && (v = this._names.indexOf(g.name), h += r.encode(v - c), c = v)), f += h;
    }
    return f;
  }, i.prototype._generateSourcesContent = function(s, o) {
    return s.map(function(l) {
      if (!this._sourcesContents)
        return null;
      o != null && (l = e.relative(o, l));
      var u = e.toSetString(l);
      return Object.prototype.hasOwnProperty.call(this._sourcesContents, u) ? this._sourcesContents[u] : null;
    }, this);
  }, i.prototype.toJSON = function() {
    var s = {
      version: this._version,
      sources: this._sources.toArray(),
      names: this._names.toArray(),
      mappings: this._serializeMappings()
    };
    return this._file != null && (s.file = this._file), this._sourceRoot != null && (s.sourceRoot = this._sourceRoot), this._sourcesContents && (s.sourcesContent = this._generateSourcesContent(s.sources, s.sourceRoot)), s;
  }, i.prototype.toString = function() {
    return JSON.stringify(this.toJSON());
  }, T0.SourceMapGenerator = i, T0;
}
var df = {}, P0 = {}, rS;
function T8() {
  return rS || (rS = 1, (function(r) {
    r.GREATEST_LOWER_BOUND = 1, r.LEAST_UPPER_BOUND = 2;
    function e(t, n, i, a, s, o) {
      var l = Math.floor((n - t) / 2) + t, u = s(i, a[l], !0);
      return u === 0 ? l : u > 0 ? n - l > 1 ? e(l, n, i, a, s, o) : o == r.LEAST_UPPER_BOUND ? n < a.length ? n : -1 : l : l - t > 1 ? e(t, l, i, a, s, o) : o == r.LEAST_UPPER_BOUND ? l : t < 0 ? -1 : t;
    }
    r.search = function(n, i, a, s) {
      if (i.length === 0)
        return -1;
      var o = e(
        -1,
        i.length,
        n,
        i,
        a,
        s || r.GREATEST_LOWER_BOUND
      );
      if (o < 0)
        return -1;
      for (; o - 1 >= 0 && a(i[o], i[o - 1], !0) === 0; )
        --o;
      return o;
    };
  })(P0)), P0;
}
var R0 = {}, nS;
function F8() {
  if (nS) return R0;
  nS = 1;
  function r(n, i, a) {
    var s = n[i];
    n[i] = n[a], n[a] = s;
  }
  function e(n, i) {
    return Math.round(n + Math.random() * (i - n));
  }
  function t(n, i, a, s) {
    if (a < s) {
      var o = e(a, s), l = a - 1;
      r(n, o, s);
      for (var u = n[s], c = a; c < s; c++)
        i(n[c], u) <= 0 && (l += 1, r(n, l, c));
      r(n, l + 1, c);
      var d = l + 1;
      t(n, i, a, d - 1), t(n, i, d + 1, s);
    }
  }
  return R0.quickSort = function(n, i) {
    t(n, i, 0, n.length - 1);
  }, R0;
}
var iS;
function I8() {
  if (iS) return df;
  iS = 1;
  var r = Ld(), e = T8(), t = pF().ArraySet, n = hF(), i = F8().quickSort;
  function a(u, c) {
    var d = u;
    return typeof u == "string" && (d = r.parseSourceMapInput(u)), d.sections != null ? new l(d, c) : new s(d, c);
  }
  a.fromSourceMap = function(u, c) {
    return s.fromSourceMap(u, c);
  }, a.prototype._version = 3, a.prototype.__generatedMappings = null, Object.defineProperty(a.prototype, "_generatedMappings", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.__generatedMappings || this._parseMappings(this._mappings, this.sourceRoot), this.__generatedMappings;
    }
  }), a.prototype.__originalMappings = null, Object.defineProperty(a.prototype, "_originalMappings", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.__originalMappings || this._parseMappings(this._mappings, this.sourceRoot), this.__originalMappings;
    }
  }), a.prototype._charIsMappingSeparator = function(c, d) {
    var f = c.charAt(d);
    return f === ";" || f === ",";
  }, a.prototype._parseMappings = function(c, d) {
    throw new Error("Subclasses must implement _parseMappings");
  }, a.GENERATED_ORDER = 1, a.ORIGINAL_ORDER = 2, a.GREATEST_LOWER_BOUND = 1, a.LEAST_UPPER_BOUND = 2, a.prototype.eachMapping = function(c, d, f) {
    var h = d || null, g = f || a.GENERATED_ORDER, v;
    switch (g) {
      case a.GENERATED_ORDER:
        v = this._generatedMappings;
        break;
      case a.ORIGINAL_ORDER:
        v = this._originalMappings;
        break;
      default:
        throw new Error("Unknown order of iteration.");
    }
    var y = this.sourceRoot;
    v.map(function(A) {
      var x = A.source === null ? null : this._sources.at(A.source);
      return x = r.computeSourceURL(y, x, this._sourceMapURL), {
        source: x,
        generatedLine: A.generatedLine,
        generatedColumn: A.generatedColumn,
        originalLine: A.originalLine,
        originalColumn: A.originalColumn,
        name: A.name === null ? null : this._names.at(A.name)
      };
    }, this).forEach(c, h);
  }, a.prototype.allGeneratedPositionsFor = function(c) {
    var d = r.getArg(c, "line"), f = {
      source: r.getArg(c, "source"),
      originalLine: d,
      originalColumn: r.getArg(c, "column", 0)
    };
    if (f.source = this._findSourceIndex(f.source), f.source < 0)
      return [];
    var h = [], g = this._findMapping(
      f,
      this._originalMappings,
      "originalLine",
      "originalColumn",
      r.compareByOriginalPositions,
      e.LEAST_UPPER_BOUND
    );
    if (g >= 0) {
      var v = this._originalMappings[g];
      if (c.column === void 0)
        for (var y = v.originalLine; v && v.originalLine === y; )
          h.push({
            line: r.getArg(v, "generatedLine", null),
            column: r.getArg(v, "generatedColumn", null),
            lastColumn: r.getArg(v, "lastGeneratedColumn", null)
          }), v = this._originalMappings[++g];
      else
        for (var A = v.originalColumn; v && v.originalLine === d && v.originalColumn == A; )
          h.push({
            line: r.getArg(v, "generatedLine", null),
            column: r.getArg(v, "generatedColumn", null),
            lastColumn: r.getArg(v, "lastGeneratedColumn", null)
          }), v = this._originalMappings[++g];
    }
    return h;
  }, df.SourceMapConsumer = a;
  function s(u, c) {
    var d = u;
    typeof u == "string" && (d = r.parseSourceMapInput(u));
    var f = r.getArg(d, "version"), h = r.getArg(d, "sources"), g = r.getArg(d, "names", []), v = r.getArg(d, "sourceRoot", null), y = r.getArg(d, "sourcesContent", null), A = r.getArg(d, "mappings"), x = r.getArg(d, "file", null);
    if (f != this._version)
      throw new Error("Unsupported version: " + f);
    v && (v = r.normalize(v)), h = h.map(String).map(r.normalize).map(function(k) {
      return v && r.isAbsolute(v) && r.isAbsolute(k) ? r.relative(v, k) : k;
    }), this._names = t.fromArray(g.map(String), !0), this._sources = t.fromArray(h, !0), this._absoluteSources = this._sources.toArray().map(function(k) {
      return r.computeSourceURL(v, k, c);
    }), this.sourceRoot = v, this.sourcesContent = y, this._mappings = A, this._sourceMapURL = c, this.file = x;
  }
  s.prototype = Object.create(a.prototype), s.prototype.consumer = a, s.prototype._findSourceIndex = function(u) {
    var c = u;
    if (this.sourceRoot != null && (c = r.relative(this.sourceRoot, c)), this._sources.has(c))
      return this._sources.indexOf(c);
    var d;
    for (d = 0; d < this._absoluteSources.length; ++d)
      if (this._absoluteSources[d] == u)
        return d;
    return -1;
  }, s.fromSourceMap = function(c, d) {
    var f = Object.create(s.prototype), h = f._names = t.fromArray(c._names.toArray(), !0), g = f._sources = t.fromArray(c._sources.toArray(), !0);
    f.sourceRoot = c._sourceRoot, f.sourcesContent = c._generateSourcesContent(
      f._sources.toArray(),
      f.sourceRoot
    ), f.file = c._file, f._sourceMapURL = d, f._absoluteSources = f._sources.toArray().map(function(R) {
      return r.computeSourceURL(f.sourceRoot, R, d);
    });
    for (var v = c._mappings.toArray().slice(), y = f.__generatedMappings = [], A = f.__originalMappings = [], x = 0, k = v.length; x < k; x++) {
      var F = v[x], S = new o();
      S.generatedLine = F.generatedLine, S.generatedColumn = F.generatedColumn, F.source && (S.source = g.indexOf(F.source), S.originalLine = F.originalLine, S.originalColumn = F.originalColumn, F.name && (S.name = h.indexOf(F.name)), A.push(S)), y.push(S);
    }
    return i(f.__originalMappings, r.compareByOriginalPositions), f;
  }, s.prototype._version = 3, Object.defineProperty(s.prototype, "sources", {
    get: function() {
      return this._absoluteSources.slice();
    }
  });
  function o() {
    this.generatedLine = 0, this.generatedColumn = 0, this.source = null, this.originalLine = null, this.originalColumn = null, this.name = null;
  }
  s.prototype._parseMappings = function(c, d) {
    for (var f = 1, h = 0, g = 0, v = 0, y = 0, A = 0, x = c.length, k = 0, F = {}, S = {}, R = [], M = [], j, G, ie, q, Y; k < x; )
      if (c.charAt(k) === ";")
        f++, k++, h = 0;
      else if (c.charAt(k) === ",")
        k++;
      else {
        for (j = new o(), j.generatedLine = f, q = k; q < x && !this._charIsMappingSeparator(c, q); q++)
          ;
        if (G = c.slice(k, q), ie = F[G], ie)
          k += G.length;
        else {
          for (ie = []; k < q; )
            n.decode(c, k, S), Y = S.value, k = S.rest, ie.push(Y);
          if (ie.length === 2)
            throw new Error("Found a source, but no line and column");
          if (ie.length === 3)
            throw new Error("Found a source and line, but no column");
          F[G] = ie;
        }
        j.generatedColumn = h + ie[0], h = j.generatedColumn, ie.length > 1 && (j.source = y + ie[1], y += ie[1], j.originalLine = g + ie[2], g = j.originalLine, j.originalLine += 1, j.originalColumn = v + ie[3], v = j.originalColumn, ie.length > 4 && (j.name = A + ie[4], A += ie[4])), M.push(j), typeof j.originalLine == "number" && R.push(j);
      }
    i(M, r.compareByGeneratedPositionsDeflated), this.__generatedMappings = M, i(R, r.compareByOriginalPositions), this.__originalMappings = R;
  }, s.prototype._findMapping = function(c, d, f, h, g, v) {
    if (c[f] <= 0)
      throw new TypeError("Line must be greater than or equal to 1, got " + c[f]);
    if (c[h] < 0)
      throw new TypeError("Column must be greater than or equal to 0, got " + c[h]);
    return e.search(c, d, g, v);
  }, s.prototype.computeColumnSpans = function() {
    for (var c = 0; c < this._generatedMappings.length; ++c) {
      var d = this._generatedMappings[c];
      if (c + 1 < this._generatedMappings.length) {
        var f = this._generatedMappings[c + 1];
        if (d.generatedLine === f.generatedLine) {
          d.lastGeneratedColumn = f.generatedColumn - 1;
          continue;
        }
      }
      d.lastGeneratedColumn = 1 / 0;
    }
  }, s.prototype.originalPositionFor = function(c) {
    var d = {
      generatedLine: r.getArg(c, "line"),
      generatedColumn: r.getArg(c, "column")
    }, f = this._findMapping(
      d,
      this._generatedMappings,
      "generatedLine",
      "generatedColumn",
      r.compareByGeneratedPositionsDeflated,
      r.getArg(c, "bias", a.GREATEST_LOWER_BOUND)
    );
    if (f >= 0) {
      var h = this._generatedMappings[f];
      if (h.generatedLine === d.generatedLine) {
        var g = r.getArg(h, "source", null);
        g !== null && (g = this._sources.at(g), g = r.computeSourceURL(this.sourceRoot, g, this._sourceMapURL));
        var v = r.getArg(h, "name", null);
        return v !== null && (v = this._names.at(v)), {
          source: g,
          line: r.getArg(h, "originalLine", null),
          column: r.getArg(h, "originalColumn", null),
          name: v
        };
      }
    }
    return {
      source: null,
      line: null,
      column: null,
      name: null
    };
  }, s.prototype.hasContentsOfAllSources = function() {
    return this.sourcesContent ? this.sourcesContent.length >= this._sources.size() && !this.sourcesContent.some(function(c) {
      return c == null;
    }) : !1;
  }, s.prototype.sourceContentFor = function(c, d) {
    if (!this.sourcesContent)
      return null;
    var f = this._findSourceIndex(c);
    if (f >= 0)
      return this.sourcesContent[f];
    var h = c;
    this.sourceRoot != null && (h = r.relative(this.sourceRoot, h));
    var g;
    if (this.sourceRoot != null && (g = r.urlParse(this.sourceRoot))) {
      var v = h.replace(/^file:\/\//, "");
      if (g.scheme == "file" && this._sources.has(v))
        return this.sourcesContent[this._sources.indexOf(v)];
      if ((!g.path || g.path == "/") && this._sources.has("/" + h))
        return this.sourcesContent[this._sources.indexOf("/" + h)];
    }
    if (d)
      return null;
    throw new Error('"' + h + '" is not in the SourceMap.');
  }, s.prototype.generatedPositionFor = function(c) {
    var d = r.getArg(c, "source");
    if (d = this._findSourceIndex(d), d < 0)
      return {
        line: null,
        column: null,
        lastColumn: null
      };
    var f = {
      source: d,
      originalLine: r.getArg(c, "line"),
      originalColumn: r.getArg(c, "column")
    }, h = this._findMapping(
      f,
      this._originalMappings,
      "originalLine",
      "originalColumn",
      r.compareByOriginalPositions,
      r.getArg(c, "bias", a.GREATEST_LOWER_BOUND)
    );
    if (h >= 0) {
      var g = this._originalMappings[h];
      if (g.source === f.source)
        return {
          line: r.getArg(g, "generatedLine", null),
          column: r.getArg(g, "generatedColumn", null),
          lastColumn: r.getArg(g, "lastGeneratedColumn", null)
        };
    }
    return {
      line: null,
      column: null,
      lastColumn: null
    };
  }, df.BasicSourceMapConsumer = s;
  function l(u, c) {
    var d = u;
    typeof u == "string" && (d = r.parseSourceMapInput(u));
    var f = r.getArg(d, "version"), h = r.getArg(d, "sections");
    if (f != this._version)
      throw new Error("Unsupported version: " + f);
    this._sources = new t(), this._names = new t();
    var g = {
      line: -1,
      column: 0
    };
    this._sections = h.map(function(v) {
      if (v.url)
        throw new Error("Support for url field in sections not implemented.");
      var y = r.getArg(v, "offset"), A = r.getArg(y, "line"), x = r.getArg(y, "column");
      if (A < g.line || A === g.line && x < g.column)
        throw new Error("Section offsets must be ordered and non-overlapping.");
      return g = y, {
        generatedOffset: {
          // The offset fields are 0-based, but we use 1-based indices when
          // encoding/decoding from VLQ.
          generatedLine: A + 1,
          generatedColumn: x + 1
        },
        consumer: new a(r.getArg(v, "map"), c)
      };
    });
  }
  return l.prototype = Object.create(a.prototype), l.prototype.constructor = a, l.prototype._version = 3, Object.defineProperty(l.prototype, "sources", {
    get: function() {
      for (var u = [], c = 0; c < this._sections.length; c++)
        for (var d = 0; d < this._sections[c].consumer.sources.length; d++)
          u.push(this._sections[c].consumer.sources[d]);
      return u;
    }
  }), l.prototype.originalPositionFor = function(c) {
    var d = {
      generatedLine: r.getArg(c, "line"),
      generatedColumn: r.getArg(c, "column")
    }, f = e.search(
      d,
      this._sections,
      function(g, v) {
        var y = g.generatedLine - v.generatedOffset.generatedLine;
        return y || g.generatedColumn - v.generatedOffset.generatedColumn;
      }
    ), h = this._sections[f];
    return h ? h.consumer.originalPositionFor({
      line: d.generatedLine - (h.generatedOffset.generatedLine - 1),
      column: d.generatedColumn - (h.generatedOffset.generatedLine === d.generatedLine ? h.generatedOffset.generatedColumn - 1 : 0),
      bias: c.bias
    }) : {
      source: null,
      line: null,
      column: null,
      name: null
    };
  }, l.prototype.hasContentsOfAllSources = function() {
    return this._sections.every(function(c) {
      return c.consumer.hasContentsOfAllSources();
    });
  }, l.prototype.sourceContentFor = function(c, d) {
    for (var f = 0; f < this._sections.length; f++) {
      var h = this._sections[f], g = h.consumer.sourceContentFor(c, !0);
      if (g)
        return g;
    }
    if (d)
      return null;
    throw new Error('"' + c + '" is not in the SourceMap.');
  }, l.prototype.generatedPositionFor = function(c) {
    for (var d = 0; d < this._sections.length; d++) {
      var f = this._sections[d];
      if (f.consumer._findSourceIndex(r.getArg(c, "source")) !== -1) {
        var h = f.consumer.generatedPositionFor(c);
        if (h) {
          var g = {
            line: h.line + (f.generatedOffset.generatedLine - 1),
            column: h.column + (f.generatedOffset.generatedLine === h.line ? f.generatedOffset.generatedColumn - 1 : 0)
          };
          return g;
        }
      }
    }
    return {
      line: null,
      column: null
    };
  }, l.prototype._parseMappings = function(c, d) {
    this.__generatedMappings = [], this.__originalMappings = [];
    for (var f = 0; f < this._sections.length; f++)
      for (var h = this._sections[f], g = h.consumer._generatedMappings, v = 0; v < g.length; v++) {
        var y = g[v], A = h.consumer._sources.at(y.source);
        A = r.computeSourceURL(h.consumer.sourceRoot, A, this._sourceMapURL), this._sources.add(A), A = this._sources.indexOf(A);
        var x = null;
        y.name && (x = h.consumer._names.at(y.name), this._names.add(x), x = this._names.indexOf(x));
        var k = {
          source: A,
          generatedLine: y.generatedLine + (h.generatedOffset.generatedLine - 1),
          generatedColumn: y.generatedColumn + (h.generatedOffset.generatedLine === y.generatedLine ? h.generatedOffset.generatedColumn - 1 : 0),
          originalLine: y.originalLine,
          originalColumn: y.originalColumn,
          name: x
        };
        this.__generatedMappings.push(k), typeof k.originalLine == "number" && this.__originalMappings.push(k);
      }
    i(this.__generatedMappings, r.compareByGeneratedPositionsDeflated), i(this.__originalMappings, r.compareByOriginalPositions);
  }, df.IndexedSourceMapConsumer = l, df;
}
var O0 = {}, aS;
function D8() {
  if (aS) return O0;
  aS = 1;
  var r = gF().SourceMapGenerator, e = Ld(), t = /(\r?\n)/, n = 10, i = "$$$isSourceNode$$$";
  function a(s, o, l, u, c) {
    this.children = [], this.sourceContents = {}, this.line = s ?? null, this.column = o ?? null, this.source = l ?? null, this.name = c ?? null, this[i] = !0, u != null && this.add(u);
  }
  return a.fromStringWithSourceMap = function(o, l, u) {
    var c = new a(), d = o.split(t), f = 0, h = function() {
      var x = F(), k = F() || "";
      return x + k;
      function F() {
        return f < d.length ? d[f++] : void 0;
      }
    }, g = 1, v = 0, y = null;
    return l.eachMapping(function(x) {
      if (y !== null)
        if (g < x.generatedLine)
          A(y, h()), g++, v = 0;
        else {
          var k = d[f] || "", F = k.substr(0, x.generatedColumn - v);
          d[f] = k.substr(x.generatedColumn - v), v = x.generatedColumn, A(y, F), y = x;
          return;
        }
      for (; g < x.generatedLine; )
        c.add(h()), g++;
      if (v < x.generatedColumn) {
        var k = d[f] || "";
        c.add(k.substr(0, x.generatedColumn)), d[f] = k.substr(x.generatedColumn), v = x.generatedColumn;
      }
      y = x;
    }, this), f < d.length && (y && A(y, h()), c.add(d.splice(f).join(""))), l.sources.forEach(function(x) {
      var k = l.sourceContentFor(x);
      k != null && (u != null && (x = e.join(u, x)), c.setSourceContent(x, k));
    }), c;
    function A(x, k) {
      if (x === null || x.source === void 0)
        c.add(k);
      else {
        var F = u ? e.join(u, x.source) : x.source;
        c.add(new a(
          x.originalLine,
          x.originalColumn,
          F,
          k,
          x.name
        ));
      }
    }
  }, a.prototype.add = function(o) {
    if (Array.isArray(o))
      o.forEach(function(l) {
        this.add(l);
      }, this);
    else if (o[i] || typeof o == "string")
      o && this.children.push(o);
    else
      throw new TypeError(
        "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + o
      );
    return this;
  }, a.prototype.prepend = function(o) {
    if (Array.isArray(o))
      for (var l = o.length - 1; l >= 0; l--)
        this.prepend(o[l]);
    else if (o[i] || typeof o == "string")
      this.children.unshift(o);
    else
      throw new TypeError(
        "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + o
      );
    return this;
  }, a.prototype.walk = function(o) {
    for (var l, u = 0, c = this.children.length; u < c; u++)
      l = this.children[u], l[i] ? l.walk(o) : l !== "" && o(l, {
        source: this.source,
        line: this.line,
        column: this.column,
        name: this.name
      });
  }, a.prototype.join = function(o) {
    var l, u, c = this.children.length;
    if (c > 0) {
      for (l = [], u = 0; u < c - 1; u++)
        l.push(this.children[u]), l.push(o);
      l.push(this.children[u]), this.children = l;
    }
    return this;
  }, a.prototype.replaceRight = function(o, l) {
    var u = this.children[this.children.length - 1];
    return u[i] ? u.replaceRight(o, l) : typeof u == "string" ? this.children[this.children.length - 1] = u.replace(o, l) : this.children.push("".replace(o, l)), this;
  }, a.prototype.setSourceContent = function(o, l) {
    this.sourceContents[e.toSetString(o)] = l;
  }, a.prototype.walkSourceContents = function(o) {
    for (var l = 0, u = this.children.length; l < u; l++)
      this.children[l][i] && this.children[l].walkSourceContents(o);
    for (var c = Object.keys(this.sourceContents), l = 0, u = c.length; l < u; l++)
      o(e.fromSetString(c[l]), this.sourceContents[c[l]]);
  }, a.prototype.toString = function() {
    var o = "";
    return this.walk(function(l) {
      o += l;
    }), o;
  }, a.prototype.toStringWithSourceMap = function(o) {
    var l = {
      code: "",
      line: 1,
      column: 0
    }, u = new r(o), c = !1, d = null, f = null, h = null, g = null;
    return this.walk(function(v, y) {
      l.code += v, y.source !== null && y.line !== null && y.column !== null ? ((d !== y.source || f !== y.line || h !== y.column || g !== y.name) && u.addMapping({
        source: y.source,
        original: {
          line: y.line,
          column: y.column
        },
        generated: {
          line: l.line,
          column: l.column
        },
        name: y.name
      }), d = y.source, f = y.line, h = y.column, g = y.name, c = !0) : c && (u.addMapping({
        generated: {
          line: l.line,
          column: l.column
        }
      }), d = null, c = !1);
      for (var A = 0, x = v.length; A < x; A++)
        v.charCodeAt(A) === n ? (l.line++, l.column = 0, A + 1 === x ? (d = null, c = !1) : c && u.addMapping({
          source: y.source,
          original: {
            line: y.line,
            column: y.column
          },
          generated: {
            line: l.line,
            column: l.column
          },
          name: y.name
        })) : l.column++;
    }), this.walkSourceContents(function(v, y) {
      u.setSourceContent(v, y);
    }), { code: l.code, map: u };
  }, O0.SourceNode = a, O0;
}
var sS;
function P8() {
  return sS || (sS = 1, ff.SourceMapGenerator = gF().SourceMapGenerator, ff.SourceMapConsumer = I8().SourceMapConsumer, ff.SourceNode = D8().SourceNode), ff;
}
var oS;
function R8() {
  return oS || (oS = 1, (function(r, e) {
    e.__esModule = !0;
    var t = Gi(), n = void 0;
    try {
      var i = P8();
      n = i.SourceNode;
    } catch {
    }
    n || (n = function(o, l, u, c) {
      this.src = "", c && this.add(c);
    }, n.prototype = {
      add: function(l) {
        t.isArray(l) && (l = l.join("")), this.src += l;
      },
      prepend: function(l) {
        t.isArray(l) && (l = l.join("")), this.src = l + this.src;
      },
      toStringWithSourceMap: function() {
        return { code: this.toString() };
      },
      toString: function() {
        return this.src;
      }
    });
    function a(o, l, u) {
      if (t.isArray(o)) {
        for (var c = [], d = 0, f = o.length; d < f; d++)
          c.push(l.wrap(o[d], u));
        return c;
      } else if (typeof o == "boolean" || typeof o == "number")
        return o + "";
      return o;
    }
    function s(o) {
      this.srcFile = o, this.source = [];
    }
    s.prototype = {
      isEmpty: function() {
        return !this.source.length;
      },
      prepend: function(l, u) {
        this.source.unshift(this.wrap(l, u));
      },
      push: function(l, u) {
        this.source.push(this.wrap(l, u));
      },
      merge: function() {
        var l = this.empty();
        return this.each(function(u) {
          l.add(["  ", u, `
`]);
        }), l;
      },
      each: function(l) {
        for (var u = 0, c = this.source.length; u < c; u++)
          l(this.source[u]);
      },
      empty: function() {
        var l = this.currentLocation || { start: {} };
        return new n(l.start.line, l.start.column, this.srcFile);
      },
      wrap: function(l) {
        var u = arguments.length <= 1 || arguments[1] === void 0 ? this.currentLocation || { start: {} } : arguments[1];
        return l instanceof n ? l : (l = a(l, this, u), new n(u.start.line, u.start.column, this.srcFile, l));
      },
      functionCall: function(l, u, c) {
        return c = this.generateList(c), this.wrap([l, u ? "." + u + "(" : "(", c, ")"]);
      },
      quotedString: function(l) {
        return '"' + (l + "").replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029") + '"';
      },
      objectLiteral: function(l) {
        var u = this, c = [];
        Object.keys(l).forEach(function(f) {
          var h = a(l[f], u);
          h !== "undefined" && c.push([u.quotedString(f), ":", h]);
        });
        var d = this.generateList(c);
        return d.prepend("{"), d.add("}"), d;
      },
      generateList: function(l) {
        for (var u = this.empty(), c = 0, d = l.length; c < d; c++)
          c && u.add(","), u.add(a(l[c], this));
        return u;
      },
      generateArray: function(l) {
        var u = this.generateList(l);
        return u.prepend("["), u.add("]"), u;
      }
    }, e.default = s, r.exports = e.default;
  })(lp, lp.exports)), lp.exports;
}
var lS;
function O8() {
  return lS || (lS = 1, (function(r, e) {
    e.__esModule = !0;
    function t(f) {
      return f && f.__esModule ? f : { default: f };
    }
    var n = u1(), i = ma(), a = t(i), s = Gi(), o = R8(), l = t(o);
    function u(f) {
      this.value = f;
    }
    function c() {
    }
    c.prototype = {
      // PUBLIC API: You can override these methods in a subclass to provide
      // alternative compiled forms for name lookup and buffering semantics
      nameLookup: function(h, g) {
        return this.internalNameLookup(h, g);
      },
      depthedLookup: function(h) {
        return [this.aliasable("container.lookup"), "(depths, ", JSON.stringify(h), ")"];
      },
      compilerInfo: function() {
        var h = n.COMPILER_REVISION, g = n.REVISION_CHANGES[h];
        return [h, g];
      },
      appendToBuffer: function(h, g, v) {
        return s.isArray(h) || (h = [h]), h = this.source.wrap(h, g), this.environment.isSimple ? ["return ", h, ";"] : v ? ["buffer += ", h, ";"] : (h.appendToBuffer = !0, h);
      },
      initializeBuffer: function() {
        return this.quotedString("");
      },
      // END PUBLIC API
      internalNameLookup: function(h, g) {
        return this.lookupPropertyFunctionIsUsed = !0, ["lookupProperty(", h, ",", JSON.stringify(g), ")"];
      },
      lookupPropertyFunctionIsUsed: !1,
      compile: function(h, g, v, y) {
        this.environment = h, this.options = g, this.stringParams = this.options.stringParams, this.trackIds = this.options.trackIds, this.precompile = !y, this.name = this.environment.name, this.isChild = !!v, this.context = v || {
          decorators: [],
          programs: [],
          environments: []
        }, this.preamble(), this.stackSlot = 0, this.stackVars = [], this.aliases = {}, this.registers = { list: [] }, this.hashes = [], this.compileStack = [], this.inlineStack = [], this.blockParams = [], this.compileChildren(h, g), this.useDepths = this.useDepths || h.useDepths || h.useDecorators || this.options.compat, this.useBlockParams = this.useBlockParams || h.useBlockParams;
        var A = h.opcodes, x = void 0, k = void 0, F = void 0, S = void 0;
        for (F = 0, S = A.length; F < S; F++)
          x = A[F], this.source.currentLocation = x.loc, k = k || x.loc, this[x.opcode].apply(this, x.args);
        if (this.source.currentLocation = k, this.pushSource(""), this.stackSlot || this.inlineStack.length || this.compileStack.length)
          throw new a.default("Compile completed with content left on stack");
        this.decorators.isEmpty() ? this.decorators = void 0 : (this.useDecorators = !0, this.decorators.prepend(["var decorators = container.decorators, ", this.lookupPropertyFunctionVarDeclaration(), `;
`]), this.decorators.push("return fn;"), y ? this.decorators = Function.apply(this, ["fn", "props", "container", "depth0", "data", "blockParams", "depths", this.decorators.merge()]) : (this.decorators.prepend(`function(fn, props, container, depth0, data, blockParams, depths) {
`), this.decorators.push(`}
`), this.decorators = this.decorators.merge()));
        var R = this.createFunctionContext(y);
        if (this.isChild)
          return R;
        var M = {
          compiler: this.compilerInfo(),
          main: R
        };
        this.decorators && (M.main_d = this.decorators, M.useDecorators = !0);
        var j = this.context, G = j.programs, ie = j.decorators;
        for (F = 0, S = G.length; F < S; F++)
          M[F] = G[F], ie[F] && (M[F + "_d"] = ie[F], M.useDecorators = !0);
        return this.environment.usePartial && (M.usePartial = !0), this.options.data && (M.useData = !0), this.useDepths && (M.useDepths = !0), this.useBlockParams && (M.useBlockParams = !0), this.options.compat && (M.compat = !0), y ? M.compilerOptions = this.options : (M.compiler = JSON.stringify(M.compiler), this.source.currentLocation = { start: { line: 1, column: 0 } }, M = this.objectLiteral(M), g.srcName ? (M = M.toStringWithSourceMap({ file: g.destName }), M.map = M.map && M.map.toString()) : M = M.toString()), M;
      },
      preamble: function() {
        this.lastContext = 0, this.source = new l.default(this.options.srcName), this.decorators = new l.default(this.options.srcName);
      },
      createFunctionContext: function(h) {
        var g = this, v = "", y = this.stackVars.concat(this.registers.list);
        y.length > 0 && (v += ", " + y.join(", "));
        var A = 0;
        Object.keys(this.aliases).forEach(function(F) {
          var S = g.aliases[F];
          S.children && S.referenceCount > 1 && (v += ", alias" + ++A + "=" + F, S.children[0] = "alias" + A);
        }), this.lookupPropertyFunctionIsUsed && (v += ", " + this.lookupPropertyFunctionVarDeclaration());
        var x = ["container", "depth0", "helpers", "partials", "data"];
        (this.useBlockParams || this.useDepths) && x.push("blockParams"), this.useDepths && x.push("depths");
        var k = this.mergeSource(v);
        return h ? (x.push(k), Function.apply(this, x)) : this.source.wrap(["function(", x.join(","), `) {
  `, k, "}"]);
      },
      mergeSource: function(h) {
        var g = this.environment.isSimple, v = !this.forceBuffer, y = void 0, A = void 0, x = void 0, k = void 0;
        return this.source.each(function(F) {
          F.appendToBuffer ? (x ? F.prepend("  + ") : x = F, k = F) : (x && (A ? x.prepend("buffer += ") : y = !0, k.add(";"), x = k = void 0), A = !0, g || (v = !1));
        }), v ? x ? (x.prepend("return "), k.add(";")) : A || this.source.push('return "";') : (h += ", buffer = " + (y ? "" : this.initializeBuffer()), x ? (x.prepend("return buffer + "), k.add(";")) : this.source.push("return buffer;")), h && this.source.prepend("var " + h.substring(2) + (y ? "" : `;
`)), this.source.merge();
      },
      lookupPropertyFunctionVarDeclaration: function() {
        return `
      lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }
    `.trim();
      },
      // [blockValue]
      //
      // On stack, before: hash, inverse, program, value
      // On stack, after: return value of blockHelperMissing
      //
      // The purpose of this opcode is to take a block of the form
      // `{{#this.foo}}...{{/this.foo}}`, resolve the value of `foo`, and
      // replace it on the stack with the result of properly
      // invoking blockHelperMissing.
      blockValue: function(h) {
        var g = this.aliasable("container.hooks.blockHelperMissing"), v = [this.contextName(0)];
        this.setupHelperArgs(h, 0, v);
        var y = this.popStack();
        v.splice(1, 0, y), this.push(this.source.functionCall(g, "call", v));
      },
      // [ambiguousBlockValue]
      //
      // On stack, before: hash, inverse, program, value
      // Compiler value, before: lastHelper=value of last found helper, if any
      // On stack, after, if no lastHelper: same as [blockValue]
      // On stack, after, if lastHelper: value
      ambiguousBlockValue: function() {
        var h = this.aliasable("container.hooks.blockHelperMissing"), g = [this.contextName(0)];
        this.setupHelperArgs("", 0, g, !0), this.flushInline();
        var v = this.topStack();
        g.splice(1, 0, v), this.pushSource(["if (!", this.lastHelper, ") { ", v, " = ", this.source.functionCall(h, "call", g), "}"]);
      },
      // [appendContent]
      //
      // On stack, before: ...
      // On stack, after: ...
      //
      // Appends the string value of `content` to the current buffer
      appendContent: function(h) {
        this.pendingContent ? h = this.pendingContent + h : this.pendingLocation = this.source.currentLocation, this.pendingContent = h;
      },
      // [append]
      //
      // On stack, before: value, ...
      // On stack, after: ...
      //
      // Coerces `value` to a String and appends it to the current buffer.
      //
      // If `value` is truthy, or 0, it is coerced into a string and appended
      // Otherwise, the empty string is appended
      append: function() {
        if (this.isInline())
          this.replaceStack(function(g) {
            return [" != null ? ", g, ' : ""'];
          }), this.pushSource(this.appendToBuffer(this.popStack()));
        else {
          var h = this.popStack();
          this.pushSource(["if (", h, " != null) { ", this.appendToBuffer(h, void 0, !0), " }"]), this.environment.isSimple && this.pushSource(["else { ", this.appendToBuffer("''", void 0, !0), " }"]);
        }
      },
      // [appendEscaped]
      //
      // On stack, before: value, ...
      // On stack, after: ...
      //
      // Escape `value` and append it to the buffer
      appendEscaped: function() {
        this.pushSource(this.appendToBuffer([this.aliasable("container.escapeExpression"), "(", this.popStack(), ")"]));
      },
      // [getContext]
      //
      // On stack, before: ...
      // On stack, after: ...
      // Compiler value, after: lastContext=depth
      //
      // Set the value of the `lastContext` compiler value to the depth
      getContext: function(h) {
        this.lastContext = h;
      },
      // [pushContext]
      //
      // On stack, before: ...
      // On stack, after: currentContext, ...
      //
      // Pushes the value of the current context onto the stack.
      pushContext: function() {
        this.pushStackLiteral(this.contextName(this.lastContext));
      },
      // [lookupOnContext]
      //
      // On stack, before: ...
      // On stack, after: currentContext[name], ...
      //
      // Looks up the value of `name` on the current context and pushes
      // it onto the stack.
      lookupOnContext: function(h, g, v, y) {
        var A = 0;
        !y && this.options.compat && !this.lastContext ? this.push(this.depthedLookup(h[A++])) : this.pushContext(), this.resolvePath("context", h, A, g, v);
      },
      // [lookupBlockParam]
      //
      // On stack, before: ...
      // On stack, after: blockParam[name], ...
      //
      // Looks up the value of `parts` on the given block param and pushes
      // it onto the stack.
      lookupBlockParam: function(h, g) {
        this.useBlockParams = !0, this.push(["blockParams[", h[0], "][", h[1], "]"]), this.resolvePath("context", g, 1);
      },
      // [lookupData]
      //
      // On stack, before: ...
      // On stack, after: data, ...
      //
      // Push the data lookup operator
      lookupData: function(h, g, v) {
        h ? this.pushStackLiteral("container.data(data, " + h + ")") : this.pushStackLiteral("data"), this.resolvePath("data", g, 0, !0, v);
      },
      resolvePath: function(h, g, v, y, A) {
        var x = this;
        if (this.options.strict || this.options.assumeObjects) {
          this.push(d(this.options.strict && A, this, g, v, h));
          return;
        }
        for (var k = g.length, F = function(R) {
          x.replaceStack(function(M) {
            var j = x.nameLookup(M, g[R], h);
            return y ? [" && ", j] : [" != null ? ", j, " : ", M];
          });
        }, S = v; S < k; S++)
          F(S);
      },
      // [resolvePossibleLambda]
      //
      // On stack, before: value, ...
      // On stack, after: resolved value, ...
      //
      // If the `value` is a lambda, replace it on the stack by
      // the return value of the lambda
      resolvePossibleLambda: function() {
        this.push([this.aliasable("container.lambda"), "(", this.popStack(), ", ", this.contextName(0), ")"]);
      },
      // [pushStringParam]
      //
      // On stack, before: ...
      // On stack, after: string, currentContext, ...
      //
      // This opcode is designed for use in string mode, which
      // provides the string value of a parameter along with its
      // depth rather than resolving it immediately.
      pushStringParam: function(h, g) {
        this.pushContext(), this.pushString(g), g !== "SubExpression" && (typeof h == "string" ? this.pushString(h) : this.pushStackLiteral(h));
      },
      emptyHash: function(h) {
        this.trackIds && this.push("{}"), this.stringParams && (this.push("{}"), this.push("{}")), this.pushStackLiteral(h ? "undefined" : "{}");
      },
      pushHash: function() {
        this.hash && this.hashes.push(this.hash), this.hash = { values: {}, types: [], contexts: [], ids: [] };
      },
      popHash: function() {
        var h = this.hash;
        this.hash = this.hashes.pop(), this.trackIds && this.push(this.objectLiteral(h.ids)), this.stringParams && (this.push(this.objectLiteral(h.contexts)), this.push(this.objectLiteral(h.types))), this.push(this.objectLiteral(h.values));
      },
      // [pushString]
      //
      // On stack, before: ...
      // On stack, after: quotedString(string), ...
      //
      // Push a quoted version of `string` onto the stack
      pushString: function(h) {
        this.pushStackLiteral(this.quotedString(h));
      },
      // [pushLiteral]
      //
      // On stack, before: ...
      // On stack, after: value, ...
      //
      // Pushes a value onto the stack. This operation prevents
      // the compiler from creating a temporary variable to hold
      // it.
      pushLiteral: function(h) {
        this.pushStackLiteral(h);
      },
      // [pushProgram]
      //
      // On stack, before: ...
      // On stack, after: program(guid), ...
      //
      // Push a program expression onto the stack. This takes
      // a compile-time guid and converts it into a runtime-accessible
      // expression.
      pushProgram: function(h) {
        h != null ? this.pushStackLiteral(this.programExpression(h)) : this.pushStackLiteral(null);
      },
      // [registerDecorator]
      //
      // On stack, before: hash, program, params..., ...
      // On stack, after: ...
      //
      // Pops off the decorator's parameters, invokes the decorator,
      // and inserts the decorator into the decorators list.
      registerDecorator: function(h, g) {
        var v = this.nameLookup("decorators", g, "decorator"), y = this.setupHelperArgs(g, h);
        this.decorators.push(["var decorator = ", v, ";"]), this.decorators.push(['if (typeof decorator !== "function") { throw new Error(', this.quotedString('Missing decorator: "' + g + '"'), "); }"]), this.decorators.push(["fn = ", this.decorators.functionCall("decorator", "", ["fn", "props", "container", y]), " || fn;"]);
      },
      // [invokeHelper]
      //
      // On stack, before: hash, inverse, program, params..., ...
      // On stack, after: result of helper invocation
      //
      // Pops off the helper's parameters, invokes the helper,
      // and pushes the helper's return value onto the stack.
      //
      // If the helper is not found, `helperMissing` is called.
      invokeHelper: function(h, g, v) {
        var y = this.popStack(), A = this.setupHelper(h, g), x = [];
        v && x.push(A.name), x.push(y), this.options.strict || x.push(this.aliasable("container.hooks.helperMissing"));
        var k = ["(", this.itemsSeparatedBy(x, "||"), ")"], F = this.source.functionCall(k, "call", A.callParams);
        this.push(F);
      },
      itemsSeparatedBy: function(h, g) {
        var v = [];
        v.push(h[0]);
        for (var y = 1; y < h.length; y++)
          v.push(g, h[y]);
        return v;
      },
      // [invokeKnownHelper]
      //
      // On stack, before: hash, inverse, program, params..., ...
      // On stack, after: result of helper invocation
      //
      // This operation is used when the helper is known to exist,
      // so a `helperMissing` fallback is not required.
      invokeKnownHelper: function(h, g) {
        var v = this.setupHelper(h, g);
        this.push(this.source.functionCall(v.name, "call", v.callParams));
      },
      // [invokeAmbiguous]
      //
      // On stack, before: hash, inverse, program, params..., ...
      // On stack, after: result of disambiguation
      //
      // This operation is used when an expression like `{{foo}}`
      // is provided, but we don't know at compile-time whether it
      // is a helper or a path.
      //
      // This operation emits more code than the other options,
      // and can be avoided by passing the `knownHelpers` and
      // `knownHelpersOnly` flags at compile-time.
      invokeAmbiguous: function(h, g) {
        this.useRegister("helper");
        var v = this.popStack();
        this.emptyHash();
        var y = this.setupHelper(0, h, g), A = this.lastHelper = this.nameLookup("helpers", h, "helper"), x = ["(", "(helper = ", A, " || ", v, ")"];
        this.options.strict || (x[0] = "(helper = ", x.push(" != null ? helper : ", this.aliasable("container.hooks.helperMissing"))), this.push(["(", x, y.paramsInit ? ["),(", y.paramsInit] : [], "),", "(typeof helper === ", this.aliasable('"function"'), " ? ", this.source.functionCall("helper", "call", y.callParams), " : helper))"]);
      },
      // [invokePartial]
      //
      // On stack, before: context, ...
      // On stack after: result of partial invocation
      //
      // This operation pops off a context, invokes a partial with that context,
      // and pushes the result of the invocation back.
      invokePartial: function(h, g, v) {
        var y = [], A = this.setupParams(g, 1, y);
        h && (g = this.popStack(), delete A.name), v && (A.indent = JSON.stringify(v)), A.helpers = "helpers", A.partials = "partials", A.decorators = "container.decorators", h ? y.unshift(g) : y.unshift(this.nameLookup("partials", g, "partial")), this.options.compat && (A.depths = "depths"), A = this.objectLiteral(A), y.push(A), this.push(this.source.functionCall("container.invokePartial", "", y));
      },
      // [assignToHash]
      //
      // On stack, before: value, ..., hash, ...
      // On stack, after: ..., hash, ...
      //
      // Pops a value off the stack and assigns it to the current hash
      assignToHash: function(h) {
        var g = this.popStack(), v = void 0, y = void 0, A = void 0;
        this.trackIds && (A = this.popStack()), this.stringParams && (y = this.popStack(), v = this.popStack());
        var x = this.hash;
        v && (x.contexts[h] = v), y && (x.types[h] = y), A && (x.ids[h] = A), x.values[h] = g;
      },
      pushId: function(h, g, v) {
        h === "BlockParam" ? this.pushStackLiteral("blockParams[" + g[0] + "].path[" + g[1] + "]" + (v ? " + " + JSON.stringify("." + v) : "")) : h === "PathExpression" ? this.pushString(g) : h === "SubExpression" ? this.pushStackLiteral("true") : this.pushStackLiteral("null");
      },
      // HELPERS
      compiler: c,
      compileChildren: function(h, g) {
        for (var v = h.children, y = void 0, A = void 0, x = 0, k = v.length; x < k; x++) {
          y = v[x], A = new this.compiler();
          var F = this.matchExistingProgram(y);
          if (F == null) {
            var S = this.context.programs.push("") - 1;
            y.index = S, y.name = "program" + S, this.context.programs[S] = A.compile(y, g, this.context, !this.precompile), this.context.decorators[S] = A.decorators, this.context.environments[S] = y, this.useDepths = this.useDepths || A.useDepths, this.useBlockParams = this.useBlockParams || A.useBlockParams, y.useDepths = this.useDepths, y.useBlockParams = this.useBlockParams;
          } else
            y.index = F.index, y.name = "program" + F.index, this.useDepths = this.useDepths || F.useDepths, this.useBlockParams = this.useBlockParams || F.useBlockParams;
        }
      },
      matchExistingProgram: function(h) {
        for (var g = 0, v = this.context.environments.length; g < v; g++) {
          var y = this.context.environments[g];
          if (y && y.equals(h))
            return y;
        }
      },
      programExpression: function(h) {
        var g = this.environment.children[h], v = [g.index, "data", g.blockParams];
        return (this.useBlockParams || this.useDepths) && v.push("blockParams"), this.useDepths && v.push("depths"), "container.program(" + v.join(", ") + ")";
      },
      useRegister: function(h) {
        this.registers[h] || (this.registers[h] = !0, this.registers.list.push(h));
      },
      push: function(h) {
        return h instanceof u || (h = this.source.wrap(h)), this.inlineStack.push(h), h;
      },
      pushStackLiteral: function(h) {
        this.push(new u(h));
      },
      pushSource: function(h) {
        this.pendingContent && (this.source.push(this.appendToBuffer(this.source.quotedString(this.pendingContent), this.pendingLocation)), this.pendingContent = void 0), h && this.source.push(h);
      },
      replaceStack: function(h) {
        var g = ["("], v = void 0, y = void 0, A = void 0;
        if (!this.isInline())
          throw new a.default("replaceStack on non-inline");
        var x = this.popStack(!0);
        if (x instanceof u)
          v = [x.value], g = ["(", v], A = !0;
        else {
          y = !0;
          var k = this.incrStack();
          g = ["((", this.push(k), " = ", x, ")"], v = this.topStack();
        }
        var F = h.call(this, v);
        A || this.popStack(), y && this.stackSlot--, this.push(g.concat(F, ")"));
      },
      incrStack: function() {
        return this.stackSlot++, this.stackSlot > this.stackVars.length && this.stackVars.push("stack" + this.stackSlot), this.topStackName();
      },
      topStackName: function() {
        return "stack" + this.stackSlot;
      },
      flushInline: function() {
        var h = this.inlineStack;
        this.inlineStack = [];
        for (var g = 0, v = h.length; g < v; g++) {
          var y = h[g];
          if (y instanceof u)
            this.compileStack.push(y);
          else {
            var A = this.incrStack();
            this.pushSource([A, " = ", y, ";"]), this.compileStack.push(A);
          }
        }
      },
      isInline: function() {
        return this.inlineStack.length;
      },
      popStack: function(h) {
        var g = this.isInline(), v = (g ? this.inlineStack : this.compileStack).pop();
        if (!h && v instanceof u)
          return v.value;
        if (!g) {
          if (!this.stackSlot)
            throw new a.default("Invalid stack pop");
          this.stackSlot--;
        }
        return v;
      },
      topStack: function() {
        var h = this.isInline() ? this.inlineStack : this.compileStack, g = h[h.length - 1];
        return g instanceof u ? g.value : g;
      },
      contextName: function(h) {
        return this.useDepths && h ? "depths[" + h + "]" : "depth" + h;
      },
      quotedString: function(h) {
        return this.source.quotedString(h);
      },
      objectLiteral: function(h) {
        return this.source.objectLiteral(h);
      },
      aliasable: function(h) {
        var g = this.aliases[h];
        return g ? (g.referenceCount++, g) : (g = this.aliases[h] = this.source.wrap(h), g.aliasable = !0, g.referenceCount = 1, g);
      },
      setupHelper: function(h, g, v) {
        var y = [], A = this.setupHelperArgs(g, h, y, v), x = this.nameLookup("helpers", g, "helper"), k = this.aliasable(this.contextName(0) + " != null ? " + this.contextName(0) + " : (container.nullContext || {})");
        return {
          params: y,
          paramsInit: A,
          name: x,
          callParams: [k].concat(y)
        };
      },
      setupParams: function(h, g, v) {
        var y = {}, A = [], x = [], k = [], F = !v, S = void 0;
        F && (v = []), y.name = this.quotedString(h), y.hash = this.popStack(), this.trackIds && (y.hashIds = this.popStack()), this.stringParams && (y.hashTypes = this.popStack(), y.hashContexts = this.popStack());
        var R = this.popStack(), M = this.popStack();
        (M || R) && (y.fn = M || "container.noop", y.inverse = R || "container.noop");
        for (var j = g; j--; )
          S = this.popStack(), v[j] = S, this.trackIds && (k[j] = this.popStack()), this.stringParams && (x[j] = this.popStack(), A[j] = this.popStack());
        return F && (y.args = this.source.generateArray(v)), this.trackIds && (y.ids = this.source.generateArray(k)), this.stringParams && (y.types = this.source.generateArray(x), y.contexts = this.source.generateArray(A)), this.options.data && (y.data = "data"), this.useBlockParams && (y.blockParams = "blockParams"), y;
      },
      setupHelperArgs: function(h, g, v, y) {
        var A = this.setupParams(h, g, v);
        return A.loc = JSON.stringify(this.source.currentLocation), A = this.objectLiteral(A), y ? (this.useRegister("options"), v.push("options"), ["options=", A]) : v ? (v.push(A), "") : A;
      }
    }, (function() {
      for (var f = "break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield await null true false".split(" "), h = c.RESERVED_WORDS = {}, g = 0, v = f.length; g < v; g++)
        h[f[g]] = !0;
    })(), c.isValidJavaScriptVariableName = function(f) {
      return !c.RESERVED_WORDS[f] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(f);
    };
    function d(f, h, g, v, y) {
      var A = h.popStack(), x = g.length;
      f && x--;
      for (var k = v; k < x; k++)
        A = h.nameLookup(A, g[k], y);
      return f ? [h.aliasable("container.strict"), "(", A, ", ", h.quotedString(g[x]), ", ", JSON.stringify(h.source.currentLocation), " )"] : A;
    }
    e.default = c, r.exports = e.default;
  })(op, op.exports)), op.exports;
}
var uS;
function B8() {
  return uS || (uS = 1, (function(r, e) {
    e.__esModule = !0;
    function t(x) {
      return x && x.__esModule ? x : { default: x };
    }
    var n = A8(), i = t(n), a = fF(), s = t(a), o = C8(), l = S8(), u = O8(), c = t(u), d = dF(), f = t(d), h = cF(), g = t(h), v = i.default.create;
    function y() {
      var x = v();
      return x.compile = function(k, F) {
        return l.compile(k, F, x);
      }, x.precompile = function(k, F) {
        return l.precompile(k, F, x);
      }, x.AST = s.default, x.Compiler = l.Compiler, x.JavaScriptCompiler = c.default, x.Parser = o.parser, x.parse = o.parse, x.parseWithoutProcessing = o.parseWithoutProcessing, x;
    }
    var A = y();
    A.create = y, g.default(A), A.Visitor = f.default, A.default = A, e.default = A, r.exports = e.default;
  })(zh, zh.exports)), zh.exports;
}
var M8 = B8();
const _8 = /* @__PURE__ */ Bs(M8);
function _u(r, e) {
  return mF(r, e.getTemplatingContext());
}
function mF(r, e) {
  try {
    r = _8.compile(r)(e);
  } catch (t) {
    console.error("failed to render templated text", t);
  }
  return r;
}
const N8 = (r) => {
  const t = (r.rotation || 0) * Math.PI / 180, n = Math.cos(t), i = -Math.sin(t), a = `text-path-${r.id}`, s = `text-fill-${r.id}`, o = r.x + (r.curved ? 0 : r.width / 2), l = r.y + (r.curved ? 0 : r.height / 2), u = mF(r.text || "", r._renderingConfiguration?.templatingContext), c = u.split(`
`), d = r.strokeColor?.browserValue && r.strokeThickness ? r.strokeColor?.browserValue : void 0, f = r.strokeColor?.browserValue && r.strokeThickness ? r.strokeThickness : void 0;
  if (r.curved && !r.paths || !r.fontData)
    return null;
  const h = () => r.textFillImage ? `url("#${s}")` : r._renderingConfiguration?.spotColors && r.fillSpotColorDefinition ? `${r.fill} ${_k(r.fillSpotColorDefinition)}` : r.fill;
  return /* @__PURE__ */ At.jsxs(At.Fragment, { children: [
    /* @__PURE__ */ At.jsxs("defs", { children: [
      r.textFillImage && /* @__PURE__ */ At.jsx(
        "pattern",
        {
          id: s,
          patternUnits: "userSpaceOnUse",
          width: r.textFillImage.scale * r.textFillImage.width,
          height: r.textFillImage.scale * r.textFillImage.height,
          x: 0,
          y: 0,
          children: /* @__PURE__ */ At.jsx(
            "image",
            {
              href: r.textFillImage.src,
              xlinkHref: r.textFillImage.src,
              width: r.textFillImage.scale * r.textFillImage.width,
              height: r.textFillImage.scale * r.textFillImage.height
            }
          )
        }
      ),
      /* @__PURE__ */ At.jsx(
        "style",
        {
          type: "text/css",
          dangerouslySetInnerHTML: {
            __html: `
                        @font-face {
                            font-family: '${r.fontData.name}';
                            src: url('${r.fontData.assetUrl}') format('truetype');
                        }
                        `
          }
        }
      ),
      r.curved && r.paths ? /* @__PURE__ */ At.jsx("path", { id: a, d: r.paths[0] }) : void 0
    ] }),
    r._renderingConfiguration?.debug ? /* @__PURE__ */ At.jsx("rect", { stroke: "blue", fill: "none", x: r.x, y: r.y, width: r.width, height: r.height }) : void 0,
    /* @__PURE__ */ At.jsx("g", { mask: r.stepName ? void 0 : r.mask, children: /* @__PURE__ */ At.jsx("g", { transform: `matrix(${n}, ${-i}, ${i}, ${n}, ${o}, ${l})`, children: /* @__PURE__ */ At.jsx(
      "text",
      {
        xmlSpace: "preserve",
        fontFamily: `'${r.fontData.name}'`,
        fontSize: r.fontSize,
        fontStyle: "normal",
        fontWeight: "normal",
        fill: h(),
        style: {
          whiteSpace: "pre",
          userSelect: "none"
        },
        stroke: d,
        strokeWidth: f,
        children: r.curved ? /* @__PURE__ */ At.jsx(U8, { text: u, curvedPathId: a, align: r.align }) : c.map((g, v) => /* @__PURE__ */ At.jsx(
          L8,
          {
            align: r.vertical ? "center" : r.align,
            fontSize: r.fontSize,
            thisLineIdx: v,
            amountLines: c.length,
            text: g,
            textboxHeight: r.height,
            textboxWidth: r.width,
            lineHeight: r.lineHeight,
            vertical: r.vertical,
            verticalAlign: r.verticalAlign,
            fontData: r.fontData
          },
          v
        ))
      }
    ) }) })
  ] });
}, L8 = (r) => {
  const e = () => {
    if (r.lineHeight !== void 0)
      return r.lineHeight * r.fontSize;
    const i = So(r.fontData.assetUrl), a = i.getFont(), s = r.fontSize / a.unitsPerEm;
    return i.getApproximateHeight() * s;
  }, t = () => r.align === "left" ? -r.textboxWidth / 2 : r.align === "right" ? r.textboxWidth / 2 : 0, n = () => {
    const i = e(), a = r.textboxHeight / 2;
    if (r.verticalAlign === "top")
      return -a + r.fontSize * 3 / 4 + r.thisLineIdx * i;
    if (r.verticalAlign === "bottom") {
      const o = r.amountLines - 1 - r.thisLineIdx;
      return a - r.fontSize / 4 - o * i;
    }
    const s = (r.amountLines - 1) / 2;
    return (r.thisLineIdx - s) * i + r.fontSize / 4;
  };
  return /* @__PURE__ */ At.jsx("tspan", { textAnchor: aF(r.align), x: t(), y: `${n()}px`, children: r.text });
}, U8 = (r) => {
  const e = `#${r.curvedPathId}`, t = () => r.align === "left" ? "0%" : r.align === "right" ? "100%" : "50%";
  return /* @__PURE__ */ At.jsx(
    "textPath",
    {
      startOffset: t(),
      textAnchor: aF(r.align),
      href: e,
      xlinkHref: e,
      children: r.text
    }
  );
}, V8 = (r) => {
  if (r.cachedObjectURL && !r._renderingConfiguration?.omitCachedFields)
    return /* @__PURE__ */ At.jsx(
      lT,
      {
        id: r.id,
        src: r.cachedObjectURL,
        x: r.x,
        y: r.y,
        width: r.width,
        height: r.height,
        rotation: r.rotation,
        preserveAspectRatio: "none",
        immutable: r.immutable,
        mask: r.stepName ? void 0 : r.mask
      }
    );
  const e = r.rotation || 0, t = xo(e), n = Math.cos(t), i = -Math.sin(t), a = `
    matrix(1, 0, 0, 1, ${r.x}, ${r.y})
    matrix(1, 0, 0, 1, ${r.width / 2}, ${r.height / 2})
    matrix(${n}, ${-i}, ${i}, ${n}, 0, 0)
    matrix(1, 0, 0, 1, ${-r.width / 2}, ${-r.height / 2})
    `;
  if (!r.svg)
    throw new Error(
      `Illustration element ${r.id} (stepName ${r.stepName}) lacked svg from src ${r.src} at render time.`
    );
  return /* @__PURE__ */ At.jsx("g", { mask: r.stepName ? void 0 : r.mask, children: /* @__PURE__ */ At.jsx(
    "g",
    {
      transform: a,
      dangerouslySetInnerHTML: {
        __html: VA(
          r.svg,
          r.width,
          r.height,
          r.colors,
          r._renderingConfiguration?.spotColors
        )
      }
    }
  ) });
};
class z8 {
  constructor() {
    this.id = br(), this.stateCallbacks = [], this.prevCommands = [], this.nextCommands = [];
  }
  registerStateCallback(e) {
    this.stateCallbacks.push(e);
  }
  unregisterStateCallback(e) {
    this.stateCallbacks.filter((t) => t !== e);
  }
  getState() {
    return this.state;
  }
  runStateCallbacks() {
    this.stateCallbacks.forEach((e) => e());
  }
  apply(e, t) {
    if (!this.state)
      throw new Error(`State not initialized for cc ${this.id}!`);
    this.state = this.commandReducer(this.state, e), this.runStateCallbacks(), this.nextCommands = [], t || this.prevCommands.push(e);
  }
  undo() {
    if (!this.state)
      return;
    const e = this.prevCommands.pop();
    if (!e)
      return;
    const t = e.undo();
    this.state = { ...this.state, transaction: t }, this.nextCommands.push(e), this.runStateCallbacks();
  }
  redo() {
    if (!this.state)
      return;
    const e = this.nextCommands.pop();
    e && (this.state = this.commandReducer(this.state, e), this.runStateCallbacks(), this.prevCommands.push(e));
  }
  /**
   * Find all commands in history with the given sequence ID,
   * discard all but the last and overwrite its oldState.
   */
  flattenSequence(e, t) {
    const i = this.prevCommands.filter((a) => a.sequenceId === e).pop();
    i && (this.prevCommands = this.prevCommands.filter((a) => a.sequenceId !== e), i?.overrideOldState(t), this.prevCommands.push(i));
  }
  getLayoutById(e) {
    if (!this.state)
      throw new Error(`State not initialized for cc ${this.id}!`);
    const t = this.state.transaction?.layouts?.[e], n = t?.layout;
    if (!n)
      throw new Error(`No layout: ${e}`);
    const i = [...t?.elements || []];
    return this.getLayoutDataWithState(n, i);
  }
  getAllLayouts() {
    if (!this.state)
      throw new Error(`State not initialized for cc ${this.id}!`);
    const e = [...Object.keys(this.state.transaction?.layouts)];
    return [...new Set(e)].map((n) => this.getLayoutById(n));
  }
  getLayoutDataWithState(e, t) {
    return {
      layoutState: {
        layout: e,
        elements: t
      },
      Component: oT,
      getComponentWithProps: (n) => c1(e, t, n)
    };
  }
  initialize(e, t) {
    if (t) {
      this.state = {
        transaction: t
      };
      return;
    }
    let n = {
      serializableWorkflow: { steps: [] },
      layouts: {}
    };
    e.forEach((i) => {
      n = new wF(i).apply(n);
    }), this.runStateCallbacks(), this.state = {
      transaction: n
    };
  }
  commandReducer(e, t) {
    const n = e.transaction || { layouts: {}, serializableWorkflow: { steps: [] } };
    return { ...e, transaction: t.apply(n) };
  }
}
const vF = (r) => r.type === tr.Image ? /* @__PURE__ */ At.jsx(lT, { ...r }, r.id) : r.type === tr.Frame ? /* @__PURE__ */ At.jsx(kM, { ...r }, r.id) : r.type === tr.Illustration ? /* @__PURE__ */ At.jsx(V8, { ...r }, r.id) : r.type === tr.Textbox ? /* @__PURE__ */ At.jsx(N8, { ...r }, r.id) : r.type === tr.Group ? /* @__PURE__ */ At.jsx(uT, { ...r }, r.id) : null, c1 = (r, e, t) => {
  const n = t.renderingConfiguration, i = n?.removeExcludedElements ? e.filter((a) => !a.excludeFromExport) : e;
  return /* @__PURE__ */ At.jsx(
    oT,
    {
      preserveAspectRatio: void 0,
      elements: i,
      backgroundColor: r.transparentBackground ? void 0 : t.backgroundColor ? t.backgroundColor : "white",
      width: t.width || r.width,
      height: t.height || r.height,
      viewBox: n?.region ? {
        x: n.region.left,
        y: n.region.top,
        width: n.region.width,
        height: n.region.height
      } : {
        x: 0,
        y: 0,
        width: r.width,
        height: r.height
      },
      configuration: n,
      outlineArea: t.outlineArea,
      maxHeight: t.maxHeight,
      maxWidth: t.maxWidth,
      position: t.position,
      borderRadius: t.borderRadius,
      outlineColor: t.outlineColor
    }
  );
};
function f1(r) {
  return r.sort((e, t) => {
    const n = e.layer || 0, i = t.layer || 0;
    if (n < i) return -1;
    if (n > i) return 1;
    const a = e.layerIndex || 0, s = t.layerIndex || 0;
    return a < s ? -1 : a > s ? 1 : 0;
  });
}
var hf = {}, pf = {}, cS;
function $8() {
  if (cS) return pf;
  cS = 1, Object.defineProperty(pf, "__esModule", { value: !0 }), pf.makeDataUriToBuffer = void 0;
  const r = (e) => (t) => {
    if (t = String(t), !/^data:/i.test(t))
      throw new TypeError('`uri` does not appear to be a Data URI (must begin with "data:")');
    t = t.replace(/\r?\n/g, "");
    const n = t.indexOf(",");
    if (n === -1 || n <= 4)
      throw new TypeError("malformed data: URI");
    const i = t.substring(5, n).split(";");
    let a = "", s = !1;
    const o = i[0] || "text/plain";
    let l = o;
    for (let d = 1; d < i.length; d++)
      i[d] === "base64" ? s = !0 : i[d] && (l += `;${i[d]}`, i[d].indexOf("charset=") === 0 && (a = i[d].substring(8)));
    !i[0] && !a.length && (l += ";charset=US-ASCII", a = "US-ASCII");
    const u = unescape(t.substring(n + 1)), c = s ? e.base64ToArrayBuffer(u) : e.stringToBuffer(u);
    return {
      type: o,
      typeFull: l,
      charset: a,
      buffer: c
    };
  };
  return pf.makeDataUriToBuffer = r, pf;
}
var fS;
function H8() {
  if (fS) return hf;
  fS = 1, Object.defineProperty(hf, "__esModule", { value: !0 }), hf.dataUriToBuffer = void 0;
  const r = $8();
  function e(n) {
    const i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = [];
    for (let l = 0; l < n.length; l += 4) {
      const u = i.indexOf(n.charAt(l)), c = i.indexOf(n.charAt(l + 1)), d = n.charAt(l + 2) === "=" ? 0 : i.indexOf(n.charAt(l + 2)), f = n.charAt(l + 3) === "=" ? 0 : i.indexOf(n.charAt(l + 3)), h = u << 2 | c >> 4, g = (c & 15) << 4 | d >> 2, v = (d & 3) << 6 | f;
      a.push(h), n.charAt(l + 2) !== "=" && a.push(g), n.charAt(l + 3) !== "=" && a.push(v);
    }
    const s = new ArrayBuffer(a.length);
    return new Uint8Array(s).set(a), s;
  }
  function t(n) {
    const i = new ArrayBuffer(n.length), a = new Uint8Array(i);
    for (let s = 0; s < n.length; s++)
      a[s] = n.charCodeAt(s);
    return i;
  }
  return hf.dataUriToBuffer = (0, r.makeDataUriToBuffer)({ stringToBuffer: t, base64ToArrayBuffer: e }), hf;
}
var j8 = H8();
const io = /* @__PURE__ */ new Map(), Of = /* @__PURE__ */ new Map(), B0 = /* @__PURE__ */ new Map(), yF = async (r, e) => {
  if (!e) {
    if (!r) throw new Error("No region or src supplied. Cannot construct frame!");
    return jy(r);
  }
  return ha(e);
}, jy = (r) => {
  const e = r.width, t = r.height;
  return `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 ${e} ${t}'>
        <path id="target-path" d='M0 0 h ${e} v ${t} h ${-e} Z' />
    </svg>
    `;
}, G8 = async (r, e) => {
  if (!e)
    return;
  const t = await ft.getDefaultVariant(e, r.frameVariantId);
  if (!t)
    throw new Error(`No variant with ID: ${r.frameVariantId}`);
  if (!t.asset)
    throw new Error(`No asset for variant with ID: ${r.frameVariantId}`);
  return t;
}, Mg = async (r) => {
  if (B0.has(r))
    return B0.get(r);
  const t = (async () => {
    if (Of.has(r))
      return Of.get(r);
    await new Promise((f) => setTimeout(f, 0));
    const i = _s().parseFromString(r, "image/svg+xml"), a = i.querySelector("svg");
    if (!a)
      throw new Error("Malformed frame SVG: <svg> tag not found");
    const s = a.getAttribute("viewBox");
    if (!s)
      throw new Error("SVG missing viewBox.");
    const o = s.split(" "), l = parseFloat(o[3]) || 1, u = parseFloat(o[2]) || 1, c = i.getElementById("target-path"), d = i.getElementsByClassName("st0").item(0);
    if (c) {
      const f = c.getAttribute("d");
      if (!f)
        throw new Error("Malformed frame SVG: 'd' attribute not found on target element");
      const h = {
        path: f,
        width: u,
        height: l
      };
      return Of.set(f, h), h;
    }
    if (d) {
      const f = d.getAttribute("d");
      if (!f)
        throw new Error("Malformed frame SVG: 'd' attribute not found on target element");
      const h = {
        path: f,
        width: u,
        height: l
      };
      return Of.set(f, h), h;
    }
    throw new Error("Malformed frame SVG");
  })();
  return B0.set(r, t), t;
}, d1 = (r, e, t, n) => {
  const i = e.width / e.height, a = r.width / r.height;
  let s;
  n ? a > i ? s = e.height / r.height : s = e.width / r.width : a > i ? s = e.width / r.width : s = e.height / r.height, t?.scale !== void 0 && (s *= t?.scale);
  const o = e.width / 2, l = e.height / 2, u = o - r.width / 2 * s, c = t?.left || u, d = l - r.height / 2 * s, f = t?.top || d;
  return {
    x: c,
    y: f,
    zoom: s,
    rotation: 0
  };
}, Gy = async (r) => {
  if (io.has(r))
    return io.get(r);
  if (r.startsWith("data:image/svg+xml")) {
    const t = j8.dataUriToBuffer(r), n = new TextDecoder().decode(t.buffer), i = AF(n), a = {
      src: r,
      width: i.width,
      height: i.height,
      aspect: i.width / i.height
    };
    return io.set(r, a), a;
  }
  if ((r.split(".").pop()?.toLowerCase() ?? "") === "svg") {
    const t = await h1(r), n = t.width, i = t.height, a = {
      src: r,
      width: n,
      height: i,
      aspect: n / i
    };
    return io.set(r, a), a;
  } else {
    const t = await Fg(r, !0), n = await Dg(t), i = {
      src: r,
      width: n.width,
      height: n.height,
      aspect: n.width / n.height
    };
    return io.set(r, i), i;
  }
}, h1 = async (r) => {
  const e = await ha(r);
  return AF(e);
}, dS = (r) => r.endsWith("mm") ? Number(r.replace("mm", "")) * 3.7795275591 : r.endsWith("px") ? Number(r.replace("px", "")) : Number(r), AF = (r) => {
  const n = _s().parseFromString(r, "image/svg+xml").querySelector("svg");
  if (!n)
    throw new Error("No svg tag found, this svg must be malformed!");
  const i = n.getAttribute("viewBox"), a = n.getAttribute("width"), s = n.getAttribute("height"), o = s && a ? [0, 0, dS(a), dS(s)] : i?.split(" ").map((l) => Number(l));
  if (!o)
    throw new Error("No viewbox or width/height values detected on SVG file!");
  return {
    width: o[2],
    height: o[3]
  };
}, gf = (r, e) => {
  const t = r.layoutState.elements.filter((i) => i.layer === e), n = Math.max(...t.map((i) => i.layerIndex).filter((i) => i !== void 0));
  return Math.max(n, 0) + 1;
}, bF = async (r) => new Promise((e) => {
  ha(r).then((t) => {
    e(t);
  }).catch((t) => console.error(t));
}), M0 = /* @__PURE__ */ new Map(), hd = async (r) => {
  if (M0.has(r))
    return M0.get(r);
  const e = async (i) => new Promise((a, s) => {
    try {
      if (!(!!URL && !!URL.createObjectURL)) throw new Error("Environment incapable of generating ObjectURL");
      i.toBlob((l) => {
        if (!l)
          throw i.width === 0 || i.height === 0 ? new Error(`Canvas dimensions are invalid (${i.width},${i.height})`) : i.width * i.height >= 268435456 ? new Error(`Canvas dimensions exceed device limit (${i.width},${i.height})`) : new Error("Couldn't generate object URL for Illustration, the blob was undefined!");
        a(URL.createObjectURL(l));
      });
    } catch (o) {
      s(o);
    }
  }), n = (async () => {
    const s = _s().parseFromString(r, "image/svg+xml").firstElementChild;
    if (!s)
      throw new Error("Failed to read SVG");
    const l = El().serializeToString(s), u = bo(), c = u.getContext("2d"), d = await so.from(c, l, {
      anonymousCrossOrigin: !0,
      ignoreDimensions: !1,
      createCanvas: bo,
      createImage: kd,
      DOMParser: RA(),
      fetch: Ms
    }), f = s.getAttribute("width"), h = s.getAttribute("height"), g = 2048;
    if (h && f) {
      const v = parseFloat(h), A = parseFloat(f) / v;
      A > 1 ? d.resize(g, g / A) : d.resize(g * A, g);
    } else
      d.resize(g, g);
    return await d.render(), await e(u);
  })();
  return M0.set(r, n), n;
}, mf = async (r, e, t, n) => {
  const i = r.layoutState.layout.useEditableArea && r.layoutState.layout.editableArea || {
    width: r.layoutState.layout.width,
    height: r.layoutState.layout.height,
    x: 0,
    y: 0
  }, a = i.width < i.height ? i.width : i.height, s = r.layoutState.layout.useEditableArea ? a / 1.3 : a / 2, o = {
    top: i.y + i.height / 2 - s / 2,
    left: i.x + i.width / 2 - s / 2,
    width: s,
    height: s,
    rotation: 0,
    panelId: r.layoutState.layout.panelId
  };
  if (t && e === tr.Illustration) {
    const l = await ss(await bF(t)), f = _s().parseFromString(l.svg, "image/svg+xml").firstElementChild.getAttribute("viewBox");
    if (!f) throw new Error("SVG missing viewBox.");
    const h = o.height, g = f.split(" "), v = parseFloat(g[2]) || 1, y = parseFloat(g[3]) || 1, A = v / y;
    o.height = o.width / A, o.top += (h - o.height) / 2;
  }
  if (t && e === tr.Image) {
    const l = o.height, u = await Fg(t), c = await Dg(u), d = c.width / c.height;
    o.height = o.width / d, o.top += (l - o.height) / 2;
  }
  if (t && e === tr.Textbox && n?.text && n?.fontScale) {
    await uc(t);
    const l = So(t), u = uo(n.text, n?.fontScale, l);
    o.width = Math.min(u, i.width * 0.85), o.left = i.x + i.width / 2 - o.width / 2;
  }
  return o;
};
class IQ {
  static async getFrame(e, t) {
    const n = await yF(t.region, t.src), i = await Mg(n), a = t.region || await mf(e, tr.Frame);
    return {
      id: br(),
      x: a.left,
      y: a.top,
      width: a.width,
      height: a.height,
      layer: a.layer || 0,
      layerIndex: a.layerIndex || gf(e, a.layer || 0),
      rotation: a.rotation,
      scaleX: a.width / i.width,
      scaleY: a.height / i.height,
      path: i.path,
      dataWidth: i.width,
      dataHeight: i.height,
      type: tr.Frame,
      disablePlaceholder: t.configuration.disablePlaceholder,
      focalBlur: t.configuration.focalBlur,
      focalBlurStrength: t.configuration.focalBlurStrength,
      focalBlurRadius: t.configuration.focalBlurRadius,
      forceImageCover: t.configuration.forceImageCover,
      pattern: void 0,
      immutable: a.immutable
    };
  }
  static async getImage(e, t) {
    const n = t.region || await mf(e, tr.Image, t.src);
    return {
      id: br(),
      src: t.src,
      type: tr.Image,
      y: n.top,
      x: n.left,
      rotation: n.rotation,
      width: n.width,
      height: n.height,
      layer: n.layer || 0,
      layerIndex: n.layerIndex || gf(e, n.layer || 0),
      immutable: n.immutable,
      preserveAspectRatio: "none"
    };
  }
  static async getTextbox(e, t) {
    const { configuration: n, fontSrc: i, designInputStep: a } = t, s = await uc(i), o = {
      assetUrl: i,
      name: s.names.fullName.en
    }, l = a?.text || n.defaultText || "", u = n.replaceableText ? n.replaceableText.replace("{{}}", l) : l, c = lg(u, {
      vertical: n.vertical,
      uppercase: n.uppercase
    }), d = t.region || await mf(e, tr.Textbox, i, {
      text: c,
      fontScale: n.size ? n.size / s.unitsPerEm : void 0
    }), f = Nd(
      {
        id: br(),
        type: tr.Textbox,
        x: d.left,
        y: d.top,
        width: d.width,
        height: d.height,
        align: s8(n.textAlign, n.vertical),
        curved: n.curved,
        fill: a?.color || n.colour || "#000000",
        fontData: o,
        layer: d.layer || 0,
        layerIndex: d.layerIndex || gf(e, d.layer || 0),
        paths: n.paths,
        rotation: d.rotation,
        vertical: n.vertical,
        verticalAlign: n.verticalAlign || "middle",
        algorithm: ic.Traditional,
        fontSize: n.size || Math.max(Math.round(d.height * 0.025), 1),
        text: c,
        input: l
      },
      c
    ), h = n8(
      { ...d, height: f.height },
      o,
      f.fontSize,
      f?.text?.split(`
`) || [],
      f.align
    );
    return {
      ...f,
      x: h.left,
      y: h.top + (d.height - h.height) / 2,
      width: h.width,
      height: h.height
    };
  }
  static async getShape(e, t) {
    const n = `
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        xmlSpace="preserve"
                        preserveAspectRatio="none"
                        version="1.1"
                        width="1"
                        height="1"
                        viewBox="0 0 1 1"
                    >
                        <rect
                            x="0"
                            y="0"
                            width="1"
                            height="1"
                            class="spiff-fill-shape"
                            fill="${t.color}"
                        />
                    </svg>
                `, i = {};
    i["spiff-fill-shape"] = { browserValue: t.color };
    const a = t.region?.item || await mf(e, tr.Illustration), s = br();
    return {
      stepRegion: t.region?.item,
      stepRegionIndex: t.region?.index,
      colors: i,
      id: s,
      svg: n,
      type: tr.Illustration,
      y: a.top,
      x: a.left,
      rotation: a.rotation,
      width: a.width,
      height: a.height,
      layer: a.layer || 0,
      layerIndex: a.layerIndex || gf(e, a.layer || 0),
      immutable: a.immutable
    };
  }
  static async getIllustration(e, t) {
    const n = t.region?.item || await mf(e, tr.Illustration, t.src), i = await ss(await bF(t.src)), a = await hd(i.svg), s = br();
    return {
      cachedObjectURL: a,
      stepRegion: t.region?.item,
      stepRegionIndex: t.region?.index,
      colors: i.colors,
      id: s,
      src: t.src,
      svg: i.svg,
      type: tr.Illustration,
      y: n.top,
      x: n.left,
      rotation: n.rotation,
      width: n.width,
      height: n.height,
      layer: n.layer || 0,
      layerIndex: n.layerIndex || gf(e, n.layer || 0),
      immutable: n.immutable
    };
  }
}
class Xn extends Error {
  constructor() {
    super("Element not found!"), Object.setPrototypeOf(this, Xn.prototype);
  }
}
const $n = (r, e) => Pi(r, e).elements.find((i) => i.id === r), Pi = (r, e) => {
  const t = Object.values(e).find((n) => n.elements.some((i) => i.id === r));
  if (!t)
    throw new Xn();
  return t;
}, qi = (r, e) => {
  const t = [...e.elements.filter((i) => i.id !== r.id), r], n = f1(t);
  return {
    layout: e.layout,
    elements: n,
    modificationID: br()
  };
}, hS = async (r) => {
  const e = [...Object.keys(r.layouts)], t = [...new Set(e)];
  for (let n = 0; n < t.length; n++) {
    const i = t[n], a = r.layouts[i];
    await Promise.all(
      a.elements.map(async (s) => {
        if (s.type === "illustration") {
          const o = s;
          if (o.src && !o.svg) {
            const l = await ha(o.src), u = await ss(l);
            o.svg = VA(
              u.svg,
              o.width,
              o.height,
              o.colors
            );
          }
        } else if (s.type === "frame") {
          const o = s;
          if (o.pattern?.colors && o.pattern?.src) {
            const l = await ha(o.pattern?.src), u = await ss(l);
            o.pattern.svg = u.svg;
          }
        }
        isNaN(s.x) && (s.x = 0), isNaN(s.y) && (s.y = 0), isNaN(s.width) && (s.width = 0), isNaN(s.height) && (s.height = 0), isNaN(s.rotation) && (s.rotation = 0);
      })
    );
  }
  for (const n in r.layouts) {
    const i = r.layouts[n].elements.filter(
      (s) => s.type === tr.Illustration
    );
    for (let s = 0; s < i.length; ++s) {
      const o = i[s];
      if (o.src && o.svg)
        try {
          o.cachedObjectURL = await hd(o.svg);
        } catch (l) {
          console.log(l);
        }
    }
    const a = r.layouts[n].elements.filter(
      (s) => s.type === tr.Textbox
    );
    for (let s = 0; s < a.length; ++s) {
      const o = a[s];
      o.fontData?.assetUrl && await uc(o.fontData.assetUrl);
    }
  }
};
class Rn {
  undo() {
    if (!this.oldState)
      throw new Error("Cannot undo.");
    return this.oldState;
  }
  overrideOldState(e) {
    this.oldState = e;
  }
}
class pS extends Rn {
  constructor(e) {
    super(), this.serializableWorkflow = e;
  }
  apply(e) {
    return this.oldState = e, {
      ...e,
      serializableWorkflow: this.serializableWorkflow
    };
  }
}
class DQ extends Rn {
  constructor(e, t, n) {
    super(), this.id = e, this.x = t, this.y = n;
  }
  apply(e) {
    this.oldState = e;
    const t = $n(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Xn();
    const n = {
      ...t,
      x: this.x,
      y: this.y
    }, i = Pi(t.id, Object.values(e.layouts)), a = qi(n, i);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [i.layout.id]: a
      }
    };
  }
}
class PQ extends Rn {
  constructor(e, t) {
    super(), this.id = e, this.angle = t;
  }
  apply(e) {
    this.oldState = e;
    const t = $n(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Xn();
    const n = {
      ...t,
      rotation: this.angle
    }, i = Pi(t.id, Object.values(e.layouts)), a = qi(n, i);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [i.layout.id]: a
      }
    };
  }
}
class RQ extends Rn {
  constructor(e, t, n) {
    super(), this.id = e, this.width = Math.abs(t), this.height = Math.abs(n);
  }
  apply(e) {
    this.oldState = e;
    const t = $n(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Xn();
    let n = {
      ...t,
      width: this.width,
      height: this.height
    };
    if (t.type === "frame") {
      const s = n;
      s.scaleX = s.scaleX * this.width / t.width, s.scaleY = s.scaleY * this.height / t.height;
    } else if (t.type === "textbox") {
      const s = n, o = (!s.algorithm || s.algorithm === ic.Autosize ? s.text : s.input) ?? "";
      n = Nd(s, o, t);
    }
    const i = Pi(t.id, Object.values(e.layouts)), a = qi(n, i);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [i.layout.id]: a
      }
    };
  }
}
class Nn extends Rn {
  constructor(e) {
    super(), this.commands = e;
  }
  apply(e) {
    return this.oldState = e, this.commands.reduce((t, n) => n.apply(t), e);
  }
}
class wF extends Rn {
  constructor(e) {
    super(), this.layout = e;
  }
  apply(e) {
    return this.oldState = e, {
      ...e,
      layouts: {
        ...e.layouts,
        [this.layout.id]: {
          elements: [],
          layout: { ...this.layout },
          modificationID: br()
        }
      }
    };
  }
}
class fi extends Rn {
  /**
   * @param initialParams The initial parameters to be set on this new object
   * @param callback An optional callback function to be notified when the object has been instantiated
   * @param layout
   */
  constructor(e, t) {
    super(), this.element = e, this.layout = t;
  }
  apply(e) {
    this.oldState = e, e.layouts[this.layout.id] || (e.layouts[this.layout.id] = { layout: this.layout, elements: [], modificationID: "" });
    const t = e.layouts[this.layout.id].elements;
    if (t.find((o) => o.id === this.element.id))
      throw new Error(
        `Failed to apply new ${this.element.type} element because ID ${this.element.id} already taken`
      );
    if (this.element.productOverlay || t.length === 0) {
      const o = [...t, this.element];
      return this.element.layerIndex === void 0 && (this.element.layerIndex = this.assignIndex(this.element, o)), {
        ...e,
        layouts: {
          ...e.layouts,
          [this.layout.id]: {
            ...e.layouts[this.layout.id],
            elements: o,
            modificationID: br()
          }
        }
      };
    }
    const i = t[t.length - 1], a = i.productOverlay ? i : null;
    a && t.pop();
    let s;
    if (this.element.layerIndex !== null && this.element.layerIndex !== void 0)
      s = [...t, this.element].sort((o, l) => o.layerIndex !== void 0 && l.layerIndex !== void 0 ? o.layerIndex - l.layerIndex : 0);
    else {
      const o = this.assignIndex(this.element, t);
      this.element.layerIndex = o !== void 0 ? o : 0, s = [...t, this.element];
    }
    return a && s.push(a), {
      ...e,
      layouts: {
        ...e.layouts,
        [this.layout.id]: {
          ...e.layouts[this.layout.id],
          elements: s,
          modificationID: br()
        }
      }
    };
  }
  // Calculate layer index for an element that doesn't have an explicit index.
  assignIndex(e, t) {
    if (t.length === 0)
      return 0;
    const n = t.filter((i) => (i.layer || 0) === (e.layer || 0)).sort((i, a) => (i.layerIndex || 0) - (a.layerIndex || 0))[t.length - 1]?.layerIndex;
    return n !== void 0 ? n + 1 : 0;
  }
}
class cc extends Rn {
  constructor(e) {
    super(), this.id = e;
  }
  apply(e) {
    this.oldState = e;
    let t = !1;
    const n = Object.values(e.layouts).map((a) => (a.elements.filter((o) => o.id !== this.id).length !== a.elements.length && (t = !0), {
      ...a,
      elements: a.elements.filter((o) => o.id !== this.id),
      modificationID: br()
    }));
    t || console.log(`Failed to delete element ${this.id}`);
    const i = {};
    return n.forEach((a) => {
      i[a.layout.id] = a;
    }), {
      ...e,
      layouts: i
    };
  }
}
class q8 extends Rn {
  constructor(e, t, n) {
    super(), this.id = e, this.color = t, this.textFillSpotColor = n;
  }
  apply(e) {
    this.oldState = e;
    const t = $n(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Xn();
    const n = {
      ...t,
      fill: this.color,
      fillSpotColorDefinition: this.textFillSpotColor,
      textFillImage: void 0
    }, i = Pi(t.id, Object.values(e.layouts)), a = qi(n, i);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [i.layout.id]: a
      }
    };
  }
}
class _0 extends Rn {
  constructor(e, t) {
    super(), this.id = e, this.imageFill = t;
  }
  apply(e) {
    this.oldState = e;
    const t = $n(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Xn();
    const n = {
      ...t,
      textFillImage: this.imageFill
    }, i = Pi(t.id, Object.values(e.layouts)), a = qi(n, i);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [i.layout.id]: a
      }
    };
  }
}
class W8 extends Rn {
  constructor(e, t) {
    super(), this.id = e, this.size = t;
  }
  apply(e) {
    this.oldState = e;
    const t = $n(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Xn();
    const n = {
      ...t,
      fontSize: this.size
    }, i = Pi(t.id, Object.values(e.layouts)), a = (!t.algorithm || t.algorithm === ic.Autosize ? t.text : t.input) ?? "", s = qi(Nd(n, a), i);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [i.layout.id]: s
      }
    };
  }
}
class gS extends Rn {
  constructor(e, t) {
    super(), this.id = e, this.fontData = t;
  }
  apply(e) {
    this.oldState = e;
    const t = $n(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Xn();
    const n = {
      ...t,
      fontData: this.fontData
    }, i = Pi(t.id, Object.values(e.layouts)), a = (!t.algorithm || t.algorithm === ic.Autosize ? t.text : t.input) ?? "", s = qi(Nd(n, a), i);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [i.layout.id]: s
      }
    };
  }
}
class Q8 extends Rn {
  constructor(e, t) {
    super(), this.id = e, this.align = t;
  }
  apply(e) {
    this.oldState = e;
    const t = $n(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Xn();
    const n = {
      ...t,
      align: this.align
    }, i = Pi(t.id, Object.values(e.layouts)), a = qi(n, i);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [i.layout.id]: a
      }
    };
  }
}
class Y8 extends Rn {
  constructor(e, t, n) {
    super(), this.id = e, this.imageData = t, this.offsets = n;
  }
  apply(e) {
    this.oldState = e;
    const t = Pi(this.id, Object.values(e.layouts)), n = t.elements.findIndex((o) => o.id === this.id), i = t.elements[n].pattern, a = [...t.elements];
    a.splice(n, 1, {
      ...t.elements[n],
      pattern: {
        ...i,
        src: this.imageData.src,
        x: this.offsets.x,
        y: this.offsets.y,
        width: this.imageData.width,
        height: this.imageData.height,
        scaleX: this.offsets.zoom,
        scaleY: this.offsets.zoom,
        rotation: this.offsets.rotation ?? i?.rotation ?? 0,
        svg: this.imageData.svg,
        colors: this.imageData.colors
      }
    });
    const s = {
      ...t,
      elements: a,
      modificationID: br()
    };
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [t.layout.id]: s
      }
    };
  }
}
class X8 extends Rn {
  constructor(e, t, n, i, a) {
    super(), this.id = e, this.useThreshold = t, this.invertThreshold = n, this.threshold = i, this.thresholdSaturation = a;
  }
  apply(e) {
    this.oldState = e;
    const t = $n(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Xn();
    const n = {
      ...t,
      useThreshold: this.useThreshold,
      invertThreshold: this.invertThreshold,
      threshold: this.threshold,
      thresholdSaturation: this.thresholdSaturation
    }, i = Pi(t.id, Object.values(e.layouts)), a = qi(n, i);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [i.layout.id]: a
      }
    };
  }
}
class OQ extends Rn {
  constructor(e, t) {
    super(), this.id = e, this.src = t;
  }
  apply(e) {
    this.oldState = e;
    const t = $n(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Xn();
    const n = {
      ...t,
      src: this.src
    }, i = Pi(t.id, Object.values(e.layouts)), a = qi(n, i);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [i.layout.id]: a
      }
    };
  }
}
class J8 extends Rn {
  constructor(e, t) {
    super(), this.id = e, this.text = t;
  }
  apply(e) {
    this.oldState = e;
    const t = $n(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Xn();
    const n = Pi(t.id, Object.values(e.layouts)), i = qi(Nd(t, this.text, t), n);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [n.layout.id]: i
      }
    };
  }
}
class N0 extends Rn {
  constructor(e, t, n) {
    super(), this.id = e, this.strokeColor = t, this.strokeThickness = n;
  }
  apply(e) {
    this.oldState = e;
    const t = $n(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Xn();
    const n = {
      ...t,
      strokeColor: this.strokeColor,
      strokeThickness: this.strokeThickness
    }, i = Pi(t.id, Object.values(e.layouts)), a = qi(n, i);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [i.layout.id]: a
      }
    };
  }
}
class qy extends Rn {
  constructor(e, t, n) {
    super(), this.id = e, this.className = t, this.fill = n;
  }
  apply(e) {
    this.oldState = e;
    const t = $n(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Xn();
    const n = t.colors || {}, i = n[this.className];
    typeof this.fill == "string" ? n[this.className] = {
      browserValue: this.fill,
      spotColor: i?.spotColor,
      pmsValue: i?.pmsValue
    } : n[this.className] = {
      browserValue: this.fill.browserValue,
      spotColor: i?.spotColor,
      pmsValue: this.fill.pmsValue
    };
    const a = {
      ...t,
      colors: n
    }, s = Pi(t.id, Object.values(e.layouts)), o = qi(a, s);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [s.layout.id]: o
      }
    };
  }
}
class K8 extends Rn {
  constructor(e, t, n) {
    super(), this.id = e, this.svgBody = t, this.objectURL = n;
  }
  apply(e) {
    this.oldState = e;
    const t = $n(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Xn();
    const n = {
      ...t,
      svg: this.svgBody,
      cachedObjectURL: this.objectURL
    }, i = Pi(t.id, Object.values(e.layouts)), a = qi(n, i);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [i.layout.id]: a
      }
    };
  }
}
class BQ extends Rn {
  /**
   * @param id The targeted element to bring to the front.
   */
  constructor(e) {
    super(), this.id = e;
  }
  apply(e) {
    if (this.oldState = e, !$n(this.id, Object.values(e.layouts)).id)
      throw new Xn();
    const n = Object.values(e.layouts).find((s) => s.elements.find((o) => o.id === this.id));
    if (!n)
      throw new Error("Layout missing from state!");
    const i = n.elements.findIndex((s) => s.id === this.id);
    n.elements.push(n.elements.splice(i, 1)[0]);
    const a = [...n.elements];
    return a.forEach((s, o) => s.layerIndex = o), {
      ...e,
      layouts: {
        ...e.layouts,
        [n.layout.id]: {
          ...e.layouts[n.layout.id],
          elements: a,
          modificationID: br()
        }
      }
    };
  }
}
class MQ extends Rn {
  /**
   * @param id The targeted element to bring to the back.
   */
  constructor(e) {
    super(), this.id = e;
  }
  apply(e) {
    this.oldState = e;
    const t = $n(this.id, Object.values(e.layouts));
    if (!t.id)
      throw new Xn();
    const n = Object.values(e.layouts).find((o) => o.elements.find((l) => l.id === this.id));
    if (!n)
      throw new Error("Layout missing from state!");
    const i = n.elements.findIndex((o) => o.id === this.id);
    n.elements.splice(i, 1), n.elements.unshift(t);
    const a = [...n.elements], s = a.splice(i, 1)[0];
    return a.splice(i, 0, s), a.forEach((o, l) => o.layerIndex = l), {
      ...e,
      layouts: {
        ...e.layouts,
        [n.layout.id]: {
          ...e.layouts[n.layout.id],
          elements: a,
          modificationID: br()
        }
      }
    };
  }
}
class _Q extends Rn {
  /**
   * @param id The targeted element to bring to the front.
   */
  constructor(e) {
    super(), this.id = e;
  }
  apply(e) {
    if (this.oldState = e, !$n(this.id, Object.values(e.layouts)).id)
      throw new Xn();
    const n = Object.values(e.layouts).find((l) => l.elements.find((u) => u.id === this.id));
    if (!n)
      throw new Error("Layout missing from state!");
    const i = n.elements.findIndex((l) => l.id === this.id), a = i + 1, s = [...n.elements], o = s.splice(i, 1)[0];
    return s.splice(a, 0, o), s.forEach((l, u) => l.layerIndex = u), {
      ...e,
      layouts: {
        ...e.layouts,
        [n.layout.id]: {
          ...e.layouts[n.layout.id],
          elements: s,
          modificationID: br()
        }
      }
    };
  }
}
class NQ extends Rn {
  /**
   * @param id The targeted element to bring to the front.
   */
  constructor(e) {
    super(), this.id = e;
  }
  apply(e) {
    if (this.oldState = e, !$n(this.id, Object.values(e.layouts)).id)
      throw new Xn();
    const n = Object.values(e.layouts).find((l) => l.elements.find((u) => u.id === this.id));
    if (!n)
      throw new Error("Layout missing from state!");
    const i = n.elements.findIndex((l) => l.id === this.id), a = i - 1, s = [...n.elements], o = s.splice(i, 1)[0];
    return s.splice(a, 0, o), s.forEach((l, u) => l.layerIndex = u), {
      ...e,
      layouts: {
        ...e.layouts,
        [n.layout.id]: {
          ...e.layouts[n.layout.id],
          elements: s,
          modificationID: br()
        }
      }
    };
  }
}
class mS {
  constructor(e, t, n) {
    this.processRegion = async (i) => {
      const a = this.layouts.find((l) => l.panelId === i.panelId);
      if (!a)
        throw new Ei(i);
      let s = "";
      if (this.configuration.type === Je.ProductOverlay) {
        let l = "";
        if (this.product?.overlayImageUrl && (l = this.product.overlayImageUrl), s = l, !l)
          throw new Is(this.configuration, "Couldn't find an asset for product overlay step");
      }
      const o = this.evaluateAssetType();
      if (o === tr.Image) {
        const l = this.configuration.type === Je.SilentIllustration ? this.configuration.data.asset?.fileLink : this.product?.overlayImageUrl;
        if (!l)
          throw new Error("Undefined raster silent step source");
        const u = {
          stepName: this.configuration.stepName,
          id: br(),
          src: l,
          type: o,
          y: i.top,
          x: i.left,
          width: i.width,
          height: i.height,
          layer: i.layer,
          layerIndex: i.layerIndex,
          immutable: i.immutable,
          productOverlay: this.configuration.type === Je.ProductOverlay ? !0 : void 0,
          rotation: i.rotation,
          excludeFromExport: this.configuration.data.excludeFromPrint,
          preserveAspectRatio: "none"
        };
        return {
          regionElement: {
            id: u.id,
            region: i
          },
          command: new fi(u, a)
        };
      } else {
        const l = this.configuration.type === Je.SilentIllustration ? this.configuration.data.asset?.fileLink : s, c = await ss(await (async () => new Promise((f, h) => {
          if (!l) {
            h("Undefined vector silent step source");
            return;
          }
          ha(l, !0).then((g) => {
            f(g);
          }).catch((g) => console.error(g));
        }))()), d = {
          stepName: this.configuration.stepName,
          id: br(),
          cachedObjectURL: await hd(c.svg),
          src: l,
          svg: c.svg,
          colors: c.colors,
          type: o,
          y: i.top,
          x: i.left,
          width: i.width,
          height: i.height,
          layer: i.layer,
          layerIndex: i.layerIndex,
          rotation: i.rotation,
          immutable: i.immutable,
          productOverlay: this.configuration.type === Je.ProductOverlay ? !0 : void 0,
          excludeFromExport: this.configuration.data.excludeFromPrint
        };
        return {
          regionElement: {
            id: d.id,
            region: i
          },
          command: new fi(d, a)
        };
      }
    }, this.configuration = e, this.layouts = t, this.product = n || void 0;
  }
  async trigger() {
    if (!this.configuration.data.regions)
      throw new Is(this.configuration, "Missing regions.");
    if (this.configuration.type === Je.SilentIllustration) {
      const e = this.configuration.data.regions.map(this.processRegion);
      return Promise.all(e);
    } else return this.configuration.type === Je.ProductOverlay ? Promise.all(
      this.configuration.data.regions.map((e) => {
        if (!this.layouts.find((n) => e.panelId === n.panelId))
          throw new Ei(e);
        return this.processRegion(e);
      })
    ) : Promise.reject("Unknown silent step. This is a bug");
  }
  evaluateAssetType() {
    const e = this.configuration.type === Je.ProductOverlay && this.product?.overlayImageUrl ? this.product.overlayImageUrl.toLowerCase() : this.configuration.data.asset?.fileLink?.toLowerCase().split("?")[0];
    return e?.startsWith("data:image/png") || e?.endsWith(".jpeg") || e?.endsWith(".jpg") || e?.endsWith(".png") ? tr.Image : (e?.endsWith(".svg") || e?.startsWith("image/svg+xml"), tr.Illustration);
  }
}
var bu = {}, L0, vS;
function Z8() {
  return vS || (vS = 1, L0 = function() {
    return typeof Promise == "function" && Promise.prototype && Promise.prototype.then;
  }), L0;
}
var U0 = {}, Ks = {}, yS;
function Fl() {
  if (yS) return Ks;
  yS = 1;
  let r;
  const e = [
    0,
    // Not used
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
  ];
  return Ks.getSymbolSize = function(n) {
    if (!n) throw new Error('"version" cannot be null or undefined');
    if (n < 1 || n > 40) throw new Error('"version" should be in range from 1 to 40');
    return n * 4 + 17;
  }, Ks.getSymbolTotalCodewords = function(n) {
    return e[n];
  }, Ks.getBCHDigit = function(t) {
    let n = 0;
    for (; t !== 0; )
      n++, t >>>= 1;
    return n;
  }, Ks.setToSJISFunction = function(n) {
    if (typeof n != "function")
      throw new Error('"toSJISFunc" is not a valid function.');
    r = n;
  }, Ks.isKanjiModeEnabled = function() {
    return typeof r < "u";
  }, Ks.toSJIS = function(n) {
    return r(n);
  }, Ks;
}
var V0 = {}, AS;
function p1() {
  return AS || (AS = 1, (function(r) {
    r.L = { bit: 1 }, r.M = { bit: 0 }, r.Q = { bit: 3 }, r.H = { bit: 2 };
    function e(t) {
      if (typeof t != "string")
        throw new Error("Param is not a string");
      switch (t.toLowerCase()) {
        case "l":
        case "low":
          return r.L;
        case "m":
        case "medium":
          return r.M;
        case "q":
        case "quartile":
          return r.Q;
        case "h":
        case "high":
          return r.H;
        default:
          throw new Error("Unknown EC Level: " + t);
      }
    }
    r.isValid = function(n) {
      return n && typeof n.bit < "u" && n.bit >= 0 && n.bit < 4;
    }, r.from = function(n, i) {
      if (r.isValid(n))
        return n;
      try {
        return e(n);
      } catch {
        return i;
      }
    };
  })(V0)), V0;
}
var z0, bS;
function e7() {
  if (bS) return z0;
  bS = 1;
  function r() {
    this.buffer = [], this.length = 0;
  }
  return r.prototype = {
    get: function(e) {
      const t = Math.floor(e / 8);
      return (this.buffer[t] >>> 7 - e % 8 & 1) === 1;
    },
    put: function(e, t) {
      for (let n = 0; n < t; n++)
        this.putBit((e >>> t - n - 1 & 1) === 1);
    },
    getLengthInBits: function() {
      return this.length;
    },
    putBit: function(e) {
      const t = Math.floor(this.length / 8);
      this.buffer.length <= t && this.buffer.push(0), e && (this.buffer[t] |= 128 >>> this.length % 8), this.length++;
    }
  }, z0 = r, z0;
}
var $0, wS;
function t7() {
  if (wS) return $0;
  wS = 1;
  function r(e) {
    if (!e || e < 1)
      throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = e, this.data = new Uint8Array(e * e), this.reservedBit = new Uint8Array(e * e);
  }
  return r.prototype.set = function(e, t, n, i) {
    const a = e * this.size + t;
    this.data[a] = n, i && (this.reservedBit[a] = !0);
  }, r.prototype.get = function(e, t) {
    return this.data[e * this.size + t];
  }, r.prototype.xor = function(e, t, n) {
    this.data[e * this.size + t] ^= n;
  }, r.prototype.isReserved = function(e, t) {
    return this.reservedBit[e * this.size + t];
  }, $0 = r, $0;
}
var H0 = {}, xS;
function r7() {
  return xS || (xS = 1, (function(r) {
    const e = Fl().getSymbolSize;
    r.getRowColCoords = function(n) {
      if (n === 1) return [];
      const i = Math.floor(n / 7) + 2, a = e(n), s = a === 145 ? 26 : Math.ceil((a - 13) / (2 * i - 2)) * 2, o = [a - 7];
      for (let l = 1; l < i - 1; l++)
        o[l] = o[l - 1] - s;
      return o.push(6), o.reverse();
    }, r.getPositions = function(n) {
      const i = [], a = r.getRowColCoords(n), s = a.length;
      for (let o = 0; o < s; o++)
        for (let l = 0; l < s; l++)
          o === 0 && l === 0 || // top-left
          o === 0 && l === s - 1 || // bottom-left
          o === s - 1 && l === 0 || i.push([a[o], a[l]]);
      return i;
    };
  })(H0)), H0;
}
var j0 = {}, CS;
function n7() {
  if (CS) return j0;
  CS = 1;
  const r = Fl().getSymbolSize, e = 7;
  return j0.getPositions = function(n) {
    const i = r(n);
    return [
      // top-left
      [0, 0],
      // top-right
      [i - e, 0],
      // bottom-left
      [0, i - e]
    ];
  }, j0;
}
var G0 = {}, SS;
function i7() {
  return SS || (SS = 1, (function(r) {
    r.Patterns = {
      PATTERN000: 0,
      PATTERN001: 1,
      PATTERN010: 2,
      PATTERN011: 3,
      PATTERN100: 4,
      PATTERN101: 5,
      PATTERN110: 6,
      PATTERN111: 7
    };
    const e = {
      N1: 3,
      N2: 3,
      N3: 40,
      N4: 10
    };
    r.isValid = function(i) {
      return i != null && i !== "" && !isNaN(i) && i >= 0 && i <= 7;
    }, r.from = function(i) {
      return r.isValid(i) ? parseInt(i, 10) : void 0;
    }, r.getPenaltyN1 = function(i) {
      const a = i.size;
      let s = 0, o = 0, l = 0, u = null, c = null;
      for (let d = 0; d < a; d++) {
        o = l = 0, u = c = null;
        for (let f = 0; f < a; f++) {
          let h = i.get(d, f);
          h === u ? o++ : (o >= 5 && (s += e.N1 + (o - 5)), u = h, o = 1), h = i.get(f, d), h === c ? l++ : (l >= 5 && (s += e.N1 + (l - 5)), c = h, l = 1);
        }
        o >= 5 && (s += e.N1 + (o - 5)), l >= 5 && (s += e.N1 + (l - 5));
      }
      return s;
    }, r.getPenaltyN2 = function(i) {
      const a = i.size;
      let s = 0;
      for (let o = 0; o < a - 1; o++)
        for (let l = 0; l < a - 1; l++) {
          const u = i.get(o, l) + i.get(o, l + 1) + i.get(o + 1, l) + i.get(o + 1, l + 1);
          (u === 4 || u === 0) && s++;
        }
      return s * e.N2;
    }, r.getPenaltyN3 = function(i) {
      const a = i.size;
      let s = 0, o = 0, l = 0;
      for (let u = 0; u < a; u++) {
        o = l = 0;
        for (let c = 0; c < a; c++)
          o = o << 1 & 2047 | i.get(u, c), c >= 10 && (o === 1488 || o === 93) && s++, l = l << 1 & 2047 | i.get(c, u), c >= 10 && (l === 1488 || l === 93) && s++;
      }
      return s * e.N3;
    }, r.getPenaltyN4 = function(i) {
      let a = 0;
      const s = i.data.length;
      for (let l = 0; l < s; l++) a += i.data[l];
      return Math.abs(Math.ceil(a * 100 / s / 5) - 10) * e.N4;
    };
    function t(n, i, a) {
      switch (n) {
        case r.Patterns.PATTERN000:
          return (i + a) % 2 === 0;
        case r.Patterns.PATTERN001:
          return i % 2 === 0;
        case r.Patterns.PATTERN010:
          return a % 3 === 0;
        case r.Patterns.PATTERN011:
          return (i + a) % 3 === 0;
        case r.Patterns.PATTERN100:
          return (Math.floor(i / 2) + Math.floor(a / 3)) % 2 === 0;
        case r.Patterns.PATTERN101:
          return i * a % 2 + i * a % 3 === 0;
        case r.Patterns.PATTERN110:
          return (i * a % 2 + i * a % 3) % 2 === 0;
        case r.Patterns.PATTERN111:
          return (i * a % 3 + (i + a) % 2) % 2 === 0;
        default:
          throw new Error("bad maskPattern:" + n);
      }
    }
    r.applyMask = function(i, a) {
      const s = a.size;
      for (let o = 0; o < s; o++)
        for (let l = 0; l < s; l++)
          a.isReserved(l, o) || a.xor(l, o, t(i, l, o));
    }, r.getBestMask = function(i, a) {
      const s = Object.keys(r.Patterns).length;
      let o = 0, l = 1 / 0;
      for (let u = 0; u < s; u++) {
        a(u), r.applyMask(u, i);
        const c = r.getPenaltyN1(i) + r.getPenaltyN2(i) + r.getPenaltyN3(i) + r.getPenaltyN4(i);
        r.applyMask(u, i), c < l && (l = c, o = u);
      }
      return o;
    };
  })(G0)), G0;
}
var fp = {}, ES;
function xF() {
  if (ES) return fp;
  ES = 1;
  const r = p1(), e = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
  ], t = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
  ];
  return fp.getBlocksCount = function(i, a) {
    switch (a) {
      case r.L:
        return e[(i - 1) * 4 + 0];
      case r.M:
        return e[(i - 1) * 4 + 1];
      case r.Q:
        return e[(i - 1) * 4 + 2];
      case r.H:
        return e[(i - 1) * 4 + 3];
      default:
        return;
    }
  }, fp.getTotalCodewordsCount = function(i, a) {
    switch (a) {
      case r.L:
        return t[(i - 1) * 4 + 0];
      case r.M:
        return t[(i - 1) * 4 + 1];
      case r.Q:
        return t[(i - 1) * 4 + 2];
      case r.H:
        return t[(i - 1) * 4 + 3];
      default:
        return;
    }
  }, fp;
}
var q0 = {}, vf = {}, kS;
function a7() {
  if (kS) return vf;
  kS = 1;
  const r = new Uint8Array(512), e = new Uint8Array(256);
  return (function() {
    let n = 1;
    for (let i = 0; i < 255; i++)
      r[i] = n, e[n] = i, n <<= 1, n & 256 && (n ^= 285);
    for (let i = 255; i < 512; i++)
      r[i] = r[i - 255];
  })(), vf.log = function(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return e[n];
  }, vf.exp = function(n) {
    return r[n];
  }, vf.mul = function(n, i) {
    return n === 0 || i === 0 ? 0 : r[e[n] + e[i]];
  }, vf;
}
var TS;
function s7() {
  return TS || (TS = 1, (function(r) {
    const e = a7();
    r.mul = function(n, i) {
      const a = new Uint8Array(n.length + i.length - 1);
      for (let s = 0; s < n.length; s++)
        for (let o = 0; o < i.length; o++)
          a[s + o] ^= e.mul(n[s], i[o]);
      return a;
    }, r.mod = function(n, i) {
      let a = new Uint8Array(n);
      for (; a.length - i.length >= 0; ) {
        const s = a[0];
        for (let l = 0; l < i.length; l++)
          a[l] ^= e.mul(i[l], s);
        let o = 0;
        for (; o < a.length && a[o] === 0; ) o++;
        a = a.slice(o);
      }
      return a;
    }, r.generateECPolynomial = function(n) {
      let i = new Uint8Array([1]);
      for (let a = 0; a < n; a++)
        i = r.mul(i, new Uint8Array([1, e.exp(a)]));
      return i;
    };
  })(q0)), q0;
}
var W0, FS;
function o7() {
  if (FS) return W0;
  FS = 1;
  const r = s7();
  function e(t) {
    this.genPoly = void 0, this.degree = t, this.degree && this.initialize(this.degree);
  }
  return e.prototype.initialize = function(n) {
    this.degree = n, this.genPoly = r.generateECPolynomial(this.degree);
  }, e.prototype.encode = function(n) {
    if (!this.genPoly)
      throw new Error("Encoder not initialized");
    const i = new Uint8Array(n.length + this.degree);
    i.set(n);
    const a = r.mod(i, this.genPoly), s = this.degree - a.length;
    if (s > 0) {
      const o = new Uint8Array(this.degree);
      return o.set(a, s), o;
    }
    return a;
  }, W0 = e, W0;
}
var Q0 = {}, Y0 = {}, X0 = {}, IS;
function CF() {
  return IS || (IS = 1, X0.isValid = function(e) {
    return !isNaN(e) && e >= 1 && e <= 40;
  }), X0;
}
var qa = {}, DS;
function SF() {
  if (DS) return qa;
  DS = 1;
  const r = "[0-9]+", e = "[A-Z $%*+\\-./:]+";
  let t = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
  t = t.replace(/u/g, "\\u");
  const n = "(?:(?![A-Z0-9 $%*+\\-./:]|" + t + `)(?:.|[\r
]))+`;
  qa.KANJI = new RegExp(t, "g"), qa.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g"), qa.BYTE = new RegExp(n, "g"), qa.NUMERIC = new RegExp(r, "g"), qa.ALPHANUMERIC = new RegExp(e, "g");
  const i = new RegExp("^" + t + "$"), a = new RegExp("^" + r + "$"), s = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
  return qa.testKanji = function(l) {
    return i.test(l);
  }, qa.testNumeric = function(l) {
    return a.test(l);
  }, qa.testAlphanumeric = function(l) {
    return s.test(l);
  }, qa;
}
var PS;
function Il() {
  return PS || (PS = 1, (function(r) {
    const e = CF(), t = SF();
    r.NUMERIC = {
      id: "Numeric",
      bit: 1,
      ccBits: [10, 12, 14]
    }, r.ALPHANUMERIC = {
      id: "Alphanumeric",
      bit: 2,
      ccBits: [9, 11, 13]
    }, r.BYTE = {
      id: "Byte",
      bit: 4,
      ccBits: [8, 16, 16]
    }, r.KANJI = {
      id: "Kanji",
      bit: 8,
      ccBits: [8, 10, 12]
    }, r.MIXED = {
      bit: -1
    }, r.getCharCountIndicator = function(a, s) {
      if (!a.ccBits) throw new Error("Invalid mode: " + a);
      if (!e.isValid(s))
        throw new Error("Invalid version: " + s);
      return s >= 1 && s < 10 ? a.ccBits[0] : s < 27 ? a.ccBits[1] : a.ccBits[2];
    }, r.getBestModeForData = function(a) {
      return t.testNumeric(a) ? r.NUMERIC : t.testAlphanumeric(a) ? r.ALPHANUMERIC : t.testKanji(a) ? r.KANJI : r.BYTE;
    }, r.toString = function(a) {
      if (a && a.id) return a.id;
      throw new Error("Invalid mode");
    }, r.isValid = function(a) {
      return a && a.bit && a.ccBits;
    };
    function n(i) {
      if (typeof i != "string")
        throw new Error("Param is not a string");
      switch (i.toLowerCase()) {
        case "numeric":
          return r.NUMERIC;
        case "alphanumeric":
          return r.ALPHANUMERIC;
        case "kanji":
          return r.KANJI;
        case "byte":
          return r.BYTE;
        default:
          throw new Error("Unknown mode: " + i);
      }
    }
    r.from = function(a, s) {
      if (r.isValid(a))
        return a;
      try {
        return n(a);
      } catch {
        return s;
      }
    };
  })(Y0)), Y0;
}
var RS;
function l7() {
  return RS || (RS = 1, (function(r) {
    const e = Fl(), t = xF(), n = p1(), i = Il(), a = CF(), s = 7973, o = e.getBCHDigit(s);
    function l(f, h, g) {
      for (let v = 1; v <= 40; v++)
        if (h <= r.getCapacity(v, g, f))
          return v;
    }
    function u(f, h) {
      return i.getCharCountIndicator(f, h) + 4;
    }
    function c(f, h) {
      let g = 0;
      return f.forEach(function(v) {
        const y = u(v.mode, h);
        g += y + v.getBitsLength();
      }), g;
    }
    function d(f, h) {
      for (let g = 1; g <= 40; g++)
        if (c(f, g) <= r.getCapacity(g, h, i.MIXED))
          return g;
    }
    r.from = function(h, g) {
      return a.isValid(h) ? parseInt(h, 10) : g;
    }, r.getCapacity = function(h, g, v) {
      if (!a.isValid(h))
        throw new Error("Invalid QR Code version");
      typeof v > "u" && (v = i.BYTE);
      const y = e.getSymbolTotalCodewords(h), A = t.getTotalCodewordsCount(h, g), x = (y - A) * 8;
      if (v === i.MIXED) return x;
      const k = x - u(v, h);
      switch (v) {
        case i.NUMERIC:
          return Math.floor(k / 10 * 3);
        case i.ALPHANUMERIC:
          return Math.floor(k / 11 * 2);
        case i.KANJI:
          return Math.floor(k / 13);
        case i.BYTE:
        default:
          return Math.floor(k / 8);
      }
    }, r.getBestVersionForData = function(h, g) {
      let v;
      const y = n.from(g, n.M);
      if (Array.isArray(h)) {
        if (h.length > 1)
          return d(h, y);
        if (h.length === 0)
          return 1;
        v = h[0];
      } else
        v = h;
      return l(v.mode, v.getLength(), y);
    }, r.getEncodedBits = function(h) {
      if (!a.isValid(h) || h < 7)
        throw new Error("Invalid QR Code version");
      let g = h << 12;
      for (; e.getBCHDigit(g) - o >= 0; )
        g ^= s << e.getBCHDigit(g) - o;
      return h << 12 | g;
    };
  })(Q0)), Q0;
}
var J0 = {}, OS;
function u7() {
  if (OS) return J0;
  OS = 1;
  const r = Fl(), e = 1335, t = 21522, n = r.getBCHDigit(e);
  return J0.getEncodedBits = function(a, s) {
    const o = a.bit << 3 | s;
    let l = o << 10;
    for (; r.getBCHDigit(l) - n >= 0; )
      l ^= e << r.getBCHDigit(l) - n;
    return (o << 10 | l) ^ t;
  }, J0;
}
var K0 = {}, Z0, BS;
function c7() {
  if (BS) return Z0;
  BS = 1;
  const r = Il();
  function e(t) {
    this.mode = r.NUMERIC, this.data = t.toString();
  }
  return e.getBitsLength = function(n) {
    return 10 * Math.floor(n / 3) + (n % 3 ? n % 3 * 3 + 1 : 0);
  }, e.prototype.getLength = function() {
    return this.data.length;
  }, e.prototype.getBitsLength = function() {
    return e.getBitsLength(this.data.length);
  }, e.prototype.write = function(n) {
    let i, a, s;
    for (i = 0; i + 3 <= this.data.length; i += 3)
      a = this.data.substr(i, 3), s = parseInt(a, 10), n.put(s, 10);
    const o = this.data.length - i;
    o > 0 && (a = this.data.substr(i), s = parseInt(a, 10), n.put(s, o * 3 + 1));
  }, Z0 = e, Z0;
}
var ev, MS;
function f7() {
  if (MS) return ev;
  MS = 1;
  const r = Il(), e = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
  ];
  function t(n) {
    this.mode = r.ALPHANUMERIC, this.data = n;
  }
  return t.getBitsLength = function(i) {
    return 11 * Math.floor(i / 2) + 6 * (i % 2);
  }, t.prototype.getLength = function() {
    return this.data.length;
  }, t.prototype.getBitsLength = function() {
    return t.getBitsLength(this.data.length);
  }, t.prototype.write = function(i) {
    let a;
    for (a = 0; a + 2 <= this.data.length; a += 2) {
      let s = e.indexOf(this.data[a]) * 45;
      s += e.indexOf(this.data[a + 1]), i.put(s, 11);
    }
    this.data.length % 2 && i.put(e.indexOf(this.data[a]), 6);
  }, ev = t, ev;
}
var tv, _S;
function d7() {
  if (_S) return tv;
  _S = 1;
  const r = Il();
  function e(t) {
    this.mode = r.BYTE, typeof t == "string" ? this.data = new TextEncoder().encode(t) : this.data = new Uint8Array(t);
  }
  return e.getBitsLength = function(n) {
    return n * 8;
  }, e.prototype.getLength = function() {
    return this.data.length;
  }, e.prototype.getBitsLength = function() {
    return e.getBitsLength(this.data.length);
  }, e.prototype.write = function(t) {
    for (let n = 0, i = this.data.length; n < i; n++)
      t.put(this.data[n], 8);
  }, tv = e, tv;
}
var rv, NS;
function h7() {
  if (NS) return rv;
  NS = 1;
  const r = Il(), e = Fl();
  function t(n) {
    this.mode = r.KANJI, this.data = n;
  }
  return t.getBitsLength = function(i) {
    return i * 13;
  }, t.prototype.getLength = function() {
    return this.data.length;
  }, t.prototype.getBitsLength = function() {
    return t.getBitsLength(this.data.length);
  }, t.prototype.write = function(n) {
    let i;
    for (i = 0; i < this.data.length; i++) {
      let a = e.toSJIS(this.data[i]);
      if (a >= 33088 && a <= 40956)
        a -= 33088;
      else if (a >= 57408 && a <= 60351)
        a -= 49472;
      else
        throw new Error(
          "Invalid SJIS character: " + this.data[i] + `
Make sure your charset is UTF-8`
        );
      a = (a >>> 8 & 255) * 192 + (a & 255), n.put(a, 13);
    }
  }, rv = t, rv;
}
var nv = { exports: {} }, LS;
function p7() {
  return LS || (LS = 1, (function(r) {
    var e = {
      single_source_shortest_paths: function(t, n, i) {
        var a = {}, s = {};
        s[n] = 0;
        var o = e.PriorityQueue.make();
        o.push(n, 0);
        for (var l, u, c, d, f, h, g, v, y; !o.empty(); ) {
          l = o.pop(), u = l.value, d = l.cost, f = t[u] || {};
          for (c in f)
            f.hasOwnProperty(c) && (h = f[c], g = d + h, v = s[c], y = typeof s[c] > "u", (y || v > g) && (s[c] = g, o.push(c, g), a[c] = u));
        }
        if (typeof i < "u" && typeof s[i] > "u") {
          var A = ["Could not find a path from ", n, " to ", i, "."].join("");
          throw new Error(A);
        }
        return a;
      },
      extract_shortest_path_from_predecessor_list: function(t, n) {
        for (var i = [], a = n; a; )
          i.push(a), t[a], a = t[a];
        return i.reverse(), i;
      },
      find_path: function(t, n, i) {
        var a = e.single_source_shortest_paths(t, n, i);
        return e.extract_shortest_path_from_predecessor_list(
          a,
          i
        );
      },
      /**
       * A very naive priority queue implementation.
       */
      PriorityQueue: {
        make: function(t) {
          var n = e.PriorityQueue, i = {}, a;
          t = t || {};
          for (a in n)
            n.hasOwnProperty(a) && (i[a] = n[a]);
          return i.queue = [], i.sorter = t.sorter || n.default_sorter, i;
        },
        default_sorter: function(t, n) {
          return t.cost - n.cost;
        },
        /**
         * Add a new item to the queue and ensure the highest priority element
         * is at the front of the queue.
         */
        push: function(t, n) {
          var i = { value: t, cost: n };
          this.queue.push(i), this.queue.sort(this.sorter);
        },
        /**
         * Return the highest priority element in the queue.
         */
        pop: function() {
          return this.queue.shift();
        },
        empty: function() {
          return this.queue.length === 0;
        }
      }
    };
    r.exports = e;
  })(nv)), nv.exports;
}
var US;
function g7() {
  return US || (US = 1, (function(r) {
    const e = Il(), t = c7(), n = f7(), i = d7(), a = h7(), s = SF(), o = Fl(), l = p7();
    function u(A) {
      return unescape(encodeURIComponent(A)).length;
    }
    function c(A, x, k) {
      const F = [];
      let S;
      for (; (S = A.exec(k)) !== null; )
        F.push({
          data: S[0],
          index: S.index,
          mode: x,
          length: S[0].length
        });
      return F;
    }
    function d(A) {
      const x = c(s.NUMERIC, e.NUMERIC, A), k = c(s.ALPHANUMERIC, e.ALPHANUMERIC, A);
      let F, S;
      return o.isKanjiModeEnabled() ? (F = c(s.BYTE, e.BYTE, A), S = c(s.KANJI, e.KANJI, A)) : (F = c(s.BYTE_KANJI, e.BYTE, A), S = []), x.concat(k, F, S).sort(function(M, j) {
        return M.index - j.index;
      }).map(function(M) {
        return {
          data: M.data,
          mode: M.mode,
          length: M.length
        };
      });
    }
    function f(A, x) {
      switch (x) {
        case e.NUMERIC:
          return t.getBitsLength(A);
        case e.ALPHANUMERIC:
          return n.getBitsLength(A);
        case e.KANJI:
          return a.getBitsLength(A);
        case e.BYTE:
          return i.getBitsLength(A);
      }
    }
    function h(A) {
      return A.reduce(function(x, k) {
        const F = x.length - 1 >= 0 ? x[x.length - 1] : null;
        return F && F.mode === k.mode ? (x[x.length - 1].data += k.data, x) : (x.push(k), x);
      }, []);
    }
    function g(A) {
      const x = [];
      for (let k = 0; k < A.length; k++) {
        const F = A[k];
        switch (F.mode) {
          case e.NUMERIC:
            x.push([
              F,
              { data: F.data, mode: e.ALPHANUMERIC, length: F.length },
              { data: F.data, mode: e.BYTE, length: F.length }
            ]);
            break;
          case e.ALPHANUMERIC:
            x.push([
              F,
              { data: F.data, mode: e.BYTE, length: F.length }
            ]);
            break;
          case e.KANJI:
            x.push([
              F,
              { data: F.data, mode: e.BYTE, length: u(F.data) }
            ]);
            break;
          case e.BYTE:
            x.push([
              { data: F.data, mode: e.BYTE, length: u(F.data) }
            ]);
        }
      }
      return x;
    }
    function v(A, x) {
      const k = {}, F = { start: {} };
      let S = ["start"];
      for (let R = 0; R < A.length; R++) {
        const M = A[R], j = [];
        for (let G = 0; G < M.length; G++) {
          const ie = M[G], q = "" + R + G;
          j.push(q), k[q] = { node: ie, lastCount: 0 }, F[q] = {};
          for (let Y = 0; Y < S.length; Y++) {
            const J = S[Y];
            k[J] && k[J].node.mode === ie.mode ? (F[J][q] = f(k[J].lastCount + ie.length, ie.mode) - f(k[J].lastCount, ie.mode), k[J].lastCount += ie.length) : (k[J] && (k[J].lastCount = ie.length), F[J][q] = f(ie.length, ie.mode) + 4 + e.getCharCountIndicator(ie.mode, x));
          }
        }
        S = j;
      }
      for (let R = 0; R < S.length; R++)
        F[S[R]].end = 0;
      return { map: F, table: k };
    }
    function y(A, x) {
      let k;
      const F = e.getBestModeForData(A);
      if (k = e.from(x, F), k !== e.BYTE && k.bit < F.bit)
        throw new Error('"' + A + '" cannot be encoded with mode ' + e.toString(k) + `.
 Suggested mode is: ` + e.toString(F));
      switch (k === e.KANJI && !o.isKanjiModeEnabled() && (k = e.BYTE), k) {
        case e.NUMERIC:
          return new t(A);
        case e.ALPHANUMERIC:
          return new n(A);
        case e.KANJI:
          return new a(A);
        case e.BYTE:
          return new i(A);
      }
    }
    r.fromArray = function(x) {
      return x.reduce(function(k, F) {
        return typeof F == "string" ? k.push(y(F, null)) : F.data && k.push(y(F.data, F.mode)), k;
      }, []);
    }, r.fromString = function(x, k) {
      const F = d(x, o.isKanjiModeEnabled()), S = g(F), R = v(S, k), M = l.find_path(R.map, "start", "end"), j = [];
      for (let G = 1; G < M.length - 1; G++)
        j.push(R.table[M[G]].node);
      return r.fromArray(h(j));
    }, r.rawSplit = function(x) {
      return r.fromArray(
        d(x, o.isKanjiModeEnabled())
      );
    };
  })(K0)), K0;
}
var VS;
function m7() {
  if (VS) return U0;
  VS = 1;
  const r = Fl(), e = p1(), t = e7(), n = t7(), i = r7(), a = n7(), s = i7(), o = xF(), l = o7(), u = l7(), c = u7(), d = Il(), f = g7();
  function h(R, M) {
    const j = R.size, G = a.getPositions(M);
    for (let ie = 0; ie < G.length; ie++) {
      const q = G[ie][0], Y = G[ie][1];
      for (let J = -1; J <= 7; J++)
        if (!(q + J <= -1 || j <= q + J))
          for (let se = -1; se <= 7; se++)
            Y + se <= -1 || j <= Y + se || (J >= 0 && J <= 6 && (se === 0 || se === 6) || se >= 0 && se <= 6 && (J === 0 || J === 6) || J >= 2 && J <= 4 && se >= 2 && se <= 4 ? R.set(q + J, Y + se, !0, !0) : R.set(q + J, Y + se, !1, !0));
    }
  }
  function g(R) {
    const M = R.size;
    for (let j = 8; j < M - 8; j++) {
      const G = j % 2 === 0;
      R.set(j, 6, G, !0), R.set(6, j, G, !0);
    }
  }
  function v(R, M) {
    const j = i.getPositions(M);
    for (let G = 0; G < j.length; G++) {
      const ie = j[G][0], q = j[G][1];
      for (let Y = -2; Y <= 2; Y++)
        for (let J = -2; J <= 2; J++)
          Y === -2 || Y === 2 || J === -2 || J === 2 || Y === 0 && J === 0 ? R.set(ie + Y, q + J, !0, !0) : R.set(ie + Y, q + J, !1, !0);
    }
  }
  function y(R, M) {
    const j = R.size, G = u.getEncodedBits(M);
    let ie, q, Y;
    for (let J = 0; J < 18; J++)
      ie = Math.floor(J / 3), q = J % 3 + j - 8 - 3, Y = (G >> J & 1) === 1, R.set(ie, q, Y, !0), R.set(q, ie, Y, !0);
  }
  function A(R, M, j) {
    const G = R.size, ie = c.getEncodedBits(M, j);
    let q, Y;
    for (q = 0; q < 15; q++)
      Y = (ie >> q & 1) === 1, q < 6 ? R.set(q, 8, Y, !0) : q < 8 ? R.set(q + 1, 8, Y, !0) : R.set(G - 15 + q, 8, Y, !0), q < 8 ? R.set(8, G - q - 1, Y, !0) : q < 9 ? R.set(8, 15 - q - 1 + 1, Y, !0) : R.set(8, 15 - q - 1, Y, !0);
    R.set(G - 8, 8, 1, !0);
  }
  function x(R, M) {
    const j = R.size;
    let G = -1, ie = j - 1, q = 7, Y = 0;
    for (let J = j - 1; J > 0; J -= 2)
      for (J === 6 && J--; ; ) {
        for (let se = 0; se < 2; se++)
          if (!R.isReserved(ie, J - se)) {
            let oe = !1;
            Y < M.length && (oe = (M[Y] >>> q & 1) === 1), R.set(ie, J - se, oe), q--, q === -1 && (Y++, q = 7);
          }
        if (ie += G, ie < 0 || j <= ie) {
          ie -= G, G = -G;
          break;
        }
      }
  }
  function k(R, M, j) {
    const G = new t();
    j.forEach(function(se) {
      G.put(se.mode.bit, 4), G.put(se.getLength(), d.getCharCountIndicator(se.mode, R)), se.write(G);
    });
    const ie = r.getSymbolTotalCodewords(R), q = o.getTotalCodewordsCount(R, M), Y = (ie - q) * 8;
    for (G.getLengthInBits() + 4 <= Y && G.put(0, 4); G.getLengthInBits() % 8 !== 0; )
      G.putBit(0);
    const J = (Y - G.getLengthInBits()) / 8;
    for (let se = 0; se < J; se++)
      G.put(se % 2 ? 17 : 236, 8);
    return F(G, R, M);
  }
  function F(R, M, j) {
    const G = r.getSymbolTotalCodewords(M), ie = o.getTotalCodewordsCount(M, j), q = G - ie, Y = o.getBlocksCount(M, j), J = G % Y, se = Y - J, oe = Math.floor(G / Y), he = Math.floor(q / Y), ye = he + 1, Ue = oe - he, Re = new l(Ue);
    let Oe = 0;
    const ee = new Array(Y), re = new Array(Y);
    let de = 0;
    const Be = new Uint8Array(R.buffer);
    for (let Ge = 0; Ge < Y; Ge++) {
      const bt = Ge < se ? he : ye;
      ee[Ge] = Be.slice(Oe, Oe + bt), re[Ge] = Re.encode(ee[Ge]), Oe += bt, de = Math.max(de, bt);
    }
    const ke = new Uint8Array(G);
    let ze = 0, je, qe;
    for (je = 0; je < de; je++)
      for (qe = 0; qe < Y; qe++)
        je < ee[qe].length && (ke[ze++] = ee[qe][je]);
    for (je = 0; je < Ue; je++)
      for (qe = 0; qe < Y; qe++)
        ke[ze++] = re[qe][je];
    return ke;
  }
  function S(R, M, j, G) {
    let ie;
    if (Array.isArray(R))
      ie = f.fromArray(R);
    else if (typeof R == "string") {
      let oe = M;
      if (!oe) {
        const he = f.rawSplit(R);
        oe = u.getBestVersionForData(he, j);
      }
      ie = f.fromString(R, oe || 40);
    } else
      throw new Error("Invalid data");
    const q = u.getBestVersionForData(ie, j);
    if (!q)
      throw new Error("The amount of data is too big to be stored in a QR Code");
    if (!M)
      M = q;
    else if (M < q)
      throw new Error(
        `
The chosen QR Code version cannot contain this amount of data.
Minimum version required to store current data is: ` + q + `.
`
      );
    const Y = k(M, j, ie), J = r.getSymbolSize(M), se = new n(J);
    return h(se, M), g(se), v(se, M), A(se, j, 0), M >= 7 && y(se, M), x(se, Y), isNaN(G) && (G = s.getBestMask(
      se,
      A.bind(null, se, j)
    )), s.applyMask(G, se), A(se, j, G), {
      modules: se,
      version: M,
      errorCorrectionLevel: j,
      maskPattern: G,
      segments: ie
    };
  }
  return U0.create = function(M, j) {
    if (typeof M > "u" || M === "")
      throw new Error("No input text");
    let G = e.M, ie, q;
    return typeof j < "u" && (G = e.from(j.errorCorrectionLevel, e.M), ie = u.from(j.version), q = s.from(j.maskPattern), j.toSJISFunc && r.setToSJISFunction(j.toSJISFunc)), S(M, ie, G, q);
  }, U0;
}
var iv = {}, av = {}, zS;
function EF() {
  return zS || (zS = 1, (function(r) {
    function e(t) {
      if (typeof t == "number" && (t = t.toString()), typeof t != "string")
        throw new Error("Color should be defined as hex string");
      let n = t.slice().replace("#", "").split("");
      if (n.length < 3 || n.length === 5 || n.length > 8)
        throw new Error("Invalid hex color: " + t);
      (n.length === 3 || n.length === 4) && (n = Array.prototype.concat.apply([], n.map(function(a) {
        return [a, a];
      }))), n.length === 6 && n.push("F", "F");
      const i = parseInt(n.join(""), 16);
      return {
        r: i >> 24 & 255,
        g: i >> 16 & 255,
        b: i >> 8 & 255,
        a: i & 255,
        hex: "#" + n.slice(0, 6).join("")
      };
    }
    r.getOptions = function(n) {
      n || (n = {}), n.color || (n.color = {});
      const i = typeof n.margin > "u" || n.margin === null || n.margin < 0 ? 4 : n.margin, a = n.width && n.width >= 21 ? n.width : void 0, s = n.scale || 4;
      return {
        width: a,
        scale: a ? 4 : s,
        margin: i,
        color: {
          dark: e(n.color.dark || "#000000ff"),
          light: e(n.color.light || "#ffffffff")
        },
        type: n.type,
        rendererOpts: n.rendererOpts || {}
      };
    }, r.getScale = function(n, i) {
      return i.width && i.width >= n + i.margin * 2 ? i.width / (n + i.margin * 2) : i.scale;
    }, r.getImageWidth = function(n, i) {
      const a = r.getScale(n, i);
      return Math.floor((n + i.margin * 2) * a);
    }, r.qrToImageData = function(n, i, a) {
      const s = i.modules.size, o = i.modules.data, l = r.getScale(s, a), u = Math.floor((s + a.margin * 2) * l), c = a.margin * l, d = [a.color.light, a.color.dark];
      for (let f = 0; f < u; f++)
        for (let h = 0; h < u; h++) {
          let g = (f * u + h) * 4, v = a.color.light;
          if (f >= c && h >= c && f < u - c && h < u - c) {
            const y = Math.floor((f - c) / l), A = Math.floor((h - c) / l);
            v = d[o[y * s + A] ? 1 : 0];
          }
          n[g++] = v.r, n[g++] = v.g, n[g++] = v.b, n[g] = v.a;
        }
    };
  })(av)), av;
}
var $S;
function v7() {
  return $S || ($S = 1, (function(r) {
    const e = EF();
    function t(i, a, s) {
      i.clearRect(0, 0, a.width, a.height), a.style || (a.style = {}), a.height = s, a.width = s, a.style.height = s + "px", a.style.width = s + "px";
    }
    function n() {
      try {
        return document.createElement("canvas");
      } catch {
        throw new Error("You need to specify a canvas element");
      }
    }
    r.render = function(a, s, o) {
      let l = o, u = s;
      typeof l > "u" && (!s || !s.getContext) && (l = s, s = void 0), s || (u = n()), l = e.getOptions(l);
      const c = e.getImageWidth(a.modules.size, l), d = u.getContext("2d"), f = d.createImageData(c, c);
      return e.qrToImageData(f.data, a, l), t(d, u, c), d.putImageData(f, 0, 0), u;
    }, r.renderToDataURL = function(a, s, o) {
      let l = o;
      typeof l > "u" && (!s || !s.getContext) && (l = s, s = void 0), l || (l = {});
      const u = r.render(a, s, l), c = l.type || "image/png", d = l.rendererOpts || {};
      return u.toDataURL(c, d.quality);
    };
  })(iv)), iv;
}
var sv = {}, HS;
function y7() {
  if (HS) return sv;
  HS = 1;
  const r = EF();
  function e(i, a) {
    const s = i.a / 255, o = a + '="' + i.hex + '"';
    return s < 1 ? o + " " + a + '-opacity="' + s.toFixed(2).slice(1) + '"' : o;
  }
  function t(i, a, s) {
    let o = i + a;
    return typeof s < "u" && (o += " " + s), o;
  }
  function n(i, a, s) {
    let o = "", l = 0, u = !1, c = 0;
    for (let d = 0; d < i.length; d++) {
      const f = Math.floor(d % a), h = Math.floor(d / a);
      !f && !u && (u = !0), i[d] ? (c++, d > 0 && f > 0 && i[d - 1] || (o += u ? t("M", f + s, 0.5 + h + s) : t("m", l, 0), l = 0, u = !1), f + 1 < a && i[d + 1] || (o += t("h", c), c = 0)) : l++;
    }
    return o;
  }
  return sv.render = function(a, s, o) {
    const l = r.getOptions(s), u = a.modules.size, c = a.modules.data, d = u + l.margin * 2, f = l.color.light.a ? "<path " + e(l.color.light, "fill") + ' d="M0 0h' + d + "v" + d + 'H0z"/>' : "", h = "<path " + e(l.color.dark, "stroke") + ' d="' + n(c, u, l.margin) + '"/>', g = 'viewBox="0 0 ' + d + " " + d + '"', y = '<svg xmlns="http://www.w3.org/2000/svg" ' + (l.width ? 'width="' + l.width + '" height="' + l.width + '" ' : "") + g + ' shape-rendering="crispEdges">' + f + h + `</svg>
`;
    return typeof o == "function" && o(null, y), y;
  }, sv;
}
var jS;
function A7() {
  if (jS) return bu;
  jS = 1;
  const r = Z8(), e = m7(), t = v7(), n = y7();
  function i(a, s, o, l, u) {
    const c = [].slice.call(arguments, 1), d = c.length, f = typeof c[d - 1] == "function";
    if (!f && !r())
      throw new Error("Callback required as last argument");
    if (f) {
      if (d < 2)
        throw new Error("Too few arguments provided");
      d === 2 ? (u = o, o = s, s = l = void 0) : d === 3 && (s.getContext && typeof u > "u" ? (u = l, l = void 0) : (u = l, l = o, o = s, s = void 0));
    } else {
      if (d < 1)
        throw new Error("Too few arguments provided");
      return d === 1 ? (o = s, s = l = void 0) : d === 2 && !s.getContext && (l = o, o = s, s = void 0), new Promise(function(h, g) {
        try {
          const v = e.create(o, l);
          h(a(v, s, l));
        } catch (v) {
          g(v);
        }
      });
    }
    try {
      const h = e.create(o, l);
      u(null, a(h, s, l));
    } catch (h) {
      u(h);
    }
  }
  return bu.create = e.create, bu.toCanvas = i.bind(null, t.render), bu.toDataURL = i.bind(null, t.renderToDataURL), bu.toString = i.bind(null, function(a, s, o) {
    return n.render(a, o);
  }), bu;
}
var kF = A7();
const b7 = async (r) => {
  const e = `${ml.getServicesApiUrl()}/shortener`;
  try {
    return (await (await Ms(e, {
      method: "POST",
      body: JSON.stringify({ longUrl: r }),
      headers: {
        "Content-Type": "application/json"
      }
    })).json()).shortUrl;
  } catch (t) {
    throw console.error(t), new Tg("Failed to shorten URL, see console.");
  }
};
class TF {
  async poll() {
    try {
      if (await this.predicate()) {
        this.onSuccess(), this.pollingId > -1 && window.clearInterval(this.pollingId);
        return;
      }
    } catch {
    }
    this.attempts += 1, this.attempts < this.maxAttempts ? this.pollingId = window.setTimeout(this.poll.bind(this), this.interval) : this.onFailure();
  }
  /**
   * Constructs a new polling service.
   * @param predicate An async function that returns true when polling has returned a successful result.
   * @param onSuccess The callback to be called when polling has returned a successful result.
   * @param onFailure The callback to be called when polling has returned a failed result.
   * @param interval The number of milliseconds to wait between each poll.
   * @param maxAttempts The maximum amount of times to check the condition.
   */
  constructor(e, t, n, i = 3e3, a = 10) {
    this.onSuccess = t, this.onFailure = n, this.predicate = e, this.attempts = 0, this.pollingId = -1, this.interval = i, this.maxAttempts = a, this.poll();
  }
}
class w7 {
  async init(e, t, n) {
    return n && await this.reload(e, t, n), null;
  }
  async reload(e, t, n) {
    const i = t.getSerializedStep(
      e.stepName,
      n.serializableWorkflow.steps
    ), l = Object.values(n.layouts).map((u) => u.elements).flat().filter((u) => u.stepName === e.stepName).map((u) => ({
      id: u.id,
      region: u.stepRegion,
      regionIndex: u.stepRegionIndex
    }));
    await t.setSelectionsAndElements(e.stepName, [], l, async () => {
      const u = i?.storage?.videoShortUrl, c = i?.storage?.videoUrl;
      t.updateStorage(e.stepName, {
        videoShortUrl: u,
        videoUrl: c
      });
    });
  }
  async regenerateQRCode(e, t, n, i) {
    const a = async () => {
      const c = (await Zp([t]))[0], d = c?.versions?.find((f) => f.name === "mpeg4")?.link;
      return { asset: c, link: d };
    }, s = await new Promise((c, d) => {
      new TF(
        async () => !!(await a()).link,
        async () => {
          const f = await a();
          if (!f.link || !f.link)
            throw new ad(f.asset);
          c({
            rel: "mpeg4",
            href: f.link
          });
        },
        () => {
          d("Poller timed out with 40 attempts @ 3 second interval");
        },
        3e3,
        40
      );
    });
    e.forEach((c) => n.getCommandDispatcher()(new cc(c.id)));
    let o;
    if (!i.data.baseUrl || i.data.baseUrl.trim() === "")
      o = s.href;
    else {
      const c = i.data.baseUrl.slice(0, 4) === "http" ? "" : "https://", d = new URL(c + i.data.baseUrl);
      d.searchParams.append("video", btoa(JSON.stringify([s]))), d.pathname = d.pathname + (d.pathname.slice(-1) === "/" ? "" : "/");
      const f = d.toString();
      if (f.length >= 2e3)
        throw new Tg("Cannot create QR code, URL too long.");
      o = await b7(f);
    }
    if (!i.data || !i.data.regions)
      throw new Is(i, "Missing regions.");
    const l = await this.regionElements(i), u = await this.command(o, l, n, i.stepName);
    return u && (u.command && n.getCommandDispatcher()(u.command), u.followup && await u.followup()), await n.setSelectionsAndElements(i.stepName, [], l, async () => {
      n.updateStorage(i.stepName, {
        videoShortUrl: o,
        videoUrl: s.href
      });
    }), o;
  }
  async regionElements(e) {
    const t = (n, i) => ({ id: br(), region: n, regionIndex: i });
    return e.data.regions.map(t);
  }
  async command(e, t, n, i) {
    const a = n.getLayouts(), o = `data:image/svg+xml;base64,${btoa(await kF.toString(e, { type: "svg" }))}`, l = t.map((u) => {
      const c = u.region, d = a.find((f) => f.panelId === c?.panelId);
      if (!d && c)
        throw new Ei(c);
      if (d && !c)
        throw new Error("Region not found");
      if (!d || !c)
        throw new Error("Neither a region or layout found!");
      return new fi(
        {
          stepRegion: c,
          stepRegionIndex: u.regionIndex,
          stepName: i,
          id: u.id,
          src: o,
          type: tr.Image,
          y: c.top,
          x: c.left,
          width: c.width,
          height: c.height,
          rotation: 0
        },
        d
      );
    });
    return { command: new Nn(l), followup: async () => {
    } };
  }
}
const FF = new w7();
class ug {
  constructor() {
    this.frameSourceSvg = async (e, t) => {
      if (!e)
        return jy(t);
      const n = e.asset;
      if (!n)
        throw new bl(e);
      const i = n.fileLink;
      if (i)
        return ha(i, !0);
      throw new ad(n);
    };
  }
  async init(e, t, n) {
    const i = n?.serializableWorkflow.steps.find(
      (l) => l.stepName === e.stepName
    );
    if (i?.storage && Object.keys(i.storage).length !== 0 || i?.selectedVariants && i.selectedVariants.length !== 0)
      return await this.reload(e, t, n), null;
    e.mandatory && t.setMandatoryFulfilled(e.stepName, !1), t.markStepsAsInitialised([e.stepName]);
    let a;
    const s = t.getWorkflowExperience().getBundle();
    if (s && e.globalPropertyAspectConfigurations) {
      const l = s.getGlobalPropertyStateManager(), u = e.globalPropertyAspectConfigurations[0];
      if (u) {
        const c = l.getAspectStorage(
          u.aspectName
        );
        c && c.originalAssetKey && (a = (await zn.getLocalOrFromServer(c.originalAssetKey)).fileLink);
      }
    }
    const o = await ft.getOptionForStep(e);
    if (o) {
      const l = await ft.getDefaultVariant(o, e.overrideDefaultVariantId);
      if (l)
        return this.selectVariantCommand(
          e,
          l,
          [],
          t,
          void 0,
          a || e.data.placeholderImageUrl
        );
      if (o.variants && o.variants?.length !== 0) return null;
    }
    return this.selectVariantCommand(
      e,
      void 0,
      [],
      t,
      void 0,
      a || e.data.placeholderImageUrl
    );
  }
  async reload(e, t, n) {
    const i = t.getSerializedStep(
      e.stepName,
      n.serializableWorkflow.steps
    ), l = Object.values(n.layouts).map((c) => c.elements).flat().filter((c) => c.stepName === e.stepName).map((c) => ({
      id: c.id,
      region: c.stepRegion,
      regionIndex: c.stepRegionIndex
    })), u = await ft.getOptionForStep(e);
    if (!u || (u.variants || []).length === 0) {
      const c = e.data.regions.map((d) => jy(d));
      t.updateStorage(e.stepName, {
        currentFrameSources: c
      });
    }
    if (i) {
      const c = async () => {
        const d = i.storage?.colors, f = i.storage?.framePatternSrc, h = i.storage?.frameOffsetsList;
        if (t.updateMetadata(e.stepName, {
          frameOffsetsList: h,
          framePatternSrc: f
        }), f) {
          const g = t.getWorkflowExperience().getStepById(e.stepName)?.frameService;
          if (!g) throw new Error("Frame service unavailable, cannot load pattern!");
          await this.loadPatternFromString(f, g, !0, d), t.updateMetadata(e.stepName, { image: f }), t.updateStorage(e.stepName, {
            framePatternSrc: f
          }), this.validateColorCount(e, t);
        }
        if (h?.some((g) => g.zoom)) {
          const g = t.getWorkflowExperience().getStepById(e.stepName)?.frameService;
          if (!g) throw new Error("Frame service unavailable, cannot load pattern!");
          g.updateOffsets(h);
        }
        t.setMandatoryFulfilled(e.stepName, !0);
      };
      if (i.selectedVariants && i.selectedVariants.length > 0) {
        const d = i.selectedVariants[0].id;
        if (u && d) {
          const f = u.variants?.find((h) => h.id === d);
          f && await t.setSelectionsAndElements(
            e.stepName,
            [f],
            l,
            async () => {
              const h = await Promise.all(
                e.data.regions.map((g) => this.frameSourceSvg(f, g))
              );
              t.updateStorage(e.stepName, { currentFrameSources: h }), await c();
            }
          );
        }
      } else
        await t.setSelectionsAndElements(e.stepName, [], l, c);
    }
  }
  async availableColors(e, t) {
    return (await ft.ensureFullOption(e.data.colorOption))?.variants?.map((i) => ({
      fill: i.color,
      stroke: i.color,
      variant: i,
      pmsValue: i.name
    })) ?? [];
  }
  selectImage(e, t, n, i = !0) {
    const a = ug.patternSource(t), s = n.getStepStorage(e.stepName)?.framePatternSrc;
    if (s && s === a)
      return Promise.resolve();
    n.setEditedStatus(e.stepName, !0);
    const o = t.fileLink || "";
    return o.endsWith(".pdf") || o.endsWith(".eps") || o.endsWith(".ai") ? new Promise((l) => {
      n.addPoller(
        new TF(
          async () => {
            const c = (await zn.getFromServer(t.key || "")).versions?.find((f) => f.name === "svg");
            return c ? (await Ms(c.link)).status === 200 : !1;
          },
          () => {
            zn.getLocalOrFromServer(t.key || "").then((u) => {
              this.loadPatternFromAsset(u, e, n, i).then(
                l
              );
            });
          },
          () => {
            throw new Tg("Failed to resolve transcoded PDF");
          }
        )
      );
    }) : this.loadPatternFromAsset(t, e, n, i);
  }
  async selectVariant(e, t, n, i, a) {
    const s = await this.selectVariantCommand(
      e,
      t,
      n,
      i,
      a
    );
    s && (s.command && i.getCommandDispatcher()(s.command), s.followup && await s.followup());
  }
  getCreateElementCommand(e, t, n, i, a) {
    return new fi(
      {
        id: e,
        type: tr.Frame,
        x: t.left,
        y: t.top,
        width: t.width,
        height: t.height,
        layer: t.layer,
        layerIndex: t.layerIndex,
        rotation: t.rotation,
        scaleX: t.width / a.frameData.width,
        scaleY: t.height / a.frameData.height,
        path: a.frameData.path,
        dataWidth: a.frameData.width,
        dataHeight: a.frameData.height,
        stepRegion: t,
        stepRegionIndex: n,
        stepName: a.stepName,
        disablePlaceholder: a.disablePlaceholder,
        pattern: a.pattern,
        immutable: t.immutable
      },
      i
    );
  }
  async loadPatternFromString(e, t, n = !0, i = void 0, a) {
    if (new URL(e).pathname.endsWith(".svg")) {
      const l = await h1(e), u = l.width, c = l.height, d = await ha(e);
      if (a) {
        const g = d.match(/<(image|linearGradient|radialGradient)(\s|>|\/>)/gim);
        if (g && g.length > 0)
          throw new Error(
            "Vector files may not include images or gradients when a color limit is specified."
          );
      }
      const f = await ss(d), h = {
        src: e,
        width: u,
        height: c,
        aspect: u / c,
        svg: f.svg,
        colors: i ?? f.colors
      };
      io.set(e, h), t.setPatternData(h, n);
    } else {
      const l = await Fg(e, !0), u = await Dg(l), c = {
        src: e,
        width: u.width,
        height: u.height,
        aspect: u.width / u.height,
        svg: void 0,
        colors: void 0
      };
      io.set(e, c), t.setPatternData(c, n);
    }
  }
  async changeColors(e, t, n) {
    const i = t.getWorkflowExperience().getStepById(e.stepName)?.frameService;
    if (!i || !i.getImageData()?.svg) {
      console.warn("changeColors was called without an SVG being assigned to a frame step");
      return;
    }
    const a = await this.calculateColorMetadata(i, e, n);
    t.updateMetadata(e.stepName, { colors: a.metadataColors }), t.updateStorage(e.stepName, {
      colors: a.storageColors
    }), i.setPatternData(
      {
        ...i.getImageData(),
        colors: a.newColors
      },
      !1
    ), this.validateColorCount(e, t);
  }
  getUniqueColorCount(e, t) {
    const n = t.getWorkflowExperience().getStepById(e.stepName)?.frameService;
    if (!n) return 0;
    const i = n.getImageData()?.colors ?? {}, a = [];
    for (const s in i) {
      const o = i[s];
      if (o.pmsValue) {
        const l = o.pmsValue.trim().toLocaleLowerCase();
        a.includes(l) || a.push(l);
      } else if (o.browserValue) {
        const l = XO(o.browserValue);
        a.includes(l) || a.push(l);
      }
    }
    return a.length;
  }
  async calculateColorMetadata(e, t, n) {
    if (!e.getImageData()?.svg)
      return {
        newColors: void 0,
        metadataColors: void 0,
        storageColors: void 0
      };
    const i = { ...e.getImageData().colors ?? {} }, a = {};
    Object.entries(i).forEach(([l, u]) => {
      const c = { browserValue: u.browserValue };
      a[l] = c;
    });
    for (const [l, u] of n.entries())
      i[l] = { browserValue: u.browserValue, pmsValue: u.pmsValue }, a[l] = u;
    let s = Array.from(Object.values(i)).map((l) => l.browserValue);
    const o = await ft.ensureFullOption(t.data.colorOption);
    return o && o.variants?.forEach((l) => {
      s = s.map((u) => u.toLowerCase() === l.color?.toLowerCase() ? l.name : u);
    }), {
      newColors: i,
      metadataColors: s,
      storageColors: a
    };
  }
  validateColorCount(e, t) {
    const n = e.data.colorPickerEnabled ? e.data.maxColors ?? 0 : 0;
    t.setStepError(
      e.stepName,
      "colors",
      n > 0 && this.getUniqueColorCount(e, t) > n ? "workflow.steps.frame.tooManyColors" : void 0
    );
  }
  async selectVariantCommand(e, t, n, i, a, s) {
    const o = i.getWorkflowExperience().getStepById(e.stepName)?.frameService;
    if (!o) throw new Error("Frame service unavailable, cannot load pattern!");
    const l = await Promise.all(
      e.data.regions.map((h) => this.frameSourceSvg(t, h))
    );
    a && a(!0);
    const u = e.data.initialZoomLevel, c = await Promise.all(
      e.data.regions.map(async (h, g) => {
        const v = await Mg(l[g]), y = o.getImageData(), A = n.map((M) => new cc(M.id)), x = y ? d1(
          y,
          v,
          u && !e.data.forceImageCover ? { scale: u } : void 0,
          e.data.forceImageCover
        ) : void 0, k = y ? {
          id: br(),
          src: y.src,
          x: x?.x || 0,
          y: x?.y || 0,
          width: y.width,
          height: y.height,
          scaleX: x?.zoom || 1,
          scaleY: x?.zoom || 1,
          rotation: 0
        } : void 0, F = br(), R = i.getLayouts().find((M) => M.panelId === h.panelId);
        if (!R)
          throw new Ei(h);
        return {
          command: this.getCreateElementCommand(F, h, g, R, {
            frameData: v,
            pattern: k,
            disablePlaceholder: e.data.disablePlaceholder,
            stepName: e.stepName
          }),
          regionEl: {
            id: F,
            region: h,
            regionIndex: g
          },
          removeExistingCommands: A
        };
      })
    ), d = c.map((h) => h.command), f = c.map((h) => h.removeExistingCommands).flat();
    return {
      command: new Nn([...d, ...f]),
      followup: async () => {
        a && a(!1), await i.setSelectionsAndElements(
          e.stepName,
          t ? [t] : [],
          [...c.map((h) => h.regionEl)],
          async () => {
            if (i.updateStorage(e.stepName, { currentFrameSources: l }), s) {
              const h = i.getWorkflowExperience().getStepById(e.stepName)?.frameService;
              if (!h) throw new Error("Frame service unavailable, cannot load pattern!");
              await this.loadPatternFromString(s, h, !0);
            }
          }
        );
      }
    };
  }
  /**
   * Grab the source to be used for a frame from the variant or throw otherwise.
   */
  static patternSource(e) {
    const t = e.versions?.find((i) => i.name === "svg");
    if (t?.link)
      return t.link;
    const n = e.fileLink;
    if (n)
      return n;
    throw new ad(e);
  }
  async loadPatternFromAsset(e, t, n, i) {
    const a = ug.patternSource(e), s = n.markUpdatePending(), o = n.getWorkflowExperience().getStepById(t.stepName)?.frameService;
    if (!o)
      throw n.markUpdateCompleted(s), new Error("Frame service unavailable, cannot load pattern!");
    try {
      await this.loadPatternFromString(
        a,
        o,
        i,
        void 0,
        t.data.colorPickerEnabled && !!t.data.maxColors && t.data.maxColors > 0
      );
    } catch (u) {
      throw n.markUpdateCompleted(s), u;
    }
    const l = await this.calculateColorMetadata(
      o,
      t,
      new Map(Object.entries(o.getImageData()?.colors ?? {}))
    );
    n.updateMetadata(t.stepName, { image: a, colors: l.metadataColors }), n.updateStorage(t.stepName, {
      framePatternSrc: a,
      colors: l.storageColors
    }), n.markUpdateCompleted(s), n.setMandatoryFulfilled(t.stepName, !0), n.setInformationResults(
      n.getInformationResults().filter((u) => u.stepID === t.stepName)
    ), this.validateColorCount(t, n);
  }
}
const ul = new ug();
class x7 {
  async getIllustrationBody(e) {
    return new Promise((t) => {
      ha(e, !0).then((n) => {
        t(n);
      }).catch((n) => console.error(n));
    });
  }
  getCreateElementCommand(e, t, n, i, a) {
    return new fi(
      {
        stepRegion: t,
        stepRegionIndex: n,
        stepName: a.stepName,
        colors: a.svg.colors,
        id: e,
        src: a.src,
        svg: a.svg.svg,
        cachedObjectURL: a.objectURL,
        type: tr.Illustration,
        y: t.top,
        x: t.left,
        rotation: t.rotation,
        width: t.width,
        height: t.height,
        layer: t.layer,
        layerIndex: t.layerIndex,
        immutable: t.immutable
      },
      i
    );
  }
  getColors(e, t) {
    const n = t.getRegionElements(e.stepName) || [];
    if (n.length === 0) return [];
    try {
      return $n(
        n[0].id,
        t.getAllLayoutData()
      ).colors;
    } catch {
      return [];
    }
  }
  async init(e, t, n) {
    const i = await ft.getOptionForStep(e);
    if (!i)
      throw new Is(e, "No option configured for illustration step.");
    if (n)
      return await this.reload(e, t, n);
    {
      const a = await ft.getDefaultVariant(i, e.overrideDefaultVariantId);
      if (a)
        return await this.selectVariantCommand(e, a, [], t);
    }
    return null;
  }
  async reload(e, t, n) {
    const i = t.getSerializedStep(
      e.stepName,
      n.serializableWorkflow.steps
    ), o = Object.values(n.layouts).map((u) => u.elements).flat().filter((u) => u.stepName === e.stepName), l = await ft.getOptionForStep(e);
    if (i?.selectedVariants) {
      const u = i.selectedVariants[0].id;
      if (l && u) {
        const c = l.variants?.find((d) => d.id === u);
        if (c) {
          const d = o.map((f) => ({
            id: f.id,
            region: f.stepRegion,
            regionIndex: f.stepRegionIndex
          }));
          await t.setSelectionsAndElements(
            e.stepName,
            [c],
            d,
            async () => {
              t.updateMetadata(e.stepName, {
                colors: i.storage?.colors
              });
            }
          );
        }
      } else throw new Error("Required illustration variant no longer available");
    }
    return null;
  }
  async availableColors(e, t) {
    const n = await ft.ensureFullOption(e.data.colorOption);
    return n ? n ? n.variants?.map((i) => ({
      fill: i.color,
      stroke: i.color,
      variant: i,
      pmsValue: i.name
    })) : [] : [];
  }
  async changeColorsCommand(e, t, n, i, a) {
    const s = {};
    for (const [c, d] of a.entries())
      typeof d == "string" ? s[c] = {
        browserValue: d,
        spotColor: void 0,
        pmsValue: void 0
      } : s[c] = {
        browserValue: d.browserValue,
        spotColor: d.spotColor,
        pmsValue: d.pmsValue
      };
    const o = VA(e, t, n, s), l = await hd(o), u = [];
    for (const c of i) {
      for (const [d, f] of a.entries())
        u.push(new qy(c, d, f));
      u.push(new K8(c, o, l));
    }
    return new Nn(u);
  }
  async changeColors(e, t, n, i) {
    if (t.length === 0)
      return;
    const a = $n(
      t[0].id,
      n.getCommandContext().getAllLayouts().map((f) => f.layoutState)
    ), s = { ...a.colors }, o = {};
    Object.entries(s).forEach(([f, h]) => {
      const g = { browserValue: h.browserValue, pmsValue: h.pmsValue }, v = h.spotColor;
      v && (g.spotColor = { profileName: v.profileName, namedColor: v.namedColor }), o[f] = g;
    });
    for (const [f, h] of i.entries()) {
      const g = typeof h == "string" ? h : h.browserValue, v = typeof h == "string" ? void 0 : h.pmsValue;
      f === "" ? Object.keys(s).forEach((y) => {
        s[y] = { browserValue: g, spotColor: s[y]?.spotColor, pmsValue: v }, o[y] = { browserValue: g };
      }) : (s[f] = { browserValue: g, spotColor: s[f]?.spotColor, pmsValue: v }, o[f] = { browserValue: g });
    }
    let l = Array.from(Object.values(s)).map((f) => f.browserValue);
    const u = await ft.ensureFullOption(e.data.colorOption);
    u && u.variants?.forEach((f) => {
      l = l.map((h) => h.toLowerCase() === f.color?.toLowerCase() ? f.name : h);
    }), n.updateMetadata(e.stepName, { colors: l });
    const c = /* @__PURE__ */ new Map();
    if (Object.entries(s).forEach(([f, h]) => {
      c.set(f, h);
    }), !a.svg)
      throw new Error("Colors changed before SVG loaded. This should never happen!");
    const d = await this.changeColorsCommand(
      a.svg,
      a.width,
      a.height,
      t.map((f) => f.id),
      c
    );
    n.updateStorage(e.stepName, {
      colors: o
    }), n.getCommandDispatcher()(d);
  }
  async selectVariant(e, t, n, i, a) {
    i(!0);
    try {
      const s = await this.selectVariantCommand(e, t, n, a);
      s && (s.command && a.getCommandDispatcher()(s.command), s.followup && await s.followup());
    } finally {
      i(!1);
    }
  }
  async selectVariantCommand(e, t, n, i) {
    if (!e.data || !e.data.regions)
      throw new Is(e, "Missing regions.");
    const a = t.asset;
    if (!a)
      throw new bl(t);
    const s = a.fileLink;
    if (!s)
      throw new ad(a);
    e.mandatory && i.setMandatoryFulfilled(e.stepName, !1);
    const o = n.map((y) => new cc(y.id)), l = await ss(await this.getIllustrationBody(s)), u = await hd(l.svg), c = (y, A) => {
      const x = i.getLayouts().find((F) => F.panelId === y.panelId);
      if (!x)
        throw new Ei(y);
      const k = br();
      return {
        regionElement: { id: k, region: y, regionIndex: A },
        command: this.getCreateElementCommand(k, y, A, x, {
          stepName: e.stepName,
          src: s,
          objectURL: u,
          svg: l
        })
      };
    }, d = e.data.regions.map(c), f = d.map((y) => y.command), h = [...o, ...f];
    let g = Array.from(Object.values(l.colors)).map((y) => y.browserValue);
    const v = await ft.ensureFullOption(e.data.colorOption);
    return v && v.variants?.forEach((y) => {
      g = g.map((A) => A.toLowerCase() === y.color?.toLowerCase() ? y.name : A);
    }), i.updateMetadata(e.stepName, { colors: g }), {
      command: new Nn(h),
      followup: async () => {
        const y = d.map((x) => x.regionElement);
        await i.setSelectionsAndElements(e.stepName, [t], y);
        const A = a.assetConfiguration?.defaultColorVariants || [];
        if (A.length !== 0) {
          const x = {};
          (a.assetConfiguration?.channelNumbers || []).forEach((F) => {
            const S = A.find((R) => R.channelNumber === F.number);
            S && (x[`${F.id.replace(/\W/g, "")}`] = { browserValue: S?.variant?.color || "" });
          }), await this.changeColors(
            e,
            y,
            i,
            new Map(Object.entries(x))
          );
        }
        if (e.data.colorPickerEnabled) {
          const x = await this.availableColors(e, i) || [], k = Object.keys(l.colors), F = x.length === 1 && k.length === 1;
          if (F) {
            const S = x[0], R = k[0];
            await this.changeColors(
              e,
              y,
              i,
              /* @__PURE__ */ new Map([[R, S.variant.color]])
            );
          }
          !F && A.length === 0 && await this.changeColors(e, y, i, /* @__PURE__ */ new Map());
        }
      }
    };
  }
}
const Lp = new x7();
class C7 {
  async init(e, t, n) {
    const i = await ft.getOptionForStep(e);
    if (!i)
      throw new Xp(e);
    if (n)
      await this.reload(e, t, n);
    else {
      const a = await ft.getDefaultVariant(i, e.overrideDefaultVariantId);
      if (a)
        return await this.selectVariantLambda(e, a, t, () => {
        });
    }
    return null;
  }
  async reload(e, t, n) {
    const i = t.getSerializedStep(
      e.stepName,
      n.serializableWorkflow.steps
    ), o = Object.values(n.layouts).map((u) => u.elements).flat().filter((u) => u.stepName === e.stepName), l = await ft.getOptionForStep(e);
    if (!l) throw new Xp(e);
    if (i?.selectedVariants) {
      const u = i.selectedVariants[0].id;
      if (u) {
        const c = l.variants?.find((d) => d.id === u);
        if (c) {
          const d = c.material, f = o.map((h) => ({
            id: h.id,
            region: h.stepRegion,
            regionIndex: h.stepRegionIndex
          }));
          await t.setSelectionsAndElements(
            e.stepName,
            [c],
            f,
            async () => {
              const h = t.getModelContainer();
              if (h) {
                const g = e.data.targetMaterials.map((v) => h.applyMaterialVariant(
                  v,
                  l.id || "",
                  d || {}
                ));
                Promise.all(g);
              }
            }
          );
        }
      }
    }
  }
  async selectVariant(e, t, n, i) {
    const a = await this.selectVariantLambda(e, t, n, i);
    a && (a.command && n.getCommandDispatcher()(a.command), a.followup && await a.followup());
  }
  async selectVariantLambda(e, t, n, i) {
    const a = n.getModelContainer();
    i(!0);
    const s = t.material;
    if (!s)
      throw i(!1), new bl(t);
    return {
      command: void 0,
      followup: async () => {
        await n.setSelectionsAndElements(e.stepName, [t], [], async () => {
          try {
            a && e.data.targetMaterials.forEach((o) => {
              e.option && a.applyMaterialVariant(o, e.option.id || "", s);
            });
          } finally {
            i(!1);
          }
        });
      }
    };
  }
}
const IF = new C7();
class S7 {
  async init(e, t, n) {
    const i = await ft.getOptionForStep(e);
    if (!i) throw new Xp(e);
    if (n)
      await this.reload(e, t, n);
    else {
      const a = await ft.getDefaultVariant(i, e.overrideDefaultVariantId);
      if (a)
        return await this.selectVariantLambda(e, a, t, () => {
        });
    }
    return null;
  }
  async reload(e, t, n) {
    const i = t.getSerializedStep(
      e.stepName,
      n.serializableWorkflow.steps
    ), o = Object.values(n.layouts).map((u) => u.elements).flat().filter((u) => u.stepName === e.stepName), l = await ft.getOptionForStep(e);
    if (i?.selectedVariants) {
      const u = i.selectedVariants[0].id;
      if (l && u) {
        const c = l.variants?.find((d) => d.id === u);
        if (c) {
          const d = o.map((f) => ({
            id: f.id,
            region: f.stepRegion,
            regionIndex: f.stepRegionIndex
          }));
          await t.setSelectionsAndElements(
            e.stepName,
            [c],
            d,
            async () => {
              const f = t.getModelContainer();
              if (f && e.option) {
                const h = c.asset?.fileLink;
                if (!h) throw new bl(c);
                await f.applyModelVariant(
                  e.stepName || "",
                  {
                    model: h,
                    contextService: t.getLayoutPreviewService()
                  },
                  e.data.replaceProductModel || !1
                );
              }
            }
          );
        }
      }
    }
  }
  async selectVariant(e, t, n, i) {
    const a = await this.selectVariantLambda(e, t, n, i);
    a && (a.command && n.getCommandDispatcher()(a.command), a.followup && await a.followup());
  }
  async selectVariantLambda(e, t, n, i) {
    i(!0);
    const a = t.asset?.fileLink;
    if (!a)
      throw new bl(t);
    return {
      command: void 0,
      followup: async () => {
        await n.setSelectionsAndElements(e.stepName, [t], [], async () => {
          try {
            const s = n.getModelContainer();
            s && await s.applyModelVariant(
              e.stepName,
              {
                model: a,
                contextService: n.getLayoutPreviewService()
              },
              e.data.replaceProductModel || !1
            );
          } finally {
            i(!1);
          }
        });
      }
    };
  }
}
const DF = new S7();
var yf = {}, Af = {}, bf = {}, GS;
function E7() {
  return GS || (GS = 1, Object.defineProperty(bf, "__esModule", { value: !0 }), bf.extendedPictographic = /^[\u00A9\u00AE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9-\u21AA\u231A-\u231B\u2328\u2388\u23CF\u23E9-\u23EC\u23ED-\u23EE\u23EF\u23F0\u23F1-\u23F2\u23F3\u23F8-\u23FA\u24C2\u25AA-\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2601\u2602-\u2603\u2604\u2605\u2607-\u260D\u260E\u260F-\u2610\u2611\u2612\u2614-\u2615\u2616-\u2617\u2618\u2619-\u261C\u261D\u261E-\u261F\u2620\u2621\u2622-\u2623\u2624-\u2625\u2626\u2627-\u2629\u262A\u262B-\u262D\u262E\u262F\u2630-\u2637\u2638-\u2639\u263A\u263B-\u263F\u2640\u2641\u2642\u2643-\u2647\u2648-\u2653\u2654-\u265E\u265F\u2660\u2661-\u2662\u2663\u2664\u2665-\u2666\u2667\u2668\u2669-\u267A\u267B\u267C-\u267D\u267E\u267F\u2680-\u2685\u2690-\u2691\u2692\u2693\u2694\u2695\u2696-\u2697\u2698\u2699\u269A\u269B-\u269C\u269D-\u269F\u26A0-\u26A1\u26A2-\u26A6\u26A7\u26A8-\u26A9\u26AA-\u26AB\u26AC-\u26AF\u26B0-\u26B1\u26B2-\u26BC\u26BD-\u26BE\u26BF-\u26C3\u26C4-\u26C5\u26C6-\u26C7\u26C8\u26C9-\u26CD\u26CE\u26CF\u26D0\u26D1\u26D2\u26D3\u26D4\u26D5-\u26E8\u26E9\u26EA\u26EB-\u26EF\u26F0-\u26F1\u26F2-\u26F3\u26F4\u26F5\u26F6\u26F7-\u26F9\u26FA\u26FB-\u26FC\u26FD\u26FE-\u2701\u2702\u2703-\u2704\u2705\u2708-\u270C\u270D\u270E\u270F\u2710-\u2711\u2712\u2714\u2716\u271D\u2721\u2728\u2733-\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2765-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934-\u2935\u2B05-\u2B07\u2B1B-\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299\u{01F000}-\u{01F003}\u{01F004}\u{01F005}-\u{01F0CE}\u{01F0CF}\u{01F0D0}-\u{01F0FF}\u{01F10D}-\u{01F10F}\u{01F12F}\u{01F16C}-\u{01F16F}\u{01F170}-\u{01F171}\u{01F17E}-\u{01F17F}\u{01F18E}\u{01F191}-\u{01F19A}\u{01F1AD}-\u{01F1E5}\u{01F201}-\u{01F202}\u{01F203}-\u{01F20F}\u{01F21A}\u{01F22F}\u{01F232}-\u{01F23A}\u{01F23C}-\u{01F23F}\u{01F249}-\u{01F24F}\u{01F250}-\u{01F251}\u{01F252}-\u{01F2FF}\u{01F300}-\u{01F30C}\u{01F30D}-\u{01F30E}\u{01F30F}\u{01F310}\u{01F311}\u{01F312}\u{01F313}-\u{01F315}\u{01F316}-\u{01F318}\u{01F319}\u{01F31A}\u{01F31B}\u{01F31C}\u{01F31D}-\u{01F31E}\u{01F31F}-\u{01F320}\u{01F321}\u{01F322}-\u{01F323}\u{01F324}-\u{01F32C}\u{01F32D}-\u{01F32F}\u{01F330}-\u{01F331}\u{01F332}-\u{01F333}\u{01F334}-\u{01F335}\u{01F336}\u{01F337}-\u{01F34A}\u{01F34B}\u{01F34C}-\u{01F34F}\u{01F350}\u{01F351}-\u{01F37B}\u{01F37C}\u{01F37D}\u{01F37E}-\u{01F37F}\u{01F380}-\u{01F393}\u{01F394}-\u{01F395}\u{01F396}-\u{01F397}\u{01F398}\u{01F399}-\u{01F39B}\u{01F39C}-\u{01F39D}\u{01F39E}-\u{01F39F}\u{01F3A0}-\u{01F3C4}\u{01F3C5}\u{01F3C6}\u{01F3C7}\u{01F3C8}\u{01F3C9}\u{01F3CA}\u{01F3CB}-\u{01F3CE}\u{01F3CF}-\u{01F3D3}\u{01F3D4}-\u{01F3DF}\u{01F3E0}-\u{01F3E3}\u{01F3E4}\u{01F3E5}-\u{01F3F0}\u{01F3F1}-\u{01F3F2}\u{01F3F3}\u{01F3F4}\u{01F3F5}\u{01F3F6}\u{01F3F7}\u{01F3F8}-\u{01F3FA}\u{01F400}-\u{01F407}\u{01F408}\u{01F409}-\u{01F40B}\u{01F40C}-\u{01F40E}\u{01F40F}-\u{01F410}\u{01F411}-\u{01F412}\u{01F413}\u{01F414}\u{01F415}\u{01F416}\u{01F417}-\u{01F429}\u{01F42A}\u{01F42B}-\u{01F43E}\u{01F43F}\u{01F440}\u{01F441}\u{01F442}-\u{01F464}\u{01F465}\u{01F466}-\u{01F46B}\u{01F46C}-\u{01F46D}\u{01F46E}-\u{01F4AC}\u{01F4AD}\u{01F4AE}-\u{01F4B5}\u{01F4B6}-\u{01F4B7}\u{01F4B8}-\u{01F4EB}\u{01F4EC}-\u{01F4ED}\u{01F4EE}\u{01F4EF}\u{01F4F0}-\u{01F4F4}\u{01F4F5}\u{01F4F6}-\u{01F4F7}\u{01F4F8}\u{01F4F9}-\u{01F4FC}\u{01F4FD}\u{01F4FE}\u{01F4FF}-\u{01F502}\u{01F503}\u{01F504}-\u{01F507}\u{01F508}\u{01F509}\u{01F50A}-\u{01F514}\u{01F515}\u{01F516}-\u{01F52B}\u{01F52C}-\u{01F52D}\u{01F52E}-\u{01F53D}\u{01F546}-\u{01F548}\u{01F549}-\u{01F54A}\u{01F54B}-\u{01F54E}\u{01F54F}\u{01F550}-\u{01F55B}\u{01F55C}-\u{01F567}\u{01F568}-\u{01F56E}\u{01F56F}-\u{01F570}\u{01F571}-\u{01F572}\u{01F573}-\u{01F579}\u{01F57A}\u{01F57B}-\u{01F586}\u{01F587}\u{01F588}-\u{01F589}\u{01F58A}-\u{01F58D}\u{01F58E}-\u{01F58F}\u{01F590}\u{01F591}-\u{01F594}\u{01F595}-\u{01F596}\u{01F597}-\u{01F5A3}\u{01F5A4}\u{01F5A5}\u{01F5A6}-\u{01F5A7}\u{01F5A8}\u{01F5A9}-\u{01F5B0}\u{01F5B1}-\u{01F5B2}\u{01F5B3}-\u{01F5BB}\u{01F5BC}\u{01F5BD}-\u{01F5C1}\u{01F5C2}-\u{01F5C4}\u{01F5C5}-\u{01F5D0}\u{01F5D1}-\u{01F5D3}\u{01F5D4}-\u{01F5DB}\u{01F5DC}-\u{01F5DE}\u{01F5DF}-\u{01F5E0}\u{01F5E1}\u{01F5E2}\u{01F5E3}\u{01F5E4}-\u{01F5E7}\u{01F5E8}\u{01F5E9}-\u{01F5EE}\u{01F5EF}\u{01F5F0}-\u{01F5F2}\u{01F5F3}\u{01F5F4}-\u{01F5F9}\u{01F5FA}\u{01F5FB}-\u{01F5FF}\u{01F600}\u{01F601}-\u{01F606}\u{01F607}-\u{01F608}\u{01F609}-\u{01F60D}\u{01F60E}\u{01F60F}\u{01F610}\u{01F611}\u{01F612}-\u{01F614}\u{01F615}\u{01F616}\u{01F617}\u{01F618}\u{01F619}\u{01F61A}\u{01F61B}\u{01F61C}-\u{01F61E}\u{01F61F}\u{01F620}-\u{01F625}\u{01F626}-\u{01F627}\u{01F628}-\u{01F62B}\u{01F62C}\u{01F62D}\u{01F62E}-\u{01F62F}\u{01F630}-\u{01F633}\u{01F634}\u{01F635}\u{01F636}\u{01F637}-\u{01F640}\u{01F641}-\u{01F644}\u{01F645}-\u{01F64F}\u{01F680}\u{01F681}-\u{01F682}\u{01F683}-\u{01F685}\u{01F686}\u{01F687}\u{01F688}\u{01F689}\u{01F68A}-\u{01F68B}\u{01F68C}\u{01F68D}\u{01F68E}\u{01F68F}\u{01F690}\u{01F691}-\u{01F693}\u{01F694}\u{01F695}\u{01F696}\u{01F697}\u{01F698}\u{01F699}-\u{01F69A}\u{01F69B}-\u{01F6A1}\u{01F6A2}\u{01F6A3}\u{01F6A4}-\u{01F6A5}\u{01F6A6}\u{01F6A7}-\u{01F6AD}\u{01F6AE}-\u{01F6B1}\u{01F6B2}\u{01F6B3}-\u{01F6B5}\u{01F6B6}\u{01F6B7}-\u{01F6B8}\u{01F6B9}-\u{01F6BE}\u{01F6BF}\u{01F6C0}\u{01F6C1}-\u{01F6C5}\u{01F6C6}-\u{01F6CA}\u{01F6CB}\u{01F6CC}\u{01F6CD}-\u{01F6CF}\u{01F6D0}\u{01F6D1}-\u{01F6D2}\u{01F6D3}-\u{01F6D4}\u{01F6D5}\u{01F6D6}-\u{01F6D7}\u{01F6D8}-\u{01F6DF}\u{01F6E0}-\u{01F6E5}\u{01F6E6}-\u{01F6E8}\u{01F6E9}\u{01F6EA}\u{01F6EB}-\u{01F6EC}\u{01F6ED}-\u{01F6EF}\u{01F6F0}\u{01F6F1}-\u{01F6F2}\u{01F6F3}\u{01F6F4}-\u{01F6F6}\u{01F6F7}-\u{01F6F8}\u{01F6F9}\u{01F6FA}\u{01F6FB}-\u{01F6FC}\u{01F6FD}-\u{01F6FF}\u{01F774}-\u{01F77F}\u{01F7D5}-\u{01F7DF}\u{01F7E0}-\u{01F7EB}\u{01F7EC}-\u{01F7FF}\u{01F80C}-\u{01F80F}\u{01F848}-\u{01F84F}\u{01F85A}-\u{01F85F}\u{01F888}-\u{01F88F}\u{01F8AE}-\u{01F8FF}\u{01F90C}\u{01F90D}-\u{01F90F}\u{01F910}-\u{01F918}\u{01F919}-\u{01F91E}\u{01F91F}\u{01F920}-\u{01F927}\u{01F928}-\u{01F92F}\u{01F930}\u{01F931}-\u{01F932}\u{01F933}-\u{01F93A}\u{01F93C}-\u{01F93E}\u{01F93F}\u{01F940}-\u{01F945}\u{01F947}-\u{01F94B}\u{01F94C}\u{01F94D}-\u{01F94F}\u{01F950}-\u{01F95E}\u{01F95F}-\u{01F96B}\u{01F96C}-\u{01F970}\u{01F971}\u{01F972}\u{01F973}-\u{01F976}\u{01F977}-\u{01F978}\u{01F979}\u{01F97A}\u{01F97B}\u{01F97C}-\u{01F97F}\u{01F980}-\u{01F984}\u{01F985}-\u{01F991}\u{01F992}-\u{01F997}\u{01F998}-\u{01F9A2}\u{01F9A3}-\u{01F9A4}\u{01F9A5}-\u{01F9AA}\u{01F9AB}-\u{01F9AD}\u{01F9AE}-\u{01F9AF}\u{01F9B0}-\u{01F9B9}\u{01F9BA}-\u{01F9BF}\u{01F9C0}\u{01F9C1}-\u{01F9C2}\u{01F9C3}-\u{01F9CA}\u{01F9CB}\u{01F9CC}\u{01F9CD}-\u{01F9CF}\u{01F9D0}-\u{01F9E6}\u{01F9E7}-\u{01F9FF}\u{01FA00}-\u{01FA6F}\u{01FA70}-\u{01FA73}\u{01FA74}\u{01FA75}-\u{01FA77}\u{01FA78}-\u{01FA7A}\u{01FA7B}-\u{01FA7F}\u{01FA80}-\u{01FA82}\u{01FA83}-\u{01FA86}\u{01FA87}-\u{01FA8F}\u{01FA90}-\u{01FA95}\u{01FA96}-\u{01FAA8}\u{01FAA9}-\u{01FAAF}\u{01FAB0}-\u{01FAB6}\u{01FAB7}-\u{01FABF}\u{01FAC0}-\u{01FAC2}\u{01FAC3}-\u{01FACF}\u{01FAD0}-\u{01FAD6}\u{01FAD7}-\u{01FAFF}\u{01FC00}-\u{01FFFD}]/u, bf.WORD_BREAK_PROPERTY = [
    [
      /*start*/
      0,
      0
      /* Other */
    ],
    [
      /*start*/
      10,
      1
      /* LF */
    ],
    [
      /*start*/
      11,
      2
      /* Newline */
    ],
    [
      /*start*/
      13,
      3
      /* CR */
    ],
    [
      /*start*/
      14,
      0
      /* Other */
    ],
    [
      /*start*/
      32,
      4
      /* WSegSpace */
    ],
    [
      /*start*/
      33,
      0
      /* Other */
    ],
    [
      /*start*/
      34,
      5
      /* Double_Quote */
    ],
    [
      /*start*/
      35,
      0
      /* Other */
    ],
    [
      /*start*/
      39,
      6
      /* Single_Quote */
    ],
    [
      /*start*/
      40,
      0
      /* Other */
    ],
    [
      /*start*/
      44,
      7
      /* MidNum */
    ],
    [
      /*start*/
      45,
      0
      /* Other */
    ],
    [
      /*start*/
      46,
      8
      /* MidNumLet */
    ],
    [
      /*start*/
      47,
      0
      /* Other */
    ],
    [
      /*start*/
      48,
      9
      /* Numeric */
    ],
    [
      /*start*/
      58,
      10
      /* MidLetter */
    ],
    [
      /*start*/
      59,
      7
      /* MidNum */
    ],
    [
      /*start*/
      60,
      0
      /* Other */
    ],
    [
      /*start*/
      65,
      11
      /* ALetter */
    ],
    [
      /*start*/
      91,
      0
      /* Other */
    ],
    [
      /*start*/
      95,
      12
      /* ExtendNumLet */
    ],
    [
      /*start*/
      96,
      0
      /* Other */
    ],
    [
      /*start*/
      97,
      11
      /* ALetter */
    ],
    [
      /*start*/
      123,
      0
      /* Other */
    ],
    [
      /*start*/
      133,
      2
      /* Newline */
    ],
    [
      /*start*/
      134,
      0
      /* Other */
    ],
    [
      /*start*/
      170,
      11
      /* ALetter */
    ],
    [
      /*start*/
      171,
      0
      /* Other */
    ],
    [
      /*start*/
      173,
      13
      /* Format */
    ],
    [
      /*start*/
      174,
      0
      /* Other */
    ],
    [
      /*start*/
      181,
      11
      /* ALetter */
    ],
    [
      /*start*/
      182,
      0
      /* Other */
    ],
    [
      /*start*/
      183,
      10
      /* MidLetter */
    ],
    [
      /*start*/
      184,
      0
      /* Other */
    ],
    [
      /*start*/
      186,
      11
      /* ALetter */
    ],
    [
      /*start*/
      187,
      0
      /* Other */
    ],
    [
      /*start*/
      192,
      11
      /* ALetter */
    ],
    [
      /*start*/
      215,
      0
      /* Other */
    ],
    [
      /*start*/
      216,
      11
      /* ALetter */
    ],
    [
      /*start*/
      247,
      0
      /* Other */
    ],
    [
      /*start*/
      248,
      11
      /* ALetter */
    ],
    [
      /*start*/
      728,
      0
      /* Other */
    ],
    [
      /*start*/
      734,
      11
      /* ALetter */
    ],
    [
      /*start*/
      768,
      14
      /* Extend */
    ],
    [
      /*start*/
      880,
      11
      /* ALetter */
    ],
    [
      /*start*/
      885,
      0
      /* Other */
    ],
    [
      /*start*/
      886,
      11
      /* ALetter */
    ],
    [
      /*start*/
      888,
      0
      /* Other */
    ],
    [
      /*start*/
      890,
      11
      /* ALetter */
    ],
    [
      /*start*/
      894,
      7
      /* MidNum */
    ],
    [
      /*start*/
      895,
      11
      /* ALetter */
    ],
    [
      /*start*/
      896,
      0
      /* Other */
    ],
    [
      /*start*/
      902,
      11
      /* ALetter */
    ],
    [
      /*start*/
      903,
      10
      /* MidLetter */
    ],
    [
      /*start*/
      904,
      11
      /* ALetter */
    ],
    [
      /*start*/
      907,
      0
      /* Other */
    ],
    [
      /*start*/
      908,
      11
      /* ALetter */
    ],
    [
      /*start*/
      909,
      0
      /* Other */
    ],
    [
      /*start*/
      910,
      11
      /* ALetter */
    ],
    [
      /*start*/
      930,
      0
      /* Other */
    ],
    [
      /*start*/
      931,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1014,
      0
      /* Other */
    ],
    [
      /*start*/
      1015,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1154,
      0
      /* Other */
    ],
    [
      /*start*/
      1155,
      14
      /* Extend */
    ],
    [
      /*start*/
      1162,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1328,
      0
      /* Other */
    ],
    [
      /*start*/
      1329,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1367,
      0
      /* Other */
    ],
    [
      /*start*/
      1369,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1373,
      0
      /* Other */
    ],
    [
      /*start*/
      1374,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1375,
      10
      /* MidLetter */
    ],
    [
      /*start*/
      1376,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1417,
      7
      /* MidNum */
    ],
    [
      /*start*/
      1418,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1419,
      0
      /* Other */
    ],
    [
      /*start*/
      1425,
      14
      /* Extend */
    ],
    [
      /*start*/
      1470,
      0
      /* Other */
    ],
    [
      /*start*/
      1471,
      14
      /* Extend */
    ],
    [
      /*start*/
      1472,
      0
      /* Other */
    ],
    [
      /*start*/
      1473,
      14
      /* Extend */
    ],
    [
      /*start*/
      1475,
      0
      /* Other */
    ],
    [
      /*start*/
      1476,
      14
      /* Extend */
    ],
    [
      /*start*/
      1478,
      0
      /* Other */
    ],
    [
      /*start*/
      1479,
      14
      /* Extend */
    ],
    [
      /*start*/
      1480,
      0
      /* Other */
    ],
    [
      /*start*/
      1488,
      15
      /* Hebrew_Letter */
    ],
    [
      /*start*/
      1515,
      0
      /* Other */
    ],
    [
      /*start*/
      1519,
      15
      /* Hebrew_Letter */
    ],
    [
      /*start*/
      1523,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1524,
      10
      /* MidLetter */
    ],
    [
      /*start*/
      1525,
      0
      /* Other */
    ],
    [
      /*start*/
      1536,
      13
      /* Format */
    ],
    [
      /*start*/
      1542,
      0
      /* Other */
    ],
    [
      /*start*/
      1548,
      7
      /* MidNum */
    ],
    [
      /*start*/
      1550,
      0
      /* Other */
    ],
    [
      /*start*/
      1552,
      14
      /* Extend */
    ],
    [
      /*start*/
      1563,
      0
      /* Other */
    ],
    [
      /*start*/
      1564,
      13
      /* Format */
    ],
    [
      /*start*/
      1565,
      0
      /* Other */
    ],
    [
      /*start*/
      1568,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1611,
      14
      /* Extend */
    ],
    [
      /*start*/
      1632,
      9
      /* Numeric */
    ],
    [
      /*start*/
      1642,
      0
      /* Other */
    ],
    [
      /*start*/
      1643,
      9
      /* Numeric */
    ],
    [
      /*start*/
      1644,
      7
      /* MidNum */
    ],
    [
      /*start*/
      1645,
      0
      /* Other */
    ],
    [
      /*start*/
      1646,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1648,
      14
      /* Extend */
    ],
    [
      /*start*/
      1649,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1748,
      0
      /* Other */
    ],
    [
      /*start*/
      1749,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1750,
      14
      /* Extend */
    ],
    [
      /*start*/
      1757,
      13
      /* Format */
    ],
    [
      /*start*/
      1758,
      0
      /* Other */
    ],
    [
      /*start*/
      1759,
      14
      /* Extend */
    ],
    [
      /*start*/
      1765,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1767,
      14
      /* Extend */
    ],
    [
      /*start*/
      1769,
      0
      /* Other */
    ],
    [
      /*start*/
      1770,
      14
      /* Extend */
    ],
    [
      /*start*/
      1774,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1776,
      9
      /* Numeric */
    ],
    [
      /*start*/
      1786,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1789,
      0
      /* Other */
    ],
    [
      /*start*/
      1791,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1792,
      0
      /* Other */
    ],
    [
      /*start*/
      1807,
      13
      /* Format */
    ],
    [
      /*start*/
      1808,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1809,
      14
      /* Extend */
    ],
    [
      /*start*/
      1810,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1840,
      14
      /* Extend */
    ],
    [
      /*start*/
      1867,
      0
      /* Other */
    ],
    [
      /*start*/
      1869,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1958,
      14
      /* Extend */
    ],
    [
      /*start*/
      1969,
      11
      /* ALetter */
    ],
    [
      /*start*/
      1970,
      0
      /* Other */
    ],
    [
      /*start*/
      1984,
      9
      /* Numeric */
    ],
    [
      /*start*/
      1994,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2027,
      14
      /* Extend */
    ],
    [
      /*start*/
      2036,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2038,
      0
      /* Other */
    ],
    [
      /*start*/
      2040,
      7
      /* MidNum */
    ],
    [
      /*start*/
      2041,
      0
      /* Other */
    ],
    [
      /*start*/
      2042,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2043,
      0
      /* Other */
    ],
    [
      /*start*/
      2045,
      14
      /* Extend */
    ],
    [
      /*start*/
      2046,
      0
      /* Other */
    ],
    [
      /*start*/
      2048,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2070,
      14
      /* Extend */
    ],
    [
      /*start*/
      2074,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2075,
      14
      /* Extend */
    ],
    [
      /*start*/
      2084,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2085,
      14
      /* Extend */
    ],
    [
      /*start*/
      2088,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2089,
      14
      /* Extend */
    ],
    [
      /*start*/
      2094,
      0
      /* Other */
    ],
    [
      /*start*/
      2112,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2137,
      14
      /* Extend */
    ],
    [
      /*start*/
      2140,
      0
      /* Other */
    ],
    [
      /*start*/
      2144,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2155,
      0
      /* Other */
    ],
    [
      /*start*/
      2208,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2229,
      0
      /* Other */
    ],
    [
      /*start*/
      2230,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2248,
      0
      /* Other */
    ],
    [
      /*start*/
      2259,
      14
      /* Extend */
    ],
    [
      /*start*/
      2274,
      13
      /* Format */
    ],
    [
      /*start*/
      2275,
      14
      /* Extend */
    ],
    [
      /*start*/
      2308,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2362,
      14
      /* Extend */
    ],
    [
      /*start*/
      2365,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2366,
      14
      /* Extend */
    ],
    [
      /*start*/
      2384,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2385,
      14
      /* Extend */
    ],
    [
      /*start*/
      2392,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2402,
      14
      /* Extend */
    ],
    [
      /*start*/
      2404,
      0
      /* Other */
    ],
    [
      /*start*/
      2406,
      9
      /* Numeric */
    ],
    [
      /*start*/
      2416,
      0
      /* Other */
    ],
    [
      /*start*/
      2417,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2433,
      14
      /* Extend */
    ],
    [
      /*start*/
      2436,
      0
      /* Other */
    ],
    [
      /*start*/
      2437,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2445,
      0
      /* Other */
    ],
    [
      /*start*/
      2447,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2449,
      0
      /* Other */
    ],
    [
      /*start*/
      2451,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2473,
      0
      /* Other */
    ],
    [
      /*start*/
      2474,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2481,
      0
      /* Other */
    ],
    [
      /*start*/
      2482,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2483,
      0
      /* Other */
    ],
    [
      /*start*/
      2486,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2490,
      0
      /* Other */
    ],
    [
      /*start*/
      2492,
      14
      /* Extend */
    ],
    [
      /*start*/
      2493,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2494,
      14
      /* Extend */
    ],
    [
      /*start*/
      2501,
      0
      /* Other */
    ],
    [
      /*start*/
      2503,
      14
      /* Extend */
    ],
    [
      /*start*/
      2505,
      0
      /* Other */
    ],
    [
      /*start*/
      2507,
      14
      /* Extend */
    ],
    [
      /*start*/
      2510,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2511,
      0
      /* Other */
    ],
    [
      /*start*/
      2519,
      14
      /* Extend */
    ],
    [
      /*start*/
      2520,
      0
      /* Other */
    ],
    [
      /*start*/
      2524,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2526,
      0
      /* Other */
    ],
    [
      /*start*/
      2527,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2530,
      14
      /* Extend */
    ],
    [
      /*start*/
      2532,
      0
      /* Other */
    ],
    [
      /*start*/
      2534,
      9
      /* Numeric */
    ],
    [
      /*start*/
      2544,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2546,
      0
      /* Other */
    ],
    [
      /*start*/
      2556,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2557,
      0
      /* Other */
    ],
    [
      /*start*/
      2558,
      14
      /* Extend */
    ],
    [
      /*start*/
      2559,
      0
      /* Other */
    ],
    [
      /*start*/
      2561,
      14
      /* Extend */
    ],
    [
      /*start*/
      2564,
      0
      /* Other */
    ],
    [
      /*start*/
      2565,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2571,
      0
      /* Other */
    ],
    [
      /*start*/
      2575,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2577,
      0
      /* Other */
    ],
    [
      /*start*/
      2579,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2601,
      0
      /* Other */
    ],
    [
      /*start*/
      2602,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2609,
      0
      /* Other */
    ],
    [
      /*start*/
      2610,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2612,
      0
      /* Other */
    ],
    [
      /*start*/
      2613,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2615,
      0
      /* Other */
    ],
    [
      /*start*/
      2616,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2618,
      0
      /* Other */
    ],
    [
      /*start*/
      2620,
      14
      /* Extend */
    ],
    [
      /*start*/
      2621,
      0
      /* Other */
    ],
    [
      /*start*/
      2622,
      14
      /* Extend */
    ],
    [
      /*start*/
      2627,
      0
      /* Other */
    ],
    [
      /*start*/
      2631,
      14
      /* Extend */
    ],
    [
      /*start*/
      2633,
      0
      /* Other */
    ],
    [
      /*start*/
      2635,
      14
      /* Extend */
    ],
    [
      /*start*/
      2638,
      0
      /* Other */
    ],
    [
      /*start*/
      2641,
      14
      /* Extend */
    ],
    [
      /*start*/
      2642,
      0
      /* Other */
    ],
    [
      /*start*/
      2649,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2653,
      0
      /* Other */
    ],
    [
      /*start*/
      2654,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2655,
      0
      /* Other */
    ],
    [
      /*start*/
      2662,
      9
      /* Numeric */
    ],
    [
      /*start*/
      2672,
      14
      /* Extend */
    ],
    [
      /*start*/
      2674,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2677,
      14
      /* Extend */
    ],
    [
      /*start*/
      2678,
      0
      /* Other */
    ],
    [
      /*start*/
      2689,
      14
      /* Extend */
    ],
    [
      /*start*/
      2692,
      0
      /* Other */
    ],
    [
      /*start*/
      2693,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2702,
      0
      /* Other */
    ],
    [
      /*start*/
      2703,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2706,
      0
      /* Other */
    ],
    [
      /*start*/
      2707,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2729,
      0
      /* Other */
    ],
    [
      /*start*/
      2730,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2737,
      0
      /* Other */
    ],
    [
      /*start*/
      2738,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2740,
      0
      /* Other */
    ],
    [
      /*start*/
      2741,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2746,
      0
      /* Other */
    ],
    [
      /*start*/
      2748,
      14
      /* Extend */
    ],
    [
      /*start*/
      2749,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2750,
      14
      /* Extend */
    ],
    [
      /*start*/
      2758,
      0
      /* Other */
    ],
    [
      /*start*/
      2759,
      14
      /* Extend */
    ],
    [
      /*start*/
      2762,
      0
      /* Other */
    ],
    [
      /*start*/
      2763,
      14
      /* Extend */
    ],
    [
      /*start*/
      2766,
      0
      /* Other */
    ],
    [
      /*start*/
      2768,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2769,
      0
      /* Other */
    ],
    [
      /*start*/
      2784,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2786,
      14
      /* Extend */
    ],
    [
      /*start*/
      2788,
      0
      /* Other */
    ],
    [
      /*start*/
      2790,
      9
      /* Numeric */
    ],
    [
      /*start*/
      2800,
      0
      /* Other */
    ],
    [
      /*start*/
      2809,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2810,
      14
      /* Extend */
    ],
    [
      /*start*/
      2816,
      0
      /* Other */
    ],
    [
      /*start*/
      2817,
      14
      /* Extend */
    ],
    [
      /*start*/
      2820,
      0
      /* Other */
    ],
    [
      /*start*/
      2821,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2829,
      0
      /* Other */
    ],
    [
      /*start*/
      2831,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2833,
      0
      /* Other */
    ],
    [
      /*start*/
      2835,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2857,
      0
      /* Other */
    ],
    [
      /*start*/
      2858,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2865,
      0
      /* Other */
    ],
    [
      /*start*/
      2866,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2868,
      0
      /* Other */
    ],
    [
      /*start*/
      2869,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2874,
      0
      /* Other */
    ],
    [
      /*start*/
      2876,
      14
      /* Extend */
    ],
    [
      /*start*/
      2877,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2878,
      14
      /* Extend */
    ],
    [
      /*start*/
      2885,
      0
      /* Other */
    ],
    [
      /*start*/
      2887,
      14
      /* Extend */
    ],
    [
      /*start*/
      2889,
      0
      /* Other */
    ],
    [
      /*start*/
      2891,
      14
      /* Extend */
    ],
    [
      /*start*/
      2894,
      0
      /* Other */
    ],
    [
      /*start*/
      2901,
      14
      /* Extend */
    ],
    [
      /*start*/
      2904,
      0
      /* Other */
    ],
    [
      /*start*/
      2908,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2910,
      0
      /* Other */
    ],
    [
      /*start*/
      2911,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2914,
      14
      /* Extend */
    ],
    [
      /*start*/
      2916,
      0
      /* Other */
    ],
    [
      /*start*/
      2918,
      9
      /* Numeric */
    ],
    [
      /*start*/
      2928,
      0
      /* Other */
    ],
    [
      /*start*/
      2929,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2930,
      0
      /* Other */
    ],
    [
      /*start*/
      2946,
      14
      /* Extend */
    ],
    [
      /*start*/
      2947,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2948,
      0
      /* Other */
    ],
    [
      /*start*/
      2949,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2955,
      0
      /* Other */
    ],
    [
      /*start*/
      2958,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2961,
      0
      /* Other */
    ],
    [
      /*start*/
      2962,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2966,
      0
      /* Other */
    ],
    [
      /*start*/
      2969,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2971,
      0
      /* Other */
    ],
    [
      /*start*/
      2972,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2973,
      0
      /* Other */
    ],
    [
      /*start*/
      2974,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2976,
      0
      /* Other */
    ],
    [
      /*start*/
      2979,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2981,
      0
      /* Other */
    ],
    [
      /*start*/
      2984,
      11
      /* ALetter */
    ],
    [
      /*start*/
      2987,
      0
      /* Other */
    ],
    [
      /*start*/
      2990,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3002,
      0
      /* Other */
    ],
    [
      /*start*/
      3006,
      14
      /* Extend */
    ],
    [
      /*start*/
      3011,
      0
      /* Other */
    ],
    [
      /*start*/
      3014,
      14
      /* Extend */
    ],
    [
      /*start*/
      3017,
      0
      /* Other */
    ],
    [
      /*start*/
      3018,
      14
      /* Extend */
    ],
    [
      /*start*/
      3022,
      0
      /* Other */
    ],
    [
      /*start*/
      3024,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3025,
      0
      /* Other */
    ],
    [
      /*start*/
      3031,
      14
      /* Extend */
    ],
    [
      /*start*/
      3032,
      0
      /* Other */
    ],
    [
      /*start*/
      3046,
      9
      /* Numeric */
    ],
    [
      /*start*/
      3056,
      0
      /* Other */
    ],
    [
      /*start*/
      3072,
      14
      /* Extend */
    ],
    [
      /*start*/
      3077,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3085,
      0
      /* Other */
    ],
    [
      /*start*/
      3086,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3089,
      0
      /* Other */
    ],
    [
      /*start*/
      3090,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3113,
      0
      /* Other */
    ],
    [
      /*start*/
      3114,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3130,
      0
      /* Other */
    ],
    [
      /*start*/
      3133,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3134,
      14
      /* Extend */
    ],
    [
      /*start*/
      3141,
      0
      /* Other */
    ],
    [
      /*start*/
      3142,
      14
      /* Extend */
    ],
    [
      /*start*/
      3145,
      0
      /* Other */
    ],
    [
      /*start*/
      3146,
      14
      /* Extend */
    ],
    [
      /*start*/
      3150,
      0
      /* Other */
    ],
    [
      /*start*/
      3157,
      14
      /* Extend */
    ],
    [
      /*start*/
      3159,
      0
      /* Other */
    ],
    [
      /*start*/
      3160,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3163,
      0
      /* Other */
    ],
    [
      /*start*/
      3168,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3170,
      14
      /* Extend */
    ],
    [
      /*start*/
      3172,
      0
      /* Other */
    ],
    [
      /*start*/
      3174,
      9
      /* Numeric */
    ],
    [
      /*start*/
      3184,
      0
      /* Other */
    ],
    [
      /*start*/
      3200,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3201,
      14
      /* Extend */
    ],
    [
      /*start*/
      3204,
      0
      /* Other */
    ],
    [
      /*start*/
      3205,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3213,
      0
      /* Other */
    ],
    [
      /*start*/
      3214,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3217,
      0
      /* Other */
    ],
    [
      /*start*/
      3218,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3241,
      0
      /* Other */
    ],
    [
      /*start*/
      3242,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3252,
      0
      /* Other */
    ],
    [
      /*start*/
      3253,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3258,
      0
      /* Other */
    ],
    [
      /*start*/
      3260,
      14
      /* Extend */
    ],
    [
      /*start*/
      3261,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3262,
      14
      /* Extend */
    ],
    [
      /*start*/
      3269,
      0
      /* Other */
    ],
    [
      /*start*/
      3270,
      14
      /* Extend */
    ],
    [
      /*start*/
      3273,
      0
      /* Other */
    ],
    [
      /*start*/
      3274,
      14
      /* Extend */
    ],
    [
      /*start*/
      3278,
      0
      /* Other */
    ],
    [
      /*start*/
      3285,
      14
      /* Extend */
    ],
    [
      /*start*/
      3287,
      0
      /* Other */
    ],
    [
      /*start*/
      3294,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3295,
      0
      /* Other */
    ],
    [
      /*start*/
      3296,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3298,
      14
      /* Extend */
    ],
    [
      /*start*/
      3300,
      0
      /* Other */
    ],
    [
      /*start*/
      3302,
      9
      /* Numeric */
    ],
    [
      /*start*/
      3312,
      0
      /* Other */
    ],
    [
      /*start*/
      3313,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3315,
      0
      /* Other */
    ],
    [
      /*start*/
      3328,
      14
      /* Extend */
    ],
    [
      /*start*/
      3332,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3341,
      0
      /* Other */
    ],
    [
      /*start*/
      3342,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3345,
      0
      /* Other */
    ],
    [
      /*start*/
      3346,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3387,
      14
      /* Extend */
    ],
    [
      /*start*/
      3389,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3390,
      14
      /* Extend */
    ],
    [
      /*start*/
      3397,
      0
      /* Other */
    ],
    [
      /*start*/
      3398,
      14
      /* Extend */
    ],
    [
      /*start*/
      3401,
      0
      /* Other */
    ],
    [
      /*start*/
      3402,
      14
      /* Extend */
    ],
    [
      /*start*/
      3406,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3407,
      0
      /* Other */
    ],
    [
      /*start*/
      3412,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3415,
      14
      /* Extend */
    ],
    [
      /*start*/
      3416,
      0
      /* Other */
    ],
    [
      /*start*/
      3423,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3426,
      14
      /* Extend */
    ],
    [
      /*start*/
      3428,
      0
      /* Other */
    ],
    [
      /*start*/
      3430,
      9
      /* Numeric */
    ],
    [
      /*start*/
      3440,
      0
      /* Other */
    ],
    [
      /*start*/
      3450,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3456,
      0
      /* Other */
    ],
    [
      /*start*/
      3457,
      14
      /* Extend */
    ],
    [
      /*start*/
      3460,
      0
      /* Other */
    ],
    [
      /*start*/
      3461,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3479,
      0
      /* Other */
    ],
    [
      /*start*/
      3482,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3506,
      0
      /* Other */
    ],
    [
      /*start*/
      3507,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3516,
      0
      /* Other */
    ],
    [
      /*start*/
      3517,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3518,
      0
      /* Other */
    ],
    [
      /*start*/
      3520,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3527,
      0
      /* Other */
    ],
    [
      /*start*/
      3530,
      14
      /* Extend */
    ],
    [
      /*start*/
      3531,
      0
      /* Other */
    ],
    [
      /*start*/
      3535,
      14
      /* Extend */
    ],
    [
      /*start*/
      3541,
      0
      /* Other */
    ],
    [
      /*start*/
      3542,
      14
      /* Extend */
    ],
    [
      /*start*/
      3543,
      0
      /* Other */
    ],
    [
      /*start*/
      3544,
      14
      /* Extend */
    ],
    [
      /*start*/
      3552,
      0
      /* Other */
    ],
    [
      /*start*/
      3558,
      9
      /* Numeric */
    ],
    [
      /*start*/
      3568,
      0
      /* Other */
    ],
    [
      /*start*/
      3570,
      14
      /* Extend */
    ],
    [
      /*start*/
      3572,
      0
      /* Other */
    ],
    [
      /*start*/
      3633,
      14
      /* Extend */
    ],
    [
      /*start*/
      3634,
      0
      /* Other */
    ],
    [
      /*start*/
      3636,
      14
      /* Extend */
    ],
    [
      /*start*/
      3643,
      0
      /* Other */
    ],
    [
      /*start*/
      3655,
      14
      /* Extend */
    ],
    [
      /*start*/
      3663,
      0
      /* Other */
    ],
    [
      /*start*/
      3664,
      9
      /* Numeric */
    ],
    [
      /*start*/
      3674,
      0
      /* Other */
    ],
    [
      /*start*/
      3761,
      14
      /* Extend */
    ],
    [
      /*start*/
      3762,
      0
      /* Other */
    ],
    [
      /*start*/
      3764,
      14
      /* Extend */
    ],
    [
      /*start*/
      3773,
      0
      /* Other */
    ],
    [
      /*start*/
      3784,
      14
      /* Extend */
    ],
    [
      /*start*/
      3790,
      0
      /* Other */
    ],
    [
      /*start*/
      3792,
      9
      /* Numeric */
    ],
    [
      /*start*/
      3802,
      0
      /* Other */
    ],
    [
      /*start*/
      3840,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3841,
      0
      /* Other */
    ],
    [
      /*start*/
      3864,
      14
      /* Extend */
    ],
    [
      /*start*/
      3866,
      0
      /* Other */
    ],
    [
      /*start*/
      3872,
      9
      /* Numeric */
    ],
    [
      /*start*/
      3882,
      0
      /* Other */
    ],
    [
      /*start*/
      3893,
      14
      /* Extend */
    ],
    [
      /*start*/
      3894,
      0
      /* Other */
    ],
    [
      /*start*/
      3895,
      14
      /* Extend */
    ],
    [
      /*start*/
      3896,
      0
      /* Other */
    ],
    [
      /*start*/
      3897,
      14
      /* Extend */
    ],
    [
      /*start*/
      3898,
      0
      /* Other */
    ],
    [
      /*start*/
      3902,
      14
      /* Extend */
    ],
    [
      /*start*/
      3904,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3912,
      0
      /* Other */
    ],
    [
      /*start*/
      3913,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3949,
      0
      /* Other */
    ],
    [
      /*start*/
      3953,
      14
      /* Extend */
    ],
    [
      /*start*/
      3973,
      0
      /* Other */
    ],
    [
      /*start*/
      3974,
      14
      /* Extend */
    ],
    [
      /*start*/
      3976,
      11
      /* ALetter */
    ],
    [
      /*start*/
      3981,
      14
      /* Extend */
    ],
    [
      /*start*/
      3992,
      0
      /* Other */
    ],
    [
      /*start*/
      3993,
      14
      /* Extend */
    ],
    [
      /*start*/
      4029,
      0
      /* Other */
    ],
    [
      /*start*/
      4038,
      14
      /* Extend */
    ],
    [
      /*start*/
      4039,
      0
      /* Other */
    ],
    [
      /*start*/
      4139,
      14
      /* Extend */
    ],
    [
      /*start*/
      4159,
      0
      /* Other */
    ],
    [
      /*start*/
      4160,
      9
      /* Numeric */
    ],
    [
      /*start*/
      4170,
      0
      /* Other */
    ],
    [
      /*start*/
      4182,
      14
      /* Extend */
    ],
    [
      /*start*/
      4186,
      0
      /* Other */
    ],
    [
      /*start*/
      4190,
      14
      /* Extend */
    ],
    [
      /*start*/
      4193,
      0
      /* Other */
    ],
    [
      /*start*/
      4194,
      14
      /* Extend */
    ],
    [
      /*start*/
      4197,
      0
      /* Other */
    ],
    [
      /*start*/
      4199,
      14
      /* Extend */
    ],
    [
      /*start*/
      4206,
      0
      /* Other */
    ],
    [
      /*start*/
      4209,
      14
      /* Extend */
    ],
    [
      /*start*/
      4213,
      0
      /* Other */
    ],
    [
      /*start*/
      4226,
      14
      /* Extend */
    ],
    [
      /*start*/
      4238,
      0
      /* Other */
    ],
    [
      /*start*/
      4239,
      14
      /* Extend */
    ],
    [
      /*start*/
      4240,
      9
      /* Numeric */
    ],
    [
      /*start*/
      4250,
      14
      /* Extend */
    ],
    [
      /*start*/
      4254,
      0
      /* Other */
    ],
    [
      /*start*/
      4256,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4294,
      0
      /* Other */
    ],
    [
      /*start*/
      4295,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4296,
      0
      /* Other */
    ],
    [
      /*start*/
      4301,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4302,
      0
      /* Other */
    ],
    [
      /*start*/
      4304,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4347,
      0
      /* Other */
    ],
    [
      /*start*/
      4348,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4681,
      0
      /* Other */
    ],
    [
      /*start*/
      4682,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4686,
      0
      /* Other */
    ],
    [
      /*start*/
      4688,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4695,
      0
      /* Other */
    ],
    [
      /*start*/
      4696,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4697,
      0
      /* Other */
    ],
    [
      /*start*/
      4698,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4702,
      0
      /* Other */
    ],
    [
      /*start*/
      4704,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4745,
      0
      /* Other */
    ],
    [
      /*start*/
      4746,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4750,
      0
      /* Other */
    ],
    [
      /*start*/
      4752,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4785,
      0
      /* Other */
    ],
    [
      /*start*/
      4786,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4790,
      0
      /* Other */
    ],
    [
      /*start*/
      4792,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4799,
      0
      /* Other */
    ],
    [
      /*start*/
      4800,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4801,
      0
      /* Other */
    ],
    [
      /*start*/
      4802,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4806,
      0
      /* Other */
    ],
    [
      /*start*/
      4808,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4823,
      0
      /* Other */
    ],
    [
      /*start*/
      4824,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4881,
      0
      /* Other */
    ],
    [
      /*start*/
      4882,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4886,
      0
      /* Other */
    ],
    [
      /*start*/
      4888,
      11
      /* ALetter */
    ],
    [
      /*start*/
      4955,
      0
      /* Other */
    ],
    [
      /*start*/
      4957,
      14
      /* Extend */
    ],
    [
      /*start*/
      4960,
      0
      /* Other */
    ],
    [
      /*start*/
      4992,
      11
      /* ALetter */
    ],
    [
      /*start*/
      5008,
      0
      /* Other */
    ],
    [
      /*start*/
      5024,
      11
      /* ALetter */
    ],
    [
      /*start*/
      5110,
      0
      /* Other */
    ],
    [
      /*start*/
      5112,
      11
      /* ALetter */
    ],
    [
      /*start*/
      5118,
      0
      /* Other */
    ],
    [
      /*start*/
      5121,
      11
      /* ALetter */
    ],
    [
      /*start*/
      5741,
      0
      /* Other */
    ],
    [
      /*start*/
      5743,
      11
      /* ALetter */
    ],
    [
      /*start*/
      5760,
      4
      /* WSegSpace */
    ],
    [
      /*start*/
      5761,
      11
      /* ALetter */
    ],
    [
      /*start*/
      5787,
      0
      /* Other */
    ],
    [
      /*start*/
      5792,
      11
      /* ALetter */
    ],
    [
      /*start*/
      5867,
      0
      /* Other */
    ],
    [
      /*start*/
      5870,
      11
      /* ALetter */
    ],
    [
      /*start*/
      5881,
      0
      /* Other */
    ],
    [
      /*start*/
      5888,
      11
      /* ALetter */
    ],
    [
      /*start*/
      5901,
      0
      /* Other */
    ],
    [
      /*start*/
      5902,
      11
      /* ALetter */
    ],
    [
      /*start*/
      5906,
      14
      /* Extend */
    ],
    [
      /*start*/
      5909,
      0
      /* Other */
    ],
    [
      /*start*/
      5920,
      11
      /* ALetter */
    ],
    [
      /*start*/
      5938,
      14
      /* Extend */
    ],
    [
      /*start*/
      5941,
      0
      /* Other */
    ],
    [
      /*start*/
      5952,
      11
      /* ALetter */
    ],
    [
      /*start*/
      5970,
      14
      /* Extend */
    ],
    [
      /*start*/
      5972,
      0
      /* Other */
    ],
    [
      /*start*/
      5984,
      11
      /* ALetter */
    ],
    [
      /*start*/
      5997,
      0
      /* Other */
    ],
    [
      /*start*/
      5998,
      11
      /* ALetter */
    ],
    [
      /*start*/
      6001,
      0
      /* Other */
    ],
    [
      /*start*/
      6002,
      14
      /* Extend */
    ],
    [
      /*start*/
      6004,
      0
      /* Other */
    ],
    [
      /*start*/
      6068,
      14
      /* Extend */
    ],
    [
      /*start*/
      6100,
      0
      /* Other */
    ],
    [
      /*start*/
      6109,
      14
      /* Extend */
    ],
    [
      /*start*/
      6110,
      0
      /* Other */
    ],
    [
      /*start*/
      6112,
      9
      /* Numeric */
    ],
    [
      /*start*/
      6122,
      0
      /* Other */
    ],
    [
      /*start*/
      6155,
      14
      /* Extend */
    ],
    [
      /*start*/
      6158,
      13
      /* Format */
    ],
    [
      /*start*/
      6159,
      0
      /* Other */
    ],
    [
      /*start*/
      6160,
      9
      /* Numeric */
    ],
    [
      /*start*/
      6170,
      0
      /* Other */
    ],
    [
      /*start*/
      6176,
      11
      /* ALetter */
    ],
    [
      /*start*/
      6265,
      0
      /* Other */
    ],
    [
      /*start*/
      6272,
      11
      /* ALetter */
    ],
    [
      /*start*/
      6277,
      14
      /* Extend */
    ],
    [
      /*start*/
      6279,
      11
      /* ALetter */
    ],
    [
      /*start*/
      6313,
      14
      /* Extend */
    ],
    [
      /*start*/
      6314,
      11
      /* ALetter */
    ],
    [
      /*start*/
      6315,
      0
      /* Other */
    ],
    [
      /*start*/
      6320,
      11
      /* ALetter */
    ],
    [
      /*start*/
      6390,
      0
      /* Other */
    ],
    [
      /*start*/
      6400,
      11
      /* ALetter */
    ],
    [
      /*start*/
      6431,
      0
      /* Other */
    ],
    [
      /*start*/
      6432,
      14
      /* Extend */
    ],
    [
      /*start*/
      6444,
      0
      /* Other */
    ],
    [
      /*start*/
      6448,
      14
      /* Extend */
    ],
    [
      /*start*/
      6460,
      0
      /* Other */
    ],
    [
      /*start*/
      6470,
      9
      /* Numeric */
    ],
    [
      /*start*/
      6480,
      0
      /* Other */
    ],
    [
      /*start*/
      6608,
      9
      /* Numeric */
    ],
    [
      /*start*/
      6618,
      0
      /* Other */
    ],
    [
      /*start*/
      6656,
      11
      /* ALetter */
    ],
    [
      /*start*/
      6679,
      14
      /* Extend */
    ],
    [
      /*start*/
      6684,
      0
      /* Other */
    ],
    [
      /*start*/
      6741,
      14
      /* Extend */
    ],
    [
      /*start*/
      6751,
      0
      /* Other */
    ],
    [
      /*start*/
      6752,
      14
      /* Extend */
    ],
    [
      /*start*/
      6781,
      0
      /* Other */
    ],
    [
      /*start*/
      6783,
      14
      /* Extend */
    ],
    [
      /*start*/
      6784,
      9
      /* Numeric */
    ],
    [
      /*start*/
      6794,
      0
      /* Other */
    ],
    [
      /*start*/
      6800,
      9
      /* Numeric */
    ],
    [
      /*start*/
      6810,
      0
      /* Other */
    ],
    [
      /*start*/
      6832,
      14
      /* Extend */
    ],
    [
      /*start*/
      6849,
      0
      /* Other */
    ],
    [
      /*start*/
      6912,
      14
      /* Extend */
    ],
    [
      /*start*/
      6917,
      11
      /* ALetter */
    ],
    [
      /*start*/
      6964,
      14
      /* Extend */
    ],
    [
      /*start*/
      6981,
      11
      /* ALetter */
    ],
    [
      /*start*/
      6988,
      0
      /* Other */
    ],
    [
      /*start*/
      6992,
      9
      /* Numeric */
    ],
    [
      /*start*/
      7002,
      0
      /* Other */
    ],
    [
      /*start*/
      7019,
      14
      /* Extend */
    ],
    [
      /*start*/
      7028,
      0
      /* Other */
    ],
    [
      /*start*/
      7040,
      14
      /* Extend */
    ],
    [
      /*start*/
      7043,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7073,
      14
      /* Extend */
    ],
    [
      /*start*/
      7086,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7088,
      9
      /* Numeric */
    ],
    [
      /*start*/
      7098,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7142,
      14
      /* Extend */
    ],
    [
      /*start*/
      7156,
      0
      /* Other */
    ],
    [
      /*start*/
      7168,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7204,
      14
      /* Extend */
    ],
    [
      /*start*/
      7224,
      0
      /* Other */
    ],
    [
      /*start*/
      7232,
      9
      /* Numeric */
    ],
    [
      /*start*/
      7242,
      0
      /* Other */
    ],
    [
      /*start*/
      7245,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7248,
      9
      /* Numeric */
    ],
    [
      /*start*/
      7258,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7294,
      0
      /* Other */
    ],
    [
      /*start*/
      7296,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7305,
      0
      /* Other */
    ],
    [
      /*start*/
      7312,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7355,
      0
      /* Other */
    ],
    [
      /*start*/
      7357,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7360,
      0
      /* Other */
    ],
    [
      /*start*/
      7376,
      14
      /* Extend */
    ],
    [
      /*start*/
      7379,
      0
      /* Other */
    ],
    [
      /*start*/
      7380,
      14
      /* Extend */
    ],
    [
      /*start*/
      7401,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7405,
      14
      /* Extend */
    ],
    [
      /*start*/
      7406,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7412,
      14
      /* Extend */
    ],
    [
      /*start*/
      7413,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7415,
      14
      /* Extend */
    ],
    [
      /*start*/
      7418,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7419,
      0
      /* Other */
    ],
    [
      /*start*/
      7424,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7616,
      14
      /* Extend */
    ],
    [
      /*start*/
      7674,
      0
      /* Other */
    ],
    [
      /*start*/
      7675,
      14
      /* Extend */
    ],
    [
      /*start*/
      7680,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7958,
      0
      /* Other */
    ],
    [
      /*start*/
      7960,
      11
      /* ALetter */
    ],
    [
      /*start*/
      7966,
      0
      /* Other */
    ],
    [
      /*start*/
      7968,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8006,
      0
      /* Other */
    ],
    [
      /*start*/
      8008,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8014,
      0
      /* Other */
    ],
    [
      /*start*/
      8016,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8024,
      0
      /* Other */
    ],
    [
      /*start*/
      8025,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8026,
      0
      /* Other */
    ],
    [
      /*start*/
      8027,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8028,
      0
      /* Other */
    ],
    [
      /*start*/
      8029,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8030,
      0
      /* Other */
    ],
    [
      /*start*/
      8031,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8062,
      0
      /* Other */
    ],
    [
      /*start*/
      8064,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8117,
      0
      /* Other */
    ],
    [
      /*start*/
      8118,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8125,
      0
      /* Other */
    ],
    [
      /*start*/
      8126,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8127,
      0
      /* Other */
    ],
    [
      /*start*/
      8130,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8133,
      0
      /* Other */
    ],
    [
      /*start*/
      8134,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8141,
      0
      /* Other */
    ],
    [
      /*start*/
      8144,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8148,
      0
      /* Other */
    ],
    [
      /*start*/
      8150,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8156,
      0
      /* Other */
    ],
    [
      /*start*/
      8160,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8173,
      0
      /* Other */
    ],
    [
      /*start*/
      8178,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8181,
      0
      /* Other */
    ],
    [
      /*start*/
      8182,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8189,
      0
      /* Other */
    ],
    [
      /*start*/
      8192,
      4
      /* WSegSpace */
    ],
    [
      /*start*/
      8199,
      0
      /* Other */
    ],
    [
      /*start*/
      8200,
      4
      /* WSegSpace */
    ],
    [
      /*start*/
      8203,
      0
      /* Other */
    ],
    [
      /*start*/
      8204,
      14
      /* Extend */
    ],
    [
      /*start*/
      8205,
      16
      /* ZWJ */
    ],
    [
      /*start*/
      8206,
      13
      /* Format */
    ],
    [
      /*start*/
      8208,
      0
      /* Other */
    ],
    [
      /*start*/
      8216,
      8
      /* MidNumLet */
    ],
    [
      /*start*/
      8218,
      0
      /* Other */
    ],
    [
      /*start*/
      8228,
      8
      /* MidNumLet */
    ],
    [
      /*start*/
      8229,
      0
      /* Other */
    ],
    [
      /*start*/
      8231,
      10
      /* MidLetter */
    ],
    [
      /*start*/
      8232,
      2
      /* Newline */
    ],
    [
      /*start*/
      8234,
      13
      /* Format */
    ],
    [
      /*start*/
      8239,
      12
      /* ExtendNumLet */
    ],
    [
      /*start*/
      8240,
      0
      /* Other */
    ],
    [
      /*start*/
      8255,
      12
      /* ExtendNumLet */
    ],
    [
      /*start*/
      8257,
      0
      /* Other */
    ],
    [
      /*start*/
      8260,
      7
      /* MidNum */
    ],
    [
      /*start*/
      8261,
      0
      /* Other */
    ],
    [
      /*start*/
      8276,
      12
      /* ExtendNumLet */
    ],
    [
      /*start*/
      8277,
      0
      /* Other */
    ],
    [
      /*start*/
      8287,
      4
      /* WSegSpace */
    ],
    [
      /*start*/
      8288,
      13
      /* Format */
    ],
    [
      /*start*/
      8293,
      0
      /* Other */
    ],
    [
      /*start*/
      8294,
      13
      /* Format */
    ],
    [
      /*start*/
      8304,
      0
      /* Other */
    ],
    [
      /*start*/
      8305,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8306,
      0
      /* Other */
    ],
    [
      /*start*/
      8319,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8320,
      0
      /* Other */
    ],
    [
      /*start*/
      8336,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8349,
      0
      /* Other */
    ],
    [
      /*start*/
      8400,
      14
      /* Extend */
    ],
    [
      /*start*/
      8433,
      0
      /* Other */
    ],
    [
      /*start*/
      8450,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8451,
      0
      /* Other */
    ],
    [
      /*start*/
      8455,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8456,
      0
      /* Other */
    ],
    [
      /*start*/
      8458,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8468,
      0
      /* Other */
    ],
    [
      /*start*/
      8469,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8470,
      0
      /* Other */
    ],
    [
      /*start*/
      8473,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8478,
      0
      /* Other */
    ],
    [
      /*start*/
      8484,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8485,
      0
      /* Other */
    ],
    [
      /*start*/
      8486,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8487,
      0
      /* Other */
    ],
    [
      /*start*/
      8488,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8489,
      0
      /* Other */
    ],
    [
      /*start*/
      8490,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8494,
      0
      /* Other */
    ],
    [
      /*start*/
      8495,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8506,
      0
      /* Other */
    ],
    [
      /*start*/
      8508,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8512,
      0
      /* Other */
    ],
    [
      /*start*/
      8517,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8522,
      0
      /* Other */
    ],
    [
      /*start*/
      8526,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8527,
      0
      /* Other */
    ],
    [
      /*start*/
      8544,
      11
      /* ALetter */
    ],
    [
      /*start*/
      8585,
      0
      /* Other */
    ],
    [
      /*start*/
      9398,
      11
      /* ALetter */
    ],
    [
      /*start*/
      9450,
      0
      /* Other */
    ],
    [
      /*start*/
      11264,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11311,
      0
      /* Other */
    ],
    [
      /*start*/
      11312,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11359,
      0
      /* Other */
    ],
    [
      /*start*/
      11360,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11493,
      0
      /* Other */
    ],
    [
      /*start*/
      11499,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11503,
      14
      /* Extend */
    ],
    [
      /*start*/
      11506,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11508,
      0
      /* Other */
    ],
    [
      /*start*/
      11520,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11558,
      0
      /* Other */
    ],
    [
      /*start*/
      11559,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11560,
      0
      /* Other */
    ],
    [
      /*start*/
      11565,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11566,
      0
      /* Other */
    ],
    [
      /*start*/
      11568,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11624,
      0
      /* Other */
    ],
    [
      /*start*/
      11631,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11632,
      0
      /* Other */
    ],
    [
      /*start*/
      11647,
      14
      /* Extend */
    ],
    [
      /*start*/
      11648,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11671,
      0
      /* Other */
    ],
    [
      /*start*/
      11680,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11687,
      0
      /* Other */
    ],
    [
      /*start*/
      11688,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11695,
      0
      /* Other */
    ],
    [
      /*start*/
      11696,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11703,
      0
      /* Other */
    ],
    [
      /*start*/
      11704,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11711,
      0
      /* Other */
    ],
    [
      /*start*/
      11712,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11719,
      0
      /* Other */
    ],
    [
      /*start*/
      11720,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11727,
      0
      /* Other */
    ],
    [
      /*start*/
      11728,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11735,
      0
      /* Other */
    ],
    [
      /*start*/
      11736,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11743,
      0
      /* Other */
    ],
    [
      /*start*/
      11744,
      14
      /* Extend */
    ],
    [
      /*start*/
      11776,
      0
      /* Other */
    ],
    [
      /*start*/
      11823,
      11
      /* ALetter */
    ],
    [
      /*start*/
      11824,
      0
      /* Other */
    ],
    [
      /*start*/
      12288,
      4
      /* WSegSpace */
    ],
    [
      /*start*/
      12289,
      0
      /* Other */
    ],
    [
      /*start*/
      12293,
      11
      /* ALetter */
    ],
    [
      /*start*/
      12294,
      0
      /* Other */
    ],
    [
      /*start*/
      12330,
      14
      /* Extend */
    ],
    [
      /*start*/
      12336,
      0
      /* Other */
    ],
    [
      /*start*/
      12337,
      17
      /* Katakana */
    ],
    [
      /*start*/
      12342,
      0
      /* Other */
    ],
    [
      /*start*/
      12347,
      11
      /* ALetter */
    ],
    [
      /*start*/
      12349,
      0
      /* Other */
    ],
    [
      /*start*/
      12441,
      14
      /* Extend */
    ],
    [
      /*start*/
      12443,
      17
      /* Katakana */
    ],
    [
      /*start*/
      12445,
      0
      /* Other */
    ],
    [
      /*start*/
      12448,
      17
      /* Katakana */
    ],
    [
      /*start*/
      12539,
      0
      /* Other */
    ],
    [
      /*start*/
      12540,
      17
      /* Katakana */
    ],
    [
      /*start*/
      12544,
      0
      /* Other */
    ],
    [
      /*start*/
      12549,
      11
      /* ALetter */
    ],
    [
      /*start*/
      12592,
      0
      /* Other */
    ],
    [
      /*start*/
      12593,
      11
      /* ALetter */
    ],
    [
      /*start*/
      12687,
      0
      /* Other */
    ],
    [
      /*start*/
      12704,
      11
      /* ALetter */
    ],
    [
      /*start*/
      12736,
      0
      /* Other */
    ],
    [
      /*start*/
      12784,
      17
      /* Katakana */
    ],
    [
      /*start*/
      12800,
      0
      /* Other */
    ],
    [
      /*start*/
      13008,
      17
      /* Katakana */
    ],
    [
      /*start*/
      13055,
      0
      /* Other */
    ],
    [
      /*start*/
      13056,
      17
      /* Katakana */
    ],
    [
      /*start*/
      13144,
      0
      /* Other */
    ],
    [
      /*start*/
      40960,
      11
      /* ALetter */
    ],
    [
      /*start*/
      42125,
      0
      /* Other */
    ],
    [
      /*start*/
      42192,
      11
      /* ALetter */
    ],
    [
      /*start*/
      42238,
      0
      /* Other */
    ],
    [
      /*start*/
      42240,
      11
      /* ALetter */
    ],
    [
      /*start*/
      42509,
      0
      /* Other */
    ],
    [
      /*start*/
      42512,
      11
      /* ALetter */
    ],
    [
      /*start*/
      42528,
      9
      /* Numeric */
    ],
    [
      /*start*/
      42538,
      11
      /* ALetter */
    ],
    [
      /*start*/
      42540,
      0
      /* Other */
    ],
    [
      /*start*/
      42560,
      11
      /* ALetter */
    ],
    [
      /*start*/
      42607,
      14
      /* Extend */
    ],
    [
      /*start*/
      42611,
      0
      /* Other */
    ],
    [
      /*start*/
      42612,
      14
      /* Extend */
    ],
    [
      /*start*/
      42622,
      0
      /* Other */
    ],
    [
      /*start*/
      42623,
      11
      /* ALetter */
    ],
    [
      /*start*/
      42654,
      14
      /* Extend */
    ],
    [
      /*start*/
      42656,
      11
      /* ALetter */
    ],
    [
      /*start*/
      42736,
      14
      /* Extend */
    ],
    [
      /*start*/
      42738,
      0
      /* Other */
    ],
    [
      /*start*/
      42760,
      11
      /* ALetter */
    ],
    [
      /*start*/
      42944,
      0
      /* Other */
    ],
    [
      /*start*/
      42946,
      11
      /* ALetter */
    ],
    [
      /*start*/
      42955,
      0
      /* Other */
    ],
    [
      /*start*/
      42997,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43010,
      14
      /* Extend */
    ],
    [
      /*start*/
      43011,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43014,
      14
      /* Extend */
    ],
    [
      /*start*/
      43015,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43019,
      14
      /* Extend */
    ],
    [
      /*start*/
      43020,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43043,
      14
      /* Extend */
    ],
    [
      /*start*/
      43048,
      0
      /* Other */
    ],
    [
      /*start*/
      43052,
      14
      /* Extend */
    ],
    [
      /*start*/
      43053,
      0
      /* Other */
    ],
    [
      /*start*/
      43072,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43124,
      0
      /* Other */
    ],
    [
      /*start*/
      43136,
      14
      /* Extend */
    ],
    [
      /*start*/
      43138,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43188,
      14
      /* Extend */
    ],
    [
      /*start*/
      43206,
      0
      /* Other */
    ],
    [
      /*start*/
      43216,
      9
      /* Numeric */
    ],
    [
      /*start*/
      43226,
      0
      /* Other */
    ],
    [
      /*start*/
      43232,
      14
      /* Extend */
    ],
    [
      /*start*/
      43250,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43256,
      0
      /* Other */
    ],
    [
      /*start*/
      43259,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43260,
      0
      /* Other */
    ],
    [
      /*start*/
      43261,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43263,
      14
      /* Extend */
    ],
    [
      /*start*/
      43264,
      9
      /* Numeric */
    ],
    [
      /*start*/
      43274,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43302,
      14
      /* Extend */
    ],
    [
      /*start*/
      43310,
      0
      /* Other */
    ],
    [
      /*start*/
      43312,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43335,
      14
      /* Extend */
    ],
    [
      /*start*/
      43348,
      0
      /* Other */
    ],
    [
      /*start*/
      43360,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43389,
      0
      /* Other */
    ],
    [
      /*start*/
      43392,
      14
      /* Extend */
    ],
    [
      /*start*/
      43396,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43443,
      14
      /* Extend */
    ],
    [
      /*start*/
      43457,
      0
      /* Other */
    ],
    [
      /*start*/
      43471,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43472,
      9
      /* Numeric */
    ],
    [
      /*start*/
      43482,
      0
      /* Other */
    ],
    [
      /*start*/
      43493,
      14
      /* Extend */
    ],
    [
      /*start*/
      43494,
      0
      /* Other */
    ],
    [
      /*start*/
      43504,
      9
      /* Numeric */
    ],
    [
      /*start*/
      43514,
      0
      /* Other */
    ],
    [
      /*start*/
      43520,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43561,
      14
      /* Extend */
    ],
    [
      /*start*/
      43575,
      0
      /* Other */
    ],
    [
      /*start*/
      43584,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43587,
      14
      /* Extend */
    ],
    [
      /*start*/
      43588,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43596,
      14
      /* Extend */
    ],
    [
      /*start*/
      43598,
      0
      /* Other */
    ],
    [
      /*start*/
      43600,
      9
      /* Numeric */
    ],
    [
      /*start*/
      43610,
      0
      /* Other */
    ],
    [
      /*start*/
      43643,
      14
      /* Extend */
    ],
    [
      /*start*/
      43646,
      0
      /* Other */
    ],
    [
      /*start*/
      43696,
      14
      /* Extend */
    ],
    [
      /*start*/
      43697,
      0
      /* Other */
    ],
    [
      /*start*/
      43698,
      14
      /* Extend */
    ],
    [
      /*start*/
      43701,
      0
      /* Other */
    ],
    [
      /*start*/
      43703,
      14
      /* Extend */
    ],
    [
      /*start*/
      43705,
      0
      /* Other */
    ],
    [
      /*start*/
      43710,
      14
      /* Extend */
    ],
    [
      /*start*/
      43712,
      0
      /* Other */
    ],
    [
      /*start*/
      43713,
      14
      /* Extend */
    ],
    [
      /*start*/
      43714,
      0
      /* Other */
    ],
    [
      /*start*/
      43744,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43755,
      14
      /* Extend */
    ],
    [
      /*start*/
      43760,
      0
      /* Other */
    ],
    [
      /*start*/
      43762,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43765,
      14
      /* Extend */
    ],
    [
      /*start*/
      43767,
      0
      /* Other */
    ],
    [
      /*start*/
      43777,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43783,
      0
      /* Other */
    ],
    [
      /*start*/
      43785,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43791,
      0
      /* Other */
    ],
    [
      /*start*/
      43793,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43799,
      0
      /* Other */
    ],
    [
      /*start*/
      43808,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43815,
      0
      /* Other */
    ],
    [
      /*start*/
      43816,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43823,
      0
      /* Other */
    ],
    [
      /*start*/
      43824,
      11
      /* ALetter */
    ],
    [
      /*start*/
      43882,
      0
      /* Other */
    ],
    [
      /*start*/
      43888,
      11
      /* ALetter */
    ],
    [
      /*start*/
      44003,
      14
      /* Extend */
    ],
    [
      /*start*/
      44011,
      0
      /* Other */
    ],
    [
      /*start*/
      44012,
      14
      /* Extend */
    ],
    [
      /*start*/
      44014,
      0
      /* Other */
    ],
    [
      /*start*/
      44016,
      9
      /* Numeric */
    ],
    [
      /*start*/
      44026,
      0
      /* Other */
    ],
    [
      /*start*/
      44032,
      11
      /* ALetter */
    ],
    [
      /*start*/
      55204,
      0
      /* Other */
    ],
    [
      /*start*/
      55216,
      11
      /* ALetter */
    ],
    [
      /*start*/
      55239,
      0
      /* Other */
    ],
    [
      /*start*/
      55243,
      11
      /* ALetter */
    ],
    [
      /*start*/
      55292,
      0
      /* Other */
    ],
    [
      /*start*/
      64256,
      11
      /* ALetter */
    ],
    [
      /*start*/
      64263,
      0
      /* Other */
    ],
    [
      /*start*/
      64275,
      11
      /* ALetter */
    ],
    [
      /*start*/
      64280,
      0
      /* Other */
    ],
    [
      /*start*/
      64285,
      15
      /* Hebrew_Letter */
    ],
    [
      /*start*/
      64286,
      14
      /* Extend */
    ],
    [
      /*start*/
      64287,
      15
      /* Hebrew_Letter */
    ],
    [
      /*start*/
      64297,
      0
      /* Other */
    ],
    [
      /*start*/
      64298,
      15
      /* Hebrew_Letter */
    ],
    [
      /*start*/
      64311,
      0
      /* Other */
    ],
    [
      /*start*/
      64312,
      15
      /* Hebrew_Letter */
    ],
    [
      /*start*/
      64317,
      0
      /* Other */
    ],
    [
      /*start*/
      64318,
      15
      /* Hebrew_Letter */
    ],
    [
      /*start*/
      64319,
      0
      /* Other */
    ],
    [
      /*start*/
      64320,
      15
      /* Hebrew_Letter */
    ],
    [
      /*start*/
      64322,
      0
      /* Other */
    ],
    [
      /*start*/
      64323,
      15
      /* Hebrew_Letter */
    ],
    [
      /*start*/
      64325,
      0
      /* Other */
    ],
    [
      /*start*/
      64326,
      15
      /* Hebrew_Letter */
    ],
    [
      /*start*/
      64336,
      11
      /* ALetter */
    ],
    [
      /*start*/
      64434,
      0
      /* Other */
    ],
    [
      /*start*/
      64467,
      11
      /* ALetter */
    ],
    [
      /*start*/
      64830,
      0
      /* Other */
    ],
    [
      /*start*/
      64848,
      11
      /* ALetter */
    ],
    [
      /*start*/
      64912,
      0
      /* Other */
    ],
    [
      /*start*/
      64914,
      11
      /* ALetter */
    ],
    [
      /*start*/
      64968,
      0
      /* Other */
    ],
    [
      /*start*/
      65008,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65020,
      0
      /* Other */
    ],
    [
      /*start*/
      65024,
      14
      /* Extend */
    ],
    [
      /*start*/
      65040,
      7
      /* MidNum */
    ],
    [
      /*start*/
      65041,
      0
      /* Other */
    ],
    [
      /*start*/
      65043,
      10
      /* MidLetter */
    ],
    [
      /*start*/
      65044,
      7
      /* MidNum */
    ],
    [
      /*start*/
      65045,
      0
      /* Other */
    ],
    [
      /*start*/
      65056,
      14
      /* Extend */
    ],
    [
      /*start*/
      65072,
      0
      /* Other */
    ],
    [
      /*start*/
      65075,
      12
      /* ExtendNumLet */
    ],
    [
      /*start*/
      65077,
      0
      /* Other */
    ],
    [
      /*start*/
      65101,
      12
      /* ExtendNumLet */
    ],
    [
      /*start*/
      65104,
      7
      /* MidNum */
    ],
    [
      /*start*/
      65105,
      0
      /* Other */
    ],
    [
      /*start*/
      65106,
      8
      /* MidNumLet */
    ],
    [
      /*start*/
      65107,
      0
      /* Other */
    ],
    [
      /*start*/
      65108,
      7
      /* MidNum */
    ],
    [
      /*start*/
      65109,
      10
      /* MidLetter */
    ],
    [
      /*start*/
      65110,
      0
      /* Other */
    ],
    [
      /*start*/
      65136,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65141,
      0
      /* Other */
    ],
    [
      /*start*/
      65142,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65277,
      0
      /* Other */
    ],
    [
      /*start*/
      65279,
      13
      /* Format */
    ],
    [
      /*start*/
      65280,
      0
      /* Other */
    ],
    [
      /*start*/
      65287,
      8
      /* MidNumLet */
    ],
    [
      /*start*/
      65288,
      0
      /* Other */
    ],
    [
      /*start*/
      65292,
      7
      /* MidNum */
    ],
    [
      /*start*/
      65293,
      0
      /* Other */
    ],
    [
      /*start*/
      65294,
      8
      /* MidNumLet */
    ],
    [
      /*start*/
      65295,
      0
      /* Other */
    ],
    [
      /*start*/
      65296,
      9
      /* Numeric */
    ],
    [
      /*start*/
      65306,
      10
      /* MidLetter */
    ],
    [
      /*start*/
      65307,
      7
      /* MidNum */
    ],
    [
      /*start*/
      65308,
      0
      /* Other */
    ],
    [
      /*start*/
      65313,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65339,
      0
      /* Other */
    ],
    [
      /*start*/
      65343,
      12
      /* ExtendNumLet */
    ],
    [
      /*start*/
      65344,
      0
      /* Other */
    ],
    [
      /*start*/
      65345,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65371,
      0
      /* Other */
    ],
    [
      /*start*/
      65382,
      17
      /* Katakana */
    ],
    [
      /*start*/
      65438,
      14
      /* Extend */
    ],
    [
      /*start*/
      65440,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65471,
      0
      /* Other */
    ],
    [
      /*start*/
      65474,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65480,
      0
      /* Other */
    ],
    [
      /*start*/
      65482,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65488,
      0
      /* Other */
    ],
    [
      /*start*/
      65490,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65496,
      0
      /* Other */
    ],
    [
      /*start*/
      65498,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65501,
      0
      /* Other */
    ],
    [
      /*start*/
      65529,
      13
      /* Format */
    ],
    [
      /*start*/
      65532,
      0
      /* Other */
    ],
    [
      /*start*/
      65536,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65548,
      0
      /* Other */
    ],
    [
      /*start*/
      65549,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65575,
      0
      /* Other */
    ],
    [
      /*start*/
      65576,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65595,
      0
      /* Other */
    ],
    [
      /*start*/
      65596,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65598,
      0
      /* Other */
    ],
    [
      /*start*/
      65599,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65614,
      0
      /* Other */
    ],
    [
      /*start*/
      65616,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65630,
      0
      /* Other */
    ],
    [
      /*start*/
      65664,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65787,
      0
      /* Other */
    ],
    [
      /*start*/
      65856,
      11
      /* ALetter */
    ],
    [
      /*start*/
      65909,
      0
      /* Other */
    ],
    [
      /*start*/
      66045,
      14
      /* Extend */
    ],
    [
      /*start*/
      66046,
      0
      /* Other */
    ],
    [
      /*start*/
      66176,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66205,
      0
      /* Other */
    ],
    [
      /*start*/
      66208,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66257,
      0
      /* Other */
    ],
    [
      /*start*/
      66272,
      14
      /* Extend */
    ],
    [
      /*start*/
      66273,
      0
      /* Other */
    ],
    [
      /*start*/
      66304,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66336,
      0
      /* Other */
    ],
    [
      /*start*/
      66349,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66379,
      0
      /* Other */
    ],
    [
      /*start*/
      66384,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66422,
      14
      /* Extend */
    ],
    [
      /*start*/
      66427,
      0
      /* Other */
    ],
    [
      /*start*/
      66432,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66462,
      0
      /* Other */
    ],
    [
      /*start*/
      66464,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66500,
      0
      /* Other */
    ],
    [
      /*start*/
      66504,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66512,
      0
      /* Other */
    ],
    [
      /*start*/
      66513,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66518,
      0
      /* Other */
    ],
    [
      /*start*/
      66560,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66718,
      0
      /* Other */
    ],
    [
      /*start*/
      66720,
      9
      /* Numeric */
    ],
    [
      /*start*/
      66730,
      0
      /* Other */
    ],
    [
      /*start*/
      66736,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66772,
      0
      /* Other */
    ],
    [
      /*start*/
      66776,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66812,
      0
      /* Other */
    ],
    [
      /*start*/
      66816,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66856,
      0
      /* Other */
    ],
    [
      /*start*/
      66864,
      11
      /* ALetter */
    ],
    [
      /*start*/
      66916,
      0
      /* Other */
    ],
    [
      /*start*/
      67072,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67383,
      0
      /* Other */
    ],
    [
      /*start*/
      67392,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67414,
      0
      /* Other */
    ],
    [
      /*start*/
      67424,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67432,
      0
      /* Other */
    ],
    [
      /*start*/
      67584,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67590,
      0
      /* Other */
    ],
    [
      /*start*/
      67592,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67593,
      0
      /* Other */
    ],
    [
      /*start*/
      67594,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67638,
      0
      /* Other */
    ],
    [
      /*start*/
      67639,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67641,
      0
      /* Other */
    ],
    [
      /*start*/
      67644,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67645,
      0
      /* Other */
    ],
    [
      /*start*/
      67647,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67670,
      0
      /* Other */
    ],
    [
      /*start*/
      67680,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67703,
      0
      /* Other */
    ],
    [
      /*start*/
      67712,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67743,
      0
      /* Other */
    ],
    [
      /*start*/
      67808,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67827,
      0
      /* Other */
    ],
    [
      /*start*/
      67828,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67830,
      0
      /* Other */
    ],
    [
      /*start*/
      67840,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67862,
      0
      /* Other */
    ],
    [
      /*start*/
      67872,
      11
      /* ALetter */
    ],
    [
      /*start*/
      67898,
      0
      /* Other */
    ],
    [
      /*start*/
      67968,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68024,
      0
      /* Other */
    ],
    [
      /*start*/
      68030,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68032,
      0
      /* Other */
    ],
    [
      /*start*/
      68096,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68097,
      14
      /* Extend */
    ],
    [
      /*start*/
      68100,
      0
      /* Other */
    ],
    [
      /*start*/
      68101,
      14
      /* Extend */
    ],
    [
      /*start*/
      68103,
      0
      /* Other */
    ],
    [
      /*start*/
      68108,
      14
      /* Extend */
    ],
    [
      /*start*/
      68112,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68116,
      0
      /* Other */
    ],
    [
      /*start*/
      68117,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68120,
      0
      /* Other */
    ],
    [
      /*start*/
      68121,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68150,
      0
      /* Other */
    ],
    [
      /*start*/
      68152,
      14
      /* Extend */
    ],
    [
      /*start*/
      68155,
      0
      /* Other */
    ],
    [
      /*start*/
      68159,
      14
      /* Extend */
    ],
    [
      /*start*/
      68160,
      0
      /* Other */
    ],
    [
      /*start*/
      68192,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68221,
      0
      /* Other */
    ],
    [
      /*start*/
      68224,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68253,
      0
      /* Other */
    ],
    [
      /*start*/
      68288,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68296,
      0
      /* Other */
    ],
    [
      /*start*/
      68297,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68325,
      14
      /* Extend */
    ],
    [
      /*start*/
      68327,
      0
      /* Other */
    ],
    [
      /*start*/
      68352,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68406,
      0
      /* Other */
    ],
    [
      /*start*/
      68416,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68438,
      0
      /* Other */
    ],
    [
      /*start*/
      68448,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68467,
      0
      /* Other */
    ],
    [
      /*start*/
      68480,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68498,
      0
      /* Other */
    ],
    [
      /*start*/
      68608,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68681,
      0
      /* Other */
    ],
    [
      /*start*/
      68736,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68787,
      0
      /* Other */
    ],
    [
      /*start*/
      68800,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68851,
      0
      /* Other */
    ],
    [
      /*start*/
      68864,
      11
      /* ALetter */
    ],
    [
      /*start*/
      68900,
      14
      /* Extend */
    ],
    [
      /*start*/
      68904,
      0
      /* Other */
    ],
    [
      /*start*/
      68912,
      9
      /* Numeric */
    ],
    [
      /*start*/
      68922,
      0
      /* Other */
    ],
    [
      /*start*/
      69248,
      11
      /* ALetter */
    ],
    [
      /*start*/
      69290,
      0
      /* Other */
    ],
    [
      /*start*/
      69291,
      14
      /* Extend */
    ],
    [
      /*start*/
      69293,
      0
      /* Other */
    ],
    [
      /*start*/
      69296,
      11
      /* ALetter */
    ],
    [
      /*start*/
      69298,
      0
      /* Other */
    ],
    [
      /*start*/
      69376,
      11
      /* ALetter */
    ],
    [
      /*start*/
      69405,
      0
      /* Other */
    ],
    [
      /*start*/
      69415,
      11
      /* ALetter */
    ],
    [
      /*start*/
      69416,
      0
      /* Other */
    ],
    [
      /*start*/
      69424,
      11
      /* ALetter */
    ],
    [
      /*start*/
      69446,
      14
      /* Extend */
    ],
    [
      /*start*/
      69457,
      0
      /* Other */
    ],
    [
      /*start*/
      69552,
      11
      /* ALetter */
    ],
    [
      /*start*/
      69573,
      0
      /* Other */
    ],
    [
      /*start*/
      69600,
      11
      /* ALetter */
    ],
    [
      /*start*/
      69623,
      0
      /* Other */
    ],
    [
      /*start*/
      69632,
      14
      /* Extend */
    ],
    [
      /*start*/
      69635,
      11
      /* ALetter */
    ],
    [
      /*start*/
      69688,
      14
      /* Extend */
    ],
    [
      /*start*/
      69703,
      0
      /* Other */
    ],
    [
      /*start*/
      69734,
      9
      /* Numeric */
    ],
    [
      /*start*/
      69744,
      0
      /* Other */
    ],
    [
      /*start*/
      69759,
      14
      /* Extend */
    ],
    [
      /*start*/
      69763,
      11
      /* ALetter */
    ],
    [
      /*start*/
      69808,
      14
      /* Extend */
    ],
    [
      /*start*/
      69819,
      0
      /* Other */
    ],
    [
      /*start*/
      69821,
      13
      /* Format */
    ],
    [
      /*start*/
      69822,
      0
      /* Other */
    ],
    [
      /*start*/
      69837,
      13
      /* Format */
    ],
    [
      /*start*/
      69838,
      0
      /* Other */
    ],
    [
      /*start*/
      69840,
      11
      /* ALetter */
    ],
    [
      /*start*/
      69865,
      0
      /* Other */
    ],
    [
      /*start*/
      69872,
      9
      /* Numeric */
    ],
    [
      /*start*/
      69882,
      0
      /* Other */
    ],
    [
      /*start*/
      69888,
      14
      /* Extend */
    ],
    [
      /*start*/
      69891,
      11
      /* ALetter */
    ],
    [
      /*start*/
      69927,
      14
      /* Extend */
    ],
    [
      /*start*/
      69941,
      0
      /* Other */
    ],
    [
      /*start*/
      69942,
      9
      /* Numeric */
    ],
    [
      /*start*/
      69952,
      0
      /* Other */
    ],
    [
      /*start*/
      69956,
      11
      /* ALetter */
    ],
    [
      /*start*/
      69957,
      14
      /* Extend */
    ],
    [
      /*start*/
      69959,
      11
      /* ALetter */
    ],
    [
      /*start*/
      69960,
      0
      /* Other */
    ],
    [
      /*start*/
      69968,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70003,
      14
      /* Extend */
    ],
    [
      /*start*/
      70004,
      0
      /* Other */
    ],
    [
      /*start*/
      70006,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70007,
      0
      /* Other */
    ],
    [
      /*start*/
      70016,
      14
      /* Extend */
    ],
    [
      /*start*/
      70019,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70067,
      14
      /* Extend */
    ],
    [
      /*start*/
      70081,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70085,
      0
      /* Other */
    ],
    [
      /*start*/
      70089,
      14
      /* Extend */
    ],
    [
      /*start*/
      70093,
      0
      /* Other */
    ],
    [
      /*start*/
      70094,
      14
      /* Extend */
    ],
    [
      /*start*/
      70096,
      9
      /* Numeric */
    ],
    [
      /*start*/
      70106,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70107,
      0
      /* Other */
    ],
    [
      /*start*/
      70108,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70109,
      0
      /* Other */
    ],
    [
      /*start*/
      70144,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70162,
      0
      /* Other */
    ],
    [
      /*start*/
      70163,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70188,
      14
      /* Extend */
    ],
    [
      /*start*/
      70200,
      0
      /* Other */
    ],
    [
      /*start*/
      70206,
      14
      /* Extend */
    ],
    [
      /*start*/
      70207,
      0
      /* Other */
    ],
    [
      /*start*/
      70272,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70279,
      0
      /* Other */
    ],
    [
      /*start*/
      70280,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70281,
      0
      /* Other */
    ],
    [
      /*start*/
      70282,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70286,
      0
      /* Other */
    ],
    [
      /*start*/
      70287,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70302,
      0
      /* Other */
    ],
    [
      /*start*/
      70303,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70313,
      0
      /* Other */
    ],
    [
      /*start*/
      70320,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70367,
      14
      /* Extend */
    ],
    [
      /*start*/
      70379,
      0
      /* Other */
    ],
    [
      /*start*/
      70384,
      9
      /* Numeric */
    ],
    [
      /*start*/
      70394,
      0
      /* Other */
    ],
    [
      /*start*/
      70400,
      14
      /* Extend */
    ],
    [
      /*start*/
      70404,
      0
      /* Other */
    ],
    [
      /*start*/
      70405,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70413,
      0
      /* Other */
    ],
    [
      /*start*/
      70415,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70417,
      0
      /* Other */
    ],
    [
      /*start*/
      70419,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70441,
      0
      /* Other */
    ],
    [
      /*start*/
      70442,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70449,
      0
      /* Other */
    ],
    [
      /*start*/
      70450,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70452,
      0
      /* Other */
    ],
    [
      /*start*/
      70453,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70458,
      0
      /* Other */
    ],
    [
      /*start*/
      70459,
      14
      /* Extend */
    ],
    [
      /*start*/
      70461,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70462,
      14
      /* Extend */
    ],
    [
      /*start*/
      70469,
      0
      /* Other */
    ],
    [
      /*start*/
      70471,
      14
      /* Extend */
    ],
    [
      /*start*/
      70473,
      0
      /* Other */
    ],
    [
      /*start*/
      70475,
      14
      /* Extend */
    ],
    [
      /*start*/
      70478,
      0
      /* Other */
    ],
    [
      /*start*/
      70480,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70481,
      0
      /* Other */
    ],
    [
      /*start*/
      70487,
      14
      /* Extend */
    ],
    [
      /*start*/
      70488,
      0
      /* Other */
    ],
    [
      /*start*/
      70493,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70498,
      14
      /* Extend */
    ],
    [
      /*start*/
      70500,
      0
      /* Other */
    ],
    [
      /*start*/
      70502,
      14
      /* Extend */
    ],
    [
      /*start*/
      70509,
      0
      /* Other */
    ],
    [
      /*start*/
      70512,
      14
      /* Extend */
    ],
    [
      /*start*/
      70517,
      0
      /* Other */
    ],
    [
      /*start*/
      70656,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70709,
      14
      /* Extend */
    ],
    [
      /*start*/
      70727,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70731,
      0
      /* Other */
    ],
    [
      /*start*/
      70736,
      9
      /* Numeric */
    ],
    [
      /*start*/
      70746,
      0
      /* Other */
    ],
    [
      /*start*/
      70750,
      14
      /* Extend */
    ],
    [
      /*start*/
      70751,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70754,
      0
      /* Other */
    ],
    [
      /*start*/
      70784,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70832,
      14
      /* Extend */
    ],
    [
      /*start*/
      70852,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70854,
      0
      /* Other */
    ],
    [
      /*start*/
      70855,
      11
      /* ALetter */
    ],
    [
      /*start*/
      70856,
      0
      /* Other */
    ],
    [
      /*start*/
      70864,
      9
      /* Numeric */
    ],
    [
      /*start*/
      70874,
      0
      /* Other */
    ],
    [
      /*start*/
      71040,
      11
      /* ALetter */
    ],
    [
      /*start*/
      71087,
      14
      /* Extend */
    ],
    [
      /*start*/
      71094,
      0
      /* Other */
    ],
    [
      /*start*/
      71096,
      14
      /* Extend */
    ],
    [
      /*start*/
      71105,
      0
      /* Other */
    ],
    [
      /*start*/
      71128,
      11
      /* ALetter */
    ],
    [
      /*start*/
      71132,
      14
      /* Extend */
    ],
    [
      /*start*/
      71134,
      0
      /* Other */
    ],
    [
      /*start*/
      71168,
      11
      /* ALetter */
    ],
    [
      /*start*/
      71216,
      14
      /* Extend */
    ],
    [
      /*start*/
      71233,
      0
      /* Other */
    ],
    [
      /*start*/
      71236,
      11
      /* ALetter */
    ],
    [
      /*start*/
      71237,
      0
      /* Other */
    ],
    [
      /*start*/
      71248,
      9
      /* Numeric */
    ],
    [
      /*start*/
      71258,
      0
      /* Other */
    ],
    [
      /*start*/
      71296,
      11
      /* ALetter */
    ],
    [
      /*start*/
      71339,
      14
      /* Extend */
    ],
    [
      /*start*/
      71352,
      11
      /* ALetter */
    ],
    [
      /*start*/
      71353,
      0
      /* Other */
    ],
    [
      /*start*/
      71360,
      9
      /* Numeric */
    ],
    [
      /*start*/
      71370,
      0
      /* Other */
    ],
    [
      /*start*/
      71453,
      14
      /* Extend */
    ],
    [
      /*start*/
      71468,
      0
      /* Other */
    ],
    [
      /*start*/
      71472,
      9
      /* Numeric */
    ],
    [
      /*start*/
      71482,
      0
      /* Other */
    ],
    [
      /*start*/
      71680,
      11
      /* ALetter */
    ],
    [
      /*start*/
      71724,
      14
      /* Extend */
    ],
    [
      /*start*/
      71739,
      0
      /* Other */
    ],
    [
      /*start*/
      71840,
      11
      /* ALetter */
    ],
    [
      /*start*/
      71904,
      9
      /* Numeric */
    ],
    [
      /*start*/
      71914,
      0
      /* Other */
    ],
    [
      /*start*/
      71935,
      11
      /* ALetter */
    ],
    [
      /*start*/
      71943,
      0
      /* Other */
    ],
    [
      /*start*/
      71945,
      11
      /* ALetter */
    ],
    [
      /*start*/
      71946,
      0
      /* Other */
    ],
    [
      /*start*/
      71948,
      11
      /* ALetter */
    ],
    [
      /*start*/
      71956,
      0
      /* Other */
    ],
    [
      /*start*/
      71957,
      11
      /* ALetter */
    ],
    [
      /*start*/
      71959,
      0
      /* Other */
    ],
    [
      /*start*/
      71960,
      11
      /* ALetter */
    ],
    [
      /*start*/
      71984,
      14
      /* Extend */
    ],
    [
      /*start*/
      71990,
      0
      /* Other */
    ],
    [
      /*start*/
      71991,
      14
      /* Extend */
    ],
    [
      /*start*/
      71993,
      0
      /* Other */
    ],
    [
      /*start*/
      71995,
      14
      /* Extend */
    ],
    [
      /*start*/
      71999,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72e3,
      14
      /* Extend */
    ],
    [
      /*start*/
      72001,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72002,
      14
      /* Extend */
    ],
    [
      /*start*/
      72004,
      0
      /* Other */
    ],
    [
      /*start*/
      72016,
      9
      /* Numeric */
    ],
    [
      /*start*/
      72026,
      0
      /* Other */
    ],
    [
      /*start*/
      72096,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72104,
      0
      /* Other */
    ],
    [
      /*start*/
      72106,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72145,
      14
      /* Extend */
    ],
    [
      /*start*/
      72152,
      0
      /* Other */
    ],
    [
      /*start*/
      72154,
      14
      /* Extend */
    ],
    [
      /*start*/
      72161,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72162,
      0
      /* Other */
    ],
    [
      /*start*/
      72163,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72164,
      14
      /* Extend */
    ],
    [
      /*start*/
      72165,
      0
      /* Other */
    ],
    [
      /*start*/
      72192,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72193,
      14
      /* Extend */
    ],
    [
      /*start*/
      72203,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72243,
      14
      /* Extend */
    ],
    [
      /*start*/
      72250,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72251,
      14
      /* Extend */
    ],
    [
      /*start*/
      72255,
      0
      /* Other */
    ],
    [
      /*start*/
      72263,
      14
      /* Extend */
    ],
    [
      /*start*/
      72264,
      0
      /* Other */
    ],
    [
      /*start*/
      72272,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72273,
      14
      /* Extend */
    ],
    [
      /*start*/
      72284,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72330,
      14
      /* Extend */
    ],
    [
      /*start*/
      72346,
      0
      /* Other */
    ],
    [
      /*start*/
      72349,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72350,
      0
      /* Other */
    ],
    [
      /*start*/
      72384,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72441,
      0
      /* Other */
    ],
    [
      /*start*/
      72704,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72713,
      0
      /* Other */
    ],
    [
      /*start*/
      72714,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72751,
      14
      /* Extend */
    ],
    [
      /*start*/
      72759,
      0
      /* Other */
    ],
    [
      /*start*/
      72760,
      14
      /* Extend */
    ],
    [
      /*start*/
      72768,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72769,
      0
      /* Other */
    ],
    [
      /*start*/
      72784,
      9
      /* Numeric */
    ],
    [
      /*start*/
      72794,
      0
      /* Other */
    ],
    [
      /*start*/
      72818,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72848,
      0
      /* Other */
    ],
    [
      /*start*/
      72850,
      14
      /* Extend */
    ],
    [
      /*start*/
      72872,
      0
      /* Other */
    ],
    [
      /*start*/
      72873,
      14
      /* Extend */
    ],
    [
      /*start*/
      72887,
      0
      /* Other */
    ],
    [
      /*start*/
      72960,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72967,
      0
      /* Other */
    ],
    [
      /*start*/
      72968,
      11
      /* ALetter */
    ],
    [
      /*start*/
      72970,
      0
      /* Other */
    ],
    [
      /*start*/
      72971,
      11
      /* ALetter */
    ],
    [
      /*start*/
      73009,
      14
      /* Extend */
    ],
    [
      /*start*/
      73015,
      0
      /* Other */
    ],
    [
      /*start*/
      73018,
      14
      /* Extend */
    ],
    [
      /*start*/
      73019,
      0
      /* Other */
    ],
    [
      /*start*/
      73020,
      14
      /* Extend */
    ],
    [
      /*start*/
      73022,
      0
      /* Other */
    ],
    [
      /*start*/
      73023,
      14
      /* Extend */
    ],
    [
      /*start*/
      73030,
      11
      /* ALetter */
    ],
    [
      /*start*/
      73031,
      14
      /* Extend */
    ],
    [
      /*start*/
      73032,
      0
      /* Other */
    ],
    [
      /*start*/
      73040,
      9
      /* Numeric */
    ],
    [
      /*start*/
      73050,
      0
      /* Other */
    ],
    [
      /*start*/
      73056,
      11
      /* ALetter */
    ],
    [
      /*start*/
      73062,
      0
      /* Other */
    ],
    [
      /*start*/
      73063,
      11
      /* ALetter */
    ],
    [
      /*start*/
      73065,
      0
      /* Other */
    ],
    [
      /*start*/
      73066,
      11
      /* ALetter */
    ],
    [
      /*start*/
      73098,
      14
      /* Extend */
    ],
    [
      /*start*/
      73103,
      0
      /* Other */
    ],
    [
      /*start*/
      73104,
      14
      /* Extend */
    ],
    [
      /*start*/
      73106,
      0
      /* Other */
    ],
    [
      /*start*/
      73107,
      14
      /* Extend */
    ],
    [
      /*start*/
      73112,
      11
      /* ALetter */
    ],
    [
      /*start*/
      73113,
      0
      /* Other */
    ],
    [
      /*start*/
      73120,
      9
      /* Numeric */
    ],
    [
      /*start*/
      73130,
      0
      /* Other */
    ],
    [
      /*start*/
      73440,
      11
      /* ALetter */
    ],
    [
      /*start*/
      73459,
      14
      /* Extend */
    ],
    [
      /*start*/
      73463,
      0
      /* Other */
    ],
    [
      /*start*/
      73648,
      11
      /* ALetter */
    ],
    [
      /*start*/
      73649,
      0
      /* Other */
    ],
    [
      /*start*/
      73728,
      11
      /* ALetter */
    ],
    [
      /*start*/
      74650,
      0
      /* Other */
    ],
    [
      /*start*/
      74752,
      11
      /* ALetter */
    ],
    [
      /*start*/
      74863,
      0
      /* Other */
    ],
    [
      /*start*/
      74880,
      11
      /* ALetter */
    ],
    [
      /*start*/
      75076,
      0
      /* Other */
    ],
    [
      /*start*/
      77824,
      11
      /* ALetter */
    ],
    [
      /*start*/
      78895,
      0
      /* Other */
    ],
    [
      /*start*/
      78896,
      13
      /* Format */
    ],
    [
      /*start*/
      78905,
      0
      /* Other */
    ],
    [
      /*start*/
      82944,
      11
      /* ALetter */
    ],
    [
      /*start*/
      83527,
      0
      /* Other */
    ],
    [
      /*start*/
      92160,
      11
      /* ALetter */
    ],
    [
      /*start*/
      92729,
      0
      /* Other */
    ],
    [
      /*start*/
      92736,
      11
      /* ALetter */
    ],
    [
      /*start*/
      92767,
      0
      /* Other */
    ],
    [
      /*start*/
      92768,
      9
      /* Numeric */
    ],
    [
      /*start*/
      92778,
      0
      /* Other */
    ],
    [
      /*start*/
      92880,
      11
      /* ALetter */
    ],
    [
      /*start*/
      92910,
      0
      /* Other */
    ],
    [
      /*start*/
      92912,
      14
      /* Extend */
    ],
    [
      /*start*/
      92917,
      0
      /* Other */
    ],
    [
      /*start*/
      92928,
      11
      /* ALetter */
    ],
    [
      /*start*/
      92976,
      14
      /* Extend */
    ],
    [
      /*start*/
      92983,
      0
      /* Other */
    ],
    [
      /*start*/
      92992,
      11
      /* ALetter */
    ],
    [
      /*start*/
      92996,
      0
      /* Other */
    ],
    [
      /*start*/
      93008,
      9
      /* Numeric */
    ],
    [
      /*start*/
      93018,
      0
      /* Other */
    ],
    [
      /*start*/
      93027,
      11
      /* ALetter */
    ],
    [
      /*start*/
      93048,
      0
      /* Other */
    ],
    [
      /*start*/
      93053,
      11
      /* ALetter */
    ],
    [
      /*start*/
      93072,
      0
      /* Other */
    ],
    [
      /*start*/
      93760,
      11
      /* ALetter */
    ],
    [
      /*start*/
      93824,
      0
      /* Other */
    ],
    [
      /*start*/
      93952,
      11
      /* ALetter */
    ],
    [
      /*start*/
      94027,
      0
      /* Other */
    ],
    [
      /*start*/
      94031,
      14
      /* Extend */
    ],
    [
      /*start*/
      94032,
      11
      /* ALetter */
    ],
    [
      /*start*/
      94033,
      14
      /* Extend */
    ],
    [
      /*start*/
      94088,
      0
      /* Other */
    ],
    [
      /*start*/
      94095,
      14
      /* Extend */
    ],
    [
      /*start*/
      94099,
      11
      /* ALetter */
    ],
    [
      /*start*/
      94112,
      0
      /* Other */
    ],
    [
      /*start*/
      94176,
      11
      /* ALetter */
    ],
    [
      /*start*/
      94178,
      0
      /* Other */
    ],
    [
      /*start*/
      94179,
      11
      /* ALetter */
    ],
    [
      /*start*/
      94180,
      14
      /* Extend */
    ],
    [
      /*start*/
      94181,
      0
      /* Other */
    ],
    [
      /*start*/
      94192,
      14
      /* Extend */
    ],
    [
      /*start*/
      94194,
      0
      /* Other */
    ],
    [
      /*start*/
      110592,
      17
      /* Katakana */
    ],
    [
      /*start*/
      110593,
      0
      /* Other */
    ],
    [
      /*start*/
      110948,
      17
      /* Katakana */
    ],
    [
      /*start*/
      110952,
      0
      /* Other */
    ],
    [
      /*start*/
      113664,
      11
      /* ALetter */
    ],
    [
      /*start*/
      113771,
      0
      /* Other */
    ],
    [
      /*start*/
      113776,
      11
      /* ALetter */
    ],
    [
      /*start*/
      113789,
      0
      /* Other */
    ],
    [
      /*start*/
      113792,
      11
      /* ALetter */
    ],
    [
      /*start*/
      113801,
      0
      /* Other */
    ],
    [
      /*start*/
      113808,
      11
      /* ALetter */
    ],
    [
      /*start*/
      113818,
      0
      /* Other */
    ],
    [
      /*start*/
      113821,
      14
      /* Extend */
    ],
    [
      /*start*/
      113823,
      0
      /* Other */
    ],
    [
      /*start*/
      113824,
      13
      /* Format */
    ],
    [
      /*start*/
      113828,
      0
      /* Other */
    ],
    [
      /*start*/
      119141,
      14
      /* Extend */
    ],
    [
      /*start*/
      119146,
      0
      /* Other */
    ],
    [
      /*start*/
      119149,
      14
      /* Extend */
    ],
    [
      /*start*/
      119155,
      13
      /* Format */
    ],
    [
      /*start*/
      119163,
      14
      /* Extend */
    ],
    [
      /*start*/
      119171,
      0
      /* Other */
    ],
    [
      /*start*/
      119173,
      14
      /* Extend */
    ],
    [
      /*start*/
      119180,
      0
      /* Other */
    ],
    [
      /*start*/
      119210,
      14
      /* Extend */
    ],
    [
      /*start*/
      119214,
      0
      /* Other */
    ],
    [
      /*start*/
      119362,
      14
      /* Extend */
    ],
    [
      /*start*/
      119365,
      0
      /* Other */
    ],
    [
      /*start*/
      119808,
      11
      /* ALetter */
    ],
    [
      /*start*/
      119893,
      0
      /* Other */
    ],
    [
      /*start*/
      119894,
      11
      /* ALetter */
    ],
    [
      /*start*/
      119965,
      0
      /* Other */
    ],
    [
      /*start*/
      119966,
      11
      /* ALetter */
    ],
    [
      /*start*/
      119968,
      0
      /* Other */
    ],
    [
      /*start*/
      119970,
      11
      /* ALetter */
    ],
    [
      /*start*/
      119971,
      0
      /* Other */
    ],
    [
      /*start*/
      119973,
      11
      /* ALetter */
    ],
    [
      /*start*/
      119975,
      0
      /* Other */
    ],
    [
      /*start*/
      119977,
      11
      /* ALetter */
    ],
    [
      /*start*/
      119981,
      0
      /* Other */
    ],
    [
      /*start*/
      119982,
      11
      /* ALetter */
    ],
    [
      /*start*/
      119994,
      0
      /* Other */
    ],
    [
      /*start*/
      119995,
      11
      /* ALetter */
    ],
    [
      /*start*/
      119996,
      0
      /* Other */
    ],
    [
      /*start*/
      119997,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120004,
      0
      /* Other */
    ],
    [
      /*start*/
      120005,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120070,
      0
      /* Other */
    ],
    [
      /*start*/
      120071,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120075,
      0
      /* Other */
    ],
    [
      /*start*/
      120077,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120085,
      0
      /* Other */
    ],
    [
      /*start*/
      120086,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120093,
      0
      /* Other */
    ],
    [
      /*start*/
      120094,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120122,
      0
      /* Other */
    ],
    [
      /*start*/
      120123,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120127,
      0
      /* Other */
    ],
    [
      /*start*/
      120128,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120133,
      0
      /* Other */
    ],
    [
      /*start*/
      120134,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120135,
      0
      /* Other */
    ],
    [
      /*start*/
      120138,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120145,
      0
      /* Other */
    ],
    [
      /*start*/
      120146,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120486,
      0
      /* Other */
    ],
    [
      /*start*/
      120488,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120513,
      0
      /* Other */
    ],
    [
      /*start*/
      120514,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120539,
      0
      /* Other */
    ],
    [
      /*start*/
      120540,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120571,
      0
      /* Other */
    ],
    [
      /*start*/
      120572,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120597,
      0
      /* Other */
    ],
    [
      /*start*/
      120598,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120629,
      0
      /* Other */
    ],
    [
      /*start*/
      120630,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120655,
      0
      /* Other */
    ],
    [
      /*start*/
      120656,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120687,
      0
      /* Other */
    ],
    [
      /*start*/
      120688,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120713,
      0
      /* Other */
    ],
    [
      /*start*/
      120714,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120745,
      0
      /* Other */
    ],
    [
      /*start*/
      120746,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120771,
      0
      /* Other */
    ],
    [
      /*start*/
      120772,
      11
      /* ALetter */
    ],
    [
      /*start*/
      120780,
      0
      /* Other */
    ],
    [
      /*start*/
      120782,
      9
      /* Numeric */
    ],
    [
      /*start*/
      120832,
      0
      /* Other */
    ],
    [
      /*start*/
      121344,
      14
      /* Extend */
    ],
    [
      /*start*/
      121399,
      0
      /* Other */
    ],
    [
      /*start*/
      121403,
      14
      /* Extend */
    ],
    [
      /*start*/
      121453,
      0
      /* Other */
    ],
    [
      /*start*/
      121461,
      14
      /* Extend */
    ],
    [
      /*start*/
      121462,
      0
      /* Other */
    ],
    [
      /*start*/
      121476,
      14
      /* Extend */
    ],
    [
      /*start*/
      121477,
      0
      /* Other */
    ],
    [
      /*start*/
      121499,
      14
      /* Extend */
    ],
    [
      /*start*/
      121504,
      0
      /* Other */
    ],
    [
      /*start*/
      121505,
      14
      /* Extend */
    ],
    [
      /*start*/
      121520,
      0
      /* Other */
    ],
    [
      /*start*/
      122880,
      14
      /* Extend */
    ],
    [
      /*start*/
      122887,
      0
      /* Other */
    ],
    [
      /*start*/
      122888,
      14
      /* Extend */
    ],
    [
      /*start*/
      122905,
      0
      /* Other */
    ],
    [
      /*start*/
      122907,
      14
      /* Extend */
    ],
    [
      /*start*/
      122914,
      0
      /* Other */
    ],
    [
      /*start*/
      122915,
      14
      /* Extend */
    ],
    [
      /*start*/
      122917,
      0
      /* Other */
    ],
    [
      /*start*/
      122918,
      14
      /* Extend */
    ],
    [
      /*start*/
      122923,
      0
      /* Other */
    ],
    [
      /*start*/
      123136,
      11
      /* ALetter */
    ],
    [
      /*start*/
      123181,
      0
      /* Other */
    ],
    [
      /*start*/
      123184,
      14
      /* Extend */
    ],
    [
      /*start*/
      123191,
      11
      /* ALetter */
    ],
    [
      /*start*/
      123198,
      0
      /* Other */
    ],
    [
      /*start*/
      123200,
      9
      /* Numeric */
    ],
    [
      /*start*/
      123210,
      0
      /* Other */
    ],
    [
      /*start*/
      123214,
      11
      /* ALetter */
    ],
    [
      /*start*/
      123215,
      0
      /* Other */
    ],
    [
      /*start*/
      123584,
      11
      /* ALetter */
    ],
    [
      /*start*/
      123628,
      14
      /* Extend */
    ],
    [
      /*start*/
      123632,
      9
      /* Numeric */
    ],
    [
      /*start*/
      123642,
      0
      /* Other */
    ],
    [
      /*start*/
      124928,
      11
      /* ALetter */
    ],
    [
      /*start*/
      125125,
      0
      /* Other */
    ],
    [
      /*start*/
      125136,
      14
      /* Extend */
    ],
    [
      /*start*/
      125143,
      0
      /* Other */
    ],
    [
      /*start*/
      125184,
      11
      /* ALetter */
    ],
    [
      /*start*/
      125252,
      14
      /* Extend */
    ],
    [
      /*start*/
      125259,
      11
      /* ALetter */
    ],
    [
      /*start*/
      125260,
      0
      /* Other */
    ],
    [
      /*start*/
      125264,
      9
      /* Numeric */
    ],
    [
      /*start*/
      125274,
      0
      /* Other */
    ],
    [
      /*start*/
      126464,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126468,
      0
      /* Other */
    ],
    [
      /*start*/
      126469,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126496,
      0
      /* Other */
    ],
    [
      /*start*/
      126497,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126499,
      0
      /* Other */
    ],
    [
      /*start*/
      126500,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126501,
      0
      /* Other */
    ],
    [
      /*start*/
      126503,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126504,
      0
      /* Other */
    ],
    [
      /*start*/
      126505,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126515,
      0
      /* Other */
    ],
    [
      /*start*/
      126516,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126520,
      0
      /* Other */
    ],
    [
      /*start*/
      126521,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126522,
      0
      /* Other */
    ],
    [
      /*start*/
      126523,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126524,
      0
      /* Other */
    ],
    [
      /*start*/
      126530,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126531,
      0
      /* Other */
    ],
    [
      /*start*/
      126535,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126536,
      0
      /* Other */
    ],
    [
      /*start*/
      126537,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126538,
      0
      /* Other */
    ],
    [
      /*start*/
      126539,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126540,
      0
      /* Other */
    ],
    [
      /*start*/
      126541,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126544,
      0
      /* Other */
    ],
    [
      /*start*/
      126545,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126547,
      0
      /* Other */
    ],
    [
      /*start*/
      126548,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126549,
      0
      /* Other */
    ],
    [
      /*start*/
      126551,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126552,
      0
      /* Other */
    ],
    [
      /*start*/
      126553,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126554,
      0
      /* Other */
    ],
    [
      /*start*/
      126555,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126556,
      0
      /* Other */
    ],
    [
      /*start*/
      126557,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126558,
      0
      /* Other */
    ],
    [
      /*start*/
      126559,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126560,
      0
      /* Other */
    ],
    [
      /*start*/
      126561,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126563,
      0
      /* Other */
    ],
    [
      /*start*/
      126564,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126565,
      0
      /* Other */
    ],
    [
      /*start*/
      126567,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126571,
      0
      /* Other */
    ],
    [
      /*start*/
      126572,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126579,
      0
      /* Other */
    ],
    [
      /*start*/
      126580,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126584,
      0
      /* Other */
    ],
    [
      /*start*/
      126585,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126589,
      0
      /* Other */
    ],
    [
      /*start*/
      126590,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126591,
      0
      /* Other */
    ],
    [
      /*start*/
      126592,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126602,
      0
      /* Other */
    ],
    [
      /*start*/
      126603,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126620,
      0
      /* Other */
    ],
    [
      /*start*/
      126625,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126628,
      0
      /* Other */
    ],
    [
      /*start*/
      126629,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126634,
      0
      /* Other */
    ],
    [
      /*start*/
      126635,
      11
      /* ALetter */
    ],
    [
      /*start*/
      126652,
      0
      /* Other */
    ],
    [
      /*start*/
      127280,
      11
      /* ALetter */
    ],
    [
      /*start*/
      127306,
      0
      /* Other */
    ],
    [
      /*start*/
      127312,
      11
      /* ALetter */
    ],
    [
      /*start*/
      127338,
      0
      /* Other */
    ],
    [
      /*start*/
      127344,
      11
      /* ALetter */
    ],
    [
      /*start*/
      127370,
      0
      /* Other */
    ],
    [
      /*start*/
      127462,
      18
      /* Regional_Indicator */
    ],
    [
      /*start*/
      127488,
      0
      /* Other */
    ],
    [
      /*start*/
      127995,
      14
      /* Extend */
    ],
    [
      /*start*/
      128e3,
      0
      /* Other */
    ],
    [
      /*start*/
      130032,
      9
      /* Numeric */
    ],
    [
      /*start*/
      130042,
      0
      /* Other */
    ],
    [
      /*start*/
      917505,
      13
      /* Format */
    ],
    [
      /*start*/
      917506,
      0
      /* Other */
    ],
    [
      /*start*/
      917536,
      14
      /* Extend */
    ],
    [
      /*start*/
      917632,
      0
      /* Other */
    ],
    [
      /*start*/
      917760,
      14
      /* Extend */
    ],
    [
      /*start*/
      918e3,
      0
      /* Other */
    ]
  ]), bf;
}
var qS;
function k7() {
  if (qS) return Af;
  qS = 1;
  Object.defineProperty(Af, "__esModule", { value: !0 });
  const r = E7();
  function* e(a) {
    if (a.length === 0)
      return;
    let s, o = 0, l, u = 19, c = 19, d = g(0), f = 0;
    do {
      if (s = o, o = h(o), [l, u, c, d] = [u, c, d, g(o)], u === 19) {
        yield s;
        continue;
      }
      if (c === 20) {
        yield s;
        break;
      }
      if (!(u === 3 && c === 1)) {
        if (u === 2 || u == 3 || u === 1) {
          yield s;
          continue;
        }
        if (c === 2 || c === 3 || c === 1) {
          yield s;
          continue;
        }
        if (u === 0 && (c === 14 || c === 13) && d === 16) {
          for (let x = 0; x < 2; x++)
            [s, o] = [o, h(o)];
          [u, c, d] = [d, g(s), g(o)];
        }
        if (!(u === 16 && v(s)) && !(u === 4 && c == 4)) {
          for (; c === 13 || c === 14 || c === 16; )
            [s, o] = [o, h(o)], [c, d] = [d, g(o)];
          if (c === 20) {
            yield s;
            break;
          }
          for (; d === 13 || d === 14 || d === 16; )
            o = h(o), d = g(o);
          if (!(y(u) && y(c)) && !(y(u) && y(d) && (c === 10 || A(c))) && !(y(l) && y(c) && (u === 10 || A(u))) && !(u === 15 && c === 6) && !(u === 15 && c === 5 && d === 15) && !(l === 15 && u === 5 && c === 15) && !(u === 9 && c === 9) && !(y(u) && c === 9) && !(u === 9 && y(c)) && !(l === 9 && c === 9 && (u === 7 || A(u))) && !(u === 9 && d === 9 && (c === 7 || A(c))) && !(u === 17 && c === 17) && !((y(u) || u === 9 || u === 17 || u === 12) && c === 12) && !((y(c) || c === 9 || c === 17) && u === 12)) {
            if (c === 18) {
              if (f += 1, f % 2 == 1)
                continue;
            } else
              f = 0;
            yield s;
          }
        }
      }
    } while (s < a.length);
    function h(x) {
      return x >= a.length ? a.length : t(a[x]) ? x + 2 : x + 1;
    }
    function g(x) {
      return x < 0 ? 19 : x >= a.length ? 20 : t(a[x]) ? n(a[x] + a[x + 1]) : n(a[x]);
    }
    function v(x) {
      return r.extendedPictographic.test(a.substring(x, x + 2));
    }
    function y(x) {
      return x === 11 || x === 15;
    }
    function A(x) {
      return x === 8 || x === 6;
    }
  }
  Af.findBoundaries = e;
  function t(a) {
    let s = a.charCodeAt(0);
    return s >= 55296 && s <= 56319;
  }
  function n(a) {
    let s = a.codePointAt(0);
    return i(s, 0, r.WORD_BREAK_PROPERTY.length - 1);
  }
  Af.property = n;
  function i(a, s, o) {
    if (o < s)
      return 0;
    let l = s + ~~((o - s) / 2), u = r.WORD_BREAK_PROPERTY[l], c = r.WORD_BREAK_PROPERTY[l + 1], d = c ? c[
      0
      /* Start */
    ] : 1 / 0;
    return a < u[
      0
      /* Start */
    ] ? i(a, s, l - 1) : a >= d ? i(a, l + 1, o) : u[
      1
      /* Value */
    ];
  }
  return Af;
}
var WS;
function T7() {
  if (WS) return yf;
  WS = 1;
  Object.defineProperty(yf, "__esModule", { value: !0 });
  const r = k7();
  function e(a) {
    return Array.from(t(a)).map((o) => o.text).filter(i);
  }
  yf.split = e;
  function* t(a) {
    let s = Array.from(r.findBoundaries(a));
    if (s.length != 0)
      for (let o = 0; o < s.length - 1; o++) {
        let l = s[o], u = s[o + 1];
        yield new n(a, l, u);
      }
  }
  yf.findSpans = t;
  class n {
    constructor(s, o, l) {
      this._source = s, this.start = o, this.end = l;
    }
    get text() {
      return this._source.substring(this.start, this.end);
    }
    get length() {
      return this.end - this.start;
    }
  }
  function i(a) {
    return !Array.from(a).map(r.property).every((s) => s === 3 || s === 1 || s === 2 || s === 4);
  }
  return yf;
}
var Wy = T7();
class F7 {
  async init(e, t, n) {
    if (n)
      await this.reload(e, t, n);
    else
      return t.updateMetadata(e.stepName, { text: "" }), this.changeTextCommand(e, "", t, () => {
      });
    return null;
  }
  async reload(e, t, n) {
    const i = t.getSerializedStep(
      e.stepName,
      n.serializableWorkflow.steps
    ), l = Object.values(n.layouts).map((u) => u.elements).flat().filter((u) => u.stepName === e.stepName).map((u) => ({
      id: u.id,
      region: u.stepRegion,
      regionIndex: u.stepRegionIndex
    }));
    await t.setSelectionsAndElements(e.stepName, [], l, async () => {
      t.updateStorage(e.stepName, { text: i?.storage?.text }), t.setMandatoryFulfilled(e.stepName, i?.storage?.text !== "");
    });
  }
  async changeText(e, t, n, i) {
    const a = await this.changeTextCommand(e, t, n, i);
    a && (a.command && n.getCommandDispatcher()(a.command), a.followup && await a.followup());
  }
  async changeTextCommand(e, t, n, i) {
    const a = n.getRegionElements(e.stepName), s = n.getStepSpecificServices(e.stepName)?.module;
    if (!s)
      return console.error("Missing module."), null;
    const o = n.getWorkflowExperience().getProfanityList(), l = this.validateInput(e, t, o, i);
    if (l.errorData)
      return n.setMandatoryFulfilled(e.stepName, !1), l.errorData.blockedProfanity ? console.error("Blocked profanity.") : l.errorData.hitCharacterLimit ? console.error("Too many characters.") : l.errorData.unsupportedCharacters && console.error("Unsupported characters."), null;
    if (n.setMandatoryFulfilled(e.stepName, t !== ""), !e.data || !e.data.regions || e.data.regions.length <= 0)
      return console.error("Missing configuration."), null;
    n.updateStorage(e.stepName, { text: t }), n.updateMetadata(e.stepName, { text: t });
    const u = (c, d, f, h) => {
      const g = h || br(), y = n.getLayouts().find((x) => x.panelId === d.panelId);
      if (!y)
        return console.error(`Can not find layout for region: ${d.panelId}`), null;
      const A = [];
      return h && A.push(new cc(g)), A.push(
        new fi(
          {
            stepRegion: d,
            stepRegionIndex: f,
            stepName: e.stepName,
            colors: {},
            id: g,
            svg: c,
            type: tr.Illustration,
            y: d.top,
            x: d.left,
            rotation: d.rotation,
            width: d.width,
            height: d.height,
            layer: d.layer,
            layerIndex: d.layerIndex,
            immutable: d.immutable
          },
          y
        )
      ), {
        id: g,
        region: d,
        command: new Nn(A)
      };
    };
    if (a.length > 0) {
      const d = a.map((f) => {
        if (!f.region)
          return null;
        const h = s.svgPrint(t, f.region);
        return u(
          h,
          f.region,
          f.regionIndex,
          f.id
        );
      }).filter((f) => !!f).filter((f) => !!f).map((f) => f && f.command);
      return {
        command: new Nn(d),
        followup: async () => {
        }
      };
    } else {
      const c = e.data.regions.map(
        (f, h) => u(s.svgPrint(t, f), f, h)
      ), d = c.filter((f) => !!f).map((f) => f && f.command);
      return {
        command: new Nn(d),
        followup: async () => {
          const f = c.filter((h) => h).map((h) => h && { id: h.id, region: h.region });
          await n.setSelectionsAndElements(
            e.stepName,
            [],
            f
          );
        }
      };
    }
  }
  validateInput(e, t, n, i) {
    if (e.data && e.data.maxLength) {
      const s = e.data.maxLength;
      if (t.length > s)
        return i("Too many characters."), { input: t, helperData: {}, errorData: { hitCharacterLimit: !0 } };
    }
    if (!/^$|^[a-zA-Z0-9 ]+$/.test(t))
      return i("Unsupported characters."), { input: t, helperData: {}, errorData: { unsupportedCharacters: !0 } };
    const a = Wy.split(t.toLowerCase());
    for (const s of a)
      for (const o in n) {
        const l = n[o].toLowerCase().replace(/\s/g, "");
        if (s === l)
          return i("Blocked profanity."), { input: t, helperData: {}, errorData: { blockedProfanity: !0 } };
      }
    return i(""), { input: t, helperData: {} };
  }
}
const PF = new F7();
class I7 {
  async init(e, t, n) {
    const i = await ft.getOptionForStep(e);
    if (!i)
      throw new Is(e, "Missing option for picture step");
    if (n)
      await this.reload(e, t, n);
    else {
      const a = await ft.getDefaultVariant(i, e.overrideDefaultVariantId);
      if (a)
        return t.markStepsAsInitialised([e.stepName]), this.selectVariantCommand(e, a, t, () => {
        });
    }
    return t.markStepsAsInitialised([e.stepName]), null;
  }
  async reload(e, t, n) {
    const i = t.getSerializedStep(
      e.stepName,
      n.serializableWorkflow.steps
    ), o = Object.values(n.layouts).map((u) => u.elements).flat().filter((u) => u.stepName === e.stepName), l = await ft.getOptionForStep(e);
    if (i?.selectedVariants) {
      const u = i.selectedVariants[0].id;
      if (l && u) {
        const c = l.variants?.find((d) => d.id === u);
        if (c) {
          const d = o.map((f) => ({
            id: f.id,
            region: f.stepRegion,
            regionIndex: f.stepRegionIndex
          }));
          await t.setSelectionsAndElements(e.stepName, [c], d);
        }
      }
    }
  }
  async selectVariant(e, t, n, i) {
    const a = await this.selectVariantCommand(e, t, n, i);
    a && (a.command && n.getCommandDispatcher()(a.command), a.followup && await a.followup());
  }
  async selectVariantCommand(e, t, n, i) {
    const a = t.asset;
    if (!a)
      throw new bl(t);
    const s = a?.fileLink;
    if (!s)
      return console.error("No URL for picture!"), null;
    i(!0), e.mandatory && n.setMandatoryFulfilled(e.stepName, !1);
    const l = n.getRegionElements(e.stepName).map((d) => new cc(d.id)), u = (d, f) => {
      const g = n.getLayouts().find((y) => y.panelId === d.panelId);
      if (!g)
        throw new Ei(d);
      const v = br();
      return {
        regionElement: { id: v, region: d, regionIndex: f },
        command: new fi(
          {
            stepName: e.stepName,
            stepRegion: d,
            stepRegionIndex: f,
            id: v,
            src: s,
            type: tr.Image,
            y: d.top,
            x: d.left,
            rotation: d.rotation,
            width: d.width,
            height: d.height,
            layer: d.layer,
            layerIndex: d.layerIndex,
            immutable: d.immutable,
            preserveAspectRatio: "none"
          },
          g
        )
      };
    }, c = e.data.regions.map(u);
    return {
      command: new Nn([...l, ...c.map((d) => d.command)]),
      followup: async () => {
        await n.setSelectionsAndElements(
          e.stepName,
          [t],
          c.map((d) => d.regionElement),
          async () => {
            i(!1);
          }
        );
      }
    };
  }
}
const RF = new I7();
class D7 {
  async init(e, t, n) {
    const i = await ft.getOptionForStep(e);
    if (!i)
      throw new Is(e, "Missing option for question step");
    if (n)
      await this.reload(e, t, n);
    else {
      const a = await ft.getDefaultVariant(i, e.overrideDefaultVariantId);
      if (a)
        return this.selectVariantLambda(e, a.id || "", t);
    }
    return null;
  }
  async reload(e, t, n) {
    const i = t.getSerializedStep(
      e.stepName,
      n.serializableWorkflow.steps
    ), a = await ft.getOptionForStep(e);
    if (i?.selectedVariants) {
      const s = i.selectedVariants[0].id;
      if (a && s) {
        const o = a.variants?.find((l) => l.id === s);
        o && await t.setSelectionsAndElements(e.stepName, [o], []);
      }
    }
  }
  async selectVariant(e, t, n) {
    const i = await this.selectVariantLambda(e, t, n);
    i && (i.command && n.getCommandDispatcher()(i.command), i.followup && await i.followup());
  }
  async selectVariantLambda(e, t, n) {
    const i = await ft.getOptionForStep(e);
    if (!i)
      throw new Is(e, "Missing option for question step");
    const a = i.variants;
    if (!a)
      throw new Is(e, "Option for question step is missing variants");
    const s = a.length > 1 ? a.find((o) => o.id === t) : a[0];
    if (!s)
      throw new Error(
        `Failed to find selected variant ${t} in option ${i.id} of step ${e.stepName} (${e.stepTitle})`
      );
    return {
      command: void 0,
      followup: async () => {
        await n.setSelectionsAndElements(e.stepName, [s], []);
      }
    };
  }
}
const OF = new D7();
class P7 {
  constructor() {
    this.shapeFillId = "spiff-fill-shape";
  }
  // Get the step's options.
  async availableColours(e) {
    const t = await ft.getOptionForStep(e);
    return t ? t.variants?.map((n) => ({
      fill: n.color,
      stroke: n.color,
      variant: n
    })) || [] : [];
  }
  setCustomColor(e, t, n) {
    const i = n.getLayouts(), s = (n.getRegionElements(t.stepName) || []).map((o) => {
      const l = o.region;
      if (!i.find((c) => c.panelId === l?.panelId)) throw new Ei(l);
      return new qy(o.id, this.shapeFillId, e);
    }).filter((o) => !!o);
    n.getCommandDispatcher()(new Nn(s)), n.updateStorage(t.stepName, { colour: e });
  }
  async init(e, t, n) {
    const i = await ft.getOptionForStep(e);
    if (!i)
      throw new Xp(e);
    if (n)
      await this.reload(e, t, n);
    else {
      const a = await ft.getDefaultVariant(i, e.overrideDefaultVariantId);
      return a ? this.selectVariantCommand(
        e,
        {
          fill: a.color,
          stroke: a.color,
          variant: a
        },
        [],
        t
      ) : null;
    }
    return null;
  }
  async selectVariant(e, t, n, i) {
    const a = await this.selectVariantCommand(e, t, n, i);
    a && (a.command && i.getCommandDispatcher()(a.command), a.followup && await a.followup());
  }
  async reload(e, t, n) {
    const i = t.getSerializedStep(
      e.stepName,
      n.serializableWorkflow.steps
    ), o = Object.values(n.layouts).map((u) => u.elements).flat().filter((u) => u.stepName === e.stepName), l = await ft.getOptionForStep(e);
    if (i?.selectedVariants) {
      const u = i.selectedVariants[0].id;
      if (l && u) {
        const c = l.variants?.find((d) => d.id === u);
        if (c) {
          const d = o.map((f) => ({
            id: f.id,
            region: f.stepRegion,
            regionIndex: f.stepRegionIndex
          }));
          await t.setSelectionsAndElements(
            e.stepName,
            [c],
            d,
            async () => {
              t.updateStorage(e.stepName, {
                colour: i?.storage?.colour || ""
              });
            }
          );
        }
      }
    }
  }
  async selectVariantCommand(e, t, n, i) {
    const a = i.getLayouts(), s = i.getStepStorage(e.stepName)?.colour, o = () => {
      if (t.variant?.color === "#custom") return s || "#FFFFFF";
      if (t.variant?.color) return t.variant.color;
      throw new Error("Failed to resolve color for shape step.");
    };
    if (n.length > 0) {
      const l = (c) => {
        const d = c.region;
        if (!a.find((g) => g.panelId === d?.panelId))
          throw new Ei(d);
        const h = o();
        return new qy(c.id, this.shapeFillId, h);
      }, u = n.map(l).filter((c) => !!c);
      return {
        command: new Nn(u),
        followup: async () => {
          await i.setSelectionsAndElements(
            e.stepName,
            t.variant ? [t.variant] : [],
            n
          ), i.updateStorage(e.stepName, { colour: o() });
        }
      };
    } else {
      const l = (f, h) => {
        const g = a.find((k) => k.panelId === f.panelId);
        if (!g)
          throw new Ei(f);
        const v = o(), y = `
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        xmlSpace="preserve"
                        preserveAspectRatio="none"
                        version="1.1"
                        width="1"
                        height="1"
                        viewBox="0 0 1 1"
                    >
                        <rect
                            x="0"
                            y="0"
                            width="1"
                            height="1"
                            class="${this.shapeFillId}"
                            fill="${v}"
                        />
                    </svg>
                `, A = {};
        A[this.shapeFillId] = { browserValue: v };
        const x = br();
        return {
          id: x,
          region: f,
          command: new fi(
            {
              stepRegion: f,
              stepRegionIndex: h,
              stepName: e.stepName,
              colors: A,
              id: x,
              svg: y,
              type: tr.Illustration,
              y: f.top,
              x: f.left,
              rotation: f.rotation,
              width: f.width,
              height: f.height,
              layer: f.layer,
              layerIndex: f.layerIndex,
              immutable: f.immutable,
              excludeFromExport: e.data.excludeFromPrint
            },
            g
          )
        };
      }, u = e.data.regions.map(l), c = u.filter((f) => !!f).map((f) => f?.command), d = u.filter((f) => !!f).map((f, h) => ({ id: f.id, region: f.region, regionIndex: h }));
      return {
        command: new Nn(c),
        followup: async () => {
          await i.setSelectionsAndElements(
            e.stepName,
            t.variant ? [t.variant] : [],
            d,
            async () => {
              i.updateStorage(e.stepName, { colour: o() });
            }
          );
        }
      };
    }
  }
}
const Bf = new P7();
class R7 {
  constructor() {
    this.latestToast = null, this.toastType = null, this.toastCallbacks = [];
  }
  addToastCallback(e) {
    e({
      toastMessage: this.latestToast,
      toastType: this.toastType
    }), this.toastCallbacks.push(e);
  }
  removeToastCallback(e) {
    this.toastCallbacks = this.toastCallbacks.filter((t) => t !== e);
  }
  setLatestToast(e, t) {
    this.latestToast = e, this.toastType = t, this.onToastChange();
  }
  onToastChange() {
    this.toastCallbacks.forEach(
      (e) => e({
        toastMessage: this.latestToast,
        toastType: this.toastType
      })
    );
  }
}
const O7 = new R7(), ov = (r, e, t, n, i) => {
  if (e.some((c) => c == null))
    throw new Error(`Failed to autosize lines: ${e.join(", ")}`);
  let a = e.map((c) => c.split(`
`)).flat(), s = a.length, o = a.map((c) => uo(c, n, i));
  const l = i.getApproximateHeight() * n;
  let u = !0;
  for (; u; ) {
    if (l + (s - 1) * t > r.height)
      return [null, null];
    const d = Math.max(...o);
    if (d <= r.width)
      return [a, d];
    const f = o.reduce((y, A, x, k) => A > k[y] ? x : y, 0), h = a[f];
    let g = !1, v = h.length;
    for (; !g && v > -1; ) {
      v = h.lastIndexOf(" ", v - 1);
      const y = [h.slice(0, v), h.slice(v + 1)], A = y.map((k) => uo(k, n, i));
      A[0] <= r.width && (a = [...a.slice(0, f), ...y, ...a.slice(f + 1)], o = [
        ...o.slice(0, f),
        ...A,
        ...o.slice(f + 1)
      ], s += 1, g = !0);
    }
    g || (u = !1);
  }
  return [null, null];
}, Up = (r, e, t, n, i) => {
  let a, s;
  const o = So(e.assetUrl), l = o.getFont();
  if (i.size) {
    const f = r / l.unitsPerEm;
    return [a, s] = ov(t, n, r, f, o), [i.size, a, s];
  }
  const u = 6;
  let c = u - k0;
  if (n.length > 0) {
    let f = n, h = 0;
    for (; (!i.maxSize || c <= i.maxSize) && f; )
      c += k0, h = c / l.unitsPerEm, [f, s] = ov(t, n, c, h, o);
  }
  c > u && (c -= k0), i.minSize && c < i.minSize && (c = i.minSize);
  const d = c / l.unitsPerEm;
  return [a, s] = ov(t, n, c, d, o), [c, a, s];
}, lv = 30;
class cg extends Error {
  constructor(e) {
    super(e), Object.setPrototypeOf(this, new.target.prototype), this.name = cg.name;
  }
}
const B7 = ["‘", "’", "“", "”", `
`];
class fg extends Error {
  constructor(e) {
    super(e), Object.setPrototypeOf(this, new.target.prototype), this.name = fg.name;
  }
}
class M7 {
  constructor() {
    this.cachedColors = /* @__PURE__ */ new Map(), this.cachedStrokeColors = /* @__PURE__ */ new Map(), this.filterUnsupportedCharacters = (e, t) => {
      let n = e.replace(
        /(\r\n|\r|(\u2665|\u00a9|\u00ae|[\u2000-\u2017]|[\u201E-\u3300]]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff]))/gm,
        ""
      );
      const i = [], a = t ? So(t.assetUrl) : void 0;
      if (a) {
        const s = n.split("").filter((l) => !B7.includes(l)).join(""), o = s.split("").map((l) => a.getFont().charToGlyph(l));
        for (let l = 0; l < o.length; l++)
          o[l].name === ".notdef" && i.push(String.fromCharCode(s.charCodeAt(l)));
      }
      for (let s = 0; s < i.length; s++)
        n = n.replaceAll(i[s], "");
      return n;
    }, this.textAlign = (e) => e.vertical ? "center" : e.textAlign || "center", this.getErrorsForText = (e, t, n, i) => {
      let a;
      n.data && n.data.maxLength && t.length > n.data.maxLength && (a || (a = {}), a.hitCharacterLimit = !0);
      const s = i.getWorkflowExperience().getProfanityList(), o = Wy.split(e.toLowerCase());
      for (const u of o)
        for (const c in s) {
          const d = s[c].toLowerCase().replace(/\s/g, "");
          if (u === d) {
            a || (a = {}), a.blockedProfanity = !0;
            break;
          }
        }
      return !n.data.allowNewlines && (e.includes(`
`) || e.includes("\r")) && (a || (a = {}), a.illegalMultipleLines = !0), a;
    };
  }
  async init(e, t, n) {
    const i = await ft.getOptionForStep(e);
    if (!i)
      return null;
    if (n)
      await this.reload(e, t, n);
    else {
      const a = await this.getDefaultImageFillVariant(e.data), s = a?.asset?.fileLink, o = s ? await Gy(s) : void 0, l = o ? {
        src: o.src,
        height: o.height,
        width: o.width,
        scale: e.data.imageFillScale || 1
      } : void 0, u = await this.getDefaultStrokeColorVariant(e.data), c = e.data.strokeEnabled && u?.color ? {
        browserValue: u.color,
        pmsValue: u.name
      } : void 0;
      let d = e.data.defaultText || "";
      const f = t.getWorkflowExperience().getBundle();
      if (f && e.globalPropertyAspectConfigurations) {
        const v = f.getGlobalPropertyConfiguration()?.aspects?.find(
          (y) => y.type === Qn.Text && e.globalPropertyAspectConfigurations?.map((A) => A.aspectName).includes(y.name)
        );
        if (v) {
          const A = f.getGlobalPropertyStateManager().getAspect(v.name);
          A && (d = A);
        }
      }
      t.updateStorage(e.stepName, {
        text: d,
        inputText: e.data.defaultText || "",
        color: (await this.getDefaultColorVariant(e.data))?.color || await this.getDefaultColor(e.data),
        fillImage: l,
        strokeColor: c
      }), t.updateMetadata(e.stepName, {
        text: d,
        color: (await this.getDefaultColorVariant(e.data))?.name || await this.getDefaultColor(e.data),
        fillImage: a?.name,
        strokeColor: e.data.strokeEnabled ? u?.color : void 0
      });
      const h = await ft.getDefaultVariant(i, e.overrideDefaultVariantId);
      if (h)
        return this.selectVariantCommand(
          e,
          h,
          { text: d },
          [],
          t,
          () => {
          },
          () => {
          },
          l,
          c
        );
    }
    return null;
  }
  findLayoutElements(e, t) {
    return e.getRegionElements(t.stepName).map((a) => {
      try {
        return $n(a.id, e.getAllLayoutData());
      } catch {
        return null;
      }
    }).filter((a) => !!a);
  }
  /**
   * Get the colors that can be used for a given text step.
   * @param stepData The text step to get colors for.
   * @returns A list of color objects containing fill, stroke and variant if available.
   */
  async availableFillColors(e) {
    const t = this.cachedColors.get(e.stepName);
    if (t)
      return t;
    const n = await ft.ensureFullOption(e.data.colorOption);
    if (n) {
      const i = n.variants?.map((a) => ({
        fill: a.color,
        stroke: a.color,
        variant: a
      })) || [];
      return this.cachedColors.set(e.stepName, i), i;
    }
    return [];
  }
  changeAlignment(e, t, n, i) {
    if (!e.data || !e.data.regions)
      return;
    const a = i.getCommandDispatcher();
    for (const s of n) {
      const o = new Q8(s.id, t);
      a(o);
    }
  }
  async changeFillColor(e, t, n, i) {
    if (!e.data || !e.data.regions)
      return;
    const a = i.getCommandDispatcher();
    t.variant ? i.updateMetadata(e.stepName, { color: t.variant.name }) : i.updateMetadata(e.stepName, { color: t.fill });
    const s = await ft.ensureFullOption(e.data.colorOption), o = s ? this.createTextFillSpotColor(s, t.variant) : void 0;
    s ? i.updateStorage(e.stepName, {
      color: t.fill,
      colorProfileAssetKey: s.colorProfile?.key
    }) : i.updateStorage(e.stepName, {
      color: t.fill
    });
    for (const l of n) {
      if (!t.fill)
        throw new Error("Fill not set on new color selection!");
      const u = new q8(l.id, t.fill, o);
      a(u);
    }
  }
  async availableFillImages(e) {
    const t = await ft.ensureFullOption(e.data.imageFillOption);
    if (t) {
      const n = t.variants?.map((i) => i.asset?.fileLink)?.filter((i) => !!i) || [];
      return Promise.all(
        n.map(async (i) => {
          const a = await Gy(i);
          return {
            src: i,
            width: a.width,
            height: a.height,
            scale: e.data.imageFillScale || 1
          };
        })
      );
    }
    return Promise.resolve([]);
  }
  async changeFillImage(e, t, n, i) {
    if (!e.data || !e.data.regions)
      return;
    const a = i.getCommandDispatcher(), o = (await ft.getOptionForStep(e))?.variants?.find((l) => l.asset?.fileLink === t.src);
    i.updateMetadata(e.stepName, { fillImage: o?.name }), i.updateStorage(e.stepName, {
      fillImage: t
    });
    for (const l of n) {
      const u = new _0(l.id, t);
      a(u);
    }
  }
  /**
   * Get the colors that can be used for a given text step's stroke.
   * @param stepData The text step to get colors for.
   * @returns A list of color objects containing fill, stroke and variant if available.
   */
  async availableStrokeColors(e) {
    const t = this.cachedStrokeColors.get(e.stepName);
    if (t)
      return t;
    const n = await ft.ensureFullOption(e.data.strokeOption);
    if (n) {
      const i = n.variants?.map((a) => ({
        fill: a.color,
        stroke: a.color,
        variant: a
      })) || [];
      return this.cachedStrokeColors.set(e.stepName, i), i;
    }
    return [];
  }
  async changeStrokeColor(e, t, n, i) {
    if (!e.data || !e.data.regions)
      return;
    const a = i.getCommandDispatcher();
    t?.variant ? i.updateMetadata(e.stepName, { strokeColor: t.variant.name }) : i.updateMetadata(e.stepName, { strokeColor: t?.fill });
    const s = t ? {
      browserValue: t.fill,
      pmsValue: t.pmsValue
    } : void 0;
    i.updateStorage(e.stepName, {
      strokeColor: s
    });
    for (const o of n) {
      const l = new N0(o.id, s, e.data?.strokeThickness);
      a(l);
    }
  }
  getProcessedInput(e, t, n) {
    const i = n ? e : this.injectReplaceableText(e, t);
    return lg(i, {
      vertical: t.vertical,
      uppercase: t.uppercase
    });
  }
  updateInputText(e, t, n, i) {
    const a = i.getStepStorage(n.stepName), s = _u(e, i), o = this.getProcessedInput(s, n.data, a?.customiseAllText ?? !1), l = {
      command: void 0,
      helperData: {},
      errorData: this.getErrorsForText(e, o, n, i)
    };
    if (l.errorData)
      return l;
    l.helperData.charactersRemaining = n.data.maxLength - o.length;
    const u = [], c = /* @__PURE__ */ new Map(), d = /* @__PURE__ */ new Map();
    for (const f of t) {
      if (!f.fontData) throw new un("Failed to resolve font data for text.");
      const [h, g] = Up(
        f.fontSize,
        f.fontData,
        { left: f.x, top: f.y, width: f.width, height: f.height, rotation: f.rotation },
        [o],
        { size: n.data.size, minSize: n.data.minSize, maxSize: n.data.maxSize }
      );
      c.set(f.id, h), d.set(f.id, g);
      const v = n.data.curved ? o : (g || []).join(`
`);
      u.push(this.generateTextChangeCommandsForRegion(h, n.data, f.id, v));
    }
    return !n.data.curved && t.length > 0 && !Array.from(d.values()).every((h) => h) ? (l.errorData || (l.errorData = {}), l.errorData.doesNotFit = !0, l) : (i.updateStorage(n.stepName, { text: e }), i.updateMetadata(n.stepName, {
      text: o
    }), (a?.defaultCleared || !n.data.deleteDefaultOnFocus) && o.trim() !== "" && i.setMandatoryFulfilled(n.stepName, !0), l.command = new Nn(u), l);
  }
  async selectVariant(e, t, n, i, a) {
    const s = await this.selectVariantCommand(
      e,
      t,
      n.getStepStorage(e.stepName) || {},
      n.getRegionElements(e.stepName),
      n,
      i,
      a
    );
    s && (s.command && n.getCommandDispatcher()(s.command), s.followup && await s.followup());
  }
  createTextFillSpotColor(e, t) {
    const n = e.colorProfile;
    if (n) {
      const i = (n.name || "").replace(/\s/g, "-"), a = i.lastIndexOf("/"), o = i.slice(a + 1).slice(0, -4);
      if (!t.namedColor) throw new Error("variant named color not set!");
      return {
        profileName: o,
        namedColor: t.namedColor
      };
    }
  }
  async reload(e, t, n) {
    const i = t.getSerializedStep(
      e.stepName,
      n.serializableWorkflow.steps
    ), o = Object.values(n.layouts).map((u) => u.elements).flat().filter((u) => u.stepName === e.stepName), l = await ft.getOptionForStep(e);
    if (i?.selectedVariants) {
      const u = i.selectedVariants[0].id;
      if (l && u) {
        const c = l.variants?.find((d) => d.id === u);
        if (c) {
          const d = await this.fontDataFromVariant(c), f = o.map((y) => ({
            id: y.id,
            region: y.stepRegion,
            regionIndex: y.stepRegionIndex
          })), h = i.storage?.color;
          let g = i.storage?.text;
          const v = t.getWorkflowExperience().getBundle();
          if (v && e.globalPropertyAspectConfigurations) {
            const A = v.getGlobalPropertyConfiguration()?.aspects?.find(
              (x) => x.type === Qn.Text && e.globalPropertyAspectConfigurations?.map((k) => k.aspectName).includes(x.name)
            );
            if (A) {
              const k = v.getGlobalPropertyStateManager().getAspect(A.name);
              k && (g = k);
            }
          }
          if (await t.setSelectionsAndElements(
            e.stepName,
            [c],
            f,
            async () => {
              t.updateMetadata(e.stepName, { color: h, text: g }), t.updateStorage(e.stepName, { text: g, inputText: g });
              const y = o.map((x) => new gS(x.id, d)), A = new Nn(y);
              t.getCommandDispatcher()(A);
            }
          ), o.length === 0 && l) {
            const y = await ft.getDefaultVariant(
              l,
              e.overrideDefaultVariantId
            );
            if (y) {
              const A = await this.selectVariantCommand(
                e,
                y,
                { text: g },
                [],
                t,
                () => {
                },
                () => {
                }
              );
              A?.command && t.getCommandDispatcher()(A.command);
            }
          } else {
            const { command: y } = pi.updateInputText(
              g || "",
              o,
              e,
              t
            );
            y && t.getCommandDispatcher()(y);
          }
        }
      }
    } else {
      const u = t.getWorkflowExperience().getBundle();
      if (u && e.globalPropertyAspectConfigurations) {
        const d = u.getGlobalPropertyConfiguration()?.aspects?.find(
          (f) => f.type === Qn.Text && e.globalPropertyAspectConfigurations?.map((h) => h.aspectName).includes(f.name)
        );
        if (d) {
          const h = u.getGlobalPropertyStateManager().getAspect(d.name);
          if (h)
            if (o.length === 0 && l) {
              const g = await ft.getDefaultVariant(
                l,
                e.overrideDefaultVariantId
              );
              if (g) {
                const v = await this.selectVariantCommand(
                  e,
                  g,
                  { text: h },
                  [],
                  t,
                  () => {
                  },
                  () => {
                  }
                );
                v?.command && t.getCommandDispatcher()(v.command);
              }
            } else {
              const { command: g } = pi.updateInputText(
                h,
                o,
                e,
                t
              );
              g && t.getCommandDispatcher()(g);
            }
        }
      }
    }
  }
  async getDefaultColorVariant(e) {
    const t = e.colorOption;
    if (t)
      return ft.getDefaultVariant(t);
  }
  async getDefaultColor(e) {
    const t = e.colorOption;
    return t ? (await ft.getDefaultVariant(t))?.color : void 0;
  }
  async getDefaultImageFillVariant(e) {
    const t = e.imageFillOption;
    if (t)
      return ft.getDefaultVariant(t);
  }
  async getDefaultStrokeColorVariant(e) {
    const t = e.strokeOption;
    if (t)
      return ft.getDefaultVariant(t);
  }
  async fontDataFromVariant(e) {
    const t = e.asset;
    if (!t)
      throw new bl(e);
    const n = t.fileLink;
    if (!n)
      throw new ad(t);
    const i = await uc(n);
    return {
      assetUrl: n,
      name: i.names.fullName.en
    };
  }
  async selectVariantCommand(e, t, n, i, a, s, o, l, u) {
    const c = a.markUpdatePending(), d = await this.fontDataFromVariant(t);
    let f = !0;
    const h = (g) => {
      s(g), g && (f = !1);
    };
    if (i.length > 0) {
      const g = i.map((A) => new gS(A.id, d));
      if (l) {
        const A = i.map((x) => new _0(x.id, l));
        g.push(...A);
      }
      if (u) {
        const A = i.map((x) => new N0(x.id, u, e.data.strokeThickness));
        g.push(...A);
      }
      const v = await this.changeInputTextWithRegion(
        e,
        e.data.size || lv,
        d,
        n.text || "",
        n,
        a,
        n?.customiseAllText ?? !1,
        h,
        o
      );
      v && g.push(v);
      const y = new Nn(g);
      return f ? {
        command: y,
        followup: async () => {
          a.markUpdateCompleted(c), await a.setSelectionsAndElements(e.stepName, [t], i);
        }
      } : null;
    } else {
      const g = await this.createTextboxRegions(
        e.stepName,
        t,
        e.data,
        d,
        n,
        a
      ), v = await this.changeInputTextWithRegion(
        e,
        e.data.size || lv,
        d,
        g[0]?.newElement.input || n.text || e.data.defaultText || "",
        n,
        a,
        n?.customiseAllText ?? !1,
        h,
        o
      ), y = g.flatMap((x) => x.commands);
      if (l) {
        const x = g.map(
          (k) => new _0(k.regionElement.id, l)
        );
        y.push(...x);
      }
      if (u) {
        const x = g.map(
          (k) => new N0(k.newElement.id, u, e.data.strokeThickness)
        );
        y.push(...x);
      }
      v && y.push(v);
      const A = new Nn(y);
      return f ? {
        command: A,
        followup: async () => {
          a.markUpdateCompleted(c);
        }
      } : null;
    }
  }
  /**
   * When a text step specifies replaceable text, the text input by the user will replace
   * a specific token within a larger string of text specified in the step configuration. Otherwise
   * this function will just return the text it's given when the feature is disabled.
   */
  injectReplaceableText(e, t) {
    return t.replaceableText ? t.replaceableText.replace("{{}}", e) : e;
  }
  async createTextboxRegions(e, t, n, i, a, s) {
    if (!n || !n.regions)
      throw new Error("Step data not supplied");
    const o = a.text || n.defaultText || "", l = _u(o, s), u = this.getProcessedInput(l, n, !1), c = async (f, h) => {
      const v = s.getLayouts().find((A) => A.panelId === f.panelId), y = br();
      try {
        if (!v)
          throw new fg("Failed to find layout for region: " + f.panelId);
        const A = await ft.ensureFullOption(n.colorOption);
        let x;
        if (A && A.variants) {
          const J = await ft.getDefaultVariant(A);
          J && (x = this.createTextFillSpotColor(A, J), s.updateStorage(e, {
            colorProfileAssetKey: A.colorProfile?.key
          }));
        }
        const k = await this.getDefaultColor(n), F = k || "#000000", S = {
          stepRegion: f,
          stepRegionIndex: h,
          stepName: e,
          align: this.textAlign(n),
          fill: a.color ? a.color : F,
          fontSize: n.size || lv,
          fontData: i,
          id: y,
          layer: f.layer,
          layerIndex: f.layerIndex,
          rotation: f.rotation,
          text: u,
          input: o,
          type: tr.Textbox,
          vertical: n.vertical,
          x: f.left,
          y: f.top,
          height: f.height,
          width: f.width,
          immutable: f.immutable,
          verticalAlign: n.verticalAlign || "middle",
          curved: n.curved,
          paths: n.paths,
          fillSpotColorDefinition: x
        }, R = [], M = /* @__PURE__ */ new Map(), j = /* @__PURE__ */ new Map();
        if (!S.fontData) throw new un("Failed to resolve font data for text.");
        const [G, ie] = Up(
          S.fontSize,
          S.fontData,
          {
            left: S.x,
            top: S.y,
            width: S.width,
            height: S.height,
            rotation: S.rotation,
            panelId: ""
          },
          [u],
          { size: n.size, minSize: n.minSize, maxSize: n.maxSize }
        );
        M.set(S.id, G), j.set(S.id, ie);
        const q = n.curved || n.vertical ? u : (ie || []).join(`
`);
        R.push(
          this.generateTextChangeCommandsForRegion(G, n, S.id, q)
        );
        const Y = new fi(S, v);
        return {
          regionElement: { id: y, region: f, regionIndex: h },
          commands: [Y, ...R],
          newElement: S,
          fontData: i
        };
      } catch (A) {
        throw console.log(A), new cg("Error adding font to region");
      }
    }, d = await Promise.all(n.regions.map(c)).catch((f) => {
      throw f instanceof cg ? (O7.setLatestToast("Failed to load font.", Lg.Error), f) : f instanceof fg ? f : new Error(f);
    });
    return await s.setSelectionsAndElements(
      e,
      [t],
      d.map((f) => f.regionElement),
      async () => {
        s.updateMetadata(e, {
          text: o
        }), s.updateStorage(e, {
          text: o
        });
      }
    ), d;
  }
  generateTextChangeCommandsForRegion(e, t, n, i) {
    const a = [], s = new J8(n, i);
    if (a.push(s), !t.size) {
      const l = new W8(n, e);
      a.push(l);
    }
    return new Nn(a);
  }
  /**
   * @deprecated
   */
  async changeInputTextWithRegion(e, t, n, i, a, s, o, l, u, c) {
    const d = (i || "").replace(/^(?![\u000A\u000D])[\u0000-\u001F\u007F-\u009F]/g, ""), f = _u(d, s), h = this.getProcessedInput(f, e.data, o), g = s.getRegionElements(e.stepName), v = /* @__PURE__ */ new Map(), y = /* @__PURE__ */ new Map();
    for (const S of g)
      if (S.region) {
        const [R, M] = Up(
          t,
          n,
          S.region,
          [h],
          { size: e.data.size, minSize: e.data.minSize, maxSize: e.data.maxSize }
        );
        v.set(S.id, R), y.set(S.id, M);
      }
    const x = (() => {
      if (e.data && e.data.maxLength && h.length > e.data.maxLength)
        return c && c(!0), { info: "0" };
      const S = s.getWorkflowExperience().getProfanityList(), R = Wy.split(h.toLowerCase());
      for (const M of R)
        for (const j in S) {
          const G = S[j].toLowerCase().replace(/\s/g, "");
          if (M === G) {
            const q = "Blocked profanity.";
            return l(q), { error: q };
          }
        }
      if (!e.data.vertical && !e.data.allowNewlines && (h.includes(`
`) || h.includes("\r"))) {
        const M = "Text may not span multiple lines.";
        return l(M), { error: M };
      }
      if (!e.data.curved && !Array.from(y.values()).every((j) => j)) {
        const j = "Text does not fit.";
        return l(j), { error: j };
      }
      return l(void 0), { info: (e.data.maxLength - h.length).toString() };
    })();
    if (x.error) {
      u(x.error);
      return;
    }
    if (u(`${x.info} characters remaining` || ""), c)
      return;
    s.updateStorage(e.stepName, { text: d }), s.updateMetadata(e.stepName, {
      text: this.injectReplaceableText(d, e.data)
    }), (a.defaultCleared || !e.data.deleteDefaultOnFocus) && d.trim() !== "" && s.setMandatoryFulfilled(e.stepName, !0);
    const k = [];
    for (const S of g) {
      const R = e.data.curved ? h : (y.get(S.id) || []).join(`
`);
      k.push(
        this.generateTextChangeCommandsForRegion(
          v.get(S.id) || 1,
          e.data,
          S.id,
          R
        )
      );
    }
    return new Nn(k);
  }
}
const pi = new M7();
class _7 {
}
const N7 = "data:application/octet-stream;base64,AAEAAAAPAIAAAwBwRkZUTYdHeHoAAElcAAAAHEdERUYAJwBUAAAe2AAAAB5HUE9TkNtcVAAAHygAACoyR1NVQrj/uP4AAB74AAAAME9TLzJoWmUcAAABeAAAAGBjbWFwtkIacAAAAxAAAAJWZ2FzcP//AAMAAB7QAAAACGdseWY27KOUAAAGCAAAFcRoZWFkFPal0gAAAPwAAAA2aGhlYQU0Ar0AAAE0AAAAJGhtdHiADw6qAAAB2AAAAThsb2Nh5CzfJAAABWgAAACebWF4cACVAEwAAAFYAAAAIG5hbWXeIPPyAAAbzAAAAiJwb3N0ABeZTwAAHfAAAADdAAEAAAABAAAZ9vREXw889QALA+gAAAAA2ZexNAAAAADZl7E0ADL/yQJ2ArwAAAAIAAIAAAAAAAAAAQAAArz/wwAAAqsAAAAAAnYAAQAAAAAAAAAAAAAAAAAAAE4AAQAAAE4ASQAFAAAAAAACAAAAAQABAAAAQAAAAAAAAAAEAbsBkAAFAAACigK7AAAAjAKKArsAAAHfADEBAgAAAAAAAAAAAAAAAAAAAAcAAAAAAAAAAAAAAABYWFhYAEAACgCtArz/wwAAAqkANgAAAAMAAAAAAmQCZAAAACAAAgIPADIAAAAAAU0AAAAAAAAAAAAAALQAAAD3ADUCfQA1AcoANQKrADUCDQA1AX4ANQHYADUBNQA1AcgANQHUADUB8AA1AeEANQHpADUBqQA1AdAANQHpADUCqgA1Af8ANQGaADUB3wA1AbgANQFtADUBbQA1AekANQG8ADUA1QA1AYcANQHBADUBUAA1AhsANQHBADUB4QA1AZYANQH0ADUBxQA1AcUAMgGJADUBwwA1Ad0ANQJ1ADUB9wA1AcoANQF6ADUB3AA1Af8ANQGaADUB3wA1AbgANQFtADUBbQA1AekANQG8ADUA1QA1AYcANQHBADUBUAA1AhsANQHBADUB4QA1AZYANQH0ADUBxQA1AcUAMgGJADUBwwA1Ad0ANQJ1ADUB9wA1AcoANQF6ADUAtAAAAAAAAAAAAAMAAAADAAAAHAABAAAAAAFQAAMAAQAAABwABAE0AAAALgAgAAQADgAAAAoADQAhACYAKgA5AFoAXgB6AKAArQDFAM8A1gDdAOUA7wD2AP0A/wF4//8AAAAAAAoADQAgACMAKgAwAEAAXgBhAKAArQDAAMcA0QDYAOAA5wDxAPgA/wF4//8AAf/5//f/5f/k/+H/3P/W/9P/0f+s/6AAAAAAAAAAAAAAAAAAAAAA/0v+twABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABYAIAAwADoARABOAF4AaAAAAAAAAAAXABcAFwAXABcAFwAZABsAGwAbABsAHwAfAB8AHwAkACUAJQAlACUAJQAlACsAKwArACsALwAyADIAMgAyADIAMgA0ADYANgA2ADYAOgA6ADoAOgA/AEAAQABAAEAAQABAAEYARgBGAEYASgAAAQYAAAEAAAAAAAAAAQIDAAAEAAAAAAAAAAAAAAAAAAAAAQAABQYABwgJCgAAAAsAAAAAAAwNDg8QERITFBUAAAAAAAAWFxgZGhscHR4fICEiIyQlJicoKSorLC0uLzAAAAAxAAAyMzQ1Njc4OTo7PD0+P0BBQkNERUZHSElKSwAAAAAAFxcZGyQlKzIyMjIyMjQ2NjY2Ojo6Oj9AQEBAQEZGRkYAAAAAAAAAAAAAAAAAAAAlAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAABMFxclAAAAAAAAAAAAAEovAAAAAAAAAAAAAAAXGxcbGx8fHx8lJQAlKysrAAAAAAAAAAAAAAAAAAAAACgAKAAoACgAKAAoADwAbgC0AQgBbgGQAcYB1AIGAkYCYAKSAtAC4gMoA2ADyAPgBBoEUAR4BI4EogTWBOoE9gUiBToFSAViBXoFqgXWBjAGWgaaBqwG2AbqBwYHIAc2B0wHXgd2B7AH5ggOCCQIOAhsCIAIjAi4CNAI3gj4CRAJQAlsCcYJ8AowCkIKbgqACpwKtgrMCuIK4griAAAABQAyAAAB3QK8AAMABgAJAAwADwAAEyERIRsCCwEREwMhAxMRMgGr/lUcubrGtMG5AXKttQK8/UQCqP7LATX+tgEs/acBGP7MAUn+0QJdAAACADUABQDCAmoAAwAHAAATESMRExUjNcGLi4sCaf5mAZr+KY2NAAAAAgA1AAACSAJkABsAHwAAJQcjNyMHIzcjNzM3IzczNzMHMzczBzMHIwczByc3IwcBthdrFkoXbBdeDl8KYA9fFWwVShVtFWoPagpqDscJSgqqqqqqqmxHbJqamppsR2xsR0cAAAEANf/JAZUCqgAwAAABFR4BByM0LgEjIgYVFBYXHgMVFA4BBxUjNS4BNTMUFjMyNjU0LgInJjU0Njc1ARwwPAF3CBQOExcsPCEwFgkZNyhnPkGDGRQTGBElHBprRzQCqkQNV0INGBIdFB8hGw4tMCkUJkU7EENDCmk8GiUgFBIeGA4LKXpKVxBEAAAABQA1/+8CdgJrAAwAGAAcACkAOAAAEzQ2MzIeARUUBiMiJjcVFBYzMjY1NCYiBiUDIxMDNTQ+ATMyFhQGIyImNxUUHgEzMjY1NC4BIyIGNk02JD0jTTc2TVEeFBUeHiodAWjhVeEtIz0kN01ONjZOUQ4YDRUeDhcOFR4B1j5XKEUoPldXPgEXISEYGCEhcf2dAmP+JgEoRChXfFdWPwEPGhAiGBAbDyIAAwA1AAAB2AJnACQAOQBIAAAlFwcnDgEjIiY1ND4CNyY1NDYzMhYVFA4IBxc3MyciBhUUHgQXPgU1NCYjAxY+ATcnDgUVFBYBmT8qQgdUMk1cDyETFDVTNzdPAwUJBw0HDgUMATUabPULGQQFCgUKAQENBAsEBBYNAQ8bEQRRAQ4ECwUEIbFNZEERMGJKHzMqEhFDQD9ZVjsLFxITDRAJDgULAUFBtRgSBw4LDwcOAQEQBg8LDwcPGf58AQsOB2IBDQUOCg8IGyQAAAAAAQA1ATwBSQJtABEAABMHNxcHFwcnFyM3Byc3JzcXJ+YXVSVnZyhTGE0WUShnZyVWGAJselJLJSVOVXp7Vk4nI0tReQACADUAAAGjAmQAFwAmAAA3NTQ+AzMyHgMdARQOAiMiLgI3FRQeATMyPQE0IyIOAjYZJzIvFxQtMicaIjc9Hh09OiR8CBsXOTkSGAsF4KQxTzEhDQwhMFAypDtaMhkYMlvjrBUkH1isVxEeGgABADUAAAEAAmEABQAAMxEjNTMRhE7KAd6D/Z8AAQA1AAMBkwJmACEAADc1Njc+AzU0JiMiByM+Ajc+AzMyFhUUBgcGBzMVOi5WFxkaCx0XMQJ2AQINDQ4qLCIQTlkjLkAargN3L1kYHCcoFyIhXhsgNxccJxIHbU04WDRHHYEAAAEANQAAAZ8CZAAtAAATNjc2MzIWFRQOAwcWFRQGIyImJyYnMxYXMjY1NC4DKwE1MzI1NCYjIgdDAjktP0RVCw0VCwlca0otVRYVBn4KLhobCg8UDQcsFT0RESQCAaxgMCdfQRcoGBcIBiVpTWwrKCRENgElHRAYCwcCbzsVHjMAAgA1//8BuwJjAAoADQAAITUjNRMzETMVIxUnMzUBDdfadDY20WJrcgGF/oN6a+XAAAAAAAEANf//AawCYwAgAAABFSMHNjMyHgIVFA4CIyIuASczFjMyNjU0JiMiBycTAX+uCxsnKUIlExYrSy8zUS8HfRYjGygkHy4SZSoCYoBSEic+QyEkSkIqL00xJi8hHy80HwFTAAACADUAAAG0AmIAFgAoAAABMhYVFAYjIiYnJjU0PwEzBw4BBzAyNgMyPgE1NC4EIyIGFRQeAQEaO19vTy9QGCksepBYAw4CCA0kEx8TBAgLDxQLHSUVHQGvbF9kgConOV1LVdqUBRYFAv7XFCYXChMSEAwHLyEaJxIAAAAAAQA1//8BdAJjAAYAABMhFQMjEyM2AT6sibS9AmJ3/hUB3wAAAwA1AAABmwJkABkAJAAuAAATNTQ2MhYVFA4BBxYVFA4BIi4BNTQ3LgMXFRQWMjY1NCYiBjcVFBYyNjQmIgZCVqBWFBAMPC1RaFEtPAkLEgpwHjAdHTAeCRskGxskGwG/AUJhYkIeMxINJGU5WjMzWjllJAkNHSbhARgqKhkaKirTARcfHy8fHwAAAAACADUAAAG0AmQAFgAkAAA/AT4BNyYOASMiJjU0NjMyFhcWFRQPARM1NC4BIyIGFRQWMzI2fVgDDQQBCA0EO15uTy9QGCoteSsVHhAcKCUfHiUBlAQWBgEBAWxfZIAqJzldTFXaAYkBGiYSLiIgMi4AAgA1/8wCdQJtADgASAAAAQcGBwYzMjY1NCYjIgYHBh4DFxY3FQYnLgQ3ND4CMzIWFRQGIyInBicuATU0NjMyFhc3BzY1NC4CJyYGHQEUFjc2AfscBAIBFhYmbFVhdgcBBhwtVThNX01cQGlGMBUBLExzQniZWjs3FB07NT1PQBwoBwgqCQIHEg0gKCAUIQG2ux0NGVo8Wm2Laxg2RTcpBAUfWxsCASlBVlsvQHpfOqF8XZBBNwEBWkRIcyAWKMkaIgcQGBEBAz8rAyYjAQIAAAIANQAAAcgCZQAHAAoAADcHIxMzEyMvAge8GG6bYJdvGhknK3JyAmT9nHJz1tYAAAMANQABAWQCaAAPABoAJQAANxEzMhcWFRQHFhUUBw4BIwMzMjc2NTQnJisBFxUzMjc2NTQnJiM2lEAiJC9DJhszNx0mEgkQEAgUJQExFAsVFAoWAgJlKShQUygka1cuIhMBfAYLIB4LBuNwCA4mIgwGAAAAAQA1AAABqQJnACUAACUzDgEjIi4CNTQ+AjMyHgMXIy4DIyIOARUUFjMyPgIBSWAQX0cxSiwWFStLMSM7KB4QA2AFDhQfER4pEi8qFCEUCulrfjNXbD47alk0HzJAPR0SISATNEwsSWcXJxkAAgA1AAABgwJlAA8AGAAAMxEzMh4DFxYVFA4CIwMRMzI1NCcmIzZ/EhcsICYOJBUtTzUiKF4TFzMCZAEMFi4hT29BbFcwAdr+r6dDLjkAAAABADUAAAE3AmUACwAAEyEVIxUzFSMVMxUhNgEBlpGSlv8AAmR4cHmKeQAAAAEANQAAATcCZQAJAAAzESEVIxUzFSMRNgEBmJOTAmR5b3r+/gAAAAABADUAAAG3AmYAIQAAARUmBw4CFRQeAjMyNzY3IzUzFgcGIyIuATU0NjMyFhcBQBQ3FygbEBkgESEWGQVr0wUTMH89WCpiX0haEAGbAUgCASNPOC1FKhUaHDlpZkOyVYlXiaZvWwAAAAEANQAAAYYCZQALAAAzIxEzFTM1MxEjNSOcZmaDZ2eDAmTm5v2c9QABADUAAACgAmUAAwAAMxEzETZpAmT9nAABADUAAAFRAmUAGgAAAREUBwYHBiMiLgMnJjUzFBYVFjMyNzY1EQFQDQ8fJi4IESsgIAUCcQEEGxUHBAJk/pZkLCscIwIRHkEsFxcCDAQzGxAhAZEAAAAAAQA1//8BiwJmAAoAABcRMxETMwMTIwMRNmdzbISTfnABAmb+7AEU/s/+zAEJ/vYAAQA1AAABGgJlAAUAADMRMxEzFTZpewJk/iaKAAEANQAAAeUCZQAMAAAzIxEzGwEzESMTAyMDlmCLTEuMYARZRVgCZP52AYr9nAHK/jYBygABADUAAAGMAmUACQAAGwEDMxEjAxMjEZ2NAWNikwJjAmT+lAFs/ZwBaf6XAmQAAAACADUAAAGsAmUADAAfAAATNDYzMhYVFA4BIyImNxQWMzI+BDU0LgIjIg4BNmRWUWs0VDRWZGgqKg8aEQ0IAwgSIhceJw4BLKGXmJpfjUaelUtjDxohKCcUHzo1IDVKAAACADUAAAFgAmYAEAAbAAATMzIeARcWFRQGBw4BKwEVIxMVMzI3NjU0JyYjNoEjMRoMLhcSFjEtKGRkJRoNGBkOHAJlCxMPO2cvWRkdGMAB3ZMJEi8uEQoAAwA1//8BvwJmABsALgA8AAAlFwYiLgInDgIjIi4BNTQ+ATMyFhUUBx4CAyIOBAc2MzIXFhc2NTQuAQMeAzsBMjcmJyYjIgG9AQINGRgcChMsFBM+VycmWD1Uah0GDQzAERwSDQcCARgVKCIbHQkbLGgGFRUTBgYWDhEOGSAPenkBAggSDRMTAlaGU1GIXK5/ZUkIBwEBZxIgHScLCBEoHzQeLTJOKP7/HCgQCQwiFSMAAAAAAgA1//8BjwJmAA0AGgAAJRcjJxUjETMXFhcWFRQnNjU0LgInKwEVMzIBDYF+cGpqOi4UW4QYCxARBQY1Lhb7++vqAmQBBQosgohEFyoVHg4IAZkAAQAyAAABjwJnACsAADczFBY3NjU0JicuAycmPgEzMhYXIy4DIyIGFRQWFx4BFRQOAiMiJjZ2JBIyJjwRICobAQE0TSs5WQp0AQMJEg0RHCdBQTEUJkQsXFbFKx8BBDgWIB4JFyg7ITlVKFRbCwwTCh0UFSIkJEc2JUE3IGkAAAABADUAAAFTAmUABwAAMxEjNSEVIxGLVQEdVQHseHj+FAAAAAABADUAAAGNAmUAGgAAEzMRFBceATI2NzY1ETMRFA4BBwYjIiYnLgE1NmsIBR8qHgUIagcQDjBUIk0ZGQwCZP6WLhsSGBYQFzUBa/6WM0MvFEEcJCZISwAAAQA1AAABpwJlAAYAADMDMxsBMwO2gGdQUWmAAmT+UwGt/ZwAAQA1AAACQAJkAAwAADMDMxsBMxsBMwMjCwGfaWk4PFA8OGhrWz4+AmP+cwGN/nEBj/2dAYz+dAABADUAAAHBAmUACwAAMxMDMxc3MwMTIycHNop6c0NCcnmJc1VRAUYBHq6u/t/+vdnZAAAAAQA1AAABlAJlAAkAADczAzMXNzMDFSOsAXdvQUFtd3HrAXn29v6H6wAAAAABADUAAAFDAmYACQAAAQMzFSE1EyM1IQFDiIj+85OTAQ0B5v6kimcBdYkAAAEANQFFAaYCagAGAAAbATMTIycHNnx3fYE4NwFFAST+3LOzAAIANQAAAcgCZQAHAAoAADcHIxMzEyMvAge8GG6bYJdvGhknK3JyAmT9nHJz1tYAAAMANQABAWQCaAAPABoAJQAANxEzMhcWFRQHFhUUBw4BIwMzMjc2NTQnJisBFxUzMjc2NTQnJiM2lEAiJC9DJhszNx0mEgkQEAgUJQExFAsVFAoWAgJlKShQUygka1cuIhMBfAYLIB4LBuNwCA4mIgwGAAAAAQA1AAABqQJnACUAACUzDgEjIi4CNTQ+AjMyHgMXIy4DIyIOARUUFjMyPgIBSWAQX0cxSiwWFStLMSM7KB4QA2AFDhQfER4pEi8qFCEUCulrfjNXbD47alk0HzJAPR0SISATNEwsSWcXJxkAAgA1AAABgwJlAA8AGAAAMxEzMh4DFxYVFA4CIwMRMzI1NCcmIzZ/EhcsICYOJBUtTzUiKF4TFzMCZAEMFi4hT29BbFcwAdr+r6dDLjkAAAABADUAAAE3AmUACwAAEyEVIxUzFSMVMxUhNgEBlpGSlv8AAmR4cHmKeQAAAAEANQAAATcCZQAJAAAzESEVIxUzFSMRNgEBmJOTAmR5b3r+/gAAAAABADUAAAG3AmYAIQAAARUmBw4CFRQeAjMyNzY3IzUzFgcGIyIuATU0NjMyFhcBQBQ3FygbEBkgESEWGQVr0wUTMH89WCpiX0haEAGbAUgCASNPOC1FKhUaHDlpZkOyVYlXiaZvWwAAAAEANQAAAYYCZQALAAAzIxEzFTM1MxEjNSOcZmaDZ2eDAmTm5v2c9QABADUAAACgAmUAAwAAMxEzETZpAmT9nAABADUAAAFRAmUAGgAAAREUBwYHBiMiLgMnJjUzFBYVFjMyNzY1EQFQDQ8fJi4IESsgIAUCcQEEGxUHBAJk/pZkLCscIwIRHkEsFxcCDAQzGxAhAZEAAAAAAQA1//8BiwJmAAoAABcRMxETMwMTIwMRNmdzbISTfnABAmb+7AEU/s/+zAEJ/vYAAQA1AAABGgJlAAUAADMRMxEzFTZpewJk/iaKAAEANQAAAeUCZQAMAAAzIxEzGwEzESMTAyMDlmCLTEuMYARZRVgCZP52AYr9nAHK/jYBygABADUAAAGMAmUACQAAGwEDMxEjAxMjEZ2NAWNikwJjAmT+lAFs/ZwBaf6XAmQAAAACADUAAAGsAmUADAAfAAATNDYzMhYVFA4BIyImNxQWMzI+BDU0LgIjIg4BNmRWUWs0VDRWZGgqKg8aEQ0IAwgSIhceJw4BLKGXmJpfjUaelUtjDxohKCcUHzo1IDVKAAACADUAAAFgAmYAEAAbAAATMzIeARcWFRQGBw4BKwEVIxMVMzI3NjU0JyYjNoEjMRoMLhcSFjEtKGRkJRoNGBkOHAJlCxMPO2cvWRkdGMAB3ZMJEi8uEQoAAwA1//8BvwJmABsALgA8AAAlFwYiLgInDgIjIi4BNTQ+ATMyFhUUBx4CAyIOBAc2MzIXFhc2NTQuAQMeAzsBMjcmJyYjIgG9AQINGRgcChMsFBM+VycmWD1Uah0GDQzAERwSDQcCARgVKCIbHQkbLGgGFRUTBgYWDhEOGSAPenkBAggSDRMTAlaGU1GIXK5/ZUkIBwEBZxIgHScLCBEoHzQeLTJOKP7/HCgQCQwiFSMAAAAAAgA1//8BjwJmAA0AGgAAJRcjJxUjETMXFhcWFRQnNjU0LgInKwEVMzIBDYF+cGpqOi4UW4QYCxARBQY1Lhb7++vqAmQBBQosgohEFyoVHg4IAZkAAQAyAAABjwJnACsAADczFBY3NjU0JicuAycmPgEzMhYXIy4DIyIGFRQWFx4BFRQOAiMiJjZ2JBIyJjwRICobAQE0TSs5WQp0AQMJEg0RHCdBQTEUJkQsXFbFKx8BBDgWIB4JFyg7ITlVKFRbCwwTCh0UFSIkJEc2JUE3IGkAAAABADUAAAFTAmUABwAAMxEjNSEVIxGLVQEdVQHseHj+FAAAAAABADUAAAGNAmUAGgAAEzMRFBceATI2NzY1ETMRFA4BBwYjIiYnLgE1NmsIBR8qHgUIagcQDjBUIk0ZGQwCZP6WLhsSGBYQFzUBa/6WM0MvFEEcJCZISwAAAQA1AAABpwJlAAYAADMDMxsBMwO2gGdQUWmAAmT+UwGt/ZwAAQA1AAACQAJkAAwAADMDMxsBMxsBMwMjCwGfaWk4PFA8OGhrWz4+AmP+cwGN/nEBj/2dAYz+dAABADUAAAHBAmUACwAAMxMDMxc3MwMTIycHNop6c0NCcnmJc1VRAUYBHq6u/t/+vdnZAAAAAQA1AAABlAJlAAkAADczAzMXNzMDFSOsAXdvQUFtd3HrAXn29v6H6wAAAAABADUAAAFDAmYACQAAAQMzFSE1EyM1IQFDiIj+85OTAQ0B5v6kimcBdYkAAAAAEADGAAEAAAAAAAEACAASAAEAAAAAAAIABwArAAEAAAAAAAMAFQBfAAEAAAAAAAQACACHAAEAAAAAAAUAIgDWAAEAAAAAAAYADwEZAAEAAAAAABAACAE7AAEAAAAAABEABwFUAAMAAQQJAAEAEAAAAAMAAQQJAAIADgAbAAMAAQQJAAMAKgAzAAMAAQQJAAQAEAB1AAMAAQQJAAUARACQAAMAAQQJAAYAHgD5AAMAAQQJABAAEAEpAAMAAQQJABEADgFEAFYAZQBnAGUAbQBpAHQAZQAAVmVnZW1pdGUAAFIAZQBnAHUAbABhAHIAAFJlZ3VsYXIAADEALgAwADAAMgA7AFYAZQBnAGUAbQBpAHQAZQBSAGUAZwB1AGwAYQByAAAxLjAwMjtWZWdlbWl0ZVJlZ3VsYXIAAFYAZQBnAGUAbQBpAHQAZQAAVmVnZW1pdGUAAFYAZQByAHMAaQBvAG4AIAAxAC4AMAAwADIAOwBGAG8AbgB0AHMAZQBsAGYAIABNAGEAawBlAHIAIAAzAC4AMwAuADAAAFZlcnNpb24gMS4wMDI7Rm9udHNlbGYgTWFrZXIgMy4zLjAAAFYAZQBnAGUAbQBpAHQAZQBSAGUAZwB1AGwAYQByAABWZWdlbWl0ZVJlZ3VsYXIAAFYAZQBnAGUAbQBpAHQAZQAAVmVnZW1pdGUAAFIAZQBnAHUAbABhAHIAAFJlZ3VsYXIAAAAAAgAAAAAAAP+DADIAAAAAAAAAAAAAAAAAAAAAAAAAAABOAAAAAQACAQIBAwADAAQABgAHAAgACQANABMAFAAVABYAFwAYABkAGgAbABwAIwAkACUAJgAnACgAKQAqACsALAAtAC4ALwAwADEAMgAzADQANQA2ADcAOAA5ADoAOwA8AD0AQQBEAEUARgBHAEgASQBKAEsATABNAE4ATwBQAFEAUgBTAFQAVQBWAFcAWABZAFoAWwBcAF0ArAEECWNvbnRyb2xMRgljb250cm9sQ1IKc29mdGh5cGhlbgAAAAAAAAH//wACAAEAAAAMAAAAFgAAAAIAAQABAE0AAQAEAAAAAgAAAAAAAQAAAAoALAAuAAJERkxUAA5sYXRuABgABAAAAAD//wAAAAQAAAAA//8AAAAAAAAAAQAAAAoAMAA+AAJERkxUAA5sYXRuABoABAAAAAD//wABAAAABAAAAAD//wABAAAAAWtlcm4ACAAAAAEAAAABAAQAAgAAAAEACAABKd4ABAAAAEYAlgEwAd4CjAM2A+AEegUsBWYGDAa+B3AIHgjQCYIKNAriC4gMAgx0DOYNZA3mDlQOyg88D54QEBCGEQARchHsEmIS1BOWFAwUghTwFWIV1BaiFxQXkhgEGMYZdBomGtQbfhwYHL4dYB3+HpgfPh/oIJYhPCHmIpQjRiPsJJolSCXuJpQnQifoKJIpRAAmAAn/8QAK//sADP/7AA3/+wAO//sAD//7ABD/+wAR//sAEv/7ABP/+wAU//sAFf/xABb/8QAZ//sAHf/2AB7/+wAf//sAIP/xACH/+wAi//sAI//7ACT/+wAl//EAJv/2ACf/8QAo//sAKf/2ACr/+wAr//sALP/sAC3/7AAu/+IAL//dADD/9gAx/+wAMv/7ADP/+wA0//YAKwAG//EACP/nAAn/4gAK/9MAC//iAAz/9gAN/+IADv/sAA//4gAQ/9gAEf/iABL/1QAT//EAFP/nABX/8QAW/9gAMf/TADL/pgAz//MANP/nADX/8QA2//EAN//7ADj/7gA5//YAOv/7ADv/2AA8//EAPf/2AD7/9gA///EAQP/sAEH/+wBC/+wAQ//xAET/7ABF/+wARv/2AEf/3QBI/90ASf/EAEr/zgBL//YAKwAG//YAB//2AAn/3QAL/+wADP/sAA3/8QAO//YAD//sABD/8QAR/+wAEv/iABP/5wAU/+wAFf/dABb/7AAX/78AMf/YADL/sAAz/+IANP/iADX/8QA2/+cAN//xADj/3QA5/+wAOv/2ADv/4gA8//EAPf/xAD7/8QA///YAQP/YAEH/9gBC/+cAQ//sAET/7ABF/+wARv/xAEf/zgBI/9MASf/OAEr/zgBL/+wAKgAG//YAB//iAAj/4gAK/+IADP/dAA3/ugAO/+IAD//iABD/5wAR/+IAEv/dABP/yQAU/90AFf+mABb/0wAx/5gAMv/YADP/4gA0/9MANf/xADb/7AA3/+wAOP/iADn/7AA6//EAO//dADz/5wA9/+wAPv/sAD//5wBA/9gAQf/sAEL/zgBD/+wARP/YAEX/tQBG/90AR/+hAEj/oQBJ/8QASv+DAEv/7AAqAAb/8QAH/90ACP/YAAn/oQAL/8kADP/iAA3/sAAO/+cAD//YABD/4gAR/90AEv/bABP/4gAU/+IAFf/TABb/5wAg/+QAMf/nADL/3AAz//QANP/rADX/9AA2//IAN//4ADj/8AA5//QAOv/1ADv/7AA8/+oAPf/7AD7/9wA///IAQP/tAEH/+wBC/+IAQ//2AET/4wBF/7YARv/vAEf/pgBK/6MAS//yACYAB//TAAj/8QAK/84ADP/dAA3/9gAO//EAD//dABD/pgAR/8kAEv+6ABP/7AAU/90AFf/OADH/xAAy/5IAM//sADT/3QA1/+cANv/xADf/9gA4/90AO/9WADz/5wA9//EAPv/sAD//5wBA/84AQf/dAEL/0wBD/+cARP/nAEX/5wBG/+cAR//dAEj/2ABJ/7oASv/JAEv/4gAsAAb/+wAH//sACP/xAAn/zgAK/+cAC//dAAz/9gAN/9gADv/tAA//7AAQ/+kAEf/rABL/3QAT/90AFP/hABX/3QAW/90AMf/nADL/vwAz/+cANP/nADX/8QA2//EAN//sADj/5wA5//YAOv/2ADv/4gA8//EAPf/2AD7/+wA///sAQP/2AEH/+wBC/+wAQ//7AET/7ABF/9MARv/7AEf/yQBI/84ASf+wAEr/xABL/+cADgAG//sACf/xAAv/7AAN//sADv/7AA8AAAAR//EAEv/0ABP/9gAU//EAFf/xABb/7AAx//YAQP/2ACkABv/7AAf/9gAI//sACf/iAAr/5wAL/+wADP/vAA3/3QAO//sAD//qABD/8QAR/+wAEv/nABP/8QAU/+cAFf/iABb/7AAx/+cAMv/vADP//AA0/+cANf/7ADb//gA4//EAOf/8ADr//AA7/+kAPP/6AD3//QA+//4AP//7AEL/6gBD//0ARP/2AEX/7ABG//EAR//YAEj/4gBJ/+wASv/LAEv//AAsAAb/+wAH//EACP/2AAn/0wAK/+IAC//JAAz/5wAN/90ADv/iAA//7AAQ/+cAEf/sABL/3QAT/9MAFP/iABX/zgAW/+cAMf/YADL/xAAz/+wANP/dADX/6AA2//EAN//xADj/4wA5//EAOv/2ADv/7AA8/+wAPf/sAD7/9gA//+wAQP/iAEH/8QBC/90AQ//nAET/5wBF/8QARv/mAEf/xABI/8kASf+1AEr/rQBL/+IALAAG//sAB//7AAj/9gAJ/9MACv/2AAv/ugAM/+kADf/dAA7/9gAP/+wAEP/2ABH/8AAS//EAE//2ABT/5wAV/9gAFv/sADH/vwAy/9UAM//eADT/3wA1//EANv/xADf/9gA4/+IAOf/xADr/9gA7/+wAPP/xAD3/9gA+//EAP//2AED/2ABB//EAQv/nAEP/9gBE/+cARf/TAEb/8QBH/9gASP/YAEn/xgBK/78AS//xACsABv/7AAf/9gAI/+wACf/TAAr/5wAL/90ADP/lAA3/zgAO/90AD//dABD/7AAR/+IAEv/iABP/2AAU/+IAFf/JABb/5wAx/90AMv/EADP/6wA0/+EANf/wADb/8AA4/9wAOf/dADr/7AA7/9gAPP/sAD3/5wA+/+wAP//iAED/0wBB/+IAQv/YAEP/4gBE/84ARf/JAEb/4gBH/8kASP/OAEn/vwBK/8kAS//TACwABv/7AAf/3wAI/+cACf+wAAr/4wAL/8kADP/dAA3/xwAO/+cAD//dABD/7AAR/+cAEv/iABP/yQAU/9cAFf+/ABb/4gAa/+kAMf/YADL/uwAz/+EANP/dADb/6wA3//MAOP/lADn/8QA6//IAO//eADz/5wA9/+4APv/zAD//8ABA/+IAQf/2AEL/6gBD//YARP/kAEX/zABG/+8AR/+0AEj/uwBJ/64ASv+vAEv/5QAsAAb/+wAH/90ACP/nAAn/4gAK/9MAC//nAAz/3QAN//YADv/eAA//3QAQ/7AAEf/OABL/sAAT//sAFP/dABX/0wAW/9MAMf/iADL/iAAz//YANP/OADX/9gA2//EAN//xADj/0wA5//YAOv/zADv/gAA8//EAPf/7AD7/+wA///YAQP/OAEH/7gBC/84AQ//2AET/2ABF//sARv/2AEf/5wBI/+cASf/TAEr/4gBL/+wALAAG//sAB//2AAj/8QAJ/9gACv/nAAv/3QAM/+IADf/dAA7/4gAP/+IAEP/nABH/5wAS/9gAE//YABT/3QAV/84AFv/sADH/5wAy/78AM//nADT/2AA1/+cANv/nADf/7AA4/90AOf/sADr/7AA7/+cAPP/sAD3/8QA+/+wAP//xAED/4gBB//EAQv/dAEP/5wBE/+IARf/YAEb/5wBH/78ASP/HAEn/sABK/7UAS//dACsABv/xAAf/8QAI/+IACf/dAAr/0wAL/+IADP/iAA3/3QAO/+cAD//dABD/zgAR/9MAEv/EABP/0wAU/84AFv/dADH/4gAy/6EAM//jADT/3QA1/+wANv/sADf/5wA4/90AOf/nADr/8QA7/78APP/xAD3/9gA+/+wAP//nAED/3QBB/+cAQv/nAEP/5wBE/+IARf/OAEb/3QBH/8QASP/JAEn/lwBK/7oAS//YACkABv/sAAf/0wAI/90ACf/OAAr/3QAM/90ADf/EAA7/5wAP/9gAEP/YABH/3QAS/9MAE//YABT/4gAV/90AMf/sADL/wAAz/+8ANP/kADX/6wA2//AAN//2ADj/5AA5//EAOv/uADv/1gA8//QAPf/2AD7/8QA///AAQP/dAEH/7ABD/+gARP/YAEX/1QBG/+wAR/+3AEj/wwBJ/7UASv+wAEv/5gAeAAf/zgAi/+4AI//5ACT/7wAy/9AAM//pADT/sQA1/+sANv/nADf/5gA4/7oAOf/vADr/9wA7/9AAPP/sAD3/6wA+/+YAP//sAED/uwBB/+kAQv+7AEP/5ABE/9QARf+6AEb/0ABH/34ASP+SAEn/zQBK/5sAS//nABwAF//RACT//wAy/9EAM//uADT/5wA1/+8ANv/3ADf/7gA4/+gAOf/3ADr/+wA7/9oAPP/vAD3/9wA+/+4AP//vAED/4QBB//cAQv/nAEP/7wBE/+4ARf/QAEb/9wBH/8EASP/MAEn/wwBK/7sAS//nABwAF//QABv/+QAy/8EAM//zADT/6wA1//sANv/zADf/+wA4/+8AOf/zADr//gA7/+EAPP/vAD3/9wA+//kAP//3AED/4gBB//kAQv/jAEP/8wBE/+YARf/VAEb/+QBH/84ASP/JAEn/twBK/8EAS//rAB8ABv/7ABL/3wAX/8kAJf/5ACv/7wAy/7oAM//zADT/6wA1/+8ANv/uADf/8wA4/+oAOf/vADr/7wA7/9QAPP/5AD3//gA+//EAP//vAED/4wBB//MAQv/mAEP/7gBE/+cARf/XAEb/6wBH/8kASP/JAEn/twBK/7cAS//nACAABv/7ACQAAgAl/+8AJ//5AC3//gAv//4AMv/oADP//QA0/+sANf/7ADb/+gA3//sAOP/jADn/9wA6//oAO//kADz//wA9//0APv/+AD8AAABA/+gAQf/7AEL/6ABD//sARP/sAEX/8QBG//sAR//qAEj/6wBJ/+cASv/qAEv/+QAbAAb/+wAl/+8AMv+5ADP/+wA0/+8ANf/7ADb/+wA3//0AOP/vADn/+wA6AAAAO/+7ADz//gA9//4APv/7AED/7ABB//4AQv/nAEP/+QBE//kARf/7AEb/+QBH//MASP/rAEn/4gBK/+8AS//7AB0ABv/2ABf/zgAl/+8AMv+3ADP/9wA0/+sANf/3ADb/8QA3//kAOP/uADn/8wA6//sAO//YADz/8wA9/+4APv/3AD//8wBA/+MAQf/3AEL/6QBD/+8ARP/nAEX/1ABG/+8AR//JAEj/zABJ/6YASv/JAEv/3AAcAAb/+wAX//MAJf/7ADL/6wAz//4ANP/uADX/+wA2//4AN//+ADj/8wA5//0AOv/+ADv/7gA8//4APf/+AD7/+wA///4AQP/uAEL/9wBD//4ARP/+AEX/+QBG//4AR//uAEj/9wBJ/+4ASv/zAEv//gAYAAb/+wAx//YAMv/rADP//wA0//MANf//ADYAAQA3//8AOP/zADv/6AA8//4APf/+AD4AAQBA/+4AQf//AEL/8wBD//4ARP/4AEX//QBH/+wASP/3AEn/7ABK//EASwABABwABv/2ABf/4QAy/8oAM//9ADT/+QA1//4ANv/7ADf//gA4//MAOf/+ADr//wA7/+EAPP/7AD3//gA+//4AP//+AED/7wBB//4AQv/zAEP//gBE//sARf/7AEb//gBH/+8ASP/5AEn/2gBK//oAS//+AB0ABv/nABf/5wAx/7AAMv/hADP/7gA0/7QANf/rADb/5wA3/+4AOP+sADn/6wA6//kAO/+3ADz/6gA9/+8APv/nAD//5wBA/6wAQf/uAEL/rgBD/+cARP+8AEX/3ABG/9oAR//cAEj/0QBJ/9oASv/RAEv/7wAeAAb/9gAX//cAI//9ADH/vwAy/+4AM//5ADT/2gA1//4ANv/3ADf/+wA4/9oAOf/3ADr/+wA7/+cAPP/7AD3/+QA+//cAP//5AED/1ABB//sAQv/cAEP/9wBE/+8ARf/JAEb/6wBH/8QASP++AEn/5wBK/8EAS//+ABwAF//7ADH/7AAy/+QAM//+ADT/7gA1//4ANgAAADf//QA4//cAOf/7ADr//gA7/+4APP/+AD3//gA+//0AP//7AED/7wBB//4AQv/uAEP//gBE//cARf/7AEb/+QBH/+gASP/vAEn/6wBK/+gAS//+AB4ABv/7ABf/8wAa//4AHf/3ACX/9wAq//4AMf/2ADL/5AAz//0ANP/zADX/+wA2//4AN//+ADj/+QA7/+4APf/+AD7/+wA///4AQP/2AEH/+gBC/+4AQ//7AET/+QBF//sARv/+AEf/8wBI/+8ASf/zAEr/6wBL//4AHQAG//EAJP/3ADH/7AAy/7sAM//sADT/4wA1/+8ANv/vADf/9wA4/+QAOf/qADr/9wA7/98APP/vAD3/9wA+/+sAP//uAED/4wBB/+4AQv/mAEP/7wBE/+IARf/VAEb/7gBH/8MASP/GAEn/uwBK/7oAS//fABwABv/sACT//gAy/54AM//rADT/6gA1//EANv/rADf/9wA4/+MAOf/oADr/9wA7/64APP/sAD3/8QA+/+wAP//sAED/4QBB//MAQv/oAEP/5ABE/9gARf/kAEb/7gBH/9EASP/QAEn/uwBK/8QAS//zADAAF//3ABj//wAZ/+kAGv//ABv//QAc//4AHf/pAB7/+wAf//8AIP/iACH//gAi//8AI//+ACT//wAl/+IAJ//uACj//gAp/+cAKv/hACv/+QAs/8MALf/QAC7/5AAv/8wAMP//ADL/4QAz//4ANP/jADX/9wA3//kAOP/fADn/9wA7/+IAPP/5AD3/+gA+//EAP//6AED/2gBB/+8AQv/aAET/7wBF/9cARv/qAEf/xgBI/7sASf/qAEr/tABL//sAHQAG/+cAF//oACT/+gAy/+IAM//xADT/zAA1/+8ANv/sADf/+gA4/8wAOf/3ADr/8wA7/8kAPP/uAD3/7wA+/+wAP//rAED/yQBB//cAQv/MAEP/+ABE/9QARf/KAEb/2gBH/8EASP/EAEn/4gBK/7cAS//vAB0ABv/xABv/+QAl/+4AMv+8ADP/7wA0/9wANf/zADb/6AA3//cAOP/hADn/5gA6//MAO//aADz/6QA9//MAPv/pAD//6wBA/+MAQf/3AEL/2gBD/+kARP/rAEX/1ABG/+kAR//JAEj/zABJ/7QASv+7AEv/5wAbAAb/9gAy/6YAM//9ADT/0wA1//oANv/+ADf//QA4/9UAOf/3ADr//wA7/7kAPP/6AD3//gA+//sAP//7AED/0ABB//oAQv/XAEP/+QBE/+IARf/zAEb/9wBH/+8ASP/vAEn/6gBK/+cAS//6ABwABv/7ACQAAgAy/9UAM//7ADT/7wA1//cANv/9ADf//wA4/+4AOf/7ADr//wA7/+sAPP/+AD3//gA+//0AP//6AED/7gBB//sAQv/sAEP/+wBE/+8ARf/7AEb//QBH/+8ASP/qAEn/3wBK//gAS//+ABwABv/nABf/lQAy/4IAM//3ADT/wQA1/+kANv/nADf/+gA4/8QAOf/oADr/6wA7/5UAPP/uAD3/+wA+//cAP//vAED/wQBB/+8AQv/DAEP/5wBE/84ARf/uAEb/7gBH/+kASP/pAEn/zgBK/+4AS//7ADMABv/sABf/owAY//kAGf/XABr//gAb//4AHP/5AB3/0AAe//gAIP+tACH/8wAi//4AJP/+ACX/0AAm//kAJ//MACj//gAp/9oAKv/+ACv//gAs/+MALf/zAC7/3AAv//cAMP/7ADL/jwAz/+oANP/CADX/7wA2/+oAN//3ADj/xgA5/+sAOv/6ADv/qgA8/+sAPf/7AD7/7wA//+8AQP++AEH/7gBC/8MAQ//qAET/1QBF/+sARv/pAEf/6ABI/+cASf/iAEr/2gBL/+4AHAAG/+cAF//hADL/1AAz/+sANP+wADX/6wA2/+QAN//jADj/qgA5/+cAOv/jADv/ugA8/+cAPf/vAD7/2gA//+kAQP+uAEH/7wBC/64AQ//kAET/uwBF/9oARv/aAEf/zABI/84ASf/TAEr/zQBL/+sAHwAG/+IAF/+lACP//gAk//sAL//uADL/hwAz/+8ANP+sADX/+AA2/9wAN//6ADj/uQA5/+4AOv/vADv/hAA8/+gAPf/pAD7/5wA//+YAQP+wAEH/6QBC/7oAQ//vAET/zgBF/+gARv/oAEf/2gBI/+YASf/QAEr/4gBL/+kAHAAG//sAF//+ADL/5wAz//sANP/kADX/+wA2//8AN//7ADj/4QA5//4AOv//ADv/6wA8//sAPf/+AD7//gA///sAQP/hAEH/+wBC/9oAQ//+AET/7wBF//sARv/6AEf/6QBI//kASf/rAEr/6QBL//sAMAAG/+wAB//YAAj/3QAJ/9MACv+/AAv/yQAM/+IADf/YAA7/7AAP/9MAEP/JABH/5wAS/+IAE//OABT/4gAV/+wAFv/nACD/WwAh/+wAIv/xACP/8QAk//YAJf/xADL/oQAz/+wANP/nADX/7AA2//sAN//2ADj/9gA5//sAO/+PADz/7AA9//YAPv/sAD//8QBA/+IAQf/nAEL/7ABD/+IARP/JAEX/zgBG/+cAR/+/AEj/xABJ/5IASv+/AEv/4gArAAb/9gAI/8QACf+cAAr/zAAL/5QADP+6AA3/xAAO/+oAD//BABD/zgAR/78AEv+7ABP/2AAU/78AFf+mABcAAgAk/+cAMf+mADL/2AAz/+cANP+7ADX/5gA2//MAN//zADj/sQA5/+oAOv/rADz/6AA9/+gAPv/mAD//5wBA/7oAQf/4AEL/twBD/+gARP/OAEX/sQBG/88AR/+EAEj/lwBJ/9AASv+NAEv/9wAsAAb/9gAH/+oACP/nAAn/xAAK/+gAC//TAAz/3QAN/9gADv/lAA//5wAQ/+IAEf/aABL/3AAT/9MAFP/bABX/xAAk//EAMf/YADL/zQAz/+wANP/kADX/9wA2//MAN//9ADj/4wA5//cAOv/3ADv/5gA8//4APf/9AD7/7gA//+4AQP/kAEH/+QBC/+YAQ//vAET/6QBF/9oARv/vAEf/zgBI/88ASf/QAEr/uQBL//kAKwAG//YAB//qAAj/7AAJ/9gACv/uAAv/4gAM/+IADf/dAA7/9AAP/+IAEP/eABH/5gAS/+IAE//TABT/3QAV/90AJP/2ADH/7AAy/74AM//uADT/3wA1//oANv/xADj/5wA5/+8AOv/5ADv/2AA8/+0APf/9AD7/8wA///EAQP/rAEH/+ABC/+QAQ//3AET/5gBF/9AARv/zAEf/xgBI/80ASf++AEr/twBL/+gAKgAH//EACP/xAAn/0wAK/+YAC//YAAz/5wAN/9gADv/oAA//5wAQ/+IAEf/iABP/2AAU/90AFf/dACT/+wAx/+wAMv+7ADP/9wA0/+QANf/rADb/5wA3//EAOP/kADn/+QA6//YAO//aADz/9wA9//4APv/uAD//8QBA/+cAQf/vAEL/4wBD/+sARP/cAEX/0ABG/+sAR//CAEj/xABJ/7QASv+6AEv/6AAmAAf/9gAI//EACf/sAAr/9gAM/+cADv/6AA//8QAQ//EAEf/vABL/4QAT//EAFP/iABX/5wAy/+kAM//9ADT/5wA1//sANv/9ADf//gA4/+sAOf/+ADoAAQA7/+gAPP/9AD3/9wA+//0AP//9AED/6wBBAAEAQv/pAEP/+QBE/+wARgACAEf/6QBI/+8ASf/nAEr/6wBL//sAKQAH//sACP/xAAn/5wAK/+4AC//2AAz/4gAN//sADv/1AA//8QAQ/90AEf/kABL/4gAT/+wAFP/YABX/3QAx//YAMv+5ADP/+AA0/+MANf/3ADb/+AA3//kAOP/iADn/+gA6//0AO//OADz//QA9//4APv/5AD///ABA/+YAQv/jAEP/9wBE/+YARf/vAEb//gBH/+cASP/vAEn/0QBK/+YAS//9ACgAB//2AAj/4gAJ/90ACv/sAAv/4gAM/+gADf/iAA7/9QAP/+gAEP/dABH/4AAS/+YAE//OABT/4gAV/90AJP/7ADH/9gAy/8EAM//vADT/3wA2//QAN//4ADj/4wA5/+kAOv/6ADv/0QA8/+YAPf/zAD7/6QA///EAQP/qAEL/3ABD/+gARP/fAEb/+ABH/7sASP+7AEn/rwBK/68AS//jACcACP/xAAn/7AAK//gADP/2AA7/9wAP//YAEP/xABH/5wAS/+cAE//xABT/7AAV/+UAMf/2ADL/6AAz//kANP/qADX/+wA2//oAN//7ADj/6wA5//cAOv//ADv/4wA8//sAPf/+AD7/+wA///oAQP/sAEH/+gBC/+MAQ//5AET/7wBF/+oARv/7AEf/4wBI/+wASf/jAEr/6gBL//4AJgAH//sACP/7AAn/5wAK//oADP/2AA7/9gAP//YAEP/xABH/8QAS//IAE//xABT/5wAV//EAMv/nADP/+wA0//EANf/9ADb//gA3//4AOP/uADn/+wA6//4AO//oAD0AAAA+//sAP//+AED/7wBB//4AQv/qAEP//wBE//EARf/3AEb/+wBH/+YASP/3AEn/2gBK/+QAS//7ACkAB//2AAj/9gAJ/90ACv/yAAz/8QAO//EAD//wABD/6gAR/+wAEv/mABP/9AAU/+wAFf/rABf/zgAx//YAMv/OADP/7wA0/+oANf/5ADb//gA3//0AOP/oADn/+QA6//0AO//YADz//gA9//8APv/6AD//+QBA/+4AQf/5AEL/4wBD//gARP/qAEX/+QBG//oAR//pAEj/6QBJ/9UASv/rAEv/+gAqAAf/sgAI/8kACf+wAAr/ugAL/7UADP+1AA3/3QAO/+QAD/+6ABD/sgAR/7UAEv+xABP/4gAU/6sAFf+mADH/lwAy/9oAM//jADT/qwA1/+IANv/iADf/4wA4/5oAOf/XADr/7gA7/7QAPP/kAD3/6wA+/+4AP//mAED/rQBB/+8AQv+qAEP/6gBE/74ARf/XAEb/2gBH/9AASP/SAEn/1QBK/80AS//qACsAB//nAAj/8QAJ/6YACv/sAAv/nAAM/90ADf+6AA7/9gAP/+IAEP/sABH/3QAS/9oAE//sABT/3QAV/8QAJP/+ADH/pgAy/+sAM//vADT/ygA1//0ANv/zADf/+wA4/9MAOf/vADr/+wA7/9gAPP/3AD3/9wA+//EAP//7AED/1QBB//cAQv/PAEP/8wBE/+YARf+7AEb/5wBH/7UASP/JAEn/2gBK/6UAS//zACkAB//2AAn/7AAK//kAC//sAAz/9gAO//oAD//2ABD/7AAR/+cAEv/vABP/9gAU//EAFf/sABcAAQAx/+YAMv/pADP/+QA0/+oANf/zADb/+wA3//oAOP/nADn/9wA6//4AO//uADz/+QA9//oAPv/7AD//+QBA/+8AQf/3AEL/6QBD//oARP/sAEX/8wBG//gAR//pAEj/6QBJ/+MASv/nAEv//QAqAAf/9gAI//sACf/sAAr/9wAL/+wADP/7AA7/+gAP//EAEP/2ABH/7AAS//EAE//2ABT/9gAV/+QAFwABADH/8QAy/+kAM//3ADT/6QA1//kANv/5ADf/+QA4/+8AOf/6ADr//gA7/+8APP/7AD3/+gA+//oAP//4AED/7wBB//sAQv/rAEP//QBE/+8ARf/3AEb/+gBH/+4ASP/rAEn/4QBK/+wAS//5ACsAB//xAAj/4gAJ/9gACv/sAAv/2AAM//YADf/iAA7/8QAP/90AEP/iABH/0wAS/+IAE//JABT/4gAV/94AJP/7ADH/3QAy/7QAM//pADT/4QA1/+wANv/vADf/6gA4/+IAOf/qADr/+gA7/9oAPP/pAD3/6wA+/+wAP//pAED/4QBB/+sAQv/cAEP/6wBE/+IARf/JAEb/7gBH/7wASP/BAEn/pgBK/7UAS//kACwAB//iAAj/5wAJ/+IACv/OAAv/2AAM/+cADf/nAA7/8AAP/90AEP+6ABH/xAAS/9cAE//XABT/2AAV/9gAG//3ACT/+wAx/+IAMv+gADP/6QA0/+MANf/mADb/7wA3/+sAOP/aADn/6AA6//YAO/+xADz/6wA9/+4APv/oAD//7wBA/9oAQf/oAEL/1wBD/+MARP/aAEX/2ABG/+cAR//PAEj/yQBJ/7kASv/BAEv/6AApAAf/8QAI/+wACf/OAAr/6gAL/84ADP/nAA3/2AAO//YAD//fABD/4gAR/9gAEv/lABP/5wAU/+IAFf/YADH/4gAy/+cAM//3ADT/2gA1//gANv/5ADf/+wA4/9wAOf/3ADr//gA7/+MAPP/3AD3//QA+//cAP//3AED/1QBC/9UAQ//9AET/6QBF/+EARv/pAEf/ugBI/8QASf/aAEr/wgBL//sAKwAH/8kACP/YAAn/xAAK/9MAC/+/AAz/yQAN/9gADv/nAA//xAAQ/7oAEf+1ABL/wQAT/9gAFP+6ABX/vwAk//sAMf+/ADL/2gAz/+gANP/KADX/6QA2/+kAN//oADj/xgA5/+QAOv/nADv/uQA8/+wAPf/uAD7/6QA//+cAQP/GAEH/7ABC/8kAQ//mAET/2ABF/84ARv/VAEf/wQBI/7wASf/GAEr/tABL/+8AKwAH//EACP/2AAn/yQAK/+oAC//TAAz/3QAN/+cADv/sAA//4gAQ/+IAEf/YABL/3wAT/90AFP/dABX/2AAk//sAMf/nADL/xgAz//MANP/iADX/7wA2/+4AN//3ADj/4wA5/+kAOv/vADv/1wA8/+4APf/zAD7/6gA//+0AQP/kAEH/9wBC/98AQ//qAET/5wBF/9AARv/vAEf/yQBI/9AASf/PAEr/xABL/+8AKQAH/+cACP/sAAn/5wAK/+kAC//dAAz/2AAO/+wAD//XABD/qwAR/8kAEv/AABP/9gAU/9MAFf/OADH/2AAy/7AAM//5ADT/2gA1//0ANv/6ADf//gA4/98AOf/3ADr//QA7/8YAPP/7AD3//gA+//gAP//4AED/1QBB//0AQv/VAEP/+ABE/+MARf/zAEb/+QBH/+4ASP/zAEn/4gBK/+cAS//zACkACP/2AAn/5wAK//QAC//sAAz/+wAN//4ADv/2AA//5QAQ/+wAEf/nABL/8wAT//EAFP/nABX/3QAx/+QAMv/KADP/+QA0/+wANf/6ADb/+gA3//sAOP/vADn/+gA6AAAAO//hADz//wA9//0APv/5AD///gBA/+wAQf/7AEL/7ABD//sARP/vAEX/9wBG//sAR//zAEj/6gBJ/+EASv/jAEv/+wArAAf/zgAI/84ACf/YAAr/ygAL/9gADP/JAA3/+wAO/9kAD//JABD/ogAR/7oAEv+5ABP/5wAU/8QAFf+9ACT/+wAx/7oAMv+FADP/+wA0/7sANf/qADb/6wA3/+wAOP++ADn/5gA6/+8AO/+iADz/6AA9/+oAPv/sAD//7wBA/8MAQf/mAEL/uwBD/+YARP/KAEX/6QBG/+8AR//jAEj/3wBJ/9MASv/hAEv/6wApAAf/zgAI/84ACf/TAAv/2AAM/84ADv/eAA//xAAQ/7AAEf/TABL/sQAT/+wAFP/FABX/yQAk//sAMf/JADL/lQAz//MANP/BADX/+QA2//MAN//3ADj/xgA5//sAOv/3ADv/pQA8/+8APf/+AD7/7gA//+oAQP/DAEH/7gBC/8QAQ//vAET/0ABF/+4ARv/uAEf/6QBI/+QASf/aAEr/5gBL//cAKgAH/8QACP/OAAn/pgAL/7oADP+rAA3/3QAO/+cAD/+5ABD/twAR/8QAEv+zABP/0wAU/7AAFf+cACT/+wAx/6EAMv/aADP/4wA0/7cANf/4ADb/4wA3//0AOP+3ADn/7gA6/+8AO/+7ADz/7gA9//EAPv/jAD//6ABA/7oAQf/zAEL/uQBD/+sARP/OAEX/3wBG/+EAR//aAEj/2ABJ/9gASv/MAEv/7gAsAAf/yQAI/84ACf/JAAr/wgAL/8kADP/JAA3//gAO/8kAD/+6ABD/jQAR/7oAEv+gABP/4gAU/7UAFf+6AB7/8QAk//sAMf+1ADL/lwAz/+8ANP+7ADX/5gA2/+4AN//uADj/uQA5/+gAOv/3ADv/hAA8/+8APf/sAD7/7AA//+oAQP+6AEH/7ABC/7kAQ//pAET/ygBF/+8ARv/vAEf/6ABI/+kASf/fAEr/5ABL//EAJgAH//YACf/iAAr/7AAL/+cADP/iAA3//wAO//UAD//nABD/7AAR/+IAEv/gABP/7AAU/90AFf/TADH/4gAy/+sAM//+ADT/6AA1//4ANgAEADf//wA4/9wAOf/6ADv/5gA8//8APf//AD///QBA/+MAQf//AEMAAABE/+8ARf/4AEb/+wBH//cASP/rAEn/6QBK/+kAS//9AAIAAQAGAEsAAAAAAAAAAQAAAADUGBYRAAAAANmXsTQAAAAA2ZexNA==", fa = (r) => I4("http://www.w3.org/2000/svg", r), L7 = (r, e) => {
  const t = fa("rect");
  return t.setAttribute("height", `${r}`), t.setAttribute("width", `${e}`), t;
}, U7 = (r, e, t, n) => {
  const i = Dh("filter");
  i.setAttribute("id", n), i.setAttribute("height", "200%"), i.setAttribute("width", "200%"), i.setAttribute("x", "-50%"), i.setAttribute("y", "-50%");
  const a = Dh("feOffset");
  i.appendChild(a), a.setAttribute("result", "offOut"), a.setAttribute("in", "SourceAlpha"), a.setAttribute("dx", `${r}`), a.setAttribute("dy", `${e}`);
  const s = Dh("feGaussianBlur");
  i.appendChild(s), s.setAttribute("result", "blurOut"), s.setAttribute("in", "offOut"), s.setAttribute("stdDeviation", `${t}`);
  const o = Dh("feBlend");
  return i.appendChild(o), o.setAttribute("in", "SourceGraphic"), o.setAttribute("in2", "blurOut"), o.setAttribute("mode", "normal"), i;
}, V7 = (r) => {
  let e = r;
  return e = e.replace(/feoffset/gi, "feOffset"), e = e.replace(/fegaussianblur/gi, "feGaussianBlur"), e = e.replace(/feblend/gi, "feBlend"), e = e.replace(/lineargradient/gi, "linearGradient"), e = e.replace(/stddeviation/gi, "stdDeviation"), e;
};
function z7(r, e, t, n, i, a) {
  const s = i, o = a, l = {
    x: e[0],
    y: e[1],
    width: e[2] - e[0],
    height: e[3] - e[1]
  };
  if (l.width <= 0)
    return;
  const u = $7(
    l.height,
    l.width,
    t * s,
    n * o
  ), c = (n - u * l.width) / 2 - u * l.x, d = (t - u * l.height) / 2 - u * l.y;
  r.setAttribute("transform", `translate(${c} ${d}) scale(${u} ${u})`);
}
function $7(r, e, t, n) {
  const i = t / r, a = n / e;
  return i > 1 && a > 1 ? Math.min(i, a) : i > 1 && a < 1 ? a : i < 1 && a > 1 ? i : Math.min(i, a);
}
const QS = {
  m: ["x", "y"],
  z: [],
  l: ["x", "y"],
  h: ["x"],
  v: ["y"],
  c: ["x1", "y1", "x2", "y2", "x", "y"],
  s: ["x2", "y2", "x", "y"],
  q: ["x1", "y1", "x", "y"],
  t: ["x", "y"],
  a: ["rx", "ry", "xRotation", "largeArc", "sweep", "x", "y"]
};
class H7 {
  constructor(e) {
    const t = Array.from(e.querySelectorAll("path"));
    this.paths = t.map((n) => {
      const i = n.getAttribute("d") || "", a = this.parsePath(i);
      return { pathElement: n, pathData: a };
    });
  }
  transform(e) {
    for (const t of this.paths)
      t.pathData = this.runTransformer(t.pathData, e);
    this.update();
  }
  encodePath(e) {
    let t = "";
    const i = (a) => {
      const s = [], o = a.relative ? a.type : a.type.toUpperCase();
      let l = t !== o;
      const u = QS[a.type];
      l && (s.push(o), t = o);
      for (const c of u) {
        const d = a[c];
        let f;
        switch (typeof d) {
          case "boolean":
            f = d | 0;
            break;
          case "number":
            f = (d * 100 | 0) / 100;
            break;
          default:
            throw new Fu("Failed to encode path.");
        }
        l || s.push(" "), s.push(f), l = !1;
      }
      return s.join("");
    };
    return e.map(i).join("");
  }
  parsePath(e) {
    const t = /([mzlhvcsqta])([^mzlhvcsqta]*)/gi, n = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/gi, i = [];
    let a;
    for (t.lastIndex = 0; a = t.exec(e); ) {
      const s = a[1].toLowerCase(), o = (a[2].match(n) || []).map(parseFloat), l = s === a[1], u = QS[s];
      if (o.length < u.length)
        throw new Fu(
          `Path type "${s}" given ${o.length} arguments, expected ${u.length}.`
        );
      if (u.length > 0) {
        if (o.length % u.length !== 0)
          throw new Fu(
            `Path type "${s}" given ${o.length} arguments, not divisible by ${u.length}`
          );
        for (let c = 0; c < o.length / u.length; c++) {
          const d = { type: s, relative: l };
          for (let f = 0; f < u.length; f++)
            d[u[f]] = o[c * u.length + f];
          i.push(d);
        }
      } else
        i.push({ type: s, relative: l });
    }
    return i;
  }
  runTransformer(e, t) {
    const n = [
      ["x1", "y1"],
      ["x2", "y2"],
      ["x", "y"]
    ], i = (a) => {
      for (let s = 0; s < n.length; s++) {
        const [o, l] = n[s];
        if (o in a && l in a) {
          const u = [a[o], a[l]], c = t(u);
          if (c.length < 2)
            throw new Fu("Transformer must return at least 2 points.");
          a[o] = c[0], a[l] = c[1];
        }
      }
      return a;
    };
    return this.transformPath(e, i);
  }
  transformPath(e, t) {
    const n = [];
    for (let i = 0; i < e.length; i++) {
      const a = JSON.parse(JSON.stringify(e[i])), s = t(a);
      Array.isArray(s) ? n.push(...s) : s && n.push(s);
    }
    return n;
  }
  update() {
    for (const { pathElement: e, pathData: t } of this.paths) {
      const n = this.encodePath(t);
      e.setAttribute("d", n);
    }
  }
}
var Vp = { exports: {} }, uv, YS;
function j7() {
  if (YS) return uv;
  YS = 1;
  var r = { a: 7, c: 6, h: 1, l: 2, m: 2, r: 4, q: 4, s: 4, t: 2, v: 1, z: 0 }, e = [
    5760,
    6158,
    8192,
    8193,
    8194,
    8195,
    8196,
    8197,
    8198,
    8199,
    8200,
    8201,
    8202,
    8239,
    8287,
    12288,
    65279
  ];
  function t(h) {
    return h === 10 || h === 13 || h === 8232 || h === 8233 || // Line terminators
    // White spaces
    h === 32 || h === 9 || h === 11 || h === 12 || h === 160 || h >= 5760 && e.indexOf(h) >= 0;
  }
  function n(h) {
    switch (h | 32) {
      case 109:
      case 122:
      case 108:
      case 104:
      case 118:
      case 99:
      case 115:
      case 113:
      case 116:
      case 97:
      case 114:
        return !0;
    }
    return !1;
  }
  function i(h) {
    return (h | 32) === 97;
  }
  function a(h) {
    return h >= 48 && h <= 57;
  }
  function s(h) {
    return h >= 48 && h <= 57 || /* 0..9 */
    h === 43 || /* + */
    h === 45 || /* - */
    h === 46;
  }
  function o(h) {
    this.index = 0, this.path = h, this.max = h.length, this.result = [], this.param = 0, this.err = "", this.segmentStart = 0, this.data = [];
  }
  function l(h) {
    for (; h.index < h.max && t(h.path.charCodeAt(h.index)); )
      h.index++;
  }
  function u(h) {
    var g = h.path.charCodeAt(h.index);
    if (g === 48) {
      h.param = 0, h.index++;
      return;
    }
    if (g === 49) {
      h.param = 1, h.index++;
      return;
    }
    h.err = "SvgPath: arc flag can be 0 or 1 only (at pos " + h.index + ")";
  }
  function c(h) {
    var g = h.index, v = g, y = h.max, A = !1, x = !1, k = !1, F = !1, S;
    if (v >= y) {
      h.err = "SvgPath: missed param (at pos " + v + ")";
      return;
    }
    if (S = h.path.charCodeAt(v), (S === 43 || S === 45) && (v++, S = v < y ? h.path.charCodeAt(v) : 0), !a(S) && S !== 46) {
      h.err = "SvgPath: param should start with 0..9 or `.` (at pos " + v + ")";
      return;
    }
    if (S !== 46) {
      if (A = S === 48, v++, S = v < y ? h.path.charCodeAt(v) : 0, A && v < y && S && a(S)) {
        h.err = "SvgPath: numbers started with `0` such as `09` are illegal (at pos " + g + ")";
        return;
      }
      for (; v < y && a(h.path.charCodeAt(v)); )
        v++, x = !0;
      S = v < y ? h.path.charCodeAt(v) : 0;
    }
    if (S === 46) {
      for (F = !0, v++; a(h.path.charCodeAt(v)); )
        v++, k = !0;
      S = v < y ? h.path.charCodeAt(v) : 0;
    }
    if (S === 101 || S === 69) {
      if (F && !x && !k) {
        h.err = "SvgPath: invalid float exponent (at pos " + v + ")";
        return;
      }
      if (v++, S = v < y ? h.path.charCodeAt(v) : 0, (S === 43 || S === 45) && v++, v < y && a(h.path.charCodeAt(v)))
        for (; v < y && a(h.path.charCodeAt(v)); )
          v++;
      else {
        h.err = "SvgPath: invalid float exponent (at pos " + v + ")";
        return;
      }
    }
    h.index = v, h.param = parseFloat(h.path.slice(g, v)) + 0;
  }
  function d(h) {
    var g, v;
    g = h.path[h.segmentStart], v = g.toLowerCase();
    var y = h.data;
    if (v === "m" && y.length > 2 && (h.result.push([g, y[0], y[1]]), y = y.slice(2), v = "l", g = g === "m" ? "l" : "L"), v === "r")
      h.result.push([g].concat(y));
    else
      for (; y.length >= r[v] && (h.result.push([g].concat(y.splice(0, r[v]))), !!r[v]); )
        ;
  }
  function f(h) {
    var g = h.max, v, y, A, x, k;
    if (h.segmentStart = h.index, v = h.path.charCodeAt(h.index), y = i(v), !n(v)) {
      h.err = "SvgPath: bad command " + h.path[h.index] + " (at pos " + h.index + ")";
      return;
    }
    if (x = r[h.path[h.index].toLowerCase()], h.index++, l(h), h.data = [], !x) {
      d(h);
      return;
    }
    for (A = !1; ; ) {
      for (k = x; k > 0; k--) {
        if (y && (k === 3 || k === 4) ? u(h) : c(h), h.err.length) {
          d(h);
          return;
        }
        h.data.push(h.param), l(h), A = !1, h.index < g && h.path.charCodeAt(h.index) === 44 && (h.index++, l(h), A = !0);
      }
      if (!A && (h.index >= h.max || !s(h.path.charCodeAt(h.index))))
        break;
    }
    d(h);
  }
  return uv = function(g) {
    var v = new o(g), y = v.max;
    for (l(v); v.index < y && !v.err.length; )
      f(v);
    return v.result.length && ("mM".indexOf(v.result[0][0]) < 0 ? (v.err = "SvgPath: string should start with `M` or `m`", v.result = []) : v.result[0][0] = "M"), {
      err: v.err,
      segments: v.result
    };
  }, uv;
}
var cv, XS;
function BF() {
  if (XS) return cv;
  XS = 1;
  function r(t, n) {
    return [
      t[0] * n[0] + t[2] * n[1],
      t[1] * n[0] + t[3] * n[1],
      t[0] * n[2] + t[2] * n[3],
      t[1] * n[2] + t[3] * n[3],
      t[0] * n[4] + t[2] * n[5] + t[4],
      t[1] * n[4] + t[3] * n[5] + t[5]
    ];
  }
  function e() {
    if (!(this instanceof e))
      return new e();
    this.queue = [], this.cache = null;
  }
  return e.prototype.matrix = function(t) {
    return t[0] === 1 && t[1] === 0 && t[2] === 0 && t[3] === 1 && t[4] === 0 && t[5] === 0 ? this : (this.cache = null, this.queue.push(t), this);
  }, e.prototype.translate = function(t, n) {
    return (t !== 0 || n !== 0) && (this.cache = null, this.queue.push([1, 0, 0, 1, t, n])), this;
  }, e.prototype.scale = function(t, n) {
    return (t !== 1 || n !== 1) && (this.cache = null, this.queue.push([t, 0, 0, n, 0, 0])), this;
  }, e.prototype.rotate = function(t, n, i) {
    var a, s, o;
    return t !== 0 && (this.translate(n, i), a = t * Math.PI / 180, s = Math.cos(a), o = Math.sin(a), this.queue.push([s, o, -o, s, 0, 0]), this.cache = null, this.translate(-n, -i)), this;
  }, e.prototype.skewX = function(t) {
    return t !== 0 && (this.cache = null, this.queue.push([1, 0, Math.tan(t * Math.PI / 180), 1, 0, 0])), this;
  }, e.prototype.skewY = function(t) {
    return t !== 0 && (this.cache = null, this.queue.push([1, Math.tan(t * Math.PI / 180), 0, 1, 0, 0])), this;
  }, e.prototype.toArray = function() {
    if (this.cache)
      return this.cache;
    if (!this.queue.length)
      return this.cache = [1, 0, 0, 1, 0, 0], this.cache;
    if (this.cache = this.queue[0], this.queue.length === 1)
      return this.cache;
    for (var t = 1; t < this.queue.length; t++)
      this.cache = r(this.cache, this.queue[t]);
    return this.cache;
  }, e.prototype.calc = function(t, n, i) {
    var a;
    return this.queue.length ? (this.cache || (this.cache = this.toArray()), a = this.cache, [
      t * a[0] + n * a[2] + (i ? 0 : a[4]),
      t * a[1] + n * a[3] + (i ? 0 : a[5])
    ]) : [t, n];
  }, cv = e, cv;
}
var fv, JS;
function G7() {
  if (JS) return fv;
  JS = 1;
  var r = BF(), e = {
    matrix: !0,
    scale: !0,
    rotate: !0,
    translate: !0,
    skewX: !0,
    skewY: !0
  }, t = /\s*(matrix|translate|scale|rotate|skewX|skewY)\s*\(\s*(.+?)\s*\)[\s,]*/, n = /[\s,]+/;
  return fv = function(a) {
    var s = new r(), o, l;
    return a.split(t).forEach(function(u) {
      if (u.length) {
        if (typeof e[u] < "u") {
          o = u;
          return;
        }
        switch (l = u.split(n).map(function(c) {
          return +c || 0;
        }), o) {
          case "matrix":
            l.length === 6 && s.matrix(l);
            return;
          case "scale":
            l.length === 1 ? s.scale(l[0], l[0]) : l.length === 2 && s.scale(l[0], l[1]);
            return;
          case "rotate":
            l.length === 1 ? s.rotate(l[0], 0, 0) : l.length === 3 && s.rotate(l[0], l[1], l[2]);
            return;
          case "translate":
            l.length === 1 ? s.translate(l[0], 0) : l.length === 2 && s.translate(l[0], l[1]);
            return;
          case "skewX":
            l.length === 1 && s.skewX(l[0]);
            return;
          case "skewY":
            l.length === 1 && s.skewY(l[0]);
            return;
        }
      }
    }), s;
  }, fv;
}
var dv, KS;
function q7() {
  if (KS) return dv;
  KS = 1;
  var r = Math.PI * 2;
  function e(i, a, s, o) {
    var l = i * o - a * s < 0 ? -1 : 1, u = i * s + a * o;
    return u > 1 && (u = 1), u < -1 && (u = -1), l * Math.acos(u);
  }
  function t(i, a, s, o, l, u, c, d, f, h) {
    var g = h * (i - s) / 2 + f * (a - o) / 2, v = -f * (i - s) / 2 + h * (a - o) / 2, y = c * c, A = d * d, x = g * g, k = v * v, F = y * A - y * k - A * x;
    F < 0 && (F = 0), F /= y * k + A * x, F = Math.sqrt(F) * (l === u ? -1 : 1);
    var S = F * c / d * v, R = F * -d / c * g, M = h * S - f * R + (i + s) / 2, j = f * S + h * R + (a + o) / 2, G = (g - S) / c, ie = (v - R) / d, q = (-g - S) / c, Y = (-v - R) / d, J = e(1, 0, G, ie), se = e(G, ie, q, Y);
    return u === 0 && se > 0 && (se -= r), u === 1 && se < 0 && (se += r), [M, j, J, se];
  }
  function n(i, a) {
    var s = 1.3333333333333333 * Math.tan(a / 4), o = Math.cos(i), l = Math.sin(i), u = Math.cos(i + a), c = Math.sin(i + a);
    return [o, l, o - l * s, l + o * s, u + c * s, c - u * s, u, c];
  }
  return dv = function(a, s, o, l, u, c, d, f, h) {
    var g = Math.sin(h * r / 360), v = Math.cos(h * r / 360), y = v * (a - o) / 2 + g * (s - l) / 2, A = -g * (a - o) / 2 + v * (s - l) / 2;
    if (y === 0 && A === 0)
      return [];
    if (d === 0 || f === 0)
      return [];
    d = Math.abs(d), f = Math.abs(f);
    var x = y * y / (d * d) + A * A / (f * f);
    x > 1 && (d *= Math.sqrt(x), f *= Math.sqrt(x));
    var k = t(a, s, o, l, u, c, d, f, g, v), F = [], S = k[2], R = k[3], M = Math.max(Math.ceil(Math.abs(R) / (r / 4)), 1);
    R /= M;
    for (var j = 0; j < M; j++)
      F.push(n(S, R)), S += R;
    return F.map(function(G) {
      for (var ie = 0; ie < G.length; ie += 2) {
        var q = G[ie + 0], Y = G[ie + 1];
        q *= d, Y *= f;
        var J = v * q - g * Y, se = g * q + v * Y;
        G[ie + 0] = J + k[0], G[ie + 1] = se + k[1];
      }
      return G;
    });
  }, dv;
}
var hv, ZS;
function W7() {
  if (ZS) return hv;
  ZS = 1;
  var r = 1e-10, e = Math.PI / 180;
  function t(n, i, a) {
    if (!(this instanceof t))
      return new t(n, i, a);
    this.rx = n, this.ry = i, this.ax = a;
  }
  return t.prototype.transform = function(n) {
    var i = Math.cos(this.ax * e), a = Math.sin(this.ax * e), s = [
      this.rx * (n[0] * i + n[2] * a),
      this.rx * (n[1] * i + n[3] * a),
      this.ry * (-n[0] * a + n[2] * i),
      this.ry * (-n[1] * a + n[3] * i)
    ], o = s[0] * s[0] + s[2] * s[2], l = s[1] * s[1] + s[3] * s[3], u = ((s[0] - s[3]) * (s[0] - s[3]) + (s[2] + s[1]) * (s[2] + s[1])) * ((s[0] + s[3]) * (s[0] + s[3]) + (s[2] - s[1]) * (s[2] - s[1])), c = (o + l) / 2;
    if (u < r * c)
      return this.rx = this.ry = Math.sqrt(c), this.ax = 0, this;
    var d = s[0] * s[1] + s[2] * s[3];
    u = Math.sqrt(u);
    var f = c + u / 2, h = c - u / 2;
    return this.ax = Math.abs(d) < r && Math.abs(f - l) < r ? 90 : Math.atan(
      Math.abs(d) > Math.abs(f - l) ? (f - o) / d : d / (f - l)
    ) * 180 / Math.PI, this.ax >= 0 ? (this.rx = Math.sqrt(f), this.ry = Math.sqrt(h)) : (this.ax += 90, this.rx = Math.sqrt(h), this.ry = Math.sqrt(f)), this;
  }, t.prototype.isDegenerate = function() {
    return this.rx < r * this.ry || this.ry < r * this.rx;
  }, hv = t, hv;
}
var pv, eE;
function Q7() {
  if (eE) return pv;
  eE = 1;
  var r = j7(), e = G7(), t = BF(), n = q7(), i = W7();
  function a(s) {
    if (!(this instanceof a))
      return new a(s);
    var o = r(s);
    this.segments = o.segments, this.err = o.err, this.__stack = [];
  }
  return a.from = function(s) {
    if (typeof s == "string") return new a(s);
    if (s instanceof a) {
      var o = new a("");
      return o.err = s.err, o.segments = s.segments.map(function(l) {
        return l.slice();
      }), o.__stack = s.__stack.map(function(l) {
        return t().matrix(l.toArray());
      }), o;
    }
    throw new Error("SvgPath.from: invalid param type " + s);
  }, a.prototype.__matrix = function(s) {
    var o = this, l;
    s.queue.length && this.iterate(function(u, c, d, f) {
      var h, g, v, y;
      switch (u[0]) {
        // Process 'assymetric' commands separately
        case "v":
          h = s.calc(0, u[1], !0), g = h[0] === 0 ? ["v", h[1]] : ["l", h[0], h[1]];
          break;
        case "V":
          h = s.calc(d, u[1], !1), g = h[0] === s.calc(d, f, !1)[0] ? ["V", h[1]] : ["L", h[0], h[1]];
          break;
        case "h":
          h = s.calc(u[1], 0, !0), g = h[1] === 0 ? ["h", h[0]] : ["l", h[0], h[1]];
          break;
        case "H":
          h = s.calc(u[1], f, !1), g = h[1] === s.calc(d, f, !1)[1] ? ["H", h[0]] : ["L", h[0], h[1]];
          break;
        case "a":
        case "A":
          var A = s.toArray(), x = i(u[1], u[2], u[3]).transform(A);
          if (A[0] * A[3] - A[1] * A[2] < 0 && (u[5] = u[5] ? "0" : "1"), h = s.calc(u[6], u[7], u[0] === "a"), u[0] === "A" && u[6] === d && u[7] === f || u[0] === "a" && u[6] === 0 && u[7] === 0) {
            g = [u[0] === "a" ? "l" : "L", h[0], h[1]];
            break;
          }
          x.isDegenerate() ? g = [u[0] === "a" ? "l" : "L", h[0], h[1]] : g = [u[0], x.rx, x.ry, x.ax, u[4], u[5], h[0], h[1]];
          break;
        case "m":
          y = c > 0, h = s.calc(u[1], u[2], y), g = ["m", h[0], h[1]];
          break;
        default:
          for (v = u[0], g = [v], y = v.toLowerCase() === v, l = 1; l < u.length; l += 2)
            h = s.calc(u[l], u[l + 1], y), g.push(h[0], h[1]);
      }
      o.segments[c] = g;
    }, !0);
  }, a.prototype.__evaluateStack = function() {
    var s, o;
    if (this.__stack.length) {
      if (this.__stack.length === 1) {
        this.__matrix(this.__stack[0]), this.__stack = [];
        return;
      }
      for (s = t(), o = this.__stack.length; --o >= 0; )
        s.matrix(this.__stack[o].toArray());
      this.__matrix(s), this.__stack = [];
    }
  }, a.prototype.toString = function() {
    var s = "", o = "", l = !1;
    this.__evaluateStack();
    for (var u = 0, c = this.segments.length; u < c; u++) {
      var d = this.segments[u], f = d[0];
      f !== o || f === "m" || f === "M" ? (f === "m" && o === "z" && (s += " "), s += f, l = !1) : l = !0;
      for (var h = 1; h < d.length; h++) {
        var g = d[h];
        h === 1 ? l && g >= 0 && (s += " ") : g >= 0 && (s += " "), s += g;
      }
      o = f;
    }
    return s;
  }, a.prototype.translate = function(s, o) {
    return this.__stack.push(t().translate(s, o || 0)), this;
  }, a.prototype.scale = function(s, o) {
    return this.__stack.push(t().scale(s, !o && o !== 0 ? s : o)), this;
  }, a.prototype.rotate = function(s, o, l) {
    return this.__stack.push(t().rotate(s, o || 0, l || 0)), this;
  }, a.prototype.skewX = function(s) {
    return this.__stack.push(t().skewX(s)), this;
  }, a.prototype.skewY = function(s) {
    return this.__stack.push(t().skewY(s)), this;
  }, a.prototype.matrix = function(s) {
    return this.__stack.push(t().matrix(s)), this;
  }, a.prototype.transform = function(s) {
    return s.trim() ? (this.__stack.push(e(s)), this) : this;
  }, a.prototype.round = function(s) {
    var o = 0, l = 0, u = 0, c = 0, d;
    return s = s || 0, this.__evaluateStack(), this.segments.forEach(function(f) {
      var h = f[0].toLowerCase() === f[0];
      switch (f[0]) {
        case "H":
        case "h":
          h && (f[1] += u), u = f[1] - f[1].toFixed(s), f[1] = +f[1].toFixed(s);
          return;
        case "V":
        case "v":
          h && (f[1] += c), c = f[1] - f[1].toFixed(s), f[1] = +f[1].toFixed(s);
          return;
        case "Z":
        case "z":
          u = o, c = l;
          return;
        case "M":
        case "m":
          h && (f[1] += u, f[2] += c), u = f[1] - f[1].toFixed(s), c = f[2] - f[2].toFixed(s), o = u, l = c, f[1] = +f[1].toFixed(s), f[2] = +f[2].toFixed(s);
          return;
        case "A":
        case "a":
          h && (f[6] += u, f[7] += c), u = f[6] - f[6].toFixed(s), c = f[7] - f[7].toFixed(s), f[1] = +f[1].toFixed(s), f[2] = +f[2].toFixed(s), f[3] = +f[3].toFixed(s + 2), f[6] = +f[6].toFixed(s), f[7] = +f[7].toFixed(s);
          return;
        default:
          d = f.length, h && (f[d - 2] += u, f[d - 1] += c), u = f[d - 2] - f[d - 2].toFixed(s), c = f[d - 1] - f[d - 1].toFixed(s), f.forEach(function(g, v) {
            v && (f[v] = +f[v].toFixed(s));
          });
          return;
      }
    }), this;
  }, a.prototype.iterate = function(s, o) {
    var l = this.segments, u = {}, c = !1, d = 0, f = 0, h = 0, g = 0, v, y, A;
    if (o || this.__evaluateStack(), l.forEach(function(x, k) {
      var F = s(x, k, d, f);
      Array.isArray(F) && (u[k] = F, c = !0);
      var S = x[0] === x[0].toLowerCase();
      switch (x[0]) {
        case "m":
        case "M":
          d = x[1] + (S ? d : 0), f = x[2] + (S ? f : 0), h = d, g = f;
          return;
        case "h":
        case "H":
          d = x[1] + (S ? d : 0);
          return;
        case "v":
        case "V":
          f = x[1] + (S ? f : 0);
          return;
        case "z":
        case "Z":
          d = h, f = g;
          return;
        default:
          d = x[x.length - 2] + (S ? d : 0), f = x[x.length - 1] + (S ? f : 0);
      }
    }), !c)
      return this;
    for (A = [], v = 0; v < l.length; v++)
      if (typeof u[v] < "u")
        for (y = 0; y < u[v].length; y++)
          A.push(u[v][y]);
      else
        A.push(l[v]);
    return this.segments = A, this;
  }, a.prototype.abs = function() {
    return this.iterate(function(s, o, l, u) {
      var c = s[0], d = c.toUpperCase(), f;
      if (c !== d)
        switch (s[0] = d, c) {
          case "v":
            s[1] += u;
            return;
          case "a":
            s[6] += l, s[7] += u;
            return;
          default:
            for (f = 1; f < s.length; f++)
              s[f] += f % 2 ? l : u;
        }
    }, !0), this;
  }, a.prototype.rel = function() {
    return this.iterate(function(s, o, l, u) {
      var c = s[0], d = c.toLowerCase(), f;
      if (c !== d && !(o === 0 && c === "M"))
        switch (s[0] = d, c) {
          case "V":
            s[1] -= u;
            return;
          case "A":
            s[6] -= l, s[7] -= u;
            return;
          default:
            for (f = 1; f < s.length; f++)
              s[f] -= f % 2 ? l : u;
        }
    }, !0), this;
  }, a.prototype.unarc = function() {
    return this.iterate(function(s, o, l, u) {
      var c, d, f, h = [], g = s[0];
      return g !== "A" && g !== "a" ? null : (g === "a" ? (d = l + s[6], f = u + s[7]) : (d = s[6], f = s[7]), c = n(l, u, d, f, s[4], s[5], s[1], s[2], s[3]), c.length === 0 ? [[s[0] === "a" ? "l" : "L", s[6], s[7]]] : (c.forEach(function(v) {
        h.push(["C", v[2], v[3], v[4], v[5], v[6], v[7]]);
      }), h));
    }), this;
  }, a.prototype.unshort = function() {
    var s = this.segments, o, l, u, c, d;
    return this.iterate(function(f, h, g, v) {
      var y = f[0], A = y.toUpperCase(), x;
      h && (A === "T" ? (x = y === "t", u = s[h - 1], u[0] === "Q" ? (o = u[1] - g, l = u[2] - v) : u[0] === "q" ? (o = u[1] - u[3], l = u[2] - u[4]) : (o = 0, l = 0), c = -o, d = -l, x || (c += g, d += v), s[h] = [
        x ? "q" : "Q",
        c,
        d,
        f[1],
        f[2]
      ]) : A === "S" && (x = y === "s", u = s[h - 1], u[0] === "C" ? (o = u[3] - g, l = u[4] - v) : u[0] === "c" ? (o = u[3] - u[5], l = u[4] - u[6]) : (o = 0, l = 0), c = -o, d = -l, x || (c += g, d += v), s[h] = [
        x ? "c" : "C",
        c,
        d,
        f[1],
        f[2],
        f[3],
        f[4]
      ]));
    }), this;
  }, pv = a, pv;
}
var gv, tE;
function Y7() {
  return tE || (tE = 1, gv = Q7()), gv;
}
var X7 = Vp.exports, rE;
function J7() {
  if (rE) return Vp.exports;
  rE = 1, Object.defineProperty(X7, "__esModule", { value: !0 });
  var r = Y7(), e = 1e-8;
  function t(a) {
    var s = Math.min(a[0], a[2]), o = Math.max(a[0], a[2]);
    if (a[1] >= a[0] ? a[2] >= a[1] : a[2] <= a[1])
      return [s, o];
    var l = (a[0] * a[2] - a[1] * a[1]) / (a[0] - 2 * a[1] + a[2]);
    return l < s ? [l, o] : [s, l];
  }
  function n(a) {
    var s = a[0] - 3 * a[1] + 3 * a[2] - a[3];
    if (Math.abs(s) < e)
      return a[0] === a[3] && a[0] === a[1] ? [a[0], a[3]] : t([
        a[0],
        -0.5 * a[0] + 1.5 * a[1],
        a[0] - 3 * a[1] + 3 * a[2]
      ]);
    var o = -a[0] * a[2] + a[0] * a[3] - a[1] * a[2] - a[1] * a[3] + a[1] * a[1] + a[2] * a[2];
    if (o <= 0)
      return [Math.min(a[0], a[3]), Math.max(a[0], a[3])];
    for (var l = Math.sqrt(o), u = Math.min(a[0], a[3]), c = Math.max(a[0], a[3]), d = a[0] - 2 * a[1] + a[2], f = (d + l) / s, h = 1; h <= 2; f = (d - l) / s, h++)
      if (f > 0 && f < 1) {
        var g = a[0] * (1 - f) * (1 - f) * (1 - f) + a[1] * 3 * (1 - f) * (1 - f) * f + a[2] * 3 * (1 - f) * f * f + a[3] * f * f * f;
        g < u && (u = g), g > c && (c = g);
      }
    return [u, c];
  }
  function i(a) {
    var s = [1 / 0, 1 / 0], o = [-1 / 0, -1 / 0];
    return r(a).abs().unarc().unshort().iterate(function(l, u, c, d) {
      switch (l[0]) {
        // The next cases are ordered based on simple-icons data
        case "M": {
          s[0] > l[1] && (s[0] = l[1]), s[1] > l[2] && (s[1] = l[2]), o[0] < l[1] && (o[0] = l[1]), o[1] < l[2] && (o[1] = l[2]);
          break;
        }
        case "H": {
          s[0] > l[1] && (s[0] = l[1]), o[0] < l[1] && (o[0] = l[1]);
          break;
        }
        case "V": {
          s[1] > l[1] && (s[1] = l[1]), o[1] < l[1] && (o[1] = l[1]);
          break;
        }
        case "L": {
          s[0] > l[1] && (s[0] = l[1]), s[1] > l[2] && (s[1] = l[2]), o[0] < l[1] && (o[0] = l[1]), o[1] < l[2] && (o[1] = l[2]);
          break;
        }
        case "C": {
          var f = n([c, l[1], l[3], l[5]]);
          s[0] > f[0] && (s[0] = f[0]), o[0] < f[1] && (o[0] = f[1]);
          var h = n([d, l[2], l[4], l[6]]);
          s[1] > h[0] && (s[1] = h[0]), o[1] < h[1] && (o[1] = h[1]);
          break;
        }
        case "Q": {
          var g = t([c, l[1], l[3]]);
          s[0] > g[0] && (s[0] = g[0]), o[0] < g[1] && (o[0] = g[1]);
          var v = t([d, l[2], l[4]]);
          s[1] > v[0] && (s[1] = v[0]), o[1] < v[1] && (o[1] = v[1]);
          break;
        }
      }
    }, !0), [s[0], s[1], o[0], o[1]];
  }
  return Vp.exports = i, Vp.exports;
}
var K7 = J7();
const Z7 = /* @__PURE__ */ Bs(K7);
class eL extends _7 {
  constructor() {
    super(...arguments), this.moduleName = "Vegemite";
  }
  svgPreview(e, t) {
    return this.svgElement(e, t);
  }
  svgPrint(e, t) {
    return this.svgElement(e, t);
  }
  svgElement(e, t) {
    const n = e8(N7), a = e !== "" ? ((k) => k.charAt(0).toUpperCase() + k.substr(1).toLowerCase())(e) : "", s = n.getPath(a, 0, 72, 72), o = s.toSVG(2), l = s.getBoundingBox(), u = l.x2 - l.x1, c = s.toPathData(3), d = () => {
      const k = fa("g");
      k.classList.add("module-text-group");
      const F = fa("defs");
      k.appendChild(F), F.appendChild(U7(0, 2, 2, "shadow"));
      const S = fa("path");
      S.setAttribute("d", c), S.setAttribute("stroke", "black"), S.setAttribute("stroke-width", "3"), F.appendChild(S);
      const R = fa("g");
      R.classList.add("module-layer0"), k.appendChild(R), R.setAttribute("filter", "url(#shadow)"), R.innerHTML = S.outerHTML;
      const M = fa("g");
      M.classList.add("module-layer1"), k.appendChild(M), M.setAttribute("stroke-width", "3"), M.setAttribute("stroke", "rgb(45,41,38)"), M.setAttribute("fill", "rgb(45,41,38)"), M.setAttribute("transform", "translate(0.5,0)"), M.innerHTML = o;
      const j = fa("g");
      j.classList.add("module-layer2"), k.appendChild(j), j.setAttribute("fill", "rgb(255,209,0)"), j.setAttribute("transform", "translate(1,-0.1)"), j.innerHTML = o;
      const G = fa("g");
      return G.classList.add("module-layer3"), k.appendChild(G), G.setAttribute("fill", "white"), G.innerHTML = o, new H7(k).transform(([q, Y]) => [q, Y + (u / 2 - q) ** 2 / (u * 6)]), k;
    }, f = fa("g");
    f.classList.add("module-root");
    const h = fa("defs");
    f.appendChild(h);
    const g = fa("g");
    g.classList.add("module-bounds"), f.appendChild(g);
    const v = L7(t.height, t.width);
    v.setAttribute("opacity", "0"), g.appendChild(v);
    const y = fa("g");
    y.classList.add("module-text-enclosure"), f.appendChild(y);
    const A = d();
    y.appendChild(A);
    const x = Z7(c);
    return z7(y, x, t.height, t.width, 0.35, 0.65), V7(f.outerHTML);
  }
}
async function MF(r) {
  if (r === "Vegemite")
    return new eL();
  throw new un(`Failed to resolve Module, Module ${r} not found`);
}
const tL = [
  "altGlyph",
  "circle",
  "ellipse",
  "path",
  "polygon",
  "polyline",
  "rect",
  "text",
  "textPath",
  "tref",
  "tspan"
], rL = async (r, e, t) => {
  const n = e.data, i = t.data.baseUrl, a = n.assetUrl.replace("localhost", "localstack");
  let s;
  if (!i || i.trim() === "")
    s = a;
  else {
    const d = i.slice(0, 4) === "http" ? "" : "https://", f = new URL(d + i);
    f.searchParams.append("video", Hw(JSON.stringify([{ href: a }]))), f.pathname = f.pathname + (f.pathname.slice(-1) === "/" ? "" : "/"), s = f.toString();
  }
  const l = `data:image/svg+xml;base64,${Hw(await kF.toString(s, { type: "svg" }))}`, u = (d) => {
    const f = r.find((g) => g.panelId === d.panelId);
    if (!f)
      throw new Ei(d);
    const h = br();
    return new fi(
      {
        id: h,
        src: l,
        type: tr.Image,
        y: d.top,
        x: d.left,
        width: d.width,
        height: d.height,
        rotation: 0
      },
      f
    );
  }, c = t.data.regions;
  try {
    return c.map(u);
  } catch (d) {
    return console.error(d), [];
  }
}, nL = async (r, e, t, n) => {
  const i = t.data, a = i.assetUrl, s = await Gy(a);
  try {
    const o = await G8(i, n.option);
    o && (e[n.stepName] = { selectedVariants: [o] });
    const l = async (u) => {
      const c = await yF(u, o?.asset?.fileLink), d = await Mg(c), f = br(), h = r.find((v) => v.panelId === u.panelId);
      if (!h)
        throw new Ei(u);
      const g = d1(
        s,
        d,
        {
          scale: i.scale,
          left: i.x,
          top: i.y
        },
        n.data.forceImageCover
      );
      return [
        new fi(
          {
            id: f,
            path: d.path,
            type: tr.Frame,
            forceImageCover: n.data.forceImageCover,
            x: u.left,
            y: u.top,
            width: u.width,
            height: u.height,
            layer: u.layer,
            layerIndex: u.layerIndex,
            rotation: u.rotation,
            scaleX: u.width / d.width,
            scaleY: u.height / d.height,
            pattern: {
              id: `${f}-pattern`,
              src: s.src,
              x: g.x,
              y: g.y,
              width: s.width,
              height: s.height,
              rotation: 0,
              scaleX: g.zoom,
              scaleY: g.zoom,
              svg: s.svg,
              colors: s.colors
            }
          },
          h
        )
      ];
    };
    return (await Promise.all(n.data.regions.map((u) => l(u)))).flat();
  } catch (o) {
    return console.error(o), [];
  }
}, iL = async (r, e, t, n) => {
  const i = t.data, a = await ft.getOptionForStep(n);
  if (!a)
    return console.error(`No option for step ${n.stepName}.`), [];
  const s = a.variants?.find((S) => S.id === i.illustrationVariantId) || await ft.getDefaultVariant(a, n.overrideDefaultVariantId);
  if (!s)
    return console.error(`No variant with ID: ${i.illustrationVariantId}`), [];
  if (!s.asset)
    return console.error(`No asset for variant with ID: ${i.illustrationVariantId}`), [];
  e[n.stepName] = { selectedVariants: [s] };
  const o = s.asset?.fileLink;
  if (!o)
    return console.error(`No asset link for variant with ID: ${i.illustrationVariantId}`), [];
  const l = await ha(o, !0), u = /<svg.*?<\/svg>/s, c = l.match(u) || [], d = c?.length > 0 ? c[0] : "", g = _s().parseFromString(d, "image/svg+xml").firstElementChild;
  if (!g)
    return console.error("Failed to read SVG."), [];
  NA(g);
  const v = {};
  wl(g, (S) => {
    tL.includes(S.tagName) && !S.attributes.getNamedItem("fill") && S.setAttribute("fill", "#000000");
    const R = S.attributes.getNamedItem("fill");
    if (R && R.value !== "none") {
      const j = R.value, ie = `spiff-fill-${j.replace(/\W/g, "")}`;
      S.classList.add(ie), v[ie] = { browserValue: j };
    }
    const M = S.attributes.getNamedItem("stroke");
    if (M && M.value !== "none") {
      const j = M.value, ie = `spiff-stroke-${j.replace(/\W/g, "")}`;
      S.classList.add(ie), v[ie] = { browserValue: j };
    }
  });
  const A = El().serializeToString(g), x = i.colors;
  if (x) {
    for (const [S, R] of Object.entries(v))
      for (const M of Object.keys(x))
        if (R.browserValue === M) {
          v[S] = { browserValue: x[M] };
          break;
        }
  }
  const k = (S) => {
    const R = r.find((j) => j.panelId === S.panelId);
    if (!R)
      throw new Ei(S);
    const M = br();
    return new fi(
      {
        colors: v,
        id: M,
        svg: A,
        type: tr.Illustration,
        y: S.top,
        x: S.left,
        rotation: S.rotation,
        width: S.width,
        height: S.height,
        layer: S.layer,
        layerIndex: S.layerIndex,
        immutable: S.immutable
      },
      R
    );
  }, F = n.data.regions;
  try {
    return F.map(k);
  } catch (S) {
    return console.error(S), [];
  }
}, aL = async (r, e, t) => {
  const n = await MF(t.data.module), i = e.data, a = (o, l) => {
    const u = r.find((d) => d.panelId === l.panelId);
    if (!u)
      throw new Ei(l);
    const c = br();
    return new fi(
      {
        colors: {},
        id: c,
        svg: o,
        type: tr.Illustration,
        y: l.top,
        x: l.left,
        rotation: l.rotation,
        width: l.width,
        height: l.height,
        layer: l.layer,
        layerIndex: l.layerIndex
      },
      u
    );
  }, s = t.data.regions;
  try {
    return s.map(
      (o) => a(n.svgPrint(i.text, o), o)
    );
  } catch (o) {
    return console.error(o), [];
  }
}, sL = async (r, e, t, n) => {
  const i = t.data, a = await ft.getOptionForStep(n);
  if (!a)
    return console.error(`No option for step ${n.stepName}.`), [];
  const s = a.variants?.find((c) => c.id === i.pictureVariantId) || await ft.getDefaultVariant(a, n.overrideDefaultVariantId);
  if (!s)
    return console.error(`No variant with ID: ${i.pictureVariantId}`), [];
  if (!s.asset)
    return console.error(`No asset for variant with ID: ${i.pictureVariantId}`), [];
  e[n.stepName] = { selectedVariants: [s] };
  const o = s.asset?.fileLink;
  if (!o)
    return console.error(`No asset link for variant with ID: ${i.pictureVariantId}`), [];
  const l = (c) => {
    const d = r.find((h) => h.panelId === c.panelId);
    if (!d)
      throw new Ei(c);
    const f = br();
    return new fi(
      {
        id: f,
        src: o,
        type: tr.Image,
        y: c.top,
        x: c.left,
        rotation: c.rotation,
        width: c.width,
        height: c.height,
        layer: c.layer,
        layerIndex: c.layerIndex,
        immutable: c.immutable,
        preserveAspectRatio: "none"
      },
      d
    );
  }, u = n.data.regions;
  try {
    return u.map(l);
  } catch (c) {
    return console.error(c), [];
  }
}, oL = async (r, e, t, n) => {
  const i = t.data, a = await ft.getOptionForStep(n);
  if (!a)
    return console.error(`No option for step ${n.stepName}.`), [];
  const s = a.variants?.find((u) => u.id === i.colorVariantId) || await ft.getDefaultVariant(a, n.overrideDefaultVariantId);
  if (!s)
    return console.error(`No variant with ID: ${i.colorVariantId}`), [];
  e[n.stepName] = { selectedVariants: [s] };
  const o = (u) => {
    const c = r.find((v) => v.panelId === u.panelId);
    if (!c)
      throw new Ei(u);
    const d = `
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            xmlSpace="preserve"
            preserveAspectRatio="none"
            version="1.1"
            width="1"
            height="1"
            viewBox="0 0 1 1"
        >
            <rect
                x="0"
                y="0"
                width="1"
                height="1"
                class="spiff-fill-shape"
                fill="${s?.color}"
            />
        </svg>
        `, h = { "spiff-fill-shape": { browserValue: s.color || "#000000" } }, g = br();
    return new fi(
      {
        colors: h,
        id: g,
        svg: d,
        type: tr.Illustration,
        y: u.top,
        x: u.left,
        rotation: u.rotation,
        width: u.width,
        height: u.height,
        layer: u.layer,
        layerIndex: u.layerIndex,
        immutable: u.immutable
      },
      c
    );
  }, l = n.data.regions;
  try {
    return l.map(o);
  } catch (u) {
    return console.error(u), [];
  }
}, lL = async (r, e, t) => {
  const n = [], a = e.type === Je.ProductOverlay ? t || e.data.asset?.fileLink || "" : e.data.asset?.fileLink || "", o = a.endsWith(".jpeg") || a.endsWith(".jpg") || a.endsWith(".png") ? tr.Image : (a.endsWith(".svg"), tr.Illustration), l = e.data.regions;
  if (o === "image")
    try {
      l.forEach((u) => {
        const c = r.find((f) => f.panelId === u.panelId);
        if (!c)
          throw new Ei(u);
        const d = {
          id: br(),
          src: a,
          type: o,
          y: u.top,
          x: u.left,
          width: u.width,
          height: u.height,
          layer: u.layer,
          layerIndex: u.layerIndex,
          productOverlay: e.type === Je.ProductOverlay ? !0 : void 0,
          scaleX: 1,
          scaleY: 1,
          rotation: u.rotation,
          excludeFromExport: e.data.excludeFromPrint,
          preserveAspectRatio: "none"
        };
        n.push(new fi(d, c));
      });
    } catch (u) {
      console.error(u);
    }
  else {
    const u = await ha(a, !0), c = (d) => {
      const f = /<svg.*?<\/svg>/s, h = d.match(f) || [], g = h?.length > 0 ? h[0] : "", A = _s().parseFromString(g, "image/svg+xml").firstElementChild;
      if (!A)
        throw new Fu("Failed to read SVG.");
      return NA(A), El().serializeToString(A);
    };
    l.forEach((d) => {
      const f = r.find((g) => g.panelId === d.panelId);
      if (!f)
        throw new Ei(d);
      const h = {
        id: br(),
        src: a,
        asset_key: a,
        svg: c(u),
        colors: {},
        type: o,
        y: d.top,
        x: d.left,
        width: d.width,
        height: d.height,
        layer: d.layer,
        layerIndex: d.layerIndex,
        scaleX: 1,
        scaleY: 1,
        rotation: d.rotation,
        productOverlay: e.type === Je.ProductOverlay ? !0 : void 0,
        excludeFromExport: e.data.excludeFromPrint
      };
      n.push(new fi(h, f));
    });
  }
  return n;
}, uL = async (r, e, t, n) => {
  const i = [], a = t.data, s = 30, o = (y) => y.vertical ? "center" : y.textAlign || "center", l = async () => {
    const y = await ft.getOptionForStep(n);
    if (!y)
      return;
    const A = y.variants?.find((k) => k.id === a.fontVariantId) || await ft.getDefaultVariant(y, n.overrideDefaultVariantId);
    if (!A || !A.asset)
      return;
    e[n.stepName] = { selectedVariants: [A] };
    const x = A.asset.fileLink;
    if (x)
      return x;
  }, c = await (async () => {
    const y = await l();
    if (!y)
      return;
    const A = await uc(y);
    return {
      assetUrl: y,
      name: A.names.fullName.en
    };
  })(), d = (n.data.replaceableText ? n.data.replaceableText.replace("{{}}", a.text) : a.text) || "", f = lg(d, {
    vertical: n.data.vertical,
    uppercase: n.data.uppercase
  }), h = async (y) => {
    const A = y.colorOption;
    return A ? (await ft.getDefaultVariant(A))?.color : void 0;
  }, g = a.color || await h(n.data), v = n.data.regions;
  for (const y of v) {
    const A = r.find((k) => k.panelId === y.panelId);
    if (!A)
      continue;
    const x = {
      stepName: t.name,
      id: br(),
      align: o(n.data),
      curved: n.data.curved,
      fill: a.color || g || "#000000",
      fontData: c,
      fontSize: n.data.size || s,
      height: y.height,
      layer: y.layer,
      layerIndex: y.layerIndex,
      paths: n.data.paths,
      rotation: y.rotation,
      text: f,
      type: tr.Textbox,
      vertical: n.data.vertical,
      verticalAlign: n.data.verticalAlign || "middle",
      width: y.width,
      x: y.left,
      y: y.top
    };
    if (c) {
      const [k, F] = Up(
        n.data.size || s,
        c,
        y,
        [
          lg(f, {
            vertical: n.data.vertical,
            uppercase: n.data.uppercase
          })
        ],
        {
          size: n.data.size,
          minSize: n.data.minSize,
          maxSize: n.data.maxSize
        }
      );
      i.push(
        new fi(
          {
            ...x,
            fontSize: k,
            text: x.curved ? x.text : (F || []).join(`
`)
          },
          A
        )
      );
    } else
      i.push(new fi(x, A));
  }
  return i;
}, cL = async (r, e, t, n) => {
  const i = [], a = {};
  for (const s of r) {
    const o = e.steps.find((l) => l.stepName === s.name);
    if (o)
      switch (o.type) {
        case Je.DigitalContent:
          i.push(
            ...await rL(t, s, o)
          );
          break;
        case Je.Frame:
        case Je.Photo:
          i.push(
            ...await nL(t, a, s, o)
          );
          break;
        case Je.Illustration:
          i.push(
            ...await iL(
              t,
              a,
              s,
              o
            )
          );
          break;
        case Je.Module:
          i.push(...await aL(t, s, o));
          break;
        case Je.Picture:
          i.push(
            ...await sL(t, a, s, o)
          );
          break;
        case Je.Shape:
          i.push(
            ...await oL(t, a, s, o)
          );
          break;
        case Je.Text:
          i.push(
            ...await uL(t, a, s, o)
          );
          break;
      }
  }
  for (const s of e.steps)
    s.type !== Je.SilentIllustration && s.type !== Je.ProductOverlay || await oo(s, a) && i.push(
      ...await lL(t, s, n)
    );
  return i;
};
class fL {
  constructor(e) {
    this.handleCompleteRender = null;
    const t = /* @__PURE__ */ new Map();
    e.forEach(
      (n) => t.set(
        n.id,
        new pL(
          n.id,
          n.name,
          this,
          { width: n.width, height: n.height },
          this.getWorkflowManager.bind(this)
        )
      )
    ), this.layouts = t;
  }
  setCompleteRenderCallback(e) {
    this.handleCompleteRender = e, e(Array.from(this.layouts.values()));
  }
  onCompleteRender() {
    this.handleCompleteRender && this.handleCompleteRender(Array.from(this.layouts.values()));
  }
  getAll() {
    return this.layouts;
  }
  setWorkflowManager(e) {
    this.workflowManager = e;
  }
  getWorkflowManager() {
    return this.workflowManager;
  }
}
const dL = () => new Promise((r, e) => {
  try {
    const n = bo().getContext("webgl2");
    r(!!n);
  } catch {
    r(!1);
  }
}), hL = dL();
class pL {
  constructor(e, t, n, i, a) {
    this.hasSetStaticContext = !1, this.interactiveDirty = !1, this.staticCtxDirty = !1, this.lastRequestedRenderArguments = void 0, this.lastCompletedStaticRender = void 0, this.renderQueue = new XA(2), this.id = e, this.name = t, this.service = n, this.panelSize = i, this.getWorkflowManager = a;
  }
  getID() {
    return this.id;
  }
  getName() {
    return this.name;
  }
  getPanelSize() {
    return this.panelSize;
  }
  getStaticContext() {
    return this.textureCtx;
  }
  /**
   * Register canvas to be rendered to.
   */
  setStaticContext(e) {
    this.textureCtx = e, this.lastRequestedRenderArguments && this.render(this.lastRequestedRenderArguments);
  }
  getStaticContextDirty() {
    return this.staticCtxDirty;
  }
  setStaticContextDirty(e) {
    this.staticCtxDirty = e;
  }
  getInteractiveCanvasDirty() {
    return this.interactiveDirty;
  }
  setInteractiveCanvasDirty(e) {
    this.interactiveDirty = e;
  }
  markLastCompletedStaticRender() {
    this.lastCompletedStaticRender = Date.now(), this.service.onCompleteRender();
  }
  /**
   * Returns a timestamp for the last time that this canvas rendered to its dynamic texture in the
   * form of Date.now(). If this panel has never rendered undefined will be returned.
   */
  getLastCompletedStaticRender() {
    return this.lastCompletedStaticRender;
  }
  /**
   * Actions to perform when a static render event is fired for this canvas.
   */
  async render(e) {
    const t = ho(e);
    this.lastRequestedRenderArguments = t;
    const n = this.getStaticContext();
    if (!n) {
      this.markLastCompletedStaticRender(), this.setStaticContextDirty(!1);
      return;
    }
    this.renderQueue.enqueue(
      new gL(
        this.getID(),
        n,
        await hL,
        () => {
          this.markLastCompletedStaticRender(), this.setStaticContextDirty(!0);
        },
        t,
        this.getWorkflowManager
      )
    );
  }
}
class gL extends YA {
  constructor(e, t, n, i, a, s) {
    super(), this.layoutId = e, this.ctx = t, this.nonPOTSupport = n, this.onRender = i, this.layouts = a, this.getWorkflowManager = s;
  }
  /**
   * Returns the resolution expected for generated textures.
   * FIXME: This is reimplemented from the preview package. Can we find a way to remove this duplication.
   */
  getDynamicTextureResolution() {
    return this.getIsMobile() || !this.offscreenRenderingSupported() ? {
      width: 1024,
      height: 1024
    } : {
      width: 2048,
      height: 2048
    };
  }
  getIsMobile() {
    return window.innerWidth <= 480;
  }
  /**
   * Returns true when multithreaded rendering is supported.
   */
  offscreenRenderingSupported() {
    return navigator.userAgent.includes("SamsungBrowser") ? !1 : !!window.Worker && !!window.OffscreenCanvas;
  }
  resizeFit(e, t = 4096) {
    const n = t / e.width, i = t / e.height, a = Math.min(n, i);
    return a > 1 ? e : { width: e.width * a, height: e.height * a };
  }
  /**
   * Render the internally stored layout to the canvas.
   * NOTE: This function is performance critical code. Please throughly test any changes to
   * ensure performance isn't lost and that rendering behavior is preserved when modifying this logic.
   * The aim is to have this code rendering in less than 16.66ms (60fps) on modern hardware. This is
   * a loose target but should be kept in mind when making changes.
   */
  async execute() {
    const e = this.layouts.find((g) => g.layoutState.layout.id === this.layoutId);
    if (!e)
      return;
    const t = e.layoutState.elements || [], n = e.layoutState.layout.width, i = e.layoutState.layout.height, a = n === 1 || i === 1 ? { width: 1, height: 1 } : this.getDynamicTextureResolution(), s = a.width, o = a.height;
    let l, u;
    if (this.nonPOTSupport) {
      const g = s / o;
      n / i < g ? (l = s, u = i * (s / n)) : (l = n * (o / i), u = o);
      const y = this.resizeFit({ width: l, height: u });
      l = y.width, u = y.height;
    } else
      l = a.width, u = a.height;
    const c = this.getWorkflowManager?.()?.getTemplatingContext(), d = c1(e.layoutState.layout, t, {
      renderingConfiguration: {
        purpose: id.ThreeD,
        templatingContext: c
      }
    }), f = xk(d), h = await so.from(this.ctx, f, {
      anonymousCrossOrigin: !0,
      ignoreDimensions: !this.nonPOTSupport,
      ignoreAnimation: !0,
      ignoreClear: !0,
      ignoreMouse: !0,
      enableRedraw: !1,
      createCanvas: bo,
      createImage: kd,
      DOMParser: RA(),
      fetch
    });
    h.resize(l, u), await h.render(), this.onRender();
  }
}
const LQ = (r, e) => {
  const t = [];
  return r.forEach((n) => {
    const i = e.steps.find((a) => a.stepName === n.stepName);
    i?.type === Je.Text && n.stepAspectType === "Text" && t.push({
      name: i.stepName,
      data: {
        text: n.value
      }
    });
  }), t;
}, UQ = async (r, e, t, n) => {
  let i = {
    serializableWorkflow: { steps: [] },
    layouts: {}
  };
  i = new Nn(t.map((l) => new wF(l))).apply(i);
  const s = await cL(r, e, t, n);
  return new Nn(s).apply(i);
}, _g = Ee`
    fragment GlobalPropertyStateAspectFields on GlobalPropertyStateAspect {
        name
        value
        type
        channel
        hidden
        storage {
            ... on GlobalPropertyStateColorOptionStorage {
                customColor
            }
            ... on GlobalPropertyStateFileUploadStorage {
                originalAssetKey
                backgroundRemovedAssetKey
                useOriginalAsset
                colors {
                    key
                    browserValue
                    pmsValue
                }
            }
        }
    }
`, mL = Ee`
    ${_g}
    mutation CreateGlobalPropertyState($bundleId: String!) {
        globalPropertyStateCreate(bundleId: $bundleId) {
            id
            aspects {
                ...GlobalPropertyStateAspectFields
            }
        }
    }
`, vL = Ee`
    ${_g}
    mutation UpdateGlobalPropertyState($id: String!, $aspects: [GlobalPropertyStateAspectInput]!) {
        globalPropertyStateUpdate(id: $id, aspects: $aspects) {
            id
            aspects {
                ...GlobalPropertyStateAspectFields
            }
        }
    }
`, yL = Ee`
    ${_g}
    query GetGlobalPropertyState($bundleId: String!) {
        globalPropertyState(bundleId: $bundleId) {
            id
            aspects {
                ...GlobalPropertyStateAspectFields
            }
        }
    }
`, VQ = async (r) => (await He.getShadowGraphqlClient().query({
  query: yL,
  fetchPolicy: "cache-first",
  errorPolicy: "all",
  variables: {
    bundleId: r
  }
})).data.globalPropertyState, AL = (r) => Ee`
    ${Pg}
    fragment ProductFields on Product {
        id
        basePrice
        enabled
        imageUrl
        minimumOrderQuantity
        integrationProducts {
            id
            externalProductId
            externalVariantId
            additionalExternalProductId
            additionalExternalVariantId
            additionalIntegrationProduct {
                ...AdditionalIntegrationProductFields
            }
            integration {
                id
                enabled
                externalIntegrationId
                type
                isCurrent
            }
        }
        modelUrl
        name
        description
        overlayImageUrl
        preloadImageUrl
        sku
        skuCode
        workflows${r ? "(filters: $productWorkflowFilters)" : ""} {
            id
            index
            friendlyName
            isPresent
            workflowName
            imageUrl
        }
        productTags {
            id
            name
        }
        productImages {
            id
            precedence
            asset {
                key
                fileLink
                name
                type
            }
        }
    }
`, g1 = (r) => Ee`
    ${AL(r)}
    fragment ProductCollectionProductFields on ProductCollectionProduct {
        id
        productId
        workflowId
        product {
            ...ProductFields
        }
    }
`, Ng = (r, e = !1) => Ee`
    ${r ? g1(e) : ""}
    fragment ProductCollectionFields on ProductCollection {
        id
        name
        description
        dispatchStartDate
        dispatchEndDate
        total
        productCollectionCustomers {
            id
            customer {
                id
            }
        }
        image {
            key
            name
            fileLink
        }
        globalPropertyConfiguration {
            id
            aspects {
                name
                type
                title
                description
                entityId
                mandatory
                silent
                conditions {
                    targetAspectName
                    action
                    requiredVariantSelections
                }
                conditionMode
                data {
                    fileUpload {
                        colorPickerEnabled
                        pmsPickerEnabled
                        colorOptionId
                    }
                    text {
                        templatingEnabled
                    }
                }
            }
        }
        ${r ? "productCollectionProducts { ...ProductCollectionProductFields }" : ""}
    }
`, _F = Ee`
    fragment BundleBaseFields on Bundle {
        id
        dispatchDate
        purchaseOrder
        createdAt
        updatedAt
        name
        completed
        template
        templateLocked
        templateStatus
        transactionsCount
        productsCount
        totalPriceSubunits
        quoteId
        orderId
        externalOrderId
        internalOrderId
        workflowViewerLink
        workflowViewerAmendLink
    }
`, bL = (r) => Ee`
    ${_g}
    ${Ng(r)}
    ${_F}
    query GetBundle($id: String!) {
        globalPropertyState(bundleId: $id) {
            id
            aspects {
                ...GlobalPropertyStateAspectFields
            }
        }
        bundles(ids: [$id]) {
            ...BundleBaseFields
            bundleStateData
            metadata {
                key
                value
            }
            partner {
                id
            }
            productCollection {
                ...ProductCollectionFields
            }
            transactionIds
            bundleShareActions {
                id
                title
                type
                stakeholderType
                precedence
                url
            }
        }
    }
`, nE = Ee`
    query GetBundleStakeholders($id: String!) {
        bundles(ids: [$id]) {
            id
            dispatchDate
            purchaseOrder
            completed
            workflowViewerLink
            workflowViewerAmendLink
            currentBundleStakeholder {
                id
                authorizationStatus
                authorizationDate
                authorizationNote
                customer {
                    id
                    emailAddress
                    firstName
                    lastName
                    phoneNumber
                    partner {
                        id
                    }
                }
                type
            }
            bundleStakeholders {
                id
                authorizationStatus
                authorizationDate
                authorizationNote
                customer {
                    id
                    emailAddress
                    firstName
                    lastName
                    phoneNumber
                    partner {
                        id
                    }
                }
                type
            }
        }
    }
`, wL = Ee`
    query GetBundlesForCustomer($id: String!) {
        customers(ids: [$id]) {
            bundleStakeholders {
                id
                authorizationStatus
                authorizationDate
                authorizationNote
                type
                bundle {
                    id
                    dispatchDate
                    purchaseOrder
                    completed
                    workflowViewerLink
                    workflowViewerAmendLink
                    name
                    createdAt
                    metadata {
                        key
                        value
                    }
                    partner {
                        id
                    }
                }
            }
        }
    }
`, xL = Ee`
    ${g1(!1)}
    query GetProductCollectionProducts($id: String!, $productIds: [String!]) {
        productCollections(ids: [$id], productIds: $productIds) {
            id
            productCollectionProducts {
                ...ProductCollectionProductFields
            }
        }
    }
`, CL = Ee`
    query GetProductCollectionForFilteredProducts(
        $id: String!
        $productFilters: ProductCollectionProductFilterInput
        $productWorkflowFilters: MetafieldFilterListInput
        $tags: ProductCollectionProductTagFilterInput
        $sortKey: ProductCollectionProductSortKey
        $sortDescending: Boolean
        $quickSearch: String
    ) {
        productCollections(ids: [$id]) {
            id
            productCollectionProductsFeed(
                filters: $productFilters
                workflowFilters: $productWorkflowFilters
                tags: $tags
                sortKey: $sortKey
                sortDescending: $sortDescending
                quickSearch: $quickSearch
            ) {
                items {
                    id
                    product {
                        id
                    }
                }
            }
        }
    }
`, SL = Ee`
    ${g1(!0)}
    query GetProductCollectionForProductsFeed(
        $id: String!
        $limit: Int
        $offset: Int
        $productFilters: ProductCollectionProductFilterInput
        $productWorkflowFilters: MetafieldFilterListInput
        $tags: ProductCollectionProductTagFilterInput
        $sortKey: ProductCollectionProductSortKey
        $sortDescending: Boolean
        $quickSearch: String
    ) {
        productCollections(ids: [$id]) {
            id
            productCollectionProductsFeed(
                filters: $productFilters
                workflowFilters: $productWorkflowFilters
                tags: $tags
                limit: $limit
                offset: $offset
                sortKey: $sortKey
                sortDescending: $sortDescending
                quickSearch: $quickSearch
            ) {
                items {
                    ...ProductCollectionProductFields
                }
                total
            }
        }
    }
`, EL = (r) => Ee`
    ${Ng(r)}
    mutation CreateBundle(
        $collectionId: String
        $initialMetadata: [MetadataInput!]
        $marketplaceThemeInstallId: String
        $marketplaceThemeInstallConfigurationId: String
        $activationId: String
    ) {
        bundleCreate(
            collectionId: $collectionId
            metadata: $initialMetadata
            marketplaceThemeInstallId: $marketplaceThemeInstallId
            marketplaceThemeInstallConfigurationId: $marketplaceThemeInstallConfigurationId
            activationId: $activationId
        ) {
            id
            bundleOwnerId
            metadata {
                key
                value
            }
            name
            partner {
                id
            }
            productCollection {
                ...ProductCollectionFields
            }
        }
    }
`, kL = () => Ee`
    mutation DuplicateBundle(
        $id: String!
        $template: Boolean
        $marketplaceThemeInstallId: String
        $marketplaceThemeInstallConfigurationId: String
        $duplicateTransactions: Boolean
    ) {
        bundleDuplicate(
            id: $id
            template: $template
            marketplaceThemeInstallId: $marketplaceThemeInstallId
            marketplaceThemeInstallConfigurationId: $marketplaceThemeInstallConfigurationId
            duplicateTransactions: $duplicateTransactions
        ) {
            id
            bundleOwnerId
            partner {
                id
            }
        }
    }
`, dp = Ee`
    mutation UpdateBundle(
        $id: String!
        $name: String
        $metadata: [MetadataInput!]
        $bundleStateData: String
        $dispatchDate: String
        $purchaseOrder: String
    ) {
        bundleUpdate(
            id: $id
            name: $name
            metadata: $metadata
            bundleStateData: $bundleStateData
            dispatchDate: $dispatchDate
            purchaseOrder: $purchaseOrder
        ) {
            id
        }
    }
`, TL = Ee`
    mutation BundleAddTransaction($id: String!, $transactionId: String!) {
        bundleAddTransaction(id: $id, transactionId: $transactionId) {
            id
        }
    }
`, FL = Ee`
    mutation BundleAddTransactions($id: String!, $transactionIds: [String!]!, $transactionOwnerIds: [String!]) {
        bundleAddTransactions(id: $id, transactionIds: $transactionIds, transactionOwnerIds: $transactionOwnerIds) {
            id
        }
    }
`, IL = Ee`
    mutation BundleRemoveTransaction(
        $id: String!
        $transactionId: String!
        $name: String
        $metadata: [MetadataInput!]
        $bundleStateData: String
    ) {
        bundleRemoveTransaction(id: $id, transactionId: $transactionId) {
            id
        }
        bundleUpdate(id: $id, name: $name, metadata: $metadata, bundleStateData: $bundleStateData) {
            id
        }
    }
`, DL = Ee`
    mutation BundleRemoveTransactions(
        $id: String!
        $transactionIds: [String!]!
        $name: String
        $metadata: [MetadataInput!]
        $bundleStateData: String
    ) {
        bundleRemoveTransactions(id: $id, transactionIds: $transactionIds) {
            id
        }
        bundleUpdate(id: $id, name: $name, metadata: $metadata, bundleStateData: $bundleStateData) {
            id
        }
    }
`, PL = Ee`
    mutation BundleAddStakeholder($id: String!, $details: CustomerDetailsInput!, $type: String!) {
        bundleAddStakeholder(id: $id, details: $details, type: $type) {
            id
            bundleStakeholders {
                id
                customer {
                    id
                    emailAddress
                    firstName
                    lastName
                    phoneNumber
                    partner {
                        id
                    }
                }
                type
            }
        }
    }
`, RL = Ee`
    mutation BundleAddStakeholder($id: String!, $emailAddress: String!) {
        bundleRemoveStakeholder(id: $id, emailAddress: $emailAddress) {
            id
        }
    }
`, OL = Ee`
    mutation BundleUpdateStakeholders($id: String!, $input: [BundleStakeholderInput!]!) {
        bundleUpdateStakeholders(id: $id, input: $input) {
            id
            bundleStakeholders {
                id
                customer {
                    id
                    emailAddress
                    firstName
                    lastName
                    phoneNumber
                    partner {
                        id
                    }
                }
                type
            }
        }
    }
`, BL = Ee`
    mutation BundleUpdateTransactionOrder($id: String!, $transactionIds: [String!]!) {
        bundleUpdateTransactionOrder(id: $id, transactionIds: $transactionIds) {
            id
        }
    }
`, ML = (r) => Ee`
    ${Ng(r)}
    mutation BundleAssignProductCollection($id: String!, $productCollectionId: String!) {
        bundleAssignProductCollection(id: $id, collectionId: $productCollectionId) {
            id
            productCollection {
                ...ProductCollectionFields
            }
        }
    }
`, _L = Ee`
    mutation AssignGlobalPropertyConfiguration($bundleId: String!, $globalPropertyConfigurationId: String!) {
        bundleUpdate(id: $bundleId, globalPropertyConfigurationId: $globalPropertyConfigurationId) {
            id
        }
    }
`, NL = (r) => Ee`
    ${_F}
    query CustomerBundlesFeed($id: String!, $limit: Int!, $offset: Int!, $template: Boolean, $templateStatus: BundleTemplateStatus, $ordered: Boolean) {
        customerBundlesFeed(id: $id, limit: $limit, offset: $offset, template: $template, templateStatus: $templateStatus, ordered: $ordered) {
            items {
                ...BundleBaseFields
                productCollection {
                    id
                    name
                    description
                    dispatchStartDate
                    dispatchEndDate
                    image {
                        key
                        name
                        fileLink
                    }
                    globalPropertyConfiguration {
                        id
                    }
                }
                ${r ? "metadata { key, value }" : ""}
            }
            total
        }
    }
`, LL = Ee`
    mutation FinalizeUpdateBundle($bundleId: String!) {
        bundleFinalizeUpdate(bundleId: $bundleId)
    }
`, UL = Ee`
    mutation ApproveBundle($id: String!, $note: String, $stakeholderId: String) {
        bundleApprove(id: $id, note: $note, stakeholderId: $stakeholderId)
    }
`, VL = Ee`
    mutation RejectBundle($id: String!, $note: String, $stakeholderId: String) {
        bundleReject(id: $id, note: $note, stakeholderId: $stakeholderId)
    }
`, zL = Ee`
    mutation ApproveTransaction($id: String!, $note: String) {
        transactionApprove(id: $id, note: $note)
    }
`, $L = Ee`
    mutation RejectTransaction($id: String!, $note: String) {
        transactionReject(id: $id, note: $note)
    }
`, HL = Ee`
    mutation CreateRecipient(
        $firstName: String
        $lastName: String
        $address: String
        $suburb: String
        $state: String
        $email: String
        $postalCode: String
        $country: String
        $mobile: String
        $company: String
        $apartment: String
        $customField1: String
        $customField2: String
        $customField3: String
        $customField4: String
        $customField5: String
        $conversionConfigurationId: String
    ) {
        recipientCreate(
            firstName: $firstName
            lastName: $lastName
            address: $address
            suburb: $suburb
            state: $state
            email: $email
            postalCode: $postalCode
            country: $country
            mobile: $mobile
            company: $company
            apartment: $apartment
            customField1: $customField1
            customField2: $customField2
            customField3: $customField3
            customField4: $customField4
            customField5: $customField5
            conversionConfigurationId: $conversionConfigurationId
        ) {
            id
        }
    }
`, jL = Ee`
    mutation UpdateRecipient(
        $id: String!
        $firstName: String
        $lastName: String
        $address: String
        $suburb: String
        $state: String
        $email: String
        $postalCode: String
        $country: String
        $mobile: String
        $company: String
        $apartment: String
        $customField1: String
        $customField2: String
        $customField3: String
        $customField4: String
        $customField5: String
        $conversionConfigurationId: String
        $prevalidated: Boolean
    ) {
        recipientUpdate(
            id: $id
            firstName: $firstName
            lastName: $lastName
            address: $address
            suburb: $suburb
            state: $state
            email: $email
            postalCode: $postalCode
            country: $country
            mobile: $mobile
            company: $company
            apartment: $apartment
            customField1: $customField1
            customField2: $customField2
            customField3: $customField3
            customField4: $customField4
            customField5: $customField5
            conversionConfigurationId: $conversionConfigurationId
            prevalidated: $prevalidated
        ) {
            id
        }
    }
`, GL = Ee`
    mutation AtttachRecipient($id: String!, $recipientId: String!) {
        transactionAttachRecipient(id: $id, recipientId: $recipientId) {
            id
        }
    }
`, qL = Ee`
    mutation DeleteBundle($id: String!) {
        bundleDelete(id: $id)
    }
`, WL = Ee`
    query FindBundleForTransactions($ids: [String!]!) {
        transactions(ids: $ids) {
            id
            bundle {
                id
            }
        }
    }
`, zQ = Ee`
    mutation EmailBundleShareLink($bundleId: String!, $email: String!, $firstName: String, $lastName: String) {
        bundleEmailSharePageLink(bundleId: $bundleId, email: $email, firstName: $firstName, lastName: $lastName) {
            id
        }
    }
`, QL = (r, e) => e && typeof e == "object" && !Array.isArray(e) ? Object.keys(e).sort().reduce((t, n) => (t[n] = e[n], t), {}) : e, YL = (r) => {
  for (const e of Object.values(r.layouts).map((t) => t.elements).flat())
    e.type === "illustration" && (delete e.cachedObjectURL, e.src && delete e.svg), e.type === "frame" && delete e.pattern?.svg;
  return NF(r, "__typename"), r;
}, NF = (r, e) => {
  if (!(typeof r != "object" || r === null))
    for (const t in r)
      t === e ? delete r[t] : NF(r[t], e);
};
var Lg = /* @__PURE__ */ ((r) => (r.Error = "Error", r.Warning = "Warning", r.Info = "Info", r))(Lg || {});
const XL = 1e3;
class iE extends YA {
  constructor(e) {
    super(), this.update = e;
  }
  async execute() {
    await this.update(), await new Promise((e) => {
      window.setTimeout(() => {
        e();
      }, XL);
    });
  }
}
const JL = (r) => r.sort((e, t) => e.index - t.index).map((e) => ({
  id: br(),
  panelId: e.name,
  name: e.name,
  title: e.title,
  index: e.index,
  createdAt: /* @__PURE__ */ new Date(),
  updatedAt: /* @__PURE__ */ new Date(),
  transparentBackground: e.transparentBackground,
  height: e.height,
  width: e.width,
  previewRegion: e.previewRegion,
  useEditableArea: e.useEditableArea,
  editableArea: e.editableArea
})), KL = (r, e) => {
  const t = r.workflowState, n = t ? JSON.parse(t) : void 0;
  return n ? Object.values(n.layouts).map((i) => i.layout) : JL(e.panels);
}, Jf = class Jf {
  constructor(e, t, n, i, a, s = !1, o, l = !1, u = !1, c = !1) {
    this.workflowStatePromiseQueue = new XA(1), this.initialized = !1, this.readOnly = !1, this.isReloadedTransaction = !1, this.singleVariantsRenderable = !1, this.stepTags = {}, this.setWorkflow = async (f) => {
      this.confirmedDesign = !1, this.editedSteps = {}, this.informationResults = [], this.mandatorySteps = {}, this.pendingUpdates = [], this.selectionCost = 0, this.stepSpecificServices = {}, this.pollers = [], this.allScenes = [], this.stepElements = {}, this.stepInitialised = {}, this.stepMetadata = {}, this.stepSelections = {}, this.storage = {}, this.validationErrors = { steps: /* @__PURE__ */ new Map() }, this.currentAdjustingStepId = "", this.reloadedState ? this.layouts = Object.values(this.reloadedState.layouts || {}).map((g) => g.layout) : f ? this.layouts = KL(this.experience.getTransaction(), f) : this.layouts = [], this.commandContext.initialize(this.layouts, this.reloadedState), this.renderableContextService = new fL(this.layouts), this.renderableContextService.setWorkflowManager(this), f.steps.forEach((g) => {
        this.stepTags[g.stepName] = g.tags ?? [];
      });
      const h = this.previewService;
      this.ejectFromPreviewService(), this.initializationPromise = this.initializeDefaultWorkflowState(f), this.initializationPromise.then(() => {
        this.initialized = !0;
      }), this.initializationPromise.catch((g) => {
        throw this.initialized = !1, new Error(g);
      }), this.initializationPromise.finally(
        () => this.commandContext.registerStateCallback(() => {
          this.updateStateWithServer(), this.renderLayouts();
        })
      ), h && await this.injectIntoPreviewService(h, !0);
    }, this.renderLayouts = () => {
      if (!this.previewService) return;
      const f = this.getCommandContext().getAllLayouts(), h = this.getLayoutPreviewService()?.getAll();
      if (h)
        for (const [, g] of h)
          g.render(f);
    }, this.experience = e, this.client = t, this.updateTransaction = n, this.graphQlClient = i, this.reloadedState = a, this.readOnly = s, this.singleVariantsRenderable = u, this.commandContext = new z8(), this.confirmCallbacks = [], this.editedCallbacks = [], this.elementsCallbacks = [], this.informationResultCallbacks = [], this.initCallbacks = [], this.mandatoryCallbacks = [], this.makingAdjustmentsCallback = [], this.metadataCallbacks = [], this.selectionCallbacks = [], this.stepSpecificStorageCallbacks = {}, this.storageCallbacks = [], this.validationCallbacks = [], this.recipientCallbacks = [], this.modelContainer = o, this.confirmedDesign = !1, this.editedSteps = {}, this.informationResults = [], this.mandatorySteps = {}, this.pendingUpdates = [], this.selectionCost = 0, this.stepSpecificServices = {}, this.pollers = [], this.allScenes = [], this.stepElements = {}, this.stepInitialised = {}, this.stepMetadata = {}, this.stepSelections = {}, this.storage = {}, this.validationErrors = { steps: /* @__PURE__ */ new Map() }, this.currentAdjustingStepId = "", this.isReloadedTransaction = l, c && (this.workflowStatePromiseQueue.enabled = !1);
    const d = this.experience.getWorkflow();
    d && this.setWorkflow(d);
  }
  getTemplatingContext() {
    const e = this.experience.getTransaction().recipient, t = { recipient: e };
    return this.recipientConversionConfiguration?.requestedDataItems?.forEach((n) => {
      const i = n.uniqueIdentifier ?? n.title ?? "";
      n.type === Pp.FirstName ? t[i] = e?.firstName : n.type === Pp.LastName ? t[i] = e?.lastName : n.type === Pp.Custom && (n.customFieldIndex === 1 ? t[i] = e?.customField1 : n.customFieldIndex === 2 ? t[i] = e?.customField2 : n.customFieldIndex === 3 ? t[i] = e?.customField3 : n.customFieldIndex === 4 ? t[i] = e?.customField4 : n.customFieldIndex === 5 && (t[i] = e?.customField5), n.option && (t[i] = n.option.variants?.find((a) => a.id === t[i])?.name));
    }), t;
  }
  async updateRecipient(e, t, n, i, a, s, o, l, u, c, d, f, h, g, v, y, A, x) {
    const k = this.experience.getTransaction();
    if (k.recipient?.id)
      this.experience.getTransaction().recipient = {
        id: k.recipient.id,
        firstName: e ?? k.recipient.firstName,
        lastName: t ?? k.recipient.lastName,
        address: n ?? k.recipient.address,
        suburb: i ?? k.recipient.suburb,
        state: a ?? k.recipient.state,
        email: s ?? k.recipient.email,
        postalCode: o ?? k.recipient.postalCode,
        country: l ?? k.recipient.country,
        mobile: u ?? k.recipient.mobile,
        company: c ?? k.recipient.company,
        apartment: d ?? k.recipient.apartment,
        customField1: f ?? k.recipient.customField1,
        customField2: h ?? k.recipient.customField2,
        customField3: g ?? k.recipient.customField3,
        customField4: v ?? k.recipient.customField4,
        customField5: y ?? k.recipient.customField5,
        conversionConfigurationId: A || k.recipient.conversionConfigurationId
      }, this.experience.callEvent(Xy.RecipientChanged), await this.graphQlClient().mutate({
        mutation: jL,
        errorPolicy: "all",
        fetchPolicy: "no-cache",
        variables: {
          id: k.recipient.id,
          firstName: e || k.recipient.firstName,
          lastName: t || k.recipient.lastName,
          address: n || k.recipient.address,
          suburb: i || k.recipient.suburb,
          state: a || k.recipient.state,
          email: s || k.recipient.email,
          postalCode: o || k.recipient.postalCode,
          country: l || k.recipient.country,
          mobile: u || k.recipient.mobile,
          company: c || k.recipient.company,
          apartment: d || k.recipient.apartment,
          customField1: f || k.recipient.customField1,
          customField2: h || k.recipient.customField2,
          customField3: g || k.recipient.customField3,
          customField4: v || k.recipient.customField4,
          customField5: y || k.recipient.customField5,
          conversionConfigurationId: A || k.recipient.conversionConfigurationId,
          prevalidated: x
        }
      });
    else {
      const F = await this.graphQlClient().mutate({
        mutation: HL,
        errorPolicy: "all",
        fetchPolicy: "no-cache",
        variables: {
          firstName: e,
          lastName: t,
          address: n,
          suburb: i,
          state: a,
          email: s,
          postalCode: o,
          country: l,
          mobile: u,
          company: c,
          apartment: d,
          customField1: f,
          customField2: h,
          customField3: g,
          customField4: v,
          customField5: y,
          conversionConfigurationId: A
        }
      });
      k.recipient = {
        id: F?.data?.recipientCreate?.id,
        firstName: e,
        lastName: t,
        address: n,
        suburb: i,
        state: a,
        email: s,
        postalCode: o,
        country: l,
        mobile: u,
        company: c,
        apartment: d,
        customField1: f,
        customField2: h,
        customField3: g,
        customField4: v,
        customField5: y,
        conversionConfigurationId: A
      }, this.experience.callEvent(Xy.RecipientChanged), await this.graphQlClient().mutate({
        mutation: GL,
        errorPolicy: "all",
        fetchPolicy: "no-cache",
        variables: {
          id: this.experience.getTransaction().id,
          recipientId: F.data?.recipientCreate?.id
        },
        context: {
          transactionOwnerId: this.experience.getTransaction().transactionOwnerId
        }
      });
    }
    await this.fetchConversionConfiguration(), this.recipientCallbacks.forEach((F) => F(this.experience.getTransaction().recipient));
  }
  async fetchConversionConfiguration() {
    const e = this.experience.getTransaction().recipient;
    if (e?.conversionConfigurationId && !this.recipientConversionConfiguration) {
      const t = Jf.configurationPromiseMap.get(
        e.conversionConfigurationId
      );
      if (t)
        this.recipientConversionConfiguration = await t;
      else {
        const i = (async () => (await this.graphQlClient().query({
          query: TB,
          errorPolicy: "all",
          fetchPolicy: "no-cache",
          variables: {
            id: e.conversionConfigurationId
          }
        })).data.conversionConfiguration)();
        Jf.configurationPromiseMap.set(e.conversionConfigurationId, i), this.recipientConversionConfiguration = await i;
      }
    }
  }
  async initializeDefaultWorkflowState(e) {
    const t = () => {
      const c = e.finalizeStepConfig;
      if (!c) return;
      const d = c.lookAtAnimation, f = c.modelAnimation;
      d && this.previewService?.executeCameraAnimation(d), f && this.modelContainer?.executeAnimation(f);
    };
    this.reloadedState && this.reloadedState.serializableWorkflow.steps.forEach((c) => {
      this.storage[c.stepName] = c.storage || {};
    });
    const n = await this.getInitialOptionIds(
      this.reloadedState?.serializableWorkflow?.steps.reduce((c, d) => (d.selectedVariants?.length && (c[d.stepName] = {
        selectedVariants: d.selectedVariants.map((f) => ({ id: f.id }))
      }), c), {})
    ), i = ft.getOptions(Array.from(n)), a = this.fetchConversionConfiguration();
    await Promise.all([i, a]), this.allScenes = Ix(e);
    const o = (await Ya(this.allScenes, this.stepSelections)).map((c) => c.silentSteps).flat(), { stepElements: l, commands: u } = await this.stepElementsForIntroducedSilentSteps(o, !!this.reloadedState);
    this.commandContext.apply(new Nn(u), !0), this.stepElements = { ...this.stepElements, ...l }, await this.ensureStepsAreLoaded(), this.isReloadedTransaction || this.updateStateWithServer(), this.renderLayouts(), this.reloadedState && t();
  }
  getWorkflowExperience() {
    return this.experience;
  }
  getClient() {
    return this.client;
  }
  setWorkflowStateSyncEnabled(e) {
    this.workflowStatePromiseQueue.enabled = e;
  }
  getInitializationPromise() {
    return this.initializationPromise;
  }
  isInitialized() {
    return this.initialized;
  }
  async getInitialOptionIds(e) {
    const t = /* @__PURE__ */ new Set(), n = this.experience.getWorkflow();
    if (!n)
      return t;
    const i = Ix(n), a = { ...e };
    let s = -1;
    for (; ; ) {
      const u = (await Ya(i, a)).flatMap((c) => c.renderableSteps);
      if (u.length === s)
        break;
      s = u.length;
      for (const c of u) {
        if (a[c.stepName])
          continue;
        const d = c.option?.defaultVariant?.id;
        d && (a[c.stepName] = {
          selectedVariants: [{ id: d }]
        });
      }
    }
    return (await Ya(i, a)).flatMap((l) => l.renderableSteps).forEach((l) => {
      l.option?.id && !l.option?.variants && t.add(l.option.id);
    }), t;
  }
  addConfirmCallback(e) {
    e(this.confirmedDesign), this.confirmCallbacks.push(e);
  }
  addEditedCallback(e) {
    e(this.editedSteps), this.editedCallbacks.push(e);
  }
  addElementsCallback(e) {
    e(this.stepElements), this.elementsCallbacks.push(e);
  }
  addInformationResultCallback(e) {
    e(this.informationResults), this.informationResultCallbacks.push(e);
  }
  addInitCallback(e) {
    e(this.stepInitialised), this.initCallbacks.push(e);
  }
  addMandatoryCallback(e) {
    e(this.mandatorySteps), this.mandatoryCallbacks.push(e);
  }
  addMetadataCallback(e) {
    e(this.stepMetadata), this.metadataCallbacks.push(e);
  }
  async addSelectionCallback(e) {
    e({
      selectionCost: this.selectionCost,
      selections: this.stepSelections,
      traversableScenes: await this.traversableScenes()
    }), this.selectionCallbacks.push(e);
  }
  addStepSpecificStorageCallback(e, t) {
    Object.keys(this.storage).includes(t) || (this.storage[t] = {}), e(this.storage[t]), Object.keys(this.stepSpecificStorageCallbacks).includes(t) || (this.stepSpecificStorageCallbacks[t] = []), this.stepSpecificStorageCallbacks[t].push(e);
  }
  /**
   * @deprecated Any call to this causes all renderable steps to re-render even if they don't care about change.
   */
  addStorageCallback(e) {
    e(this.storage), this.storageCallbacks.push(e);
  }
  addMakingAdjustmentsCallback(e) {
    e(this.currentAdjustingStepId), this.makingAdjustmentsCallback.push(e);
  }
  addPoller(e) {
    this.pollers.push(e);
  }
  addValidationCallback(e) {
    this.validationCallbacks.push(e), e(this.validationErrors);
  }
  addRecipientCallback(e) {
    this.recipientCallbacks.push(e), e(this.experience.getTransaction().recipient);
  }
  removeRecipientCallback(e) {
    this.recipientCallbacks = this.recipientCallbacks.filter((t) => t !== e);
  }
  getLayouts() {
    return this.layouts;
  }
  getAllLayoutData() {
    return this.commandContext.getAllLayouts().map((e) => e.layoutState);
  }
  getLayoutPreviewService() {
    return this.renderableContextService;
  }
  getInformationResults() {
    return this.informationResults;
  }
  getPreviewService() {
    return this.previewService;
  }
  getCommandContext() {
    return this.commandContext;
  }
  getRegionElements(e) {
    return this.stepElements[e] || [];
  }
  getStepSpecificServices(e) {
    return this.stepSpecificServices[e];
  }
  getTransactionCustomer() {
    return this.ownerCustomer;
  }
  setTransactionCustomer(e) {
    this.ownerCustomer = e;
  }
  setTransactionCustomerDetails(e) {
    this.ownerCustomer = { ...this.ownerCustomer, emailAddress: e.email };
  }
  getModelContainer() {
    return this.modelContainer;
  }
  setModelContainer(e) {
    (!e || this.previewService && this.previewService.getAllModels().includes(e)) && (this.modelContainer = e, e && e.metadata && e.metadata instanceof Map && this.modelContainer.metadata.set("workflowManager", this));
  }
  getCommandDispatcher() {
    return (e) => this.commandContext.apply(e, !this.initialized);
  }
  getWorkflowSelections() {
    const e = {};
    return this.experience.getWorkflow()?.steps.forEach((t) => {
      const n = this.stepSelections[t.stepName];
      n && n.selectedVariants && n.selectedVariants.length > 0 && (e[t.stepName] = {
        selections: n.selectedVariants
      });
    }), e;
  }
  getStepSelections() {
    return this.stepSelections;
  }
  markStepsAsInitialised(e) {
    const t = { ...this.stepInitialised };
    e.forEach((n) => {
      t[n] = !0;
    }), this.stepInitialised = t, this.onInitChange();
  }
  getUpdatesPending() {
    return this.pendingUpdates.length > 0;
  }
  markUpdateCompleted(e) {
    this.pendingUpdates = this.pendingUpdates.filter((t) => t !== e);
  }
  markUpdatePending() {
    const e = br();
    return this.pendingUpdates = [...this.pendingUpdates, e], e;
  }
  setEditedStatus(e, t) {
    this.editedSteps = { ...this.editedSteps, [e]: t }, this.onEditedChange();
  }
  setInformationResults(e) {
    this.informationResults = [...e], this.onInformationResultChange();
  }
  setCurrentAdjustingStepId(e) {
    this.currentAdjustingStepId = e, this.onMakingAdjustmentsChange();
  }
  setMandatoryFulfilled(e, t) {
    this.mandatorySteps[e] !== t && (this.mandatorySteps = { ...this.mandatorySteps, [e]: t }, this.onMandatoryChange());
  }
  async getMandatoryUnfulfilledSteps() {
    return (await Ya(this.allScenes, this.stepSelections)).flatMap((a) => a.renderableSteps).filter((a) => a.mandatory).filter((a) => !this.mandatorySteps[a.stepName]).map((a) => a.stepName);
  }
  setStepError(e, t, n) {
    let i = !1;
    if (!this.validationErrors.steps.has(e) && n)
      i = !0, this.validationErrors.steps.set(e, /* @__PURE__ */ new Map([[t, n]]));
    else if (this.validationErrors.steps.has(e)) {
      const a = this.validationErrors.steps.get(e);
      n && n !== a.get(t) ? (i = !0, a.set(t, n)) : n || (i = !0, a.delete(t), a.size === 0 && this.validationErrors.steps.delete(e));
    }
    i && this.onValidationChange();
  }
  getStepErrors(e) {
    return this.validationErrors.steps.get(e);
  }
  getValidationErrors() {
    return this.validationErrors;
  }
  toggleDesignConfirmed() {
    this.confirmedDesign = !this.confirmedDesign, this.onConfirmChange();
  }
  toggleMakingAdjustmentsCallback(e) {
    e(this.mandatorySteps), this.mandatoryCallbacks.push(e);
  }
  async injectIntoPreviewService(e, t) {
    if (this.modelContainer)
      throw new Error("You must eject from the preview service before injecting again.");
    this.previewService = e;
    const n = this.experience.getProduct();
    if (!n?.modelUrl || !this.previewService) return;
    const i = e.loadModel(
      {
        model: n.modelUrl,
        contextService: this.getLayoutPreviewService()
      },
      { refocusCamera: t }
    );
    this.setModelContainer(i), (await Ya(this.allScenes, this.stepSelections)).filter((o) => o).map((o) => o.renderableSteps).flat().filter((o) => o.type === Je.Model || o.type === Je.Material).forEach((o) => {
      if (!o.option?.id) {
        console.error(`Failed to read option id from step: ${o.stepName}`);
        return;
      }
      const l = this.stepSelections[o.stepName]?.selectedVariants || [];
      if (l.length === 0) return;
      const u = l[0];
      if (o.type === Je.Model) {
        if (!this.modelContainer)
          throw new un(
            "We should always have a model container when injecting a preview!"
          );
        const c = u.asset?.fileLink;
        if (!c) {
          console.error(`Failed to read model url from variant: ${u.id} for step: ${o.stepName}`);
          return;
        }
        const d = o.data;
        this.modelContainer.applyModelVariant(
          o.stepName,
          {
            model: c,
            contextService: this.getLayoutPreviewService()
          },
          d.replaceProductModel || !1
        );
      } else {
        const c = u.material;
        if (!c) {
          console.error(`Failed to read material from variant: ${u.id} for step: ${o.stepName}`);
          return;
        }
        o.data.targetMaterials.forEach((f) => {
          if (!this.modelContainer)
            throw new un(
              "We should always have a model container when injecting a preview!"
            );
          this.modelContainer.applyMaterialVariant(f, o.option.id, c);
        });
      }
    }), await i.getInitializationPromise(), this.renderLayouts();
  }
  ejectFromPreviewService() {
    if (this.modelContainer) {
      if (!this.modelContainer.dispose)
        throw new Error("This feature is not supported in the current preview service.");
      this.modelContainer.dispose(), this.modelContainer = void 0;
    }
    this.previewService = void 0;
  }
  updateStorage(e, t) {
    const n = {
      ...this.storage,
      [e]: { ...this.storage[e], ...t }
    };
    if (!ld(n, this.storage)) {
      this.storage = n;
      const i = new pS(this.constructSerializableWorkflow());
      this.commandContext.apply(i, !0), this.onStepSpecificStorageChange(e), this.onStorageChange();
    }
  }
  constructSerializableWorkflow() {
    const e = [];
    return this.allScenes.forEach((t) => {
      t.renderableSteps.forEach((n) => {
        const i = { stepName: n.stepName };
        i.storage = this.storage[n.stepName], i.selectedVariants = this.stepSelections[n.stepName]?.selectedVariants?.map(
          (a) => ({ id: a.id, priceModifier: a.priceModifier })
        ), e.push(i);
      });
    }), { steps: e };
  }
  updateStateWithServer() {
    if (this.readOnly) return;
    const e = this.serialize();
    this.workflowStatePromiseQueue.enqueue(
      new iE(async () => {
        await new Promise((t) => {
          setTimeout(() => {
            t();
          }, 1);
        }), await this.updateTransaction({
          variables: {
            id: this.experience.getTransaction().id,
            workflowState: e
          }
        });
      })
    );
  }
  async updateStateWithServerImmediate() {
    if (this.readOnly) return;
    const e = this.serialize();
    return new iE(async () => {
      await this.updateTransaction({
        variables: {
          id: this.experience.getTransaction().id,
          workflowState: e
        }
      });
    }).execute();
  }
  serialize() {
    const e = this.getCommandContext().getState();
    if (!e)
      throw new un("Attempted to serialize state before it was initialized.");
    const t = ho(e.transaction), n = YL(t);
    return JSON.stringify(n, QL, void 0);
  }
  async getStateHash() {
    const e = this.getCommandContext().getState(), n = Object.values(e?.transaction.layouts || {}).map((s) => s.modificationID ?? "").sort().join(""), a = new TextEncoder().encode(n);
    if (typeof window < "u" && window.crypto && window.crypto.subtle && window.crypto.subtle.digest) {
      const s = await window.crypto.subtle.digest("SHA-256", a);
      return Array.from(new Uint8Array(s)).map((u) => u.toString(16).padStart(2, "0")).join("");
    }
    try {
      return (await import("crypto")).createHash("sha256").update(n, "utf8").digest("hex");
    } catch {
      throw new Error("Unable to compute SHA-256 hash: no suitable crypto implementation available.");
    }
  }
  async outstandingRequestsPromise() {
    return this.workflowStatePromiseQueue.finalize();
  }
  updateMetadata(e, t) {
    this.stepMetadata = {
      ...this.stepMetadata,
      [e]: { ...this.stepMetadata[e], ...t }
    }, this.onMetadataChange();
  }
  removeElements(e) {
    const t = (n, i) => Object.keys(n).reduce((a, s) => {
      const o = [...n[s] || []];
      return i.forEach((l) => {
        const u = o.findIndex((c) => c.id === l.id);
        u > -1 && o.splice(u, 1);
      }), a[s] = o, a;
    }, {});
    this.stepElements = t(this.stepElements, e);
  }
  async getInvalidCanvasRegions() {
    let e = [];
    for (const t of this.experience.getWorkflow()?.steps || [])
      if (!await oo(t, this.stepSelections) && this.stepElements[t.stepName])
        for (const n of this.stepElements[t.stepName])
          e.push(n);
    return e;
  }
  async getInvalidModelVariants() {
    let e = [];
    for (const t of this.experience.getWorkflow()?.steps || [])
      t.type === Je.Model && !await oo(t, this.stepSelections) && e.push(t.stepName);
    return e;
  }
  /**
   * @deprecated This function is only relevant for silent steps that are introduced by a selection. Steps now expose a silent flag that should allow any step to achieve the same behavior without needing special handling. We should remove this function once all silent steps have been migrated to use the new flag and logic.
   */
  async stepElementsForIntroducedSilentSteps(e, t) {
    const n = this.experience.getProduct();
    if (!n)
      return Promise.resolve({ stepElements: {}, commands: [] });
    const i = async (u, c, d) => {
      if (u.type === Je.SilentIllustration) {
        const f = await new mS(u, c).trigger();
        return { step: u, results: f };
      } else if (u.type === Je.ProductOverlay) {
        const f = await new mS(
          u,
          c,
          d
        ).trigger();
        return { step: u, results: f };
      }
      return Promise.reject("Unknown silent step. This is a bug");
    }, a = e.filter(
      (u) => !this.stepInitialised[u.stepName]
    ), s = {
      stepElements: {},
      commands: []
    }, o = [];
    for (const u of a)
      this.markStepsAsInitialised([u.stepName]), t || o.push(i(u, this.layouts, n));
    const l = await Promise.all(o);
    for (const u of l)
      s.stepElements[u.step.stepName] = u.results.map((c) => c.regionElement), s.commands = [...s.commands, ...u.results.map((c) => c.command)];
    return s;
  }
  getStepStorage(e) {
    return this.storage[e];
  }
  getMetadata(e) {
    return this.stepMetadata[e];
  }
  getWorkflowMetadata() {
    return this.stepMetadata;
  }
  getStepTags(e) {
    return this.stepTags[e] || [];
  }
  /**
   * @deprecated Simply run serializedSteps.find((step) => step.stepName === stepName) instead.
   */
  getSerializedStep(e, t) {
    return t.find((n) => n.stepName === e);
  }
  async updateTransactionShareActions() {
    const e = await this.client.getShareActionsForTransaction(this.experience.getTransaction().id);
    this.experience.getTransaction().transactionShareActions = e;
  }
  async updateTransactionStakeholders() {
    const e = await He.getShadowGraphqlClient().query({
      query: OB,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        id: this.experience.getTransaction().id
      }
    });
    !e?.data?.transactions || e.data.transactions.length !== 1 ? (this.experience.getTransaction().currentStakeholder = void 0, this.experience.getTransaction().stakeholders = void 0) : (this.experience.getTransaction().stakeholders = e.data.transactions[0].stakeholders, this.experience.getTransaction().currentStakeholder = e.data.transactions[0].currentStakeholder);
  }
  async approveTransaction(e) {
    await He.getShadowGraphqlClient().mutate({
      mutation: zL,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        id: this.experience.getTransaction().id,
        note: e
      }
    });
  }
  async rejectTransaction(e) {
    await He.getShadowGraphqlClient().mutate({
      mutation: $L,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        id: this.experience.getTransaction().id,
        note: e
      }
    });
  }
  async reset() {
    this.stepElements = {}, this.stepInitialised = {}, this.stepMetadata = {}, this.stepSelections = {}, this.storage = {}, await this.ensureStepsAreLoaded();
  }
  async setSelectionsAndElements(e, t, n, i) {
    const a = this.experience.getWorkflow();
    if (!a) throw new Error("Attempted to set selections when no workflow is set!");
    const s = this.stepSelections;
    this.stepSelections = {
      ...this.stepSelections,
      [e]: { selectedVariants: t }
    }, this.selectionCost = Object.values(this.stepSelections).reduce((R, M) => R + M.selectedVariants.map((j) => j.priceModifier || 0).reduce((j, G) => j + G, 0), 0);
    for (const R of a.steps)
      await oo(R, this.stepSelections) || (this.stepInitialised[R.stepName] = !1, delete this.stepMetadata[R.stepName], delete this.stepSelections[R.stepName], delete this.storage[R.stepName]);
    const o = this.allScenes, l = await Ya(o, s), u = await Ya(o, this.stepSelections), c = l.map((R) => R.silentSteps).flat(), f = u.map((R) => R.silentSteps).flat().filter(
      (R) => !c.some((M) => M.stepName === R.stepName)
    );
    for (const R of c)
      await oo(R, this.stepSelections) || (this.stepInitialised[R.stepName] = !1);
    const h = await this.getInvalidCanvasRegions(), { stepElements: g, commands: v } = await this.stepElementsForIntroducedSilentSteps(f, !1);
    this.stepElements = {
      ...this.stepElements,
      ...g,
      [e]: n
    }, this.removeElements(h);
    const y = a.steps.find((R) => R.stepName === e);
    y?.type === Je.Frame && this.getWorkflowExperience().getStepById(y.stepName)?.frameService?.setTargetElements(n.map((M) => M.id));
    const A = h.map((R) => new cc(R.id)), x = new pS(this.constructSerializableWorkflow()), k = [...v, ...A, x];
    k.length > 0 && this.commandContext.apply(new Nn(k), !0), await this.ensureStepsAreLoaded(), this.onElementsChange();
    const F = await this.getInvalidModelVariants(), S = this.modelContainer;
    if (S) {
      const R = F.map(
        (M) => S.applyModelVariant(
          M,
          {
            contextService: this.getLayoutPreviewService()
          },
          !1
        )
      );
      await Promise.all(R);
    }
    await this.onSelectionChange(), await this.reapplyMaterialSteps(), y?.type !== Je.Frame && y?.type !== Je.Text && this.setMandatoryFulfilled(e, !0), i && await i();
  }
  /**
   * Ensures all steps for active scenes are initialized and loads them in parallel.
   *
   * This method:
   * 1. Identifies active scenes and their renderable steps
   * 2. Initializes uninitialized steps by invoking the appropriate step service based on step type
   * 3. Executes all initialization commands as a batch and processes followup actions
   * 4. Recursively handles any followup conditions that may trigger additional step loading
   * 5. Notifies listeners of initialization changes
   *
   * @throws {Error} If any step initialization fails during the settlement of promises
   * @returns {Promise<void>}
   */
  async ensureStepsAreLoaded() {
    const t = (await Ya(this.allScenes, this.stepSelections)).map((l) => l.renderableSteps), n = [], i = t.flat();
    for (const l of i)
      if (!this.stepInitialised[l.stepName])
        switch (this.stepInitialised[l.stepName] = !0, l.type) {
          case Je.DigitalContent:
            n.push(
              FF.init(
                l,
                this,
                this.reloadedState
              )
            );
            break;
          case Je.Frame:
            n.push(ul.init(l, this, this.reloadedState));
            break;
          case Je.Illustration:
            n.push(
              Lp.init(l, this, this.reloadedState)
            );
            break;
          case Je.Material:
            n.push(
              IF.init(l, this, this.reloadedState)
            );
            break;
          case Je.Model:
            n.push(DF.init(l, this, this.reloadedState));
            break;
          case Je.Module:
            this.stepSpecificServices[l.stepName] = {
              module: await MF(l.data.module)
            }, n.push(
              PF.init(l, this, this.reloadedState)
            );
            break;
          case Je.Picture:
            n.push(
              RF.init(l, this, this.reloadedState)
            );
            break;
          case Je.Question:
            n.push(
              OF.init(l, this, this.reloadedState)
            );
            break;
          case Je.Shape:
            n.push(Bf.init(l, this, this.reloadedState));
            break;
          case Je.Text:
            n.push(pi.init(l, this, this.reloadedState));
            break;
        }
    const a = (await Promise.allSettled(n)).map((l) => {
      if (l.status === "rejected")
        throw new Error(`Step initialization failed: ${l.reason}`);
      return l.value;
    }), s = a.flatMap((l) => l?.command ? [l.command] : []), o = a.flatMap((l) => l?.followup ? [l.followup] : []);
    s && s.length > 0 && this.commandContext.apply(new Nn(s), !0);
    for (const l of o) await l();
    o.length > 0 && await this.ensureStepsAreLoaded(), this.onInitChange();
  }
  onConfirmChange() {
    this.confirmCallbacks.forEach((e) => e(this.confirmedDesign));
  }
  onEditedChange() {
    this.editedCallbacks.forEach((e) => e(this.editedSteps));
  }
  onElementsChange() {
    this.elementsCallbacks.forEach((e) => e(this.stepElements));
  }
  onInformationResultChange() {
    this.informationResultCallbacks.forEach((e) => e(this.informationResults));
  }
  onInitChange() {
    this.initCallbacks.forEach((e) => e(this.stepInitialised));
  }
  onMakingAdjustmentsChange() {
    this.makingAdjustmentsCallback.forEach((e) => {
      e(this.currentAdjustingStepId);
    });
  }
  onMandatoryChange() {
    this.mandatoryCallbacks.forEach((e) => e(this.mandatorySteps));
  }
  onMetadataChange() {
    this.metadataCallbacks.forEach((e) => {
      e(this.stepMetadata);
    });
  }
  async onSelectionChange() {
    const e = await this.traversableScenes();
    for (const t of this.selectionCallbacks)
      t({
        selectionCost: this.selectionCost,
        selections: this.stepSelections,
        traversableScenes: e
      });
  }
  onStepSpecificStorageChange(e) {
    Object.keys(this.stepSpecificStorageCallbacks).includes(e) || (this.stepSpecificStorageCallbacks[e] = []), this.stepSpecificStorageCallbacks[e].forEach((t) => t(this.storage[e]));
  }
  onStorageChange() {
    this.storageCallbacks.forEach((e) => e(this.storage));
  }
  onValidationChange() {
    this.validationCallbacks.forEach((e) => e(this.validationErrors));
  }
  traversableScenes() {
    return vM(this.allScenes, this.stepSelections, this.singleVariantsRenderable);
  }
  async reapplyMaterialSteps() {
    if (!this.modelContainer) return;
    const t = (await Ya(this.allScenes, this.stepSelections)).flatMap((n) => n.renderableSteps).filter((n) => n.type === Je.Material);
    for (const n of t) {
      const i = this.stepSelections[n.stepName]?.selectedVariants;
      if (!i || i.length === 0) continue;
      const s = i[0].material;
      if (!s || !n.option?.id) continue;
      n.data.targetMaterials.forEach((l) => {
        this.modelContainer?.applyMaterialVariant(l, n.option.id, s);
      });
    }
  }
};
Jf.configurationPromiseMap = /* @__PURE__ */ new Map();
let Qy = Jf;
class es {
  constructor(e) {
    this.variantData = e;
  }
  getType() {
    return this.variantData.asset?.type;
  }
  /**
   * @returns The unique identifier for the variant.
   */
  getId() {
    return this.variantData.id;
  }
  /**
   * @returns The configured name of the variant. Generally a human readable value.
   */
  getName() {
    return this.variantData.name;
  }
  /**
   * @returns The price modifier for this variant. This is the amount that will be added to the base price of the product.
   */
  getPriceFormatted(e, t) {
    return this.variantData.priceModifier.toLocaleString(e || "en-US", {
      style: "currency",
      currency: "USD",
      ...t
    });
  }
  /**
   * @returns The price modifier for this variant. This is the amount that will be added to the base price of the product.
   *          Presented in subunits of the currency of the option. For example, if the option is configured to use USD, the price modifier will be in cents.
   */
  getPrice() {
    return this.variantData.priceModifier;
  }
  /**
   * @returns The URL for the base asset resource configured on this variant
   */
  getAsset() {
    return this.variantData.asset?.fileLink;
  }
  /**
   * @returns The URL for the base asset resource configured on this variant
   */
  getAssetResource() {
    return this.variantData.asset;
  }
  /**
   * @returns The URL for a thumbnail resource configured on this variant.
   */
  getThumbnail(e = 256, t) {
    const n = this.variantData.thumbnail;
    if (!(!n || !n.fileLink))
      return $A(n, e, "webp", t);
  }
  /**
   * @returns When this variant is configured to have a color, this will return the hex value for that color.
   */
  getColor() {
    return this.variantData.color;
  }
  /**
   * @returns True when the variant is the default for its containing option. False otherwise.
   */
  isDefault() {
    return !!this.variantData.default;
  }
  /**
   * @returns The underlying variant resource. Generally not needed but made available just in case.
   */
  getResource() {
    return this.variantData;
  }
  /**
   * @returns True when the variant is enabled. False otherwise.
   */
  isEnabled() {
    return this.variantData.enabled;
  }
  /**
   * @returns The category for grouping variants in an option.
   */
  getCategory() {
    return this.variantData.category;
  }
  /**
   * @returns The product associated with this variant.
   */
  getProduct() {
    return this.variantData.product;
  }
}
const Kf = class Kf {
  constructor(e, t, n) {
    this.manager = e, this.step = t, this.tags = n;
  }
  /**
   * Set the current update state of this step. All step handles pointing to this step will
   * see this value.
   * @param value The new value
   */
  setUpdateState(e) {
    Kf.updateState.set(
      `${this.step.stepName}-${this.manager.getWorkflowExperience().getTransaction().id}`,
      e
    );
  }
  /**
   * @returns Gets the current update state of this step. All step handles for this step will see this value.
   */
  getUpdateState() {
    return !!Kf.updateState.get(
      `${this.step.stepName}-${this.manager.getWorkflowExperience().getTransaction().id}`
    );
  }
  /**
   * Gets the currently selected variant, or undefined if no variant is selected.
   */
  getCurrentVariant() {
    const n = this.manager.getWorkflowSelections()[this.step.stepName]?.selections[0];
    if (n)
      return new es(n);
  }
  /**
   * @returns A list of valid variants for this step. Does not include disabled variants.
   */
  async getAvailableVariants() {
    return (await this.getAllVariants()).filter((t) => t.isEnabled()) || [];
  }
  /**
   * @returns A list of all variants for this step, including disabled ones.
   */
  async getAllVariants() {
    if (!this.step.option?.id) return [];
    if (this.step.option.variants)
      return (this.step.option.variants || []).map((t) => new es(t)) || [];
    const e = await ft.getOption(this.step.option?.id);
    if (!e) throw new Error("Option not found, cannot fetch variants.");
    return (e.variants || []).map((t) => new es(t)) || [];
  }
  /**
   * @returns A unique identifier for this step within the workflow.
   */
  getId() {
    return this.step.stepName;
  }
  /**
   * @returns The name of the step
   */
  getName() {
    return this.step.stepTitle;
  }
  /**
   * @returns A message that can accompany the step name in UI components. Used to describe the purpose of the step in more detail.
   */
  getHelpText() {
    return this.step.helpText;
  }
  /**
   * @returns The type of the step handle.
   */
  getType() {
    return this.step.type;
  }
  /**
   * @returns The underlying data for this step. Favor using the step handle methods instead of this.
   */
  getRaw() {
    return this.step;
  }
  /**
   * @returns Returns all of the tags that are present on this step.
   */
  getTags() {
    return this.tags;
  }
  /**
   * @param tag The tag to check for.
   * @returns True if the step has the specified tag, false otherwise.
   */
  hasTag(e) {
    return this.tags.includes(e) || !1;
  }
  /**
   * @returns True if the step is required to be filled by the customer. False otherwise.
   */
  getMandatory() {
    return this.step.mandatory || !1;
  }
  /**
   * @param type The AspectType to fetch the value for.
   * @returns A boolean indicating whether this step should override Global Properties.
   * Only relevant when the Workflow Experience is associated with a Bundle that is using Global Properties,
   * and when this step is associated with one or more Global Property Aspects.
   */
  getOverrideGlobalPropertyConfiguration(e) {
    return (this.manager.getStepStorage(this.step.stepName)?.overrideGlobalConfigurations ?? {})[e.toString()] ?? !1;
  }
  /**
   * Sets whether or not this step should override Global Properties.
   * Only relevant when the Workflow Experience is associated with a Bundle that is using Global Properties,
   * and when this step is associated with one or more Global Property Aspects.
   * @param type The AspectType to override.
   */
  setOverrideGlobalPropertyConfiguration(e, t) {
    const n = this.manager.getStepStorage(this.step.stepName)?.overrideGlobalConfigurations ?? {};
    this.manager.updateStorage(this.step.stepName, {
      overrideGlobalConfigurations: { ...n, [e.toString()]: t }
    });
  }
  /**
   * Retrieves the identifiers of all of the configured aspects for the specified Global Property Configuration.
   * @param configurationId The ID of the Global Property Configuration. You can usually find this with `bundle.getGlobalPropertyConfiguration()?.id`
   * @returns An array of strings matching the keys of all the Global Property Aspects in the Configuration that this step is configured to use.
   */
  getGlobalPropertyAspects(e) {
    return this.step.globalPropertyAspectConfigurations?.filter((t) => t.globalPropertyConfigurationId === e && t.aspectName).map((t) => t.aspectName) ?? [];
  }
  /**
   * Fires any configured animations on the 3D preview for this step.
   * This includes camera & model animations. If the preview is unavailable
   * this function will do nothing.
   */
  executeAnimations(e) {
    const t = this.manager.getPreviewService(), n = this.manager.getModelContainer(), i = this.step.data.modelAnimation, a = this.step.data.lookAtAnimation;
    t ? a && t.executeCameraAnimation(a) : console.warn("No preview service available, cannot execute camera animations."), n ? i && n.executeAnimation(i, e) : console.warn("No model container available, cannot execute model animations.");
  }
};
Kf.updateState = /* @__PURE__ */ new Map();
let ji = Kf;
class ZL extends ji {
  constructor(e, t, n) {
    super(e, t, n);
  }
  /**
   * Allows for select a vector from the available vectors configured on this steps base option.
   * @param variant The new vector variant to use for this step.
   * @returns A promise that can be awaited to know when the new vector asset has been updated on the design.
   */
  async selectVariant(e) {
    if (!this.getUpdateState() && this.getCurrentVariant() !== e)
      return Lp.selectVariant(
        this.step,
        e.getResource(),
        this.manager.getRegionElements(this.step.stepName) || [],
        (t) => this.setUpdateState(t),
        this.manager
      );
  }
  /**
   * Get the colors that are in the illustration.
   * @returns A list of color definitions that are currently applied to the illustration.
   */
  getColors() {
    const e = this.manager.getRegionElements(this.step.stepName) || [];
    if (e.length === 0) return;
    const n = $n(e[0].id, this.manager.getAllLayoutData()).colors, a = this.getCurrentVariant()?.getAssetResource()?.assetConfiguration, s = a?.defaultColorVariants || [];
    if (s.length !== 0) {
      const o = {};
      return s.forEach((l) => {
        const u = a.channelNumbers.find((c) => c.number === l.channelNumber);
        if (u) {
          const c = u.id.replace(/\W/g, "");
          o[l.channelNumber] = { browserValue: n[c]?.browserValue || "" };
        }
      }), o;
    }
    try {
      return n;
    } catch (o) {
      console.error(o);
    }
  }
  /**
   * Set color for the illustration.
   */
  setColor(e, t, n) {
    const i = /* @__PURE__ */ new Map(), s = this.getCurrentVariant()?.getAssetResource()?.assetConfiguration;
    return (s?.defaultColorVariants || []).length !== 0 ? s.channelNumbers.forEach((l) => {
      if (l.number.toString() === e) {
        const u = l.id.replace(/\W/g, "");
        n ? i.set(u, { browserValue: t, pmsValue: n }) : i.set(u, t);
      }
    }) : n ? i.set(e, { browserValue: t, pmsValue: n }) : i.set(e, t), Lp.changeColors(
      this.step,
      this.manager.getRegionElements(this.step.stepName),
      this.manager,
      i
    );
  }
  async getColorOption() {
    return await ft.ensureFullOption(this.step.data.colorOption);
  }
  getAvailableColors() {
    return this.step.data.colorPickerEnabled ? Lp.availableColors(this.step, this.manager) : Promise.resolve([]);
  }
  isColorPickerEnabled() {
    return this.step.data.colorPickerEnabled ?? !1;
  }
  isPMSPickerEnabled() {
    return this.step.data.pmsPickerEnabled ?? !1;
  }
  isVariantSearchEnabled() {
    return this.step.data.enableVariantSearch ?? !1;
  }
  isVariantCategoriesEnabled() {
    return this.step.data.enableVariantCategories ?? !1;
  }
}
class eU extends ji {
  constructor(e, t, n) {
    super(e, t, n);
  }
  selectVariant(e) {
    return IF.selectVariant(
      this.step,
      e.getResource(),
      this.manager,
      (t) => this.setUpdateState(t)
    );
  }
  isVariantCategoriesEnabled() {
    return this.step.data.enableVariantCategories ?? !1;
  }
}
class tU extends ji {
  constructor(e, t, n) {
    super(e, t, n);
  }
  selectVariant(e) {
    return DF.selectVariant(
      this.step,
      e.getResource(),
      this.manager,
      (t) => this.setUpdateState(t)
    );
  }
  isVariantCategoriesEnabled() {
    return this.step.data.enableVariantCategories ?? !1;
  }
}
class rU extends ji {
  constructor(e, t, n) {
    super(e, t, n);
  }
  /**
   * Allows the user to select an image variant from the available variants configured on this steps base option.
   * @param variant The new image variant to use.
   * @returns A promise that can be awaited to ensure the new image asset has been updated on the design.
   */
  selectVariant(e) {
    return RF.selectVariant(
      this.step,
      e.getResource(),
      this.manager,
      (t) => this.setUpdateState(t)
    );
  }
  isVariantSearchEnabled() {
    return this.step.data.enableVariantSearch ?? !1;
  }
  isVariantCategoriesEnabled() {
    return this.step.data.enableVariantCategories ?? !1;
  }
}
class nU extends ji {
  constructor(e, t, n) {
    super(e, t, n);
  }
  async selectVariant(e) {
    if (!e.getId())
      throw new Error("Unable to select variant with a null ID");
    await OF.selectVariant(this.step, e.getId(), this.manager);
  }
  /**
   * The way that this step expects to be rendered.
   */
  async getDisplayType() {
    return this.step.data.displayType ? this.step.data.displayType : (await ft.getOptionForStep(this.step))?.displayType;
  }
}
class iU extends ji {
  constructor(e, t, n) {
    super(e, t, n);
  }
  selectVariant(e) {
    const t = e.getResource();
    return Bf.selectVariant(
      this.step,
      {
        fill: t.color,
        stroke: t.color,
        variant: t
      },
      this.manager.getRegionElements(this.step.stepName) || [],
      this.manager
    );
  }
  /**
   * Sets the color of the shape.
   * @param color The color option to use.
   * @returns A promise resolving when the color has changed in the design.
   * @deprecated The shape step can now pass through colors returned by getColors via selectVariant. Please swap setColor for selectVariant.
   */
  setColor(e) {
    return Bf.selectVariant(
      this.step,
      e,
      this.manager.getRegionElements(this.step.stepName) || [],
      this.manager
    );
  }
  /**
   * Get available colors for the shape.
   * @returns A list of color definitions that are currently applied to the illustration.
   */
  getColors() {
    return Bf.availableColours(this.step);
  }
  /**
   * Allows for setting a custom color when the custom variant is selected. Will
   * throw when a non-custom variant is selected.
   */
  setCustomColor(e) {
    return this.getCurrentVariant()?.getColor() !== "#custom" && console.warn(
      `setting custom color for step ${this.step.stepName} but color is ${this.getCurrentVariant()?.getColor()}`
    ), Bf.setCustomColor(e, this.step, this.manager);
  }
  getCustomColor() {
    this.getCurrentVariant()?.getColor() !== "#custom" && console.warn(
      `setting custom color for step ${this.step.stepName} but color is ${this.getCurrentVariant()?.getColor()}`
    );
    const e = this.manager.getStepStorage(this.step.stepName)?.colour;
    if (!e)
      throw new Error(
        `Color not available on step ${this.step.stepName}. Set a default on the workflow to fix this.`
      );
    return e;
  }
  isVariantCategoriesEnabled() {
    return this.step.data.enableVariantCategories ?? !1;
  }
}
class aU extends ji {
  constructor(e, t, n) {
    super(e, t, n);
  }
  /**
   * Allows for select a font from the available fonts configured on this steps base option.
   * @param variant The font variant to use.
   */
  async selectVariant(e) {
    await pi.selectVariant(
      this.step,
      e.getResource(),
      this.manager,
      (t) => {
        if (t)
          this.manager.setInformationResults([
            ...this.manager.getInformationResults(),
            {
              message: t,
              messageType: Lg.Error,
              stepID: this.step.stepName
            }
          ]);
        else {
          const n = this.manager.getInformationResults().filter((i) => i.stepID !== this.step.stepName);
          this.manager.setInformationResults(n);
        }
      },
      () => {
      }
    );
  }
  /**
   * @returns A list of colors that can be used to fill the text.
   */
  async getAvailableFillColors() {
    return this.step.data.colorPickerEnabled ? pi.availableFillColors(this.step) : [];
  }
  /**
   * Changes the fill of text related to this step to the new fill value.
   * @param fill A new fill value to use.
   */
  async setFillColor(e) {
    const t = this.manager.getRegionElements(this.step.stepName);
    await pi.changeFillColor(this.step, e, t, this.manager);
  }
  /**
   * Gets the color currently applied to the element.
   */
  getFillColor() {
    return this.manager.getStepStorage(this.step.stepName)?.color || "#000000";
  }
  getAvailableFillImages() {
    return pi.availableFillImages(this.step);
  }
  async setFillImage(e) {
    const t = this.manager.getRegionElements(this.step.stepName);
    await pi.changeFillImage(this.step, e, t, this.manager);
  }
  getFillImage() {
    return this.manager.getStepStorage(this.step.stepName)?.fillImage;
  }
  getAlignment() {
    return pi.findLayoutElements(this.manager, this.step)?.[0].align;
  }
  setAlignment(e) {
    const t = this.manager.getRegionElements(this.step.stepName);
    pi.changeAlignment(this.step, e, t, this.manager);
  }
  /**
   * When true & the step has replaceable text configured the user will be
   * abled to edit the entire text string including the non-replaceable text.
   * @param shouldCustomizeAll When true the user can configure the entire text string.
   */
  setFullTextCustomization(e) {
    const t = this.manager.getStepStorage(this.step.stepName)?.inputText || "", n = this.step.data.replaceableText !== void 0 ? this.step.data.replaceableText.replace("{{}}", t) : t, i = e ? n : this.step.data.defaultText;
    return this.manager.updateStorage(this.step.stepName, {
      customiseAllText: e,
      text: i,
      defaultCleared: !1
    }), this.setText(i);
  }
  /**
   * Changes the text value of text related to this step to a new value.
   * @param userInput Input from the user.
   */
  setText(e) {
    const t = {
      input: e,
      helperData: {}
    }, n = pi.findLayoutElements(this.manager, this.step), i = pi.filterUnsupportedCharacters(e, n[0]?.fontData), a = _u(i, this.manager).length, s = !!this.step.data && !!this.step.data.maxLength && a > this.step.data.maxLength;
    s || (t.input = i);
    const o = n.length <= 0, l = o ? { inputText: i, text: i } : { inputText: i };
    this.manager.updateStorage(this.step.stepName, l);
    const u = this.manager.getStepStorage(this.step.stepName), c = pi.getProcessedInput(
      i,
      this.step.data,
      u?.customiseAllText ?? !1
    );
    if (o)
      s || this.manager.updateMetadata(this.step.stepName, {
        text: c
      });
    else {
      const { command: d, errorData: f, helperData: h } = pi.updateInputText(
        i,
        n,
        this.step,
        this.manager
      );
      d && this.manager.getCommandDispatcher()(d), t.helperData = h, t.errorData = f, !s && !f && this.manager.updateMetadata(this.step.stepName, {
        text: c
      });
    }
    return t;
  }
  /**
   * Gets the text currently applied to the elements of this step.
   */
  getText() {
    const e = this.step.data.defaultText, t = this.manager.getStepStorage(this.step.stepName);
    return e && t?.defaultCleared !== void 0 && !t?.defaultCleared ? e : this.manager.getStepStorage(this.step.stepName)?.text || "";
  }
  isReplaceable() {
    return this.step.data.userCanReplaceText;
  }
  /**
   * @returns True if the step allows new lines in the text input.
   */
  newLinesSupported() {
    return this.step.data.allowNewlines || !1;
  }
  /**
   * Inform the step that now is the time to
   * clear default text if it should do so.
   * Returns a text change rwsult if a clear occurred.
   */
  clearDefaultTextIfNecessary() {
    if (!this.manager.getStepStorage(this.step.stepName)?.defaultCleared && this.step.data.deleteDefaultOnFocus) {
      const t = this.setText("");
      this.manager.updateStorage(this.step.stepName, { defaultCleared: !0, inputText: "" });
      const n = pi.findLayoutElements(this.manager, this.step);
      return pi.updateInputText("", n, this.step, this.manager), t;
    }
  }
  hasColorPicker() {
    return this.step.data.colorPickerEnabled;
  }
  getRegions() {
    return this.step.data.regions;
  }
  /**
   * Return the maximum characters allowed for
   * this step, or undefined if there is no limit.
   */
  getCharacterLimit() {
    return this.step.data.maxLength;
  }
  /**
   * Return the remaining amount of characters that
   * the user is allowed to add, or undefined if there is no limit.
   */
  getCharactersRemaining() {
    const e = this.step.data.maxLength;
    if (e === void 0)
      return;
    const t = _u(this.getText(), this.manager);
    return e - t.length;
  }
  setCustomColor(e) {
    throw new Error("Custom color support is not yet available on text. Check back soon.");
  }
  getCustomColor() {
    throw new Error("Custom color support is not yet available on text. Check back soon.");
  }
  /**
   * @returns A list of colors that can be used for the text's outline.
   */
  async getAvailableStrokeColors() {
    return this.step.data.strokeEnabled ? pi.availableStrokeColors(this.step) : [];
  }
  getStrokeColor() {
    return this.manager.getStepStorage(this.step.stepName)?.strokeColor?.browserValue || "#000000";
  }
  /**
   * Changes the stroke of text related to this step to the new stroke value.
   * @param stroke A new stroke value to use.
   */
  async setStrokeColor(e) {
    const t = this.manager.getRegionElements(this.step.stepName);
    await pi.changeStrokeColor(this.step, e, t, this.manager);
  }
  isVariantCategoriesEnabled() {
    return this.step.data.enableVariantCategories ?? !1;
  }
}
class sU extends ji {
  constructor(e, t, n) {
    super(e, t, n);
  }
  async selectVariant() {
  }
  /**
   * The way that this step expects to be rendered.
   */
  getContent() {
    return this.step.data.content;
  }
}
class oU extends ji {
  constructor(e, t, n) {
    super(e, t, n);
  }
  async selectVariant() {
  }
  /**
   * Returns a preview URL used to show the generated QR code in your UI.
   */
  getPreviewURL() {
    return this.manager.getStepStorage(this.step.stepName)?.videoUrl || "";
  }
  /**
   * Turns an asset into a QR code that can be used to access the content.
   * @param asset The asset to use for the QR code.
   * @returns The final URL string for the QR code.
   */
  async selectVideo(e) {
    return FF.regenerateQRCode(
      this.manager.getRegionElements(this.step.stepName),
      e.key,
      this.manager,
      this.step
    );
  }
}
class lU extends ji {
  constructor(e, t, n) {
    super(e, t, n);
  }
  async selectVariant() {
    console.info("Text Modules don't support variants.");
  }
  /**
   * Return the remaining amount of characters that
   * the user is allowed to add, or undefined if there is no limit.
   */
  getCharactersRemaining() {
    const e = this.step.data.maxLength;
    if (e === void 0)
      return;
    const t = _u(this.getText(), this.manager);
    return e - t.length;
  }
  /**
   * Return the maximum characters allowed for
   * this step, or undefined if there is no limit.
   */
  getCharacterLimit() {
    return this.step.data.maxLength;
  }
  getText() {
    return this.manager.getStepStorage(this.step.stepName)?.text || "";
  }
  setText(e) {
    PF.changeText(this.step, e, this.manager, (t) => {
      if (t) {
        const n = [
          ...this.manager.getInformationResults(),
          {
            message: t,
            messageType: Lg.Error,
            stepID: this.step.stepName
          }
        ];
        this.manager.setInformationResults(n);
      } else {
        const n = this.manager.getInformationResults().filter((i) => i.stepID !== this.step.stepName);
        this.manager.setInformationResults(n);
      }
    });
  }
}
class uU extends ji {
  constructor(e, t, n) {
    super(e, t, n);
  }
  async selectVariant() {
  }
  async getAvailableVariants() {
    const e = await super.getAvailableVariants();
    if (!this.cachedProductIds) {
      this.cachedProductIds = /* @__PURE__ */ new Set();
      for (const t of e) {
        const n = t.getProduct();
        n?.id && this.cachedProductIds.add(n.id);
      }
    }
    return e;
  }
  /**
   * Whether a product's variant has an associated workflow (is personalisable).
   */
  isPersonalisable(e) {
    const t = e.getProduct();
    return !!t?.workflows && t.workflows.length > 0;
  }
  async addProduct(e) {
    const t = this.manager.getWorkflowExperience().getBundle();
    if (!t)
      throw new Error("Product step requires bundle context");
    const n = e.getProduct();
    if (!n)
      throw new Error("Variant has no product. Ensure the option query includes the product field on variants.");
    if (!this.isPersonalisable(e)) {
      await this.incrementNonPersonalisable(e);
      return;
    }
    const i = this.manager.getWorkflowExperience().getTransaction(), a = i.integrationProduct?.integration?.id;
    let s;
    if (a && n.integrationProducts && (s = n.integrationProducts.find(
      (f) => f.integration?.id === a
    )?.id), !s)
      throw new Error("No integration product found for bundle context");
    const o = this.manager.getClient(), l = n?.workflows || [];
    let u;
    if (l.length === 1)
      u = l[0].id;
    else if (l.length > 1) {
      const d = this.step.data.workflows, f = l.find((h) => d.includes(h.id));
      if (f)
        u = f.id;
      else
        throw new Error("Multiple workflows available but none match step configuration");
    }
    const c = await o.getWorkflowExperience({
      type: "integration",
      integrationProductId: s,
      workflowId: u,
      parentTransactionId: i.id
    });
    await t.addWorkflowExperience(c);
  }
  /**
   * For non-personalisable products: if a transaction already exists for this product,
   * increment its quantity. Otherwise create a new transaction with quantity 1.
   */
  async incrementNonPersonalisable(e) {
    const t = this.manager.getWorkflowExperience().getBundle();
    if (!t) return;
    const n = e.getProduct(), i = this.findExperienceForProduct(n.id);
    if (i) {
      const c = i.getTransaction().quantity || 1;
      await i.setQuantity(c + 1);
      return;
    }
    const a = this.manager.getWorkflowExperience().getTransaction(), s = a.integrationProduct?.integration?.id;
    let o;
    if (s && n.integrationProducts && (o = n.integrationProducts.find(
      (d) => d.integration?.id === s
    )?.id), !o)
      throw new Error("No integration product found for bundle context");
    const u = await this.manager.getClient().getWorkflowExperience({
      type: "integration",
      integrationProductId: o,
      parentTransactionId: a.id
    });
    await t.addWorkflowExperience(u);
  }
  async removeProduct(e) {
    const t = this.manager.getWorkflowExperience().getBundle();
    if (!t)
      throw new Error("Product step requires bundle context");
    const i = t.getWorkflowExperiences().find((o) => o.getTransaction().id === e);
    if (!i)
      throw new Error("Transaction is not a child of this product step");
    const a = i.getTransaction(), s = a.quantity || 1;
    if (s > 1) {
      await i.setQuantity(s - 1);
      return;
    }
    await t.removeWorkflowExperienceByTransaction(a);
  }
  /**
   * Whether category filtering is enabled.
   */
  isCategoryFilterEnabled() {
    return this.step.data.categoryFilterEnabled ?? !1;
  }
  /**
   * Whether search bar is enabled.
   */
  isSearchBarEnabled() {
    return this.step.data.searchBarEnabled ?? !1;
  }
  /**
   * Get minimum number of products required.
   */
  getMin() {
    return this.step.data.min;
  }
  /**
   * Get maximum number of products allowed.
   */
  getMax() {
    return this.step.data.max;
  }
  /**
   * Get pricing configuration.
   */
  getPricing() {
    return this.step.data.pricing;
  }
  /**
   * Get associated workflow IDs.
   */
  getWorkflows() {
    return this.step.data.workflows || [];
  }
  /**
   * Get child transactions that belong to this step specifically.
   * Filters by parent transaction AND by products available in this step's option.
   */
  getChildTransactions() {
    const e = this.manager.getWorkflowExperience().getBundle();
    if (!e)
      return [];
    const t = this.manager.getWorkflowExperience().getTransaction().id, n = e.getWorkflowExperiences(), i = this.getStepProductIds();
    return n.map((a) => a.getTransaction()).filter((a) => a.parentTransaction?.id !== t || i.size === 0 ? !1 : a.product?.id ? i.has(a.product.id) : !1);
  }
  /**
   * Get the set of product IDs that belong to this step's option.
   * Uses cached data from getAvailableVariants() which has full product info.
   */
  getStepProductIds() {
    if (this.cachedProductIds && this.cachedProductIds.size > 0)
      return this.cachedProductIds;
    const e = this.step.option?.variants || [], t = /* @__PURE__ */ new Set();
    for (const n of e)
      n.product?.id && t.add(n.product.id);
    return t;
  }
  /**
   * Get locked add-ons configured on this product step.
   */
  getLockedAddOns() {
    return this.step.data.lockedAddOns || [];
  }
  /**
   * Find an existing WorkflowExperience for a given product ID within this step's children.
   */
  findExperienceForProduct(e) {
    const t = this.manager.getWorkflowExperience().getBundle();
    if (!t) return;
    const n = this.manager.getWorkflowExperience().getTransaction().id, i = this.getStepProductIds();
    return t.getWorkflowExperiences().find((a) => {
      const s = a.getTransaction();
      return s.parentTransaction?.id !== n || i.size > 0 && !i.has(e) ? !1 : s.product?.id === e;
    });
  }
}
class hp {
  static get(e, t) {
    switch (t.type) {
      case Je.DigitalContent:
        return new oU(
          e,
          t,
          e.getStepTags(t.stepName)
        );
      case Je.Information:
        return new sU(
          e,
          t,
          e.getStepTags(t.stepName)
        );
      case Je.Question:
        return new nU(
          e,
          t,
          e.getStepTags(t.stepName)
        );
      case Je.Text:
        return new aU(e, t, e.getStepTags(t.stepName));
      case Je.Illustration:
        return new ZL(
          e,
          t,
          e.getStepTags(t.stepName)
        );
      case Je.Picture:
        return new rU(
          e,
          t,
          e.getStepTags(t.stepName)
        );
      case Je.Shape:
        return new iU(e, t, e.getStepTags(t.stepName));
      case Je.Material:
        return new eU(
          e,
          t,
          e.getStepTags(t.stepName)
        );
      case Je.Model:
        return new tU(e, t, e.getStepTags(t.stepName));
      case Je.Frame:
        return new BW(e, t, e.getStepTags(t.stepName));
      case Je.Module:
        return new lU(e, t, e.getStepTags(t.stepName));
      case Je.Product:
        return new uU(
          e,
          t,
          e.getStepTags(t.stepName)
        );
      default:
        throw new un(`Step type ${t.type} not yet supported in Core SDK`);
    }
  }
}
var mv, aE;
function cU() {
  if (aE) return mv;
  aE = 1;
  var r = 1 / 0, e = 9007199254740991, t = 17976931348623157e292, n = NaN, i = "[object Function]", a = "[object GeneratorFunction]", s = "[object Symbol]", o = /^\s+|\s+$/g, l = /^[-+]0x[0-9a-f]+$/i, u = /^0b[01]+$/i, c = /^0o[0-7]+$/i, d = /^(?:0|[1-9]\d*)$/, f = parseInt, h = Object.prototype, g = h.toString, v = Math.ceil, y = Math.max;
  function A(oe, he, ye) {
    var Ue = -1, Re = oe.length;
    he < 0 && (he = -he > Re ? 0 : Re + he), ye = ye > Re ? Re : ye, ye < 0 && (ye += Re), Re = he > ye ? 0 : ye - he >>> 0, he >>>= 0;
    for (var Oe = Array(Re); ++Ue < Re; )
      Oe[Ue] = oe[Ue + he];
    return Oe;
  }
  function x(oe, he) {
    return he = he ?? e, !!he && (typeof oe == "number" || d.test(oe)) && oe > -1 && oe % 1 == 0 && oe < he;
  }
  function k(oe, he, ye) {
    if (!G(ye))
      return !1;
    var Ue = typeof he;
    return (Ue == "number" ? R(ye) && x(he, ye.length) : Ue == "string" && he in ye) ? S(ye[he], oe) : !1;
  }
  function F(oe, he, ye) {
    (ye ? k(oe, he, ye) : he === void 0) ? he = 1 : he = y(J(he), 0);
    var Ue = oe ? oe.length : 0;
    if (!Ue || he < 1)
      return [];
    for (var Re = 0, Oe = 0, ee = Array(v(Ue / he)); Re < Ue; )
      ee[Oe++] = A(oe, Re, Re += he);
    return ee;
  }
  function S(oe, he) {
    return oe === he || oe !== oe && he !== he;
  }
  function R(oe) {
    return oe != null && j(oe.length) && !M(oe);
  }
  function M(oe) {
    var he = G(oe) ? g.call(oe) : "";
    return he == i || he == a;
  }
  function j(oe) {
    return typeof oe == "number" && oe > -1 && oe % 1 == 0 && oe <= e;
  }
  function G(oe) {
    var he = typeof oe;
    return !!oe && (he == "object" || he == "function");
  }
  function ie(oe) {
    return !!oe && typeof oe == "object";
  }
  function q(oe) {
    return typeof oe == "symbol" || ie(oe) && g.call(oe) == s;
  }
  function Y(oe) {
    if (!oe)
      return oe === 0 ? oe : 0;
    if (oe = se(oe), oe === r || oe === -r) {
      var he = oe < 0 ? -1 : 1;
      return he * t;
    }
    return oe === oe ? oe : 0;
  }
  function J(oe) {
    var he = Y(oe), ye = he % 1;
    return he === he ? ye ? he - ye : he : 0;
  }
  function se(oe) {
    if (typeof oe == "number")
      return oe;
    if (q(oe))
      return n;
    if (G(oe)) {
      var he = typeof oe.valueOf == "function" ? oe.valueOf() : oe;
      oe = G(he) ? he + "" : he;
    }
    if (typeof oe != "string")
      return oe === 0 ? oe : +oe;
    oe = oe.replace(o, "");
    var ye = u.test(oe);
    return ye || c.test(oe) ? f(oe.slice(2), ye ? 2 : 8) : l.test(oe) ? n : +oe;
  }
  return mv = F, mv;
}
var fU = cU();
const Yy = /* @__PURE__ */ Bs(fU), dU = Ee`
    fragment CreateDesignTransaction on Transaction {
        id
        designName
        externalCartProductId
        externalCartProductVariantId
        externalDesignProductId
        externalDesignProductVariantId
        lastSyncedAt
        quantity
        previewImageLink
        priceModifierTotal
        workflowViewerLink
        workflowViewerReadOnlyLink
        integrationProduct {
            id
            additionalExternalProductId
            additionalExternalVariantId
        }
        designExternalVariants {
            id
            externalProductId
            externalProductVariantId
        }
    }
`, hU = Ee`
    ${dU}
    mutation CreateDesigns($inputs: [DesignCreateInput]!) {
        designCreateMany(inputs: $inputs) {
            id
            sku
            transaction {
                ...CreateDesignTransaction
            }
            processExecution {
                id
            }
        }
    }
`;
function dg(r) {
  const e = JSON.parse(atob(r.split(".")[1])).exp;
  return Math.floor((/* @__PURE__ */ new Date()).getTime() / 1e3) >= e;
}
const pU = async (r, e) => {
  const t = {};
  try {
    if (e) {
      const i = await e.loggedInBearerToken();
      t.Authorization = `Bearer ${i}`;
    } else
      throw new Error();
  } catch {
    const s = Object.entries(localStorage).find(([l, u]) => l.startsWith("CognitoIdentityServiceProvider") && l.endsWith("idToken"))?.[0] || "", o = localStorage.getItem(s);
    o && !dg(o) && (t.Authorization = `Bearer ${o}`);
  }
  return await e.getBetaEnabled() && (t["X-Spiff-Beta"] = "true"), (await He.getShadowGraphqlClient().mutate({
    mutation: hU,
    errorPolicy: "all",
    fetchPolicy: "no-cache",
    variables: {
      inputs: r.map((i) => ({
        name: i.name,
        layouts: i.layouts,
        workflowId: i.workflowId,
        transactionId: i.transactionId,
        previewImage: i.previewImage,
        useThreeDimPreview: i.useThreeDimPreview,
        metadata: i.metadata,
        selectedVariants: i.selectedVariants
      }))
    },
    context: {
      headers: t
    }
  })).data?.designCreateMany;
}, sE = (r, e, t) => {
  const n = (a) => {
    const s = {};
    if (a.type === "Frame") {
      const o = r[a.stepName], l = a.data;
      if (!o || !o.image || l.hideImageInCart && t)
        return s;
      s[`${a.stepTitle} image`] = o.image;
    }
    if (a.type === "Illustration") {
      const o = r[a.stepName], l = a.data;
      if (!o || l.hideColorsInCart && t || !o.colors)
        return s;
      if (o.colors.length > 0) {
        const u = o.colors.join(", ").toUpperCase();
        s[`${a.stepTitle} colors`] = u;
      }
    }
    if (a.type === "Module") {
      const o = r[a.stepName], l = a.data;
      if (!o || o.text === void 0 || o.text === null || l.hideTextInCart && t)
        return s;
      s[`${a.stepTitle} text`] = o.text;
    }
    if (a.type === "Text") {
      const o = r[a.stepName];
      if (!o)
        return s;
      const l = a.data;
      (!l.hideTextInCart || !t && o.text !== void 0 && o.text !== null) && (s[`${a.stepTitle} text`] = o.text), o.color && (!l.hideColorInCart || !t) && (s[`${a.stepTitle} color`] = o.color), o.strokeColor && (!l.hideStrokeInCart || !t) && (s[`${a.stepTitle} stroke`] = o.strokeColor);
    }
    return s;
  }, i = {};
  return e.steps.forEach((a) => {
    Object.assign(i, n(a));
  }), i;
}, gU = (r, e, t, n) => {
  const i = {};
  let a = {};
  n && (a = n);
  const o = e.steps.map((l) => l.stepTitle).filter((l, u, c) => c.indexOf(l) == u);
  for (const l of o) {
    if (Object.keys(r).includes(l)) {
      const u = r[l], c = e.steps.find((d) => d.stepTitle === l);
      i[`${c?.stepTitle} selection`] = {
        value: u[0].name,
        priceModifier: u[0].priceModifier
      };
    }
    for (const u of Object.keys(a))
      [`${l} color`, `${l} colors`, `${l} text`, `${l} image`].includes(u) && (i[u] = {
        value: a[u],
        priceModifier: 0
      });
  }
  return i;
}, mU = (r, e, t, n, i, a, s, o) => {
  const l = e.basePrice || 0, u = r.priceModifierTotal || 0, c = gU(n, t, void 0, a), f = (Cr.getMap("transactionOwnerIds") || /* @__PURE__ */ new Map()).get(r.id), h = {
    additionalExternalProductId: r.integrationProduct?.additionalExternalProductId,
    additionalExternalVariantId: r.integrationProduct?.additionalExternalVariantId,
    baseCost: l,
    designExternalVariants: r.designExternalVariants,
    designProductId: r.externalDesignProductId,
    designProductVariantId: r.externalDesignProductVariantId,
    event: "onComplete",
    exportedData: c,
    externalCartProductId: r.externalCartProductId,
    externalCartProductVariantId: r.externalCartProductVariantId,
    lineItemImageUrl: s || "",
    optionsCost: u,
    processExecutionId: o,
    quantity: r.quantity,
    transactionId: r.id,
    transactionOwnerId: f,
    weight: e.weight,
    workflowViewerLink: r.workflowViewerLink || "",
    workflowViewerReadOnlyLink: r.workflowViewerReadOnlyLink || ""
  };
  return a && (h.metadata = a), n && (h.selectedVariants = n), i && (h.sku = i), h;
}, vU = (r) => {
  const e = r.integrationProductId || r.integrationProduct?.id, t = r.integrationProduct;
  if (t?.externalProductId && t?.externalVariantId)
    return t;
  if (e && r.product?.integrationProducts) {
    const n = r.product.integrationProducts.find((i) => i.id === e);
    if (n)
      return { ...t, ...n };
  }
  return t;
}, LF = (r) => {
  const e = vU(r);
  return {
    id: r.id,
    externalProductId: r.externalCartProductId || r.externalDesignProductId || e?.externalProductId || e?.additionalExternalProductId,
    externalProductVariantId: r.externalCartProductVariantId || r.externalDesignProductVariantId || e?.externalVariantId || e?.additionalExternalVariantId
  };
}, yU = async (r) => {
  const e = [
    ...new Set(
      r.filter((i) => {
        const a = LF(i);
        return !a.externalProductId || !a.externalProductVariantId;
      }).map((i) => i.integrationProductId || i.integrationProduct?.id).filter((i) => !!i)
    )
  ];
  if (e.length === 0)
    return;
  const t = await HI(e), n = new Map(t.map((i) => [i.id, i]));
  for (const i of r) {
    const a = i.integrationProductId || i.integrationProduct?.id;
    if (!a)
      continue;
    const s = n.get(a);
    s && (i.integrationProduct = { ...i.integrationProduct, ...s }, s.product && (i.product = { ...i.product, ...s.product }));
  }
}, AU = (r, e) => {
  for (const t of e) {
    const n = t.parentTransaction?.id;
    if (!n)
      continue;
    const i = r.get(n);
    if (!i)
      throw new Error(
        `SpiffCommerce - Unable to attach product-step extra to parent - parent message not found: ${n}`
      );
    const a = t.quantity || 1, s = LF(t);
    if (!s.externalProductId || !s.externalProductVariantId)
      throw new Error(
        `SpiffCommerce - Product-step extra is missing external product identifiers (transaction: ${t.id})`
      );
    const o = i.designExternalVariants || [];
    i.designExternalVariants = [
      ...o,
      ...Array.from({ length: a }, () => ({ ...s }))
    ];
  }
}, bU = async (r, e, t, n, i, a, s, o, l, u) => {
  u && (console.warn("State mismatch detected. Uploading known state explicitly"), console.warn("State Object:", JSON.stringify(n())), await r.updateStateWithServerImmediate(n), console.log("Server state is undefined @ Workflow completion"));
  const c = r.getPreviewService(), d = e?.finalizeStepConfig?.lookAtAnimation, f = c && e.showModelOnFinishStep && !!d, h = l && sE(l, e, !0), g = l && sE(l, e, !1), v = async (R) => {
    const M = {};
    let j = 0;
    if (Object.keys(a).length > 0)
      for (const G of Object.keys(a)) {
        const ie = a[G], q = e.steps.find((Y) => Y.stepName === G);
        for (let Y = 0; Y < ie.selections.length; ++Y) {
          const J = ie.selections[Y];
          if (q) {
            const se = await ft.getOptionForStep(q);
            if (!R || se && (se.variants || []).length > 1 && !q.data.hideSelectionInCart && !q.data.hideSelectionsInCart) {
              const oe = q.stepTitle;
              M[oe] ? M[oe].push({
                id: J.id || "",
                name: J.name,
                priceModifier: J.priceModifier
              }) : M[oe] = [
                {
                  id: J.id || "",
                  name: J.name,
                  priceModifier: J.priceModifier
                }
              ];
            }
          }
          j += J.priceModifier;
        }
      }
    return [M, j];
  }, [y] = await v(!0), A = Object.fromEntries(
    Object.keys(y).map((R) => [R, y[R].map((M) => M.id)])
  ), [x] = await v(!1), k = Object.fromEntries(
    Object.keys(x).map((R) => [
      R,
      x[R].map((M) => M.id)
    ])
  );
  let F = await o(f, i.id);
  if (F) {
    const R = await (await Ms(F)).blob();
    F = (await zn.uploadAsset(
      { name: `${i.id}-preview-image.png`, blob: R },
      Yp.Image,
      !0,
      !1
    )).fileLink;
  }
  return {
    designDetails: (() => {
      const R = {
        name: s,
        layouts: t.map((M) => ({
          index: M.index,
          panelId: M.panelId
        })),
        workflowId: e.id,
        transactionId: i.id,
        useThreeDimPreview: !!f,
        previewImage: F
      };
      if (g) {
        const M = [];
        for (const [j, G] of Object.entries(g))
          M.push({ key: j, value: G });
        R.metadata = M;
      }
      if (A) {
        const M = [];
        for (const [j, G] of Object.entries(k))
          M.push({ key: j, ids: G });
        R.selectedVariants = M;
      }
      return R;
    })(),
    cartSelectionsWithPrices: y,
    cartMetadata: h
  };
}, UF = async (r, e) => {
  await Promise.all(
    r.map(async (o) => {
      await o.workflowManager.outstandingRequestsPromise();
    })
  );
  const n = await (async () => {
    const o = He.getShadowGraphqlClient(), l = await Promise.all(
      r.map(async (f) => ({
        id: f.transaction.id,
        hash: await f.workflowManager.getStateHash()
      }))
    ), c = Yy(l, 100), d = [];
    for (const f of c) {
      const h = await o.query({
        query: DB,
        variables: {
          transactions: f
        },
        fetchPolicy: "no-cache",
        errorPolicy: "all"
      });
      if (h.errors && h.errors.length > 0)
        return l.map((g) => g.id);
      d.push(...h.data?.transactionConfirmWorkflowStates ?? []);
    }
    return d;
  })(), i = await Promise.all(
    r.map(async (o) => await bU(
      o.workflowManager,
      o.workflow,
      o.layouts,
      o.getReducerState,
      o.transaction,
      o.workflowSelections,
      o.designName,
      e ?? (() => Promise.resolve(void 0)),
      o.workflowMetadata,
      n.includes(o.transaction.id)
    ))
  ), a = r[0].workflowManager.getClient(), s = await pU(
    i.map((o) => o.designDetails),
    a
  );
  if (!s)
    throw new Error("Failed to create designs");
  return s.map((o, l) => {
    const u = r[l], c = i[l], d = o.transaction;
    return mU(
      d,
      u.product,
      u.workflow,
      c.cartSelectionsWithPrices,
      o.sku,
      c.cartMetadata,
      d.previewImageLink,
      o.processExecution?.id
    );
  });
};
class wU {
  constructor() {
    this.localPersistenceKey = "designTransactions", this.storageMethod = "Local", this.designSavedListeners = [];
  }
  /**
   * @param func The function to call when a design is saved.
   */
  attachSaveListener(e) {
    this.designSavedListeners.push(e);
  }
  /**
   * @param func The function to remove from the list of listeners.
   */
  detachSaveListener(e) {
    this.designSavedListeners = this.designSavedListeners.filter((t) => t !== e);
  }
  /**
   * Gets the currently persisted designs.
   */
  async getSavedDesigns() {
    if (this.storageMethod === "Local") {
      const e = Cr.get(this.localPersistenceKey);
      return e ? JSON.parse(e) : [];
    }
    throw new un("Unexpected storage method requested");
  }
  /**
   * Search for a transaction that has been saved.
   * @param transactionId The id to search for.
   * @returns The transaction for the given id provided it has been saved. undefined if it doesn't exist.
   */
  async getSavedDesignByTransaction(e) {
    return (await this.getSavedDesigns()).find((n) => n.transactionId === e);
  }
  /**
   * Saves a design to storage.
   * @param design The design to save.
   */
  async addDesign(e) {
    const n = (await this.getSavedDesigns()).filter((i) => i.transactionId !== e.transactionId);
    n.unshift(e), await this.setDesigns(n), this.designSavedListeners.forEach((i) => i(e));
  }
  /**
   * Change the user's name of the given saved design.
   */
  async renameDesign(e, t) {
    const n = await this.getSavedDesigns(), i = n.find((a) => a.transactionId === e);
    if (!i)
      throw new Error(`No saved design for transaction ${e}.`);
    i.title = t, await this.setDesigns(n);
  }
  /**
   * Removes a given design from storage.
   * @param transactionId
   */
  async removeDesign(e) {
    const t = await this.getSavedDesigns();
    await this.setDesigns(t.filter((n) => n.transactionId !== e));
  }
  async setDesigns(e) {
    if (this.storageMethod === "Local") {
      Cr.set(this.localPersistenceKey, JSON.stringify(e));
      return;
    }
    throw new un("Unexpected storage method requested");
  }
}
const vv = new wU();
var yv, oE;
function xU() {
  if (oE) return yv;
  oE = 1;
  var r = "Expected a function", e = NaN, t = "[object Symbol]", n = /^\s+|\s+$/g, i = /^[-+]0x[0-9a-f]+$/i, a = /^0b[01]+$/i, s = /^0o[0-7]+$/i, o = parseInt, l = typeof ui == "object" && ui && ui.Object === Object && ui, u = typeof self == "object" && self && self.Object === Object && self, c = l || u || Function("return this")(), d = Object.prototype, f = d.toString, h = Math.max, g = Math.min, v = function() {
    return c.Date.now();
  };
  function y(S, R, M) {
    var j, G, ie, q, Y, J, se = 0, oe = !1, he = !1, ye = !0;
    if (typeof S != "function")
      throw new TypeError(r);
    R = F(R) || 0, A(M) && (oe = !!M.leading, he = "maxWait" in M, ie = he ? h(F(M.maxWait) || 0, R) : ie, ye = "trailing" in M ? !!M.trailing : ye);
    function Ue(je) {
      var qe = j, Ge = G;
      return j = G = void 0, se = je, q = S.apply(Ge, qe), q;
    }
    function Re(je) {
      return se = je, Y = setTimeout(re, R), oe ? Ue(je) : q;
    }
    function Oe(je) {
      var qe = je - J, Ge = je - se, bt = R - qe;
      return he ? g(bt, ie - Ge) : bt;
    }
    function ee(je) {
      var qe = je - J, Ge = je - se;
      return J === void 0 || qe >= R || qe < 0 || he && Ge >= ie;
    }
    function re() {
      var je = v();
      if (ee(je))
        return de(je);
      Y = setTimeout(re, Oe(je));
    }
    function de(je) {
      return Y = void 0, ye && j ? Ue(je) : (j = G = void 0, q);
    }
    function Be() {
      Y !== void 0 && clearTimeout(Y), se = 0, j = J = G = Y = void 0;
    }
    function ke() {
      return Y === void 0 ? q : de(v());
    }
    function ze() {
      var je = v(), qe = ee(je);
      if (j = arguments, G = this, J = je, qe) {
        if (Y === void 0)
          return Re(J);
        if (he)
          return Y = setTimeout(re, R), Ue(J);
      }
      return Y === void 0 && (Y = setTimeout(re, R)), q;
    }
    return ze.cancel = Be, ze.flush = ke, ze;
  }
  function A(S) {
    var R = typeof S;
    return !!S && (R == "object" || R == "function");
  }
  function x(S) {
    return !!S && typeof S == "object";
  }
  function k(S) {
    return typeof S == "symbol" || x(S) && f.call(S) == t;
  }
  function F(S) {
    if (typeof S == "number")
      return S;
    if (k(S))
      return e;
    if (A(S)) {
      var R = typeof S.valueOf == "function" ? S.valueOf() : S;
      S = A(R) ? R + "" : R;
    }
    if (typeof S != "string")
      return S === 0 ? S : +S;
    S = S.replace(n, "");
    var M = a.test(S);
    return M || s.test(S) ? o(S.slice(2), M ? 2 : 8) : i.test(S) ? e : +S;
  }
  return yv = y, yv;
}
var CU = xU();
const VF = /* @__PURE__ */ Bs(CU), SU = Ee`
    mutation AddTransactionStakeholder($id: String!, $type: String!, $details: CustomerDetailsInput!) {
        transactionAddStakeholder(id: $id, details: $details, type: $type) {
            id
            stakeholders {
                id
                type
                customer {
                    id
                    emailAddress
                }
            }
        }
    }
`, EU = Ee`
    mutation AddStakeholderToAllTransactions($ids: [String!]!, $type: String!, $details: CustomerDetailsInput!) {
        transactionsAddStakeholder(ids: $ids, details: $details, type: $type) {
            id
            stakeholders {
                id
                type
                customer {
                    id
                    emailAddress
                }
            }
        }
    }
`, kU = Ee`
    mutation AddAddressToTransaction(
        $transactionId: String!
        $streetAddress: String
        $apartment: String
        $city: String
        $country: String
        $state: String
        $postCode: String
    ) {
        addressAttachToTransaction(
            transactionId: $transactionId
            streetAddress: $streetAddress
            apartment: $apartment
            city: $city
            country: $country
            state: $state
            postCode: $postCode
        ) {
            id
        }
    }
`, TU = Ee`
    mutation AddOrganizationToTransaction($transactionId: String!, $organizationName: String!) {
        organizationAttachToTransaction(transactionId: $transactionId, organizationName: $organizationName) {
            id
        }
    }
`, lE = Ee`
    ${Pg}
    ${Td}
    mutation TransactionUpdateIntegrationProduct($id: String!, $integrationProductId: String) {
        transactionUpdateIntegrationProduct(id: $id, integrationProductId: $integrationProductId) {
            id
            integrationProduct {
                id
                externalProductId
                externalVariantId
                additionalExternalProductId
                additionalExternalVariantId
            }
            product {
                id
                basePrice
                enabled
                minimumOrderQuantity
                name
                description
                partner {
                    id
                    name
                    currencyCode
                    customerDetailsPromptMarkdown
                }
                productImages {
                    id
                    precedence
                    asset {
                        key
                        fileLink
                        name
                        type
                    }
                }
                integrationProducts {
                    id
                    integration {
                        id
                        type
                    }
                    externalProductId
                    externalVariantId
                    additionalExternalProductId
                    additionalExternalVariantId
                    additionalIntegrationProduct {
                        ...AdditionalIntegrationProductFields
                    }
                }
                profanities {
                    id
                    word
                }
                sku
                skuCode
                weight
                workflows {
                    id
                    friendlyName
                    isPresent
                    workflowName
                    imageUrl
                }
                imageUrl
                modelUrl
                overlayImageUrl
                preloadImageUrl
                promptForCustomerDetails
                conversionConfiguration {
                    ...ConversionConfigurationFields
                }
                productTags {
                    id
                    name
                }
                priceBreaks {
                    id
                    minQty
                    percentage
                }
            }
        }
    }
`;
var Xy = /* @__PURE__ */ ((r) => (r.PriceBreakChanged = "PriceBreakChanged", r.ProductChanged = "ProductChanged", r.QuantityChanged = "QuantityChanged", r.RecipientChanged = "RecipientChanged", r.SelectionChanged = "SelectionChanged", r))(Xy || {});
class FU {
  constructor(e, t) {
    this.cachedStepHandles = /* @__PURE__ */ new Map(), this.profanityList = [], this.currentPriceBreak = 1, this.renderableScenes = [], this.renderableSceneCallbacks = [], this.eventCallbacks = /* @__PURE__ */ new Map(), this.debouncedSavedDesignUpdate = VF(async () => {
      await vv.getSavedDesignByTransaction(this.getTransaction().id) && this.save();
    }, 2500), this.getCanvasObjectURLAsync = async (n) => new Promise((i, a) => {
      try {
        n.toBlob((s) => {
          if (s) {
            const o = URL.createObjectURL(s);
            i(o);
          }
        });
      } catch (s) {
        a(s);
      }
    }), this.client = e, this.transaction = t.transaction, this.workflow = t.workflow, this.profanityList = this.transaction.product?.profanities?.map((n) => n.word) || [], this.isReadOnly = t.transaction.isOrdered || !!t.readOnly, this.graphQlClient = t.graphQlClient, this.workflowManager = new Qy(
      this,
      e,
      (n) => {
        try {
          this.debouncedSavedDesignUpdate();
        } catch {
          console.error("Failed to update saved design details.");
        }
        return t.stateMutationFunc(n);
      },
      t.graphQlClient,
      t.reloadedState,
      t.readOnly,
      t.modelContainer,
      t.isReloadedTransaction,
      t.singleVariantsRenderable,
      t.delayWorkflowStateSync
    ), this.workflowManager.addSelectionCallback((n) => {
      const i = n.traversableScenes.map((a) => {
        const s = a.renderableSteps.map((o) => o.stepName);
        return {
          id: a.name,
          title: a.title,
          renderableSteps: s,
          workflowScene: a
        };
      });
      this.renderableScenes = i, this.renderableSceneCallbacks.forEach((a) => a(i)), this.callEvent(
        "SelectionChanged"
        /* SelectionChanged */
      );
    }), this.currentPriceBreak = this.priceBreakToBeApplied();
  }
  getTransaction() {
    return this.transaction;
  }
  getProduct() {
    return this.transaction.product;
  }
  getProfanityList() {
    return this.profanityList;
  }
  async setProduct(e) {
    this.workflow = void 0;
    const t = await this.graphQlClient().mutate({
      mutation: lE,
      variables: {
        id: this.getTransaction().id,
        integrationProductId: e
      }
    }), n = t.data?.transactionUpdateIntegrationProduct.product;
    if (!n)
      throw new un("Failed to set product. No product returned from server.");
    if (!this.bundle)
      throw new un("Cannot set product on experience that is not part of a bundle.");
    this.transaction.product = {
      ...this.transaction.product,
      ...t.data?.transactionUpdateIntegrationProduct.product
    }, this.transaction.integrationProduct = {
      ...this.transaction.integrationProduct,
      ...t.data?.transactionUpdateIntegrationProduct.integrationProduct
    }, this.transaction.workflowState = void 0, this.currentPriceBreak = this.priceBreakToBeApplied(), this.callEvent(
      "ProductChanged"
      /* ProductChanged */
    );
    const i = (await this.bundle.getProductCollection().fetchProducts()).find(
      (a) => a.getId() === n.id
    );
    try {
      const a = i?.getDefaultWorkflow();
      if (a) {
        const s = await kW(a.getId());
        await this.setWorkflow(s), console.log("Setting Product - Workflow set to default for product.");
      }
    } catch {
      console.log("Setting Product - No default workflow available, must be set manually.");
    }
  }
  async clearProduct() {
    if (!this.bundle)
      throw new un("Cannot clear product on experience that is not part of a bundle.");
    this.workflow = void 0, this.transaction.workflowState = void 0, this.transaction.product = void 0, this.transaction.integrationProduct = void 0, this.currentPriceBreak = this.priceBreakToBeApplied(), this.callEvent(
      "ProductChanged"
      /* ProductChanged */
    ), await this.graphQlClient().mutate({
      mutation: lE,
      variables: {
        id: this.getTransaction().id
      }
    });
  }
  getWorkflow() {
    return this.workflow;
  }
  async setWorkflow(e) {
    return this.workflow = e, await this.graphQlClient().mutate({
      mutation: kB,
      variables: {
        id: this.getTransaction().id,
        workflowId: e.id
      }
    }), this.workflowManager.setWorkflow(e);
  }
  async attachAddress(e, t, n, i, a, s) {
    await this.graphQlClient().mutate({
      mutation: kU,
      variables: {
        transactionId: this.getTransaction().id,
        streetAddress: e || void 0,
        apartment: t || void 0,
        city: n || void 0,
        country: i || void 0,
        state: a || void 0,
        postCode: s || void 0
      }
    });
  }
  async attachOrganization(e) {
    await this.graphQlClient().mutate({
      mutation: TU,
      variables: {
        transactionId: this.getTransaction().id,
        organizationName: e
      }
    });
  }
  getBundle() {
    return this.bundle;
  }
  setBundle(e) {
    this.bundle = e;
  }
  getClient() {
    return this.client;
  }
  getIsReadOnly() {
    return this.isReadOnly;
  }
  getCommandContext() {
    return this.workflowManager.getCommandContext();
  }
  getWorkflowManager() {
    return this.workflowManager;
  }
  async createPreviewImage(e, t) {
    const n = this.getWorkflow(), i = n?.finalizeStepConfig?.lookAtAnimation;
    if (!n)
      throw new Error("Failed to generate cart preview image! No workflow is set.");
    if (e) {
      if (!i)
        throw new Error("Failed to generate cart preview image! No camera orientation configured.");
      return await this.workflowManager.getPreviewService()?.renderSceneScreenshot(t ?? 512, i) || "";
    }
    let a = 2048;
    t && t <= 2048 && (a = t);
    const s = bo(a, a), o = this.workflowManager.getCommandContext().getAllLayouts(), l = n.defaultPreviewPanelIndex || 0, u = n.panels[l], c = o.find((k) => k.layoutState?.layout.panelId === u?.name) || o[0], d = c.layoutState.layout.previewRegion ? {
      x: c.layoutState.layout.previewRegion.left,
      y: c.layoutState.layout.previewRegion.top,
      width: c.layoutState.layout.previewRegion.width,
      height: c.layoutState.layout.previewRegion.height
    } : {
      x: 0,
      y: 0,
      width: c.layoutState.layout.width,
      height: c.layoutState.layout.height
    }, f = this.workflowManager.getCommandContext().getLayoutById(c.layoutState.layout.id), h = s.getContext("2d");
    if (!h)
      throw new Tg("Failed to obtain 2D context for preview image creation");
    const g = this.workflowManager.getTemplatingContext(), v = c1(f.layoutState.layout, f.layoutState.elements, {
      renderingConfiguration: {
        purpose: id.Print,
        region: { left: d.x, top: d.y, width: d.width, height: d.height },
        templatingContext: g
      }
    }), y = xk(v);
    await (await so.from(h, y, {
      anonymousCrossOrigin: !0,
      ignoreDimensions: !1,
      createCanvas: bo,
      createImage: kd,
      DOMParser: RA(),
      fetch
    })).render();
    const x = await this.getCanvasObjectURLAsync(s);
    return s.toDataURL(x);
  }
  getStepById(e) {
    const t = this.getWorkflow()?.steps.find((a) => a.stepName === e);
    if (!t || !this.stepHasHandle(t)) return;
    const n = this.cachedStepHandles.get(t.stepName);
    if (n)
      return n;
    const i = hp.get(this.getWorkflowManager(), t);
    return this.cachedStepHandles.set(t.stepName, i), i;
  }
  getSteps() {
    return this.getScenes().flatMap((e) => this.getStepsByScene(e));
  }
  async getStepsConditionallyActive() {
    const e = this.getScenes();
    return (await Promise.all(
      e.map(async (n) => {
        const i = this.getStepsByScene(n), a = await Promise.all(
          i.map(
            (s) => oo(s.getRaw(), this.getWorkflowManager().getStepSelections())
          )
        );
        return i.filter((s, o) => a[o]);
      })
    )).flat();
  }
  getScenes() {
    return (this.getWorkflow()?.stepGroups || []).map((t) => ({
      id: t.id,
      name: t.name,
      stepIds: t.stepNames
    }));
  }
  getSelectionPriceSubunits(e) {
    const t = this.getWorkflowManager().getWorkflowSelections();
    let n = 0;
    return Object.values(t).forEach((i) => {
      n += i.selections.reduce((a, s) => a + (s.priceModifier || 0), 0);
    }), this.getPriceSubUnitsAfterPriceBreaks(n, e);
  }
  getBasePriceSubunits(e, t) {
    const n = this.getPriceSubUnitsAfterPriceBreaks(this.getProduct()?.basePrice || 0, t);
    if (e) {
      const i = this.getAdditionalProductPriceSubunits(t) || 0;
      return n + i;
    }
    return n;
  }
  getAdditionalProductPriceSubunits(e) {
    const t = this.getTransaction().integrationProduct;
    if (t?.additionalIntegrationProduct?.product) {
      const n = t.additionalIntegrationProduct.product.basePrice || 0;
      return this.getPriceSubUnitsAfterPriceBreaks(n, e);
    }
  }
  getTotalPriceSubunits(e) {
    return this.getBasePriceSubunits(!1, e) + this.getSelectionPriceSubunits(e);
  }
  getPriceSubUnitsAfterPriceBreaks(e, t) {
    const n = t ? 1 : this.priceBreakToBeApplied(), i = e * n;
    return Math.ceil(i);
  }
  priceBreakToBeApplied() {
    const e = (this.getProduct()?.priceBreaks || []).sort((i, a) => -(i.minQty - a.minQty)), n = [...this.getMatchingExperiencesFromBundle(), this].reduce((i, a) => i + a.getQuantity(), 0);
    for (const i of e)
      if (i.minQty <= n)
        return i.percentage;
    return 1;
  }
  checkForPriceBreakChanges() {
    const e = this.priceBreakToBeApplied();
    this.currentPriceBreak !== e && (this.updatePriceBreak(e), this.getMatchingExperiencesFromBundle().forEach(
      (t) => t.updatePriceBreak(e)
    ));
  }
  getMatchingExperiencesFromBundle() {
    return (this.bundle?.getWorkflowExperiences() || []).filter((e) => {
      const t = e.getTransaction().id, n = this.getTransaction().id, i = e.getProduct()?.id, a = this.getProduct()?.id;
      return t !== n && i === a;
    });
  }
  updatePriceBreak(e) {
    this.currentPriceBreak = e, this.callEvent(
      "PriceBreakChanged"
      /* PriceBreakChanged */
    );
  }
  async copySelectionsViaGlobalConfiguration(e, t, n) {
    const i = await e.getGlobalProperties(), a = n?.map((u) => u.getId()), s = this.getSteps().filter((u) => a === void 0 || a.includes(u.getId())), o = t.getSteps(), l = (u) => i.find((c) => c.getRawProperty().name === u.aspectName);
    s.forEach((u) => {
      const c = /* @__PURE__ */ new Set(), d = u.getRaw().globalPropertyAspectConfigurations;
      d !== void 0 && (d.forEach((f) => c.add(JSON.stringify(f))), o.forEach((f) => {
        const h = f.getRaw().globalPropertyAspectConfigurations;
        h !== void 0 && h.forEach((g) => {
          const v = l(g), y = c.has(JSON.stringify(g));
          if (y && v?.getType() === "Option") {
            const A = f.getCurrentVariant();
            if (!A) return;
            u.selectVariant(A), c.delete(JSON.stringify(g));
          } else if (y && v?.getType() === "Text") {
            const A = f.getText();
            u.setText(A), c.delete(JSON.stringify(g));
          }
        });
      }));
    });
  }
  getStepByName(e) {
    const t = this.getWorkflow()?.steps.find((n) => n.stepTitle === e);
    if (!(!t || !this.stepHasHandle(t)))
      return hp.get(this.getWorkflowManager(), t);
  }
  getStepsByType(e) {
    return this.getWorkflow()?.steps.filter((t) => t.type === e).map((t) => hp.get(this.getWorkflowManager(), t)) || [];
  }
  getStepsByScene(e) {
    const t = this.getWorkflow();
    if (!t?.stepGroups.find((i) => i.name === e.name))
      throw new Error(
        "Given scene is not present on workflow! Be careful when persisting scenes that you only use them with the relevant workflow."
      );
    return e.stepIds.map((i) => t.steps.find((a) => a.stepName === i)).filter((i) => !!i && this.stepHasHandle(i)).map((i) => hp.get(this.getWorkflowManager(), i));
  }
  async attachCustomerDetails(e) {
    return this.assignCustomerDetails({ emailAddress: e.email });
  }
  async assignCustomerDetails(e) {
    const n = (await this.graphQlClient().mutate({
      mutation: SU,
      variables: {
        id: this.getTransaction().id,
        details: e,
        type: "Owner"
      }
    })).data?.transactionAddStakeholder?.stakeholders?.find(
      (i) => i.customer?.emailAddress === e.emailAddress
    );
    n?.customer && this.assignCustomerInternal(n.customer);
  }
  assignCustomerInternal(e) {
    this.getWorkflowManager().setTransactionCustomer(e);
    const t = Cr.getMap("transactionCustomerIds") || /* @__PURE__ */ new Map();
    t.set(this.getTransaction().id, e.id), Cr.setMap("transactionCustomerIds", t);
  }
  attachRenderableSceneListener(e) {
    this.renderableSceneCallbacks.push(e), e(this.renderableScenes);
  }
  detachRenderableSceneListener(e) {
    this.renderableSceneCallbacks = this.renderableSceneCallbacks.filter((t) => t !== e);
  }
  async save(e) {
    const t = this.getProduct(), n = this.getWorkflow(), i = this.getCommandContext().getState();
    if (!t) throw new un("Product undefined!");
    if (!n) throw new un("Workflow undefined!");
    if (!i) throw new un("State undefined!");
    const s = {
      title: await (async () => {
        if (e) return e;
        const o = this.getTransaction().id, u = (await vv.getSavedDesigns()).find((c) => c.transactionId === o)?.title;
        return u || "My design";
      })(),
      thumbnail: await this.createPreviewImage(!1, 256),
      transactionId: this.getTransaction().id,
      productId: t.id,
      integrationProductId: this.getTransaction().integrationProduct.id,
      workflowName: n.name,
      workflowId: n.id,
      lastEdited: /* @__PURE__ */ new Date()
    };
    return await vv.addDesign(s), s;
  }
  async copy() {
    const e = ho(this.getCommandContext().getState());
    if (!e) throw new un("Internal state is undefined! Cannot copy experience!");
    const t = JSON.stringify(e.transaction), n = this.getWorkflow();
    if (!n) throw new un("Workflow is undefined! Cannot copy experience!");
    const i = this.getTransaction().integrationProduct?.id;
    if (!i) throw new un("Integration product id is undefined!");
    return await this.getClient().getWorkflowExperience({
      type: "integration",
      integrationProductId: i,
      workflowId: n.id,
      workflowState: t
    });
  }
  async onDesignFinished(e = !0) {
    const t = this.getTransaction(), n = this.getProduct(), i = this.getWorkflow();
    if (!n)
      throw new un("Product undefined! Cannot finish an experience without a product.");
    if (!i)
      throw new un("Workflow undefined! Cannot finish an experience without a workflow.");
    if (t.isOrdered)
      return {
        event: "",
        exportedData: {},
        lineItemImageUrl: "",
        optionsCost: 0,
        transactionId: t.id,
        workflowViewerLink: "",
        workflowViewerReadOnlyLink: ""
      };
    const a = await UF(
      [
        {
          workflowManager: this.workflowManager,
          workflow: i,
          layouts: this.workflowManager.getLayouts(),
          getReducerState: () => this.workflowManager.getCommandContext().getState(),
          // Handle case where undefined (create a default state)
          product: n,
          transaction: t,
          workflowSelections: this.workflowManager.getWorkflowSelections(),
          workflowMetadata: this.workflowManager.getWorkflowMetadata(),
          designName: i.name
        }
      ],
      (s) => e ? this.createPreviewImage(s, 1024) : Promise.resolve(void 0)
    );
    return t.completed && await this.graphQlClient().mutate({
      mutation: BB,
      variables: {
        transactionId: t.id
      }
    }), a[0];
  }
  /**
   * @param step The step to test against.
   * @returns Returns true when a valid handle is implemented for a given step type. Certain steps don't support handles, such as silent illustrations.
   */
  stepHasHandle(e) {
    return e.type !== Je.SilentIllustration && e.type !== Je.ProductOverlay;
  }
  async getExportedStepData() {
    const e = this.getWorkflow(), t = this.getWorkflowManager().getWorkflowMetadata(), n = this.getWorkflowManager().getWorkflowSelections(), i = [];
    for (const a of e?.steps || []) {
      const s = a.stepName, o = t[s], l = n[s]?.selections[0], u = {
        stepId: s,
        title: a.stepTitle,
        properties: []
      };
      if (l && await DU(a, n) && u.properties.push({
        type: "selection",
        value: l.name,
        priceModifier: l.priceModifier
      }), !o) {
        i.push(u);
        continue;
      }
      switch (a.type) {
        case Je.Frame:
          {
            const c = a.data, d = o;
            d.image && c.displayImageOnFinishStep && u.properties.push({
              type: "image",
              value: d.image,
              priceModifier: 0
            });
          }
          break;
        case Je.Illustration:
          {
            const c = a.data, d = o;
            if (d && d.colors && d.colors.length > 0 && c.displayColorsOnFinishStep) {
              const f = d.colors.join(", ").toUpperCase();
              u.properties.push({
                type: "color",
                value: f,
                priceModifier: 0
              });
            }
          }
          break;
        case Je.Module:
          {
            const c = a.data, d = o;
            d && d.text && c.displayTextOnFinishStep && u.properties.push({
              type: "text",
              value: d.text,
              priceModifier: 0
            });
          }
          break;
        case Je.Text: {
          const c = a.data, d = o;
          d && d.text && c.displayTextOnFinishStep && u.properties.push({
            type: "text",
            value: d.text,
            priceModifier: 0
          }), d && d.color && c.displayColorOnFinishStep && u.properties.push({
            type: "color",
            value: d.color,
            priceModifier: 0
          });
        }
      }
      i.push(u);
    }
    return i.filter((a) => a.properties && a.properties.length > 0);
  }
  getQuantity() {
    return this.getTransaction().quantity || 1;
  }
  async setQuantity(e) {
    if (e < 1)
      throw new RangeError("WorkflowExperience quantity must be greater than zero.");
    if (this.isReadOnly)
      throw new Error("Cannot update quantity on a read-only WorkflowExperience");
    this.getTransaction().quantity = e, this.callEvent(
      "QuantityChanged"
      /* QuantityChanged */
    ), this.checkForPriceBreakChanges();
    const t = this.getTransaction();
    await this.graphQlClient().mutate({
      mutation: EB,
      variables: {
        id: t.id,
        quantity: e
      }
    });
  }
  addEventListener(e, t) {
    const n = this.eventCallbacks.get(e) || [];
    n.push(t), this.eventCallbacks.set(e, n);
  }
  removeEventListener(e, t) {
    const n = this.eventCallbacks.get(e) || [];
    this.eventCallbacks.set(
      e,
      n.filter((i) => i !== t)
    );
  }
  callEvent(e) {
    (this.eventCallbacks.get(e) || []).forEach((t) => t(this));
  }
}
const IU = (r) => {
  if ([
    Je.Question,
    Je.Frame,
    Je.Illustration,
    Je.Material,
    Je.Model,
    Je.Picture,
    Je.Shape,
    Je.Text
  ].includes(r.type)) {
    const t = r.data;
    return !!t.displaySelectionOnFinishStep || !!t.displaySelectionsOnFinishStep;
  }
  return !1;
}, DU = async (r, e) => {
  if (!IU(r)) return !1;
  const t = await ft.getOptionForStep(r);
  if (t && (t.variants || []).length > 1) {
    const n = e[r.stepName];
    return !!(n && n.selections.length > 0);
  }
  return !1;
};
class PU {
  constructor(e) {
    this.handleCache = {}, this.bundle = e;
  }
  /**
   * Gets a handle for the given global property. Fetches from cache if available.
   * @param property The property to get a handle for.
   * @returns A promise resolving to the handle.
   */
  async getHandle(e) {
    if (this.handleCache[e.name]) return this.handleCache[e.name];
    const t = await this.createHandle(e);
    return this.handleCache[e.name] = t, t;
  }
  /**
   * Gets a list of handles for all global properties. Fetches from cache if available.
   * @returns A promise resolving to the handles.
   */
  async getHandles() {
    if (!this.bundle.getProductCollection()?.getResource().globalPropertyConfiguration) return [];
    await this.bundle.getGlobalPropertyStateManager().getInitializationPromise();
    const e = this.bundle.getProductCollection()?.getResource().globalPropertyConfiguration;
    return e ? Promise.all(e.aspects.map((t) => this.getHandle(t))) : [];
  }
  /**
   * Applies the global state to all handles, if the state is set.
   * @param handles The handles to apply the state to.
   * @param state
   * @returns
   */
  applyConditionsFromState(e, t) {
    return t ? e.filter((n) => this.aspectConditionsSatisfied(n.getRawProperty(), t)) : e;
  }
  aspectConditionsSatisfied(e, t) {
    return !e.conditions || e.conditions.length === 0 ? !0 : (e.conditionMode === mk.AND ? Array.prototype.every.bind(e.conditions) : Array.prototype.some.bind(e.conditions))((i) => {
      const a = t.aspects.find((s) => s.name === i.targetAspectName);
      return a ? i.requiredVariantSelections.some((s) => s === a.value) : !1;
    });
  }
  async createHandle(e) {
    switch (e.type) {
      case Qn.FileUpload:
        return new RU(this.bundle, e).initialize();
      case Qn.ColorOption:
        return new uE(
          this.bundle,
          e,
          e.entityId ? await ft.getOption(e.entityId) : void 0
        );
      case Qn.Option: {
        const t = e.entityId ? await ft.getOption(e.entityId) : void 0;
        return t?.type === "Color" ? new uE(this.bundle, e, t) : new zF(this.bundle, e, t);
      }
      case Qn.Text:
        return new OU(this.bundle, e);
      default:
        throw new Error("Unhandled Global Property Aspect Type");
    }
  }
}
class m1 {
  constructor(e, t) {
    this.bundle = e, this.property = t;
  }
  /**
   * @returns The name of the global property. This is the key used to store the property in the state.
   */
  getName() {
    return this.property.name;
  }
  /**
   * @returns A human-friendly title.
   */
  getTitle() {
    return this.property.title;
  }
  /**
   * @returns A human-friendly description.
   */
  getDescription() {
    return this.property.description;
  }
  /**
   * @returns The type of the global property. Use this to determine how to render the property.
   */
  getType() {
    return this.property.type;
  }
  /**
   * @returns The underlying property data object.
   */
  getRawProperty() {
    return this.property;
  }
  /**
   * @returns Whether this aspect has been marked as required to be completed before the user can continue.
   */
  isMandatory() {
    return !!this.property.mandatory;
  }
  /**
   * @returns Whether this aspect has been marked as `completed` for mandatory checks. Note that this function always returns `true` if the aspect has not been marked as mandatory.
   */
  isMandatoryFulfilled() {
    return !this.property.mandatory || !!this.bundle.getGlobalPropertyStateManager().getAspectMandatoryFulfilled(this.property.name);
  }
  /**
   * @returns Whether this aspect has been marked as silent and therefore should not be displayed to the user.
   */
  isSilent() {
    return !!this.property.silent || this.bundle.getGlobalPropertyStateManager().getAspectHidden(this.property.name);
  }
  /**
   * Returns all steps that share this property.
   * @param targetExperiences Optionally filter the steps to only those in the given experiences.
   */
  async getSharedSteps(e) {
    const t = e ?? this.bundle.getWorkflowExperiences();
    return (await Promise.all(t.map((a) => a.getStepsConditionallyActive()))).map(
      (a) => a.filter((s) => s.getOverrideGlobalPropertyConfiguration(this.property.type) ? !1 : s.getRaw().globalPropertyAspectConfigurations?.some(
        (o) => o.globalPropertyConfigurationId === this.bundle.getProductCollection()?.getResource().globalPropertyConfiguration?.id && o.aspectName === this.property.name
      ))
    ).flat();
  }
  getStateValue() {
    return this.bundle.getGlobalPropertyStateManager().getAspect(this.property.name);
  }
}
class RU extends m1 {
  constructor(e, t) {
    super(e, t);
  }
  async initialize() {
    return this.property.data?.fileUpload?.colorOptionId && (this.colorOption = await ft.getOption(this.property.data?.fileUpload?.colorOptionId)), await this.loadImageData(), this;
  }
  async loadImageData() {
    const e = await this.getImage();
    if (e?.fileLink)
      if (e?.fileLink.endsWith(".svg")) {
        const t = await ha(e?.fileLink), n = await h1(e?.fileLink), i = n.width, a = n.height, s = await ss(t);
        this.bundle.getGlobalPropertyStateManager().getAspectStorage(this.property.name)?.colors?.forEach((u) => {
          s.colors[u.key] = {
            browserValue: u.browserValue,
            pmsValue: u.pmsValue
          };
        });
        const l = {
          src: e?.fileLink,
          width: i,
          height: a,
          aspect: i / a,
          svg: s.svg,
          colors: s.colors
        };
        io.set(e?.fileLink, l), this.imageData = l;
      } else
        this.imageData = void 0;
  }
  /**
   * Select an image to be used for all shared steps.
   * @param asset The asset to use.
   * @returns A promise resolving when all affected steps have been updated.
   */
  async selectImage(e) {
    const t = this.bundle.getGlobalPropertyStateManager();
    await Promise.all([
      t.setAspect(
        this.property.name,
        e.key,
        {
          ...t.getAspectStorage(this.property.name) || {},
          originalAssetKey: e.key,
          backgroundRemovedAssetKey: void 0,
          vectorizedAssetKey: void 0,
          useOriginalAsset: void 0
        },
        void 0
      ),
      this.applyImageSelection(e),
      this.loadImageData()
    ]);
  }
  async canUseAdvancedImageManipulation() {
    return this.bundle.getClient().canUseAddon(IA.AdvancedImageManipulation);
  }
  /**
   * Removes the background from an image, stores it in the state, and returns the new asset.
   * @param applyNewAsset Optionally applies the new asset to all shared steps. Default: `true`.
   * @returns A promise that resolves with the newly generated Asset.
   */
  async removeBackgroundFromImage(e = !0) {
    if (!await this.canUseAdvancedImageManipulation())
      throw new Error(
        "The current Integration does not have access to the Advanced Image Manipulation addon. Please call canUseAdvancedImageManipulation to ensure you disable this feature when appropriate."
      );
    const t = await this.getOriginalImage();
    if (!t)
      throw new Error("You must supply an image selection before attempting to remove the background.");
    const n = this.bundle.getGlobalPropertyStateManager(), i = await zn.removeBackgroundFromAsset(t), s = {
      ...n.getAspectStorage(this.property.name),
      backgroundRemovedAssetKey: i.key,
      useOriginalAsset: !e
    }, l = [e ? n.setAspect(this.property.name, i.key, s) : n.setAspectStorage(this.property.name, s)];
    return e && (l.push(this.applyImageSelection(i, void 0, !1, !1)), l.push(this.loadImageData())), await Promise.all(l), this.updateSharedStepStorage(s), i;
  }
  /**
   * Vectorizes the current image selection, stores it in the state, and returns the new asset.
   * Note: This is a more expensive operation than raster background removal, so should only be used when necessary (e.g., for large images or when the user needs a transparent background for printing).
   * @param applyNewAsset Optionally applies the new asset to all shared steps. Default: `true`.
   * @returns A promise that resolves with the newly generated Asset.
   */
  async vectorizeImage(e = !0) {
    if (!await this.canUseAdvancedImageManipulation())
      throw new Error(
        "The current Integration does not have access to the Advanced Image Manipulation addon. Please call canUseAdvancedImageManipulation to ensure you disable this feature when appropriate."
      );
    const t = await this.getOriginalImage();
    if (!t)
      throw new Error("You must supply an image selection before attempting to vectorize the image.");
    const n = this.bundle.getGlobalPropertyStateManager(), i = await zn.vectorizeAsset(t), s = {
      ...n.getAspectStorage(this.property.name),
      vectorizedAssetKey: i.key,
      useOriginalAsset: !e
    }, l = [e ? n.setAspect(this.property.name, i.key, s) : n.setAspectStorage(this.property.name, s)];
    return e && (l.push(this.applyImageSelection(i, void 0, !1, !1)), l.push(this.loadImageData())), await Promise.all(l), this.updateSharedStepStorage(s), i;
  }
  /**
   * Returns `true` if the state has an image assigned, otherwise `false`.
   */
  hasImage() {
    return !!this.getStateValue();
  }
  /**
   * Retrieves the current image selection, if one exists.
   * @returns A promise that resolves with an `Asset` object if one is assigned to the state, otherwise `undefined`.
   */
  async getImage() {
    const e = this.getStateValue();
    if (e)
      return zn.getLocalOrFromServer(e);
  }
  async getImageWithColors() {
    return await this.loadImageData(), this.imageData?.svg ? DA(zA(this.imageData.svg, this.imageData.colors ?? {}, !1)) : this.imageData?.src;
  }
  /**
   * Retrieves the original, unmodified image selection, if one exists.
   * @returns A promise that resolves with an `Asset` object if one is assigned to the state, otherwise `undefined`.
   */
  async getOriginalImage() {
    const e = this.bundle.getGlobalPropertyStateManager().getAspectStorage(this.property.name);
    if (e?.originalAssetKey)
      return zn.getLocalOrFromServer(e.originalAssetKey);
  }
  /**
   * Retrieves the version of the image selection that has the background removed, if one exists.
   * @returns A promise that resolves with an `Asset` object if one is assigned to the state, otherwise `undefined`.
   */
  async getBackgroundRemovedImage() {
    const e = this.bundle.getGlobalPropertyStateManager().getAspectStorage(this.property.name);
    if (e?.backgroundRemovedAssetKey)
      return zn.getLocalOrFromServer(e.backgroundRemovedAssetKey);
  }
  getUseOriginalImage() {
    return this.bundle.getGlobalPropertyStateManager().getAspectStorage(this.property.name)?.useOriginalAsset ?? !1;
  }
  async setUseOriginalImage(e) {
    const t = await this.getOriginalImage();
    if (!t)
      throw new Error("You must select an image before calling setUseOriginalImage");
    const n = this.bundle.getGlobalPropertyStateManager(), i = n.getAspectStorage(this.property.name);
    if (i?.useOriginalAsset === e)
      return;
    const a = {
      ...i,
      useOriginalAsset: e
    }, s = e ? i?.originalAssetKey : i?.backgroundRemovedAssetKey, o = [n.setAspect(this.property.name, s || "", a)];
    if (e)
      o.push(this.applyImageSelection(t, void 0, !1, !1));
    else {
      const l = async () => {
        const u = await this.getBackgroundRemovedImage();
        if (!u)
          throw new Error(
            "You must call removeBackgroundFromImage before attempting to use that version of the image."
          );
        this.applyImageSelection(u, void 0, !1, !1);
      };
      o.push(l());
    }
    o.push(this.loadImageData()), await Promise.all(o), this.updateSharedStepStorage(a);
  }
  async applyGlobalState(e) {
    const t = this.getStateValue();
    if (!t) return;
    const n = await zn.getLocalOrFromServer(t);
    if (!n) return;
    await this.applyImageSelection(n, e, !1, !0);
    const i = this.bundle.getGlobalPropertyStateManager().getAspectStorage(this.property.name);
    if (i) {
      if (this.updateSharedStepStorage({ ...i }), i.colors) {
        const a = new Map(
          i.colors.map((s) => [s.key, { browserValue: s.browserValue, pmsValue: s.pmsValue }]) ?? []
        );
        await Promise.all(
          (await this.getSharedSteps(e)).map(async (s) => {
            await s.changeColors(a);
          })
        );
      }
    } else
      this.updateSharedStepStorage({ originalAssetKey: t }), await this.bundle.getGlobalPropertyStateManager().setAspectStorage(this.property.name, { originalAssetKey: t });
  }
  getAvailableColors() {
    return this.property.data?.fileUpload?.colorPickerEnabled ? this.colorOption?.variants?.map((e) => ({
      fill: e.color,
      stroke: e.color,
      variant: e,
      pmsValue: e.name
    })) ?? [] : [];
  }
  getCurrentColors() {
    return this.imageData?.colors;
  }
  isColorPickerEnabled() {
    return this.property.data?.fileUpload?.colorPickerEnabled ?? !1;
  }
  isPmsPickerEnabled() {
    return this.property.data?.fileUpload?.pmsPickerEnabled ?? !1;
  }
  async getOriginalColors() {
    return this.imageData?.svg ? (await ss(this.imageData.svg)).colors : void 0;
  }
  async changeColors(e) {
    if (!this.imageData?.svg)
      return;
    const t = this.getSharedSteps(), n = new Map(Object.entries(e));
    await Promise.all(
      (await t).map(async (a) => {
        await a.changeColors(n);
      })
    );
    const i = this.bundle.getGlobalPropertyStateManager().getAspectStorage(this.property.name);
    await Promise.all([
      this.bundle.getGlobalPropertyStateManager().setAspectStorage(this.property.name, {
        ...i,
        colors: Object.entries(e).map(([a, s]) => ({
          key: a,
          browserValue: s.browserValue,
          pmsValue: s.pmsValue
        }))
      }),
      await this.loadImageData()
    ]);
  }
  async applyImageSelection(e, t, n = !0, i = !0) {
    const s = (await this.getSharedSteps(t)).map((o) => {
      const l = o;
      if (l.getFrameService())
        return l.selectImage(e, n, i);
    });
    await Promise.all(s);
  }
  updateSharedStepStorage(e) {
    this.bundle.getWorkflowExperiences().forEach(
      (n) => n.getSteps().forEach((i) => {
        if (i.getOverrideGlobalPropertyConfiguration(this.property.type))
          return;
        i.getRaw().globalPropertyAspectConfigurations?.some(
          (s) => s.globalPropertyConfigurationId === this.bundle.getProductCollection()?.getResource().globalPropertyConfiguration?.id && s.aspectName === this.property.name
        ) && n.getWorkflowManager().updateStorage(i.getId(), {
          framePatternData: {
            originalAssetKey: e.originalAssetKey,
            backgroundRemovedAssetKey: e.backgroundRemovedAssetKey,
            useOriginalAsset: e.useOriginalAsset
          }
        });
      })
    );
  }
}
class OU extends m1 {
  constructor(e, t) {
    super(e, t);
  }
  /**
   * If this returns false, you should not display any templating tools.
   * Note: Templates will currently still be rendered, regardless of what this function returns.
   */
  isTemplatingEnabled() {
    return this.property.data?.text?.templatingEnabled || !1;
  }
  /**
   * Gets the current text
   */
  getText() {
    const e = this.getStateValue();
    return e || "";
  }
  /**
   * Set the text.
   */
  async setText(e) {
    await Promise.all([
      this.bundle.getGlobalPropertyStateManager().setAspect(this.property.name, e, void 0, void 0),
      this.applyTextSelection(e)
    ]);
  }
  async applyGlobalState(e) {
    const t = this.getStateValue();
    if (!t) return Promise.resolve();
    await this.applyTextSelection(t, e);
  }
  async applyTextSelection(e, t) {
    const i = (await this.getSharedSteps(t)).map((a) => {
      a.setText(e);
    });
    await Promise.all(i);
  }
}
class zF extends m1 {
  constructor(e, t, n) {
    super(e, t), this.optionResource = n;
  }
  /**
   * Ensures the option resource has its variants loaded. If the option was loaded
   * with minimal fields (e.g., lazy loading), this will re-fetch the full option.
   */
  async ensureOptionLoaded() {
    if (this.optionResource?.variants) return this.optionResource;
    if (!this.property.entityId) return this.optionResource;
    const e = await ft.getOption(this.property.entityId);
    return e && (this.optionResource = e), this.optionResource;
  }
  /**
   * If the option has a default variant, select it.
   */
  async initDefaultVariant() {
    await this.ensureOptionLoaded();
    const e = this.optionResource?.variants?.find(
      (t) => t.id === this.optionResource?.defaultVariant?.id
    );
    e && await this.selectVariant(new es(e));
  }
  /**
   * Gets the currently selected variant, or undefined if no variant is selected.
   */
  getCurrentVariant() {
    if (!this.optionResource) return;
    const e = this.getStateValue();
    if (e) {
      const t = this.optionResource.variants?.find((n) => n.id === e);
      return t ? new es(t) : void 0;
    } else {
      const t = this.optionResource.variants?.find(
        (n) => n.id === this.optionResource?.defaultVariant?.id
      );
      return t ? new es(t) : void 0;
    }
  }
  /**
   * @returns A list of valid variants for this step. Does not include disabled variants.
   */
  async getAvailableVariants() {
    return await this.ensureOptionLoaded(), (this.optionResource?.variants?.filter((t) => t.enabled) || []).map((t) => new es(t));
  }
  /**
   * @returns A list of all variants for this step, including disabled ones.
   */
  async getAllVariants() {
    return await this.ensureOptionLoaded(), (this.optionResource?.variants || []).map((t) => new es(t));
  }
  /**
   * Select a given variant on the option for all shared steps.
   * @param variant The variant to select.
   */
  async selectVariant(e, t) {
    await this.applyVariantSelection(e), await this.bundle.getGlobalPropertyStateManager().setAspect(this.property.name, e.getId(), void 0, t);
  }
  async applyGlobalState(e) {
    const t = this.getStateValue();
    if (!t) return;
    await this.ensureOptionLoaded();
    const n = this.optionResource?.variants?.find((i) => i.id === t);
    if (n)
      return this.applyVariantSelection(new es(n), e);
  }
  async applyVariantSelection(e, t) {
    const i = (await this.getSharedSteps(t)).map((a) => a.selectVariant(e));
    await Promise.all(i);
  }
}
class uE extends zF {
  constructor(e, t, n) {
    super(e, t, n);
  }
  /**
   * Select a given variant on the option for all shared steps.
   * @param variant The variant to select.
   */
  async selectVariant(e, t) {
    await this.bundle.getGlobalPropertyStateManager().setAspect(this.property.name, e.getId(), void 0, t), await this.applyColorVariant(e, void 0, t);
  }
  async applyGlobalState(e) {
    const t = this.getStateValue();
    if (!t) return;
    await this.ensureOptionLoaded();
    const n = this.optionResource?.variants?.find((a) => a.id === t);
    if (!n) return;
    await this.applyColorVariant(new es(n), e);
    const i = this.bundle.getGlobalPropertyStateManager().getAspectStorage(this.property.name)?.customColor;
    i && await this.setCustomColor(i);
  }
  async applyColorVariant(e, t, n) {
    const a = (await this.getSharedSteps(t)).map((s) => {
      switch (s.getType()) {
        case Je.Shape:
          return s.selectVariant(e);
        case Je.Text:
          return s.setFillColor({
            fill: e.getColor(),
            stroke: e.getColor(),
            variant: e.getResource()
          });
        case Je.Illustration:
          return s.setColor(n?.toString() || "", e.getColor() || "");
      }
    });
    await Promise.all(a);
  }
  /**
   * Sets a custom color on the global state.
   */
  async setCustomColor(e) {
    const t = this.getCurrentVariant()?.getColor();
    t && t.toLowerCase() === "#custom" && (await this.getSharedSteps()).forEach((i) => i.setCustomColor(e)), this.bundle.getGlobalPropertyStateManager().setAspectStorage(this.property.name, { customColor: e });
  }
  /**
   * Gets the custom color used by the global state.
   */
  getCustomColor() {
    return this.bundle.getGlobalPropertyStateManager().getAspectStorage(this.property.name)?.customColor || this.getCurrentVariant()?.getColor() || "#ffffff";
  }
}
const BU = (r, e, t) => {
  const n = r.getWorkflowExperiences(), i = r.getGlobalPropertyConfiguration();
  return i ? n.flatMap((s) => s.getSteps()).filter((s) => s.getGlobalPropertyAspects(i.id).includes(e) && s.getType() === t) : [];
}, MU = (r, e) => {
  const n = BU(r, e, Je.Illustration).map((i) => {
    if (!i.getCurrentVariant()?.getAssetResource()?.assetConfiguration)
      return 0;
    const s = i.getColors();
    return s ? Object.getOwnPropertyNames(s).length : 0;
  });
  return Math.max(...n);
};
var Mf = { exports: {} };
Mf.exports;
var cE;
function _U() {
  return cE || (cE = 1, (function(r, e) {
    var t = 200, n = "Expected a function", i = "__lodash_hash_undefined__", a = 500, s = 1, o = 2, l = 4, u = 800, c = 16, d = 9007199254740991, f = "[object Arguments]", h = "[object Array]", g = "[object AsyncFunction]", v = "[object Boolean]", y = "[object Date]", A = "[object Error]", x = "[object Function]", k = "[object GeneratorFunction]", F = "[object Map]", S = "[object Number]", R = "[object Null]", M = "[object Object]", j = "[object Promise]", G = "[object Proxy]", ie = "[object RegExp]", q = "[object Set]", Y = "[object String]", J = "[object Symbol]", se = "[object Undefined]", oe = "[object WeakMap]", he = "[object ArrayBuffer]", ye = "[object DataView]", Ue = "[object Float32Array]", Re = "[object Float64Array]", Oe = "[object Int8Array]", ee = "[object Int16Array]", re = "[object Int32Array]", de = "[object Uint8Array]", Be = "[object Uint8ClampedArray]", ke = "[object Uint16Array]", ze = "[object Uint32Array]", je = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, qe = /^\w*$/, Ge = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, bt = /[\\^$.*+?()[\]{}|]/g, rr = /\\(\\)?/g, Pr = /\w*$/, Gt = /^\[object .+?Constructor\]$/, ar = /^(?:0|[1-9]\d*)$/, St = {};
    St[Ue] = St[Re] = St[Oe] = St[ee] = St[re] = St[de] = St[Be] = St[ke] = St[ze] = !0, St[f] = St[h] = St[he] = St[v] = St[ye] = St[y] = St[A] = St[x] = St[F] = St[S] = St[M] = St[ie] = St[q] = St[Y] = St[oe] = !1;
    var st = {};
    st[f] = st[h] = st[he] = st[ye] = st[v] = st[y] = st[Ue] = st[Re] = st[Oe] = st[ee] = st[re] = st[F] = st[S] = st[M] = st[ie] = st[q] = st[Y] = st[J] = st[de] = st[Be] = st[ke] = st[ze] = !0, st[A] = st[x] = st[oe] = !1;
    var Qr = typeof ui == "object" && ui && ui.Object === Object && ui, Sr = typeof self == "object" && self && self.Object === Object && self, gr = Qr || Sr || Function("return this")(), nr = e && !e.nodeType && e, fr = nr && !0 && r && !r.nodeType && r, Yt = fr && fr.exports === nr, Xt = Yt && Qr.process, mt = (function() {
      try {
        var L = fr && fr.require && fr.require("util").types;
        return L || Xt && Xt.binding && Xt.binding("util");
      } catch {
      }
    })(), wr = mt && mt.isMap, an = mt && mt.isSet, _r = mt && mt.isTypedArray;
    function ir(L, te, le) {
      switch (le.length) {
        case 0:
          return L.call(te);
        case 1:
          return L.call(te, le[0]);
        case 2:
          return L.call(te, le[0], le[1]);
        case 3:
          return L.call(te, le[0], le[1], le[2]);
      }
      return L.apply(te, le);
    }
    function Yr(L, te) {
      for (var le = -1, Ve = L == null ? 0 : L.length; ++le < Ve && te(L[le], le, L) !== !1; )
        ;
      return L;
    }
    function kr(L, te) {
      for (var le = -1, Ve = L == null ? 0 : L.length, pt = 0, _t = []; ++le < Ve; ) {
        var Wr = L[le];
        te(Wr, le, L) && (_t[pt++] = Wr);
      }
      return _t;
    }
    function Zr(L, te) {
      for (var le = -1, Ve = L == null ? 0 : L.length, pt = Array(Ve); ++le < Ve; )
        pt[le] = te(L[le], le, L);
      return pt;
    }
    function Vr(L, te) {
      for (var le = -1, Ve = te.length, pt = L.length; ++le < Ve; )
        L[pt + le] = te[le];
      return L;
    }
    function pn(L, te) {
      for (var le = -1, Ve = Array(L); ++le < L; )
        Ve[le] = te(le);
      return Ve;
    }
    function gn(L) {
      return function(te) {
        return L(te);
      };
    }
    function Tr(L, te) {
      return L?.[te];
    }
    function zr(L, te) {
      return function(le) {
        return L(te(le));
      };
    }
    var en = Array.prototype, $r = Function.prototype, zt = Object.prototype, sr = gr["__core-js_shared__"], Er = $r.toString, tt = zt.hasOwnProperty, Nr = (function() {
      var L = /[^.]+$/.exec(sr && sr.keys && sr.keys.IE_PROTO || "");
      return L ? "Symbol(src)_1." + L : "";
    })(), Xr = zt.toString, Se = Er.call(Object), P = RegExp(
      "^" + Er.call(tt).replace(bt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), U = Yt ? gr.Buffer : void 0, X = gr.Symbol, ue = gr.Uint8Array;
    U && U.allocUnsafe;
    var Fe = zr(Object.getPrototypeOf, Object), We = zt.propertyIsEnumerable, wt = en.splice, Pt = X ? X.isConcatSpreadable : void 0, Nt = X ? X.toStringTag : void 0, or = (function() {
      try {
        var L = Ut(Object, "defineProperty");
        return L({}, "", {}), L;
      } catch {
      }
    })(), Lt = Object.getOwnPropertySymbols, K = U ? U.isBuffer : void 0, Ie = Math.max, Qe = Date.now, Ye = Ut(gr, "DataView"), Ct = Ut(gr, "Map"), dt = Ut(gr, "Promise"), Rt = Ut(gr, "Set"), Et = Ut(gr, "WeakMap"), hr = Ut(Object, "create"), er = di(Ye), dr = di(Ct), $t = di(dt), On = di(Rt), Fn = di(Et), mr = X ? X.prototype : void 0, xr = mr ? mr.valueOf : void 0, wn = mr ? mr.toString : void 0;
    function Rr(L) {
      var te = -1, le = L == null ? 0 : L.length;
      for (this.clear(); ++te < le; ) {
        var Ve = L[te];
        this.set(Ve[0], Ve[1]);
      }
    }
    function jn() {
      this.__data__ = hr ? hr(null) : {}, this.size = 0;
    }
    function xn(L) {
      var te = this.has(L) && delete this.__data__[L];
      return this.size -= te ? 1 : 0, te;
    }
    function Hr(L) {
      var te = this.__data__;
      if (hr) {
        var le = te[L];
        return le === i ? void 0 : le;
      }
      return tt.call(te, L) ? te[L] : void 0;
    }
    function Cn(L) {
      var te = this.__data__;
      return hr ? te[L] !== void 0 : tt.call(te, L);
    }
    function cn(L, te) {
      var le = this.__data__;
      return this.size += this.has(L) ? 0 : 1, le[L] = hr && te === void 0 ? i : te, this;
    }
    Rr.prototype.clear = jn, Rr.prototype.delete = xn, Rr.prototype.get = Hr, Rr.prototype.has = Cn, Rr.prototype.set = cn;
    function tn(L) {
      var te = -1, le = L == null ? 0 : L.length;
      for (this.clear(); ++te < le; ) {
        var Ve = L[te];
        this.set(Ve[0], Ve[1]);
      }
    }
    function Jn() {
      this.__data__ = [], this.size = 0;
    }
    function ii(L) {
      var te = this.__data__, le = Jt(te, L);
      if (le < 0)
        return !1;
      var Ve = te.length - 1;
      return le == Ve ? te.pop() : wt.call(te, le, 1), --this.size, !0;
    }
    function Sn(L) {
      var te = this.__data__, le = Jt(te, L);
      return le < 0 ? void 0 : te[le][1];
    }
    function mn(L) {
      return Jt(this.__data__, L) > -1;
    }
    function sn(L, te) {
      var le = this.__data__, Ve = Jt(le, L);
      return Ve < 0 ? (++this.size, le.push([L, te])) : le[Ve][1] = te, this;
    }
    tn.prototype.clear = Jn, tn.prototype.delete = ii, tn.prototype.get = Sn, tn.prototype.has = mn, tn.prototype.set = sn;
    function rn(L) {
      var te = -1, le = L == null ? 0 : L.length;
      for (this.clear(); ++te < le; ) {
        var Ve = L[te];
        this.set(Ve[0], Ve[1]);
      }
    }
    function Lr() {
      this.size = 0, this.__data__ = {
        hash: new Rr(),
        map: new (Ct || tn)(),
        string: new Rr()
      };
    }
    function on(L) {
      var te = Ht(this, L).delete(L);
      return this.size -= te ? 1 : 0, te;
    }
    function E(L) {
      return Ht(this, L).get(L);
    }
    function O(L) {
      return Ht(this, L).has(L);
    }
    function z(L, te) {
      var le = Ht(this, L), Ve = le.size;
      return le.set(L, te), this.size += le.size == Ve ? 0 : 1, this;
    }
    rn.prototype.clear = Lr, rn.prototype.delete = on, rn.prototype.get = E, rn.prototype.has = O, rn.prototype.set = z;
    function W(L) {
      var te = this.__data__ = new tn(L);
      this.size = te.size;
    }
    function pe() {
      this.__data__ = new tn(), this.size = 0;
    }
    function ce(L) {
      var te = this.__data__, le = te.delete(L);
      return this.size = te.size, le;
    }
    function Ce(L) {
      return this.__data__.get(L);
    }
    function _e(L) {
      return this.__data__.has(L);
    }
    function rt(L, te) {
      var le = this.__data__;
      if (le instanceof tn) {
        var Ve = le.__data__;
        if (!Ct || Ve.length < t - 1)
          return Ve.push([L, te]), this.size = ++le.size, this;
        le = this.__data__ = new rn(Ve);
      }
      return le.set(L, te), this.size = le.size, this;
    }
    W.prototype.clear = pe, W.prototype.delete = ce, W.prototype.get = Ce, W.prototype.has = _e, W.prototype.set = rt;
    function ut(L, te) {
      var le = Ti(L), Ve = !le && ls(L), pt = !le && !Ve && us(L), _t = !le && !Ve && !pt && Ae(L), Wr = le || Ve || pt || _t, Vn = Wr ? pn(L.length, String) : [], ai = Vn.length;
      for (var Vi in L)
        Wr && // Safari 9 has enumerable `arguments.length` in strict mode.
        (Vi == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        pt && (Vi == "offset" || Vi == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        _t && (Vi == "buffer" || Vi == "byteLength" || Vi == "byteOffset") || // Skip index properties.
        Xe(Vi, ai)) || Vn.push(Vi);
      return Vn;
    }
    function nt(L, te, le) {
      var Ve = L[te];
      (!(tt.call(L, te) && os(Ve, le)) || le === void 0 && !(te in L)) && vr(L, te, le);
    }
    function Jt(L, te) {
      for (var le = L.length; le--; )
        if (os(L[le][0], te))
          return le;
      return -1;
    }
    function vr(L, te, le) {
      te == "__proto__" && or ? or(L, te, {
        configurable: !0,
        enumerable: !0,
        value: le,
        writable: !0
      }) : L[te] = le;
    }
    function jr(L, te, le, Ve, pt, _t) {
      var Wr;
      if (le && (Wr = pt ? le(L, Ve, pt, _t) : le(L)), Wr !== void 0)
        return Wr;
      if (!oa(L))
        return L;
      var Vn = Ti(L);
      if (Vn)
        Wr = be(L);
      else {
        var ai = fe(L), Vi = ai == x || ai == k;
        if (us(L))
          return Zn(L);
        if (ai == M || ai == f || Vi && !pt)
          Wr = {};
        else {
          if (!st[ai])
            return pt ? L : {};
          Wr = Me(L, ai);
        }
      }
      _t || (_t = new W());
      var Dl = _t.get(L);
      if (Dl)
        return Dl;
      _t.set(L, Wr), V(L) ? L.forEach(function(la) {
        Wr.add(jr(la, te, le, la, L, _t));
      }) : T(L) && L.forEach(function(la, va) {
        Wr.set(va, jr(la, te, le, va, L, _t));
      });
      var Pl = lt, Io = Vn ? void 0 : Pl(L);
      return Yr(Io || L, function(la, va) {
        Io && (va = la, la = L[va]), nt(Wr, va, jr(la, te, le, va, L, _t));
      }), Wr;
    }
    function fn(L, te, le, Ve, pt) {
      var _t = -1, Wr = L.length;
      for (le || (le = Ke), pt || (pt = []); ++_t < Wr; ) {
        var Vn = L[_t];
        le(Vn) ? Vr(pt, Vn) : pt[pt.length] = Vn;
      }
      return pt;
    }
    function Kn(L, te) {
      te = En(te, L);
      for (var le = 0, Ve = te.length; L != null && le < Ve; )
        L = L[Yi(te[le++])];
      return le && le == Ve ? L : void 0;
    }
    function Ln(L, te, le) {
      var Ve = te(L);
      return Ti(L) ? Ve : Vr(Ve, le(L));
    }
    function vn(L) {
      return L == null ? L === void 0 ? se : R : Nt && Nt in Object(L) ? Br(L) : Gr(L);
    }
    function Or(L) {
      return Ui(L) && vn(L) == f;
    }
    function Gn(L) {
      return Ui(L) && fe(L) == F;
    }
    function Bn(L) {
      if (!oa(L) || pr(L))
        return !1;
      var te = cs(L) ? P : Gt;
      return te.test(di(L));
    }
    function Mn(L) {
      return Ui(L) && fe(L) == q;
    }
    function Ri(L) {
      return Ui(L) && fs(L.length) && !!St[vn(L)];
    }
    function yi(L) {
      if (!oa(L))
        return Fr(L);
      var te = yr(L), le = [];
      for (var Ve in L)
        Ve == "constructor" && (te || !tt.call(L, Ve)) || le.push(Ve);
      return le;
    }
    var Ai = or ? function(L, te) {
      return or(L, "toString", {
        configurable: !0,
        enumerable: !1,
        value: Bt(te),
        writable: !0
      });
    } : Kt;
    function _n(L, te, le) {
      var Ve = -1, pt = L.length;
      te < 0 && (te = -te > pt ? 0 : pt + te), le = le > pt ? pt : le, le < 0 && (le += pt), pt = te > le ? 0 : le - te >>> 0, te >>>= 0;
      for (var _t = Array(pt); ++Ve < pt; )
        _t[Ve] = L[Ve + te];
      return _t;
    }
    function ki(L) {
      if (typeof L == "string")
        return L;
      if (Ti(L))
        return Zr(L, ki) + "";
      if (Q(L))
        return wn ? wn.call(L) : "";
      var te = L + "";
      return te == "0" && 1 / L == -1 / 0 ? "-0" : te;
    }
    function Un(L, te) {
      te = En(te, L);
      var le = -1, Ve = te.length;
      if (!Ve)
        return !0;
      for (; ++le < Ve; ) {
        var pt = Yi(te[le]);
        if (pt === "__proto__" && !tt.call(L, "__proto__") || (pt === "constructor" || pt === "prototype") && le < Ve - 1)
          return !1;
      }
      var _t = Wi(L, te);
      return _t == null || delete _t[Yi(La(te))];
    }
    function En(L, te) {
      return Ti(L) ? L : yt(L, te) ? [L] : qn(ve(L));
    }
    function Zn(L, te) {
      return L.slice();
    }
    function lr(L) {
      var te = new L.constructor(L.byteLength);
      return new ue(te).set(new ue(L)), te;
    }
    function In(L, te) {
      var le = lr(L.buffer);
      return new L.constructor(le, L.byteOffset, L.byteLength);
    }
    function bi(L) {
      var te = new L.constructor(L.source, Pr.exec(L));
      return te.lastIndex = L.lastIndex, te;
    }
    function I(L) {
      return xr ? Object(xr.call(L)) : {};
    }
    function $(L, te) {
      var le = lr(L.buffer);
      return new L.constructor(le, L.byteOffset, L.length);
    }
    function ae(L, te, le, Ve) {
      var pt = !le;
      le || (le = {});
      for (var _t = -1, Wr = te.length; ++_t < Wr; ) {
        var Vn = te[_t], ai = void 0;
        ai === void 0 && (ai = L[Vn]), pt ? vr(le, Vn, ai) : nt(le, Vn, ai);
      }
      return le;
    }
    function xe(L) {
      return _(L) ? void 0 : L;
    }
    function ht(L) {
      return aa(yn(L, void 0, Na), L + "");
    }
    function lt(L) {
      return Ln(L, Te, Z);
    }
    function Ht(L, te) {
      var le = L.__data__;
      return Ot(te) ? le[typeof te == "string" ? "string" : "hash"] : le.map;
    }
    function Ut(L, te) {
      var le = Tr(L, te);
      return Bn(le) ? le : void 0;
    }
    function Br(L) {
      var te = tt.call(L, Nt), le = L[Nt];
      try {
        L[Nt] = void 0;
        var Ve = !0;
      } catch {
      }
      var pt = Xr.call(L);
      return Ve && (te ? L[Nt] = le : delete L[Nt]), pt;
    }
    var B = Lt ? function(L) {
      return L == null ? [] : (L = Object(L), kr(Lt(L), function(te) {
        return We.call(L, te);
      }));
    } : qt, Z = Lt ? function(L) {
      for (var te = []; L; )
        Vr(te, B(L)), L = Fe(L);
      return te;
    } : qt, fe = vn;
    (Ye && fe(new Ye(new ArrayBuffer(1))) != ye || Ct && fe(new Ct()) != F || dt && fe(dt.resolve()) != j || Rt && fe(new Rt()) != q || Et && fe(new Et()) != oe) && (fe = function(L) {
      var te = vn(L), le = te == M ? L.constructor : void 0, Ve = le ? di(le) : "";
      if (Ve)
        switch (Ve) {
          case er:
            return ye;
          case dr:
            return F;
          case $t:
            return j;
          case On:
            return q;
          case Fn:
            return oe;
        }
      return te;
    });
    function be(L) {
      var te = L.length, le = new L.constructor(te);
      return te && typeof L[0] == "string" && tt.call(L, "index") && (le.index = L.index, le.input = L.input), le;
    }
    function Me(L, te, le) {
      var Ve = L.constructor;
      switch (te) {
        case he:
          return lr(L);
        case v:
        case y:
          return new Ve(+L);
        case ye:
          return In(L);
        case Ue:
        case Re:
        case Oe:
        case ee:
        case re:
        case de:
        case Be:
        case ke:
        case ze:
          return $(L);
        case F:
          return new Ve();
        case S:
        case Y:
          return new Ve(L);
        case ie:
          return bi(L);
        case q:
          return new Ve();
        case J:
          return I(L);
      }
    }
    function Ke(L) {
      return Ti(L) || ls(L) || !!(Pt && L && L[Pt]);
    }
    function Xe(L, te) {
      var le = typeof L;
      return te = te ?? d, !!te && (le == "number" || le != "symbol" && ar.test(L)) && L > -1 && L % 1 == 0 && L < te;
    }
    function yt(L, te) {
      if (Ti(L))
        return !1;
      var le = typeof L;
      return le == "number" || le == "symbol" || le == "boolean" || L == null || Q(L) ? !0 : qe.test(L) || !je.test(L) || te != null && L in Object(te);
    }
    function Ot(L) {
      var te = typeof L;
      return te == "string" || te == "number" || te == "symbol" || te == "boolean" ? L !== "__proto__" : L === null;
    }
    function pr(L) {
      return !!Nr && Nr in L;
    }
    function yr(L) {
      var te = L && L.constructor, le = typeof te == "function" && te.prototype || zt;
      return L === le;
    }
    function ur(L) {
      var te = sa(L, function(Ve) {
        return le.size === a && le.clear(), Ve;
      }), le = te.cache;
      return te;
    }
    function Fr(L) {
      var te = [];
      if (L != null)
        for (var le in Object(L))
          te.push(le);
      return te;
    }
    function Gr(L) {
      return Xr.call(L);
    }
    function yn(L, te, le) {
      return te = Ie(te === void 0 ? L.length - 1 : te, 0), function() {
        for (var Ve = arguments, pt = -1, _t = Ie(Ve.length - te, 0), Wr = Array(_t); ++pt < _t; )
          Wr[pt] = Ve[te + pt];
        pt = -1;
        for (var Vn = Array(te + 1); ++pt < te; )
          Vn[pt] = Ve[pt];
        return Vn[te] = le(Wr), ir(L, this, Vn);
      };
    }
    function Wi(L, te) {
      return te.length < 2 ? L : Kn(L, _n(te, 0, -1));
    }
    var aa = Qi(Ai);
    function Qi(L) {
      var te = 0, le = 0;
      return function() {
        var Ve = Qe(), pt = c - (Ve - le);
        if (le = Ve, pt > 0) {
          if (++te >= u)
            return arguments[0];
        } else
          te = 0;
        return L.apply(void 0, arguments);
      };
    }
    var qn = ur(function(L) {
      var te = [];
      return L.charCodeAt(0) === 46 && te.push(""), L.replace(Ge, function(le, Ve, pt, _t) {
        te.push(pt ? _t.replace(rr, "$1") : Ve || le);
      }), te;
    });
    function Yi(L) {
      if (typeof L == "string" || Q(L))
        return L;
      var te = L + "";
      return te == "0" && 1 / L == -1 / 0 ? "-0" : te;
    }
    function di(L) {
      if (L != null) {
        try {
          return Er.call(L);
        } catch {
        }
        try {
          return L + "";
        } catch {
        }
      }
      return "";
    }
    function Na(L) {
      var te = L == null ? 0 : L.length;
      return te ? fn(L) : [];
    }
    function La(L) {
      var te = L == null ? 0 : L.length;
      return te ? L[te - 1] : void 0;
    }
    function sa(L, te) {
      if (typeof L != "function" || te != null && typeof te != "function")
        throw new TypeError(n);
      var le = function() {
        var Ve = arguments, pt = te ? te.apply(this, Ve) : Ve[0], _t = le.cache;
        if (_t.has(pt))
          return _t.get(pt);
        var Wr = L.apply(this, Ve);
        return le.cache = _t.set(pt, Wr) || _t, Wr;
      };
      return le.cache = new (sa.Cache || rn)(), le;
    }
    sa.Cache = rn;
    function os(L, te) {
      return L === te || L !== L && te !== te;
    }
    var ls = Or(/* @__PURE__ */ (function() {
      return arguments;
    })()) ? Or : function(L) {
      return Ui(L) && tt.call(L, "callee") && !We.call(L, "callee");
    }, Ti = Array.isArray;
    function Ua(L) {
      return L != null && fs(L.length) && !cs(L);
    }
    var us = K || qr;
    function cs(L) {
      if (!oa(L))
        return !1;
      var te = vn(L);
      return te == x || te == k || te == g || te == G;
    }
    function fs(L) {
      return typeof L == "number" && L > -1 && L % 1 == 0 && L <= d;
    }
    function oa(L) {
      var te = typeof L;
      return L != null && (te == "object" || te == "function");
    }
    function Ui(L) {
      return L != null && typeof L == "object";
    }
    var T = wr ? gn(wr) : Gn;
    function _(L) {
      if (!Ui(L) || vn(L) != M)
        return !1;
      var te = Fe(L);
      if (te === null)
        return !0;
      var le = tt.call(te, "constructor") && te.constructor;
      return typeof le == "function" && le instanceof le && Er.call(le) == Se;
    }
    var V = an ? gn(an) : Mn;
    function Q(L) {
      return typeof L == "symbol" || Ui(L) && vn(L) == J;
    }
    var Ae = _r ? gn(_r) : Ri;
    function ve(L) {
      return L == null ? "" : ki(L);
    }
    function Te(L) {
      return Ua(L) ? ut(L) : yi(L);
    }
    var $e = ht(function(L, te) {
      var le = {};
      if (L == null)
        return le;
      var Ve = !1;
      te = Zr(te, function(_t) {
        return _t = En(_t, L), Ve || (Ve = _t.length > 1), _t;
      }), ae(L, lt(L), le), Ve && (le = jr(le, s | o | l, xe));
      for (var pt = te.length; pt--; )
        Un(le, te[pt]);
      return le;
    });
    function Bt(L) {
      return function() {
        return L;
      };
    }
    function Kt(L) {
      return L;
    }
    function qt() {
      return [];
    }
    function qr() {
      return !1;
    }
    r.exports = $e;
  })(Mf, Mf.exports)), Mf.exports;
}
var NU = _U();
const LU = /* @__PURE__ */ Bs(NU);
function Jy(r, e) {
  function t(n) {
    if (typeof n > "u" || !Array.isArray(n) && !VU(n))
      return n;
    if (Array.isArray(n))
      return Jy(n, e);
    let i = {};
    for (const [a, s] of Object.entries(n))
      i[a] = UU(s) ? s : Jy(s, e);
    return LU(i, e);
  }
  return Array.isArray(r) ? r.map(t) : t(r);
}
function UU(r) {
  return r == null;
}
function VU(r) {
  return typeof r == "object" && !Array.isArray(r) && r !== null;
}
function fE(r, e) {
  return r == null && e == null ? !0 : r === e;
}
function $F(r) {
  const e = /* @__PURE__ */ new Map();
  return r?.aspects?.forEach((t) => {
    t.value !== "" && e.set(t.name, !0);
  }), e;
}
class zU extends YA {
  constructor(e) {
    super(), this.update = e;
  }
  async execute() {
    await this.update(), await new Promise((e) => {
      window.setTimeout(() => {
        e();
      }, 1e3);
    });
  }
}
function Av(r) {
  return Jy(r, ["__typename"]);
}
class $U {
  constructor(e, t, n, i, a) {
    this.stateUpdateQueue = new XA(1), this.mandatoryFulfilledAspects = /* @__PURE__ */ new Map(), this.bundleId = e, this.bundleOwnerId = t, this.configuration = n, this.bundleOptions = a;
    const s = a?.existingGlobalPropertyState;
    this.initPromise = s ? Promise.resolve(s).then(() => {
      console.log("Setting global property state to existing state."), this.globalPropertyState = Av(s), this.recalculateMandatoryStates();
    }) : this.createGlobalPropertyState().then((o) => {
      console.log("Setting global property state to new state."), this.globalPropertyState = Av(o), this.recalculateMandatoryStates();
    }), this.onGlobalPropertyStateChange = i;
  }
  async clearAspects(e) {
    if (!this.globalPropertyState)
      throw new Error("Global property state not initialized");
    const t = this.globalPropertyState.aspects;
    this.globalPropertyState.aspects = t.filter((n) => !e.includes(n.name));
  }
  recalculateMandatoryStates() {
    this.mandatoryFulfilledAspects = $F(this.globalPropertyState);
  }
  setBundleOptions(e) {
    this.bundleOptions = e;
  }
  getBundleOptions() {
    return this.bundleOptions;
  }
  setConfiguration(e) {
    this.configuration = e;
  }
  getInitializationPromise() {
    return this.initPromise;
  }
  getGlobalPropertyState() {
    return this.globalPropertyState;
  }
  async setGlobalPropertyState(e) {
    this.globalPropertyState || await this.initPromise;
    const t = ho(this.globalPropertyState);
    this.globalPropertyState = { ...Av(e), id: t.id }, this.recalculateMandatoryStates(), this.queueGlobalPropertyStateUpdate(), await this.onGlobalPropertyStateChange(t, this.globalPropertyState);
  }
  getAspectMandatoryFulfilled(e) {
    return this.mandatoryFulfilledAspects.get(e);
  }
  getAspectHidden(e) {
    if (!this.globalPropertyState)
      throw new Error("Global property state not initialized");
    return !!this.globalPropertyState.aspects.find((t) => t.name === e)?.hidden;
  }
  getAspect(e, t) {
    if (!this.globalPropertyState)
      throw new Error("Global property state not initialized");
    const n = this.globalPropertyState.aspects.find((i) => i.name === e && fE(i.channel, t));
    if (n)
      return n.value;
  }
  getAspectStorage(e, t) {
    if (!this.globalPropertyState)
      throw new Error("Global property state not initialized");
    return this.globalPropertyState.aspects.find((n) => n.name === e && fE(n.channel, t))?.storage;
  }
  async setAspect(e, t, n, i, a) {
    if (!this.globalPropertyState)
      throw new Error("Global property state not initialized");
    if (!this.configuration)
      throw new Error("Global property configuration not linked to the state manager.");
    const s = this.configuration.aspects.find((u) => u.name === e);
    if (!s)
      throw new Error(`Failed to find configuration aspect with name: ${e}`);
    this.mandatoryFulfilledAspects.set(e, t !== "");
    const o = ho(this.globalPropertyState), l = this.globalPropertyState.aspects.filter((u) => u.name === e);
    if (l.length > 0)
      if (i) {
        const u = l.find((c) => c.channel === i);
        if (u)
          u.value = t, u.type = s.type, u.channel = i, u.hidden = a ?? u.hidden, n !== void 0 && (u.storage = n !== null ? n : void 0);
        else {
          let c;
          if (i === 1) {
            const d = this.globalPropertyState.aspects.findIndex(
              (f) => !f.channel && f.name === e
            );
            d && d > 0 && (c = this.globalPropertyState.aspects.splice(d, 1)[0].hidden);
          }
          this.globalPropertyState.aspects.push({
            name: e,
            value: t,
            type: s.type,
            storage: n !== null ? n : void 0,
            channel: i,
            hidden: a ?? c
          });
        }
      } else {
        const u = l[0];
        u.value = t, u.type = s.type, u.hidden = a ?? u.hidden, n !== void 0 && (u.storage = n !== null ? n : void 0);
      }
    else
      this.globalPropertyState.aspects.push({
        name: e,
        value: t,
        type: s.type,
        storage: n !== null ? n : void 0,
        channel: i,
        hidden: a
      });
    ld(o, this.globalPropertyState) || (this.queueGlobalPropertyStateUpdate(), await this.onGlobalPropertyStateChange(o, this.globalPropertyState));
  }
  async setAspectStorage(e, t, n) {
    if (!this.globalPropertyState)
      throw new Error("Global property state not initialized");
    if (!this.configuration)
      throw new Error("Global property configuration not linked to the state manager.");
    const i = this.configuration.aspects.find((o) => o.name === e);
    if (!i)
      throw new Error(`Failed to find configuration aspect with name: ${e}`);
    const a = ho(this.globalPropertyState), s = this.globalPropertyState.aspects.filter((o) => o.name === e);
    if (s.length > 0)
      if (n) {
        const o = s.find((l) => l.channel === n);
        o && (o.storage = t !== null ? t : void 0, o.type = i.type);
      } else {
        const o = s[0];
        o.storage = t !== null ? t : void 0, o.type = i.type;
      }
    else
      this.globalPropertyState.aspects.push({
        name: e,
        value: "",
        type: i.type,
        storage: t !== null ? t : void 0,
        channel: n
      });
    ld(a, this.globalPropertyState) || (this.queueGlobalPropertyStateUpdate(), await this.onGlobalPropertyStateChange(a, this.globalPropertyState));
  }
  queueGlobalPropertyStateUpdate() {
    this.stateUpdateQueue.enqueue(
      new zU(async () => {
        await this.updateGlobalPropertyState();
      })
    );
  }
  async updateGlobalPropertyState() {
    if (!this.globalPropertyState)
      throw new Error("Global property state not initialized");
    if (!(await He.getShadowGraphqlClient().mutate({
      mutation: vL,
      variables: {
        id: this.globalPropertyState.id,
        aspects: this.globalPropertyState.aspects.map((t) => {
          let n = t.type && t.storage ? {} : void 0;
          if (n)
            switch (t.type) {
              case Qn.FileUpload: {
                n.fileUpload = t.storage;
                break;
              }
              case Qn.ColorOption:
              case Qn.Option: {
                n.option = t.storage;
                break;
              }
            }
          return {
            name: t.name,
            value: t.value,
            type: t.type,
            storage: n,
            channel: t.channel,
            hidden: t.hidden
          };
        })
      },
      context: {
        headers: {
          bundleOwnerId: this.bundleOwnerId,
          ...this.bundleOptions?.additionalHeaders
        }
      }
    })).data?.globalPropertyStateUpdate)
      throw new Error("Unable to update global property state");
  }
  async createGlobalPropertyState() {
    const e = await He.getShadowGraphqlClient().mutate({
      mutation: mL,
      variables: {
        bundleId: this.bundleId
      },
      context: {
        headers: {
          bundleOwnerId: this.bundleOwnerId,
          ...this.bundleOptions?.additionalHeaders
        }
      }
    });
    if (e.data?.globalPropertyStateCreate && e.data.globalPropertyStateCreate.id)
      return e.data.globalPropertyStateCreate;
    throw new Error(`Unable to create global property state for bundle: ${this.bundleId}`);
  }
}
class HU {
  constructor(e) {
    this.setState(e || '{"transactions": []}');
  }
  setState(e) {
    e && (this.state = JSON.parse(e));
  }
  getState() {
    return this.state;
  }
  removeStateForTransaction(e) {
    if (!this.state || !this.state.transactions)
      return;
    const t = this.state.transactions.findIndex((n) => n.transactionId === e);
    t !== -1 && this.state.transactions.splice(t, 1);
  }
  getSerializedState() {
    if (this.state)
      return this.deleteFieldNameFromObjectRecursive(this.state, "__typename"), JSON.stringify(this.state);
  }
  deleteFieldNameFromObjectRecursive(e, t) {
    if (!(typeof e != "object" || e === null))
      for (const n in e)
        n === t ? delete e[n] : this.deleteFieldNameFromObjectRecursive(e[n], t);
  }
}
const jU = Ee`
    query GetManyMetafields($entityIds: [String!]!) {
        metafieldsMany(entityIds: $entityIds) {
            id
            value
            metafieldConfiguration {
                id
                metafieldType
                name
            }
        }
    }
`;
class GU {
  constructor() {
    this.internalMap = /* @__PURE__ */ new Map();
  }
  /**
   * Given a specific entity, request the given keys for that entity.
   * This will first check if the keys are already present in the internal map, and if not, it will fetch them from the server.
   * @param entityId The entity to check.
   * @param keys The keys to look for.
   * @returns Returns map of keys and values for the given entity. Missing keys will not be present. Use map.has() to check if a key was present.
   */
  async requestKeysForEntity(e, t) {
    const n = /* @__PURE__ */ new Map();
    return await this.ensureIdsArePresent([e]), t.forEach((i) => {
      const a = this.requestKeyForEntityIfAvailable(e, i);
      a && n.set(i, a);
    }), n;
  }
  async ensureIdsArePresent(e) {
    if (e.every((n) => this.internalMap.has(n))) return;
    const t = await He.getShadowGraphqlClient().query({
      query: jU,
      errorPolicy: "all",
      variables: {
        entityIds: e.filter((n) => !this.internalMap.has(n))
      }
    });
    e.forEach((n, i) => {
      const a = t.data.metafieldsMany[i];
      this.internalMap.set(
        n,
        a.map((s) => ({
          key: s.metafieldConfiguration.name,
          value: s.value,
          metafieldConfigurationId: s.metafieldConfiguration.id,
          metafieldType: s.metafieldConfiguration.metafieldType
        }))
      );
    });
  }
  /**
   * Returns a metafield for this product if available. Fetching from the server if not available locally.
   * @param entityId The entity to request a field for.
   * @param key The field name to request
   * @returns A promise resolving to the field if available or undefined if not.
   */
  async requestKeyForEntity(e, t) {
    if (!this.internalMap.has(e))
      return;
    let n = this.internalMap.get(e);
    const i = n.find((a) => a.key === t);
    return i || (await this.ensureIdsArePresent([e]), n = this.internalMap.get(e)), i ? JSON.parse(i.value) : void 0;
  }
  /**
   * Returns a metafield for this product if available. Checks locally only, use ensureIdsArePresent to fetch first from the server.
   * @param entityId The entity to request a field for.
   * @param key The field name to request
   * @returns A promise resolving to the field if available or undefined if not.
   */
  requestKeyForEntityIfAvailable(e, t) {
    if (!this.internalMap.has(e))
      return;
    const i = this.internalMap.get(e).find((a) => a.key === t);
    if (i)
      return JSON.parse(i.value);
  }
  /*
   * Returns a metafield for this product if available. Checks locally only, use ensureIdsArePresent to fetch first from the server.
   * The metafield value in the returned value will need to be parsed to be used.
   * Uses the metafield configuration ID as opposed to the metafield name.
   */
  requestIfAvailable(e, t) {
    return this.internalMap.has(e) ? this.internalMap.get(e).find((a) => a.metafieldConfigurationId === t) : void 0;
  }
}
const Ky = new GU();
var qU = /* @__PURE__ */ ((r) => (r.Default = "Default", r.Name = "Name", r.Price = "Price", r))(qU || {});
class HF {
  constructor(e) {
    this.fullFetched = !1, this.collection = e;
    const t = this.collection.productCollectionProducts;
    t && t.length >= this.collection.total && (this.fullFetched = !0);
  }
  /**
   * The ID of the product collection.
   */
  getId() {
    return this.collection.id;
  }
  /**
   * The name of the collection.
   */
  getName() {
    return this.collection.name;
  }
  /**
   * The description of the collection.
   */
  getDescription() {
    return this.collection.description || "";
  }
  /**
   * The start date of the dispatch.
   * @returns The start date of the dispatch or undefined if not set.
   */
  getDispatchStartDate() {
    if (this.collection.dispatchStartDate)
      return new Date(this.collection.dispatchStartDate);
  }
  /**
   * The end date of the dispatch.
   * @returns The end date of the dispatch or undefined if not set.
   */
  getDispatchEndDate() {
    if (this.collection.dispatchEndDate)
      return new Date(this.collection.dispatchEndDate);
  }
  /**
   * The image of the collection.
   */
  getImage() {
    return this.collection.image;
  }
  /**
   * A list of products in this collections with useful helpers for interacting with them.
   */
  getProducts() {
    if (!this.collection.productCollectionProducts)
      throw new Error("Failed to find products on collection. Ensure you fetch them first!");
    return this.collection.productCollectionProducts.filter((e) => !!e.product).map((e) => new pp(e));
  }
  /**
   * A list of products in this collections with useful helpers for interacting with them.
   */
  async fetchProducts(e) {
    if (this.fullFetched)
      return (this.collection.productCollectionProducts ?? []).filter((i) => !!i.product).map((i) => new pp(i));
    const t = await He.getShadowGraphqlClient().query({
      query: xL,
      variables: {
        id: this.getId(),
        productIds: e
      },
      errorPolicy: "all"
    }), n = this.collection.productCollectionProducts || [];
    return this.collection.productCollectionProducts = [
      ...n,
      ...t.data.productCollections[0].productCollectionProducts?.filter(
        (i) => !n.some((a) => i.id === a.id)
      ) || []
    ], this.collection.productCollectionProducts.length >= this.collection.total && (this.fullFetched = !0), this.collection.productCollectionProducts.filter((i) => !!i.product && (!e || e.includes(i.product.id))).map((i) => new pp(i));
  }
  /**
   * Fetches a paginated feed of products.
   * @param offset The zero-based start index.
   * @param limit The maximum number of products to return.
   * @param productFilters Optional product metafields to filter the products by.
   * @param tags Optional object of tag filters to apply.
   * @param sortKey Optional field of the products to sort by.
   * @param sortDescending Optional boolean to indicate if the sort should be in descending order.
   * @param quickSearch Optional string to filter products by name.
   * @param workflowFilters Optional workflow metafields to filter the products and their workflows by.
   * @returns
   */
  async fetchProductsFeed(e, t, n, i, a, s, o, l) {
    const u = {
      id: this.getId(),
      productFilters: n ? {
        link: "And",
        metafields: n
      } : void 0,
      productWorkflowFilters: l ? {
        link: "And",
        metafields: l
      } : void 0,
      tags: i ? {
        include: i.include ?? [],
        exclude: i.exclude ?? []
      } : void 0,
      sortKey: a,
      sortDescending: s,
      quickSearch: o
    };
    if (this.fullFetched) {
      const h = await He.getShadowGraphqlClient().query({
        query: CL,
        errorPolicy: "all",
        variables: u
      });
      if (!h.data?.productCollections || h.data?.productCollections.length === 0)
        throw new Error("Failed to filter product collection products.");
      const g = this.getProducts(), v = /* @__PURE__ */ new Map();
      for (const A of g)
        v.set(A.getId(), A);
      const y = h.data.productCollections[0].productCollectionProductsFeed.items.map((A) => v.get(A.product.id)).filter((A) => !!A);
      return {
        total: y.length,
        items: y.slice(e, e + t)
      };
    }
    const c = new AbortController(), { signal: d } = c, f = He.getShadowGraphqlClient().watchQuery({
      query: SL,
      variables: { ...u, limit: t, offset: e },
      errorPolicy: "all",
      fetchPolicy: "cache-first",
      returnPartialData: !0,
      context: {
        fetchOptions: {
          signal: d
        }
      }
    });
    return new Promise((h) => {
      let g = !1;
      const v = f.subscribe({
        next(y) {
          if (g || y.partial && (!y.data.productCollections || y.data.productCollections.length === 0 || !y.data.productCollections[0].productCollectionProductsFeed?.items || y.data.productCollections[0].productCollectionProductsFeed?.items.length === 0))
            return;
          c.abort(), g = !0, v.unsubscribe();
          const A = y.data.productCollections?.[0].productCollectionProductsFeed?.items.filter((x) => !!x.product).map((x) => new pp(ho(x))) || [];
          h({
            items: A,
            // Clone items because it could be cached data (immutable)
            total: y.data.productCollections?.[0].productCollectionProductsFeed?.total ?? 0
          });
        },
        error() {
          g || (g = !0, v.unsubscribe(), h({ items: [], total: 0 }));
        }
      });
    });
  }
  /**
   * The raw collection resource. This is generally not needed and should be avoided.
   */
  getResource() {
    return this.collection;
  }
}
class pp {
  constructor(e) {
    this.product = e.product, this.productResource = e;
  }
  /**
   * The ID of the product in SpiffCommerce.
   * @returns
   */
  getId() {
    return this.product.id;
  }
  /**
   * The name of the product. Human readable.
   */
  getName() {
    return this.product.name;
  }
  /**
   * A helper function for getting integrations
   * @param type The type of integration you want.
   * @param externalId An external integration ID to further filter by. Otherwise we return the first encountered.
   * @returns The integration if found. Throws an error if not found as this data is typically a neccesity.
   */
  getIntegrationByType(e, t) {
    const i = (this.product.integrationProducts || []).find((a) => {
      const s = a.integration?.type, o = a.integration?.type === e, l = t ? a.integration?.externalIntegrationId === t : !0;
      return s && o && l;
    });
    if (!i)
      throw new Error(
        "Failed to find requested integration type on product. This is generally due to a configuration error"
      );
    return i;
  }
  getCurrentIntegration() {
    const t = (this.product.integrationProducts || []).find((n) => n.integration?.isCurrent);
    if (!t)
      throw new Error(
        `Product: ${this.productResource.id} is not linked to this current integration. This is generally due to a configuration error.`
      );
    return t;
  }
  /**
   * A helper function for pulling the default workflow.
   */
  getDefaultWorkflow() {
    const e = this.product.workflows;
    if (e === void 0)
      throw new ao(
        "Called getDefaultWorkflow() before fetching collection products. Use collection.fetchProducts() first to ensure the data is available."
      );
    if (e.length === 0)
      throw new ao(
        "Called getDefaultWorkflow() but no workflows on requested product. Ensure at least 1 workflow is assigned to this product."
      );
    const t = this.productResource.workflowId;
    if (t) {
      const n = e.find((i) => i.workflowName === t);
      if (n) return new Gf(n);
    }
    if (e.length === 1)
      return new Gf(e[0]);
    throw new ao(
      "Called getDefaultWorkflow() but no default workflow is configured for the requested product. Multiple workflows exist so we can't assume!"
    );
  }
  /**
   * @returns All workflows associated with this Product.
   */
  getAllWorkflows() {
    if ((this.product.workflows || []).length === 0)
      throw new ao(
        "No workflows on configured product. Ensure at least 1 workflow is assigned to this product."
      );
    return this.product.workflows.sort((t, n) => (t.index ?? 0) - (n.index ?? 0)).map((t) => new Gf(t));
  }
  /**
   * A list of all integrations this product is connected to.
   */
  getIntegrations() {
    return this.product.integrationProducts || [];
  }
  /**
   * The raw product resource. This is generally not needed and should be avoided.
   */
  getResource() {
    return this.product;
  }
  /**
   * Gets the base price of the product. Optionally include additional product pricing.
   * @param includeAdditionalProduct Optionally include additional product pricing. You must provide at least one of the fields on this object.
   * @returns
   */
  getBasePrice(e) {
    const t = this.product.basePrice || 0;
    if (!e) return t;
    if (!e.integrationType && !e.externalId && !e.integrationId)
      throw new Error(
        "You must provide at least one of the following fields on the includeAdditionalProduct object: integrationType, externalId, integrationId"
      );
    let n;
    return e.integrationId ? n = this.product.integrationProducts?.find(
      (i) => i.integration?.id === e.integrationId
    ) : e.externalId ? n = this.product.integrationProducts?.find(
      (i) => i.integration?.externalIntegrationId === e.externalId
    ) : n = this.product.integrationProducts?.find(
      (i) => i.integration?.type === e.integrationType
    ), n?.additionalIntegrationProduct?.product ? t + (n.additionalIntegrationProduct.product.basePrice || 0) : t;
  }
  /**
   * Requests a set of metafields for this product. Metafields that are not available locally will be fetched from the server.
   * @param keys The set of metafield keys to request.
   * @returns A map of metafield key to value. Any unavailable keys will not be present in the map. use map.has() to check if a key is present.
   */
  async requestMetafields(e) {
    return Ky.requestKeysForEntity(this.product.id, e);
  }
}
class Gf {
  constructor(e) {
    this.workflow = e;
  }
  /**
   * @returns The ID of this workflow, to be used when starting an experience.
   */
  getId() {
    return this.workflow.workflowName;
  }
  /**
   * @returns The name of the workflow.
   */
  getName() {
    return this.workflow.friendlyName;
  }
  /**
   * An image to be used to display this workflow in a UI to the customer.
   * @returns A resource URL.
   */
  getThumbnail(e = 128, t) {
    const n = this.workflow?.imageUrl, i = window?.devicePixelRatio || 1;
    if (n)
      return $A(n, e * i, "webp", t);
  }
}
const WU = Ee`
    ${Ng(!1)}
    query GetProductCollections($ids: [String!]!) {
        productCollections(ids: $ids) {
            ...ProductCollectionFields
        }
    }
`, $Q = async (r) => (await He.getShadowGraphqlClient().query({
  query: WU,
  errorPolicy: "all",
  variables: {
    ids: r
  }
})).data?.productCollections?.map((t) => new HF(t));
class QU {
  constructor() {
    this.listeners = {};
  }
  // Add a listener for a specific event type
  on(e, t) {
    this.listeners[e] || (this.listeners[e] = []), this.listeners[e].push(t);
  }
  // Remove a listener for a specific event type
  off(e, t) {
    this.listeners[e] && (this.listeners[e] = this.listeners[e].filter((n) => n !== t));
  }
  // Emit an event with the given payload
  emit(e, t) {
    if (this.listeners[e])
      for (const n of this.listeners[e])
        n(t);
  }
  // Clear all listeners for a specific event or all events
  clear(e) {
    if (e)
      delete this.listeners[e];
    else
      for (const t in this.listeners)
        delete this.listeners[t];
  }
}
const YU = Ee`
    mutation AddAddressToBundle(
        $bundleId: String!
        $streetAddress: String
        $apartment: String
        $city: String
        $country: String
        $state: String
        $postCode: String
    ) {
        addressAttachToBundle(
            bundleId: $bundleId
            streetAddress: $streetAddress
            apartment: $apartment
            city: $city
            country: $country
            state: $state
            postCode: $postCode
        ) {
            id
        }
    }
`, XU = Ee`
    mutation AddOrganizationToBundle($bundleId: String!, $organizationName: String!) {
        organizationAttachToBundle(bundleId: $bundleId, organizationName: $organizationName) {
            id
        }
    }
`, JU = Ee`
    mutation GenerateQuoteId($id: String!) {
        bundleGenerateQuoteId(id: $id) {
            id
            quoteId
        }
    }
`;
class dE {
  constructor(e, t, n, i, a, s, o) {
    this.workflowExperiences = [], this.eventEmitter = new QU(), this.updatesLocked = !1, this.client = e, this.id = t.id, this.name = t.name || "", this.dispatchDate = t.dispatchDate, this.purchaseOrder = t.purchaseOrder, this.template = t.template || !1, this.quoteId = t.quoteId, this.shareActions = t.bundleShareActions, this.workflowViewerLink = t.workflowViewerLink, this.workflowViewerAmendLink = t.workflowViewerAmendLink, this.ownerId = a, this.metadata = new Map(t.metadata?.map((u) => [u.key, u.value]) || []), this.completed = t.completed ?? !1, this.productCollection = t.productCollection, this.bundleStateManager = new HU(t.bundleStateData);
    const l = this.productCollection?.globalPropertyConfiguration;
    this.globalConfigurationPropertyId = l?.id, this.globalPropertyStateManager = new $U(
      this.id,
      this.ownerId,
      l,
      this.onGlobalPropertiesChanged.bind(this),
      s
    ), this.globalPropertyHandleService = new PU(this), this.setPreviewService(n), this.initializationPromise = (async () => {
      if (!s?.readonly) {
        const u = this.bundleStateManager.getState();
        if (u.integrationProductIds && u.integrationProductIds.length > 0) {
          const c = await He.getShadowGraphqlClient().query({
            query: jk,
            variables: {
              ids: u.integrationProductIds
            },
            errorPolicy: "all",
            fetchPolicy: "no-cache"
          });
          if (c.errors)
            throw new Error(`Failed to fetch integration products for Bundle ${t.id}`);
          const d = c.data.integrationProducts?.filter((h) => !!h.product?.id && u.integrationProductIds.includes(h.id)).map((h) => h.product.id);
          u.integrationProductIds = [], u.productIds = Array.from(/* @__PURE__ */ new Set([...u.productIds || [], ...d || []]));
          const f = JSON.stringify(u);
          this.bundleStateManager.setState(f), await He.getShadowGraphqlClient().mutate({
            mutation: dp,
            variables: {
              id: this.id,
              bundleStateData: f
            },
            context: {
              bundleOwnerId: a
            }
          });
        }
      }
      return Promise.all([
        this.loadExistingWorkflowExperiences(
          t.transactionIds || [],
          {
            ...i,
            bundleOwnerId: a
          },
          o
        ),
        this.globalPropertyStateManager.getInitializationPromise()
      ]).then(
        () => new Promise((u, c) => {
          if (s?.readonly) {
            u([]);
            return;
          }
          console.log("Setting default global variants."), this.initializeUninitializedHandles().then(u).catch(c);
        })
      );
    })(), this.initializationPromise.catch((u) => {
      console.error(`Bundle initialization failed: ${u}`);
    }), this.initializationPromise.then(() => {
      this.getGlobalProperties().then((u) => this.checkMandatoryHandlesChanged(void 0, u));
    });
  }
  async initializeUninitializedHandles() {
    const e = this.globalPropertyStateManager.getGlobalPropertyState();
    if (!e)
      return console.log("Attempted to set global default variant before state was initialized."), [];
    const n = (await this.globalPropertyHandleService.getHandles()).map(async (i) => {
      if (i.getType() === Qn.ColorOption || i.getType() === Qn.Option) {
        const a = i;
        if (!e.aspects.find((o) => o.name === a.getName()))
          try {
            return await a.initDefaultVariant();
          } catch (o) {
            console.error(`Failed to initialize default global variant - ${o}`);
          }
      }
    });
    return Promise.all(n);
  }
  getProductIds() {
    return this.bundleStateManager.getState()?.productIds;
  }
  async addProductId(e) {
    const t = this.bundleStateManager.getState();
    if (t) {
      if (!t.productIds)
        t.productIds = [];
      else if (t.productIds.some((i) => i === e)) {
        this.fireEvent("bundle-products-added", {
          productIds: t.productIds,
          added: []
        });
        return;
      }
      t.productIds = [...t.productIds, e];
      const n = JSON.stringify(t);
      this.bundleStateManager.setState(n), this.fireEvent("bundle-products-added", {
        productIds: t.productIds,
        added: [e]
      }), await He.getShadowGraphqlClient().mutate({
        mutation: dp,
        variables: {
          id: this.id,
          bundleStateData: n
        },
        context: {
          bundleOwnerId: this.ownerId
        }
      });
    }
  }
  async removeProductIds(e) {
    const t = this.bundleStateManager.getState();
    if (t) {
      const n = e.filter((a) => (t.productIds ?? []).includes(a));
      if (n.length === 0)
        return;
      t.productIds = (t.productIds ?? []).filter((a) => !n.includes(a));
      const i = JSON.stringify(t);
      this.bundleStateManager.setState(i), this.fireEvent("bundle-products-removed", {
        productIds: t.productIds,
        removed: n
        // Technically might not include all of these, but that's not important.
      }), await He.getShadowGraphqlClient().mutate({
        mutation: dp,
        variables: {
          id: this.id,
          bundleStateData: i
        },
        context: {
          bundleOwnerId: this.ownerId
        }
      });
    }
  }
  getTemplate() {
    return this.template;
  }
  async generateQuoteId() {
    const t = (await He.getShadowGraphqlClient().mutate({
      mutation: JU,
      variables: {
        id: this.id
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    })).data?.bundleGenerateQuoteId?.quoteId;
    return this.quoteId = t, t || "";
  }
  async attachAddress(e, t, n, i, a, s) {
    await He.getShadowGraphqlClient().mutate({
      mutation: YU,
      variables: {
        bundleId: this.id,
        streetAddress: e || void 0,
        apartment: t || void 0,
        city: n || void 0,
        country: i || void 0,
        state: a || void 0,
        postCode: s || void 0
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    });
  }
  async attachOrganization(e) {
    await He.getShadowGraphqlClient().mutate({
      mutation: XU,
      variables: {
        bundleId: this.id,
        organizationName: e
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    });
  }
  setBundleOptions(e) {
    this.globalPropertyStateManager.setBundleOptions(e);
  }
  getInitializationPromise() {
    return this.initializationPromise;
  }
  addEventListener(e, t) {
    this.eventEmitter.on(e, t);
  }
  removeEventListener(e, t) {
    this.eventEmitter.off(e, t);
  }
  getClient() {
    return this.client;
  }
  getId() {
    return this.id;
  }
  getName() {
    return this.name;
  }
  getQuoteId() {
    return this.quoteId;
  }
  setName(e) {
    return this.name = e, this.updateBundle();
  }
  getDispatchDate() {
    return this.dispatchDate;
  }
  setDispatchDate(e) {
    return this.dispatchDate = e, this.updateBundle();
  }
  getPurchaseOrder() {
    return this.purchaseOrder;
  }
  setPurchaseOrder(e) {
    return this.purchaseOrder = e, this.updateBundle();
  }
  getMetadata() {
    return new Map(this.metadata);
  }
  setMetadata(e) {
    return this.metadata = new Map(e), this.updateBundle();
  }
  setNameAndMetadata(e, t) {
    return this.name = e, this.metadata = new Map(t), this.updateBundle();
  }
  hasGlobalProperties() {
    return !!this.productCollection?.globalPropertyConfiguration;
  }
  getGlobalPropertyConfiguration() {
    return this.productCollection?.globalPropertyConfiguration;
  }
  async getGlobalProperties() {
    return this.globalPropertyHandleService.applyConditionsFromState(
      await this.globalPropertyHandleService.getHandles(),
      this.getGlobalPropertyStateManager().getGlobalPropertyState()
    );
  }
  async applyGlobalPropertyState(e) {
    this.updatesLocked = !0;
    const t = await this.globalPropertyHandleService.getHandles();
    try {
      for (const n of e.aspects) {
        const i = n?.name;
        await this.getGlobalPropertyStateManager().setAspect(
          i,
          n.value,
          void 0,
          void 0,
          n.hidden
        );
      }
      for (const n of e.aspects) {
        const i = n?.name, a = t.find((s) => s.getName() === i);
        if (a)
          switch (n.type) {
            case Qn.FileUpload: {
              const s = a, o = await Zp([n.value]);
              o.length > 0 && await s.selectImage(o[0]);
              const l = n.storage?.colors;
              if (l) {
                const u = Object.fromEntries(
                  l.map((c) => [
                    c.key,
                    { browserValue: c.browserValue, pmsValue: c.pmsValue }
                  ]) ?? []
                );
                await s.changeColors(u);
              }
              break;
            }
            case Qn.ColorOption: {
              const s = a, l = (await s.getAllVariants()).find((c) => c.getId() === n.value), u = n.storage ? n.storage : void 0;
              l && await s.selectVariant(l), u?.customColor && s.setCustomColor(u.customColor);
              break;
            }
            case Qn.Option: {
              const s = a, l = (await s.getAllVariants()).find((u) => u.getId() === n.value);
              l && await s.selectVariant(l);
              break;
            }
            case Qn.Text: {
              await a.setText(n.value);
              break;
            }
          }
      }
    } finally {
      this.updatesLocked = !1, this.onGlobalPropertiesChanged(void 0, this.globalPropertyStateManager.getGlobalPropertyState());
    }
  }
  getGlobalPropertyStateManager() {
    return this.globalPropertyStateManager;
  }
  async getGlobalPropertyTotalSubunits() {
    return (await this.globalPropertyHandleService.getHandles()).filter((n) => n.getType() === Qn.Option).map((n) => n.getCurrentVariant()?.getPrice() || 0).reduce((n, i) => n + i, 0);
  }
  getTotalSubunits() {
    return this.workflowExperiences.map((e) => e.getTotalPriceSubunits()).reduce((e, t) => e + t, 0);
  }
  getProductCollection() {
    return this.productCollection ? new HF(this.productCollection) : void 0;
  }
  async initializeAdditionalRequiredColorChannels(e) {
    for (const t of e.getStepsByType(Je.Illustration)) {
      const n = t.getGlobalPropertyAspects(this.globalConfigurationPropertyId || "");
      for (const i of n) {
        const a = this.getGlobalPropertyConfiguration()?.aspects.find(
          (s) => s.name === i
        );
        if (a && a.type === Qn.ColorOption) {
          const s = t.getCurrentVariant()?.getAssetResource(), o = s?.assetConfiguration?.channelNumbers || [], l = s?.assetConfiguration?.defaultColorVariants || [], u = MU(this, i), c = [...new Set(o.map((f) => f.number))];
          if (c.length > u)
            for (const f of c) {
              const h = this.getGlobalPropertyStateManager(), g = l.find((v) => v.channelNumber === f);
              g && await h.setAspect(i, g.variant.id || "", void 0, g.channelNumber);
            }
        }
      }
    }
  }
  async addWorkflowExperience(e) {
    await this.initializeAdditionalRequiredColorChannels(e), e.setBundle(this), await this.appendWorkflowExperience(e), await this.injectExperienceIntoPreviewService(e), await e.getWorkflowManager().getInitializationPromise();
    const t = await this.getGlobalProperties();
    for (const n of t)
      await n.applyGlobalState([e]);
    this.fireEvent("workflow-experience-added", {
      workflowExperiences: [e]
    });
  }
  async addWorkflowExperiences(e) {
    for (const o of e)
      await this.initializeAdditionalRequiredColorChannels(o);
    const t = e.map((o) => o.getTransaction().id), n = t.map(
      (o) => this.workflowExperiences.find((l) => l.getTransaction().id === o)
    );
    if (n.some((o) => !!o))
      throw new Error(
        "Unable to add transaction to bundle - Already Exists: " + n.filter((o) => !!o).map((o) => o?.getTransaction().id).join(", ")
      );
    const i = Cr.getMap("transactionOwnerIds") || /* @__PURE__ */ new Map(), a = t.map((o) => i.get(o));
    await He.getShadowGraphqlClient().mutate({
      mutation: FL,
      variables: {
        id: this.id,
        transactionIds: t,
        transactionOwnerIds: a
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    }).catch((o) => {
      console.error(o);
    }), this.workflowExperiences.push(...e);
    const s = async () => {
      for (const l of e)
        l.setBundle(this), await this.injectExperienceIntoPreviewService(l);
      await Promise.all(e.map((l) => l.getWorkflowManager().getInitializationPromise()));
      const o = await this.getGlobalProperties();
      for (const l of o)
        await l.applyGlobalState(e);
    };
    await Promise.all([this.updateTransactionOrder(), s()]), await this.initializeUninitializedHandles(), this.workflowExperiences.forEach((o) => o.checkForPriceBreakChanges()), this.fireEvent("workflow-experience-added", {
      workflowExperiences: this.workflowExperiences
    });
  }
  async appendWorkflowExperience(e, t = !0) {
    const n = e.getTransaction().id;
    if (this.workflowExperiences.find((o) => o.getTransaction().id === n)) throw new Error("Unable to add transaction to bundle - Already Exists!");
    const s = (Cr.getMap("transactionOwnerIds") || /* @__PURE__ */ new Map()).get(n);
    await He.getShadowGraphqlClient().mutate({
      mutation: TL,
      variables: {
        id: this.id,
        transactionId: n
      },
      context: {
        bundleOwnerId: this.ownerId,
        transactionOwnerId: s
      }
    }), t && (this.workflowExperiences.push(e), this.workflowExperiences.forEach((o) => o.checkForPriceBreakChanges()));
  }
  async removeWorkflowExperience(e) {
    const t = this.workflowExperiences.indexOf(e);
    await this.removeTransaction(t, this.workflowExperiences[t].getTransaction()), this.fireEvent("workflow-experience-added", {
      workflowExperiences: [e]
    });
  }
  async removeWorkflowExperiences(e) {
    await this.removeTransactions(e.map((t) => t.getTransaction()));
  }
  async removeWorkflowExperienceByTransaction(e) {
    const t = this.workflowExperiences.findIndex((n) => n.getTransaction().id === e.id);
    await this.removeTransaction(t, e);
  }
  async removeWorkflowExperiencesByTransactions(e) {
    await this.removeTransactions(e);
  }
  async removeTransaction(e, t, n = !0) {
    if (e > -1) {
      const i = this.workflowExperiences.find((a) => a.getTransaction().id === t.id);
      if (i.setBundle(void 0), this.previewService && i.getWorkflowManager().ejectFromPreviewService(), this.bundleStateManager.removeStateForTransaction(t.id), await He.getShadowGraphqlClient().mutate({
        mutation: IL,
        variables: {
          id: this.id,
          transactionId: t.id,
          name: this.name,
          metadata: Array.from(this.metadata.entries()).map(([a, s]) => ({ key: a, value: s })),
          bundleStateData: this.bundleStateManager.getSerializedState()
        },
        context: {
          bundleOwnerId: this.ownerId
        }
      }), n) {
        const a = this.workflowExperiences.splice(e, 1);
        this.workflowExperiences.forEach((s) => s.checkForPriceBreakChanges()), i.checkForPriceBreakChanges(), await this.updateTransactionOrder(), this.fireEvent("workflow-experience-removed", {
          workflowExperiences: a
        });
      }
    } else
      throw new Error("Unable to remove workflow experience from bundle - Not Found! - " + t.id);
  }
  async removeTransactions(e) {
    const t = e.map(
      (i) => this.workflowExperiences.findIndex((a) => a.getTransaction().id === i.id)
    );
    if (t.some((i) => i === -1))
      throw new Error(
        "Unable to remove workflow experience from bundle - The following aren't included in the bundle: " + e.filter((i, a) => t[a] === -1).map((i) => i.id).join(", ")
      );
    const n = e.map(
      (i) => this.workflowExperiences.splice(
        this.workflowExperiences.findIndex((a) => a.getTransaction().id === i.id),
        1
      )[0]
    );
    n.forEach((i) => i.setBundle(void 0)), [...this.workflowExperiences, ...n].forEach(
      (i) => i.checkForPriceBreakChanges()
    ), this.previewService && n.forEach((i) => i.getWorkflowManager().ejectFromPreviewService()), e.forEach((i) => this.bundleStateManager.removeStateForTransaction(i.id)), await He.getShadowGraphqlClient().mutate({
      mutation: DL,
      variables: {
        id: this.id,
        transactionIds: e.map((i) => i.id),
        name: this.name,
        metadata: Array.from(this.metadata.entries()).map(([i, a]) => ({ key: i, value: a })),
        bundleStateData: this.bundleStateManager.getSerializedState()
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    }), this.fireEvent("workflow-experience-removed", {
      workflowExperiences: n
    }), await this.updateTransactionOrder();
  }
  async insertWorkflowExperience(e, t) {
    await this.appendWorkflowExperience(e, !1), this.workflowExperiences.splice(t, 0, e), await Promise.all([
      this.updateTransactionOrder(),
      (async () => {
        await this.injectExperienceIntoPreviewService(e);
        const n = await this.getGlobalProperties();
        await Promise.all(n.map((i) => i.applyGlobalState([e])));
      })()
    ]);
  }
  async replaceWorkflowExperience(e, t) {
    if (e < 0 || e >= this.workflowExperiences.length)
      throw new Error("Unable to replace workflow experience in bundle - Index out of range!");
    const n = this.workflowExperiences[e];
    if (n.getTransaction().id === t.getTransaction().id)
      throw new Error("Unable to replace workflow experience in bundle - Same transaction!");
    await Promise.all([
      this.removeTransaction(e, n.getTransaction(), !1),
      this.appendWorkflowExperience(t, !1)
    ]), this.workflowExperiences[e] = t, await Promise.all([
      this.updateTransactionOrder(),
      (async () => {
        await this.injectExperienceIntoPreviewService(t);
        const i = await this.getGlobalProperties();
        await Promise.all(i.map((a) => a.applyGlobalState([t])));
      })()
    ]);
  }
  async swapWorkflowExperiences(e, t) {
    if (e < 0 || e >= this.workflowExperiences.length || t < 0 || t >= this.workflowExperiences.length)
      throw new Error("Unable to swap workflow experiences in bundle - Index out of range!");
    if (e === t) return;
    const n = this.workflowExperiences[e];
    this.workflowExperiences[e] = this.workflowExperiences[t], this.workflowExperiences[t] = n, await this.updateTransactionOrder();
  }
  getWorkflowExperiences() {
    return [...this.workflowExperiences];
  }
  getTopLevelWorkflowExperiences() {
    return this.workflowExperiences.filter((e) => !e.getTransaction().parentTransaction);
  }
  getChildWorkflowExperiences(e) {
    return this.workflowExperiences.filter(
      (t) => t.getTransaction().parentTransaction?.id === e
    );
  }
  async sortWorkflowExperiences(e) {
    this.workflowExperiences = this.workflowExperiences.sort(e), await this.updateTransactionOrder();
  }
  getWorkflowExperienceCount() {
    return this.workflowExperiences.length;
  }
  async addStakeholder(e, t) {
    const n = await He.getShadowGraphqlClient().mutate({
      mutation: PL,
      variables: {
        id: this.id,
        details: e,
        type: t || vk.Owner
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    });
    if (!n.data?.bundleAddStakeholder) throw new Error("Bundle not found!");
    const i = n.data.bundleAddStakeholder.bundleStakeholders || [];
    this.storeStakeholderCustomers(i);
  }
  async removeStakeholder(e) {
    if (!(await He.getShadowGraphqlClient().mutate({
      mutation: RL,
      variables: {
        id: this.id,
        emailAddress: e
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    })).data?.bundleRemoveStakeholder) throw new Error("Bundle not found!");
  }
  async updateStakeholders(e) {
    const t = await He.getShadowGraphqlClient().mutate({
      mutation: OL,
      variables: {
        id: this.id,
        input: e
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    });
    if (!t.data?.bundleUpdateStakeholders) throw new Error("Bundle not found!");
    const n = t.data.bundleUpdateStakeholders.bundleStakeholders || [];
    this.storeStakeholderCustomers(n);
  }
  async getAllStakeholders() {
    const e = await He.getShadowGraphqlClient().query({
      query: nE,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        id: this.id
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    });
    if (!e.data.bundles || e.data.bundles.length === 0) throw new Error("Bundle not found!");
    const t = e.data.bundles[0].bundleStakeholders || [];
    return this.storeStakeholderCustomers(t), t;
  }
  async getCurrentStakeholder() {
    const e = await He.getShadowGraphqlClient().query({
      query: nE,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        id: this.id
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    });
    if (!e.data.bundles || e.data.bundles.length === 0) throw new Error("Bundle not found!");
    return e.data.bundles[0].currentBundleStakeholder;
  }
  storeStakeholderCustomers(e) {
    e.forEach((t) => {
      t.customer && this.client.storeCustomer(t.customer);
    });
  }
  async finish(e, t) {
    this.completed && await He.getShadowGraphqlClient().mutate({
      mutation: LL,
      variables: {
        bundleId: this.id
      }
    });
    const n = this.workflowExperiences.filter((o) => !!o.getWorkflow()), i = this.workflowExperiences.filter((o) => !o.getWorkflow() && !!o.getTransaction().parentTransaction?.id).map((o) => o.getTransaction()), a = await UF(
      n.map((o) => {
        const l = o.getWorkflow();
        if (!l) throw new Error("Unable to create designs - Workflow not found!");
        const u = o.getProduct();
        if (!u) throw new Error("Unable to create designs - Product not found!");
        return {
          workflowManager: o.getWorkflowManager(),
          workflow: l,
          layouts: o.getWorkflowManager().getLayouts(),
          getReducerState: () => o.getCommandContext().getState(),
          product: u,
          transaction: o.getTransaction(),
          workflowSelections: o.getWorkflowManager().getWorkflowSelections(),
          designName: l.name,
          workflowMetadata: o.getWorkflowManager().getWorkflowMetadata()
        };
      }),
      t ? (o, l) => {
        const u = n.find(
          (c) => c.getTransaction().id === l
        );
        return u ? t(u, o) : (console.warn(
          "SpiffCommerce - Bundle create design - Unable to find experience for transaction: " + l
        ), Promise.resolve(void 0));
      } : void 0
    ), s = /* @__PURE__ */ new Map();
    return n.forEach((o, l) => {
      s.set(o.getTransaction().id, a[l]);
    }), await yU(i), AU(s, i), {
      bundleId: this.id,
      name: this.getName(),
      dispatchDate: this.getDispatchDate() || "",
      purchaseOrder: this.getPurchaseOrder() || "",
      collectionId: this.getProductCollection()?.getId() || "",
      collectionName: this.getProductCollection()?.getName() || "",
      items: a,
      bundleOwnerId: this.ownerId
    };
  }
  async placeOrder() {
    const e = this.workflowExperiences.map((t) => ({
      transactionId: t.getTransaction().id,
      amountToOrder: t.getTransaction().quantity || 1
    }));
    return await this.getClient().placeOrder(e);
  }
  getPreviewService() {
    return this.previewService;
  }
  async setPreviewService(e) {
    if (this.workflowExperiences && this.workflowExperiences.length > 0 && (this.workflowExperiences.forEach((t) => t.getWorkflowManager().ejectFromPreviewService()), e))
      for (const t of this.workflowExperiences)
        await this.injectExperienceIntoPreviewService(t);
    e && e.registerModelLoadEventListener && e.registerModelLoadEventListener(this.onModelLoadEvent.bind(this)), this.previewService && this.previewService !== e && this.previewService.unregisterModelLoadEventListener && this.previewService.unregisterModelLoadEventListener(this.onModelLoadEvent.bind(this)), this.previewService = e;
  }
  async assignGlobalPropertyConfiguration(e) {
    await He.getShadowGraphqlClient().mutate({
      mutation: _L,
      variables: {
        bundleId: this.id,
        globalPropertyConfigurationId: e
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    }), this.globalConfigurationPropertyId = e;
  }
  async assignProductCollection(e) {
    const t = await He.getShadowGraphqlClient().mutate({
      mutation: ML(
        this.globalPropertyStateManager.getBundleOptions()?.eagerFetchProducts ?? !1
      ),
      variables: {
        id: this.id,
        productCollectionId: e ?? ""
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    });
    if (t.data?.bundleAssignProductCollection.productCollection) {
      this.productCollection = t.data.bundleAssignProductCollection.productCollection;
      const n = t.data.bundleAssignProductCollection.productCollection.globalPropertyConfiguration;
      this.globalPropertyStateManager.setConfiguration(n), await this.globalPropertyHandleService.getHandles(), this.globalConfigurationPropertyId = n?.id, await this.clearOldProducts(this.workflowExperiences);
    }
  }
  onModelLoadEvent(e) {
    e.eventType === "unload" || !e.modelContainer || (e.modelContainer.registerMaterialSelectedCallback(() => this.onModelSelectedEvent(e.modelContainer, !0)), e.modelContainer.registerMaterialDeselectedCallback(() => this.onModelSelectedEvent(e.modelContainer, !1)));
  }
  onModelSelectedEvent(e, t) {
    if (e && e.metadata && e.metadata instanceof Map && e.metadata.has("workflowManager")) {
      const i = e.metadata.get("workflowManager").getWorkflowExperience().getTransaction(), a = this.workflowExperiences.find((s) => s.getTransaction().id === i.id);
      a && this.fireEvent(t ? "workflow-experience-hover-enter" : "workflow-experience-hover-exit", {
        workflowExperience: a
      });
    }
  }
  async injectExperienceIntoPreviewService(e) {
    this.previewService && await e.getWorkflowManager().injectIntoPreviewService(this.previewService);
  }
  async loadExistingWorkflowExperiences(e, t, n) {
    let i = [];
    if (e.length > 0 && (i = await this.client.getWorkflowExperiences(
      e.map((a) => ({
        type: "transaction",
        transactionId: a
      })),
      t,
      void 0,
      n
    ), i.forEach((a) => a.setBundle(this)), i.forEach((a) => a.checkForPriceBreakChanges()), this.workflowExperiences = i, this.previewService))
      for (const a of i)
        await this.injectExperienceIntoPreviewService(a);
    await this.clearOldProducts(i);
  }
  // Remove products from bundle that aren't in the collection.
  async clearOldProducts(e) {
    if (!this.globalPropertyStateManager.getBundleOptions()?.readonly) {
      const t = this.getProductIds() || [], n = this.getProductCollection();
      if (n && t.length > 0) {
        await n.fetchProducts();
        const i = n.getProducts(), a = [], s = [];
        for (const l of t)
          if (!i.find((c) => c.getId() === l)) {
            for (const c of e)
              c.getProduct()?.id === l && s.push(c);
            a.push(l);
          }
        const o = [];
        a.length > 0 && o.push(this.removeProductIds(a)), s.length > 0 && o.push(Promise.all(s.map((l) => l.clearProduct()))), o.length > 0 && await Promise.all(o);
      }
    }
  }
  async updateBundle() {
    if (!(await He.getShadowGraphqlClient().mutate({
      mutation: dp,
      variables: {
        id: this.id,
        name: this.name,
        metadata: Array.from(this.metadata.entries()).map(([t, n]) => ({ key: t, value: n })),
        bundleStateData: this.bundleStateManager.getSerializedState(),
        dispatchDate: this.dispatchDate,
        purchaseOrder: this.purchaseOrder
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    })).data?.bundleUpdate) throw new Error("Bundle not found!");
  }
  async updateTransactionOrder() {
    await He.getShadowGraphqlClient().mutate({
      mutation: BL,
      variables: {
        id: this.id,
        transactionIds: this.workflowExperiences.map((e) => e.getTransaction().id)
      },
      context: {
        bundleOwnerId: this.ownerId
      }
    });
  }
  async onGlobalPropertiesChanged(e, t) {
    if (this.updatesLocked)
      return;
    const n = await this.globalPropertyHandleService.getHandles(), i = this.globalPropertyHandleService.applyConditionsFromState(n, e), a = this.globalPropertyHandleService.applyConditionsFromState(n, t);
    this.checkConditionalHandlesChanged(i, a), this.checkMandatoryHandlesChanged(e, a);
    const s = this.getGlobalPropertyStateManager();
    let o = [];
    for (const d of n)
      a.find((f) => f.getName() == d.getName()) || (o = [...o, d.getName()]);
    await s.clearAspects(o);
    const l = a.map((d) => {
      if (d.getType() === Qn.ColorOption || d.getType() === Qn.Option) {
        const f = d;
        if (!t.aspects.find((g) => g.name === f.getName()))
          return f.initDefaultVariant();
      }
    });
    await Promise.all(l), await Promise.all(a.map((d) => d.applyGlobalState()));
    const u = this.globalPropertyStateManager.getGlobalPropertyState(), c = this.globalPropertyHandleService.applyConditionsFromState(n, u);
    ld(a.sort(), c.sort()) || (this.checkConditionalHandlesChanged(a, c), this.checkMandatoryHandlesChanged(u, c), await this.onGlobalPropertiesChanged(t, u));
  }
  checkConditionalHandlesChanged(e, t) {
    (() => {
      if (e.length !== t.length) return !0;
      for (let a = 0; a < e.length; a++)
        if (e[a].getName() !== t[a].getName()) return !0;
      return !1;
    })() && this.fireEvent("conditional-global-properties-changed", {
      globalProperties: t
    });
  }
  checkMandatoryHandlesChanged(e, t) {
    const n = [], i = [], a = [], s = $F(e);
    t.forEach((o) => {
      if (o.isMandatory()) {
        const l = o.isMandatoryFulfilled();
        l ? i.push(o) : a.push(o);
        const u = s.get(o.getName());
        (u === void 0 || u !== l) && n.push(o);
      }
    }), this.fireEvent("global-properties-mandatory-changed", {
      changed: n,
      completed: i,
      remaining: a
    });
  }
  fireEvent(e, t) {
    this.eventEmitter.emit(e, t);
  }
  getShareActions() {
    return this.shareActions;
  }
  getWorkflowViewerLink() {
    return this.workflowViewerLink;
  }
  getWorkflowViewerAmendLink() {
    return this.workflowViewerAmendLink;
  }
  async approve(e, t) {
    await He.getShadowGraphqlClient().mutate({
      mutation: UL,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        id: this.id,
        note: e,
        stakeholderId: t
      }
    });
  }
  async reject(e, t) {
    await He.getShadowGraphqlClient().mutate({
      mutation: VL,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        id: this.id,
        note: e,
        stakeholderId: t
      }
    });
  }
  getQuoteCompleteMessage() {
    return {
      bundleId: this.id,
      bundleOwnerId: this.ownerId,
      quoteId: this.quoteId || ""
    };
  }
}
const KU = Ee`
    mutation processFlowCreate($processFlowId: String!, $inputs: [String]!) {
        processExecutionCreate(processFlowId: $processFlowId, inputs: $inputs) {
            id
        }
    }
`;
class ZU {
  /**
   *
   * @param id
   * @param inputs
   * @param options
   * @returns
   */
  async execute(e, t, n) {
    const a = (await He.getShadowGraphqlClient().mutate({
      mutation: KU,
      variables: {
        processFlowId: e,
        inputs: [...t.map((d) => d.getValueForTransmission())]
      }
    })).data?.processExecutionCreate?.id;
    if (!a) throw new Error("Failed to create process execution.");
    function s(d) {
      return new Promise((f) => {
        setTimeout(f, d);
      });
    }
    let o = !1, l = 0, u, c;
    for (; !o; ) {
      u = await He.getShadowGraphqlClient().query({
        query: Ee`
                    query getProcessFlowExecution($ids: [String]!) {
                        processExecutions(ids: $ids) {
                            id
                            completedAt
                            failedAt
                            nodes {
                                id
                                type
                                artifacts
                            }
                        }
                    }
                `,
        variables: {
          ids: [a]
        }
      });
      const d = u.data?.processExecutions[0];
      if (!u || !d) throw new Error("Failed to retrieve server response for execution.");
      if (d.failedAt)
        throw new Error(
          "Execution has failed to complete. See Automation > FLows in Flight on partner account on SpiffCommerce Hub."
        );
      if (d.completedAt) {
        o = !0, c = new e9(d);
        break;
      }
      l += 1;
      const f = n?.repeats ? n?.repeats : 5;
      if (l >= f) throw new Error("Maximum wait time exceeded for execution result.");
      await s(n?.sleepTime ? Math.max(n.sleepTime, 500) : 2e3);
    }
    if (!c) throw new Error("Failed to retrieve server response for execution.");
    return Promise.resolve(c);
  }
}
class e9 {
  constructor(e) {
    this.execution = e;
  }
  /**
   * @returns The raw response from the server.
   */
  getRaw() {
    return this.execution;
  }
  /**
   * @returns The nodes contained within the execution.
   */
  getNodes() {
    return this.execution.nodes.map((e) => new gp(e));
  }
  /**
   * @param type The type of node to return.
   * @returns A list of nodes matching the requested type.
   */
  getNodesByType(e) {
    return this.execution.nodes.filter((t) => t.type === e).map((t) => new gp(t));
  }
  /**
   * @returns A list of input nodes that exist in this execution.
   */
  getInputs() {
    return this.execution.nodes.filter(
      (e) => e.type === "StartTerminal"
      /* StartTerminal */
    ).map((e) => new gp(e));
  }
  /**
   * @returns A list of out put nodes that exist in this execution.
   */
  getOutputs() {
    return this.execution.nodes.filter(
      (e) => e.type === "EndTerminal"
      /* EndTerminal */
    ).map((e) => new gp(e));
  }
  /**
   * @returns A date object representing the point in time this execution completed.
   */
  getCompletedAt() {
    if (this.execution.completedAt)
      return new Date(this.execution.completedAt);
  }
  /**
   * @returns A date object representing the point in time this execution failed.
   */
  getFailedAt() {
    if (this.execution.failedAt)
      return new Date(this.execution.failedAt);
  }
}
class gp {
  constructor(e) {
    this.node = e;
  }
  getId() {
    return this.node.id;
  }
  getType() {
    return this.node.type;
  }
  getArtifacts() {
    return new Map(Object.entries(JSON.parse(this.node.artifacts).value));
  }
  getArtifactByName(e) {
    return this.getArtifacts().get(e);
  }
}
class v1 {
  constructor(e) {
    this.value = e;
  }
  getRaw() {
    return this.value;
  }
  getValueForTransmission() {
    const e = this.value;
    return e.startsWith("[") ? JSON.stringify(JSON.parse(e)) : e;
  }
}
var t9 = /* @__PURE__ */ ((r) => (r.Transaction = "Transaction", r.Bundle = "Bundle", r.Product = "Product", r.Variant = "Variant", r.Option = "Option", r.LineItem = "LineItem", r.Asset = "Asset", r))(t9 || {});
class HQ extends v1 {
  constructor(e) {
    super(`"${e}"`);
  }
}
class jF extends v1 {
  constructor(e, t) {
    if (t !== "Asset" && !jF.validUUID(e))
      throw new Error("Invalid ID, must be a valid v4 UUID. https://www.uuidgenerator.net/");
    super(`{"isSpiffObject": true, "id": "${e}", "type": "${t}"}`);
  }
  static validUUID(e) {
    return e.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i);
  }
}
class jQ extends v1 {
  constructor(e) {
    super(`[${e.map((t) => t.getRaw()).join(",")}]`);
  }
}
class hE {
  constructor(e) {
    this.integrationProduct = e;
  }
  getId() {
    return this.integrationProduct.id;
  }
  getResource() {
    return this.integrationProduct;
  }
  getBasePrice() {
    if (!this.integrationProduct.product)
      throw new Error("IntegrationProductResource does not have a product");
    const e = this.integrationProduct.product.basePrice || 0, t = this.integrationProduct?.additionalIntegrationProduct;
    if (!t) return e;
    if (t && !t.product)
      throw new Error("An additional integration product was found, but it does not have a product");
    return e + (t.product.basePrice || 0);
  }
  getDefaultWorkflow() {
    if (!this.integrationProduct.product)
      throw new Error("IntegrationProductResource does not have a product");
    const e = this.integrationProduct.product.workflows || [];
    if (e.length === 0)
      throw new Error(
        "No workflows found on product. This is generally due to a configuration error. Please confirm at least one workflow is configured for this product."
      );
    return new Gf(e[0]);
  }
  getAllWorkflows() {
    if (!this.integrationProduct.product)
      throw new Error("IntegrationProductResource does not have a product");
    const e = this.integrationProduct.product.workflows || [];
    if (e.length === 0)
      throw new Error(
        "No workflows found on product. This is generally due to a configuration error. Please confirm at least one workflow is configured for this product."
      );
    return e.sort((t, n) => (t.index ?? 0) - (n.index ?? 0)).map((t) => new Gf(t));
  }
}
const bv = Ee`
    query GetCustomer($emailAddress: String!) {
        customer(emailAddress: $emailAddress) {
            id
            emailAddress
            defaultTemplateBundleId
            hasBundleTemplates
            partner {
                id
            }
            productCollectionCustomers {
                id
                productCollection {
                    id
                }
            }
        }
    }
`, r9 = Ee`
    mutation CustomerCreate($details: CustomerDetailsInput!) {
        customerCreate(details: $details) {
            id
            emailAddress
            partner {
                id
            }
        }
    }
`;
Ee`
    mutation CustomerAuthenticate($loginToken: String!) {
        customerAuthenticate(loginToken: $loginToken) {
            id
            emailAddress
            stakeholders {
                id
                type
                transaction {
                    id
                }
            }
            bundleStakeholders {
                id
                authorizationStatus
                authorizationDate
                authorizationNote
                type
                bundle {
                    id
                    transactions {
                        id
                    }
                }
            }
            partner {
                id
            }
        }
    }
`;
const n9 = Ee`
    mutation CustomerGenerateVerificationCode($emailAddress: String!) {
        customerGenerateVerificationCode(emailAddress: $emailAddress)
    }
`, i9 = Ee`
    mutation CustomerVerifyCode($emailAddress: String!, $verificationCode: String!) {
        customerVerifyCode(emailAddress: $emailAddress, verificationCode: $verificationCode) {
            id
            emailAddress
            loginToken
            partner {
                id
            }
            stakeholders {
                id
                type
                transaction {
                    id
                }
            }
            bundleStakeholders {
                id
                authorizationStatus
                authorizationDate
                authorizationNote
                type
                bundle {
                    id
                    transactions {
                        id
                    }
                }
            }
        }
    }
`, a9 = Ee`
    query CustomerMetafields($id: String!) {
        metafields(entityId: $id) {
            id
            createdAt
            updatedAt
            entityId
            value
            metafieldConfiguration {
                id
                createdAt
                updatedAt
                entityType
                metafieldType
                name
            }
        }
    }
`;
class s9 {
  constructor(e, t = He.getShadowGraphqlClient.bind(He)) {
    this.options = e, this.client = t;
  }
  query(e) {
    const t = this.options?.onQuery ? this.options?.onQuery(e) : {};
    return this.client().query({
      ...t,
      ...e,
      context: {
        ...t.context ?? {},
        ...e.context ?? {}
      }
    });
  }
  mutate(e) {
    const t = this.options?.onMutate ? this.options?.onMutate(e) : {};
    return this.client().mutate({
      ...t,
      ...e,
      context: {
        ...t.context ?? {},
        ...e.context ?? {}
      }
    });
  }
}
function o9(r, e, t) {
  return r.$source || (r.$source = {}), r.$source[e] = t, r;
}
const l9 = (r) => r?.body instanceof ReadableStream, sl = (r, e) => {
  const t = [];
  if (r && t.push(r), e)
    for (const n of e)
      t.push(n);
  return t;
}, Zs = (r, e) => `${r || "anonymous"}${e && e.length > 0 ? ` (a.k.a. ${e.join(",")})` : ""}`, hg = () => {
  let r = [], e = [], t = !1;
  const n = /* @__PURE__ */ new Set(), i = (d) => d.sort((f, h) => pE[h.step] - pE[f.step] || gE[h.priority || "normal"] - gE[f.priority || "normal"]), a = (d) => {
    let f = !1;
    const h = (g) => {
      const v = sl(g.name, g.aliases);
      if (v.includes(d)) {
        f = !0;
        for (const y of v)
          n.delete(y);
        return !1;
      }
      return !0;
    };
    return r = r.filter(h), e = e.filter(h), f;
  }, s = (d) => {
    let f = !1;
    const h = (g) => {
      if (g.middleware === d) {
        f = !0;
        for (const v of sl(g.name, g.aliases))
          n.delete(v);
        return !1;
      }
      return !0;
    };
    return r = r.filter(h), e = e.filter(h), f;
  }, o = (d) => (r.forEach((f) => {
    d.add(f.middleware, { ...f });
  }), e.forEach((f) => {
    d.addRelativeTo(f.middleware, { ...f });
  }), d.identifyOnResolve?.(c.identifyOnResolve()), d), l = (d) => {
    const f = [];
    return d.before.forEach((h) => {
      h.before.length === 0 && h.after.length === 0 ? f.push(h) : f.push(...l(h));
    }), f.push(d), d.after.reverse().forEach((h) => {
      h.before.length === 0 && h.after.length === 0 ? f.push(h) : f.push(...l(h));
    }), f;
  }, u = (d = !1) => {
    const f = [], h = [], g = {};
    return r.forEach((y) => {
      const A = {
        ...y,
        before: [],
        after: []
      };
      for (const x of sl(A.name, A.aliases))
        g[x] = A;
      f.push(A);
    }), e.forEach((y) => {
      const A = {
        ...y,
        before: [],
        after: []
      };
      for (const x of sl(A.name, A.aliases))
        g[x] = A;
      h.push(A);
    }), h.forEach((y) => {
      if (y.toMiddleware) {
        const A = g[y.toMiddleware];
        if (A === void 0) {
          if (d)
            return;
          throw new Error(`${y.toMiddleware} is not found when adding ${Zs(y.name, y.aliases)} middleware ${y.relation} ${y.toMiddleware}`);
        }
        y.relation === "after" && A.after.push(y), y.relation === "before" && A.before.push(y);
      }
    }), i(f).map(l).reduce((y, A) => (y.push(...A), y), []);
  }, c = {
    add: (d, f = {}) => {
      const { name: h, override: g, aliases: v } = f, y = {
        step: "initialize",
        priority: "normal",
        middleware: d,
        ...f
      }, A = sl(h, v);
      if (A.length > 0) {
        if (A.some((x) => n.has(x))) {
          if (!g)
            throw new Error(`Duplicate middleware name '${Zs(h, v)}'`);
          for (const x of A) {
            const k = r.findIndex((S) => S.name === x || S.aliases?.some((R) => R === x));
            if (k === -1)
              continue;
            const F = r[k];
            if (F.step !== y.step || y.priority !== F.priority)
              throw new Error(`"${Zs(F.name, F.aliases)}" middleware with ${F.priority} priority in ${F.step} step cannot be overridden by "${Zs(h, v)}" middleware with ${y.priority} priority in ${y.step} step.`);
            r.splice(k, 1);
          }
        }
        for (const x of A)
          n.add(x);
      }
      r.push(y);
    },
    addRelativeTo: (d, f) => {
      const { name: h, override: g, aliases: v } = f, y = {
        middleware: d,
        ...f
      }, A = sl(h, v);
      if (A.length > 0) {
        if (A.some((x) => n.has(x))) {
          if (!g)
            throw new Error(`Duplicate middleware name '${Zs(h, v)}'`);
          for (const x of A) {
            const k = e.findIndex((S) => S.name === x || S.aliases?.some((R) => R === x));
            if (k === -1)
              continue;
            const F = e[k];
            if (F.toMiddleware !== y.toMiddleware || F.relation !== y.relation)
              throw new Error(`"${Zs(F.name, F.aliases)}" middleware ${F.relation} "${F.toMiddleware}" middleware cannot be overridden by "${Zs(h, v)}" middleware ${y.relation} "${y.toMiddleware}" middleware.`);
            e.splice(k, 1);
          }
        }
        for (const x of A)
          n.add(x);
      }
      e.push(y);
    },
    clone: () => o(hg()),
    use: (d) => {
      d.applyToStack(c);
    },
    remove: (d) => typeof d == "string" ? a(d) : s(d),
    removeByTag: (d) => {
      let f = !1;
      const h = (g) => {
        const { tags: v, name: y, aliases: A } = g;
        if (v && v.includes(d)) {
          const x = sl(y, A);
          for (const k of x)
            n.delete(k);
          return f = !0, !1;
        }
        return !0;
      };
      return r = r.filter(h), e = e.filter(h), f;
    },
    concat: (d) => {
      const f = o(hg());
      return f.use(d), f.identifyOnResolve(t || f.identifyOnResolve() || (d.identifyOnResolve?.() ?? !1)), f;
    },
    applyToStack: o,
    identify: () => u(!0).map((d) => {
      const f = d.step ?? d.relation + " " + d.toMiddleware;
      return Zs(d.name, d.aliases) + " - " + f;
    }),
    identifyOnResolve(d) {
      return typeof d == "boolean" && (t = d), t;
    },
    resolve: (d, f) => {
      for (const h of u().map((g) => g.middleware).reverse())
        d = h(d, f);
      return t && console.log(c.identify()), d;
    }
  };
  return c;
}, pE = {
  initialize: 5,
  serialize: 4,
  build: 3,
  finalizeRequest: 2,
  deserialize: 1
}, gE = {
  high: 3,
  normal: 2,
  low: 1
};
var pd;
(function(r) {
  r.HTTP = "http", r.HTTPS = "https";
})(pd || (pd = {}));
var gd;
(function(r) {
  r.MD5 = "md5", r.CRC32 = "crc32", r.CRC32C = "crc32c", r.SHA1 = "sha1", r.SHA256 = "sha256";
})(gd || (gd = {}));
const Zy = "__smithy_context", fc = (r) => r[Zy] || (r[Zy] = {});
class ra {
  method;
  protocol;
  hostname;
  port;
  path;
  query;
  headers;
  username;
  password;
  fragment;
  body;
  constructor(e) {
    this.method = e.method || "GET", this.hostname = e.hostname || "localhost", this.port = e.port, this.query = e.query || {}, this.headers = e.headers || {}, this.body = e.body, this.protocol = e.protocol ? e.protocol.slice(-1) !== ":" ? `${e.protocol}:` : e.protocol : "https:", this.path = e.path ? e.path.charAt(0) !== "/" ? `/${e.path}` : e.path : "/", this.username = e.username, this.password = e.password, this.fragment = e.fragment;
  }
  static clone(e) {
    const t = new ra({
      ...e,
      headers: { ...e.headers }
    });
    return t.query && (t.query = u9(t.query)), t;
  }
  static isInstance(e) {
    if (!e)
      return !1;
    const t = e;
    return "method" in t && "protocol" in t && "hostname" in t && "path" in t && typeof t.query == "object" && typeof t.headers == "object";
  }
  clone() {
    return ra.clone(this);
  }
}
function u9(r) {
  return Object.keys(r).reduce((e, t) => {
    const n = r[t];
    return {
      ...e,
      [t]: Array.isArray(n) ? [...n] : n
    };
  }, {});
}
class Xu {
  statusCode;
  reason;
  headers;
  body;
  constructor(e) {
    this.statusCode = e.statusCode, this.reason = e.reason, this.headers = e.headers || {}, this.body = e.body;
  }
  static isInstance(e) {
    if (!e)
      return !1;
    const t = e;
    return typeof t.statusCode == "number" && typeof t.headers == "object";
  }
}
const c9 = new RegExp("^(?!.*-$)(?!-)[a-zA-Z0-9-]{1,63}$"), Ug = (r, e = !1) => {
  if (!e)
    return c9.test(r);
  const t = r.split(".");
  for (const n of t)
    if (!Ug(n))
      return !1;
  return !0;
}, Ps = (r) => {
  if (typeof r == "function")
    return r;
  const e = Promise.resolve(r);
  return () => e;
};
function f9(r) {
  const e = {};
  if (r = r.replace(/^\?/, ""), r)
    for (const t of r.split("&")) {
      let [n, i = null] = t.split("=");
      n = decodeURIComponent(n), i && (i = decodeURIComponent(i)), n in e ? Array.isArray(e[n]) ? e[n].push(i) : e[n] = [e[n], i] : e[n] = i;
    }
  return e;
}
const pg = (r) => {
  if (typeof r == "string")
    return pg(new URL(r));
  const { hostname: e, pathname: t, port: n, protocol: i, search: a } = r;
  let s;
  return a && (s = f9(a)), {
    hostname: e,
    port: n ? parseInt(n) : void 0,
    protocol: i,
    path: t,
    query: s
  };
}, y1 = (r) => {
  if (typeof r == "object") {
    if ("url" in r) {
      const e = pg(r.url);
      if (r.headers) {
        e.headers = {};
        for (const t in r.headers)
          e.headers[t.toLowerCase()] = r.headers[t].join(", ");
      }
      return e;
    }
    return r;
  }
  return pg(r);
}, d9 = (r) => () => Promise.reject(r);
class h9 {
  config;
  middlewareStack = hg();
  initConfig;
  handlers;
  constructor(e) {
    this.config = e;
    const { protocol: t, protocolSettings: n } = e;
    n && typeof t == "function" && (e.protocol = new t(n));
  }
  send(e, t, n) {
    const i = typeof t != "function" ? t : void 0, a = typeof t == "function" ? t : n, s = i === void 0 && this.config.cacheMiddleware === !0;
    let o;
    if (s) {
      this.handlers || (this.handlers = /* @__PURE__ */ new WeakMap());
      const l = this.handlers;
      l.has(e.constructor) ? o = l.get(e.constructor) : (o = e.resolveMiddleware(this.middlewareStack, this.config, i), l.set(e.constructor, o));
    } else
      delete this.handlers, o = e.resolveMiddleware(this.middlewareStack, this.config, i);
    if (a)
      o(e).then((l) => a(null, l.output), (l) => a(l)).catch(() => {
      });
    else
      return o(e).then((l) => l.output);
  }
  destroy() {
    this.config?.requestHandler?.destroy?.(), delete this.handlers;
  }
}
const zp = (r) => typeof r == "function" ? r() : r, GF = (r, e, t, n, i) => ({
  name: e,
  namespace: r,
  traits: t,
  input: n,
  output: i
}), p9 = (r) => (e, t) => async (n) => {
  const { response: i } = await e(n), { operationSchema: a } = fc(t), [, s, o, l, u, c] = a ?? [];
  try {
    const d = await r.protocol.deserializeResponse(GF(s, o, l, u, c), {
      ...r,
      ...t
    }, i);
    return {
      response: i,
      output: d
    };
  } catch (d) {
    if (Object.defineProperty(d, "$response", {
      value: i,
      enumerable: !1,
      writable: !1,
      configurable: !1
    }), !("$metadata" in d)) {
      const f = "Deserialization error: to see the raw response, inspect the hidden field {error}.$response on this object.";
      try {
        d.message += `
  ` + f;
      } catch {
        !t.logger || t.logger?.constructor?.name === "NoOpLogger" ? console.warn(f) : t.logger?.warn?.(f);
      }
      typeof d.$responseBodyText < "u" && d.$response && (d.$response.body = d.$responseBodyText);
      try {
        if (Xu.isInstance(i)) {
          const { headers: h = {}, statusCode: g } = i, v = Object.entries(h);
          d.$metadata = {
            httpStatusCode: g,
            requestId: wv(/^x-[\w-]+-request-?id$/, v),
            extendedRequestId: wv(/^x-[\w-]+-id-2$/, v),
            cfId: wv(/^x-[\w-]+-cf-id$/, v)
          };
        }
      } catch {
      }
    }
    throw d;
  }
}, wv = (r, e) => (e.find(([t]) => t.match(r)) || [void 0, void 0])[1], g9 = (r) => (e, t) => async (n) => {
  const { operationSchema: i } = fc(t), [, a, s, o, l, u] = i ?? [], c = t.endpointV2 ? async () => y1(t.endpointV2) : r.endpoint, d = await r.protocol.serializeRequest(GF(a, s, o, l, u), n.input, {
    ...r,
    ...t,
    endpoint: c
  });
  return e({
    ...n,
    request: d
  });
}, m9 = {
  name: "deserializerMiddleware",
  step: "deserialize",
  tags: ["DESERIALIZER"],
  override: !0
}, v9 = {
  name: "serializerMiddleware",
  step: "serialize",
  tags: ["SERIALIZER"],
  override: !0
};
function y9(r) {
  return {
    applyToStack: (e) => {
      e.add(g9(r), v9), e.add(p9(r), m9), r.protocol.setSerdeContext(r);
    }
  };
}
const xv = [];
function _f(r) {
  if (typeof r == "object")
    return r;
  if (r = r | 0, xv[r])
    return xv[r];
  const e = {};
  let t = 0;
  for (const n of [
    "httpLabel",
    "idempotent",
    "idempotencyToken",
    "sensitive",
    "httpPayload",
    "httpResponseCode",
    "httpQueryParams"
  ])
    (r >> t++ & 1) === 1 && (e[n] = 1);
  return xv[r] = e;
}
const wf = {
  it: /* @__PURE__ */ Symbol.for("@smithy/nor-struct-it"),
  ns: /* @__PURE__ */ Symbol.for("@smithy/ns")
}, Cv = [], Sv = {};
class mi {
  ref;
  memberName;
  static symbol = /* @__PURE__ */ Symbol.for("@smithy/nor");
  symbol = mi.symbol;
  name;
  schema;
  _isMemberSchema;
  traits;
  memberTraits;
  normalizedTraits;
  constructor(e, t) {
    this.ref = e, this.memberName = t;
    const n = [];
    let i = e, a = e;
    for (this._isMemberSchema = !1; Ev(i); )
      n.push(i[1]), i = i[0], a = zp(i), this._isMemberSchema = !0;
    if (n.length > 0) {
      this.memberTraits = {};
      for (let s = n.length - 1; s >= 0; --s) {
        const o = n[s];
        Object.assign(this.memberTraits, _f(o));
      }
    } else
      this.memberTraits = 0;
    if (a instanceof mi) {
      const s = this.memberTraits;
      Object.assign(this, a), this.memberTraits = Object.assign({}, s, a.getMemberTraits(), this.getMemberTraits()), this.normalizedTraits = void 0, this.memberName = t ?? a.memberName;
      return;
    }
    if (this.schema = zp(a), A9(this.schema) ? (this.name = `${this.schema[1]}#${this.schema[2]}`, this.traits = this.schema[3]) : (this.name = this.memberName ?? String(a), this.traits = 0), this._isMemberSchema && !t)
      throw new Error(`@smithy/core/schema - NormalizedSchema member init ${this.getName(!0)} missing member name.`);
  }
  static [Symbol.hasInstance](e) {
    const t = this.prototype.isPrototypeOf(e);
    return !t && typeof e == "object" && e !== null ? e.symbol === this.symbol : t;
  }
  static of(e) {
    const t = typeof e == "function" || typeof e == "object" && e !== null;
    if (typeof e == "number") {
      if (Cv[e])
        return Cv[e];
    } else if (typeof e == "string") {
      if (Sv[e])
        return Sv[e];
    } else if (t && e[wf.ns])
      return e[wf.ns];
    const n = zp(e);
    if (n instanceof mi)
      return n;
    if (Ev(n)) {
      const [a, s] = n;
      if (a instanceof mi)
        return Object.assign(a.getMergedTraits(), _f(s)), a;
      throw new Error(`@smithy/core/schema - may not init unwrapped member schema=${JSON.stringify(e, null, 2)}.`);
    }
    const i = new mi(n);
    return t ? e[wf.ns] = i : typeof n == "string" ? Sv[n] = i : typeof n == "number" ? Cv[n] = i : i;
  }
  getSchema() {
    const e = this.schema;
    return Array.isArray(e) && e[0] === 0 ? e[4] : e;
  }
  getName(e = !1) {
    const { name: t } = this;
    return !e && t && t.includes("#") ? t.split("#")[1] : t || void 0;
  }
  getMemberName() {
    return this.memberName;
  }
  isMemberSchema() {
    return this._isMemberSchema;
  }
  isListSchema() {
    const e = this.getSchema();
    return typeof e == "number" ? e >= 64 && e < 128 : e[0] === 1;
  }
  isMapSchema() {
    const e = this.getSchema();
    return typeof e == "number" ? e >= 128 && e <= 255 : e[0] === 2;
  }
  isStructSchema() {
    const e = this.getSchema();
    if (typeof e != "object")
      return !1;
    const t = e[0];
    return t === 3 || t === -3 || t === 4;
  }
  isUnionSchema() {
    const e = this.getSchema();
    return typeof e != "object" ? !1 : e[0] === 4;
  }
  isBlobSchema() {
    const e = this.getSchema();
    return e === 21 || e === 42;
  }
  isTimestampSchema() {
    const e = this.getSchema();
    return typeof e == "number" && e >= 4 && e <= 7;
  }
  isUnitSchema() {
    return this.getSchema() === "unit";
  }
  isDocumentSchema() {
    return this.getSchema() === 15;
  }
  isStringSchema() {
    return this.getSchema() === 0;
  }
  isBooleanSchema() {
    return this.getSchema() === 2;
  }
  isNumericSchema() {
    return this.getSchema() === 1;
  }
  isBigIntegerSchema() {
    return this.getSchema() === 17;
  }
  isBigDecimalSchema() {
    return this.getSchema() === 19;
  }
  isStreaming() {
    const { streaming: e } = this.getMergedTraits();
    return !!e || this.getSchema() === 42;
  }
  isIdempotencyToken() {
    return !!this.getMergedTraits().idempotencyToken;
  }
  getMergedTraits() {
    return this.normalizedTraits ?? (this.normalizedTraits = {
      ...this.getOwnTraits(),
      ...this.getMemberTraits()
    });
  }
  getMemberTraits() {
    return _f(this.memberTraits);
  }
  getOwnTraits() {
    return _f(this.traits);
  }
  getKeySchema() {
    const [e, t] = [this.isDocumentSchema(), this.isMapSchema()];
    if (!e && !t)
      throw new Error(`@smithy/core/schema - cannot get key for non-map: ${this.getName(!0)}`);
    const n = this.getSchema(), i = e ? 15 : n[4] ?? 0;
    return xf([i, 0], "key");
  }
  getValueSchema() {
    const e = this.getSchema(), [t, n, i] = [this.isDocumentSchema(), this.isMapSchema(), this.isListSchema()], a = typeof e == "number" ? 63 & e : e && typeof e == "object" && (n || i) ? e[3 + e[0]] : t ? 15 : void 0;
    if (a != null)
      return xf([a, 0], n ? "value" : "member");
    throw new Error(`@smithy/core/schema - ${this.getName(!0)} has no value member.`);
  }
  getMemberSchema(e) {
    const t = this.getSchema();
    if (this.isStructSchema() && t[4].includes(e)) {
      const n = t[4].indexOf(e), i = t[5][n];
      return xf(Ev(i) ? i : [i, 0], e);
    }
    if (this.isDocumentSchema())
      return xf([15, 0], e);
    throw new Error(`@smithy/core/schema - ${this.getName(!0)} has no member=${e}.`);
  }
  getMemberSchemas() {
    const e = {};
    try {
      for (const [t, n] of this.structIterator())
        e[t] = n;
    } catch {
    }
    return e;
  }
  getEventStreamMember() {
    if (this.isStructSchema()) {
      for (const [e, t] of this.structIterator())
        if (t.isStreaming() && t.isStructSchema())
          return e;
    }
    return "";
  }
  *structIterator() {
    if (this.isUnitSchema())
      return;
    if (!this.isStructSchema())
      throw new Error("@smithy/core/schema - cannot iterate non-struct schema.");
    const e = this.getSchema(), t = e[4].length;
    let n = e[wf.it];
    if (n && t === n.length) {
      yield* n;
      return;
    }
    n = Array(t);
    for (let i = 0; i < t; ++i) {
      const a = e[4][i], s = xf([e[5][i], 0], a);
      yield n[i] = [a, s];
    }
    e[wf.it] = n;
  }
}
function xf(r, e) {
  if (r instanceof mi)
    return Object.assign(r, {
      memberName: e,
      _isMemberSchema: !0
    });
  const t = mi;
  return new t(r, e);
}
const Ev = (r) => Array.isArray(r) && r.length === 2, A9 = (r) => Array.isArray(r) && r.length >= 5;
class Zi {
  namespace;
  schemas;
  exceptions;
  static registries = /* @__PURE__ */ new Map();
  constructor(e, t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map()) {
    this.namespace = e, this.schemas = t, this.exceptions = n;
  }
  static for(e) {
    return Zi.registries.has(e) || Zi.registries.set(e, new Zi(e)), Zi.registries.get(e);
  }
  copyFrom(e) {
    const { schemas: t, exceptions: n } = this;
    for (const [i, a] of e.schemas)
      t.has(i) || t.set(i, a);
    for (const [i, a] of e.exceptions)
      n.has(i) || n.set(i, a);
  }
  register(e, t) {
    const n = this.normalizeShapeId(e);
    for (const i of [this, Zi.for(n.split("#")[0])])
      i.schemas.set(n, t);
  }
  getSchema(e) {
    const t = this.normalizeShapeId(e);
    if (!this.schemas.has(t)) {
      if (!e.includes("#")) {
        const n = "#" + e, i = [];
        for (const [a, s] of this.schemas.entries())
          a.endsWith(n) && i.push(s);
        if (i.length === 1)
          return i[0];
      }
      throw new Error(`@smithy/core/schema - schema not found for ${t}`);
    }
    return this.schemas.get(t);
  }
  registerError(e, t) {
    const n = e, i = n[1];
    for (const a of [this, Zi.for(i)])
      a.schemas.set(i + "#" + n[2], n), a.exceptions.set(n, t);
  }
  getErrorCtor(e) {
    const t = e;
    return this.exceptions.has(t) ? this.exceptions.get(t) : Zi.for(t[1]).exceptions.get(t);
  }
  getBaseException() {
    for (const e of this.exceptions.keys())
      if (Array.isArray(e)) {
        const [, t, n] = e, i = t + "#" + n;
        if (i.startsWith("smithy.ts.sdk.synthetic.") && i.endsWith("ServiceException"))
          return e;
      }
  }
  find(e) {
    for (const t of this.schemas.values())
      if (e(t))
        return t;
  }
  clear() {
    this.schemas.clear(), this.exceptions.clear();
  }
  normalizeShapeId(e) {
    return e.includes("#") ? e : this.namespace + "#" + e;
  }
}
const kv = "***SensitiveInformation***";
function eA(r, e) {
  if (e == null)
    return e;
  const t = mi.of(r);
  if (t.getMergedTraits().sensitive)
    return kv;
  if (t.isListSchema()) {
    if (!!t.getValueSchema().getMergedTraits().sensitive)
      return kv;
  } else if (t.isMapSchema()) {
    if (!!t.getKeySchema().getMergedTraits().sensitive || !!t.getValueSchema().getMergedTraits().sensitive)
      return kv;
  } else if (t.isStructSchema() && typeof e == "object") {
    const n = e, i = {};
    for (const [a, s] of t.structIterator())
      n[a] != null && (i[a] = eA(s, n[a]));
    return i;
  }
  return e;
}
class A1 {
  middlewareStack = hg();
  schema;
  static classBuilder() {
    return new b9();
  }
  resolveMiddlewareWithContext(e, t, n, { middlewareFn: i, clientName: a, commandName: s, inputFilterSensitiveLog: o, outputFilterSensitiveLog: l, smithyContext: u, additionalContext: c, CommandCtor: d }) {
    for (const A of i.bind(this)(d, e, t, n))
      this.middlewareStack.use(A);
    const f = e.concat(this.middlewareStack), { logger: h } = t, g = {
      logger: h,
      clientName: a,
      commandName: s,
      inputFilterSensitiveLog: o,
      outputFilterSensitiveLog: l,
      [Zy]: {
        commandInstance: this,
        ...u
      },
      ...c
    }, { requestHandler: v } = t;
    let y = n ?? {};
    return u.eventStream && (y = {
      isEventStream: !0,
      ...y
    }), f.resolve((A) => v.handle(A.request, y), g);
  }
}
class b9 {
  _init = () => {
  };
  _ep = {};
  _middlewareFn = () => [];
  _commandName = "";
  _clientName = "";
  _additionalContext = {};
  _smithyContext = {};
  _inputFilterSensitiveLog = void 0;
  _outputFilterSensitiveLog = void 0;
  _serializer = null;
  _deserializer = null;
  _operationSchema;
  init(e) {
    this._init = e;
  }
  ep(e) {
    return this._ep = e, this;
  }
  m(e) {
    return this._middlewareFn = e, this;
  }
  s(e, t, n = {}) {
    return this._smithyContext = {
      service: e,
      operation: t,
      ...n
    }, this;
  }
  c(e = {}) {
    return this._additionalContext = e, this;
  }
  n(e, t) {
    return this._clientName = e, this._commandName = t, this;
  }
  f(e = (n) => n, t = (n) => n) {
    return this._inputFilterSensitiveLog = e, this._outputFilterSensitiveLog = t, this;
  }
  ser(e) {
    return this._serializer = e, this;
  }
  de(e) {
    return this._deserializer = e, this;
  }
  sc(e) {
    return this._operationSchema = e, this._smithyContext.operationSchema = e, this;
  }
  build() {
    const e = this;
    let t;
    return t = class extends A1 {
      input;
      static getEndpointParameterInstructions() {
        return e._ep;
      }
      constructor(...[n]) {
        super(), this.input = n ?? {}, e._init(this), this.schema = e._operationSchema;
      }
      resolveMiddleware(n, i, a) {
        const s = e._operationSchema, o = s?.[4] ?? s?.input, l = s?.[5] ?? s?.output;
        return this.resolveMiddlewareWithContext(n, i, a, {
          CommandCtor: t,
          middlewareFn: e._middlewareFn,
          clientName: e._clientName,
          commandName: e._commandName,
          inputFilterSensitiveLog: e._inputFilterSensitiveLog ?? (s ? eA.bind(null, o) : (u) => u),
          outputFilterSensitiveLog: e._outputFilterSensitiveLog ?? (s ? eA.bind(null, l) : (u) => u),
          smithyContext: e._smithyContext,
          additionalContext: e._additionalContext
        });
      }
      serialize = e._serializer;
      deserialize = e._deserializer;
    };
  }
}
class Du extends Error {
  $fault;
  $response;
  $retryable;
  $metadata;
  constructor(e) {
    super(e.message), Object.setPrototypeOf(this, Object.getPrototypeOf(this).constructor.prototype), this.name = e.name, this.$fault = e.$fault, this.$metadata = e.$metadata;
  }
  static isInstance(e) {
    if (!e)
      return !1;
    const t = e;
    return Du.prototype.isPrototypeOf(t) || !!t.$fault && !!t.$metadata && (t.$fault === "client" || t.$fault === "server");
  }
  static [Symbol.hasInstance](e) {
    if (!e)
      return !1;
    const t = e;
    return this === Du ? Du.isInstance(e) : Du.isInstance(e) ? t.name && this.name ? this.prototype.isPrototypeOf(e) || t.name === this.name : this.prototype.isPrototypeOf(e) : !1;
  }
}
const mE = (r, e = {}) => {
  Object.entries(e).filter(([, n]) => n !== void 0).forEach(([n, i]) => {
    (r[n] == null || r[n] === "") && (r[n] = i);
  });
  const t = r.message || r.Message || "UnknownError";
  return r.message = t, delete r.Message, r;
}, w9 = (r) => {
  switch (r) {
    case "standard":
      return {
        retryMode: "standard",
        connectionTimeout: 3100
      };
    case "in-region":
      return {
        retryMode: "standard",
        connectionTimeout: 1100
      };
    case "cross-region":
      return {
        retryMode: "standard",
        connectionTimeout: 3100
      };
    case "mobile":
      return {
        retryMode: "standard",
        connectionTimeout: 3e4
      };
    default:
      return {};
  }
}, qF = Object.values(gd), x9 = (r) => {
  const e = [];
  for (const t in gd) {
    const n = gd[t];
    r[n] !== void 0 && e.push({
      algorithmId: () => n,
      checksumConstructor: () => r[n]
    });
  }
  for (const [t, n] of Object.entries(r.checksumAlgorithms ?? {}))
    e.push({
      algorithmId: () => t,
      checksumConstructor: () => n
    });
  return {
    addChecksumAlgorithm(t) {
      r.checksumAlgorithms = r.checksumAlgorithms ?? {};
      const n = t.algorithmId(), i = t.checksumConstructor();
      qF.includes(n) ? r.checksumAlgorithms[n.toUpperCase()] = i : r.checksumAlgorithms[n] = i, e.push(t);
    },
    checksumAlgorithms() {
      return e;
    }
  };
}, C9 = (r) => {
  const e = {};
  return r.checksumAlgorithms().forEach((t) => {
    const n = t.algorithmId();
    qF.includes(n) && (e[n] = t.checksumConstructor());
  }), e;
}, S9 = (r) => ({
  setRetryStrategy(e) {
    r.retryStrategy = e;
  },
  retryStrategy() {
    return r.retryStrategy;
  }
}), E9 = (r) => {
  const e = {};
  return e.retryStrategy = r.retryStrategy(), e;
}, k9 = (r) => Object.assign(x9(r), S9(r)), T9 = (r) => Object.assign(C9(r), E9(r));
class WF {
  trace() {
  }
  debug() {
  }
  info() {
  }
  warn() {
  }
  error() {
  }
}
const QF = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", vE = Object.entries(QF).reduce((r, [e, t]) => (r[t] = Number(e), r), {}), F9 = QF.split(""), Nu = 6, qf = 8, I9 = 63, Vg = (r) => {
  let e = r.length / 4 * 3;
  r.slice(-2) === "==" ? e -= 2 : r.slice(-1) === "=" && e--;
  const t = new ArrayBuffer(e), n = new DataView(t);
  for (let i = 0; i < r.length; i += 4) {
    let a = 0, s = 0;
    for (let u = i, c = i + 3; u <= c; u++)
      if (r[u] !== "=") {
        if (!(r[u] in vE))
          throw new TypeError(`Invalid character ${r[u]} in base64 string.`);
        a |= vE[r[u]] << (c - u) * Nu, s += Nu;
      } else
        a >>= Nu;
    const o = i / 4 * 3;
    a >>= s % qf;
    const l = Math.floor(s / qf);
    for (let u = 0; u < l; u++) {
      const c = (l - u - 1) * qf;
      n.setUint8(o + u, (a & 255 << c) >> c);
    }
  }
  return new Uint8Array(t);
}, Ju = (r) => new TextEncoder().encode(r);
function gg(r) {
  let e;
  typeof r == "string" ? e = Ju(r) : e = r;
  const t = typeof e == "object" && typeof e.length == "number", n = typeof e == "object" && typeof e.byteOffset == "number" && typeof e.byteLength == "number";
  if (!t && !n)
    throw new Error("@smithy/util-base64: toBase64 encoder function only accepts string | Uint8Array.");
  let i = "";
  for (let a = 0; a < e.length; a += 3) {
    let s = 0, o = 0;
    for (let u = a, c = Math.min(a + 3, e.length); u < c; u++)
      s |= e[u] << (c - u - 1) * qf, o += qf;
    const l = Math.ceil(o / Nu);
    s <<= l * Nu - o;
    for (let u = 1; u <= l; u++) {
      const c = (l - u) * Nu;
      i += F9[(s & I9 << c) >> c];
    }
    i += "==".slice(0, 4 - l);
  }
  return i;
}
function D9(r, e, t, n) {
  return class $p extends Uint8Array {
    static fromString(a, s = "utf-8") {
      if (typeof a == "string")
        return s === "base64" ? $p.mutate(n(a)) : $p.mutate(e(a));
      throw new Error(`Unsupported conversion from ${typeof a} to Uint8ArrayBlobAdapter.`);
    }
    static mutate(a) {
      return Object.setPrototypeOf(a, $p.prototype), a;
    }
    transformToString(a = "utf-8") {
      return a === "base64" ? t(this) : r(this);
    }
  };
}
const b1 = (r) => {
  if (typeof r == "string")
    return r;
  if (typeof r != "object" || typeof r.byteOffset != "number" || typeof r.byteLength != "number")
    throw new Error("@smithy/util-utf8: toUtf8 encoder function only accepts string | Uint8Array.");
  return new TextDecoder("utf-8").decode(r);
}, Ii = Array.from({ length: 256 }, (r, e) => e.toString(16).padStart(2, "0"));
function P9(r) {
  return typeof crypto < "u" && typeof crypto.randomUUID == "function" ? () => crypto.randomUUID() : () => {
    const e = new Uint8Array(16);
    return r(e), e[6] = e[6] & 15 | 64, e[8] = e[8] & 63 | 128, Ii[e[0]] + Ii[e[1]] + Ii[e[2]] + Ii[e[3]] + "-" + Ii[e[4]] + Ii[e[5]] + "-" + Ii[e[6]] + Ii[e[7]] + "-" + Ii[e[8]] + Ii[e[9]] + "-" + Ii[e[10]] + Ii[e[11]] + Ii[e[12]] + Ii[e[13]] + Ii[e[14]] + Ii[e[15]];
  };
}
const tA = (r) => {
  if (r != null) {
    if (typeof r == "string") {
      const e = parseFloat(r);
      if (!Number.isNaN(e))
        return String(e) !== String(r) && V9.warn(U9(`Expected number but observed string: ${r}`)), e;
    }
    if (typeof r == "number")
      return r;
    throw new TypeError(`Expected number, got ${typeof r}: ${r}`);
  }
}, R9 = Math.ceil(2 ** 127 * (2 - 2 ** -23)), yE = (r) => {
  const e = tA(r);
  if (e !== void 0 && !Number.isNaN(e) && e !== 1 / 0 && e !== -1 / 0 && Math.abs(e) > R9)
    throw new TypeError(`Expected 32-bit float, got ${r}`);
  return e;
}, O9 = (r) => {
  if (r != null) {
    if (Number.isInteger(r) && !Number.isNaN(r))
      return r;
    throw new TypeError(`Expected integer, got ${typeof r}: ${r}`);
  }
}, AE = (r) => YF(r, 16), bE = (r) => YF(r, 8), YF = (r, e) => {
  const t = O9(r);
  if (t !== void 0 && B9(t, e) !== t)
    throw new TypeError(`Expected ${e}-bit integer, got ${r}`);
  return t;
}, B9 = (r, e) => {
  switch (e) {
    case 32:
      return Int32Array.of(r)[0];
    case 16:
      return Int16Array.of(r)[0];
    case 8:
      return Int8Array.of(r)[0];
  }
}, M9 = (r) => tA(typeof r == "string" ? zg(r) : r), _9 = (r) => yE(typeof r == "string" ? zg(r) : r), N9 = /(-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?)|(-?Infinity)|(NaN)/g, zg = (r) => {
  const e = r.match(N9);
  if (e === null || e[0].length !== r.length)
    throw new TypeError("Expected real number, got implicit NaN");
  return parseFloat(r);
}, mg = (r) => AE(typeof r == "string" ? zg(r) : r), L9 = (r) => bE(typeof r == "string" ? zg(r) : r), U9 = (r) => String(new TypeError(r).stack || r).split(`
`).slice(0, 5).filter((e) => !e.includes("stackTraceWarning")).join(`
`), V9 = {
  warn: console.warn
}, z9 = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], w1 = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
function $9(r) {
  const e = r.getUTCFullYear(), t = r.getUTCMonth(), n = r.getUTCDay(), i = r.getUTCDate(), a = r.getUTCHours(), s = r.getUTCMinutes(), o = r.getUTCSeconds(), l = i < 10 ? `0${i}` : `${i}`, u = a < 10 ? `0${a}` : `${a}`, c = s < 10 ? `0${s}` : `${s}`, d = o < 10 ? `0${o}` : `${o}`;
  return `${z9[n]}, ${l} ${w1[t]} ${e} ${u}:${c}:${d} GMT`;
}
const H9 = new RegExp(/^(\d{4})-(\d{2})-(\d{2})[tT](\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?(([-+]\d{2}\:\d{2})|[zZ])$/), j9 = (r) => {
  if (r == null)
    return;
  if (typeof r != "string")
    throw new TypeError("RFC-3339 date-times must be expressed as strings");
  const e = H9.exec(r);
  if (!e)
    throw new TypeError("Invalid RFC-3339 date-time value");
  const [t, n, i, a, s, o, l, u, c] = e, d = mg(md(n)), f = go(i, "month", 1, 12), h = go(a, "day", 1, 31), g = Hp(d, f, h, { hours: s, minutes: o, seconds: l, fractionalMilliseconds: u });
  return c.toUpperCase() != "Z" && g.setTime(g.getTime() - rV(c)), g;
}, G9 = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d{2}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/), q9 = new RegExp(/^(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d{2})-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/), W9 = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( [1-9]|\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? (\d{4})$/), XF = (r) => {
  if (r == null)
    return;
  if (typeof r != "string")
    throw new TypeError("RFC-7231 date-times must be expressed as strings");
  let e = G9.exec(r);
  if (e) {
    const [t, n, i, a, s, o, l, u] = e;
    return Hp(mg(md(a)), Tv(i), go(n, "day", 1, 31), { hours: s, minutes: o, seconds: l, fractionalMilliseconds: u });
  }
  if (e = q9.exec(r), e) {
    const [t, n, i, a, s, o, l, u] = e;
    return J9(Hp(Y9(a), Tv(i), go(n, "day", 1, 31), {
      hours: s,
      minutes: o,
      seconds: l,
      fractionalMilliseconds: u
    }));
  }
  if (e = W9.exec(r), e) {
    const [t, n, i, a, s, o, l, u] = e;
    return Hp(mg(md(u)), Tv(n), go(i.trimLeft(), "day", 1, 31), { hours: a, minutes: s, seconds: o, fractionalMilliseconds: l });
  }
  throw new TypeError("Invalid RFC-7231 date-time value");
}, Q9 = (r) => {
  if (r == null)
    return;
  let e;
  if (typeof r == "number")
    e = r;
  else if (typeof r == "string")
    e = M9(r);
  else if (typeof r == "object" && r.tag === 1)
    e = r.value;
  else
    throw new TypeError("Epoch timestamps must be expressed as floating point numbers or their string representation");
  if (Number.isNaN(e) || e === 1 / 0 || e === -1 / 0)
    throw new TypeError("Epoch timestamps must be valid, non-Infinite, non-NaN numerics");
  return new Date(Math.round(e * 1e3));
}, Hp = (r, e, t, n) => {
  const i = e - 1;
  return Z9(r, i, t), new Date(Date.UTC(r, i, t, go(n.hours, "hour", 0, 23), go(n.minutes, "minute", 0, 59), go(n.seconds, "seconds", 0, 60), tV(n.fractionalMilliseconds)));
}, Y9 = (r) => {
  const e = (/* @__PURE__ */ new Date()).getUTCFullYear(), t = Math.floor(e / 100) * 100 + mg(md(r));
  return t < e ? t + 100 : t;
}, X9 = 50 * 365 * 24 * 60 * 60 * 1e3, J9 = (r) => r.getTime() - (/* @__PURE__ */ new Date()).getTime() > X9 ? new Date(Date.UTC(r.getUTCFullYear() - 100, r.getUTCMonth(), r.getUTCDate(), r.getUTCHours(), r.getUTCMinutes(), r.getUTCSeconds(), r.getUTCMilliseconds())) : r, Tv = (r) => {
  const e = w1.indexOf(r);
  if (e < 0)
    throw new TypeError(`Invalid month: ${r}`);
  return e + 1;
}, K9 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Z9 = (r, e, t) => {
  let n = K9[e];
  if (e === 1 && eV(r) && (n = 29), t > n)
    throw new TypeError(`Invalid day for ${w1[e]} in ${r}: ${t}`);
}, eV = (r) => r % 4 === 0 && (r % 100 !== 0 || r % 400 === 0), go = (r, e, t, n) => {
  const i = L9(md(r));
  if (i < t || i > n)
    throw new TypeError(`${e} must be between ${t} and ${n}, inclusive`);
  return i;
}, tV = (r) => r == null ? 0 : _9("0." + r) * 1e3, rV = (r) => {
  const e = r[0];
  let t = 1;
  if (e == "+")
    t = 1;
  else if (e == "-")
    t = -1;
  else
    throw new TypeError(`Offset direction, ${e}, must be "+" or "-"`);
  const n = Number(r.substring(1, 3)), i = Number(r.substring(4, 6));
  return t * (n * 60 + i) * 60 * 1e3;
}, md = (r) => {
  let e = 0;
  for (; e < r.length - 1 && r.charAt(e) === "0"; )
    e++;
  return e === 0 ? r : r.slice(e);
}, co = function(e) {
  return Object.assign(new String(e), {
    deserializeJSON() {
      return JSON.parse(String(e));
    },
    toString() {
      return String(e);
    },
    toJSON() {
      return String(e);
    }
  });
};
co.from = (r) => r && typeof r == "object" && (r instanceof co || "deserializeJSON" in r) ? r : typeof r == "string" || Object.getPrototypeOf(r) === String.prototype ? co(String(r)) : co(JSON.stringify(r));
co.fromObject = co.from;
const wE = /^-?\d*(\.\d+)?$/;
class rs {
  string;
  type;
  constructor(e, t) {
    if (this.string = e, this.type = t, !wE.test(e))
      throw new Error('@smithy/core/serde - NumericValue must only contain [0-9], at most one decimal point ".", and an optional negation prefix "-".');
  }
  toString() {
    return this.string;
  }
  static [Symbol.hasInstance](e) {
    if (!e || typeof e != "object")
      return !1;
    const t = e;
    return rs.prototype.isPrototypeOf(e) || t.type === "bigDecimal" && wE.test(t.string);
  }
}
const JF = {}, rA = {};
for (let r = 0; r < 256; r++) {
  let e = r.toString(16).toLowerCase();
  e.length === 1 && (e = `0${e}`), JF[r] = e, rA[e] = r;
}
function nV(r) {
  if (r.length % 2 !== 0)
    throw new Error("Hex encoded strings must have an even number length");
  const e = new Uint8Array(r.length / 2);
  for (let t = 0; t < r.length; t += 2) {
    const n = r.slice(t, t + 2).toLowerCase();
    if (n in rA)
      e[t / 2] = rA[n];
    else
      throw new Error(`Cannot decode unrecognized sequence ${n} as hexadecimal`);
  }
  return e;
}
function vl(r) {
  let e = "";
  for (let t = 0; t < r.byteLength; t++)
    e += JF[r[t]];
  return e;
}
const xE = typeof TextEncoder == "function" ? new TextEncoder() : null, iV = (r) => {
  if (typeof r == "string") {
    if (xE)
      return xE.encode(r).byteLength;
    let e = r.length;
    for (let t = e - 1; t >= 0; t--) {
      const n = r.charCodeAt(t);
      n > 127 && n <= 2047 ? e++ : n > 2047 && n <= 65535 && (e += 2), n >= 56320 && n <= 57343 && t--;
    }
    return e;
  } else {
    if (typeof r.byteLength == "number")
      return r.byteLength;
    if (typeof r.size == "number")
      return r.size;
  }
  throw new Error(`Body Length computation failed for ${r}`);
}, vd = (r) => typeof r == "string" ? Ju(r) : ArrayBuffer.isView(r) ? new Uint8Array(r.buffer, r.byteOffset, r.byteLength / Uint8Array.BYTES_PER_ELEMENT) : new Uint8Array(r), aV = (r) => typeof ArrayBuffer == "function" && r instanceof ArrayBuffer || Object.prototype.toString.call(r) === "[object ArrayBuffer]", KF = async (r) => {
}, sV = async (r) => {
  const e = r?.Bucket || "";
  if (typeof r.Bucket == "string" && (r.Bucket = e.replace(/#/g, encodeURIComponent("#")).replace(/\?/g, encodeURIComponent("?"))), fV(e)) {
    if (r.ForcePathStyle === !0)
      throw new Error("Path-style addressing cannot be used with ARN buckets");
  } else (!cV(e) || e.indexOf(".") !== -1 && !String(r.Endpoint).startsWith("http:") || e.toLowerCase() !== e || e.length < 3) && (r.ForcePathStyle = !0);
  return r.DisableMultiRegionAccessPoints && (r.disableMultiRegionAccessPoints = !0, r.DisableMRAP = !0), r;
}, oV = /^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/, lV = /(\d+\.){3}\d+/, uV = /\.\./, cV = (r) => oV.test(r) && !lV.test(r) && !uV.test(r), fV = (r) => {
  const [e, t, n, , , i] = r.split(":"), a = e === "arn" && r.split(":").length >= 6, s = !!(a && t && n && i);
  if (a && !s)
    throw new Error(`Invalid ARN: ${r} was an invalid ARN.`);
  return s;
}, dV = (r, e, t, n = !1) => {
  const i = async () => {
    let a;
    return n ? a = t.clientContextParams?.[r] ?? t[r] ?? t[e] : a = t[r] ?? t[e], typeof a == "function" ? a() : a;
  };
  return r === "credentialScope" || e === "CredentialScope" ? async () => {
    const a = typeof t.credentials == "function" ? await t.credentials() : t.credentials;
    return a?.credentialScope ?? a?.CredentialScope;
  } : r === "accountId" || e === "AccountId" ? async () => {
    const a = typeof t.credentials == "function" ? await t.credentials() : t.credentials;
    return a?.accountId ?? a?.AccountId;
  } : r === "endpoint" || e === "endpoint" ? async () => {
    if (t.isCustomEndpoint === !1)
      return;
    const a = await i();
    if (a && typeof a == "object") {
      if ("url" in a)
        return a.url.href;
      if ("hostname" in a) {
        const { protocol: s, hostname: o, port: l, path: u } = a;
        return `${s}//${o}${l ? ":" + l : ""}${u}`;
      }
    }
    return a;
  } : i;
};
function hV(r) {
  return async (e, t, n, i) => {
    if (!n.isCustomEndpoint) {
      let o;
      n.serviceConfiguredEndpoint ? o = await n.serviceConfiguredEndpoint() : o = await r(n.serviceId), o && (n.endpoint = () => Promise.resolve(y1(o)), n.isCustomEndpoint = !0);
    }
    const a = await pV(e, t, n);
    if (typeof n.endpointProvider != "function")
      throw new Error("config.endpointProvider is not set.");
    const s = n.endpointProvider(a, i);
    if (n.isCustomEndpoint && n.endpoint) {
      const o = await n.endpoint();
      if (o?.headers) {
        s.headers ??= {};
        for (const [l, u] of Object.entries(o.headers))
          s.headers[l] = Array.isArray(u) ? u : [u];
      }
    }
    return s;
  };
}
const pV = async (r, e, t) => {
  const n = {}, i = e?.getEndpointParameterInstructions?.() || {};
  for (const [a, s] of Object.entries(i))
    switch (s.type) {
      case "staticContextParams":
        n[a] = s.value;
        break;
      case "contextParams":
        n[a] = r[s.name];
        break;
      case "clientContextParams":
      case "builtInParams":
        n[a] = await dV(s.name, a, t, s.type !== "builtInParams")();
        break;
      case "operationContextParams":
        n[a] = s.get(r);
        break;
      default:
        throw new Error("Unrecognized endpoint parameter instruction: " + JSON.stringify(s));
    }
  return Object.keys(i).length === 0 && Object.assign(n, t), String(t.serviceId).toLowerCase() === "s3" && await sV(n), n;
};
function gV(r, e, t) {
  r.__smithy_context ? r.__smithy_context.features || (r.__smithy_context.features = {}) : r.__smithy_context = { features: {} }, r.__smithy_context.features[e] = t;
}
function mV(r) {
  const e = hV(r);
  return ({ config: t, instructions: n }) => (i, a) => async (s) => {
    t.isCustomEndpoint && gV(a, "ENDPOINT_OVERRIDE", "N");
    const o = await e(s.input, {
      getEndpointParameterInstructions() {
        return n;
      }
    }, { ...t }, a);
    a.endpointV2 = o, a.authSchemes = o.properties?.authSchemes;
    const l = a.authSchemes?.[0];
    if (l) {
      a.signing_region = l.signingRegion, a.signing_service = l.signingName;
      const c = fc(a)?.selectedHttpAuthScheme?.httpAuthOption;
      c && (c.signingProperties = Object.assign(c.signingProperties || {}, {
        signing_region: l.signingRegion,
        signingRegion: l.signingRegion,
        signing_service: l.signingName,
        signingName: l.signingName,
        signingRegionSet: l.signingRegionSet
      }, l.properties));
    }
    return i({
      ...s
    });
  };
}
const vV = {
  name: "serializerMiddleware"
}, yV = {
  step: "serialize",
  tags: ["ENDPOINT_PARAMETERS", "ENDPOINT_V2", "ENDPOINT"],
  name: "endpointV2Middleware",
  override: !0,
  relation: "before",
  toMiddleware: vV.name
};
function AV(r) {
  const e = mV(r);
  return (t, n) => ({
    applyToStack: (i) => {
      i.addRelativeTo(e({
        config: t,
        instructions: n
      }), yV);
    }
  });
}
function bV(r) {
  return (e) => {
    const t = e.tls ?? !0, { endpoint: n, useDualstackEndpoint: i, useFipsEndpoint: a } = e, s = n != null ? async () => y1(await Ps(n)()) : void 0, l = Object.assign(e, {
      endpoint: s,
      tls: t,
      isCustomEndpoint: !!n,
      useDualstackEndpoint: Ps(i ?? !1),
      useFipsEndpoint: Ps(a ?? !1)
    });
    let u;
    return l.serviceConfiguredEndpoint = async () => (e.serviceId && !u && (u = r(e.serviceId)), u), l;
  };
}
class x1 {
  nodes;
  root;
  conditions;
  results;
  constructor(e, t, n, i) {
    this.nodes = e, this.root = t, this.conditions = n, this.results = i;
  }
  static from(e, t, n, i) {
    return new x1(e, t, n, i);
  }
}
class wV {
  capacity;
  data = /* @__PURE__ */ new Map();
  parameters = [];
  constructor({ size: e, params: t }) {
    this.capacity = e ?? 50, t && (this.parameters = t);
  }
  get(e, t) {
    const n = this.hash(e);
    if (n === !1)
      return t();
    if (!this.data.has(n)) {
      if (this.data.size > this.capacity + 10) {
        const i = this.data.keys();
        let a = 0;
        for (; ; ) {
          const { value: s, done: o } = i.next();
          if (this.data.delete(s), o || ++a > 10)
            break;
        }
      }
      this.data.set(n, t());
    }
    return this.data.get(n);
  }
  size() {
    return this.data.size;
  }
  hash(e) {
    let t = "";
    const { parameters: n } = this;
    if (n.length === 0)
      return !1;
    for (const i of n) {
      const a = String(e[i] ?? "");
      if (a.includes("|;"))
        return !1;
      t += a + "|;";
    }
    return t;
  }
}
class Ra extends Error {
  constructor(e) {
    super(e), this.name = "EndpointError";
  }
}
const xV = "endpoints";
function vg(r) {
  return typeof r != "object" || r == null ? r : "ref" in r ? `$${vg(r.ref)}` : "fn" in r ? `${r.fn}(${(r.argv || []).map(vg).join(", ")})` : JSON.stringify(r, null, 2);
}
const C1 = {}, CV = (r, e) => r === e;
function SV(...r) {
  for (const e of r)
    if (e != null)
      return e;
}
const EV = (r) => {
  const e = r.split("."), t = [];
  for (const n of e) {
    const i = n.indexOf("[");
    if (i !== -1) {
      if (n.indexOf("]") !== n.length - 1)
        throw new Ra(`Path: '${r}' does not end with ']'`);
      const a = n.slice(i + 1, -1);
      if (Number.isNaN(parseInt(a)))
        throw new Ra(`Invalid array index: '${a}' in path: '${r}'`);
      i !== 0 && t.push(n.slice(0, i)), t.push(a);
    } else
      t.push(n);
  }
  return t;
}, ZF = (r, e) => EV(e).reduce((t, n) => {
  if (typeof t != "object")
    throw new Ra(`Index '${n}' in '${e}' not found in '${JSON.stringify(r)}'`);
  if (Array.isArray(t)) {
    const i = parseInt(n);
    return t[i < 0 ? t.length + i : i];
  }
  return t[n];
}, r), kV = (r) => r != null;
function TV(r, e, t) {
  return r ? e : t;
}
const FV = (r) => !r, IV = new RegExp("^(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}$"), eI = (r) => IV.test(r) || r.startsWith("[") && r.endsWith("]"), Fv = {
  [pd.HTTP]: 80,
  [pd.HTTPS]: 443
}, DV = (r) => {
  const e = (() => {
    try {
      if (r instanceof URL)
        return r;
      if (typeof r == "object" && "hostname" in r) {
        const { hostname: f, port: h, protocol: g = "", path: v = "", query: y = {} } = r, A = new URL(`${g}//${f}${h ? `:${h}` : ""}${v}`);
        return A.search = Object.entries(y).map(([x, k]) => `${x}=${k}`).join("&"), A;
      }
      return new URL(r);
    } catch {
      return null;
    }
  })();
  if (!e)
    return console.error(`Unable to parse ${JSON.stringify(r)} as a whatwg URL.`), null;
  const t = e.href, { host: n, hostname: i, pathname: a, protocol: s, search: o } = e;
  if (o)
    return null;
  const l = s.slice(0, -1);
  if (!Object.values(pd).includes(l))
    return null;
  const u = eI(i), c = t.includes(`${n}:${Fv[l]}`) || typeof r == "string" && r.includes(`${n}:${Fv[l]}`), d = `${n}${c ? `:${Fv[l]}` : ""}`;
  return {
    scheme: l,
    authority: d,
    path: a,
    normalizedPath: a.endsWith("/") ? a : `${a}/`,
    isIp: u
  };
};
function PV(r, e, t) {
  if (t === 1)
    return [r];
  if (r === "")
    return [""];
  const n = r.split(e);
  return t === 0 ? n : n.slice(0, t - 1).concat(n.slice(1).join(e));
}
const RV = (r, e) => r === e, OV = (r, e, t, n) => r == null || e >= t || r.length < t || /[^\u0000-\u007f]/.test(r) ? null : n ? r.substring(r.length - t, r.length - e) : r.substring(e, t), BV = (r) => encodeURIComponent(r).replace(/[!*'()]/g, (e) => `%${e.charCodeAt(0).toString(16).toUpperCase()}`), MV = {
  booleanEquals: CV,
  coalesce: SV,
  getAttr: ZF,
  isSet: kV,
  isValidHostLabel: Ug,
  ite: TV,
  not: FV,
  parseURL: DV,
  split: PV,
  stringEquals: RV,
  substring: OV,
  uriEncode: BV
}, tI = (r, e) => {
  const t = [], { referenceRecord: n, endpointParams: i } = e;
  let a = 0;
  for (; a < r.length; ) {
    const s = r.indexOf("{", a);
    if (s === -1) {
      t.push(r.slice(a));
      break;
    }
    t.push(r.slice(a, s));
    const o = r.indexOf("}", s);
    if (o === -1) {
      t.push(r.slice(s));
      break;
    }
    r[s + 1] === "{" && r[o + 1] === "}" && (t.push(r.slice(s + 1, o)), a = o + 2);
    const l = r.substring(s + 1, o);
    if (l.includes("#")) {
      const [u, c] = l.split("#");
      t.push(ZF(n[u] ?? i[u], c));
    } else
      t.push(n[l] ?? i[l]);
    a = o + 1;
  }
  return t.join("");
}, _V = ({ ref: r }, e) => e.referenceRecord[r] ?? e.endpointParams[r], $g = (r, e, t) => {
  if (typeof r == "string")
    return tI(r, t);
  if (r.fn)
    return nI.callFunction(r, t);
  if (r.ref)
    return _V(r, t);
  throw new Ra(`'${e}': ${String(r)} is not a string, function or reference.`);
}, rI = ({ fn: r, argv: e }, t) => {
  const n = Array(e.length);
  for (let s = 0; s < n.length; ++s) {
    const o = e[s];
    typeof o == "boolean" || typeof o == "number" ? n[s] = o : n[s] = nI.evaluateExpression(o, "arg", t);
  }
  const i = r.indexOf(".");
  if (i !== -1) {
    const o = C1[r.slice(0, i)]?.[r.slice(i + 1)];
    if (typeof o == "function")
      return o(...n);
  }
  const a = MV[r];
  if (typeof a == "function")
    return a(...n);
  throw new Error(`function ${r} not loaded in endpointFunctions.`);
}, nI = {
  evaluateExpression: $g,
  callFunction: rI
}, NV = (r, e) => {
  const { assign: t } = r;
  if (t && t in e.referenceRecord)
    throw new Ra(`'${t}' is already defined in Reference Record.`);
  const n = rI(r, e);
  e.logger?.debug?.(`${xV} evaluateCondition: ${vg(r)} = ${vg(n)}`);
  const i = n === "" ? !0 : !!n;
  return t != null ? { result: i, toAssign: { name: t, value: n } } : { result: i };
}, LV = (r, e) => Object.entries(r ?? {}).reduce((t, [n, i]) => (t[n] = i.map((a) => {
  const s = $g(a, "Header value entry", e);
  if (typeof s != "string")
    throw new Ra(`Header '${n}' value '${s}' is not a string`);
  return s;
}), t), {}), iI = (r, e) => Object.entries(r).reduce((t, [n, i]) => (t[n] = sI.getEndpointProperty(i, e), t), {}), aI = (r, e) => {
  if (Array.isArray(r))
    return r.map((t) => aI(t, e));
  switch (typeof r) {
    case "string":
      return tI(r, e);
    case "object":
      if (r === null)
        throw new Ra(`Unexpected endpoint property: ${r}`);
      return sI.getEndpointProperties(r, e);
    case "boolean":
      return r;
    default:
      throw new Ra(`Unexpected endpoint property type: ${typeof r}`);
  }
}, sI = {
  getEndpointProperty: aI,
  getEndpointProperties: iI
}, UV = (r, e) => {
  const t = $g(r, "Endpoint URL", e);
  if (typeof t == "string")
    try {
      return new URL(t);
    } catch (n) {
      throw console.error(`Failed to construct URL with ${t}`, n), n;
    }
  throw new Ra(`Endpoint URL must be a string, got ${typeof t}`);
}, Iv = 1e8, VV = (r, e) => {
  const { nodes: t, root: n, results: i, conditions: a } = r;
  let s = n;
  const o = {}, l = {
    referenceRecord: o,
    endpointParams: e.endpointParams,
    logger: e.logger
  };
  for (; s !== 1 && s !== -1 && s < Iv; ) {
    const u = 3 * (Math.abs(s) - 1), [c, d, f] = [t[u], t[u + 1], t[u + 2]], [h, g, v] = a[c], y = NV({ fn: h, assign: v, argv: g }, l);
    if (y.toAssign) {
      const { name: A, value: x } = y.toAssign;
      o[A] = x;
    }
    s = s >= 0 === y.result ? d : f;
  }
  if (s >= Iv) {
    const u = i[s - Iv];
    if (u[0] === -1) {
      const [, h] = u;
      throw new Ra($g(h, "Error", l));
    }
    const [c, d, f] = u;
    return {
      url: UV(c, l),
      properties: iI(d, l),
      headers: LV(f ?? {}, l)
    };
  }
  throw new Ra("No matching endpoint.");
}, zV = bV(KF), oI = AV(KF);
class Dv extends D9(b1, Ju, gg, Vg) {
}
const $V = (r) => crypto.getRandomValues(r), lI = P9($V), HV = lI, nA = async (r = new Uint8Array(), e) => {
  if (r instanceof Uint8Array)
    return Dv.mutate(r);
  if (!r)
    return Dv.mutate(new Uint8Array());
  const t = e.streamCollector(r);
  return Dv.mutate(await t);
};
class jV {
  serdeContext;
  setSerdeContext(e) {
    this.serdeContext = e;
  }
}
class GV extends jV {
  options;
  compositeErrorRegistry;
  constructor(e) {
    super(), this.options = e, this.compositeErrorRegistry = Zi.for(e.defaultNamespace);
    for (const t of e.errorTypeRegistries ?? [])
      this.compositeErrorRegistry.copyFrom(t);
  }
  getRequestType() {
    return ra;
  }
  getResponseType() {
    return Xu;
  }
  setSerdeContext(e) {
    this.serdeContext = e, this.serializer.setSerdeContext(e), this.deserializer.setSerdeContext(e), this.getPayloadCodec() && this.getPayloadCodec().setSerdeContext(e);
  }
  updateServiceEndpoint(e, t) {
    if ("url" in t) {
      e.protocol = t.url.protocol, e.hostname = t.url.hostname, e.port = t.url.port ? Number(t.url.port) : void 0, e.path = t.url.pathname, e.fragment = t.url.hash || void 0, e.username = t.url.username || void 0, e.password = t.url.password || void 0, e.query || (e.query = {});
      for (const [n, i] of t.url.searchParams.entries())
        e.query[n] = i;
      if (t.headers)
        for (const n in t.headers)
          e.headers[n] = t.headers[n].join(", ");
      return e;
    } else {
      if (e.protocol = t.protocol, e.hostname = t.hostname, e.port = t.port ? Number(t.port) : void 0, e.path = t.path, e.query = {
        ...t.query
      }, t.headers)
        for (const n in t.headers)
          e.headers[n] = t.headers[n];
      return e;
    }
  }
  setHostPrefix(e, t, n) {
    if (this.serdeContext?.disableHostPrefix)
      return;
    const i = mi.of(t.input), a = _f(t.traits ?? {});
    if (a.endpoint) {
      let s = a.endpoint?.[0];
      if (typeof s == "string") {
        for (const [o, l] of i.structIterator()) {
          if (!l.getMergedTraits().hostLabel)
            continue;
          const u = n[o];
          if (typeof u != "string")
            throw new Error(`@smithy/core/schema - ${o} in input must be a string as hostLabel.`);
          s = s.replace(`{${o}}`, u);
        }
        e.hostname = s + e.hostname;
      }
    }
  }
  deserializeMetadata(e) {
    return {
      httpStatusCode: e.statusCode,
      requestId: e.headers["x-amzn-requestid"] ?? e.headers["x-amzn-request-id"] ?? e.headers["x-amz-request-id"],
      extendedRequestId: e.headers["x-amz-id-2"],
      cfId: e.headers["x-amz-cf-id"]
    };
  }
  async serializeEventStream({ eventStream: e, requestSchema: t, initialRequest: n }) {
    return (await this.loadEventStreamCapability()).serializeEventStream({
      eventStream: e,
      requestSchema: t,
      initialRequest: n
    });
  }
  async deserializeEventStream({ response: e, responseSchema: t, initialResponseContainer: n }) {
    return (await this.loadEventStreamCapability()).deserializeEventStream({
      response: e,
      responseSchema: t,
      initialResponseContainer: n
    });
  }
  async loadEventStreamCapability() {
    const { EventStreamSerde: e, eventStreamSerdeProvider: t } = await import("./index.browser-XZIYK-aA.js"), n = this.resolveEventStreamMarshaller(t);
    return new e({
      marshaller: n,
      serializer: this.serializer,
      deserializer: this.deserializer,
      serdeContext: this.serdeContext,
      defaultContentType: this.getDefaultContentType()
    });
  }
  resolveEventStreamMarshaller(e) {
    const t = this.serdeContext;
    return t.eventStreamMarshaller ? t.eventStreamMarshaller : e(this.serdeContext);
  }
  getDefaultContentType() {
    throw new Error(`@smithy/core/protocols - ${this.constructor.name} getDefaultContentType() implementation missing.`);
  }
  async deserializeHttpMessage(e, t, n, i, a) {
    return [];
  }
  getEventStreamMarshaller() {
    const e = this.serdeContext;
    if (!e.eventStreamMarshaller)
      throw new Error("@smithy/core - HttpProtocol: eventStreamMarshaller missing in serdeContext.");
    return e.eventStreamMarshaller;
  }
}
class qV extends GV {
  async serializeRequest(e, t, n) {
    const i = this.serializer, a = {}, s = {}, o = await n.endpoint(), l = mi.of(e?.input), u = l.getSchema();
    let c;
    const d = t && typeof t == "object" ? t : {}, f = new ra({
      protocol: "",
      hostname: "",
      port: void 0,
      path: "/",
      fragment: void 0,
      query: a,
      headers: s,
      body: void 0
    });
    if (o && (this.updateServiceEndpoint(f, o), this.setHostPrefix(f, e, d)), d) {
      const h = l.getEventStreamMember();
      if (h) {
        if (d[h]) {
          const g = {};
          for (const [v, y] of l.structIterator())
            v !== h && d[v] && (i.write(y, d[v]), g[v] = i.flush());
          c = await this.serializeEventStream({
            eventStream: d[h],
            requestSchema: l,
            initialRequest: g
          });
        }
      } else
        i.write(u, d), c = i.flush();
    }
    return f.headers = Object.assign(f.headers, s), f.query = a, f.body = c, f.method = "POST", f;
  }
  async deserializeResponse(e, t, n) {
    const i = this.deserializer, a = mi.of(e.output), s = {};
    if (n.statusCode >= 300) {
      const l = await nA(n.body, t);
      throw l.byteLength > 0 && Object.assign(s, await i.read(15, l)), await this.handleError(e, t, n, s, this.deserializeMetadata(n)), new Error("@smithy/core/protocols - RPC Protocol error handler failed to throw.");
    }
    for (const l in n.headers) {
      const u = n.headers[l];
      delete n.headers[l], n.headers[l.toLowerCase()] = u;
    }
    const o = a.getEventStreamMember();
    if (o)
      s[o] = await this.deserializeEventStream({
        response: n,
        responseSchema: a,
        initialResponseContainer: s
      });
    else {
      const l = await nA(n.body, t);
      l.byteLength > 0 && Object.assign(s, await i.read(a, l));
    }
    return s.$metadata = this.deserializeMetadata(n), s;
  }
}
function uI(r, e) {
  if (e.timestampFormat.useTrait && r.isTimestampSchema() && (r.getSchema() === 5 || r.getSchema() === 6 || r.getSchema() === 7))
    return r.getSchema();
  const { httpLabel: t, httpPrefixHeaders: n, httpHeader: i, httpQuery: a } = r.getMergedTraits();
  return (e.httpBindings ? typeof n == "string" || i ? 6 : a || t ? 5 : void 0 : void 0) ?? e.timestampFormat.default;
}
const WV = (r) => ({
  setHttpHandler(e) {
    r.httpHandler = e;
  },
  httpHandler() {
    return r.httpHandler;
  },
  updateHttpClientConfig(e, t) {
    r.httpHandler?.updateHttpClientConfig(e, t);
  },
  httpHandlerConfigs() {
    return r.httpHandler.httpHandlerConfigs();
  }
}), QV = (r) => ({
  httpHandler: r.httpHandler()
}), CE = "content-length";
function YV(r) {
  return (e) => async (t) => {
    const n = t.request;
    if (ra.isInstance(n)) {
      const { body: i, headers: a } = n;
      if (i && Object.keys(a).map((s) => s.toLowerCase()).indexOf(CE) === -1)
        try {
          const s = r(i);
          n.headers = {
            ...n.headers,
            [CE]: String(s)
          };
        } catch {
        }
    }
    return e({
      ...t,
      request: n
    });
  };
}
const XV = {
  step: "build",
  tags: ["SET_CONTENT_LENGTH", "CONTENT_LENGTH"],
  name: "contentLengthMiddleware",
  override: !0
}, JV = (r) => ({
  applyToStack: (e) => {
    e.add(YV(r.bodyLengthChecker), XV);
  }
}), yl = (r) => encodeURIComponent(r).replace(/[!'()*]/g, KV), KV = (r) => `%${r.charCodeAt(0).toString(16).toUpperCase()}`;
function ZV(r) {
  const e = [];
  for (let t of Object.keys(r).sort()) {
    const n = r[t];
    if (t = yl(t), Array.isArray(n))
      for (let i = 0, a = n.length; i < a; i++)
        e.push(`${t}=${yl(n[i])}`);
    else {
      let i = t;
      (n || typeof n == "string") && (i += `=${yl(n)}`), e.push(i);
    }
  }
  return e.join("&");
}
const ez = [
  "BandwidthLimitExceeded",
  "EC2ThrottledException",
  "LimitExceededException",
  "PriorRequestNotComplete",
  "ProvisionedThroughputExceededException",
  "RequestLimitExceeded",
  "RequestThrottled",
  "RequestThrottledException",
  "SlowDown",
  "ThrottledException",
  "Throttling",
  "ThrottlingException",
  "TooManyRequestsException",
  "TransactionInProgressException"
], tz = ["TimeoutError", "RequestTimeout", "RequestTimeoutException"], rz = [500, 502, 503, 504], nz = ["ECONNRESET", "ECONNREFUSED", "EPIPE", "ETIMEDOUT"], iz = ["EHOSTUNREACH", "ENETUNREACH", "ENOTFOUND", "EAI_AGAIN"], az = (r) => r?.$retryable !== void 0, sz = (r) => r.$metadata?.clockSkewCorrected, oz = (r) => {
  const e = /* @__PURE__ */ new Set([
    "Failed to fetch",
    "NetworkError when attempting to fetch resource",
    "The Internet connection appears to be offline",
    "Load failed",
    "Network request failed"
  ]);
  return r && r instanceof TypeError ? e.has(r.message) : !1;
}, cI = (r) => r.$metadata?.httpStatusCode === 429 || ez.includes(r.name) || r.$retryable?.throttling == !0, S1 = (r, e = 0) => az(r) || sz(r) || r.name === "InvalidSignatureException" && r.message?.includes("Signature expired") || tz.includes(r.name) || nz.includes(r?.code || "") || iz.includes(r?.code || "") || rz.includes(r.$metadata?.httpStatusCode || 0) || oz(r) || uz(r) || r.cause !== void 0 && e <= 10 && S1(r.cause, e + 1), lz = (r) => {
  if (r.$metadata?.httpStatusCode !== void 0) {
    const e = r.$metadata.httpStatusCode;
    return 500 <= e && e <= 599 && !S1(r);
  }
  return !1;
};
function uz(r) {
  return r.code === "ERR_HTTP2_STREAM_ERROR" && r.message.includes("NGHTTP2_REFUSED_STREAM");
}
const fI = 20 * 1e3, SE = 500, cz = 1, fz = "amz-sdk-invocation-id", dz = "amz-sdk-request";
function hz(r, e) {
  if (Xu.isInstance(r))
    for (const t of Object.keys(r.headers)) {
      const n = t.toLowerCase();
      if (n === "retry-after") {
        const i = r.headers[t];
        let a = NaN;
        if (i.endsWith("GMT"))
          try {
            a = (XF(i).getTime() - Date.now()) / 1e3;
          } catch (s) {
            e?.trace?.("Failed to parse retry-after header"), e?.trace?.(s);
          }
        else i.match(/ GMT, ((\d+)|(\d+\.\d+))$/) ? a = Number(i.match(/ GMT, ([\d.]+)$/)?.[1]) : i.match(/^((\d+)|(\d+\.\d+))$/) ? a = Number(i) : Date.parse(i) >= Date.now() && (a = (Date.parse(i) - Date.now()) / 1e3);
        return isNaN(a) ? void 0 : new Date(Date.now() + a * 1e3);
      } else if (n === "x-amz-retry-after") {
        const i = r.headers[t], a = Number(i);
        if (isNaN(a)) {
          e?.trace?.(`Failed to parse x-amz-retry-after=${i}`);
          return;
        }
        return new Date(Date.now() + a);
      }
    }
}
const pz = (r) => r instanceof Error ? r : r instanceof Object ? Object.assign(new Error(), r) : typeof r == "string" ? new Error(r) : new Error(`AWS SDK error wrapper for ${r}`);
function gz(r) {
  return (e) => (t, n) => async (i) => {
    let a = await e.retryStrategy();
    const s = await e.maxAttempts();
    if (vz(a)) {
      a = a;
      let o = await a.acquireInitialRetryToken((n.partition_id ?? "") + (n.__retryLongPoll ? ":longpoll" : "")), l = new Error(), u = 0, c = 0;
      const { request: d } = i, f = ra.isInstance(d);
      for (f && (d.headers[fz] = lI()); ; )
        try {
          f && (d.headers[dz] = `attempt=${u + 1}; max=${s}`);
          const { response: h, output: g } = await t(i);
          return a.recordSuccess(o), g.$metadata.attempts = u + 1, g.$metadata.totalRetryDelay = c, { response: h, output: g };
        } catch (h) {
          const g = yz(h, e.logger);
          if (l = pz(h), f && r(d))
            throw (n.logger instanceof WF ? console : n.logger)?.warn("An error was encountered in a non-retryable streaming request."), l;
          try {
            o = await a.refreshRetryTokenForRetry(o, g);
          } catch {
            throw l.$metadata || (l.$metadata = {}), l.$metadata.attempts = u + 1, l.$metadata.totalRetryDelay = c, l;
          }
          u = o.getRetryCount();
          const v = o.getRetryDelay();
          c += (o?.$retryLog?.acquisitionDelay ?? 0) + v, v > 0 && await mz(v);
        }
    } else
      return a = a, a?.mode && (n.userAgent = [...n.userAgent || [], ["cfg/retry-mode", a.mode]]), a.retry(t, i);
  };
}
const mz = (r) => new Promise((e) => setTimeout(e, r)), vz = (r) => typeof r.acquireInitialRetryToken < "u" && typeof r.refreshRetryTokenForRetry < "u" && typeof r.recordSuccess < "u", yz = (r, e) => {
  const t = {
    error: r,
    errorType: Az(r)
  }, n = hz(r.$response, e);
  return n && (t.retryAfterHint = n), t;
}, Az = (r) => cI(r) ? "THROTTLING" : S1(r) ? "TRANSIENT" : lz(r) ? "SERVER_ERROR" : "CLIENT_ERROR", bz = {
  name: "retryMiddleware",
  tags: ["RETRY"],
  step: "finalizeRequest",
  priority: "high",
  override: !0
};
function wz(r) {
  const e = gz(r);
  return (t) => ({
    applyToStack: (n) => {
      n.add(e(t), bz);
    }
  });
}
class E1 {
  static setTimeoutFn = (e, t) => setTimeout(e, t);
  beta;
  minCapacity;
  minFillRate;
  scaleConstant;
  smooth;
  enabled = !1;
  availableTokens = 0;
  lastMaxRate = 0;
  measuredTxRate = 0;
  requestCount = 0;
  fillRate;
  lastThrottleTime;
  lastTimestamp = 0;
  lastTxRateBucket;
  maxCapacity;
  timeWindow = 0;
  constructor(e) {
    this.beta = e?.beta ?? 0.7, this.minCapacity = e?.minCapacity ?? 1, this.minFillRate = e?.minFillRate ?? 0.5, this.scaleConstant = e?.scaleConstant ?? 0.4, this.smooth = e?.smooth ?? 0.8, this.lastThrottleTime = this.getCurrentTimeInSeconds(), this.lastTxRateBucket = Math.floor(this.getCurrentTimeInSeconds()), this.fillRate = this.minFillRate, this.maxCapacity = this.minCapacity;
  }
  async getSendToken() {
    return this.acquireTokenBucket(1);
  }
  updateClientSendingRate(e) {
    let t;
    this.updateMeasuredRate();
    const n = e;
    if (n?.errorType === "THROTTLING" || cI(n?.error ?? e)) {
      const s = this.enabled ? Math.min(this.measuredTxRate, this.fillRate) : this.measuredTxRate;
      this.lastMaxRate = s, this.calculateTimeWindow(), this.lastThrottleTime = this.getCurrentTimeInSeconds(), t = this.cubicThrottle(s), this.enableTokenBucket();
    } else
      this.calculateTimeWindow(), t = this.cubicSuccess(this.getCurrentTimeInSeconds());
    const a = Math.min(t, 2 * this.measuredTxRate);
    this.updateTokenBucketRate(a);
  }
  getCurrentTimeInSeconds() {
    return Date.now() / 1e3;
  }
  async acquireTokenBucket(e) {
    if (this.enabled) {
      for (this.refillTokenBucket(); e > this.availableTokens; ) {
        const t = (e - this.availableTokens) / this.fillRate * 1e3;
        await new Promise((n) => E1.setTimeoutFn(n, t)), this.refillTokenBucket();
      }
      this.availableTokens = this.availableTokens - e;
    }
  }
  refillTokenBucket() {
    const e = this.getCurrentTimeInSeconds();
    if (!this.lastTimestamp) {
      this.lastTimestamp = e;
      return;
    }
    const t = (e - this.lastTimestamp) * this.fillRate;
    this.availableTokens = Math.min(this.maxCapacity, this.availableTokens + t), this.lastTimestamp = e;
  }
  calculateTimeWindow() {
    this.timeWindow = this.getPrecise(Math.pow(this.lastMaxRate * (1 - this.beta) / this.scaleConstant, 1 / 3));
  }
  cubicThrottle(e) {
    return this.getPrecise(e * this.beta);
  }
  cubicSuccess(e) {
    return this.getPrecise(this.scaleConstant * Math.pow(e - this.lastThrottleTime - this.timeWindow, 3) + this.lastMaxRate);
  }
  enableTokenBucket() {
    this.enabled = !0;
  }
  updateTokenBucketRate(e) {
    this.refillTokenBucket(), this.fillRate = Math.max(e, this.minFillRate), this.maxCapacity = Math.max(e, this.minCapacity), this.availableTokens = Math.min(this.availableTokens, this.maxCapacity);
  }
  updateMeasuredRate() {
    const e = this.getCurrentTimeInSeconds(), t = Math.floor(e * 2) / 2;
    if (this.requestCount++, t > this.lastTxRateBucket) {
      const n = this.requestCount / (t - this.lastTxRateBucket);
      this.measuredTxRate = this.getPrecise(n * this.smooth + this.measuredTxRate * (1 - this.smooth)), this.requestCount = 0, this.lastTxRateBucket = t;
    }
  }
  getPrecise(e) {
    return parseFloat(e.toFixed(8));
  }
}
class Si {
  static v2026 = typeof process < "u" && process.env?.SMITHY_NEW_RETRIES_2026 === "true";
  static delay() {
    return Si.v2026 ? 50 : 100;
  }
  static throttlingDelay() {
    return Si.v2026 ? 1e3 : 500;
  }
  static cost() {
    return Si.v2026 ? 14 : 5;
  }
  static throttlingCost() {
    return Si.v2026 ? 5 : 10;
  }
  static modifiedCostType() {
    return Si.v2026 ? "THROTTLING" : "TRANSIENT";
  }
}
class xz {
  x = Si.delay();
  computeNextBackoffDelay(e) {
    const i = Math.random() * Math.min(this.x * 2 ** e, fI);
    return Math.floor(i);
  }
  setDelayBase(e) {
    this.x = e;
  }
}
class EE {
  delay;
  count;
  cost;
  longPoll;
  $retryLog = {
    acquisitionDelay: 0
  };
  constructor(e, t, n, i) {
    this.delay = e, this.count = t, this.cost = n, this.longPoll = i;
  }
  getRetryCount() {
    return this.count;
  }
  getRetryDelay() {
    return Math.min(fI, this.delay);
  }
  getRetryCost() {
    return this.cost;
  }
  isLongPoll() {
    return this.longPoll;
  }
}
var Eo;
(function(r) {
  r.STANDARD = "standard", r.ADAPTIVE = "adaptive";
})(Eo || (Eo = {}));
const Wf = 3, Cz = Eo.STANDARD, mp = {
  incompatible: 1,
  attempts: 2,
  capacity: 3
};
class iA {
  mode = Eo.STANDARD;
  retryBackoffStrategy;
  capacity = SE;
  maxAttemptsProvider;
  baseDelay;
  constructor(e) {
    typeof e == "number" ? this.maxAttemptsProvider = async () => e : typeof e == "function" ? this.maxAttemptsProvider = e : e && typeof e == "object" && (this.maxAttemptsProvider = async () => e.maxAttempts, this.baseDelay = e.baseDelay, this.retryBackoffStrategy = e.backoff), this.maxAttemptsProvider ??= async () => Wf, this.baseDelay ??= Si.delay(), this.retryBackoffStrategy ??= new xz();
  }
  async acquireInitialRetryToken(e) {
    return new EE(Si.delay(), 0, void 0, Si.v2026 && e.includes(":longpoll"));
  }
  async refreshRetryTokenForRetry(e, t) {
    const n = await this.getMaxAttempts(), i = this.retryCode(e, t, n), a = i === 0, s = e.isLongPoll?.();
    if (a || s) {
      const o = t.errorType;
      this.retryBackoffStrategy.setDelayBase(o === "THROTTLING" ? Si.throttlingDelay() : this.baseDelay);
      const l = this.retryBackoffStrategy.computeNextBackoffDelay(e.getRetryCount());
      let u = l;
      if (t.retryAfterHint instanceof Date && (u = Math.max(l, Math.min(t.retryAfterHint.getTime() - Date.now(), l + 5e3))), a) {
        const c = this.getCapacityCost(o);
        this.capacity -= c;
        const d = new EE(0, e.getRetryCount() + 1, c, e.isLongPoll?.() ?? !1);
        return await new Promise((f) => setTimeout(f, u)), d.$retryLog.acquisitionDelay = u, d;
      } else {
        const c = Si.v2026 && i === mp.capacity && s ? u : 0;
        c > 0 && await new Promise((d) => setTimeout(d, c));
      }
    }
    throw new Error("No retry token available");
  }
  recordSuccess(e) {
    this.capacity = Math.min(SE, this.capacity + (e.getRetryCost() ?? cz));
  }
  getCapacity() {
    return this.capacity;
  }
  async maxAttempts() {
    return this.maxAttemptsProvider();
  }
  async getMaxAttempts() {
    try {
      return await this.maxAttemptsProvider();
    } catch {
      return console.warn(`Max attempts provider could not resolve. Using default of ${Wf}`), Wf;
    }
  }
  retryCode(e, t, n) {
    const i = e.getRetryCount() + 1, a = this.isRetryableError(t.errorType) ? 0 : mp.incompatible, s = i < n ? 0 : mp.attempts, o = this.capacity >= this.getCapacityCost(t.errorType) ? 0 : mp.capacity;
    return a || s || o;
  }
  getCapacityCost(e) {
    return e === Si.modifiedCostType() ? Si.throttlingCost() : Si.cost();
  }
  isRetryableError(e) {
    return e === "THROTTLING" || e === "TRANSIENT";
  }
}
class Sz {
  mode = Eo.ADAPTIVE;
  rateLimiter;
  standardRetryStrategy;
  constructor(e, t) {
    const { rateLimiter: n } = t ?? {};
    this.rateLimiter = n ?? new E1(), this.standardRetryStrategy = t ? new iA({
      maxAttempts: typeof e == "number" ? e : 3,
      ...t
    }) : new iA(e);
  }
  async acquireInitialRetryToken(e) {
    const t = await this.standardRetryStrategy.acquireInitialRetryToken(e);
    return await this.rateLimiter.getSendToken(), t;
  }
  async refreshRetryTokenForRetry(e, t) {
    this.rateLimiter.updateClientSendingRate(t);
    const n = await this.standardRetryStrategy.refreshRetryTokenForRetry(e, t);
    return await this.rateLimiter.getSendToken(), n;
  }
  recordSuccess(e) {
    this.rateLimiter.updateClientSendingRate({}), this.standardRetryStrategy.recordSuccess(e);
  }
  async maxAttemptsProvider() {
    return this.standardRetryStrategy.maxAttempts();
  }
}
const Ez = (r, e) => {
  const { retryStrategy: t, retryMode: n } = r, { defaultMaxAttempts: i = Wf, defaultBaseDelay: a = Si.delay() } = {}, s = Ps(r.maxAttempts ?? i);
  let o = t ? Promise.resolve(t) : void 0;
  const l = async () => {
    const u = await s();
    return await Ps(n)() === Eo.ADAPTIVE ? new Sz(s, {
      maxAttempts: u,
      baseDelay: a
    }) : new iA({
      maxAttempts: u,
      baseDelay: a
    });
  };
  return Object.assign(r, {
    maxAttempts: s,
    retryStrategy: () => o ??= l()
  });
}, kz = wz(l9);
Si.v2026 ||= typeof process == "object" && process.env?.AWS_NEW_RETRIES_2026 === "true";
function ks(r, e, t) {
  r.__aws_sdk_context ? r.__aws_sdk_context.features || (r.__aws_sdk_context.features = {}) : r.__aws_sdk_context = {
    features: {}
  }, r.__aws_sdk_context.features[e] = t;
}
const Tz = (r) => (e) => async (t) => {
  if (!ra.isInstance(t.request))
    return e(t);
  const { request: n } = t, { handlerProtocol: i = "" } = r.requestHandler.metadata || {};
  if (i.indexOf("h2") >= 0 && !n.headers[":authority"])
    delete n.headers.host, n.headers[":authority"] = n.hostname + (n.port ? ":" + n.port : "");
  else if (!n.headers.host) {
    let a = n.hostname;
    n.port != null && (a += `:${n.port}`), n.headers.host = a;
  }
  return e(t);
}, Fz = {
  name: "hostHeaderMiddleware",
  step: "build",
  priority: "low",
  tags: ["HOST"],
  override: !0
}, Iz = (r) => ({
  applyToStack: (e) => {
    e.add(Tz(r), Fz);
  }
}), Dz = () => (r, e) => async (t) => {
  try {
    const n = await r(t), { clientName: i, commandName: a, logger: s, dynamoDbDocumentClientOptions: o = {} } = e, { overrideInputFilterSensitiveLog: l, overrideOutputFilterSensitiveLog: u } = o, c = l ?? e.inputFilterSensitiveLog, d = u ?? e.outputFilterSensitiveLog, { $metadata: f, ...h } = n.output;
    return s?.info?.({
      clientName: i,
      commandName: a,
      input: c(t.input),
      output: d(h),
      metadata: f
    }), n;
  } catch (n) {
    const { clientName: i, commandName: a, logger: s, dynamoDbDocumentClientOptions: o = {} } = e, { overrideInputFilterSensitiveLog: l } = o, u = l ?? e.inputFilterSensitiveLog;
    throw s?.error?.({
      clientName: i,
      commandName: a,
      input: u(t.input),
      error: n,
      metadata: n.$metadata
    }), n;
  }
}, Pz = {
  name: "loggerMiddleware",
  tags: ["LOGGER"],
  step: "initialize",
  override: !0
}, Rz = (r) => ({
  applyToStack: (e) => {
    e.add(Dz(), Pz);
  }
}), Oz = (r) => ({
  applyToStack: (e) => {
  }
}), Bz = (r, e) => {
  if (!e || e.length === 0)
    return r;
  const t = [];
  for (const n of e)
    for (const i of r)
      i.schemeId.split("#")[1] === n && t.push(i);
  for (const n of r)
    t.find(({ schemeId: i }) => i === n.schemeId) || t.push(n);
  return t;
};
function Mz(r) {
  const e = /* @__PURE__ */ new Map();
  for (const t of r)
    e.set(t.schemeId, t);
  return e;
}
const _z = (r, e) => (t, n) => async (i) => {
  const a = r.httpAuthSchemeProvider(await e.httpAuthSchemeParametersProvider(r, n, i.input)), s = r.authSchemePreference ? await r.authSchemePreference() : [], o = Bz(a, s), l = Mz(r.httpAuthSchemes), u = fc(n), c = [];
  for (const d of o) {
    const f = l.get(d.schemeId);
    if (!f) {
      c.push(`HttpAuthScheme \`${d.schemeId}\` was not enabled for this service.`);
      continue;
    }
    const h = f.identityProvider(await e.identityProviderConfigProvider(r));
    if (!h) {
      c.push(`HttpAuthScheme \`${d.schemeId}\` did not have an IdentityProvider configured.`);
      continue;
    }
    const { identityProperties: g = {}, signingProperties: v = {} } = d.propertiesExtractor?.(r, n) || {};
    d.identityProperties = Object.assign(d.identityProperties || {}, g), d.signingProperties = Object.assign(d.signingProperties || {}, v), u.selectedHttpAuthScheme = {
      httpAuthOption: d,
      identity: await h(d.identityProperties),
      signer: f.signer
    };
    break;
  }
  if (!u.selectedHttpAuthScheme)
    throw new Error(c.join(`
`));
  return t(i);
}, Nz = {
  step: "serialize",
  tags: ["HTTP_AUTH_SCHEME"],
  name: "httpAuthSchemeMiddleware",
  override: !0,
  relation: "before",
  toMiddleware: "endpointV2Middleware"
}, Lz = (r, { httpAuthSchemeParametersProvider: e, identityProviderConfigProvider: t }) => ({
  applyToStack: (n) => {
    n.addRelativeTo(_z(r, {
      httpAuthSchemeParametersProvider: e,
      identityProviderConfigProvider: t
    }), Nz);
  }
}), Uz = (r) => (e) => {
  throw e;
}, Vz = (r, e) => {
}, zz = (r) => (e, t) => async (n) => {
  if (!ra.isInstance(n.request))
    return e(n);
  const a = fc(t).selectedHttpAuthScheme;
  if (!a)
    throw new Error("No HttpAuthScheme was selected: unable to sign request");
  const { httpAuthOption: { signingProperties: s = {} }, identity: o, signer: l } = a, u = await e({
    ...n,
    request: await l.sign(n.request, o, s)
  }).catch((l.errorHandler || Uz)(s));
  return (l.successHandler || Vz)(u.response, s), u;
}, $z = {
  step: "finalizeRequest",
  tags: ["HTTP_SIGNING"],
  name: "httpSigningMiddleware",
  aliases: ["apiKeyMiddleware", "tokenMiddleware", "awsAuthMiddleware"],
  override: !0,
  relation: "after",
  toMiddleware: "retryMiddleware"
}, Hz = (r) => ({
  applyToStack: (e) => {
    e.addRelativeTo(zz(), $z);
  }
}), Qf = (r) => {
  if (typeof r == "function")
    return r;
  const e = Promise.resolve(r);
  return () => e;
};
class jz {
  authSchemes = /* @__PURE__ */ new Map();
  constructor(e) {
    for (const t in e) {
      const n = e[t];
      n !== void 0 && this.authSchemes.set(t, n);
    }
  }
  getIdentityProvider(e) {
    return this.authSchemes.get(e);
  }
}
class Gz {
  async sign(e, t, n) {
    return e;
  }
}
const qz = (r) => function(t) {
  return dI(t) && t.expiration.getTime() - Date.now() < r;
}, Wz = 3e5, Qz = qz(Wz), dI = (r) => r.expiration !== void 0, Yz = (r, e, t) => {
  if (r === void 0)
    return;
  const n = typeof r != "function" ? async () => Promise.resolve(r) : r;
  let i, a, s, o = !1;
  const l = async (u) => {
    a || (a = n(u));
    try {
      i = await a, s = !0, o = !1;
    } finally {
      a = void 0;
    }
    return i;
  };
  return e === void 0 ? async (u) => ((!s || u?.forceRefresh) && (i = await l(u)), i) : async (u) => ((!s || u?.forceRefresh) && (i = await l(u)), o ? i : t(i) ? (e(i) && await l(u), i) : (o = !0, i));
}, Xz = void 0;
function Jz(r) {
  return r === void 0 ? !0 : typeof r == "string" && r.length <= 50;
}
function Kz(r) {
  const e = Qf(r.userAgentAppId ?? Xz), { customUserAgent: t } = r;
  return Object.assign(r, {
    customUserAgent: typeof t == "string" ? [[t]] : t,
    userAgentAppId: async () => {
      const n = await e();
      if (!Jz(n)) {
        const i = r.logger?.constructor?.name === "NoOpLogger" || !r.logger ? console : r.logger;
        typeof n != "string" ? i?.warn("userAgentAppId must be a string or undefined.") : n.length > 50 && i?.warn("The provided userAgentAppId exceeds the maximum length of 50 characters.");
      }
      return n;
    }
  });
}
const Zz = {
  partitions: [
    {
      id: "aws",
      outputs: {
        dnsSuffix: "amazonaws.com",
        dualStackDnsSuffix: "api.aws",
        implicitGlobalRegion: "us-east-1",
        name: "aws",
        supportsDualStack: !0,
        supportsFIPS: !0
      },
      regionRegex: "^(us|eu|ap|sa|ca|me|af|il|mx)\\-\\w+\\-\\d+$",
      regions: {
        "af-south-1": {
          description: "Africa (Cape Town)"
        },
        "ap-east-1": {
          description: "Asia Pacific (Hong Kong)"
        },
        "ap-east-2": {
          description: "Asia Pacific (Taipei)"
        },
        "ap-northeast-1": {
          description: "Asia Pacific (Tokyo)"
        },
        "ap-northeast-2": {
          description: "Asia Pacific (Seoul)"
        },
        "ap-northeast-3": {
          description: "Asia Pacific (Osaka)"
        },
        "ap-south-1": {
          description: "Asia Pacific (Mumbai)"
        },
        "ap-south-2": {
          description: "Asia Pacific (Hyderabad)"
        },
        "ap-southeast-1": {
          description: "Asia Pacific (Singapore)"
        },
        "ap-southeast-2": {
          description: "Asia Pacific (Sydney)"
        },
        "ap-southeast-3": {
          description: "Asia Pacific (Jakarta)"
        },
        "ap-southeast-4": {
          description: "Asia Pacific (Melbourne)"
        },
        "ap-southeast-5": {
          description: "Asia Pacific (Malaysia)"
        },
        "ap-southeast-6": {
          description: "Asia Pacific (New Zealand)"
        },
        "ap-southeast-7": {
          description: "Asia Pacific (Thailand)"
        },
        "aws-global": {
          description: "aws global region"
        },
        "ca-central-1": {
          description: "Canada (Central)"
        },
        "ca-west-1": {
          description: "Canada West (Calgary)"
        },
        "eu-central-1": {
          description: "Europe (Frankfurt)"
        },
        "eu-central-2": {
          description: "Europe (Zurich)"
        },
        "eu-north-1": {
          description: "Europe (Stockholm)"
        },
        "eu-south-1": {
          description: "Europe (Milan)"
        },
        "eu-south-2": {
          description: "Europe (Spain)"
        },
        "eu-west-1": {
          description: "Europe (Ireland)"
        },
        "eu-west-2": {
          description: "Europe (London)"
        },
        "eu-west-3": {
          description: "Europe (Paris)"
        },
        "il-central-1": {
          description: "Israel (Tel Aviv)"
        },
        "me-central-1": {
          description: "Middle East (UAE)"
        },
        "me-south-1": {
          description: "Middle East (Bahrain)"
        },
        "mx-central-1": {
          description: "Mexico (Central)"
        },
        "sa-east-1": {
          description: "South America (Sao Paulo)"
        },
        "us-east-1": {
          description: "US East (N. Virginia)"
        },
        "us-east-2": {
          description: "US East (Ohio)"
        },
        "us-west-1": {
          description: "US West (N. California)"
        },
        "us-west-2": {
          description: "US West (Oregon)"
        }
      }
    },
    {
      id: "aws-cn",
      outputs: {
        dnsSuffix: "amazonaws.com.cn",
        dualStackDnsSuffix: "api.amazonwebservices.com.cn",
        implicitGlobalRegion: "cn-northwest-1",
        name: "aws-cn",
        supportsDualStack: !0,
        supportsFIPS: !0
      },
      regionRegex: "^cn\\-\\w+\\-\\d+$",
      regions: {
        "aws-cn-global": {
          description: "aws-cn global region"
        },
        "cn-north-1": {
          description: "China (Beijing)"
        },
        "cn-northwest-1": {
          description: "China (Ningxia)"
        }
      }
    },
    {
      id: "aws-eusc",
      outputs: {
        dnsSuffix: "amazonaws.eu",
        dualStackDnsSuffix: "api.amazonwebservices.eu",
        implicitGlobalRegion: "eusc-de-east-1",
        name: "aws-eusc",
        supportsDualStack: !0,
        supportsFIPS: !0
      },
      regionRegex: "^eusc\\-(de)\\-\\w+\\-\\d+$",
      regions: {
        "eusc-de-east-1": {
          description: "AWS European Sovereign Cloud (Germany)"
        }
      }
    },
    {
      id: "aws-iso",
      outputs: {
        dnsSuffix: "c2s.ic.gov",
        dualStackDnsSuffix: "api.aws.ic.gov",
        implicitGlobalRegion: "us-iso-east-1",
        name: "aws-iso",
        supportsDualStack: !0,
        supportsFIPS: !0
      },
      regionRegex: "^us\\-iso\\-\\w+\\-\\d+$",
      regions: {
        "aws-iso-global": {
          description: "aws-iso global region"
        },
        "us-iso-east-1": {
          description: "US ISO East"
        },
        "us-iso-west-1": {
          description: "US ISO WEST"
        }
      }
    },
    {
      id: "aws-iso-b",
      outputs: {
        dnsSuffix: "sc2s.sgov.gov",
        dualStackDnsSuffix: "api.aws.scloud",
        implicitGlobalRegion: "us-isob-east-1",
        name: "aws-iso-b",
        supportsDualStack: !0,
        supportsFIPS: !0
      },
      regionRegex: "^us\\-isob\\-\\w+\\-\\d+$",
      regions: {
        "aws-iso-b-global": {
          description: "aws-iso-b global region"
        },
        "us-isob-east-1": {
          description: "US ISOB East (Ohio)"
        },
        "us-isob-west-1": {
          description: "US ISOB West"
        }
      }
    },
    {
      id: "aws-iso-e",
      outputs: {
        dnsSuffix: "cloud.adc-e.uk",
        dualStackDnsSuffix: "api.cloud-aws.adc-e.uk",
        implicitGlobalRegion: "eu-isoe-west-1",
        name: "aws-iso-e",
        supportsDualStack: !0,
        supportsFIPS: !0
      },
      regionRegex: "^eu\\-isoe\\-\\w+\\-\\d+$",
      regions: {
        "aws-iso-e-global": {
          description: "aws-iso-e global region"
        },
        "eu-isoe-west-1": {
          description: "EU ISOE West"
        }
      }
    },
    {
      id: "aws-iso-f",
      outputs: {
        dnsSuffix: "csp.hci.ic.gov",
        dualStackDnsSuffix: "api.aws.hci.ic.gov",
        implicitGlobalRegion: "us-isof-south-1",
        name: "aws-iso-f",
        supportsDualStack: !0,
        supportsFIPS: !0
      },
      regionRegex: "^us\\-isof\\-\\w+\\-\\d+$",
      regions: {
        "aws-iso-f-global": {
          description: "aws-iso-f global region"
        },
        "us-isof-east-1": {
          description: "US ISOF EAST"
        },
        "us-isof-south-1": {
          description: "US ISOF SOUTH"
        }
      }
    },
    {
      id: "aws-us-gov",
      outputs: {
        dnsSuffix: "amazonaws.com",
        dualStackDnsSuffix: "api.aws",
        implicitGlobalRegion: "us-gov-west-1",
        name: "aws-us-gov",
        supportsDualStack: !0,
        supportsFIPS: !0
      },
      regionRegex: "^us\\-gov\\-\\w+\\-\\d+$",
      regions: {
        "aws-us-gov-global": {
          description: "aws-us-gov global region"
        },
        "us-gov-east-1": {
          description: "AWS GovCloud (US-East)"
        },
        "us-gov-west-1": {
          description: "AWS GovCloud (US-West)"
        }
      }
    }
  ]
};
let e$ = Zz;
const t$ = (r) => {
  const { partitions: e } = e$;
  for (const n of e) {
    const { regions: i, outputs: a } = n;
    for (const [s, o] of Object.entries(i))
      if (s === r)
        return {
          ...a,
          ...o
        };
  }
  for (const n of e) {
    const { regionRegex: i, outputs: a } = n;
    if (new RegExp(i).test(r))
      return {
        ...a
      };
  }
  const t = e.find((n) => n.id === "aws");
  if (!t)
    throw new Error("Provided region was not found in the partition array or regex, and default partition with id 'aws' doesn't exist.");
  return {
    ...t.outputs
  };
}, r$ = /\d{12}\.ddb/;
async function n$(r, e, t) {
  if (t.request?.headers?.["smithy-protocol"] === "rpc-v2-cbor" && ks(r, "PROTOCOL_RPC_V2_CBOR", "M"), typeof e.retryStrategy == "function") {
    const a = await e.retryStrategy();
    if (typeof a.mode == "string")
      switch (a.mode) {
        case Eo.ADAPTIVE:
          ks(r, "RETRY_MODE_ADAPTIVE", "F");
          break;
        case Eo.STANDARD:
          ks(r, "RETRY_MODE_STANDARD", "E");
          break;
      }
  }
  if (typeof e.accountIdEndpointMode == "function") {
    const a = r.endpointV2;
    switch (String(a?.url?.hostname).match(r$) && ks(r, "ACCOUNT_ID_ENDPOINT", "O"), await e.accountIdEndpointMode?.()) {
      case "disabled":
        ks(r, "ACCOUNT_ID_MODE_DISABLED", "Q");
        break;
      case "preferred":
        ks(r, "ACCOUNT_ID_MODE_PREFERRED", "P");
        break;
      case "required":
        ks(r, "ACCOUNT_ID_MODE_REQUIRED", "R");
        break;
    }
  }
  const i = r.__smithy_context?.selectedHttpAuthScheme?.identity;
  if (i?.$source) {
    const a = i;
    a.accountId && ks(r, "RESOLVED_ACCOUNT_ID", "T");
    for (const [s, o] of Object.entries(a.$source ?? {}))
      ks(r, s, o);
  }
}
const kE = "user-agent", Pv = "x-amz-user-agent", TE = " ", Rv = "/", i$ = /[^!$%&'*+\-.^_`|~\w]/g, a$ = /[^!$%&'*+\-.^_`|~\w#]/g, FE = "-", s$ = 1024;
function o$(r) {
  let e = "";
  for (const t in r) {
    const n = r[t];
    if (e.length + n.length + 1 <= s$) {
      e.length ? e += "," + n : e += n;
      continue;
    }
    break;
  }
  return e;
}
const l$ = (r) => (e, t) => async (n) => {
  const { request: i } = n;
  if (!ra.isInstance(i))
    return e(n);
  const { headers: a } = i, s = t?.userAgent?.map(vp) || [], o = (await r.defaultUserAgentProvider()).map(vp);
  await n$(t, r, n);
  const l = t;
  o.push(`m/${o$(Object.assign({}, t.__smithy_context?.features, l.__aws_sdk_context?.features))}`);
  const u = r?.customUserAgent?.map(vp) || [], c = await r.userAgentAppId();
  c && o.push(vp(["app", `${c}`]));
  const d = [].concat([...o, ...s, ...u]).join(TE), f = [
    ...o.filter((h) => h.startsWith("aws-sdk-")),
    ...u
  ].join(TE);
  return r.runtime !== "browser" ? (f && (a[Pv] = a[Pv] ? `${a[kE]} ${f}` : f), a[kE] = d) : a[Pv] = d, e({
    ...n,
    request: i
  });
}, vp = (r) => {
  const e = r[0].split(Rv).map((s) => s.replace(i$, FE)).join(Rv), t = r[1]?.replace(a$, FE), n = e.indexOf(Rv), i = e.substring(0, n);
  let a = e.substring(n + 1);
  return i === "api" && (a = a.toLowerCase()), [i, a, t].filter((s) => s && s.length > 0).reduce((s, o, l) => {
    switch (l) {
      case 0:
        return o;
      case 1:
        return `${s}/${o}`;
      default:
        return `${s}#${o}`;
    }
  }, "");
}, u$ = {
  name: "getUserAgentMiddleware",
  step: "build",
  priority: "low",
  tags: ["SET_USER_AGENT", "USER_AGENT"],
  override: !0
}, c$ = (r) => ({
  applyToStack: (e) => {
    e.add(l$(r), u$);
  }
}), f$ = ({ serviceId: r, clientVersion: e }) => async (t) => {
  const n = typeof window < "u" ? window.navigator : void 0, i = n?.userAgent ?? "", a = n?.userAgentData?.platform ?? IE.os(i) ?? "other", s = void 0, o = n?.userAgentData?.brands ?? [], l = o[o.length - 1], u = l?.brand ?? IE.browser(i) ?? "unknown", c = l?.version ?? "unknown", d = [
    ["aws-sdk-js", e],
    ["ua", "2.1"],
    [`os/${a}`, s],
    ["lang/js"],
    ["md/browser", `${u}_${c}`]
  ];
  r && d.push([`api/${r}`, e]);
  const f = await t?.userAgentAppId?.();
  return f && d.push([`app/${f}`]), d;
}, IE = {
  os(r) {
    if (/iPhone|iPad|iPod/.test(r))
      return "iOS";
    if (/Macintosh|Mac OS X/.test(r))
      return "macOS";
    if (/Windows NT/.test(r))
      return "Windows";
    if (/Android/.test(r))
      return "Android";
    if (/Linux/.test(r))
      return "Linux";
  },
  browser(r) {
    if (/EdgiOS|EdgA|Edg\//.test(r))
      return "Microsoft Edge";
    if (/Firefox\//.test(r))
      return "Firefox";
    if (/Chrome\//.test(r))
      return "Chrome";
    if (/Safari\//.test(r))
      return "Safari";
  }
}, hI = (r, e = !1) => {
  if (e) {
    for (const t of r.split("."))
      if (!hI(t))
        return !1;
    return !0;
  }
  return !(!Ug(r) || r.length < 3 || r.length > 63 || r !== r.toLowerCase() || eI(r));
}, DE = ":", d$ = "/", h$ = (r) => {
  const e = r.split(DE);
  if (e.length < 6)
    return null;
  const [t, n, i, a, s, ...o] = e;
  if (t !== "arn" || n === "" || i === "" || o.join(DE) === "")
    return null;
  const l = o.map((u) => u.split(d$)).flat();
  return {
    partition: n,
    service: i,
    region: a,
    accountId: s,
    resourceId: l
  };
}, pI = {
  isVirtualHostableS3Bucket: hI,
  parseArn: h$,
  partition: t$
};
C1.aws = pI;
const p$ = (r, e, t) => {
  let n, i, a, s = !1;
  const o = async () => {
    i || (i = r());
    try {
      n = await i, a = !0, s = !1;
    } finally {
      i = void 0;
    }
    return n;
  };
  return async (l) => ((!a || l?.forceRefresh) && (n = await o()), n);
}, PE = /* @__PURE__ */ new Set(), g$ = (r, e = Ug) => {
  if (!PE.has(r) && !e(r))
    if (r === "*")
      console.warn('@smithy/config-resolver WARN - Please use the caller region instead of "*". See "sigv4a" in https://github.com/aws/aws-sdk-js-v3/blob/main/supplemental-docs/CLIENTS.md.');
    else
      throw new Error(`Region not accepted: region="${r}" is not a valid hostname component.`);
  else
    PE.add(r);
}, gI = (r) => typeof r == "string" && (r.startsWith("fips-") || r.endsWith("-fips")), m$ = (r) => gI(r) ? ["fips-aws-global", "aws-fips"].includes(r) ? "us-east-1" : r.replace(/fips-(dkr-|prod-)?|-fips/, "") : r, v$ = (r) => {
  const { region: e, useFipsEndpoint: t } = r;
  if (!e)
    throw new Error("Region is missing");
  return Object.assign(r, {
    region: async () => {
      const n = typeof e == "function" ? await e() : e, i = m$(n);
      return g$(i), i;
    },
    useFipsEndpoint: async () => {
      const n = typeof e == "string" ? e : await e();
      return gI(n) ? !0 : typeof t != "function" ? Promise.resolve(!!t) : t();
    }
  });
}, y$ = ["in-region", "cross-region", "mobile", "standard", "legacy"], A$ = ({ defaultsMode: r } = {}) => p$(async () => {
  const e = typeof r == "function" ? await r() : r;
  switch (e?.toLowerCase()) {
    case "auto":
      return Promise.resolve(b$() ? "mobile" : "standard");
    case "mobile":
    case "in-region":
    case "cross-region":
    case "standard":
    case "legacy":
      return Promise.resolve(e?.toLocaleLowerCase());
    case void 0:
      return Promise.resolve("legacy");
    default:
      throw new Error(`Invalid parameter for "defaultsMode", expect ${y$.join(", ")}, got ${e}`);
  }
}), b$ = () => {
  const r = window?.navigator;
  if (r?.connection) {
    const { effectiveType: e, rtt: t, downlink: n } = r?.connection;
    if (typeof e == "string" && e !== "4g" || Number(t) > 100 || Number(n) < 10)
      return !0;
  }
  return r?.userAgentData?.mobile || typeof r?.maxTouchPoints == "number" && r?.maxTouchPoints > 1;
}, w$ = !1, x$ = !1, C$ = (r) => ({
  setRegion(e) {
    r.region = e;
  },
  region() {
    return r.region;
  }
}), S$ = (r) => ({
  region: r.region()
}), RE = (r) => Xu.isInstance(r) ? r.headers?.date ?? r.headers?.Date : void 0, mI = (r) => new Date(Date.now() + r), E$ = (r, e) => Math.abs(mI(e).getTime() - r) >= 3e5, OE = (r, e) => {
  const t = Date.parse(r);
  return E$(t, e) ? t - Date.now() : e;
}, Yf = (r, e) => {
  if (!e)
    throw new Error(`Property \`${r}\` is not resolved for AWS SDK SigV4Auth`);
  return e;
}, k$ = async (r) => {
  const e = Yf("context", r.context), t = Yf("config", r.config), n = e.endpointV2?.properties?.authSchemes?.[0], a = await Yf("signer", t.signer)(n), s = r?.signingRegion, o = r?.signingRegionSet, l = r?.signingName;
  return {
    config: t,
    signer: a,
    signingRegion: s,
    signingRegionSet: o,
    signingName: l
  };
};
class T$ {
  async sign(e, t, n) {
    if (!ra.isInstance(e))
      throw new Error("The request is not an instance of `HttpRequest` and cannot be signed");
    const i = await k$(n), { config: a, signer: s } = i;
    let { signingRegion: o, signingName: l } = i;
    const u = n.context;
    if (u?.authSchemes?.length ?? !1) {
      const [d, f] = u.authSchemes;
      d?.name === "sigv4a" && f?.name === "sigv4" && (o = f?.signingRegion ?? o, l = f?.signingName ?? l);
    }
    return n._preRequestSystemClockOffset = a.systemClockOffset, await s.sign(e, {
      signingDate: mI(a.systemClockOffset),
      signingRegion: o,
      signingService: l
    });
  }
  errorHandler(e) {
    return (t) => {
      const n = t, i = n.ServerTime ?? RE(n.$response);
      if (i) {
        const a = Yf("config", e.config), s = e._preRequestSystemClockOffset, o = OE(i, a.systemClockOffset);
        (o !== a.systemClockOffset || s !== void 0 && s !== o) && n.$metadata && (a.systemClockOffset = o, n.$metadata.clockSkewCorrected = !0);
      }
      throw t;
    };
  }
  successHandler(e, t) {
    const n = RE(e);
    if (n) {
      const i = Yf("config", t.config);
      i.systemClockOffset = OE(n, i.systemClockOffset);
    }
  }
}
class F$ {
  format(e) {
    const t = [];
    for (const a of Object.keys(e)) {
      const s = Ju(a);
      t.push(Uint8Array.from([s.byteLength]), s, this.formatHeaderValue(e[a]));
    }
    const n = new Uint8Array(t.reduce((a, s) => a + s.byteLength, 0));
    let i = 0;
    for (const a of t)
      n.set(a, i), i += a.byteLength;
    return n;
  }
  formatHeaderValue(e) {
    switch (e.type) {
      case "boolean":
        return Uint8Array.from([e.value ? 0 : 1]);
      case "byte":
        return Uint8Array.from([2, e.value]);
      case "short":
        const t = new DataView(new ArrayBuffer(3));
        return t.setUint8(0, 3), t.setInt16(1, e.value, !1), new Uint8Array(t.buffer);
      case "integer":
        const n = new DataView(new ArrayBuffer(5));
        return n.setUint8(0, 4), n.setInt32(1, e.value, !1), new Uint8Array(n.buffer);
      case "long":
        const i = new Uint8Array(9);
        return i[0] = 5, i.set(e.value.bytes, 1), i;
      case "binary":
        const a = new DataView(new ArrayBuffer(3 + e.value.byteLength));
        a.setUint8(0, 6), a.setUint16(1, e.value.byteLength, !1);
        const s = new Uint8Array(a.buffer);
        return s.set(e.value, 3), s;
      case "string":
        const o = Ju(e.value), l = new DataView(new ArrayBuffer(3 + o.byteLength));
        l.setUint8(0, 7), l.setUint16(1, o.byteLength, !1);
        const u = new Uint8Array(l.buffer);
        return u.set(o, 3), u;
      case "timestamp":
        const c = new Uint8Array(9);
        return c[0] = 8, c.set(k1.fromNumber(e.value.valueOf()).bytes, 1), c;
      case "uuid":
        if (!I$.test(e.value))
          throw new Error(`Invalid UUID received: ${e.value}`);
        const d = new Uint8Array(17);
        return d[0] = 9, d.set(nV(e.value.replace(/\-/g, "")), 1), d;
    }
  }
}
var BE;
(function(r) {
  r[r.boolTrue = 0] = "boolTrue", r[r.boolFalse = 1] = "boolFalse", r[r.byte = 2] = "byte", r[r.short = 3] = "short", r[r.integer = 4] = "integer", r[r.long = 5] = "long", r[r.byteArray = 6] = "byteArray", r[r.string = 7] = "string", r[r.timestamp = 8] = "timestamp", r[r.uuid = 9] = "uuid";
})(BE || (BE = {}));
const I$ = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;
class k1 {
  bytes;
  constructor(e) {
    if (this.bytes = e, e.byteLength !== 8)
      throw new Error("Int64 buffers must be exactly 8 bytes");
  }
  static fromNumber(e) {
    if (e > 9223372036854776e3 || e < -9223372036854776e3)
      throw new Error(`${e} is too large (or, if negative, too small) to represent as an Int64`);
    const t = new Uint8Array(8);
    for (let n = 7, i = Math.abs(Math.round(e)); n > -1 && i > 0; n--, i /= 256)
      t[n] = i;
    return e < 0 && ME(t), new k1(t);
  }
  valueOf() {
    const e = this.bytes.slice(0), t = e[0] & 128;
    return t && ME(e), parseInt(vl(e), 16) * (t ? -1 : 1);
  }
  toString() {
    return String(this.valueOf());
  }
}
function ME(r) {
  for (let e = 0; e < 8; e++)
    r[e] ^= 255;
  for (let e = 7; e > -1 && (r[e]++, r[e] === 0); e--)
    ;
}
const D$ = "X-Amz-Algorithm", P$ = "X-Amz-Credential", vI = "X-Amz-Date", R$ = "X-Amz-SignedHeaders", O$ = "X-Amz-Expires", yI = "X-Amz-Signature", AI = "X-Amz-Security-Token", bI = "authorization", wI = vI.toLowerCase(), B$ = "date", M$ = [bI, wI, B$], _$ = yI.toLowerCase(), aA = "x-amz-content-sha256", N$ = AI.toLowerCase(), L$ = {
  authorization: !0,
  "cache-control": !0,
  connection: !0,
  expect: !0,
  from: !0,
  "keep-alive": !0,
  "max-forwards": !0,
  pragma: !0,
  referer: !0,
  te: !0,
  trailer: !0,
  "transfer-encoding": !0,
  upgrade: !0,
  "user-agent": !0,
  "x-amzn-trace-id": !0
}, U$ = /^proxy-/, V$ = /^sec-/, Ov = "AWS4-HMAC-SHA256", z$ = "AWS4-HMAC-SHA256-PAYLOAD", $$ = "UNSIGNED-PAYLOAD", H$ = 50, xI = "aws4_request", j$ = 3600 * 24 * 7, G$ = ({ query: r = {} }) => {
  const e = [], t = {};
  for (const n of Object.keys(r)) {
    if (n.toLowerCase() === _$)
      continue;
    const i = yl(n);
    e.push(i);
    const a = r[n];
    typeof a == "string" ? t[i] = `${i}=${yl(a)}` : Array.isArray(a) && (t[i] = a.slice(0).reduce((s, o) => s.concat([`${i}=${yl(o)}`]), []).sort().join("&"));
  }
  return e.sort().map((n) => t[n]).filter((n) => n).join("&");
}, q$ = (r) => W$(r).toISOString().replace(/\.\d{3}Z$/, "Z"), W$ = (r) => typeof r == "number" ? new Date(r * 1e3) : typeof r == "string" ? Number(r) ? new Date(Number(r) * 1e3) : new Date(r) : r;
class Q$ {
  service;
  regionProvider;
  credentialProvider;
  sha256;
  uriEscapePath;
  applyChecksum;
  constructor({ applyChecksum: e, credentials: t, region: n, service: i, sha256: a, uriEscapePath: s = !0 }) {
    this.service = i, this.sha256 = a, this.uriEscapePath = s, this.applyChecksum = typeof e == "boolean" ? e : !0, this.regionProvider = Ps(n), this.credentialProvider = Ps(t);
  }
  createCanonicalRequest(e, t, n) {
    const i = Object.keys(t).sort();
    return `${e.method}
${this.getCanonicalPath(e)}
${G$(e)}
${i.map((a) => `${a}:${t[a]}`).join(`
`)}

${i.join(";")}
${n}`;
  }
  async createStringToSign(e, t, n, i) {
    const a = new this.sha256();
    a.update(vd(n));
    const s = await a.digest();
    return `${i}
${e}
${t}
${vl(s)}`;
  }
  getCanonicalPath({ path: e }) {
    if (this.uriEscapePath) {
      const t = [];
      for (const a of e.split("/"))
        a?.length !== 0 && a !== "." && (a === ".." ? t.pop() : t.push(a));
      const n = `${e?.startsWith("/") ? "/" : ""}${t.join("/")}${t.length > 0 && e?.endsWith("/") ? "/" : ""}`;
      return yl(n).replace(/%2F/g, "/");
    }
    return e;
  }
  validateResolvedCredentials(e) {
    if (typeof e != "object" || typeof e.accessKeyId != "string" || typeof e.secretAccessKey != "string")
      throw new Error("Resolved credential object is not valid");
  }
  formatDate(e) {
    const t = q$(e).replace(/[\-:]/g, "");
    return {
      longDate: t,
      shortDate: t.slice(0, 8)
    };
  }
  getCanonicalHeaderList(e) {
    return Object.keys(e).sort().join(";");
  }
}
const yp = {}, Bv = [], Mv = (r, e, t) => `${r}/${e}/${t}/${xI}`, Y$ = async (r, e, t, n, i) => {
  const a = await _E(r, e.secretAccessKey, e.accessKeyId), s = `${t}:${n}:${i}:${vl(a)}:${e.sessionToken}`;
  if (s in yp)
    return yp[s];
  for (Bv.push(s); Bv.length > H$; )
    delete yp[Bv.shift()];
  let o = `AWS4${e.secretAccessKey}`;
  for (const l of [t, n, i, xI])
    o = await _E(r, o, l);
  return yp[s] = o;
}, _E = (r, e, t) => {
  const n = new r(e);
  return n.update(vd(t)), n.digest();
}, NE = ({ headers: r }, e, t) => {
  const n = {};
  for (const i of Object.keys(r).sort()) {
    if (r[i] == null)
      continue;
    const a = i.toLowerCase();
    (a in L$ || e?.has(a) || U$.test(a) || V$.test(a)) && (!t || t && !t.has(a)) || (n[a] = r[i].trim().replace(/\s+/g, " "));
  }
  return n;
}, _v = async ({ headers: r, body: e }, t) => {
  for (const n of Object.keys(r))
    if (n.toLowerCase() === aA)
      return r[n];
  if (e == null)
    return "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855";
  if (typeof e == "string" || ArrayBuffer.isView(e) || aV(e)) {
    const n = new t();
    return n.update(vd(e)), vl(await n.digest());
  }
  return $$;
}, X$ = (r, e) => {
  r = r.toLowerCase();
  for (const t of Object.keys(e))
    if (r === t.toLowerCase())
      return !0;
  return !1;
}, J$ = (r, e = {}) => {
  const { headers: t, query: n = {} } = ra.clone(r);
  for (const i of Object.keys(t)) {
    const a = i.toLowerCase();
    (a.slice(0, 6) === "x-amz-" && !e.unhoistableHeaders?.has(a) || e.hoistableHeaders?.has(a)) && (n[i] = t[i], delete t[i]);
  }
  return {
    ...r,
    headers: t,
    query: n
  };
}, LE = (r) => {
  r = ra.clone(r);
  for (const e of Object.keys(r.headers))
    M$.indexOf(e.toLowerCase()) > -1 && delete r.headers[e];
  return r;
};
class UE extends Q$ {
  headerFormatter = new F$();
  constructor({ applyChecksum: e, credentials: t, region: n, service: i, sha256: a, uriEscapePath: s = !0 }) {
    super({
      applyChecksum: e,
      credentials: t,
      region: n,
      service: i,
      sha256: a,
      uriEscapePath: s
    });
  }
  async presign(e, t = {}) {
    const { signingDate: n = /* @__PURE__ */ new Date(), expiresIn: i = 3600, unsignableHeaders: a, unhoistableHeaders: s, signableHeaders: o, hoistableHeaders: l, signingRegion: u, signingService: c } = t, d = await this.credentialProvider();
    this.validateResolvedCredentials(d);
    const f = u ?? await this.regionProvider(), { longDate: h, shortDate: g } = this.formatDate(n);
    if (i > j$)
      return Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future");
    const v = Mv(g, f, c ?? this.service), y = J$(LE(e), { unhoistableHeaders: s, hoistableHeaders: l });
    d.sessionToken && (y.query[AI] = d.sessionToken), y.query[D$] = Ov, y.query[P$] = `${d.accessKeyId}/${v}`, y.query[vI] = h, y.query[O$] = i.toString(10);
    const A = NE(y, a, o);
    return y.query[R$] = this.getCanonicalHeaderList(A), y.query[yI] = await this.getSignature(h, v, this.getSigningKey(d, f, g, c), this.createCanonicalRequest(y, A, await _v(e, this.sha256))), y;
  }
  async sign(e, t) {
    return typeof e == "string" ? this.signString(e, t) : e.headers && e.payload ? this.signEvent(e, t) : e.message ? this.signMessage(e, t) : this.signRequest(e, t);
  }
  async signEvent({ headers: e, payload: t }, { signingDate: n = /* @__PURE__ */ new Date(), priorSignature: i, signingRegion: a, signingService: s, eventStreamCredentials: o }) {
    const l = a ?? await this.regionProvider(), { shortDate: u, longDate: c } = this.formatDate(n), d = Mv(u, l, s ?? this.service), f = await _v({ headers: {}, body: t }, this.sha256), h = new this.sha256();
    h.update(e);
    const g = vl(await h.digest()), v = [
      z$,
      c,
      d,
      i,
      g,
      f
    ].join(`
`);
    return this.signString(v, {
      signingDate: n,
      signingRegion: l,
      signingService: s,
      eventStreamCredentials: o
    });
  }
  async signMessage(e, { signingDate: t = /* @__PURE__ */ new Date(), signingRegion: n, signingService: i, eventStreamCredentials: a }) {
    return this.signEvent({
      headers: this.headerFormatter.format(e.message.headers),
      payload: e.message.body
    }, {
      signingDate: t,
      signingRegion: n,
      signingService: i,
      priorSignature: e.priorSignature,
      eventStreamCredentials: a
    }).then((o) => ({ message: e.message, signature: o }));
  }
  async signString(e, { signingDate: t = /* @__PURE__ */ new Date(), signingRegion: n, signingService: i, eventStreamCredentials: a } = {}) {
    const s = a ?? await this.credentialProvider();
    this.validateResolvedCredentials(s);
    const o = n ?? await this.regionProvider(), { shortDate: l } = this.formatDate(t), u = new this.sha256(await this.getSigningKey(s, o, l, i));
    return u.update(vd(e)), vl(await u.digest());
  }
  async signRequest(e, { signingDate: t = /* @__PURE__ */ new Date(), signableHeaders: n, unsignableHeaders: i, signingRegion: a, signingService: s } = {}) {
    const o = await this.credentialProvider();
    this.validateResolvedCredentials(o);
    const l = a ?? await this.regionProvider(), u = LE(e), { longDate: c, shortDate: d } = this.formatDate(t), f = Mv(d, l, s ?? this.service);
    u.headers[wI] = c, o.sessionToken && (u.headers[N$] = o.sessionToken);
    const h = await _v(u, this.sha256);
    !X$(aA, u.headers) && this.applyChecksum && (u.headers[aA] = h);
    const g = NE(u, i, n), v = await this.getSignature(c, f, this.getSigningKey(o, l, d, s), this.createCanonicalRequest(u, g, h));
    return u.headers[bI] = `${Ov} Credential=${o.accessKeyId}/${f}, SignedHeaders=${this.getCanonicalHeaderList(g)}, Signature=${v}`, u;
  }
  async getSignature(e, t, n, i) {
    const a = await this.createStringToSign(e, t, i, Ov), s = new this.sha256(await n);
    return s.update(vd(a)), vl(await s.digest());
  }
  getSigningKey(e, t, n, i) {
    return Y$(this.sha256, e, n, t, i || this.service);
  }
}
const K$ = (r) => {
  let e = r.credentials, t = !!r.credentials, n;
  Object.defineProperty(r, "credentials", {
    set(u) {
      u && u !== e && u !== n && (t = !0), e = u;
      const c = Z$(r, {
        credentials: e,
        credentialDefaultProvider: r.credentialDefaultProvider
      }), d = eH(r, c);
      if (t && !d.attributed) {
        const f = typeof e == "object" && e !== null;
        n = async (h) => {
          const v = await d(h);
          return f && (!v.$source || Object.keys(v.$source).length === 0) ? o9(v, "CREDENTIALS_CODE", "e") : v;
        }, n.memoized = d.memoized, n.configBound = d.configBound, n.attributed = !0;
      } else
        n = d;
    },
    get() {
      return n;
    },
    enumerable: !0,
    configurable: !0
  }), r.credentials = e;
  const { signingEscapePath: i = !0, systemClockOffset: a = r.systemClockOffset || 0, sha256: s } = r;
  let o;
  return r.signer ? o = Qf(r.signer) : r.regionInfoProvider ? o = () => Qf(r.region)().then(async (u) => [
    await r.regionInfoProvider(u, {
      useFipsEndpoint: await r.useFipsEndpoint(),
      useDualstackEndpoint: await r.useDualstackEndpoint()
    }) || {},
    u
  ]).then(([u, c]) => {
    const { signingRegion: d, signingService: f } = u;
    r.signingRegion = r.signingRegion || d || c, r.signingName = r.signingName || f || r.serviceId;
    const h = {
      ...r,
      credentials: r.credentials,
      region: r.signingRegion,
      service: r.signingName,
      sha256: s,
      uriEscapePath: i
    }, g = r.signerConstructor || UE;
    return new g(h);
  }) : o = async (u) => {
    u = Object.assign({}, {
      name: "sigv4",
      signingName: r.signingName || r.defaultSigningName,
      signingRegion: await Qf(r.region)(),
      properties: {}
    }, u);
    const c = u.signingRegion, d = u.signingName;
    r.signingRegion = r.signingRegion || c, r.signingName = r.signingName || d || r.serviceId;
    const f = {
      ...r,
      credentials: r.credentials,
      region: r.signingRegion,
      service: r.signingName,
      sha256: s,
      uriEscapePath: i
    }, h = r.signerConstructor || UE;
    return new h(f);
  }, Object.assign(r, {
    systemClockOffset: a,
    signingEscapePath: i,
    signer: o
  });
};
function Z$(r, { credentials: e, credentialDefaultProvider: t }) {
  let n;
  return e ? e?.memoized ? n = e : n = Yz(e, Qz, dI) : t ? n = Qf(t(Object.assign({}, r, {
    parentClientConfig: r
  }))) : n = async () => {
    throw new Error("@aws-sdk/core::resolveAwsSdkSigV4Config - `credentials` not provided and no credentialDefaultProvider was configured.");
  }, n.memoized = !0, n;
}
function eH(r, e) {
  if (e.configBound)
    return e;
  const t = async (n) => e({ ...n, callerClientConfig: r });
  return t.memoized = e.memoized, t.configBound = !0, t;
}
const tH = async (r, e, t) => ({
  operation: fc(e).operation,
  region: await Ps(r.region)() || (() => {
    throw new Error("expected `region` to be configured for `aws.auth#sigv4`");
  })()
});
function rH(r) {
  return {
    schemeId: "aws.auth#sigv4",
    signingProperties: {
      name: "cognito-idp",
      region: r.region
    },
    propertiesExtractor: (e, t) => ({
      signingProperties: {
        config: e,
        context: t
      }
    })
  };
}
function Ur(r) {
  return {
    schemeId: "smithy.api#noAuth"
  };
}
const nH = (r) => {
  const e = [];
  switch (r.operation) {
    case "AssociateSoftwareToken": {
      e.push(Ur());
      break;
    }
    case "ChangePassword": {
      e.push(Ur());
      break;
    }
    case "CompleteWebAuthnRegistration": {
      e.push(Ur());
      break;
    }
    case "ConfirmDevice": {
      e.push(Ur());
      break;
    }
    case "ConfirmForgotPassword": {
      e.push(Ur());
      break;
    }
    case "ConfirmSignUp": {
      e.push(Ur());
      break;
    }
    case "DeleteUser": {
      e.push(Ur());
      break;
    }
    case "DeleteUserAttributes": {
      e.push(Ur());
      break;
    }
    case "DeleteWebAuthnCredential": {
      e.push(Ur());
      break;
    }
    case "ForgetDevice": {
      e.push(Ur());
      break;
    }
    case "ForgotPassword": {
      e.push(Ur());
      break;
    }
    case "GetDevice": {
      e.push(Ur());
      break;
    }
    case "GetTokensFromRefreshToken": {
      e.push(Ur());
      break;
    }
    case "GetUser": {
      e.push(Ur());
      break;
    }
    case "GetUserAttributeVerificationCode": {
      e.push(Ur());
      break;
    }
    case "GetUserAuthFactors": {
      e.push(Ur());
      break;
    }
    case "GlobalSignOut": {
      e.push(Ur());
      break;
    }
    case "InitiateAuth": {
      e.push(Ur());
      break;
    }
    case "ListDevices": {
      e.push(Ur());
      break;
    }
    case "ListWebAuthnCredentials": {
      e.push(Ur());
      break;
    }
    case "ResendConfirmationCode": {
      e.push(Ur());
      break;
    }
    case "RespondToAuthChallenge": {
      e.push(Ur());
      break;
    }
    case "RevokeToken": {
      e.push(Ur());
      break;
    }
    case "SetUserMFAPreference": {
      e.push(Ur());
      break;
    }
    case "SetUserSettings": {
      e.push(Ur());
      break;
    }
    case "SignUp": {
      e.push(Ur());
      break;
    }
    case "StartWebAuthnRegistration": {
      e.push(Ur());
      break;
    }
    case "UpdateAuthEventFeedback": {
      e.push(Ur());
      break;
    }
    case "UpdateDeviceStatus": {
      e.push(Ur());
      break;
    }
    case "UpdateUserAttributes": {
      e.push(Ur());
      break;
    }
    case "VerifySoftwareToken": {
      e.push(Ur());
      break;
    }
    case "VerifyUserAttribute": {
      e.push(Ur());
      break;
    }
    default:
      e.push(rH(r));
  }
  return e;
}, iH = (r) => {
  const e = K$(r);
  return Object.assign(e, {
    authSchemePreference: Ps(r.authSchemePreference ?? [])
  });
}, aH = (r) => Object.assign(r, {
  useDualstackEndpoint: r.useDualstackEndpoint ?? !1,
  useFipsEndpoint: r.useFipsEndpoint ?? !1,
  defaultSigningName: "cognito-idp"
}), CI = {
  UseFIPS: { type: "builtInParams", name: "useFipsEndpoint" },
  Endpoint: { type: "builtInParams", name: "endpoint" },
  Region: { type: "builtInParams", name: "region" },
  UseDualStack: { type: "builtInParams", name: "useDualstackEndpoint" }
}, sH = "3.1075.0", oH = {
  version: sH
}, lH = (r) => new TextEncoder().encode(r);
var uH = typeof Buffer < "u" && Buffer.from ? function(r) {
  return Buffer.from(r, "utf8");
} : lH;
function yd(r) {
  return r instanceof Uint8Array ? r : typeof r == "string" ? uH(r) : ArrayBuffer.isView(r) ? new Uint8Array(r.buffer, r.byteOffset, r.byteLength / Uint8Array.BYTES_PER_ELEMENT) : new Uint8Array(r);
}
function sA(r) {
  return typeof r == "string" ? r.length === 0 : r.byteLength === 0;
}
var SI = { name: "SHA-256" }, VE = {
  name: "HMAC",
  hash: SI
}, cH = new Uint8Array([
  227,
  176,
  196,
  66,
  152,
  252,
  28,
  20,
  154,
  251,
  244,
  200,
  153,
  111,
  185,
  36,
  39,
  174,
  65,
  228,
  100,
  155,
  147,
  76,
  164,
  149,
  153,
  27,
  120,
  82,
  184,
  85
]);
const fH = {};
function jp() {
  return typeof window < "u" ? window : typeof self < "u" ? self : fH;
}
var dH = (
  /** @class */
  (function() {
    function r(e) {
      this.toHash = new Uint8Array(0), this.secret = e, this.reset();
    }
    return r.prototype.update = function(e) {
      if (!sA(e)) {
        var t = yd(e), n = new Uint8Array(this.toHash.byteLength + t.byteLength);
        n.set(this.toHash, 0), n.set(t, this.toHash.byteLength), this.toHash = n;
      }
    }, r.prototype.digest = function() {
      var e = this;
      return this.key ? this.key.then(function(t) {
        return jp().crypto.subtle.sign(VE, t, e.toHash).then(function(n) {
          return new Uint8Array(n);
        });
      }) : sA(this.toHash) ? Promise.resolve(cH) : Promise.resolve().then(function() {
        return jp().crypto.subtle.digest(SI, e.toHash);
      }).then(function(t) {
        return Promise.resolve(new Uint8Array(t));
      });
    }, r.prototype.reset = function() {
      var e = this;
      this.toHash = new Uint8Array(0), this.secret && this.secret !== void 0 && (this.key = new Promise(function(t, n) {
        jp().crypto.subtle.importKey("raw", yd(e.secret), VE, !1, ["sign"]).then(t, n);
      }), this.key.catch(function() {
      }));
    }, r;
  })()
), da = 64, hH = 32, pH = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), gH = [
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
], mH = Math.pow(2, 53) - 1, Gp = (
  /** @class */
  (function() {
    function r() {
      this.state = Int32Array.from(gH), this.temp = new Int32Array(64), this.buffer = new Uint8Array(64), this.bufferLength = 0, this.bytesHashed = 0, this.finished = !1;
    }
    return r.prototype.update = function(e) {
      if (this.finished)
        throw new Error("Attempted to update an already finished hash.");
      var t = 0, n = e.byteLength;
      if (this.bytesHashed += n, this.bytesHashed * 8 > mH)
        throw new Error("Cannot hash more than 2^53 - 1 bits");
      for (; n > 0; )
        this.buffer[this.bufferLength++] = e[t++], n--, this.bufferLength === da && (this.hashBuffer(), this.bufferLength = 0);
    }, r.prototype.digest = function() {
      if (!this.finished) {
        var e = this.bytesHashed * 8, t = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength), n = this.bufferLength;
        if (t.setUint8(this.bufferLength++, 128), n % da >= da - 8) {
          for (var i = this.bufferLength; i < da; i++)
            t.setUint8(i, 0);
          this.hashBuffer(), this.bufferLength = 0;
        }
        for (var i = this.bufferLength; i < da - 8; i++)
          t.setUint8(i, 0);
        t.setUint32(da - 8, Math.floor(e / 4294967296), !0), t.setUint32(da - 4, e), this.hashBuffer(), this.finished = !0;
      }
      for (var a = new Uint8Array(hH), i = 0; i < 8; i++)
        a[i * 4] = this.state[i] >>> 24 & 255, a[i * 4 + 1] = this.state[i] >>> 16 & 255, a[i * 4 + 2] = this.state[i] >>> 8 & 255, a[i * 4 + 3] = this.state[i] >>> 0 & 255;
      return a;
    }, r.prototype.hashBuffer = function() {
      for (var e = this, t = e.buffer, n = e.state, i = n[0], a = n[1], s = n[2], o = n[3], l = n[4], u = n[5], c = n[6], d = n[7], f = 0; f < da; f++) {
        if (f < 16)
          this.temp[f] = (t[f * 4] & 255) << 24 | (t[f * 4 + 1] & 255) << 16 | (t[f * 4 + 2] & 255) << 8 | t[f * 4 + 3] & 255;
        else {
          var h = this.temp[f - 2], g = (h >>> 17 | h << 15) ^ (h >>> 19 | h << 13) ^ h >>> 10;
          h = this.temp[f - 15];
          var v = (h >>> 7 | h << 25) ^ (h >>> 18 | h << 14) ^ h >>> 3;
          this.temp[f] = (g + this.temp[f - 7] | 0) + (v + this.temp[f - 16] | 0);
        }
        var y = (((l >>> 6 | l << 26) ^ (l >>> 11 | l << 21) ^ (l >>> 25 | l << 7)) + (l & u ^ ~l & c) | 0) + (d + (pH[f] + this.temp[f] | 0) | 0) | 0, A = ((i >>> 2 | i << 30) ^ (i >>> 13 | i << 19) ^ (i >>> 22 | i << 10)) + (i & a ^ i & s ^ a & s) | 0;
        d = c, c = u, u = l, l = o + y | 0, o = s, s = a, a = i, i = y + A | 0;
      }
      n[0] += i, n[1] += a, n[2] += s, n[3] += o, n[4] += l, n[5] += u, n[6] += c, n[7] += d;
    }, r;
  })()
), vH = (
  /** @class */
  (function() {
    function r(e) {
      this.secret = e, this.hash = new Gp(), this.reset();
    }
    return r.prototype.update = function(e) {
      if (!(sA(e) || this.error))
        try {
          this.hash.update(yd(e));
        } catch (t) {
          this.error = t;
        }
    }, r.prototype.digestSync = function() {
      if (this.error)
        throw this.error;
      return this.outer ? (this.outer.finished || this.outer.update(this.hash.digest()), this.outer.digest()) : this.hash.digest();
    }, r.prototype.digest = function() {
      return Ka(this, void 0, void 0, function() {
        return Za(this, function(e) {
          return [2, this.digestSync()];
        });
      });
    }, r.prototype.reset = function() {
      if (this.hash = new Gp(), this.secret) {
        this.outer = new Gp();
        var e = yH(this.secret), t = new Uint8Array(da);
        t.set(e);
        for (var n = 0; n < da; n++)
          e[n] ^= 54, t[n] ^= 92;
        this.hash.update(e), this.outer.update(t);
        for (var n = 0; n < e.byteLength; n++)
          e[n] = 0;
      }
    }, r;
  })()
);
function yH(r) {
  var e = yd(r);
  if (e.byteLength > da) {
    var t = new Gp();
    t.update(e), e = t.digest();
  }
  var n = new Uint8Array(da);
  return n.set(e), n;
}
var AH = [
  "decrypt",
  "digest",
  "encrypt",
  "exportKey",
  "generateKey",
  "importKey",
  "sign",
  "verify"
];
function bH(r) {
  if (wH(r) && typeof r.crypto.subtle == "object") {
    var e = r.crypto.subtle;
    return xH(e);
  }
  return !1;
}
function wH(r) {
  if (typeof r == "object" && typeof r.crypto == "object") {
    var e = r.crypto.getRandomValues;
    return typeof e == "function";
  }
  return !1;
}
function xH(r) {
  return r && AH.every(function(e) {
    return typeof r[e] == "function";
  });
}
var CH = (
  /** @class */
  (function() {
    function r(e) {
      bH(jp()) ? this.hash = new dH(e) : this.hash = new vH(e);
    }
    return r.prototype.update = function(e, t) {
      this.hash.update(yd(e));
    }, r.prototype.digest = function() {
      return this.hash.digest();
    }, r.prototype.reset = function() {
      this.hash.reset();
    }, r;
  })()
);
function zE(r, e) {
  return new Request(r, e);
}
function SH(r = 0) {
  return new Promise((e, t) => {
    r && setTimeout(() => {
      const n = new Error(`Request did not complete within ${r} ms`);
      n.name = "TimeoutError", t(n);
    }, r);
  });
}
const Nv = {
  supported: void 0
};
class T1 {
  config;
  configProvider;
  static create(e) {
    return typeof e?.handle == "function" ? e : new T1(e);
  }
  constructor(e) {
    typeof e == "function" ? this.configProvider = e().then((t) => t || {}) : (this.config = e ?? {}, this.configProvider = Promise.resolve(this.config)), Nv.supported === void 0 && (Nv.supported = typeof Request < "u" && "keepalive" in zE("https://[::1]"));
  }
  destroy() {
  }
  async handle(e, { abortSignal: t, requestTimeout: n } = {}) {
    this.config || (this.config = await this.configProvider);
    const i = n ?? this.config.requestTimeout, a = this.config.keepAlive === !0, s = this.config.credentials;
    if (t?.aborted) {
      const x = $E(t);
      return Promise.reject(x);
    }
    let o = e.path;
    const l = ZV(e.query || {});
    l && (o += `?${l}`), e.fragment && (o += `#${e.fragment}`);
    let u = "";
    if (e.username != null || e.password != null) {
      const x = e.username ?? "", k = e.password ?? "";
      u = `${x}:${k}@`;
    }
    const { port: c, method: d } = e, f = `${e.protocol}//${u}${e.hostname}${c ? `:${c}` : ""}${o}`, h = d === "GET" || d === "HEAD" ? void 0 : e.body, g = {
      body: h,
      headers: new Headers(e.headers),
      method: d,
      credentials: s
    };
    this.config?.cache && (g.cache = this.config.cache), h && (g.duplex = "half"), typeof AbortController < "u" && (g.signal = t), Nv.supported && (g.keepalive = a), typeof this.config.requestInit == "function" && Object.assign(g, this.config.requestInit(e));
    let v = () => {
    };
    const y = zE(f, g), A = [
      fetch(y).then((x) => {
        const k = x.headers, F = {};
        for (const R of k.entries())
          F[R[0]] = R[1];
        return x.body != null ? {
          response: new Xu({
            headers: F,
            reason: x.statusText,
            statusCode: x.status,
            body: x.body
          })
        } : x.blob().then((R) => ({
          response: new Xu({
            headers: F,
            reason: x.statusText,
            statusCode: x.status,
            body: R
          })
        }));
      }),
      SH(i)
    ];
    return t && A.push(new Promise((x, k) => {
      const F = () => {
        const S = $E(t);
        k(S);
      };
      if (typeof t.addEventListener == "function") {
        const S = t;
        S.addEventListener("abort", F, { once: !0 }), v = () => S.removeEventListener("abort", F);
      } else
        t.onabort = F;
    })), Promise.race(A).finally(v);
  }
  updateHttpClientConfig(e, t) {
    this.config = void 0, this.configProvider = this.configProvider.then((n) => (n[e] = t, n));
  }
  httpHandlerConfigs() {
    return this.config ?? {};
  }
}
function $E(r) {
  const e = r && typeof r == "object" && "reason" in r ? r.reason : void 0;
  if (e) {
    if (e instanceof Error) {
      const i = new Error("Request aborted");
      return i.name = "AbortError", i.cause = e, i;
    }
    const n = new Error(String(e));
    return n.name = "AbortError", n;
  }
  const t = new Error("Request aborted");
  return t.name = "AbortError", t;
}
const EH = async (r) => typeof Blob == "function" && r instanceof Blob || r.constructor?.name === "Blob" ? Blob.prototype.arrayBuffer !== void 0 ? new Uint8Array(await r.arrayBuffer()) : kH(r) : TH(r);
async function kH(r) {
  const e = await FH(r), t = Vg(e);
  return new Uint8Array(t);
}
async function TH(r) {
  const e = [], t = r.getReader();
  let n = !1, i = 0;
  for (; !n; ) {
    const { done: o, value: l } = await t.read();
    l && (e.push(l), i += l.length), n = o;
  }
  const a = new Uint8Array(i);
  let s = 0;
  for (const o of e)
    a.set(o, s), s += o.length;
  return a;
}
function FH(r) {
  return new Promise((e, t) => {
    const n = new FileReader();
    n.onloadend = () => {
      if (n.readyState !== 2)
        return t(new Error("Reader aborted too early"));
      const i = n.result ?? "", a = i.indexOf(","), s = a > -1 ? a + 1 : i.length;
      e(i.substring(s));
    }, n.onabort = () => t(new Error("Read aborted")), n.onerror = () => t(n.error), n.readAsDataURL(r);
  });
}
class IH {
  queryCompat;
  errorRegistry;
  constructor(e = !1) {
    this.queryCompat = e;
  }
  resolveRestContentType(e, t) {
    const n = t.getMemberSchemas(), i = Object.values(n).find((a) => !!a.getMergedTraits().httpPayload);
    if (i) {
      const a = i.getMergedTraits().mediaType;
      return a || (i.isStringSchema() ? "text/plain" : i.isBlobSchema() ? "application/octet-stream" : e);
    } else if (!t.isUnitSchema() && Object.values(n).find((s) => {
      const { httpQuery: o, httpQueryParams: l, httpHeader: u, httpLabel: c, httpPrefixHeaders: d } = s.getMergedTraits();
      return !o && !l && !u && !c && d === void 0;
    }))
      return e;
  }
  async getErrorSchemaOrThrowBaseException(e, t, n, i, a, s) {
    let o = e;
    e.includes("#") && ([, o] = e.split("#"));
    const l = {
      $metadata: a,
      $fault: n.statusCode < 500 ? "client" : "server"
    };
    if (!this.errorRegistry)
      throw new Error("@aws-sdk/core/protocols - error handler not initialized.");
    try {
      return { errorSchema: s?.(this.errorRegistry, o) ?? this.errorRegistry.getSchema(e), errorMetadata: l };
    } catch {
      i.message = i.message ?? i.Message ?? "UnknownError";
      const c = this.errorRegistry, d = c.getBaseException();
      if (d) {
        const g = c.getErrorCtor(d) ?? Error;
        throw this.decorateServiceException(Object.assign(new g({ name: o }), l), i);
      }
      const f = i, h = f?.message ?? f?.Message ?? f?.Error?.Message ?? f?.Error?.message;
      throw this.decorateServiceException(Object.assign(new Error(h), {
        name: o
      }, l), i);
    }
  }
  compose(e, t, n) {
    let i = n;
    t.includes("#") && ([i] = t.split("#"));
    const a = Zi.for(i), s = Zi.for("smithy.ts.sdk.synthetic." + n);
    e.copyFrom(a), e.copyFrom(s), this.errorRegistry = e;
  }
  decorateServiceException(e, t = {}) {
    if (this.queryCompat) {
      const n = e.Message ?? t.Message, i = mE(e, t);
      n && (i.message = n);
      const a = i.Error ?? {};
      a.Type = i.Error?.Type, a.Code = i.Error?.Code, a.Message = i.Error?.message ?? i.Error?.Message ?? n, i.Error = a;
      const s = i.$metadata.requestId;
      return s && (i.RequestId = s), i;
    }
    return mE(e, t);
  }
  setQueryCompatError(e, t) {
    const n = t.headers?.["x-amzn-query-error"];
    if (e !== void 0 && n != null) {
      const [i, a] = n.split(";"), s = Object.keys(e), o = {
        Code: i,
        Type: a
      };
      e.Code = i, e.Type = a;
      for (let l = 0; l < s.length; l++) {
        const u = s[l];
        o[u === "message" ? "Message" : u] = e[u];
      }
      delete o.__type, e.Error = o;
    }
  }
  queryCompatOutput(e, t) {
    e.Error && (t.Error = e.Error), e.Type && (t.Type = e.Type), e.Code && (t.Code = e.Code);
  }
  findQueryCompatibleError(e, t) {
    try {
      return e.getSchema(t);
    } catch {
      return e.find((i) => mi.of(i).getMergedTraits().awsQueryError?.[0] === t);
    }
  }
}
class F1 {
  serdeContext;
  setSerdeContext(e) {
    this.serdeContext = e;
  }
}
class DH {
  from;
  to;
  keys;
  constructor(e, t) {
    this.from = e, this.to = t;
    const n = Object.keys(this.from), i = new Set(n);
    i.delete("__type"), this.keys = i;
  }
  mark(e) {
    this.keys.delete(e);
  }
  hasUnknown() {
    return this.keys.size === 1 && Object.keys(this.to).length === 0;
  }
  writeUnknown() {
    if (this.hasUnknown()) {
      const e = this.keys.values().next().value, t = this.from[e];
      this.to.$unknown = [e, t];
    }
  }
}
function PH(r, e, t) {
  if (t?.source) {
    const n = t.source;
    if (typeof e == "number" && (e > Number.MAX_SAFE_INTEGER || e < Number.MIN_SAFE_INTEGER || n !== String(e)))
      return n.includes(".") ? new rs(n, "bigDecimal") : BigInt(n);
  }
  return e;
}
const RH = (r, e) => nA(r, e).then((t) => (e?.utf8Encoder ?? b1)(t)), OH = (r, e) => RH(r, e).then((t) => {
  if (t.length)
    try {
      return JSON.parse(t);
    } catch (n) {
      throw n?.name === "SyntaxError" && Object.defineProperty(n, "$responseBodyText", {
        value: t
      }), n;
    }
  return {};
}), HE = (r, e) => Object.keys(r).find((t) => t.toLowerCase() === e.toLowerCase()), Lv = (r) => {
  let e = r;
  return typeof e == "number" && (e = e.toString()), e.indexOf(",") >= 0 && (e = e.split(",")[0]), e.indexOf(":") >= 0 && (e = e.split(":")[0]), e.indexOf("#") >= 0 && (e = e.split("#")[1]), e;
}, BH = (r, e, t = !1) => MH(r, e, t ? ["code", "header", "type"] : ["type", "code", "header"]), MH = ({ headers: r }, e, t) => {
  for (; t.length > 0; )
    switch (t.shift()) {
      case "header":
        const i = HE(r ?? {}, "x-amzn-errortype");
        if (i !== void 0)
          return Lv(r[i]);
        break;
      case "code":
        const a = HE(e ?? {}, "code");
        if (a && e[a] !== void 0)
          return Lv(e[a]);
        break;
      case "type":
        if (e?.__type !== void 0)
          return Lv(e.__type);
        break;
    }
};
class _H extends F1 {
  settings;
  constructor(e) {
    super(), this.settings = e;
  }
  async read(e, t) {
    return this._read(e, typeof t == "string" ? JSON.parse(t, PH) : await OH(t, this.serdeContext));
  }
  readObject(e, t) {
    return this._read(e, t);
  }
  _read(e, t) {
    const n = t !== null && typeof t == "object", i = mi.of(e);
    if (n) {
      if (i.isStructSchema()) {
        const s = t, o = i.isUnionSchema(), l = {};
        let u;
        const { jsonName: c } = this.settings;
        c && (u = {});
        let d;
        o && (d = new DH(s, l));
        for (const [f, h] of i.structIterator()) {
          let g = f;
          c && (g = h.getMergedTraits().jsonName ?? g, u[g] = f), o && d.mark(g), s[g] != null && (l[f] = this._read(h, s[g]));
        }
        if (o)
          d.writeUnknown();
        else if (typeof s.__type == "string")
          for (const f in s) {
            const h = s[f], g = c ? u[f] ?? f : f;
            g in l || (l[g] = h);
          }
        return l;
      }
      if (Array.isArray(t) && i.isListSchema()) {
        const s = i.getValueSchema(), o = [];
        for (const l of t)
          o.push(this._read(s, l));
        return o;
      }
      if (i.isMapSchema()) {
        const s = i.getValueSchema(), o = {};
        for (const l in t)
          o[l] = this._read(s, t[l]);
        return o;
      }
    }
    if (i.isBlobSchema() && typeof t == "string")
      return Vg(t);
    const a = i.getMergedTraits().mediaType;
    if (i.isStringSchema() && typeof t == "string" && a)
      return a === "application/json" || a.endsWith("+json") ? co.from(t) : t;
    if (i.isTimestampSchema() && t != null)
      switch (uI(i, this.settings)) {
        case 5:
          return j9(t);
        case 6:
          return XF(t);
        case 7:
          return Q9(t);
        default:
          return console.warn("Missing timestamp format, parsing value with Date constructor:", t), new Date(t);
      }
    if (i.isBigIntegerSchema() && (typeof t == "number" || typeof t == "string"))
      return BigInt(t);
    if (i.isBigDecimalSchema() && t != null) {
      if (t instanceof rs)
        return t;
      const s = t;
      return s.type === "bigDecimal" && "string" in s ? new rs(s.string, s.type) : new rs(String(t), "bigDecimal");
    }
    if (i.isNumericSchema() && typeof t == "string") {
      switch (t) {
        case "Infinity":
          return 1 / 0;
        case "-Infinity":
          return -1 / 0;
        case "NaN":
          return NaN;
      }
      return t;
    }
    if (i.isDocumentSchema())
      if (n) {
        const s = Array.isArray(t) ? [] : {};
        for (const o in t) {
          const l = t[o];
          l instanceof rs ? s[o] = l : s[o] = this._read(i, l);
        }
        return s;
      } else
        return structuredClone(t);
    return t;
  }
}
const jE = "Ν";
class NH {
  values = /* @__PURE__ */ new Map();
  counter = 0;
  stage = 0;
  createReplacer() {
    if (this.stage === 1)
      throw new Error("@aws-sdk/core/protocols - JsonReplacer already created.");
    if (this.stage === 2)
      throw new Error("@aws-sdk/core/protocols - JsonReplacer exhausted.");
    return this.stage = 1, (e, t) => {
      if (t instanceof rs) {
        const n = `${jE + "nv" + this.counter++}_` + t.string;
        return this.values.set(`"${n}"`, t.string), n;
      }
      if (typeof t == "bigint") {
        const n = t.toString(), i = `${jE + "b" + this.counter++}_` + n;
        return this.values.set(`"${i}"`, n), i;
      }
      return t;
    };
  }
  replaceInJson(e) {
    if (this.stage === 0)
      throw new Error("@aws-sdk/core/protocols - JsonReplacer not created yet.");
    if (this.stage === 2)
      throw new Error("@aws-sdk/core/protocols - JsonReplacer exhausted.");
    if (this.stage = 2, this.counter === 0)
      return e;
    for (const [t, n] of this.values)
      e = e.replace(t, n);
    return e;
  }
}
class LH extends F1 {
  settings;
  buffer;
  useReplacer = !1;
  rootSchema;
  constructor(e) {
    super(), this.settings = e;
  }
  write(e, t) {
    this.rootSchema = mi.of(e), this.buffer = this._write(this.rootSchema, t);
  }
  flush() {
    const { rootSchema: e, useReplacer: t } = this;
    if (this.rootSchema = void 0, this.useReplacer = !1, e?.isStructSchema() || e?.isDocumentSchema()) {
      if (!t)
        return JSON.stringify(this.buffer);
      const n = new NH();
      return n.replaceInJson(JSON.stringify(this.buffer, n.createReplacer(), 0));
    }
    return this.buffer;
  }
  writeDiscriminatedDocument(e, t) {
    this.write(e, t), typeof this.buffer == "object" && (this.buffer.__type = mi.of(e).getName(!0));
  }
  _write(e, t, n) {
    const i = t !== null && typeof t == "object", a = mi.of(e);
    if (i) {
      if (a.isStructSchema()) {
        const s = t, o = {}, { jsonName: l } = this.settings;
        let u;
        l && (u = {});
        let c = 0;
        for (const [d, f] of a.structIterator()) {
          const h = this._write(f, s[d], a);
          if (h !== void 0) {
            let g = d;
            l && (g = f.getMergedTraits().jsonName ?? d, u[d] = g), o[g] = h, c++;
          }
        }
        if (a.isUnionSchema() && c === 0) {
          const { $unknown: d } = s;
          if (Array.isArray(d)) {
            const [f, h] = d;
            o[f] = this._write(15, h);
          }
        } else if (typeof s.__type == "string")
          for (const d in s) {
            const f = s[d], h = l ? u[d] ?? d : d;
            h in o || (o[h] = this._write(15, f));
          }
        return o;
      }
      if (Array.isArray(t) && a.isListSchema()) {
        const s = a.getValueSchema(), o = [], l = !!a.getMergedTraits().sparse;
        for (const u of t)
          (l || u != null) && o.push(this._write(s, u));
        return o;
      }
      if (a.isMapSchema()) {
        const s = a.getValueSchema(), o = {}, l = !!a.getMergedTraits().sparse;
        for (const u in t) {
          const c = t[u];
          (l || c != null) && (o[u] = this._write(s, c));
        }
        return o;
      }
      if (t instanceof Uint8Array && (a.isBlobSchema() || a.isDocumentSchema()))
        return a === this.rootSchema ? t : (this.serdeContext?.base64Encoder ?? gg)(t);
      if (t instanceof Date && (a.isTimestampSchema() || a.isDocumentSchema()))
        switch (uI(a, this.settings)) {
          case 5:
            return t.toISOString().replace(".000Z", "Z");
          case 6:
            return $9(t);
          case 7:
            return t.getTime() / 1e3;
          default:
            return console.warn("Missing timestamp format, using epoch seconds", t), t.getTime() / 1e3;
        }
      t instanceof rs && (this.useReplacer = !0);
    }
    if (!(t === null && n?.isStructSchema())) {
      if (a.isStringSchema()) {
        if (typeof t > "u" && a.isIdempotencyToken())
          return HV();
        const s = a.getMergedTraits().mediaType;
        return t != null && s && (s === "application/json" || s.endsWith("+json")) ? co.from(t) : t;
      }
      if (typeof t == "number" && a.isNumericSchema())
        return Math.abs(t) === 1 / 0 || isNaN(t) ? String(t) : t;
      if (typeof t == "string" && a.isBlobSchema())
        return a === this.rootSchema ? t : (this.serdeContext?.base64Encoder ?? gg)(t);
      if (typeof t == "bigint" && (this.useReplacer = !0), a.isDocumentSchema())
        if (i) {
          const s = Array.isArray(t) ? [] : {};
          for (const o in t) {
            const l = t[o];
            l instanceof rs ? (this.useReplacer = !0, s[o] = l) : s[o] = this._write(a, l);
          }
          return s;
        } else
          return structuredClone(t);
      return t;
    }
  }
}
class UH extends F1 {
  settings;
  constructor(e) {
    super(), this.settings = e;
  }
  createSerializer() {
    const e = new LH(this.settings);
    return e.setSerdeContext(this.serdeContext), e;
  }
  createDeserializer() {
    const e = new _H(this.settings);
    return e.setSerdeContext(this.serdeContext), e;
  }
}
class VH extends qV {
  serializer;
  deserializer;
  serviceTarget;
  codec;
  mixin;
  awsQueryCompatible;
  constructor({ defaultNamespace: e, errorTypeRegistries: t, serviceTarget: n, awsQueryCompatible: i, jsonCodec: a }) {
    super({
      defaultNamespace: e,
      errorTypeRegistries: t
    }), this.serviceTarget = n, this.codec = a ?? new UH({
      timestampFormat: {
        useTrait: !0,
        default: 7
      },
      jsonName: !1
    }), this.serializer = this.codec.createSerializer(), this.deserializer = this.codec.createDeserializer(), this.awsQueryCompatible = !!i, this.mixin = new IH(this.awsQueryCompatible);
  }
  async serializeRequest(e, t, n) {
    const i = await super.serializeRequest(e, t, n);
    return i.path.endsWith("/") || (i.path += "/"), i.headers["content-type"] = `application/x-amz-json-${this.getJsonRpcVersion()}`, i.headers["x-amz-target"] = `${this.serviceTarget}.${e.name}`, this.awsQueryCompatible && (i.headers["x-amzn-query-mode"] = "true"), (zp(e.input) === "unit" || !i.body) && (i.body = "{}"), i;
  }
  getPayloadCodec() {
    return this.codec;
  }
  async handleError(e, t, n, i, a) {
    const { awsQueryCompatible: s } = this;
    s && this.mixin.setQueryCompatError(i, n);
    const o = BH(n, i, s) ?? "Unknown";
    this.mixin.compose(this.compositeErrorRegistry, o, this.options.defaultNamespace);
    const { errorSchema: l, errorMetadata: u } = await this.mixin.getErrorSchemaOrThrowBaseException(o, this.options.defaultNamespace, n, i, a, s ? this.mixin.findQueryCompatibleError : void 0), c = mi.of(l), d = i.message ?? i.Message ?? "UnknownError", f = this.compositeErrorRegistry.getErrorCtor(l) ?? Error, h = new f({}), g = {}, v = this.codec.createDeserializer();
    for (const [y, A] of c.structIterator())
      i[y] != null && (g[y] = v.readObject(A, i[y]));
    throw s && this.mixin.queryCompatOutput(i, g), this.mixin.decorateServiceException(Object.assign(h, u, {
      $fault: c.getMergedTraits().error,
      message: d
    }, g), i);
  }
}
class zH extends VH {
  constructor({ defaultNamespace: e, errorTypeRegistries: t, serviceTarget: n, awsQueryCompatible: i, jsonCodec: a }) {
    super({
      defaultNamespace: e,
      errorTypeRegistries: t,
      serviceTarget: n,
      awsQueryCompatible: i,
      jsonCodec: a
    });
  }
  getShapeId() {
    return "aws.protocols#awsJson1_1";
  }
  getJsonRpcVersion() {
    return "1.1";
  }
  getDefaultContentType() {
    return "application/x-amz-json-1.1";
  }
}
const Ad = "ref", ol = -1, Ap = !0, GE = "isSet", EI = "PartitionResult", bp = "booleanEquals", Uv = "getAttr", Cf = "stringEquals", qE = { [Ad]: "Endpoint" }, Vv = { [Ad]: EI }, Nf = { [Ad]: "Region" }, Wa = {}, WE = [Nf], QE = {
  conditions: [
    [GE, [qE]],
    [GE, WE],
    ["aws.partition", WE, EI],
    [bp, [{ [Ad]: "UseFIPS" }, Ap]],
    [bp, [{ fn: Uv, argv: [Vv, "supportsFIPS"] }, Ap]],
    [bp, [{ [Ad]: "UseDualStack" }, Ap]],
    [bp, [{ fn: Uv, argv: [Vv, "supportsDualStack"] }, Ap]],
    [Cf, [{ fn: Uv, argv: [Vv, "name"] }, "aws"]],
    [Cf, [Nf, "us-east-1"]],
    [Cf, [Nf, "us-east-2"]],
    [Cf, [Nf, "us-west-1"]],
    [Cf, [Nf, "us-west-2"]]
  ],
  results: [
    [ol],
    [ol, "Invalid Configuration: FIPS and custom endpoint are not supported"],
    [ol, "Invalid Configuration: Dualstack and custom endpoint are not supported"],
    [qE, Wa],
    ["https://cognito-idp-fips.us-east-1.amazonaws.com", Wa],
    ["https://cognito-idp-fips.us-east-2.amazonaws.com", Wa],
    ["https://cognito-idp-fips.us-west-1.amazonaws.com", Wa],
    ["https://cognito-idp-fips.us-west-2.amazonaws.com", Wa],
    ["https://cognito-idp-fips.{Region}.{PartitionResult#dualStackDnsSuffix}", Wa],
    [ol, "FIPS and DualStack are enabled, but this partition does not support one or both"],
    ["https://cognito-idp-fips.{Region}.{PartitionResult#dnsSuffix}", Wa],
    [ol, "FIPS is enabled but this partition does not support FIPS"],
    ["https://cognito-idp.{Region}.amazonaws.com", Wa],
    ["https://cognito-idp.{Region}.{PartitionResult#dualStackDnsSuffix}", Wa],
    [ol, "DualStack is enabled but this partition does not support DualStack"],
    ["https://cognito-idp.{Region}.{PartitionResult#dnsSuffix}", Wa],
    [ol, "Invalid Configuration: Missing Region"]
  ]
}, $H = 2, hi = 1e8, HH = new Int32Array([
  -1,
  1,
  -1,
  0,
  17,
  3,
  1,
  4,
  hi + 16,
  2,
  5,
  hi + 16,
  3,
  9,
  6,
  5,
  7,
  hi + 15,
  6,
  8,
  hi + 14,
  7,
  hi + 12,
  hi + 13,
  4,
  11,
  10,
  5,
  hi + 9,
  hi + 11,
  5,
  12,
  hi + 10,
  6,
  13,
  hi + 9,
  8,
  hi + 4,
  14,
  9,
  hi + 5,
  15,
  10,
  hi + 6,
  16,
  11,
  hi + 7,
  hi + 8,
  3,
  hi + 1,
  18,
  5,
  hi + 2,
  hi + 3
]), jH = x1.from(HH, $H, QE.conditions, QE.results), GH = new wV({
  size: 50,
  params: ["Endpoint", "Region", "UseDualStack", "UseFIPS"]
}), qH = (r, e = {}) => GH.get(r, () => VV(jH, {
  endpointParams: r,
  logger: e.logger
}));
C1.aws = pI;
class xt extends Du {
  constructor(e) {
    super(e), Object.setPrototypeOf(this, xt.prototype);
  }
}
class I1 extends xt {
  name = "AccessDeniedException";
  $fault = "client";
  constructor(e) {
    super({
      name: "AccessDeniedException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, I1.prototype);
  }
}
class D1 extends xt {
  name = "InternalErrorException";
  $fault = "server";
  constructor(e) {
    super({
      name: "InternalErrorException",
      $fault: "server",
      ...e
    }), Object.setPrototypeOf(this, D1.prototype);
  }
}
class P1 extends xt {
  name = "InvalidParameterException";
  $fault = "client";
  reasonCode;
  constructor(e) {
    super({
      name: "InvalidParameterException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, P1.prototype), this.reasonCode = e.reasonCode;
  }
}
class R1 extends xt {
  name = "NotAuthorizedException";
  $fault = "client";
  constructor(e) {
    super({
      name: "NotAuthorizedException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, R1.prototype);
  }
}
class O1 extends xt {
  name = "OperationNotEnabledException";
  $fault = "client";
  constructor(e) {
    super({
      name: "OperationNotEnabledException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, O1.prototype);
  }
}
class B1 extends xt {
  name = "ResourceNotFoundException";
  $fault = "client";
  constructor(e) {
    super({
      name: "ResourceNotFoundException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, B1.prototype);
  }
}
class M1 extends xt {
  name = "TooManyRequestsException";
  $fault = "client";
  constructor(e) {
    super({
      name: "TooManyRequestsException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, M1.prototype);
  }
}
class _1 extends xt {
  name = "UserImportInProgressException";
  $fault = "client";
  constructor(e) {
    super({
      name: "UserImportInProgressException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, _1.prototype);
  }
}
class N1 extends xt {
  name = "InternalServerException";
  $fault = "server";
  constructor(e) {
    super({
      name: "InternalServerException",
      $fault: "server",
      ...e
    }), Object.setPrototypeOf(this, N1.prototype);
  }
}
class L1 extends xt {
  name = "LimitExceededException";
  $fault = "client";
  constructor(e) {
    super({
      name: "LimitExceededException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, L1.prototype);
  }
}
class U1 extends xt {
  name = "UserNotFoundException";
  $fault = "client";
  constructor(e) {
    super({
      name: "UserNotFoundException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, U1.prototype);
  }
}
class V1 extends xt {
  name = "InvalidLambdaResponseException";
  $fault = "client";
  constructor(e) {
    super({
      name: "InvalidLambdaResponseException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, V1.prototype);
  }
}
class z1 extends xt {
  name = "TooManyFailedAttemptsException";
  $fault = "client";
  constructor(e) {
    super({
      name: "TooManyFailedAttemptsException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, z1.prototype);
  }
}
class $1 extends xt {
  name = "UnexpectedLambdaException";
  $fault = "client";
  constructor(e) {
    super({
      name: "UnexpectedLambdaException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, $1.prototype);
  }
}
class H1 extends xt {
  name = "UserLambdaValidationException";
  $fault = "client";
  constructor(e) {
    super({
      name: "UserLambdaValidationException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, H1.prototype);
  }
}
class j1 extends xt {
  name = "CodeDeliveryFailureException";
  $fault = "client";
  constructor(e) {
    super({
      name: "CodeDeliveryFailureException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, j1.prototype);
  }
}
class G1 extends xt {
  name = "InvalidPasswordException";
  $fault = "client";
  constructor(e) {
    super({
      name: "InvalidPasswordException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, G1.prototype);
  }
}
class q1 extends xt {
  name = "InvalidSmsRoleAccessPolicyException";
  $fault = "client";
  constructor(e) {
    super({
      name: "InvalidSmsRoleAccessPolicyException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, q1.prototype);
  }
}
class W1 extends xt {
  name = "InvalidSmsRoleTrustRelationshipException";
  $fault = "client";
  constructor(e) {
    super({
      name: "InvalidSmsRoleTrustRelationshipException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, W1.prototype);
  }
}
class Q1 extends xt {
  name = "PreconditionNotMetException";
  $fault = "client";
  constructor(e) {
    super({
      name: "PreconditionNotMetException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Q1.prototype);
  }
}
class Y1 extends xt {
  name = "UnsupportedUserStateException";
  $fault = "client";
  constructor(e) {
    super({
      name: "UnsupportedUserStateException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Y1.prototype);
  }
}
class X1 extends xt {
  name = "UsernameExistsException";
  $fault = "client";
  constructor(e) {
    super({
      name: "UsernameExistsException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, X1.prototype);
  }
}
class J1 extends xt {
  name = "AliasExistsException";
  $fault = "client";
  constructor(e) {
    super({
      name: "AliasExistsException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, J1.prototype);
  }
}
class K1 extends xt {
  name = "InvalidUserPoolConfigurationException";
  $fault = "client";
  constructor(e) {
    super({
      name: "InvalidUserPoolConfigurationException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, K1.prototype);
  }
}
class Z1 extends xt {
  name = "InvalidEmailRoleAccessPolicyException";
  $fault = "client";
  constructor(e) {
    super({
      name: "InvalidEmailRoleAccessPolicyException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Z1.prototype);
  }
}
class eb extends xt {
  name = "MFAMethodNotFoundException";
  $fault = "client";
  constructor(e) {
    super({
      name: "MFAMethodNotFoundException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, eb.prototype);
  }
}
class tb extends xt {
  name = "PasswordResetRequiredException";
  $fault = "client";
  constructor(e) {
    super({
      name: "PasswordResetRequiredException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, tb.prototype);
  }
}
class rb extends xt {
  name = "UnsupportedOperationException";
  $fault = "client";
  constructor(e) {
    super({
      name: "UnsupportedOperationException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, rb.prototype);
  }
}
class nb extends xt {
  name = "UserNotConfirmedException";
  $fault = "client";
  constructor(e) {
    super({
      name: "UserNotConfirmedException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, nb.prototype);
  }
}
class ib extends xt {
  name = "UserPoolAddOnNotEnabledException";
  $fault = "client";
  constructor(e) {
    super({
      name: "UserPoolAddOnNotEnabledException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, ib.prototype);
  }
}
class ab extends xt {
  name = "CodeMismatchException";
  $fault = "client";
  constructor(e) {
    super({
      name: "CodeMismatchException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, ab.prototype);
  }
}
class sb extends xt {
  name = "ExpiredCodeException";
  $fault = "client";
  constructor(e) {
    super({
      name: "ExpiredCodeException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, sb.prototype);
  }
}
class ob extends xt {
  name = "PasswordHistoryPolicyViolationException";
  $fault = "client";
  constructor(e) {
    super({
      name: "PasswordHistoryPolicyViolationException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, ob.prototype);
  }
}
class lb extends xt {
  name = "SoftwareTokenMFANotFoundException";
  $fault = "client";
  constructor(e) {
    super({
      name: "SoftwareTokenMFANotFoundException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, lb.prototype);
  }
}
class ub extends xt {
  name = "ConcurrentModificationException";
  $fault = "client";
  constructor(e) {
    super({
      name: "ConcurrentModificationException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, ub.prototype);
  }
}
class cb extends xt {
  name = "ForbiddenException";
  $fault = "client";
  constructor(e) {
    super({
      name: "ForbiddenException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, cb.prototype);
  }
}
class fb extends xt {
  name = "WebAuthnChallengeNotFoundException";
  $fault = "client";
  constructor(e) {
    super({
      name: "WebAuthnChallengeNotFoundException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, fb.prototype);
  }
}
class db extends xt {
  name = "WebAuthnClientMismatchException";
  $fault = "client";
  constructor(e) {
    super({
      name: "WebAuthnClientMismatchException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, db.prototype);
  }
}
class hb extends xt {
  name = "WebAuthnCredentialNotSupportedException";
  $fault = "client";
  constructor(e) {
    super({
      name: "WebAuthnCredentialNotSupportedException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, hb.prototype);
  }
}
class pb extends xt {
  name = "WebAuthnNotEnabledException";
  $fault = "client";
  constructor(e) {
    super({
      name: "WebAuthnNotEnabledException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, pb.prototype);
  }
}
class gb extends xt {
  name = "WebAuthnOriginNotAllowedException";
  $fault = "client";
  constructor(e) {
    super({
      name: "WebAuthnOriginNotAllowedException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, gb.prototype);
  }
}
class mb extends xt {
  name = "WebAuthnRelyingPartyMismatchException";
  $fault = "client";
  constructor(e) {
    super({
      name: "WebAuthnRelyingPartyMismatchException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, mb.prototype);
  }
}
class vb extends xt {
  name = "DeviceKeyExistsException";
  $fault = "client";
  constructor(e) {
    super({
      name: "DeviceKeyExistsException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, vb.prototype);
  }
}
class yb extends xt {
  name = "GroupExistsException";
  $fault = "client";
  constructor(e) {
    super({
      name: "GroupExistsException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, yb.prototype);
  }
}
class Ab extends xt {
  name = "DuplicateProviderException";
  $fault = "client";
  constructor(e) {
    super({
      name: "DuplicateProviderException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Ab.prototype);
  }
}
class bb extends xt {
  name = "ManagedLoginBrandingExistsException";
  $fault = "client";
  constructor(e) {
    super({
      name: "ManagedLoginBrandingExistsException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, bb.prototype);
  }
}
class wb extends xt {
  name = "TermsExistsException";
  $fault = "client";
  constructor(e) {
    super({
      name: "TermsExistsException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, wb.prototype);
  }
}
class xb extends xt {
  name = "FeatureUnavailableInTierException";
  $fault = "client";
  constructor(e) {
    super({
      name: "FeatureUnavailableInTierException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, xb.prototype);
  }
}
class Cb extends xt {
  name = "TierChangeNotAllowedException";
  $fault = "client";
  constructor(e) {
    super({
      name: "TierChangeNotAllowedException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Cb.prototype);
  }
}
class Sb extends xt {
  name = "UserPoolTaggingException";
  $fault = "client";
  constructor(e) {
    super({
      name: "UserPoolTaggingException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Sb.prototype);
  }
}
class Eb extends xt {
  name = "InvalidOAuthFlowException";
  $fault = "client";
  constructor(e) {
    super({
      name: "InvalidOAuthFlowException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Eb.prototype);
  }
}
class kb extends xt {
  name = "ScopeDoesNotExistException";
  $fault = "client";
  constructor(e) {
    super({
      name: "ScopeDoesNotExistException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, kb.prototype);
  }
}
class Tb extends xt {
  name = "UnsupportedIdentityProviderException";
  $fault = "client";
  constructor(e) {
    super({
      name: "UnsupportedIdentityProviderException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Tb.prototype);
  }
}
class Fb extends xt {
  name = "RefreshTokenReuseException";
  $fault = "client";
  constructor(e) {
    super({
      name: "RefreshTokenReuseException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Fb.prototype);
  }
}
class Ib extends xt {
  name = "UnauthorizedException";
  $fault = "client";
  constructor(e) {
    super({
      name: "UnauthorizedException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Ib.prototype);
  }
}
class Db extends xt {
  name = "UnsupportedTokenTypeException";
  $fault = "client";
  constructor(e) {
    super({
      name: "UnsupportedTokenTypeException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Db.prototype);
  }
}
class Pb extends xt {
  name = "WebAuthnConfigurationMissingException";
  $fault = "client";
  constructor(e) {
    super({
      name: "WebAuthnConfigurationMissingException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Pb.prototype);
  }
}
class Rb extends xt {
  name = "EnableSoftwareTokenMFAException";
  $fault = "client";
  constructor(e) {
    super({
      name: "EnableSoftwareTokenMFAException",
      $fault: "client",
      ...e
    }), Object.setPrototypeOf(this, Rb.prototype);
  }
}
const WH = "AvailableChallenges", QH = "AccessDeniedException", YH = "AliasExistsException", XH = "AnalyticsEndpointId", JH = "AuthFlow", kI = "AnalyticsMetadata", KH = "AnalyticsMetadataType", ZH = "AuthParameters", ej = "AuthParametersType", TI = "AuthenticationResult", tj = "AuthenticationResultType", rj = "AccessToken", nj = "CodeDeliveryFailureException", FI = "ClientId", ij = "ClientIdType", II = "ClientMetadata", aj = "CodeMismatchException", sj = "ConcurrentModificationException", Ob = "ChallengeName", DI = "ChallengeParameters", oj = "ChallengeResponses", lj = "ChallengeResponsesType", uj = "DeviceGroupKey", cj = "DeviceKey", fj = "DeviceKeyExistsException", dj = "DuplicateProviderException", hj = "ExpiredCodeException", pj = "EncodedData", gj = "ExpiresIn", mj = "EnableSoftwareTokenMFAException", vj = "ForbiddenException", yj = "FeatureUnavailableInTierException", Aj = "GroupExistsException", bj = "IpAddress", wj = "InitiateAuthRequest", xj = "InitiateAuthResponse", Cj = "InitiateAuth", Sj = "InternalErrorException", Ej = "InvalidEmailRoleAccessPolicyException", kj = "InvalidLambdaResponseException", Tj = "InvalidOAuthFlowException", Fj = "InvalidParameterException", Ij = "InvalidPasswordException", Dj = "InternalServerException", Pj = "InvalidSmsRoleAccessPolicyException", Rj = "InvalidSmsRoleTrustRelationshipException", Oj = "IdToken", Bj = "InvalidUserPoolConfigurationException", Mj = "LimitExceededException", _j = "MFAMethodNotFoundException", Nj = "ManagedLoginBrandingExistsException", Lj = "NotAuthorizedException", Uj = "NewDeviceMetadata", Vj = "NewDeviceMetadataType", zj = "OperationNotEnabledException", $j = "PasswordHistoryPolicyViolationException", Hj = "PreconditionNotMetException", jj = "PasswordResetRequiredException", Gj = "ResourceNotFoundException", qj = "RefreshToken", Wj = "RespondToAuthChallenge", Qj = "RespondToAuthChallengeRequest", Yj = "RespondToAuthChallengeResponse", Xj = "RefreshTokenReuseException", Hg = "Session", Jj = "ScopeDoesNotExistException", Kj = "SessionType", Zj = "SoftwareTokenMFANotFoundException", eG = "TierChangeNotAllowedException", tG = "TermsExistsException", rG = "TooManyFailedAttemptsException", nG = "TooManyRequestsException", iG = "TokenModelType", aG = "TokenType", sG = "UserContextDataType", PI = "UserContextData", oG = "UnauthorizedException", lG = "UsernameExistsException", uG = "UserImportInProgressException", cG = "UnsupportedIdentityProviderException", fG = "UnexpectedLambdaException", dG = "UserLambdaValidationException", hG = "UserNotConfirmedException", pG = "UserNotFoundException", gG = "UnsupportedOperationException", mG = "UserPoolAddOnNotEnabledException", vG = "UserPoolTaggingException", yG = "UnsupportedTokenTypeException", AG = "UnsupportedUserStateException", bG = "WebAuthnClientMismatchException", wG = "WebAuthnConfigurationMissingException", xG = "WebAuthnChallengeNotFoundException", CG = "WebAuthnCredentialNotSupportedException", SG = "WebAuthnNotEnabledException", EG = "WebAuthnOriginNotAllowedException", kG = "WebAuthnRelyingPartyMismatchException", It = "client", Tt = "error", Dt = "httpError", Ft = "message", TG = "reasonCode", RI = "smithy.ts.sdk.synthetic.com.amazonaws.cognitoidentityprovider", OI = "server", at = "com.amazonaws.cognitoidentityprovider", BI = Zi.for(RI);
var FG = [-3, RI, "CognitoIdentityProviderServiceException", 0, [], []];
BI.registerError(FG, xt);
const kt = Zi.for(at);
var IG = [
  -3,
  at,
  QH,
  { [Tt]: It, [Dt]: 403 },
  [Ft],
  [0]
];
kt.registerError(IG, I1);
var DG = [
  -3,
  at,
  YH,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(DG, J1);
var PG = [
  -3,
  at,
  nj,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(PG, j1);
var RG = [
  -3,
  at,
  aj,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(RG, ab);
var OG = [
  -3,
  at,
  sj,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(OG, ub);
var BG = [
  -3,
  at,
  fj,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(BG, vb);
var MG = [
  -3,
  at,
  dj,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(MG, Ab);
var _G = [
  -3,
  at,
  mj,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(_G, Rb);
var NG = [
  -3,
  at,
  hj,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(NG, sb);
var LG = [
  -3,
  at,
  yj,
  { [Tt]: It, [Dt]: 403 },
  [Ft],
  [0]
];
kt.registerError(LG, xb);
var UG = [
  -3,
  at,
  vj,
  { [Tt]: It, [Dt]: 403 },
  [Ft],
  [0]
];
kt.registerError(UG, cb);
var VG = [
  -3,
  at,
  Aj,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(VG, yb);
var zG = [
  -3,
  at,
  Sj,
  { [Tt]: OI },
  [Ft],
  [0]
];
kt.registerError(zG, D1);
var $G = [
  -3,
  at,
  Dj,
  { [Tt]: OI },
  [Ft],
  [0]
];
kt.registerError($G, N1);
var HG = [
  -3,
  at,
  Ej,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(HG, Z1);
var jG = [
  -3,
  at,
  kj,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(jG, V1);
var GG = [
  -3,
  at,
  Tj,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(GG, Eb);
var qG = [
  -3,
  at,
  Fj,
  { [Tt]: It, [Dt]: 400 },
  [Ft, TG],
  [0, 0]
];
kt.registerError(qG, P1);
var WG = [
  -3,
  at,
  Ij,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(WG, G1);
var QG = [
  -3,
  at,
  Pj,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(QG, q1);
var YG = [
  -3,
  at,
  Rj,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(YG, W1);
var XG = [
  -3,
  at,
  Bj,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(XG, K1);
var JG = [
  -3,
  at,
  Mj,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(JG, L1);
var KG = [
  -3,
  at,
  Nj,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(KG, bb);
var ZG = [
  -3,
  at,
  _j,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(ZG, eb);
var eq = [
  -3,
  at,
  Lj,
  { [Tt]: It, [Dt]: 403 },
  [Ft],
  [0]
];
kt.registerError(eq, R1);
var tq = [
  -3,
  at,
  zj,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(tq, O1);
var rq = [
  -3,
  at,
  $j,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(rq, ob);
var nq = [
  -3,
  at,
  jj,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(nq, tb);
var iq = [
  -3,
  at,
  Hj,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(iq, Q1);
var aq = [
  -3,
  at,
  Xj,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(aq, Fb);
var sq = [
  -3,
  at,
  Gj,
  { [Tt]: It, [Dt]: 404 },
  [Ft],
  [0]
];
kt.registerError(sq, B1);
var oq = [
  -3,
  at,
  Jj,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(oq, kb);
var lq = [
  -3,
  at,
  Zj,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(lq, lb);
var uq = [
  -3,
  at,
  tG,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(uq, wb);
var cq = [
  -3,
  at,
  eG,
  { [Tt]: It, [Dt]: 403 },
  [Ft],
  [0]
];
kt.registerError(cq, Cb);
var fq = [
  -3,
  at,
  rG,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(fq, z1);
var dq = [
  -3,
  at,
  nG,
  { [Tt]: It, [Dt]: 429 },
  [Ft],
  [0]
];
kt.registerError(dq, M1);
var hq = [
  -3,
  at,
  oG,
  { [Tt]: It, [Dt]: 401 },
  [Ft],
  [0]
];
kt.registerError(hq, Ib);
var pq = [
  -3,
  at,
  fG,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(pq, $1);
var gq = [
  -3,
  at,
  cG,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(gq, Tb);
var mq = [
  -3,
  at,
  gG,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(mq, rb);
var vq = [
  -3,
  at,
  yG,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(vq, Db);
var yq = [
  -3,
  at,
  AG,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(yq, Y1);
var Aq = [
  -3,
  at,
  uG,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(Aq, _1);
var bq = [
  -3,
  at,
  dG,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(bq, H1);
var wq = [
  -3,
  at,
  lG,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(wq, X1);
var xq = [
  -3,
  at,
  hG,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(xq, nb);
var Cq = [
  -3,
  at,
  pG,
  { [Tt]: It, [Dt]: 404 },
  [Ft],
  [0]
];
kt.registerError(Cq, U1);
var Sq = [
  -3,
  at,
  mG,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(Sq, ib);
var Eq = [
  -3,
  at,
  vG,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(Eq, Sb);
var kq = [
  -3,
  at,
  xG,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(kq, fb);
var Tq = [
  -3,
  at,
  bG,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(Tq, db);
var Fq = [
  -3,
  at,
  wG,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(Fq, Pb);
var Iq = [
  -3,
  at,
  CG,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(Iq, hb);
var Dq = [
  -3,
  at,
  SG,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(Dq, pb);
var Pq = [
  -3,
  at,
  EG,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(Pq, gb);
var Rq = [
  -3,
  at,
  kG,
  { [Tt]: It, [Dt]: 400 },
  [Ft],
  [0]
];
kt.registerError(Rq, mb);
const Oq = [
  BI,
  kt
];
var MI = [0, at, ij, 8, 0], jg = [0, at, Kj, 8, 0], zv = [0, at, iG, 8, 0], _I = [
  3,
  at,
  KH,
  0,
  [XH],
  [0]
], NI = [
  3,
  at,
  tj,
  0,
  [rj, gj, aG, qj, Oj, Uj],
  [[() => zv, 0], 1, 0, [() => zv, 0], [() => zv, 0], () => _q]
], Bq = [
  3,
  at,
  wj,
  0,
  [JH, FI, ZH, II, kI, PI, Hg],
  [0, [() => MI, 0], [() => Uq, 0], 128, () => _I, [() => LI, 0], [() => jg, 0]],
  2
], Mq = [
  3,
  at,
  xj,
  0,
  [Ob, Hg, DI, TI, WH],
  [0, [() => jg, 0], 128, [() => NI, 0], 64]
], _q = [
  3,
  at,
  Vj,
  0,
  [cj, uj],
  [0, 0]
], Nq = [
  3,
  at,
  Qj,
  0,
  [FI, Ob, Hg, oj, kI, PI, II],
  [[() => MI, 0], 0, [() => jg, 0], [() => Vq, 0], () => _I, [() => LI, 0], 128],
  2
], Lq = [
  3,
  at,
  Yj,
  0,
  [Ob, Hg, DI, TI],
  [0, [() => jg, 0], 128, [() => NI, 0]]
], LI = [
  3,
  at,
  sG,
  8,
  [bj, pj],
  [0, 0]
], Uq = [
  2,
  at,
  ej,
  8,
  0,
  0
], Vq = [
  2,
  at,
  lj,
  8,
  0,
  0
], zq = [
  9,
  at,
  Cj,
  0,
  () => Bq,
  () => Mq
], $q = [
  9,
  at,
  Wj,
  0,
  () => Nq,
  () => Lq
];
const Hq = (r) => ({
  apiVersion: "2016-04-18",
  base64Decoder: r?.base64Decoder ?? Vg,
  base64Encoder: r?.base64Encoder ?? gg,
  disableHostPrefix: r?.disableHostPrefix ?? !1,
  endpointProvider: r?.endpointProvider ?? qH,
  extensions: r?.extensions ?? [],
  httpAuthSchemeProvider: r?.httpAuthSchemeProvider ?? nH,
  httpAuthSchemes: r?.httpAuthSchemes ?? [
    {
      schemeId: "aws.auth#sigv4",
      identityProvider: (e) => e.getIdentityProvider("aws.auth#sigv4"),
      signer: new T$()
    },
    {
      schemeId: "smithy.api#noAuth",
      identityProvider: (e) => e.getIdentityProvider("smithy.api#noAuth") || (async () => ({})),
      signer: new Gz()
    }
  ],
  logger: r?.logger ?? new WF(),
  protocol: r?.protocol ?? zH,
  protocolSettings: r?.protocolSettings ?? {
    defaultNamespace: "com.amazonaws.cognitoidentityprovider",
    errorTypeRegistries: Oq,
    xmlNamespace: "http://cognito-idp.amazonaws.com/doc/2016-04-18/",
    version: "2016-04-18",
    serviceTarget: "AWSCognitoIdentityProviderService"
  },
  serviceId: r?.serviceId ?? "Cognito Identity Provider",
  urlParser: r?.urlParser ?? pg,
  utf8Decoder: r?.utf8Decoder ?? Ju,
  utf8Encoder: r?.utf8Encoder ?? b1
}), jq = (r) => {
  const e = A$(r), t = () => e().then(w9), n = Hq(r);
  return {
    ...n,
    ...r,
    runtime: "browser",
    defaultsMode: e,
    bodyLengthChecker: r?.bodyLengthChecker ?? iV,
    credentialDefaultProvider: r?.credentialDefaultProvider ?? ((i) => () => Promise.reject(new Error("Credential is missing"))),
    defaultUserAgentProvider: r?.defaultUserAgentProvider ?? f$({ serviceId: n.serviceId, clientVersion: oH.version }),
    maxAttempts: r?.maxAttempts ?? Wf,
    region: r?.region ?? d9("Region is missing"),
    requestHandler: T1.create(r?.requestHandler ?? t),
    retryMode: r?.retryMode ?? (async () => (await t()).retryMode || Cz),
    sha256: r?.sha256 ?? CH,
    streamCollector: r?.streamCollector ?? EH,
    useDualstackEndpoint: r?.useDualstackEndpoint ?? (() => Promise.resolve(w$)),
    useFipsEndpoint: r?.useFipsEndpoint ?? (() => Promise.resolve(x$))
  };
}, Gq = (r) => {
  const e = r.httpAuthSchemes;
  let t = r.httpAuthSchemeProvider, n = r.credentials;
  return {
    setHttpAuthScheme(i) {
      const a = e.findIndex((s) => s.schemeId === i.schemeId);
      a === -1 ? e.push(i) : e.splice(a, 1, i);
    },
    httpAuthSchemes() {
      return e;
    },
    setHttpAuthSchemeProvider(i) {
      t = i;
    },
    httpAuthSchemeProvider() {
      return t;
    },
    setCredentials(i) {
      n = i;
    },
    credentials() {
      return n;
    }
  };
}, qq = (r) => ({
  httpAuthSchemes: r.httpAuthSchemes(),
  httpAuthSchemeProvider: r.httpAuthSchemeProvider(),
  credentials: r.credentials()
}), Wq = (r, e) => {
  const t = Object.assign(C$(r), k9(r), WV(r), Gq(r));
  return e.forEach((n) => n.configure(t)), Object.assign(r, S$(t), T9(t), QV(t), qq(t));
};
class Qq extends h9 {
  config;
  constructor(...[e]) {
    const t = jq(e || {});
    super(t), this.initConfig = t;
    const n = aH(t), i = Kz(n), a = Ez(i), s = v$(a), o = s, l = zV(o), u = iH(l), c = Wq(u, e?.extensions || []);
    this.config = c, this.middlewareStack.use(y9(this.config)), this.middlewareStack.use(c$(this.config)), this.middlewareStack.use(kz(this.config)), this.middlewareStack.use(JV(this.config)), this.middlewareStack.use(Iz(this.config)), this.middlewareStack.use(Rz(this.config)), this.middlewareStack.use(Oz(this.config)), this.middlewareStack.use(Lz(this.config, {
      httpAuthSchemeParametersProvider: tH,
      identityProviderConfigProvider: async (d) => new jz({
        "aws.auth#sigv4": d.credentials
      })
    })), this.middlewareStack.use(Hz(this.config));
  }
  destroy() {
    super.destroy();
  }
}
class YE extends A1.classBuilder().ep(CI).m(function(e, t, n, i) {
  return [oI(n, e.getEndpointParameterInstructions())];
}).s("AWSCognitoIdentityProviderService", "InitiateAuth", {}).n("CognitoIdentityProviderClient", "InitiateAuthCommand").sc(zq).build() {
}
class Yq extends A1.classBuilder().ep(CI).m(function(e, t, n, i) {
  return [oI(n, e.getEndpointParameterInstructions())];
}).s("AWSCognitoIdentityProviderService", "RespondToAuthChallenge", {}).n("CognitoIdentityProviderClient", "RespondToAuthChallengeCommand").sc($q).build() {
}
class Xq {
  init(e, t, n) {
    this.cognitoClient = new Qq({ region: t }), this.spiffRegion = e, this.userPoolClientId = n;
  }
  async generateCode(e) {
    const t = await this.cognitoClient?.send(
      new YE({
        AuthFlow: "CUSTOM_AUTH",
        ClientId: this.userPoolClientId,
        AuthParameters: {
          USERNAME: e
        }
      })
    );
    t?.ChallengeName === "CUSTOM_CHALLENGE" && (this.challengeSession = t.Session);
  }
  async verifyCode(e, t, n) {
    const i = await this.cognitoClient?.send(
      new Yq({
        ClientId: this.userPoolClientId,
        ChallengeName: "CUSTOM_CHALLENGE",
        Session: this.challengeSession,
        ChallengeResponses: {
          USERNAME: e,
          ANSWER: t
        },
        ClientMetadata: {
          partnerId: n,
          environment: (this.spiffRegion || "").toLowerCase()
        }
      })
    );
    return i?.ChallengeName === "CUSTOM_CHALLENGE" && (this.challengeSession = i.Session), i;
  }
  async refreshTokens() {
    const e = localStorage.getItem("cognito-tokens");
    if (!e)
      throw new Error("Failed to find existing tokens.");
    const t = JSON.parse(e);
    return await this.cognitoClient?.send(
      new YE({
        AuthFlow: "REFRESH_TOKEN_AUTH",
        ClientId: this.userPoolClientId,
        AuthParameters: {
          REFRESH_TOKEN: t.RefreshToken || ""
        }
      })
    );
  }
}
const Sf = new Xq();
var Jq = {
  defaultAmount: 0,
  defaultCurrency: "USD",
  defaultPrecision: 2
}, Kq = {
  globalLocale: "en-US",
  globalFormat: "$0,0.00",
  globalRoundingMode: "HALF_EVEN",
  globalFormatRoundingMode: "HALF_AWAY_FROM_ZERO",
  globalExchangeRatesApi: {
    endpoint: void 0,
    headers: void 0,
    propertyPath: void 0
  }
};
function Xf(r) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Xf = function(e) {
    return typeof e;
  } : Xf = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Xf(r);
}
function XE(r) {
  return Zq(r) || eW(r) || tW(r) || rW();
}
function Zq(r) {
  if (Array.isArray(r)) return r;
}
function eW(r) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(r)) return Array.from(r);
}
function tW(r, e) {
  if (r) {
    if (typeof r == "string") return JE(r, e);
    var t = Object.prototype.toString.call(r).slice(8, -1);
    if (t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set") return Array.from(r);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return JE(r, e);
  }
}
function JE(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, n = new Array(e); t < e; t++) n[t] = r[t];
  return n;
}
function rW() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var nW = {
  /**
   * Returns an array of Dinero objects, normalized to the same precision (the highest).
   *
   * @memberof module:Dinero
   * @method
   *
   * @param {Dinero[]} objects - An array of Dinero objects
   *
   * @example
   * // returns an array of Dinero objects
   * // both with a precision of 3
   * // and an amount of 1000
   * Dinero.normalizePrecision([
   *   Dinero({ amount: 100, precision: 2 }),
   *   Dinero({ amount: 1000, precision: 3 })
   * ])
   *
   * @return {Dinero[]}
   */
  normalizePrecision: function(e) {
    var t = e.reduce(function(n, i) {
      return Math.max(n.getPrecision(), i.getPrecision());
    });
    return e.map(function(n) {
      return n.getPrecision() !== t ? n.convertPrecision(t) : n;
    });
  },
  /**
   * Returns the smallest Dinero object from an array of Dinero objects
   *
   * @memberof module:Dinero
   * @method
   *
   * @param {Dinero[]} objects - An array of Dinero objects
   *
   * @example
   * // returns the smallest Dinero object with amount of 500 from an array of Dinero objects with different precisions
   * Dinero.minimum([
   *   Dinero({ amount: 500, precision: 3 }),
   *   Dinero({ amount: 100, precision: 2 })
   * ])
   * @example
   * // returns the smallest Dinero object with amount of 50 from an array of Dinero objects
   * Dinero.minimum([
   *   Dinero({ amount: 50 }),
   *   Dinero({ amount: 100 })
   * ])
   *
   * @return {Dinero[]}
   */
  minimum: function(e) {
    var t = XE(e), n = t[0], i = t.slice(1), a = n;
    return i.forEach(function(s) {
      a = a.lessThan(s) ? a : s;
    }), a;
  },
  /**
   * Returns the biggest Dinero object from an array of Dinero objects
   *
   * @memberof module:Dinero
   * @method
   *
   * @param {Dinero[]} objects - An array of Dinero objects
   *
   * @example
   * // returns the biggest Dinero object with amount of 20, from an array of Dinero objects with different precisions
   * Dinero.maximum([
   *   Dinero({ amount: 20, precision: 2 }),
   *   Dinero({ amount: 150, precision: 3 })
   * ])
   * @example
   * // returns the biggest Dinero object with amount of 100, from an array of Dinero objects
   * Dinero.maximum([
   *   Dinero({ amount: 100 }),
   *   Dinero({ amount: 50 })
   * ])
   *
   * @return {Dinero[]}
   */
  maximum: function(e) {
    var t = XE(e), n = t[0], i = t.slice(1), a = n;
    return i.forEach(function(s) {
      a = a.greaterThan(s) ? a : s;
    }), a;
  }
};
function UI(r) {
  return !isNaN(parseInt(r)) && isFinite(r);
}
function iW(r) {
  return UI(r) && r <= 100 && r >= 0;
}
function aW(r) {
  return r.length > 0 && r.every(function(e) {
    return e >= 0;
  }) && r.some(function(e) {
    return e > 0;
  });
}
function KE(r) {
  return r % 2 === 0;
}
function ZE(r) {
  return UI(r) && !Number.isInteger(r);
}
function sW() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, e = r.toString();
  if (e.indexOf("e-") > 0)
    return parseInt(e.split("e-")[1]);
  var t = e.split(".")[1];
  return t ? t.length : 0;
}
function Ef(r) {
  return Math.abs(r) % 1 === 0.5;
}
function oW(r) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return new Promise(function(t, n) {
    var i = Object.assign(new XMLHttpRequest(), {
      onreadystatechange: function() {
        i.readyState === 4 && (i.status >= 200 && i.status < 400 ? t(JSON.parse(i.responseText)) : n(new Error(i.statusText)));
      },
      onerror: function() {
        n(new Error("Network error"));
      }
    });
    i.open("GET", r, !0), lW(i, e.headers), i.send();
  });
}
function lW(r) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  for (var t in e)
    r.setRequestHeader(t, e[t]);
  return r;
}
function Lf(r) {
  return typeof r > "u";
}
function VI(r) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ".", t = {};
  return Object.entries(r).forEach(function(n) {
    if (Xf(n[1]) === "object") {
      var i = VI(n[1]);
      Object.entries(i).forEach(function(a) {
        t[n[0] + e + a[0]] = a[1];
      });
    } else
      t[n[0]] = n[1];
  }), t;
}
function uW(r) {
  return !!r && (Xf(r) === "object" || typeof r == "function") && typeof r.then == "function";
}
function zI() {
  var r = function(n, i) {
    var a = function(l) {
      return Math.pow(10, sW(l));
    }, s = Math.max(a(n), a(i));
    return Math.round(n * s) * Math.round(i * s) / (s * s);
  }, e = {
    HALF_ODD: function(n) {
      var i = Math.round(n);
      return Ef(n) && KE(i) ? i - 1 : i;
    },
    HALF_EVEN: function(n) {
      var i = Math.round(n);
      return Ef(n) ? KE(i) ? i : i - 1 : i;
    },
    HALF_UP: function(n) {
      return Math.round(n);
    },
    HALF_DOWN: function(n) {
      return Ef(n) ? Math.floor(n) : Math.round(n);
    },
    HALF_TOWARDS_ZERO: function(n) {
      return Ef(n) ? Math.sign(n) * Math.floor(Math.abs(n)) : Math.round(n);
    },
    HALF_AWAY_FROM_ZERO: function(n) {
      return Ef(n) ? Math.sign(n) * Math.ceil(Math.abs(n)) : Math.round(n);
    },
    DOWN: function(n) {
      return Math.floor(n);
    }
  };
  return {
    /**
     * Returns the sum of two numbers.
     * @ignore
     *
     * @param {Number} a - The first number to add.
     * @param {Number} b - The second number to add.
     *
     * @return {Number}
     */
    add: function(n, i) {
      return n + i;
    },
    /**
     * Returns the difference of two numbers.
     * @ignore
     *
     * @param {Number} a - The first number to subtract.
     * @param {Number} b - The second number to subtract.
     *
     * @return {Number}
     */
    subtract: function(n, i) {
      return n - i;
    },
    /**
     * Returns the product of two numbers.
     * @ignore
     *
     * @param {Number} a - The first number to multiply.
     * @param {Number} b - The second number to multiply.
     *
     * @return {Number}
     */
    multiply: function(n, i) {
      return ZE(n) || ZE(i) ? r(n, i) : n * i;
    },
    /**
     * Returns the quotient of two numbers.
     * @ignore
     *
     * @param {Number} a - The first number to divide.
     * @param {Number} b - The second number to divide.
     *
     * @return {Number}
     */
    divide: function(n, i) {
      return n / i;
    },
    /**
     * Returns the remainder of two numbers.
     * @ignore
     *
     * @param  {Number} a - The first number to divide.
     * @param  {Number} b - The second number to divide.
     *
     * @return {Number}
     */
    modulo: function(n, i) {
      return n % i;
    },
    /**
     * Returns a rounded number based off a specific rounding mode.
     * @ignore
     *
     * @param {Number} number - The number to round.
     * @param {String} [roundingMode='HALF_EVEN'] - The rounding mode to use.
     *
     * @returns {Number}
     */
    round: function(n) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "HALF_EVEN";
      return e[i](n);
    }
  };
}
var cW = zI();
function fW(r) {
  var e = /^(?:(\$|USD)?0(?:(,)0)?(\.)?(0+)?|0(?:(,)0)?(\.)?(0+)?\s?(dollar)?)$/gm.exec(r);
  return {
    /**
     * Returns the matches.
     * @ignore
     *
     * @return {Array}
     */
    getMatches: function() {
      return e !== null ? e.slice(1).filter(function(n) {
        return !Lf(n);
      }) : [];
    },
    /**
     * Returns the amount of fraction digits to display.
     * @ignore
     *
     * @return {Number}
     */
    getMinimumFractionDigits: function() {
      var n = function(a) {
        return a === ".";
      };
      return Lf(this.getMatches().find(n)) ? 0 : this.getMatches()[cW.add(this.getMatches().findIndex(n), 1)].split("").length;
    },
    /**
     * Returns the currency display mode.
     * @ignore
     *
     * @return {String}
     */
    getCurrencyDisplay: function() {
      var n = {
        USD: "code",
        dollar: "name",
        $: "symbol"
      };
      return n[this.getMatches().find(function(i) {
        return i === "USD" || i === "dollar" || i === "$";
      })];
    },
    /**
     * Returns the formatting style.
     * @ignore
     *
     * @return {String}
     */
    getStyle: function() {
      return Lf(this.getCurrencyDisplay(this.getMatches())) ? "decimal" : "currency";
    },
    /**
     * Returns whether grouping should be used or not.
     * @ignore
     *
     * @return {Boolean}
     */
    getUseGrouping: function() {
      return !Lf(this.getMatches().find(function(n) {
        return n === ",";
      }));
    }
  };
}
function dW(r) {
  var e = function() {
    var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", a = arguments.length > 1 ? arguments[1] : void 0;
    for (var s in a)
      i = i.replace("{{".concat(s, "}}"), a[s]);
    return i;
  }, t = function(i, a) {
    return oW(e(r.endpoint, {
      from: i,
      to: a
    }), {
      headers: r.headers
    });
  };
  return {
    /**
     * Returns the exchange rate.
     * @ignore
     *
     * @param  {String} from - The base currency.
     * @param  {String} to   - The destination currency.
     *
     * @return {Promise}
     */
    getExchangeRate: function(i, a) {
      return (uW(r.endpoint) ? r.endpoint : t(i, a)).then(function(s) {
        return VI(s)[e(r.propertyPath, {
          from: i,
          to: a
        })];
      });
    }
  };
}
function bd(r, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Error;
  if (!r) throw new t(e);
}
function hW(r) {
  bd(iW(r), "You must provide a numeric value between 0 and 100.", RangeError);
}
function pW(r) {
  bd(aW(r), "You must provide a non-empty array of numeric values greater than 0.", TypeError);
}
function $v(r) {
  bd(Number.isInteger(r), "You must provide an integer.", TypeError);
}
var kn = zI(), gW = function r(e) {
  var t = Object.assign({}, {
    amount: r.defaultAmount,
    currency: r.defaultCurrency,
    precision: r.defaultPrecision
  }, e), n = t.amount, i = t.currency, a = t.precision;
  $v(n), $v(a);
  var s = r.globalLocale, o = r.globalFormat, l = r.globalRoundingMode, u = r.globalFormatRoundingMode, c = Object.assign({}, r.globalExchangeRatesApi), d = function(g) {
    var v = Object.assign({}, Object.assign({}, {
      amount: n,
      currency: i,
      precision: a
    }, g), Object.assign({}, {
      locale: this.locale
    }, g));
    return Object.assign(r({
      amount: v.amount,
      currency: v.currency,
      precision: v.precision
    }), {
      locale: v.locale
    });
  }, f = function(g) {
    bd(this.hasSameCurrency(g), "You must provide a Dinero instance with the same currency.", TypeError);
  };
  return {
    /**
     * Returns the amount.
     *
     * @example
     * // returns 500
     * Dinero({ amount: 500 }).getAmount()
     *
     * @return {Number}
     */
    getAmount: function() {
      return n;
    },
    /**
     * Returns the currency.
     *
     * @example
     * // returns 'EUR'
     * Dinero({ currency: 'EUR' }).getCurrency()
     *
     * @return {String}
     */
    getCurrency: function() {
      return i;
    },
    /**
     * Returns the locale.
     *
     * @example
     * // returns 'fr-FR'
     * Dinero().setLocale('fr-FR').getLocale()
     *
     * @return {String}
     */
    getLocale: function() {
      return this.locale || s;
    },
    /**
     * Returns a new Dinero object with an embedded locale.
     *
     * @param {String} newLocale - The new locale as an {@link http://tools.ietf.org/html/rfc5646 BCP 47 language tag}.
     *
     * @example
     * // Returns a Dinero object with locale 'ja-JP'
     * Dinero().setLocale('ja-JP')
     *
     * @return {Dinero}
     */
    setLocale: function(g) {
      return d.call(this, {
        locale: g
      });
    },
    /**
     * Returns the precision.
     *
     * @example
     * // returns 3
     * Dinero({ precision: 3 }).getPrecision()
     *
     * @return {Number}
     */
    getPrecision: function() {
      return a;
    },
    /**
     * Returns a new Dinero object with a new precision and a converted amount.
     *
     * By default, fractional minor currency units are rounded using the **half to even** rule ([banker's rounding](http://wiki.c2.com/?BankersRounding)).
     * This can be necessary when you need to convert objects to a smaller precision.
     *
     * Rounding *can* lead to accuracy issues as you chain many times. Consider a minimal amount of subsequent conversions for safer results.
     * You can also specify a different `roundingMode` to better fit your needs.
     *
     * @param {Number} newPrecision - The new precision.
     * @param {String} [roundingMode='HALF_EVEN'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
     *
     * @example
     * // Returns a Dinero object with precision 3 and amount 1000
     * Dinero({ amount: 100, precision: 2 }).convertPrecision(3)
     *
     * @throws {TypeError} If `newPrecision` is invalid.
     *
     * @return {Dinero}
     */
    convertPrecision: function(g) {
      var v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : u;
      $v(g);
      var y = this.getPrecision(), A = g > y, x = A ? kn.multiply : kn.divide, k = A ? [g, y] : [y, g], F = Math.pow(10, kn.subtract.apply(kn, k));
      return d.call(this, {
        amount: kn.round(x(this.getAmount(), F), v),
        precision: g
      });
    },
    /**
     * Returns a new Dinero object that represents the sum of this and an other Dinero object.
     *
     * If Dinero objects have a different `precision`, they will be first converted to the highest.
     *
     * @param {Dinero} addend - The Dinero object to add.
     *
     * @example
     * // returns a Dinero object with amount 600
     * Dinero({ amount: 400 }).add(Dinero({ amount: 200 }))
     * @example
     * // returns a Dinero object with amount 144545 and precision 4
     * Dinero({ amount: 400 }).add(Dinero({ amount: 104545, precision: 4 }))
     *
     * @throws {TypeError} If `addend` has a different currency.
     *
     * @return {Dinero}
     */
    add: function(g) {
      f.call(this, g);
      var v = r.normalizePrecision([this, g]);
      return d.call(this, {
        amount: kn.add(v[0].getAmount(), v[1].getAmount()),
        precision: v[0].getPrecision()
      });
    },
    /**
     * Returns a new Dinero object that represents the difference of this and an other Dinero object.
     *
     * If Dinero objects have a different `precision`, they will be first converted to the highest.
     *
     * @param  {Dinero} subtrahend - The Dinero object to subtract.
     *
     * @example
     * // returns a Dinero object with amount 200
     * Dinero({ amount: 400 }).subtract(Dinero({ amount: 200 }))
     * @example
     * // returns a Dinero object with amount 64545 and precision 4
     * Dinero({ amount: 104545, precision: 4 }).subtract(Dinero({ amount: 400 }))
     *
     * @throws {TypeError} If `subtrahend` has a different currency.
     *
     * @return {Dinero}
     */
    subtract: function(g) {
      f.call(this, g);
      var v = r.normalizePrecision([this, g]);
      return d.call(this, {
        amount: kn.subtract(v[0].getAmount(), v[1].getAmount()),
        precision: v[0].getPrecision()
      });
    },
    /**
     * Returns a new Dinero object that represents the multiplied value by the given factor.
     *
     * By default, fractional minor currency units are rounded using the **half to even** rule ([banker's rounding](http://wiki.c2.com/?BankersRounding)).
     *
     * Rounding *can* lead to accuracy issues as you chain many times. Consider a minimal amount of subsequent calculations for safer results.
     * You can also specify a different `roundingMode` to better fit your needs.
     *
     * @param  {Number} multiplier - The factor to multiply by.
     * @param  {String} [roundingMode='HALF_EVEN'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
     *
     * @example
     * // returns a Dinero object with amount 1600
     * Dinero({ amount: 400 }).multiply(4)
     * @example
     * // returns a Dinero object with amount 800
     * Dinero({ amount: 400 }).multiply(2.001)
     * @example
     * // returns a Dinero object with amount 801
     * Dinero({ amount: 400 }).multiply(2.00125, 'HALF_UP')
     *
     * @return {Dinero}
     */
    multiply: function(g) {
      var v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : l;
      return d.call(this, {
        amount: kn.round(kn.multiply(this.getAmount(), g), v)
      });
    },
    /**
     * Returns a new Dinero object that represents the divided value by the given factor.
     *
     * By default, fractional minor currency units are rounded using the **half to even** rule ([banker's rounding](http://wiki.c2.com/?BankersRounding)).
     *
     * Rounding *can* lead to accuracy issues as you chain many times. Consider a minimal amount of subsequent calculations for safer results.
     * You can also specify a different `roundingMode` to better fit your needs.
     *
     * As rounding is applied, precision may be lost in the process. If you want to accurately split a Dinero object, use {@link module:Dinero~allocate allocate} instead.
     *
     * @param  {Number} divisor - The factor to divide by.
     * @param  {String} [roundingMode='HALF_EVEN'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
     *
     * @example
     * // returns a Dinero object with amount 100
     * Dinero({ amount: 400 }).divide(4)
     * @example
     * // returns a Dinero object with amount 52
     * Dinero({ amount: 105 }).divide(2)
     * @example
     * // returns a Dinero object with amount 53
     * Dinero({ amount: 105 }).divide(2, 'HALF_UP')
     *
     * @return {Dinero}
     */
    divide: function(g) {
      var v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : l;
      return d.call(this, {
        amount: kn.round(kn.divide(this.getAmount(), g), v)
      });
    },
    /**
     * Returns a new Dinero object that represents a percentage of this.
     *
     * As rounding is applied, precision may be lost in the process. If you want to accurately split a Dinero object, use {@link module:Dinero~allocate allocate} instead.
     *
     * @param  {Number} percentage - The percentage to extract (between 0 and 100).
     * @param  {String} [roundingMode='HALF_EVEN'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
     *
     * @example
     * // returns a Dinero object with amount 5000
     * Dinero({ amount: 10000 }).percentage(50)
     * @example
     * // returns a Dinero object with amount 29
     * Dinero({ amount: 57 }).percentage(50, "HALF_ODD")
     *
     * @throws {RangeError} If `percentage` is out of range.
     *
     * @return {Dinero}
     */
    percentage: function(g) {
      var v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : l;
      return hW(g), this.multiply(kn.divide(g, 100), v);
    },
    /**
     * Allocates the amount of a Dinero object according to a list of ratios.
     *
     * Sometimes you need to split monetary values but percentages can't cut it without adding or losing pennies.
     * A good example is invoicing: let's say you need to bill $1,000.03 and you want a 50% downpayment.
     * If you use {@link module:Dinero~percentage percentage}, you'll get an accurate Dinero object but the amount won't be billable: you can't split a penny.
     * If you round it, you'll bill a penny extra.
     * With {@link module:Dinero~allocate allocate}, you can split a monetary amount then distribute the remainder as evenly as possible.
     *
     * You can use percentage style or ratio style for `ratios`: `[25, 75]` and `[1, 3]` will do the same thing.
     *
     * Since v1.8.0, you can use zero ratios (such as [0, 50, 50]). If there's a remainder to distribute, zero ratios are skipped and return a Dinero object with amount zero.
     *
     * @param  {Number[]} ratios - The ratios to allocate the money to.
     *
     * @example
     * // returns an array of two Dinero objects
     * // the first one with an amount of 502
     * // the second one with an amount of 501
     * Dinero({ amount: 1003 }).allocate([50, 50])
     * @example
     * // returns an array of two Dinero objects
     * // the first one with an amount of 25
     * // the second one with an amount of 75
     * Dinero({ amount: 100 }).allocate([1, 3])
     * @example
     * // since version 1.8.0
     * // returns an array of three Dinero objects
     * // the first one with an amount of 0
     * // the second one with an amount of 502
     * // the third one with an amount of 501
     * Dinero({ amount: 1003 }).allocate([0, 50, 50])
     *
     * @throws {TypeError} If ratios are invalid.
     *
     * @return {Dinero[]}
     */
    allocate: function(g) {
      var v = this;
      pW(g);
      for (var y = g.reduce(function(F, S) {
        return kn.add(F, S);
      }), A = this.getAmount(), x = g.map(function(F) {
        var S = Math.floor(kn.divide(kn.multiply(v.getAmount(), F), y));
        return A = kn.subtract(A, S), d.call(v, {
          amount: S
        });
      }), k = 0; A > 0; )
        g[k] > 0 && (x[k] = x[k].add(d.call(this, {
          amount: 1
        })), A = kn.subtract(A, 1)), k += 1;
      return x;
    },
    /**
     * Returns a Promise containing a new Dinero object converted to another currency.
     *
     * You have two options to provide the exchange rates:
     *
     * 1. **Use an exchange rate REST API, and let Dinero handle the fetching and conversion.**
     *   This is a simple option if you have access to an exchange rate REST API and want Dinero to do the rest.
     * 2. **Fetch the exchange rates on your own and provide them directly.**
     *   This is useful if you're fetching your rates from somewhere else (a file, a database), use a different protocol or query language than REST (SOAP, GraphQL) or want to fetch rates once and cache them instead of making new requests every time.
     *
     * **If you want to use a REST API**, you must provide a third-party endpoint yourself. Dinero doesn't come bundled with an exchange rates endpoint.
     *
     * Here are some exchange rate APIs you can use:
     *
     * * [Fixer](https://fixer.io)
     * * [Open Exchange Rates](https://openexchangerates.org)
     * * [Coinbase](https://api.coinbase.com/v2/exchange-rates)
     * * More [foreign](https://github.com/toddmotto/public-apis#currency-exchange) and [crypto](https://github.com/toddmotto/public-apis#cryptocurrency) exchange rate APIs.
     *
     * **If you want to fetch your own rates and provide them directly**, you need to pass a promise that resolves to the exchanges rates.
     *
     * In both cases, you need to specify at least:
     *
     * * a **destination currency**: the currency in which you want to convert your Dinero object. You can specify it with `currency`.
     * * an **endpoint**: the API URL to query exchange rates, with parameters, or a promise that resolves to the exchange rates. You can specify it with `options.endpoint`.
     * * a **property path**: the path to access the wanted rate in your API's JSON response (or the custom promise's payload). For example, with a response of:
     * ```json
     * {
     *     "data": {
     *       "base": "USD",
     *       "destination": "EUR",
     *       "rate": "0.827728919"
     *     }
     * }
     * ```
     * Then the property path is `'data.rate'`. You can specify it with `options.propertyPath`.
     *
     * The base currency (the one of your Dinero object) and the destination currency can be used as "merge tags" with the mustache syntax, respectively `{{from}}` and `{{to}}`.
     * You can use these tags to refer to these values in `options.endpoint` and `options.propertyPath`.
     *
     * For example, if you need to specify the base currency as a query parameter, you can do the following:
     *
     * ```js
     * {
     *   endpoint: 'https://yourexchangerates.api/latest?base={{from}}'
     * }
     * ```
     *
     * @param  {String} currency - The destination currency, expressed as an {@link https://en.wikipedia.org/wiki/ISO_4217#Active_codes ISO 4217 currency code}.
     * @param  {(String|Promise)} options.endpoint - The API endpoint to retrieve exchange rates. You can substitute this with a promise that resolves to the exchanges rates if you already have them.
     * @param  {String} [options.propertyPath='rates.{{to}}'] - The property path to the rate.
     * @param  {Object} [options.headers] - The HTTP headers to provide, if needed.
     * @param  {String} [options.roundingMode='HALF_EVEN'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
     *
     * @example
     * // your global API parameters
     * Dinero.globalExchangeRatesApi = { ... }
     *
     * // returns a Promise containing a Dinero object with the destination currency
     * // and the initial amount converted to the new currency.
     * Dinero({ amount: 500 }).convert('EUR')
     * @example
     * // returns a Promise containing a Dinero object,
     * // with specific API parameters and rounding mode for this specific instance.
     * Dinero({ amount: 500 })
     *   .convert('XBT', {
     *     endpoint: 'https://yourexchangerates.api/latest?base={{from}}',
     *     propertyPath: 'data.rates.{{to}}',
     *     headers: {
     *       'user-key': 'xxxxxxxxx'
     *     },
     *     roundingMode: 'HALF_UP'
     *   })
     * @example
     * // usage with exchange rates provided as a custom promise
     * // using the default `propertyPath` format (so it doesn't have to be specified)
     * const rates = {
     *   rates: {
     *     EUR: 0.81162
     *   }
     * }
     *
     * Dinero({ amount: 500 })
     *   .convert('EUR', {
     *     endpoint: new Promise(resolve => resolve(rates))
     *   })
     * @example
     * // usage with Promise.prototype.then and Promise.prototype.catch
     * Dinero({ amount: 500 })
     *   .convert('EUR')
     *   .then(dinero => {
     *     dinero.getCurrency() // returns 'EUR'
     *   })
     *   .catch(err => {
     *     // handle errors
     *   })
     * @example
     * // usage with async/await
     * (async () => {
     *   const price = await Dinero({ amount: 500 }).convert('EUR')
     *   price.getCurrency() // returns 'EUR'
     * })()
     *
     * @return {Promise}
     */
    convert: function(g) {
      var v = this, y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, A = y.endpoint, x = A === void 0 ? c.endpoint : A, k = y.propertyPath, F = k === void 0 ? c.propertyPath || "rates.{{to}}" : k, S = y.headers, R = S === void 0 ? c.headers : S, M = y.roundingMode, j = M === void 0 ? l : M, G = Object.assign({}, {
        endpoint: x,
        propertyPath: F,
        headers: R,
        roundingMode: j
      });
      return dW(G).getExchangeRate(this.getCurrency(), g).then(function(ie) {
        return bd(!Lf(ie), 'No rate was found for the destination currency "'.concat(g, '".'), TypeError), d.call(v, {
          amount: kn.round(kn.multiply(v.getAmount(), parseFloat(ie)), G.roundingMode),
          currency: g
        });
      });
    },
    /**
     * Checks whether the value represented by this object equals to the other.
     *
     * @param  {Dinero} comparator - The Dinero object to compare to.
     *
     * @example
     * // returns true
     * Dinero({ amount: 500, currency: 'EUR' }).equalsTo(Dinero({ amount: 500, currency: 'EUR' }))
     * @example
     * // returns false
     * Dinero({ amount: 500, currency: 'EUR' }).equalsTo(Dinero({ amount: 800, currency: 'EUR' }))
     * @example
     * // returns false
     * Dinero({ amount: 500, currency: 'USD' }).equalsTo(Dinero({ amount: 500, currency: 'EUR' }))
     * @example
     * // returns false
     * Dinero({ amount: 500, currency: 'USD' }).equalsTo(Dinero({ amount: 800, currency: 'EUR' }))
     * @example
     * // returns true
     * Dinero({ amount: 1000, currency: 'EUR', precision: 2 }).equalsTo(Dinero({ amount: 10000, currency: 'EUR', precision: 3 }))
     * @example
     * // returns false
     * Dinero({ amount: 10000, currency: 'EUR', precision: 2 }).equalsTo(Dinero({ amount: 10000, currency: 'EUR', precision: 3 }))
     *
     * @return {Boolean}
     */
    equalsTo: function(g) {
      return this.hasSameAmount(g) && this.hasSameCurrency(g);
    },
    /**
     * Checks whether the value represented by this object is less than the other.
     *
     * @param  {Dinero} comparator - The Dinero object to compare to.
     *
     * @example
     * // returns true
     * Dinero({ amount: 500 }).lessThan(Dinero({ amount: 800 }))
     * @example
     * // returns false
     * Dinero({ amount: 800 }).lessThan(Dinero({ amount: 500 }))
     * @example
     * // returns true
     * Dinero({ amount: 5000, precision: 3 }).lessThan(Dinero({ amount: 800 }))
     * @example
     * // returns false
     * Dinero({ amount: 800 }).lessThan(Dinero({ amount: 5000, precision: 3 }))
     *
     * @throws {TypeError} If `comparator` has a different currency.
     *
     * @return {Boolean}
     */
    lessThan: function(g) {
      f.call(this, g);
      var v = r.normalizePrecision([this, g]);
      return v[0].getAmount() < v[1].getAmount();
    },
    /**
     * Checks whether the value represented by this object is less than or equal to the other.
     *
     * @param  {Dinero} comparator - The Dinero object to compare to.
     *
     * @example
     * // returns true
     * Dinero({ amount: 500 }).lessThanOrEqual(Dinero({ amount: 800 }))
     * @example
     * // returns true
     * Dinero({ amount: 500 }).lessThanOrEqual(Dinero({ amount: 500 }))
     * @example
     * // returns false
     * Dinero({ amount: 500 }).lessThanOrEqual(Dinero({ amount: 300 }))
     * @example
     * // returns true
     * Dinero({ amount: 5000, precision: 3 }).lessThanOrEqual(Dinero({ amount: 800 }))
     * @example
     * // returns true
     * Dinero({ amount: 5000, precision: 3 }).lessThanOrEqual(Dinero({ amount: 500 }))
     * @example
     * // returns false
     * Dinero({ amount: 800 }).lessThanOrEqual(Dinero({ amount: 5000, precision: 3 }))
     *
     * @throws {TypeError} If `comparator` has a different currency.
     *
     * @return {Boolean}
     */
    lessThanOrEqual: function(g) {
      f.call(this, g);
      var v = r.normalizePrecision([this, g]);
      return v[0].getAmount() <= v[1].getAmount();
    },
    /**
     * Checks whether the value represented by this object is greater than the other.
     *
     * @param  {Dinero} comparator - The Dinero object to compare to.
     *
     * @example
     * // returns false
     * Dinero({ amount: 500 }).greaterThan(Dinero({ amount: 800 }))
     * @example
     * // returns true
     * Dinero({ amount: 800 }).greaterThan(Dinero({ amount: 500 }))
     * @example
     * // returns true
     * Dinero({ amount: 800 }).greaterThan(Dinero({ amount: 5000, precision: 3 }))
     * @example
     * // returns false
     * Dinero({ amount: 5000, precision: 3 }).greaterThan(Dinero({ amount: 800 }))
     *
     * @throws {TypeError} If `comparator` has a different currency.
     *
     * @return {Boolean}
     */
    greaterThan: function(g) {
      f.call(this, g);
      var v = r.normalizePrecision([this, g]);
      return v[0].getAmount() > v[1].getAmount();
    },
    /**
     * Checks whether the value represented by this object is greater than or equal to the other.
     *
     * @param  {Dinero} comparator - The Dinero object to compare to.
     *
     * @example
     * // returns true
     * Dinero({ amount: 500 }).greaterThanOrEqual(Dinero({ amount: 300 }))
     * @example
     * // returns true
     * Dinero({ amount: 500 }).greaterThanOrEqual(Dinero({ amount: 500 }))
     * @example
     * // returns false
     * Dinero({ amount: 500 }).greaterThanOrEqual(Dinero({ amount: 800 }))
     * @example
     * // returns true
     * Dinero({ amount: 800 }).greaterThanOrEqual(Dinero({ amount: 5000, precision: 3 }))
     * @example
     * // returns true
     * Dinero({ amount: 500 }).greaterThanOrEqual(Dinero({ amount: 5000, precision: 3 }))
     * @example
     * // returns false
     * Dinero({ amount: 5000, precision: 3 }).greaterThanOrEqual(Dinero({ amount: 800 }))
     *
     * @throws {TypeError} If `comparator` has a different currency.
     *
     * @return {Boolean}
     */
    greaterThanOrEqual: function(g) {
      f.call(this, g);
      var v = r.normalizePrecision([this, g]);
      return v[0].getAmount() >= v[1].getAmount();
    },
    /**
     * Checks if the value represented by this object is zero.
     *
     * @example
     * // returns true
     * Dinero({ amount: 0 }).isZero()
     * @example
     * // returns false
     * Dinero({ amount: 100 }).isZero()
     *
     * @return {Boolean}
     */
    isZero: function() {
      return this.getAmount() === 0;
    },
    /**
     * Checks if the value represented by this object is positive.
     *
     * @example
     * // returns false
     * Dinero({ amount: -10 }).isPositive()
     * @example
     * // returns true
     * Dinero({ amount: 10 }).isPositive()
     * @example
     * // returns true
     * Dinero({ amount: 0 }).isPositive()
     *
     * @return {Boolean}
     */
    isPositive: function() {
      return this.getAmount() >= 0;
    },
    /**
     * Checks if the value represented by this object is negative.
     *
     * @example
     * // returns true
     * Dinero({ amount: -10 }).isNegative()
     * @example
     * // returns false
     * Dinero({ amount: 10 }).isNegative()
     * @example
     * // returns false
     * Dinero({ amount: 0 }).isNegative()
     *
     * @return {Boolean}
     */
    isNegative: function() {
      return this.getAmount() < 0;
    },
    /**
     * Checks if this has minor currency units.
     * Deprecates {@link module:Dinero~hasCents hasCents}.
     *
     * @example
     * // returns false
     * Dinero({ amount: 1100 }).hasSubUnits()
     * @example
     * // returns true
     * Dinero({ amount: 1150 }).hasSubUnits()
     *
     * @return {Boolean}
     */
    hasSubUnits: function() {
      return kn.modulo(this.getAmount(), Math.pow(10, a)) !== 0;
    },
    /**
     * Checks if this has minor currency units.
     *
     * @deprecated since version 1.4.0, will be removed in 2.0.0
     * Use {@link module:Dinero~hasSubUnits hasSubUnits} instead.
     *
     * @example
     * // returns false
     * Dinero({ amount: 1100 }).hasCents()
     * @example
     * // returns true
     * Dinero({ amount: 1150 }).hasCents()
     *
     * @return {Boolean}
     */
    hasCents: function() {
      return kn.modulo(this.getAmount(), Math.pow(10, a)) !== 0;
    },
    /**
     * Checks whether the currency represented by this object equals to the other.
     *
     * @param  {Dinero}  comparator - The Dinero object to compare to.
     *
     * @example
     * // returns true
     * Dinero({ amount: 2000, currency: 'EUR' }).hasSameCurrency(Dinero({ amount: 1000, currency: 'EUR' }))
     * @example
     * // returns false
     * Dinero({ amount: 1000, currency: 'EUR' }).hasSameCurrency(Dinero({ amount: 1000, currency: 'USD' }))
     *
     * @return {Boolean}
     */
    hasSameCurrency: function(g) {
      return this.getCurrency() === g.getCurrency();
    },
    /**
     * Checks whether the amount represented by this object equals to the other.
     *
     * @param  {Dinero}  comparator - The Dinero object to compare to.
     *
     * @example
     * // returns true
     * Dinero({ amount: 1000, currency: 'EUR' }).hasSameAmount(Dinero({ amount: 1000 }))
     * @example
     * // returns false
     * Dinero({ amount: 2000, currency: 'EUR' }).hasSameAmount(Dinero({ amount: 1000, currency: 'EUR' }))
     * @example
     * // returns true
     * Dinero({ amount: 1000, currency: 'EUR', precision: 2 }).hasSameAmount(Dinero({ amount: 10000, precision: 3 }))
     * @example
     * // returns false
     * Dinero({ amount: 10000, currency: 'EUR', precision: 2 }).hasSameAmount(Dinero({ amount: 10000, precision: 3 }))
     *
     * @return {Boolean}
     */
    hasSameAmount: function(g) {
      var v = r.normalizePrecision([this, g]);
      return v[0].getAmount() === v[1].getAmount();
    },
    /**
     * Returns this object formatted as a string.
     *
     * The format is a mask which defines how the output string will be formatted.
     * It defines whether to display a currency, in what format, how many fraction digits to display and whether to use grouping separators.
     * The output is formatted according to the applying locale.
     *
     * Object                       | Format            | String
     * :--------------------------- | :---------------- | :---
     * `Dinero({ amount: 500050 })` | `'$0,0.00'`       | $5,000.50
     * `Dinero({ amount: 500050 })` | `'$0,0'`          | $5,001
     * `Dinero({ amount: 500050 })` | `'$0'`            | $5001
     * `Dinero({ amount: 500050 })` | `'$0.0'`          | $5000.5
     * `Dinero({ amount: 500050 })` | `'USD0,0.0'`      | USD5,000.5
     * `Dinero({ amount: 500050 })` | `'0,0.0 dollar'`  | 5,000.5 dollars
     *
     * Don't try to substitute the `$` sign or the `USD` code with your target currency, nor adapt the format string to the exact format you want.
     * The format is a mask which defines a pattern and returns a valid, localized currency string.
     * If you want to display the object in a custom way, either use {@link module:Dinero~getAmount getAmount}, {@link module:Dinero~toUnit toUnit} or {@link module:Dinero~toRoundedUnit toRoundedUnit} and manipulate the output string as you wish.
     *
     * {@link module:Dinero~toFormat toFormat} wraps around `Number.prototype.toLocaleString`. For that reason, **format will vary depending on how it's implemented in the end user's environment**.
     *
     * You can also use `toLocaleString` directly:
     * `Dinero().toRoundedUnit(digits, roundingMode).toLocaleString(locale, options)`.
     *
     * By default, amounts are rounded using the **half away from zero** rule ([commercial rounding](https://en.wikipedia.org/wiki/Rounding#Round_half_away_from_zero)).
     * You can also specify a different `roundingMode` to better fit your needs.
     *
     * @param  {String} [format='$0,0.00'] - The format mask to format to.
     * @param  {String} [roundingMode='HALF_AWAY_FROM_ZERO'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
     *
     * @example
     * // returns $2,000
     * Dinero({ amount: 200000 }).toFormat('$0,0')
     * @example
     * // returns €50.5
     * Dinero({ amount: 5050, currency: 'EUR' }).toFormat('$0,0.0')
     * @example
     * // returns 100 euros
     * Dinero({ amount: 10000, currency: 'EUR' }).setLocale('fr-FR').toFormat('0,0 dollar')
     * @example
     * // returns 2000
     * Dinero({ amount: 200000, currency: 'EUR' }).toFormat()
     * @example
     * // returns $10
     * Dinero({ amount: 1050 }).toFormat('$0', 'HALF_EVEN')
     *
     * @return {String}
     */
    toFormat: function() {
      var g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : o, v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : u, y = fW(g);
      return this.toRoundedUnit(y.getMinimumFractionDigits(), v).toLocaleString(this.getLocale(), {
        currencyDisplay: y.getCurrencyDisplay(),
        useGrouping: y.getUseGrouping(),
        minimumFractionDigits: y.getMinimumFractionDigits(),
        style: y.getStyle(),
        currency: this.getCurrency()
      });
    },
    /**
     * Returns the amount represented by this object in units.
     *
     * @example
     * // returns 10.5
     * Dinero({ amount: 1050 }).toUnit()
     * @example
     * // returns 10.545
     * Dinero({ amount: 10545, precision: 3 }).toUnit()
     *
     * @return {Number}
     */
    toUnit: function() {
      return kn.divide(this.getAmount(), Math.pow(10, a));
    },
    /**
     * Returns the amount represented by this object in rounded units.
     *
     * By default, the method uses the **half away from zero** rule ([commercial rounding](https://en.wikipedia.org/wiki/Rounding#Round_half_away_from_zero)).
     * You can also specify a different `roundingMode` to better fit your needs.
     *
     * @example
     * // returns 10.6
     * Dinero({ amount: 1055 }).toRoundedUnit(1)
     * @example
     * // returns 10
     * Dinero({ amount: 1050 }).toRoundedUnit(0, 'HALF_EVEN')
     *
     * @param  {Number} digits - The number of fraction digits to round to.
     * @param  {String} [roundingMode='HALF_AWAY_FROM_ZERO'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
     *
     * @return {Number}
     */
    toRoundedUnit: function(g) {
      var v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : u, y = Math.pow(10, g);
      return kn.divide(kn.round(kn.multiply(this.toUnit(), y), v), y);
    },
    /**
     * Returns the object's data as an object literal.
     *
     * @example
     * // returns { amount: 500, currency: 'EUR', precision: 2 }
     * Dinero({ amount: 500, currency: 'EUR', precision: 2 }).toObject()
     *
     * @return {Object}
     */
    toObject: function() {
      return {
        amount: n,
        currency: i,
        precision: a
      };
    },
    /**
     * Returns the object's data as an object literal.
     *
     * Alias of {@link module:Dinero~toObject toObject}.
     * It is defined so that calling `JSON.stringify` on a Dinero object will automatically extract the relevant data.
     *
     * @example
     * // returns '{"amount":500,"currency":"EUR","precision":2}'
     * JSON.stringify(Dinero({ amount: 500, currency: 'EUR', precision: 2 }))
     *
     * @return {Object}
     */
    toJSON: function() {
      return this.toObject();
    }
  };
}, mW = Object.assign(gW, Jq, Kq, nW), Qa = {}, Hv, e2;
function vW() {
  if (e2) return Hv;
  e2 = 1;
  function r(t) {
    return t;
  }
  function e(t, a, s) {
    for (var a = a || r, s = s || t, o = 0, l = t.length; o < l; o += 1)
      if (a.call(s, t[o], o)) return t[o];
  }
  return Hv = e, Hv;
}
var jv = { exports: {} }, t2;
function yW() {
  if (t2) return jv.exports;
  t2 = 1;
  var r = jv.exports = function(e, t) {
    if (typeof e == "function" || t)
      return r.by(e, t);
    for (var n = {
      object: [],
      function: [],
      string: {},
      number: {},
      boolean: {},
      undefined: {}
    }, i = [], a = 0; a < e.length; a++) {
      var s = e[a], o = s === "__proto__" ? n.objects : n[typeof s] || n.objects;
      Array.isArray(o) ? o.indexOf(s) < 0 && (o.push(s), i.push(s)) : Object.hasOwnProperty.call(o, s) || (o[s] = !0, i.push(s));
    }
    return i;
  };
  return r.by = function(e, t) {
    if (typeof e == "function") {
      var n = t;
      t = e, e = n;
    }
    for (var i = [], a = 0; a < e.length; a++) {
      for (var s = e[a], o = !1, l = 0; l < i.length; l++) {
        var u = i[l];
        if (t.call(i, s, u)) {
          o = !0;
          break;
        }
      }
      o || i.push(s);
    }
    return i;
  }, jv.exports;
}
var Gv, r2;
function AW() {
  return r2 || (r2 = 1, Gv = [
    {
      code: "AED",
      number: "784",
      digits: 2,
      currency: "UAE Dirham",
      countries: [
        "United Arab Emirates (The)"
      ]
    },
    {
      code: "AFN",
      number: "971",
      digits: 2,
      currency: "Afghani",
      countries: [
        "Afghanistan"
      ]
    },
    {
      code: "ALL",
      number: "008",
      digits: 2,
      currency: "Lek",
      countries: [
        "Albania"
      ]
    },
    {
      code: "AMD",
      number: "051",
      digits: 2,
      currency: "Armenian Dram",
      countries: [
        "Armenia"
      ]
    },
    {
      code: "ANG",
      number: "532",
      digits: 2,
      currency: "Netherlands Antillean Guilder",
      countries: [
        "Curaçao",
        "Sint Maarten (Dutch Part)"
      ]
    },
    {
      code: "AOA",
      number: "973",
      digits: 2,
      currency: "Kwanza",
      countries: [
        "Angola"
      ]
    },
    {
      code: "ARS",
      number: "032",
      digits: 2,
      currency: "Argentine Peso",
      countries: [
        "Argentina"
      ]
    },
    {
      code: "AUD",
      number: "036",
      digits: 2,
      currency: "Australian Dollar",
      countries: [
        "Australia",
        "Christmas Island",
        "Cocos (Keeling) Islands (The)",
        "Heard Island and Mcdonald Islands",
        "Kiribati",
        "Nauru",
        "Norfolk Island",
        "Tuvalu"
      ]
    },
    {
      code: "AWG",
      number: "533",
      digits: 2,
      currency: "Aruban Florin",
      countries: [
        "Aruba"
      ]
    },
    {
      code: "AZN",
      number: "944",
      digits: 2,
      currency: "Azerbaijan Manat",
      countries: [
        "Azerbaijan"
      ]
    },
    {
      code: "BAM",
      number: "977",
      digits: 2,
      currency: "Convertible Mark",
      countries: [
        "Bosnia and Herzegovina"
      ]
    },
    {
      code: "BBD",
      number: "052",
      digits: 2,
      currency: "Barbados Dollar",
      countries: [
        "Barbados"
      ]
    },
    {
      code: "BDT",
      number: "050",
      digits: 2,
      currency: "Taka",
      countries: [
        "Bangladesh"
      ]
    },
    {
      code: "BGN",
      number: "975",
      digits: 2,
      currency: "Bulgarian Lev",
      countries: [
        "Bulgaria"
      ]
    },
    {
      code: "BHD",
      number: "048",
      digits: 3,
      currency: "Bahraini Dinar",
      countries: [
        "Bahrain"
      ]
    },
    {
      code: "BIF",
      number: "108",
      digits: 0,
      currency: "Burundi Franc",
      countries: [
        "Burundi"
      ]
    },
    {
      code: "BMD",
      number: "060",
      digits: 2,
      currency: "Bermudian Dollar",
      countries: [
        "Bermuda"
      ]
    },
    {
      code: "BND",
      number: "096",
      digits: 2,
      currency: "Brunei Dollar",
      countries: [
        "Brunei Darussalam"
      ]
    },
    {
      code: "BOB",
      number: "068",
      digits: 2,
      currency: "Boliviano",
      countries: [
        "Bolivia (Plurinational State Of)"
      ]
    },
    {
      code: "BOV",
      number: "984",
      digits: 2,
      currency: "Mvdol",
      countries: [
        "Bolivia (Plurinational State Of)"
      ]
    },
    {
      code: "BRL",
      number: "986",
      digits: 2,
      currency: "Brazilian Real",
      countries: [
        "Brazil"
      ]
    },
    {
      code: "BSD",
      number: "044",
      digits: 2,
      currency: "Bahamian Dollar",
      countries: [
        "Bahamas (The)"
      ]
    },
    {
      code: "BTN",
      number: "064",
      digits: 2,
      currency: "Ngultrum",
      countries: [
        "Bhutan"
      ]
    },
    {
      code: "BWP",
      number: "072",
      digits: 2,
      currency: "Pula",
      countries: [
        "Botswana"
      ]
    },
    {
      code: "BYN",
      number: "933",
      digits: 2,
      currency: "Belarusian Ruble",
      countries: [
        "Belarus"
      ]
    },
    {
      code: "BZD",
      number: "084",
      digits: 2,
      currency: "Belize Dollar",
      countries: [
        "Belize"
      ]
    },
    {
      code: "CAD",
      number: "124",
      digits: 2,
      currency: "Canadian Dollar",
      countries: [
        "Canada"
      ]
    },
    {
      code: "CDF",
      number: "976",
      digits: 2,
      currency: "Congolese Franc",
      countries: [
        "Congo (The Democratic Republic of The)"
      ]
    },
    {
      code: "CHE",
      number: "947",
      digits: 2,
      currency: "WIR Euro",
      countries: [
        "Switzerland"
      ]
    },
    {
      code: "CHF",
      number: "756",
      digits: 2,
      currency: "Swiss Franc",
      countries: [
        "Liechtenstein",
        "Switzerland"
      ]
    },
    {
      code: "CHW",
      number: "948",
      digits: 2,
      currency: "WIR Franc",
      countries: [
        "Switzerland"
      ]
    },
    {
      code: "CLF",
      number: "990",
      digits: 4,
      currency: "Unidad de Fomento",
      countries: [
        "Chile"
      ]
    },
    {
      code: "CLP",
      number: "152",
      digits: 0,
      currency: "Chilean Peso",
      countries: [
        "Chile"
      ]
    },
    {
      code: "CNY",
      number: "156",
      digits: 2,
      currency: "Yuan Renminbi",
      countries: [
        "China"
      ]
    },
    {
      code: "COP",
      number: "170",
      digits: 2,
      currency: "Colombian Peso",
      countries: [
        "Colombia"
      ]
    },
    {
      code: "COU",
      number: "970",
      digits: 2,
      currency: "Unidad de Valor Real",
      countries: [
        "Colombia"
      ]
    },
    {
      code: "CRC",
      number: "188",
      digits: 2,
      currency: "Costa Rican Colon",
      countries: [
        "Costa Rica"
      ]
    },
    {
      code: "CUC",
      number: "931",
      digits: 2,
      currency: "Peso Convertible",
      countries: [
        "Cuba"
      ]
    },
    {
      code: "CUP",
      number: "192",
      digits: 2,
      currency: "Cuban Peso",
      countries: [
        "Cuba"
      ]
    },
    {
      code: "CVE",
      number: "132",
      digits: 2,
      currency: "Cabo Verde Escudo",
      countries: [
        "Cabo Verde"
      ]
    },
    {
      code: "CZK",
      number: "203",
      digits: 2,
      currency: "Czech Koruna",
      countries: [
        "Czechia"
      ]
    },
    {
      code: "DJF",
      number: "262",
      digits: 0,
      currency: "Djibouti Franc",
      countries: [
        "Djibouti"
      ]
    },
    {
      code: "DKK",
      number: "208",
      digits: 2,
      currency: "Danish Krone",
      countries: [
        "Denmark",
        "Faroe Islands (The)",
        "Greenland"
      ]
    },
    {
      code: "DOP",
      number: "214",
      digits: 2,
      currency: "Dominican Peso",
      countries: [
        "Dominican Republic (The)"
      ]
    },
    {
      code: "DZD",
      number: "012",
      digits: 2,
      currency: "Algerian Dinar",
      countries: [
        "Algeria"
      ]
    },
    {
      code: "EGP",
      number: "818",
      digits: 2,
      currency: "Egyptian Pound",
      countries: [
        "Egypt"
      ]
    },
    {
      code: "ERN",
      number: "232",
      digits: 2,
      currency: "Nakfa",
      countries: [
        "Eritrea"
      ]
    },
    {
      code: "ETB",
      number: "230",
      digits: 2,
      currency: "Ethiopian Birr",
      countries: [
        "Ethiopia"
      ]
    },
    {
      code: "EUR",
      number: "978",
      digits: 2,
      currency: "Euro",
      countries: [
        "Åland Islands",
        "Andorra",
        "Austria",
        "Belgium",
        "Croatia",
        "Cyprus",
        "Estonia",
        "European Union",
        "Finland",
        "France",
        "French Guiana",
        "French Southern Territories (The)",
        "Germany",
        "Greece",
        "Guadeloupe",
        "Holy See (The)",
        "Ireland",
        "Italy",
        "Latvia",
        "Lithuania",
        "Luxembourg",
        "Malta",
        "Martinique",
        "Mayotte",
        "Monaco",
        "Montenegro",
        "Netherlands (The)",
        "Portugal",
        "Réunion",
        "Saint Barthélemy",
        "Saint Martin (French Part)",
        "Saint Pierre and Miquelon",
        "San Marino",
        "Slovakia",
        "Slovenia",
        "Spain"
      ]
    },
    {
      code: "FJD",
      number: "242",
      digits: 2,
      currency: "Fiji Dollar",
      countries: [
        "Fiji"
      ]
    },
    {
      code: "FKP",
      number: "238",
      digits: 2,
      currency: "Falkland Islands Pound",
      countries: [
        "Falkland Islands (The) [Malvinas]"
      ]
    },
    {
      code: "GBP",
      number: "826",
      digits: 2,
      currency: "Pound Sterling",
      countries: [
        "Guernsey",
        "Isle of Man",
        "Jersey",
        "United Kingdom of Great Britain and Northern Ireland (The)"
      ]
    },
    {
      code: "GEL",
      number: "981",
      digits: 2,
      currency: "Lari",
      countries: [
        "Georgia"
      ]
    },
    {
      code: "GHS",
      number: "936",
      digits: 2,
      currency: "Ghana Cedi",
      countries: [
        "Ghana"
      ]
    },
    {
      code: "GIP",
      number: "292",
      digits: 2,
      currency: "Gibraltar Pound",
      countries: [
        "Gibraltar"
      ]
    },
    {
      code: "GMD",
      number: "270",
      digits: 2,
      currency: "Dalasi",
      countries: [
        "Gambia (The)"
      ]
    },
    {
      code: "GNF",
      number: "324",
      digits: 0,
      currency: "Guinean Franc",
      countries: [
        "Guinea"
      ]
    },
    {
      code: "GTQ",
      number: "320",
      digits: 2,
      currency: "Quetzal",
      countries: [
        "Guatemala"
      ]
    },
    {
      code: "GYD",
      number: "328",
      digits: 2,
      currency: "Guyana Dollar",
      countries: [
        "Guyana"
      ]
    },
    {
      code: "HKD",
      number: "344",
      digits: 2,
      currency: "Hong Kong Dollar",
      countries: [
        "Hong Kong"
      ]
    },
    {
      code: "HNL",
      number: "340",
      digits: 2,
      currency: "Lempira",
      countries: [
        "Honduras"
      ]
    },
    {
      code: "HTG",
      number: "332",
      digits: 2,
      currency: "Gourde",
      countries: [
        "Haiti"
      ]
    },
    {
      code: "HUF",
      number: "348",
      digits: 2,
      currency: "Forint",
      countries: [
        "Hungary"
      ]
    },
    {
      code: "IDR",
      number: "360",
      digits: 2,
      currency: "Rupiah",
      countries: [
        "Indonesia"
      ]
    },
    {
      code: "ILS",
      number: "376",
      digits: 2,
      currency: "New Israeli Sheqel",
      countries: [
        "Israel"
      ]
    },
    {
      code: "INR",
      number: "356",
      digits: 2,
      currency: "Indian Rupee",
      countries: [
        "Bhutan",
        "India"
      ]
    },
    {
      code: "IQD",
      number: "368",
      digits: 3,
      currency: "Iraqi Dinar",
      countries: [
        "Iraq"
      ]
    },
    {
      code: "IRR",
      number: "364",
      digits: 2,
      currency: "Iranian Rial",
      countries: [
        "Iran (Islamic Republic Of)"
      ]
    },
    {
      code: "ISK",
      number: "352",
      digits: 0,
      currency: "Iceland Krona",
      countries: [
        "Iceland"
      ]
    },
    {
      code: "JMD",
      number: "388",
      digits: 2,
      currency: "Jamaican Dollar",
      countries: [
        "Jamaica"
      ]
    },
    {
      code: "JOD",
      number: "400",
      digits: 3,
      currency: "Jordanian Dinar",
      countries: [
        "Jordan"
      ]
    },
    {
      code: "JPY",
      number: "392",
      digits: 0,
      currency: "Yen",
      countries: [
        "Japan"
      ]
    },
    {
      code: "KES",
      number: "404",
      digits: 2,
      currency: "Kenyan Shilling",
      countries: [
        "Kenya"
      ]
    },
    {
      code: "KGS",
      number: "417",
      digits: 2,
      currency: "Som",
      countries: [
        "Kyrgyzstan"
      ]
    },
    {
      code: "KHR",
      number: "116",
      digits: 2,
      currency: "Riel",
      countries: [
        "Cambodia"
      ]
    },
    {
      code: "KMF",
      number: "174",
      digits: 0,
      currency: "Comorian Franc ",
      countries: [
        "Comoros (The)"
      ]
    },
    {
      code: "KPW",
      number: "408",
      digits: 2,
      currency: "North Korean Won",
      countries: [
        "Korea (The Democratic People’s Republic Of)"
      ]
    },
    {
      code: "KRW",
      number: "410",
      digits: 0,
      currency: "Won",
      countries: [
        "Korea (The Republic Of)"
      ]
    },
    {
      code: "KWD",
      number: "414",
      digits: 3,
      currency: "Kuwaiti Dinar",
      countries: [
        "Kuwait"
      ]
    },
    {
      code: "KYD",
      number: "136",
      digits: 2,
      currency: "Cayman Islands Dollar",
      countries: [
        "Cayman Islands (The)"
      ]
    },
    {
      code: "KZT",
      number: "398",
      digits: 2,
      currency: "Tenge",
      countries: [
        "Kazakhstan"
      ]
    },
    {
      code: "LAK",
      number: "418",
      digits: 2,
      currency: "Lao Kip",
      countries: [
        "Lao People’s Democratic Republic (The)"
      ]
    },
    {
      code: "LBP",
      number: "422",
      digits: 2,
      currency: "Lebanese Pound",
      countries: [
        "Lebanon"
      ]
    },
    {
      code: "LKR",
      number: "144",
      digits: 2,
      currency: "Sri Lanka Rupee",
      countries: [
        "Sri Lanka"
      ]
    },
    {
      code: "LRD",
      number: "430",
      digits: 2,
      currency: "Liberian Dollar",
      countries: [
        "Liberia"
      ]
    },
    {
      code: "LSL",
      number: "426",
      digits: 2,
      currency: "Loti",
      countries: [
        "Lesotho"
      ]
    },
    {
      code: "LYD",
      number: "434",
      digits: 3,
      currency: "Libyan Dinar",
      countries: [
        "Libya"
      ]
    },
    {
      code: "MAD",
      number: "504",
      digits: 2,
      currency: "Moroccan Dirham",
      countries: [
        "Morocco",
        "Western Sahara"
      ]
    },
    {
      code: "MDL",
      number: "498",
      digits: 2,
      currency: "Moldovan Leu",
      countries: [
        "Moldova (The Republic Of)"
      ]
    },
    {
      code: "MGA",
      number: "969",
      digits: 2,
      currency: "Malagasy Ariary",
      countries: [
        "Madagascar"
      ]
    },
    {
      code: "MKD",
      number: "807",
      digits: 2,
      currency: "Denar",
      countries: [
        "North Macedonia"
      ]
    },
    {
      code: "MMK",
      number: "104",
      digits: 2,
      currency: "Kyat",
      countries: [
        "Myanmar"
      ]
    },
    {
      code: "MNT",
      number: "496",
      digits: 2,
      currency: "Tugrik",
      countries: [
        "Mongolia"
      ]
    },
    {
      code: "MOP",
      number: "446",
      digits: 2,
      currency: "Pataca",
      countries: [
        "Macao"
      ]
    },
    {
      code: "MRU",
      number: "929",
      digits: 2,
      currency: "Ouguiya",
      countries: [
        "Mauritania"
      ]
    },
    {
      code: "MUR",
      number: "480",
      digits: 2,
      currency: "Mauritius Rupee",
      countries: [
        "Mauritius"
      ]
    },
    {
      code: "MVR",
      number: "462",
      digits: 2,
      currency: "Rufiyaa",
      countries: [
        "Maldives"
      ]
    },
    {
      code: "MWK",
      number: "454",
      digits: 2,
      currency: "Malawi Kwacha",
      countries: [
        "Malawi"
      ]
    },
    {
      code: "MXN",
      number: "484",
      digits: 2,
      currency: "Mexican Peso",
      countries: [
        "Mexico"
      ]
    },
    {
      code: "MXV",
      number: "979",
      digits: 2,
      currency: "Mexican Unidad de Inversion (UDI)",
      countries: [
        "Mexico"
      ]
    },
    {
      code: "MYR",
      number: "458",
      digits: 2,
      currency: "Malaysian Ringgit",
      countries: [
        "Malaysia"
      ]
    },
    {
      code: "MZN",
      number: "943",
      digits: 2,
      currency: "Mozambique Metical",
      countries: [
        "Mozambique"
      ]
    },
    {
      code: "NAD",
      number: "516",
      digits: 2,
      currency: "Namibia Dollar",
      countries: [
        "Namibia"
      ]
    },
    {
      code: "NGN",
      number: "566",
      digits: 2,
      currency: "Naira",
      countries: [
        "Nigeria"
      ]
    },
    {
      code: "NIO",
      number: "558",
      digits: 2,
      currency: "Cordoba Oro",
      countries: [
        "Nicaragua"
      ]
    },
    {
      code: "NOK",
      number: "578",
      digits: 2,
      currency: "Norwegian Krone",
      countries: [
        "Bouvet Island",
        "Norway",
        "Svalbard and Jan Mayen"
      ]
    },
    {
      code: "NPR",
      number: "524",
      digits: 2,
      currency: "Nepalese Rupee",
      countries: [
        "Nepal"
      ]
    },
    {
      code: "NZD",
      number: "554",
      digits: 2,
      currency: "New Zealand Dollar",
      countries: [
        "Cook Islands (The)",
        "New Zealand",
        "Niue",
        "Pitcairn",
        "Tokelau"
      ]
    },
    {
      code: "OMR",
      number: "512",
      digits: 3,
      currency: "Rial Omani",
      countries: [
        "Oman"
      ]
    },
    {
      code: "PAB",
      number: "590",
      digits: 2,
      currency: "Balboa",
      countries: [
        "Panama"
      ]
    },
    {
      code: "PEN",
      number: "604",
      digits: 2,
      currency: "Sol",
      countries: [
        "Peru"
      ]
    },
    {
      code: "PGK",
      number: "598",
      digits: 2,
      currency: "Kina",
      countries: [
        "Papua New Guinea"
      ]
    },
    {
      code: "PHP",
      number: "608",
      digits: 2,
      currency: "Philippine Peso",
      countries: [
        "Philippines (The)"
      ]
    },
    {
      code: "PKR",
      number: "586",
      digits: 2,
      currency: "Pakistan Rupee",
      countries: [
        "Pakistan"
      ]
    },
    {
      code: "PLN",
      number: "985",
      digits: 2,
      currency: "Zloty",
      countries: [
        "Poland"
      ]
    },
    {
      code: "PYG",
      number: "600",
      digits: 0,
      currency: "Guarani",
      countries: [
        "Paraguay"
      ]
    },
    {
      code: "QAR",
      number: "634",
      digits: 2,
      currency: "Qatari Rial",
      countries: [
        "Qatar"
      ]
    },
    {
      code: "RON",
      number: "946",
      digits: 2,
      currency: "Romanian Leu",
      countries: [
        "Romania"
      ]
    },
    {
      code: "RSD",
      number: "941",
      digits: 2,
      currency: "Serbian Dinar",
      countries: [
        "Serbia"
      ]
    },
    {
      code: "RUB",
      number: "643",
      digits: 2,
      currency: "Russian Ruble",
      countries: [
        "Russian Federation (The)"
      ]
    },
    {
      code: "RWF",
      number: "646",
      digits: 0,
      currency: "Rwanda Franc",
      countries: [
        "Rwanda"
      ]
    },
    {
      code: "SAR",
      number: "682",
      digits: 2,
      currency: "Saudi Riyal",
      countries: [
        "Saudi Arabia"
      ]
    },
    {
      code: "SBD",
      number: "090",
      digits: 2,
      currency: "Solomon Islands Dollar",
      countries: [
        "Solomon Islands"
      ]
    },
    {
      code: "SCR",
      number: "690",
      digits: 2,
      currency: "Seychelles Rupee",
      countries: [
        "Seychelles"
      ]
    },
    {
      code: "SDG",
      number: "938",
      digits: 2,
      currency: "Sudanese Pound",
      countries: [
        "Sudan (The)"
      ]
    },
    {
      code: "SEK",
      number: "752",
      digits: 2,
      currency: "Swedish Krona",
      countries: [
        "Sweden"
      ]
    },
    {
      code: "SGD",
      number: "702",
      digits: 2,
      currency: "Singapore Dollar",
      countries: [
        "Singapore"
      ]
    },
    {
      code: "SHP",
      number: "654",
      digits: 2,
      currency: "Saint Helena Pound",
      countries: [
        "Saint Helena, Ascension and Tristan Da Cunha"
      ]
    },
    {
      code: "SLE",
      number: "925",
      digits: 2,
      currency: "Leone",
      countries: [
        "Sierra Leone"
      ]
    },
    {
      code: "SOS",
      number: "706",
      digits: 2,
      currency: "Somali Shilling",
      countries: [
        "Somalia"
      ]
    },
    {
      code: "SRD",
      number: "968",
      digits: 2,
      currency: "Surinam Dollar",
      countries: [
        "Suriname"
      ]
    },
    {
      code: "SSP",
      number: "728",
      digits: 2,
      currency: "South Sudanese Pound",
      countries: [
        "South Sudan"
      ]
    },
    {
      code: "STN",
      number: "930",
      digits: 2,
      currency: "Dobra",
      countries: [
        "Sao Tome and Principe"
      ]
    },
    {
      code: "SVC",
      number: "222",
      digits: 2,
      currency: "El Salvador Colon",
      countries: [
        "El Salvador"
      ]
    },
    {
      code: "SYP",
      number: "760",
      digits: 2,
      currency: "Syrian Pound",
      countries: [
        "Syrian Arab Republic"
      ]
    },
    {
      code: "SZL",
      number: "748",
      digits: 2,
      currency: "Lilangeni",
      countries: [
        "Eswatini"
      ]
    },
    {
      code: "THB",
      number: "764",
      digits: 2,
      currency: "Baht",
      countries: [
        "Thailand"
      ]
    },
    {
      code: "TJS",
      number: "972",
      digits: 2,
      currency: "Somoni",
      countries: [
        "Tajikistan"
      ]
    },
    {
      code: "TMT",
      number: "934",
      digits: 2,
      currency: "Turkmenistan New Manat",
      countries: [
        "Turkmenistan"
      ]
    },
    {
      code: "TND",
      number: "788",
      digits: 3,
      currency: "Tunisian Dinar",
      countries: [
        "Tunisia"
      ]
    },
    {
      code: "TOP",
      number: "776",
      digits: 2,
      currency: "Pa’anga",
      countries: [
        "Tonga"
      ]
    },
    {
      code: "TRY",
      number: "949",
      digits: 2,
      currency: "Turkish Lira",
      countries: [
        "Türki̇ye"
      ]
    },
    {
      code: "TTD",
      number: "780",
      digits: 2,
      currency: "Trinidad and Tobago Dollar",
      countries: [
        "Trinidad and Tobago"
      ]
    },
    {
      code: "TWD",
      number: "901",
      digits: 2,
      currency: "New Taiwan Dollar",
      countries: [
        "Taiwan (Province of China)"
      ]
    },
    {
      code: "TZS",
      number: "834",
      digits: 2,
      currency: "Tanzanian Shilling",
      countries: [
        "Tanzania, United Republic Of"
      ]
    },
    {
      code: "UAH",
      number: "980",
      digits: 2,
      currency: "Hryvnia",
      countries: [
        "Ukraine"
      ]
    },
    {
      code: "UGX",
      number: "800",
      digits: 0,
      currency: "Uganda Shilling",
      countries: [
        "Uganda"
      ]
    },
    {
      code: "USD",
      number: "840",
      digits: 2,
      currency: "US Dollar",
      countries: [
        "American Samoa",
        "Bonaire, Sint Eustatius and Saba",
        "British Indian Ocean Territory (The)",
        "Ecuador",
        "El Salvador",
        "Guam",
        "Haiti",
        "Marshall Islands (The)",
        "Micronesia (Federated States Of)",
        "Northern Mariana Islands (The)",
        "Palau",
        "Panama",
        "Puerto Rico",
        "Timor-Leste",
        "Turks and Caicos Islands (The)",
        "United States Minor Outlying Islands (The)",
        "United States of America (The)",
        "Virgin Islands (British)",
        "Virgin Islands (u.s.)"
      ]
    },
    {
      code: "USN",
      number: "997",
      digits: 2,
      currency: "US Dollar (Next day)",
      countries: [
        "United States of America (The)"
      ]
    },
    {
      code: "UYI",
      number: "940",
      digits: 0,
      currency: "Uruguay Peso en Unidades Indexadas (UI)",
      countries: [
        "Uruguay"
      ]
    },
    {
      code: "UYU",
      number: "858",
      digits: 2,
      currency: "Peso Uruguayo",
      countries: [
        "Uruguay"
      ]
    },
    {
      code: "UYW",
      number: "927",
      digits: 4,
      currency: "Unidad Previsional",
      countries: [
        "Uruguay"
      ]
    },
    {
      code: "UZS",
      number: "860",
      digits: 2,
      currency: "Uzbekistan Sum",
      countries: [
        "Uzbekistan"
      ]
    },
    {
      code: "VED",
      number: "926",
      digits: 2,
      currency: "Bolívar Soberano",
      countries: [
        "Venezuela (Bolivarian Republic Of)"
      ]
    },
    {
      code: "VES",
      number: "928",
      digits: 2,
      currency: "Bolívar Soberano",
      countries: [
        "Venezuela (Bolivarian Republic Of)"
      ]
    },
    {
      code: "VND",
      number: "704",
      digits: 0,
      currency: "Dong",
      countries: [
        "Viet Nam"
      ]
    },
    {
      code: "VUV",
      number: "548",
      digits: 0,
      currency: "Vatu",
      countries: [
        "Vanuatu"
      ]
    },
    {
      code: "WST",
      number: "882",
      digits: 2,
      currency: "Tala",
      countries: [
        "Samoa"
      ]
    },
    {
      code: "XAF",
      number: "950",
      digits: 0,
      currency: "CFA Franc BEAC",
      countries: [
        "Cameroon",
        "Central African Republic (The)",
        "Chad",
        "Congo (The)",
        "Equatorial Guinea",
        "Gabon"
      ]
    },
    {
      code: "XAG",
      number: "961",
      digits: 0,
      currency: "Silver",
      countries: [
        "Zz11_silver"
      ]
    },
    {
      code: "XAU",
      number: "959",
      digits: 0,
      currency: "Gold",
      countries: [
        "Zz08_gold"
      ]
    },
    {
      code: "XBA",
      number: "955",
      digits: 0,
      currency: "Bond Markets Unit European Composite Unit (EURCO)",
      countries: [
        "Zz01_bond Markets Unit European_eurco"
      ]
    },
    {
      code: "XBB",
      number: "956",
      digits: 0,
      currency: "Bond Markets Unit European Monetary Unit (E.M.U.-6)",
      countries: [
        "Zz02_bond Markets Unit European_emu-6"
      ]
    },
    {
      code: "XBC",
      number: "957",
      digits: 0,
      currency: "Bond Markets Unit European Unit of Account 9 (E.U.A.-9)",
      countries: [
        "Zz03_bond Markets Unit European_eua-9"
      ]
    },
    {
      code: "XBD",
      number: "958",
      digits: 0,
      currency: "Bond Markets Unit European Unit of Account 17 (E.U.A.-17)",
      countries: [
        "Zz04_bond Markets Unit European_eua-17"
      ]
    },
    {
      code: "XCD",
      number: "951",
      digits: 2,
      currency: "East Caribbean Dollar",
      countries: [
        "Anguilla",
        "Antigua and Barbuda",
        "Dominica",
        "Grenada",
        "Montserrat",
        "Saint Kitts and Nevis",
        "Saint Lucia",
        "Saint Vincent and the Grenadines"
      ]
    },
    {
      code: "XDR",
      number: "960",
      digits: 0,
      currency: "SDR (Special Drawing Right)",
      countries: [
        "International Monetary Fund (Imf) "
      ]
    },
    {
      code: "XOF",
      number: "952",
      digits: 0,
      currency: "CFA Franc BCEAO",
      countries: [
        "Benin",
        "Burkina Faso",
        "Côte D'ivoire",
        "Guinea-Bissau",
        "Mali",
        "Niger (The)",
        "Senegal",
        "Togo"
      ]
    },
    {
      code: "XPD",
      number: "964",
      digits: 0,
      currency: "Palladium",
      countries: [
        "Zz09_palladium"
      ]
    },
    {
      code: "XPF",
      number: "953",
      digits: 0,
      currency: "CFP Franc",
      countries: [
        "French Polynesia",
        "New Caledonia",
        "Wallis and Futuna"
      ]
    },
    {
      code: "XPT",
      number: "962",
      digits: 0,
      currency: "Platinum",
      countries: [
        "Zz10_platinum"
      ]
    },
    {
      code: "XSU",
      number: "994",
      digits: 0,
      currency: "Sucre",
      countries: [
        'Sistema Unitario De Compensacion Regional De Pagos "Sucre"'
      ]
    },
    {
      code: "XTS",
      number: "963",
      digits: 0,
      currency: "Codes specifically reserved for testing purposes",
      countries: [
        "Zz06_testing_code"
      ]
    },
    {
      code: "XUA",
      number: "965",
      digits: 0,
      currency: "ADB Unit of Account",
      countries: [
        "Member Countries of the African Development Bank Group"
      ]
    },
    {
      code: "XXX",
      number: "999",
      digits: 0,
      currency: "The codes assigned for transactions where no currency is involved",
      countries: [
        "Zz07_no_currency"
      ]
    },
    {
      code: "YER",
      number: "886",
      digits: 2,
      currency: "Yemeni Rial",
      countries: [
        "Yemen"
      ]
    },
    {
      code: "ZAR",
      number: "710",
      digits: 2,
      currency: "Rand",
      countries: [
        "Lesotho",
        "Namibia",
        "South Africa"
      ]
    },
    {
      code: "ZMW",
      number: "967",
      digits: 2,
      currency: "Zambian Kwacha",
      countries: [
        "Zambia"
      ]
    },
    {
      code: "ZWG",
      number: "924",
      digits: 2,
      currency: "Zimbabwe Gold",
      countries: [
        "Zimbabwe"
      ]
    }
  ]), Gv;
}
var qv, n2;
function bW() {
  return n2 || (n2 = 1, qv = "2024-06-25"), qv;
}
var i2;
function wW() {
  if (i2) return Qa;
  i2 = 1;
  var r = vW(), e = yW(), t = AW(), n = bW(), i = function(c) {
    return c = c.toUpperCase(), r(t, function(d) {
      return d.code === c;
    });
  }, a = function(c) {
    return c = c.toLowerCase(), t.filter(function(d) {
      return (d.countries.map(function(f) {
        return f.toLowerCase();
      }) || []).indexOf(c) > -1;
    });
  }, s = function(c) {
    return r(t, function(d) {
      return d.number === String(c);
    });
  }, o = function() {
    return t.map(function(c) {
      return c.code;
    });
  }, l = function() {
    var c = t.map(function(d) {
      return d.number;
    });
    return c.filter(function(d) {
      if (d)
        return d;
    });
  }, u = function() {
    var c = t.filter(function(d) {
      return d.countries;
    }).map(function(d) {
      return d.countries;
    });
    return e(Array.prototype.concat.apply([], c));
  };
  return Qa.code = i, Qa.country = a, Qa.number = s, Qa.codes = o, Qa.numbers = l, Qa.countries = u, Qa.publishDate = n, Qa.data = t, Qa;
}
var a2 = wW();
class xW {
  /**
   * Returns a formatted string representing a given amount with desired currency.
   * @param currency The currency to represent the amount in.
   * @param amount The amount in minor units to format.
   */
  formatCurrencyForDisplay(e, t) {
    const n = {
      amount: t || 0,
      currency: e,
      precision: this.getPrecisionForCurrency(e)
    };
    return mW(n).toFormat(this.getSpecialFormat(e));
  }
  /**
   * Get the number of decimal places expected in a currency string.
   * @param currency The currency to determine precision for.
   */
  getPrecisionForCurrency(e) {
    const t = e, n = a2.code(t);
    return n ? n.digits : 2;
  }
  /**
   * Sometimes default formatting will display format in a way that isn't natural
   * for natives of a currency. This function is intended to capture those specific cases and return a format
   * that makes the most sense.
   * @param currency The currency to test for special format.
   */
  getSpecialFormat(e) {
    const t = e;
    if (a2.code(t)?.code === "CLP")
      return "USD0,0";
  }
}
const s2 = new xW();
class CW {
  constructor(e, t, n, i) {
    this.presentmentCurrency = void 0, this.presentmentCurrency = i, this.partnerCurrency = n, this.rateFrom = e, this.rateTo = t;
  }
  /**
   * @returns The currency code for the currency being used for monetary display.
   */
  code() {
    return this.presentmentCurrency ? this.presentmentCurrency : this.partnerCurrency;
  }
  /**
   * @returns true if the conversion is required, false otherwise.
   */
  conversionRequired() {
    return this.presentmentCurrency !== void 0 && this.code() !== this.partnerCurrency;
  }
  /**
   * Converts a monetary value from a workflow in a partner specified currency
   * to the units of the currency being used for display.
   * @param amount The amount in minor units to convert.
   * @returns
   */
  getConvertedSubunits(e) {
    return this.conversionRequired() ? Math.ceil(
      this.subunits(this.units(e, this.partnerCurrency) / this.rateFrom * this.rateTo, this.code())
    ) : e;
  }
  /**
   * Converts a monetary value from the database to the units of its currency.
   */
  units(e, t) {
    return e / Math.pow(10, s2.getPrecisionForCurrency(t));
  }
  /**
   * Converts a monetary value in units to the subunits of its currency.
   */
  subunits(e, t) {
    return e * Math.pow(10, s2.getPrecisionForCurrency(t));
  }
}
const SW = async (r, e) => {
  const t = await He.getShadowGraphqlClient().query({
    query: UB(e?.assets?.metadata || !1),
    errorPolicy: "all",
    variables: {
      ids: r
    }
  });
  if (t.error)
    throw t.error;
  if (t.errors)
    throw t.errors.forEach((i) => console.error(i)), new Error("Unable to read workflows. Consult GraphQL errors.");
  if (!t.data.workflows || t.data.workflows.length !== r.length)
    throw new Error(`Unable to read workflows: ${t.errors ?? "Length mismatch in response"}`);
  const n = ho(t.data.workflows);
  return n.forEach((i) => {
    i.finalizeStepConfig || (i.finalizeStepConfig = {}), i.finalizeStepConfig.termsMarkdown = i.finalizeStepConfig.termsMarkdown || i.partner.termsMarkdown;
  }), n;
}, EW = async (r, e) => {
  const n = (await e).find((i) => i.id === r);
  if (!n)
    throw new Error(`Workflow not found: ${r}`);
  return n;
}, $I = async (r, e) => {
  const t = r.map((o) => eg.get({ id: o, options: e })), n = r.filter((o, l) => t[l] === void 0);
  if (n.length === 0)
    return Promise.all(t);
  const i = SW(n, e), a = n.map(
    (o) => eg.set({ id: o, options: e }, EW(o, i))
  ), s = t.filter((o) => o !== void 0);
  return await Promise.all(s.concat(a));
}, kW = async (r, e) => (await $I([r], e))[0], HI = async (r) => {
  const e = await He.getShadowGraphqlClient().query({
    query: jk,
    variables: {
      ids: r
    },
    errorPolicy: "all",
    fetchPolicy: "no-cache"
  });
  return e.errors && console.error(e.errors), e.data.integrationProducts || [];
};
class GQ {
  constructor(e) {
    this.activeIntegration = void 0, this.updateTransactionState = async (t) => {
      try {
        return He.getShadowGraphqlClient().mutate({
          ...t,
          mutation: SB
        });
      } catch (n) {
        throw console.error(n), new ao("Critical - Unable to synchronize workflow state with server.");
      }
    }, this.options = e, this.options.applicationKey && H4(this.options.applicationKey), console.debug("------------------------"), console.debug("Spiff Commerce Core SDK"), console.debug("Version: 44.1.1"), console.debug(`Application Key Provided: ${!!this.options.applicationKey}`), console.debug("------------------------");
  }
  configure(e) {
    ml.setHubUrl(e.hubUrl), ml.setServerUrl(e.serverUrl), ml.setServicesApiUrl(e.servicesApiUrl), this.marketplaceThemeInstallId = e.marketplaceThemeInstallId, this.marketplaceThemeInstallConfigurationId = e.marketplaceThemeInstallConfigurationId, this.userPoolClientId = e.userPoolClientId, this.userPoolRegion = e.userPoolRegion, this.spiffRegion = e.spiffRegion, e.bearerAuthenticationToken && G4(e.bearerAuthenticationToken), this.options.applicationKey && this.getIntegration(), this.spiffRegion && this.userPoolRegion && this.userPoolClientId && Sf.init(this.spiffRegion, this.userPoolRegion, this.userPoolClientId);
  }
  /**
   * @returns The version of the @spiffcommerce/core package that this client is running.
   */
  getVersion() {
    return "44.1.1";
  }
  /**
   * @returns The asset manager allows for common operations related to assets
   * and the Spiff Commerce platform.
   */
  getAssetManager() {
    return zn;
  }
  /**
   * @returns A promise that resolves with a boolean indicating whether to use beta features.
   */
  async getBetaEnabled() {
    return this.options.enableBetaFeatures ? !0 : (await this.getIntegration()).partner.beta === !0;
  }
  getFlowService() {
    if (!j4()) throw new Error("Application key required to use Flow Service.");
    return new ZU();
  }
  async getCurrencyContext(e) {
    const n = (await this.getIntegration()).partner.currencyCode, a = await He.getShadowGraphqlClient().query({
      query: GB,
      errorPolicy: "all",
      fetchPolicy: "cache-first",
      variables: {
        from: n,
        to: e
      }
    }), { rateFrom: s, rateTo: o } = a.data.currencyConversion;
    return new CW(s, o, n, e);
  }
  async getIntegration() {
    if (this.activeIntegration)
      return this.activeIntegration;
    if (!this.options.applicationKey)
      throw new Error("Cannot get current Integration without specifying an Application Key.");
    return this.activeIntegration = TW(this.options.applicationKey), this.activeIntegration;
  }
  async canUseAddon(e) {
    try {
      return (await this.getIntegration()).partner.activeAddons?.includes(e) ?? !1;
    } catch (t) {
      return console.error(t), !1;
    }
  }
  clearCustomer() {
    this.customer = void 0;
  }
  clearCustomerForTransaction(e) {
    const t = Cr.getMap("transactionCustomerIds");
    t?.has(e) && (t.delete(e), Cr.setMap("transactionCustomerIds", t));
  }
  async customerHasBundleTemplates(e) {
    const i = (await He.getShadowGraphqlClient().query({
      query: bv,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        emailAddress: e
      }
    })).data.customer;
    return i.id ? i.hasBundleTemplates ?? !1 : !1;
  }
  getStakeholderTypeForTransaction(e) {
    const t = this.customer?.stakeholders?.find(
      (n) => n.transaction?.id === e
    );
    if (t)
      return t.type;
  }
  async getOrCreateCustomer(e) {
    this.customer = void 0;
    const t = He.getShadowGraphqlClient(), i = (await t.query({
      query: bv,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        emailAddress: e
      }
    })).data.customer;
    if (!i.id) {
      const o = (await t.mutate({
        mutation: r9,
        errorPolicy: "all",
        fetchPolicy: "no-cache",
        variables: {
          details: {
            emailAddress: e
          }
        }
      })).data?.customerCreate;
      if (!o)
        throw new Error("Unable to create customer.");
      return this.storeCustomer(o), this.customer = o, {
        customer: o,
        isAuthenticated: !1
      };
    }
    this.storeCustomer(i);
    const a = await this.reloadLoggedInCustomer();
    return {
      customer: this.customer || i,
      isAuthenticated: a
    };
  }
  getCustomer() {
    return this.customer;
  }
  /**
   * Check if a customer is logged in.
   * If they are, set the customer object.
   * This is how we resume sessions between loads.
   */
  async reloadLoggedInCustomer() {
    const e = localStorage.getItem("last-refreshed-cognito-tokens"), t = localStorage.getItem("cognito-tokens"), n = localStorage.getItem("cognito-email");
    if (!e || !t || !n)
      return !1;
    const i = JSON.parse(t), a = (/* @__PURE__ */ new Date()).getTime() / 1e3;
    if (!i.ExpiresIn || i.ExpiresIn < a - parseInt(e)) {
      const u = await Sf.refreshTokens();
      if (u?.AuthenticationResult)
        localStorage.setItem("last-refreshed-cognito-tokens", `${(/* @__PURE__ */ new Date()).getTime() / 1e3}`), i.AccessToken = u.AuthenticationResult.AccessToken, localStorage.setItem("cognito-tokens", JSON.stringify(i));
      else
        return this.logOut(), console.error("Failed to refresh tokens."), !1;
    }
    const s = localStorage.getItem("customer-login-token");
    s && e0(s);
    const l = (await He.getShadowGraphqlClient().query({
      query: bv,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        emailAddress: n
      }
    })).data.customer;
    return l.id ? (this.customer = l, !0) : (console.error("Failed to get customer."), !1);
  }
  /**
   * Generate an email code to allow logging in as a Spiff user.
   */
  async generateVerificationCode(e) {
    await He.getShadowGraphqlClient().mutate({
      mutation: n9,
      variables: {
        emailAddress: e
      }
    }), await Sf.generateCode(e);
  }
  /**
   * Verify an email code to log in as a Spiff user.
   * Always returns true if it doesn't throw.
   */
  async verifyCode(e, t) {
    const n = (await this.getIntegration()).partner.id || "", i = await Sf.verifyCode(e, t, n);
    if (i?.AuthenticationResult) {
      localStorage.setItem("last-refreshed-cognito-tokens", `${(/* @__PURE__ */ new Date()).getTime() / 1e3}`), localStorage.setItem("cognito-tokens", JSON.stringify(i.AuthenticationResult)), localStorage.setItem("cognito-email", e);
      const s = (await He.getShadowGraphqlClient().mutate({
        mutation: i9,
        errorPolicy: "all",
        fetchPolicy: "no-cache",
        variables: {
          emailAddress: e,
          verificationCode: t
        }
      })).data?.customerVerifyCode;
      if (!s?.id)
        throw new Error("Failed to get customer.");
      return this.customer = s, s.loginToken && (localStorage.setItem("customer-login-token", s.loginToken), e0(s.loginToken)), !0;
    } else
      throw new Error();
  }
  /**
   * Log out the currently logged-in Spiff user.
   */
  async logOut() {
    localStorage.removeItem("last-refreshed-cognito-tokens"), localStorage.removeItem("cognito-tokens"), localStorage.removeItem("cognito-email"), localStorage.removeItem("customer-login-token"), e0(""), this.clearCustomer();
  }
  // Get a Cognito bearer token from local storage, attempting to refresh if it's old.
  async loggedInBearerToken() {
    const e = localStorage.getItem("last-refreshed-cognito-tokens"), t = localStorage.getItem("cognito-tokens");
    if (!e || !t)
      throw new Error("No token data in storage.");
    const n = JSON.parse(t), i = (/* @__PURE__ */ new Date()).getTime() / 1e3, a = !n?.AccessToken || dg(n.AccessToken);
    if (!n.ExpiresIn || n.ExpiresIn < i - parseInt(e) || a) {
      const s = await Sf.refreshTokens();
      if (s?.AuthenticationResult)
        localStorage.setItem("last-refreshed-cognito-tokens", `${(/* @__PURE__ */ new Date()).getTime() / 1e3}`), n.AccessToken = s.AuthenticationResult.AccessToken, localStorage.setItem("cognito-tokens", JSON.stringify(n));
      else
        throw this.logOut(), new Error("Failed to refresh tokens.");
    }
    if (!n.AccessToken)
      throw new Error("No bearer token in storage.");
    return n.AccessToken;
  }
  async getCustomerMetafields() {
    if (!this.customer?.id)
      throw new Error("Customer must be logged in before calling this function.");
    return (await He.getShadowGraphqlClient().query({
      query: a9,
      variables: {
        id: this.customer.id
      }
    })).data.metafields;
  }
  /**
   * @param collectionId Optional: The id of the product collection that the bundle can use.
   * @returns A bundle to be used for grouping and operating on large amounts of workflow experiences.
   */
  async getNewBundle(e, t, n, i) {
    const s = (await He.getShadowGraphqlClient().mutate({
      mutation: EL(n?.graphql?.productCollection?.eagerFetchProducts || !1),
      variables: {
        collectionId: e,
        initialMetadata: t ? Object.entries(t).map((c, d) => ({ key: c[0], value: c[1] })) : void 0,
        marketplaceThemeInstallId: this.marketplaceThemeInstallId,
        marketplaceThemeInstallConfigurationId: this.marketplaceThemeInstallConfigurationId,
        activationId: i
      },
      fetchPolicy: "no-cache"
    })).data?.bundleCreate;
    if (!s?.id)
      throw new Error("Unable to create bundle");
    const o = Cr.getMap("bundlePartnerIds") || /* @__PURE__ */ new Map();
    o.set(s.id, s.partner.id), Cr.setMap("bundlePartnerIds", o);
    const l = Cr.getMap("bundleOwnerIds") || /* @__PURE__ */ new Map();
    l.set(s.id, s.bundleOwnerId), Cr.setMap("bundleOwnerIds", l);
    const u = new dE(this, s, void 0, void 0, s.bundleOwnerId, {
      eagerFetchProducts: n?.graphql?.productCollection?.eagerFetchProducts
    });
    return await u.getInitializationPromise(), u;
  }
  /**
   * Retrieves an existing bundle from the API, by id.
   * @param bundleId The id of the bundle to retrieve.
   * @param previewService Optional: A reference to an existing preview service to use. This can be assigned manually later.
   * @param graphqlOptions Optional: Options to configure loading the bundle.
   * @param options Optional: Options to configure loading the bundle.
   * @returns A bundle to be used for grouping and operating on large amounts of workflow experiences.
   */
  async getExistingBundle(e, t, n, i, a) {
    const o = Cr.getMap("bundleOwnerIds")?.get(e), l = {};
    try {
      const g = await this.loggedInBearerToken();
      l.Authorization = `Bearer ${g}`;
    } catch {
      const y = Object.entries(localStorage).find(([x, k]) => x.startsWith("CognitoIdentityServiceProvider") && x.endsWith("idToken"))?.[0] || "", A = localStorage.getItem(y);
      A && !dg(A) && (l.Authorization = `Bearer ${A}`);
    }
    const u = {
      bundleOwnerId: o,
      ...l,
      ...i?.graphql?.additionalHeaders
    }, c = await He.getShadowGraphqlClient().query({
      query: bL(i?.graphql?.productCollection?.eagerFetchProducts || !1),
      variables: {
        id: e
      },
      fetchPolicy: "no-cache",
      context: {
        headers: u
      }
    });
    if (!c.data?.bundles || c.data?.bundles.length === 0 || !c.data?.bundles[0])
      throw new Error(`Unable to find bundle: ${e}`);
    const d = c.data?.bundles[0], f = Cr.getMap("bundlePartnerIds") || /* @__PURE__ */ new Map();
    f.set(d.id, d.partner.id), Cr.setMap("bundlePartnerIds", f);
    const h = new dE(
      this,
      d,
      t,
      n,
      o,
      {
        additionalHeaders: i?.graphql?.additionalHeaders,
        eagerFetchProducts: i?.graphql?.productCollection?.eagerFetchProducts,
        existingGlobalPropertyState: c.data.globalPropertyState,
        readonly: i?.readonly
      },
      a
    );
    return await h.getInitializationPromise(), h;
  }
  /**
   * @param bundleId The id of the bundle to copy. The current context must have write access to the this bundle in order to duplicate it.
   * @param template Optional: Whether to mark the new bundle as a template. Default is false.
   * @param duplicateTransactions Optional: Whether to also duplicate the original bundle's transactions. Default is true.
   * @returns A bundle to be used for grouping and operating on large amounts of workflow experiences.
   */
  async duplicateBundle(e, t, n, i) {
    const s = {
      ...await GI(e),
      ...i?.graphql?.additionalHeaders
    }, l = (await He.getShadowGraphqlClient().mutate({
      mutation: kL(),
      variables: {
        id: e,
        template: t,
        marketplaceThemeInstallId: this.marketplaceThemeInstallId,
        marketplaceThemeInstallConfigurationId: this.marketplaceThemeInstallConfigurationId,
        duplicateTransactions: n
      },
      context: {
        headers: s
      },
      fetchPolicy: "no-cache"
    })).data?.bundleDuplicate;
    if (!l?.id)
      throw new Error("Unable to duplicate bundle");
    const u = Cr.getMap("bundlePartnerIds") || /* @__PURE__ */ new Map();
    u.set(l.id, l.partner.id), Cr.setMap("bundlePartnerIds", u);
    const c = Cr.getMap("bundleOwnerIds") || /* @__PURE__ */ new Map();
    return c.set(l.id, l.bundleOwnerId), Cr.setMap("bundleOwnerIds", c), async () => await this.getExistingBundle(l.id, void 0, void 0, {
      graphql: {
        productCollection: {
          eagerFetchProducts: i?.graphql?.productCollection?.eagerFetchProducts || !1
        }
      }
    });
  }
  /**
   * Fetches information about the currently authenticated customer's bundles.
   * NOTE: This does not initialize a bundle for active use.
   * You must call either `getExistingBundle` or `duplicateBundle` to actually interact with a bundle.
   * @param options Options to configure the request.
   * @returns A promise that resolves with an object containing:
   * `items` - The bundles that matched the request.
   * `total` - The total number of bundles on the server that match this query.
   */
  async getBundlesForCustomer(e) {
    if (!this.customer?.id)
      throw new Error("Customer not authenticated.");
    const { includeMetadata: t, ...n } = e;
    return (await He.getShadowGraphqlClient().query({
      query: NL(t ?? !1),
      variables: {
        ...n,
        id: this.customer.id
      },
      fetchPolicy: "no-cache"
    })).data.customerBundlesFeed;
  }
  /**
   * Retrieves all existing bundle stakeholders from the API, for the currently authenticated customer.
   * @returns An array of bundle stakeholders.
   */
  async getBundleStakeholders() {
    if (!this.customer)
      throw new Error("Customer not authenticated.");
    const e = await He.getShadowGraphqlClient().query({
      query: wL,
      variables: {
        id: this.customer.id
      },
      fetchPolicy: "no-cache"
    });
    if (!e.data?.customers || e.data.customers.length === 0)
      throw new Error("Unable to find customer.");
    const n = e.data.customers[0].bundleStakeholders || [], i = Cr.getMap("bundlePartnerIds") || /* @__PURE__ */ new Map();
    return n.forEach((a) => {
      a.bundle?.id && a.bundle.partner?.id && i.set(a.bundle.id, a.bundle.partner.id);
    }), Cr.setMap("bundlePartnerIds", i), n;
  }
  /**
   * Creates a new instance of WorkflowExperience. A high level wrapper for workflows.
   * @param options Options to configure loading the transaction and workflow.
   * @param previewServiceConstructor A function called during initialization. Takes a class implementing ThreeDPreviewService in return.
   * @returns A workflow experience configured as requested.
   */
  async getWorkflowExperience(e, t) {
    if (!e)
      throw new Error("getWorkflowExperience has been called without an options object! This is not supported.");
    const n = await this.getWorkflowExperiences([e], e.graphql), i = n[0], a = i.getWorkflow();
    return t && !a && console.error("No workflow instantiated when trying to create preview service."), t && a && await i.getWorkflowManager().injectIntoPreviewService(t(a)), n[0];
  }
  /**
   * Gets multiple workflow experiences at once.
   * @param optionsArray An array of options to configure loading the transactions and workflows.
   * NOTE: The `previewService` field on the option is currently unsupported in this function, as loading multiple models at once will likely cause performance issues.
   * @param graphqlOptions Options to configure loading the workflows.
   * @returns An array of workflow experiences configured as requested.
   */
  async getWorkflowExperiences(e, t, n, i) {
    if (e.length === 0)
      throw new ao("No options provided!");
    const a = e.map((q, Y) => ({ option: q, index: Y })), s = a.filter((q) => q.option.type === "transaction"), o = a.filter(
      (q) => q.option.type === "integration" || q.option.type === "external" || q.option.type === "blank"
    ), l = 50, u = Yy(s, l), c = Yy(o, l);
    let d = 0;
    const f = He.getShadowGraphqlClient(), h = async (q) => {
      if (q.length === 0)
        return [];
      const Y = q.map((oe) => oe.option.transactionId), J = await f.query({
        query: CB,
        variables: {
          ids: Y
        },
        errorPolicy: "all",
        fetchPolicy: "no-cache"
      }), se = J.data.transactions;
      if (d = d + se.length, i && i(d, s.length), se.length !== q.length) {
        const oe = J.errors?.[0]?.message || "Unknown error";
        throw new ao(`Not all transactions were found: ${oe}`);
      }
      return !this.activeIntegration && se[0].integrationProduct?.integration && (this.activeIntegration = Promise.resolve(se[0].integrationProduct.integration)), se.map((oe, he) => ({
        transaction: oe,
        workflowId: oe.workflowId,
        readOnly: q.find((ye) => ye.option.transactionId === oe.id)?.option.readOnly ?? !1,
        index: q[he].index
      }));
    }, g = async (q) => {
      if (q.length === 0)
        return [];
      const Y = await f.mutate({
        mutation: xB,
        variables: {
          inputs: q.map((se) => ({
            integrationProductId: se.option.type === "integration" ? se.option.integrationProductId : void 0,
            externalIntegrationId: se.option.type === "external" ? se.option.externalIntegrationId : void 0,
            externalProductId: se.option.type === "external" ? se.option.externalProductId : void 0,
            workflowId: se.option.workflowId,
            designName: se.option.designName,
            claim: !0,
            quantity: se.option.quantity,
            recipient: se.option.recipient,
            parentTransactionId: se.option.parentTransactionId
          })),
          marketplaceThemeInstallId: this.marketplaceThemeInstallId,
          marketplaceThemeInstallConfigurationId: this.marketplaceThemeInstallConfigurationId
        },
        errorPolicy: "all",
        fetchPolicy: "no-cache",
        context: this.getCreateTransactionContext(q, t)
      }), J = Y.data?.transactionCreateMany;
      if (!J || J.length === 0) {
        const se = Y.errors?.[0]?.message || "Unknown error";
        throw new ao(`Failed to create transactions: ${se}`);
      }
      return d = d + J.length, i && i(d, s.length), J.map((se, oe) => ({
        transaction: se,
        workflowId: se.workflowId,
        readOnly: !1,
        index: q[oe].index
      }));
    }, v = (await Promise.all([
      ...u.map(h),
      ...c.map(g)
    ])).flat();
    let y = [
      ...new Set(v.map((q) => q.transaction.integrationProductId))
    ].filter((q) => !!q);
    y = y.filter((q) => !!q);
    let A = [...new Set(v.map((q) => q.workflowId))].filter((q) => !!q);
    A = A.filter((q) => !!q);
    const [x, k] = await Promise.all([
      (async () => y.length > 0 ? await HI(y) : [])(),
      (async () => A.length > 0 ? await $I(A, t) : [])()
    ]), F = new Map(x.map((q) => [q.id, q])), S = new Map(k.map((q) => [q.id, q])), R = v.map(async (q) => {
      const { transaction: Y, workflowId: J, readOnly: se, index: oe } = q, he = J ? S.get(J) : void 0, ye = e[oe];
      if (Y.integrationProductId) {
        const re = F.get(Y.integrationProductId);
        Y.integrationProduct = re, Y.product = re?.product, Y.integrationProduct || console.error("failed to find transaction's product");
      }
      const Ue = Cr.getMap("transactionOwnerIds") || /* @__PURE__ */ new Map();
      !Ue.get(Y.id) && Y.transactionOwnerId && (Ue.set(Y.id, Y.transactionOwnerId), Cr.setMap("transactionOwnerIds", Ue));
      const Re = Ue.get(Y.id) || void 0, Oe = new s9({
        onMutate: () => ({ context: { transactionOwnerId: Re, bundleOwnerId: t?.bundleOwnerId } }),
        onQuery: () => ({ context: { transactionOwnerId: Re, bundleOwnerId: t?.bundleOwnerId } })
      }), ee = {
        workflow: he,
        transaction: Y,
        singleVariantsRenderable: ye?.workflowConfiguration?.singleVariantsRenderable,
        stateMutationFunc: se ? async () => {
          throw new un("State mutation is forbidden in read only mode!");
        } : async (re) => this.updateTransactionState({
          ...re,
          context: { transactionOwnerId: Re, bundleOwnerId: t?.bundleOwnerId }
        }),
        graphQlClient: () => Oe,
        readOnly: se,
        isReloadedTransaction: ye.type === "transaction"
      };
      if (ye.type === "transaction" && Y.workflowState) {
        const re = JSON.parse(Y.workflowState);
        await hS(re), ee.reloadedState = re;
      } else if (!se && ye.workflowState) {
        const re = JSON.parse(ye.workflowState);
        await hS(re), ee.reloadedState = re;
      }
      return ee.delayWorkflowStateSync = !0, { experienceOptions: ee, index: oe, options: ye };
    }), j = (await Promise.all(R)).sort((q, Y) => q.index - Y.index);
    let G = [], ie = [];
    for (const q of j) {
      const { experienceOptions: Y, options: J } = q, se = new FU(this, Y);
      await se.getWorkflowManager().getInitializationPromise(), n && n(), J.type !== "transaction" && this.customer && ie.push(se), G = [...G, se], se.getWorkflowManager().setWorkflowStateSyncEnabled(!0);
    }
    if (ie.length > 0) {
      const q = this.customer.emailAddress, Y = ie.map((oe) => oe.getTransaction().id), se = (await f.mutate({
        mutation: EU,
        variables: {
          ids: Y,
          details: { emailAddress: q },
          type: "Owner"
        },
        errorPolicy: "all"
      })).data?.transactionsAddStakeholder;
      if (se && se?.length > 0) {
        const oe = se[0].stakeholders?.find((he) => he.customer?.emailAddress === q);
        if (oe?.customer)
          for (const he of ie)
            he.assignCustomerInternal(oe.customer);
      }
    }
    return G;
  }
  getCreateTransactionContext(e, t) {
    const n = e.find((s) => s.option.parentTransactionId)?.option.parentTransactionId;
    if (!n && !t?.bundleOwnerId) return;
    const i = Cr.getMap("transactionOwnerIds") || /* @__PURE__ */ new Map(), a = n ? i.get(n) : void 0;
    return {
      ...a ? { transactionOwnerId: a } : {},
      ...t?.bundleOwnerId ? { bundleOwnerId: t.bundleOwnerId } : {}
    };
  }
  storeCustomer(e) {
    const t = Cr.getMap("partnerCustomerIds") || /* @__PURE__ */ new Map();
    t.set(e.partner.id, e.id), Cr.setMap("partnerCustomerIds", t);
  }
  async getIntegrationProductById(e, t) {
    const a = (await He.getShadowGraphqlClient().query({
      query: PB(t),
      variables: {
        ids: [e]
      },
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    })).data?.integrationProducts;
    if (!a || a.length === 0 || !a[0]?.id)
      throw new Error("Integration product not found.");
    return new hE(a[0]);
  }
  async getIntegrationProductFromExternalIds(e, t, n) {
    const s = (await He.getShadowGraphqlClient().query({
      query: RB(n),
      variables: {
        externalProductId: t,
        externalIntegrationId: e
      },
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    })).data?.integrationProductFromExternalIds;
    if (!s?.id)
      throw new Error("Integration product not found.");
    return new hE(s);
  }
  async getIntegrationProduct(e) {
    return e.type === "integration" ? this.getIntegrationProductById(e.integrationProductId) : this.getIntegrationProductFromExternalIds(e.externalIntegrationId, e.externalProductId);
  }
  async getShareActionsForTransaction(e) {
    const n = (Cr.getMap("transactionOwnerIds") || /* @__PURE__ */ new Map()).get(e) || void 0, i = await He.getShadowGraphqlClient().query({
      query: IB,
      errorPolicy: "all",
      fetchPolicy: "no-cache",
      variables: {
        id: e
      },
      context: {
        transactionOwnerId: n
      }
    });
    if (!i.data.transactions || i.data.transactions.length !== 1)
      throw new Error(`Failed to fetch share actions for transaction: ${e}`);
    return i.data.transactions[0].transactionShareActions;
  }
  async placeOrder(e) {
    const t = await He.getShadowGraphqlClient().mutate({
      mutation: jB,
      variables: {
        orderItems: e
      }
    });
    if (t.errors)
      throw new Error(t.errors[0].message);
    if (!t.data)
      throw new Error("Failed to create order: No order data in response.");
    return {
      id: t.data.orderCreate.id,
      internalId: t.data.orderCreate.internalId
    };
  }
}
const TW = async (r, e) => (await He.getShadowGraphqlClient().query({
  query: zB,
  errorPolicy: "all",
  fetchPolicy: "no-cache",
  context: {
    headers: {
      "x-application-key": r
    },
    skipIntegrationCheck: !0
  },
  variables: {
    themeConfigurationId: e
  }
})).data.currentIntegration, qQ = async (r) => {
  const t = await He.getShadowGraphqlClient().query({
    query: FB,
    errorPolicy: "all",
    fetchPolicy: "network-only",
    variables: {
      id: r
    }
  });
  if (t.data.transactions.length !== 0)
    return t.data.transactions[0];
}, WQ = async (r, e) => (await He.getShadowGraphqlClient().query({
  query: VB,
  errorPolicy: "all",
  variables: {
    themeConfigurationId: r,
    themeInstallId: e
  }
})).data?.marketplaceThemeInstallConfiguration, QQ = async (r) => (await He.getShadowGraphqlClient().query({
  query: HB,
  errorPolicy: "all",
  variables: {
    id: r
  }
})).data?.bundles?.[0]?.marketplaceThemeInstallConfiguration, YQ = async (r) => (await He.getShadowGraphqlClient().query({
  query: $B,
  errorPolicy: "all",
  variables: {
    id: r
  }
})).data?.transactions?.[0]?.marketplaceThemeInstallConfiguration, FW = async (r) => (await He.getShadowGraphqlClient().query({
  query: qB,
  errorPolicy: "all",
  variables: {
    id: r
  }
})).data?.activation, XQ = async (r) => (await FW(r))?.marketplaceThemeInstallConfiguration;
async function jI() {
  const r = {};
  try {
    const e = await this.loggedInBearerToken();
    r.Authorization = `Bearer ${e}`;
  } catch {
    const n = Object.entries(localStorage).find(([a, s]) => a.startsWith("CognitoIdentityServiceProvider") && a.endsWith("idToken"))?.[0] || "", i = localStorage.getItem(n);
    i && !dg(i) && (r.Authorization = `Bearer ${i}`);
  }
  return r;
}
async function GI(r) {
  const t = Cr.getMap("bundleOwnerIds")?.get(r), n = await jI();
  return {
    bundleOwnerId: t,
    ...n
  };
}
async function IW(r) {
  const t = Cr.getMap("transactionOwnerIds")?.get(r), n = await jI();
  return {
    transactionOwnerId: t,
    ...n
  };
}
const JQ = async (r) => {
  const e = await GI(r), t = await He.getShadowGraphqlClient().mutate({
    mutation: qL,
    errorPolicy: "all",
    fetchPolicy: "no-cache",
    variables: {
      id: r
    },
    context: {
      headers: e
    }
  });
  if (t.data?.bundleDelete !== r)
    throw new Error(`Failed to delete bundle: ${t.errors}`);
}, KQ = async (r) => {
  const e = await IW(r), t = await He.getShadowGraphqlClient().mutate({
    mutation: WL,
    errorPolicy: "all",
    fetchPolicy: "no-cache",
    variables: {
      ids: [r]
    },
    context: {
      headers: e
    }
  });
  if (!t.data?.transactions || t.data.transactions.length !== 1 || t.data.transactions[0].id !== r)
    throw new Error(`Failed to find transaction to read bundle id: ${JSON.stringify(t.errors)}`);
  return t.data.transactions[0].bundle?.id;
};
function DW(r, e, t, n) {
  const i = t.width * r.zoom, a = t.height * r.zoom;
  if (n) {
    const s = Math.max(e.width / t.width, e.height / t.height), o = Math.max(s, r.zoom), l = t.width * o, u = t.height * o;
    return {
      ...r,
      x: wp(r.x, e.width - l, 0),
      y: wp(r.y, e.height - u, 0),
      zoom: o
    };
  }
  return {
    ...r,
    x: wp(r.x, -i, e.width),
    y: wp(r.y, -a, e.height)
  };
}
function wp(r, e, t) {
  return Math.min(Math.max(r, e), t);
}
class PW {
  constructor(e, t) {
    this.minZoomScale = [0.03], this.maxZoomScale = [20], this._debouncedUpdateFrameOffsets = VF(this.updateFrameOffsets, 200), this.targetElements = [], this.onFrameDataChangeListeners = [], this.onZoomChangeListeners = [], this.onRotationChangeListeners = [], this.forceImageCover = e, this.initialZoom = t, this.thresholdSettings = {
      useThreshold: !1,
      invertThreshold: !1,
      threshold: 128,
      thresholdSaturation: 0.5
    };
  }
  /**
   * When we want to connect a workflow manager to the state of the image cropper we
   * can pass it to this function. Inside we'll attach any required event listeners.
   * @param workflowManager The workflow manager to attach.
   * @param stepName The specific step we want to attach to within the manager.
   */
  connectWorkflowManager(e, t) {
    t && e.addStepSpecificStorageCallback(async (n) => {
      if (n) {
        const i = n;
        if (i.currentFrameSources) {
          let a = !1;
          for (let s = 0; s < i.currentFrameSources.length; s++) {
            const o = i.currentFrameSources[s], l = await Mg(o), u = this.frameData ? this.frameData[s] : void 0;
            ld(l, u) || (this.frameData || (this.frameData = new Array(i.currentFrameSources.length)), this.frameData[s] = l, a = !0);
          }
          a && (this.onFrameDataChangeListeners.forEach(
            (s) => s(this.frameData)
          ), this.frameData && this.imageData && (this.recalculateOffsets(this.imageData), this.updateOffsets(this.offsets), this.recalculateZoomLimits(this.imageData, this.frameData)));
        }
      }
    }, t), this.workflowManager = e, this.stepName = t;
  }
  /**
   * Sets the elements that should be update when changes are made to
   * the cropper that owns this service.
   * @param targetElements A list of element Ids to track
   */
  setTargetElements(e) {
    this.targetElements = e;
  }
  /**
   * Gets the current calculated frame data
   * @returns A FrameData object or undefined if no frame has been set.
   */
  getFrameData() {
    return this.frameData;
  }
  /**
   * Sets the current frame data. Note:
   * @param paths The paths to lookup in our frame data cache.
   */
  setFrameData(e) {
    if (!e) {
      this.frameData = void 0;
      return;
    }
    e.forEach((t, n) => {
      const i = Of.get(t);
      i && (this.frameData || (this.frameData = new Array(e.length)), this.frameData[n] = i);
    });
  }
  /**
   * Gets the currently set image of the frame..
   * @returns A PatternImageData object, or undefined if no image is set.
   */
  getImageData() {
    return this.imageData;
  }
  /**
   * Helper function to get the src of the image of the frame, since it can be an svg with modified colors.
   * @returns A url (a data url if svg), or undefined if no image is set.
   */
  getImageSrc() {
    if (this.imageData) {
      if (this.imageData.svg) {
        const e = zA(this.imageData.svg, this.imageData.colors || {}, !1);
        return DA(e);
      }
      return this.imageData.src;
    }
  }
  /**
   * Gets the current calculated offsets of the pattern within the frame.
   * @returns A FrameOffsets object or undefined if no offsets are defined.
   */
  getOffsets() {
    return this.offsets;
  }
  /**
   * Updates the frame offsets explicitly.
   */
  setOffsets(e) {
    this.offsets = e;
  }
  /**
   * Sets the zoom of the cropper that owns this service.
   * @param zoom The new zoom value, per frame.
   * @param cX The center of zoom on x axis, per frame.
   * @param cY The center of zoom on Y axis, per frame.
   * @param onComplete A function to call when zoom changes have been completed
   */
  setZoom(e, t, n, i) {
    if (this.imageData && this.offsets && this.frameData) {
      (!this.offsets || this.offsets.length !== this.frameData.length) && (this.offsets = new Array(this.frameData.length));
      const a = this.frameData.map((s, o) => {
        const l = (t[o] - this.offsets[o].x) / this.offsets[o].zoom, u = (n[o] - this.offsets[o].y) / this.offsets[o].zoom, c = t[o] - l * e[o], d = n[o] - u * e[o];
        return {
          x: c,
          y: d,
          zoom: this.imageData.width * e[o] / this.imageData.width,
          rotation: this.offsets[o].rotation
        };
      });
      this.updateOffsets(a, i), this.onZoomChangeListeners.forEach((s) => s(e));
    }
  }
  /**
   * Sets the rotation of the pattern within the frame
   * @param rotation The new rotation value in degrees, per frame
   * @param onComplete A function to call when rotation changes have been completed
   */
  setRotation(e, t) {
    if (this.imageData && this.offsets && this.frameData) {
      (!this.offsets || this.offsets.length !== this.frameData.length) && (this.offsets = new Array(this.frameData.length));
      const n = this.frameData.map((i, a) => ({
        ...this.offsets[a],
        rotation: e[a]
      }));
      this.updateOffsets(n, t), this.onRotationChangeListeners.forEach((i) => i(e));
    }
  }
  /**
   * Sets the image currently contained by this frame.
   * @param value The new image as an ImageData property
   * @param [recalculateOffsets=true] Optional: Enable/disable re-calculating of frame offsets. Default: `true`.
   * Note: Will always calculate when offsets have not been calculated.
   */
  setPatternData(e, t = !0) {
    this.imageData = e, e && this.frameData && ((t || !this.offsets) && this.recalculateOffsets(e, t), this.updateOffsets(this.offsets, void 0, !0)), this.imageData && this.frameData && this.recalculateZoomLimits(this.imageData, this.frameData);
  }
  /**
   * Modify the offsets of the frame.
   * @param value The new FrameOffsets objects.
   * @param onComplete A callback, called when the modification is complete
   * @param forceUpdate When true the offsets will be updated even if they haven't changed.
   */
  updateOffsets(e, t, n) {
    const i = this.imageData;
    if (!i || !this.frameData)
      return;
    if (this.frameData.length !== e.length)
      throw new un(
        "Frame data and offsets are not the same length. This is a bug. Please report it."
      );
    if (!this.offsets.some((s, o) => !(e[o].x === s.x && e[o].y === s.y && e[o].zoom === s.zoom && e[o].rotation === s.rotation)) && !n) {
      t && t();
      return;
    }
    (!this.offsets || this.offsets.length !== this.frameData.length) && (this.offsets = new Array(this.frameData.length)), this.frameData.forEach((s, o) => {
      this.offsets[o] = DW(e[o], s, this.imageData, this.forceImageCover);
    }), this._debouncedUpdateFrameOffsets(
      this.offsets,
      i,
      this.frameData,
      this.thresholdSettings,
      t
    );
  }
  getThresholdSettings() {
    return this.thresholdSettings;
  }
  setThresholdSettings(e) {
    this.thresholdSettings = e, this.imageData && this.frameData && this._debouncedUpdateFrameOffsets(this.offsets, this.imageData, this.frameData, e);
  }
  // Allows users of the frame service to listen to frame data changes.
  onFrameDataChanged(e) {
    e(this.frameData), this.onFrameDataChangeListeners.push(e);
  }
  /**
   * Append a new listener to zoom events on this frame.
   * @param newListener
   */
  onZoom(e) {
    this.onZoomChangeListeners.push(e);
  }
  /**
   * Append a new listener to rotation events on this frame.
   * @param newListener
   */
  onRotation(e) {
    this.onRotationChangeListeners.push(e);
  }
  /**
   * Updates the offsets of the frame
   * @param newOffsets New offset object
   * @param imageData The image data
   * @param frameData The frame data
   * @param targetElements A list of elements that need updating, by ID
   * @param onComplete A callback when the operation is completed.
   */
  updateFrameOffsets(e, t, n, i, a) {
    if (!n || n.length === 0 || n.some((l) => !l))
      throw new un("Frame data not set. This is a bug");
    if (!this.workflowManager) throw new un("No workflow manager set, cannot update offsets.");
    const s = this.workflowManager.getRegionElements(this.stepName || ""), o = this.workflowManager.getCommandDispatcher();
    this.targetElements.forEach((l, u) => {
      let c = s.find((d) => d.id === l)?.regionIndex ?? u;
      c >= e.length && (c = u);
      try {
        o(
          new Nn([
            new Y8(l, t, e[c]),
            new X8(
              l,
              i.useThreshold,
              i.invertThreshold,
              i.threshold,
              i.thresholdSaturation
            )
          ])
        );
      } catch {
      }
    }), this.stepName && this.workflowManager.updateStorage(this.stepName, {
      frameOffsetsList: e
    }), a && a();
  }
  /**
   * Determines limitations of zoom based on relative size of image and frame.
   * @param imageData The image to include in calculations
   * @param frameData The frame to include in calculations.
   */
  recalculateZoomLimits(e, t) {
    (this.minZoomScale.length !== t.length || this.maxZoomScale.length !== t.length) && (this.minZoomScale = new Array(t.length), this.maxZoomScale = new Array(t.length)), t.forEach((n, i) => {
      const a = Math.max(n.width / e.width, n.height / e.height);
      this.forceImageCover ? (this.minZoomScale[i] = a, this.maxZoomScale[i] = a * 2.5) : (this.minZoomScale[i] = a / 10, this.maxZoomScale[i] = a * 2.5);
    });
  }
  recalculateOffsets(e, t = !0) {
    this.frameData && ((!this.offsets || this.offsets.length !== this.frameData.length) && (this.offsets = new Array(this.frameData.length)), this.frameData.forEach((n, i) => {
      const a = t ? 0 : this.offsets[i]?.rotation || 0;
      this.offsets[i] = {
        ...d1(
          e,
          n,
          this.initialZoom && !this.forceImageCover ? { scale: this.initialZoom } : void 0,
          this.forceImageCover
        ),
        rotation: a
      };
    }), this._debouncedUpdateFrameOffsets(this.offsets, e, this.frameData, this.thresholdSettings));
  }
}
class ZQ {
  traversableScenes() {
    throw new Error("Method not implemented.");
  }
  updateRecipient(e, t, n, i, a, s, o, l, u, c, d, f, h, g, v, y, A) {
    throw new Error("Method not implemented.");
  }
  approveTransaction(e) {
    throw new Error("Method not implemented.");
  }
  rejectTransaction(e) {
    throw new Error("Method not implemented.");
  }
  getClient() {
    return this.client ?? {};
  }
  getWorkflowExperience() {
    return {};
  }
  setClient(e) {
    this.client = e;
  }
  getInitializationPromise() {
    return Promise.resolve();
  }
  isInitialized() {
    return !0;
  }
  getInformationResults() {
    return [];
  }
  async reset() {
  }
  updateStateWithServer(e) {
  }
  async outstandingRequestsPromise() {
  }
  async updateStateWithServerImmediate(e) {
  }
  addPoller(e) {
  }
  addConfirmCallback(e) {
  }
  addEditedCallback(e) {
  }
  addElementsCallback(e) {
  }
  addInformationResultCallback(e) {
  }
  addInitCallback(e) {
  }
  addMakingAdjustmentsCallback(e) {
  }
  addMandatoryCallback(e) {
  }
  addMetadataCallback(e) {
  }
  addSelectionCallback(e) {
  }
  addStepSpecificStorageCallback(e, t) {
  }
  addStorageCallback(e) {
  }
  getCommandDispatcher() {
    return (e) => {
    };
  }
  getLayouts() {
    return [];
  }
  getLayoutPreviewService() {
    return {
      getAll: () => /* @__PURE__ */ new Map()
    };
  }
  getPreviewService() {
  }
  getModelContainer() {
  }
  getRegionElements(e) {
    return [];
  }
  getSerializedStep(e, t) {
  }
  getStepSpecificServices(e) {
  }
  getTransaction() {
    return {
      id: ""
    };
  }
  getTransactionCustomer() {
  }
  setTransactionCustomer() {
  }
  setTransactionCustomerDetails() {
  }
  getInitialOptionIds() {
    return new Promise(() => /* @__PURE__ */ new Set());
  }
  getWorkflow() {
    return {
      id: "",
      name: "",
      panels: [],
      steps: [],
      showModelOnFinishStep: !1,
      allowProofDownload: !1,
      introduction: "",
      stepGroups: []
    };
  }
  markStepsAsInitialised(e) {
  }
  markUpdateCompleted(e) {
  }
  markUpdatePending() {
    return "123";
  }
  getWorkflowSelections() {
    return {};
  }
  getStepSelections() {
    return {};
  }
  setCurrentAdjustingStepId(e) {
  }
  setEditedStatus(e, t) {
  }
  setInformationResults(e) {
  }
  setMandatoryFulfilled(e, t) {
  }
  async setSelectionsAndElements(e, t, n) {
  }
  toggleDesignConfirmed() {
  }
  updateMetadata(e, t) {
  }
  async updateStorage(e, t) {
  }
  injectIntoPreviewService(e) {
    return Promise.resolve();
  }
  ejectFromPreviewService() {
  }
  setWorkflowStateSyncEnabled(e) {
  }
  async updateTransactionShareActions() {
  }
  addValidationCallback(e) {
  }
  setStepError(e, t, n) {
  }
  getStepErrors(e) {
  }
  getValidationErrors() {
    return { steps: /* @__PURE__ */ new Map() };
  }
  async updateTransactionStakeholders() {
  }
  getStepTags(e) {
    return [];
  }
}
var RW = /* @__PURE__ */ ((r) => (r.SelectFrame = "SelectFrame", r.SelectImage = "SelectImage", r.Position = "Position", r))(RW || {}), OW = /* @__PURE__ */ ((r) => (r.Original = "original", r.BackgroundRemoved = "backgroundRemoved", r.Optimized = "optimized", r))(OW || {});
class BW extends ji {
  constructor(e, t, n) {
    super(e, t, n);
    const i = t.data;
    this.frameService = new PW(i.forceImageCover, i.initialZoomLevel), this.frameService.connectWorkflowManager(e, t.stepName);
  }
  selectVariant(e) {
    const t = this.manager.getRegionElements(this.step.stepName);
    return ul.selectVariant(
      this.step,
      e.getResource(),
      t,
      this.manager,
      (n) => this.setUpdateState(n)
    );
  }
  onFrameDataChanged(e) {
    this.frameService && this.frameService.onFrameDataChanged((t) => {
      t && e(t);
    });
  }
  /**
   * Updates the image selection inside the frame.
   * @param asset The asset to use.
   * @param storeAsOriginal Optional: Store this asset as the original, unmodified version of the image. Default: `true`.
   * @param [recalculateOffsets=true] Optional: Recalculates the offsets of the image inside the frame. Default: `true`.
   */
  async selectImage(e, t = !0, n = !0) {
    await ul.selectImage(this.step, e, this.manager, n), t && this.manager.updateStorage(this.step.stepName, {
      framePatternData: {
        originalAssetKey: e.key,
        backgroundRemovedAssetKey: void 0,
        vectorizedAssetKey: void 0,
        enhancedAssetKey: void 0,
        useOriginalAsset: void 0
      }
    });
  }
  /**
   * Returns `true` if the Advanced Image Manipulation addon is available for the current session.
   */
  async canUseAdvancedImageManipulation() {
    return this.manager.getClient().canUseAddon(IA.AdvancedImageManipulation);
  }
  /**
   * Returns `true` if the Background Remover is available for the current session and if the associated frame has a user-supplied raster image.
   */
  async canRemoveBackground() {
    return await this.canUseAdvancedImageManipulation() && this.hasOriginalImageSelection() && !!this.frameService?.getImageData()?.src && !this.frameService?.getImageData()?.svg;
  }
  /**
   * Removes the background from an image, stores it in the state, and returns the new asset.
   * @param applyNewAsset Optionally applies the new asset as the current image selection. Default: `true`.
   * @returns A promise that resolves with the newly generated Asset.
   */
  async removeBackgroundFromImageSelection(e = !0) {
    if (!await this.canUseAdvancedImageManipulation())
      throw new Error(
        "The current Integration does not have access to the Background Remover. Please call canUseAdvancedImageManipulation to ensure you disable this feature when appropriate."
      );
    const t = await this.getOriginalImageSelection();
    if (!t)
      throw new Error("You must supply an image selection before attempting to remove the background.");
    const n = await zn.removeBackgroundFromAsset(t);
    e && await ul.selectImage(this.step, n, this.manager, !1);
    const i = this.getFrameStepStorage()?.framePatternData || {};
    return this.manager.updateStorage(this.step.stepName, {
      framePatternData: {
        ...i,
        backgroundRemovedAssetKey: n.key,
        useOriginalAsset: !e
      }
    }), n;
  }
  /**
   * Takes an asset and vectorizes it, stores the new asset in the state, and returns the new asset.
   * @param asset An optional asset to use for vectorization. If not supplied, the method will attempt to vectorize the current image selection. If there is no current image selection, the method will throw an error.
   * @returns The newly vectorized asset.
   */
  async vectorize(e, t = void 0) {
    const n = e ?? await this.getOriginalImageSelection();
    if (!n)
      throw new Error("You must supply an image selection before attempting to vectorize the image.");
    const i = await zn.vectorizeAsset(n, t);
    await this.selectImage(i, !1);
    const a = this.getFrameStepStorage()?.framePatternData || {};
    return this.manager.updateStorage(this.step.stepName, {
      framePatternData: {
        ...a,
        vectorizedAssetKey: i.key,
        useOriginalAsset: !1
      }
    }), i;
  }
  /**
   * Takes an asset and enhances it using AI, stores the new asset in the state, and returns the new asset.
   * @param asset An optional asset to use for enhancement. If not supplied, the method will attempt to enhance the current image selection. If there is no current image selection, the method will throw an error.
   * @param options Optional enhancement options including quality, dimensions, and AI parameters.
   * @returns The newly enhanced asset.
   */
  async enhanceWithAI(e, t) {
    const n = e ?? await this.getOriginalImageSelection();
    if (!n)
      throw new Error("You must supply an image selection before attempting to enhance the image with AI.");
    const i = await zn.enhanceWithAI(n, t);
    await this.selectImage(i, !1);
    const a = this.getFrameStepStorage()?.framePatternData || {};
    return this.manager.updateStorage(this.step.stepName, {
      framePatternData: {
        originalAssetKey: a.originalAssetKey,
        backgroundRemovedAssetKey: a.backgroundRemovedAssetKey,
        vectorizedAssetKey: a.vectorizedAssetKey,
        enhancedAssetKey: i.key,
        useOriginalAsset: !1
      }
    }), i;
  }
  /**
   * @returns The asset representing the image with its background removed. If there is no such image, returns `undefined`.
   */
  async getBackgroundRemovedImageSelection() {
    const e = this.getFrameStepStorage()?.framePatternData?.backgroundRemovedAssetKey;
    if (e)
      return zn.getLocalOrFromServer(e);
  }
  /**
   * @returns The asset representing the vectorized version of the image. If there is no such image, returns `undefined`.
   */
  async getVectorizedImageSelection() {
    const e = this.getFrameStepStorage()?.framePatternData?.vectorizedAssetKey;
    if (e)
      return zn.getLocalOrFromServer(e);
  }
  /**
   * @returns The asset representing the AI-enhanced version of the image. If there is no such image, returns `undefined`.
   */
  async getEnhancedImageSelection() {
    const e = this.getFrameStepStorage()?.framePatternData?.enhancedAssetKey;
    if (e)
      return zn.getLocalOrFromServer(e);
  }
  /**
   * @returns Returns true when an initial asset upload was received from the user.
   */
  hasOriginalImageSelection() {
    return !!this.getFrameStepStorage()?.framePatternData?.originalAssetKey;
  }
  /**
   * @returns True when a background removed version of the original image exists in the state, regardless of whether it is currently applied as the image selection or not.
   */
  hasBackgroundRemovedImageSelection() {
    return !!this.getFrameStepStorage()?.framePatternData?.backgroundRemovedAssetKey;
  }
  /**
   * @returns True when a vectorized version of the original image exists in the state, regardless of whether it is currently applied as the image selection or not.
   */
  hasVectorizedImageSelection() {
    return !!this.getFrameStepStorage()?.framePatternData?.vectorizedAssetKey;
  }
  /**
   * @returns True when an AI-enhanced version of the original image exists in the state, regardless of whether it is currently applied as the image selection or not.
   */
  hasEnhancedImageSelection() {
    return !!this.getFrameStepStorage()?.framePatternData?.enhancedAssetKey;
  }
  /**
   * Updates the colors on the currently displayed image. Only applicable to an SVG image with identifiable colors or a raster image with the color picker enabled.
   * @returns A promise that resolves when the colors have been updated on the image.
   */
  async changeColors(e) {
    await ul.changeColors(this.step, this.manager, e);
  }
  /**
   * @returns The PatternImageData for the current frame, which includes information about the image currently in the frame such as whether it's an SVG or raster image, its dimensions, and its colors (if applicable). Returns `undefined` if there is no image currently in the frame or if the frameService is not initialized.
   */
  getImageData() {
    if (this.frameService)
      return this.frameService.getImageData();
  }
  /**
   * @returns The ColorOption associated with this step, which includes information about whether the color picker is enabled and any predefined colors. Returns `undefined` if there is no ColorOption associated with this step.
   */
  async getColorOption() {
    return await ft.ensureFullOption(this.step.data.colorOption);
  }
  /**
   * @returns A list of available colors for the current image selection, if the color picker is enabled. If the color picker is not enabled, returns an empty array.
   */
  getAvailableColors() {
    return this.step.data.colorPickerEnabled ? ul.availableColors(this.step, this.manager) : Promise.resolve([]);
  }
  /**
   * @returns True if the color picker is enabled for this step, otherwise false.
   */
  isColorPickerEnabled() {
    return this.step.data.colorPickerEnabled ?? !1;
  }
  /**
   * @returns A mapping of color identifiers to their corresponding ColorDefinition for the original image. Only applicable if the current image is an SVG with identifiable colors. Returns `undefined` if there is no image or if the image is not an SVG with identifiable colors.
   */
  async getOriginalImageColors() {
    const e = this.getImageData();
    return e?.svg ? (await ss(e.svg)).colors : void 0;
  }
  /**
   * Merges multiple color class IDs into a single unified color. This is useful for consolidating near-identical colors in vectorized SVGs.
   * @param sourceClassIds - Array of color class IDs to merge from (e.g., ["ff0000", "fe0101", "ff0a0a"])
   * @param targetClassId - The color class ID to merge into (e.g., "ff0000")
   * @param targetColor - The color definition for the merged result
   * @throws Error if the current image is not an SVG with colors
   */
  async mergeColors(e, t, n) {
    const i = this.frameService.getImageData();
    if (!i?.svg || !i.colors)
      throw new Error("Cannot merge colors on non-SVG image or image without color information");
    const { svg: a, colors: s } = nB(
      i.svg,
      i.colors,
      e,
      t,
      n
    );
    this.frameService.setPatternData(
      {
        ...i,
        svg: a,
        colors: s
      },
      !1
    ), this.manager.updateStorage(this.step.stepName, {
      colors: s
    });
  }
  /**
   * Unmerges colors by restoring the pre-merge color state and SVG
   * @param sourceClassIds - Original class IDs that were merged
   * @param targetClassId - The class ID they were merged into
   * @param preMergeColors - The color definitions before the merge
   * @param preMergeSvg - The SVG string before the merge
   * @throws Error if the current image is not an SVG with colors
   */
  async unmergeColors(e, t, n, i) {
    const a = this.frameService.getImageData();
    if (!a?.svg || !a.colors)
      throw new Error("Cannot unmerge colors on non-SVG image or image without color information");
    this.frameService.setPatternData(
      {
        ...a,
        svg: i,
        colors: n
      },
      !1
    ), this.manager.updateStorage(this.step.stepName, {
      colors: n
    });
  }
  /**
   * @returns True when vectorizing should be available to the user.
   */
  getShouldVectorize() {
    return this.step.data.shouldVectorize ?? !1;
  }
  /**
   * @returns The maximum number of colors allowed when vectorizing an image. Only applicable if shouldVectorize is true. If not specified, a suitable default will be applied.
   */
  getVectorizeMaxColors() {
    return this.step.data.vectorizeMaxColors;
  }
  /**
   * @returns The minimum number of pixels in either dimension of the image required for optimization pathway to be suggested.
   */
  getMinimumPixelThresholdForOptimization() {
    return this.step.data.vectorizationMinimumPixelThreshold;
  }
  /**
   * @returns The maximum number of colors allowed in the image selection.
   */
  getMaxAllowedColors() {
    return this.step.data.maxColors;
  }
  /**
   * @returns The number of unique colors present in the image. Only applicable to SVG files.
   */
  getUniqueColorCount() {
    return ul.getUniqueColorCount(this.step, this.manager);
  }
  getCurrentFrameStep(e, t, n, i) {
    return i && i.length > 1 && e === void 0 ? "SelectFrame" : t || n || this.getImageData() ? "Position" : "SelectImage";
  }
  getFrameService() {
    return this.frameService;
  }
  hasOverlayImageKey() {
    return this.step.data.overlayImageKey;
  }
  hasOverlayImageUrl() {
    return this.step.data.overlayImageUrl;
  }
  getWhitelistedExtensions() {
    return [
      ...this.step.data.whitelistedExtensions,
      ...this.step.data.whitelistedExtensions.includes(".jpg") ? [".jpeg"] : []
    ];
  }
  async getOriginalImageSelection() {
    const e = this.getFrameStepStorage()?.framePatternData?.originalAssetKey;
    if (e)
      return zn.getLocalOrFromServer(e);
  }
  /**
   * @returns The current image state being displayed (original, backgroundRemoved, or optimized).
   */
  getCurrentImageState() {
    const e = this.getFrameStepStorage()?.framePatternData;
    return e ? e.vectorizedAssetKey && !e.useOriginalAsset ? "optimized" : e.useOriginalAsset !== !1 ? "original" : "backgroundRemoved" : "original";
  }
  /**
   * Sets the current image state to display one of: original, backgroundRemoved, or optimized.
   * This will switch between the available image versions without creating new ones.
   * @param state The image state to switch to.
   * @throws Error if the requested state is not available (e.g., trying to switch to backgroundRemoved when no background-removed version exists).
   */
  async setImageState(e) {
    const t = this.getFrameStepStorage()?.framePatternData || {};
    let n, i;
    switch (e) {
      case "original":
        if (n = await this.getOriginalImageSelection(), !n)
          throw new Error("No original image available");
        i = !0;
        break;
      case "backgroundRemoved":
        if (n = await this.getBackgroundRemovedImageSelection(), !n)
          throw new Error(
            "No background-removed image available. Call removeBackgroundFromImageSelection first."
          );
        i = !1;
        break;
      case "optimized":
        if (n = await this.getVectorizedImageSelection(), !n)
          throw new Error("No optimized image available. Call vectorize first.");
        i = !1;
        break;
    }
    await this.selectImage(n, !1, !0), this.manager.updateStorage(this.step.stepName, {
      framePatternData: { ...t, useOriginalAsset: i }
    });
  }
  /**
   * @deprecated Use getCurrentImageState() instead. Returns true if displaying original image, false otherwise.
   */
  getUseOriginalImageSelection() {
    return this.getFrameStepStorage()?.framePatternData?.useOriginalAsset ?? !1;
  }
  /**
   * @deprecated Use setImageState() instead. Sets whether to use original (true) or background-removed (false) image.
   */
  async setUseOriginalImageSelection(e) {
    const t = this.getFrameStepStorage()?.framePatternData || {};
    if (t.useOriginalAsset === e)
      return;
    const n = await this.getOriginalImageSelection();
    if (!n)
      throw new Error("You must provide an image selection before calling setUseOriginalImageSelection");
    if (e)
      await this.selectImage(n, !1, !1);
    else {
      const i = await this.getBackgroundRemovedImageSelection();
      if (!i)
        throw new Error(
          "You must call removeBackgroundFromImageSelection before attempting to apply the image."
        );
      await this.selectImage(i, !1, !1);
    }
    this.manager.updateStorage(this.step.stepName, {
      framePatternData: { ...t, useOriginalAsset: e }
    });
  }
  getFrameStepStorage() {
    return this.manager.getStepStorage(this.step.stepName);
  }
  isVariantCategoriesEnabled() {
    return this.step.data.enableVariantCategories ?? !1;
  }
}
const MW = Ee`
    query GetLoggedInCustomer($email: String!) {
        customer(emailAddress: $email) {
            id
            defaultTemplateBundleId
        }
    }
`, Bb = Ee`
    query GetCustomerTransactions(
        $id: String!
        $limit: Int!
        $offset: Int!
        $startDate: String
        $endDate: String
        $filters: TransactionFiltersInput
        $quicksearch: String
    ) {
        customerTransactionsFeed(
            id: $id
            limit: $limit
            offset: $offset
            startDate: $startDate
            endDate: $endDate
            filters: $filters
            quicksearch: $quicksearch
        ) {
            items {
                id
                createdAt
                designName
                integrationType
                status
                workflowState
                workflowViewerLink
                workflowViewerReadOnlyLink
                product {
                    minimumOrderQuantity
                    id
                    name
                }
            }
            total
        }
    }
`, _W = Ee`
    mutation SetTransactionDesignName($id: String!, $name: String!) {
        transactionUpdate(id: $id, designName: $name) {
            id
            designName
        }
    }
`, NW = Ee`
    mutation DuplicateTransaction($id: String!, $template: Boolean!) {
        transactionDuplicate(id: $id, template: $template) {
            id
            workflowViewerLink
        }
    }
`, LW = Ee`
    query GetCustomerBundles($id: String!, $limit: Int!, $offset: Int!) {
        customerBundlesFeed(id: $id, limit: $limit, offset: $offset) {
            items {
                id
                workflowViewerLink
                createdAt
                dispatchDate
                purchaseOrder
                name
                ordered
            }
            total
        }
    }
`, UW = Ee`
    query GetTransactionsForBundle($id: String!) {
        bundles(ids: [$id]) {
            id
            transactions {
                id
                createdAt
                designName
                integrationType
                status
                workflowState
                workflowViewerLink
                workflowViewerReadOnlyLink
                parentTransaction {
                    id
                }
                product {
                    minimumOrderQuantity
                    id
                    name
                }
            }
        }
    }
`, VW = Ee`
    mutation SetBundleName($id: String!, $name: String!) {
        bundleUpdate(id: $id, name: $name) {
            id
            name
        }
    }
`, zW = Ee`
    mutation DuplicateBundle($id: String!, $template: Boolean!) {
        bundleDuplicate(id: $id, template: $template) {
            id
            workflowViewerLink
        }
    }
`, $W = Ee`
    query GetBundleTemplates($id: String!, $limit: Int!, $offset: Int!) {
        customerBundlesFeed(id: $id, limit: $limit, offset: $offset, template: true) {
            items {
                id
                workflowViewerLink
                createdAt
                name
                ordered
            }
            total
        }
    }
`, eY = async (r, e, t) => await He.getShadowGraphqlClient().mutate({
  mutation: VW,
  errorPolicy: "all",
  variables: {
    id: r,
    name: e
  },
  context: t
}), tY = async (r, e) => await He.getShadowGraphqlClient().mutate({
  mutation: _W,
  errorPolicy: "all",
  variables: {
    id: r,
    name: e
  }
}), rY = async (r, e) => await He.getShadowGraphqlClient().mutate({
  mutation: zW,
  errorPolicy: "all",
  variables: {
    id: r,
    template: e
  }
}), nY = async (r, e) => await He.getShadowGraphqlClient().mutate({
  mutation: NW,
  errorPolicy: "all",
  variables: {
    id: r,
    template: e
  }
}), iY = async (r) => (await He.getShadowGraphqlClient().query({
  query: MW,
  errorPolicy: "all",
  variables: {
    email: r
  }
})).data.customer, aY = async (r, e, t) => await He.getShadowGraphqlClient().query({
  query: LW,
  errorPolicy: "all",
  fetchPolicy: "no-cache",
  variables: {
    id: r,
    offset: t,
    limit: e
  }
}), sY = async (r, e) => await He.getShadowGraphqlClient().query({
  query: UW,
  errorPolicy: "all",
  fetchPolicy: "no-cache",
  variables: {
    id: r
  },
  context: e
}), oY = async (r, e, t) => (await He.getShadowGraphqlClient().query({
  query: Bb,
  errorPolicy: "all",
  fetchPolicy: "no-cache",
  variables: {
    id: r,
    quicksearch: "",
    filters: {
      link: "and",
      status: {
        operator: "isAnyOf",
        values: ["Created", "DesignCompleted", "ExternallyOrdered"]
      },
      template: {
        value: "false"
      }
    },
    offset: t,
    limit: e
  }
}))?.data.customerTransactionsFeed?.items || [], lY = async (r, e, t) => (await He.getShadowGraphqlClient().query({
  query: Bb,
  errorPolicy: "all",
  fetchPolicy: "no-cache",
  variables: {
    id: r,
    quicksearch: "",
    filters: {
      link: "and",
      status: {
        operator: "equals",
        value: "Ordered"
      },
      template: {
        value: "false"
      }
    },
    offset: t,
    limit: e
  }
}))?.data.customerTransactionsFeed?.items || [], uY = async (r, e, t) => (await He.getShadowGraphqlClient().query({
  query: Bb,
  errorPolicy: "all",
  fetchPolicy: "no-cache",
  variables: {
    id: r,
    quicksearch: "",
    filters: {
      link: "and",
      template: {
        value: "true"
      }
    },
    offset: t,
    limit: e
  }
}))?.data.customerTransactionsFeed?.items || [], cY = async (r, e, t) => (await He.getShadowGraphqlClient().query({
  query: $W,
  errorPolicy: "all",
  fetchPolicy: "no-cache",
  variables: {
    id: r,
    offset: t,
    limit: e
  }
}))?.data.customerBundlesFeed?.items || [], qI = Ee`
    fragment AddressValidationResultFields on AddressValidationResult {
        addressComplete
        address {
            formattedAddress
            regionCode
            postalCode
            administrativeArea
            locality
            sublocality
        }
        components {
            name
            type
            confirmationLevel
            inferred
            spellCorrected
            replaced
            unexpected
        }
        missingComponentTypes
    }
`, Mb = Ee`
    ${qI}
    fragment AddressValidationJobFields on AddressValidationJob {
        id
        entityId
        status
        createdAt
        updatedAt
        result {
            ...AddressValidationResultFields
        }
    }
`, HW = Ee`
    ${Mb}
    query GetAddressValidationJobs($ids: [String!]!) {
        addressValidationJobs(ids: $ids) {
            ...AddressValidationJobFields
        }
    }
`, jW = Ee`
    ${Mb}
    query GetRecipientsWithAddressValidationJobs($ids: [String!]!) {
        recipients(ids: $ids) {
            id
            addressValidationJob {
                ...AddressValidationJobFields
            }
        }
    }
`, GW = Ee`
    ${qI}
    mutation ValidateRecipientAddress($id: String!) {
        recipientValidate(id: $id) {
            ...AddressValidationResultFields
        }
    }
`, qW = Ee`
    ${Mb}
    mutation BatchValidateRecipientAddress($ids: [String!]!) {
        recipientValidateBatch(ids: $ids) {
            ...AddressValidationJobFields
        }
    }
`, WW = Ee`
    mutation OverrideRecipientAddress($id: String!) {
        recipientOverrideAddress(id: $id) {
            id
        }
    }
`, QW = Ee`
    mutation SkipRecipientAddress($id: String!) {
        recipientSkipAddress(id: $id) {
            id
        }
    }
`;
var YW = /* @__PURE__ */ ((r) => (r.Confirmed = "Confirmed", r.Plausible = "Plausible", r.Unlikely = "Unlikely", r))(YW || {}), XW = /* @__PURE__ */ ((r) => (r.Created = "Created", r.Processing = "Processing", r.Completed = "Completed", r.Failed = "Failed", r.Cancelled = "Cancelled", r))(XW || {});
const fY = async (r) => {
  const e = r.map((n) => n.getTransaction().recipient?.id).filter((n) => !!n), t = await He.getShadowGraphqlClient().query({
    query: jW,
    errorPolicy: "all",
    fetchPolicy: "network-only",
    variables: {
      ids: e
    }
  });
  return r.map((n) => {
    const i = n.getTransaction().recipient?.id;
    if (i)
      return t.data?.recipients?.find((a) => a.id === i)?.addressValidationJob;
  });
}, dY = async (r) => (await He.getShadowGraphqlClient().query({
  query: HW,
  errorPolicy: "all",
  fetchPolicy: "network-only",
  variables: {
    ids: r
  }
})).data?.addressValidationJobs, hY = async (r) => r.getTransaction().recipient?.id ? (await He.getShadowGraphqlClient().mutate({
  mutation: GW,
  errorPolicy: "all",
  fetchPolicy: "network-only",
  variables: {
    id: r.getTransaction().recipient.id
  }
})).data?.recipientValidate : void 0, pY = async (r) => {
  const e = r.map((n) => n.getTransaction().recipient?.id).filter((n) => !!n), t = await He.getShadowGraphqlClient().mutate({
    mutation: qW,
    errorPolicy: "all",
    fetchPolicy: "network-only",
    variables: {
      ids: e
    }
  });
  return r.map((n) => {
    const i = n.getTransaction().recipient?.id;
    if (i)
      return t.data?.recipientValidateBatch?.find((a) => a.entityId === i);
  });
}, gY = async (r) => {
  const e = r.getTransaction().recipient?.id;
  if (!e)
    return;
  (await He.getShadowGraphqlClient().mutate({
    mutation: WW,
    errorPolicy: "all",
    fetchPolicy: "network-only",
    variables: {
      id: e
    }
  })).data?.recipientOverrideAddress?.id && (r.getTransaction().addressValidationStatus = FA.Overridden);
}, mY = async (r) => {
  const e = r.getTransaction().recipient?.id;
  if (!e)
    return;
  (await He.getShadowGraphqlClient().mutate({
    mutation: QW,
    errorPolicy: "all",
    fetchPolicy: "network-only",
    variables: {
      id: e
    }
  })).data?.recipientSkipAddress?.id && (r.getTransaction().addressValidationStatus = FA.Skipped);
}, JW = Ee`
    query GetIntegrationProductsForIds($ids: [String!]!) {
        integrationProducts(ids: $ids) {
            id
            product {
                id
                name
            }
        }
    }
`, vY = async (r) => (await He.getShadowGraphqlClient().query({
  query: JW,
  variables: {
    ids: r
  }
})).data.integrationProducts;
export {
  ZQ as $,
  IA as A,
  _Q as B,
  Rn as C,
  cc as D,
  Q8 as E,
  RU as F,
  q8 as G,
  W8 as H,
  gS as I,
  PW as J,
  RW as K,
  BW as L,
  m1 as M,
  Nn as N,
  ZL as O,
  OW as P,
  Lg as Q,
  sU as R,
  hE as S,
  h4 as T,
  IQ as U,
  tr as V,
  Ei as W,
  id as X,
  eU as Y,
  Is as Z,
  KW as _,
  b1 as a,
  ul as a$,
  tU as a0,
  lU as a1,
  DQ as a2,
  jF as a3,
  t9 as a4,
  zF as a5,
  Xp as a6,
  Fu as a7,
  rU as a8,
  p4 as a9,
  g4 as aA,
  OQ as aB,
  es as aC,
  Xy as aD,
  FU as aE,
  MU as aF,
  dQ as aG,
  fQ as aH,
  cQ as aI,
  zn as aJ,
  XO as aK,
  zQ as aL,
  TQ as aM,
  SQ as aN,
  sQ as aO,
  JQ as aP,
  vv as aQ,
  Up as aR,
  FF as aS,
  _s as aT,
  rY as aU,
  nY as aV,
  ha as aW,
  vQ as aX,
  $n as aY,
  uQ as aZ,
  Of as a_,
  HF as aa,
  qU as ab,
  uU as ac,
  Gf as ad,
  eg as ae,
  XA as af,
  nU as ag,
  YA as ah,
  RQ as ai,
  ad as aj,
  PQ as ak,
  Ci as al,
  NQ as am,
  iU as an,
  d4 as ao,
  GQ as ap,
  vk as aq,
  c4 as ar,
  ji as as,
  Je as at,
  ic as au,
  J8 as av,
  OU as aw,
  HQ as ax,
  aU as ay,
  un as az,
  Ju as b,
  hS as b$,
  br as b0,
  cL as b1,
  ss as b2,
  UQ as b3,
  FW as b4,
  XQ as b5,
  dY as b6,
  hQ as b7,
  Dg as b8,
  mQ as b9,
  fY as bA,
  kW as bB,
  $I as bC,
  He as bD,
  Lp as bE,
  yQ as bF,
  uc as bG,
  lQ as bH,
  IF as bI,
  nB as bJ,
  Ky as bK,
  kQ as bL,
  DF as bM,
  zA as bN,
  PF as bO,
  eY as bP,
  tY as bQ,
  ft as bR,
  FQ as bS,
  gY as bT,
  io as bU,
  Cr as bV,
  RF as bW,
  oQ as bX,
  OF as bY,
  aQ as bZ,
  iQ as b_,
  DW as ba,
  KQ as bb,
  QQ as bc,
  iY as bd,
  aY as be,
  EQ as bf,
  Mg as bg,
  VQ as bh,
  TW as bi,
  vY as bj,
  xQ as bk,
  wQ as bl,
  lY as bm,
  WQ as bn,
  bQ as bo,
  $Q as bp,
  CQ as bq,
  c1 as br,
  cY as bs,
  uY as bt,
  qQ as bu,
  YQ as bv,
  sY as bw,
  $A as bx,
  AQ as by,
  oY as bz,
  XW as c,
  qO as c0,
  Mh as c1,
  NA as c2,
  G4 as c3,
  kk as c4,
  Bf as c5,
  b7 as c6,
  mY as c7,
  ml as c8,
  LQ as c9,
  tx as ca,
  AF as cb,
  DA as cc,
  pi as cd,
  O7 as ce,
  hY as cf,
  pY as cg,
  El as ch,
  YW as d,
  FA as e,
  nV as f,
  jQ as g,
  Qn as h,
  bl as i,
  Yp as j,
  MQ as k,
  BQ as l,
  f4 as m,
  pp as n,
  uE as o,
  z8 as p,
  Pp as q,
  fi as r,
  wF as s,
  vl as t,
  CW as u,
  xW as v,
  oU as w,
  gp as x,
  e9 as y,
  ZU as z
};
//# sourceMappingURL=index-BTlRIHGf.js.map
